
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0a44"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0a44"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ecd4d", function(module, exports) {
$parcel$export(module.exports, "cloneVNode", () => (parcelRequire("TusQn")).cloneVNode);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "mergeModels", () => (parcelRequire("TusQn")).mergeModels);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("TusQn")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("TusQn")).Teleport);
$parcel$export(module.exports, "Text", () => (parcelRequire("TusQn")).Text);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useModel", () => (parcelRequire("TusQn")).useModel);
$parcel$export(module.exports, "version", () => (parcelRequire("TusQn")).version);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("eeJ70")).createApp);
$parcel$export(module.exports, "TransitionGroup", () => (parcelRequire("eeJ70")).TransitionGroup);
$parcel$export(module.exports, "vModelCheckbox", () => (parcelRequire("eeJ70")).vModelCheckbox);
$parcel$export(module.exports, "vModelDynamic", () => (parcelRequire("eeJ70")).vModelDynamic);
$parcel$export(module.exports, "vModelRadio", () => (parcelRequire("eeJ70")).vModelRadio);
$parcel$export(module.exports, "vModelSelect", () => (parcelRequire("eeJ70")).vModelSelect);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("eeJ70")).vModelText);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("eeJ70")).withModifiers);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "toValue", () => (parcelRequire("01W3b")).toValue);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
/**
* vue v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");parcelRequire("eeJ70");parcelRequire("01W3b");parcelRequire("8POXm");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
$a55c527d369bf9c1$var$initDev();
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{
    (0, $TusQn.warn)(`Runtime compilation is not supported in this build of Vue.` + ` Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".`);
};

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "assertNumber", () => $0a6cc4ba868319ae$export$dfbcecb440255e4a);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Text", () => $0a6cc4ba868319ae$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "cloneVNode", () => $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a);
$parcel$export(module.exports, "resolveComponent", () => $0a6cc4ba868319ae$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $0a6cc4ba868319ae$export$b44c564a05ca975);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "watchEffect", () => $0a6cc4ba868319ae$export$ede35fc0e5500309);
$parcel$export(module.exports, "watchPostEffect", () => $0a6cc4ba868319ae$export$b7f27ea67102d543);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $0a6cc4ba868319ae$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "onActivated", () => $0a6cc4ba868319ae$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $0a6cc4ba868319ae$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeMount", () => $0a6cc4ba868319ae$export$23b7aeb0d671f804);
$parcel$export(module.exports, "onBeforeUpdate", () => $0a6cc4ba868319ae$export$ab91988a13872e4c);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "renderSlot", () => $0a6cc4ba868319ae$export$4abee4c34694ada1);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "mergeModels", () => $0a6cc4ba868319ae$export$ad4f724f587e6828);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $0a6cc4ba868319ae$export$abe1e183e22e10ad);
$parcel$export(module.exports, "version", () => $0a6cc4ba868319ae$export$83d89fbfd8236492);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "Teleport", () => $0a6cc4ba868319ae$export$76d55a0304a371f4);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "mergeProps", () => $0a6cc4ba868319ae$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createStaticVNode", () => $0a6cc4ba868319ae$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "useModel", () => $0a6cc4ba868319ae$export$fb78bd113157f1a1);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
/**
* @vue/runtime-core v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8POXm.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    if (val === void 0) return;
    else if (typeof val !== "number") $0a6cc4ba868319ae$var$warn$1(`${type} is not a valid number - got ${JSON.stringify(val)}.`);
    else if (isNaN(val)) $0a6cc4ba868319ae$var$warn$1(`${type} is NaN - the duration expression might be incorrect.`);
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://github.com/vuejs/core ."
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8POXm.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    } else $0a6cc4ba868319ae$var$warn$1(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof fn}`);
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = (0, $0a6cc4ba868319ae$var$ErrorTypeStrings$1[type]);
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true) {
    {
        const info = $0a6cc4ba868319ae$var$ErrorTypeStrings$1[type];
        if (contextVNode) $0a6cc4ba868319ae$var$pushWarningContext(contextVNode);
        $0a6cc4ba868319ae$var$warn$1(`Unhandled error${info ? ` during execution of ${info}` : ``}`);
        if (contextVNode) $0a6cc4ba868319ae$var$popWarningContext();
        if (throwInDev) throw err;
        else console.error(err);
    }
}
let $0a6cc4ba868319ae$var$isFlushing = false;
let $0a6cc4ba868319ae$var$isFlushPending = false;
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = 0;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!$0a6cc4ba868319ae$var$queue.length || !$0a6cc4ba868319ae$var$queue.includes(job, $0a6cc4ba868319ae$var$isFlushing && job.allowRecurse ? $0a6cc4ba868319ae$var$flushIndex + 1 : $0a6cc4ba868319ae$var$flushIndex)) {
        if (job.id == null) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(job.id), 0, job);
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$isFlushing && !$0a6cc4ba868319ae$var$isFlushPending) {
        $0a6cc4ba868319ae$var$isFlushPending = true;
        $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
    }
}
function $0a6cc4ba868319ae$var$invalidateJob(job) {
    const i = $0a6cc4ba868319ae$var$queue.indexOf(job);
    if (i > $0a6cc4ba868319ae$var$flushIndex) $0a6cc4ba868319ae$var$queue.splice(i, 1);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if (!$0a6cc4ba868319ae$var$activePostFlushCbs || !$0a6cc4ba868319ae$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $0a6cc4ba868319ae$var$postFlushIndex + 1 : $0a6cc4ba868319ae$var$postFlushIndex)) $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
    } else $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, seen, i = $0a6cc4ba868319ae$var$isFlushing ? $0a6cc4ba868319ae$var$flushIndex + 1 : 0) {
    seen = seen || /* @__PURE__ */ new Map();
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.pre) {
            if (instance && cb.id !== instance.uid) continue;
            if ($0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, cb)) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        seen = seen || /* @__PURE__ */ new Map();
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++){
            if ($0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, $0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex])) continue;
            $0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex]();
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $0a6cc4ba868319ae$var$comparator = (a, b)=>{
    const diff = $0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    $0a6cc4ba868319ae$var$isFlushPending = false;
    $0a6cc4ba868319ae$var$isFlushing = true;
    seen = seen || /* @__PURE__ */ new Map();
    $0a6cc4ba868319ae$var$queue.sort($0a6cc4ba868319ae$var$comparator);
    const check = (job)=>$0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, job);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && job.active !== false) {
                if (check(job)) continue;
                $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, null, 14);
            }
        }
    } finally{
        $0a6cc4ba868319ae$var$flushIndex = 0;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$isFlushing = false;
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
(0, $8POXm.getGlobalThis)().__VUE_HMR_RUNTIME__ = {
    createRecord: $0a6cc4ba868319ae$var$tryWrap($0a6cc4ba868319ae$var$createRecord),
    rerender: $0a6cc4ba868319ae$var$tryWrap($0a6cc4ba868319ae$var$rerender),
    reload: $0a6cc4ba868319ae$var$tryWrap($0a6cc4ba868319ae$var$reload)
};
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        instance.effect.dirty = true;
        instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        if (!$0a6cc4ba868319ae$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            instance.parent.effect.dirty = true;
            $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
        } else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        for (const instance of instances)$0a6cc4ba868319ae$var$hmrDirtyComponents.delete($0a6cc4ba868319ae$var$normalizeClassComponent(instance.type));
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    {
        const { emitsOptions: emitsOptions, propsOptions: [propsOptions] } = instance;
        if (emitsOptions) {
            if (!(event in emitsOptions) && true) {
                if (!propsOptions || !((0, $8POXm.toHandlerKey)(event) in propsOptions)) $0a6cc4ba868319ae$var$warn$1(`Component emitted event "${event}" but it is neither declared in the emits option nor as an "${(0, $8POXm.toHandlerKey)(event)}" prop.`);
            } else {
                const validator = emitsOptions[event];
                if ((0, $8POXm.isFunction)(validator)) {
                    const isValid = validator(...rawArgs);
                    if (!isValid) $0a6cc4ba868319ae$var$warn$1(`Invalid event arguments: event validation failed for event "${event}".`);
                }
            }
        }
    }
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $8POXm.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $8POXm.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $8POXm.looseToNumber));
    }
    $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    {
        const lowerCaseEvent = event.toLowerCase();
        if (lowerCaseEvent !== event && props[(0, $8POXm.toHandlerKey)(lowerCaseEvent)]) $0a6cc4ba868319ae$var$warn$1(`Event "${lowerCaseEvent}" is emitted in component ${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)} but the handler is registered for "${event}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${(0, $8POXm.hyphenate)(event)}" instead of "${event}".`);
    }
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    $0a6cc4ba868319ae$var$accessedAttrs = false;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = (0, setupState.__isScriptSetup) ? new Proxy(proxyToUse, {
                get (target, key, receiver) {
                    $0a6cc4ba868319ae$var$warn$1(`Property '${String(key)}' was accessed via 'this'. Avoid using 'this' in templates.`);
                    return Reflect.get(target, key, receiver);
                }
            }) : proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, (0, $01W3b.shallowReadonly)(props), setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            if (attrs === props) $0a6cc4ba868319ae$var$markAttrsAccessed();
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2((0, $01W3b.shallowReadonly)(props), {
                get attrs () {
                    $0a6cc4ba868319ae$var$markAttrsAccessed();
                    return (0, $01W3b.shallowReadonly)(attrs);
                },
                slots: slots,
                emit: emit
            }) : render2((0, $01W3b.shallowReadonly)(props), null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (result.patchFlag > 0 && result.patchFlag & 2048) [root, setRoot] = $0a6cc4ba868319ae$var$getChildRoot(result);
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            } else if (!$0a6cc4ba868319ae$var$accessedAttrs && root.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                const allAttrs = Object.keys(attrs);
                const eventAttrs = [];
                const extraAttrs = [];
                for(let i = 0, l = allAttrs.length; i < l; i++){
                    const key = allAttrs[i];
                    if ((0, $8POXm.isOn)(key)) {
                        if (!(0, $8POXm.isModelListener)(key)) eventAttrs.push(key[2].toLowerCase() + key.slice(3));
                    } else extraAttrs.push(key);
                }
                if (extraAttrs.length) $0a6cc4ba868319ae$var$warn$1(`Extraneous non-props attributes (${extraAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes.`);
                if (eventAttrs.length) $0a6cc4ba868319ae$var$warn$1(`Extraneous non-emits event listeners (${eventAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`);
            }
        }
    }
    if (vnode.dirs) {
        if (!$0a6cc4ba868319ae$var$isElementRoot(root)) $0a6cc4ba868319ae$var$warn$1(`Runtime directive used on component with non-element root node. The directives will not function as intended.`);
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
        if (!$0a6cc4ba868319ae$var$isElementRoot(root)) $0a6cc4ba868319ae$var$warn$1(`Component inside <Transition> renders non-element root node that cannot be animated.`);
        root.transition = vnode.transition;
    }
    if (setRoot) setRoot(root);
    else result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    else if (childRoot.patchFlag > 0 && childRoot.patchFlag & 2048) return $0a6cc4ba868319ae$var$getChildRoot(childRoot);
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else {
                    singleRoot = child;
                    if (recurse && singleRoot.patchFlag > 0 && singleRoot.patchFlag & 2048) return $0a6cc4ba868319ae$var$filterSingleRoot(singleRoot.children);
                }
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if ((prevChildren || nextChildren) && $0a6cc4ba868319ae$var$isHmrUpdating) return true;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        if (warnMissing && !res) {
            const extra = type === $0a6cc4ba868319ae$var$COMPONENTS ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.` : ``;
            $0a6cc4ba868319ae$var$warn$1(`Failed to resolve ${type.slice(0, -1)}: ${name}${extra}`);
        }
        return res;
    } else $0a6cc4ba868319ae$var$warn$1(`resolve${(0, $8POXm.capitalize)(type.slice(0, -1))} can only be used in render() or setup().`);
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    create: $0a6cc4ba868319ae$var$createSuspenseBoundary,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    if (!$0a6cc4ba868319ae$var$hasWarned) {
        $0a6cc4ba868319ae$var$hasWarned = true;
        console[console.info ? "info" : "log"](`<Suspense> is an experimental feature and its API will likely change.`);
    }
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8POXm.toNumber)(vnode.props.timeout) : void 0;
    $0a6cc4ba868319ae$export$dfbcecb440255e4a(timeout, `Suspense timeout`);
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            if (!resume && !suspense.pendingBranch) throw new Error(`suspense.resolve() is called without a pending branch.`);
            if (suspense.isUnmounted) throw new Error(`suspense.resolve() is called on an already unmounted suspense boundary.`);
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) !== suspense.hiddenContainer) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$pushWarningContext(vnode2);
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized);
                if (placeholder) remove(placeholder);
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                $0a6cc4ba868319ae$var$popWarningContext();
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        if (!singleChild && s.filter((child)=>child !== $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT).length > 0) $0a6cc4ba868319ae$var$warn$1(`<Suspense> slots expect a single root node.`);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        if (!ctx) $0a6cc4ba868319ae$var$warn$1(`Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build.`);
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, (0, $8POXm.extend)({}, options, {
        flush: "post"
    }));
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, (0, $8POXm.extend)({}, options, {
        flush: "sync"
    }));
}
const $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE = {};
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    if (!(0, $8POXm.isFunction)(cb)) $0a6cc4ba868319ae$var$warn$1(`\`watch(fn, options?)\` signature has been moved to a separate API. Use \`watchEffect(fn, options?)\` instead. \`watch\` now only supports \`watch(source, cb, options?) signature.`);
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, once: once, onTrack: onTrack, onTrigger: onTrigger } = (0, $8POXm.EMPTY_OBJ)) {
    if (cb && once) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            unwatch();
        };
    }
    if (deep !== void 0 && typeof deep === "number") $0a6cc4ba868319ae$var$warn$1(`watch() "deep" option with number value will be used as watch depth in future versions. Please use a boolean instead to avoid potential breakage.`);
    if (!cb) {
        if (immediate !== void 0) $0a6cc4ba868319ae$var$warn$1(`watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.`);
        if (deep !== void 0) $0a6cc4ba868319ae$var$warn$1(`watch() "deep" option is only respected when using the watch(source, callback, options?) signature.`);
        if (once !== void 0) $0a6cc4ba868319ae$var$warn$1(`watch() "once" option is only respected when using the watch(source, callback, options?) signature.`);
    }
    const warnInvalidSource = (s)=>{
        $0a6cc4ba868319ae$var$warn$1(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    const reactiveGetter = (source2)=>deep === true ? source2 : // for deep: false, only traverse root-level properties
        $0a6cc4ba868319ae$var$traverse(source2, deep === false ? 1 : void 0);
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $01W3b.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $01W3b.isShallow)(source);
    } else if ((0, $01W3b.isReactive)(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $01W3b.isReactive)(s) || (0, $01W3b.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $01W3b.isRef)(s)) return s.value;
                else if ((0, $01W3b.isReactive)(s)) return reactiveGetter(s);
                else if ((0, $8POXm.isFunction)(s)) return $0a6cc4ba868319ae$export$b22fcaf88446e9bf(s, instance, 2);
                else warnInvalidSource(s);
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) getter = ()=>$0a6cc4ba868319ae$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (cleanup) cleanup();
            return $0a6cc4ba868319ae$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else {
        getter = (0, $8POXm.NOOP);
        warnInvalidSource(source);
    }
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$0a6cc4ba868319ae$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, 4);
            cleanup = effect.onStop = void 0;
        };
    };
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        onCleanup = (0, $8POXm.NOOP);
        if (!cb) getter();
        else if (immediate) $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $8POXm.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE) : $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active || !effect.dirty) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $8POXm.hasChanged)(v1, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
    }
    const effect = new (0, $01W3b.ReactiveEffect)(getter, (0, $8POXm.NOOP), scheduler);
    const scope = (0, $01W3b.getCurrentScope)();
    const unwatch = ()=>{
        effect.stop();
        if (scope) (0, $8POXm.remove)(scope.effects, effect);
    };
    effect.onTrack = onTrack;
    effect.onTrigger = onTrigger;
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $0a6cc4ba868319ae$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $0a6cc4ba868319ae$var$traverse(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $8POXm.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ((0, $01W3b.isRef)(value)) $0a6cc4ba868319ae$var$traverse(value.value, depth, seen);
    else if ((0, $8POXm.isArray)(value)) for(let i = 0; i < value.length; i++)$0a6cc4ba868319ae$var$traverse(value[i], depth, seen);
    else if ((0, $8POXm.isSet)(value) || (0, $8POXm.isMap)(value)) value.forEach((v1)=>{
        $0a6cc4ba868319ae$var$traverse(v1, depth, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value)) for(const key in value)$0a6cc4ba868319ae$var$traverse(value[key], depth, seen);
    return value;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) {
        $0a6cc4ba868319ae$var$warn$1(`withDirectives can only be used inside render functions.`);
        return vnode;
    }
    const instance = $0a6cc4ba868319ae$var$getExposeProxy($0a6cc4ba868319ae$var$currentRenderingInstance) || $0a6cc4ba868319ae$var$currentRenderingInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8POXm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $0a6cc4ba868319ae$var$traverse(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
const $0a6cc4ba868319ae$var$leaveCbKey = Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    if (hasFound) {
                        $0a6cc4ba868319ae$var$warn$1("<transition> can only be used on a single element or component. Use <transition-group> for lists.");
                        break;
                    }
                    child = c;
                    hasFound = true;
                }
            }
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (mode && mode !== "in-out" && mode !== "out-in" && mode !== "default") $0a6cc4ba868319ae$var$warn$1(`invalid <transition> mode: ${mode}`);
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getKeepAliveChild(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $0a6cc4ba868319ae$var$getKeepAliveChild(oldChild);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(innerChild, oldInnerChild)) {
                const leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) {
                            instance.effect.dirty = true;
                            instance.update();
                        }
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getKeepAliveChild(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) return vnode;
    if (0, vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8POXm.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8POXm.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8POXm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (!comp) $0a6cc4ba868319ae$var$warn$1(`Async component loader resolved to undefined. If you are using retry(), make sure to return its return value.`);
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            if (comp && !(0, $8POXm.isObject)(comp) && !(0, $8POXm.isFunction)(comp)) throw new Error(`Invalid async component load result: ${comp}`);
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) {
                    instance.parent.effect.dirty = true;
                    $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
                }
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8POXm.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8POXm.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                $0a6cc4ba868319ae$var$warn$1(`KeepAlive should contain exactly one component child.`);
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8POXm.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    } else {
        const apiName = (0, $8POXm.toHandlerKey)($0a6cc4ba868319ae$var$ErrorTypeStrings$1[type].replace(/ hook$/, ""));
        $0a6cc4ba868319ae$var$warn$1(`${apiName} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup().` + ` If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`);
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") && $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $8POXm.isArray)(source) || (0, $8POXm.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        if (!Number.isInteger(source)) $0a6cc4ba868319ae$var$warn$1(`The v-for range expect an integer value but got ${source}.`);
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.isCE || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot.length > 1) {
        $0a6cc4ba868319ae$var$warn$1(`SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template.`);
        slot = ()=>[];
    }
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    if (!(0, $8POXm.isObject)(obj)) {
        $0a6cc4ba868319ae$var$warn$1(`v-on with no argument expects an object value.`);
        return ret;
    }
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getExposeProxy(i) || i.proxy;
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, $01W3b.shallowReadonly)(i.props),
    $attrs: (i)=>(0, $01W3b.shallowReadonly)(i.attrs),
    $slots: (i)=>(0, $01W3b.shallowReadonly)(i.slots),
    $refs: (i)=>(0, $01W3b.shallowReadonly)(i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            i.effect.dirty = true;
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8POXm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8POXm.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key === "__isVue") return true;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") {
                (0, $01W3b.track)(instance.attrs, "get", "");
                $0a6cc4ba868319ae$var$markAttrsAccessed();
            } else if (key === "$slots") (0, $01W3b.track)(instance, "get", key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
        else if ($0a6cc4ba868319ae$var$currentRenderingInstance && (!(0, $8POXm.isString)(key) || // #1091 avoid internal isRef/isVNode checks on component instance leading
        // to infinite warning loop
        key.indexOf("__v") !== 0)) {
            if (data !== (0, $8POXm.EMPTY_OBJ) && $0a6cc4ba868319ae$var$isReservedPrefix(key[0]) && (0, $8POXm.hasOwn)(data, key)) $0a6cc4ba868319ae$var$warn$1(`Property ${JSON.stringify(key)} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`);
            else if (instance === $0a6cc4ba868319ae$var$currentRenderingInstance) $0a6cc4ba868319ae$var$warn$1(`Property ${JSON.stringify(key)} was accessed during render but is not defined on instance.`);
        }
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else if ((0, setupState.__isScriptSetup) && (0, $8POXm.hasOwn)(setupState, key)) {
            $0a6cc4ba868319ae$var$warn$1(`Cannot mutate <script setup> binding "${key}" from Options API.`);
            return false;
        } else if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
            data[key] = value;
            return true;
        } else if ((0, $8POXm.hasOwn)(instance.props, key)) {
            $0a6cc4ba868319ae$var$warn$1(`Attempting to mutate prop "${key}". Props are readonly.`);
            return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) {
            $0a6cc4ba868319ae$var$warn$1(`Attempting to mutate public property "${key}". Properties starting with $ are reserved and readonly.`);
            return false;
        } else if (key in instance.appContext.config.globalProperties) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            value: value
        });
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
$0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.ownKeys = (target)=>{
    $0a6cc4ba868319ae$var$warn$1(`Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.`);
    return Reflect.ownKeys(target);
};
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8POXm.isGloballyAllowed)(key);
        if (!has && $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.has(_, key)) $0a6cc4ba868319ae$var$warn$1(`Property ${JSON.stringify(key)} should not start with _ which is a reserved prefix for Vue internals.`);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    $0a6cc4ba868319ae$var$warnRuntimeUsage(`defineProps`);
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    $0a6cc4ba868319ae$var$warnRuntimeUsage(`defineEmits`);
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {
    $0a6cc4ba868319ae$var$warnRuntimeUsage(`defineExpose`);
}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {
    $0a6cc4ba868319ae$var$warnRuntimeUsage(`defineOptions`);
}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    $0a6cc4ba868319ae$var$warnRuntimeUsage(`defineSlots`);
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {
    $0a6cc4ba868319ae$var$warnRuntimeUsage("defineModel");
}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    $0a6cc4ba868319ae$var$warnRuntimeUsage(`withDefaults`);
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext().slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext().attrs;
}
function $0a6cc4ba868319ae$var$getContext() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (!i) $0a6cc4ba868319ae$var$warn$1(`useContext() called without active instance.`);
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8POXm.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        else $0a6cc4ba868319ae$var$warn$1(`props default key "${key}" has no corresponding declaration.`);
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8POXm.isArray)(a) && (0, $8POXm.isArray)(b)) return a.concat(b);
    return (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (!ctx) $0a6cc4ba868319ae$var$warn$1(`withAsyncContext called without active current instance. This is likely a bug.`);
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$0a6cc4ba868319ae$var$setCurrentInstance(ctx)
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = $0a6cc4ba868319ae$var$createDuplicateChecker();
    {
        const [propsOptions] = instance.propsOptions;
        if (propsOptions) for(const key in propsOptions)checkDuplicateProperties("Props" /* PROPS */ , key);
    }
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) {
            Object.defineProperty(ctx, key, {
                value: methodHandler.bind(publicThis),
                configurable: true,
                enumerable: true,
                writable: true
            });
            checkDuplicateProperties("Methods" /* METHODS */ , key);
        } else $0a6cc4ba868319ae$var$warn$1(`Method "${key}" has type "${typeof methodHandler}" in the component definition. Did you reference the function correctly?`);
    }
    if (dataOptions) {
        if (!(0, $8POXm.isFunction)(dataOptions)) $0a6cc4ba868319ae$var$warn$1(`The data option must be a function. Plain object usage is no longer supported.`);
        const data = dataOptions.call(publicThis, publicThis);
        if ((0, $8POXm.isPromise)(data)) $0a6cc4ba868319ae$var$warn$1(`data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>.`);
        if (!(0, $8POXm.isObject)(data)) $0a6cc4ba868319ae$var$warn$1(`data() should return an object.`);
        else {
            instance.data = (0, $01W3b.reactive)(data);
            for(const key in data){
                checkDuplicateProperties("Data" /* DATA */ , key);
                if (!$0a6cc4ba868319ae$var$isReservedPrefix(key[0])) Object.defineProperty(ctx, key, {
                    configurable: true,
                    enumerable: true,
                    get: ()=>data[key],
                    set: (0, $8POXm.NOOP)
                });
            }
        }
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        if (get === (0, $8POXm.NOOP)) $0a6cc4ba868319ae$var$warn$1(`Computed property "${key}" has no getter.`);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : ()=>{
            $0a6cc4ba868319ae$var$warn$1(`Write operation failed: computed property "${key}" is readonly.`);
        };
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
        checkDuplicateProperties("Computed" /* COMPUTED */ , key);
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP)) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
        checkDuplicateProperties("Inject" /* INJECT */ , key);
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
        else $0a6cc4ba868319ae$var$warn$1(`Invalid watch handler specified by key "${raw}"`, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
            else $0a6cc4ba868319ae$var$warn$1(`Invalid watch handler specified by key "${raw.handler}"`, handler);
        }
    } else $0a6cc4ba868319ae$var$warn$1(`Invalid watch option: "${key}"`, raw);
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from)if (asMixin && key === "expose") $0a6cc4ba868319ae$var$warn$1(`"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.`);
    else {
        const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
        to[key] = strat ? strat(to[key], from[key]) : from[key];
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8POXm.isArray)(to) && (0, $8POXm.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = (0, $8POXm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) {
            $0a6cc4ba868319ae$var$warn$1(`root props passed to app.mount() must be an object.`);
            rootProps = null;
        }
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){
                $0a6cc4ba868319ae$var$warn$1(`app.config cannot be replaced. Modify individual options instead.`);
            },
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) $0a6cc4ba868319ae$var$warn$1(`Plugin has already been applied to target app.`);
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                } else $0a6cc4ba868319ae$var$warn$1(`A plugin must either be a function or an object with an "install" function.`);
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                    else $0a6cc4ba868319ae$var$warn$1("Mixin has already been applied to target app" + (mixin.name ? `: ${mixin.name}` : ""));
                } else $0a6cc4ba868319ae$var$warn$1("Mixins are only available in builds supporting Options API");
                return app;
            },
            component (name, component) {
                $0a6cc4ba868319ae$var$validateComponentName(name, context.config);
                if (!component) return context.components[name];
                if (0, context.components[name]) $0a6cc4ba868319ae$var$warn$1(`Component "${name}" has already been registered in target app.`);
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                $0a6cc4ba868319ae$var$validateDirectiveName(name);
                if (!directive) return context.directives[name];
                if (0, context.directives[name]) $0a6cc4ba868319ae$var$warn$1(`Directive "${name}" has already been registered in target app.`);
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    if (0, rootContainer.__vue_app__) $0a6cc4ba868319ae$var$warn$1(`There is already an app instance mounted on the host container.
 If you want to mount another app on the same host container, you need to unmount the previous app by calling \`app.unmount()\` first.`);
                    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    context.reload = ()=>{
                        render($0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode), rootContainer, namespace);
                    };
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    app._instance = vnode.component;
                    $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    return $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                } else $0a6cc4ba868319ae$var$warn$1(`App has already been mounted.
If you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. \`const createMyApp = () => createApp(App)\``);
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    app._instance = null;
                    $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    delete app._container.__vue_app__;
                } else $0a6cc4ba868319ae$var$warn$1(`Cannot unmount an app that is not mounted.`);
            },
            provide (key, value) {
                if (key in context.provides) $0a6cc4ba868319ae$var$warn$1(`App already provides property with key "${String(key)}". It will be overwritten with the new value.`);
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if (!$0a6cc4ba868319ae$var$currentInstance) $0a6cc4ba868319ae$var$warn$1(`provide() can only be used inside setup().`);
    else {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $0a6cc4ba868319ae$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
        else $0a6cc4ba868319ae$var$warn$1(`injection "${String(key)}" not found.`);
    } else $0a6cc4ba868319ae$var$warn$1(`inject() can only be used inside setup() or functional components.`);
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    $0a6cc4ba868319ae$var$validateProps(rawProps || {}, props, instance);
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !$0a6cc4ba868319ae$var$isInHmrContext(instance) && (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
    $0a6cc4ba868319ae$var$validateProps(rawProps || {}, props, instance);
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8POXm.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        if (!(0, $8POXm.isString)(raw[i])) $0a6cc4ba868319ae$var$warn$1(`props must be strings when using array syntax.`, raw[i]);
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) {
        if (!(0, $8POXm.isObject)(raw)) $0a6cc4ba868319ae$var$warn$1(`invalid props options`, raw);
        for(const key in raw){
            const normalizedKey = (0, $8POXm.camelize)(key);
            if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
                const opt = raw[key];
                const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                    type: opt
                } : (0, $8POXm.extend)({}, opt);
                if (prop) {
                    const booleanIndex = $0a6cc4ba868319ae$var$getTypeIndex(Boolean, prop.type);
                    const stringIndex = $0a6cc4ba868319ae$var$getTypeIndex(String, prop.type);
                    prop[0 /* shouldCast */ ] = booleanIndex > -1;
                    prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                    if (booleanIndex > -1 || (0, $8POXm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
                }
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8POXm.isReservedProp)(key)) return true;
    else $0a6cc4ba868319ae$var$warn$1(`Invalid prop name: "${key}" is a reserved property.`);
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$isSameType(a, b) {
    return $0a6cc4ba868319ae$var$getType(a) === $0a6cc4ba868319ae$var$getType(b);
}
function $0a6cc4ba868319ae$var$getTypeIndex(type, expectedTypes) {
    if ((0, $8POXm.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$0a6cc4ba868319ae$var$isSameType(t, type));
    else if ((0, $8POXm.isFunction)(expectedTypes)) return $0a6cc4ba868319ae$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, (0, $01W3b.shallowReadonly)(resolvedValues), !(0, $8POXm.hasOwn)(rawProps, key) && !(0, $8POXm.hasOwn)(rawProps, (0, $8POXm.hyphenate)(key)));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8POXm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8POXm.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8POXm.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8POXm.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        if ($0a6cc4ba868319ae$var$currentInstance && (!ctx || ctx.root === $0a6cc4ba868319ae$var$currentInstance.root)) $0a6cc4ba868319ae$var$warn$1(`Slot "${key}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`);
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8POXm.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            $0a6cc4ba868319ae$var$warn$1(`Non-function value encountered for slot "${key}". Prefer function slots for better performance.`);
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    if (!$0a6cc4ba868319ae$var$isKeepAlive(instance.vnode) && true) $0a6cc4ba868319ae$var$warn$1(`Non-function value encountered for default slot. Prefer function slots for better performance.`);
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            (0, $8POXm.extend)(slots, children);
            (0, $8POXm.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if ($0a6cc4ba868319ae$var$isHmrUpdating) {
                (0, $8POXm.extend)(slots, children);
                (0, $01W3b.trigger)(instance, "set", "$slots");
            } else if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $8POXm.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    if (!owner) {
        $0a6cc4ba868319ae$var$warn$1(`Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function.`);
        return;
    }
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $8POXm.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $8POXm.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $8POXm.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $8POXm.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                } else $0a6cc4ba868319ae$var$warn$1("Invalid template ref type:", ref, `(${typeof ref})`);
            };
            if (value) {
                doSet.id = -1;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        } else $0a6cc4ba868319ae$var$warn$1("Invalid template ref type:", ref, `(${typeof ref})`);
    }
}
let $0a6cc4ba868319ae$var$hasMismatch = false;
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $0a6cc4ba868319ae$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($0a6cc4ba868319ae$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (!("__vnode" in node)) Object.defineProperty(node, "__vnode", {
            value: vnode,
            enumerable: false
        });
        if (!("__vueParentComponent" in node)) Object.defineProperty(node, "__vueParentComponent", {
            value: parentComponent,
            enumerable: false
        });
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $0a6cc4ba868319ae$var$hasMismatch = true;
                        $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    if (!hasWarned) {
                        $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                    el.textContent = vnode.children;
                }
            }
            if (props) for(const key in props){
                if ($0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$hasMismatch = true;
                if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                key[0] === ".") patchProp(el, key, null, props[key], void 0, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $0a6cc4ba868319ae$var$hasMismatch = true;
                if (!hasWarned) {
                    $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                    hasWarned = true;
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $0a6cc4ba868319ae$var$hasMismatch = true;
        $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 /* TEXT */  ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 /* ELEMENT */  && node.tagName.toLowerCase() === "template";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    var _a;
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $8POXm.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) mismatchType = mismatchKey = `class`;
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $8POXm.isString)(clientValue) ? clientValue : (0, $8POXm.stringifyStyle)((0, $8POXm.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        const root = instance == null ? void 0 : instance.subTree;
        if (vnode === root || (root == null ? void 0 : root.type) === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode)) {
            const cssVars = (_a = instance == null ? void 0 : instance.getCssVars) == null ? void 0 : _a.call(instance);
            for(const key2 in cssVars)expectedMap.set(`--${key2}`, String(cssVars[key2]));
        }
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) mismatchType = mismatchKey = "style";
    } else if (el instanceof SVGElement && (0, $8POXm.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8POXm.isBooleanAttr)(key) || (0, $8POXm.isKnownHtmlAttr)(key))) {
        if ((0, $8POXm.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8POXm.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8POXm.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = `attribute`;
            mismatchKey = key;
        }
    }
    if (mismatchType) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${mismatchType} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key == null ? void 0 : key.trim();
        value = value == null ? void 0 : value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(`<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") {
        needWarn.push(`__VUE_OPTIONS_API__`);
        (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    }
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") {
        needWarn.push(`__VUE_PROD_DEVTOOLS__`);
        (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    }
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") {
        needWarn.push(`__VUE_PROD_HYDRATION_MISMATCH_DETAILS__`);
        (0, $8POXm.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
    }
    if (0, needWarn.length) {
        const multi = needWarn.length > 1;
        console.warn(`Feature flag${multi ? `s` : ``} ${needWarn.join(", ")} ${multi ? `are` : `is`} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`);
    }
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = $0a6cc4ba868319ae$var$isHmrUpdating ? false : !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                else patchStaticNode(n1, n2, container, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else $0a6cc4ba868319ae$var$warn$1("Invalid VNode type:", type, `(${typeof type})`);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        Object.defineProperty(el, "__vnode", {
            value: vnode,
            enumerable: false
        });
        Object.defineProperty(el, "__vueParentComponent", {
            value: parentComponent,
            enumerable: false
        });
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (subTree.patchFlag > 0 && subTree.patchFlag & 2048) subTree = $0a6cc4ba868319ae$var$filterSingleRoot(subTree.children) || subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if ($0a6cc4ba868319ae$var$isHmrUpdating) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
            $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2);
        } else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (// #5523 dev root fragment may inherit directives
        $0a6cc4ba868319ae$var$isHmrUpdating || patchFlag & 2048) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if (0, instance.type.__hmrId) $0a6cc4ba868319ae$var$registerHMR(instance);
        $0a6cc4ba868319ae$var$pushWarningContext(initialVNode);
        $0a6cc4ba868319ae$var$startMeasure(instance, `mount`);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$startMeasure(instance, `init`);
        $0a6cc4ba868319ae$var$setupComponent(instance);
        $0a6cc4ba868319ae$var$endMeasure(instance, `init`);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
        $0a6cc4ba868319ae$var$popWarningContext();
        $0a6cc4ba868319ae$var$endMeasure(instance, `mount`);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                $0a6cc4ba868319ae$var$pushWarningContext(n2);
                updateComponentPreRender(instance, n2, optimized);
                $0a6cc4ba868319ae$var$popWarningContext();
                return;
            } else {
                instance.next = n2;
                $0a6cc4ba868319ae$var$invalidateJob(instance.update);
                instance.effect.dirty = true;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        $0a6cc4ba868319ae$var$startMeasure(instance, `render`);
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        $0a6cc4ba868319ae$var$endMeasure(instance, `render`);
                        $0a6cc4ba868319ae$var$startMeasure(instance, `hydrate`);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                        $0a6cc4ba868319ae$var$endMeasure(instance, `hydrate`);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    $0a6cc4ba868319ae$var$startMeasure(instance, `render`);
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    $0a6cc4ba868319ae$var$endMeasure(instance, `render`);
                    $0a6cc4ba868319ae$var$startMeasure(instance, `patch`);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    $0a6cc4ba868319ae$var$endMeasure(instance, `patch`);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$pushWarningContext(next || instance.vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                $0a6cc4ba868319ae$var$startMeasure(instance, `render`);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                $0a6cc4ba868319ae$var$endMeasure(instance, `render`);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                $0a6cc4ba868319ae$var$startMeasure(instance, `patch`);
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                $0a6cc4ba868319ae$var$endMeasure(instance, `patch`);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
                $0a6cc4ba868319ae$var$popWarningContext();
            }
        };
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn, (0, $8POXm.NOOP), ()=>$0a6cc4ba868319ae$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>{
            if (effect.dirty) effect.run();
        };
        update.id = instance.uid;
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        effect.onTrack = instance.rtc ? (e)=>(0, $8POXm.invokeArrayFns)(instance.rtc, e) : void 0;
        effect.onTrigger = instance.rtg ? (e)=>(0, $8POXm.invokeArrayFns)(instance.rtg, e) : void 0;
        update.ownerInstance = instance;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) {
                    if (keyToNewIndexMap.has(nextChild.key)) $0a6cc4ba868319ae$var$warn$1(`Duplicate keys found during update:`, JSON.stringify(nextChild.key), `Make sure keys are unique.`);
                    keyToNewIndexMap.set(nextChild.key, i);
                }
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (vnode.patchFlag > 0 && vnode.patchFlag & 2048 && transition && !transition.persisted) vnode.children.forEach((child)=>{
                if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) hostRemove(child.el);
                else remove(child);
            });
            else removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        if (0, instance.type.__hmrId) $0a6cc4ba868319ae$var$unregisterHMR(instance);
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        if (!isFlushing) {
            isFlushing = true;
            $0a6cc4ba868319ae$var$flushPreFlushCbs();
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            isFlushing = false;
        }
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) c2.el = c1.el;
        if (c2.type === $0a6cc4ba868319ae$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) {
            $0a6cc4ba868319ae$var$warn$1(`Current renderer does not support string target for Teleports. (missing querySelector renderer option)`);
            return null;
        } else {
            const target = select(targetSelector);
            if (!target) $0a6cc4ba868319ae$var$warn$1(`Failed to locate Teleport target with selector "${targetSelector}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`);
            return target;
        }
    } else {
        if (!targetSelector && !$0a6cc4ba868319ae$var$isTeleportDisabled(props)) $0a6cc4ba868319ae$var$warn$1(`Invalid Teleport target: ${targetSelector}`);
        return targetSelector;
    }
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if ($0a6cc4ba868319ae$var$isHmrUpdating) {
            optimized = false;
            dynamicChildren = null;
        }
        if (n1 == null) {
            const placeholder = n2.el = createComment("teleport start");
            const mainAnchor = n2.anchor = createComment("teleport end");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            } else if (!disabled) $0a6cc4ba868319ae$var$warn$1("Invalid Teleport target on mount:", target, `(${typeof target})`);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                    else $0a6cc4ba868319ae$var$warn$1("Invalid Teleport target on update:", target, `(${typeof target})`);
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    if (n2.shapeFlag & 6 && $0a6cc4ba868319ae$var$hmrDirtyComponents.has(n2.type)) {
        n1.shapeFlag &= -257;
        n2.shapeFlag &= -513;
        return false;
    }
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 : 16;
    if (vnode.key !== vnode.key) $0a6cc4ba868319ae$var$warn$1(`VNode created with invalid key (NaN). VNode type:`, vnode.type);
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$createVNodeWithArgsTransform;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) {
        if (!type) $0a6cc4ba868319ae$var$warn$1(`Invalid vnode type when creating vnode: ${type}.`);
        type = $0a6cc4ba868319ae$export$4d299b491347818a;
    }
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8POXm.isObject)(type) ? 4 : (0, $8POXm.isFunction)(type) ? 2 : 0;
    if (shapeFlag & 4 && (0, $01W3b.isProxy)(type)) {
        type = (0, $01W3b.toRaw)(type);
        $0a6cc4ba868319ae$var$warn$1(`Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with \`markRaw\` or using \`shallowRef\` instead of \`ref\`.`, `
Component that was made reactive: `, type);
    }
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: patchFlag === -1 && (0, $8POXm.isArray)(children) ? children.map($0a6cc4ba868319ae$var$deepCloneVNode) : children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) cloned.transition = transition.clone(cloned);
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = $0a6cc4ba868319ae$var$createDevRenderContext(instance);
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8POXm.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8POXm.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    if (Component.name) $0a6cc4ba868319ae$var$validateComponentName(Component.name, instance.appContext.config);
    if (Component.components) {
        const names = Object.keys(Component.components);
        for(let i = 0; i < names.length; i++)$0a6cc4ba868319ae$var$validateComponentName(names[i], instance.appContext.config);
    }
    if (Component.directives) {
        const names = Object.keys(Component.directives);
        for(let i = 0; i < names.length; i++)$0a6cc4ba868319ae$var$validateDirectiveName(names[i]);
    }
    if (Component.compilerOptions && $0a6cc4ba868319ae$export$c93a9c496c5211fa()) $0a6cc4ba868319ae$var$warn$1(`"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.`);
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance);
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, $01W3b.shallowReadonly)(instance.props),
            setupContext
        ]);
        (0, $01W3b.resetTracking)();
        reset();
        if ((0, $8POXm.isPromise)(setupResult)) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else {
                instance.asyncDep = setupResult;
                if (!instance.suspense) {
                    const name = (_a = Component.name) != null ? _a : "Anonymous";
                    $0a6cc4ba868319ae$var$warn$1(`Component <${name}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`);
                }
            }
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(setupResult)) $0a6cc4ba868319ae$var$warn$1(`setup() should not return VNodes directly - return a render function instead.`);
        instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
        $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance);
    } else if (setupResult !== void 0) $0a6cc4ba868319ae$var$warn$1(`setup() should return an object. Received: ${setupResult === null ? "null" : typeof setupResult}`);
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                $0a6cc4ba868319ae$var$startMeasure(instance, `compile`);
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
                $0a6cc4ba868319ae$var$endMeasure(instance, `compile`);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
    if (!Component.render && instance.render === (0, $8POXm.NOOP) && !isSSR) {
        if (!$0a6cc4ba868319ae$var$compile && Component.template) $0a6cc4ba868319ae$var$warn$1(`Component provided template option but runtime compilation is not supported in this build of Vue.` + ` Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".`);
        else $0a6cc4ba868319ae$var$warn$1(`Component is missing template or render function.`);
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        $0a6cc4ba868319ae$var$markAttrsAccessed();
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    },
    set () {
        $0a6cc4ba868319ae$var$warn$1(`setupContext.attrs is readonly.`);
        return false;
    },
    deleteProperty () {
        $0a6cc4ba868319ae$var$warn$1(`setupContext.attrs is readonly.`);
        return false;
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        if (instance.exposed) $0a6cc4ba868319ae$var$warn$1(`expose() should be called only once per setup().`);
        if (exposed != null) {
            let exposedType = typeof exposed;
            if (exposedType === "object") {
                if ((0, $8POXm.isArray)(exposed)) exposedType = "array";
                else if ((0, $01W3b.isRef)(exposed)) exposedType = "ref";
            }
            if (exposedType !== "object") $0a6cc4ba868319ae$var$warn$1(`expose() should be passed a plain object, received ${exposedType}.`);
        }
        instance.exposed = exposed || {};
    };
    {
        let attrsProxy;
        return Object.freeze({
            get attrs () {
                return attrsProxy || (attrsProxy = new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers));
            },
            get slots () {
                return $0a6cc4ba868319ae$var$getSlotsProxy(instance);
            },
            get emit () {
                return (event, ...args)=>instance.emit(event, ...args);
            },
            expose: expose
        });
    }
}
function $0a6cc4ba868319ae$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])(\w)/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8POXm.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    {
        const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
        if (i && i.appContext.config.warnRecursiveComputed) c._warnRecursive = true;
    }
    return c;
};
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8POXm.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (!i) {
        $0a6cc4ba868319ae$var$warn$1(`useModel() called without active instance.`);
        return (0, $01W3b.ref)();
    }
    if (!i.propsOptions[0][name]) {
        $0a6cc4ba868319ae$var$warn$1(`useModel() called with prop "${name}" which is not declared.`);
        return (0, $01W3b.ref)();
    }
    const camelizedName = (0, $8POXm.camelize)(name);
    const hyphenatedName = (0, $8POXm.hyphenate)(name);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[name];
            if ((0, $8POXm.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps)) && (0, $8POXm.hasChanged)(value, localValue)) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, options.set ? options.set(value) : value);
            }
        };
    });
    const modifierKey = name === "modelValue" ? "modelModifiers" : `${name}Modifiers`;
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? props[modifierKey] || {} : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
            if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    if (typeof window === "undefined") return;
    const vueStyle = {
        style: "color:#3ba776"
    };
    const numberStyle = {
        style: "color:#1677ff"
    };
    const stringStyle = {
        style: "color:#f5222d"
    };
    const keywordStyle = {
        style: "color:#eb2f96"
    };
    const formatter = {
        header (obj) {
            if (!(0, $8POXm.isObject)(obj)) return null;
            if (obj.__isVue) return [
                "div",
                vueStyle,
                `VueInstance`
            ];
            else if ((0, $01W3b.isRef)(obj)) return [
                "div",
                {},
                [
                    "span",
                    vueStyle,
                    genRefFlag(obj)
                ],
                "<",
                formatValue(obj.value),
                `>`
            ];
            else if ((0, $01W3b.isReactive)(obj)) return [
                "div",
                {},
                [
                    "span",
                    vueStyle,
                    (0, $01W3b.isShallow)(obj) ? "ShallowReactive" : "Reactive"
                ],
                "<",
                formatValue(obj),
                `>${(0, $01W3b.isReadonly)(obj) ? ` (readonly)` : ``}`
            ];
            else if ((0, $01W3b.isReadonly)(obj)) return [
                "div",
                {},
                [
                    "span",
                    vueStyle,
                    (0, $01W3b.isShallow)(obj) ? "ShallowReadonly" : "Readonly"
                ],
                "<",
                formatValue(obj),
                ">"
            ];
            return null;
        },
        hasBody (obj) {
            return obj && obj.__isVue;
        },
        body (obj) {
            if (obj && obj.__isVue) return [
                "div",
                {},
                ...formatInstance(obj.$)
            ];
        }
    };
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
    if (window.devtoolsFormatters) window.devtoolsFormatters.push(formatter);
    else window.devtoolsFormatters = [
        formatter
    ];
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.4.27";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = $0a6cc4ba868319ae$var$warn$1;
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $005d1fb7704e278c$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $005d1fb7704e278c$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "readonly", () => $005d1fb7704e278c$export$6ec456bd5b7b3c51);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "isReadonly", () => $005d1fb7704e278c$export$92d09b48637741e7);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "shallowReadonly", () => $005d1fb7704e278c$export$7c4b5f2b50f09f6b);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "toValue", () => $005d1fb7704e278c$export$30bdcc2218aa9458);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $005d1fb7704e278c$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $005d1fb7704e278c$export$1f60508e4f47b4b7);
/**
* @vue/reactivity v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $005d1fb7704e278c$var$activeEffectScope;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        } else $005d1fb7704e278c$var$warn(`cannot run an inactive effect scope.`);
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $005d1fb7704e278c$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $005d1fb7704e278c$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$var$recordEffectScope(effect, scope = $005d1fb7704e278c$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
    else $005d1fb7704e278c$var$warn(`onScopeDispose() is called when there is no active effect scope to be associated with.`);
}
let $005d1fb7704e278c$var$activeEffect;
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn, trigger, scheduler, scope){
        this.fn = fn;
        this.trigger = trigger;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        /**
     * @internal
     */ this._dirtyLevel = 4;
        /**
     * @internal
     */ this._trackId = 0;
        /**
     * @internal
     */ this._runnings = 0;
        /**
     * @internal
     */ this._shouldSchedule = false;
        /**
     * @internal
     */ this._depsLength = 0;
        $005d1fb7704e278c$var$recordEffectScope(this, scope);
    }
    get dirty() {
        if (this._dirtyLevel === 2 || this._dirtyLevel === 3) {
            this._dirtyLevel = 1;
            $005d1fb7704e278c$export$938a971395fef855();
            for(let i = 0; i < this._depsLength; i++){
                const dep = this.deps[i];
                if (dep.computed) {
                    $005d1fb7704e278c$var$triggerComputed(dep.computed);
                    if (this._dirtyLevel >= 4) break;
                }
            }
            if (this._dirtyLevel === 1) this._dirtyLevel = 0;
            $005d1fb7704e278c$export$c39176b1babaa8b8();
        }
        return this._dirtyLevel >= 4;
    }
    set dirty(v) {
        this._dirtyLevel = v ? 4 : 0;
    }
    run() {
        this._dirtyLevel = 0;
        if (!this.active) return this.fn();
        let lastShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        let lastEffect = $005d1fb7704e278c$var$activeEffect;
        try {
            $005d1fb7704e278c$var$shouldTrack = true;
            $005d1fb7704e278c$var$activeEffect = this;
            this._runnings++;
            $005d1fb7704e278c$var$preCleanupEffect(this);
            return this.fn();
        } finally{
            $005d1fb7704e278c$var$postCleanupEffect(this);
            this._runnings--;
            $005d1fb7704e278c$var$activeEffect = lastEffect;
            $005d1fb7704e278c$var$shouldTrack = lastShouldTrack;
        }
    }
    stop() {
        if (this.active) {
            $005d1fb7704e278c$var$preCleanupEffect(this);
            $005d1fb7704e278c$var$postCleanupEffect(this);
            this.onStop && this.onStop();
            this.active = false;
        }
    }
}
function $005d1fb7704e278c$var$triggerComputed(computed) {
    return computed.value;
}
function $005d1fb7704e278c$var$preCleanupEffect(effect2) {
    effect2._trackId++;
    effect2._depsLength = 0;
}
function $005d1fb7704e278c$var$postCleanupEffect(effect2) {
    if (effect2.deps.length > effect2._depsLength) {
        for(let i = effect2._depsLength; i < effect2.deps.length; i++)$005d1fb7704e278c$var$cleanupDepEffect(effect2.deps[i], effect2);
        effect2.deps.length = effect2._depsLength;
    }
}
function $005d1fb7704e278c$var$cleanupDepEffect(dep, effect2) {
    const trackId = dep.get(effect2);
    if (trackId !== void 0 && effect2._trackId !== trackId) {
        dep.delete(effect2);
        if (dep.size === 0) dep.cleanup();
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const _effect = new $005d1fb7704e278c$export$28352bb4dd362521(fn, (0, $8POXm.NOOP), ()=>{
        if (_effect.dirty) _effect.run();
    });
    if (options) {
        (0, $8POXm.extend)(_effect, options);
        if (options.scope) $005d1fb7704e278c$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
let $005d1fb7704e278c$var$pauseScheduleStack = 0;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$262a949f95482a17() {
    $005d1fb7704e278c$var$pauseScheduleStack++;
}
function $005d1fb7704e278c$export$3539fa10306ef581() {
    $005d1fb7704e278c$var$pauseScheduleStack--;
    while(!$005d1fb7704e278c$var$pauseScheduleStack && $005d1fb7704e278c$var$queueEffectSchedulers.length)$005d1fb7704e278c$var$queueEffectSchedulers.shift()();
}
function $005d1fb7704e278c$var$trackEffect(effect2, dep, debuggerEventExtraInfo) {
    var _a;
    if (dep.get(effect2) !== effect2._trackId) {
        dep.set(effect2, effect2._trackId);
        const oldDep = effect2.deps[effect2._depsLength];
        if (oldDep !== dep) {
            if (oldDep) $005d1fb7704e278c$var$cleanupDepEffect(oldDep, effect2);
            effect2.deps[effect2._depsLength++] = dep;
        } else effect2._depsLength++;
        (_a = effect2.onTrack) == null || _a.call(effect2, (0, $8POXm.extend)({
            effect: effect2
        }, debuggerEventExtraInfo));
    }
}
const $005d1fb7704e278c$var$queueEffectSchedulers = [];
function $005d1fb7704e278c$var$triggerEffects(dep, dirtyLevel, debuggerEventExtraInfo) {
    var _a;
    $005d1fb7704e278c$export$262a949f95482a17();
    for (const effect2 of dep.keys()){
        let tracking;
        if (effect2._dirtyLevel < dirtyLevel && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2._shouldSchedule || (effect2._shouldSchedule = effect2._dirtyLevel === 0);
            effect2._dirtyLevel = dirtyLevel;
        }
        if (effect2._shouldSchedule && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            (_a = effect2.onTrigger) == null || _a.call(effect2, (0, $8POXm.extend)({
                effect: effect2
            }, debuggerEventExtraInfo));
            effect2.trigger();
            if ((!effect2._runnings || effect2.allowRecurse) && effect2._dirtyLevel !== 2) {
                effect2._shouldSchedule = false;
                if (effect2.scheduler) $005d1fb7704e278c$var$queueEffectSchedulers.push(effect2.scheduler);
            }
        }
    }
    $005d1fb7704e278c$export$3539fa10306ef581();
}
const $005d1fb7704e278c$var$createDep = (cleanup, computed)=>{
    const dep = /* @__PURE__ */ new Map();
    dep.cleanup = cleanup;
    dep.computed = computed;
    return dep;
};
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = Symbol("iterate");
const $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $005d1fb7704e278c$var$createDep(()=>depsMap.delete(key)));
        $005d1fb7704e278c$var$trackEffect($005d1fb7704e278c$var$activeEffect, dep, {
            target: target,
            type: type,
            key: key
        });
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $8POXm.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || !(0, $8POXm.isSymbol)(key2) && key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $8POXm.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $8POXm.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $8POXm.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                break;
        }
    }
    $005d1fb7704e278c$export$262a949f95482a17();
    for (const dep of deps)if (dep) $005d1fb7704e278c$var$triggerEffects(dep, 4, {
        target: target,
        type: type,
        key: key,
        newValue: newValue,
        oldValue: oldValue,
        oldTarget: oldTarget
    });
    $005d1fb7704e278c$export$3539fa10306ef581();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depsMap && depsMap.get(key);
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
const $005d1fb7704e278c$var$arrayInstrumentations = /* @__PURE__ */ $005d1fb7704e278c$var$createArrayInstrumentations();
function $005d1fb7704e278c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$005d1fb7704e278c$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($005d1fb7704e278c$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $005d1fb7704e278c$export$938a971395fef855();
            $005d1fb7704e278c$export$262a949f95482a17();
            const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $005d1fb7704e278c$export$3539fa10306ef581();
            $005d1fb7704e278c$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $8POXm.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the reciever is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $8POXm.hasOwn)($005d1fb7704e278c$var$arrayInstrumentations, key)) return Reflect.get($005d1fb7704e278c$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
        if ((0, $8POXm.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $8POXm.isArray)(target) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key) ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $8POXm.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $8POXm.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        $005d1fb7704e278c$var$warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
    deleteProperty(target, key) {
        $005d1fb7704e278c$var$warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $005d1fb7704e278c$var$getProto(rawTarget);
    const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $005d1fb7704e278c$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $005d1fb7704e278c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $005d1fb7704e278c$var$add(value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const proto = $005d1fb7704e278c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $005d1fb7704e278c$var$set(key, value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    } else $005d1fb7704e278c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $005d1fb7704e278c$var$deleteEntry(key) {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    } else $005d1fb7704e278c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $005d1fb7704e278c$var$clear() {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = (0, $8POXm.isMap)(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $005d1fb7704e278c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            $005d1fb7704e278c$var$warn(`${(0, $8POXm.capitalize)(type)} operation ${key}failed: target is readonly.`, $005d1fb7704e278c$export$ab18938b9fc5f28e(this));
        }
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, false, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$005d1fb7704e278c$var$mutableInstrumentations, $005d1fb7704e278c$var$readonlyInstrumentations, $005d1fb7704e278c$var$shallowInstrumentations, $005d1fb7704e278c$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentations();
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $005d1fb7704e278c$var$shallowReadonlyInstrumentations : $005d1fb7704e278c$var$shallowInstrumentations : isReadonly ? $005d1fb7704e278c$var$readonlyInstrumentations : $005d1fb7704e278c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(value));
}
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) {
        $005d1fb7704e278c$var$warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(value)) return $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (Object.isExtensible(value)) (0, $8POXm.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$var$toReactive = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$var$toReadonly = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
const $005d1fb7704e278c$var$COMPUTED_SIDE_EFFECT_WARN = `Computed is still dirty after getter evaluation, likely because a computed is mutating its own dependency in its getter. State mutations in computed getters should be avoided.  Check the docs for more details: https://vuejs.org/guide/essentials/computed.html#getters-should-be-side-effect-free`;
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this.getter = getter;
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this.effect = new $005d1fb7704e278c$export$28352bb4dd362521(()=>getter(this._value), ()=>$005d1fb7704e278c$var$triggerRefValue(this, this.effect._dirtyLevel === 2 ? 2 : 3));
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
        if ((!self._cacheable || self.effect.dirty) && (0, $8POXm.hasChanged)(self._value, self._value = self.effect.run())) $005d1fb7704e278c$var$triggerRefValue(self, 4);
        $005d1fb7704e278c$var$trackRefValue(self);
        if (self.effect._dirtyLevel >= 2) {
            if (0, this._warnRecursive) $005d1fb7704e278c$var$warn($005d1fb7704e278c$var$COMPUTED_SIDE_EFFECT_WARN, `

getter: `, this.getter);
            $005d1fb7704e278c$var$triggerRefValue(self, 2);
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
    get _dirty() {
        return this.effect.dirty;
    }
    set _dirty(v) {
        this.effect.dirty = v;
    }
}
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $8POXm.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = ()=>{
            $005d1fb7704e278c$var$warn("Write operation failed: computed value is readonly");
        };
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    if (debugOptions && !isSSR) {
        cRef.effect.onTrack = debugOptions.onTrack;
        cRef.effect.onTrigger = debugOptions.onTrigger;
    }
    return cRef;
}
function $005d1fb7704e278c$var$trackRefValue(ref2) {
    var _a;
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
        $005d1fb7704e278c$var$trackEffect($005d1fb7704e278c$var$activeEffect, (_a = ref2.dep) != null ? _a : ref2.dep = $005d1fb7704e278c$var$createDep(()=>ref2.dep = void 0, ref2 instanceof $005d1fb7704e278c$var$ComputedRefImpl ? ref2 : void 0), {
            target: ref2,
            type: "get",
            key: "value"
        });
    }
}
function $005d1fb7704e278c$var$triggerRefValue(ref2, dirtyLevel = 4, newVal) {
    ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $005d1fb7704e278c$var$triggerEffects(dep, dirtyLevel, {
        target: ref2,
        type: "set",
        key: "value",
        newValue: newVal
    });
}
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $005d1fb7704e278c$var$toReactive(value);
    }
    get value() {
        $005d1fb7704e278c$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $005d1fb7704e278c$export$7f3fe6025abfa26e(newVal) || $005d1fb7704e278c$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $005d1fb7704e278c$export$ab18938b9fc5f28e(newVal);
        if ((0, $8POXm.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $005d1fb7704e278c$var$toReactive(newVal);
            $005d1fb7704e278c$var$triggerRefValue(this, 4, newVal);
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    $005d1fb7704e278c$var$triggerRefValue(ref2, 4, (0, ref2.value));
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $8POXm.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$005d1fb7704e278c$var$trackRefValue(this), ()=>$005d1fb7704e278c$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    if (!$005d1fb7704e278c$export$5f3ca29d057519b3(object)) $005d1fb7704e278c$var$warn(`toRefs() expects a reactive object but received a plain one.`);
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive($005d1fb7704e278c$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $8POXm.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $8POXm.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $005d1fb7704e278c$export$4f9f5282de18fc69(val) ? val : new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
const $005d1fb7704e278c$export$483264c4ec4c46ce = $005d1fb7704e278c$export$2983e091f1a1e8e2;
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw"
};

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $66ea9d0aaa418c4d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $66ea9d0aaa418c4d$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $66ea9d0aaa418c4d$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $66ea9d0aaa418c4d$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $66ea9d0aaa418c4d$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $66ea9d0aaa418c4d$export$921dd2acf0d386a3);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
/**
* @vue/shared v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = Object.freeze({});
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = Object.freeze([]);
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) || $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val)) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-(\w)/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $66ea9d0aaa418c4d$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $66ea9d0aaa418c4d$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_ALLOWED);
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf;
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, "").split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$4a46ca4c5be17b20 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$MATH_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $66ea9d0aaa418c4d$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    return src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$66ea9d0aaa418c4d$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$66ea9d0aaa418c4d$var$stringifySymbol(v))
    };
    else if ($66ea9d0aaa418c4d$export$a244864fd9645c7f(val)) return $66ea9d0aaa418c4d$var$stringifySymbol(val);
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $66ea9d0aaa418c4d$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $66ea9d0aaa418c4d$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});



parcelRegister("eeJ70", function(module, exports) {
$parcel$export(module.exports, "assertNumber", () => (parcelRequire("TusQn")).assertNumber);
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("TusQn")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("TusQn")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("TusQn")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "cloneVNode", () => (parcelRequire("TusQn")).cloneVNode);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("TusQn")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("TusQn")).createRenderer);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("TusQn")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("TusQn")).isRuntimeOnly);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "mergeModels", () => (parcelRequire("TusQn")).mergeModels);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("TusQn")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("TusQn")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("TusQn")).setTransitionHooks);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "Static", () => (parcelRequire("TusQn")).Static);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("TusQn")).Teleport);
$parcel$export(module.exports, "Text", () => (parcelRequire("TusQn")).Text);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useModel", () => (parcelRequire("TusQn")).useModel);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("TusQn")).useTransitionState);
$parcel$export(module.exports, "version", () => (parcelRequire("TusQn")).version);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "watchPostEffect", () => (parcelRequire("TusQn")).watchPostEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "toValue", () => (parcelRequire("01W3b")).toValue);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);

$parcel$export(module.exports, "TransitionGroup", () => $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelCheckbox", () => $a5d55dc64ccb07cf$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelRadio", () => $a5d55dc64ccb07cf$export$b4356c59b38b7aa9);
$parcel$export(module.exports, "vModelSelect", () => $a5d55dc64ccb07cf$export$87d227567b51ca39);
$parcel$export(module.exports, "vModelDynamic", () => $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
/**
* @vue/runtime-dom v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");parcelRequire("01W3b");parcelRequire("8POXm");

var $8POXm = parcelRequire("8POXm");
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : $a5d55dc64ccb07cf$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content;
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = Symbol("_vtc");
const $a5d55dc64ccb07cf$export$be58926105124dd4 = (props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots);
$a5d55dc64ccb07cf$export$be58926105124dd4.displayName = "Transition";
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = $a5d55dc64ccb07cf$export$be58926105124dd4.props = /* @__PURE__ */ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            $a5d55dc64ccb07cf$var$forceReflow();
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    (0, $TusQn.assertNumber)(res, "<transition> explicit duration");
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow() {
    return document.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
$a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.name = "show";
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = Symbol("CSS_VAR_TEXT");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) {
        (0, $TusQn.warn)(`useCssVars is called without current active component instance.`);
        return;
    }
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    instance.getCssVars = ()=>getter(instance.proxy);
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watchPostEffect)(setVars);
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $8POXm.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if ($a5d55dc64ccb07cf$var$semicolonRE.test(val)) (0, $TusQn.warn)(`Unexpected semicolon at the end of '${name}' style value: '${val}'`);
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {
        if (!needRemove) (0, $TusQn.warn)(`Failed setting prop "${key}" on <${tag.toLowerCase()}>: value ${value} is invalid.`, e);
    }
    needRemove && el.removeAttribute(key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = $a5d55dc64ccb07cf$var$sanitizeEventValue(nextValue, rawName);
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker($a5d55dc64ccb07cf$var$sanitizeEventValue(nextValue, rawName), instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $8POXm.isFunction)(value) || (0, $8POXm.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $8POXm.NOOP;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $8POXm.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$var$patchProp = (el, key, prevValue, nextValue, namespace, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $TusQn.defineComponent)(options);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, $a5d55dc64ccb07cf$export$fa8d919ba61d84db);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._ob = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            if (0, this.shadowRoot) (0, $TusQn.warn)(`Custom element has pre-rendered declarative shadow root but is not defined as hydratable. Use \`defineSSRCustomElement\`.`);
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        if (this._ob) {
            this._ob.disconnect();
            this._ob = null;
        }
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $8POXm.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $8POXm.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $8POXm.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.hasAttribute(key) ? this.getAttribute(key) : void 0;
        const camelKey = (0, $8POXm.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $8POXm.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8POXm.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
            }
        }
    }
    _update() {
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            instance.ceReload = (newStyles)=>{
                if (this._styles) {
                    this._styles.forEach((s)=>this.shadowRoot.removeChild(s));
                    this._styles.length = 0;
                }
                this._applyStyles(newStyles);
                this._instance = null;
                this._update();
            };
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $8POXm.hyphenate)(event) !== event) dispatch((0, $8POXm.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
            (this._styles || (this._styles = [])).push(s);
        });
    }
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) {
            (0, $TusQn.warn)(`useCssModule must be called inside setup()`);
            return 0, $8POXm.EMPTY_OBJ;
        }
        const modules = instance.type.__cssModules;
        if (!modules) {
            (0, $TusQn.warn)(`Current instance does not have CSS modules injected.`);
            return 0, $8POXm.EMPTY_OBJ;
        }
        const mod = modules[name];
        if (!mod) {
            (0, $TusQn.warn)(`Current instance does not have CSS module named "${name}".`);
            return 0, $8POXm.EMPTY_OBJ;
        }
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                else (0, $TusQn.warn)(`<TransitionGroup> children must be keyed.`);
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
};
const $a5d55dc64ccb07cf$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $a5d55dc64ccb07cf$var$removeMode($a5d55dc64ccb07cf$var$TransitionGroupImpl.props);
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = Symbol("_assign");
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $8POXm.looseToNumber)(domValue);
            el[$a5d55dc64ccb07cf$var$assignKey](domValue);
        });
        if (trim) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $8POXm.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $8POXm.isArray)(value)) el.checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $8POXm.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $TusQn.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value, modifiers: { number: number } }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value, modifiers: { number: number } }) {
        if (!el._assigning) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value, number) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $8POXm.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $8POXm.isSet)(value)) {
        (0, $TusQn.warn)(`<select multiple v-model> expects an Array or Set value for its binding, but got ${Object.prototype.toString.call(value).slice(8, -1)}.`);
        return;
    }
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$var$patchProp
}, $a5d55dc64ccb07cf$var$nodeOps);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    $a5d55dc64ccb07cf$var$injectNativeTagCheck(app);
    $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    $a5d55dc64ccb07cf$var$injectNativeTagCheck(app);
    $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag) || (0, $8POXm.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        if (!res) (0, $TusQn.warn)(`Failed to mount app: mount target selector "${container}" returned null.`);
        return res;
    }
    if ((0, window.ShadowRoot) && container instanceof window.ShadowRoot && container.mode === "closed") (0, $TusQn.warn)(`mounting on a ShadowRoot with \`{mode: "closed"}\` may lead to unpredictable bugs`);
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};

});


parcelRegister("jFUWD", function(module, exports) {

$parcel$export(module.exports, "useI18n", () => $409cbe3732db83c2$export$3f3caade1c12f8c9);
$parcel$export(module.exports, "createI18n", () => $409cbe3732db83c2$export$920091e3d72d80ee);
/*!
  * vue-i18n v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $9QywT = parcelRequire("9QywT");

var $f97E4 = parcelRequire("f97E4");
var $7yiTB = parcelRequire("7yiTB");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $j6G8F = parcelRequire("j6G8F");
/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */ const $409cbe3732db83c2$export$a4ad2735b021c132 = "9.13.1";
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $409cbe3732db83c2$var$initFeatureFlags() {
    if (typeof __VUE_I18N_FULL_INSTALL__ !== "boolean") (0, $9QywT.getGlobalThis)().__VUE_I18N_FULL_INSTALL__ = true;
    if (typeof __VUE_I18N_LEGACY_API__ !== "boolean") (0, $9QywT.getGlobalThis)().__VUE_I18N_LEGACY_API__ = true;
    if (typeof __INTLIFY_JIT_COMPILATION__ !== "boolean") (0, $9QywT.getGlobalThis)().__INTLIFY_JIT_COMPILATION__ = false;
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== "boolean") (0, $9QywT.getGlobalThis)().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $9QywT.getGlobalThis)().__INTLIFY_PROD_DEVTOOLS__ = false;
}
const $409cbe3732db83c2$var$code$1 = (0, $f97E4.CoreWarnCodes).__EXTEND_POINT__;
const $409cbe3732db83c2$var$inc$1 = (0, $9QywT.incrementer)($409cbe3732db83c2$var$code$1);
const $409cbe3732db83c2$var$I18nWarnCodes = {
    FALLBACK_TO_ROOT: $409cbe3732db83c2$var$code$1,
    NOT_SUPPORTED_PRESERVE: $409cbe3732db83c2$var$inc$1(),
    NOT_SUPPORTED_FORMATTER: $409cbe3732db83c2$var$inc$1(),
    NOT_SUPPORTED_PRESERVE_DIRECTIVE: $409cbe3732db83c2$var$inc$1(),
    NOT_SUPPORTED_GET_CHOICE_INDEX: $409cbe3732db83c2$var$inc$1(),
    COMPONENT_NAME_LEGACY_COMPATIBLE: $409cbe3732db83c2$var$inc$1(),
    NOT_FOUND_PARENT_SCOPE: $409cbe3732db83c2$var$inc$1(),
    IGNORE_OBJ_FLATTEN: $409cbe3732db83c2$var$inc$1(),
    NOTICE_DROP_ALLOW_COMPOSITION: $409cbe3732db83c2$var$inc$1(),
    NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: $409cbe3732db83c2$var$inc$1() // 18
};
const $409cbe3732db83c2$var$warnMessages = {
    [$409cbe3732db83c2$var$I18nWarnCodes.FALLBACK_TO_ROOT]: `Fall back to {type} '{key}' with root locale.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE]: `Not supported 'preserve'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_FORMATTER]: `Not supported 'formatter'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: `Not supported 'preserveDirectiveContent'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_GET_CHOICE_INDEX]: `Not supported 'getChoiceIndex'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.COMPONENT_NAME_LEGACY_COMPATIBLE]: `Component name legacy compatible: '{name}' -> 'i18n'`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_FOUND_PARENT_SCOPE]: `Not found parent scope. use the global scope.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.IGNORE_OBJ_FLATTEN]: `Ignore object flatten: '{key}' key has an string value`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOTICE_DROP_ALLOW_COMPOSITION]: `'allowComposition' option will be dropped in the next major version. For more information, please see \u{1F449} https://tinyurl.com/2p97mcze`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG]: `'translateExistCompatible' option will be dropped in the next major version.`
};
function $409cbe3732db83c2$var$getWarnMessage(code, ...args) {
    return (0, $9QywT.format)($409cbe3732db83c2$var$warnMessages[code], ...args);
}
const $409cbe3732db83c2$var$code = (0, $f97E4.CoreErrorCodes).__EXTEND_POINT__;
const $409cbe3732db83c2$var$inc = (0, $9QywT.incrementer)($409cbe3732db83c2$var$code);
const $409cbe3732db83c2$var$I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: $409cbe3732db83c2$var$code,
    // legacy module errors
    INVALID_ARGUMENT: $409cbe3732db83c2$var$inc(),
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: $409cbe3732db83c2$var$inc(),
    NOT_INSTALLED: $409cbe3732db83c2$var$inc(),
    NOT_AVAILABLE_IN_LEGACY_MODE: $409cbe3732db83c2$var$inc(),
    // directive module errors
    REQUIRED_VALUE: $409cbe3732db83c2$var$inc(),
    INVALID_VALUE: $409cbe3732db83c2$var$inc(),
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: $409cbe3732db83c2$var$inc(),
    NOT_INSTALLED_WITH_PROVIDE: $409cbe3732db83c2$var$inc(),
    // unexpected error
    UNEXPECTED_ERROR: $409cbe3732db83c2$var$inc(),
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: $409cbe3732db83c2$var$inc(),
    // bridge support vue 2.x only
    BRIDGE_SUPPORT_VUE_2_ONLY: $409cbe3732db83c2$var$inc(),
    // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
    MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: $409cbe3732db83c2$var$inc(),
    // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
    NOT_AVAILABLE_COMPOSITION_IN_LEGACY: $409cbe3732db83c2$var$inc(),
    // for enhancement
    __EXTEND_POINT__: $409cbe3732db83c2$var$inc() // 38
};
function $409cbe3732db83c2$var$createI18nError(code, ...args) {
    return (0, $7yiTB.createCompileError)(code, null, {
        messages: $409cbe3732db83c2$var$errorMessages,
        args: args
    });
}
const $409cbe3732db83c2$var$errorMessages = {
    [$409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
    [$409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT]: "Invalid argument",
    [$409cbe3732db83c2$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED]: "Need to install with `app.use` function",
    [$409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR]: "Unexpected error",
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
    [$409cbe3732db83c2$var$I18nErrorCodes.REQUIRED_VALUE]: `Required in value: {0}`,
    [$409cbe3732db83c2$var$I18nErrorCodes.INVALID_VALUE]: `Invalid value`,
    [$409cbe3732db83c2$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: `Cannot setup vue-devtools plugin`,
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
    [$409cbe3732db83c2$var$I18nErrorCodes.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
    [$409cbe3732db83c2$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define \u2018i18n\u2019 option or custom block in Composition API with using local scope in Legacy API mode",
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
};
const $409cbe3732db83c2$var$TranslateVNodeSymbol = /* #__PURE__*/ (0, $9QywT.makeSymbol)("__translateVNode");
const $409cbe3732db83c2$var$DatetimePartsSymbol = /* #__PURE__*/ (0, $9QywT.makeSymbol)("__datetimeParts");
const $409cbe3732db83c2$var$NumberPartsSymbol = /* #__PURE__*/ (0, $9QywT.makeSymbol)("__numberParts");
const $409cbe3732db83c2$var$EnableEmitter = /* #__PURE__*/ (0, $9QywT.makeSymbol)("__enableEmitter");
const $409cbe3732db83c2$var$DisableEmitter = /* #__PURE__*/ (0, $9QywT.makeSymbol)("__disableEmitter");
const $409cbe3732db83c2$var$SetPluralRulesSymbol = (0, $9QywT.makeSymbol)("__setPluralRules");
(0, $9QywT.makeSymbol)("__intlifyMeta");
const $409cbe3732db83c2$var$InejctWithOptionSymbol = /* #__PURE__*/ (0, $9QywT.makeSymbol)("__injectWithOption");
const $409cbe3732db83c2$var$DisposeSymbol = /* #__PURE__*/ (0, $9QywT.makeSymbol)("__dispose");
const $409cbe3732db83c2$var$__VUE_I18N_BRIDGE__ = "__VUE_I18N_BRIDGE__";
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Transform flat json in obj to normal json in obj
 */ function $409cbe3732db83c2$var$handleFlatJson(obj) {
    // check obj
    if (!(0, $9QywT.isObject)(obj)) return obj;
    for(const key in obj){
        // check key
        if (!(0, $9QywT.hasOwn)(obj, key)) continue;
        // handle for normal json
        if (!key.includes(".")) // recursive process value if value is also a object
        {
            if ((0, $9QywT.isObject)(obj[key])) $409cbe3732db83c2$var$handleFlatJson(obj[key]);
        } else {
            // go to the last object
            const subKeys = key.split(".");
            const lastIndex = subKeys.length - 1;
            let currentObj = obj;
            let hasStringValue = false;
            for(let i = 0; i < lastIndex; i++){
                if (!(subKeys[i] in currentObj)) currentObj[subKeys[i]] = {};
                if (!(0, $9QywT.isObject)(currentObj[subKeys[i]])) {
                    (0, $9QywT.warn)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.IGNORE_OBJ_FLATTEN, {
                        key: subKeys[i]
                    }));
                    hasStringValue = true;
                    break;
                }
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            if (!hasStringValue) {
                currentObj[subKeys[lastIndex]] = obj[key];
                delete obj[key];
            }
            // recursive process value if value is also a object
            if ((0, $9QywT.isObject)(currentObj[subKeys[lastIndex]])) $409cbe3732db83c2$var$handleFlatJson(currentObj[subKeys[lastIndex]]);
        }
    }
    return obj;
}
function $409cbe3732db83c2$var$getLocaleMessages(locale, options) {
    const { messages: messages, __i18n: __i18n, messageResolver: messageResolver, flatJson: flatJson } = options;
    // prettier-ignore
    const ret = (0, $9QywT.isPlainObject)(messages) ? messages : (0, $9QywT.isArray)(__i18n) ? {} : {
        [locale]: {}
    };
    // merge locale messages of i18n custom block
    if ((0, $9QywT.isArray)(__i18n)) __i18n.forEach((custom)=>{
        if ("locale" in custom && "resource" in custom) {
            const { locale: locale, resource: resource } = custom;
            if (locale) {
                ret[locale] = ret[locale] || {};
                (0, $9QywT.deepCopy)(resource, ret[locale]);
            } else (0, $9QywT.deepCopy)(resource, ret);
        } else (0, $9QywT.isString)(custom) && (0, $9QywT.deepCopy)(JSON.parse(custom), ret);
    });
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for(const key in ret)if ((0, $9QywT.hasOwn)(ret, key)) $409cbe3732db83c2$var$handleFlatJson(ret[key]);
    }
    return ret;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getComponentOptions(instance) {
    return instance.type;
}
function $409cbe3732db83c2$var$adjustI18nResources(gl, options, componentOptions // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    let messages = (0, $9QywT.isObject)(options.messages) ? options.messages : {};
    if ("__i18nGlobal" in componentOptions) messages = $409cbe3732db83c2$var$getLocaleMessages(gl.locale.value, {
        messages: messages,
        __i18n: componentOptions.__i18nGlobal
    });
    // merge locale messages
    const locales = Object.keys(messages);
    if (locales.length) locales.forEach((locale)=>{
        gl.mergeLocaleMessage(locale, messages[locale]);
    });
    // merge datetime formats
    if ((0, $9QywT.isObject)(options.datetimeFormats)) {
        const locales = Object.keys(options.datetimeFormats);
        if (locales.length) locales.forEach((locale)=>{
            gl.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
        });
    }
    // merge number formats
    if ((0, $9QywT.isObject)(options.numberFormats)) {
        const locales = Object.keys(options.numberFormats);
        if (locales.length) locales.forEach((locale)=>{
            gl.mergeNumberFormat(locale, options.numberFormats[locale]);
        });
    }
}
function $409cbe3732db83c2$var$createTextNode(key) {
    return (0, $TusQn.createVNode)((0, $TusQn.Text), null, key, 0);
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ // extend VNode interface
const $409cbe3732db83c2$var$DEVTOOLS_META = "__INTLIFY_META__";
const $409cbe3732db83c2$var$NOOP_RETURN_ARRAY = ()=>[];
const $409cbe3732db83c2$var$NOOP_RETURN_FALSE = ()=>false;
let $409cbe3732db83c2$var$composerID = 0;
function $409cbe3732db83c2$var$defineCoreMissingHandler(missing) {
    return (ctx, locale, key, type)=>{
        return missing(locale, key, (0, $TusQn.getCurrentInstance)() || undefined, type);
    };
}
// for Intlify DevTools
/* #__NO_SIDE_EFFECTS__ */ const $409cbe3732db83c2$var$getMetaInfo = ()=>{
    const instance = (0, $TusQn.getCurrentInstance)();
    let meta = null; // eslint-disable-line @typescript-eslint/no-explicit-any
    return instance && (meta = $409cbe3732db83c2$var$getComponentOptions(instance)[$409cbe3732db83c2$var$DEVTOOLS_META]) ? {
        [$409cbe3732db83c2$var$DEVTOOLS_META]: meta
    } // eslint-disable-line @typescript-eslint/no-explicit-any
     : null;
};
/**
 * Create composer interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$var$createComposer(options = {}, VueI18nLegacy) {
    const { __root: __root, __injectWithOption: __injectWithOption } = options;
    const _isGlobal = __root === undefined;
    const flatJson = options.flatJson;
    const _ref = (0, $9QywT.inBrowser) ? (0, $01W3b.ref) : (0, $01W3b.shallowRef);
    const translateExistCompatible = !!options.translateExistCompatible;
    if (translateExistCompatible && true) (0, $9QywT.warnOnce)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG));
    let _inheritLocale = (0, $9QywT.isBoolean)(options.inheritLocale) ? options.inheritLocale : true;
    const _locale = _ref(// prettier-ignore
    __root && _inheritLocale ? __root.locale.value : (0, $9QywT.isString)(options.locale) ? options.locale : (0, $f97E4.DEFAULT_LOCALE));
    const _fallbackLocale = _ref(// prettier-ignore
    __root && _inheritLocale ? __root.fallbackLocale.value : (0, $9QywT.isString)(options.fallbackLocale) || (0, $9QywT.isArray)(options.fallbackLocale) || (0, $9QywT.isPlainObject)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    const _messages = _ref($409cbe3732db83c2$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = _ref((0, $9QywT.isPlainObject)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _numberFormats = _ref((0, $9QywT.isPlainObject)(options.numberFormats) ? options.numberFormats : {
        [_locale.value]: {}
    });
    // warning suppress options
    // prettier-ignore
    let _missingWarn = __root ? __root.missingWarn : (0, $9QywT.isBoolean)(options.missingWarn) || (0, $9QywT.isRegExp)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    let _fallbackWarn = __root ? __root.fallbackWarn : (0, $9QywT.isBoolean)(options.fallbackWarn) || (0, $9QywT.isRegExp)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    let _fallbackRoot = __root ? __root.fallbackRoot : (0, $9QywT.isBoolean)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    let _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    let _missing = (0, $9QywT.isFunction)(options.missing) ? options.missing : null;
    let _runtimeMissing = (0, $9QywT.isFunction)(options.missing) ? $409cbe3732db83c2$var$defineCoreMissingHandler(options.missing) : null;
    // postTranslation handler
    let _postTranslation = (0, $9QywT.isFunction)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    let _warnHtmlMessage = __root ? __root.warnHtmlMessage : (0, $9QywT.isBoolean)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    let _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    const _modifiers = __root ? __root.modifiers : (0, $9QywT.isPlainObject)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    let _pluralRules = options.pluralRules || __root && __root.pluralRules;
    // runtime context
    // eslint-disable-next-line prefer-const
    let _context;
    const getCoreContext = ()=>{
        _isGlobal && (0, $f97E4.setFallbackContext)(null);
        const ctxOptions = {
            version: $409cbe3732db83c2$export$a4ad2735b021c132,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            messageCompiler: options.messageCompiler,
            __meta: {
                framework: "vue"
            }
        };
        ctxOptions.datetimeFormats = _datetimeFormats.value;
        ctxOptions.numberFormats = _numberFormats.value;
        ctxOptions.__datetimeFormatters = (0, $9QywT.isPlainObject)(_context) ? _context.__datetimeFormatters : undefined;
        ctxOptions.__numberFormatters = (0, $9QywT.isPlainObject)(_context) ? _context.__numberFormatters : undefined;
        ctxOptions.__v_emitter = (0, $9QywT.isPlainObject)(_context) ? _context.__v_emitter : undefined;
        const ctx = (0, $f97E4.createCoreContext)(ctxOptions);
        _isGlobal && (0, $f97E4.setFallbackContext)(ctx);
        return ctx;
    };
    _context = getCoreContext();
    (0, $f97E4.updateFallbackLocale)(_context, _locale.value, _fallbackLocale.value);
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = (0, $01W3b.computed)({
        get: ()=>_locale.value,
        set: (val1)=>{
            _locale.value = val1;
            _context.locale = _locale.value;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0, $01W3b.computed)({
        get: ()=>_fallbackLocale.value,
        set: (val1)=>{
            _fallbackLocale.value = val1;
            _context.fallbackLocale = _fallbackLocale.value;
            (0, $f97E4.updateFallbackLocale)(_context, _locale.value, val1);
        }
    });
    // messages
    const messages = (0, $01W3b.computed)(()=>_messages.value);
    // datetimeFormats
    const datetimeFormats = /* #__PURE__*/ (0, $01W3b.computed)(()=>_datetimeFormats.value);
    // numberFormats
    const numberFormats = /* #__PURE__*/ (0, $01W3b.computed)(()=>_numberFormats.value);
    // getPostTranslationHandler
    function getPostTranslationHandler() {
        return (0, $9QywT.isFunction)(_postTranslation) ? _postTranslation : null;
    }
    // setPostTranslationHandler
    function setPostTranslationHandler(handler1) {
        _postTranslation = handler1;
        _context.postTranslation = handler1;
    }
    // getMissingHandler
    function getMissingHandler() {
        return _missing;
    }
    // setMissingHandler
    function setMissingHandler(handler1) {
        if (handler1 !== null) _runtimeMissing = $409cbe3732db83c2$var$defineCoreMissingHandler(handler1);
        _missing = handler1;
        _context.missing = _runtimeMissing;
    }
    function isResolvedTranslateMessage(type, arg // eslint-disable-line @typescript-eslint/no-explicit-any
    ) {
        return type !== "translate" || !arg.resolvedMessage;
    }
    const wrapWithDeps = (fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition)=>{
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        let ret;
        try {
            (0, $f97E4.setAdditionalMeta)($409cbe3732db83c2$var$getMetaInfo());
            if (!_isGlobal) _context.fallbackContext = __root ? (0, $f97E4.getFallbackContext)() : undefined;
            ret = fn(_context);
        } finally{
            (0, $f97E4.setAdditionalMeta)(null);
            if (!_isGlobal) _context.fallbackContext = undefined;
        }
        if (warnType !== "translate exists" && // for not `te` (e.g `t`)
        (0, $9QywT.isNumber)(ret) && ret === (0, $f97E4.NOT_REOSLVED) || warnType === "translate exists" && !ret // for `te`
        ) {
            const [key, arg2] = argumentParser();
            if (__root && (0, $9QywT.isString)(key) && isResolvedTranslateMessage(warnType, arg2)) {
                if (_fallbackRoot && ((0, $f97E4.isTranslateFallbackWarn)(_fallbackWarn, key) || (0, $f97E4.isTranslateMissingWarn)(_missingWarn, key))) (0, $9QywT.warn)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.FALLBACK_TO_ROOT, {
                    key: key,
                    type: warnType
                }));
                {
                    const { __v_emitter: emitter } = _context;
                    if (emitter && _fallbackRoot) emitter.emit("fallback" /* VueDevToolsTimelineEvents.FALBACK */ , {
                        type: warnType,
                        key: key,
                        to: "global",
                        groupId: `${warnType}:${key}`
                    });
                }
            }
            return __root && _fallbackRoot ? fallbackSuccess(__root) : fallbackFail(key);
        } else if (successCondition(ret)) return ret;
        else /* istanbul ignore next */ throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    };
    // t
    function t(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f97E4.translate), null, [
                context,
                ...args
            ]), ()=>(0, $f97E4.parseTranslateArgs)(...args), "translate", (root)=>Reflect.apply(root.t, root, [
                ...args
            ]), (key)=>key, (val1)=>(0, $9QywT.isString)(val1));
    }
    // rt
    function rt(...args) {
        const [arg1, arg2, arg3] = args;
        if (arg3 && !(0, $9QywT.isObject)(arg3)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT);
        return t(...[
            arg1,
            arg2,
            (0, $9QywT.assign)({
                resolvedMessage: true
            }, arg3 || {})
        ]);
    }
    // d
    function d(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f97E4.datetime), null, [
                context,
                ...args
            ]), ()=>(0, $f97E4.parseDateTimeArgs)(...args), "datetime format", (root)=>Reflect.apply(root.d, root, [
                ...args
            ]), ()=>(0, $f97E4.MISSING_RESOLVE_VALUE), (val1)=>(0, $9QywT.isString)(val1));
    }
    // n
    function n(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f97E4.number), null, [
                context,
                ...args
            ]), ()=>(0, $f97E4.parseNumberArgs)(...args), "number format", (root)=>Reflect.apply(root.n, root, [
                ...args
            ]), ()=>(0, $f97E4.MISSING_RESOLVE_VALUE), (val1)=>(0, $9QywT.isString)(val1));
    }
    // for custom processor
    function normalize(values) {
        return values.map((val1)=>(0, $9QywT.isString)(val1) || (0, $9QywT.isNumber)(val1) || (0, $9QywT.isBoolean)(val1) ? $409cbe3732db83c2$var$createTextNode(String(val1)) : val1);
    }
    const interpolate = (val1)=>val1;
    const processor = {
        normalize: normalize,
        interpolate: interpolate,
        type: "vnode"
    };
    // translateVNode, using for `i18n-t` component
    function translateVNode(...args) {
        return wrapWithDeps((context)=>{
            let ret;
            const _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply((0, $f97E4.translate), null, [
                    _context,
                    ...args
                ]);
            } finally{
                _context.processor = null;
            }
            return ret;
        }, ()=>(0, $f97E4.parseTranslateArgs)(...args), "translate", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$409cbe3732db83c2$var$TranslateVNodeSymbol](...args), (key)=>[
                $409cbe3732db83c2$var$createTextNode(key)
            ], (val1)=>(0, $9QywT.isArray)(val1));
    }
    // numberParts, using for `i18n-n` component
    function numberParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f97E4.number), null, [
                context,
                ...args
            ]), ()=>(0, $f97E4.parseNumberArgs)(...args), "number format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$409cbe3732db83c2$var$NumberPartsSymbol](...args), $409cbe3732db83c2$var$NOOP_RETURN_ARRAY, (val1)=>(0, $9QywT.isString)(val1) || (0, $9QywT.isArray)(val1));
    }
    // datetimeParts, using for `i18n-d` component
    function datetimeParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f97E4.datetime), null, [
                context,
                ...args
            ]), ()=>(0, $f97E4.parseDateTimeArgs)(...args), "datetime format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$409cbe3732db83c2$var$DatetimePartsSymbol](...args), $409cbe3732db83c2$var$NOOP_RETURN_ARRAY, (val1)=>(0, $9QywT.isString)(val1) || (0, $9QywT.isArray)(val1));
    }
    function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    }
    // te
    function te(key, locale) {
        return wrapWithDeps(()=>{
            if (!key) return false;
            const targetLocale = (0, $9QywT.isString)(locale) ? locale : _locale.value;
            const message = getLocaleMessage(targetLocale);
            const resolved = _context.messageResolver(message, key);
            return !translateExistCompatible ? (0, $f97E4.isMessageAST)(resolved) || (0, $f97E4.isMessageFunction)(resolved) || (0, $9QywT.isString)(resolved) : resolved != null;
        }, ()=>[
                key
            ], "translate exists", (root)=>{
            return Reflect.apply(root.te, root, [
                key,
                locale
            ]);
        }, $409cbe3732db83c2$var$NOOP_RETURN_FALSE, (val1)=>(0, $9QywT.isBoolean)(val1));
    }
    function resolveMessages(key) {
        let messages = null;
        const locales = (0, $f97E4.fallbackWithLocaleChain)(_context, _fallbackLocale.value, _locale.value);
        for(let i = 0; i < locales.length; i++){
            const targetLocaleMessages = _messages.value[locales[i]] || {};
            const messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    }
    // tm
    function tm(key) {
        const messages = resolveMessages(key);
        // prettier-ignore
        return messages != null ? messages : __root ? __root.tm(key) || {} : {};
    }
    // getLocaleMessage
    function getLocaleMessage(locale) {
        return _messages.value[locale] || {};
    }
    // setLocaleMessage
    function setLocaleMessage(locale, message) {
        if (flatJson) {
            const _message = {
                [locale]: message
            };
            for(const key in _message)if ((0, $9QywT.hasOwn)(_message, key)) $409cbe3732db83c2$var$handleFlatJson(_message[key]);
            message = _message[locale];
        }
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    }
    // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        _messages.value[locale] = _messages.value[locale] || {};
        const _message = {
            [locale]: message
        };
        if (flatJson) {
            for(const key in _message)if ((0, $9QywT.hasOwn)(_message, key)) $409cbe3732db83c2$var$handleFlatJson(_message[key]);
        }
        message = _message[locale];
        (0, $9QywT.deepCopy)(message, _messages.value[locale]);
        _context.messages = _messages.value;
    }
    // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    }
    // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $f97E4.clearDateTimeFormat)(_context, locale, format);
    }
    // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = (0, $9QywT.assign)(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $f97E4.clearDateTimeFormat)(_context, locale, format);
    }
    // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    }
    // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        (0, $f97E4.clearNumberFormat)(_context, locale, format);
    }
    // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = (0, $9QywT.assign)(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        (0, $f97E4.clearNumberFormat)(_context, locale, format);
    }
    // for debug
    $409cbe3732db83c2$var$composerID++;
    // watch root locale & fallbackLocale
    if (__root && (0, $9QywT.inBrowser)) {
        (0, $TusQn.watch)(__root.locale, (val1)=>{
            if (_inheritLocale) {
                _locale.value = val1;
                _context.locale = val1;
                (0, $f97E4.updateFallbackLocale)(_context, _locale.value, _fallbackLocale.value);
            }
        });
        (0, $TusQn.watch)(__root.fallbackLocale, (val1)=>{
            if (_inheritLocale) {
                _fallbackLocale.value = val1;
                _context.fallbackLocale = val1;
                (0, $f97E4.updateFallbackLocale)(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    const composer = {
        id: $409cbe3732db83c2$var$composerID,
        locale: locale,
        fallbackLocale: fallbackLocale,
        get inheritLocale () {
            return _inheritLocale;
        },
        set inheritLocale (val){
            _inheritLocale = val;
            if (val && __root) {
                _locale.value = __root.locale.value;
                _fallbackLocale.value = __root.fallbackLocale.value;
                (0, $f97E4.updateFallbackLocale)(_context, _locale.value, _fallbackLocale.value);
            }
        },
        get availableLocales () {
            return Object.keys(_messages.value).sort();
        },
        messages: messages,
        get modifiers () {
            return _modifiers;
        },
        get pluralRules () {
            return _pluralRules || {};
        },
        get isGlobal () {
            return _isGlobal;
        },
        get missingWarn () {
            return _missingWarn;
        },
        set missingWarn (val){
            _missingWarn = val;
            _context.missingWarn = _missingWarn;
        },
        get fallbackWarn () {
            return _fallbackWarn;
        },
        set fallbackWarn (val){
            _fallbackWarn = val;
            _context.fallbackWarn = _fallbackWarn;
        },
        get fallbackRoot () {
            return _fallbackRoot;
        },
        set fallbackRoot (val){
            _fallbackRoot = val;
        },
        get fallbackFormat () {
            return _fallbackFormat;
        },
        set fallbackFormat (val){
            _fallbackFormat = val;
            _context.fallbackFormat = _fallbackFormat;
        },
        get warnHtmlMessage () {
            return _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            _warnHtmlMessage = val;
            _context.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _escapeParameter;
        },
        set escapeParameter (val){
            _escapeParameter = val;
            _context.escapeParameter = val;
        },
        t: t,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        [$409cbe3732db83c2$var$SetPluralRulesSymbol]: setPluralRules
    };
    composer.datetimeFormats = datetimeFormats;
    composer.numberFormats = numberFormats;
    composer.rt = rt;
    composer.te = te;
    composer.tm = tm;
    composer.d = d;
    composer.n = n;
    composer.getDateTimeFormat = getDateTimeFormat;
    composer.setDateTimeFormat = setDateTimeFormat;
    composer.mergeDateTimeFormat = mergeDateTimeFormat;
    composer.getNumberFormat = getNumberFormat;
    composer.setNumberFormat = setNumberFormat;
    composer.mergeNumberFormat = mergeNumberFormat;
    composer[$409cbe3732db83c2$var$InejctWithOptionSymbol] = __injectWithOption;
    composer[$409cbe3732db83c2$var$TranslateVNodeSymbol] = translateVNode;
    composer[$409cbe3732db83c2$var$DatetimePartsSymbol] = datetimeParts;
    composer[$409cbe3732db83c2$var$NumberPartsSymbol] = numberParts;
    composer[$409cbe3732db83c2$var$EnableEmitter] = (emitter)=>{
        _context.__v_emitter = emitter;
    };
    composer[$409cbe3732db83c2$var$DisableEmitter] = ()=>{
        _context.__v_emitter = undefined;
    };
    return composer;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */ function $409cbe3732db83c2$var$convertComposerOptions(options) {
    const locale = (0, $9QywT.isString)(options.locale) ? options.locale : (0, $f97E4.DEFAULT_LOCALE);
    const fallbackLocale = (0, $9QywT.isString)(options.fallbackLocale) || (0, $9QywT.isArray)(options.fallbackLocale) || (0, $9QywT.isPlainObject)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
    const missing = (0, $9QywT.isFunction)(options.missing) ? options.missing : undefined;
    const missingWarn = (0, $9QywT.isBoolean)(options.silentTranslationWarn) || (0, $9QywT.isRegExp)(options.silentTranslationWarn) ? !options.silentTranslationWarn : true;
    const fallbackWarn = (0, $9QywT.isBoolean)(options.silentFallbackWarn) || (0, $9QywT.isRegExp)(options.silentFallbackWarn) ? !options.silentFallbackWarn : true;
    const fallbackRoot = (0, $9QywT.isBoolean)(options.fallbackRoot) ? options.fallbackRoot : true;
    const fallbackFormat = !!options.formatFallbackMessages;
    const modifiers = (0, $9QywT.isPlainObject)(options.modifiers) ? options.modifiers : {};
    const pluralizationRules = options.pluralizationRules;
    const postTranslation = (0, $9QywT.isFunction)(options.postTranslation) ? options.postTranslation : undefined;
    const warnHtmlMessage = (0, $9QywT.isString)(options.warnHtmlInMessage) ? options.warnHtmlInMessage !== "off" : true;
    const escapeParameter = !!options.escapeParameterHtml;
    const inheritLocale = (0, $9QywT.isBoolean)(options.sync) ? options.sync : true;
    if (0, options.formatter) (0, $9QywT.warn)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_FORMATTER));
    if (0, options.preserveDirectiveContent) (0, $9QywT.warn)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
    let messages = options.messages;
    if ((0, $9QywT.isPlainObject)(options.sharedMessages)) {
        const sharedMessages = options.sharedMessages;
        const locales = Object.keys(sharedMessages);
        messages = locales.reduce((messages, locale)=>{
            const message = messages[locale] || (messages[locale] = {});
            (0, $9QywT.assign)(message, sharedMessages[locale]);
            return messages;
        }, messages || {});
    }
    const { __i18n: __i18n, __root: __root, __injectWithOption: __injectWithOption } = options;
    const datetimeFormats = options.datetimeFormats;
    const numberFormats = options.numberFormats;
    const flatJson = options.flatJson;
    const translateExistCompatible = options.translateExistCompatible;
    return {
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        flatJson: flatJson,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackRoot: fallbackRoot,
        fallbackFormat: fallbackFormat,
        modifiers: modifiers,
        pluralRules: pluralizationRules,
        postTranslation: postTranslation,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageResolver: options.messageResolver,
        inheritLocale: inheritLocale,
        translateExistCompatible: translateExistCompatible,
        __i18n: __i18n,
        __root: __root,
        __injectWithOption: __injectWithOption
    };
}
/**
 * create VueI18n interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$var$createVueI18n(options = {}, VueI18nLegacy) {
    {
        const composer = $409cbe3732db83c2$var$createComposer($409cbe3732db83c2$var$convertComposerOptions(options));
        const { __extender: __extender } = options;
        // defines VueI18n
        const vueI18n = {
            // id
            id: composer.id,
            // locale
            get locale () {
                return composer.locale.value;
            },
            set locale (val){
                composer.locale.value = val;
            },
            // fallbackLocale
            get fallbackLocale () {
                return composer.fallbackLocale.value;
            },
            set fallbackLocale (val){
                composer.fallbackLocale.value = val;
            },
            // messages
            get messages () {
                return composer.messages.value;
            },
            // datetimeFormats
            get datetimeFormats () {
                return composer.datetimeFormats.value;
            },
            // numberFormats
            get numberFormats () {
                return composer.numberFormats.value;
            },
            // availableLocales
            get availableLocales () {
                return composer.availableLocales;
            },
            // formatter
            get formatter () {
                (0, $9QywT.warn)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_FORMATTER));
                // dummy
                return {
                    interpolate () {
                        return [];
                    }
                };
            },
            set formatter (val){
                (0, $9QywT.warn)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_FORMATTER));
            },
            // missing
            get missing () {
                return composer.getMissingHandler();
            },
            set missing (handler){
                composer.setMissingHandler(handler);
            },
            // silentTranslationWarn
            get silentTranslationWarn () {
                return (0, $9QywT.isBoolean)(composer.missingWarn) ? !composer.missingWarn : composer.missingWarn;
            },
            set silentTranslationWarn (val){
                composer.missingWarn = (0, $9QywT.isBoolean)(val) ? !val : val;
            },
            // silentFallbackWarn
            get silentFallbackWarn () {
                return (0, $9QywT.isBoolean)(composer.fallbackWarn) ? !composer.fallbackWarn : composer.fallbackWarn;
            },
            set silentFallbackWarn (val){
                composer.fallbackWarn = (0, $9QywT.isBoolean)(val) ? !val : val;
            },
            // modifiers
            get modifiers () {
                return composer.modifiers;
            },
            // formatFallbackMessages
            get formatFallbackMessages () {
                return composer.fallbackFormat;
            },
            set formatFallbackMessages (val){
                composer.fallbackFormat = val;
            },
            // postTranslation
            get postTranslation () {
                return composer.getPostTranslationHandler();
            },
            set postTranslation (handler){
                composer.setPostTranslationHandler(handler);
            },
            // sync
            get sync () {
                return composer.inheritLocale;
            },
            set sync (val){
                composer.inheritLocale = val;
            },
            // warnInHtmlMessage
            get warnHtmlInMessage () {
                return composer.warnHtmlMessage ? "warn" : "off";
            },
            set warnHtmlInMessage (val){
                composer.warnHtmlMessage = val !== "off";
            },
            // escapeParameterHtml
            get escapeParameterHtml () {
                return composer.escapeParameter;
            },
            set escapeParameterHtml (val){
                composer.escapeParameter = val;
            },
            // preserveDirectiveContent
            get preserveDirectiveContent () {
                (0, $9QywT.warn)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
                return true;
            },
            set preserveDirectiveContent (val){
                (0, $9QywT.warn)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
            },
            // pluralizationRules
            get pluralizationRules () {
                return composer.pluralRules || {};
            },
            // for internal
            __composer: composer,
            // t
            t (...args) {
                const [arg1, arg2, arg3] = args;
                const options = {};
                let list = null;
                let named = null;
                if (!(0, $9QywT.isString)(arg1)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT);
                const key = arg1;
                if ((0, $9QywT.isString)(arg2)) options.locale = arg2;
                else if ((0, $9QywT.isArray)(arg2)) list = arg2;
                else if ((0, $9QywT.isPlainObject)(arg2)) named = arg2;
                if ((0, $9QywT.isArray)(arg3)) list = arg3;
                else if ((0, $9QywT.isPlainObject)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            rt (...args) {
                return Reflect.apply(composer.rt, composer, [
                    ...args
                ]);
            },
            // tc
            tc (...args) {
                const [arg1, arg2, arg3] = args;
                const options = {
                    plural: 1
                };
                let list = null;
                let named = null;
                if (!(0, $9QywT.isString)(arg1)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT);
                const key = arg1;
                if ((0, $9QywT.isString)(arg2)) options.locale = arg2;
                else if ((0, $9QywT.isNumber)(arg2)) options.plural = arg2;
                else if ((0, $9QywT.isArray)(arg2)) list = arg2;
                else if ((0, $9QywT.isPlainObject)(arg2)) named = arg2;
                if ((0, $9QywT.isString)(arg3)) options.locale = arg3;
                else if ((0, $9QywT.isArray)(arg3)) list = arg3;
                else if ((0, $9QywT.isPlainObject)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            // te
            te (key, locale) {
                return composer.te(key, locale);
            },
            // tm
            tm (key) {
                return composer.tm(key);
            },
            // getLocaleMessage
            getLocaleMessage (locale) {
                return composer.getLocaleMessage(locale);
            },
            // setLocaleMessage
            setLocaleMessage (locale, message) {
                composer.setLocaleMessage(locale, message);
            },
            // mergeLocaleMessage
            mergeLocaleMessage (locale, message) {
                composer.mergeLocaleMessage(locale, message);
            },
            // d
            d (...args) {
                return Reflect.apply(composer.d, composer, [
                    ...args
                ]);
            },
            // getDateTimeFormat
            getDateTimeFormat (locale) {
                return composer.getDateTimeFormat(locale);
            },
            // setDateTimeFormat
            setDateTimeFormat (locale, format) {
                composer.setDateTimeFormat(locale, format);
            },
            // mergeDateTimeFormat
            mergeDateTimeFormat (locale, format) {
                composer.mergeDateTimeFormat(locale, format);
            },
            // n
            n (...args) {
                return Reflect.apply(composer.n, composer, [
                    ...args
                ]);
            },
            // getNumberFormat
            getNumberFormat (locale) {
                return composer.getNumberFormat(locale);
            },
            // setNumberFormat
            setNumberFormat (locale, format) {
                composer.setNumberFormat(locale, format);
            },
            // mergeNumberFormat
            mergeNumberFormat (locale, format) {
                composer.mergeNumberFormat(locale, format);
            },
            // getChoiceIndex
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            getChoiceIndex (choice, choicesLength) {
                (0, $9QywT.warn)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_GET_CHOICE_INDEX));
                return -1;
            }
        };
        vueI18n.__extender = __extender;
        vueI18n.__enableEmitter = (emitter)=>{
            const __composer = composer;
            __composer[$409cbe3732db83c2$var$EnableEmitter] && __composer[$409cbe3732db83c2$var$EnableEmitter](emitter);
        };
        vueI18n.__disableEmitter = ()=>{
            const __composer = composer;
            __composer[$409cbe3732db83c2$var$DisableEmitter] && __composer[$409cbe3732db83c2$var$DisableEmitter]();
        };
        return vueI18n;
    }
}
/* eslint-enable @typescript-eslint/no-explicit-any */ const $409cbe3732db83c2$var$baseFormatProps = {
    tag: {
        type: [
            String,
            Object
        ]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: (val1 /* ComponentI18nScope */ )=>val1 === "parent" || val1 === "global",
        default: "parent" /* ComponentI18nScope */ 
    },
    i18n: {
        type: Object
    }
};
function $409cbe3732db83c2$var$getInterpolateArg(// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ slots: slots }, keys) {
    if (keys.length === 1 && keys[0] === "default") {
        // default slot with list
        const ret = slots.default ? slots.default() : [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return ret.reduce((slot, current)=>{
            return [
                ...slot,
                // prettier-ignore
                ...current.type === (0, $TusQn.Fragment) ? current.children : [
                    current
                ]
            ];
        }, []);
    } else // named slots
    return keys.reduce((arg, key)=>{
        const slot = slots[key];
        if (slot) arg[key] = slot();
        return arg;
    }, {});
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getFragmentableTag(tag) {
    return 0, $TusQn.Fragment;
}
const $409cbe3732db83c2$var$TranslationImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    /* eslint-disable */ name: "i18n-t",
    props: (0, $9QywT.assign)({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [
                Number,
                String
            ],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validator: (val1)=>(0, $9QywT.isNumber)(val1) || !isNaN(val1)
        }
    }, $409cbe3732db83c2$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const { slots: slots, attrs: attrs } = context;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        const i18n = props.i18n || $409cbe3732db83c2$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return ()=>{
            const keys = Object.keys(slots).filter((key)=>key !== "_");
            const options = {};
            if (props.locale) options.locale = props.locale;
            if (props.plural !== undefined) options.plural = (0, $9QywT.isString)(props.plural) ? +props.plural : props.plural;
            const arg = $409cbe3732db83c2$var$getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const children = i18n[$409cbe3732db83c2$var$TranslateVNodeSymbol](props.keypath, arg, options);
            const assignedAttrs = (0, $9QywT.assign)({}, attrs);
            const tag = (0, $9QywT.isString)(props.tag) || (0, $9QywT.isObject)(props.tag) ? props.tag : $409cbe3732db83c2$var$getFragmentableTag();
            return (0, $TusQn.h)(tag, assignedAttrs, children);
        };
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */ /**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n keypath="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */ const $409cbe3732db83c2$export$b63289fbda65eed1 = $409cbe3732db83c2$var$TranslationImpl;
const $409cbe3732db83c2$export$1d08de71ac06ffd6 = $409cbe3732db83c2$export$b63289fbda65eed1;
function $409cbe3732db83c2$var$isVNode(target) {
    return (0, $9QywT.isArray)(target) && !(0, $9QywT.isString)(target[0]);
}
function $409cbe3732db83c2$var$renderFormatter(props, context, slotKeys, partFormatter) {
    const { slots: slots, attrs: attrs } = context;
    return ()=>{
        const options = {
            part: true
        };
        let overrides = {};
        if (props.locale) options.locale = props.locale;
        if ((0, $9QywT.isString)(props.format)) options.key = props.format;
        else if ((0, $9QywT.isObject)(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if ((0, $9QywT.isString)(props.format.key)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            options.key = props.format.key;
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce((options, prop)=>{
                return slotKeys.includes(prop) ? (0, $9QywT.assign)({}, options, {
                    [prop]: props.format[prop]
                }) // eslint-disable-line @typescript-eslint/no-explicit-any
                 : options;
            }, {});
        }
        const parts = partFormatter(...[
            props.value,
            options,
            overrides
        ]);
        let children = [
            options.key
        ];
        if ((0, $9QywT.isArray)(parts)) children = parts.map((part, index)=>{
            const slot = slots[part.type];
            const node = slot ? slot({
                [part.type]: part.value,
                index: index,
                parts: parts
            }) : [
                part.value
            ];
            if ($409cbe3732db83c2$var$isVNode(node)) node[0].key = `${part.type}-${index}`;
            return node;
        });
        else if ((0, $9QywT.isString)(parts)) children = [
            parts
        ];
        const assignedAttrs = (0, $9QywT.assign)({}, attrs);
        const tag = (0, $9QywT.isString)(props.tag) || (0, $9QywT.isObject)(props.tag) ? props.tag : $409cbe3732db83c2$var$getFragmentableTag();
        return (0, $TusQn.h)(tag, assignedAttrs, children);
    };
}
const $409cbe3732db83c2$var$NumberFormatImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    /* eslint-disable */ name: "i18n-n",
    props: (0, $9QywT.assign)({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $409cbe3732db83c2$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $409cbe3732db83c2$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return $409cbe3732db83c2$var$renderFormatter(props, context, (0, $f97E4.NUMBER_FORMAT_OPTIONS_KEYS), (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$409cbe3732db83c2$var$NumberPartsSymbol](...args));
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */ /**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */ const $409cbe3732db83c2$export$27bce688931fdfcc = $409cbe3732db83c2$var$NumberFormatImpl;
const $409cbe3732db83c2$export$4665d24327644133 = $409cbe3732db83c2$export$27bce688931fdfcc;
const $409cbe3732db83c2$var$DatetimeFormatImpl = /* #__PURE__*/ (0, $TusQn.defineComponent)({
    /* eslint-disable */ name: "i18n-d",
    props: (0, $9QywT.assign)({
        value: {
            type: [
                Number,
                Date
            ],
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $409cbe3732db83c2$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $409cbe3732db83c2$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return $409cbe3732db83c2$var$renderFormatter(props, context, (0, $f97E4.DATETIME_FORMAT_OPTIONS_KEYS), (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$409cbe3732db83c2$var$DatetimePartsSymbol](...args));
    }
});
/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */ const $409cbe3732db83c2$export$64ca50867510e64e = $409cbe3732db83c2$var$DatetimeFormatImpl;
const $409cbe3732db83c2$export$c741260b89dcb234 = $409cbe3732db83c2$export$64ca50867510e64e;
function $409cbe3732db83c2$var$getComposer$2(i18n, instance) {
    const i18nInternal = i18n;
    if (i18n.mode === "composition") return i18nInternal.__getInstance(instance) || i18n.global;
    else {
        const vueI18n = i18nInternal.__getInstance(instance);
        return vueI18n != null ? vueI18n.__composer : i18n.global.__composer;
    }
}
function $409cbe3732db83c2$export$8a5a05546006d0b5(i18n) {
    const _process = (binding)=>{
        const { instance: instance, modifiers: modifiers, value: value } = binding;
        /* istanbul ignore if */ if (!instance || !instance.$) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const composer = $409cbe3732db83c2$var$getComposer$2(i18n, instance.$);
        if (0, modifiers.preserve) (0, $9QywT.warn)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE));
        const parsedValue = $409cbe3732db83c2$var$parseValue(value);
        return [
            Reflect.apply(composer.t, composer, [
                ...$409cbe3732db83c2$var$makeParams(parsedValue)
            ]),
            composer
        ];
    };
    const register = (el, binding)=>{
        const [textContent, composer] = _process(binding);
        if ((0, $9QywT.inBrowser) && i18n.global === composer) // global scope only
        el.__i18nWatcher = (0, $TusQn.watch)(composer.locale, ()=>{
            binding.instance && binding.instance.$forceUpdate();
        });
        el.__composer = composer;
        el.textContent = textContent;
    };
    const unregister = (el)=>{
        if ((0, $9QywT.inBrowser) && el.__i18nWatcher) {
            el.__i18nWatcher();
            el.__i18nWatcher = undefined;
            delete el.__i18nWatcher;
        }
        if (el.__composer) {
            el.__composer = undefined;
            delete el.__composer;
        }
    };
    const update = (el, { value: value })=>{
        if (el.__composer) {
            const composer = el.__composer;
            const parsedValue = $409cbe3732db83c2$var$parseValue(value);
            el.textContent = Reflect.apply(composer.t, composer, [
                ...$409cbe3732db83c2$var$makeParams(parsedValue)
            ]);
        }
    };
    const getSSRProps = (binding)=>{
        const [textContent] = _process(binding);
        return {
            textContent: textContent
        };
    };
    return {
        created: register,
        unmounted: unregister,
        beforeUpdate: update,
        getSSRProps: getSSRProps
    };
}
function $409cbe3732db83c2$var$parseValue(value) {
    if ((0, $9QywT.isString)(value)) return {
        path: value
    };
    else if ((0, $9QywT.isPlainObject)(value)) {
        if (!("path" in value)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.REQUIRED_VALUE, "path");
        return value;
    } else throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_VALUE);
}
function $409cbe3732db83c2$var$makeParams(value) {
    const { path: path, locale: locale, args: args, choice: choice, plural: plural } = value;
    const options = {};
    const named = args || {};
    if ((0, $9QywT.isString)(locale)) options.locale = locale;
    if ((0, $9QywT.isNumber)(choice)) options.plural = choice;
    if ((0, $9QywT.isNumber)(plural)) options.plural = plural;
    return [
        path,
        named,
        options
    ];
}
function $409cbe3732db83c2$var$apply(app, i18n, ...options) {
    const pluginOptions = (0, $9QywT.isPlainObject)(options[0]) ? options[0] : {};
    const useI18nComponentName = !!pluginOptions.useI18nComponentName;
    const globalInstall = (0, $9QywT.isBoolean)(pluginOptions.globalInstall) ? pluginOptions.globalInstall : true;
    if (globalInstall && useI18nComponentName) (0, $9QywT.warn)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.COMPONENT_NAME_LEGACY_COMPATIBLE, {
        name: $409cbe3732db83c2$export$b63289fbda65eed1.name
    }));
    if (globalInstall) {
        [
            !useI18nComponentName ? $409cbe3732db83c2$export$b63289fbda65eed1.name : "i18n",
            "I18nT"
        ].forEach((name)=>app.component(name, $409cbe3732db83c2$export$b63289fbda65eed1));
        [
            $409cbe3732db83c2$export$27bce688931fdfcc.name,
            "I18nN"
        ].forEach((name)=>app.component(name, $409cbe3732db83c2$export$27bce688931fdfcc));
        [
            $409cbe3732db83c2$export$64ca50867510e64e.name,
            "I18nD"
        ].forEach((name)=>app.component(name, $409cbe3732db83c2$export$64ca50867510e64e));
    }
    app.directive("t", $409cbe3732db83c2$export$8a5a05546006d0b5(i18n));
}
const $409cbe3732db83c2$var$VueDevToolsLabels = {
    ["vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ]: "Vue I18n devtools",
    ["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]: "I18n Resources",
    ["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]: "Vue I18n"
};
const $409cbe3732db83c2$var$VueDevToolsPlaceholders = {
    ["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]: "Search for scopes ..."
};
const $409cbe3732db83c2$var$VueDevToolsTimelineColors = {
    ["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]: 0xffcd19
};
const $409cbe3732db83c2$var$VUE_I18N_COMPONENT_TYPES = "vue-i18n: composer properties";
let $409cbe3732db83c2$var$devtoolsApi;
async function $409cbe3732db83c2$var$enableDevTools(app, i18n) {
    return new Promise((resolve, reject)=>{
        try {
            (0, $j6G8F.setupDevtoolsPlugin)({
                id: "vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ,
                label: $409cbe3732db83c2$var$VueDevToolsLabels["vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ],
                packageName: "vue-i18n",
                homepage: "https://vue-i18n.intlify.dev",
                logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
                componentStateTypes: [
                    $409cbe3732db83c2$var$VUE_I18N_COMPONENT_TYPES
                ],
                app: app // eslint-disable-line @typescript-eslint/no-explicit-any
            }, (api)=>{
                $409cbe3732db83c2$var$devtoolsApi = api;
                api.on.visitComponentTree(({ componentInstance: componentInstance, treeNode: treeNode })=>{
                    $409cbe3732db83c2$var$updateComponentTreeTags(componentInstance, treeNode, i18n);
                });
                api.on.inspectComponent(({ componentInstance: componentInstance, instanceData: instanceData })=>{
                    if (componentInstance.vnode.el && componentInstance.vnode.el.__VUE_I18N__ && instanceData) {
                        if (i18n.mode === "legacy") // ignore global scope on legacy mode
                        {
                            if (componentInstance.vnode.el.__VUE_I18N__ !== i18n.global.__composer) $409cbe3732db83c2$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                        } else $409cbe3732db83c2$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                    }
                });
                api.addInspector({
                    id: "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ,
                    label: $409cbe3732db83c2$var$VueDevToolsLabels["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ],
                    icon: "language",
                    treeFilterPlaceholder: $409cbe3732db83c2$var$VueDevToolsPlaceholders["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]
                });
                api.on.getInspectorTree((payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) $409cbe3732db83c2$var$registerScope(payload, i18n);
                });
                const roots = new Map();
                api.on.getInspectorState(async (payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) {
                        api.unhighlightElement();
                        $409cbe3732db83c2$var$inspectScope(payload, i18n);
                        if (payload.nodeId === "global") {
                            if (!roots.has(payload.app)) {
                                const [root] = await api.getComponentInstances(payload.app);
                                roots.set(payload.app, root);
                            }
                            api.highlightElement(roots.get(payload.app));
                        } else {
                            const instance = $409cbe3732db83c2$var$getComponentInstance(payload.nodeId, i18n);
                            instance && api.highlightElement(instance);
                        }
                    }
                });
                api.on.editInspectorState((payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) $409cbe3732db83c2$var$editScope(payload, i18n);
                });
                api.addTimelineLayer({
                    id: "vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ,
                    label: $409cbe3732db83c2$var$VueDevToolsLabels["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ],
                    color: $409cbe3732db83c2$var$VueDevToolsTimelineColors["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]
                });
                resolve(true);
            });
        } catch (e) {
            console.error(e);
            reject(false);
        }
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getI18nScopeLable(instance) {
    return instance.type.name || instance.type.displayName || instance.type.__file || "Anonymous";
}
function $409cbe3732db83c2$var$updateComponentTreeTags(instance, treeNode, i18n) {
    // prettier-ignore
    const global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    if (instance && instance.vnode.el && instance.vnode.el.__VUE_I18N__) // add custom tags local scope only
    {
        if (instance.vnode.el.__VUE_I18N__ !== global) {
            const tag = {
                label: `i18n (${$409cbe3732db83c2$var$getI18nScopeLable(instance)} Scope)`,
                textColor: 0x000000,
                backgroundColor: 0xffcd19
            };
            treeNode.tags.push(tag);
        }
    }
}
function $409cbe3732db83c2$var$inspectComposer(instanceData, composer) {
    const type = $409cbe3732db83c2$var$VUE_I18N_COMPONENT_TYPES;
    instanceData.state.push({
        type: type,
        key: "locale",
        editable: true,
        value: composer.locale.value
    });
    instanceData.state.push({
        type: type,
        key: "availableLocales",
        editable: false,
        value: composer.availableLocales
    });
    instanceData.state.push({
        type: type,
        key: "fallbackLocale",
        editable: true,
        value: composer.fallbackLocale.value
    });
    instanceData.state.push({
        type: type,
        key: "inheritLocale",
        editable: true,
        value: composer.inheritLocale
    });
    instanceData.state.push({
        type: type,
        key: "messages",
        editable: false,
        value: $409cbe3732db83c2$var$getLocaleMessageValue(composer.messages.value)
    });
    instanceData.state.push({
        type: type,
        key: "datetimeFormats",
        editable: false,
        value: composer.datetimeFormats.value
    });
    instanceData.state.push({
        type: type,
        key: "numberFormats",
        editable: false,
        value: composer.numberFormats.value
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getLocaleMessageValue(messages) {
    const value = {};
    Object.keys(messages).forEach((key)=>{
        const v = messages[key];
        if ((0, $9QywT.isFunction)(v) && "source" in v) value[key] = $409cbe3732db83c2$var$getMessageFunctionDetails(v);
        else if ((0, $f97E4.isMessageAST)(v) && v.loc && v.loc.source) value[key] = v.loc.source;
        else if ((0, $9QywT.isObject)(v)) value[key] = $409cbe3732db83c2$var$getLocaleMessageValue(v);
        else value[key] = v;
    });
    return value;
}
const $409cbe3732db83c2$var$ESC = {
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "&": "&amp;"
};
function $409cbe3732db83c2$var$escape(s) {
    return s.replace(/[<>"&]/g, $409cbe3732db83c2$var$escapeChar);
}
function $409cbe3732db83c2$var$escapeChar(a) {
    return $409cbe3732db83c2$var$ESC[a] || a;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getMessageFunctionDetails(func) {
    const argString = func.source ? `("${$409cbe3732db83c2$var$escape(func.source)}")` : `(?)`;
    return {
        _custom: {
            type: "function",
            display: `<span>\u{192}</span> ${argString}`
        }
    };
}
function $409cbe3732db83c2$var$registerScope(payload, i18n) {
    payload.rootNodes.push({
        id: "global",
        label: "Global Scope"
    });
    // prettier-ignore
    const global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    for (const [keyInstance, instance] of i18n.__instances){
        // prettier-ignore
        const composer = i18n.mode === "composition" ? instance : instance.__composer;
        if (global === composer) continue;
        payload.rootNodes.push({
            id: composer.id.toString(),
            label: `${$409cbe3732db83c2$var$getI18nScopeLable(keyInstance)} Scope`
        });
    }
}
function $409cbe3732db83c2$var$getComponentInstance(nodeId, i18n) {
    let instance = null;
    if (nodeId !== "global") {
        for (const [component, composer] of i18n.__instances.entries())if (composer.id.toString() === nodeId) {
            instance = component;
            break;
        }
    }
    return instance;
}
function $409cbe3732db83c2$var$getComposer$1(nodeId, i18n) {
    if (nodeId === "global") return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    else {
        const instance = Array.from(i18n.__instances.values()).find((item)=>item.id.toString() === nodeId);
        if (instance) return i18n.mode === "composition" ? instance : instance.__composer;
        else return null;
    }
}
function $409cbe3732db83c2$var$inspectScope(payload, i18n) {
    const composer = $409cbe3732db83c2$var$getComposer$1(payload.nodeId, i18n);
    if (composer) // TODO:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload.state = $409cbe3732db83c2$var$makeScopeInspectState(composer);
    return null;
}
function $409cbe3732db83c2$var$makeScopeInspectState(composer) {
    const state = {};
    const localeType = "Locale related info";
    const localeStates = [
        {
            type: localeType,
            key: "locale",
            editable: true,
            value: composer.locale.value
        },
        {
            type: localeType,
            key: "fallbackLocale",
            editable: true,
            value: composer.fallbackLocale.value
        },
        {
            type: localeType,
            key: "availableLocales",
            editable: false,
            value: composer.availableLocales
        },
        {
            type: localeType,
            key: "inheritLocale",
            editable: true,
            value: composer.inheritLocale
        }
    ];
    state[localeType] = localeStates;
    const localeMessagesType = "Locale messages info";
    const localeMessagesStates = [
        {
            type: localeMessagesType,
            key: "messages",
            editable: false,
            value: $409cbe3732db83c2$var$getLocaleMessageValue(composer.messages.value)
        }
    ];
    state[localeMessagesType] = localeMessagesStates;
    {
        const datetimeFormatsType = "Datetime formats info";
        const datetimeFormatsStates = [
            {
                type: datetimeFormatsType,
                key: "datetimeFormats",
                editable: false,
                value: composer.datetimeFormats.value
            }
        ];
        state[datetimeFormatsType] = datetimeFormatsStates;
        const numberFormatsType = "Datetime formats info";
        const numberFormatsStates = [
            {
                type: numberFormatsType,
                key: "numberFormats",
                editable: false,
                value: composer.numberFormats.value
            }
        ];
        state[numberFormatsType] = numberFormatsStates;
    }
    return state;
}
function $409cbe3732db83c2$var$addTimelineEvent(event, payload) {
    if ($409cbe3732db83c2$var$devtoolsApi) {
        let groupId;
        if (payload && "groupId" in payload) {
            groupId = payload.groupId;
            delete payload.groupId;
        }
        $409cbe3732db83c2$var$devtoolsApi.addTimelineEvent({
            layerId: "vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ,
            event: {
                title: event,
                groupId: groupId,
                time: Date.now(),
                meta: {},
                data: payload || {},
                logType: event === "compile-error" /* VueDevToolsTimelineEvents.COMPILE_ERROR */  ? "error" : event === "fallback" /* VueDevToolsTimelineEvents.FALBACK */  || event === "missing" /* VueDevToolsTimelineEvents.MISSING */  ? "warning" : "default"
            }
        });
    }
}
function $409cbe3732db83c2$var$editScope(payload, i18n) {
    const composer = $409cbe3732db83c2$var$getComposer$1(payload.nodeId, i18n);
    if (composer) {
        const [field] = payload.path;
        if (field === "locale" && (0, $9QywT.isString)(payload.state.value)) composer.locale.value = payload.state.value;
        else if (field === "fallbackLocale" && ((0, $9QywT.isString)(payload.state.value) || (0, $9QywT.isArray)(payload.state.value) || (0, $9QywT.isObject)(payload.state.value))) composer.fallbackLocale.value = payload.state.value;
        else if (field === "inheritLocale" && (0, $9QywT.isBoolean)(payload.state.value)) composer.inheritLocale = payload.state.value;
    }
}
/**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */ function $409cbe3732db83c2$var$defineMixin(vuei18n, composer, i18n) {
    return {
        beforeCreate () {
            const instance = (0, $TusQn.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
            const options = this.$options;
            if (options.i18n) {
                const optionsI18n = options.i18n;
                if (options.__i18n) optionsI18n.__i18n = options.__i18n;
                optionsI18n.__root = composer;
                if (this === this.$root) // merge option and gttach global
                this.$i18n = $409cbe3732db83c2$var$mergeToGlobal(vuei18n, optionsI18n);
                else {
                    optionsI18n.__injectWithOption = true;
                    optionsI18n.__extender = i18n.__vueI18nExtend;
                    // atttach local VueI18n instance
                    this.$i18n = $409cbe3732db83c2$var$createVueI18n(optionsI18n);
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                }
            } else if (options.__i18n) {
                if (this === this.$root) // merge option and gttach global
                this.$i18n = $409cbe3732db83c2$var$mergeToGlobal(vuei18n, options);
                else {
                    // atttach local VueI18n instance
                    this.$i18n = $409cbe3732db83c2$var$createVueI18n({
                        __i18n: options.__i18n,
                        __injectWithOption: true,
                        __extender: i18n.__vueI18nExtend,
                        __root: composer
                    });
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                }
            } else // attach global VueI18n instance
            this.$i18n = vuei18n;
            if (options.__i18nGlobal) $409cbe3732db83c2$var$adjustI18nResources(composer, options, options);
            // defines vue-i18n legacy APIs
            this.$t = (...args)=>this.$i18n.t(...args);
            this.$rt = (...args)=>this.$i18n.rt(...args);
            this.$tc = (...args)=>this.$i18n.tc(...args);
            this.$te = (key, locale)=>this.$i18n.te(key, locale);
            this.$d = (...args)=>this.$i18n.d(...args);
            this.$n = (...args)=>this.$i18n.n(...args);
            this.$tm = (key)=>this.$i18n.tm(key);
            i18n.__setInstance(instance, this.$i18n);
        },
        mounted () {
            /* istanbul ignore if */ if ((0, this.$el) && this.$i18n) {
                const _vueI18n = this.$i18n;
                this.$el.__VUE_I18N__ = _vueI18n.__composer;
                const emitter = this.__v_emitter = (0, $9QywT.createEmitter)();
                _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                emitter.on("*", $409cbe3732db83c2$var$addTimelineEvent);
            }
        },
        unmounted () {
            const instance = (0, $TusQn.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
            const _vueI18n = this.$i18n;
            /* istanbul ignore if */ if ((0, this.$el) && this.$el.__VUE_I18N__) {
                if (this.__v_emitter) {
                    this.__v_emitter.off("*", $409cbe3732db83c2$var$addTimelineEvent);
                    delete this.__v_emitter;
                }
                if (this.$i18n) {
                    _vueI18n.__disableEmitter && _vueI18n.__disableEmitter();
                    delete this.$el.__VUE_I18N__;
                }
            }
            delete this.$t;
            delete this.$rt;
            delete this.$tc;
            delete this.$te;
            delete this.$d;
            delete this.$n;
            delete this.$tm;
            if (_vueI18n.__disposer) {
                _vueI18n.__disposer();
                delete _vueI18n.__disposer;
                delete _vueI18n.__extender;
            }
            i18n.__deleteInstance(instance);
            delete this.$i18n;
        }
    };
}
function $409cbe3732db83c2$var$mergeToGlobal(g, options) {
    g.locale = options.locale || g.locale;
    g.fallbackLocale = options.fallbackLocale || g.fallbackLocale;
    g.missing = options.missing || g.missing;
    g.silentTranslationWarn = options.silentTranslationWarn || g.silentFallbackWarn;
    g.silentFallbackWarn = options.silentFallbackWarn || g.silentFallbackWarn;
    g.formatFallbackMessages = options.formatFallbackMessages || g.formatFallbackMessages;
    g.postTranslation = options.postTranslation || g.postTranslation;
    g.warnHtmlInMessage = options.warnHtmlInMessage || g.warnHtmlInMessage;
    g.escapeParameterHtml = options.escapeParameterHtml || g.escapeParameterHtml;
    g.sync = options.sync || g.sync;
    g.__composer[$409cbe3732db83c2$var$SetPluralRulesSymbol](options.pluralizationRules || g.pluralizationRules);
    const messages = $409cbe3732db83c2$var$getLocaleMessages(g.locale, {
        messages: options.messages,
        __i18n: options.__i18n
    });
    Object.keys(messages).forEach((locale)=>g.mergeLocaleMessage(locale, messages[locale]));
    if (options.datetimeFormats) Object.keys(options.datetimeFormats).forEach((locale)=>g.mergeDateTimeFormat(locale, options.datetimeFormats[locale]));
    if (options.numberFormats) Object.keys(options.numberFormats).forEach((locale)=>g.mergeNumberFormat(locale, options.numberFormats[locale]));
    return g;
}
/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */ const $409cbe3732db83c2$export$b19990ca6e622dd2 = /* #__PURE__*/ (0, $9QywT.makeSymbol)("global-vue-i18n");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$export$920091e3d72d80ee(options = {}, VueI18nLegacy) {
    // prettier-ignore
    const __legacyMode = __VUE_I18N_LEGACY_API__ && (0, $9QywT.isBoolean)(options.legacy) ? options.legacy : __VUE_I18N_LEGACY_API__;
    // prettier-ignore
    const __globalInjection = (0, $9QywT.isBoolean)(options.globalInjection) ? options.globalInjection : true;
    // prettier-ignore
    const __allowComposition = __VUE_I18N_LEGACY_API__ && __legacyMode ? !!options.allowComposition : true;
    const __instances = new Map();
    const [globalScope, __global] = $409cbe3732db83c2$var$createGlobal(options, __legacyMode);
    const symbol = /* #__PURE__*/ (0, $9QywT.makeSymbol)("vue-i18n");
    if (__legacyMode && __allowComposition && true) (0, $9QywT.warn)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.NOTICE_DROP_ALLOW_COMPOSITION));
    function __getInstance(component) {
        return __instances.get(component) || null;
    }
    function __setInstance(component, instance) {
        __instances.set(component, instance);
    }
    function __deleteInstance(component) {
        __instances.delete(component);
    }
    {
        const i18n = {
            // mode
            get mode () {
                return __VUE_I18N_LEGACY_API__ && __legacyMode ? "legacy" : "composition";
            },
            // allowComposition
            get allowComposition () {
                return __allowComposition;
            },
            // install plugin
            async install (app, ...options) {
                app.__VUE_I18N__ = i18n;
                // setup global provider
                app.__VUE_I18N_SYMBOL__ = symbol;
                app.provide(app.__VUE_I18N_SYMBOL__, i18n);
                // set composer & vuei18n extend hook options from plugin options
                if ((0, $9QywT.isPlainObject)(options[0])) {
                    const opts = options[0];
                    i18n.__composerExtend = opts.__composerExtend;
                    i18n.__vueI18nExtend = opts.__vueI18nExtend;
                }
                // global method and properties injection for Composition API
                let globalReleaseHandler = null;
                if (!__legacyMode && __globalInjection) globalReleaseHandler = $409cbe3732db83c2$var$injectGlobalFields(app, i18n.global);
                // install built-in components and directive
                if (__VUE_I18N_FULL_INSTALL__) $409cbe3732db83c2$var$apply(app, i18n, ...options);
                // setup mixin for Legacy API
                if (__VUE_I18N_LEGACY_API__ && __legacyMode) app.mixin($409cbe3732db83c2$var$defineMixin(__global, __global.__composer, i18n));
                // release global scope
                const unmountApp = app.unmount;
                app.unmount = ()=>{
                    globalReleaseHandler && globalReleaseHandler();
                    i18n.dispose();
                    unmountApp();
                };
                {
                    const ret = await $409cbe3732db83c2$var$enableDevTools(app, i18n);
                    if (!ret) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
                    const emitter = (0, $9QywT.createEmitter)();
                    if (__legacyMode) {
                        const _vueI18n = __global;
                        _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                    } else {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const _composer = __global;
                        _composer[$409cbe3732db83c2$var$EnableEmitter] && _composer[$409cbe3732db83c2$var$EnableEmitter](emitter);
                    }
                    emitter.on("*", $409cbe3732db83c2$var$addTimelineEvent);
                }
            },
            // global accessor
            get global () {
                return __global;
            },
            dispose () {
                globalScope.stop();
            },
            __instances: // @internal
            __instances,
            __getInstance: // @internal
            __getInstance,
            __setInstance: // @internal
            __setInstance,
            __deleteInstance: // @internal
            __deleteInstance
        };
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$export$3f3caade1c12f8c9(options = {}) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (instance == null) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    if (!instance.isCE && instance.appContext.app != null && !instance.appContext.app.__VUE_I18N_SYMBOL__) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED);
    const i18n = $409cbe3732db83c2$var$getI18nInstance(instance);
    const gl = $409cbe3732db83c2$var$getGlobalComposer(i18n);
    const componentOptions = $409cbe3732db83c2$var$getComponentOptions(instance);
    const scope = $409cbe3732db83c2$var$getScope(options, componentOptions);
    if (__VUE_I18N_LEGACY_API__) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {
        if (i18n.mode === "legacy" && !options.__useComponent) {
            if (!i18n.allowComposition) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);
            return $409cbe3732db83c2$var$useI18nForLegacy(instance, scope, gl, options);
        }
    }
    if (scope === "global") {
        $409cbe3732db83c2$var$adjustI18nResources(gl, options, componentOptions);
        return gl;
    }
    if (scope === "parent") {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let composer = $409cbe3732db83c2$var$getComposer(i18n, instance, options.__useComponent);
        if (composer == null) {
            (0, $9QywT.warn)($409cbe3732db83c2$var$getWarnMessage($409cbe3732db83c2$var$I18nWarnCodes.NOT_FOUND_PARENT_SCOPE));
            composer = gl;
        }
        return composer;
    }
    const i18nInternal = i18n;
    let composer = i18nInternal.__getInstance(instance);
    if (composer == null) {
        const composerOptions = (0, $9QywT.assign)({}, options);
        if ("__i18n" in componentOptions) composerOptions.__i18n = componentOptions.__i18n;
        if (gl) composerOptions.__root = gl;
        composer = $409cbe3732db83c2$var$createComposer(composerOptions);
        if (i18nInternal.__composerExtend) composer[$409cbe3732db83c2$var$DisposeSymbol] = i18nInternal.__composerExtend(composer);
        $409cbe3732db83c2$var$setupLifeCycle(i18nInternal, instance, composer);
        i18nInternal.__setInstance(instance, composer);
    }
    return composer;
}
/**
 * Cast to VueI18n legacy compatible type
 *
 * @remarks
 * This API is provided only with [vue-i18n-bridge](https://vue-i18n.intlify.dev/guide/migration/ways.html#what-is-vue-i18n-bridge).
 *
 * The purpose of this function is to convert an {@link I18n} instance created with {@link createI18n | createI18n(legacy: true)} into a `vue-i18n@v8.x` compatible instance of `new VueI18n` in a TypeScript environment.
 *
 * @param i18n - An instance of {@link I18n}
 * @returns A i18n instance which is casted to {@link VueI18n} type
 *
 * @VueI18nTip
 * :new: provided by **vue-i18n-bridge only**
 *
 * @VueI18nGeneral
 */ /* #__NO_SIDE_EFFECTS__ */ const $409cbe3732db83c2$export$ec8a89fa64fbfb0 = (i18n)=>{
    if (!($409cbe3732db83c2$var$__VUE_I18N_BRIDGE__ in i18n)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N);
    return i18n;
};
function $409cbe3732db83c2$var$createGlobal(options, legacyMode, VueI18nLegacy // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const scope = (0, $01W3b.effectScope)();
    {
        const obj = __VUE_I18N_LEGACY_API__ && legacyMode ? scope.run(()=>$409cbe3732db83c2$var$createVueI18n(options)) : scope.run(()=>$409cbe3732db83c2$var$createComposer(options));
        if (obj == null) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        return [
            scope,
            obj
        ];
    }
}
function $409cbe3732db83c2$var$getI18nInstance(instance) {
    {
        const i18n = (0, $TusQn.inject)(!instance.isCE ? instance.appContext.app.__VUE_I18N_SYMBOL__ : $409cbe3732db83c2$export$b19990ca6e622dd2);
        /* istanbul ignore if */ if (!i18n) throw $409cbe3732db83c2$var$createI18nError(!instance.isCE ? $409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR : $409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE);
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getScope(options, componentOptions) {
    // prettier-ignore
    return (0, $9QywT.isEmptyObject)(options) ? "__i18n" in componentOptions ? "local" : "global" : !options.useScope ? "local" : options.useScope;
}
function $409cbe3732db83c2$var$getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
}
function $409cbe3732db83c2$var$getComposer(i18n, target, useComponent = false) {
    let composer = null;
    const root = target.root;
    let current = $409cbe3732db83c2$var$getParentComponentInstance(target, useComponent);
    while(current != null){
        const i18nInternal = i18n;
        if (i18n.mode === "composition") composer = i18nInternal.__getInstance(current);
        else if (__VUE_I18N_LEGACY_API__) {
            const vueI18n = i18nInternal.__getInstance(current);
            if (vueI18n != null) {
                composer = vueI18n.__composer;
                if (useComponent && composer && !composer[$409cbe3732db83c2$var$InejctWithOptionSymbol] // eslint-disable-line @typescript-eslint/no-explicit-any
                ) composer = null;
            }
        }
        if (composer != null) break;
        if (root === current) break;
        current = current.parent;
    }
    return composer;
}
function $409cbe3732db83c2$var$getParentComponentInstance(target, useComponent = false) {
    if (target == null) return null;
    // if `useComponent: true` will be specified, we get lexical scope owner instance for use-case slots
    return !useComponent ? target.parent : target.vnode.ctx || target.parent; // eslint-disable-line @typescript-eslint/no-explicit-any
}
function $409cbe3732db83c2$var$setupLifeCycle(i18n, target, composer) {
    let emitter = null;
    (0, $TusQn.onMounted)(()=>{
        // inject composer instance to DOM for intlify-devtools
        if (0, target.vnode.el) {
            target.vnode.el.__VUE_I18N__ = composer;
            emitter = (0, $9QywT.createEmitter)();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const _composer = composer;
            _composer[$409cbe3732db83c2$var$EnableEmitter] && _composer[$409cbe3732db83c2$var$EnableEmitter](emitter);
            emitter.on("*", $409cbe3732db83c2$var$addTimelineEvent);
        }
    }, target);
    (0, $TusQn.onUnmounted)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _composer = composer;
        // remove composer instance from DOM for intlify-devtools
        if ((0, target.vnode.el) && target.vnode.el.__VUE_I18N__) {
            emitter && emitter.off("*", $409cbe3732db83c2$var$addTimelineEvent);
            _composer[$409cbe3732db83c2$var$DisableEmitter] && _composer[$409cbe3732db83c2$var$DisableEmitter]();
            delete target.vnode.el.__VUE_I18N__;
        }
        i18n.__deleteInstance(target);
        // dispose extended resources
        const dispose = _composer[$409cbe3732db83c2$var$DisposeSymbol];
        if (dispose) {
            dispose();
            delete _composer[$409cbe3732db83c2$var$DisposeSymbol];
        }
    }, target);
}
function $409cbe3732db83c2$var$useI18nForLegacy(instance, scope, root, options = {} // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const isLocalScope = scope === "local";
    const _composer = (0, $01W3b.shallowRef)(null);
    if (isLocalScope && instance.proxy && !(instance.proxy.$options.i18n || instance.proxy.$options.__i18n)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
    const _inheritLocale = (0, $9QywT.isBoolean)(options.inheritLocale) ? options.inheritLocale : !(0, $9QywT.isString)(options.locale);
    const _locale = (0, $01W3b.ref)(// prettier-ignore
    !isLocalScope || _inheritLocale ? root.locale.value : (0, $9QywT.isString)(options.locale) ? options.locale : (0, $f97E4.DEFAULT_LOCALE));
    const _fallbackLocale = (0, $01W3b.ref)(// prettier-ignore
    !isLocalScope || _inheritLocale ? root.fallbackLocale.value : (0, $9QywT.isString)(options.fallbackLocale) || (0, $9QywT.isArray)(options.fallbackLocale) || (0, $9QywT.isPlainObject)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    const _messages = (0, $01W3b.ref)($409cbe3732db83c2$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = (0, $01W3b.ref)((0, $9QywT.isPlainObject)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _numberFormats = (0, $01W3b.ref)((0, $9QywT.isPlainObject)(options.numberFormats) ? options.numberFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _missingWarn = isLocalScope ? root.missingWarn : (0, $9QywT.isBoolean)(options.missingWarn) || (0, $9QywT.isRegExp)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    const _fallbackWarn = isLocalScope ? root.fallbackWarn : (0, $9QywT.isBoolean)(options.fallbackWarn) || (0, $9QywT.isRegExp)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    const _fallbackRoot = isLocalScope ? root.fallbackRoot : (0, $9QywT.isBoolean)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    const _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    const _missing = (0, $9QywT.isFunction)(options.missing) ? options.missing : null;
    // postTranslation handler
    const _postTranslation = (0, $9QywT.isFunction)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    const _warnHtmlMessage = isLocalScope ? root.warnHtmlMessage : (0, $9QywT.isBoolean)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    const _escapeParameter = !!options.escapeParameter;
    // prettier-ignore
    const _modifiers = isLocalScope ? root.modifiers : (0, $9QywT.isPlainObject)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    const _pluralRules = options.pluralRules || isLocalScope && root.pluralRules;
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = (0, $01W3b.computed)({
        get: ()=>{
            return _composer.value ? _composer.value.locale.value : _locale.value;
        },
        set: (val1)=>{
            if (_composer.value) _composer.value.locale.value = val1;
            _locale.value = val1;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0, $01W3b.computed)({
        get: ()=>{
            return _composer.value ? _composer.value.fallbackLocale.value : _fallbackLocale.value;
        },
        set: (val1)=>{
            if (_composer.value) _composer.value.fallbackLocale.value = val1;
            _fallbackLocale.value = val1;
        }
    });
    // messages
    const messages = (0, $01W3b.computed)(()=>{
        if (_composer.value) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _composer.value.messages.value;
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _messages.value;
    });
    const datetimeFormats = (0, $01W3b.computed)(()=>_datetimeFormats.value);
    const numberFormats = (0, $01W3b.computed)(()=>_numberFormats.value);
    function getPostTranslationHandler() {
        return _composer.value ? _composer.value.getPostTranslationHandler() : _postTranslation;
    }
    function setPostTranslationHandler(handler1) {
        if (_composer.value) _composer.value.setPostTranslationHandler(handler1);
    }
    function getMissingHandler() {
        return _composer.value ? _composer.value.getMissingHandler() : _missing;
    }
    function setMissingHandler(handler1) {
        if (_composer.value) _composer.value.setMissingHandler(handler1);
    }
    function warpWithDeps(fn) {
        trackReactivityValues();
        return fn();
    }
    function t(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.t, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function rt(...args) {
        return _composer.value ? Reflect.apply(_composer.value.rt, null, [
            ...args
        ]) : "";
    }
    function d(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.d, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function n(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.n, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function tm(key) {
        return _composer.value ? _composer.value.tm(key) : {};
    }
    function te(key, locale) {
        return _composer.value ? _composer.value.te(key, locale) : false;
    }
    function getLocaleMessage(locale) {
        return _composer.value ? _composer.value.getLocaleMessage(locale) : {};
    }
    function setLocaleMessage(locale, message) {
        if (_composer.value) {
            _composer.value.setLocaleMessage(locale, message);
            _messages.value[locale] = message;
        }
    }
    function mergeLocaleMessage(locale, message) {
        if (_composer.value) _composer.value.mergeLocaleMessage(locale, message);
    }
    function getDateTimeFormat(locale) {
        return _composer.value ? _composer.value.getDateTimeFormat(locale) : {};
    }
    function setDateTimeFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setDateTimeFormat(locale, format);
            _datetimeFormats.value[locale] = format;
        }
    }
    function mergeDateTimeFormat(locale, format) {
        if (_composer.value) _composer.value.mergeDateTimeFormat(locale, format);
    }
    function getNumberFormat(locale) {
        return _composer.value ? _composer.value.getNumberFormat(locale) : {};
    }
    function setNumberFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setNumberFormat(locale, format);
            _numberFormats.value[locale] = format;
        }
    }
    function mergeNumberFormat(locale, format) {
        if (_composer.value) _composer.value.mergeNumberFormat(locale, format);
    }
    const wrapper = {
        get id () {
            return _composer.value ? _composer.value.id : -1;
        },
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        get inheritLocale () {
            return _composer.value ? _composer.value.inheritLocale : _inheritLocale;
        },
        set inheritLocale (val){
            if (_composer.value) _composer.value.inheritLocale = val;
        },
        get availableLocales () {
            return _composer.value ? _composer.value.availableLocales : Object.keys(_messages.value);
        },
        get modifiers () {
            return _composer.value ? _composer.value.modifiers : _modifiers;
        },
        get pluralRules () {
            return _composer.value ? _composer.value.pluralRules : _pluralRules;
        },
        get isGlobal () {
            return _composer.value ? _composer.value.isGlobal : false;
        },
        get missingWarn () {
            return _composer.value ? _composer.value.missingWarn : _missingWarn;
        },
        set missingWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackWarn () {
            return _composer.value ? _composer.value.fallbackWarn : _fallbackWarn;
        },
        set fallbackWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackRoot () {
            return _composer.value ? _composer.value.fallbackRoot : _fallbackRoot;
        },
        set fallbackRoot (val){
            if (_composer.value) _composer.value.fallbackRoot = val;
        },
        get fallbackFormat () {
            return _composer.value ? _composer.value.fallbackFormat : _fallbackFormat;
        },
        set fallbackFormat (val){
            if (_composer.value) _composer.value.fallbackFormat = val;
        },
        get warnHtmlMessage () {
            return _composer.value ? _composer.value.warnHtmlMessage : _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            if (_composer.value) _composer.value.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _composer.value ? _composer.value.escapeParameter : _escapeParameter;
        },
        set escapeParameter (val){
            if (_composer.value) _composer.value.escapeParameter = val;
        },
        t: t,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        rt: rt,
        d: d,
        n: n,
        tm: tm,
        te: te,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getDateTimeFormat: getDateTimeFormat,
        setDateTimeFormat: setDateTimeFormat,
        mergeDateTimeFormat: mergeDateTimeFormat,
        getNumberFormat: getNumberFormat,
        setNumberFormat: setNumberFormat,
        mergeNumberFormat: mergeNumberFormat
    };
    function sync(composer) {
        composer.locale.value = _locale.value;
        composer.fallbackLocale.value = _fallbackLocale.value;
        Object.keys(_messages.value).forEach((locale)=>{
            composer.mergeLocaleMessage(locale, _messages.value[locale]);
        });
        Object.keys(_datetimeFormats.value).forEach((locale)=>{
            composer.mergeDateTimeFormat(locale, _datetimeFormats.value[locale]);
        });
        Object.keys(_numberFormats.value).forEach((locale)=>{
            composer.mergeNumberFormat(locale, _numberFormats.value[locale]);
        });
        composer.escapeParameter = _escapeParameter;
        composer.fallbackFormat = _fallbackFormat;
        composer.fallbackRoot = _fallbackRoot;
        composer.fallbackWarn = _fallbackWarn;
        composer.missingWarn = _missingWarn;
        composer.warnHtmlMessage = _warnHtmlMessage;
    }
    (0, $TusQn.onBeforeMount)(()=>{
        if (instance.proxy == null || instance.proxy.$i18n == null) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const composer = _composer.value = instance.proxy.$i18n.__composer;
        if (scope === "global") {
            _locale.value = composer.locale.value;
            _fallbackLocale.value = composer.fallbackLocale.value;
            _messages.value = composer.messages.value;
            _datetimeFormats.value = composer.datetimeFormats.value;
            _numberFormats.value = composer.numberFormats.value;
        } else if (isLocalScope) sync(composer);
    });
    return wrapper;
}
const $409cbe3732db83c2$var$globalExportProps = [
    "locale",
    "fallbackLocale",
    "availableLocales"
];
const $409cbe3732db83c2$var$globalExportMethods = [
    "t",
    "rt",
    "d",
    "n",
    "tm",
    "te"
];
function $409cbe3732db83c2$var$injectGlobalFields(app, composer) {
    const i18n = Object.create(null);
    $409cbe3732db83c2$var$globalExportProps.forEach((prop)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, prop);
        if (!desc) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const wrap = (0, $01W3b.isRef)(desc.value) // check computed props
         ? {
            get () {
                return desc.value.value;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            set (val1) {
                desc.value.value = val1;
            }
        } : {
            get () {
                return desc.get && desc.get();
            }
        };
        Object.defineProperty(i18n, prop, wrap);
    });
    app.config.globalProperties.$i18n = i18n;
    $409cbe3732db83c2$var$globalExportMethods.forEach((method)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, method);
        if (!desc || !desc.value) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        Object.defineProperty(app.config.globalProperties, `$${method}`, desc);
    });
    const dispose = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete app.config.globalProperties.$i18n;
        $409cbe3732db83c2$var$globalExportMethods.forEach((method)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            delete app.config.globalProperties[`$${method}`];
        });
    };
    return dispose;
}
$409cbe3732db83c2$var$initFeatureFlags();
// register message compiler at vue-i18n
if (__INTLIFY_JIT_COMPILATION__) (0, $f97E4.registerMessageCompiler)((0, $f97E4.compile));
else (0, $f97E4.registerMessageCompiler)((0, $f97E4.compileToFunction));
// register message resolver at vue-i18n
(0, $f97E4.registerMessageResolver)((0, $f97E4.resolveValue));
// register fallback locale at vue-i18n
(0, $f97E4.registerLocaleFallbacker)((0, $f97E4.fallbackWithLocaleChain));
{
    const target = (0, $9QywT.getGlobalThis)();
    target.__INTLIFY__ = true;
    (0, $f97E4.setDevToolsHook)(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
});
parcelRegister("9QywT", function(module, exports) {

$parcel$export(module.exports, "inBrowser", () => $fbd1e3bc010bc8c2$export$620a268685f0ac45);
$parcel$export(module.exports, "mark", () => $fbd1e3bc010bc8c2$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "measure", () => $fbd1e3bc010bc8c2$export$83602b44513dc228);
$parcel$export(module.exports, "format", () => $fbd1e3bc010bc8c2$export$d9468344d3651243);
$parcel$export(module.exports, "isObject", () => $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "makeSymbol", () => $fbd1e3bc010bc8c2$export$cd133c5e04906ece);
$parcel$export(module.exports, "generateFormatCacheKey", () => $fbd1e3bc010bc8c2$export$5024ef1f92c9a364);
$parcel$export(module.exports, "isNumber", () => $fbd1e3bc010bc8c2$export$7e4aa119212bc614);
$parcel$export(module.exports, "isDate", () => $fbd1e3bc010bc8c2$export$871608497c498473);
$parcel$export(module.exports, "isRegExp", () => $fbd1e3bc010bc8c2$export$49841c62b9eff15);
$parcel$export(module.exports, "isEmptyObject", () => $fbd1e3bc010bc8c2$export$83b788b1a3698c03);
$parcel$export(module.exports, "isPlainObject", () => $fbd1e3bc010bc8c2$export$53b83ca8eaab0383);
$parcel$export(module.exports, "assign", () => $fbd1e3bc010bc8c2$export$e6e34fd1f2686227);
$parcel$export(module.exports, "getGlobalThis", () => $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "escapeHtml", () => $fbd1e3bc010bc8c2$export$4cf11838cdc2a8a8);
$parcel$export(module.exports, "hasOwn", () => $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $fbd1e3bc010bc8c2$export$43bee75e5e14138e);
$parcel$export(module.exports, "isFunction", () => $fbd1e3bc010bc8c2$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $fbd1e3bc010bc8c2$export$844ec244b1367d54);
$parcel$export(module.exports, "isBoolean", () => $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isPromise", () => $fbd1e3bc010bc8c2$export$4369c812aac99591);
$parcel$export(module.exports, "toDisplayString", () => $fbd1e3bc010bc8c2$export$b5b1545233b45293);
$parcel$export(module.exports, "join", () => $fbd1e3bc010bc8c2$export$f7e2c8231c57a8bd);
$parcel$export(module.exports, "generateCodeFrame", () => $fbd1e3bc010bc8c2$export$f9c0d8b6684a279b);
$parcel$export(module.exports, "incrementer", () => $fbd1e3bc010bc8c2$export$47db5deb603dfca1);
$parcel$export(module.exports, "warn", () => $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "warnOnce", () => $fbd1e3bc010bc8c2$export$5b28268982f175ba);
$parcel$export(module.exports, "createEmitter", () => $fbd1e3bc010bc8c2$export$6f5e8f34570e3ad1);
$parcel$export(module.exports, "deepCopy", () => $fbd1e3bc010bc8c2$export$6c40052bed430212);
/*!
  * shared v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */ /**
 * Original Utilities
 * written by kazuya kawaguchi
 */ const $fbd1e3bc010bc8c2$export$620a268685f0ac45 = typeof window !== "undefined";
let $fbd1e3bc010bc8c2$export$bf7f2fce5c1cf636;
let $fbd1e3bc010bc8c2$export$83602b44513dc228;
{
    const perf = $fbd1e3bc010bc8c2$export$620a268685f0ac45 && window.performance;
    if (perf && perf.mark && perf.measure && perf.clearMarks && // @ts-ignore browser compat
    perf.clearMeasures) {
        $fbd1e3bc010bc8c2$export$bf7f2fce5c1cf636 = (tag)=>{
            perf.mark(tag);
        };
        $fbd1e3bc010bc8c2$export$83602b44513dc228 = (name, startTag, endTag)=>{
            perf.measure(name, startTag, endTag);
            perf.clearMarks(startTag);
            perf.clearMarks(endTag);
        };
    }
}const $fbd1e3bc010bc8c2$var$RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
/* eslint-disable */ function $fbd1e3bc010bc8c2$export$d9468344d3651243(message, ...args) {
    if (args.length === 1 && $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(args[0])) args = args[0];
    if (!args || !args.hasOwnProperty) args = {};
    return message.replace($fbd1e3bc010bc8c2$var$RE_ARGS, (match, identifier)=>{
        return args.hasOwnProperty(identifier) ? args[identifier] : "";
    });
}
const $fbd1e3bc010bc8c2$export$cd133c5e04906ece = (name, shareable = false)=>!shareable ? Symbol(name) : Symbol.for(name);
const $fbd1e3bc010bc8c2$export$5024ef1f92c9a364 = (locale, key, source)=>$fbd1e3bc010bc8c2$export$d704025436eaed65({
        l: locale,
        k: key,
        s: source
    });
const $fbd1e3bc010bc8c2$export$d704025436eaed65 = (json)=>JSON.stringify(json).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027");
const $fbd1e3bc010bc8c2$export$7e4aa119212bc614 = (val)=>typeof val === "number" && isFinite(val);
const $fbd1e3bc010bc8c2$export$871608497c498473 = (val)=>$fbd1e3bc010bc8c2$export$1dccc787cc36538b(val) === "[object Date]";
const $fbd1e3bc010bc8c2$export$49841c62b9eff15 = (val)=>$fbd1e3bc010bc8c2$export$1dccc787cc36538b(val) === "[object RegExp]";
const $fbd1e3bc010bc8c2$export$83b788b1a3698c03 = (val)=>$fbd1e3bc010bc8c2$export$53b83ca8eaab0383(val) && Object.keys(val).length === 0;
const $fbd1e3bc010bc8c2$export$e6e34fd1f2686227 = Object.assign;
let $fbd1e3bc010bc8c2$var$_globalThis;
const $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14 = ()=>{
    // prettier-ignore
    return $fbd1e3bc010bc8c2$var$_globalThis || ($fbd1e3bc010bc8c2$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
function $fbd1e3bc010bc8c2$export$4cf11838cdc2a8a8(rawText) {
    return rawText.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const $fbd1e3bc010bc8c2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3(obj, key) {
    return $fbd1e3bc010bc8c2$var$hasOwnProperty.call(obj, key);
}
/* eslint-enable */ /**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */ const $fbd1e3bc010bc8c2$export$43bee75e5e14138e = Array.isArray;
const $fbd1e3bc010bc8c2$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $fbd1e3bc010bc8c2$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238 = (val)=>typeof val === "boolean";
const $fbd1e3bc010bc8c2$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fbd1e3bc010bc8c2$export$4369c812aac99591 = (val)=>{
    return $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(val) && $fbd1e3bc010bc8c2$export$f6e2535fb5126e54(val.then) && $fbd1e3bc010bc8c2$export$f6e2535fb5126e54(val.catch);
};
const $fbd1e3bc010bc8c2$export$830c053460e5ddf6 = Object.prototype.toString;
const $fbd1e3bc010bc8c2$export$1dccc787cc36538b = (value)=>$fbd1e3bc010bc8c2$export$830c053460e5ddf6.call(value);
const $fbd1e3bc010bc8c2$export$53b83ca8eaab0383 = (val)=>{
    if (!$fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(val)) return false;
    const proto = Object.getPrototypeOf(val);
    return proto === null || proto.constructor === Object;
};
// for converting list and named values to displayed strings.
const $fbd1e3bc010bc8c2$export$b5b1545233b45293 = (val)=>{
    return val == null ? "" : $fbd1e3bc010bc8c2$export$43bee75e5e14138e(val) || $fbd1e3bc010bc8c2$export$53b83ca8eaab0383(val) && val.toString === $fbd1e3bc010bc8c2$export$830c053460e5ddf6 ? JSON.stringify(val, null, 2) : String(val);
};
function $fbd1e3bc010bc8c2$export$f7e2c8231c57a8bd(items, separator = "") {
    return items.reduce((str, item, index)=>index === 0 ? str + item : str + separator + item, "");
}
const $fbd1e3bc010bc8c2$var$RANGE = 2;
function $fbd1e3bc010bc8c2$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    const lines = source.split(/\r?\n/);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + 1;
        if (count >= start) {
            for(let j = i - $fbd1e3bc010bc8c2$var$RANGE; j <= i + $fbd1e3bc010bc8c2$var$RANGE || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(3 - String(line).length)}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    const pad = start - (count - lineLength) + 1;
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $fbd1e3bc010bc8c2$export$47db5deb603dfca1(code) {
    let current = code;
    return ()=>++current;
}
function $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d(msg, err) {
    if (typeof console !== "undefined") {
        console.warn(`[intlify] ` + msg);
        /* istanbul ignore if */ if (err) console.warn(err.stack);
    }
}
const $fbd1e3bc010bc8c2$var$hasWarned = {};
function $fbd1e3bc010bc8c2$export$5b28268982f175ba(msg) {
    if (!$fbd1e3bc010bc8c2$var$hasWarned[msg]) {
        $fbd1e3bc010bc8c2$var$hasWarned[msg] = true;
        $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d(msg);
    }
}
/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 */ /**
 * Create a event emitter
 *
 * @returns An event emitter
 */ function $fbd1e3bc010bc8c2$export$6f5e8f34570e3ad1() {
    const events = new Map();
    const emitter = {
        events: events,
        on (event, handler) {
            const handlers = events.get(event);
            const added = handlers && handlers.push(handler);
            if (!added) events.set(event, [
                handler
            ]);
        },
        off (event, handler) {
            const handlers = events.get(event);
            if (handlers) handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit (event, payload) {
            (events.get(event) || []).slice().map((handler)=>handler(payload));
            (events.get("*") || []).slice().map((handler)=>handler(event, payload));
        }
    };
    return emitter;
}
const $fbd1e3bc010bc8c2$var$isNotObjectOrIsArray = (val)=>!$fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(val) || $fbd1e3bc010bc8c2$export$43bee75e5e14138e(val);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $fbd1e3bc010bc8c2$export$6c40052bed430212(src, des) {
    // src and des should both be objects, and none of them can be a array
    if ($fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(src) || $fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(des)) throw new Error("Invalid value");
    const stack = [
        {
            src: src,
            des: des
        }
    ];
    while(stack.length){
        const { src: src, des: des } = stack.pop();
        Object.keys(src).forEach((key)=>{
            if ($fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(src[key]) || $fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(des[key])) // replace with src[key] when:
            // src[key] or des[key] is not an object, or
            // src[key] or des[key] is an array
            des[key] = src[key];
            else // src[key] and des[key] are both objects, merge them
            stack.push({
                src: src[key],
                des: des[key]
            });
        });
    }
}

});

parcelRegister("f97E4", function(module, exports) {

$parcel$export(module.exports, "resolveValue", () => $a739018d680a1535$export$d812c8e1906863d0);
$parcel$export(module.exports, "setDevToolsHook", () => $a739018d680a1535$export$c893d6c8966908b9);
$parcel$export(module.exports, "CoreWarnCodes", () => $a739018d680a1535$export$b6a676a18b27d4c8);
$parcel$export(module.exports, "CoreErrorCodes", () => $a739018d680a1535$export$1d4dfd6045c40277);
$parcel$export(module.exports, "fallbackWithLocaleChain", () => $a739018d680a1535$export$71df9db82dc445);
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $a739018d680a1535$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "NOT_REOSLVED", () => $a739018d680a1535$export$b7f13a18d1d0f835);
$parcel$export(module.exports, "MISSING_RESOLVE_VALUE", () => $a739018d680a1535$export$a04371e9dbb3870b);
$parcel$export(module.exports, "registerMessageCompiler", () => $a739018d680a1535$export$6ee2fbe83628b40b);
$parcel$export(module.exports, "registerMessageResolver", () => $a739018d680a1535$export$45dacdc710815463);
$parcel$export(module.exports, "registerLocaleFallbacker", () => $a739018d680a1535$export$fd8ec9dd8067edec);
$parcel$export(module.exports, "setAdditionalMeta", () => $a739018d680a1535$export$605703447dca72aa);
$parcel$export(module.exports, "setFallbackContext", () => $a739018d680a1535$export$e16aca6786e72a5e);
$parcel$export(module.exports, "getFallbackContext", () => $a739018d680a1535$export$3adddc434faa9e35);
$parcel$export(module.exports, "createCoreContext", () => $a739018d680a1535$export$3599d465b05a74a5);
$parcel$export(module.exports, "isTranslateFallbackWarn", () => $a739018d680a1535$export$d9435df38da77a63);
$parcel$export(module.exports, "isTranslateMissingWarn", () => $a739018d680a1535$export$e419d347a4a2eb71);
$parcel$export(module.exports, "updateFallbackLocale", () => $a739018d680a1535$export$c743ad8a3cc01530);
$parcel$export(module.exports, "isMessageAST", () => $a739018d680a1535$export$9ba95744594b90e0);
$parcel$export(module.exports, "compileToFunction", () => $a739018d680a1535$export$1ea8807c727891fc);
$parcel$export(module.exports, "compile", () => $a739018d680a1535$export$ef7acd7185315e22);
$parcel$export(module.exports, "isMessageFunction", () => $a739018d680a1535$export$92c0a039cf358271);
$parcel$export(module.exports, "translate", () => $a739018d680a1535$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "parseTranslateArgs", () => $a739018d680a1535$export$8d9616744e22681a);
$parcel$export(module.exports, "datetime", () => $a739018d680a1535$export$7ba4466dbd0f07e1);
$parcel$export(module.exports, "parseDateTimeArgs", () => $a739018d680a1535$export$165524b21a0d6b5e);
$parcel$export(module.exports, "DATETIME_FORMAT_OPTIONS_KEYS", () => $a739018d680a1535$export$c77049eaf05b1508);
$parcel$export(module.exports, "clearDateTimeFormat", () => $a739018d680a1535$export$5bc4fc7cf15d6ccd);
$parcel$export(module.exports, "number", () => $a739018d680a1535$export$98e628dec113755e);
$parcel$export(module.exports, "parseNumberArgs", () => $a739018d680a1535$export$d0e2eec8b686cf72);
$parcel$export(module.exports, "NUMBER_FORMAT_OPTIONS_KEYS", () => $a739018d680a1535$export$c39a7c3789c46ed6);
$parcel$export(module.exports, "clearNumberFormat", () => $a739018d680a1535$export$6a8717b3043a4f23);
$parcel$export(module.exports, "createCompileError", () => (parcelRequire("7yiTB")).createCompileError);
/*!
  * core-base v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $9QywT = parcelRequire("9QywT");

var $7yiTB = parcelRequire("7yiTB");
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $a739018d680a1535$var$initFeatureFlags() {
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $9QywT.getGlobalThis)().__INTLIFY_PROD_DEVTOOLS__ = false;
    if (typeof __INTLIFY_JIT_COMPILATION__ !== "boolean") (0, $9QywT.getGlobalThis)().__INTLIFY_JIT_COMPILATION__ = false;
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== "boolean") (0, $9QywT.getGlobalThis)().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
}
const $a739018d680a1535$var$pathStateMachine = [];
$a739018d680a1535$var$pathStateMachine[0 /* States.BEFORE_PATH */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        0 /* States.BEFORE_PATH */ 
    ],
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[1 /* States.IN_PATH */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        1 /* States.IN_PATH */ 
    ],
    ["." /* PathCharTypes.DOT */ ]: [
        2 /* States.BEFORE_IDENT */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[2 /* States.BEFORE_IDENT */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        2 /* States.BEFORE_IDENT */ 
    ],
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["0" /* PathCharTypes.ZERO */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[3 /* States.IN_IDENT */ ] = {
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["0" /* PathCharTypes.ZERO */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        1 /* States.IN_PATH */ ,
        1 /* Actions.PUSH */ 
    ],
    ["." /* PathCharTypes.DOT */ ]: [
        2 /* States.BEFORE_IDENT */ ,
        1 /* Actions.PUSH */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        1 /* Actions.PUSH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ ,
        1 /* Actions.PUSH */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[4 /* States.IN_SUB_PATH */ ] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */ ]: [
        5 /* States.IN_SINGLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ],
    ['"' /* PathCharTypes.DOUBLE_QUOTE */ ]: [
        6 /* States.IN_DOUBLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        2 /* Actions.INC_SUB_PATH_DEPTH */ 
    ],
    ["]" /* PathCharTypes.RIGHT_BRACKET */ ]: [
        1 /* States.IN_PATH */ ,
        3 /* Actions.PUSH_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[5 /* States.IN_SINGLE_QUOTE */ ] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        5 /* States.IN_SINGLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[6 /* States.IN_DOUBLE_QUOTE */ ] = {
    ['"' /* PathCharTypes.DOUBLE_QUOTE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        6 /* States.IN_DOUBLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ]
};
/**
 * Check if an expression is a literal value.
 */ const $a739018d680a1535$var$literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function $a739018d680a1535$var$isLiteral(exp) {
    return $a739018d680a1535$var$literalValueRE.test(exp);
}
/**
 * Strip quotes from a string
 */ function $a739018d680a1535$var$stripQuotes(str) {
    const a = str.charCodeAt(0);
    const b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}
/**
 * Determine the type of a character in a keypath.
 */ function $a739018d680a1535$var$getPathCharType(ch) {
    if (ch === undefined || ch === null) return "o" /* PathCharTypes.END_OF_FAIL */ ;
    const code = ch.charCodeAt(0);
    switch(code){
        case 0x5b:
        case 0x5d:
        case 0x2e:
        case 0x22:
        case 0x27:
            return ch;
        case 0x5f:
        case 0x24:
        case 0x2d:
            return "i" /* PathCharTypes.IDENT */ ;
        case 0x09:
        case 0x0a:
        case 0x0d:
        case 0xa0:
        case 0xfeff:
        case 0x2028:
        case 0x2029:
            return "w" /* PathCharTypes.WORKSPACE */ ;
    }
    return "i" /* PathCharTypes.IDENT */ ;
}
/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */ function $a739018d680a1535$var$formatSubPath(path) {
    const trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === "0" && isNaN(parseInt(path))) return false;
    return $a739018d680a1535$var$isLiteral(trimmed) ? $a739018d680a1535$var$stripQuotes(trimmed) : "*" /* PathCharTypes.ASTARISK */  + trimmed;
}
/**
 * Parse a string path into an array of segments
 */ function $a739018d680a1535$export$98e6a39c04603d36(path) {
    const keys = [];
    let index = -1;
    let mode = 0 /* States.BEFORE_PATH */ ;
    let subPathDepth = 0;
    let c;
    let key; // eslint-disable-line
    let newChar;
    let type;
    let transition;
    let action;
    let typeMap;
    const actions = [];
    actions[0 /* Actions.APPEND */ ] = ()=>{
        if (key === undefined) key = newChar;
        else key += newChar;
    };
    actions[1 /* Actions.PUSH */ ] = ()=>{
        if (key !== undefined) {
            keys.push(key);
            key = undefined;
        }
    };
    actions[2 /* Actions.INC_SUB_PATH_DEPTH */ ] = ()=>{
        actions[0 /* Actions.APPEND */ ]();
        subPathDepth++;
    };
    actions[3 /* Actions.PUSH_SUB_PATH */ ] = ()=>{
        if (subPathDepth > 0) {
            subPathDepth--;
            mode = 4 /* States.IN_SUB_PATH */ ;
            actions[0 /* Actions.APPEND */ ]();
        } else {
            subPathDepth = 0;
            if (key === undefined) return false;
            key = $a739018d680a1535$var$formatSubPath(key);
            if (key === false) return false;
            else actions[1 /* Actions.PUSH */ ]();
        }
    };
    function maybeUnescapeQuote() {
        const nextChar = path[index + 1];
        if (mode === 5 /* States.IN_SINGLE_QUOTE */  && nextChar === "'" /* PathCharTypes.SINGLE_QUOTE */  || mode === 6 /* States.IN_DOUBLE_QUOTE */  && nextChar === '"' /* PathCharTypes.DOUBLE_QUOTE */ ) {
            index++;
            newChar = "\\" + nextChar;
            actions[0 /* Actions.APPEND */ ]();
            return true;
        }
    }
    while(mode !== null){
        index++;
        c = path[index];
        if (c === "\\" && maybeUnescapeQuote()) continue;
        type = $a739018d680a1535$var$getPathCharType(c);
        typeMap = $a739018d680a1535$var$pathStateMachine[mode];
        transition = typeMap[type] || typeMap["l" /* PathCharTypes.ELSE */ ] || 8 /* States.ERROR */ ;
        // check parse error
        if (transition === 8 /* States.ERROR */ ) return;
        mode = transition[0];
        if (transition[1] !== undefined) {
            action = actions[transition[1]];
            if (action) {
                newChar = c;
                if (action() === false) return;
            }
        }
        // check parse finish
        if (mode === 7 /* States.AFTER_PATH */ ) return keys;
    }
}
// path token cache
const $a739018d680a1535$var$cache = new Map();
/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$b365de4c3506886c(obj, path) {
    return (0, $9QywT.isObject)(obj) ? obj[path] : null;
}
/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$d812c8e1906863d0(obj, path) {
    // check object
    if (!(0, $9QywT.isObject)(obj)) return null;
    // parse path
    let hit = $a739018d680a1535$var$cache.get(path);
    if (!hit) {
        hit = $a739018d680a1535$export$98e6a39c04603d36(path);
        if (hit) $a739018d680a1535$var$cache.set(path, hit);
    }
    // check hit
    if (!hit) return null;
    // resolve path value
    const len = hit.length;
    let last = obj;
    let i = 0;
    while(i < len){
        const val = last[hit[i]];
        if (val === undefined) return null;
        if ((0, $9QywT.isFunction)(last)) return null;
        last = val;
        i++;
    }
    return last;
}
const $a739018d680a1535$var$DEFAULT_MODIFIER = (str)=>str;
const $a739018d680a1535$var$DEFAULT_MESSAGE = (ctx)=>""; // eslint-disable-line
const $a739018d680a1535$export$12b53af6b8529bfc = "text";
const $a739018d680a1535$var$DEFAULT_NORMALIZE = (values)=>values.length === 0 ? "" : (0, $9QywT.join)(values);
const $a739018d680a1535$var$DEFAULT_INTERPOLATE = (0, $9QywT.toDisplayString);
function $a739018d680a1535$var$pluralDefault(choice, choicesLength) {
    choice = Math.abs(choice);
    if (choicesLength === 2) // prettier-ignore
    return choice ? choice > 1 ? 1 : 0 : 1;
    return choice ? Math.min(choice, 2) : 0;
}
function $a739018d680a1535$var$getPluralIndex(options) {
    // prettier-ignore
    const index = (0, $9QywT.isNumber)(options.pluralIndex) ? options.pluralIndex : -1;
    // prettier-ignore
    return options.named && ((0, $9QywT.isNumber)(options.named.count) || (0, $9QywT.isNumber)(options.named.n)) ? (0, $9QywT.isNumber)(options.named.count) ? options.named.count : (0, $9QywT.isNumber)(options.named.n) ? options.named.n : index : index;
}
function $a739018d680a1535$var$normalizeNamed(pluralIndex, props) {
    if (!props.count) props.count = pluralIndex;
    if (!props.n) props.n = pluralIndex;
}
function $a739018d680a1535$export$70de3b14beda2f5e(options = {}) {
    const locale = options.locale;
    const pluralIndex = $a739018d680a1535$var$getPluralIndex(options);
    const pluralRule = (0, $9QywT.isObject)(options.pluralRules) && (0, $9QywT.isString)(locale) && (0, $9QywT.isFunction)(options.pluralRules[locale]) ? options.pluralRules[locale] : $a739018d680a1535$var$pluralDefault;
    const orgPluralRule = (0, $9QywT.isObject)(options.pluralRules) && (0, $9QywT.isString)(locale) && (0, $9QywT.isFunction)(options.pluralRules[locale]) ? $a739018d680a1535$var$pluralDefault : undefined;
    const plural = (messages)=>{
        return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
    };
    const _list = options.list || [];
    const list = (index)=>_list[index];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _named = options.named || {};
    (0, $9QywT.isNumber)(options.pluralIndex) && $a739018d680a1535$var$normalizeNamed(pluralIndex, _named);
    const named = (key)=>_named[key];
    function message(key) {
        // prettier-ignore
        const msg = (0, $9QywT.isFunction)(options.messages) ? options.messages(key) : (0, $9QywT.isObject)(options.messages) ? options.messages[key] : false;
        return !msg ? options.parent ? options.parent.message(key) // resolve from parent messages
         : $a739018d680a1535$var$DEFAULT_MESSAGE : msg;
    }
    const _modifier = (name)=>options.modifiers ? options.modifiers[name] : $a739018d680a1535$var$DEFAULT_MODIFIER;
    const normalize = (0, $9QywT.isPlainObject)(options.processor) && (0, $9QywT.isFunction)(options.processor.normalize) ? options.processor.normalize : $a739018d680a1535$var$DEFAULT_NORMALIZE;
    const interpolate = (0, $9QywT.isPlainObject)(options.processor) && (0, $9QywT.isFunction)(options.processor.interpolate) ? options.processor.interpolate : $a739018d680a1535$var$DEFAULT_INTERPOLATE;
    const type = (0, $9QywT.isPlainObject)(options.processor) && (0, $9QywT.isString)(options.processor.type) ? options.processor.type : $a739018d680a1535$export$12b53af6b8529bfc;
    const linked = (key, ...args)=>{
        const [arg1, arg2] = args;
        let type = "text";
        let modifier = "";
        if (args.length === 1) {
            if ((0, $9QywT.isObject)(arg1)) {
                modifier = arg1.modifier || modifier;
                type = arg1.type || type;
            } else if ((0, $9QywT.isString)(arg1)) modifier = arg1 || modifier;
        } else if (args.length === 2) {
            if ((0, $9QywT.isString)(arg1)) modifier = arg1 || modifier;
            if ((0, $9QywT.isString)(arg2)) type = arg2 || type;
        }
        const ret = message(key)(ctx);
        const msg = // The message in vnode resolved with linked are returned as an array by processor.nomalize
        type === "vnode" && (0, $9QywT.isArray)(ret) && modifier ? ret[0] : ret;
        return modifier ? _modifier(modifier)(msg, type) : msg;
    };
    const ctx = {
        ["list" /* HelperNameMap.LIST */ ]: list,
        ["named" /* HelperNameMap.NAMED */ ]: named,
        ["plural" /* HelperNameMap.PLURAL */ ]: plural,
        ["linked" /* HelperNameMap.LINKED */ ]: linked,
        ["message" /* HelperNameMap.MESSAGE */ ]: message,
        ["type" /* HelperNameMap.TYPE */ ]: type,
        ["interpolate" /* HelperNameMap.INTERPOLATE */ ]: interpolate,
        ["normalize" /* HelperNameMap.NORMALIZE */ ]: normalize,
        ["values" /* HelperNameMap.VALUES */ ]: (0, $9QywT.assign)({}, _list, _named)
    };
    return ctx;
}
let $a739018d680a1535$var$devtools = null;
function $a739018d680a1535$export$c893d6c8966908b9(hook) {
    $a739018d680a1535$var$devtools = hook;
}
function $a739018d680a1535$export$8bd08e70642dc6f4() {
    return $a739018d680a1535$var$devtools;
}
function $a739018d680a1535$export$725afc6a300324a0(i18n, version, meta) {
    // TODO: queue if devtools is undefined
    $a739018d680a1535$var$devtools && $a739018d680a1535$var$devtools.emit("i18n:init" /* IntlifyDevToolsHooks.I18nInit */ , {
        timestamp: Date.now(),
        i18n: i18n,
        version: version,
        meta: meta
    });
}
const $a739018d680a1535$export$190d71a47ff3f767 = /* #__PURE__*/ $a739018d680a1535$var$createDevToolsHook("function:translate" /* IntlifyDevToolsHooks.FunctionTranslate */ );
function $a739018d680a1535$var$createDevToolsHook(hook) {
    return (payloads)=>$a739018d680a1535$var$devtools && $a739018d680a1535$var$devtools.emit(hook, payloads);
}
const $a739018d680a1535$var$code$1 = (0, $7yiTB.CompileWarnCodes).__EXTEND_POINT__;
const $a739018d680a1535$var$inc$1 = (0, $9QywT.incrementer)($a739018d680a1535$var$code$1);
const $a739018d680a1535$export$b6a676a18b27d4c8 = {
    NOT_FOUND_KEY: $a739018d680a1535$var$code$1,
    FALLBACK_TO_TRANSLATE: $a739018d680a1535$var$inc$1(),
    CANNOT_FORMAT_NUMBER: $a739018d680a1535$var$inc$1(),
    FALLBACK_TO_NUMBER_FORMAT: $a739018d680a1535$var$inc$1(),
    CANNOT_FORMAT_DATE: $a739018d680a1535$var$inc$1(),
    FALLBACK_TO_DATE_FORMAT: $a739018d680a1535$var$inc$1(),
    EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: $a739018d680a1535$var$inc$1(),
    __EXTEND_POINT__: $a739018d680a1535$var$inc$1() // 9
};
/** @internal */ const $a739018d680a1535$var$warnMessages = {
    [$a739018d680a1535$export$b6a676a18b27d4c8.NOT_FOUND_KEY]: `Not found '{key}' key in '{locale}' locale messages.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_TRANSLATE]: `Fall back to translate '{key}' key with '{target}' locale.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.CANNOT_FORMAT_NUMBER]: `Cannot format a number value due to not supported Intl.NumberFormat.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_NUMBER_FORMAT]: `Fall back to number format '{key}' key with '{target}' locale.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.CANNOT_FORMAT_DATE]: `Cannot format a date value due to not supported Intl.DateTimeFormat.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_DATE_FORMAT]: `Fall back to datetime format '{key}' key with '{target}' locale.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: `This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.`
};
function $a739018d680a1535$export$ae7a7631f2b2bb7(code, ...args) {
    return (0, $9QywT.format)($a739018d680a1535$var$warnMessages[code], ...args);
}
const $a739018d680a1535$var$code = (0, $7yiTB.CompileErrorCodes).__EXTEND_POINT__;
const $a739018d680a1535$var$inc = (0, $9QywT.incrementer)($a739018d680a1535$var$code);
const $a739018d680a1535$export$1d4dfd6045c40277 = {
    INVALID_ARGUMENT: $a739018d680a1535$var$code,
    INVALID_DATE_ARGUMENT: $a739018d680a1535$var$inc(),
    INVALID_ISO_DATE_ARGUMENT: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_NON_STRING_MESSAGE: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_LOCALE_PROMISE_VALUE: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_LOCALE_TYPE: $a739018d680a1535$var$inc(),
    __EXTEND_POINT__: $a739018d680a1535$var$inc() // 24
};
function $a739018d680a1535$export$3d702f7ac45b0a6b(code) {
    return (0, $7yiTB.createCompileError)(code, null, {
        messages: $a739018d680a1535$var$errorMessages
    });
}
/** @internal */ const $a739018d680a1535$var$errorMessages = {
    [$a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT]: "Invalid arguments",
    [$a739018d680a1535$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
    [$a739018d680a1535$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
/** @internal */ function $a739018d680a1535$export$180605366c04f0cd(context, options) {
    return options.locale != null ? $a739018d680a1535$export$df9bcabe7f932e01(options.locale) : $a739018d680a1535$export$df9bcabe7f932e01(context.locale);
}
let $a739018d680a1535$var$_resolveLocale;
/** @internal */ function $a739018d680a1535$export$df9bcabe7f932e01(locale) {
    if ((0, $9QywT.isString)(locale)) return locale;
    else {
        if ((0, $9QywT.isFunction)(locale)) {
            if (locale.resolvedOnce && $a739018d680a1535$var$_resolveLocale != null) return $a739018d680a1535$var$_resolveLocale;
            else if (locale.constructor.name === "Function") {
                const resolve = locale();
                if ((0, $9QywT.isPromise)(resolve)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
                return $a739018d680a1535$var$_resolveLocale = resolve;
            } else throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
        } else throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_TYPE);
    }
}
/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$e3330076537ef9d1(ctx, fallback, start // eslint-disable-line @typescript-eslint/no-unused-vars
) {
    // prettier-ignore
    return [
        ...new Set([
            start,
            ...(0, $9QywT.isArray)(fallback) ? fallback : (0, $9QywT.isObject)(fallback) ? Object.keys(fallback) : (0, $9QywT.isString)(fallback) ? [
                fallback
            ] : [
                start
            ]
        ])
    ];
}
/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$71df9db82dc445(ctx, fallback, start) {
    const startLocale = (0, $9QywT.isString)(start) ? start : $a739018d680a1535$export$1af4c7e47ad72f44;
    const context = ctx;
    if (!context.__localeChainCache) context.__localeChainCache = new Map();
    let chain = context.__localeChainCache.get(startLocale);
    if (!chain) {
        chain = [];
        // first block defined by start
        let block = [
            start
        ];
        // while any intervening block found
        while((0, $9QywT.isArray)(block))block = $a739018d680a1535$var$appendBlockToChain(chain, block, fallback);
        // prettier-ignore
        // last block defined by default
        const defaults = (0, $9QywT.isArray)(fallback) || !(0, $9QywT.isPlainObject)(fallback) ? fallback : fallback["default"] ? fallback["default"] : null;
        // convert defaults to array
        block = (0, $9QywT.isString)(defaults) ? [
            defaults
        ] : defaults;
        if ((0, $9QywT.isArray)(block)) $a739018d680a1535$var$appendBlockToChain(chain, block, false);
        context.__localeChainCache.set(startLocale, chain);
    }
    return chain;
}
function $a739018d680a1535$var$appendBlockToChain(chain, block, blocks) {
    let follow = true;
    for(let i = 0; i < block.length && (0, $9QywT.isBoolean)(follow); i++){
        const locale = block[i];
        if ((0, $9QywT.isString)(locale)) follow = $a739018d680a1535$var$appendLocaleToChain(chain, block[i], blocks);
    }
    return follow;
}
function $a739018d680a1535$var$appendLocaleToChain(chain, locale, blocks) {
    let follow;
    const tokens = locale.split("-");
    do {
        const target = tokens.join("-");
        follow = $a739018d680a1535$var$appendItemToChain(chain, target, blocks);
        tokens.splice(-1, 1);
    }while (tokens.length && follow === true);
    return follow;
}
function $a739018d680a1535$var$appendItemToChain(chain, target, blocks) {
    let follow = false;
    if (!chain.includes(target)) {
        follow = true;
        if (target) {
            follow = target[target.length - 1] !== "!";
            const locale = target.replace(/!/g, "");
            chain.push(locale);
            if (((0, $9QywT.isArray)(blocks) || (0, $9QywT.isPlainObject)(blocks)) && blocks[locale] // eslint-disable-line @typescript-eslint/no-explicit-any
            ) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            follow = blocks[locale];
        }
    }
    return follow;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Intlify core-base version
 * @internal
 */ const $a739018d680a1535$export$a4ad2735b021c132 = "9.13.1";
const $a739018d680a1535$export$b7f13a18d1d0f835 = -1;
const $a739018d680a1535$export$1af4c7e47ad72f44 = "en-US";
const $a739018d680a1535$export$a04371e9dbb3870b = "";
const $a739018d680a1535$var$capitalize = (str)=>`${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`;
function $a739018d680a1535$var$getDefaultLinkedModifiers() {
    return {
        upper: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $9QywT.isString)(val) ? val.toUpperCase() : type === "vnode" && (0, $9QywT.isObject)(val) && "__v_isVNode" in val ? val.children.toUpperCase() : val;
        },
        lower: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $9QywT.isString)(val) ? val.toLowerCase() : type === "vnode" && (0, $9QywT.isObject)(val) && "__v_isVNode" in val ? val.children.toLowerCase() : val;
        },
        capitalize: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $9QywT.isString)(val) ? $a739018d680a1535$var$capitalize(val) : type === "vnode" && (0, $9QywT.isObject)(val) && "__v_isVNode" in val ? $a739018d680a1535$var$capitalize(val.children) : val;
        }
    };
}
let $a739018d680a1535$var$_compiler;
function $a739018d680a1535$export$6ee2fbe83628b40b(compiler) {
    $a739018d680a1535$var$_compiler = compiler;
}
let $a739018d680a1535$var$_resolver;
/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$45dacdc710815463(resolver) {
    $a739018d680a1535$var$_resolver = resolver;
}
let $a739018d680a1535$var$_fallbacker;
/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$fd8ec9dd8067edec(fallbacker) {
    $a739018d680a1535$var$_fallbacker = fallbacker;
}
// Additional Meta for Intlify DevTools
let $a739018d680a1535$var$_additionalMeta = null;
/* #__NO_SIDE_EFFECTS__ */ const $a739018d680a1535$export$605703447dca72aa = (meta)=>{
    $a739018d680a1535$var$_additionalMeta = meta;
};
/* #__NO_SIDE_EFFECTS__ */ const $a739018d680a1535$export$817795a14e5c6622 = ()=>$a739018d680a1535$var$_additionalMeta;
let $a739018d680a1535$var$_fallbackContext = null;
const $a739018d680a1535$export$e16aca6786e72a5e = (context)=>{
    $a739018d680a1535$var$_fallbackContext = context;
};
const $a739018d680a1535$export$3adddc434faa9e35 = ()=>$a739018d680a1535$var$_fallbackContext;
// ID for CoreContext
let $a739018d680a1535$var$_cid = 0;
function $a739018d680a1535$export$3599d465b05a74a5(options = {}) {
    // setup options
    const onWarn = (0, $9QywT.isFunction)(options.onWarn) ? options.onWarn : (0, $9QywT.warn);
    const version = (0, $9QywT.isString)(options.version) ? options.version : $a739018d680a1535$export$a4ad2735b021c132;
    const locale = (0, $9QywT.isString)(options.locale) || (0, $9QywT.isFunction)(options.locale) ? options.locale : $a739018d680a1535$export$1af4c7e47ad72f44;
    const _locale = (0, $9QywT.isFunction)(locale) ? $a739018d680a1535$export$1af4c7e47ad72f44 : locale;
    const fallbackLocale = (0, $9QywT.isArray)(options.fallbackLocale) || (0, $9QywT.isPlainObject)(options.fallbackLocale) || (0, $9QywT.isString)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale;
    const messages = (0, $9QywT.isPlainObject)(options.messages) ? options.messages : {
        [_locale]: {}
    };
    const datetimeFormats = (0, $9QywT.isPlainObject)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale]: {}
    };
    const numberFormats = (0, $9QywT.isPlainObject)(options.numberFormats) ? options.numberFormats : {
        [_locale]: {}
    };
    const modifiers = (0, $9QywT.assign)({}, options.modifiers || {}, $a739018d680a1535$var$getDefaultLinkedModifiers());
    const pluralRules = options.pluralRules || {};
    const missing = (0, $9QywT.isFunction)(options.missing) ? options.missing : null;
    const missingWarn = (0, $9QywT.isBoolean)(options.missingWarn) || (0, $9QywT.isRegExp)(options.missingWarn) ? options.missingWarn : true;
    const fallbackWarn = (0, $9QywT.isBoolean)(options.fallbackWarn) || (0, $9QywT.isRegExp)(options.fallbackWarn) ? options.fallbackWarn : true;
    const fallbackFormat = !!options.fallbackFormat;
    const unresolving = !!options.unresolving;
    const postTranslation = (0, $9QywT.isFunction)(options.postTranslation) ? options.postTranslation : null;
    const processor = (0, $9QywT.isPlainObject)(options.processor) ? options.processor : null;
    const warnHtmlMessage = (0, $9QywT.isBoolean)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    const escapeParameter = !!options.escapeParameter;
    const messageCompiler = (0, $9QywT.isFunction)(options.messageCompiler) ? options.messageCompiler : $a739018d680a1535$var$_compiler;
    if ((0, $9QywT.isFunction)(options.messageCompiler)) (0, $9QywT.warnOnce)($a739018d680a1535$export$ae7a7631f2b2bb7($a739018d680a1535$export$b6a676a18b27d4c8.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
    const messageResolver = (0, $9QywT.isFunction)(options.messageResolver) ? options.messageResolver : $a739018d680a1535$var$_resolver || $a739018d680a1535$export$b365de4c3506886c;
    const localeFallbacker = (0, $9QywT.isFunction)(options.localeFallbacker) ? options.localeFallbacker : $a739018d680a1535$var$_fallbacker || $a739018d680a1535$export$e3330076537ef9d1;
    const fallbackContext = (0, $9QywT.isObject)(options.fallbackContext) ? options.fallbackContext : undefined;
    // setup internal options
    const internalOptions = options;
    const __datetimeFormatters = (0, $9QywT.isObject)(internalOptions.__datetimeFormatters) ? internalOptions.__datetimeFormatters : new Map();
    const __numberFormatters = (0, $9QywT.isObject)(internalOptions.__numberFormatters) ? internalOptions.__numberFormatters : new Map();
    const __meta = (0, $9QywT.isObject)(internalOptions.__meta) ? internalOptions.__meta : {};
    $a739018d680a1535$var$_cid++;
    const context = {
        version: version,
        cid: $a739018d680a1535$var$_cid,
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        modifiers: modifiers,
        pluralRules: pluralRules,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackFormat: fallbackFormat,
        unresolving: unresolving,
        postTranslation: postTranslation,
        processor: processor,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageCompiler: messageCompiler,
        messageResolver: messageResolver,
        localeFallbacker: localeFallbacker,
        fallbackContext: fallbackContext,
        onWarn: onWarn,
        __meta: __meta
    };
    context.datetimeFormats = datetimeFormats;
    context.numberFormats = numberFormats;
    context.__datetimeFormatters = __datetimeFormatters;
    context.__numberFormatters = __numberFormatters;
    context.__v_emitter = internalOptions.__v_emitter != null ? internalOptions.__v_emitter : undefined;
    $a739018d680a1535$export$725afc6a300324a0(context, version, __meta);
    return context;
}
/** @internal */ function $a739018d680a1535$export$d9435df38da77a63(fallback, key) {
    return fallback instanceof RegExp ? fallback.test(key) : fallback;
}
/** @internal */ function $a739018d680a1535$export$e419d347a4a2eb71(missing, key) {
    return missing instanceof RegExp ? missing.test(key) : missing;
}
/** @internal */ function $a739018d680a1535$export$bc779048ece0c567(context, key, locale, missingWarn, type) {
    const { missing: missing, onWarn: onWarn } = context;
    {
        const emitter = context.__v_emitter;
        if (emitter) emitter.emit("missing" /* VueDevToolsTimelineEvents.MISSING */ , {
            locale: locale,
            key: key,
            type: type,
            groupId: `${type}:${key}`
        });
    }
    if (missing !== null) {
        const ret = missing(context, locale, key, type);
        return (0, $9QywT.isString)(ret) ? ret : key;
    } else {
        if ($a739018d680a1535$export$e419d347a4a2eb71(missingWarn, key)) onWarn($a739018d680a1535$export$ae7a7631f2b2bb7($a739018d680a1535$export$b6a676a18b27d4c8.NOT_FOUND_KEY, {
            key: key,
            locale: locale
        }));
        return key;
    }
}
/** @internal */ function $a739018d680a1535$export$c743ad8a3cc01530(ctx, locale, fallback) {
    const context = ctx;
    context.__localeChainCache = new Map();
    ctx.localeFallbacker(ctx, fallback, locale);
}
/** @internal */ function $a739018d680a1535$export$59f8e8904fd79a18(locale, compareLocale) {
    if (locale === compareLocale) return false;
    return locale.split("-")[0] === compareLocale.split("-")[0];
}
/** @internal */ function $a739018d680a1535$export$d783301aca6271c3(targetLocale, locales) {
    const index = locales.indexOf(targetLocale);
    if (index === -1) return false;
    for(let i = index + 1; i < locales.length; i++){
        if ($a739018d680a1535$export$59f8e8904fd79a18(targetLocale, locales[i])) return true;
    }
    return false;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ function $a739018d680a1535$var$format(ast) {
    const msg = (ctx)=>$a739018d680a1535$var$formatParts(ctx, ast);
    return msg;
}
function $a739018d680a1535$var$formatParts(ctx, ast) {
    const body = ast.b || ast.body;
    if ((body.t || body.type) === 1 /* NodeTypes.Plural */ ) {
        const plural = body;
        const cases = plural.c || plural.cases;
        return ctx.plural(cases.reduce((messages, c)=>[
                ...messages,
                $a739018d680a1535$var$formatMessageParts(ctx, c)
            ], []));
    } else return $a739018d680a1535$var$formatMessageParts(ctx, body);
}
function $a739018d680a1535$var$formatMessageParts(ctx, node) {
    const _static = node.s || node.static;
    if (_static) return ctx.type === "text" ? _static : ctx.normalize([
        _static
    ]);
    else {
        const messages = (node.i || node.items).reduce((acm, c)=>[
                ...acm,
                $a739018d680a1535$var$formatMessagePart(ctx, c)
            ], []);
        return ctx.normalize(messages);
    }
}
function $a739018d680a1535$var$formatMessagePart(ctx, node) {
    const type = node.t || node.type;
    switch(type){
        case 3 /* NodeTypes.Text */ :
            {
                const text = node;
                return text.v || text.value;
            }
        case 9 /* NodeTypes.Literal */ :
            {
                const literal = node;
                return literal.v || literal.value;
            }
        case 4 /* NodeTypes.Named */ :
            {
                const named = node;
                return ctx.interpolate(ctx.named(named.k || named.key));
            }
        case 5 /* NodeTypes.List */ :
            {
                const list = node;
                return ctx.interpolate(ctx.list(list.i != null ? list.i : list.index));
            }
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                const modifier = linked.m || linked.modifier;
                return ctx.linked($a739018d680a1535$var$formatMessagePart(ctx, linked.k || linked.key), modifier ? $a739018d680a1535$var$formatMessagePart(ctx, modifier) : undefined, ctx.type);
            }
        case 7 /* NodeTypes.LinkedKey */ :
            {
                const linkedKey = node;
                return linkedKey.v || linkedKey.value;
            }
        case 8 /* NodeTypes.LinkedModifier */ :
            {
                const linkedModifier = node;
                return linkedModifier.v || linkedModifier.value;
            }
        default:
            throw new Error(`unhandled node type on format message part: ${type}`);
    }
}
const $a739018d680a1535$var$WARN_MESSAGE = `Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.`;
function $a739018d680a1535$var$checkHtmlMessage(source, warnHtmlMessage) {
    if (warnHtmlMessage && (0, $7yiTB.detectHtmlTag)(source)) (0, $9QywT.warn)((0, $9QywT.format)($a739018d680a1535$var$WARN_MESSAGE, {
        source: source
    }));
}
const $a739018d680a1535$var$defaultOnCacheKey = (message)=>message;
let $a739018d680a1535$var$compileCache = Object.create(null);
function $a739018d680a1535$var$onCompileWarn(_warn) {
    if (_warn.code === (0, $7yiTB.CompileWarnCodes).USE_MODULO_SYNTAX) (0, $9QywT.warn)(`The use of named interpolation with modulo syntax is deprecated. ` + `It will be removed in v10.\n` + `reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format \n` + `(message compiler warning message: ${_warn.message})`);
}
function $a739018d680a1535$export$2683c80ae3fe544() {
    $a739018d680a1535$var$compileCache = Object.create(null);
}
const $a739018d680a1535$export$9ba95744594b90e0 = (val)=>(0, $9QywT.isObject)(val) && (val.t === 0 || val.type === 0) && ("b" in val || "body" in val);
function $a739018d680a1535$var$baseCompile(message, options = {}) {
    // error detecting on compile
    let detectError = false;
    const onError = options.onError || (0, $7yiTB.defaultOnError);
    options.onError = (err)=>{
        detectError = true;
        onError(err);
    };
    // compile with mesasge-compiler
    return {
        ...(0, $7yiTB.baseCompile)(message, options),
        detectError: detectError
    };
}
/* #__NO_SIDE_EFFECTS__ */ const $a739018d680a1535$export$1ea8807c727891fc = (message, context)=>{
    if (!(0, $9QywT.isString)(message)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_NON_STRING_MESSAGE);
    context.onWarn = $a739018d680a1535$var$onCompileWarn;
    {
        // check HTML message
        const warnHtmlMessage = (0, $9QywT.isBoolean)(context.warnHtmlMessage) ? context.warnHtmlMessage : true;
        $a739018d680a1535$var$checkHtmlMessage(message, warnHtmlMessage);
        // check caches
        const onCacheKey = context.onCacheKey || $a739018d680a1535$var$defaultOnCacheKey;
        const cacheKey = onCacheKey(message);
        const cached = $a739018d680a1535$var$compileCache[cacheKey];
        if (cached) return cached;
        // compile
        const { code: code, detectError: detectError } = $a739018d680a1535$var$baseCompile(message, context);
        // evaluate function
        const msg = new Function(`return ${code}`)();
        // if occurred compile error, don't cache
        return !detectError ? $a739018d680a1535$var$compileCache[cacheKey] = msg : msg;
    }
};
function $a739018d680a1535$export$ef7acd7185315e22(message, context) {
    context.onWarn = $a739018d680a1535$var$onCompileWarn;
    if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && (0, $9QywT.isString)(message)) {
        // check HTML message
        const warnHtmlMessage = (0, $9QywT.isBoolean)(context.warnHtmlMessage) ? context.warnHtmlMessage : true;
        $a739018d680a1535$var$checkHtmlMessage(message, warnHtmlMessage);
        // check caches
        const onCacheKey = context.onCacheKey || $a739018d680a1535$var$defaultOnCacheKey;
        const cacheKey = onCacheKey(message);
        const cached = $a739018d680a1535$var$compileCache[cacheKey];
        if (cached) return cached;
        // compile with JIT mode
        const { ast: ast, detectError: detectError } = $a739018d680a1535$var$baseCompile(message, {
            ...context,
            location: true,
            jit: true
        });
        // compose message function from AST
        const msg = $a739018d680a1535$var$format(ast);
        // if occurred compile error, don't cache
        return !detectError ? $a739018d680a1535$var$compileCache[cacheKey] = msg : msg;
    } else {
        if (!$a739018d680a1535$export$9ba95744594b90e0(message)) {
            (0, $9QywT.warn)(`the message that is resolve with key '${context.key}' is not supported for jit compilation`);
            return ()=>message;
        }
        // AST case (passed from bundler)
        const cacheKey = message.cacheKey;
        if (cacheKey) {
            const cached = $a739018d680a1535$var$compileCache[cacheKey];
            if (cached) return cached;
            // compose message function from message (AST)
            return $a739018d680a1535$var$compileCache[cacheKey] = $a739018d680a1535$var$format(message);
        } else return $a739018d680a1535$var$format(message);
    }
}
const $a739018d680a1535$var$NOOP_MESSAGE_FUNCTION = ()=>"";
const $a739018d680a1535$export$92c0a039cf358271 = (val)=>(0, $9QywT.isFunction)(val);
// implementation of `translate` function
function $a739018d680a1535$export$d73ee8ef04f5226a(context, ...args) {
    const { fallbackFormat: fallbackFormat, postTranslation: postTranslation, unresolving: unresolving, messageCompiler: messageCompiler, fallbackLocale: fallbackLocale, messages: messages } = context;
    const [key, options] = $a739018d680a1535$export$8d9616744e22681a(...args);
    const missingWarn = (0, $9QywT.isBoolean)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $9QywT.isBoolean)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const escapeParameter = (0, $9QywT.isBoolean)(options.escapeParameter) ? options.escapeParameter : context.escapeParameter;
    const resolvedMessage = !!options.resolvedMessage;
    // prettier-ignore
    const defaultMsgOrKey = (0, $9QywT.isString)(options.default) || (0, $9QywT.isBoolean)(options.default) // default by function option
     ? !(0, $9QywT.isBoolean)(options.default) ? options.default : !messageCompiler ? ()=>key : key : fallbackFormat // default by `fallbackFormat` option
     ? !messageCompiler ? ()=>key : key : "";
    const enableDefaultMsg = fallbackFormat || defaultMsgOrKey !== "";
    const locale = $a739018d680a1535$export$180605366c04f0cd(context, options);
    // escape params
    escapeParameter && $a739018d680a1535$var$escapeParams(options);
    // resolve message format
    // eslint-disable-next-line prefer-const
    let [formatScope, targetLocale, message] = !resolvedMessage ? $a739018d680a1535$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) : [
        key,
        locale,
        messages[locale] || {}
    ];
    // NOTE:
    //  Fix to work around `ssrTransfrom` bug in Vite.
    //  https://github.com/vitejs/vite/issues/4306
    //  To get around this, use temporary variables.
    //  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
    let format = formatScope;
    // if you use default message, set it as message format!
    let cacheBaseKey = key;
    if (!resolvedMessage && !((0, $9QywT.isString)(format) || $a739018d680a1535$export$9ba95744594b90e0(format) || $a739018d680a1535$export$92c0a039cf358271(format))) {
        if (enableDefaultMsg) {
            format = defaultMsgOrKey;
            cacheBaseKey = format;
        }
    }
    // checking message format and target locale
    if (!resolvedMessage && (!((0, $9QywT.isString)(format) || $a739018d680a1535$export$9ba95744594b90e0(format) || $a739018d680a1535$export$92c0a039cf358271(format)) || !(0, $9QywT.isString)(targetLocale))) return unresolving ? $a739018d680a1535$export$b7f13a18d1d0f835 : key;
    // TODO: refactor
    if ((0, $9QywT.isString)(format) && context.messageCompiler == null) {
        (0, $9QywT.warn)(`The message format compilation is not supported in this build. ` + `Because message compiler isn't included. ` + `You need to pre-compilation all message format. ` + `So translate function return '${key}'.`);
        return key;
    }
    // setup compile error detecting
    let occurred = false;
    const onError = ()=>{
        occurred = true;
    };
    // compile message format
    const msg = !$a739018d680a1535$export$92c0a039cf358271(format) ? $a739018d680a1535$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) : format;
    // if occurred compile error, return the message format
    if (occurred) return format;
    // evaluate message with context
    const ctxOptions = $a739018d680a1535$var$getMessageContextOptions(context, targetLocale, message, options);
    const msgContext = $a739018d680a1535$export$70de3b14beda2f5e(ctxOptions);
    const messaged = $a739018d680a1535$var$evaluateMessage(context, msg, msgContext);
    // if use post translation option, proceed it with handler
    const ret = postTranslation ? postTranslation(messaged, key) : messaged;
    {
        // prettier-ignore
        const payloads = {
            timestamp: Date.now(),
            key: (0, $9QywT.isString)(key) ? key : $a739018d680a1535$export$92c0a039cf358271(format) ? format.key : "",
            locale: targetLocale || ($a739018d680a1535$export$92c0a039cf358271(format) ? format.locale : ""),
            format: (0, $9QywT.isString)(format) ? format : $a739018d680a1535$export$92c0a039cf358271(format) ? format.source : "",
            message: ret
        };
        payloads.meta = (0, $9QywT.assign)({}, context.__meta, $a739018d680a1535$export$817795a14e5c6622() || {});
        $a739018d680a1535$export$190d71a47ff3f767(payloads);
    }
    return ret;
}
function $a739018d680a1535$var$escapeParams(options) {
    if ((0, $9QywT.isArray)(options.list)) options.list = options.list.map((item)=>(0, $9QywT.isString)(item) ? (0, $9QywT.escapeHtml)(item) : item);
    else if ((0, $9QywT.isObject)(options.named)) Object.keys(options.named).forEach((key)=>{
        if ((0, $9QywT.isString)(options.named[key])) options.named[key] = (0, $9QywT.escapeHtml)(options.named[key]);
    });
}
function $a739018d680a1535$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
    const { messages: messages, onWarn: onWarn, messageResolver: resolveValue, localeFallbacker: localeFallbacker } = context;
    const locales = localeFallbacker(context, fallbackLocale, locale); // eslint-disable-line @typescript-eslint/no-explicit-any
    let message = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "translate";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        if (locale !== targetLocale && !$a739018d680a1535$export$59f8e8904fd79a18(locale, targetLocale) && $a739018d680a1535$export$d9435df38da77a63(fallbackWarn, key)) onWarn($a739018d680a1535$export$ae7a7631f2b2bb7($a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_TRANSLATE, {
            key: key,
            target: targetLocale
        }));
        // for vue-devtools timeline event
        if (locale !== targetLocale) {
            const emitter = context.__v_emitter;
            if (emitter) emitter.emit("fallback" /* VueDevToolsTimelineEvents.FALBACK */ , {
                type: type,
                key: key,
                from: from,
                to: to,
                groupId: `${type}:${key}`
            });
        }
        message = messages[targetLocale] || {};
        // for vue-devtools timeline event
        let start = null;
        let startTag;
        let endTag;
        if (0, $9QywT.inBrowser) {
            start = window.performance.now();
            startTag = "intlify-message-resolve-start";
            endTag = "intlify-message-resolve-end";
            (0, $9QywT.mark) && (0, $9QywT.mark)(startTag);
        }
        if ((format = resolveValue(message, key)) === null) // if null, resolve with object key path
        format = message[key]; // eslint-disable-line @typescript-eslint/no-explicit-any
        // for vue-devtools timeline event
        if (0, $9QywT.inBrowser) {
            const end = window.performance.now();
            const emitter = context.__v_emitter;
            if (emitter && start && format) emitter.emit("message-resolve" /* VueDevToolsTimelineEvents.MESSAGE_RESOLVE */ , {
                type: "message-resolve" /* VueDevToolsTimelineEvents.MESSAGE_RESOLVE */ ,
                key: key,
                message: format,
                time: end - start,
                groupId: `${type}:${key}`
            });
            if (startTag && endTag && (0, $9QywT.mark) && (0, $9QywT.measure)) {
                (0, $9QywT.mark)(endTag);
                (0, $9QywT.measure)("intlify message resolve", startTag, endTag);
            }
        }
        if ((0, $9QywT.isString)(format) || $a739018d680a1535$export$9ba95744594b90e0(format) || $a739018d680a1535$export$92c0a039cf358271(format)) break;
        if (!$a739018d680a1535$export$d783301aca6271c3(targetLocale, locales)) {
            const missingRet = $a739018d680a1535$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type);
            if (missingRet !== key) format = missingRet;
        }
        from = to;
    }
    return [
        format,
        targetLocale,
        message
    ];
}
function $a739018d680a1535$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) {
    const { messageCompiler: messageCompiler, warnHtmlMessage: warnHtmlMessage } = context;
    if ($a739018d680a1535$export$92c0a039cf358271(format)) {
        const msg = format;
        msg.locale = msg.locale || targetLocale;
        msg.key = msg.key || key;
        return msg;
    }
    if (messageCompiler == null) {
        const msg = ()=>format;
        msg.locale = targetLocale;
        msg.key = key;
        return msg;
    }
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    if (0, $9QywT.inBrowser) {
        start = window.performance.now();
        startTag = "intlify-message-compilation-start";
        endTag = "intlify-message-compilation-end";
        (0, $9QywT.mark) && (0, $9QywT.mark)(startTag);
    }
    const msg = messageCompiler(format, $a739018d680a1535$var$getCompileContext(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, onError));
    // for vue-devtools timeline event
    if (0, $9QywT.inBrowser) {
        const end = window.performance.now();
        const emitter = context.__v_emitter;
        if (emitter && start) emitter.emit("message-compilation" /* VueDevToolsTimelineEvents.MESSAGE_COMPILATION */ , {
            type: "message-compilation" /* VueDevToolsTimelineEvents.MESSAGE_COMPILATION */ ,
            message: format,
            time: end - start,
            groupId: `${"translate"}:${key}`
        });
        if (startTag && endTag && (0, $9QywT.mark) && (0, $9QywT.measure)) {
            (0, $9QywT.mark)(endTag);
            (0, $9QywT.measure)("intlify message compilation", startTag, endTag);
        }
    }
    msg.locale = targetLocale;
    msg.key = key;
    msg.source = format;
    return msg;
}
function $a739018d680a1535$var$evaluateMessage(context, msg, msgCtx) {
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    if (0, $9QywT.inBrowser) {
        start = window.performance.now();
        startTag = "intlify-message-evaluation-start";
        endTag = "intlify-message-evaluation-end";
        (0, $9QywT.mark) && (0, $9QywT.mark)(startTag);
    }
    const messaged = msg(msgCtx);
    // for vue-devtools timeline event
    if (0, $9QywT.inBrowser) {
        const end = window.performance.now();
        const emitter = context.__v_emitter;
        if (emitter && start) emitter.emit("message-evaluation" /* VueDevToolsTimelineEvents.MESSAGE_EVALUATION */ , {
            type: "message-evaluation" /* VueDevToolsTimelineEvents.MESSAGE_EVALUATION */ ,
            value: messaged,
            time: end - start,
            groupId: `${"translate"}:${msg.key}`
        });
        if (startTag && endTag && (0, $9QywT.mark) && (0, $9QywT.measure)) {
            (0, $9QywT.mark)(endTag);
            (0, $9QywT.measure)("intlify message evaluation", startTag, endTag);
        }
    }
    return messaged;
}
/** @internal */ function $a739018d680a1535$export$8d9616744e22681a(...args) {
    const [arg1, arg2, arg3] = args;
    const options = {};
    if (!(0, $9QywT.isString)(arg1) && !(0, $9QywT.isNumber)(arg1) && !$a739018d680a1535$export$92c0a039cf358271(arg1) && !$a739018d680a1535$export$9ba95744594b90e0(arg1)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    // prettier-ignore
    const key = (0, $9QywT.isNumber)(arg1) ? String(arg1) : $a739018d680a1535$export$92c0a039cf358271(arg1) ? arg1 : arg1;
    if ((0, $9QywT.isNumber)(arg2)) options.plural = arg2;
    else if ((0, $9QywT.isString)(arg2)) options.default = arg2;
    else if ((0, $9QywT.isPlainObject)(arg2) && !(0, $9QywT.isEmptyObject)(arg2)) options.named = arg2;
    else if ((0, $9QywT.isArray)(arg2)) options.list = arg2;
    if ((0, $9QywT.isNumber)(arg3)) options.plural = arg3;
    else if ((0, $9QywT.isString)(arg3)) options.default = arg3;
    else if ((0, $9QywT.isPlainObject)(arg3)) (0, $9QywT.assign)(options, arg3);
    return [
        key,
        options
    ];
}
function $a739018d680a1535$var$getCompileContext(context, locale, key, source, warnHtmlMessage, onError) {
    return {
        locale: locale,
        key: key,
        warnHtmlMessage: warnHtmlMessage,
        onError: (err)=>{
            onError && onError(err);
            {
                const _source = $a739018d680a1535$var$getSourceForCodeFrame(source);
                const message = `Message compilation error: ${err.message}`;
                const codeFrame = err.location && _source && (0, $9QywT.generateCodeFrame)(_source, err.location.start.offset, err.location.end.offset);
                const emitter = context.__v_emitter;
                if (emitter && _source) emitter.emit("compile-error" /* VueDevToolsTimelineEvents.COMPILE_ERROR */ , {
                    message: _source,
                    error: err.message,
                    start: err.location && err.location.start.offset,
                    end: err.location && err.location.end.offset,
                    groupId: `${"translate"}:${key}`
                });
                console.error(codeFrame ? `${message}\n${codeFrame}` : message);
            }
        },
        onCacheKey: (source)=>(0, $9QywT.generateFormatCacheKey)(locale, key, source)
    };
}
function $a739018d680a1535$var$getSourceForCodeFrame(source) {
    if ((0, $9QywT.isString)(source)) return source;
    else {
        if (source.loc && source.loc.source) return source.loc.source;
    }
}
function $a739018d680a1535$var$getMessageContextOptions(context, locale, message, options) {
    const { modifiers: modifiers, pluralRules: pluralRules, messageResolver: resolveValue, fallbackLocale: fallbackLocale, fallbackWarn: fallbackWarn, missingWarn: missingWarn, fallbackContext: fallbackContext } = context;
    const resolveMessage = (key)=>{
        let val = resolveValue(message, key);
        // fallback to root context
        if (val == null && fallbackContext) {
            const [, , message] = $a739018d680a1535$var$resolveMessageFormat(fallbackContext, key, locale, fallbackLocale, fallbackWarn, missingWarn);
            val = resolveValue(message, key);
        }
        if ((0, $9QywT.isString)(val) || $a739018d680a1535$export$9ba95744594b90e0(val)) {
            let occurred = false;
            const onError = ()=>{
                occurred = true;
            };
            const msg = $a739018d680a1535$var$compileMessageFormat(context, key, locale, val, key, onError);
            return !occurred ? msg : $a739018d680a1535$var$NOOP_MESSAGE_FUNCTION;
        } else if ($a739018d680a1535$export$92c0a039cf358271(val)) return val;
        else // TODO: should be implemented warning message
        return $a739018d680a1535$var$NOOP_MESSAGE_FUNCTION;
    };
    const ctxOptions = {
        locale: locale,
        modifiers: modifiers,
        pluralRules: pluralRules,
        messages: resolveMessage
    };
    if (context.processor) ctxOptions.processor = context.processor;
    if (options.list) ctxOptions.list = options.list;
    if (options.named) ctxOptions.named = options.named;
    if ((0, $9QywT.isNumber)(options.plural)) ctxOptions.pluralIndex = options.plural;
    return ctxOptions;
}
const $a739018d680a1535$var$intlDefined = typeof Intl !== "undefined";
const $a739018d680a1535$var$Availabilities = {
    dateTimeFormat: $a739018d680a1535$var$intlDefined && typeof Intl.DateTimeFormat !== "undefined",
    numberFormat: $a739018d680a1535$var$intlDefined && typeof Intl.NumberFormat !== "undefined"
};
// implementation of `datetime` function
function $a739018d680a1535$export$7ba4466dbd0f07e1(context, ...args) {
    const { datetimeFormats: datetimeFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __datetimeFormatters: __datetimeFormatters } = context;
    if (!$a739018d680a1535$var$Availabilities.dateTimeFormat) {
        onWarn($a739018d680a1535$export$ae7a7631f2b2bb7($a739018d680a1535$export$b6a676a18b27d4c8.CANNOT_FORMAT_DATE));
        return $a739018d680a1535$export$a04371e9dbb3870b;
    }
    const [key, value, options, overrides] = $a739018d680a1535$export$165524b21a0d6b5e(...args);
    const missingWarn = (0, $9QywT.isBoolean)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $9QywT.isBoolean)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = $a739018d680a1535$export$180605366c04f0cd(context, options);
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $9QywT.isString)(key) || key === "") return new Intl.DateTimeFormat(locale, overrides).format(value);
    // resolve format
    let datetimeFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "datetime format";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        if (locale !== targetLocale && $a739018d680a1535$export$d9435df38da77a63(fallbackWarn, key)) onWarn($a739018d680a1535$export$ae7a7631f2b2bb7($a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_DATE_FORMAT, {
            key: key,
            target: targetLocale
        }));
        // for vue-devtools timeline event
        if (locale !== targetLocale) {
            const emitter = context.__v_emitter;
            if (emitter) emitter.emit("fallback" /* VueDevToolsTimelineEvents.FALBACK */ , {
                type: type,
                key: key,
                from: from,
                to: to,
                groupId: `${type}:${key}`
            });
        }
        datetimeFormat = datetimeFormats[targetLocale] || {};
        format = datetimeFormat[key];
        if ((0, $9QywT.isPlainObject)(format)) break;
        $a739018d680a1535$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $9QywT.isPlainObject)(format) || !(0, $9QywT.isString)(targetLocale)) return unresolving ? $a739018d680a1535$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $9QywT.isEmptyObject)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __datetimeFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(targetLocale, (0, $9QywT.assign)({}, format, overrides));
        __datetimeFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $a739018d680a1535$export$c77049eaf05b1508 = [
    "localeMatcher",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "formatMatcher",
    "hour12",
    "timeZone",
    "dateStyle",
    "timeStyle",
    "calendar",
    "dayPeriod",
    "numberingSystem",
    "hourCycle",
    "fractionalSecondDigits"
];
/** @internal */ function $a739018d680a1535$export$165524b21a0d6b5e(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = {};
    let overrides = {};
    let value;
    if ((0, $9QywT.isString)(arg1)) {
        // Only allow ISO strings - other date formats are often supported,
        // but may cause different results in different browsers.
        const matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
        if (!matches) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        // Some browsers can not parse the iso datetime separated by space,
        // this is a compromise solution by replace the 'T'/' ' with 'T'
        const dateTime = matches[3] ? matches[3].trim().startsWith("T") ? `${matches[1].trim()}${matches[3].trim()}` : `${matches[1].trim()}T${matches[3].trim()}` : matches[1].trim();
        value = new Date(dateTime);
        try {
            // This will fail if the date is not valid
            value.toISOString();
        } catch (e) {
            throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        }
    } else if ((0, $9QywT.isDate)(arg1)) {
        if (isNaN(arg1.getTime())) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT);
        value = arg1;
    } else if ((0, $9QywT.isNumber)(arg1)) value = arg1;
    else throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    if ((0, $9QywT.isString)(arg2)) options.key = arg2;
    else if ((0, $9QywT.isPlainObject)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($a739018d680a1535$export$c77049eaf05b1508.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $9QywT.isString)(arg3)) options.locale = arg3;
    else if ((0, $9QywT.isPlainObject)(arg3)) overrides = arg3;
    if ((0, $9QywT.isPlainObject)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $a739018d680a1535$export$5bc4fc7cf15d6ccd(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__datetimeFormatters.has(id)) continue;
        context.__datetimeFormatters.delete(id);
    }
}
// implementation of `number` function
function $a739018d680a1535$export$98e628dec113755e(context, ...args) {
    const { numberFormats: numberFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __numberFormatters: __numberFormatters } = context;
    if (!$a739018d680a1535$var$Availabilities.numberFormat) {
        onWarn($a739018d680a1535$export$ae7a7631f2b2bb7($a739018d680a1535$export$b6a676a18b27d4c8.CANNOT_FORMAT_NUMBER));
        return $a739018d680a1535$export$a04371e9dbb3870b;
    }
    const [key, value, options, overrides] = $a739018d680a1535$export$d0e2eec8b686cf72(...args);
    const missingWarn = (0, $9QywT.isBoolean)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $9QywT.isBoolean)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = $a739018d680a1535$export$180605366c04f0cd(context, options);
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $9QywT.isString)(key) || key === "") return new Intl.NumberFormat(locale, overrides).format(value);
    // resolve format
    let numberFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "number format";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        if (locale !== targetLocale && $a739018d680a1535$export$d9435df38da77a63(fallbackWarn, key)) onWarn($a739018d680a1535$export$ae7a7631f2b2bb7($a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_NUMBER_FORMAT, {
            key: key,
            target: targetLocale
        }));
        // for vue-devtools timeline event
        if (locale !== targetLocale) {
            const emitter = context.__v_emitter;
            if (emitter) emitter.emit("fallback" /* VueDevToolsTimelineEvents.FALBACK */ , {
                type: type,
                key: key,
                from: from,
                to: to,
                groupId: `${type}:${key}`
            });
        }
        numberFormat = numberFormats[targetLocale] || {};
        format = numberFormat[key];
        if ((0, $9QywT.isPlainObject)(format)) break;
        $a739018d680a1535$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $9QywT.isPlainObject)(format) || !(0, $9QywT.isString)(targetLocale)) return unresolving ? $a739018d680a1535$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $9QywT.isEmptyObject)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __numberFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.NumberFormat(targetLocale, (0, $9QywT.assign)({}, format, overrides));
        __numberFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $a739018d680a1535$export$c39a7c3789c46ed6 = [
    "localeMatcher",
    "style",
    "currency",
    "currencyDisplay",
    "currencySign",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    "compactDisplay",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "roundingMode",
    "roundingPriority",
    "roundingIncrement",
    "trailingZeroDisplay"
];
/** @internal */ function $a739018d680a1535$export$d0e2eec8b686cf72(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = {};
    let overrides = {};
    if (!(0, $9QywT.isNumber)(arg1)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    const value = arg1;
    if ((0, $9QywT.isString)(arg2)) options.key = arg2;
    else if ((0, $9QywT.isPlainObject)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($a739018d680a1535$export$c39a7c3789c46ed6.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $9QywT.isString)(arg3)) options.locale = arg3;
    else if ((0, $9QywT.isPlainObject)(arg3)) overrides = arg3;
    if ((0, $9QywT.isPlainObject)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $a739018d680a1535$export$6a8717b3043a4f23(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__numberFormatters.has(id)) continue;
        context.__numberFormatters.delete(id);
    }
}
$a739018d680a1535$var$initFeatureFlags();

});
parcelRegister("7yiTB", function(module, exports) {

$parcel$export(module.exports, "CompileWarnCodes", () => $b46efaa99568cb1e$export$21499b937901db8a);
$parcel$export(module.exports, "CompileErrorCodes", () => $b46efaa99568cb1e$export$77436aae039469c4);
$parcel$export(module.exports, "createCompileError", () => $b46efaa99568cb1e$export$21efa8bb37d5fecb);
$parcel$export(module.exports, "defaultOnError", () => $b46efaa99568cb1e$export$ad0eb2c702f03471);
$parcel$export(module.exports, "detectHtmlTag", () => $b46efaa99568cb1e$export$6de85467cbd6ae39);
$parcel$export(module.exports, "baseCompile", () => $b46efaa99568cb1e$export$3243579822c486a0);
/*!
  * message-compiler v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $9QywT = parcelRequire("9QywT");
const $b46efaa99568cb1e$export$7119efed969a17d8 = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    }
};
function $b46efaa99568cb1e$export$edb4795983846c10(line, column, offset) {
    return {
        line: line,
        column: column,
        offset: offset
    };
}
function $b46efaa99568cb1e$export$90c043f1c57770b8(start, end, source) {
    const loc = {
        start: start,
        end: end
    };
    if (source != null) loc.source = source;
    return loc;
}
const $b46efaa99568cb1e$export$21499b937901db8a = {
    USE_MODULO_SYNTAX: 1,
    __EXTEND_POINT__: 2
};
/** @internal */ const $b46efaa99568cb1e$export$a9ce0120dbc716f9 = {
    [$b46efaa99568cb1e$export$21499b937901db8a.USE_MODULO_SYNTAX]: `Use modulo before '{{0}}'.`
};
function $b46efaa99568cb1e$export$b5ca1ea40a366b08(code, loc, ...args) {
    const msg = (0, $9QywT.format)($b46efaa99568cb1e$export$a9ce0120dbc716f9[code] || "", ...args || []);
    const message = {
        message: String(msg),
        code: code
    };
    if (loc) message.location = loc;
    return message;
}
const $b46efaa99568cb1e$export$77436aae039469c4 = {
    // tokenizer error codes
    EXPECTED_TOKEN: 1,
    INVALID_TOKEN_IN_PLACEHOLDER: 2,
    UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
    UNKNOWN_ESCAPE_SEQUENCE: 4,
    INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
    UNBALANCED_CLOSING_BRACE: 6,
    UNTERMINATED_CLOSING_BRACE: 7,
    EMPTY_PLACEHOLDER: 8,
    NOT_ALLOW_NEST_PLACEHOLDER: 9,
    INVALID_LINKED_FORMAT: 10,
    // parser error codes
    MUST_HAVE_MESSAGES_IN_PLURAL: 11,
    UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
    UNEXPECTED_EMPTY_LINKED_KEY: 13,
    UNEXPECTED_LEXICAL_ANALYSIS: 14,
    // generator error codes
    UNHANDLED_CODEGEN_NODE_TYPE: 15,
    // minifier error codes
    UNHANDLED_MINIFIER_NODE_TYPE: 16,
    // Special value for higher-order compilers to pick up the last code
    // to avoid collision of error codes. This should always be kept as the last
    // item.
    __EXTEND_POINT__: 17
};
/** @internal */ const $b46efaa99568cb1e$export$d8bd0967cb58683 = {
    // tokenizer error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.EXPECTED_TOKEN]: `Expected token: '{0}'`,
    [$b46efaa99568cb1e$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER]: `Invalid token in placeholder: '{0}'`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: `Unterminated single quote in placeholder`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE]: `Unknown escape sequence: \\{0}`,
    [$b46efaa99568cb1e$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE]: `Invalid unicode escape sequence: {0}`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE]: `Unbalanced closing brace`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE]: `Unterminated closing brace`,
    [$b46efaa99568cb1e$export$77436aae039469c4.EMPTY_PLACEHOLDER]: `Empty placeholder`,
    [$b46efaa99568cb1e$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER]: `Not allowed nest placeholder`,
    [$b46efaa99568cb1e$export$77436aae039469c4.INVALID_LINKED_FORMAT]: `Invalid linked format`,
    // parser error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL]: `Plural must have messages`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER]: `Unexpected empty linked modifier`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY]: `Unexpected empty linked key`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS]: `Unexpected lexical analysis in token: '{0}'`,
    // generator error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.UNHANDLED_CODEGEN_NODE_TYPE]: `unhandled codegen node type: '{0}'`,
    // minimizer error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.UNHANDLED_MINIFIER_NODE_TYPE]: `unhandled mimifier node type: '{0}'`
};
function $b46efaa99568cb1e$export$21efa8bb37d5fecb(code, loc, options = {}) {
    const { domain: domain, messages: messages, args: args } = options;
    const msg = (0, $9QywT.format)((messages || $b46efaa99568cb1e$export$d8bd0967cb58683)[code] || "", ...args || []);
    const error = new SyntaxError(String(msg));
    error.code = code;
    if (loc) error.location = loc;
    error.domain = domain;
    return error;
}
/** @internal */ function $b46efaa99568cb1e$export$ad0eb2c702f03471(error) {
    throw error;
}
// eslint-disable-next-line no-useless-escape
const $b46efaa99568cb1e$var$RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/;
const $b46efaa99568cb1e$export$6de85467cbd6ae39 = (source)=>$b46efaa99568cb1e$var$RE_HTML_TAG.test(source);
const $b46efaa99568cb1e$var$CHAR_SP = " ";
const $b46efaa99568cb1e$var$CHAR_CR = "\r";
const $b46efaa99568cb1e$var$CHAR_LF = "\n";
const $b46efaa99568cb1e$var$CHAR_LS = String.fromCharCode(0x2028);
const $b46efaa99568cb1e$var$CHAR_PS = String.fromCharCode(0x2029);
function $b46efaa99568cb1e$var$createScanner(str) {
    const _buf = str;
    let _index = 0;
    let _line = 1;
    let _column = 1;
    let _peekOffset = 0;
    const isCRLF = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_CR && _buf[index + 1] === $b46efaa99568cb1e$var$CHAR_LF;
    const isLF = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_LF;
    const isPS = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_PS;
    const isLS = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_LS;
    const isLineEnd = (index)=>isCRLF(index) || isLF(index) || isPS(index) || isLS(index);
    const index = ()=>_index;
    const line = ()=>_line;
    const column = ()=>_column;
    const peekOffset = ()=>_peekOffset;
    const charAt = (offset)=>isCRLF(offset) || isPS(offset) || isLS(offset) ? $b46efaa99568cb1e$var$CHAR_LF : _buf[offset];
    const currentChar = ()=>charAt(_index);
    const currentPeek = ()=>charAt(_index + _peekOffset);
    function next() {
        _peekOffset = 0;
        if (isLineEnd(_index)) {
            _line++;
            _column = 0;
        }
        if (isCRLF(_index)) _index++;
        _index++;
        _column++;
        return _buf[_index];
    }
    function peek() {
        if (isCRLF(_index + _peekOffset)) _peekOffset++;
        _peekOffset++;
        return _buf[_index + _peekOffset];
    }
    function reset() {
        _index = 0;
        _line = 1;
        _column = 1;
        _peekOffset = 0;
    }
    function resetPeek(offset = 0) {
        _peekOffset = offset;
    }
    function skipToPeek() {
        const target = _index + _peekOffset;
        // eslint-disable-next-line no-unmodified-loop-condition
        while(target !== _index)next();
        _peekOffset = 0;
    }
    return {
        index: index,
        line: line,
        column: column,
        peekOffset: peekOffset,
        charAt: charAt,
        currentChar: currentChar,
        currentPeek: currentPeek,
        next: next,
        peek: peek,
        reset: reset,
        resetPeek: resetPeek,
        skipToPeek: skipToPeek
    };
}
const $b46efaa99568cb1e$var$EOF = undefined;
const $b46efaa99568cb1e$var$DOT = ".";
const $b46efaa99568cb1e$var$LITERAL_DELIMITER = "'";
const $b46efaa99568cb1e$var$ERROR_DOMAIN$3 = "tokenizer";
function $b46efaa99568cb1e$var$createTokenizer(source, options = {}) {
    const location = options.location !== false;
    const _scnr = $b46efaa99568cb1e$var$createScanner(source);
    const currentOffset = ()=>_scnr.index();
    const currentPosition = ()=>$b46efaa99568cb1e$export$edb4795983846c10(_scnr.line(), _scnr.column(), _scnr.index());
    const _initLoc = currentPosition();
    const _initOffset = currentOffset();
    const _context = {
        currentType: 14 /* TokenTypes.EOF */ ,
        offset: _initOffset,
        startLoc: _initLoc,
        endLoc: _initLoc,
        lastType: 14 /* TokenTypes.EOF */ ,
        lastOffset: _initOffset,
        lastStartLoc: _initLoc,
        lastEndLoc: _initLoc,
        braceNest: 0,
        inLinked: false,
        text: ""
    };
    const context = ()=>_context;
    const { onError: onError } = options;
    function emitError(code, pos, offset, ...args) {
        const ctx = context();
        pos.column += offset;
        pos.offset += offset;
        if (onError) {
            const loc = location ? $b46efaa99568cb1e$export$90c043f1c57770b8(ctx.startLoc, pos) : null;
            const err = $b46efaa99568cb1e$export$21efa8bb37d5fecb(code, loc, {
                domain: $b46efaa99568cb1e$var$ERROR_DOMAIN$3,
                args: args
            });
            onError(err);
        }
    }
    function getToken(context, type, value) {
        context.endLoc = currentPosition();
        context.currentType = type;
        const token = {
            type: type
        };
        if (location) token.loc = $b46efaa99568cb1e$export$90c043f1c57770b8(context.startLoc, context.endLoc);
        if (value != null) token.value = value;
        return token;
    }
    const getEndToken = (context)=>getToken(context, 14 /* TokenTypes.EOF */ );
    function eat(scnr, ch) {
        if (scnr.currentChar() === ch) {
            scnr.next();
            return ch;
        } else {
            emitError($b46efaa99568cb1e$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
            return "";
        }
    }
    function peekSpaces(scnr) {
        let buf = "";
        while(scnr.currentPeek() === $b46efaa99568cb1e$var$CHAR_SP || scnr.currentPeek() === $b46efaa99568cb1e$var$CHAR_LF){
            buf += scnr.currentPeek();
            scnr.peek();
        }
        return buf;
    }
    function skipSpaces(scnr) {
        const buf = peekSpaces(scnr);
        scnr.skipToPeek();
        return buf;
    }
    function isIdentifierStart(ch) {
        if (ch === $b46efaa99568cb1e$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc === 95 // _
        ;
    }
    function isNumberStart(ch) {
        if (ch === $b46efaa99568cb1e$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function isNamedIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isListIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ch = scnr.currentPeek() === "-" ? scnr.peek() : scnr.currentPeek();
        const ret = isNumberStart(ch);
        scnr.resetPeek();
        return ret;
    }
    function isLiteralStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === $b46efaa99568cb1e$var$LITERAL_DELIMITER;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDotStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 8 /* TokenTypes.LinkedAlias */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "." /* TokenChars.LinkedDot */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedModifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 9 /* TokenTypes.LinkedDot */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDelimiterStart(scnr, context) {
        const { currentType: currentType } = context;
        if (!(currentType === 8 /* TokenTypes.LinkedAlias */  || currentType === 12 /* TokenTypes.LinkedModifier */ )) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === ":" /* TokenChars.LinkedDelimiter */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedReferStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 10 /* TokenTypes.LinkedDelimiter */ ) return false;
        const fn = ()=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */ ) return isIdentifierStart(scnr.peek());
            else if (ch === "@" /* TokenChars.LinkedAlias */  || ch === "%" /* TokenChars.Modulo */  || ch === "|" /* TokenChars.Pipe */  || ch === ":" /* TokenChars.LinkedDelimiter */  || ch === "." /* TokenChars.LinkedDot */  || ch === $b46efaa99568cb1e$var$CHAR_SP || !ch) return false;
            else if (ch === $b46efaa99568cb1e$var$CHAR_LF) {
                scnr.peek();
                return fn();
            } else // other characters
            return isTextStart(scnr, false);
        };
        const ret = fn();
        scnr.resetPeek();
        return ret;
    }
    function isPluralStart(scnr) {
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "|" /* TokenChars.Pipe */ ;
        scnr.resetPeek();
        return ret;
    }
    function detectModuloStart(scnr) {
        const spaces = peekSpaces(scnr);
        const ret = scnr.currentPeek() === "%" /* TokenChars.Modulo */  && scnr.peek() === "{" /* TokenChars.BraceLeft */ ;
        scnr.resetPeek();
        return {
            isModulo: ret,
            hasSpace: spaces.length > 0
        };
    }
    function isTextStart(scnr, reset = true) {
        const fn = (hasSpace = false, prev = "", detectModulo = false)=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */ ) return prev === "%" /* TokenChars.Modulo */  ? false : hasSpace;
            else if (ch === "@" /* TokenChars.LinkedAlias */  || !ch) return prev === "%" /* TokenChars.Modulo */  ? true : hasSpace;
            else if (ch === "%" /* TokenChars.Modulo */ ) {
                scnr.peek();
                return fn(hasSpace, "%" /* TokenChars.Modulo */ , true);
            } else if (ch === "|" /* TokenChars.Pipe */ ) return prev === "%" /* TokenChars.Modulo */  || detectModulo ? true : !(prev === $b46efaa99568cb1e$var$CHAR_SP || prev === $b46efaa99568cb1e$var$CHAR_LF);
            else if (ch === $b46efaa99568cb1e$var$CHAR_SP) {
                scnr.peek();
                return fn(true, $b46efaa99568cb1e$var$CHAR_SP, detectModulo);
            } else if (ch === $b46efaa99568cb1e$var$CHAR_LF) {
                scnr.peek();
                return fn(true, $b46efaa99568cb1e$var$CHAR_LF, detectModulo);
            } else return true;
        };
        const ret = fn();
        reset && scnr.resetPeek();
        return ret;
    }
    function takeChar(scnr, fn) {
        const ch = scnr.currentChar();
        if (ch === $b46efaa99568cb1e$var$EOF) return $b46efaa99568cb1e$var$EOF;
        if (fn(ch)) {
            scnr.next();
            return ch;
        }
        return null;
    }
    function isIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc >= 48 && cc <= 57 || // 0-9
        cc === 95 || // _
        cc === 36 // $
        ;
    }
    function takeIdentifierChar(scnr) {
        return takeChar(scnr, isIdentifier);
    }
    function isNamedIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc >= 48 && cc <= 57 || // 0-9
        cc === 95 || // _
        cc === 36 || // $
        cc === 45 // -
        ;
    }
    function takeNamedIdentifierChar(scnr) {
        return takeChar(scnr, isNamedIdentifier);
    }
    function isDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function takeDigit(scnr) {
        return takeChar(scnr, isDigit);
    }
    function isHexDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57 || // 0-9
        cc >= 65 && cc <= 70 || // A-F
        cc >= 97 && cc <= 102; // a-f
    }
    function takeHexDigit(scnr) {
        return takeChar(scnr, isHexDigit);
    }
    function getDigits(scnr) {
        let ch = "";
        let num = "";
        while(ch = takeDigit(scnr))num += ch;
        return num;
    }
    function readModulo(scnr) {
        skipSpaces(scnr);
        const ch = scnr.currentChar();
        if (ch !== "%" /* TokenChars.Modulo */ ) emitError($b46efaa99568cb1e$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
        scnr.next();
        return "%" /* TokenChars.Modulo */ ;
    }
    function readText(scnr) {
        let buf = "";
        // eslint-disable-next-line no-constant-condition
        while(true){
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */  || ch === "}" /* TokenChars.BraceRight */  || ch === "@" /* TokenChars.LinkedAlias */  || ch === "|" /* TokenChars.Pipe */  || !ch) break;
            else if (ch === "%" /* TokenChars.Modulo */ ) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else break;
            } else if (ch === $b46efaa99568cb1e$var$CHAR_SP || ch === $b46efaa99568cb1e$var$CHAR_LF) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else if (isPluralStart(scnr)) break;
                else {
                    buf += ch;
                    scnr.next();
                }
            } else {
                buf += ch;
                scnr.next();
            }
        }
        return buf;
    }
    function readNamedIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = "";
        let name = "";
        while(ch = takeNamedIdentifierChar(scnr))name += ch;
        if (scnr.currentChar() === $b46efaa99568cb1e$var$EOF) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return name;
    }
    function readListIdentifier(scnr) {
        skipSpaces(scnr);
        let value = "";
        if (scnr.currentChar() === "-") {
            scnr.next();
            value += `-${getDigits(scnr)}`;
        } else value += getDigits(scnr);
        if (scnr.currentChar() === $b46efaa99568cb1e$var$EOF) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return value;
    }
    function isLiteral(ch) {
        return ch !== $b46efaa99568cb1e$var$LITERAL_DELIMITER && ch !== $b46efaa99568cb1e$var$CHAR_LF;
    }
    function readLiteral(scnr) {
        skipSpaces(scnr);
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        let ch = "";
        let literal = "";
        while(ch = takeChar(scnr, isLiteral))if (ch === "\\") literal += readEscapeSequence(scnr);
        else literal += ch;
        const current = scnr.currentChar();
        if (current === $b46efaa99568cb1e$var$CHAR_LF || current === $b46efaa99568cb1e$var$EOF) {
            emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
            // TODO: Is it correct really?
            if (current === $b46efaa99568cb1e$var$CHAR_LF) {
                scnr.next();
                // eslint-disable-next-line no-useless-escape
                eat(scnr, `\'`);
            }
            return literal;
        }
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        return literal;
    }
    function readEscapeSequence(scnr) {
        const ch = scnr.currentChar();
        switch(ch){
            case "\\":
            case `\'`:
                scnr.next();
                return `\\${ch}`;
            case "u":
                return readUnicodeEscapeSequence(scnr, ch, 4);
            case "U":
                return readUnicodeEscapeSequence(scnr, ch, 6);
            default:
                emitError($b46efaa99568cb1e$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
                return "";
        }
    }
    function readUnicodeEscapeSequence(scnr, unicode, digits) {
        eat(scnr, unicode);
        let sequence = "";
        for(let i = 0; i < digits; i++){
            const ch = takeHexDigit(scnr);
            if (!ch) {
                emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
                break;
            }
            sequence += ch;
        }
        return `\\${unicode}${sequence}`;
    }
    function isInvalidIdentifier(ch) {
        return ch !== "{" /* TokenChars.BraceLeft */  && ch !== "}" /* TokenChars.BraceRight */  && ch !== $b46efaa99568cb1e$var$CHAR_SP && ch !== $b46efaa99568cb1e$var$CHAR_LF;
    }
    function readInvalidIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = "";
        let identifiers = "";
        while(ch = takeChar(scnr, isInvalidIdentifier))identifiers += ch;
        return identifiers;
    }
    function readLinkedModifier(scnr) {
        let ch = "";
        let name = "";
        while(ch = takeIdentifierChar(scnr))name += ch;
        return name;
    }
    function readLinkedRefer(scnr) {
        const fn = (buf)=>{
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */  || ch === "%" /* TokenChars.Modulo */  || ch === "@" /* TokenChars.LinkedAlias */  || ch === "|" /* TokenChars.Pipe */  || ch === "(" /* TokenChars.ParenLeft */  || ch === ")" /* TokenChars.ParenRight */  || !ch) return buf;
            else if (ch === $b46efaa99568cb1e$var$CHAR_SP) return buf;
            else if (ch === $b46efaa99568cb1e$var$CHAR_LF || ch === $b46efaa99568cb1e$var$DOT) {
                buf += ch;
                scnr.next();
                return fn(buf);
            } else {
                buf += ch;
                scnr.next();
                return fn(buf);
            }
        };
        return fn("");
    }
    function readPlural(scnr) {
        skipSpaces(scnr);
        const plural = eat(scnr, "|" /* TokenChars.Pipe */ );
        skipSpaces(scnr);
        return plural;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInPlaceholder(scnr, context) {
        let token = null;
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* TokenChars.BraceLeft */ :
                if (context.braceNest >= 1) emitError($b46efaa99568cb1e$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 2 /* TokenTypes.BraceLeft */ , "{" /* TokenChars.BraceLeft */ );
                skipSpaces(scnr);
                context.braceNest++;
                return token;
            case "}" /* TokenChars.BraceRight */ :
                if (context.braceNest > 0 && context.currentType === 2 /* TokenTypes.BraceLeft */ ) emitError($b46efaa99568cb1e$export$77436aae039469c4.EMPTY_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 3 /* TokenTypes.BraceRight */ , "}" /* TokenChars.BraceRight */ );
                context.braceNest--;
                context.braceNest > 0 && skipSpaces(scnr);
                if (context.inLinked && context.braceNest === 0) context.inLinked = false;
                return token;
            case "@" /* TokenChars.LinkedAlias */ :
                if (context.braceNest > 0) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                token = readTokenInLinked(scnr, context) || getEndToken(context);
                context.braceNest = 0;
                return token;
            default:
                {
                    let validNamedIdentifier = true;
                    let validListIdentifier = true;
                    let validLiteral = true;
                    if (isPluralStart(scnr)) {
                        if (context.braceNest > 0) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                        token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                        // reset
                        context.braceNest = 0;
                        context.inLinked = false;
                        return token;
                    }
                    if (context.braceNest > 0 && (context.currentType === 5 /* TokenTypes.Named */  || context.currentType === 6 /* TokenTypes.List */  || context.currentType === 7 /* TokenTypes.Literal */ )) {
                        emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                        context.braceNest = 0;
                        return readToken(scnr, context);
                    }
                    if (validNamedIdentifier = isNamedIdentifierStart(scnr, context)) {
                        token = getToken(context, 5 /* TokenTypes.Named */ , readNamedIdentifier(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (validListIdentifier = isListIdentifierStart(scnr, context)) {
                        token = getToken(context, 6 /* TokenTypes.List */ , readListIdentifier(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (validLiteral = isLiteralStart(scnr, context)) {
                        token = getToken(context, 7 /* TokenTypes.Literal */ , readLiteral(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
                        // TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
                        token = getToken(context, 13 /* TokenTypes.InvalidPlace */ , readInvalidIdentifier(scnr));
                        emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
                        skipSpaces(scnr);
                        return token;
                    }
                    break;
                }
        }
        return token;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInLinked(scnr, context) {
        const { currentType: currentType } = context;
        let token = null;
        const ch = scnr.currentChar();
        if ((currentType === 8 /* TokenTypes.LinkedAlias */  || currentType === 9 /* TokenTypes.LinkedDot */  || currentType === 12 /* TokenTypes.LinkedModifier */  || currentType === 10 /* TokenTypes.LinkedDelimiter */ ) && (ch === $b46efaa99568cb1e$var$CHAR_LF || ch === $b46efaa99568cb1e$var$CHAR_SP)) emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
        switch(ch){
            case "@" /* TokenChars.LinkedAlias */ :
                scnr.next();
                token = getToken(context, 8 /* TokenTypes.LinkedAlias */ , "@" /* TokenChars.LinkedAlias */ );
                context.inLinked = true;
                return token;
            case "." /* TokenChars.LinkedDot */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 9 /* TokenTypes.LinkedDot */ , "." /* TokenChars.LinkedDot */ );
            case ":" /* TokenChars.LinkedDelimiter */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 10 /* TokenTypes.LinkedDelimiter */ , ":" /* TokenChars.LinkedDelimiter */ );
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isLinkedDotStart(scnr, context) || isLinkedDelimiterStart(scnr, context)) {
                    skipSpaces(scnr);
                    return readTokenInLinked(scnr, context);
                }
                if (isLinkedModifierStart(scnr, context)) {
                    skipSpaces(scnr);
                    return getToken(context, 12 /* TokenTypes.LinkedModifier */ , readLinkedModifier(scnr));
                }
                if (isLinkedReferStart(scnr, context)) {
                    skipSpaces(scnr);
                    if (ch === "{" /* TokenChars.BraceLeft */ ) // scan the placeholder
                    return readTokenInPlaceholder(scnr, context) || token;
                    else return getToken(context, 11 /* TokenTypes.LinkedKey */ , readLinkedRefer(scnr));
                }
                if (currentType === 8 /* TokenTypes.LinkedAlias */ ) emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
                context.braceNest = 0;
                context.inLinked = false;
                return readToken(scnr, context);
        }
    }
    // TODO: We need refactoring of token parsing ...
    function readToken(scnr, context) {
        let token = {
            type: 14 /* TokenTypes.EOF */ 
        };
        if (context.braceNest > 0) return readTokenInPlaceholder(scnr, context) || getEndToken(context);
        if (context.inLinked) return readTokenInLinked(scnr, context) || getEndToken(context);
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* TokenChars.BraceLeft */ :
                return readTokenInPlaceholder(scnr, context) || getEndToken(context);
            case "}" /* TokenChars.BraceRight */ :
                emitError($b46efaa99568cb1e$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
                scnr.next();
                return getToken(context, 3 /* TokenTypes.BraceRight */ , "}" /* TokenChars.BraceRight */ );
            case "@" /* TokenChars.LinkedAlias */ :
                return readTokenInLinked(scnr, context) || getEndToken(context);
            default:
                {
                    if (isPluralStart(scnr)) {
                        token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                        // reset
                        context.braceNest = 0;
                        context.inLinked = false;
                        return token;
                    }
                    const { isModulo: isModulo, hasSpace: hasSpace } = detectModuloStart(scnr);
                    if (isModulo) return hasSpace ? getToken(context, 0 /* TokenTypes.Text */ , readText(scnr)) : getToken(context, 4 /* TokenTypes.Modulo */ , readModulo(scnr));
                    if (isTextStart(scnr)) return getToken(context, 0 /* TokenTypes.Text */ , readText(scnr));
                    break;
                }
        }
        return token;
    }
    function nextToken() {
        const { currentType: currentType, offset: offset, startLoc: startLoc, endLoc: endLoc } = _context;
        _context.lastType = currentType;
        _context.lastOffset = offset;
        _context.lastStartLoc = startLoc;
        _context.lastEndLoc = endLoc;
        _context.offset = currentOffset();
        _context.startLoc = currentPosition();
        if (_scnr.currentChar() === $b46efaa99568cb1e$var$EOF) return getToken(_context, 14 /* TokenTypes.EOF */ );
        return readToken(_scnr, _context);
    }
    return {
        nextToken: nextToken,
        currentOffset: currentOffset,
        currentPosition: currentPosition,
        context: context
    };
}
const $b46efaa99568cb1e$export$9838302824baa7fa = "parser";
// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
const $b46efaa99568cb1e$var$KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function $b46efaa99568cb1e$var$fromEscapeSequence(match, codePoint4, codePoint6) {
    switch(match){
        case `\\\\`:
            return `\\`;
        // eslint-disable-next-line no-useless-escape
        case `\\\'`:
            // eslint-disable-next-line no-useless-escape
            return `\'`;
        default:
            {
                const codePoint = parseInt(codePoint4 || codePoint6, 16);
                if (codePoint <= 0xd7ff || codePoint >= 0xe000) return String.fromCodePoint(codePoint);
                // invalid ...
                // Replace them with U+FFFD REPLACEMENT CHARACTER.
                return "\uFFFD";
            }
    }
}
function $b46efaa99568cb1e$export$88a1156fad04455f(options = {}) {
    const location = options.location !== false;
    const { onError: onError, onWarn: onWarn } = options;
    function emitError(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onError) {
            const loc = location ? $b46efaa99568cb1e$export$90c043f1c57770b8(start, end) : null;
            const err = $b46efaa99568cb1e$export$21efa8bb37d5fecb(code, loc, {
                domain: $b46efaa99568cb1e$export$9838302824baa7fa,
                args: args
            });
            onError(err);
        }
    }
    function emitWarn(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onWarn) {
            const loc = location ? $b46efaa99568cb1e$export$90c043f1c57770b8(start, end) : null;
            onWarn($b46efaa99568cb1e$export$b5ca1ea40a366b08(code, loc, args));
        }
    }
    function startNode(type, offset, loc) {
        const node = {
            type: type
        };
        if (location) {
            node.start = offset;
            node.end = offset;
            node.loc = {
                start: loc,
                end: loc
            };
        }
        return node;
    }
    function endNode(node, offset, pos, type) {
        if (type) node.type = type;
        if (location) {
            node.end = offset;
            if (node.loc) node.loc.end = pos;
        }
    }
    function parseText(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(3 /* NodeTypes.Text */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseList(tokenizer, index) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(5 /* NodeTypes.List */ , offset, loc);
        node.index = parseInt(index, 10);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseNamed(tokenizer, key, modulo) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(4 /* NodeTypes.Named */ , offset, loc);
        node.key = key;
        if (modulo === true) node.modulo = true;
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLiteral(tokenizer, value) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(9 /* NodeTypes.Literal */ , offset, loc);
        node.value = value.replace($b46efaa99568cb1e$var$KNOWN_ESCAPES, $b46efaa99568cb1e$var$fromEscapeSequence);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinkedModifier(tokenizer) {
        const token = tokenizer.nextToken();
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get linked dot loc
        const node = startNode(8 /* NodeTypes.LinkedModifier */ , offset, loc);
        if (token.type !== 12 /* TokenTypes.LinkedModifier */ ) {
            // empty modifier
            emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
            node.value = "";
            endNode(node, offset, loc);
            return {
                nextConsumeToken: token,
                node: node
            };
        }
        // check token
        if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
        node.value = token.value || "";
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: node
        };
    }
    function parseLinkedKey(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(7 /* NodeTypes.LinkedKey */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinked(tokenizer) {
        const context = tokenizer.context();
        const linkedNode = startNode(6 /* NodeTypes.Linked */ , context.offset, context.startLoc);
        let token = tokenizer.nextToken();
        if (token.type === 9 /* TokenTypes.LinkedDot */ ) {
            const parsed = parseLinkedModifier(tokenizer);
            linkedNode.modifier = parsed.node;
            token = parsed.nextConsumeToken || tokenizer.nextToken();
        }
        // asset check token
        if (token.type !== 10 /* TokenTypes.LinkedDelimiter */ ) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
        token = tokenizer.nextToken();
        // skip brace left
        if (token.type === 2 /* TokenTypes.BraceLeft */ ) token = tokenizer.nextToken();
        switch(token.type){
            case 11 /* TokenTypes.LinkedKey */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseLinkedKey(tokenizer, token.value || "");
                break;
            case 5 /* TokenTypes.Named */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseNamed(tokenizer, token.value || "");
                break;
            case 6 /* TokenTypes.List */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseList(tokenizer, token.value || "");
                break;
            case 7 /* TokenTypes.Literal */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseLiteral(tokenizer, token.value || "");
                break;
            default:
                {
                    // empty key
                    emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
                    const nextContext = tokenizer.context();
                    const emptyLinkedKeyNode = startNode(7 /* NodeTypes.LinkedKey */ , nextContext.offset, nextContext.startLoc);
                    emptyLinkedKeyNode.value = "";
                    endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
                    linkedNode.key = emptyLinkedKeyNode;
                    endNode(linkedNode, nextContext.offset, nextContext.startLoc);
                    return {
                        nextConsumeToken: token,
                        node: linkedNode
                    };
                }
        }
        endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: linkedNode
        };
    }
    function parseMessage(tokenizer) {
        const context = tokenizer.context();
        const startOffset = context.currentType === 1 /* TokenTypes.Pipe */  ? tokenizer.currentOffset() : context.offset;
        const startLoc = context.currentType === 1 /* TokenTypes.Pipe */  ? context.endLoc : context.startLoc;
        const node = startNode(2 /* NodeTypes.Message */ , startOffset, startLoc);
        node.items = [];
        let nextToken = null;
        let modulo = null;
        do {
            const token = nextToken || tokenizer.nextToken();
            nextToken = null;
            switch(token.type){
                case 0 /* TokenTypes.Text */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseText(tokenizer, token.value || ""));
                    break;
                case 6 /* TokenTypes.List */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseList(tokenizer, token.value || ""));
                    break;
                case 4 /* TokenTypes.Modulo */ :
                    modulo = true;
                    break;
                case 5 /* TokenTypes.Named */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseNamed(tokenizer, token.value || "", !!modulo));
                    if (modulo) {
                        emitWarn(tokenizer, $b46efaa99568cb1e$export$21499b937901db8a.USE_MODULO_SYNTAX, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                        modulo = null;
                    }
                    break;
                case 7 /* TokenTypes.Literal */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseLiteral(tokenizer, token.value || ""));
                    break;
                case 8 /* TokenTypes.LinkedAlias */ :
                    {
                        const parsed = parseLinked(tokenizer);
                        node.items.push(parsed.node);
                        nextToken = parsed.nextConsumeToken || null;
                        break;
                    }
            }
        }while (context.currentType !== 14 /* TokenTypes.EOF */  && context.currentType !== 1 /* TokenTypes.Pipe */ );
        // adjust message node loc
        const endOffset = context.currentType === 1 /* TokenTypes.Pipe */  ? context.lastOffset : tokenizer.currentOffset();
        const endLoc = context.currentType === 1 /* TokenTypes.Pipe */  ? context.lastEndLoc : tokenizer.currentPosition();
        endNode(node, endOffset, endLoc);
        return node;
    }
    function parsePlural(tokenizer, offset, loc, msgNode) {
        const context = tokenizer.context();
        let hasEmptyMessage = msgNode.items.length === 0;
        const node = startNode(1 /* NodeTypes.Plural */ , offset, loc);
        node.cases = [];
        node.cases.push(msgNode);
        do {
            const msg = parseMessage(tokenizer);
            if (!hasEmptyMessage) hasEmptyMessage = msg.items.length === 0;
            node.cases.push(msg);
        }while (context.currentType !== 14 /* TokenTypes.EOF */ );
        if (hasEmptyMessage) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseResource(tokenizer) {
        const context = tokenizer.context();
        const { offset: offset, startLoc: startLoc } = context;
        const msgNode = parseMessage(tokenizer);
        if (context.currentType === 14 /* TokenTypes.EOF */ ) return msgNode;
        else return parsePlural(tokenizer, offset, startLoc, msgNode);
    }
    function parse(source) {
        const tokenizer = $b46efaa99568cb1e$var$createTokenizer(source, (0, $9QywT.assign)({}, options));
        const context = tokenizer.context();
        const node = startNode(0 /* NodeTypes.Resource */ , context.offset, context.startLoc);
        if (location && node.loc) node.loc.source = source;
        node.body = parseResource(tokenizer);
        if (options.onCacheKey) node.cacheKey = options.onCacheKey(source);
        // assert whether achieved to EOF
        if (context.currentType !== 14 /* TokenTypes.EOF */ ) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || "");
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    return {
        parse: parse
    };
}
function $b46efaa99568cb1e$var$getTokenCaption(token) {
    if (token.type === 14 /* TokenTypes.EOF */ ) return "EOF";
    const name = (token.value || "").replace(/\r?\n/gu, "\\n");
    return name.length > 10 ? name.slice(0, 9) + "\u2026" : name;
}
function $b46efaa99568cb1e$var$createTransformer(ast, options = {} // eslint-disable-line
) {
    const _context = {
        ast: ast,
        helpers: new Set()
    };
    const context = ()=>_context;
    const helper = (name)=>{
        _context.helpers.add(name);
        return name;
    };
    return {
        context: context,
        helper: helper
    };
}
function $b46efaa99568cb1e$var$traverseNodes(nodes, transformer) {
    for(let i = 0; i < nodes.length; i++)$b46efaa99568cb1e$var$traverseNode(nodes[i], transformer);
}
function $b46efaa99568cb1e$var$traverseNode(node, transformer) {
    // TODO: if we need pre-hook of transform, should be implemented to here
    switch(node.type){
        case 1 /* NodeTypes.Plural */ :
            $b46efaa99568cb1e$var$traverseNodes(node.cases, transformer);
            transformer.helper("plural" /* HelperNameMap.PLURAL */ );
            break;
        case 2 /* NodeTypes.Message */ :
            $b46efaa99568cb1e$var$traverseNodes(node.items, transformer);
            break;
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                $b46efaa99568cb1e$var$traverseNode(linked.key, transformer);
                transformer.helper("linked" /* HelperNameMap.LINKED */ );
                transformer.helper("type" /* HelperNameMap.TYPE */ );
                break;
            }
        case 5 /* NodeTypes.List */ :
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */ );
            transformer.helper("list" /* HelperNameMap.LIST */ );
            break;
        case 4 /* NodeTypes.Named */ :
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */ );
            transformer.helper("named" /* HelperNameMap.NAMED */ );
            break;
    }
// TODO: if we need post-hook of transform, should be implemented to here
}
// transform AST
function $b46efaa99568cb1e$var$transform(ast, options = {} // eslint-disable-line
) {
    const transformer = $b46efaa99568cb1e$var$createTransformer(ast);
    transformer.helper("normalize" /* HelperNameMap.NORMALIZE */ );
    // traverse
    ast.body && $b46efaa99568cb1e$var$traverseNode(ast.body, transformer);
    // set meta information
    const context = transformer.context();
    ast.helpers = Array.from(context.helpers);
}
function $b46efaa99568cb1e$var$optimize(ast) {
    const body = ast.body;
    if (body.type === 2 /* NodeTypes.Message */ ) $b46efaa99568cb1e$var$optimizeMessageNode(body);
    else body.cases.forEach((c)=>$b46efaa99568cb1e$var$optimizeMessageNode(c));
    return ast;
}
function $b46efaa99568cb1e$var$optimizeMessageNode(message) {
    if (message.items.length === 1) {
        const item = message.items[0];
        if (item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ ) {
            message.static = item.value;
            delete item.value; // optimization for size
        }
    } else {
        const values = [];
        for(let i = 0; i < message.items.length; i++){
            const item = message.items[i];
            if (!(item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ )) break;
            if (item.value == null) break;
            values.push(item.value);
        }
        if (values.length === message.items.length) {
            message.static = (0, $9QywT.join)(values);
            for(let i = 0; i < message.items.length; i++){
                const item = message.items[i];
                if (item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ ) delete item.value; // optimization for size
            }
        }
    }
}
const $b46efaa99568cb1e$var$ERROR_DOMAIN$1 = "minifier";
/* eslint-disable @typescript-eslint/no-explicit-any */ function $b46efaa99568cb1e$var$minify(node) {
    node.t = node.type;
    switch(node.type){
        case 0 /* NodeTypes.Resource */ :
            {
                const resource = node;
                $b46efaa99568cb1e$var$minify(resource.body);
                resource.b = resource.body;
                delete resource.body;
                break;
            }
        case 1 /* NodeTypes.Plural */ :
            {
                const plural = node;
                const cases = plural.cases;
                for(let i = 0; i < cases.length; i++)$b46efaa99568cb1e$var$minify(cases[i]);
                plural.c = cases;
                delete plural.cases;
                break;
            }
        case 2 /* NodeTypes.Message */ :
            {
                const message = node;
                const items = message.items;
                for(let i = 0; i < items.length; i++)$b46efaa99568cb1e$var$minify(items[i]);
                message.i = items;
                delete message.items;
                if (message.static) {
                    message.s = message.static;
                    delete message.static;
                }
                break;
            }
        case 3 /* NodeTypes.Text */ :
        case 9 /* NodeTypes.Literal */ :
        case 8 /* NodeTypes.LinkedModifier */ :
        case 7 /* NodeTypes.LinkedKey */ :
            {
                const valueNode = node;
                if (valueNode.value) {
                    valueNode.v = valueNode.value;
                    delete valueNode.value;
                }
                break;
            }
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                $b46efaa99568cb1e$var$minify(linked.key);
                linked.k = linked.key;
                delete linked.key;
                if (linked.modifier) {
                    $b46efaa99568cb1e$var$minify(linked.modifier);
                    linked.m = linked.modifier;
                    delete linked.modifier;
                }
                break;
            }
        case 5 /* NodeTypes.List */ :
            {
                const list = node;
                list.i = list.index;
                delete list.index;
                break;
            }
        case 4 /* NodeTypes.Named */ :
            {
                const named = node;
                named.k = named.key;
                delete named.key;
                break;
            }
        default:
            throw $b46efaa99568cb1e$export$21efa8bb37d5fecb($b46efaa99568cb1e$export$77436aae039469c4.UNHANDLED_MINIFIER_NODE_TYPE, null, {
                domain: $b46efaa99568cb1e$var$ERROR_DOMAIN$1,
                args: [
                    node.type
                ]
            });
    }
    delete node.type;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ // eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference types="source-map-js" />
const $b46efaa99568cb1e$var$ERROR_DOMAIN = "parser";
function $b46efaa99568cb1e$var$createCodeGenerator(ast, options) {
    const { sourceMap: sourceMap, filename: filename, breakLineCode: breakLineCode, needIndent: _needIndent } = options;
    const location = options.location !== false;
    const _context = {
        filename: filename,
        code: "",
        column: 1,
        line: 1,
        offset: 0,
        map: undefined,
        breakLineCode: breakLineCode,
        needIndent: _needIndent,
        indentLevel: 0
    };
    if (location && ast.loc) _context.source = ast.loc.source;
    const context = ()=>_context;
    function push(code, node) {
        _context.code += code;
    }
    function _newline(n, withBreakLine = true) {
        const _breakLineCode = withBreakLine ? breakLineCode : "";
        push(_needIndent ? _breakLineCode + `  `.repeat(n) : _breakLineCode);
    }
    function indent(withNewLine = true) {
        const level = ++_context.indentLevel;
        withNewLine && _newline(level);
    }
    function deindent(withNewLine = true) {
        const level = --_context.indentLevel;
        withNewLine && _newline(level);
    }
    function newline() {
        _newline(_context.indentLevel);
    }
    const helper = (key)=>`_${key}`;
    const needIndent = ()=>_context.needIndent;
    return {
        context: context,
        push: push,
        indent: indent,
        deindent: deindent,
        newline: newline,
        helper: helper,
        needIndent: needIndent
    };
}
function $b46efaa99568cb1e$var$generateLinkedNode(generator, node) {
    const { helper: helper } = generator;
    generator.push(`${helper("linked" /* HelperNameMap.LINKED */ )}(`);
    $b46efaa99568cb1e$var$generateNode(generator, node.key);
    if (node.modifier) {
        generator.push(`, `);
        $b46efaa99568cb1e$var$generateNode(generator, node.modifier);
        generator.push(`, _type`);
    } else generator.push(`, undefined, _type`);
    generator.push(`)`);
}
function $b46efaa99568cb1e$var$generateMessageNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    generator.push(`${helper("normalize" /* HelperNameMap.NORMALIZE */ )}([`);
    generator.indent(needIndent());
    const length = node.items.length;
    for(let i = 0; i < length; i++){
        $b46efaa99568cb1e$var$generateNode(generator, node.items[i]);
        if (i === length - 1) break;
        generator.push(", ");
    }
    generator.deindent(needIndent());
    generator.push("])");
}
function $b46efaa99568cb1e$var$generatePluralNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    if (node.cases.length > 1) {
        generator.push(`${helper("plural" /* HelperNameMap.PLURAL */ )}([`);
        generator.indent(needIndent());
        const length = node.cases.length;
        for(let i = 0; i < length; i++){
            $b46efaa99568cb1e$var$generateNode(generator, node.cases[i]);
            if (i === length - 1) break;
            generator.push(", ");
        }
        generator.deindent(needIndent());
        generator.push(`])`);
    }
}
function $b46efaa99568cb1e$var$generateResource(generator, node) {
    if (node.body) $b46efaa99568cb1e$var$generateNode(generator, node.body);
    else generator.push("null");
}
function $b46efaa99568cb1e$var$generateNode(generator, node) {
    const { helper: helper } = generator;
    switch(node.type){
        case 0 /* NodeTypes.Resource */ :
            $b46efaa99568cb1e$var$generateResource(generator, node);
            break;
        case 1 /* NodeTypes.Plural */ :
            $b46efaa99568cb1e$var$generatePluralNode(generator, node);
            break;
        case 2 /* NodeTypes.Message */ :
            $b46efaa99568cb1e$var$generateMessageNode(generator, node);
            break;
        case 6 /* NodeTypes.Linked */ :
            $b46efaa99568cb1e$var$generateLinkedNode(generator, node);
            break;
        case 8 /* NodeTypes.LinkedModifier */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 7 /* NodeTypes.LinkedKey */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 5 /* NodeTypes.List */ :
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */ )}(${helper("list" /* HelperNameMap.LIST */ )}(${node.index}))`, node);
            break;
        case 4 /* NodeTypes.Named */ :
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */ )}(${helper("named" /* HelperNameMap.NAMED */ )}(${JSON.stringify(node.key)}))`, node);
            break;
        case 9 /* NodeTypes.Literal */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 3 /* NodeTypes.Text */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        default:
            throw $b46efaa99568cb1e$export$21efa8bb37d5fecb($b46efaa99568cb1e$export$77436aae039469c4.UNHANDLED_CODEGEN_NODE_TYPE, null, {
                domain: $b46efaa99568cb1e$var$ERROR_DOMAIN,
                args: [
                    node.type
                ]
            });
    }
}
// generate code from AST
const $b46efaa99568cb1e$var$generate = (ast, options = {} // eslint-disable-line
)=>{
    const mode = (0, $9QywT.isString)(options.mode) ? options.mode : "normal";
    const filename = (0, $9QywT.isString)(options.filename) ? options.filename : "message.intl";
    const sourceMap = !!options.sourceMap;
    // prettier-ignore
    const breakLineCode = options.breakLineCode != null ? options.breakLineCode : mode === "arrow" ? ";" : "\n";
    const needIndent = options.needIndent ? options.needIndent : mode !== "arrow";
    const helpers = ast.helpers || [];
    const generator = $b46efaa99568cb1e$var$createCodeGenerator(ast, {
        mode: mode,
        filename: filename,
        sourceMap: sourceMap,
        breakLineCode: breakLineCode,
        needIndent: needIndent
    });
    generator.push(mode === "normal" ? `function __msg__ (ctx) {` : `(ctx) => {`);
    generator.indent(needIndent);
    if (helpers.length > 0) {
        generator.push(`const { ${(0, $9QywT.join)(helpers.map((s)=>`${s}: _${s}`), ", ")} } = ctx`);
        generator.newline();
    }
    generator.push(`return `);
    $b46efaa99568cb1e$var$generateNode(generator, ast);
    generator.deindent(needIndent);
    generator.push(`}`);
    delete ast.helpers;
    const { code: code, map: map } = generator.context();
    return {
        ast: ast,
        code: code,
        map: map ? map.toJSON() : undefined // eslint-disable-line @typescript-eslint/no-explicit-any
    };
};
function $b46efaa99568cb1e$export$3243579822c486a0(source, options = {}) {
    const assignedOptions = (0, $9QywT.assign)({}, options);
    const jit = !!assignedOptions.jit;
    const enalbeMinify = !!assignedOptions.minify;
    const enambeOptimize = assignedOptions.optimize == null ? true : assignedOptions.optimize;
    // parse source codes
    const parser = $b46efaa99568cb1e$export$88a1156fad04455f(assignedOptions);
    const ast = parser.parse(source);
    if (!jit) {
        // transform ASTs
        $b46efaa99568cb1e$var$transform(ast, assignedOptions);
        // generate javascript codes
        return $b46efaa99568cb1e$var$generate(ast, assignedOptions);
    } else {
        // optimize ASTs
        enambeOptimize && $b46efaa99568cb1e$var$optimize(ast);
        // minimize ASTs
        enalbeMinify && $b46efaa99568cb1e$var$minify(ast);
        // In JIT mode, no ast transform, no code generation.
        return {
            ast: ast,
            code: ""
        };
    }
}

});


parcelRegister("j6G8F", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", () => $de8f43bece76d38a$export$63b9a9bba9f20f3e);

var $jiSSU = parcelRequire("jiSSU");

var $7mHjb = parcelRequire("7mHjb");

var $83xTH = parcelRequire("83xTH");



function $de8f43bece76d38a$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $jiSSU.getTarget)();
    const hook = (0, $jiSSU.getDevtoolsGlobalHook)();
    const enableProxy = (0, $jiSSU.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $7mHjb.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $83xTH.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("jiSSU", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", () => $e0da45b668fffb6e$export$5a2d366b2d9f38f6);
$parcel$export(module.exports, "getTarget", () => $e0da45b668fffb6e$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isProxyAvailable", () => $e0da45b668fffb6e$export$bc32a04c49ed7464);
function $e0da45b668fffb6e$export$5a2d366b2d9f38f6() {
    return $e0da45b668fffb6e$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $e0da45b668fffb6e$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : {};
}
const $e0da45b668fffb6e$export$bc32a04c49ed7464 = typeof Proxy === "function";

});

parcelRegister("7mHjb", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", () => $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df);
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", () => $55cc2ea2e53f2ca6$export$a0897f44accbe922);
const $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
const $55cc2ea2e53f2ca6$export$a0897f44accbe922 = "plugin:settings:set";

});

parcelRegister("83xTH", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", () => $5dd8e5d828be8ae1$export$5728f3776e9b2ac1);

var $7mHjb = parcelRequire("7mHjb");

var $2QQ8V = parcelRequire("2QQ8V");
class $5dd8e5d828be8ae1$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $2QQ8V.now)();
            }
        };
        if (hook) hook.on((0, $7mHjb.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === "on") return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("2QQ8V", function(module, exports) {

$parcel$export(module.exports, "now", () => $2138e2947b5f69c4$export$461939dd4422153);
let $2138e2947b5f69c4$var$supported;
let $2138e2947b5f69c4$var$perf;
function $2138e2947b5f69c4$export$70d26280bc1ca547() {
    var _a;
    if ($2138e2947b5f69c4$var$supported !== undefined) return $2138e2947b5f69c4$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = window.performance;
    } else if (typeof globalThis !== "undefined" && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = globalThis.perf_hooks.performance;
    } else $2138e2947b5f69c4$var$supported = false;
    return $2138e2947b5f69c4$var$supported;
}
function $2138e2947b5f69c4$export$461939dd4422153() {
    return $2138e2947b5f69c4$export$70d26280bc1ca547() ? $2138e2947b5f69c4$var$perf.now() : Date.now();
}

});




parcelRegister("boZNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $84d1df06ca739753$export$2e2bcd8739ae039);

var $73mM4 = parcelRequire("73mM4");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $bRn2L = parcelRequire("bRn2L");

var $deRlR = parcelRequire("deRlR");
var // TODO: move cleanup call to cronjob
//  this will call a clean up method on every visit.
//  This should be moved to a CRON job or similar later
$84d1df06ca739753$export$2e2bcd8739ae039 = {
    __name: "App",
    setup (__props, { expose: __expose }) {
        __expose();
        const { callEndpoint: callEndpoint, endpointData: endpointData } = (0, $bRn2L.default)("cleanup");
        (0, $TusQn.onMounted)(async ()=>{
            await callEndpoint({
                method: "POST"
            });
            (0, $deRlR.default)("Cleanup called: ", endpointData);
        });
        const __returned__ = {
            callEndpoint: callEndpoint,
            endpointData: endpointData,
            get RouterView () {
                return 0, $73mM4.RouterView;
            },
            onMounted: $TusQn.onMounted,
            get useCallEndPointWith () {
                return 0, $bRn2L.default;
            },
            get logInDevMode () {
                return 0, $deRlR.default;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("73mM4", function(module, exports) {

$parcel$export(module.exports, "createWebHistory", () => $a809ac530d32f081$export$7b4942f78e7b8a49);
$parcel$export(module.exports, "RouterLink", () => $a809ac530d32f081$export$fce709ebdac448ed);
$parcel$export(module.exports, "RouterView", () => $a809ac530d32f081$export$d941f00e9b9a537);
$parcel$export(module.exports, "createRouter", () => $a809ac530d32f081$export$baddd0131ee8c05b);
$parcel$export(module.exports, "useRouter", () => $a809ac530d32f081$export$9a302a45f65d0572);
$parcel$export(module.exports, "useRoute", () => $a809ac530d32f081$export$3f79f0b98112cf57);
/*!
  * vue-router v4.3.2
  * (c) 2024 Eduardo San Martin Morote
  * @license MIT
  */ parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $j6G8F = parcelRequire("j6G8F");
const $a809ac530d32f081$var$isBrowser = typeof document !== "undefined";
function $a809ac530d32f081$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module";
}
const $a809ac530d32f081$var$assign = Object.assign;
function $a809ac530d32f081$var$applyToParams(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $a809ac530d32f081$var$isArray(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $a809ac530d32f081$var$noop = ()=>{};
/**
 * Typesafe alternative to Array.isArray
 * https://github.com/microsoft/TypeScript/pull/48228
 */ const $a809ac530d32f081$var$isArray = Array.isArray;
function $a809ac530d32f081$var$warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
/**
 * Encoding Rules (␣ = Space)
 * - Path: ␣ " < > # ? { }
 * - Query: ␣ " < > # & =
 * - Hash: ␣ " < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */ // const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const $a809ac530d32f081$var$HASH_RE = /#/g; // %23
const $a809ac530d32f081$var$AMPERSAND_RE = /&/g; // %26
const $a809ac530d32f081$var$SLASH_RE = /\//g; // %2F
const $a809ac530d32f081$var$EQUAL_RE = /=/g; // %3D
const $a809ac530d32f081$var$IM_RE = /\?/g; // %3F
const $a809ac530d32f081$var$PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query, but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */ const $a809ac530d32f081$var$ENC_BRACKET_OPEN_RE = /%5B/g; // [
const $a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
const $a809ac530d32f081$var$ENC_CARET_RE = /%5E/g; // ^
const $a809ac530d32f081$var$ENC_BACKTICK_RE = /%60/g; // `
const $a809ac530d32f081$var$ENC_CURLY_OPEN_RE = /%7B/g; // {
const $a809ac530d32f081$var$ENC_PIPE_RE = /%7C/g; // |
const $a809ac530d32f081$var$ENC_CURLY_CLOSE_RE = /%7D/g; // }
const $a809ac530d32f081$var$ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$commonEncode(text) {
    return encodeURI("" + text).replace($a809ac530d32f081$var$ENC_PIPE_RE, "|").replace($a809ac530d32f081$var$ENC_BRACKET_OPEN_RE, "[").replace($a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeHash(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, "{").replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, "}").replace($a809ac530d32f081$var$ENC_CARET_RE, "^");
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeQueryValue(text) {
    return $a809ac530d32f081$var$commonEncode(text)// Encode the space as +, encode the + to differentiate it from the space
    .replace($a809ac530d32f081$var$PLUS_RE, "%2B").replace($a809ac530d32f081$var$ENC_SPACE_RE, "+").replace($a809ac530d32f081$var$HASH_RE, "%23").replace($a809ac530d32f081$var$AMPERSAND_RE, "%26").replace($a809ac530d32f081$var$ENC_BACKTICK_RE, "`").replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, "{").replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, "}").replace($a809ac530d32f081$var$ENC_CARET_RE, "^");
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */ function $a809ac530d32f081$var$encodeQueryKey(text) {
    return $a809ac530d32f081$var$encodeQueryValue(text).replace($a809ac530d32f081$var$EQUAL_RE, "%3D");
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodePath(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$HASH_RE, "%23").replace($a809ac530d32f081$var$IM_RE, "%3F");
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeParam(text) {
    return text == null ? "" : $a809ac530d32f081$var$encodePath(text).replace($a809ac530d32f081$var$SLASH_RE, "%2F");
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */ function $a809ac530d32f081$var$decode(text) {
    try {
        return decodeURIComponent("" + text);
    } catch (err) {
        $a809ac530d32f081$var$warn(`Error decoding "${text}". Using original value`);
    }
    return "" + text;
}
const $a809ac530d32f081$var$TRAILING_SLASH_RE = /\/$/;
const $a809ac530d32f081$var$removeTrailingSlash = (path)=>path.replace($a809ac530d32f081$var$TRAILING_SLASH_RE, "");
/**
 * Transforms a URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */ function $a809ac530d32f081$var$parseURL(parseQuery, location1, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    // TODO: move to new URL()
    const hashPos = location1.indexOf("#");
    let searchPos = location1.indexOf("?");
    // the hash appears before the search, so it's not part of the search string
    if (hashPos < searchPos && hashPos >= 0) searchPos = -1;
    if (searchPos > -1) {
        path = location1.slice(0, searchPos);
        searchString = location1.slice(searchPos + 1, hashPos > -1 ? hashPos : location1.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location1.slice(0, hashPos);
        // keep the # character
        hash = location1.slice(hashPos, location1.length);
    }
    // no search and no query
    path = $a809ac530d32f081$var$resolveRelativePath(path != null ? path : location1, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && "?") + searchString + hash,
        path: path,
        query: query,
        hash: $a809ac530d32f081$var$decode(hash)
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */ function $a809ac530d32f081$var$stringifyURL(stringifyQuery, location1) {
    const query = location1.query ? stringifyQuery(location1.query) : "";
    return location1.path + (query && "?") + query + (location1.hash || "");
}
/**
 * Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */ function $a809ac530d32f081$var$stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */ function $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $a809ac530d32f081$var$isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) && $a809ac530d32f081$var$isSameRouteLocationParams(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */ function $a809ac530d32f081$var$isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $a809ac530d32f081$var$isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (!$a809ac530d32f081$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    }
    return true;
}
function $a809ac530d32f081$var$isSameRouteLocationParamsValue(a, b) {
    return $a809ac530d32f081$var$isArray(a) ? $a809ac530d32f081$var$isEquivalentArray(a, b) : $a809ac530d32f081$var$isArray(b) ? $a809ac530d32f081$var$isEquivalentArray(b, a) : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */ function $a809ac530d32f081$var$isEquivalentArray(a, b) {
    return $a809ac530d32f081$var$isArray(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */ function $a809ac530d32f081$var$resolveRelativePath(to, from) {
    if (to.startsWith("/")) return to;
    if (!from.startsWith("/")) {
        $a809ac530d32f081$var$warn(`Cannot resolve a relative location without an absolute path. Trying to resolve "${to}" from "${from}". It should look like "/${from}".`);
        return to;
    }
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    // make . and ./ the same (../ === .., ../../ === ../..)
    // this is the same behavior as new URL()
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        // we stay on the same position
        if (segment === ".") continue;
        // go up in the from array
        if (segment === "..") // we can't go below zero, but we still need to increment toPosition
        {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
var $a809ac530d32f081$var$NavigationType;
(function(NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})($a809ac530d32f081$var$NavigationType || ($a809ac530d32f081$var$NavigationType = {}));
var $a809ac530d32f081$var$NavigationDirection;
(function(NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})($a809ac530d32f081$var$NavigationDirection || ($a809ac530d32f081$var$NavigationDirection = {}));
/**
 * Starting location for Histories
 */ const $a809ac530d32f081$var$START = "";
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */ function $a809ac530d32f081$var$normalizeBase(base) {
    if (!base) {
        if ($a809ac530d32f081$var$isBrowser) {
            // respect <base> tag
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return $a809ac530d32f081$var$removeTrailingSlash(base);
}
// remove any character before the hash
const $a809ac530d32f081$var$BEFORE_HASH_RE = /^[^#]+#/;
function $a809ac530d32f081$var$createHref(base, location1) {
    return base.replace($a809ac530d32f081$var$BEFORE_HASH_RE, "#") + location1;
}
function $a809ac530d32f081$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $a809ac530d32f081$var$computeScrollPosition = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $a809ac530d32f081$var$scrollToPosition(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        /**
         * `id`s can accept pretty much any characters, including CSS combinators
         * like `>` or `~`. It's still possible to retrieve elements using
         * `document.getElementById('~')` but it needs to be escaped when using
         * `document.querySelector('#\\~')` for it to be valid. The only
         * requirements for `id`s are them to be unique on the page and to not be
         * empty (`id=""`). Because of that, when passing an id selector, it should
         * be properly escaped for it to work with `querySelector`. We could check
         * for the id selector to be simple (no CSS combinators `+ >~`) but that
         * would make things inconsistent since they are valid characters for an
         * `id` but would need to be escaped when using `querySelector`, breaking
         * their usage and ending up in no selector returned. Selectors need to be
         * escaped:
         *
         * - `#1-thing` becomes `#\31 -thing`
         * - `#with~symbols` becomes `#with\\~symbols`
         *
         * - More information about  the topic can be found at
         *   https://mathiasbynens.be/notes/html5-id-class.
         * - Practical example: https://mathiasbynens.be/demo/html5-id
         */ if (typeof position.el === "string") {
            if (!isIdSelector || !document.getElementById(position.el.slice(1))) try {
                const foundEl = document.querySelector(position.el);
                if (isIdSelector && foundEl) {
                    $a809ac530d32f081$var$warn(`The selector "${position.el}" should be passed as "el: document.querySelector('${position.el}')" because it starts with "#".`);
                    // return to avoid other warnings
                    return;
                }
            } catch (err) {
                $a809ac530d32f081$var$warn(`The selector "${position.el}" is invalid. If you are using an id selector, make sure to escape it. You can find more information about escaping characters in selectors at https://mathiasbynens.be/notes/css-escapes or use CSS.escape (https://developer.mozilla.org/en-US/docs/Web/API/CSS/escape).`);
                // return to avoid other warnings
                return;
            }
        }
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) {
            $a809ac530d32f081$var$warn(`Couldn't find element using selector "${position.el}" returned by scrollBehavior.`);
            return;
        }
        scrollToOptions = $a809ac530d32f081$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $a809ac530d32f081$var$getScrollKey(path, delta) {
    const position = history.state ? history.state.position - delta : -1;
    return position + path;
}
const $a809ac530d32f081$var$scrollPositions = new Map();
function $a809ac530d32f081$var$saveScrollPosition(key, scrollPosition) {
    $a809ac530d32f081$var$scrollPositions.set(key, scrollPosition);
}
function $a809ac530d32f081$var$getSavedScrollPosition(key) {
    const scroll = $a809ac530d32f081$var$scrollPositions.get(key);
    // consume it so it's not used again
    $a809ac530d32f081$var$scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */ // export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }
let $a809ac530d32f081$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
 * Creates a normalized history location from a window.location object
 * @param base - The base path
 * @param location - The window.location object
 */ function $a809ac530d32f081$var$createCurrentLocation(base, location1) {
    const { pathname: pathname, search: search, hash: hash } = location1;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return $a809ac530d32f081$var$stripBase(pathFromHash, "");
    }
    const path = $a809ac530d32f081$var$stripBase(pathname, base);
    return path + search + hash;
}
function $a809ac530d32f081$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $a809ac530d32f081$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: $a809ac530d32f081$var$NavigationType.pop,
                direction: delta ? delta > 0 ? $a809ac530d32f081$var$NavigationDirection.forward : $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // set up the listener and prepare teardown callbacks
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history: history1 } = window;
        if (!history1.state) return;
        history1.replaceState($a809ac530d32f081$var$assign({}, history1.state, {
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        }), "");
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("beforeunload", beforeUnloadListener);
    }
    // set up the listeners and prepare teardown callbacks
    window.addEventListener("popstate", popStateHandler);
    // TODO: could we use 'pagehide' or 'visibilitychange' instead?
    // https://developer.chrome.com/blog/page-lifecycle-api/
    window.addEventListener("beforeunload", beforeUnloadListener, {
        passive: true
    });
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
 * Creates a state object
 */ function $a809ac530d32f081$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? $a809ac530d32f081$var$computeScrollPosition() : null
    };
}
function $a809ac530d32f081$var$useHistoryStateNavigation(base) {
    const { history: history1, location: location1 } = window;
    // private variables
    const currentLocation = {
        value: $a809ac530d32f081$var$createCurrentLocation(base, location1)
    };
    const historyState = {
        value: history1.state
    };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        // the length is off by one, we need to decrease it
        position: history1.length - 1,
        replaced: true,
        // don't add a scroll as the user may have an anchor, and we want
        // scrollBehavior to be triggered without a saved position
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided, and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/router/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $a809ac530d32f081$var$createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history1[replace ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            $a809ac530d32f081$var$warn("Error with push/replace State", err);
            // Force the navigation, this also resets the call count
            location1[replace ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        const state = $a809ac530d32f081$var$assign({}, history1.state, $a809ac530d32f081$var$buildState(historyState.value.back, // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, {
            position: historyState.value.position
        });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        const currentState = $a809ac530d32f081$var$assign({}, // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/router/issues/366
        historyState.value, history1.state, {
            forward: to,
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        });
        if (!history1.state) $a809ac530d32f081$var$warn(`history.state seems to have been manually replaced without preserving the necessary values. Make sure to preserve existing history state if you are manually calling history.replaceState:\n\n` + `history.replaceState(history.state, '', url)\n\n` + `You can find more information at https://next.router.vuejs.org/guide/migration/#usage-of-history-state.`);
        changeLocation(currentState.current, currentState, true);
        const state = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */ function $a809ac530d32f081$export$7b4942f78e7b8a49(base) {
    base = $a809ac530d32f081$var$normalizeBase(base);
    const historyNavigation = $a809ac530d32f081$var$useHistoryStateNavigation(base);
    const historyListeners = $a809ac530d32f081$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = $a809ac530d32f081$var$assign({
        // it's overridden right after
        location: "",
        base: base,
        go: go,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
/**
 * Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */ function $a809ac530d32f081$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        $a809ac530d32f081$var$START
    ];
    let position = 0;
    base = $a809ac530d32f081$var$normalizeBase(base);
    function setLocation(location1) {
        position++;
        if (position !== queue.length) // we are in the middle, we remove everything from here in the queue
        queue.splice(position);
        queue.push(location1);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: $a809ac530d32f081$var$NavigationType.pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        // rewritten by Object.defineProperty
        location: $a809ac530d32f081$var$START,
        // TODO: should be kept in queue
        state: {},
        base: base,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base),
        replace (to) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to);
        },
        push (to, data) {
            setLocation(to);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                $a809ac530d32f081$var$START
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position]
    });
    return routerHistory;
}
/**
 * Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
 * handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
 * in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
 * calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
 * after the `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */ function $a809ac530d32f081$export$542bc3a76486c94d(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : "";
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes("#")) base += "#";
    if (!base.endsWith("#/") && !base.endsWith("#")) $a809ac530d32f081$var$warn(`A hash base must end with a "#":\n"${base}" should be "${base.replace(/#.*$/, "#")}".`);
    return $a809ac530d32f081$export$7b4942f78e7b8a49(base);
}
function $a809ac530d32f081$var$isRouteLocation(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $a809ac530d32f081$var$isRouteName(name) {
    return typeof name === "string" || typeof name === "symbol";
}
/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */ const $a809ac530d32f081$export$e44be9a9779c480b = {
    path: "/",
    name: undefined,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: undefined
};
const $a809ac530d32f081$var$NavigationFailureSymbol = Symbol("navigation failure");
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */ var $a809ac530d32f081$export$35710516f95d6a57;
(function(NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})($a809ac530d32f081$export$35710516f95d6a57 || ($a809ac530d32f081$export$35710516f95d6a57 = {}));
// DEV only debug messages
const $a809ac530d32f081$var$ErrorTypeMessages = {
    [1 /* ErrorTypes.MATCHER_NOT_FOUND */ ] ({ location: location1, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location1)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$a809ac530d32f081$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [4 /* ErrorTypes.NAVIGATION_ABORTED */ ] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8 /* ErrorTypes.NAVIGATION_CANCELLED */ ] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16 /* ErrorTypes.NAVIGATION_DUPLICATED */ ] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
 * Creates a typed NavigationFailure object.
 * @internal
 * @param type - NavigationFailureType
 * @param params - { from, to }
 */ function $a809ac530d32f081$var$createRouterError(type, params) {
    return $a809ac530d32f081$var$assign(new Error($a809ac530d32f081$var$ErrorTypeMessages[type](params)), {
        type: type,
        [$a809ac530d32f081$var$NavigationFailureSymbol]: true
    }, params);
}
function $a809ac530d32f081$export$873de56207a30e5a(error, type) {
    return error instanceof Error && $a809ac530d32f081$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $a809ac530d32f081$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $a809ac530d32f081$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if (to.path != null) return to.path;
    const location1 = {};
    for (const key of $a809ac530d32f081$var$propertiesToLog)if (key in to) location1[key] = to[key];
    return JSON.stringify(location1, null, 2);
}
// default pattern for a param: non-greedy everything but /
const $a809ac530d32f081$var$BASE_PARAM_PATTERN = "[^/]+?";
const $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
// Special Regex characters that must be escaped in static tokens
const $a809ac530d32f081$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */ function $a809ac530d32f081$var$tokensToParser(segments, extraOptions) {
    const options = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    const score = [];
    // the regexp as a string
    let pattern = options.start ? "^" : "";
    // extracted keys
    const keys = [];
    for (const segment of segments){
        // the root segment needs special treatment
        const segmentScores = segment.length ? [] : [
            90 /* PathScore.Root */ 
        ];
        // allow trailing slash
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            // resets the score if we are inside a sub-segment /:a-other-:b
            let subSegmentScore = 40 /* PathScore.Segment */  + (options.sensitive ? 0.25 /* PathScore.BonusCaseSensitive */  : 0);
            if (token.type === 0 /* TokenType.Static */ ) {
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($a809ac530d32f081$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += 40 /* PathScore.Static */ ;
            } else if (token.type === 1 /* TokenType.Param */ ) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re = regexp ? regexp : $a809ac530d32f081$var$BASE_PARAM_PATTERN;
                // the user provided a custom regexp /:id(\\d+)
                if (re !== $a809ac530d32f081$var$BASE_PARAM_PATTERN) {
                    subSegmentScore += 10 /* PathScore.BonusCustomRegExp */ ;
                    // make sure the regexp is valid before using it
                    try {
                        new RegExp(`(${re})`);
                    } catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` + err.message);
                    }
                }
                // when we repeat we must take care of the repeating leading slash
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) subPattern = // avoid an optional / if there are more segments e.g. /:p?-static
                // or /:p?-:p2
                optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += 20 /* PathScore.Dynamic */ ;
                if (optional) subSegmentScore += -8 /* PathScore.BonusOptional */ ;
                if (repeatable) subSegmentScore += -20 /* PathScore.BonusRepeatable */ ;
                if (re === ".*") subSegmentScore += -50 /* PathScore.BonusWildcard */ ;
            }
            segmentScores.push(subSegmentScore);
        }
        // an empty array like /home/ -> [[{home}], []]
        // if (!segment.length) pattern += '/'
        score.push(segmentScores);
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* PathScore.BonusStrict */ ;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        // for optional parameters to allow to be empty
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment){
                if (token.type === 0 /* TokenType.Static */ ) path += token.value;
                else if (token.type === 1 /* TokenType.Param */ ) {
                    const { value: value, repeatable: repeatable, optional: optional } = token;
                    const param = value in params ? params[value] : "";
                    if ($a809ac530d32f081$var$isArray(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                    const text = $a809ac530d32f081$var$isArray(param) ? param.join("/") : param;
                    if (!text) {
                        if (optional) // if we have more than one optional param like /:a?-static we don't need to care about the optional param
                        {
                            if (segment.length < 2) {
                                // remove the last slash as we could be at the end
                                if (path.endsWith("/")) path = path.slice(0, -1);
                                else avoidDuplicatedSlash = true;
                            }
                        } else throw new Error(`Missing required param "${value}"`);
                    }
                    path += text;
                }
            }
        }
        // avoid empty path when we have multiple optional params
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */ function $a809ac530d32f081$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff) return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) return a.length === 1 && a[0] === 80 /* PathScore.Segment */  ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 /* PathScore.Segment */  ? 1 : -1;
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */ function $a809ac530d32f081$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $a809ac530d32f081$var$compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($a809ac530d32f081$var$isLastScoreNegative(aScore)) return 1;
        if ($a809ac530d32f081$var$isLastScoreNegative(bScore)) return -1;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
// this is the ternary version
// return aScore.length < bScore.length
//   ? 1
//   : aScore.length > bScore.length
//   ? -1
//   : 0
}
/**
 * This allows detecting splats at the end of a path: /home/:id(.*)*
 *
 * @param score - score to check
 * @returns true if the last entry is negative
 */ function $a809ac530d32f081$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $a809ac530d32f081$var$ROOT_TOKEN = {
    type: 0 /* TokenType.Static */ ,
    value: ""
};
const $a809ac530d32f081$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function $a809ac530d32f081$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $a809ac530d32f081$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Route paths should start with a "/": "${path}" should be "/${path}".`);
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0 /* TokenizerState.Static */ ;
    let previousState = state;
    const tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    // index on the path
    let i = 0;
    // char at index
    let char;
    // buffer of the value read
    let buffer = "";
    // custom regexp for a param
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0 /* TokenizerState.Static */ ) segment.push({
            type: 0 /* TokenType.Static */ ,
            value: buffer
        });
        else if (state === 1 /* TokenizerState.Param */  || state === 2 /* TokenizerState.ParamRegExp */  || state === 3 /* TokenizerState.ParamRegExpEnd */ ) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1 /* TokenType.Param */ ,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== 2 /* TokenizerState.ParamRegExp */ ) {
            previousState = state;
            state = 4 /* TokenizerState.EscapeNext */ ;
            continue;
        }
        switch(state){
            case 0 /* TokenizerState.Static */ :
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = 1 /* TokenizerState.Param */ ;
                } else addCharToBuffer();
                break;
            case 4 /* TokenizerState.EscapeNext */ :
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* TokenizerState.Param */ :
                if (char === "(") state = 2 /* TokenizerState.ParamRegExp */ ;
                else if ($a809ac530d32f081$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0 /* TokenizerState.Static */ ;
                    // go back one character if we were not modifying
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case 2 /* TokenizerState.ParamRegExp */ :
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ")") {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = 3 /* TokenizerState.ParamRegExpEnd */ ;
                } else customRe += char;
                break;
            case 3 /* TokenizerState.ParamRegExpEnd */ :
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* TokenizerState.Static */ ;
                // go back one character if we were not modifying
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === 2 /* TokenizerState.ParamRegExp */ ) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}
function $a809ac530d32f081$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $a809ac530d32f081$var$tokensToParser($a809ac530d32f081$var$tokenizePath(record.path), options);
    {
        const existingKeys = new Set();
        for (const key of parser.keys){
            if (existingKeys.has(key.name)) $a809ac530d32f081$var$warn(`Found duplicated params with name "${key.name}" for path "${record.path}". Only the last one will be available on "$route.params".`);
            existingKeys.add(key.name);
        }
    }
    const matcher = $a809ac530d32f081$var$assign(parser, {
        record: record,
        parent: parent,
        // these needs to be populated by the parent
        children: [],
        alias: []
    });
    if (parent) // both are aliases or both are not aliases
    // we don't want to mix them because the order is used when
    // passing originalRecord in Matcher.addRoute
    {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */ function $a809ac530d32f081$export$36302c85fdcc95a8(routes, globalOptions) {
    // normalized ordered array of matchers
    const matchers = [];
    const matcherMap = new Map();
    globalOptions = $a809ac530d32f081$var$mergeOptions({
        strict: false,
        end: true,
        sensitive: false
    }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $a809ac530d32f081$var$normalizeRouteRecord(record);
        $a809ac530d32f081$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent);
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = $a809ac530d32f081$var$mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($a809ac530d32f081$var$assign({}, mainNormalizedRecord, {
                // this allows us to hold a copy of the `components` option
                // so that async components cache is hold on the original record
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                // we might be the child of an alias
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            }));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            // Build up the path for nested routes if the child isn't an absolute
            // route. Only add the / delimiter if the child path isn't empty and if the
            // parent path doesn't have a trailing slash
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            if (normalizedRecord.path === "*") throw new Error('Catch all routes ("*") must now be defined using a param with a custom regexp.\nSee more at https://next.router.vuejs.org/guide/migration/#removed-star-or-catch-all-routes.');
            // create the object beforehand, so it can be passed to children
            matcher = $a809ac530d32f081$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            if (parent && path[0] === "/") $a809ac530d32f081$var$checkMissingParamsInAbsolutePath(matcher, parent);
            // if we are an alias we must tell the original record that we exist,
            // so we can be removed
            if (originalRecord) {
                originalRecord.alias.push(matcher);
                $a809ac530d32f081$var$checkSameParams(originalRecord, matcher);
            } else {
                // otherwise, the first record is the original and others are aliases
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                // remove the route if named and only for the top record (avoid in nested calls)
                // this works because the original record is the first one
                if (isRootAdd && record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            // if there was no original record, then the first one was not an alias and all
            // other aliases (if any) need to reference this record when adding children
            originalRecord = originalRecord || matcher;
            // TODO: add normalized records for more flexibility
            // if (parent && isAliasRecord(originalRecord)) {
            //   parent.children.push(originalRecord)
            // }
            // Avoid adding a record that doesn't display anything. This allows passing through records without a component to
            // not be reached and pass through the catch all route
            if (matcher.record.components && Object.keys(matcher.record.components).length || matcher.record.name || matcher.record.redirect) insertMatcher(matcher);
        }
        return originalMatcher ? ()=>{
            // since other matchers are aliases, they should be removed by the original matcher
            removeRoute(originalMatcher);
        } : $a809ac530d32f081$var$noop;
    }
    function removeRoute(matcherRef) {
        if ($a809ac530d32f081$var$isRouteName(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        let i = 0;
        while(i < matchers.length && $a809ac530d32f081$var$comparePathParserScore(matcher, matchers[i]) >= 0 && // Adding children with empty path should still appear before the parent
        // https://github.com/vuejs/router/issues/1124
        (matcher.record.path !== matchers[i].record.path || !$a809ac530d32f081$var$isRecordChildOf(matcher, matchers[i])))i++;
        matchers.splice(i, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1
            });
            {
                const invalidParams = Object.keys(location1.params || {}).filter((paramName)=>!matcher.keys.find((k)=>k.name === paramName));
                if (invalidParams.length) $a809ac530d32f081$var$warn(`Discarded invalid param(s) "${invalidParams.join('", "')}" when navigating. See https://github.com/vuejs/router/blob/main/packages/router/CHANGELOG.md#414-2022-08-22 for more details.`);
            }
            name = matcher.record.name;
            params = $a809ac530d32f081$var$assign(// paramsFromLocation is a new object
            $a809ac530d32f081$var$paramsFromLocation(currentLocation.params, // only keep params that exist in the resolved location
            // only keep optional params coming from a parent record
            matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), // discard any existing params in the current location that do not exist here
            // #1497 this ensures better active/exact matching
            location1.params && $a809ac530d32f081$var$paramsFromLocation(location1.params, matcher.keys.map((k)=>k.name)));
            // throws if cannot be stringified
            path = matcher.stringify(params);
        } else if (location1.path != null) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location1.path;
            if (!path.startsWith("/")) $a809ac530d32f081$var$warn(`The Matcher cannot resolve relative paths but received "${path}". Unless you directly called \`matcher.resolve("${path}")\`, this is probably a bug in vue-router. Please open an issue at https://github.com/vuejs/router/issues/new/choose.`);
            matcher = matchers.find((m)=>m.re.test(path));
            // matcher should have a value after the loop
            if (matcher) {
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        // location is a relative path
        } else {
            // match by name or path of current route
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = $a809ac530d32f081$var$assign({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $a809ac530d32f081$var$mergeMetaFields(matched)
        };
    }
    // add initial routes
    routes.forEach((route)=>addRoute(route));
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
function $a809ac530d32f081$var$paramsFromLocation(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */ function $a809ac530d32f081$var$normalizeRouteRecord(record) {
    return {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: undefined,
        beforeEnter: record.beforeEnter,
        props: $a809ac530d32f081$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */ function $a809ac530d32f081$var$normalizeRecordProps(record) {
    const propsObject = {};
    // props does not exist on redirect records, but we can set false directly
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else // NOTE: we could also allow a function to be applied to every component.
    // Would need user feedback for use cases
    for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */ function $a809ac530d32f081$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */ function $a809ac530d32f081$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>$a809ac530d32f081$var$assign(meta, record.meta), {});
}
function $a809ac530d32f081$var$mergeOptions(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
function $a809ac530d32f081$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */ function $a809ac530d32f081$var$checkSameParams(a, b) {
    for (const key of a.keys){
        if (!key.optional && !b.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
    for (const key of b.keys){
        if (!key.optional && !a.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
}
/**
 * A route with a name and a child with an empty path without a name should warn when adding the route
 *
 * @param mainNormalizedRecord - RouteRecordNormalized
 * @param parent - RouteRecordMatcher
 */ function $a809ac530d32f081$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) $a809ac530d32f081$var$warn(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $a809ac530d32f081$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys){
        if (!record.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
    }
}
function $a809ac530d32f081$var$isRecordChildOf(record, parent) {
    return parent.children.some((child)=>child === record || $a809ac530d32f081$var$isRecordChildOf(record, child));
}
/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */ function $a809ac530d32f081$export$1e8473eaf75b0d10(search) {
    const query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === "" || search === "?") return query;
    const hasLeadingIM = search[0] === "?";
    const searchParams = (hasLeadingIM ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        // pre decode the + into space
        const searchParam = searchParams[i].replace($a809ac530d32f081$var$PLUS_RE, " ");
        // allow the = character
        const eqPos = searchParam.indexOf("=");
        const key = $a809ac530d32f081$var$decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $a809ac530d32f081$var$decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            let currentValue = query[key];
            if (!$a809ac530d32f081$var$isArray(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */ function $a809ac530d32f081$export$d33b45a8f796a30(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $a809ac530d32f081$var$encodeQueryKey(key);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) search += (search.length ? "&" : "") + key;
            continue;
        }
        // keep null values
        const values = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v && $a809ac530d32f081$var$encodeQueryValue(v)) : [
            value && $a809ac530d32f081$var$encodeQueryValue(value)
        ];
        values.forEach((value)=>{
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? "&" : "") + key;
                if (value != null) search += "=" + value;
            }
        });
    }
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */ function $a809ac530d32f081$var$normalizeQuery(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== undefined) normalizedQuery[key] = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */ const $a809ac530d32f081$export$7f4879db1558672d = Symbol("router view location matched");
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */ const $a809ac530d32f081$export$9b3825c34ca1427a = Symbol("router view depth");
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */ const $a809ac530d32f081$export$b6c0da8b9dae491f = Symbol("router");
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */ const $a809ac530d32f081$export$3aca783e9a3e6e9e = Symbol("route location");
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */ const $a809ac530d32f081$export$54c8124bead129f8 = Symbol("router view location");
/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */ function $a809ac530d32f081$var$useCallbacks() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
function $a809ac530d32f081$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $TusQn.onUnmounted)(removeFromList);
    (0, $TusQn.onDeactivated)(removeFromList);
    (0, $TusQn.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$d7fcdd004b009a9e(leaveGuard) {
    if (!(0, $TusQn.getCurrentInstance)()) {
        $a809ac530d32f081$var$warn("getCurrentInstance() returned null. onBeforeRouteLeave() must be called at the top of a setup function");
        return;
    }
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) {
        $a809ac530d32f081$var$warn("No active route record was found when calling `onBeforeRouteLeave()`. Make sure you call this function inside a component child of <router-view>. Maybe you called it inside of App.vue?");
        return;
    }
    $a809ac530d32f081$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$46b4cb99461f4cc7(updateGuard) {
    if (!(0, $TusQn.getCurrentInstance)()) {
        $a809ac530d32f081$var$warn("getCurrentInstance() returned null. onBeforeRouteUpdate() must be called at the top of a setup function");
        return;
    }
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) {
        $a809ac530d32f081$var$warn("No active route record was found when calling `onBeforeRouteUpdate()`. Make sure you call this function inside a component child of <router-view>. Maybe you called it inside of App.vue?");
        return;
    }
    $a809ac530d32f081$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    const enterCallbackArray = record && // name is defined if record is because of the function overload
    (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($a809ac530d32f081$var$createRouterError(4 /* ErrorTypes.NAVIGATION_ABORTED */ , {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($a809ac530d32f081$var$isRouteLocation(valid)) reject($a809ac530d32f081$var$createRouterError(2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ , {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            // wrapping with Promise.resolve allows it to work with both async and sync guards
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, $a809ac530d32f081$var$canOnlyBeCalledOnce(next, to, from)));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            if (guard.length > 2) {
                const message = `The "next" callback was never called inside of ${guard.name ? '"' + guard.name + '"' : ""}:\n${guard.toString()}\n. If you are returning a value instead of calling "next", make sure to remove the "next" parameter from your function.`;
                if (typeof guardReturn === "object" && "then" in guardReturn) guardCall = guardCall.then((resolvedValue)=>{
                    // @ts-expect-error: _called is added at canOnlyBeCalledOnce
                    if (!next._called) {
                        $a809ac530d32f081$var$warn(message);
                        return Promise.reject(new Error("Invalid navigation guard"));
                    }
                    return resolvedValue;
                });
                else if (guardReturn !== undefined) // @ts-expect-error: _called is added at canOnlyBeCalledOnce
                {
                    if (!next._called) {
                        $a809ac530d32f081$var$warn(message);
                        reject(new Error("Invalid navigation guard"));
                        return;
                    }
                }
            }
            guardCall.catch((err)=>reject(err));
        });
}
function $a809ac530d32f081$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $a809ac530d32f081$var$warn(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $a809ac530d32f081$var$extractComponentsGuards(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched){
        if (!record.components && !record.children.length) $a809ac530d32f081$var$warn(`Record with path "${record.path}" is either missing a "component(s)"` + ` or "children" property.`);
        for(const name in record.components){
            let rawComponent = record.components[name];
            if (!rawComponent || typeof rawComponent !== "object" && typeof rawComponent !== "function") {
                $a809ac530d32f081$var$warn(`Component "${name}" in record with path "${record.path}" is not` + ` a valid component. Received "${String(rawComponent)}".`);
                // throw to ensure we stop here but warn to ensure the message isn't
                // missed by the user
                throw new Error("Invalid route component");
            } else if ("then" in rawComponent) {
                // warn if user wrote import('/component.vue') instead of () =>
                // import('./component.vue')
                $a809ac530d32f081$var$warn(`Component "${name}" in record with path "${record.path}" is a ` + `Promise instead of a function that returns a Promise. Did you ` + `write "import('./MyPage.vue')" instead of ` + `"() => import('./MyPage.vue')" ? This will break in ` + `production if not fixed.`);
                const promise = rawComponent;
                rawComponent = ()=>promise;
            } else if (rawComponent.__asyncLoader && // warn only once per component
            !rawComponent.__warnedDefineAsync) {
                rawComponent.__warnedDefineAsync = true;
                $a809ac530d32f081$var$warn(`Component "${name}" in record with path "${record.path}" is defined ` + `using "defineAsyncComponent()". ` + `Write "() => import('./MyPage.vue')" instead of ` + `"defineAsyncComponent(() => import('./MyPage.vue'))".`);
            }
            // skip update and leave guards if the route component is not mounted
            if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
            if ($a809ac530d32f081$var$isRouteComponent(rawComponent)) {
                // __vccOpts is added by vue-class-component and contain the regular options
                const options = rawComponent.__vccOpts || rawComponent;
                const guard = options[guardType];
                guard && guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext));
            } else {
                // start requesting the chunk already
                let componentPromise = rawComponent();
                if (!("catch" in componentPromise)) {
                    $a809ac530d32f081$var$warn(`Component "${name}" in record with path "${record.path}" is a function that does not return a Promise. If you were passing a functional component, make sure to add a "displayName" to the component. This will break in production if not fixed.`);
                    componentPromise = Promise.resolve(componentPromise);
                }
                guards.push(()=>componentPromise.then((resolved)=>{
                        if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}"`));
                        const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                        // replace the function with the resolved component
                        // cannot be null or undefined because we went into the for loop
                        record.components[name] = resolvedComponent;
                        // __vccOpts is added by vue-class-component and contain the regular options
                        const options = resolvedComponent.__vccOpts || resolvedComponent;
                        const guard = options[guardType];
                        return guard && $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext)();
                    }));
            }
        }
    }
    return guards;
}
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 * @internal
 *
 * @param component
 */ function $a809ac530d32f081$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
/**
 * Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
 *
 * @param route - resolved route to load
 */ function $a809ac530d32f081$export$d092a02cbf0deea7(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                // replace the function with the resolved component
                // cannot be null or undefined because we went into the for loop
                record.components[name] = resolvedComponent;
                return;
            }));
            return promises;
        }, [])))).then(()=>route);
}
// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
function $a809ac530d32f081$export$dcf14c9974fe2767(props) {
    const router = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
    const currentRoute = (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
    let hasPrevious = false;
    let previousTo = null;
    const route = (0, $01W3b.computed)(()=>{
        const to = (0, $01W3b.unref)(props.to);
        if (!hasPrevious || to !== previousTo) {
            if (!$a809ac530d32f081$var$isRouteLocation(to)) {
                if (hasPrevious) $a809ac530d32f081$var$warn(`Invalid value for prop "to" in useLink()\n- to:`, to, `\n- previous to:`, previousTo, `\n- props:`, props);
                else $a809ac530d32f081$var$warn(`Invalid value for prop "to" in useLink()\n- to:`, to, `\n- props:`, props);
            }
            previousTo = to;
            hasPrevious = true;
        }
        return router.resolve(to);
    });
    const activeRecordIndex = (0, $01W3b.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, routeMatched));
        if (index > -1) return index;
        // possible parent record
        const parentRecordPath = $a809ac530d32f081$var$getOriginalPath(matched[length - 2]);
        return(// we are dealing with nested routes
        length > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        $a809ac530d32f081$var$getOriginalPath(routeMatched) === parentRecordPath && // avoid comparing the child with its parent
        currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, matched[length - 2])) : index);
    });
    const isActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && $a809ac530d32f081$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && $a809ac530d32f081$var$isSameRouteLocationParams(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($a809ac530d32f081$var$guardEvent(e)) return router[(0, $01W3b.unref)(props.replace) ? "replace" : "push"]((0, $01W3b.unref)(props.to)).catch($a809ac530d32f081$var$noop);
        return Promise.resolve();
    }
    // devtools only
    if ($a809ac530d32f081$var$isBrowser) {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            // @ts-expect-error: this is internal
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            // @ts-expect-error: this is internal
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $TusQn.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = $a809ac530d32f081$var$isRouteLocation((0, $01W3b.unref)(props.to)) ? null : 'Invalid "to" value';
            }, {
                flush: "post"
            });
        }
    }
    /**
     * NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
     */ return {
        route: route,
        href: (0, $01W3b.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
const $a809ac530d32f081$var$RouterLinkImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        }
    },
    useLink: $a809ac530d32f081$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $01W3b.reactive)($a809ac530d32f081$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
        const elClass = (0, $01W3b.computed)(()=>({
                [$a809ac530d32f081$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                // [getLinkClass(
                //   props.inactiveClass,
                //   options.linkInactiveClass,
                //   'router-link-inactive'
                // )]: !link.isExactActive,
                [$a809ac530d32f081$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && slots.default(link);
            return props.custom ? children : (0, $TusQn.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                // this would override user added attrs but Vue will still add
                // the listener, so we end up triggering both
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */ const $a809ac530d32f081$export$fce709ebdac448ed = $a809ac530d32f081$var$RouterLinkImpl;
function $a809ac530d32f081$var$guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $a809ac530d32f081$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else {
            if (!$a809ac530d32f081$var$isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value !== outerValue[i])) return false;
        }
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */ function $a809ac530d32f081$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */ const $a809ac530d32f081$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
const $a809ac530d32f081$var$RouterViewImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: "RouterView",
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    // Better compat for @vue/compat users
    // https://github.com/vuejs/router/issues/1315
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        $a809ac530d32f081$var$warnDeprecatedUsage();
        const injectedRoute = (0, $TusQn.inject)($a809ac530d32f081$export$54c8124bead129f8);
        const routeToDisplay = (0, $01W3b.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $TusQn.inject)($a809ac530d32f081$export$9b3825c34ca1427a, 0);
        // The depth changes based on empty components option, which allows passthrough routes e.g. routes with children
        // that are used to reuse the `path` property
        const depth = (0, $01W3b.computed)(()=>{
            let initialDepth = (0, $01W3b.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $01W3b.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $TusQn.provide)($a809ac530d32f081$export$9b3825c34ca1427a, (0, $01W3b.computed)(()=>depth.value + 1));
        (0, $TusQn.provide)($a809ac530d32f081$export$7f4879db1558672d, matchedRouteRef);
        (0, $TusQn.provide)($a809ac530d32f081$export$54c8124bead129f8, routeToDisplay);
        const viewRef = (0, $01W3b.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0, $TusQn.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name, so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance && to && // if there is no instance but to and from are the same this might be
            // the first visit
            (!from || !$a809ac530d32f081$var$isSameRouteRecord(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            // props from route configuration
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $TusQn.h)(ViewComponent, $a809ac530d32f081$var$assign({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if ($a809ac530d32f081$var$isBrowser && component.ref) {
                // TODO: can display if it's an alias, its props
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                const internalInstances = $a809ac530d32f081$var$isArray(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ];
                internalInstances.forEach((instance)=>{
                    // @ts-expect-error
                    instance.__vrv_devtools = info;
                });
            }
            return(// pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component);
        };
    }
});
function $a809ac530d32f081$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */ const $a809ac530d32f081$export$d941f00e9b9a537 = $a809ac530d32f081$var$RouterViewImpl;
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function $a809ac530d32f081$var$warnDeprecatedUsage() {
    const instance = (0, $TusQn.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        $a809ac530d32f081$var$warn(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n` + `Use slot props instead:\n\n` + `<router-view v-slot="{ Component }">\n` + `  <${comp}>\n` + `    <component :is="Component" />\n` + `  </${comp}>\n` + `</router-view>`);
    }
}
/**
 * Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
 *
 * @param routeLocation - routeLocation to format
 * @param tooltip - optional tooltip
 * @returns a copy of the routeLocation
 */ function $a809ac530d32f081$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $a809ac530d32f081$var$assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map((matched)=>$a809ac530d32f081$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $a809ac530d32f081$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
// to support multiple router instances
let $a809ac530d32f081$var$routerId = 0;
function $a809ac530d32f081$var$addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    const id = $a809ac530d32f081$var$routerId++;
    (0, $j6G8F.setupDevtoolsPlugin)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") console.warn("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        // display state added by the router
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $a809ac530d32f081$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $a809ac530d32f081$var$PINK_500
                });
            }
            // if multiple useLink are used
            if ($a809ac530d32f081$var$isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $a809ac530d32f081$var$ORANGE_400;
                    let tooltip = "";
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $a809ac530d32f081$var$RED_100;
                        textColor = $a809ac530d32f081$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $a809ac530d32f081$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $a809ac530d32f081$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $TusQn.watch)(router.currentRoute, ()=>{
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 0x40a8c4
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        // attached to `meta` and used to group events
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay("beforeEach"),
                from: $a809ac530d32f081$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $a809ac530d32f081$var$formatRouteLocation(to, "Target location")
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $a809ac530d32f081$var$formatDisplay("\u274C");
            } else data.status = $a809ac530d32f081$var$formatDisplay("\u2705");
            // we set here to have the right order
            data.from = $a809ac530d32f081$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $a809ac530d32f081$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
         * Inspector of Existing routes
         */ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            // children routes will appear as nested
            let routes = matcher.getRoutes().filter((route)=>!route.parent || // these routes have a parent with no component which will not appear in the view
                // therefore we still need to include them
                !route.parent.record.components);
            // reset match state to false
            routes.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) routes = routes.filter((route)=>// save matches state based on the payload
                $a809ac530d32f081$var$isRouteMatching(route, payload.filter.toLowerCase()));
            // mark active routes
            routes.forEach((route)=>$a809ac530d32f081$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($a809ac530d32f081$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
         * Display information about the currently selected route record
         */ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const routes = matcher.getRoutes();
                const route = routes.find((route)=>route.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $a809ac530d32f081$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$a809ac530d32f081$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */ const $a809ac530d32f081$var$PINK_500 = 0xec4899;
const $a809ac530d32f081$var$BLUE_600 = 0x2563eb;
const $a809ac530d32f081$var$LIME_500 = 0x84cc16;
const $a809ac530d32f081$var$CYAN_400 = 0x22d3ee;
const $a809ac530d32f081$var$ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
const $a809ac530d32f081$var$DARK = 0x666666;
const $a809ac530d32f081$var$RED_100 = 0xfee2e2;
const $a809ac530d32f081$var$RED_700 = 0xb91c1c;
function $a809ac530d32f081$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 0xffffff,
        backgroundColor: $a809ac530d32f081$var$DARK
    });
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    let id = record.__vd_id;
    if (id == null) {
        id = String($a809ac530d32f081$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($a809ac530d32f081$var$formatRouteRecordForInspector)
    };
}
//  incremental id for route records and inspector state
let $a809ac530d32f081$var$routeRecordId = 0;
const $a809ac530d32f081$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $a809ac530d32f081$var$markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    const isExactActive = currentRoute.matched.length && $a809ac530d32f081$var$isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$a809ac530d32f081$var$isSameRouteRecord(match, route.record));
    route.children.forEach((childRoute)=>$a809ac530d32f081$var$markRouteRecordActive(childRoute, currentRoute));
}
function $a809ac530d32f081$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
}
function $a809ac530d32f081$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($a809ac530d32f081$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    // use a regexp without $ at the end to match nested routes better
    const nonEndingRE = new RegExp(found[1].replace(/\$$/, ""), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
        // exception case: `/`
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $a809ac530d32f081$var$decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
}
function $a809ac530d32f081$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) // @ts-expect-error
    ret[key] = obj[key];
    return ret;
}
/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */ function $a809ac530d32f081$export$baddd0131ee8c05b(options) {
    const matcher = $a809ac530d32f081$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || $a809ac530d32f081$export$1e8473eaf75b0d10;
    const stringifyQuery$1 = options.stringifyQuery || $a809ac530d32f081$export$d33b45a8f796a30;
    const routerHistory = options.history;
    if (!routerHistory) throw new Error('Provide the "history" option when calling "createRouter()": https://next.router.vuejs.org/api/#history.');
    const beforeGuards = $a809ac530d32f081$var$useCallbacks();
    const beforeResolveGuards = $a809ac530d32f081$var$useCallbacks();
    const afterGuards = $a809ac530d32f081$var$useCallbacks();
    const currentRoute = (0, $01W3b.shallowRef)($a809ac530d32f081$export$e44be9a9779c480b);
    let pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
    // leave the scrollRestoration if no scrollBehavior is provided
    if ($a809ac530d32f081$var$isBrowser && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = $a809ac530d32f081$var$applyToParams.bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$encodeParam);
    const decodeParams = // @ts-expect-error: intentionally avoid the type check
    $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$decode);
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ($a809ac530d32f081$var$isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            if (!parent) $a809ac530d32f081$var$warn(`Parent route "${String(parentOrRoute)}" not found when adding child route`, route);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
        else $a809ac530d32f081$var$warn(`Cannot remove non-existent route "${String(name)}"`);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = $a809ac530d32f081$var$assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            if (href.startsWith("//")) $a809ac530d32f081$var$warn(`Location "${rawLocation}" resolved to "${href}". A resolved location cannot start with multiple slashes.`);
            else if (!matchedRoute.matched.length) $a809ac530d32f081$var$warn(`No match found for location with path "${rawLocation}"`);
            // locationNormalized is always a new object
            return $a809ac530d32f081$var$assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: $a809ac530d32f081$var$decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href: href
            });
        }
        if (!$a809ac530d32f081$var$isRouteLocation(rawLocation)) {
            $a809ac530d32f081$var$warn(`router.resolve() was passed an invalid location. This will fail in production.\n- Location:`, rawLocation);
            rawLocation = {};
        }
        let matcherLocation;
        // path could be relative in object as well
        if (rawLocation.path != null) {
            if ("params" in rawLocation && !("name" in rawLocation) && // @ts-expect-error: the type is never
            Object.keys(rawLocation.params).length) $a809ac530d32f081$var$warn(`Path "${rawLocation.path}" was passed with params but they will be ignored. Use a named route alongside params instead.`);
            matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
                path: $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path
            });
        } else {
            // remove any nullish param
            const targetParams = $a809ac530d32f081$var$assign({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            // pass encoded values to the matcher, so it can produce encoded path and fullPath
            matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        if (hash && !hash.startsWith("#")) $a809ac530d32f081$var$warn(`A \`hash\` should always start with the character "#". Replace "${hash}" with "#${hash}".`);
        // the matcher might have merged current location params, so
        // we need to run the decoding again
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = $a809ac530d32f081$var$stringifyURL(stringifyQuery$1, $a809ac530d32f081$var$assign({}, rawLocation, {
            hash: $a809ac530d32f081$var$encodeHash(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        if (href.startsWith("//")) $a809ac530d32f081$var$warn(`Location "${rawLocation}" resolved to "${href}". A resolved location cannot start with multiple slashes.`);
        else if (!matchedRoute.matched.length) $a809ac530d32f081$var$warn(`No match found for location with path "${rawLocation.path != null ? rawLocation.path : rawLocation}"`);
        return $a809ac530d32f081$var$assign({
            fullPath: fullPath,
            hash: // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash,
            query: // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/router/issues/328#issuecomment-649481567
            stringifyQuery$1 === $a809ac530d32f081$export$d33b45a8f796a30 ? $a809ac530d32f081$var$normalizeQuery(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: undefined,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? $a809ac530d32f081$var$parseURL(parseQuery$1, to, currentRoute.value.path) : $a809ac530d32f081$var$assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return $a809ac530d32f081$var$createRouterError(8 /* ErrorTypes.NAVIGATION_CANCELLED */ , {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push($a809ac530d32f081$var$assign(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            if (newTargetLocation.path == null && !("name" in newTargetLocation)) {
                $a809ac530d32f081$var$warn(`Invalid redirect found:\n${JSON.stringify(newTargetLocation, null, 2)}\n when navigating to "${to.fullPath}". A redirect must contain a name or path. This will break in production.`);
                throw new Error("Invalid redirect");
            }
            return $a809ac530d32f081$var$assign({
                query: to.query,
                hash: to.hash,
                // avoid transferring params if the redirect has a path
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        // to could be a string where `replace` is a function
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect) return pushWithRedirect($a809ac530d32f081$var$assign(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? $a809ac530d32f081$var$assign({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace
        }), // keep original redirectedFrom if it exists
        redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = $a809ac530d32f081$var$createRouterError(16 /* ErrorTypes.NAVIGATION_DUPLICATED */ , {
                to: toLocation,
                from: from
            });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>$a809ac530d32f081$export$873de56207a30e5a(error) ? $a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ) ? error : markAsReady(error) // also returns the error
             : triggerError(error, toLocation, from)).then((failure)=>{
            if (failure) {
                if ($a809ac530d32f081$export$873de56207a30e5a(failure, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    if (// we are redirecting to the same location we were already at
                    $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery$1, resolve(failure.to), toLocation) && // and we have done it a couple of times
                    redirectedFrom && // @ts-expect-error: added only in dev
                    (redirectedFrom._count = redirectedFrom._count ? redirectedFrom._count + 1 : 1) > 30) {
                        $a809ac530d32f081$var$warn(`Detected a possibly infinite redirection in a navigation guard when going from "${from.fullPath}" to "${toLocation.fullPath}". Aborting to avoid a Stack Overflow.\n Are you always returning a new location within a navigation guard? That would lead to this error. Only return when redirecting or aborting, that should fix this. This might break in production if not fixed.`);
                        return Promise.reject(new Error("Infinite redirect in navigation guard"));
                    }
                    return pushWithRedirect(// keep options
                    $a809ac530d32f081$var$assign({
                        replace: // preserve an existing replacement but allow the redirect to override it
                        replace
                    }, locationAsObject(failure.to), {
                        state: typeof failure.to === "object" ? $a809ac530d32f081$var$assign({}, data, failure.to.state) : data,
                        force: force
                    }), // preserve the original redirectedFrom if any
                    redirectedFrom || toLocation);
                }
            } else // if we fail we don't finalize the navigation
            failure = finalizeNavigation(toLocation, from, true, replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        // support Vue < 3.3
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = $a809ac530d32f081$var$extractChangingRecords(to, from);
        // all components here have been resolved once because we are leaving
        guards = $a809ac530d32f081$var$extractComponentsGuards(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        // leavingRecords is already reversed
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return runGuardQueue(guards).then(()=>{
            // check global guards beforeEach
            guards = [];
            for (const guard of beforeGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            // check in components beforeRouteUpdate
            guards = $a809ac530d32f081$var$extractComponentsGuards(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check the route beforeEnter
            guards = [];
            for (const record of enteringRecords)// do not trigger beforeEnter on reused views
            if (record.beforeEnter) {
                if ($a809ac530d32f081$var$isArray(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push($a809ac530d32f081$var$guardToPromiseFn(beforeEnter, to, from));
                else guards.push($a809ac530d32f081$var$guardToPromiseFn(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach((record)=>record.enterCallbacks = {});
            // check in-component beforeRouteEnter
            guards = $a809ac530d32f081$var$extractComponentsGuards(enteringRecords, "beforeRouteEnter", to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check global guards beforeResolve
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        })// catch any navigation canceled
        .catch((err)=>$a809ac530d32f081$export$873de56207a30e5a(err, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ ) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        // navigation is confirmed, call afterGuards
        // TODO: wrap with error handlers
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        // only consider as push if it's not the first navigation
        const isFirstNavigation = from === $a809ac530d32f081$export$e44be9a9779c480b;
        const state = !$a809ac530d32f081$var$isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, $a809ac530d32f081$var$assign({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        // avoid setting up listeners twice due to an invalid first navigation
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            // cannot be a redirect route because it was in history
            const toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            const shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect($a809ac530d32f081$var$assign(shouldRedirect, {
                    replace: true
                }), toLocation).catch($a809ac530d32f081$var$noop);
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            // TODO: should be moved to web history?
            if ($a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$saveScrollPosition($a809ac530d32f081$var$getScrollKey(from.fullPath, info.delta), $a809ac530d32f081$var$computeScrollPosition());
            navigate(toLocation, from).catch((error)=>{
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 12 /* ErrorTypes.NAVIGATION_CANCELLED */ )) return error;
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is no guarantee for
                    // it to work on every browser. So instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect(error.to, toLocation).then((failure)=>{
                        // manual change in hash history #916 ending up in the URL not
                        // changing, but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if ($a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ ) && !info.delta && info.type === $a809ac530d32f081$var$NavigationType.pop) routerHistory.go(-1, false);
                    }).catch($a809ac530d32f081$var$noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) routerHistory.go(-info.delta, false);
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(// after navigation, all matched components are resolved
                toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta && // a new navigation has been triggered, so we do not want to revert, that will change the current history
                    // entry while a different route is displayed
                    !$a809ac530d32f081$export$873de56207a30e5a(failure, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ )) routerHistory.go(-info.delta, false);
                    else if (info.type === $a809ac530d32f081$var$NavigationType.pop && $a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ )) // manual change in hash history #916
                    // it's like a push but lacks the information of the direction
                    routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            })// avoid warnings in the console about uncaught rejections, they are logged by triggerErrors
            .catch($a809ac530d32f081$var$noop);
        });
    }
    // Initialization and Errors
    let readyHandlers = $a809ac530d32f081$var$useCallbacks();
    let errorListeners = $a809ac530d32f081$var$useCallbacks();
    let ready;
    /**
     * Trigger errorListeners added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else {
            $a809ac530d32f081$var$warn("uncaught error during route navigation:");
            console.error(error);
        }
        // reject the error no matter there were error listeners or not
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== $a809ac530d32f081$export$e44be9a9779c480b) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            // still not ready if an error happened
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve, reject])=>err ? reject(err) : resolve());
            readyHandlers.reset();
        }
        return err;
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!$a809ac530d32f081$var$isBrowser || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && $a809ac530d32f081$var$getSavedScrollPosition($a809ac530d32f081$var$getScrollKey(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $TusQn.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && $a809ac530d32f081$var$scrollToPosition(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            const router = this;
            app.component("RouterLink", $a809ac530d32f081$export$fce709ebdac448ed);
            app.component("RouterView", $a809ac530d32f081$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $01W3b.unref)(currentRoute)
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if ($a809ac530d32f081$var$isBrowser && // used for the initial navigation client side to avoid pushing
            // multiple times when the router is used in multiple apps
            !started && currentRoute.value === $a809ac530d32f081$export$e44be9a9779c480b) {
                // see above
                started = true;
                push(routerHistory.location).catch((err)=>{
                    $a809ac530d32f081$var$warn("Unexpected error when starting the router:", err);
                });
            }
            const reactiveRoute = {};
            for(const key in $a809ac530d32f081$export$e44be9a9779c480b)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide($a809ac530d32f081$export$b6c0da8b9dae491f, router);
            app.provide($a809ac530d32f081$export$3aca783e9a3e6e9e, (0, $01W3b.shallowReactive)(reactiveRoute));
            app.provide($a809ac530d32f081$export$54c8124bead129f8, currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = $a809ac530d32f081$export$e44be9a9779c480b;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            // TODO: this probably needs to be updated so it can be used by vue-termui
            if ($a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$addDevtools(app, router, matcher);
        }
    };
    // TODO: type this as NavigationGuardReturn or similar instead of any
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
function $a809ac530d32f081$var$extractChangingRecords(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) // the type doesn't matter because we are comparing per reference
        {
            if (!from.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */ function $a809ac530d32f081$export$9a302a45f65d0572() {
    return (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */ function $a809ac530d32f081$export$3f79f0b98112cf57() {
    return (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
}

});

parcelRegister("bRn2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a2684ef06535730$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $47c0h = parcelRequire("47c0h");
var $ey2ik = parcelRequire("ey2ik");
var $5zyMx = parcelRequire("5zyMx");
var $dT8YM = parcelRequire("dT8YM");
var $jKF2J = parcelRequire("jKF2J");
var $16nvB = parcelRequire("16nvB");
var $4Gqbx = parcelRequire("4Gqbx");
var $iDR1F = parcelRequire("iDR1F");
var $hKvje = parcelRequire("hKvje");
var $emKID = parcelRequire("emKID");
var $3maNl = parcelRequire("3maNl");
var $iqNgl = parcelRequire("iqNgl");

var $kxbCN = parcelRequire("kxbCN");

var $6RKL9 = parcelRequire("6RKL9");

var $7c6z4 = parcelRequire("7c6z4");

var $1rS06 = parcelRequire("1rS06");

var $deRlR = parcelRequire("deRlR");

var $gzF45 = parcelRequire("gzF45");
const $8a2684ef06535730$var$useCallEndPointWith = (endpoint)=>{
    const requestEndpointPath = `${(0, $gzF45.backendUrl)}/${(0, $01W3b.toValue)(endpoint)}`;
    const endpointData = (0, $01W3b.ref)("");
    const isLoading = (0, $01W3b.ref)(false);
    const userFriendlyError = (0, $01W3b.ref)("");
    const report500StatusCode = (0, $iqNgl.default)((0, $hKvje.default)(500, "status"), (0, $3maNl.default)(()=>{
        userFriendlyError.value = (0, $7c6z4.default).global.t("global.endpointError");
    }));
    const process = (0, $5zyMx.default)([
        [
            (0, $hKvje.default)(true, "error"),
            (0, $3maNl.default)((v)=>{
                userFriendlyError.value = (0, $iDR1F.default)("message", v);
            })
        ],
        [
            (0, $dT8YM.default)("error"),
            (0, $4Gqbx.default)((0, $iDR1F.default)("error"), (0, $3maNl.default)((v)=>{
                userFriendlyError.value = v;
            }))
        ],
        [
            (0, $emKID.default),
            (0, $3maNl.default)((v)=>{
                endpointData.value = v;
            })
        ]
    ]);
    const callEndpoint = async (options)=>{
        const { sessionId: sessionId } = (0, $1rS06.useGlobalState)();
        endpointData.value = "";
        userFriendlyError.value = "";
        isLoading.value = true;
        try {
            (0, $deRlR.default)(`fetching: ${requestEndpointPath}`);
            (0, $deRlR.default)("options: ", options);
            const response = await (0, $kxbCN.default)(fetch(requestEndpointPath, (0, $6RKL9.default)((0, $ey2ik.default)("sessionId", (0, $01W3b.toValue)(sessionId), options))));
            if ((0, $16nvB.default)(response)) throw new Error("Response is null");
            if (!response.ok) {
                const errorDetails = await response.json();
                throw new Error(`HTTP error! Status: ${response.status}, ${JSON.stringify(errorDetails)}, ${response}`);
            }
            (0, $deRlR.default)(response);
            report500StatusCode(response);
            const responseData = await (0, $jKF2J.default)((0, $hKvje.default)(204, "status"), (0, $47c0h.default)(""), async (r)=>r.json())(response);
            process(responseData);
            isLoading.value = false;
            return responseData;
        } catch (e) {
            userFriendlyError.value = (0, $7c6z4.default).global.t("global.endpointError");
            isLoading.value = false;
            (0, $deRlR.default)(e);
            console.error("Catched Error:", e);
            throw e;
        }
    };
    return {
        endpointData: endpointData,
        userFriendlyError: userFriendlyError,
        callEndpoint: callEndpoint,
        isLoading: isLoading
    };
};
var $8a2684ef06535730$export$2e2bcd8739ae039 = $8a2684ef06535730$var$useCallEndPointWith;

});
parcelRegister("47c0h", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ff120835f8592de$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");
/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      const t = R.always('Tee');
 *      t(); //=> 'Tee'
 */ var $2ff120835f8592de$var$always = /*#__PURE__*/ (0, $aSQee.default)(function always(val) {
    return function() {
        return val;
    };
});
var $2ff120835f8592de$export$2e2bcd8739ae039 = $2ff120835f8592de$var$always;

});
parcelRegister("aSQee", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ec77605189b4758$export$2e2bcd8739ae039);

var $jUoAu = parcelRequire("jUoAu");
function $7ec77605189b4758$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $jUoAu.default)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}

});
parcelRegister("jUoAu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7e651d63487d7d6$export$2e2bcd8739ae039);

var $abLR6 = parcelRequire("abLR6");
function $e7e651d63487d7d6$export$2e2bcd8739ae039(a) {
    return a === (0, $abLR6.default);
}

});
parcelRegister("abLR6", function(module, exports) {

$parcel$export(module.exports, "default", () => $76b00d8c58246b7f$export$2e2bcd8739ae039);
var $76b00d8c58246b7f$export$2e2bcd8739ae039 = {
    "@@functional/placeholder": true
};

});




parcelRegister("ey2ik", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9760553a5e17ba5$export$2e2bcd8739ae039);

var $io7kf = parcelRequire("io7kf");

var $l8CfQ = parcelRequire("l8CfQ");
/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig Idx -> a -> {k: v} -> {k: v}
 * @param {String|Number} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc, R.pick
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */ var $a9760553a5e17ba5$var$assoc = /*#__PURE__*/ (0, $io7kf.default)(function assoc(prop, val, obj) {
    return (0, $l8CfQ.default)([
        prop
    ], val, obj);
});
var $a9760553a5e17ba5$export$2e2bcd8739ae039 = $a9760553a5e17ba5$var$assoc;

});
parcelRegister("io7kf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d630269a6cff22d9$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $2jcOR = parcelRequire("2jcOR");

var $jUoAu = parcelRequire("jUoAu");
function $d630269a6cff22d9$export$2e2bcd8739ae039(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, $jUoAu.default)(a) ? f3 : (0, $2jcOR.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, $jUoAu.default)(a) && (0, $jUoAu.default)(b) ? f3 : (0, $jUoAu.default)(a) ? (0, $2jcOR.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $jUoAu.default)(b) ? (0, $2jcOR.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $aSQee.default)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, $jUoAu.default)(a) && (0, $jUoAu.default)(b) && (0, $jUoAu.default)(c) ? f3 : (0, $jUoAu.default)(a) && (0, $jUoAu.default)(b) ? (0, $2jcOR.default)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, $jUoAu.default)(a) && (0, $jUoAu.default)(c) ? (0, $2jcOR.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $jUoAu.default)(b) && (0, $jUoAu.default)(c) ? (0, $2jcOR.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $jUoAu.default)(a) ? (0, $aSQee.default)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, $jUoAu.default)(b) ? (0, $aSQee.default)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, $jUoAu.default)(c) ? (0, $aSQee.default)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}

});
parcelRegister("2jcOR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ae74cc5623cea21$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $jUoAu = parcelRequire("jUoAu");
function $1ae74cc5623cea21$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $jUoAu.default)(a) ? f2 : (0, $aSQee.default)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $jUoAu.default)(a) && (0, $jUoAu.default)(b) ? f2 : (0, $jUoAu.default)(a) ? (0, $aSQee.default)(function(_a) {
                    return fn(_a, b);
                }) : (0, $jUoAu.default)(b) ? (0, $aSQee.default)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}

});


parcelRegister("l8CfQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f63804dd4a880548$export$2e2bcd8739ae039);

var $io7kf = parcelRequire("io7kf");

var $5lqfp = parcelRequire("5lqfp");

var $e1REz = parcelRequire("e1REz");

var $iG2M7 = parcelRequire("iG2M7");

var $16nvB = parcelRequire("16nvB");
/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */ var $f63804dd4a880548$var$assocPath = /*#__PURE__*/ (0, $io7kf.default)(function assocPath(path, val, obj) {
    if (path.length === 0) return val;
    var idx = path[0];
    if (path.length > 1) {
        var nextObj = !(0, $16nvB.default)(obj) && (0, $5lqfp.default)(idx, obj) && typeof obj[idx] === "object" ? obj[idx] : (0, $e1REz.default)(path[1]) ? [] : {};
        val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
    }
    return (0, $iG2M7.default)(idx, val, obj);
});
var $f63804dd4a880548$export$2e2bcd8739ae039 = $f63804dd4a880548$var$assocPath;

});
parcelRegister("5lqfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e434626b2866668$export$2e2bcd8739ae039);
function $3e434626b2866668$export$2e2bcd8739ae039(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});

parcelRegister("e1REz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a36ac71f20068253$export$2e2bcd8739ae039);
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var $a36ac71f20068253$export$2e2bcd8739ae039 = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};

});

parcelRegister("iG2M7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d98e4d563993ddcf$export$2e2bcd8739ae039);

var $aTzs4 = parcelRequire("aTzs4");

var $e1REz = parcelRequire("e1REz");
function $d98e4d563993ddcf$export$2e2bcd8739ae039(prop, val, obj) {
    if ((0, $e1REz.default)(prop) && (0, $aTzs4.default)(obj)) {
        var arr = [].concat(obj);
        arr[prop] = val;
        return arr;
    }
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = val;
    return result;
}

});
parcelRegister("aTzs4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eea8a68c490b09b$export$2e2bcd8739ae039);
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var $7eea8a68c490b09b$export$2e2bcd8739ae039 = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};

});


parcelRegister("16nvB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cd8964fcc0096b1$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");
/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */ var $0cd8964fcc0096b1$var$isNil = /*#__PURE__*/ (0, $aSQee.default)(function isNil(x) {
    return x == null;
});
var $0cd8964fcc0096b1$export$2e2bcd8739ae039 = $0cd8964fcc0096b1$var$isNil;

});



parcelRegister("5zyMx", function(module, exports) {

$parcel$export(module.exports, "default", () => $40eb3393f03f13a1$export$2e2bcd8739ae039);

var $4Ddsy = parcelRequire("4Ddsy");

var $aSQee = parcelRequire("aSQee");

var $f7umK = parcelRequire("f7umK");

var $13hpE = parcelRequire("13hpE");

var $1mo4j = parcelRequire("1mo4j");
/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * **Please note**: This is not a direct substitute for a `switch` statement.
 * Remember that both elements of every pair passed to `cond` are *functions*,
 * and `cond` returns a function.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @see R.ifElse, R.unless, R.when
 * @example
 *
 *      const fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */ var $40eb3393f03f13a1$var$cond = /*#__PURE__*/ (0, $aSQee.default)(function cond(pairs) {
    var arity = (0, $1mo4j.default)((0, $13hpE.default), 0, (0, $f7umK.default)(function(pair) {
        return pair[0].length;
    }, pairs));
    return (0, $4Ddsy.default)(arity, function() {
        var idx = 0;
        while(idx < pairs.length){
            if (pairs[idx][0].apply(this, arguments)) return pairs[idx][1].apply(this, arguments);
            idx += 1;
        }
    });
});
var $40eb3393f03f13a1$export$2e2bcd8739ae039 = $40eb3393f03f13a1$var$cond;

});
parcelRegister("4Ddsy", function(module, exports) {

$parcel$export(module.exports, "default", () => $35f53eb613cc1282$export$2e2bcd8739ae039);
function $35f53eb613cc1282$export$2e2bcd8739ae039(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
}

});

parcelRegister("f7umK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b01f107cd36c1471$export$2e2bcd8739ae039);

var $i5mkn = parcelRequire("i5mkn");

var $2jcOR = parcelRequire("2jcOR");

var $6ZOtW = parcelRequire("6ZOtW");

var $h5Qzz = parcelRequire("h5Qzz");

var $5dqa2 = parcelRequire("5dqa2");

var $56Gyq = parcelRequire("56Gyq");

var $bNBEE = parcelRequire("bNBEE");
/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex, R.pluck, R.project
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var $b01f107cd36c1471$var$map = /*#__PURE__*/ (0, $2jcOR.default)(/*#__PURE__*/ (0, $6ZOtW.default)([
    "fantasy-land/map",
    "map"
], (0, $5dqa2.default), function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case "[object Function]":
            return (0, $56Gyq.default)(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case "[object Object]":
            return (0, $i5mkn.default)(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, (0, $bNBEE.default)(functor));
        default:
            return (0, $h5Qzz.default)(fn, functor);
    }
}));
var $b01f107cd36c1471$export$2e2bcd8739ae039 = $b01f107cd36c1471$var$map;

});
parcelRegister("i5mkn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2aa03739b387a2a$export$2e2bcd8739ae039);
function $d2aa03739b387a2a$export$2e2bcd8739ae039(reducer, acc, list) {
    var index = 0;
    var length = list.length;
    while(index < length){
        acc = reducer(acc, list[index]);
        index += 1;
    }
    return acc;
}

});

parcelRegister("6ZOtW", function(module, exports) {

$parcel$export(module.exports, "default", () => $517f9939d3c2c885$export$2e2bcd8739ae039);

var $aTzs4 = parcelRequire("aTzs4");

var $i6x2p = parcelRequire("i6x2p");
function $517f9939d3c2c885$export$2e2bcd8739ae039(methodNames, transducerCreator, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var obj = arguments[arguments.length - 1];
        if (!(0, $aTzs4.default)(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === "function") return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
                idx += 1;
            }
            if ((0, $i6x2p.default)(obj)) {
                var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}

});
parcelRegister("i6x2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2e26a2a9b11036b$export$2e2bcd8739ae039);
function $d2e26a2a9b11036b$export$2e2bcd8739ae039(obj) {
    return obj != null && typeof obj["@@transducer/step"] === "function";
}

});


parcelRegister("h5Qzz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c71baf20e55260bc$export$2e2bcd8739ae039);
function $c71baf20e55260bc$export$2e2bcd8739ae039(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}

});

parcelRegister("5dqa2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cc275a5f5c51b13$export$2e2bcd8739ae039);

var $eR2XP = parcelRequire("eR2XP");
var $3cc275a5f5c51b13$var$XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype["@@transducer/init"] = (0, $eR2XP.default).init;
    XMap.prototype["@@transducer/result"] = (0, $eR2XP.default).result;
    XMap.prototype["@@transducer/step"] = function(result, input) {
        return this.xf["@@transducer/step"](result, this.f(input));
    };
    return XMap;
}();
var $3cc275a5f5c51b13$var$_xmap = function _xmap(f) {
    return function(xf) {
        return new $3cc275a5f5c51b13$var$XMap(f, xf);
    };
};
var $3cc275a5f5c51b13$export$2e2bcd8739ae039 = $3cc275a5f5c51b13$var$_xmap;

});
parcelRegister("eR2XP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad08508171bdd1fe$export$2e2bcd8739ae039);
var $ad08508171bdd1fe$export$2e2bcd8739ae039 = {
    init: function() {
        return this.xf["@@transducer/init"]();
    },
    result: function(result) {
        return this.xf["@@transducer/result"](result);
    }
};

});


parcelRegister("56Gyq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7e85b0e9d353dc$export$2e2bcd8739ae039);

var $4Ddsy = parcelRequire("4Ddsy");

var $aSQee = parcelRequire("aSQee");

var $2jcOR = parcelRequire("2jcOR");

var $iJj5W = parcelRequire("iJj5W");
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $3b7e85b0e9d353dc$var$curryN = /*#__PURE__*/ (0, $2jcOR.default)(function curryN(length, fn) {
    if (length === 1) return (0, $aSQee.default)(fn);
    return (0, $4Ddsy.default)(length, (0, $iJj5W.default)(length, [], fn));
});
var $3b7e85b0e9d353dc$export$2e2bcd8739ae039 = $3b7e85b0e9d353dc$var$curryN;

});
parcelRegister("iJj5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $da2b3dc738142f7b$export$2e2bcd8739ae039);

var $4Ddsy = parcelRequire("4Ddsy");

var $jUoAu = parcelRequire("jUoAu");
function $da2b3dc738142f7b$export$2e2bcd8739ae039(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        var hasPlaceholder = false;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!(0, $jUoAu.default)(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!(0, $jUoAu.default)(result)) left -= 1;
            else hasPlaceholder = true;
            combinedIdx += 1;
        }
        return !hasPlaceholder && left <= 0 ? fn.apply(this, combined) : (0, $4Ddsy.default)(Math.max(0, left), $da2b3dc738142f7b$export$2e2bcd8739ae039(length, combined, fn));
    };
}

});


parcelRegister("bNBEE", function(module, exports) {

$parcel$export(module.exports, "default", () => $89717ab94613e822$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $5lqfp = parcelRequire("5lqfp");

var $hW4tV = parcelRequire("hW4tV");
// cover IE < 9 keys issues
var $89717ab94613e822$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable("toString");
var $89717ab94613e822$var$nonEnumerableProps = [
    "constructor",
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
];
// Safari bug
var $89717ab94613e822$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    "use strict";
    return arguments.propertyIsEnumerable("length");
}();
var $89717ab94613e822$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $89717ab94613e822$var$keys = typeof Object.keys === "function" && !$89717ab94613e822$var$hasArgsEnumBug ? /*#__PURE__*/ (0, $aSQee.default)(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ (0, $aSQee.default)(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $89717ab94613e822$var$hasArgsEnumBug && (0, $hW4tV.default)(obj);
    for(prop in obj)if ((0, $5lqfp.default)(prop, obj) && (!checkArgsLength || prop !== "length")) ks[ks.length] = prop;
    if ($89717ab94613e822$var$hasEnumBug) {
        nIdx = $89717ab94613e822$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $89717ab94613e822$var$nonEnumerableProps[nIdx];
            if ((0, $5lqfp.default)(prop, obj) && !$89717ab94613e822$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
var $89717ab94613e822$export$2e2bcd8739ae039 = $89717ab94613e822$var$keys;

});
parcelRegister("hW4tV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0eb546af0a6cb8d$export$2e2bcd8739ae039);

var $5lqfp = parcelRequire("5lqfp");
var $d0eb546af0a6cb8d$var$toString = Object.prototype.toString;
var $d0eb546af0a6cb8d$var$_isArguments = /*#__PURE__*/ function() {
    return $d0eb546af0a6cb8d$var$toString.call(arguments) === "[object Arguments]" ? function _isArguments(x) {
        return $d0eb546af0a6cb8d$var$toString.call(x) === "[object Arguments]";
    } : function _isArguments(x) {
        return (0, $5lqfp.default)("callee", x);
    };
}();
var $d0eb546af0a6cb8d$export$2e2bcd8739ae039 = $d0eb546af0a6cb8d$var$_isArguments;

});



parcelRegister("13hpE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c43941275b0bc8e$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");

var $a4m3P = parcelRequire("a4m3P");
/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */ var $0c43941275b0bc8e$var$max = /*#__PURE__*/ (0, $2jcOR.default)(function max(a, b) {
    if (a === b) return b;
    function safeMax(x, y) {
        if (x > y !== y > x) return y > x ? y : x;
        return undefined;
    }
    var maxByValue = safeMax(a, b);
    if (maxByValue !== undefined) return maxByValue;
    var maxByType = safeMax(typeof a, typeof b);
    if (maxByType !== undefined) return maxByType === typeof a ? a : b;
    var stringA = (0, $a4m3P.default)(a);
    var maxByStringValue = safeMax(stringA, (0, $a4m3P.default)(b));
    if (maxByStringValue !== undefined) return maxByStringValue === stringA ? a : b;
    return b;
});
var $0c43941275b0bc8e$export$2e2bcd8739ae039 = $0c43941275b0bc8e$var$max;

});
parcelRegister("a4m3P", function(module, exports) {

$parcel$export(module.exports, "default", () => $754b63e580f0fde1$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $149EV = parcelRequire("149EV");
/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */ var $754b63e580f0fde1$var$toString = /*#__PURE__*/ (0, $aSQee.default)(function toString(val) {
    return (0, $149EV.default)(val, []);
});
var $754b63e580f0fde1$export$2e2bcd8739ae039 = $754b63e580f0fde1$var$toString;

});
parcelRegister("149EV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c6da83ecedaf41e$export$2e2bcd8739ae039);

var $lWKir = parcelRequire("lWKir");

var $h5Qzz = parcelRequire("h5Qzz");

var $4aERJ = parcelRequire("4aERJ");

var $dSSEN = parcelRequire("dSSEN");

var $bNBEE = parcelRequire("bNBEE");

var $eamAk = parcelRequire("eamAk");
function $0c6da83ecedaf41e$export$2e2bcd8739ae039(x, seen) {
    var recur = function recur(y) {
        var xs = seen.concat([
            x
        ]);
        return (0, $lWKir.default)(y, xs) ? "<Circular>" : $0c6da83ecedaf41e$export$2e2bcd8739ae039(y, xs);
    };
    //  mapPairs :: (Object, [String]) -> [String]
    var mapPairs = function(obj, keys) {
        return (0, $h5Qzz.default)(function(k) {
            return (0, $4aERJ.default)(k) + ": " + recur(obj[k]);
        }, keys.slice().sort());
    };
    switch(Object.prototype.toString.call(x)){
        case "[object Arguments]":
            return "(function() { return arguments; }(" + (0, $h5Qzz.default)(recur, x).join(", ") + "))";
        case "[object Array]":
            return "[" + (0, $h5Qzz.default)(recur, x).concat(mapPairs(x, (0, $eamAk.default)(function(k) {
                return /^\d+$/.test(k);
            }, (0, $bNBEE.default)(x)))).join(", ") + "]";
        case "[object Boolean]":
            return typeof x === "object" ? "new Boolean(" + recur(x.valueOf()) + ")" : x.toString();
        case "[object Date]":
            return "new Date(" + (isNaN(x.valueOf()) ? recur(NaN) : (0, $4aERJ.default)((0, $dSSEN.default)(x))) + ")";
        case "[object Map]":
            return "new Map(" + recur(Array.from(x)) + ")";
        case "[object Null]":
            return "null";
        case "[object Number]":
            return typeof x === "object" ? "new Number(" + recur(x.valueOf()) + ")" : 1 / x === -Infinity ? "-0" : x.toString(10);
        case "[object Set]":
            return "new Set(" + recur(Array.from(x).sort()) + ")";
        case "[object String]":
            return typeof x === "object" ? "new String(" + recur(x.valueOf()) + ")" : (0, $4aERJ.default)(x);
        case "[object Undefined]":
            return "undefined";
        default:
            if (typeof x.toString === "function") {
                var repr = x.toString();
                if (repr !== "[object Object]") return repr;
            }
            return "{" + mapPairs(x, (0, $bNBEE.default)(x)).join(", ") + "}";
    }
}

});
parcelRegister("lWKir", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa2ed402645a184$export$2e2bcd8739ae039);

var $9G10s = parcelRequire("9G10s");
function $ffa2ed402645a184$export$2e2bcd8739ae039(a, list) {
    return (0, $9G10s.default)(list, a, 0) >= 0;
}

});
parcelRegister("9G10s", function(module, exports) {

$parcel$export(module.exports, "default", () => $70b8d125c84c0682$export$2e2bcd8739ae039);

var $l7ahT = parcelRequire("l7ahT");
function $70b8d125c84c0682$export$2e2bcd8739ae039(list, a, idx) {
    var inf, item;
    // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === "function") switch(typeof a){
        case "number":
            if (a === 0) {
                // manually crawl the list to distinguish between +0 and -0
                inf = 1 / a;
                while(idx < list.length){
                    item = list[idx];
                    if (item === 0 && 1 / item === inf) return idx;
                    idx += 1;
                }
                return -1;
            } else if (a !== a) {
                // NaN
                while(idx < list.length){
                    item = list[idx];
                    if (typeof item === "number" && item !== item) return idx;
                    idx += 1;
                }
                return -1;
            }
            // non-zero numbers can utilise Set
            return list.indexOf(a, idx);
        // all these types can utilise Set
        case "string":
        case "boolean":
        case "function":
        case "undefined":
            return list.indexOf(a, idx);
        case "object":
            if (a === null) // null can utilise Set
            return list.indexOf(a, idx);
    }
    // anything else not covered above, defer to R.equals
    while(idx < list.length){
        if ((0, $l7ahT.default)(list[idx], a)) return idx;
        idx += 1;
    }
    return -1;
}

});
parcelRegister("l7ahT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5f23b53da900217$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");

var $lVNYu = parcelRequire("lVNYu");
/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var $f5f23b53da900217$var$equals = /*#__PURE__*/ (0, $2jcOR.default)(function equals(a, b) {
    return (0, $lVNYu.default)(a, b, [], []);
});
var $f5f23b53da900217$export$2e2bcd8739ae039 = $f5f23b53da900217$var$equals;

});
parcelRegister("lVNYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff75afc2044d59c0$export$2e2bcd8739ae039);

var $bp6nt = parcelRequire("bp6nt");

var $3z8SR = parcelRequire("3z8SR");

var $1eEUJ = parcelRequire("1eEUJ");

var $5lqfp = parcelRequire("5lqfp");

var $cwzjB = parcelRequire("cwzjB");

var $bNBEE = parcelRequire("bNBEE");

var $7QtL4 = parcelRequire("7QtL4");
/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparison of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function $ff75afc2044d59c0$var$_uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = (0, $bp6nt.default)(aIterator);
    var b = (0, $bp6nt.default)(bIterator);
    function eq(_a, _b) {
        return $ff75afc2044d59c0$export$2e2bcd8739ae039(_a, _b, stackA.slice(), stackB.slice());
    }
    // if *a* array contains any element that is not included in *b*
    return !(0, $3z8SR.default)(function(b, aItem) {
        return !(0, $3z8SR.default)(eq, aItem, b);
    }, b, a);
}
function $ff75afc2044d59c0$export$2e2bcd8739ae039(a, b, stackA, stackB) {
    if ((0, $cwzjB.default)(a, b)) return true;
    var typeA = (0, $7QtL4.default)(a);
    if (typeA !== (0, $7QtL4.default)(b)) return false;
    if (typeof a["fantasy-land/equals"] === "function" || typeof b["fantasy-land/equals"] === "function") return typeof a["fantasy-land/equals"] === "function" && a["fantasy-land/equals"](b) && typeof b["fantasy-land/equals"] === "function" && b["fantasy-land/equals"](a);
    if (typeof a.equals === "function" || typeof b.equals === "function") return typeof a.equals === "function" && a.equals(b) && typeof b.equals === "function" && b.equals(a);
    switch(typeA){
        case "Arguments":
        case "Array":
        case "Object":
            if (typeof a.constructor === "function" && (0, $1eEUJ.default)(a.constructor) === "Promise") return a === b;
            break;
        case "Boolean":
        case "Number":
        case "String":
            if (!(typeof a === typeof b && (0, $cwzjB.default)(a.valueOf(), b.valueOf()))) return false;
            break;
        case "Date":
            if (!(0, $cwzjB.default)(a.valueOf(), b.valueOf())) return false;
            break;
        case "Error":
            return a.name === b.name && a.message === b.message;
        case "RegExp":
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case "Map":
            if (a.size !== b.size) return false;
            return $ff75afc2044d59c0$var$_uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Set":
            if (a.size !== b.size) return false;
            return $ff75afc2044d59c0$var$_uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Arguments":
        case "Array":
        case "Object":
        case "Boolean":
        case "Number":
        case "String":
        case "Date":
        case "Error":
        case "RegExp":
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "ArrayBuffer":
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = (0, $bNBEE.default)(a);
    if (keysA.length !== (0, $bNBEE.default)(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!((0, $5lqfp.default)(key, b) && $ff75afc2044d59c0$export$2e2bcd8739ae039(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}

});
parcelRegister("bp6nt", function(module, exports) {

$parcel$export(module.exports, "default", () => $84d6f9f9a58cca82$export$2e2bcd8739ae039);
function $84d6f9f9a58cca82$export$2e2bcd8739ae039(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}

});

parcelRegister("3z8SR", function(module, exports) {

$parcel$export(module.exports, "default", () => $298b882271db9e5b$export$2e2bcd8739ae039);
function $298b882271db9e5b$export$2e2bcd8739ae039(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}

});

parcelRegister("1eEUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e66d5ef9194bf29$export$2e2bcd8739ae039);
function $0e66d5ef9194bf29$export$2e2bcd8739ae039(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? "" : match[1];
}

});

parcelRegister("cwzjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $91e3de09550f1416$export$2e2bcd8739ae039);
// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $91e3de09550f1416$var$_objectIs(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
}
var $91e3de09550f1416$export$2e2bcd8739ae039 = typeof Object.is === "function" ? Object.is : $91e3de09550f1416$var$_objectIs;

});

parcelRegister("7QtL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b647918ed6a8a39$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");
/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig * -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(async () => {}); //=> "AsyncFunction"
 *      R.type(undefined); //=> "Undefined"
 *      R.type(BigInt(123)); //=> "BigInt"
 */ var $5b647918ed6a8a39$var$type = /*#__PURE__*/ (0, $aSQee.default)(function type(val) {
    return val === null ? "Null" : val === undefined ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
var $5b647918ed6a8a39$export$2e2bcd8739ae039 = $5b647918ed6a8a39$var$type;

});





parcelRegister("4aERJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3097cbacd8f99590$export$2e2bcd8739ae039);
function $3097cbacd8f99590$export$2e2bcd8739ae039(s) {
    var escaped = s.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b") // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
    return '"' + escaped.replace(/"/g, '\\"') + '"';
}

});

parcelRegister("dSSEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1bab742c708109e$export$2e2bcd8739ae039);
/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */ var $a1bab742c708109e$var$pad = function pad(n) {
    return (n < 10 ? "0" : "") + n;
};
var $a1bab742c708109e$var$_toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString(d) {
    return d.toISOString();
} : function _toISOString(d) {
    return d.getUTCFullYear() + "-" + $a1bab742c708109e$var$pad(d.getUTCMonth() + 1) + "-" + $a1bab742c708109e$var$pad(d.getUTCDate()) + "T" + $a1bab742c708109e$var$pad(d.getUTCHours()) + ":" + $a1bab742c708109e$var$pad(d.getUTCMinutes()) + ":" + $a1bab742c708109e$var$pad(d.getUTCSeconds()) + "." + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + "Z";
};
var $a1bab742c708109e$export$2e2bcd8739ae039 = $a1bab742c708109e$var$_toISOString;

});

parcelRegister("eamAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a50384c73326e174$export$2e2bcd8739ae039);

var $4Ie0O = parcelRequire("4Ie0O");

var $2jcOR = parcelRequire("2jcOR");

var $faIDi = parcelRequire("faIDi");
/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 !== 0;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $a50384c73326e174$var$reject = /*#__PURE__*/ (0, $2jcOR.default)(function reject(pred, filterable) {
    return (0, $faIDi.default)((0, $4Ie0O.default)(pred), filterable);
});
var $a50384c73326e174$export$2e2bcd8739ae039 = $a50384c73326e174$var$reject;

});
parcelRegister("4Ie0O", function(module, exports) {

$parcel$export(module.exports, "default", () => $36e62400fc48e701$export$2e2bcd8739ae039);
function $36e62400fc48e701$export$2e2bcd8739ae039(f) {
    return function() {
        return !f.apply(this, arguments);
    };
}

});

parcelRegister("faIDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ba695691479374$export$2e2bcd8739ae039);

var $i5mkn = parcelRequire("i5mkn");

var $2jcOR = parcelRequire("2jcOR");

var $6ZOtW = parcelRequire("6ZOtW");

var $kM5uQ = parcelRequire("kM5uQ");

var $Ufvzo = parcelRequire("Ufvzo");

var $93eUK = parcelRequire("93eUK");

var $bNBEE = parcelRequire("bNBEE");
/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @category Object
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $b0ba695691479374$var$filter = /*#__PURE__*/ (0, $2jcOR.default)(/*#__PURE__*/ (0, $6ZOtW.default)([
    "fantasy-land/filter",
    "filter"
], (0, $93eUK.default), function(pred, filterable) {
    return (0, $Ufvzo.default)(filterable) ? (0, $i5mkn.default)(function(acc, key) {
        if (pred(filterable[key])) acc[key] = filterable[key];
        return acc;
    }, {}, (0, $bNBEE.default)(filterable)) : // else
    (0, $kM5uQ.default)(pred, filterable);
}));
var $b0ba695691479374$export$2e2bcd8739ae039 = $b0ba695691479374$var$filter;

});
parcelRegister("kM5uQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1fc8dd126aa3213$export$2e2bcd8739ae039);
function $f1fc8dd126aa3213$export$2e2bcd8739ae039(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while(idx < len){
        if (fn(list[idx])) result[result.length] = list[idx];
        idx += 1;
    }
    return result;
}

});

parcelRegister("Ufvzo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a9142ae7089a2b4$export$2e2bcd8739ae039);
function $0a9142ae7089a2b4$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
}

});

parcelRegister("93eUK", function(module, exports) {

$parcel$export(module.exports, "default", () => $696ff683ca156b87$export$2e2bcd8739ae039);

var $eR2XP = parcelRequire("eR2XP");
var $696ff683ca156b87$var$XFilter = /*#__PURE__*/ function() {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype["@@transducer/init"] = (0, $eR2XP.default).init;
    XFilter.prototype["@@transducer/result"] = (0, $eR2XP.default).result;
    XFilter.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : result;
    };
    return XFilter;
}();
function $696ff683ca156b87$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $696ff683ca156b87$var$XFilter(f, xf);
    };
}

});






parcelRegister("1mo4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fda840d89c87320$export$2e2bcd8739ae039);

var $io7kf = parcelRequire("io7kf");

var $fHLsp = parcelRequire("fHLsp");

var $e5xOm = parcelRequire("e5xOm");
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Be cautious of mutating and returning the accumulator. If you reuse it across
 * invocations, it will continue to accumulate onto the same value. The general
 * recommendation is to always return a new value. If you can't do so for
 * performance reasons, then be sure to reinitialize the accumulator on each
 * invocation.
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $0fda840d89c87320$var$reduce = /*#__PURE__*/ (0, $io7kf.default)(function(xf, acc, list) {
    return (0, $fHLsp.default)(typeof xf === "function" ? (0, $e5xOm.default)(xf) : xf, acc, list);
});
var $0fda840d89c87320$export$2e2bcd8739ae039 = $0fda840d89c87320$var$reduce;

});
parcelRegister("fHLsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6efaf32de038477$export$2e2bcd8739ae039);

var $gjl6R = parcelRequire("gjl6R");

var $dJnlt = parcelRequire("dJnlt");

var $2l9z7 = parcelRequire("2l9z7");
function $b6efaf32de038477$var$_xIterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf["@@transducer/step"](acc, step.value);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        step = iter.next();
    }
    return xf["@@transducer/result"](acc);
}
function $b6efaf32de038477$var$_xMethodReduce(xf, acc, obj, methodName) {
    return xf["@@transducer/result"](obj[methodName]((0, $2l9z7.default)(xf["@@transducer/step"], xf), acc));
}
var $b6efaf32de038477$var$_xReduce = /*#__PURE__*/ (0, $gjl6R.default)((0, $dJnlt.default), $b6efaf32de038477$var$_xMethodReduce, $b6efaf32de038477$var$_xIterableReduce);
var $b6efaf32de038477$export$2e2bcd8739ae039 = $b6efaf32de038477$var$_xReduce;

});
parcelRegister("gjl6R", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdfecba04769b2f2$export$2e2bcd8739ae039);

var $3CVBE = parcelRequire("3CVBE");
var $bdfecba04769b2f2$var$symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function $bdfecba04769b2f2$export$2e2bcd8739ae039(arrayReduce, methodReduce, iterableReduce) {
    return function _reduce(xf, acc, list) {
        if ((0, $3CVBE.default)(list)) return arrayReduce(xf, acc, list);
        if (list == null) return acc;
        if (typeof list["fantasy-land/reduce"] === "function") return methodReduce(xf, acc, list, "fantasy-land/reduce");
        if (list[$bdfecba04769b2f2$var$symIterator] != null) return iterableReduce(xf, acc, list[$bdfecba04769b2f2$var$symIterator]());
        if (typeof list.next === "function") return iterableReduce(xf, acc, list);
        if (typeof list.reduce === "function") return methodReduce(xf, acc, list, "reduce");
        throw new TypeError("reduce: list must be array or iterable");
    };
}

});
parcelRegister("3CVBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a419b1d87c69d2d$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $aTzs4 = parcelRequire("aTzs4");

var $lBqhj = parcelRequire("lBqhj");
/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 *      _isArrayLike({nodeType: 1, length: 1}) // => false
 */ var $2a419b1d87c69d2d$var$_isArrayLike = /*#__PURE__*/ (0, $aSQee.default)(function isArrayLike(x) {
    if ((0, $aTzs4.default)(x)) return true;
    if (!x) return false;
    if (typeof x !== "object") return false;
    if ((0, $lBqhj.default)(x)) return false;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
var $2a419b1d87c69d2d$export$2e2bcd8739ae039 = $2a419b1d87c69d2d$var$_isArrayLike;

});
parcelRegister("lBqhj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fba16ff7050dd77f$export$2e2bcd8739ae039);
function $fba16ff7050dd77f$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object String]";
}

});



parcelRegister("dJnlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $029469a637191b6a$export$2e2bcd8739ae039);
function $029469a637191b6a$export$2e2bcd8739ae039(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf["@@transducer/step"](acc, list[idx]);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx += 1;
    }
    return xf["@@transducer/result"](acc);
}

});

parcelRegister("2l9z7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b44f66a6f82142b$export$2e2bcd8739ae039);

var $4Ddsy = parcelRequire("4Ddsy");

var $2jcOR = parcelRequire("2jcOR");
/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $1b44f66a6f82142b$var$bind = /*#__PURE__*/ (0, $2jcOR.default)(function bind(fn, thisObj) {
    return (0, $4Ddsy.default)(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
var $1b44f66a6f82142b$export$2e2bcd8739ae039 = $1b44f66a6f82142b$var$bind;

});


parcelRegister("e5xOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a41bc283a458b174$export$2e2bcd8739ae039);
var $a41bc283a458b174$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype["@@transducer/init"] = function() {
        throw new Error("init not implemented on XWrap");
    };
    XWrap.prototype["@@transducer/result"] = function(acc) {
        return acc;
    };
    XWrap.prototype["@@transducer/step"] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $a41bc283a458b174$export$2e2bcd8739ae039(fn) {
    return new $a41bc283a458b174$var$XWrap(fn);
}

});



parcelRegister("dT8YM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1c76089443586f4$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");

var $lvzmo = parcelRequire("lvzmo");
/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      const hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      const point = {x: 0, y: 0};
 *      const pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */ var $a1c76089443586f4$var$has = /*#__PURE__*/ (0, $2jcOR.default)(function has(prop, obj) {
    return (0, $lvzmo.default)([
        prop
    ], obj);
});
var $a1c76089443586f4$export$2e2bcd8739ae039 = $a1c76089443586f4$var$has;

});
parcelRegister("lvzmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa87ec08b45b57a0$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");

var $5lqfp = parcelRequire("5lqfp");

var $16nvB = parcelRequire("16nvB");
/**
 * Returns whether or not a path exists in an object. Only the object's
 * own properties are checked.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {a} -> Boolean
 * @param {Array} path The path to use.
 * @param {Object} obj The object to check the path in.
 * @return {Boolean} Whether the path exists.
 * @see R.has
 * @example
 *
 *      R.hasPath(['a', 'b'], {a: {b: 2}});         // => true
 *      R.hasPath(['a', 'b'], {a: {b: undefined}}); // => true
 *      R.hasPath(['a', 'b'], {a: {c: 2}});         // => false
 *      R.hasPath(['a', 'b'], {});                  // => false
 */ var $fa87ec08b45b57a0$var$hasPath = /*#__PURE__*/ (0, $2jcOR.default)(function hasPath(_path, obj) {
    if (_path.length === 0 || (0, $16nvB.default)(obj)) return false;
    var val = obj;
    var idx = 0;
    while(idx < _path.length){
        if (!(0, $16nvB.default)(val) && (0, $5lqfp.default)(_path[idx], val)) {
            val = val[_path[idx]];
            idx += 1;
        } else return false;
    }
    return true;
});
var $fa87ec08b45b57a0$export$2e2bcd8739ae039 = $fa87ec08b45b57a0$var$hasPath;

});


parcelRegister("jKF2J", function(module, exports) {

$parcel$export(module.exports, "default", () => $e612267c9d2f1844$export$2e2bcd8739ae039);

var $io7kf = parcelRequire("io7kf");

var $56Gyq = parcelRequire("56Gyq");
/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * Note that `ifElse` takes its arity from the longest of the three functions passed to it.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when, R.cond
 * @example
 *
 *      const incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({ count: 1 }); //=> { count: 2 }
 *      incCount({});           //=> { count: 1 }
 */ var $e612267c9d2f1844$var$ifElse = /*#__PURE__*/ (0, $io7kf.default)(function ifElse(condition, onTrue, onFalse) {
    return (0, $56Gyq.default)(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
        return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    });
});
var $e612267c9d2f1844$export$2e2bcd8739ae039 = $e612267c9d2f1844$var$ifElse;

});

parcelRegister("4Gqbx", function(module, exports) {

$parcel$export(module.exports, "default", () => $368f657a44b4e40a$export$2e2bcd8739ae039);

var $4Ddsy = parcelRequire("4Ddsy");

var $8BhjG = parcelRequire("8BhjG");

var $1mo4j = parcelRequire("1mo4j");

var $eZ8oV = parcelRequire("eZ8oV");
function $368f657a44b4e40a$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("pipe requires at least one argument");
    return (0, $4Ddsy.default)(arguments[0].length, (0, $1mo4j.default)((0, $8BhjG.default), arguments[0], (0, $eZ8oV.default)(arguments)));
}

});
parcelRegister("8BhjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $642f361a13081dbc$export$2e2bcd8739ae039);
function $642f361a13081dbc$export$2e2bcd8739ae039(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}

});

parcelRegister("eZ8oV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae8d4779ceb1bf28$export$2e2bcd8739ae039);

var $iC1iK = parcelRequire("iC1iK");

var $aSQee = parcelRequire("aSQee");

var $gRi1d = parcelRequire("gRi1d");
/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $ae8d4779ceb1bf28$var$tail = /*#__PURE__*/ (0, $aSQee.default)(/*#__PURE__*/ (0, $iC1iK.default)("tail", /*#__PURE__*/ (0, $gRi1d.default)(1, Infinity)));
var $ae8d4779ceb1bf28$export$2e2bcd8739ae039 = $ae8d4779ceb1bf28$var$tail;

});
parcelRegister("iC1iK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8ccc90b207990fc$export$2e2bcd8739ae039);

var $aTzs4 = parcelRequire("aTzs4");
function $d8ccc90b207990fc$export$2e2bcd8739ae039(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, $aTzs4.default)(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}

});

parcelRegister("gRi1d", function(module, exports) {

$parcel$export(module.exports, "default", () => $c45f92b9793bed27$export$2e2bcd8739ae039);

var $iC1iK = parcelRequire("iC1iK");

var $io7kf = parcelRequire("io7kf");
/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $c45f92b9793bed27$var$slice = /*#__PURE__*/ (0, $io7kf.default)(/*#__PURE__*/ (0, $iC1iK.default)("slice", function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
var $c45f92b9793bed27$export$2e2bcd8739ae039 = $c45f92b9793bed27$var$slice;

});



parcelRegister("iDR1F", function(module, exports) {

$parcel$export(module.exports, "default", () => $d925005fae164d75$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");

var $e1REz = parcelRequire("e1REz");

var $cJy4o = parcelRequire("cJy4o");
/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx -> {s: a} -> a | Undefined
 * @param {String|Number} p The property name or array index
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path, R.props, R.pluck, R.project, R.nth
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.prop(0, [100]); //=> 100
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */ var $d925005fae164d75$var$prop = /*#__PURE__*/ (0, $2jcOR.default)(function prop(p, obj) {
    if (obj == null) return;
    return (0, $e1REz.default)(p) ? (0, $cJy4o.default)(p, obj) : obj[p];
});
var $d925005fae164d75$export$2e2bcd8739ae039 = $d925005fae164d75$var$prop;

});
parcelRegister("cJy4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $94541d93beca63cd$export$2e2bcd8739ae039);

var $lBqhj = parcelRequire("lBqhj");
function $94541d93beca63cd$export$2e2bcd8739ae039(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return (0, $lBqhj.default)(list) ? list.charAt(idx) : list[idx];
}

});


parcelRegister("hKvje", function(module, exports) {

$parcel$export(module.exports, "default", () => $cebf04ec59ada341$export$2e2bcd8739ae039);

var $io7kf = parcelRequire("io7kf");

var $iDR1F = parcelRequire("iDR1F");

var $l7ahT = parcelRequire("l7ahT");
/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.whereEq`](#whereEq),
 * and test nested path property with [`R.pathEq`](#pathEq).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig a -> String -> Object -> Boolean
 * @param {*} val The value to compare the property with
 * @param {String} name the specified object property's key
 * @param {*} obj The object to check the property in
 * @return {Boolean} `true` if the value equals the specified object property,
 *         `false` otherwise.
 * @see R.whereEq, R.pathEq, R.propSatisfies, R.equals
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      const kids = [abby, fred, rusty, alois];
 *      const hasBrownHair = R.propEq('brown', 'hair');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */ var $cebf04ec59ada341$var$propEq = /*#__PURE__*/ (0, $io7kf.default)(function propEq(val, name, obj) {
    return (0, $l7ahT.default)(val, (0, $iDR1F.default)(name, obj));
});
var $cebf04ec59ada341$export$2e2bcd8739ae039 = $cebf04ec59ada341$var$propEq;

});

parcelRegister("emKID", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7575c2b1a08b3b4$export$2e2bcd8739ae039);
/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.F
 * @example
 *
 *      R.T(); //=> true
 */ var $a7575c2b1a08b3b4$var$T = function() {
    return true;
};
var $a7575c2b1a08b3b4$export$2e2bcd8739ae039 = $a7575c2b1a08b3b4$var$T;

});

parcelRegister("3maNl", function(module, exports) {

$parcel$export(module.exports, "default", () => $271bccc994e648d9$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");

var $6ZOtW = parcelRequire("6ZOtW");

var $3TjyC = parcelRequire("3TjyC");
/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      const sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = (f(a), a)
 */ var $271bccc994e648d9$var$tap = /*#__PURE__*/ (0, $2jcOR.default)(/*#__PURE__*/ (0, $6ZOtW.default)([], (0, $3TjyC.default), function tap(fn, x) {
    fn(x);
    return x;
}));
var $271bccc994e648d9$export$2e2bcd8739ae039 = $271bccc994e648d9$var$tap;

});
parcelRegister("3TjyC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d55addb98a0ff14$export$2e2bcd8739ae039);

var $eR2XP = parcelRequire("eR2XP");
var $2d55addb98a0ff14$var$XTap = /*#__PURE__*/ function() {
    function XTap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTap.prototype["@@transducer/init"] = (0, $eR2XP.default).init;
    XTap.prototype["@@transducer/result"] = (0, $eR2XP.default).result;
    XTap.prototype["@@transducer/step"] = function(result, input) {
        this.f(input);
        return this.xf["@@transducer/step"](result, input);
    };
    return XTap;
}();
function $2d55addb98a0ff14$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $2d55addb98a0ff14$var$XTap(f, xf);
    };
}

});


parcelRegister("iqNgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6b0de3fc120c2b2$export$2e2bcd8739ae039);

var $io7kf = parcelRequire("io7kf");
/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> b) -> a -> a | b
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless, R.cond
 * @example
 *
 *      // truncate :: String -> String
 *      const truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */ var $d6b0de3fc120c2b2$var$when = /*#__PURE__*/ (0, $io7kf.default)(function when(pred, whenTrueFn, x) {
    return pred(x) ? whenTrueFn(x) : x;
});
var $d6b0de3fc120c2b2$export$2e2bcd8739ae039 = $d6b0de3fc120c2b2$var$when;

});

parcelRegister("kxbCN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef2fe8277e2b8915$export$2e2bcd8739ae039);

var $deRlR = parcelRequire("deRlR");

var $5zyMx = parcelRequire("5zyMx");
var $hKvje = parcelRequire("hKvje");
var $emKID = parcelRequire("emKID");

var $4OcZ0 = parcelRequire("4OcZ0");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $26BmW = parcelRequire("26BmW");

var $1rS06 = parcelRequire("1rS06");
const $ef2fe8277e2b8915$var$isSessionTimeOut = (0, $hKvje.default)(401, "status");
const $ef2fe8277e2b8915$var$isAlreadyAuthenticated = (0, $hKvje.default)(409, "status");
const { userState: $ef2fe8277e2b8915$var$userState } = (0, $1rS06.useGlobalState)();
const $ef2fe8277e2b8915$var$withRedirectOnUnauthorizedStatusCode = (0, $5zyMx.default)([
    [
        $ef2fe8277e2b8915$var$isSessionTimeOut,
        async ()=>{
            await (0, $4OcZ0.default).push({
                name: "login"
            });
            return null;
        }
    ],
    [
        $ef2fe8277e2b8915$var$isAlreadyAuthenticated,
        ()=>{
            (0, $26BmW.goToHomeScreenFor)((0, $01W3b.toRaw)($ef2fe8277e2b8915$var$userState));
            return null;
        }
    ],
    [
        (0, $emKID.default),
        (responseObject)=>responseObject
    ]
]);
const $ef2fe8277e2b8915$var$sessionAwareApiCall = async (apiCall)=>{
    const response = await apiCall;
    (0, $deRlR.default)(response);
    return $ef2fe8277e2b8915$var$withRedirectOnUnauthorizedStatusCode(response);
};
var $ef2fe8277e2b8915$export$2e2bcd8739ae039 = $ef2fe8277e2b8915$var$sessionAwareApiCall;

});
parcelRegister("deRlR", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a35f7ac5844f355$export$2e2bcd8739ae039);

var $3maNl = parcelRequire("3maNl");
var $iqNgl = parcelRequire("iqNgl");

var $gzF45 = parcelRequire("gzF45");
const $9a35f7ac5844f355$var$logInDevMode = (0, $iqNgl.default)((0, $gzF45.isLocalDevMode), (0, $3maNl.default)((v)=>console.log(v)));
var $9a35f7ac5844f355$export$2e2bcd8739ae039 = $9a35f7ac5844f355$var$logInDevMode;

});
parcelRegister("gzF45", function(module, exports) {

$parcel$export(module.exports, "backendUrl", () => $c10fc4dd470a6ad9$export$f49b885ad9e68da5);
$parcel$export(module.exports, "isLocalDevMode", () => $c10fc4dd470a6ad9$export$c060201668c29257);
$parcel$export(module.exports, "isNoAuthMode", () => $c10fc4dd470a6ad9$export$77452601c3a5b68e);
const $c10fc4dd470a6ad9$export$f49b885ad9e68da5 = "https://api.cyberalarm.training";
const $c10fc4dd470a6ad9$export$c060201668c29257 = ()=>false;
const $c10fc4dd470a6ad9$export$77452601c3a5b68e = ()=>false;
if ($c10fc4dd470a6ad9$export$c060201668c29257) {
    // Print info of used environment vars in local dev mode
    console.log(`Used Environment: ${"prod"}`);
    console.log(`BackendURL: ${$c10fc4dd470a6ad9$export$f49b885ad9e68da5}`);
    console.log(`IsLocalDevMode: ${$c10fc4dd470a6ad9$export$c060201668c29257()}`);
    console.log(`isNoAuthMode: ${$c10fc4dd470a6ad9$export$77452601c3a5b68e()}`);
}

});


parcelRegister("4OcZ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3805e7143c36831c$export$2e2bcd8739ae039);

var $73mM4 = parcelRequire("73mM4");

var $580JV = parcelRequire("580JV");

var $ynPL8 = parcelRequire("ynPL8");

var $7WABx = parcelRequire("7WABx");

var $1rS06 = parcelRequire("1rS06");

var $fAzx8 = parcelRequire("fAzx8");

var $fpXBf = parcelRequire("fpXBf");

var $bgAOC = parcelRequire("bgAOC");

var $99Mjh = parcelRequire("99Mjh");

var $82LGi = parcelRequire("82LGi");

var $bY4xD = parcelRequire("bY4xD");

var $jHZ5W = parcelRequire("jHZ5W");

var $bvEvf = parcelRequire("bvEvf");















const $3805e7143c36831c$var$router = (0, $73mM4.createRouter)({
    history: (0, $73mM4.createWebHistory)(undefined),
    routes: [
        {
            path: "/:locale?",
            component: (0, $73mM4.RouterView),
            beforeEnter: (0, $580JV.default).routeMiddleware,
            children: [
                {
                    path: "",
                    name: "home",
                    component: (0, $fpXBf.default),
                    redirect: {
                        name: "landing"
                    },
                    children: [
                        {
                            path: "",
                            name: "landing",
                            alias: "",
                            component: (0, $jHZ5W.default)
                        }
                    ]
                },
                {
                    path: "research-project",
                    name: "research-project",
                    component: (0, $bvEvf.default)
                },
                {
                    path: "register",
                    name: "register",
                    component: (0, $bY4xD.default)
                },
                {
                    path: "register/payment/:success",
                    name: "register-payment-return",
                    component: (0, $bY4xD.default)
                },
                {
                    path: "login",
                    name: "login",
                    component: (0, $ynPL8.default)
                },
                {
                    path: "logout",
                    name: "logout",
                    component: (0, $7WABx.default)
                },
                {
                    path: "reset-password",
                    name: "reset-password",
                    component: ()=>(parcelRequire("epiTL"))
                },
                {
                    path: "renew-password/:token([A-Za-z0-9_-]{21,21})",
                    name: "renew-password",
                    component: ()=>(parcelRequire("iQTAW"))
                },
                {
                    path: "dashboard",
                    name: "dashboard",
                    component: ()=>(parcelRequire("9OKOf")),
                    meta: {
                        requiresAuth: true
                    },
                    children: [
                        {
                            path: "company",
                            name: "company",
                            children: [
                                {
                                    path: "employees",
                                    name: "employees",
                                    alias: "employees",
                                    component: ()=>(parcelRequire("6UF9E"))
                                },
                                {
                                    path: "analytics",
                                    name: "company-analytics",
                                    component: ()=>(parcelRequire("bHrXk"))
                                },
                                {
                                    path: "seats",
                                    name: "company-seats",
                                    component: ()=>(parcelRequire("c6hxS"))
                                },
                                {
                                    path: "subscription",
                                    name: "company-subscription",
                                    component: ()=>(parcelRequire("1uE3O"))
                                },
                                {
                                    path: "billing",
                                    name: "company-billing",
                                    component: ()=>(parcelRequire("1bXD0"))
                                },
                                {
                                    path: "details",
                                    name: "company-details",
                                    component: ()=>(parcelRequire("e8BMT"))
                                },
                                {
                                    path: "overview",
                                    name: "company-course-overview",
                                    component: ()=>(parcelRequire("aJeJ1"))
                                }
                            ]
                        },
                        {
                            path: "training",
                            name: "training",
                            children: [
                                {
                                    path: "course/:courseId",
                                    name: "training-course",
                                    redirect: {
                                        name: "training-course-overview"
                                    },
                                    children: [
                                        {
                                            path: "overview",
                                            name: "training-course-overview",
                                            component: ()=>(parcelRequire("aIy1Q"))
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: "account",
                            name: "account",
                            children: [
                                {
                                    path: "subscription",
                                    name: "account-subscription",
                                    component: ()=>(parcelRequire("ZxrTi"))
                                },
                                {
                                    path: "payments",
                                    name: "account-payments",
                                    component: ()=>(parcelRequire("7Pdvf"))
                                },
                                {
                                    path: "details",
                                    name: "account-details",
                                    component: ()=>(parcelRequire("4xSV3"))
                                }
                            ]
                        },
                        {
                            path: "subscription",
                            name: "subscription",
                            component: ()=>(parcelRequire("1uE3O"))
                        }
                    ]
                },
                {
                    path: "imprint",
                    name: "imprint",
                    component: (0, $bgAOC.default)
                },
                {
                    path: "privacy-policy",
                    name: "privacy-policy",
                    component: (0, $99Mjh.default)
                },
                {
                    path: "terms-and-conditions",
                    name: "terms-and-conditions",
                    component: (0, $82LGi.default)
                },
                {
                    path: "contact",
                    name: "contact",
                    component: (0, $fAzx8.default)
                }
            ]
        },
        {
            path: "/:pathMatch(.*)*",
            redirect: "home"
        }
    ],
    scrollBehavior (to /* , from, savedPosition */ ) {
        if (to.hash) return {
            el: to.hash,
            behavior: "smooth"
        };
        return {
            top: 0,
            behavior: "smooth"
        };
    }
});
$3805e7143c36831c$var$router.beforeResolve((to /* , from */ )=>{
    if (!to.meta.requiresAuth) return null;
    if (to.name === "login") return null;
    const { isAuthenticated: isAuthenticated } = (0, $1rS06.useGlobalState)();
    if (isAuthenticated()) return null;
    return {
        name: "login",
        query: {
            redirect: to.fullPath
        }
    };
});
var $3805e7143c36831c$export$2e2bcd8739ae039 = $3805e7143c36831c$var$router;

});
parcelRegister("580JV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bbe45fea0bb6206$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $7c6z4 = parcelRequire("7c6z4");
const $3bbe45fea0bb6206$var$Trans = {
    get defaultLocale () {
        return "en";
    },
    get supportedLocales () {
        return [
            "en",
            "de"
        ];
    },
    get currentLocale () {
        return (0, $7c6z4.default).global.locale.value;
    },
    set currentLocale (newLocale){
        (0, $7c6z4.default).global.locale.value = newLocale;
    },
    async switchLanguage (newLocale1) {
        await $3bbe45fea0bb6206$var$Trans.loadLocaleMessages(newLocale1);
        $3bbe45fea0bb6206$var$Trans.currentLocale = newLocale1;
        document.querySelector("html").setAttribute("lang", newLocale1);
        localStorage.setItem("user-locale", newLocale1);
    },
    async loadLocaleMessages (locale) {
        if (!(0, $7c6z4.default).global.availableLocales.includes(locale)) {
            const messages = await import(`src/i18n/locales/${locale}.json`);
            (0, $7c6z4.default).global.setLocaleMessage(locale, messages.default);
        }
        return (0, $TusQn.nextTick)();
    },
    isLocaleSupported (locale) {
        return $3bbe45fea0bb6206$var$Trans.supportedLocales.includes(locale);
    },
    getUserLocale () {
        const locale = window.navigator.language || window.navigator.userLanguage || $3bbe45fea0bb6206$var$Trans.defaultLocale;
        return {
            locale: locale,
            localeNoRegion: locale.split("-")[0]
        };
    },
    getPersistedLocale () {
        const persistedLocale = localStorage.getItem("user-locale");
        if ($3bbe45fea0bb6206$var$Trans.isLocaleSupported(persistedLocale)) return persistedLocale;
        return null;
    },
    guessDefaultLocale () {
        const userPersistedLocale = $3bbe45fea0bb6206$var$Trans.getPersistedLocale();
        if (userPersistedLocale) return userPersistedLocale;
        const userPreferredLocale = $3bbe45fea0bb6206$var$Trans.getUserLocale();
        if ($3bbe45fea0bb6206$var$Trans.isLocaleSupported(userPreferredLocale.locale)) return userPreferredLocale.locale;
        if ($3bbe45fea0bb6206$var$Trans.isLocaleSupported(userPreferredLocale.localeNoRegion)) return userPreferredLocale.localeNoRegion;
        return $3bbe45fea0bb6206$var$Trans.defaultLocale;
    },
    async routeMiddleware (to, _from, next) {
        const paramLocale = to.params.locale;
        if (!$3bbe45fea0bb6206$var$Trans.isLocaleSupported(paramLocale)) return next($3bbe45fea0bb6206$var$Trans.guessDefaultLocale());
        await $3bbe45fea0bb6206$var$Trans.switchLanguage(paramLocale);
        return next();
    },
    i18nRoute (to) {
        return {
            ...to,
            params: {
                locale: $3bbe45fea0bb6206$var$Trans.currentLocale,
                ...to.params
            }
        };
    }
};
var $3bbe45fea0bb6206$export$2e2bcd8739ae039 = $3bbe45fea0bb6206$var$Trans;

});
parcelRegister("7c6z4", function(module, exports) {

$parcel$export(module.exports, "default", () => $53cebf01a6481b81$export$2e2bcd8739ae039);

var $jFUWD = parcelRequire("jFUWD");

var $5XUMN = parcelRequire("5XUMN");

var $j328z = parcelRequire("j328z");
const $53cebf01a6481b81$var$i18n = (0, $jFUWD.createI18n)({
    // default locale
    locale: "en",
    fallbackLocale: "en",
    legacy: false,
    // translations
    messages: {
        en: (/*@__PURE__*/$parcel$interopDefault($5XUMN)),
        de: (/*@__PURE__*/$parcel$interopDefault($j328z))
    }
});
var $53cebf01a6481b81$export$2e2bcd8739ae039 = $53cebf01a6481b81$var$i18n;

});
parcelRegister("5XUMN", function(module, exports) {
module.exports = JSON.parse('{"locale":{"en":"EN","de":"DE"},"global":{"endpointError":"There was an issue with your request. Please try again or contact an administrator."},"confirm":{"yes":"Yes","no":"No","default":"Are you sure?"},"general":{"seat":"seat | seats"},"nav":{"closeMenu":"Close Menu","openMenu":"Open main menu","whyCyberalarm":"Why CyberALARM","howItWorks":"How it works","alarm":"Alarm","courses":"Courses","aboutUs":"About us","pricing":"Prices","imprint":"Imprint","privacy":"Privacy Policy","terms":"Terms & Conditions","contact":"Contact us"},"landingPage":{"heroSection":{"slogan":"Keep your Company {0}","sloganHighlighted":"safe!","subtext":"Become aware of different cybersecurity threats and learn how to prevent them safely.","statsTitle":"Scientifically proven results!","stats":["NIS2 Complies with the Law","Any Languages","Demo Access"]},"whySection":{"title":"Why choose CyberALARM?","block1":{"title":"Be prepared for NIS2 with our digital Cybersecurity Training for Businesses","text":"CyberALARM is a digital cybersecurity simulation for businesses that offers affordable training with scientifically proven results. Our app will help your team develop a deep understanding of the most common and dangerous cybersecurity threats and how to prevent them, making your business more secure and resilient."},"block2":{"title":"EU NIS2 Cybersecurity Directive 2024 Facts","bullet1":"NIS2 introduces penalties of up to \u20AC10.000.000","bullet2":"NIS2 holds Management accountable regarding their cybersecurity maturity and framework","bullet3":"NIS2 advises management and employees training for more in-depth cybersecurity knowledge"},"incentivesTitle":"Have access to a quality training guided by your needs","incentives":[{"title":"Realistic Simulation","text":"Our app offers realistic simulations of cyber attacks, providing your team with the experience they need to effectively prevent cyber threats."},{"title":"Personal Training","text":"Assume different roles from Employee to Hacker to Security Expert. Any choice you make has an impact that shows in your feedback and points in the end."},{"title":"Scientifically Proven","text":"We developed and tested our training in a 3 year research project in collaboration with the renown cyber security experts at TH Wildau."},{"title":"Any Language","text":"English, Spanish, Turkish, Chinese... We cater to any language you train your team in with our cost efficient localization framework."},{"title":"Customized Solution","text":"We customize our cyber training modules to your needs: with your branding, in your own technical environment, with custom content and individual training expansions."},{"title":"Your Environment","text":"Your data and accessibility is key for us. We offer a technical setup of your choice: Mobile App, Web App, Company Intranet."}]},"howSection":{"title":"How it Works?","text":"CyberALARM offers comprehensive cybersecurity training with two specific access levels. Companies, organizations, and associations can manage training and employees, as well as obtain participation certificates. Individual users and employees have access to cybersecurity courses that prepare them for potential threats from the internet and their surroundings. CyberALARM enhances cybersecurity through practical and up-to-date training content tailored to the specific needs of different user groups.","block1":{"title":"Training Platform","subtitle":"Access for Single Users & Employees of a Company (User account)","bullet1":"Access to a wide range of courses","bullet2":"Learn with training simulations","bullet3":"Play different roles","bullet4":"Receive a certificate"},"block2":{"title":"Management Platform","subtitle":"Access for Management of Employees & Lessons (Admin account)","bullet1":"Import your employees list","bullet2":"Invite employees for specific courses","bullet3":"Check your employees progress","bullet4":"Receive a certificate"}},"alarmSection":{"title":"Research Project ALARM","text":"From 2020\u20132023, we partnered with TH Wildau on the ALARM project. The result: CyberALARM \u2013 our research-based platform for effective awareness training and hands-on cybersecurity tailored to small and medium-sized enterprises (SMEs).","alarmProject":{"title":"ALARM Project","text":"The ALARM project aimed to identify the biggest cybersecurity threats to SMEs and develop effective training solutions to protect employees from cyberattacks and enhance their security awareness."},"digital":{"title":"Digital Security Simulations","text":"As the exclusive partner for digital simulations with TH Wildau, we developed a cybersecurity training solution based on digital serious games. Over 3 years, we validated the solution through multiple testing phases and tailored it to the needs of SMEs."},"partners":{"title":"Project Partners","text":"The research project brought together key academic and industrial partners, supported by the Federal Ministry for Economic Affairs and Energy and the Chambers of Industry and Commerce (IHKs), to develop practical cybersecurity solutions for businesses."},"publication":{"title":"Publications & Events","text":"We presented our research and project results at various events and in renowned research publications, including the 35th AKWI Annual Conference proceedings and a final report documenting the research findings."},"seeMore":"See more"},"coursesSection":{"title":"Courses","subtitle":"Cybersecurity Training:\\n7 Scientifically Proven Cyber Security Trainings","text":"This first course will enable your team to recognize and handle the most common and dangerous cyber security threats safely.","moreComing":"More courses are coming !","courses":[{"title":"Social Engineering","desc":"In this learning scenario, you as a specialist will try to familiarise the workforce with the topic of information security. Terms such as malware and social engineering are explained."},{"title":"How do hackers work?","desc":"In this learning scenario, you will try to gain illegal access to the company\'s data as a hacker. Terms such as spoofing, password stealer, spyware, VoIP phone and password tracker are explained."},{"title":"Human error source","desc":"In this learning scenario, you will act as a sleuth and try to track down a hacker. Terms such as SPhishing, spear phishing, CEO fraud, scam, two-factor authentication and deep fake attack are explained."},{"title":"Home Office","desc":"In this learning scenario, you as an artificial intelligence (AI) will try to find the most popular errors in the home office. Terms such as smartphone, VPN, blockchain and machine learning (AI) are explained."},{"title":"Think like a hacker","desc":"In this learning scenario, you will first hack and then investigate. Terms such as cloud, darknet, password cracker, backup, two-factor authentication and password manager are explained."},{"title":"Why do we need information classes?","desc":"In this learning scenario, you will deal with the topic of information classification as an artificial intelligence (AI). Terms such as information classification and sensitive data are explained."},{"title":"Understanding encryption","desc":"In this learning scenario, you will be a sleuth trying to track down a certain Scarlett. Terms such as encryption, end-to-end encryption, GDPR, ransomware, Caesar cipher and symmetric encryption are explained."},{"title":"The business trip (available soon)","desc":"The latest learning scenario will focus on business travel."}]},"aboutUsSection":{"title":"About us","block1":{"title":"Empower your Business to be Cyber Secure!","text":"With CyberALARM, our mission at Gamebook is to help businesses of all sizes to improve their cybersecurity posture. We believe that cybersecurity training should be accessible to everyone, and we\'re committed to providing high-quality training at an affordable price."},"block2":{"title":"What is Gamebook Services?","text":"Gamebook Studios distributes an innovative CMS platform for creating, publishing and managing interactive simulations and educational games. The platform offers numerous benefits and USPs, including seamless integration, user-friendly interface and flexible customisation options. With CyberALARM, Gamebook Studio offers a comprehensive cyber threat training and prevention solution. Gamebook\'s satisfied customers include well-known companies such as Deutsche Bank, Hasbro, the Hamburg Parliament and the Brandenburg Police. More information at Gamebook Studio."}},"prices":{"title":"Prices","subtitle":"Choose your preferred subscription.","freeTrial":"Or start a FREE Demo","limitedTime":"","contactForPricing":"","unsubscribe":{"title":"How to unsubscribe?","text":"You can cancel your subscription at any time by visiting [LINK/PLACE ON ACCOUNT]. Your subscription will remain active until its renewal date, after which it will not be charged again and your seats will be canceled."}},"seeMore":"See more","seeMoreLink":"https://alarm.wildau.biz/en","contactUs":"Ask for a demo","startNow":"Start Now"},"footer":{"title":"CyberALARM","slogan":"Keep your company safe!","product":"Product","company":"Company","legal":"Legal"},"company":{"email":"info{\'@\'}gamebook.services","linkedin":"LinkedIn","address1":"Gamebook Studio HQ GmbH","address2":"Wilhelm-Kabus-Strasse 77","address3":"10829 Berlin","address4":"Germany","copyright":"2025 by Gamebook Services"},"logIn":"Log In","logOut":"Log Out","dashboardBtn":"Dashboard","getStartedCTA":"Get started","appTitle":"CyberALARM","loginView":{"header":"Log in to your account","email":"Email address","password":"Password","forgotPassword":"Forgot password?","noAccount":"Not a member?","signUp":"Go to the Plans","emailPlaceholder":"","genericError":"There was an issue logging you in.<br />Please try again or contact an administrator.","wrongCredentials":"The email or the password is incorrect."},"logoutView":{"header":"Logging you out..."},"resetPasswordView":{"header":"Enter your email address to reset your password","email":"Email address","reset":"Request password reset","emailPlaceholder":"","requestSuccess":"Successfully requested password reset.","instructions":"We will send you an email with a link to reset your password.<br />Please <span class=\'text-secondary\'>check your inbox</span> and <span class=\'text-secondary\'>follow the instructions.</span>"},"renewPasswordView":{"header":"Renew your password","password":"Password","passwordRepeated":"Repeat password","reset":"Renew password","resetSuccess":"Your password has been renewed successfully.","login":"Go to Login","noMatch":"Password do not match","waitingForInitialization":"Loading.."},"dashboard":{"navigation":{"companyHeading":"Your Company","managingHeading":"Manage Courses","trainingHeading":"Training","accountHeading":"My Account","companyInvoices":"Billing","invoices":"Invoices","analytics":"Progress","seats":"Seats","buyPlan":"Buy a plan","subscription":"Subscription","companyDetails":"Company details","payments":"Payments","accountDetails":"Account details"},"deleteSeats":{"title":"Delete unassigned seats","btnTitle":"Delete Seats","subtitle":"You can only delete unassigned seats that have never been used by anyone. You will stop paying for them starting next renewal.","numSeatsLabel":"Number of unassigned seats for this course","labelNumberOfSeatsToDelete":"Number of seats you want to delete","labelTotalPriceSubtracted":"Total price to be subtracted from current price","subTotalPriceSubtracted":"{0} (delete) x {1} (price per seat)","labelYearlyTotal":"New yearly total price","subYearlyTotal":"{0} (actual) - {1} (subtract)","btnDelete":"Delete seats"},"buySeats":{"btnTitle":"Buy Seats","title":"Buy more seats","subtitle":"New seats will be added on the actual subscription. The renewal date stays the same for all the seats. It means that, for the next renewal date, you\'ll be charged on prorata of the remaining months.","numSeatsLabel":"Number of seats you want to add","labelYearlyAdditionalPrice":"Yearly additional price","subYearlyAdditionalPrice":"{0} (new seats) x {1} (price per seat)","labelTotalSeatNumber":"New total seat number","subTotalSeatNumber":"{0} (actual) + {1} (additional)","labelYearlyTotal":"New yearly total price","subYearlyTotal":"{0} (actual) + {1} (additional)"},"seats":{"totalNumberSeats":"Total number of seats","activeSeats":"Active seats","inactiveSeats":"Inactive seats","availableSeats":"Unassigned seats","listOfSeats":"List of seats","inactivateSeats":{"btnInactivate":"Inactivate seats","confirmTitle":"Inactivate assigned seats","confirmText1":"You can inactivate assigned seats when you no longer want to pay for them. ","confirmText2":"For example, when an employee already finished a course, you can inactivate his seat linked to this specific course.","confirmTextBold":"Are you sure you want to inactivate selected seats?"},"activateSeats":{"btnActivate":"Activate seats","confirmTitle":"Activate assigned seats","confirmText1":"You can activate inactive seats ","confirmText2":"","confirmTextBold":"Are you sure you want to activate selected seats?"},"headerStatus":"Status","headerCourse":"Course","headerEmployee":"Assigned Employee","headerRole":"Role","headerEmail":"Email"},"subscription":{"title":"Subscription details","tier":"Plan","renewDate":"Renew date","numberOfSeats":"Quantity","pricePerSeat":"Price per seat","billingCycle":"Billing cycle","renewal":{"title":"Renewal details","autoRenew":"Auto-renew","autoRenewOn":"On","autoRenewOff":"Off","date":"Date","btnCancel":"Cancel renewal","confirmTitle":"Cancel renewal","confirmText1":"Keeping auto-renew on ensures that your subscription remains active and access to courses is uninterrupted.","confirmText2":"If you cancel the automatic renewal, your subscription will stop on the actual renewal date, **date**, and all your employees will loose their access starting from this date too.","confirmTextBold":"Are you sure you want to cancel the automatic renewal?","btnRenew":"Activate renewal","confirmRenewTitle":"Activate renewal","confirmRenewText1":"If you activate the automatic renewal, your subscription will remains active and will renew on the actual end date, **date**. All your your employees will have an uninterrupted access to their courses.","confirmRenewTextBold":"Are you sure you want to activate the automatic renewal?"},"paymentMethod":{"title":"Payment method","modifyBtn":"Modify","paymentMethod":"Payment method","numberId":"Number ID","ownerName":"Owner Full Name","ownerMail":"Owner Email Address"}},"account":{"details":{"title":"My Account Details","modifyBtn":"Modify","updateEmailTitle":"Update your Email","updateEmailDesc":"Change your user Email address, this will update your login credentials and contact information.","currentEmailLabel":"Current Email","currentEmailMismatch":"The current Email is not correct","updateEmailSuccess":"Your Email address has been successfully updated","updatePasswordSuccess":"Your password has been successfully updated","passwordLabel":"Password","newEmailLabel":"New Email","confirmNewEmailLabel":"Confirm new Email","updateEmailBtn":"Update","updatePasswordTitle":"Update Password","updatePasswordBtn":"Update","currentPasswordLabel":"Current Password","newPasswordLabel":"New Password","updatePasswordDesc":"Ensure your account is using long, random password to stay secure","deleteAccountTitle":"Delete Account","deleteAccountBtn":"Delete account","deleteAccountDesc":"When you delete your account, all your data, including company and employee information, will be permanently erased. This process is irreversible once confirmed. Please ensure you have backed up any important information before proceeding.","deleteAccountConfirm":"Are you sure you want to delete your account?","updateAccountSuccess":"Your account has been successfully updated"}},"company":{"employees":{"link":"Employees","employeesCouldNotBeAddedMessage":"Employees could not be added: {employees}","add":{"btnTitle":"Add employees","title":"Add Employee","btnAdd":"Add","success":"Successfully added {employee}.","description":"Need to add many employees? Go back, then click on \u201CImport employees by CSV\u201D."},"unbound":{"btnUnbound":"Unbind employees","confirmTitle":"Unbound employees","confirmText1":"You can unbound employees that left the company or retired.","confirmText2":"All their assigned seats will be set as inactive. This means that the seats won\u2019t renew, so you will not pay for those at next renewal date.","confirmTextBold":"Are you sure you want to unbound employees you selected?"},"import":{"title":"Import Employees","btn":"Import Employees","desc1":"Import your employees list directly from a CSV file. You will need these info for each employee:","btnImport":"Select a file","modal":{"fileDrop":"Drag your files or Browse","fileDropInfo":"Authorized files: CSV","clearFile":"Clear file","fileInfo_file":"File parsed","fileInfo_numRows":"Number of data rows","fileInfo_colsFound":"Columns found","previewBtn":"Show Preview","previewTitle":"Preview","mappingTitle":"Mapping","close":"Close","submit":"Submit","cancel":"Cancel"}},"list":{"title":"List of Employees"},"firstName":"Name","lastName":"Last Name","email":"Email","roleInCompany":"Role","progress":"Progress","status":"Status","seats":"Seats","boundStatus":"Bound","unboundStatus":"Unbound"},"settings":"Settings","subscription":"Subscription","overview":"Overview","management":"Management","courses":{"progressTitle":"Your team\'s overall progress for this course","manageBtn":"Manage the course","moreSeatsBtn":"More seats","availableSeats":"available Seats","assignEmployeesBtn":"Assign Seats","moreDetailsBtn":"More details","moreDetailsDesc":"Take a look at the course content and your team\'s progress","employeeListTitle":"List of Employees invited to {courseName}","lessonModal":{"progressTitle":"Your team\'s progress for this lesson","inviteBtn":"Invite employees to the course"},"assignModal":{"title":"Assign employees to course","assignBtn":"Assign employees","cancelBtn":"Cancel","selectCourseLabel":"Select a course","searchLabel":"Search by email, first, or last name","seatInfoText":"You can assign {0} {1} to this course","assignedCourse":"Invite employees to the following course"}},"details":{"title":"Company details","modifyBtn":"Modify"}},"invoices":{"title":"Billing","list":{"date":"Bill date","payPalId":"PayPal Payment ID","quantity":"Quantity","courses":"Assigned courses","total":"Total","bill":"Bill"},"colTitleDate":"Invoice date","colTitlePayPalId":"PayPal Payment ID","colTitle":"PayPal Payment ID"},"training":{"navBarWelcome":"Hi {0},{1} Welcome back!","courseProgressCta":"Hurry up! 85% of your colleagues have already finished the course","progressTitle":"Your progress for this course","lessonContinue":"Continue","lessonRestart":"Restart","lessonStart":"Start the lesson","defaultProgress":"Start a lesson!"}},"registerView":{"selectSubscription":"Select your subscription","choosePlan":"Start Now","goBack":"< Back Home","loginHint":"If you have been invited by your company, you have to","processCircle":{"plan":"Plans","accountDetails":"Account Details","billing":"Billing Information","confirmation":"Confirmation"},"accountForm":{"title":"Set up your Account","companyDetailsTitle":"Company details","individualDetailsTitle":"Your details","ownerDetailsTitle":"Account owner details","labels":{"companyName":"Company Name","numberOfEmployees":"Number of employees","industry":"Industry","website":"URL of the company website","legalForm":"Legal form","taxNumber":"Tax number","commercialRegisterNumber":"Commercial register number","streetAddress":"House number & Street","zipCode":"Postal code","city":"City","country":"Country","gender":"Gender","genderOptionOther":"Other","genderOptionMale":"Male","genderOptionFemale":"Female","firstName":"First Name","lastName":"Last Name","roleInCompany":"Role in the company","department":"Department","phoneNumber":"Telephone Number","email":"Email address for communication","confirmEmail":"Email address confirmation","password":"Password","confirmPassword":"Confirm password","communicationPreference":"Communication preference","communicationPreferenceOptionEmail":"Email","communicationPreferenceOptionPhone":"Phone","communicationLanguage":"Communication languages","communicationLanguageOptionEN":"English","communicationLanguageOptionDE":"German","terms":"Accept our <a class=\'text-secondary\' target=\'_blank\'href=\\"https://www.cyberalarm.training/en/terms-and-conditions\\">Terms and Conditions</a>","privacy":"Accept our <a class=\'text-secondary\' target=\'_blank\'href=\\"https://www.cyberalarm.training/en/privacy-policy\\"> Privacy Policy</a>","termsRequired":"You must accept our T&C","privacyRequired":"You must accept our Privacy Policy","situation":"Situation","situationOptions":{"employed":"Employed","unemployed":"Unemployed","training":"In training","selfEmployed":"Self-employed","student":"Pupil/Student","civilServant":"Civil servant","pensioner":"Pensioner","other":"Other"},"situationEmployed":"Employed","situationUnemployed":"Unemployed","countries":{"germany":"Germany","other":"Other"},"job":"Job title","message":"Message"},"confirm":"Confirm","errors":{"userExists":"User already exists"}},"billing":{"title":"Purchase Summary","yearlyPriceLabel":"Yearly price per seat net","numLicensesLabel":"Number of seats you want to add","yearlyTotalPrice":"Yearly total price ({0} x {1})","discountPlaceholder":"Discount code","vatLabel":"VAT","discountApply":"Apply","discountClear":"Remove","discount":"Discount","discountGenericError":"There was an error redeeming the key.","invalidKey":"Key is not valid.","terms":{"desc":"You will be redirected to Paypal. If you don\'t have a Paypal account, you can make your payment in the next window without a Paypal account. You then remain anonymous and Paypal only saves the payment data.","bullet1":"12 months access","bullet2":"Multi user management","bullet3":"Confirmation of participation"},"payWithPaypal":"Pay with Paypal","free":"Free"},"confirmation":{"successTitle":"Successful Payment and Registration","successInfo":"You just bought the {planName} plan.<br /><br /> You should already have received a registration confirmation email from us. <br /><br />You will also receive a payment confirmation email with the purchase summary from PayPal.","waitingTitle":"Please wait","waitingInfo":"Your subscription is being activated, please wait a few seconds.<br />If this process takes more than 5 minutes please contact us.","failureTitle":"Payment not successful","failureInfo":"Unfortunately the payment process could not be completed. However, your customer account has been created. Please take a look at our help section. You can repeat the payment process at any time under Plans.","freeInfo":"You just bought the {planName} plan. <br /><br /> Please enjoy your subscription.","homeButton":"Home","logInButton":"Log In"}},"imprintView":{"title":"Imprint","siteNotice":{"title":"Site Notice","content":"Gamebook Studio HQ GmbH <br /> Wilhelm-Kabus-Strasse 77 <br /> 10829 Berlin <br /><br /> Commercial Register: HRB 232902 B <br /> Registration court: Amtsgericht Berlin Charlottenburg <br /><br /><b> Represented by:</b> <br /> Ulrike K\xfcchler <br /> Prof. Thomas Langhanki"},"contact":{"title":"Contact","content":"E-mail: info@gamebook-studio.com <br />Phone: +4917623963455"},"vat":{"title":"VAT ID","content":"Sales tax identification number according to Sect. 27 a of the Sales Tax Law: DE347404113"},"editorialResponsible":{"title":"Person responsible for editorial","content":"Ulrike K\xfcchler<br />Gamebook Studio HQ GmbH <br /> Wilhelm-Kabus-Strasse 77 <br /> 10829 Berlin Germany"},"euDisputeResolution":{"title":"EU dispute resolution","content":"The European Commission provides a platform for online dispute resolution (ODR): <a target=\'_blank\'href=\'https://ec.europa.eu/consumers/odr/\'>Online Dispute Resolution. European Commission</a>. Our e-mail address can be found above in the site notice."},"disputeProceedings":{"title":"Dispute resolution proceedings in front of a consumer arbitration board","content":"We are not willing or obliged to participate in dispute resolution proceedings in front of a consumer arbitration board."}},"privacyPolicyView":{"title":"Privacy Policy","dataProtection":{"title":"1. An overview of data protection","content":"<h3>General information</h3><br />The following information will provide you with an easy to navigate overview of what will happen with your personal data when you visit this website. The term \u201Cpersonal data\u201D comprises all data that can be used to personally identify you. For detailed information about the subject matter of data protection, please consult our Data Protection Declaration, which we have included beneath this copy.\\n\\n <br /><br /><h3>Data recording on this website</h3>\\n<h3>Who is the responsible party for the recording of data on this website (i.e., the \u201Ccontroller\u201D)?</h3><br />The data on this website is processed by the operator of the website, whose contact information is available under section \u201CInformation about the responsible party (referred to as the \u201Ccontroller\u201D in the GDPR)\u201D in this Privacy Policy.\\n\\n <br /><br /><h3>How do we record your data?</h3><br />\\nWe collect your data as a result of your sharing of your data with us. This may, for instance be information you enter into our contact form.<br />\\n\\nOther data shall be recorded by our IT systems automatically or after you consent to its recording during your website visit. This data comprises primarily technical information (e.g., web browser, operating system, or time the site was accessed). This information is recorded automatically when you access this website.<br />\\n\\n<br /><h3>What are the purposes we use your data for?</h3><br />\\nA portion of the information is generated to guarantee the error free provision of the website. Other data may be used to analyze your user patterns.<br /><br />\\n\\n<h3>What rights do you have as far as your information is concerned?</h3><br />\\nYou have the right to receive information about the source, recipients, and purposes of your archived personal data at any time without having to pay a fee for such disclosures. You also have the right to demand that your data are rectified or eradicated. If you have consented to data processing, you have the option to revoke this consent at any time, which shall affect all future data processing. Moreover, you have the right to demand that the processing of your data be restricted under certain circumstances. Furthermore, you have the right to log a complaint with the competent supervising agency.<br />\\n\\nPlease do not hesitate to contact us at any time if you have questions about this or any other data protection related issues.<br /><br />\\n\\n<h3>Analysis tools and tools provided by third parties</h3><br />\\nThere is a possibility that your browsing patterns will be statistically analyzed when your visit this website. Such analyses are performed primarily with what we refer to as analysis programs.<br />\\n\\nFor detailed information about these analysis programs please consult our Data Protection Declaration below.<br />\\n\\n"},"hostingCDN":{"title":"2. Hosting and Content Delivery Networks (CDN)","content":"We are hosting the content of our website ate the following provider:<br /><br /><h3>Amazon Web Services (AWS)</h3><br />The provider is the Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, 1855 Luxembourg (hereinafter referred to as \u201CAWS\u201D).<br /><br /> When you visit our website, your personal data will be processed on AWS servers. This may also result in the transfer of personal data to the parent company of AWS in the United States. The transfer of data to the US is based on the EU\u2019s standard contractual clauses. For details please consult: <a target=\'_blank\'href=\\"https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/\\">AWS GDPR Data Processing Addendum \u2013 Now Part of Service Terms Amazon Web Services</a>.\\n <br /><br />For more information, please see the AWS Data Privacy Policy: <a target=\'_blank\'href=\\"https://aws.amazon.com/de/privacy/?nc1=f_pr\\">Datenschutzhinweis</a>.\\n <br /><br />AWS is used on the basis of Art. 6(1)(f) GDPR. We have a legitimate interest in a depiction of our website that is as reliable as possible. If appropriate consent has been obtained, the processing is carried out exclusively on the basis of Art. 6(1)(a) GDPR and \xa7 25 (1) TDDDG, insofar the consent includes the storage of cookies or the access to information in the user\u2019s end device (e.g., device fingerprinting) within the meaning of the TDDDG. This consent can be revoked at any time.<br /><br /> The company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TOWQAA4&status=Active\\">Data Privacy Framework</a>.\\n <br /><br /> <h3>Data processing</h3><br />\\nWe have concluded a data processing agreement (DPA) for the use of the above-mentioned service. This is a contract mandated by data privacy laws that guarantees that they process personal data of our website visitors only based on our instructions and in compliance with the GDPR.<br /><br /><h3>Amazon CloudFront CDN</h3>\\n<br />We use the Content Delivery Network Amazon CloudFront CDN. The provider is Amazon Web Services EMEA SARL, 38 avenue John F. Kennedy, L-1855, Luxembourg (hereinafter referred to as \u201CAmazon\u201D).<br /><br />Amazon CloudFront CDN is a globally distributed Content Delivery Network. During these transactions, the information transfer between your browser and our website is technically routed via the Content Delivery Network. This enables us to boost the global availability and performance capabilities of our website.<br /><br />The use of Amazon CloudFront CDN is based on our legitimate interest in keeping the presentation of our web services as error free and secure as possible (Art. 6(1)(f) GDPR).<br /><br />The data transfer to the United States is based on the Standard Contract Clauses of the EU Commission. You can find the details here: <a target=\'_blank\'href=\\"https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/\\">AWS GDPR Data Processing Addendum \u2013 Now Part of Service Terms  Amazon Web Services</a>.\\n <br /><br />For more information on Amazon CloudFront CDN please follow this link: <a target=\'_blank\'href=\\"https://d1.awsstatic.com/legal/privacypolicy/AWS_Privacy_Notice__German_Translation.pdf\\">https://d1.awsstatic.com/legal/privacypolicy/AWS_Privacy_Notice__German_Translation.pdf</a>.\\n<br /><br />The company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TOWQAA4&status=Active\\">Data Privacy Framework</a>.\\n"},"generalInformation":{"title":"3. General information and mandatory information","content":"<h3>Data protection</h3>\\n\\nThe operators of this website and its pages take the protection of your personal data very seriously. Hence, we handle your personal data as confidential information and in compliance with the statutory data protection regulations and this Data Protection Declaration.<br />Whenever you use this website, a variety of personal information will be collected. Personal data comprises data that can be used to personally identify you. This Data Protection Declaration explains which data we collect as well as the purposes we use this data for. It also explains how, and for which purpose the information is collected.<br /><br />We herewith advise you that the transmission of data via the Internet (i.e., through e-mail communications) may be prone to security gaps. It is not possible to completely protect data against third-party access.<br /><br /><h3>Information about the responsible party (referred to as the \u201Ccontroller\u201D in the GDPR)</h3>The data processing controller on this website is:<br /><br />Gamebook Studio HQ GmbH<br />Wilhelm-Kabus-Strasse 77<br />10829 Berlin<br />Germany<br /><br />Phone: +4917623963455<br />E-mail: info@gamebook.studio<br /><br />The controller is the natural person or legal entity that single-handedly or jointly with others makes decisions as to the purposes of and resources for the processing of personal data (e.g., names, e-mail addresses, etc.).<br /><br /><h3>Storage duration</h3><br />Unless a more specific storage period has been specified in this privacy policy, your personal data will remain with us until the purpose for which it was collected no longer applies. If you assert a justified request for deletion or revoke your consent to data processing, your data will be deleted, unless we have other legally permissible reasons for storing your personal data (e.g., tax or commercial law retention periods); in the latter case, the deletion will take place after these reasons cease to apply.<br /><br /><h3>General information on the legal basis for the data processing on this website</h3><br />If you have consented to data processing, we process your personal data on the basis of Art. 6(1)(a) GDPR or Art. 9 (2)(a) GDPR, if special categories of data are processed according to Art. 9 (1) DSGVO. In the case of explicit consent to the transfer of personal data to third countries, the data processing is also based on Art. 49 (1)(a) GDPR. If you have consented to the storage of cookies or to the access to information in your end device (e.g., via device fingerprinting), the data processing is additionally based on \xa7 25 (1) TDDDG. The consent can be revoked at any time. If your data is required for the fulfillment of a contract or for the implementation of pre-contractual measures, we process your data on the basis of Art. 6(1)(b) GDPR. Furthermore, if your data is required for the fulfillment of a legal obligation, we process it on the basis of Art. 6(1)(c) GDPR. Furthermore, the data processing may be carried out on the basis of our legitimate interest according to Art. 6(1)(f) GDPR. Information on the relevant legal basis in each individual case is provided in the following paragraphs of this privacy policy.<br /><br /><h3>Designation of a data protection officer</h3><br />We have appointed a data protection officer.<br />Dr. Malte Behermann<br />Ganghoferstr. 4<br />12163 Berlin<br /><br />Phone: +49 30 65214472<br />E-mail: <a target=\'_blank\'href=\\"mailto:kanzlei@malte-behrmann.de\\">kanzlei@malte-behrmann.de</a>\\n<br /><br /><h3>Information on the data transfer to third-party countries that are not secure under data protection law and the transfer to US companies that are not DPF-certified</h3><br />We use, among other technologies, tools from companies located in third-party countries that are not safe under data protection law, as well as US tools whose providers are not certified under the EU-US Data Privacy Framework (DPF). If these tools are enabled, your personal data may be transferred to and processed in these countries. We would like you to note that no level of data protection comparable to that in the EU can be guaranteed in third countries that are insecure in terms of data protection law.<br /><br />We would like to point out that the US, as a secure third-party country, generally has a level of data protection comparable to that of the EU. Data transfer to the US is therefore permitted if the recipient is certified under the \u201CEU-US Data Privacy Framework\u201D (DPF) or has appropriate additional assurances. Information on transfers to third-party countries, including the data recipients, can be found in this Privacy Policy.<br /><br /><h3>Recipients of personal data\\n</h3><br />In the scope of our business activities, we cooperate with various external parties. In some cases, this also requires the transfer of personal data to these external parties. We only disclose personal data to external parties if this is required as part of the fulfillment of a contract, if we are legally obligated to do so (e.g., disclosure of data to tax authorities), if we have a legitimate interest in the disclosure pursuant to Art. 6 (1)(f) GDPR, or if another legal basis permits the disclosure of this data. When using processors, we only disclose personal data of our customers on the basis of a valid contract on data processing. In the case of joint processing, a joint processing agreement is concluded.<br /><br /><h3>Revocation of your consent to the processing of data</h3><br />A wide range of data processing transactions are possible only subject to your express consent. You can also revoke at any time any consent you have already given us. This shall be without prejudice to the lawfulness of any data collection that occurred prior to your revocation.<br /><br /><h3>Right to object to the collection of data in special cases; right to object to direct advertising (Art. 21 GDPR)</h3><br />IN THE EVENT THAT DATA ARE PROCESSED ON THE BASIS OF ART. 6(1)(E) OR (F) GDPR, YOU HAVE THE RIGHT TO AT ANY TIME OBJECT TO THE PROCESSING OF YOUR PERSONAL DATA BASED ON GROUNDS ARISING FROM YOUR UNIQUE SITUATION. THIS ALSO APPLIES TO ANY PROFILING BASED ON THESE PROVISIONS. TO DETERMINE THE LEGAL BASIS, ON WHICH ANY PROCESSING OF DATA IS BASED, PLEASE CONSULT THIS DATA PROTECTION DECLARATION. IF YOU LOG AN OBJECTION, WE WILL NO LONGER PROCESS YOUR AFFECTED PERSONAL DATA, UNLESS WE ARE IN A POSITION TO PRESENT COMPELLING PROTECTION WORTHY GROUNDS FOR THE PROCESSING OF YOUR DATA, THAT OUTWEIGH YOUR INTERESTS, RIGHTS AND FREEDOMS OR IF THE PURPOSE OF THE PROCESSING IS THE CLAIMING, EXERCISING OR DEFENCE OF LEGAL ENTITLEMENTS (OBJECTION PURSUANT TO ART. 21(1) GDPR).<br /><br />IF YOUR PERSONAL DATA IS BEING PROCESSED IN ORDER TO ENGAGE IN DIRECT ADVERTISING, YOU HAVE THE RIGHT TO OBJECT TO THE PROCESSING OF YOUR AFFECTED PERSONAL DATA FOR THE PURPOSES OF SUCH ADVERTISING AT ANY TIME. THIS ALSO APPLIES TO PROFILING TO THE EXTENT THAT IT IS AFFILIATED WITH SUCH DIRECT ADVERTISING. IF YOU OBJECT, YOUR PERSONAL DATA WILL SUBSEQUENTLY NO LONGER BE USED FOR DIRECT ADVERTISING PURPOSES (OBJECTION PURSUANT TO ART. 21(2) GDPR).<br /><br /><h3>Right to log a complaint with the competent supervisory agency</h3><br />In the event of violations of the GDPR, data subjects are entitled to log a complaint with a supervisory agency, in particular in the member state where they usually maintain their domicile, place of work or at the place where the alleged violation occurred. The right to log a complaint is in effect regardless of any other administrative or court proceedings available as legal recourses.<br /><br /><h3>Right to data portability</h3><br />You have the right to have data that we process automatically on the basis of your consent or in fulfillment of a contract handed over to you or to a third party in a common, machine-readable format. If you should demand the direct transfer of the data to another controller, this will be done only if it is technically feasible.<br /><br /><h3>Information about, rectification and eradication of data</h3><br />Within the scope of the applicable statutory provisions, you have the right to demand information about your archived personal data, their source and recipients as well as the purpose of the processing of your data at any time. You may also have a right to have your data rectified or eradicated. If you have questions about this subject matter or any other questions about personal data, please do not hesitate to contact us at any time.<br /><br /><h3>Right to demand processing restrictions</h3><br />You have the right to demand the imposition of restrictions as far as the processing of your personal data is concerned. To do so, you may contact us at any time. The right to demand restriction of processing applies in the following cases:<br /><br /><style>ul {list-style-type: disc; padding-left: 20px;}</style><ul><ul><li>In the event that you should dispute the correctness of your data archived by us, we will usually need some time to verify this claim. During the time that this investigation is ongoing, you have the right to demand that we restrict the processing of your personal data.</li><br /><li>If the processing of your personal data was/is conducted in an unlawful manner, you have the option to demand the restriction of the processing of your data instead of demanding the eradication of this data.</li><br /><li>If we do not need your personal data any longer and you need it to exercise, defend or claim legal entitlements, you have the right to demand the restriction of the processing of your personal data instead of its eradication.</li><br /><li>If you have raised an objection pursuant to Art. 21(1) GDPR, your rights and our rights will have to be weighed against each other. As long as it has not been determined whose interests prevail, you have the right to demand a restriction of the processing of your personal data.</li></ul><br />If you have restricted the processing of your personal data, these data \u2013 with the exception of their archiving \u2013 may be processed only subject to your consent or to claim, exercise or defend legal entitlements or to protect the rights of other natural persons or legal entities or for important public interest reasons cited by the European Union or a member state of the EU.<br /><br /><h3>SSL and/or TLS encryption\\n</h3><br />For security reasons and to protect the transmission of confidential content, such as purchase orders or inquiries you submit to us as the website operator, this website uses either an SSL or a TLS encryption program. You can recognize an encrypted connection by checking whether the address line of the browser switches from \u201Chttp://\u201D to \u201Chttps://\u201D and also by the appearance of the lock icon in the browser line.\\n\\n<br />If the SSL or TLS encryption is activated, data you transmit to us cannot be read by third parties.<br /><br /><h3>Encrypted payment transactions on this website\\n</h3><br />If you are under an obligation to share your payment information (e.g. account number if you give us the authority to debit your bank account) with us after you have entered into a fee-based contract with us, this information is required to process payments.<br />Payment transactions using common modes of paying (Visa/MasterCard, debit to your bank account) are processed exclusively via encrypted SSL or TLS connections. You can recognize an encrypted connection by checking whether the address line of the browser switches from \u201Chttp://\u201D to \u201Chttps://\u201D and also by the appearance of the lock icon in the browser line.<br />If the communication with us is encrypted, third parties will not be able to read the payment information you share with us.<br /><br /><h3>Rejection of unsolicited e-mails</h3><br />We herewith object to the use of contact information published in conjunction with the mandatory information to be provided in our Site Notice to send us promotional and information material that we have not expressly requested. The operators of this website and its pages reserve the express right to take legal action in the event of the unsolicited sending of promotional information, for instance via SPAM messages."},"recordingData":{"title":"4. Recording of data on this website","content":"<h3>Cookies</h3><br />Our websites and pages use what the industry refers to as \u201Ccookies.\u201D Cookies are small data packages that do not cause any damage to your device. They are either stored temporarily for the duration of a session (session cookies) or they are permanently archived on your device (permanent cookies). Session cookies are automatically deleted once you terminate your visit. Permanent cookies remain archived on your device until you actively delete them, or they are automatically eradicated by your web browser.<br /><br />Cookies can be issued by us (first-party cookies) or by third-party companies (so-called third-party cookies). Third-party cookies enable the integration of certain services of third-party companies into websites (e.g., cookies for handling payment services).<br /><br />Cookies have a variety of functions. Many cookies are technically essential since certain website functions would not work in the absence of these cookies (e.g., the shopping cart function or the display of videos). Other cookies may be used to analyze user behavior or for promotional purposes.<br /><br />Cookies, which are required for the performance of electronic communication transactions, for the provision of certain functions you want to use (e.g., for the shopping cart function) or those that are necessary for the optimization (required cookies) of the website (e.g., cookies that provide measurable insights into the web audience), shall be stored on the basis of Art. 6(1)(f) GDPR, unless a different legal basis is cited. The operator of the website has a legitimate interest in the storage of required cookies to ensure the technically error-free and optimized provision of the operator\u2019s services. If your consent to the storage of the cookies and similar recognition technologies has been requested, the processing occurs exclusively on the basis of the consent obtained (Art. 6(1)(a) GDPR and \xa7 25 (1) TDDDG); this consent may be revoked at any time.<br /><br />You have the option to set up your browser in such a manner that you will be notified any time cookies are placed and to permit the acceptance of cookies only in specific cases. You may also exclude the acceptance of cookies in certain cases or in general or activate the delete-function for the automatic eradication of cookies when the browser closes. If cookies are deactivated, the functions of this website may be limited.<br /><br />Which cookies and services are used on this website can be found in this privacy policy.<br /><br /><h3>Server log files</h3><br />The provider of this website and its pages automatically collects and stores information in so-called server log files, which your browser communicates to us automatically. The information comprises:<style>ul {list-style-type: disc; padding-left: 20px;}</style><ul>  <li>The type and version of browser used</li> <br />  <li>The used operating system</li>  <br />  <li>Referrer URL</li>  <br />  <li>The hostname of the accessing computer</li>  <br />  <li>The time of the server inquiry</li> <br />  <li>The IP address</li></ul><br />This data is not merged with other data sources.<br /><br />This data is recorded on the basis of Art. 6(1)(f) GDPR. The operator of the website has a legitimate interest in the technically error free depiction and the optimization of the operator\u2019s website. In order to achieve this, server log files must be recorded.<br /><br /><h3>Contact form</h3><br />If you submit inquiries to us via our contact form, the information provided in the contact form as well as any contact information provided therein will be stored by us in order to handle your inquiry and in the event that we have further questions. We will not share this information without your consent.<br /><br />\\n\\nThe processing of these data is based on Art. 6(1)(b) GDPR, if your request is related to the execution of a contract or if it is necessary to carry out pre-contractual measures. In all other cases the processing is based on our legitimate interest in the effective processing of the requests addressed to us (Art. 6(1)(f) GDPR) or on your agreement (Art. 6(1)(a) GDPR) if this has been requested; the consent can be revoked at any time.<br /><br />\\n\\nThe information you have entered into the contact form shall remain with us until you ask us to eradicate the data, revoke your consent to the archiving of data or if the purpose for which the information is being archived no longer exists (e.g., after we have concluded our response to your inquiry). This shall be without prejudice to any mandatory legal provisions, in particular retention periods.<br /><br /><h3>Request by e-mail, telephone or fax</h3><br />If you contact us by e-mail, telephone or fax, your request, including all resulting personal data (name, request) will be stored and processed by us for the purpose of processing your request. We do not pass these data on without your consent.<br /><br />\\n\\nThese data are processed on the basis of Art. 6(1)(b) GDPR if your inquiry is related to the fulfillment of a contract or is required for the performance of pre-contractual measures. In all other cases, the data are processed on the basis of our legitimate interest in the effective handling of inquiries submitted to us (Art. 6(1)(f) GDPR) or on the basis of your consent (Art. 6(1)(a) GDPR) if it has been obtained; the consent can be revoked at any time.<br /><br />\\n\\nThe data sent by you to us via contact requests remain with us until you request us to delete, revoke your consent to the storage or the purpose for the data storage lapses (e.g. after completion of your request). Mandatory statutory provisions - in particular statutory retention periods - remain unaffected.<br /><br /><h3>Google Forms</h3><br />We have integrated Google Forms into this website. The provider is Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland (hereinafter referred to as \u201EGoogle\u201D).<br /><br />\\n\\nGoogle Forms enables us to generate online forms to record messages, inquiries and other entries entered by visitors to our website. All entries you make will be processed on Google\u2019s servers. Google Forms stores a cookie in your browser that contains a unique ID (NID cookie). This cookie stores a wide range of information, including, for example your language settings.<br /><br />\\n\\nWe use Google Forms on the basis of our legitimate interest in determining your needs as effectively as possible (Art. 6(1)(f) GDPR). If appropriate consent has been obtained, the processing is carried out exclusively on the basis of Art. 6(1)(a) GDPR and \xa7 25 (1) TDDDG, insofar the consent includes the storage of cookies or the access to information in the user\u2019s end device (e.g., device fingerprinting) within the meaning of the TDDDG. This consent can be revoked at any time.<br /><br />\\n\\nThe data you enter into the form will remain in our possession until you ask us to delete them, revoke your consent to the archiving of your data or until the purpose of archiving the data no longer exists (e.g., upon completion of the processing of your inquiry). This does not affect mandatory statutory provisions \u2013 in particular those governing retention periods.<br /> <br />For more information, please consult Google\u2019s Data Privacy Policy at <a target=\'_blank\'href=\\"https://policies.google.com/\\">Privacy & Terms \u2013 Google</a>.<br /><br />The company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>Data processing</h3><br />We have concluded a data processing agreement (DPA) for the use of the above-mentioned service. This is a contract mandated by data privacy laws that guarantees that they process personal data of our website visitors only based on our instructions and in compliance with the GDPR.<br /><br /><h3>Registration on this website</h3><br />You have the option to register on this website to be able to use additional website functions. We shall use the data you enter only for the purpose of using the respective offer or service you have registered for. The required information we request at the time of registration must be entered in full. Otherwise, we shall reject the registration.<br /><br />\\n\\nTo notify you of any important changes to the scope of our portfolio or in the event of technical modifications, we shall use the e-mail address provided during the registration process.<br /><br />\\n\\nWe shall process the data entered during the registration process on the basis of your consent (Art. 6(1)(a) GDPR).<br /><br />\\n\\nThe data recorded during the registration process shall be stored by us as long as you are registered on this website. Subsequently, such data shall be deleted. This shall be without prejudice to mandatory statutory retention obligations.<br /><br /><h3>Registration with Facebook Connect</h3><br />Instead of registering directly on this website, you also have the option to register using Facebook Connect. The provider of this service is Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublin 2, Ireland. According to Facebook\u2019s statement the collected data will be transferred to the USA and other third-party countries too.<br /><br />\\n\\nIf you decide to register via Facebook Connect and click on the \u201CLogin with Facebook\u201D/\u201EConnect with Facebook\u201D button, you will be automatically connected to the Facebook platform. There, you can log in using your username and password. As a result, your Facebook profile will be linked to this website or our services. This link gives us access to the data you have archived with Facebook. These data comprise primarily the following:<br /><br />\\n\\n<ul>\\n  <li>Facebook name</li>\\n  <li>Facebook profile photo and cover photo</li>\\n  <li>Facebook cover photo</li>\\n  <li>E-mail address archived with Facebook</li>\\n  <li>Facebook-ID</li>\\n  <li>Facebook friends lists</li>\\n  <li>Facebook Likes (\u201CLikes\u201D information)</li>\\n  <li>Date of birth</li>\\n  <li>Gender</li>\\n  <li>Country</li>\\n  <li>Language</li>\\n</ul><br /><br />\\n\\nThis information will be used to set up, provide and customize your account.<br /><br />The registration via Facebook Connect and the affiliated data processing transactions are implemented on the basis of your consent (Art. 6(1)(a) GDPR). You may revoke this consent at any time, which shall affect all future transactions thereafter.Insofar as personal data is collected on our website with the help of the tool described here and forwarded to Facebook, we and Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Ireland are jointly responsible for this data processing (Art. 26 DSGVO). The joint responsibility is limited exclusively to the collection of the data and its forwarding to Facebook. The processing by Facebook that takes place after the onward transfer is not part of the joint responsibility. The obligations incumbent on us jointly have been set out in a joint processing agreement. The wording of the agreement can be found under: <a target=\'_blank\'href=\\"https://www.facebook.com/legal/controller_addendum\\">Facebook</a>. According to this agreement, we are responsible for providing the privacy information when using the Facebook tool and for the privacy-secure implementation of the tool on our website. Facebook is responsible for the data security of Facebook products. You can assert data subject rights (e.g., requests for information) regarding data processed by Facebook directly with Facebook. If you assert the data subject rights with us, we are obliged to forward them to Facebook.<br /><br />Data transmission to the US is based on the Standard Contractual Clauses (SCC) of the European Commission. Details can be found here: <a target=\'_blank\'href=\\"https://www.facebook.com/legal/EU_data_transfer_addendum\\">Facebook</a>, <a target=\'_blank\'href=\\"https://de-de.facebook.com/help/566994660333381\\">What are Standard Contractual Clauses? Facebook Help Center</a> and <a target=\'_blank\'href=\\"https://www.facebook.com/policy.php\\">Meta Privacy Policy - How Meta collects and uses user data</a>.<br /> <br />For more information, please consult the Facebook Terms of Use and the Facebook Data Privacy Policies. Use these links to access this information: <a target=\'_blank\'href=\\"https://www.facebook.com/about/privacy/\\">Meta Privacy Policy</a> and <a target=\'_blank\'href=\\"https://www.facebook.com/legal/terms/\\">Facebook Legal</a>.<br /><br />The company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000GnywAAC&status=Active\\">Data Privacy Framework</a>.<br /><br /><h3>Registration with Google</h3><br />Instead of registering directly on this website, you can register with Google. The provider of this service is Google Ireland Limited (\u201CGoogle\u201D), Gordon House, Barrow Street, Dublin 4, Ireland.<br /><br />\\n\\nTo register with Google, you must only enter your Google name and password. Google will identify you and confirm your identity to our website.<br /><br />\\n\\nWhen you sign in with Google, we may be able to use certain information in your account to complete your profile with us. You decide whether you want this information to be used and if so, which information it is, within the framework of your Google security settings, which you can find here: <a target=\'_blank\'href=\\"https://myaccount.google.com/security\\">https://myaccount.google.com/security</a> and <a target=\'_blank\'href=\\"https://myaccount.google.com/permissions\\">https://myaccount.google.com/permissions</a>.<br /><br />\\n\\nThe data processing associated with Google\u2019s registration is based on our legitimate interest in making the registration process as simple as possible for our users (Art. 6(1)(f) GDPR). Since the use of the registration function is voluntary and the users themselves can decide on the respective access options, no conflicting predominant rights of the data subjects are apparent.<br /><br />The company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br />"},"socialMedia":{"title":"5. Social Media","content":"<h3>Facebook</h3><br />We have integrated elements of the social network Facebook on this website. The provider of this service is Meta Platforms Ireland Limited, Merrion Road, Dublin 4, D04 X2K5, Ireland. According to Facebook\u2019s statement the collected data will be transferred to the USA and other third-party countries too.<br /><br />\\n\\nAn overview of the Facebook social media elements is available under the following link: <a target=\'_blank\'href=\\"https://developers.facebook.com/docs/plugins/\\">Social Plugins - Documentation - Meta for Developers</a>.<br /><br />If the social media element has been activated, a direct connection between your device and the Facebook server will be established. As a result, Facebook will receive information confirming your visit to this website with your IP address. If you click on the Facebook Like button while you are logged into your Facebook account, you can link content of this website to your Facebook profile. Consequently, Facebook will be able to allocate your visit to this website to your user account. We have to emphasize that we as the provider of the website do not receive any information on the content of the transferred data and its use by Facebook. For more information, please consult the Data Privacy Policy of Facebook at: <a target=\'_blank\'href=\\"https://de-de.facebook.com/privacy/explanation\\">Meta Privacy Policy - How Meta collects and uses user data</a>.<br /><br />\\n\\nThe use of this service is based on your consent in accordance with Art. 6 (1)(a) GDPR and \xa7 25 (1) TDDDG. Consent can be revoked at any time.<br /><br />\\n\\nInsofar as personal data is collected on our website with the help of the tool described here and forwarded to Facebook, we and Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Ireland are jointly responsible for this data processing (Art. 26 DSGVO). The joint responsibility is limited exclusively to the collection of the data and its forwarding to Facebook. The processing by Facebook that takes place after the onward transfer is not part of the joint responsibility. The obligations incumbent on us jointly have been set out in a joint processing agreement. The wording of the agreement can be found under: <a target=\'_blank\'href=\\"https://www.facebook.com/legal/controller_addendum\\">Facebook</a>. According to this agreement, we are responsible for providing the privacy information when using the Facebook tool and for the privacy-secure implementation of the tool on our website. Facebook is responsible for the data security of Facebook products. You can assert data subject rights (e.g., requests for information) regarding data processed by Facebook directly with Facebook. If you assert the data subject rights with us, we are obliged to forward them to Facebook<br /><br />Data transmission to the US is based on the Standard Contractual Clauses (SCC) of the European Commission. Details can be found here: <a target=\'_blank\'href=\\"https://www.facebook.com/legal/EU_data_transfer_addendum\\">Facebook</a>, <a target=\'_blank\'href=\\"https://de-de.facebook.com/help/566994660333381\\">What are Standard Contractual Clauses? Facebook Help Center</a> and <a target=\'_blank\'href=\\"https://www.facebook.com/policy.php\\">Meta Privacy Policy - How Meta collects and uses user data</a>.<br /><br />The company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000GnywAAC&status=Active\\">Data Privacy Framework</a>.<br /><br /><h3>X (formerly Twitter)</h3><br />We have integrated functions of the social media platform X (formerly Twitter) into this website. These functions are provided by the parent company X Corp., 1355 Market Street, Suite 900, San Francisco, CA 94103, USA. The branch Twitter International Unlimited Company, One Cumberland Place, Fenian Street, Dublin 2, D02 AX07, Ireland, is responsible for the data processing of individuals living outside the United States.<br /><br />\\n\\nIf the social media element has been activated, a direct connection between your device and X\u2019s server will be established. As a result, X (formerly Twitter) will receive information on your visit to this website. While you use X (formerly Twitter) and the \u201CRe-Tweet\u201D or \u201CRepost\u201D function, websites you visit are linked to your X (formerly Twitter) account and disclosed to other users. We must point out, that we, the providers of the website and its pages do not know anything about the content of the data transferred and the use of this information by X (formerly Twitter). For more details, please consult the X (formerly Twitter) Data Privacy Declaration at: <a target=\'_blank\'href=\\"https://x.com/en/privacy\\">X Privacy Policy</a>.<br /><br />The use of this service is based on your consent in accordance with Art. 6 (1)(a) GDPR and \xa7 25 (1) TDDDG. Consent can be revoked at any time.<br /><br />Data transmission to the US is based on the Standard Contractual Clauses (SCC) of the European Commission. Details can be found here: <a target=\'_blank\'href=\\"https://gdpr.x.com/en/controller-to-controller-transfers.html\\">Controller-to-Controller Transfers</a>.<br /><br /><h3>Instagram</h3><br />We have integrated functions of the public media platform Instagram into this website. These functions are being offered by Meta Platforms Ireland Limited, Merrion Road, Dublin 4, D04 X2K5, Ireland.<br /><br />\\n\\nIf the social media element has been activated, a direct connection between your device and Instagram\u2019s server will be established. As a result, Instagram will receive information on your visit to this website.<br /><br />\\n\\nIf you are logged into your Instagram account, you may click the Instagram button to link contents from this website to your Instagram profile. This enables Instagram to allocate your visit to this website to your user account. We have to point out that we as the provider of the website and its pages do not have any knowledge of the content of the data transferred and its use by Instagram.<br /><br />\\n\\nThe use of this service is based on your consent in accordance with Art. 6 (1)(a) GDPR and \xa7 25 (1) TDDDG. Consent can be revoked at any time.<br /><br />\\n\\nInsofar as personal data is collected on our website with the help of the tool described here and forwarded to Facebook or Instagram, we and Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Ireland are jointly responsible for this data processing (Art. 26 DSGVO). The joint responsibility is limited exclusively to the collection of the data and its forwarding to Facebook or Instagram. The processing by Facebook or Instagram that takes place after the onward transfer is not part of the joint responsibility. The obligations incumbent on us jointly have been set out in a joint processing agreement. The wording of the agreement can be found under: <a target=\'_blank\'href=\\"https://www.facebook.com/legal/controller_addendum\\">Facebook</a>. According to this agreement, we are responsible for providing the privacy information when using the Facebook or Instagram tool and for the privacy-secure implementation of the tool on our website. Facebook is responsible for the data security of Facebook or Instagram products. You can assert data subject rights (e.g., requests for information) regarding data processed by Facebook or Instagram directly with Facebook. If you assert the data subject rights with us, we are obliged to forward them to Facebook.<br /><br />Data transmission to the US is based on the Standard Contractual Clauses (SCC) of the European Commission. Details can be found here: <a target=\'_blank\'href=\\"https://www.facebook.com/legal/controller_addendum\\">Facebook</a> and <a target=\'_blank\'href=\\"https://www.facebook.com/legal/EU_data_transfer_addendum\\">Facebook</a>, <a target=\'_blank\'href=\\"https://privacycenter.instagram.com/policy/\\">Meta Privacy Policy - How Meta collects and uses user data</a> and <a target=\'_blank\'href=\\"https://de-de.facebook.com/help/566994660333381\\">What are Standard Contractual Clauses? Facebook Help Center</a>.<br /><br />For more information on this subject, please consult Instagram\u2019s Data Privacy Declaration at:<a target=\'_blank\'href=\\"https://privacycenter.instagram.com/policy/\\">Meta Privacy Policy - How Meta collects and uses user data</a>.<br /><br />The company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000GnywAAC&status=Active\\">Data Privacy Framework</a>.<br /><br /><h3>LinkedIn</h3><br />This website uses elements of the LinkedIn network. The provider is LinkedIn Ireland Unlimited Company, Wilton Plaza, Wilton Place, Dublin 2, Ireland.<br /><br />\\n\\nAny time you access a page of this website that contains elements of LinkedIn, a connection to LinkedIn\u2019s servers is established. LinkedIn is notified that you have visited this website with your IP address. If you click on LinkedIn\u2019s \u201CRecommend\u201D button and are logged into your LinkedIn account at the time, LinkedIn will be in a position to allocate your visit to this website to your user account. We have to point out that we as the provider of the websites do not have any knowledge of the content of the transferred data and its use by LinkedIn.<br /><br />\\n\\nThe use of this service is based on your consent in accordance with Art. 6 (1)(a) GDPR and \xa7 25 (1) TDDDG. Consent can be revoked at any time.<br /><br />Data transmission to the US is based on the Standard Contractual Clauses (SCC) of the European Commission. Details can be found here: <a target=\'_blank\'href=\\"https://www.linkedin.com/help/linkedin/answer/a1343190/datenubertragung-aus-der-eu-dem-ewr-und-der-schweiz?lang=de\\">https://www.linkedin.com/help/linkedin/answer/a1343190/datenubertragung-aus-der-eu-dem-ewr-und-der-schweiz?lang=de</a>.<br /><br />For further information on this subject, please consult LinkedIn\u2019s Data Privacy Declaration at: <a target=\'_blank\'href=\\"https://www.linkedin.com/legal/privacy-policy\\">https://www.linkedin.com/legal/privacy-policy</a>.<br /><br />The company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5448\\">Data Privacy Framework</a>.<br /><br /><h3>XING</h3><br />This website uses elements of the XING network. The provider is the New Work SE, Am Strandkai 1, 20457 Hamburg, Germany.<br /><br />\\n\\nAny time one of our sites/pages that contains elements of XING is accessed, a connection with XING\u2019s servers is established. As far as we know, this does not result in the archiving of any personal data. In particular, the service does not store any IP addresses or analyze user patterns.<br /><br />\\n\\nThe use of this service is based on your consent in accordance with Art. 6 (1)(a) GDPR and \xa7 25 (1) TDDDG. Consent can be revoked at any time.<br /><br />\\n\\nFor more information on data protection and the XING share button please consult the Data Protection Declaration of Xing at: <a target=\'_blank\'href=\\"https://privacy.xing.com/de/datenschutzerklaerung\\">Datenschutz bei XING</a>.<br />"},"analysisTools":{"title":"6. Analysis tools and advertising","content":"<h3>Google Tag Manager</h3><br />We use the Google Tag Manager. The provider is Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland.<br /><br />\\n\\nThe Google Tag Manager is a tool that allows us to integrate tracking or statistical tools and other technologies on our website. The Google Tag Manager itself does not create any user profiles, does not store cookies, and does not carry out any independent analyses. It only manages and runs the tools integrated via it. However, the Google Tag Manager does collect your IP address, which may also be transferred to Google\u2019s parent company in the United States.<br /><br />\\n\\nThe Google Tag Manager is used on the basis of Art. 6(1)(f) GDPR. The website operator has a legitimate interest in the quick and uncomplicated integration and administration of various tools on his website. If appropriate consent has been obtained, the processing is carried out exclusively on the basis of Art. 6(1)(a) GDPR and \xa7 25 (1) TDDDG, insofar the consent includes the storage of cookies or the access to information in the user\u2019s end device (e.g., device fingerprinting) within the meaning of the TDDDG. This consent can be revoked at any time.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>Google Analytics</h3><br />This website uses functions of the web analysis service Google Analytics. The provider of this service is Google Ireland Limited (\u201CGoogle\u201D), Gordon House, Barrow Street, Dublin 4, Ireland.<br /><br />\\n\\nGoogle Analytics enables the website operator to analyze the behavior patterns of website visitors. To that end, the website operator receives a variety of user data, such as pages accessed, time spent on the page, the utilized operating system and the user\u2019s origin. This data is assigned to the respective end device of the user. An assignment to a user-ID does not take place.<br /><br />\\n\\nFurthermore, Google Analytics allows us to record your mouse and scroll movements and clicks, among other things. Google Analytics uses various modeling approaches to augment the collected data sets and uses machine learning technologies in data analysis.<br /><br />\\n\\nGoogle Analytics uses technologies that make the recognition of the user for the purpose of analyzing the user behavior patterns (e.g., cookies or device fingerprinting). The website use information recorded by Google is, as a rule transferred to a Google server in the United States, where it is stored.<br /><br />\\n\\nThe use of these services occurs on the basis of your consent pursuant to Art. 6(1)(a) GDPR and \xa7 25(1) TDDDG. You may revoke your consent at any time.<br /><br />\\n\\nData transmission to the US is based on the Standard Contractual Clauses (SCC) of the European Commission. Details can be found here: <a target=\'_blank\'href=\\"https://privacy.google.com/businesses/controllerterms/mccs/\\">https://privacy.google.com/businesses/controllerterms/mccs/</a>.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>IP anonymization</h3><br />Google Analytics IP anonymization is active. As a result, your IP address will be abbreviated by Google within the member states of the European Union or in other states that have ratified the Convention on the European Economic Area prior to its transmission to the United States. The full IP address will be transmitted to one of Google\u2019s servers in the United States and abbreviated there only in exceptional cases. On behalf of the operator of this website, Google shall use this information to analyze your use of this website to generate reports on website activities and to render other services to the operator of this website that are related to the use of the website and the Internet. The IP address transmitted in conjunction with Google Analytics from your browser shall not be merged with other data in Google\u2019s possession.<br /><br /><h3>Browser plug-in</h3><br />You can prevent the recording and processing of your data by Google by downloading and installing the browser plugin available under the following link: <a target=\'_blank\'href=\\"https://tools.google.com/dlpage/gaoptout?hl=en\\">Google Analytics Opt-out Browser Add-on Download Page</a>.<br /><br />\\n\\nFor more information about the handling of user data by Google Analytics, please consult Google\u2019s Data Privacy Declaration at: <a target=\'_blank\'href=\\"https://support.google.com/analytics/answer/6004245?hl=en\\">Safeguarding your data - Analytics Help</a>.<br /><br /><h3>Demographic parameters provided by Google Analytics</h3><br />This website uses the \u201Cdemographic characteristics\u201D function of Google Analytics, to be able to display to the website visitor compatible ads within the Google advertising network. This allows reports to be created that contain information about the age, gender, and interests of the website visitors. The sources of this information are interest-related advertising by Google as well as visitor data obtained from third-party providers. This data cannot be allocated to a specific individual. You have the option to deactivate this function at any time by making pertinent settings changes for advertising in your Google account or you can generally prohibit the recording of your data by Google Analytics as explained in section \u201CObjection to the recording of data\u201D.<br /><br /><h3>Contract data processing\\n</h3><br />We have executed a contract data processing agreement with Google and are implementing the stringent provisions of the German data protection agencies to the fullest when using Google Analytics.<br /><br /><h3>Google Analytics E-Commerce-Tracking</h3><br />This website uses the \u201CE-Commerce Tracking\u201D function of Google Analytics. With the assistance of E-Commerce Tracking, the website operator is in a position to analyze the purchasing patterns of website visitors with the aim of improving the operator\u2019s online marketing campaigns. In this context, information, such as the orders placed, the average order values, shipping costs and the time from viewing the product to making the purchasing decision are tracked. These data may be consolidated by Google under a transaction ID, which is allocated to the respective user or the user\u2019s device.<br /><br /><h3>WP Statistics</h3><br />This website uses the WP Statistics analysis tool to evaluate visitor accesses statistically. The provider is Veronalabs, Tatari 64, 10134, Tallinn, Estonia (<a target=\'_blank\'href=\\"https://veronalabs.com\\">https://veronalabs.com</a>).<br /><br />\\n\\nWP Statistics can be used to analyze the use of our website. In doing so, WP Statistics records, among other things, log files (IP address, referrer, browser used, origin of the user, search engine used) and actions that the website visitors have taken on the site (e.g. clicks and views).<br /><br />\\n\\nThe data collected with WP Statistics is stored exclusively on our own server.<br /><br />\\n\\nThe use of this analysis tool is based on Art. 6(1)(f) GDPR. We have a legitimate interest in the anonymized analysis of user behavior in order to optimize both our websites and our advertising. If appropriate consent has been obtained, the processing is carried out exclusively on the basis of Art. 6(1)(a) GDPR and \xa7 25 (1) TDDDG, insofar the consent includes the storage of cookies or the access to information in the user\u2019s end device (e.g., device fingerprinting) within the meaning of the TDDDG. This consent can be revoked at any time.<br /><br /><h3>IP anonymization</h3><br />We use WP Statistics with anonymized IP. Your IP address is shortened so that it can no longer be directly assigned to you.<br /><br /><h3>Google Ads</h3><br />The website operator uses Google Ads. Google Ads is an online promotional program of Google Ireland Limited (\u201CGoogle\u201D), Gordon House, Barrow Street, Dublin 4, Ireland.<br /><br />\\n\\nGoogle Ads enables us to display ads in the Google search engine or on third-party websites, if the user enters certain search terms into Google (keyword targeting). It is also possible to place targeted ads based on the user data Google has in its possession (e.g., location data and interests; target group targeting). As the website operator, we can analyze these data quantitatively, for instance by analyzing which search terms resulted in the display of our ads and how many ads led to respective clicks.<br /><br />\\n\\nThe use of these services occurs on the basis of your consent pursuant to Art. 6(1)(a) GDPR and \xa7 25(1) TDDDG. You may revoke your consent at any time.<br /><br />\\n\\nData transmission to the US is based on the Standard Contractual Clauses (SCC) of the European Commission. Details can be found here: <a target=\'_blank\'href=\\"https://policies.google.com/privacy/frameworks\\">Data transfer frameworks \u2013 Privacy & Terms \u2013 Google</a> and <a target=\'_blank\'href=\\"https://business.safety.google/controllerterms/\\">Google Controller-Controller Data Protection Terms</a>.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>Google AdSense (not personalized)</h3><br />This website uses Google AdSense, an ad embedding service provided by Google Ireland Limited (\u201CGoogle\u201D), Gordon House, Barrow Street, Dublin 4, Ireland.<br /><br />\\n\\nWe use Google AdSense in the \u201Cnon-personalized\u201D mode. Contrary to the personalized mode, the ads are not based on your previous user patterns and the service does not generate a user profile for you. Instead, the service uses so-called \u201Ccontext information\u201D to choose the ads that are posted for you to view. The selected ads are thus based e.g., on your location, the content of the website you are visiting at the time, or the search terms you are using. To learn more about the distinct differences between personalized targeting and targeting that has not been personalized by Google AdSense, please click on the following link: <a target=\'_blank\'href=\\"https://support.google.com/adsense/answer/9007336\\">Personalized and non-personalized ads - Google AdSense Help</a>.<br /><br />\\n\\nPlease keep in mind that if Google Adsense is used in the non-personalized mode, it is possible that cookies are stored or comparable recognition technologies (e.g., device fingerprinting) are used.<br /><br />\\n\\nThe use of these services occurs on the basis of your consent pursuant to Art. 6(1)(a) GDPR and \xa7 25(1) TDDDG. You may revoke your consent at any time.<br /><br />\\n\\nData transmission to the US is based on the Standard Contractual Clauses (SCC) of the European Commission. Details can be found here: <a target=\'_blank\'href=\\"https://privacy.google.com/businesses/controllerterms/mccs/\\">https://privacy.google.com/businesses/controllerterms/mccs/</a>.<br /><br />\\n\\nYou have the option to autonomously adjust the advertising settings in your user account. To do so, please click on the link provided below and log in: <a target=\'_blank\'href=\\"https://adssettings.google.com/authenticated\\">https://adssettings.google.com/authenticated</a>.<br /><br />\\n\\nFor more information about Google\u2019s advertising technologies, please click here: <a target=\'_blank\'href=\\"https://policies.google.com/technologies/ads\\">Advertising \u2013 Privacy & Terms \u2013 Google</a> and <a target=\'_blank\'href=\\"https://www.google.de/intl/de/policies/privacy/\\">Datenschutzerkl\xe4rung \u2013 Datenschutzerkl\xe4rung & Nutzungsbedingungen \u2013 Google</a>.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>Google Ads Remarketing</h3><br />This website uses the functions of Google Ads Remarketing. The provider of these solutions is Google Ireland Limited (\u201CGoogle\u201D), Gordon House, Barrow Street, Dublin 4, Ireland.<br /><br />\\n\\nWith Google Ads Remarketing, we can assign people who interact with our online offering to specific target groups in order to subsequently display interest-based advertising to them in the Google advertising network (remarketing or retargeting).<br /><br />\\n\\nMoreover, it is possible to link the advertising target groups generated with Google Ads Remarketing to device encompassing functions of Google. This makes it possible to display interest-based customized advertising messages, depending on your prior usage and browsing patterns on a device (e.g., cell phone) in a manner tailored to you as well as on any of your devices (e.g., tablet or PC).<br /><br />\\n\\nIf you have a Google account, you have the option to object to personalized advertising under the following link: <a target=\'_blank\'href=\\"https://adssettings.google.com/anonymous?hl=de\\">https://adssettings.google.com/anonymous?hl=de</a>.<br /><br />\\n\\nThe use of these services occurs on the basis of your consent pursuant to Art. 6(1)(a) GDPR and \xa7 25(1) TDDDG. You may revoke your consent at any time.<br /><br />\\n\\nFor further information and the pertinent data protection regulations, please consult the Data Privacy Policies of Google at: <a target=\'_blank\'href=\\"https://policies.google.com/technologies/ads?hl=en\\">Advertising \u2013 Privacy & Terms \u2013 Google</a>.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>Formation of Target Groups with Customer Reconciliation\\n</h3><br />For the formation of target groups, we use, among other things, the Google Ads Remarketing customer reconciliation feature. To achieve this, we transfer certain customer data (e.g., email addresses) from our customer lists to Google. If the respective customers are Google users and are logged into their Google accounts, matching advertising messages within the Google network (e.g., YouTube, Gmail or in a search engine) are displayed for them to view.<br /><br /><h3>Google Conversion-Tracking</h3><br />This website uses Google Conversion Tracking. The provider of this service is Google Ireland Limited (\u201CGoogle\u201D), Gordon House, Barrow Street, Dublin 4, Ireland.<br /><br />\\n\\nWith the assistance of Google Conversion Tracking, we are in a position to recognize whether the user has completed certain actions. For instance, we can analyze how frequently which buttons on our website have been clicked and which products are reviewed or purchased with particular frequency. The purpose of this information is to compile conversion statistics. We learn how many users have clicked on our ads and which actions they have completed. We do not receive any information that would allow us to personally identify the users. Google as such uses cookies or comparable recognition technologies for identification purposes.<br /><br />\\n\\nThe use of these services occurs on the basis of your consent pursuant to Art. 6(1)(a) GDPR and \xa7 25(1) TDDDG. You may revoke your consent at any time.<br /><br />\\n\\nFor more information about Google Conversion Tracking, please review Google\u2019s data protection policy at: <a target=\'_blank\'href=\\"https://policies.google.com/privacy?hl=en\\">Privacy Policy \u2013 Privacy & Terms \u2013 Google</a>.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br />"},"newsletterPrivacyPolicy":{"title":"7. Newsletter","content":"<h3>Newsletter mailing to existing customers</h3><br />If you order goods or services from us and enter your e-mail address, this e-mail address may subsequently be used by us to send you newsletters, provided we inform you of this in advance. In such a case, only direct advertising for our own similar goods or services will be sent via the newsletter. You can unsubscribe from this newsletter at any time. There is a corresponding link in every newsletter for this purpose. In this case, the legal basis for sending the newsletter is Art. 6 (1)(f) GDPR in conjunction with Section 7 (3) UWG.<br /><br />\\n\\nAfter you unsubscribe from the newsletter distribution list, we may store your email address in a blacklist to prevent future mailings to you. The data from the blacklist will only be used for this purpose and will not be merged with other data. This serves both your interest and our interest in complying with the legal requirements when sending newsletters (legitimate interest within the meaning of Art. 6 (1)(f) GDPR). Storage in the blacklist is not limited in time. You can object to the storage if your interests outweigh our legitimate interest.<br />"},"pluginsTools":{"title":"8. Plug-ins and Tools","content":"<h3>YouTube with expanded data protection integration\\n</h3><br />This website integrates videos from the YouTube website. The operator of the website is Google Ireland Limited (\u201CGoogle\u201D), Gordon House, Barrow Street, Dublin 4, Ireland.<br /><br />\\n\\nWhen you visit one of these websites on which YouTube is integrated, a connection to the YouTube servers is established. This tells the YouTube server which of our pages you have visited. If you are logged into your YouTube account, you enable YouTube to assign your surfing behavior directly to your personal profile. You can prevent this by logging out of your YouTube account.<br /><br />\\n\\nWe use YouTube in extended data protection mode. According to YouTube, videos that are played in extended data protection mode are not used to personalize browsing on YouTube. Ads that are played in extended data protection mode are also not personalized. No cookies are set in extended data protection mode. Instead, so-called local storage elements are stored in the user\'s browser, which contain personal data similar to cookies and can be used for recognition. Details on the extended data protection mode can be found here: <a target=\'_blank\'href=\\"https://support.google.com/youtube/answer/171780\\">Embed videos & playlists - YouTube Help</a>.<br /><br />\\n\\nAfter activating a YouTube video, further data processing operations may be triggered over which we have no influence.<br /><br />\\n\\nThe use of YouTube is based on our interest in presenting our online content in an appealing manner. Pursuant to Art. 6(1)(f) GDPR, this is a legitimate interest. If appropriate consent has been obtained, the processing is carried out exclusively on the basis of Art. 6(1)(a) GDPR and \xa7 25 (1) TDDDG, insofar the consent includes the storage of cookies or the access to information in the user\u2019s end device (e.g., device fingerprinting) within the meaning of the TDDDG. This consent can be revoked at any time.<br /><br />\\n\\nFor more information on how YouTube handles user data, please consult the YouTube Data Privacy Policy under: <a target=\'_blank\'href=\\"https://policies.google.com/privacy?hl=en\\">Privacy Policy \u2013 Privacy & Terms \u2013 Google</a>.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>Vimeo Without Tracking (Do-Not-Track)</h3><br />This website uses plugins of the Vimeo video portal. The provider is Vimeo Inc., 555 West 18th Street, New York, New York 10011, USA.<br /><br />\\n\\nWhenever you visit one of our pages featuring Vimeo videos, a connection with the servers of Vimeo is established. In conjunction with this, the Vimeo server receives information about which of our sites you have visited. Vimeo also receives your IP address. However, we have set up Vimeo in such a way that Vimeo cannot track your user activities and does not place any cookies.<br /><br />\\n\\nWe use Vimeo to make our online presentation attractive for you. This is a legitimate interest on our part pursuant to Art. 6(1)(f) GDPR. If a respective declaration of consent was requested (e.g. concerning the storage of cookies), processing shall occur exclusively on the basis of Art. 6(1)(a) GDPR; the given consent may be revoked at any time.<br /><br />\\n\\nData transmission to the US is based on the Standard Contractual Clauses (SCC) of the European Commission and, according to Vimeo, on \u201Clegitimate business interests\u201D. Details can be found here: <a target=\'_blank\'href=\\"https://vimeo.com/privacy\\">Privacy Policy on Vimeo</a>.<br /><br />\\n\\nFor more information on the handling of user data, please consult Vimeo\u2019s data privacy policy at: <a target=\'_blank\'href=\\"https://vimeo.com/privacy\\">Privacy Policy on Vimeo</a>.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5711\\">Data Privacy Framework</a>.<br /><br /><h3>Google Fonts (local embedding)</h3><br />This website uses so-called Google Fonts provided by Google to ensure the uniform use of fonts on this site. These Google fonts are locally installed so that a connection to Google\u2019s servers will not be established in conjunction with this application.<br /><br />\\n\\nFor more information on Google Fonts, please follow this link: <a target=\'_blank\'href=\\"https://developers.google.com/fonts/faq\\">Frequently Asked Questions - Google Fonts - Google for Developers</a> and consult Google\u2019s Data Privacy Declaration under: <a target=\'_blank\'href=\\"https://policies.google.com/privacy?hl=en\\">Privacy Policy \u2013 Privacy & Terms \u2013 Google</a>.<br /><br /><h3>Adobe Fonts</h3><br />In order to ensure the uniform depiction of certain fonts, this website uses fonts called Adobe Fonts provided by Adobe Systems Incorporated, 345 Park Avenue, San Jose, CA 95110-2704, USA (Adobe).<br /><br />\\n\\nWhen you access pages of this website, your browser will automatically load the required fonts directly from the Adobe site to be able to display them correctly on your device. As a result, your browser will establish a connection with Adobe\u2019s servers in the United States. Hence, Adobe learns that your IP address was used to access this website. According to the information provided by Adobe, no cookies will be stored in conjunction with the provision of the fonts.<br /><br />\\n\\nData are stored and analyzed on the basis of Art. 6(1)(f) GDPR. The website operator has a legitimate interest in a uniform presentation of the font on the operator\u2019s website. If appropriate consent has been obtained, the processing is carried out exclusively on the basis of Art. 6(1)(a) GDPR and \xa7 25 (1) TDDDG, insofar the consent includes the storage of cookies or the access to information in the user\u2019s end device (e.g., device fingerprinting) within the meaning of the TDDDG. This consent can be revoked at any time.<br /><br />\\n\\nData transmission to the US is based on the Standard Contractual Clauses (SCC) of the European Commission. Details can be found here: <a target=\'_blank\'href=\\"https://www.adobe.com/de/privacy/eudatatransfers.html\\">Datenschutzzentrum von Adobe</a>.<br /><br />\\n\\nFor more information about Adobe Fonts, please read the policies under: <a target=\'_blank\'href=\\"https://www.adobe.com/privacy/policies/adobe-fonts.html\\">Adobe Privacy Center</a>.<br /><br />\\n\\nAdobe\u2019s Data Privacy Declaration may be reviewed under: <a target=\'_blank\'href=\\"https://www.adobe.com/privacy/policy.html\\">Adobe Privacy Center</a>.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TNo9AAG&status=Active\\">Data Privacy Framework</a>.<br /><br /><h3>Google Maps</h3><br />This website uses the mapping service Google Maps. The provider is Google Ireland Limited (\u201CGoogle\u201D), Gordon House, Barrow Street, Dublin 4, Ireland. With the means of this service, we can integrate map material on our website.<br /><br />\\n\\nTo enable the use of the Google Maps features, your IP address must be stored. As a rule, this information is transferred to one of Google\u2019s servers in the United States, where it is archived. The operator of this website has no control over the data transfer. In case Google Maps has been activated, Google has the option to use Google Fonts for the purpose of the uniform depiction of fonts. When you access Google Maps, your browser will load the required web fonts into your browser cache, to correctly display text and fonts.<br /><br />\\n\\nWe use Google Maps to present our online content in an appealing manner and to make the locations disclosed on our website easy to find. This constitutes a legitimate interest as defined in Art. 6(1)(f) GDPR. If appropriate consent has been obtained, the processing is carried out exclusively on the basis of Art. 6(1)(a) GDPR and \xa7 25 (1) TDDDG, insofar the consent includes the storage of cookies or the access to information in the user\u2019s end device (e.g., device fingerprinting) within the meaning of the TDDDG. This consent can be revoked at any time.<br /><br />\\n\\nData transmission to the US is based on the Standard Contractual Clauses (SCC) of the European Commission. Details can be found here: <a target=\'_blank\'href=\\"https://privacy.google.com/businesses/gdprcontrollerterms/\\">Google Controller-Controller Data Protection Terms</a> and <a target=\'_blank\'href=\\"https://privacy.google.com/businesses/gdprcontrollerterms/sccs/\\">https://privacy.google.com/businesses/gdprcontrollerterms/sccs/</a>.<br /><br />\\n\\nFor more information on the handling of user data, please review Google\u2019s Data Privacy Declaration under: <a target=\'_blank\'href=\\"https://policies.google.com/privacy?hl=en\\">Privacy Policy \u2013 Privacy & Terms \u2013 Google</a>.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>Bing Maps</h3><br />We have integrated Bing Maps on this website. The provider is Microsoft Corporation, One Microsoft Way, Redmond, WA 98052-6399, United States (hereinafter \u201CBing Maps\u201D). With the means of this service, we can integrate map material on our website.<br /><br />\\n\\nTo use the features of Bing Maps, it is necessary to store your IP address. This information is usually transmitted to a Microsoft server in the USA and stored there. The provider of this site has no influence on this data transfer.<br /><br />\\n\\nThe use of Bing is in the interest of an appealing presentation of our online offers and to make it easy to find the places we have indicated on the website. This presents a legitimate interest within the meaning of Art. 6 (1)(f) GDPR. If a corresponding consent has been requested, the processing is carried out exclusively on the basis of Art. 6 (1)(a) GDPR and \xa7 25 (1) TDDDG, insofar as the consent includes the storage of cookies or access to information in the user\'s terminal device (e.g., device fingerprinting) within the meaning of the TDDDG. Consent can be revoked at any time.<br /><br />\\n\\nData transfer to the USA is based on the standard contractual clauses of the EU Commission. You can find details here: <a target=\'_blank\'href=\\"https://learn.microsoft.com/de-de/compliance/regulatory/offering-eu-model-clauses\\">Standardvertragsklauseln der Europ\xe4ischen Union - Microsoft Compliance</a>.<br /><br />\\n\\nFurther details can be found in the provider\'s privacy policy at <a target=\'_blank\'href=\\"https://www.microsoft.com/en-us/maps/bing-maps/product\\">Microsoft Bing Maps Platform APIs Terms Of Use - Microsoft Map Solutions</a>.<br /><br /><h3>Google reCAPTCHA</h3><br />We use \u201CGoogle reCAPTCHA\u201D (hereinafter referred to as \u201CreCAPTCHA\u201D) on this website. The provider is Google Ireland Limited (\u201CGoogle\u201D), Gordon House, Barrow Street, Dublin 4, Ireland.<br /><br />\\n\\nThe purpose of reCAPTCHA is to determine whether data entered on this website (e.g., information entered into a contact form) is being provided by a human user or by an automated program. To determine this, reCAPTCHA analyzes the behavior of the website visitors based on a variety of parameters. This analysis is triggered automatically as soon as the website visitor enters the site. For this analysis, reCAPTCHA evaluates a variety of data (e.g., IP address, time the website visitor spent on the site or cursor movements initiated by the user). The data tracked during such analyses are forwarded to Google.<br /><br />\\n\\nreCAPTCHA analyses run entirely in the background. Website visitors are not alerted that an analysis is underway.<br /><br />\\n\\nData are stored and analyzed on the basis of Art. 6(1)(f) GDPR. The website operator has a legitimate interest in the protection of the operator\u2019s websites against abusive automated spying and against SPAM. If appropriate consent has been obtained, the processing is carried out exclusively on the basis of Art. 6(1)(a) GDPR and \xa7 25 (1) TDDDG, insofar the consent includes the storage of cookies or the access to information in the user\u2019s end device (e.g., device fingerprinting) within the meaning of the TDDDG. This consent can be revoked at any time.<br /><br />\\n\\nFor more information about Google reCAPTCHA please refer to the Google Data Privacy Declaration and Terms Of Use under the following links: <a target=\'_blank\'href=\\"https://policies.google.com/privacy?hl=en\\">Privacy Policy \u2013 Privacy & Terms \u2013 Google</a> and <a target=\'_blank\'href=\\"https://policies.google.com/terms?hl=en\\">Google Terms of Service \u2013 Privacy & Terms \u2013 Google</a>.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>hCaptcha</h3><br />We use \u201ChCaptcha\u201D (hereinafter referred to as \u201ChCaptcha\u201D) on this website. The provider is Intuition Machines, Inc., 2211 Selig Drive, Los Angeles, CA 90026, USA (hereinafter referred to as \u201CIMI\u201D).<br /><br />\\n\\nhCaptcha is being used to determine whether the entry of data into this website (e.g., into a contact form) is being processed by a person or an automated program. For this purpose, hCaptcha analyzes the behavior patterns of website visitors on the basis of several characteristics.<br /><br />\\n\\nThis analysis begins automatically as soon as the website visitor enters a website with the activated hCaptcha feature. For the analysis, hCaptcha uses a wide range of information (e.g., the IP address, time spent on the website or mouse actions taken by the user). The data recorded during this analysis is forwarded to IMI. If hCaptcha is used in the \u201Cinvisible mode,\u201D the analyses are completely conducted in the background. Website visitors are not alerted to the performance of an analysis.<br /><br />\\n\\nThe storage and analysis of the data occurs on the basis of Art. 6 (1)(f) GDPR. The website operator has a legitimate interest in protecting the operator\u2019s web presentations against abusive automatic spying and SPAM. In the event that respective consent has been obtained, the data will be processed exclusively on the basis of Art. 6 (1)(a) GDPR and \xa7 25 (1) TDDDG, if the consent comprises the storage of cookies or access to information on the user\u2019s device (e.g., device fingerprinting) as defined in the TDDDG (German Telecommunications Act). Such consent may be revoked at any time.<br /><br />\\n\\nThe processing of data is based on Standard Contract Clauses, included in the Data Processing Supplement to the General Terms and Conditions of IMI or in the data processing agreements.<br /><br />\\n\\nFor further information on hCaptcha, please consult the Data Protection Policy and Terms of Use under the following links: <a target=\'_blank\'href=\\"https://www.hcaptcha.com/privacy\\">hCaptcha - Privacy Policy</a> and <a target=\'_blank\'href=\\"https://hcaptcha.com/terms\\">hCaptcha - Terms</a>.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/list\\">Data Privacy Framework</a>.<br /><br />"},"eCommerce":{"title":"9. eCommerce and payment service providers","content":"<h3>Processing of Customer and Contract Data</h3><br />\\nWe collect, process, and use personal customer and contract data for the establishment, content arrangement and modification of our contractual relationships. Data with personal references to the use of this website (usage data) will be collected, processed, and used only if this is necessary to enable the user to use our services or required for billing purposes. The legal basis for these processes is Art. 6(1)(b) GDPR.<br /><br />\\n\\nThe collected customer data shall be deleted upon completion of the order or termination of the business relationship and upon expiration of any existing statutory archiving periods. This shall be without prejudice to any statutory archiving periods.<br /><br /><h3>Data transfer upon closing of contracts for online stores, retailers, and the shipment of merchandise</h3><br />\\nWhenever you order merchandise from us, we will share your personal data with the transportation company entrusted with the delivery as well as the payment service commissioned to handle the payment transactions. Only the data these respective service providers require to meet their obligations will be shared. The legal basis for this sharing is Art. 6 (1)(b) GDPR, which permits the processing of data for the fulfillment of contractual or pre-contractual obligations. If you give us your respective consent pursuant to Art. 6 (1)(a) GDPR, we will share your email address with the transportation company entrusted with the delivery so that this company can notify you on the shipping status for your order via email. You have the option to revoke your consent at any time.<br /><br /><h3>Data transfer upon closing of contracts for services and digital content</h3><br />\\nWe share personal data with third parties only if this is necessary in conjunction with the handling of the contract; for instance, with the financial institution tasked with the processing of payments.<br /><br />\\n\\nAny further transfer of data shall not occur or shall only occur if you have expressly consented to the transfer. Any sharing of your data with third parties in the absence of your express consent, for instance for advertising purposes, shall not occur.<br /><br />\\n\\nThe basis for the processing of data is Art. 6(1)(b) GDPR, which permits the processing of data for the fulfilment of a contract or for pre-contractual actions.<br /><br />\\n\\n<h3>Credit checks</h3><br />\\nWe may conduct a credit check in the event that purchases are made on account or based on other payment terms that require us to extend credit (scoring). For this purpose, we transmit the data you have entered (e.g., name, address, age, or banking information) to a credit information agency. Based on this data, the probability of non-payment is determined. If the likelihood of non-payment is excessive, we may reject the respective payment term.<br /><br />The credit check is performed on the basis of contractual fulfillment (Art. 6(1)(b) GDPR) and to avert non-payment (justified interest pursuant to Art. 6(1)(f) GDPR). If consent has been obtained, the credit check shall be performed on the basis of this consent (Art. 6(1)(a) GDPR); the consent may be revoked at any time.<br /><br /><h3>Payment services</h3><br />\\nWe integrate payment services of third-party companies on our website. When you make a purchase from us, your payment data (e.g. name, payment amount, bank account details, credit card number) are processed by the payment service provider for the purpose of payment processing. For these transactions, the respective contractual and data protection provisions of the respective providers apply. The use of the payment service providers is based on Art. 6(1)(b) GDPR (contract processing) and in the interest of a smooth, convenient, and secure payment transaction (Art. 6(1)(f) GDPR). Insofar as your consent is requested for certain actions, Art. 6(1)(a) GDPR is the legal basis for data processing; consent may be revoked at any time for the future.<br /><br />\\n\\nWe use the following payment services / payment service providers within the scope of this website:<br /><br />\\n\\n<b>PayPal</b><br />\\nThe provider of this payment service is PayPal (Europe) S.\xe0.r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg (hereinafter \u201CPayPal\u201D).<br /><br />\\n\\nData transmission to the US is based on the Standard Contractual Clauses (SCC) of the European Commission. Details can be found here: <a target=\'_blank\'href=\\"https://www.paypal.com/de/webapps/mpp/ua/pocpsa-full\\">PayPal</a>.<br /><br />\\n\\nDetails can be found in PayPal\u2019s privacy policy: <a target=\'_blank\'href=\\"https://www.paypal.com/de/webapps/mpp/ua/privacy-full\\">PayPal-Datenschutzerkl\xe4rung</a>.<br /><br />"},"conferenceTools":{"title":"10. Online-based Audio and Video Conferences (Conference tools)","content":"<h3>Data processing</h3><br />\\nWe use online conference tools, among other things, for communication with our customers. The tools we use are listed in detail below. If you communicate with us by video or audio conference using the Internet, your personal data will be collected and processed by the provider of the respective conference tool and by us. The conferencing tools collect all information that you provide/access to use the tools (email address and/or your phone number). Furthermore, the conference tools process the duration of the conference, start and end (time) of participation in the conference, number of participants and other \u201Ccontext information\u201D related to the communication process (metadata).<br /><br />\\n\\nFurthermore, the provider of the tool processes all the technical data required for the processing of the online communication. This includes, in particular, IP addresses, MAC addresses, device IDs, device type, operating system type and version, client version, camera type, microphone or loudspeaker and the type of connection.<br /><br />\\n\\nShould content be exchanged, uploaded, or otherwise made available within the tool, it is also stored on the servers of the tool provider. Such content includes, but is not limited to, cloud recordings, chat/ instant messages, voicemail uploaded photos and videos, files, whiteboards, and other information shared while using the service.<br /><br />\\n\\nPlease note that we do not have complete influence on the data processing procedures of the tools used. Our possibilities are largely determined by the corporate policy of the respective provider. Further information on data processing by the conference tools can be found in the data protection declarations of the tools used, and which we have listed below this text.<br /><br />\\n\\n<h3>Purpose and legal bases</h3><br />\\nThe conference tools are used to communicate with prospective or existing contractual partners or to offer certain services to our customers (Art. 6(1)(b) GDPR). Furthermore, the use of the tools serves to generally simplify and accelerate communication with us or our company (legitimate interest in the meaning of Art. 6(1)(f) GDPR). Insofar as consent has been requested, the tools in question will be used on the basis of this consent; the consent may be revoked at any time with effect from that date.<br /><br />\\n\\n<h3>Duration of storage</h3><br />\\nData collected directly by us via the video and conference tools will be deleted from our systems immediately after you request us to delete it, revoke your consent to storage, or the reason for storing the data no longer applies. Stored cookies remain on your end device until you delete them. Mandatory legal retention periods remain unaffected.<br /><br />\\n\\nWe have no influence on the duration of storage of your data that is stored by the operators of the conference tools for their own purposes. For details, please directly contact the operators of the conference tools.<br /><br />\\n\\n<h3>Conference tools used</h3><br />\\nWe employ the following conference tools:<br /><br />\\n\\n<h3>Google Meet</h3><br />\\nWe use Google Meet. The provider is Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland. For details on data processing, please see the Google privacy policy: <a target=\'_blank\'href=\\"https://policies.google.com/privacy?hl=en\\">Privacy Policy \u2013 Privacy & Terms \u2013 Google</a>.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br />\\n\\n<h3>Data processing</h3><br />\\nWe have concluded a data processing agreement (DPA) for the use of the above-mentioned service. This is a contract mandated by data privacy laws that guarantees that they process personal data of our website visitors only based on our instructions and in compliance with the GDPR.<br /><br />"},"customServices":{"title":"11. Custom Services","content":"<h3>Google Drive</h3><br />\\nWe have integrated Google Drive on this website. The provider is Google Ireland Limited (\u201CGoogle\u201D), Gordon House, Barrow Street, Dublin 4, Ireland.<br /><br />\\n\\nGoogle Drive allows us to include an upload area on our website where you can upload content. When you upload content, it is stored on Google Drive\u2019s servers. When you visit our website, a connection to Google Drive is additionally established so that Google Drive can determine that you have visited our website.<br /><br />\\n\\nThe use of Google Drive is based on Art. 6(1)(f) GDPR. The website operator has a legitimate interest in having a reliable upload area on its website. If a corresponding consent has been obtained, the processing is carried out exclusively on the basis of Art. 6(1)(a) GDPR; the consent can be revoked at any time.<br /><br />\\n\\nThe company is certified in accordance with the \u201CEU-US Data Privacy Framework\u201D (DPF). The DPF is an agreement between the European Union and the US, which is intended to ensure compliance with European data protection standards for data processing in the US. Every company certified under the DPF is obliged to comply with these data protection standards. For more information, please contact the provider under the following link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br />\\n\\n<h3>Data processing</h3><br />\\nWe have concluded a data processing agreement (DPA) for the use of the above-mentioned service. This is a contract mandated by data privacy laws that guarantees that they process personal data of our website visitors only based on our instructions and in compliance with the GDPR.<br /><br />"}},"terms&condition":{"title":"General Terms and Conditions","generalCondition":{"title":"","content":"General Terms and Conditions\\nfor the online store at the URL\\n<a href=\\"https://www.cyberalarm.training\\">https://www.cyberalarm.training</a>\\noperated by\\nGamebook Studio HQ GmbH Wilhelm-Kabus-Strasse 77 10829 BerlinGermany\\n\\nin the following: Provider -\\n\\n"},"scope":{"title":"1. Scope of application","content":"These General Terms and Conditions (GTC) apply to all contracts for the purchase of goods, services or other goods (hereinafter referred to as \'goods\') in the online store at the above URL in the version valid at the time the contract is concluded. These GTC apply exclusively. Deviating GTC of the customer shall not become part of the contract unless the Provider expressly agrees to them.<br /><br />"},"conclusion":{"title":"2. Conclusion of contract","content":"<b>2.1</b> The offers in the online store are a non-binding invitation from the Provider to online store visitors to submit an offer to purchase the goods offered in the store.\\n<br /><br /><b>2.2</b> The order of the goods is placed via the Provider\'s online order form. After selecting the desired goods, entering all required mandatory information, and completing all other mandatory steps in the ordering process, the selected goods can be ordered by clicking the order button at the end of the checkout page (order). By placing the order, the customer submits a binding contractual offer to purchase the selected goods. The contract is concluded when the Provider accepts the customer\'s offer. Acceptance occurs when the Provider confirms the conclusion of the contract in writing or in text form (e.g., by e-mail) and this order confirmation reaches the customer, or when the Provider delivers the ordered goods and these goods reach the customer, or when the Provider requests payment (e.g., invoice or credit card payment in the order process) and the payment request reaches the customer; the relevant time for the conclusion of the contract is when one of the aforementioned alternatives occurs for the first time.\\n<br /><b>2.3</b> Before submitting the binding order via the Provider\'s online order form, the customer can review their entries and correct them at any time using the usual keyboard, mouse, touch, or other available input functions. In addition, all entries are displayed again in a confirmation window before the binding order is placed and can also be corrected there using the usual input functions.\\n<br /><b>2.4</b> The Provider will store the contract text after the conclusion of the contract and send it to the customer in text form (e.g., by e-mail). The Provider does not provide any further access to the contract text. If the purchase was made through a customer account in the online store, the customer can view their orders and associated order data there.\\n<br /><b>2.5</b> The following languages are available for contract conclusion: German, English."},"withdrawal":{"title":"3. Right of withdrawal for consumers","content":"Consumers have a fundamental right of withdrawal for contracts concluded outside business premises and for distance selling contracts. A consumer is any natural person who enters into a legal transaction for purposes that are predominantly not attributable to their commercial or independent professional activity. Details can be found in the cancellation policy, which is provided to every consumer no later than immediately before the contract is concluded.\\n\\n"},"defaultPayment":{"title":"4. Payment, default","content":"<b>4.1</b> The prices listed in the online store at the time of the order apply. All prices include the statutory VAT and any applicable shipping costs. The customer will be informed about the available payment methods in the Provider\'s online store.\\n<br /><b>4.2</b> If \'advance payment\' is agreed upon, the purchase price is due immediately upon conclusion of the contract.\\n<br /><b>4.3</b> If \'purchase on account/invoice purchase\' is agreed upon, payment is due immediately upon conclusion of the contract, unless another payment term is specified in the invoice or during the purchase process.\\n<br /><b>4.4</b> If payment via \'PayPal\' is agreed upon, the purchase price is due immediately upon conclusion of the contract. Payment processing is carried out via the payment service provider PayPal (Europe) S.\xe0 r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg."},"retention":{"title":"5. Retention of title","content":"The purchased goods remain the property of the Provider until full payment of the purchase price has been made."},"delivery":{"title":"6. Delivery and self-supply reservation","content":"<b>6.1</b> Unless otherwise agreed, delivery is made within the delivery time specified in the online store to the delivery address provided by the customer. The applicable delivery times can be found in the online store.\\n<br /><b>6.2</b> Self-collection of the purchased goods is excluded.\\n<br /><b>6.3</b> If the Provider is unable to deliver the ordered goods because they were not supplied to them on time through no fault of their own, despite having concluded a congruent covering transaction with a reliable supplier, the Provider is released from their performance obligation and may withdraw from the contract. The Provider is obligated to inform the customer immediately about the impossibility of performance. Any consideration already provided by the contracting party will be refunded immediately. Mandatory consumer rights remain unaffected."},"warranty":{"title":"7. Warranty","content":"The statutory liability for defects applies."},"liability":{"title":"8. Liability","content":"<b>8.1</b> The Provider shall be liable without limitation:<br /><style>ul {list-style-type: disc; padding-left: 20px;}</style><ul>\\n<li>for damages resulting from injury to life, body or health, which are based on an intentional or negligent breach of duty by the provider or an intentional or negligent breach of duty by a legal representative or vicarious agent of the provider;</li>\\n<li>for damages caused by an intentional or grossly negligent breach of duty by the provider or by an intentional or grossly negligent breach of duty by a legal representative or vicarious agent of the provider;</li>\\n<li>on the basis of a guarantee promise, insofar as no other provision has been made in this respect;</li>\\n<li>due to mandatory liability (e.g. under the Product Liability Act)</li>\\n</ul><br />\\n<b>8.2</b> If the Provider negligently breaches a material contractual obligation, its liability shall be limited to the foreseeable damage typical of the contract, unless unlimited liability applies in accordance with the preceding paragraph. Essential contractual obligations are obligations which the contract imposes on the provider according to its content in order to achieve the purpose of the contract, the fulfillment of which makes the proper execution of the contract possible in the first place and on the observance of which the customer may regularly rely.<br /><br />\\n<b>8.3</b> In all other respects, the liability of the Provider and the liability of its vicarious agents and legal representatives is excluded.\\n"},"dataProtection":{"title":"9. Data protection","content":"The Provider treats its customers\' personal data confidentially and in accordance with statutory data protection regulations. Further details can be found in the Provider\'s privacy policy."},"final":{"title":"10. Final Provisions","content":"<b>10.1</b> The law of the Federal Republic of Germany shall apply to the exclusion of the UN Convention on Contracts for the International Sale of Goods, insofar as this choice of law does not result in a consumer with habitual residence in the EU being deprived of the mandatory statutory provisions of the law of his country of residence.\\n<br /><b>10.2</b> If the customer is a merchant, a legal entity under public law or a special fund under public law, the court at the registered office of the provider shall have jurisdiction, unless an exclusive place of jurisdiction has been established for the dispute. This also applies if the customer is not domiciled within the European Union. The registered office of our company can be found in the heading of these GTC.\\n<br /><b>10.3</b> If a provision of this contract is or becomes invalid or unenforceable, the remaining provisions of this contract shall remain unaffected."},"disputeResolution":{"title":"11. Information on Online Dispute Resolution / Consumer Arbitration","content":"The EU Commission provides a platform for online dispute resolution on the Internet at the following link: <a href=\\"https://ec.europa.eu/consumers/odr\\">Online Dispute Resolution  European Commission</a>.\\n<br />The provider is not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.\\nOur e-mail address can be found under the heading of these GTC."}},"passwordValidator":{"minLength":"The password must be at least 8 characters long.","maxLength":"The password can not be longer than 128 characters.","lowercase":"The password must contain at least one lowercase letter.","uppercase":"The password must contain at least one uppercase letter.","containNumber":"The password must contain at least one number.","specialCharacter":"The password must contain at least one special character.","passwordRequired":"Password is a required field","emailRequired":"Email is a required field","passwordMatch":"Password must match","emailMatch":"Email must match","emailValid":"Email address must be a valid email"},"cookieConsent":{"consentModal":{"label":"Cookie Consent","title":"Cookie Consent","description":"By clicking \\"<b>Accept all</b>,\\" you agree to the use of all cookies.</br>By clicking \\"<b>Reject all</b>,\\" only essential cookies will be used.","acceptAllBtn":"Accept all","acceptNecessaryBtn":"Reject all","showPreferencesBtn":"Manage preferences","closeIconLabel":"Close","footer":"For more information, please see our </br><a target=\'_blank\'href=\\"https://www.cyberalarm.training/en/privacy-policy\\">Privacy Policy</a>"},"preferencesModal":{"title":"Cookie preferences","acceptAllBtn":"Accept all","acceptNecessaryBtn":"Accept only necessary cookies","savePreferencesBtn":"Save preferences","closeIconLabel":"Close","sections":[{"title":"Cookie usage","description":"We use cookies to enhance your experience on our website. Some cookies are essential for the website to function (e.g., session cookies and PayPal cookies). Others, like Google Analytics cookies, help us analyze and improve the website."},{"title":"Strictly necessary cookies","description":"These cookies are essential for the proper functioning of my website...","linkedCategory":"necessary"},{"title":"Performance and Analytics","description":"These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.","linkedCategory":"analytics"},{"title":"Marketing and Ads","description":"These cookies allow us and our partners (Google Ads, LinkedIn, Meta) to deliver tailored advertising and measure campaign effectiveness.","linkedCategory":"marketing"},{"title":"More information","description":"For any queries in relation to our policy on cookies and your choices..."}]}},"contact":{"contactForm":{"header":"Contact Us","labels":{"email":"Email","confirmEmail":"Confirm your email","name":"Name","helpType":"What can we help you with?","subject":"Subject","message":"Message"},"options":{"sales":"Sales, purchases...","help":"General help","info":"Information","account":"My account","feedback":"Feedback","other":"Other"},"successMessage":"Mail sent successfully, a support member will contact you shortly.","submit":"Send"}}}');

});

parcelRegister("j328z", function(module, exports) {
module.exports = JSON.parse('{"locale":{"en":"EN","de":"DE"},"global":{"endpointError":"Es gab ein Problem mit Ihrer Anfrage. Bitte versuchen Sie es erneut oder kontaktieren Sie einen Administrator."},"confirm":{"yes":"Ja","no":"Nein","default":"Sind Sie sicher?"},"general":{"seat":"Lizenz | Lizenzen"},"nav":{"closeMenu":"Men\xfc schlie\xdfen","openMenu":"Hauptmen\xfc \xf6ffnen","whyCyberalarm":"\xdcber CyberALARM","howItWorks":"Funktionen","alarm":"Alarm","courses":"Kurse","aboutUs":"\xdcber uns","pricing":"Preise","imprint":"Impressum","privacy":"Datenschutzerkl\xe4rung","terms":"AGB","contact":"Kontaktieren Sie uns"},"landingPage":{"heroSection":{"slogan":"Sch\xfctzen Sie sich vor {0}","sloganHighlighted":"Cyberangriffen!","subtext":"Schulen Sie sich oder Ihr Team mit unserer wissenschaftlich erprobten Cybersicherheitsschulung: Bek\xe4mpfen Sie die 7 gef\xe4hrlichsten Cybersicherheitsbedrohungen.","statsTitle":"Wissenschaftlich belegtes Cybersicherheitstraining!","stats":["Konform mit der NIS2 Richtlinie","E-Learing Cybersicherheit","Cybersicherheitsbewusstsein schulen"]},"whySection":{"title":"Warum CyberALARM!","block1":{"title":"Unsere interaktive Cybersicherheitsschulung gibt Ihnen die n\xf6tige gesetzliche Sicherheit","text":"CyberALARM ist eine digitale Cybersicherheitssimulation f\xfcr Einzelpersonen, Unternehmen, Verb\xe4nde und Beh\xf6rden. Die kosteng\xfcnstigen Cybersicherheitskurse basieren auf wissenschaftlich belegten Ergebnissen. Unsere Awareness-Schulung hilft ein tiefes Verst\xe4ndnis f\xfcr die h\xe4ufigsten und gef\xe4hrlichsten Cybersicherheitsbedrohungen zu entwickeln. Es wird gezeigt wie diese verhindert werden k\xf6nnen, um Ihr Umfeld und Unternehmen nach den gesetzlichen Vorschriften sicherer zu machen. Buchen Sie jetzt unsere CyberALARM Schulung."},"block2":{"title":"Fakten zur EU NIS2 Cybersicherheitsrichtlinie 2024","bullet1":"Der Gesetzgeber schreibt Cybersicherheits-Schulungen f\xfcr das Management und Mitarbeitern vor. Regem\xe4\xdfige Schulungen sind zwingend notwendig","bullet2":"Der Gesetzgeber nimmt das Management hinsichtlich der Cybersicherheit in die private Haftung. Bei Nicheinhaltung drohen Strafen von bis zu 10.000.000 \u20AC.","bullet3":"80% aller erfolgreichen Cyberangriffe basieren auf Fehlverhalten der Mitarbeiter. Die NIS 2 Regulierung soll f\xfcr mehr Sicherheit in ganz Europa f\xfchren!"},"incentivesTitle":"Kosteng\xfcnstige Qualit\xe4tsschulung, die sich an Ihren Bed\xfcrfnissen und den gestzlichen Anforderungen orientiert","incentives":[{"title":"Realistische Simulationen","text":"Unsere Schulungs-Plattform bietet realistische Simulationen von Cyber-Angriffen und bringt Ihrem Team die Erfahrung, die es braucht, um Cyber-Bedrohungen effektiv zu erkennen und zu verhindern. Minimieren Sie Einfallstore"},{"title":"Personalisiertes Training","text":"\xdcbernehmen Sie unterschiedliche Rollen vom Mitarbeiter, \xfcber den Hacker, bis zum Sicherheitsexperten. Jede Entscheidung, die Sie treffen, hat KI gesteuerte Auswirkungen auf den Lerninhalt und die sich am Ende in Ihrem Feedback zur Schulung zeigen."},{"title":"Wissenschaftlich bewiesen","text":"Wir haben unsere digitalen Cybersecurity L\xf6sungen in einem dreij\xe4hrigen Forschungsprojekt in Zusammenarbeit mit den renommierten Cyber-Sicherheitsexperten der TH Wildau entwickelt und getestet."},{"title":"Mehrsprachige Schulung","text":"Englisch, Spanisch, T\xfcrkisch, Franz\xf6sisch, Italienisch ... In der Enterprise Version der Schulung, k\xf6nnen Sie jegliche Sprachversion f\xfcr Ihr Team kosteng\xfcnstig erstellen."},{"title":"Ma\xdfgeschneiderte L\xf6sung","text":"F\xfcr gr\xf6\xdfere Unternehmen oder Organisationen passen wir unsere Cyber-Trainingsmodule an Ihre Bed\xfcrfnisse an: mit Ihrem Branding, individuellen Inhalten und individuellen Trainingserweiterungen."},{"title":"\xdcberall Einsatzbereit","text":"Ihre Anforderung an bestimmte Zugangsbestimmungen oder Systeme k\xf6nnen wir entsprechen. Wir bieten Ihnen ein technisches Setup Ihrer Wahl: Mobile App, Web App, Firmen-Intranet."}]},"howSection":{"title":"Wie funktioniert CyberALARM?","text":"CyberALARM bietet umfassende Cybersecurity-Schulungen mit zwei speziellen Zug\xe4ngen. Unternehmen (KMU), Organisationen und Verb\xe4nde k\xf6nnen Schulungen und Mitarbeiter verwalten, den Fortschritt der Schulungen verfolgen sowie Teilnahmebescheinigungen erhalten. Einzelnutzer und Mitarbeiter haben Zugang zu Cybersecurity-Schulungen, die sie auf potenzielle Bedrohungen aus dem Internet und ihrer Umgebung vorbereiten. CyberALARM st\xe4rkt die Cybersecurity durch praxisnahe und aktuelle Schulungsinhalte, die auf die spezifischen Bed\xfcrfnisse verschiedener Benutzergruppen zugeschnitten sind.","block1":{"title":"E-Learning Schulungsplattform","subtitle":"Mitarbeiter oder Einzelpersonen","bullet1":"Zugang zu CyberAwareness Schulungen","bullet2":"Einfaches und schnelles Lernen","bullet3":"Jederzeit von \xdcberall aus","bullet4":"Teilnahmebest\xe4tigung der Cybersicherheitsschulung"},"block2":{"title":"Plattform f\xfcr Mitarbeitermanagement","subtitle":"Firmen, Organisationen, Beh\xf6rden, Verb\xe4nde","bullet1":"Importfunktion Ihrer Mitarbeiterdaten","bullet2":"Mitarbeiter Kursmanagement, Einladungen, Fortschritt","bullet3":"Neue Inhalte f\xfcr Ihre Mitarbeiter hinzuf\xfcgen","bullet4":"Teilnahmebest\xe4tigung \xfcber die Kurse f\xfcr Ihre Mitarbeiter"}},"alarmSection":{"title":"Forschungsprojekt ALARM","text":"Von 2020\u20132023 waren wir Partner der TH Wildau im Projekt ALARM. Daraus entstand CyberALARM \u2013 unsere wissenschaftlich fundierte Plattform f\xfcr Awareness-Training und praxisnahe Cybersecurity in kleinen und mittleren Unternehmen (KMU).","alarmProject":{"title":"ALARM Projekt","text":"Das ALARM-Projekt hatte zum Ziel, die gr\xf6\xdften Bedrohungen f\xfcr die Cybersicherheit von KMU zu identifizieren und effektive Schulungsl\xf6sungen zu entwickeln, um Mitarbeitende vor Cyberangriffen zu sch\xfctzen und ihre Sicherheitskompetenz zu st\xe4rken."},"digital":{"title":"Digitale Serious Games","text":"Als exklusiver Partner der TH Wildau entwickelten wir eine Cybersecurity-Trainingsl\xf6sung basierend auf interaktiven Simulationen. In 3 Jahren verifizierten wir die L\xf6sung in mehreren Testphasen und passten sie erfolgreich an die Bed\xfcrfnisse von KMU an."},"partners":{"title":"Projektpartner","text":"Das Forschungsprojekt vereinte f\xfchrende akademische und industrielle Partner und wurde vom Bundesministerium f\xfcr Wirtschaft und Energie sowie den IHKs unterst\xfctzt, um praxisnahe L\xf6sungen f\xfcr die Cybersicherheit von Unternehmen zu entwickeln."},"publication":{"title":"Veranstaltungen & Ver\xf6ffentlichungen","text":"Wir pr\xe4sentierten unsere Forschungs- und Projektergebnisse auf verschiedenen Veranstaltungen und in renommierten Forschungspublikationen, darunter der 35. AKWI-Jahrestagungsband sowie ein Abschlussbericht zur Dokumentation der Forschungsergebnisse."},"seeMore":"Mehr"},"coursesSection":{"title":"Unsere Cyberbedrohungs-Kurse","subtitle":"7 wissenschaftlich nachgewiesene Cyber-Sicherheitsbedrohungen","text":"Unsere Kurse werden Ihr Team in die Lage versetzen, die h\xe4ufigsten und gef\xe4hrlichsten Bedrohungen der Cybersicherheit zu erkennen und sicher zu handhaben. In unseren Kursen werden die Themen Ransomware, Phishing, Social Engineering, CEO-Betrug, Daten & Cloud-Sicherheit, Homeoffice & Smarthome, Passw\xf6rter, Informationsklassifizierung und Messenger und Verschl\xfcsselung behandelt.","moreComing":"Weitere Kurse sind in Vorbereitung!","courses":[{"title":"Einf\xfchrung ins Thema - Social Engineering","desc":"In diesem Lernszenario werden Sie als Fachkraft versuchen, der Belegschaft das Thema Informationssicherheit n\xe4herzubringen. Begriffe, wie Malware und Social Engineering werden erkl\xe4rt."},{"title":"Wie arbeiten Hacker?","desc":"In diesem Lernszenario werden Sie als Hackerin oder Hacker versuchen, sich illegal Zugang zu den Daten der Firma zu verschaffen. Begriffe, wie Spoofing, Password Stealer, Spyware, VoIP-Telefon und Passwort Tracker werden erkl\xe4rt."},{"title":"Wie man sich angreifbar macht - Fehlerquelle Mensch","desc":"In diesem Lernszenario werden Sie als Sp\xfcrnase versuchen, einem Hacker oder einer Hackerin auf die Schliche zu kommen. Begriffe, wie SPhishing, Spear Phishing, CEO Fraud, Scam, Zwei-Faktor-Authentisierung und Deep-Fake-Attacke werden erkl\xe4rt."},{"title":"Was Zuhause zu beachten ist - Home Office","desc":"In diesem Lernszenario werden Sie als K\xfcnstliche Intelligenz (KI) versuchen, die beliebtesten Fehler im Homeoffice zu finden. Begriffe, wie Smartphone, VPN, Blockchain und Machine learning (KI) werden erkl\xe4rt."},{"title":"Angriffe nachverfolgen - Denken wie ein Hacker","desc":"In diesem Lernszenario werden Sie zuerst hackend und anschlie\xdfend ermittelnd t\xe4tig werden. Begriffe, wie Cloud, Darknet, Passwort-Cracker, Backup, Zwei-Faktor-Authentisierung und Passwortmanager werden erkl\xe4rt."},{"title":"Wof\xfcr braucht man Informationsklassen?","desc":"In diesem Lernszenario werden Sie sich als K\xfcnstliche Intelligenz (KI) mit dem Thema Informationsklassifizierung besch\xe4ftigen. Begriffe, wie Informationsklassifizierung und sensible Daten werden erkl\xe4rt."},{"title":"Verschl\xfcsselung verstehen - einfach und schnell","desc":"In diesem Lernszenario werden Sie als Sp\xfcrnase versuchen, einem gewissen Scarlett auf die Schliche zu kommen. Begriffe, wie Verschl\xfcsselung, Ende-zu-Ende-Verschl\xfcsselung, DSGVO, Ransomware, C\xe4sar-Chiffre und symmetrische Verschl\xfcsselung werden erkl\xe4rt."},{"title":"Die Gesch\xe4ftsreise (demn\xe4chst verf\xfcgbar)","desc":"Das neuste Lernszenario wird sich rund um die Gesch\xe4ftsreise besch\xe4ftigen."}]},"aboutUsSection":{"title":"\xdcber Gamebook und CyberALARM","block1":{"title":"Sichern Sie Ihr Unternehmen vor Cyberangriffen. Erf\xfcllen Sie die EU NIS2 Regulierungen","text":"Mit CyberALARM m\xf6chten wir Unternehmen jeder Gr\xf6\xdfe helfen, den gesetzlichen Anforderungen gerecht zu werden. Das Management und die Mitarbeiter zum Thema Cybersicherheit zu sensibilisieren und auf m\xf6gliche Gefahren hinzuweisen. Unsere Cybersicherheitsschulung ist ortsunabh\xe4ngig, kosteng\xfcnstig im Vergleich zu aufwendigen Schulungen vor Ort, spart Zeit und bringt die gesetzliche Sicherheit. F\xfcr Einzelpersonen, Bildungseinrichtungen, Start-Ups und Unternehmen jeder Gr\xf6\xdfe."},"block2":{"title":"Was ist Gamebook?","text":"Gamebook Studio bietet eine innovative CMS-Plattform zur Erstellung, Ver\xf6ffentlichung und Verwaltung von interaktiven Simulationen und Lernspielen. Die Plattform bietet zahlreiche Vorteile und USPs, darunter nahtlose Integration, benutzerfreundliche Oberfl\xe4che und flexible Anpassungsm\xf6glichkeiten. Mit CyberALARM.Training bietet Gamebook Studio eine umfassende L\xf6sung zur Schulung und Pr\xe4vention von Cyberbedrohungen. Zu den zufriedenen Kunden von Gamebook z\xe4hlen die Deutsche Bank, Hasbro, Hamburger B\xfcrgerschaft und die Polizei Brandenburg."}},"prices":{"title":"Preise","subtitle":"W\xe4hlen Sie Ihr bevorzugtes Abonnement.","freeTrial":"Oder starten Sie eine KOSTENLOSE Testversion","limitedTime":"* bestimmte Laufzeit","contactForPricing":"Kontaktieren Sie uns f\xfcr Preise","unsubscribe":{"title":"F\xfcr Bildungseinrichtungen wie Universit\xe4ten und Schulen komplett kostenlos!","text":"Schreiben Sie uns an f\xfcr Anfragen bez\xfcglich weiterer M\xf6glichkeiten unsere Schulungsplattform zu nutzen."}},"seeMore":"Weitere Informationen","seeMoreLink":"https://alarm.wildau.biz","contactUs":"Kontakt","startNow":"Registrieren"},"footer":{"title":"CyberALARM Training","slogan":"Sch\xfctzen Sie sich vor Cyberangriffen!","product":"Produkt","company":"CaberALARM","legal":"Rechtliches"},"company":{"email":"info{\'@\'}gamebook.services","linkedin":"LinkedIn","address1":"Gamebook Studio HQ GmbH","address2":"Wilhelm-Kabus-Strasse 77","address3":"10829 Berlin","address4":"Germany","copyright":"2025 by Gamebook Services"},"logIn":"Einloggen","logOut":"Ausloggen","dashboardBtn":"Dashboard","getStartedCTA":"Starten","appTitle":"CyberALARM","loginView":{"header":"Bei Ihrem Konto anmelden","email":"Email Adresse","password":"Passwort","forgotPassword":"Passwort vergessen?","noAccount":"Noch kein Account?","signUp":"Hier registrieren","emailPlaceholder":"","genericError":"Es gab ein Problem beim Einloggen.<br />Bitte versuchen Sie es erneut oder kontaktieren Sie ihren Administrator.","wrongCredentials":"Die E-Mail oder das Passwort ist falsch."},"logoutView":{"header":"Hier abmelden..."},"resetPasswordView":{"header":"Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zur\xfcckzusetzen","email":"E-Mail Adresse","reset":"Passwort zur\xfccksetzen","emailPlaceholder":"","requestSuccess":"Das Passwort wurde erfolgreich zur\xfcckgesetzt.","instructions":"Wir senden Ihnen eine E-Mail mit einem Link zum Zur\xfccksetzen Ihres Passworts.<br />Bitte <span class=\'text-secondary\'>checken Sie ihr Postfach</span> und <span class=\'text-secondary\'>folgen Sie den Anweisungen.</span>"},"renewPasswordView":{"header":"Erneuern Sie Ihr Passwort","password":"Passwort","passwordRepeated":"Passwort wiederholen","reset":"Passwort erneuern","resetSuccess":"Ihr Passwort wurde erfolgreich erneuert.","login":"Zum Login gehen","noMatch":"Passwort stimmt nicht \xfcberein","waitingForInitialization":"Laden.."},"dashboard":{"navigation":{"companyHeading":"Ihr Unternehmen","managingHeading":"Kurse verwalten","trainingHeading":"CyberALARM Training","accountHeading":"Mein Konto","companyInvoices":"Rechnungsstellung","invoices":"Rechnungen","analytics":"Statistik","seats":"Lizenzen","buyPlan":"Lizenzen verwalten","subscription":"Abonnement","companyDetails":"Angaben zum Unternehmen","payments":"Zahlungen","accountDetails":"Kontodetails"},"deleteSeats":{"title":"Freie Lizenzen l\xf6schen","btnTitle":"Lizenzen l\xf6schen","subtitle":"Sie k\xf6nnen nur nicht zugewiesene Pl\xe4tze l\xf6schen, die noch nie von jemandem genutzt wurden. Ab der n\xe4chsten Verl\xe4ngerung zahlen Sie nicht mehr f\xfcr diese Pl\xe4tze.","numSeatsLabel":"Anzahl der verf\xfcgbaren Lizenzen f\xfcr diesen Kurs","labelNumberOfSeatsToDelete":"Anzahl der Lizenzen, die Sie l\xf6schen m\xf6chten","labelTotalPriceSubtracted":"Gesamtpreis, der vom aktuellen Preis abzuziehen ist","subTotalPriceSubtracted":"{0} (l\xf6schen) x {1} (Preis pro Mitarbeiter)","labelYearlyTotal":"Neuer j\xe4hrlicher Gesamtpreis","subYearlyTotal":"{0} (aktuell) - {1} (abziehen.)","btnDelete":"Anzahl Mitarbeiter l\xf6schen"},"buySeats":{"btnTitle":"Lizenz kaufen","title":"Weitere Lizenzen kaufen","subtitle":"Neue Pl\xe4tze werden dem tats\xe4chlichen Abonnement hinzugef\xfcgt. Das Verl\xe4ngerungsdatum bleibt f\xfcr alle Pl\xe4tze gleich. Das bedeutet, dass Ihnen f\xfcr das n\xe4chste Verl\xe4ngerungsdatum die verbleibenden Monate anteilig in Rechnung gestellt werden.","numSeatsLabel":"Anzahl der Lizenzen, die Sie hinzuf\xfcgen m\xf6chten","labelYearlyAdditionalPrice":"J\xe4hrlicher Mehrpreis","subYearlyAdditionalPrice":"{0} (neue Lizenzen) x {1} (Preis pro Mitarbeiter)","labelTotalSeatNumber":"Neue Gesamtzahl der Lizenzen","subTotalSeatNumber":"{0} (aktuell) + {1} (zus\xe4tzlich)","labelYearlyTotal":"Neuer j\xe4hrlicher Gesamtpreis","subYearlyTotal":"{0} (aktuell) + {1} (zus\xe4tzlich)"},"seats":{"totalNumberSeats":"Gesamtanzahl Lizenzen","activeSeats":"Aktive Lizenzen","inactiveSeats":"nicht genutzte Lizenzen","availableSeats":"verf\xfcgbare Lizenzen","listOfSeats":"\xdcbersicht Lizenzen","inactivateSeats":{"btnInactivate":"freie Lizenzen","confirmTitle":"Zugewiesene Lizenzen deaktivieren","confirmText1":"Sie k\xf6nnen nicht genutzte Lizenzen k\xfcndigen. ","confirmText2":"Wenn zum Beispiel ein Mitarbeiter einen Kurs bereits abgeschlossen hat, k\xf6nnen Sie seinen mit diesem Kurs verbundenen Platz deaktivieren.","confirmTextBold":"Sind Sie sicher, dass Sie ausgew\xe4hlte Lizenzen k\xfcndigen m\xf6chten?"},"activateSeats":{"btnActivate":"Lizenzen zuweisen","confirmTitle":"Zugewiesene Lizenzen aktivieren","confirmText1":"Sie k\xf6nnen nicht genutzte Lizenzen aktivieren","confirmText2":"","confirmTextBold":"Sind Sie sicher, dass Sie die ausgew\xe4hlten Lizenzen aktivieren m\xf6chten?"},"headerStatus":"Status","headerCourse":"Kurs","headerEmployee":"Zugewiesener Mitarbeiter","headerRole":"Titel","headerEmail":"Email"},"subscription":{"title":"Details zum Abonnement","tier":"Abonnement-Stufe","renewDate":"Datum der Verl\xe4ngerung","numberOfSeats":"Anzahl Lizenzen","pricePerSeat":"Preis pro Mitarbeiterlizenz","billingCycle":"Abrechnungszyklus","renewal":{"title":"Abonnement Verl\xe4ngerung","autoRenew":"Automatische Erneuerung","autoRenewOn":"aktiv","autoRenewOff":"deaktiviert","date":"Datum","btnCancel":"Abonnement k\xfcndigen","confirmTitle":"Abonnement k\xfcndigen","confirmText1":"Wenn Sie die automatische Erneuerung eingeschaltet lassen, bleibt Ihr Abonnement aktiv und der Zugang zu den Kursen wird nicht unterbrochen.","confirmText2":"Wenn Sie die automatische Verl\xe4ngerung k\xfcndigen, endet Ihr Abonnement am tats\xe4chlichen Verl\xe4ngerungsdatum **Datum**, und alle Ihre Mitarbeiter verlieren ab diesem Datum auch ihren Zugang.","confirmTextBold":"Sind Sie sicher, dass Sie das Abonnement k\xfcndigen m\xf6chten?","btnRenew":"Abonnement verl\xe4ngern","confirmRenewTitle":"Erneuerung aktivieren","confirmRenewText1":"Wenn Sie die automatische Verl\xe4ngerung aktivieren, bleibt Ihr Abonnement aktiv und wird am tats\xe4chlichen Enddatum, **Datum**, verl\xe4ngert. Alle Ihre Mitarbeiter haben weiterhin Zugang zu den Kursen.","confirmRenewTextBold":"Sind Sie sicher, dass Sie die automatische Verl\xe4ngerung aktivieren wollen?"},"paymentMethod":{"title":"Zahlungsmethode","modifyBtn":"\xc4ndern","paymentMethod":"Zahlungsmethode","numberId":"Zahlungs ID","ownerName":"Kontoinhaber Name","ownerMail":"Kontoinhaber Email Adresse"}},"account":{"details":{"title":"Meine Kontodaten","modifyBtn":"\xc4ndern","updateEmailTitle":"E-Mail Actualisieren","updateEmailDesc":"Sie k\xf6nnen Ihre E-Mail-Adresse \xe4ndern","currentEmailLabel":"Aktuelles E-Mail","currentEmailMismatch":"Die aktuelle E-Mail-Adresse ist nicht korrekt","updateEmailSuccess":"Ihre E-Mail-Adresse wurde erfolgreich aktualisiert","updatePasswordSuccess":"Ihr Passwort wurde erfolgreich aktualisiert","passwordLabel":"Passwort","newEmailLabel":"Neues E-Mail","confirmNewEmailLabel":"Neue E-Mail best\xe4tigen","updateEmailBtn":"\xe4ndern ","updatePasswordTitle":"Passwort Aktualisieren","updatePasswordBtn":"\xe4ndern","currentPasswordLabel":"Aktuelles Passwort","newPasswordLabel":"Neues Passwort","updatePasswordDesc":"Stellen Sie sicher, dass Ihr Paswort aus mindestens 12 Zeichen, mindestens aus einem Gro\xdf- und Kleinbuchstaben, einer Nummer und 2 Sonderzeichen besteht.","deleteAccountTitle":"Konto L\xf6schen","deleteAccountBtn":"Konto l\xf6schen","deleteAccountDesc":"Beim L\xf6schen Ihres Accounts werden alle Ihre Daten, einschlie\xdflich Firmen- und Mitarbeiterdaten, unwiderruflich gel\xf6scht. Dieser Vorgang kann nach der Best\xe4tigung nicht r\xfcckg\xe4ngig gemacht werden. Bitte stellen Sie sicher, dass Sie alle wichtigen Informationen gesichert haben, bevor Sie fortfahren.","deleteAccountConfirm":"Sind Sie sicher, dass Sie Ihr Konto l\xf6schen m\xf6chten?","updateAccountSuccess":"Ihr Konto wurde erfolgreich aktualisiert"}},"company":{"employees":{"link":"Mitarbeiter","add":{"title":"Mitarbeiter hinzuf\xfcgen","btnTitle":"Mitarbeiter hinzuf\xfcgen","btnAdd":"hinzuf\xfcgen","success":"Erfolgreich {Mitarbeiter} hinzugef\xfcgt.","description":"M\xf6chten mehrere Mitarbeiter gleichzeitig hinzuf\xfcgen? Gehen Sie zur\xfcck und klicken Sie dann auf \\"Mitarbeiter per CSV importieren\\"."},"unbound":{"btnUnbound":"nicht zugeordnete Mitarbeiter","confirmTitle":"nicht zugeordnete Mitarbeiter","confirmText1":"Sie k\xf6nnen die Zuordnung von Mitarbeitern aufheben, die das Unternehmen verlassen haben oder in den Ruhestand gegangen sind.","confirmText2":"Alle zugeordneten Lizenzen werden deaktiviert. Bei der n\xe4chsten Abonnement Verl\xe4ngern werden diese nicht berechnet.","confirmTextBold":"Sind Sie sicher, dass Sie die von Ihnen ausgew\xe4hlten Mitarbeiter deaktiviert lassen wollen?"},"import":{"title":"Mitarbeiter importieren","btn":"Mitarbeiter importieren","desc1":"Importieren Sie Ihre Mitarbeiterliste direkt aus einer CSV-Datei. Sie ben\xf6tigen diese Angaben f\xfcr jeden Mitarbeiter:","btnImport":"W\xe4hlen Sie eine Datei","modal":{"fileDrop":"Ziehen Sie Ihre Dateien in das Feld oder suchen Sie","fileDropInfo":"Erlaubte Dateien: CSV","clearFile":"Datei l\xf6schen","fileInfo_file":"Datei geparst","fileInfo_numRows":"Anzahl der Datenzeilen","fileInfo_colsFound":"Gefundene Zeilen","previewBtn":"Vorschau anzeigen","previewTitle":"Vorschau","mappingTitle":"Mapping","close":"Schlie\xdfen","submit":"\xfcbermitteln","cancel":"Abbrechen"}},"list":{"title":"Liste der Mitarbeiter"},"firstName":"Vorname","lastName":"Nachname","email":"E-Mail Adresse","roleInCompany":"Titel","progress":"Fortschritt","status":"Status","seats":"Lizenzen","boundStatus":"aktiv","unboundStatus":"inaktiv"},"settings":"Einstellungen","subscription":"Abonnement","overview":"\xdcbersicht","management":"Management","courses":{"progressTitle":"Der Gesamtfortschritt Ihres Teams in diesem Kurs","manageBtn":"Verwalten des Kurses","moreSeatsBtn":"Weitere Lizenzen","availableSeats":"verf\xfcgbare Lizenzen","assignEmployeesBtn":"Mitarbeiter lizenzen","moreDetailsBtn":"Weitere Details","moreDetailsDesc":"\xdcbersicht auf die Kursinhalte und den Fortschritt Ihres Teams","employeeListTitle":"Liste der zu {coursename} eingeladenen Mitarbeiter","lessonModal":{"progressTitle":"Der Fortschritt Ihres Teams in diesem Kurs","inviteBtn":"Mitarbeiter zum Kurs einladen"},"assignModal":{"title":"Mitarbeiter einem Kurs zuordnen","assignBtn":"Mitarbeiter zuweisen","cancelBtn":"Abbrechen","selectCourseLabel":"W\xe4hlen Sie einen Kurs","searchLabel":"Suche nach E-Mail, Vor- oder Nachname","seatInfoText":"Sie k\xf6nnen {0} {1} zum Kurs zuweisen","assignedCourse":"Mitarbeiter zum Kurs einladen"}},"details":{"title":"Angaben zum Unternehmen","modifyBtn":"\xc4ndern"}},"invoices":{"title":"Rechnungen","list":{"date":"Rechnungsdaten","payPalId":"PayPal-Zahlungs-ID","quantity":"Anzahl","courses":"Zugewiesene Kurse","total":"Insgesamt","bill":"Rechnung"},"colTitleDate":"Rechnungsdatum","colTitlePayPalId":"PayPal-Zahlungs-ID","colTitle":"PayPal-Zahlungs-ID"},"training":{"navBarWelcome":"Hallo {0},{1} Willkommen zur\xfcck!","courseProgressCta":"Beeilen Sie sich! 85% Ihrer Kollegen haben den Kurs bereits abgeschlossen","progressTitle":"Ihr Fortschritt in diesem Kurs","lessonContinue":"Weiter","lessonRestart":"Neustart","lessonStart":"Beginn der Lektion","defaultProgress":"Beginnen Sie eine Lektion!"}},"registerView":{"selectSubscription":"W\xe4hlen Sie Ihr Abonnement","choosePlan":"Jetzt beginnen","goBack":"< Zur\xfcck","loginHint":"Wenn Sie von Ihrem Unternehmen eingeladen worden sind, m\xfcssen Sie","processCircle":{"plan":"Lizenzen","accountDetails":"Kundendaten","billing":"Rechnungsdaten","confirmation":"Best\xe4tigung"},"accountForm":{"title":"Ihr Konto einrichten","companyDetailsTitle":"Angaben zum Unternehmen","individualDetailsTitle":"Ihre Angaben","ownerDetailsTitle":"Angaben zum Kontoinhaber","labels":{"companyName":"Firmenname","numberOfEmployees":"Anzahl der Mitarbeiter","industry":"Branche","website":"URL der Unternehmenswebseite","legalForm":"Rechtsform","taxNumber":"Steuer ID Nr.","commercialRegisterNumber":"Handelsregisternummer","streetAddress":"Stra\xdfe & Hausnummer","zipCode":"Postleitzahl","city":"Stadt","country":"Land","gender":"Anrede","genderOptionOther":"","genderOptionMale":"Herr","genderOptionFemale":"Frau","firstName":"Vorname","lastName":"Nachname","roleInCompany":"Position im Unternehmen","department":"Abteilung","phoneNumber":"Telefonnummer","email":"E-Mail Adresse f\xfcr Kommunikation","confirmEmail":"Best\xe4tigung der E-Mail Adresse","password":"Passwort","confirmPassword":"Best\xe4tigen Sie das Passwort","communicationPreference":"Pr\xe4ferenz f\xfcr Kommunikation","communicationPreferenceOptionEmail":"per Email","communicationPreferenceOptionPhone":"Telefonisch","communicationLanguage":"Bevorzugte Sprache","communicationLanguageOptionEN":"Englisch","communicationLanguageOptionDE":"Deutsch","terms":"Akzeptieren Sie unsere <a class=\'text-secondary\' target=\'_blank\'href=\\"https://www.cyberalarm.training/de/terms-and-conditions\\">AGB</a>","privacy":"Akzeptieren Sie unsere <a class=\'text-secondary\' target=\'_blank\'href=\\"https://www.cyberalarm.training/de/privacy-policy\\">Datenschutzerkl\xe4rung</a>","termsRequired":"Sie m\xfcssen unsere AGB akzeptieren","privacyRequired":"Sie m\xfcssen unsere Datenschutzerkl\xe4rung akzeptieren","situation":"Besch\xe4ftigungsverh\xe4ltnis","situationOptions":{"employed":"Angestellter","unemployed":"keine Besch\xe4ftigung","training":"in Ausbildung","selfEmployed":"Selbstst\xe4ndig","student":"Sch\xfcler/Student","civilServant":"Beamter","pensioner":"Rentner","other":"sonstiges"},"countries":{"germany":"Deutschland","other":"Other"},"job":"Wenn Sie einen Job haben, Berufsbezeichnung","message":"Nachricht"},"confirm":"Best\xe4tigen","errors":{"userExists":"Der Benutzer existiert bereits"}},"billing":{"title":"Zusammenfassung des Kaufs","yearlyPriceLabel":"J\xe4hrlicher Preis pro Lizenz","numLicensesLabel":"Anzahl der Lizenzen, die Sie hinzuf\xfcgen m\xf6chten","yearlyTotalPrice":"J\xe4hrlicher Gesamtpreis ({0} x {1})","discountPlaceholder":"Rabatt-Code","vatLabel":"VAT","discountApply":"hinzuf\xfcgen","discountClear":"entfernen","discount":"Rabatt","discountGenericError":"Beim Einl\xf6sen des Codes ist ein Fehler aufgetreten.","invalidKey":"Der Code ist nicht g\xfcltig.","terms":{"desc":"Sie werden an Paypal weitergeleitet. Sollten Sie kein Paypal Konto haben, k\xf6nnen Sie im n\xe4chsten Fenster auch ohne ein Paypal Konto, Ihre Zahlung vornehmen. Sie bleiben dann Anonym und Paypal speichert nur die Zahlungsdaten.","bullet1":"Es wird ein 12 Monatsabo abgeschlossen","bullet2":"Eine K\xfcndigung ist jederzeit m\xf6glich","bullet3":"Fragen beantworten wir gerne \xfcber unsere Hilfeseite"},"payWithPaypal":"Bezahlen mit Paypal","free":"Kostenlos"},"confirmation":{"successTitle":"Erfolgreiche Zahlung und Registrierung","successInfo":"Herzlich Willkommen bei CyberALARM.Training.<br /> Sie haben sich f\xfcr die Lizenz {planName} entschieden.<br /> Ihre Zahlung war erfolgreich und Sie wurden mit einem Benutzerkonto angelegt.<br /><br /> F\xfcr alle Fragen stehen wir gerne zur Verf\xfcgung. Sch\xf6n, dass Sie bei uns sind!","waitingTitle":"Bitte warten","waitingInfo":"Ihr Abonnement wird aktiviert. Bitte haben sie einen Moment Geduld.<br />Sollte dieser Prozess l\xe4nger als 5 Minuten dauern, kontaktieren sie uns bitte.","failureTitle":"Zahlung fehlgeschlagen","failureInfo":"Leider konnte der Zahlungsvorgang nicht abgeschlossen werden. Ihr Kundenkonto wurde aber angelegt. Bitte schauen Sie in unserem Hilfe Bereich nach. Sie k\xf6nnen den Zahlungsvorgang jederzeit unter dem Punkt Lizenzen wiederholen.","freeInfo":"Sie haben gerade {planName} gekauft. <br /><br /> Wir w\xfcnschen Ihnen viel Spa\xdf mit Ihrem Abonnement.\\"","homeButton":"Startseite","logInButton":"Einloggen"}},"imprintView":{"title":"Impressum","siteNotice":{"title":"Impressum","content":"Gamebook Studio HQ GmbH <br /> Wilhelm-Kabus-Strasse 77 <br /> 10829 Berlin <br /> <br />Handelsregister: HRB 232902 B <br /> Registergericht: Amtsgericht Berlin Charlottenburg <br /> <br /> <b>Vertreten durch:</b> <br /> Ulrike K\xfcchler <br /> Prof. Thomas Langhanki"},"contact":{"title":"Kontact","content":"E-mail: info@gamebook-studio.com <br />Telefon: +4917623963455"},"vat":{"title":"Umsatzsteuer-ID","content":"Umsatzsteuer-Identifikationsnummer gem\xe4\xdf \xa7 27 a Umsatzsteuergesetz: DE347404113"},"editorialResponsible":{"title":"Redaktionell verantwortlich","content":"Ulrike K\xfcchler<br />Gamebook Studio HQ GmbH <br /> Wilhelm-Kabus-Strasse 77 <br /> 10829 Berlin Germany"},"euDisputeResolution":{"title":"EU-Streitschlichtung","content":"Die Europ\xe4ische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a target=\'_blank\'style=\'color:blue\' href=\'https://ec.europa.eu/consumers/odr/\'>Online Dispute Resolution. European Commission</a>. Unsere E-Mail-Adresse finden Sie oben im Impressum."},"disputeProceedings":{"title":"Verbraucher\xadstreit\xadbeilegung/Universal\xadschlichtungs\xadstelle","content":"Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen."}},"privacyPolicyView":{"title":"Datenschutzerkl\xe4rung","dataProtection":{"title":"1. Datenschutz auf einen Blick","content":"<h3>Allgemeine Hinweise</h3><br />Die folgenden Hinweise geben einen einfachen \xdcberblick dar\xfcber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Ausf\xfchrliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgef\xfchrten Datenschutzerkl\xe4rung.<br /><br /><h3>Datenerfassung auf dieser Website</h3>\\n<h3>Wer ist verantwortlich f\xfcr die Datenerfassung auf dieser Website?</h3><br />Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten k\xf6nnen Sie dem Abschnitt \u201EHinweis zur Verantwortlichen Stelle\u201C in dieser Datenschutzerkl\xe4rung entnehmen.<br /><br />\\n\\n<h3>Wie erfassen wir Ihre Daten?</h3><br />Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.<br /><br />\\nAndere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.<br /><br />\\n\\n<h3>Wof\xfcr nutzen wir Ihre Daten?</h3><br />Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gew\xe4hrleisten. Andere Daten k\xf6nnen zur Analyse Ihres Nutzerverhaltens verwendet werden.<br /><br />\\n\\n<h3>Welche Rechte haben Sie bez\xfcglich Ihrer Daten?</h3><br />Sie haben jederzeit das Recht, unentgeltlich Auskunft \xfcber Herkunft, Empf\xe4nger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben au\xdferdem ein Recht, die Berichtigung oder L\xf6schung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, k\xf6nnen Sie diese Einwilligung jederzeit f\xfcr die Zukunft widerrufen. Au\xdferdem haben Sie das Recht, unter bestimmten Umst\xe4nden die Einschr\xe4nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zust\xe4ndigen Aufsichtsbeh\xf6rde zu.<br /><br />\\nHierzu sowie zu weiteren Fragen zum Thema Datenschutz k\xf6nnen Sie sich jederzeit an uns wenden.<br /><br />\\n\\n<h3>Analyse-Tools und Tools von Dritt\xadanbietern</h3><br />Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit sogenannten Analyseprogrammen.<br /><br />\\nDetaillierte Informationen zu diesen Analyseprogrammen finden Sie in der folgenden Datenschutzerkl\xe4rung.<br /><br />\\n"},"hostingCDN":{"title":"2. Hosting und Content Delivery Networks (CDN)","content":"Wir hosten die Inhalte unserer Website bei folgendem Anbieter:<br /><br />\\n\\n<h3>Amazon Web Services (AWS)</h3><br />\\nAnbieter ist die Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, 1855 Luxemburg (nachfolgend AWS).<br /><br />\\n\\nWenn Sie unsere Website besuchen, werden Ihre personenbezogenen Daten auf den Servern von AWS verarbeitet. Hierbei k\xf6nnen auch personenbezogene Daten an das Mutterunternehmen von AWS in die USA \xfcbermittelt werden. Die Daten\xfcbertragung in die USA wird auf die EU-Standardvertragsklauseln gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/\\">AWS GDPR Data Processing Addendum \u2013 Now Part of Service Terms Amazon Web Services</a>.<br /><br />\\n\\nWeitere Informationen entnehmen Sie der Datenschutzerkl\xe4rung von AWS: <a target=\'_blank\'href=\\"https://aws.amazon.com/de/privacy/?nc1=f_pr\\">Datenschutzhinweis</a>.<br /><br />\\n\\nDie Verwendung von AWS erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer m\xf6glichst zuverl\xe4ssigen Darstellung unserer Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TOWQAA4&status=Active\\">Data Privacy Framework</a>.<br /><br />\\n\\n<h3>Auftragsverarbeitung</h3><br />\\nWir haben einen Vertrag \xfcber Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gew\xe4hrleistet, dass dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.<br /><br />\\n\\n<h3>Amazon CloudFront CDN</h3><br />\\nWir nutzen das Content Delivery Network Amazon CloudFront CDN. Anbieter ist die Amazon Web Services EMEA SARL, 38 avenue John F. Kennedy, L-1855, Luxemburg (nachfolgend \u201EAmazon\u201C).<br /><br />\\n\\nBei Amazon CloudFront CDN handelt es sich um ein weltweit verteiltes Content Delivery Network. Dabei wird technisch der Informationstransfer zwischen Ihrem Browser und unserer Website \xfcber das Content Delivery Network geleitet. Hierdurch k\xf6nnen wir die weltweite Erreichbarkeit und die Leistungsf\xe4higkeit unserer Website erh\xf6hen.<br /><br />\\n\\nDer Einsatz von Amazon CloudFront CDN beruht auf unserem berechtigten Interesse an einer m\xf6glichst fehlerfreien und sicheren Bereitstellung unseres Webangebotes (Art. 6 Abs. 1 lit. f DSGVO).<br /><br />\\n\\nDie Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/\\">AWS GDPR Data Processing Addendum \u2013 Now Part of Service Terms  Amazon Web Services</a>.<br /><br />\\n\\nWeitere Informationen zu Amazon CloudFront CDN finden Sie hier: <a target=\'_blank\'href=\\"https://d1.awsstatic.com/legal/privacypolicy/AWS_Privacy_Notice__German_Translation.pdf\\">https://d1.awsstatic.com/legal/privacypolicy/AWS_Privacy_Notice__German_Translation.pdf</a>.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TOWQAA4&status=Active\\">Data Privacy Framework</a>.<br /><br />"},"generalInformation":{"title":"3. Allgemeine Hinweise und Pflichtinformationen","content":"<h3>Datenschutz</h3>\\nDie Betreiber dieser Seiten nehmen den Schutz Ihrer pers\xf6nlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerkl\xe4rung.<br />Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Die vorliegende Datenschutzerkl\xe4rung erl\xe4utert, welche Daten wir erheben und wof\xfcr wir sie nutzen. Sie erl\xe4utert auch, wie und zu welchem Zweck das geschieht.<br /><br />Wir weisen darauf hin, dass die Daten\xfcbertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitsl\xfccken aufweisen kann. Ein l\xfcckenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht m\xf6glich.<br /><br />\\n<h3>Hinweis zur verantwortlichen Stelle</h3>\\nDie verantwortliche Stelle f\xfcr die Datenverarbeitung auf dieser Website ist:<br /><br />\\nGamebook Studio HQ GmbH<br />\\nWilhelm-Kabus-Strasse 77<br />\\n10829 Berlin<br />\\nGermany<br /><br />\\nTelefon: +4917623963455<br />\\nE-Mail: info@gamebook.studio<br /><br />\\nVerantwortliche Stelle ist die nat\xfcrliche oder juristische Person, die allein oder gemeinsam mit anderen \xfcber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. \xc4.) entscheidet.<br /><br />\\n<h3>Speicherdauer</h3><br />Soweit innerhalb dieser Datenschutzerkl\xe4rung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck f\xfcr die Datenverarbeitung entf\xe4llt. Wenn Sie ein berechtigtes L\xf6schersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gel\xf6scht, sofern wir keine anderen rechtlich zul\xe4ssigen Gr\xfcnde f\xfcr die Speicherung Ihrer personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt die L\xf6schung nach Fortfall dieser Gr\xfcnde.<br /><br />\\n<h3>Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser Website</h3><br />Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle einer ausdr\xfccklichen Einwilligung in die \xdcbertragung personenbezogener Daten in Drittstaaten erfolgt die Datenverarbeitung au\xdferdem auf Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in die Speicherung von Cookies oder in den Zugriff auf Informationen in Ihr Endger\xe4t (z. B. via Device-Fingerprinting) eingewilligt haben, erfolgt die Datenverarbeitung zus\xe4tzlich auf Grundlage von \xa7 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten zur Vertragserf\xfcllung oder zur Durchf\xfchrung vorvertraglicher Ma\xdfnahmen erforderlich, verarbeiten wir Ihre Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern diese zur Erf\xfcllung einer rechtlichen Verpflichtung erforderlich sind auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann ferner auf Grundlage unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. \xdcber die jeweils im Einzelfall einschl\xe4gigen Rechtsgrundlagen wird in den folgenden Abs\xe4tzen dieser Datenschutzerkl\xe4rung informiert.<br /><br />\\n<h3>Datenschutz\xadbeauftragter</h3><br />Wir haben einen Datenschutzbeauftragten benannt.<br />Dr. Malte Behrmann<br />Ganghoferstr. 4<br />12163 Berlin<br /><br />Telefon: +49 30 65214472<br />E-Mail: <a target=\'_blank\'href=\\"mailto:kanzlei@malte-behrmann.de\\">kanzlei@malte-behrmann.de</a><br /><br />\\n<h3>Hinweis zur Datenweitergabe in datenschutzrechtlich nicht sichere Drittstaaten sowie die Weitergabe an US-Unternehmen, die nicht DPF-zertifiziert sind</h3><br />Wir verwenden unter anderem Tools von Unternehmen mit Sitz in datenschutzrechtlich nicht sicheren Drittstaaten sowie US-Tools, deren Anbieter nicht nach dem EU-US-Data Privacy Framework (DPF) zertifiziert sind. Wenn diese Tools aktiv sind, k\xf6nnen Ihre personenbezogene Daten in diese Staaten \xfcbertragen und dort verarbeitet werden. Wir weisen darauf hin, dass in datenschutzrechtlich unsicheren Drittstaaten kein mit der EU vergleichbares Datenschutzniveau garantiert werden kann.<br /><br />Wir weisen darauf hin, dass die USA als sicherer Drittstaat grunds\xe4tzlich ein mit der EU vergleichbares Datenschutzniveau aufweisen. Eine Daten\xfcbertragung in die USA ist danach zul\xe4ssig, wenn der Empf\xe4nger eine Zertifizierung unter dem \u201EEU-US Data Privacy Framework\u201C (DPF) besitzt oder \xfcber geeignete zus\xe4tzliche Garantien verf\xfcgt. Informationen zu \xdcbermittlungen an Drittstaaten einschlie\xdflich der Datenempf\xe4nger finden Sie in dieser Datenschutzerkl\xe4rung.<br /><br />\\n<h3>Empf\xe4nger von personenbezogenen Daten</h3><br />Im Rahmen unserer Gesch\xe4ftst\xe4tigkeit arbeiten wir mit verschiedenen externen Stellen zusammen. Dabei ist teilweise auch eine \xdcbermittlung von personenbezogenen Daten an diese externen Stellen erforderlich. Wir geben personenbezogene Daten nur dann an externe Stellen weiter, wenn dies im Rahmen einer Vertragserf\xfcllung erforderlich ist, wenn wir gesetzlich hierzu verpflichtet sind (z. B. Weitergabe von Daten an Steuerbeh\xf6rden), wenn wir ein berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der Weitergabe haben oder wenn eine sonstige Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von Auftragsverarbeitern geben wir personenbezogene Daten unserer Kunden nur auf Grundlage eines g\xfcltigen Vertrags \xfcber Auftragsverarbeitung weiter. Im Falle einer gemeinsamen Verarbeitung wird ein Vertrag \xfcber gemeinsame Verarbeitung geschlossen.<br /><br />\\n<h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3><br />Viele Datenverarbeitungsvorg\xe4nge sind nur mit Ihrer ausdr\xfccklichen Einwilligung m\xf6glich. Sie k\xf6nnen eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtm\xe4\xdfigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unber\xfchrt.<br /><br />\\n<h3>Widerspruchsrecht gegen die Datenerhebung in besonderen F\xe4llen sowie gegen Direktwerbung (Art. 21 DSGVO)</h3><br />WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GR\xdcNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH F\xdcR EIN AUF DIESE BESTIMMUNGEN GEST\xdcTZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE DIESER DATENSCHUTZERKL\xc4RUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI DENN, WIR K\xd6NNEN ZWINGENDE SCHUTZW\xdcRDIGE GR\xdcNDE F\xdcR DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN \xdcBERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUS\xdcBUNG ODER VERTEIDIGUNG VON RECHTSANSPR\xdcCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).<br /><br />WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH F\xdcR DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).<br /><br />\\n<h3>Beschwerde\xadrecht bei der zust\xe4ndigen Aufsichts\xadbeh\xf6rde</h3><br />Im Falle von Verst\xf6\xdfen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbeh\xf6rde, insbesondere in dem Mitgliedstaat ihres gew\xf6hnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutma\xdflichen Versto\xdfes zu. Das Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.<br /><br />\\n<h3>Recht auf Daten\xad\xfcbertrag\xadbarkeit</h3><br />Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erf\xfcllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem g\xe4ngigen, maschinenlesbaren Format aush\xe4ndigen zu lassen. Sofern Sie die direkte \xdcbertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.<br /><br />\\n<h3>Auskunft, Berichtigung und L\xf6schung</h3><br />Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft \xfcber Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empf\xe4nger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder L\xf6schung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten k\xf6nnen Sie sich jederzeit an uns wenden.<br /><br />\\n<h3>Recht auf Einschr\xe4nkung der Verarbeitung</h3><br />Sie haben das Recht, die Einschr\xe4nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Hierzu k\xf6nnen Sie sich jederzeit an uns wenden. Das Recht auf Einschr\xe4nkung der Verarbeitung besteht in folgenden F\xe4llen:<br /><br /><style>ul {list-style-type: disc; padding-left: 20px;}</style><ul><li>Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, ben\xf6tigen wir in der Regel Zeit, um dies zu \xfcberpr\xfcfen. F\xfcr die Dauer der Pr\xfcfung haben Sie das Recht, die Einschr\xe4nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.</li><br /><li>Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtm\xe4\xdfig geschah/geschieht, k\xf6nnen Sie statt der L\xf6schung die Einschr\xe4nkung der Datenverarbeitung verlangen.</li><br /><li>Wenn wir Ihre personenbezogenen Daten nicht mehr ben\xf6tigen, Sie sie jedoch zur Aus\xfcbung, Verteidigung oder Geltendmachung von Rechtsanspr\xfcchen ben\xf6tigen, haben Sie das Recht, statt der L\xf6schung die Einschr\xe4nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.</li><br /><li>Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abw\xe4gung zwischen Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen Interessen \xfcberwiegen, haben Sie das Recht, die Einschr\xe4nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.</li></ul><br />Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschr\xe4nkt haben, d\xfcrfen diese Daten \u2013 von ihrer Speicherung abgesehen \u2013 nur mit Ihrer Einwilligung oder zur Geltendmachung, Aus\xfcbung oder Verteidigung von Rechtsanspr\xfcchen oder zum Schutz der Rechte einer anderen nat\xfcrlichen oder juristischen Person oder aus Gr\xfcnden eines wichtigen \xf6ffentlichen Interesses der Europ\xe4ischen Union oder eines Mitgliedstaats verarbeitet werden.<br /><br />\\n<h3>SSL- bzw. TLS-Verschl\xfcsselung</h3><br />Diese Seite nutzt aus Sicherheitsgr\xfcnden und zum Schutz der \xdcbertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschl\xfcsselung. Eine verschl\xfcsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von \u201Ehttp://\u201C auf \u201Ehttps://\u201C wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.<br /><br />Wenn die SSL- bzw. TLS-Verschl\xfcsselung aktiviert ist, k\xf6nnen die Daten, die Sie an uns \xfcbermitteln, nicht von Dritten mitgelesen werden.<br /><br />\\n<h3>Verschl\xfcsselter Zahlungsverkehr auf dieser Website</h3><br />Besteht nach dem Abschluss eines kostenpflichtigen Vertrags eine Verpflichtung, uns Ihre Zahlungsdaten (z. B. Kontonummer bei Einzugserm\xe4chtigung) zu \xfcbermitteln, werden diese Daten zur Zahlungsabwicklung ben\xf6tigt.<br />Der Zahlungsverkehr \xfcber die g\xe4ngigen Zahlungsmittel (Visa/MasterCard, Lastschriftverfahren) erfolgt ausschlie\xdflich \xfcber eine verschl\xfcsselte SSL- bzw. TLS-Verbindung. Eine verschl\xfcsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von \u201Ehttp://\u201C auf \u201Ehttps://\u201C wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.<br />Bei verschl\xfcsselter Kommunikation k\xf6nnen Ihre Zahlungsdaten, die Sie an uns \xfcbermitteln, nicht von Dritten mitgelesen werden.<br /><br />\\n<h3>Widerspruch gegen Werbe-E-Mails</h3><br />Der Nutzung von im Rahmen der Impressumspflicht ver\xf6ffentlichten Kontaktdaten zur \xdcbersendung von nicht ausdr\xfccklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten behalten sich ausdr\xfccklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor."},"recordingData":{"title":"4. Datenerfassung auf dieser Website","content":"<h3>Cookies</h3><br />Unsere Internetseiten verwenden so genannte \u201ECookies\u201C. Cookies sind kleine Datenpakete und richten auf Ihrem Endger\xe4t keinen Schaden an. Sie werden entweder vor\xfcbergehend f\xfcr die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endger\xe4t gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gel\xf6scht. Permanente Cookies bleiben auf Ihrem Endger\xe4t gespeichert, bis Sie diese selbst l\xf6schen oder eine automatische L\xf6schung durch Ihren Webbrowser erfolgt.<br /><br />Cookies k\xf6nnen von uns (First-Party-Cookies) oder von Drittunternehmen stammen (sog. Third-Party-Cookies). Third-Party-Cookies erm\xf6glichen die Einbindung bestimmter Dienstleistungen von Drittunternehmen innerhalb von Webseiten (z. B. Cookies zur Abwicklung von Zahlungsdienstleistungen).<br /><br />Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte Webseitenfunktionen ohne diese nicht funktionieren w\xfcrden (z. B. die Warenkorbfunktion oder die Anzeige von Videos). Andere Cookies k\xf6nnen zur Auswertung des Nutzerverhaltens oder zu Werbezwecken verwendet werden.<br /><br />Cookies, die zur Durchf\xfchrung des elektronischen Kommunikationsvorgangs, zur Bereitstellung bestimmter, von Ihnen erw\xfcnschter Funktionen (z. B. f\xfcr die Warenkorbfunktion) oder zur Optimierung der Website (z. B. Cookies zur Messung des Webpublikums) erforderlich sind (notwendige Cookies), werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere Rechtsgrundlage angegeben wird. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von notwendigen Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung zur Speicherung von Cookies und vergleichbaren Wiedererkennungstechnologien abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG); die Einwilligung ist jederzeit widerrufbar.<br /><br />Sie k\xf6nnen Ihren Browser so einstellen, dass Sie \xfcber das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies f\xfcr bestimmte F\xe4lle oder generell ausschlie\xdfen sowie das automatische L\xf6schen der Cookies beim Schlie\xdfen des Browsers aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalit\xe4t dieser Website eingeschr\xe4nkt sein.<br /><br />Welche Cookies und Dienste auf dieser Website eingesetzt werden, k\xf6nnen Sie dieser Datenschutzerkl\xe4rung entnehmen.<br /><br /><h3>Server-Log-Dateien</h3><br />Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns \xfcbermittelt. Dies sind:<style>ul {list-style-type: disc; padding-left: 20px;}</style><ul> <li>Browsertyp und Browserversion</li> <br />  <li>verwendetes Betriebssystem</li>  <br />  <li>Referrer URL</li>  <br />  <li>Hostname des zugreifenden Rechners</li>  <br />  <li>Uhrzeit der Serveranfrage</li> <br />  <li>IP-Adresse</li></ul><br />Eine Zusammenf\xfchrung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.<br /><br />Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website \u2013 hierzu m\xfcssen die Server-Log-Files erfasst werden.<br /><br /><h3>Kontaktformular</h3><br />Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und f\xfcr den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.<br /><br />Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erf\xfcllung eines Vertrags zusammenh\xe4ngt oder zur Durchf\xfchrung vorvertraglicher Ma\xdfnahmen erforderlich ist. In allen \xfcbrigen F\xe4llen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung ist jederzeit widerrufbar.<br /><br />Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur L\xf6schung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck f\xfcr die Datenspeicherung entf\xe4llt (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen \u2013 insbesondere Aufbewahrungsfristen \u2013 bleiben unber\xfchrt.<br /><br /><h3>Anfrage per E-Mail, Telefon oder Telefax</h3><br />Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.<br /><br />Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erf\xfcllung eines Vertrags zusammenh\xe4ngt oder zur Durchf\xfchrung vorvertraglicher Ma\xdfnahmen erforderlich ist. In allen \xfcbrigen F\xe4llen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung ist jederzeit widerrufbar.<br /><br />Die von Ihnen an uns per Kontaktanfragen \xfcbersandten Daten verbleiben bei uns, bis Sie uns zur L\xf6schung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck f\xfcr die Datenspeicherung entf\xe4llt (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen \u2013 insbesondere gesetzliche Aufbewahrungsfristen \u2013 bleiben unber\xfchrt.<br /><br /><h3>Google Forms</h3><br />Wir haben Google Forms auf dieser Website eingebunden. Anbieter ist die die Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland (nachfolgend Google).<br /><br />Google Forms erm\xf6glicht es uns, Online-Formulare zu erstellen um Nachrichten, Anfragen und sonstige Eingaben unserer Websitebesucher strukturiert zu erfassen. Alle von Ihnen get\xe4tigten Eingaben werden auf den Servern von Google verarbeitet. Google Forms speichert ein Cookie in Ihrem Browser, das eine eindeutige ID enth\xe4lt (NID-Cookie). Dieses Cookie speichert verschiedene Informationen wie beispielsweise Ihre Spracheinstellungen.<br /><br />Der Einsatz von Google Forms erfolgt auf Grundlage unseres berechtigten Interesses an einer m\xf6glichst nutzerfreundlichen Ermittlung Ihres Anliegens (Art. 6 Abs. 1 lit. f DSGVO). Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.<br /><br />Die von Ihnen im Formular eingegebenen Daten verbleiben bei uns, bis Sie uns zur L\xf6schung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck f\xfcr die Datenspeicherung entf\xe4llt (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen \u2013 insbesondere Aufbewahrungsfristen \u2013 bleiben unber\xfchrt.<br /><br />Weitere Informationen entnehmen Sie der Datenschutzerkl\xe4rung von Google unter <a target=\'_blank\'href=\\"https://policies.google.com/\\">Privacy & Terms \u2013 Google</a>.<br /><br />Das Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>Auftragsverarbeitung</h3><br />Wir haben einen Vertrag \xfcber Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gew\xe4hrleistet, dass dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.<br /><br /><h3>Registrierung auf dieser Website</h3><br />Sie k\xf6nnen sich auf dieser Website registrieren, um zus\xe4tzliche Funktionen auf der Seite zu nutzen. Die dazu eingegebenen Daten verwenden wir nur zum Zwecke der Nutzung des jeweiligen Angebotes oder Dienstes, f\xfcr den Sie sich registriert haben. Die bei der Registrierung abgefragten Pflichtangaben m\xfcssen vollst\xe4ndig angegeben werden. Anderenfalls werden wir die Registrierung ablehnen.<br /><br />F\xfcr wichtige \xc4nderungen etwa beim Angebotsumfang oder bei technisch notwendigen \xc4nderungen nutzen wir die bei der Registrierung angegebene E-Mail-Adresse, um Sie auf diesem Wege zu informieren.<br /><br />Die Verarbeitung der bei der Registrierung eingegebenen Daten erfolgt zum Zwecke der Durchf\xfchrung des durch die Registrierung begr\xfcndeten Nutzungsverh\xe4ltnisses und ggf. zur Anbahnung weiterer Vertr\xe4ge (Art. 6 Abs. 1 lit. b DSGVO).<br /><br />Die bei der Registrierung erfassten Daten werden von uns gespeichert, solange Sie auf dieser Website registriert sind und werden anschlie\xdfend gel\xf6scht. Gesetzliche Aufbewahrungsfristen bleiben unber\xfchrt.<br /><br /><h3>Registrierung mit Facebook Connect</h3><br />Statt einer direkten Registrierung auf dieser Website k\xf6nnen Sie sich mit Facebook Connect registrieren. Anbieter dieses Dienstes ist die Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublin 2, Irland. Die erfassten Daten werden nach Aussage von Facebook jedoch auch in die USA und in andere Drittl\xe4nder \xfcbertragen.<br /><br />Wenn Sie sich f\xfcr die Registrierung mit Facebook Connect entscheiden und auf den \u201ELogin with Facebook\u201D-/\u201EConnect with Facebook\u201D-Button klicken, werden Sie automatisch auf die Plattform von Facebook weitergeleitet. Dort k\xf6nnen Sie sich mit Ihren Nutzungsdaten anmelden. Dadurch wird Ihr Facebook-Profil mit dieser Website bzw. unseren Diensten verkn\xfcpft. Durch diese Verkn\xfcpfung erhalten wir Zugriff auf Ihre bei Facebook hinterlegten Daten. Dies sind vor allem:<br /><br /><style>ul {list-style-type: disc; padding-left: 20px;}</style><ul><li>Facebook-Name</li><li>Facebook-Profil- und Titelbild</li><li>Facebook-Titelbild</li><li>bei Facebook hinterlegte E-Mail-Adresse</li><li>Facebook-ID</li><li>Facebook-Freundeslisten</li><li>Facebook Likes (\u201EGef\xe4llt-mir\u201C-Angaben)</li><li>Geburtstag</li><li>Geschlecht</li><li>Land</li><li>Sprache</li></ul><br /><br />Diese Daten werden zur Einrichtung, Bereitstellung und Personalisierung Ihres Accounts genutzt.<br /><br />Die Registrierung mit Facebook-Connect und die damit verbundenen Datenverarbeitungsvorg\xe4nge erfolgen auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Diese Einwilligung k\xf6nnen Sie jederzeit mit Wirkung f\xfcr die Zukunft widerrufen.<br /><br />Soweit mit Hilfe des hier beschriebenen Tools personenbezogene Daten auf unserer Website erfasst und an Facebook weitergeleitet werden, sind wir und die Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland gemeinsam f\xfcr diese Datenverarbeitung verantwortlich (Art. 26 DSGVO). Die gemeinsame Verantwortlichkeit beschr\xe4nkt sich dabei ausschlie\xdflich auf die Erfassung der Daten und deren Weitergabe an Facebook. Die nach der Weiterleitung erfolgende Verarbeitung durch Facebook ist nicht Teil der gemeinsamen Verantwortung. Die uns gemeinsam obliegenden Verpflichtungen wurden in einer Vereinbarung \xfcber gemeinsame Verarbeitung festgehalten. Den Wortlaut der Vereinbarung finden Sie unter: <a target=\'_blank\'href=\\"https://www.facebook.com/legal/controller_addendum\\">Facebook</a>. Laut dieser Vereinbarung sind wir f\xfcr die Erteilung der Datenschutzinformationen beim Einsatz des Facebook-Tools und f\xfcr die datenschutzrechtlich sichere Implementierung des Tools auf unserer Website verantwortlich. F\xfcr die Datensicherheit der Facebook-Produkte ist Facebook verantwortlich. Betroffenenrechte (z. B. Auskunftsersuchen) hinsichtlich der bei Facebook verarbeiteten Daten k\xf6nnen Sie direkt bei Facebook geltend machen. Wenn Sie die Betroffenenrechte bei uns geltend machen, sind wir verpflichtet, diese an Facebook weiterzuleiten.<br /><br />Die Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://www.facebook.com/legal/EU_data_transfer_addendum\\">Facebook</a>, <a target=\'_blank\'href=\\"https://de-de.facebook.com/help/566994660333381\\">What are Standard Contractual Clauses? Facebook Help Center</a> und <a target=\'_blank\'href=\\"https://www.facebook.com/policy.php\\">Meta Privacy Policy - How Meta collects and uses user data</a>.<br /> <br />Weitere Informationen finden Sie in den Facebook-Nutzungsbedingungen und den Facebook-Datenschutzbestimmungen. Diese finden Sie unter: <a target=\'_blank\'href=\\"https://www.facebook.com/about/privacy/\\">Meta Privacy Policy</a> und <a target=\'_blank\'href=\\"https://www.facebook.com/legal/terms/\\">Facebook Legal</a>.<br /><br />Das Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000GnywAAC&status=Active\\">Data Privacy Framework</a>.<br /><br /><h3>Registrierung mit Google</h3><br />Statt einer direkten Registrierung auf dieser Website k\xf6nnen Sie sich mit Google registrieren. Anbieter dieses Dienstes ist die Google Ireland Limited (\u201EGoogle\u201D), Gordon House, Barrow Street, Dublin 4, Irland.<br /><br />Um sich mit Google zu registrieren, m\xfcssen Sie ausschlie\xdflich Ihre Google-Namen und Ihr Passwort eingeben. Google wird Sie identifizieren und unserer Website Ihre Identit\xe4t best\xe4tigen.<br /><br />Wenn Sie sich mit Google anmelden, ist es uns ggf. m\xf6glich bestimmte Informationen auf Ihrem Konto zu nutzen, um Ihr Profil bei uns zu vervollst\xe4ndigen. Ob und welche Informationen das sind, entscheiden Sie im Rahmen Ihrer Google-Sicherheitseinstellungen, die Sie hier finden: <a target=\'_blank\'href=\\"https://myaccount.google.com/security\\">https://myaccount.google.com/security</a> und <a target=\'_blank\'href=\\"https://myaccount.google.com/permissions\\">https://myaccount.google.com/permissions</a>.<br /><br />Die Datenverarbeitung, die mit der Google-Registrierung einhergeht beruht auf unserem berechtigten Interesse, unseren Nutzern einen m\xf6glichst einfachen Registrierungsprozess zu erm\xf6glichen (Art. 6 Abs. 1 lit. f DSGVO). Da die Nutzung der Registrierungsfunktion freiwillig ist und die Nutzer selbst \xfcber die jeweiligen Zugriffsm\xf6glichkeiten entscheiden k\xf6nnen, sind keine entgegenstehenden \xfcberwiegenden Rechte der Betroffenen ersichtlich.<br /><br />Das Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br />"},"socialMedia":{"title":"5. Soziale Medien","content":"<h3>Facebook</h3><br />Auf dieser Website sind Elemente des sozialen Netzwerks Facebook integriert. Anbieter dieses Dienstes ist die Meta Platforms Ireland Limited, Merrion Road, Dublin 4, D04 X2K5, Irland. Die erfassten Daten werden nach Aussage von Facebook jedoch auch in die USA und in andere Drittl\xe4nder \xfcbertragen.<br /><br />\\n\\nEine \xdcbersicht \xfcber die Facebook Social-Media-Elemente finden Sie hier: <a target=\'_blank\'href=\\"https://developers.facebook.com/docs/plugins/\\">Soziale Plugins - Dokumentation - Meta for Developers</a>.<br /><br />Wenn das Social-Media-Element aktiv ist, wird eine direkte Verbindung zwischen Ihrem Endger\xe4t und dem Facebook-Server hergestellt. Facebook erh\xe4lt dadurch die Information, dass Sie mit Ihrer IP-Adresse diese Website besucht haben. Wenn Sie den Facebook \u201ELike-Button\u201C anklicken, w\xe4hrend Sie in Ihrem Facebook-Account eingeloggt sind, k\xf6nnen Sie die Inhalte dieser Website auf Ihrem Facebook-Profil verlinken. Dadurch kann Facebook den Besuch dieser Website Ihrem Benutzerkonto zuordnen. Wir weisen darauf hin, dass wir als Anbieter der Seiten keine Kenntnis vom Inhalt der \xfcbermittelten Daten sowie deren Nutzung durch Facebook erhalten. Weitere Informationen hierzu finden Sie in der Datenschutzerkl\xe4rung von Facebook unter: <a target=\'_blank\'href=\\"https://de-de.facebook.com/privacy/explanation\\">Meta Privacy Policy - How Meta collects and uses user data</a>.<br /><br />\\n\\nDie Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nSoweit mit Hilfe des hier beschriebenen Tools personenbezogene Daten auf unserer Website erfasst und an Facebook weitergeleitet werden, sind wir und die Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland gemeinsam f\xfcr diese Datenverarbeitung verantwortlich (Art. 26 DSGVO). Die gemeinsame Verantwortlichkeit beschr\xe4nkt sich dabei ausschlie\xdflich auf die Erfassung der Daten und deren Weitergabe an Facebook. Die nach der Weiterleitung erfolgende Verarbeitung durch Facebook ist nicht Teil der gemeinsamen Verantwortung. Die uns gemeinsam obliegenden Verpflichtungen wurden in einer Vereinbarung \xfcber gemeinsame Verarbeitung festgehalten. Den Wortlaut der Vereinbarung finden Sie unter: <a target=\'_blank\'href=\\"https://www.facebook.com/legal/controller_addendum\\">Facebook</a>. Laut dieser Vereinbarung sind wir f\xfcr die Erteilung der Datenschutzinformationen beim Einsatz des Facebook-Tools und f\xfcr die datenschutzrechtlich sichere Implementierung des Tools auf unserer Website verantwortlich. F\xfcr die Datensicherheit der Facebook-Produkte ist Facebook verantwortlich. Betroffenenrechte (z. B. Auskunftsersuchen) hinsichtlich der bei Facebook verarbeiteten Daten k\xf6nnen Sie direkt bei Facebook geltend machen. Wenn Sie die Betroffenenrechte bei uns geltend machen, sind wir verpflichtet, diese an Facebook weiterzuleiten.<br /><br />Die Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://www.facebook.com/legal/EU_data_transfer_addendum\\">Facebook</a>, <a target=\'_blank\'href=\\"https://de-de.facebook.com/help/566994660333381\\">What are Standard Contractual Clauses? Facebook Help Center</a> und <a target=\'_blank\'href=\\"https://www.facebook.com/policy.php\\">Meta Privacy Policy - How Meta collects and uses user data</a>.<br /><br />Das Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000GnywAAC&status=Active\\">Data Privacy Framework</a>.<br /><br /><h3>X (ehemals Twitter)</h3><br />Auf dieser Website sind Funktionen des Dienstes X (ehemals Twitter) eingebunden. Diese Funktionen werden angeboten durch den Mutterkonzern X Corp., 1355 Market Street, Suite 900, San Francisco, CA 94103, USA. F\xfcr die Datenverarbeitung von au\xdferhalb der USA lebenden Personen ist die Niederlassung Twitter International Unlimited Company, One Cumberland Place, Fenian Street, Dublin 2, D02 AX07, Irland, verantwortlich.<br /><br />\\n\\nWenn das Social-Media-Element aktiv ist, wird eine direkte Verbindung zwischen Ihrem Endger\xe4t und dem X-Server hergestellt. X (ehemals Twitter) erh\xe4lt dadurch Informationen \xfcber den Besuch dieser Website durch Sie. Durch das Benutzen von X (ehemals Twitter) und der Funktion \u201ERe-Tweet\u201C bzw. \u201ERepost\u201C werden die von Ihnen besuchten Websites mit Ihrem X (ehemals Twitter)-Account verkn\xfcpft und anderen Nutzern bekannt gegeben. Wir weisen darauf hin, dass wir als Anbieter der Seiten keine Kenntnis vom Inhalt der \xfcbermittelten Daten sowie deren Nutzung durch X (ehemals Twitter) erhalten. Weitere Informationen hierzu finden Sie in der Datenschutzerkl\xe4rung von X (ehemals Twitter) unter: <a target=\'_blank\'href=\\"https://x.com/en/privacy\\">Datenschutzrichtlinie von X</a>.<br /><br />Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.<br /><br />Die Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://gdpr.x.com/en/controller-to-controller-transfers.html\\">Controller-to-Controller Transfers</a>.<br /><br />Ihre Datenschutzeinstellungen bei X (ehemals Twitter) k\xf6nnen Sie in den Konto-Einstellungen unter <a target=\'_blank\'href:\\"https://x.com/settings/account\\">X.com</a> \xe4ndern.<br /><br /><h3>Instagram</h3><br />Auf dieser Website sind Funktionen des Dienstes Instagram eingebunden. Diese Funktionen werden angeboten durch die Meta Platforms Ireland Limited, Merrion Road, Dublin 4, D04 X2K5, Irland.<br /><br />\\n\\nWenn das Social-Media-Element aktiv ist, wird eine direkte Verbindung zwischen Ihrem Endger\xe4t und dem Instagram-Server hergestellt. Instagram erh\xe4lt dadurch Informationen \xfcber den Besuch dieser Website durch Sie.<br /><br />\\n\\nWenn Sie in Ihrem Instagram-Account eingeloggt sind, k\xf6nnen Sie durch Anklicken des Instagram-Buttons die Inhalte dieser Website mit Ihrem Instagram-Profil verlinken. Dadurch kann Instagram den Besuch dieser Website Ihrem Benutzerkonto zuordnen. Wir weisen darauf hin, dass wir als Anbieter der Seiten keine Kenntnis vom Inhalt der \xfcbermittelten Daten sowie deren Nutzung durch Instagram erhalten.<br /><br />\\n\\nDie Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nSoweit mit Hilfe des hier beschriebenen Tools personenbezogene Daten auf unserer Website erfasst und an Facebook bzw. Instagram weitergeleitet werden, sind wir und die Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland gemeinsam f\xfcr diese Datenverarbeitung verantwortlich (Art. 26 DSGVO). Die gemeinsame Verantwortlichkeit beschr\xe4nkt sich dabei ausschlie\xdflich auf die Erfassung der Daten und deren Weitergabe an Facebook bzw. Instagram. Die nach der Weiterleitung erfolgende Verarbeitung durch Facebook bzw. Instagram ist nicht Teil der gemeinsamen Verantwortung. Die uns gemeinsam obliegenden Verpflichtungen wurden in einer Vereinbarung \xfcber gemeinsame Verarbeitung festgehalten. Den Wortlaut der Vereinbarung finden Sie unter: <a target=\'_blank\'href=\\"https://www.facebook.com/legal/controller_addendum\\">Facebook</a>. Laut dieser Vereinbarung sind wir f\xfcr die Erteilung der Datenschutzinformationen beim Einsatz des Facebook- bzw. Instagram-Tools und f\xfcr die datenschutzrechtlich sichere Implementierung des Tools auf unserer Website verantwortlich. F\xfcr die Datensicherheit der Facebook bzw. Instagram-Produkte ist Facebook verantwortlich. Betroffenenrechte (z. B. Auskunftsersuchen) hinsichtlich der bei Facebook bzw. Instagram verarbeiteten Daten k\xf6nnen Sie direkt bei Facebook geltend machen. Wenn Sie die Betroffenenrechte bei uns geltend machen, sind wir verpflichtet, diese an Facebook weiterzuleiten.<br /><br />Die Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://www.facebook.com/legal/controller_addendum\\">Facebook</a> und <a target=\'_blank\'href=\\"https://www.facebook.com/legal/EU_data_transfer_addendum\\">Facebook</a>, <a target=\'_blank\'href=\\"https://privacycenter.instagram.com/policy/\\">Meta Privacy Policy - How Meta collects and uses user data</a> und <a target=\'_blank\'href=\\"https://de-de.facebook.com/help/566994660333381\\">What are Standard Contractual Clauses? Facebook Help Center</a>.<br /><br />Weitere Informationen hierzu finden Sie in der Datenschutzerkl\xe4rung von Instagram: <a target=\'_blank\'href=\\"https://privacycenter.instagram.com/policy/\\">Meta Privacy Policy - How Meta collects and uses user data</a>.<br /><br />Das Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000GnywAAC&status=Active\\">Data Privacy Framework</a>.<br /><br /><h3>LinkedIn</h3><br />Diese Website nutzt Elemente des Netzwerks LinkedIn. Anbieter ist die LinkedIn Ireland Unlimited Company, Wilton Plaza, Wilton Place, Dublin 2, Irland.<br /><br />\\n\\nBei jedem Abruf einer Seite dieser Website, die Elemente von LinkedIn enth\xe4lt, wird eine Verbindung zu Servern von LinkedIn aufgebaut. LinkedIn wird dar\xfcber informiert, dass Sie diese Website mit Ihrer IP-Adresse besucht haben. Wenn Sie den \u201ERecommend-Button\u201C von LinkedIn anklicken und in Ihrem Account bei LinkedIn eingeloggt sind, ist es LinkedIn m\xf6glich, Ihren Besuch auf dieser Website Ihnen und Ihrem Benutzerkonto zuzuordnen. Wir weisen darauf hin, dass wir als Anbieter der Seiten keine Kenntnis vom Inhalt der \xfcbermittelten Daten sowie deren Nutzung durch LinkedIn haben.<br /><br />\\n\\nDie Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.<br /><br />Die Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://www.linkedin.com/help/linkedin/answer/a1343190/datenubertragung-aus-der-eu-dem-ewr-und-der-schweiz?lang=de\\">https://www.linkedin.com/help/linkedin/answer/a1343190/datenubertragung-aus-der-eu-dem-ewr-und-der-schweiz?lang=de</a>.<br /><br />Weitere Informationen hierzu finden Sie in der Datenschutzerkl\xe4rung von LinkedIn unter: <a target=\'_blank\'href=\\"https://www.linkedin.com/legal/privacy-policy\\">https://www.linkedin.com/legal/privacy-policy</a>.<br /><br />Das Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5448\\">Data Privacy Framework</a>.<br /><br /><h3>XING</h3><br />Diese Website nutzt Elemente des Netzwerks XING. Anbieter ist die New Work SE, Am Strandkai 1, 20457 Hamburg, Deutschland.<br /><br />\\n\\nBei jedem Abruf einer unserer Seiten, die Elemente von XING enth\xe4lt, wird eine Verbindung zu Servern von XING hergestellt. Eine Speicherung von personenbezogenen Daten erfolgt dabei nach unserer Kenntnis nicht. Insbesondere werden keine IP-Adressen gespeichert oder das Nutzungsverhalten ausgewertet.<br /><br />\\n\\nDie Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nWeitere Information zum Datenschutz und dem XING Share-Button finden Sie in der Datenschutzerkl\xe4rung von XING unter: <a target=\'_blank\'href=\\"https://privacy.xing.com/de/datenschutzerklaerung\\">Datenschutz bei XING</a>.<br />"},"analysisTools":{"title":"6. Analyse-Tools und Werbung","content":"<h3>Google Tag Manager</h3><br />Wir setzen den Google Tag Manager ein. Anbieter ist die Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.<br /><br />\\n\\nDer Google Tag Manager ist ein Tool, mit dessen Hilfe wir Tracking- oder Statistik-Tools und andere Technologien auf unserer Website einbinden k\xf6nnen. Der Google Tag Manager selbst erstellt keine Nutzerprofile, speichert keine Cookies und nimmt keine eigenst\xe4ndigen Analysen vor. Er dient lediglich der Verwaltung und Ausspielung der \xfcber ihn eingebundenen Tools. Der Google Tag Manager erfasst jedoch Ihre IP-Adresse, die auch an das Mutterunternehmen von Google in die Vereinigten Staaten \xfcbertragen werden kann.<br /><br />\\n\\nDer Einsatz des Google Tag Managers erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an einer schnellen und unkomplizierten Einbindung und Verwaltung verschiedener Tools auf seiner Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>Google Analytics</h3><br />Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google Ireland Limited (\u201EGoogle\u201C), Gordon House, Barrow Street, Dublin 4, Irland.<br /><br />\\n\\nGoogle Analytics erm\xf6glicht es dem Websitebetreiber, das Verhalten der Websitebesucher zu analysieren. Hierbei erh\xe4lt der Websitebetreiber verschiedene Nutzungsdaten, wie z. B. Seitenaufrufe, Verweildauer, verwendete Betriebssysteme und Herkunft des Nutzers. Diese Daten werden dem jeweiligen Endger\xe4t des Users zugeordnet. Eine Zuordnung zu einer User-ID erfolgt nicht.<br /><br />\\n\\nDes Weiteren k\xf6nnen wir mit Google Analytics u. a. Ihre Maus- und Scrollbewegungen und Klicks aufzeichnen. Ferner verwendet Google Analytics verschiedene Modellierungsans\xe4tze, um die erfassten Datens\xe4tze zu erg\xe4nzen und setzt Machine-Learning-Technologien bei der Datenanalyse ein.<br /><br />\\n\\nGoogle Analytics verwendet Technologien, die die Wiedererkennung des Nutzers zum Zwecke der Analyse des Nutzerverhaltens erm\xf6glichen (z. B. Cookies oder Device-Fingerprinting). Die von Google erfassten Informationen \xfcber die Benutzung dieser Website werden in der Regel an einen Server von Google in den USA \xfcbertragen und dort gespeichert.<br /><br />\\n\\nDie Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nDie Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://privacy.google.com/businesses/controllerterms/mccs/\\">https://privacy.google.com/businesses/controllerterms/mccs/</a>.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>IP Anonymisierung</h3><br />Die Google Analytics IP-Anonymisierung ist aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europ\xe4ischen Union oder in anderen Vertragsstaaten des Abkommens \xfcber den Europ\xe4ischen Wirtschaftsraum vor der \xdcbermittlung in die USA gek\xfcrzt. Nur in Ausnahmef\xe4llen wird die volle IP-Adresse an einen Server von Google in den USA \xfcbertragen und dort gek\xfcrzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports \xfcber die Websiteaktivit\xe4ten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegen\xfcber dem Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser \xfcbermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengef\xfchrt.<br /><br /><h3>Browser Plugin</h3><br />Sie k\xf6nnen die Erfassung und Verarbeitung Ihrer Daten durch Google verhindern, indem Sie das unter dem folgenden Link verf\xfcgbare Browser-Plugin herunterladen und installieren: <a target=\'_blank\'href=\\"https://tools.google.com/dlpage/gaoptout?hl=de\\">Download-Seite f\xfcr das Browser-Add-on zur Deaktivierung von Google Analytics</a>.<br /><br />\\n\\nMehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerkl\xe4rung von Google: <a target=\'_blank\'href=\\"https://support.google.com/analytics/answer/6004245?hl=de\\">Datenschutz - Google Analytics-Hilfe</a>.<br /><br /><h3>Demografische Merkmale bei Google Analytics</h3><br />Diese Website nutzt die Funktion \u201Edemografische Merkmale\u201C von Google Analytics, um den Websitebesuchern passende Werbeanzeigen innerhalb des Google-Werbenetzwerks anzeigen zu k\xf6nnen. Dadurch k\xf6nnen Berichte erstellt werden, die Aussagen zu Alter, Geschlecht und Interessen der Seitenbesucher enthalten. Diese Daten stammen aus interessenbezogener Werbung von Google sowie aus Besucherdaten von Drittanbietern. Diese Daten k\xf6nnen keiner bestimmten Person zugeordnet werden. Sie k\xf6nnen diese Funktion jederzeit \xfcber die Anzeigeneinstellungen in Ihrem Google-Konto deaktivieren oder die Erfassung Ihrer Daten durch Google Analytics wie im Punkt \u201EWiderspruch gegen Datenerfassung\u201C dargestellt generell untersagen.<br /><br /><h3>Auftragsverarbeitung</h3><br />Wir haben mit Google einen Vertrag zur Auftragsverarbeitung abgeschlossen und setzen die strengen Vorgaben der deutschen Datenschutzbeh\xf6rden bei der Nutzung von Google Analytics vollst\xe4ndig um.<br /><br /><h3>Google Analytics E-Commerce-Messung</h3><br />Diese Website nutzt die Funktion \u201EE-Commerce-Messung\u201C von Google Analytics. Mit Hilfe von E-Commerce-Messung kann der Websitebetreiber das Kaufverhalten der Websitebesucher zur Verbesserung seiner Online-Marketing-Kampagnen analysieren. Hierbei werden Informationen, wie zum Beispiel die get\xe4tigten Bestellungen, durchschnittliche Bestellwerte, Versandkosten und die Zeit von der Ansicht bis zum Kauf eines Produktes erfasst. Diese Daten k\xf6nnen von Google unter einer Transaktions-ID zusammengefasst werden, die dem jeweiligen Nutzer bzw. dessen Ger\xe4t zugeordnet ist.<br /><br /><h3>WP Statistics</h3><br />Diese Website nutzt das Analysetool WP Statistics, um Besucherzugriffe statistisch auszuwerten. Anbieter ist Veronalabs, Tatari 64, 10134, Tallinn, Estland (<a target=\'_blank\'href=\\"https://veronalabs.com\\">https://veronalabs.com</a>).<br /><br />\\n\\nMit WP Statistics k\xf6nnen wir die Nutzung unserer Website analysieren. WP Statistics erfasst dabei u. a. Logdateien (IP-Adresse, Referrer, verwendete Browser, Herkunft des Nutzers, verwendete Suchmaschine) und Aktionen, die die Websitebesucher auf der Seite get\xe4tigt haben (z. B. Klicks und Ansichten).<br /><br />\\n\\nDie mit WP Statistics erfassten Daten werden ausschlie\xdflich auf unserem eigenen Server gespeichert.<br /><br />\\n\\nDie Nutzung dieses Analyse-Tools erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an der anonymisierten Analyse des Nutzerverhaltens, um sowohl unser Webangebot als auch unsere Werbung zu optimieren. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.<br /><br /><h3>IP-Anonymisierung</h3><br />Wir verwenden WP Statistics mit anonymisierter IP. Ihre IP-Adresse wird dabei gek\xfcrzt, sodass diese Ihnen nicht mehr direkt zugeordnet werden kann.<br /><br /><h3>Google Ads</h3><br />Der Websitebetreiber verwendet Google Ads. Google Ads ist ein Online-Werbeprogramm der Google Ireland Limited (\u201EGoogle\u201C), Gordon House, Barrow Street, Dublin 4, Irland.<br /><br />\\n\\nGoogle Ads erm\xf6glicht es uns Werbeanzeigen in der Google-Suchmaschine oder auf Drittwebseiten auszuspielen, wenn der Nutzer bestimmte Suchbegriffe bei Google eingibt (Keyword-Targeting). Ferner k\xf6nnen zielgerichtete Werbeanzeigen anhand der bei Google vorhandenen Nutzerdaten (z. B. Standortdaten und Interessen) ausgespielt werden (Zielgruppen-Targeting). Wir als Websitebetreiber k\xf6nnen diese Daten quantitativ auswerten, indem wir beispielsweise analysieren, welche Suchbegriffe zur Ausspielung unserer Werbeanzeigen gef\xfchrt haben und wie viele Anzeigen zu entsprechenden Klicks gef\xfchrt haben.<br /><br />\\n\\nDie Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nDie Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://policies.google.com/privacy/frameworks\\">Data transfer frameworks \u2013 Privacy & Terms \u2013 Google</a> und <a target=\'_blank\'href=\\"https://business.safety.google/controllerterms/\\">Google Controller-Controller Data Protection Terms</a>.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>Google AdSense (nicht personalisiert)</h3><br />Diese Website nutzt Google AdSense, einen Dienst zum Einbinden von Werbeanzeigen. Anbieter ist die Google Ireland Limited (\u201EGoogle\u201C), Gordon House, Barrow Street, Dublin 4, Irland.<br /><br />\\n\\nWir nutzen Google AdSense im \u201Enicht-personalisierten\u201C Modus. Im Gegensatz zum personalisierten Modus beruhen die Werbeanzeigen daher nicht auf Ihrem fr\xfcheren Nutzerverhalten und es wird kein Nutzerprofil von Ihnen erstellt. Stattdessen werden bei der Auswahl der Werbung sogenannte \u201EKontextinformationen\u201C herangezogen. Die ausgew\xe4hlten Werbeanzeigen richten sich dann beispielsweise nach Ihrem Standort, dem Inhalt der Website, auf der Sie sich befinden oder nach Ihren aktuellen Suchbegriffen. Mehr zu den Unterschieden zwischen personalisiertem und nicht-personalisiertem Targeting mit Google AdSense finden Sie unter: <a target=\'_blank\'href=\\"https://support.google.com/adsense/answer/9007336\\">Personalized and non-personalized ads - Google AdSense Help</a>.<br /><br />\\n\\nBitte beachten Sie, dass auch beim Einsatz von Google Adsense im nicht-personalisierten Modus Cookies oder vergleichbare Wiedererkennungstechnologien (z. B. Device-Fingerprinting) verwendet werden k\xf6nnen. Diese werden laut Google zur Bek\xe4mpfung von Betrug und Missbrauch eingesetzt.<br /><br />\\n\\nDie Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nDie Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://privacy.google.com/businesses/controllerterms/mccs/\\">https://privacy.google.com/businesses/controllerterms/mccs/</a>.<br /><br />\\n\\nSie k\xf6nnen Ihre Werbeeinstellungen selbstst\xe4ndig in Ihrem Nutzer-Account anpassen. Klicken Sie hierzu auf folgenden Link und loggen Sie sich ein: <a target=\'_blank\'href=\\"https://adssettings.google.com/authenticated\\">https://adssettings.google.com/authenticated</a>.<br /><br />\\n\\nWeitere Informationen zu den Werbetechnologien von Google finden Sie hier: <a target=\'_blank\'href=\\"https://policies.google.com/technologies/ads\\">Advertising \u2013 Privacy & Terms \u2013 Google</a> und <a target=\'_blank\'href=\\"https://www.google.de/intl/de/policies/privacy/\\">Datenschutzerkl\xe4rung \u2013 Datenschutzerkl\xe4rung & Nutzungsbedingungen \u2013 Google</a>.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>Google Ads Remarketing</h3><br />Diese Website nutzt die Funktionen von Google Ads Remarketing. Anbieter ist die Google Ireland Limited (\u201EGoogle\u201C), Gordon House, Barrow Street, Dublin 4, Irland.<br /><br />\\n\\nMit Google Ads Remarketing k\xf6nnen wir Personen, die mit unserem Online-Angebot interagieren bestimmten Zielgruppen zuordnen, um ihnen anschlie\xdfend interessenbezogene Werbung im Google-Werbenetzwerk anzeigen zu lassen (Remarketing bzw. Retargeting).<br /><br />\\n\\nDes Weiteren k\xf6nnen die mit Google Ads Remarketing erstellten Werbe-Zielgruppen mit den ger\xe4te\xfcbergreifenden Funktionen von Google verkn\xfcpft werden. Auf diese Weise k\xf6nnen interessenbezogene, personalisierte Werbebotschaften, die in Abh\xe4ngigkeit Ihres fr\xfcheren Nutzungs- und Surfverhaltens auf einem Endger\xe4t (z. B. Handy) an Sie angepasst wurden auch auf einem anderen Ihrer Endger\xe4te (z. B. Tablet oder PC) angezeigt werden.<br /><br />\\n\\nWenn Sie \xfcber einen Google-Account verf\xfcgen, k\xf6nnen Sie der personalisierten Werbung unter folgendem Link widersprechen: <a target=\'_blank\'href=\\"https://adssettings.google.com/anonymous?hl=de\\">https://adssettings.google.com/anonymous?hl=de</a>.<br /><br />\\n\\nDie Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nWeitergehende Informationen und die Datenschutzbestimmungen finden Sie in der <a target=\'_blank\'href=\\"https://policies.google.com/technologies/ads?hl=de\\">Datenschutzerkl\xe4rung von Google</a>.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br /><h3>Zielgruppenbildung mit Kundenabgleich</h3><br />Zur Zielgruppenbildung verwenden wir unter anderem den Kundenabgleich von Google Ads Remarketing. Hierbei \xfcbergeben wir bestimmte Kundendaten (z. B. E-Mail-Adressen) aus unseren Kundenlisten an Google. Sind die betreffenden Kunden Google-Nutzer und in ihrem Google-Konto eingeloggt, werden ihnen passende Werbebotschaften innerhalb des Google-Netzwerks (z. B. bei YouTube, Gmail oder in der Suchmaschine) angezeigt.<br /><br /><h3>Google Conversion-Tracking</h3><br />Diese Website nutzt Google Conversion Tracking. Anbieter ist die Google Ireland Limited (\u201EGoogle\u201C), Gordon House, Barrow Street, Dublin 4, Irland.<br /><br />\\n\\nMit Hilfe von Google-Conversion-Tracking k\xf6nnen Google und wir erkennen, ob der Nutzer bestimmte Aktionen durchgef\xfchrt hat. So k\xf6nnen wir beispielsweise auswerten, welche Buttons auf unserer Website wie h\xe4ufig geklickt und welche Produkte besonders h\xe4ufig angesehen oder gekauft wurden. Diese Informationen dienen dazu, Conversion-Statistiken zu erstellen. Wir erfahren die Gesamtanzahl der Nutzer, die auf unsere Anzeigen geklickt haben und welche Aktionen sie durchgef\xfchrt haben. Wir erhalten keine Informationen, mit denen wir den Nutzer pers\xf6nlich identifizieren k\xf6nnen. Google selbst nutzt zur Identifikation Cookies oder vergleichbare Wiedererkennungstechnologien.<br /><br />\\n\\nDie Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nMehr Informationen zu Google Conversion-Tracking finden Sie in den Datenschutzbestimmungen von Google: <a target=\'_blank\'href=\\"https://policies.google.com/privacy?hl=de\\">Datenschutzerkl\xe4rung \u2013 Datenschutzerkl\xe4rung & Nutzungsbedingungen \u2013 Google </a>.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br />"},"newsletterPrivacyPolicy":{"title":"7. Newsletter","content":"<h3>Newsletterversand an Bestandskunden</h3><br />Wenn Sie Waren oder Dienstleistungen bei uns bestellen und hierbei Ihre E-Mail-Adresse hinterlegen, kann diese E-Mail-Adresse in der Folge durch uns f\xfcr den Versand von Newslettern verwendet werden, sofern wir Sie vorab hier\xfcber informieren. In einem solchen Fall wird \xfcber den Newsletter nur Direktwerbung f\xfcr eigene \xe4hnliche Waren oder Dienstleistungen versendet. Die Zusendung dieses Newsletters kann von Ihnen jederzeit gek\xfcndigt werden. Zu diesem Zweck findet sich in jedem Newsletter ein entsprechender Link. Rechtsgrundlage f\xfcr den Versand des Newsletters ist in diesem Fall Art. 6 Abs. 1 lit. f DSGVO in Verbindung mit \xa7 7 Abs. 3 UWG.<br /><br />\\n\\nNach Ihrer Austragung aus der Newsletterverteilerliste wird Ihre E-Mail-Adresse bei uns ggf. in einer Blacklist gespeichert, um k\xfcnftige Mailings an Sie zu verhindern. Die Daten aus der Blacklist werden nur f\xfcr diesen Zweck verwendet und nicht mit anderen Daten zusammengef\xfchrt. Dies dient sowohl Ihrem Interesse als auch unserem Interesse an der Einhaltung der gesetzlichen Vorgaben beim Versand von Newslettern (berechtigtes Interesse im Sinne des Art. 6 Abs. 1 lit. f DSGVO). Die Speicherung in der Blacklist ist zeitlich nicht befristet. Sie k\xf6nnen der Speicherung widersprechen, sofern Ihre Interessen unser berechtigtes Interesse \xfcberwiegen.<br />"},"pluginsTools":{"title":"8. Plugins und Tools","content":"<h3>YouTube mit erweitertem Datenschutz</h3><br />Diese Website bindet Videos der Website YouTube ein. Betreiber der Website ist die Google Ireland Limited (\u201EGoogle\u201D), Gordon House, Barrow Street, Dublin 4, Irland.<br /><br />\\n\\nWenn Sie eine dieser Website besuchen, auf denen YouTube eingebunden ist, wird eine Verbindung zu den Servern von YouTube hergestellt. Dabei wird dem YouTube-Server mitgeteilt, welche unserer Seiten Sie besucht haben. Wenn Sie in Ihrem YouTube-Account eingeloggt sind, erm\xf6glichen Sie YouTube, Ihr Surfverhalten direkt Ihrem pers\xf6nlichen Profil zuzuordnen. Dies k\xf6nnen Sie verhindern, indem Sie sich aus Ihrem YouTube-Account ausloggen.<br /><br />\\n\\nWir nutzen YouTube im erweiterten Datenschutzmodus. Videos, die im erweiterten Datenschutzmodus abgespielt werden, werden nach Aussage von YouTube nicht zur Personalisierung des Surfens auf YouTube eingesetzt. Anzeigen, die im erweiterten Datenschutzmodus ausgespielt werden, sind ebenfalls nicht personalisiert. Im erweiterten Datenschutzmodus werden keine Cookies gesetzt. Stattdessen werden jedoch sogenannte Local Storage Elemente im Browser des Users gespeichert, die \xe4hnlich wie Cookies personenbezogene Daten beinhalten und zur Wiedererkennung eingesetzt werden k\xf6nnen. Details zum erweiterten Datenschutzmodus finden Sie hier: <a target=\'_blank\'href=\\"https://support.google.com/youtube/answer/171780\\">Embed videos & playlists - YouTube Help</a>.<br /><br />\\n\\nGegebenenfalls k\xf6nnen nach der Aktivierung eines YouTube-Videos weitere Datenverarbeitungsvorg\xe4nge ausgel\xf6st werden, auf die wir keinen Einfluss haben.<br /><br />\\n\\nDie Nutzung von YouTube erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nWeitere Informationen \xfcber Datenschutz bei YouTube finden Sie in deren Datenschutzerkl\xe4rung unter: <a target=\'_blank\'href=\\"https://policies.google.com/privacy?hl=en\\">Datenschutzerkl\xe4rung \u2013 Datenschutzerkl\xe4rung & Nutzungsbedingungen \u2013 Google </a>.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br />\\n\\n<h3>Vimeo ohne Tracking (Do-Not-Track)</h3><br />Diese Website nutzt Plugins des Videoportals Vimeo. Anbieter ist die Vimeo Inc., 555 West 18th Street, New York, New York 10011, USA.<br /><br />\\n\\nWenn Sie eine unserer mit Vimeo-Videos ausgestatteten Seiten besuchen, wird eine Verbindung zu den Servern von Vimeo hergestellt. Dabei wird dem Vimeo-Server mitgeteilt, welche unserer Seiten Sie besucht haben. Zudem erlangt Vimeo Ihre IP-Adresse. Wir haben Vimeo jedoch so eingestellt, dass Vimeo Ihre Nutzeraktivit\xe4ten nicht nachverfolgen und keine Cookies setzen wird.<br /><br />\\n\\nDie Nutzung von Vimeo erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne des Art. 6 Abs. 1 lit. f DSGVO dar. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nDie Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission sowie nach Aussage von Vimeo auf \u201Eberechtigte Gesch\xe4ftsinteressen\u201C gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://vimeo.com/privacy\\">Privacy Policy on Vimeo</a>.<br /><br />\\n\\nWeitere Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerkl\xe4rung von Vimeo unter: <a target=\'_blank\'href=\\"https://vimeo.com/privacy\\">Privacy Policy on Vimeo</a>.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5711\\">Data Privacy Framework</a>.<br /><br />\\n\\n<h3>Google Fonts (lokales Hosting)</h3><br />Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Google Fonts, die von Google bereitgestellt werden. Die Google Fonts sind lokal installiert. Eine Verbindung zu Servern von Google findet dabei nicht statt.<br /><br />\\n\\nWeitere Informationen zu Google Fonts finden Sie unter <a target=\'_blank\'href=\\"https://developers.google.com/fonts/faq\\">Frequently Asked Questions - Google Fonts - Google for Developers</a> und in der Datenschutzerkl\xe4rung von Google: <a target=\'_blank\'href=\\"https://policies.google.com/privacy?hl=en\\">Privacy Policy \u2013 Privacy & Terms \u2013 Google</a>.<br /><br />\\n\\n<h3>Adobe Fonts</h3><br />Diese Website nutzt zur einheitlichen Darstellung bestimmter Schriftarten Web Fonts von Adobe. Anbieter ist die Adobe Systems Incorporated, 345 Park Avenue, San Jose, CA 95110-2704, USA (Adobe).<br /><br />\\n\\nBeim Aufruf dieser Website l\xe4dt Ihr Browser die ben\xf6tigten Schriftarten direkt von Adobe, um sie Ihrem Endger\xe4t korrekt anzeigen zu k\xf6nnen. Dabei stellt Ihr Browser eine Verbindung zu den Servern von Adobe in den USA her. Hierdurch erlangt Adobe Kenntnis dar\xfcber, dass \xfcber Ihre IP-Adresse diese Website aufgerufen wurde. Bei der Bereitstellung der Schriftarten werden nach Aussage von Adobe keine Cookies gespeichert.<br /><br />\\n\\nDie Speicherung und Analyse der Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der einheitlichen Darstellung des Schriftbildes auf seiner Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nDie Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://www.adobe.com/de/privacy/eudatatransfers.html\\">Datenschutzzentrum von Adobe</a>.<br /><br />\\n\\nN\xe4here Informationen zu Adobe Fonts erhalten Sie unter: <a target=\'_blank\'href=\\"https://www.adobe.com/privacy/policies/adobe-fonts.html\\">Adobe Privacy Center</a>.<br /><br />\\n\\nDie Datenschutzerkl\xe4rung von Adobe finden Sie unter: <a target=\'_blank\'href=\\"https://www.adobe.com/privacy/policy.html\\">Adobe Privacy Center</a>.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TNo9AAG&status=Active\\">Data Privacy Framework</a>.<br /><br />\\n\\n<h3>Google Maps</h3><br />Diese Seite nutzt den Kartendienst Google Maps. Anbieter ist die Google Ireland Limited (\u201EGoogle\u201C), Gordon House, Barrow Street, Dublin 4, Irland. Mit Hilfe dieses Dienstes k\xf6nnen wir Kartenmaterial auf unserer Website einbinden.<br /><br />\\n\\nZur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP-Adresse zu speichern. Diese Informationen werden in der Regel an einen Server von Google in den USA \xfcbertragen und dort gespeichert. Der Anbieter dieser Seite hat keinen Einfluss auf diese Daten\xfcbertragung. Wenn Google Maps aktiviert ist, kann Google zum Zwecke der einheitlichen Darstellung der Schriftarten Google Fonts verwenden. Beim Aufruf von Google Maps l\xe4dt Ihr Browser die ben\xf6tigten Web Fonts in ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.<br /><br />\\n\\nDie Nutzung von Google Maps erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote und an einer leichten Auffindbarkeit der von uns auf der Website angegebenen Orte. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nDie Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://privacy.google.com/businesses/gdprcontrollerterms/\\">Google Controller-Controller Data Protection Terms</a> und <a target=\'_blank\'href=\\"https://privacy.google.com/businesses/gdprcontrollerterms/sccs/\\">https://privacy.google.com/businesses/gdprcontrollerterms/sccs/</a>.<br /><br />\\n\\nMehr Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerkl\xe4rung von Google: <a target=\'_blank\'href=\\"https://policies.google.com/privacy?hl=en\\">Privacy Policy \u2013 Privacy & Terms \u2013 Google</a>.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br />\\n\\n<h3>Bing Maps</h3><br />Wir haben Bing Maps auf dieser Website eingebunden. Anbieter ist die Microsoft Corporation, One Microsoft Way, Redmond, WA 98052-6399, United States (nachfolgend \u201EBing Maps\u201C). Mit Hilfe dieses Dienstes k\xf6nnen wir Kartenmaterial auf unserer Website einbinden.<br /><br />\\n\\nZur Nutzung der Funktionen von Bing Maps ist es notwendig, Ihre IP-Adresse zu speichern. Diese Informationen werden in der Regel an einen Server von Microsoft in den USA \xfcbertragen und dort gespeichert. Der Anbieter dieser Seite hat keinen Einfluss auf diese Daten\xfcbertragung.<br /><br />\\n\\nDie Nutzung von Bing erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote und an einer leichten Auffindbarkeit der von uns auf der Website angegebenen Orte. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nDie Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://learn.microsoft.com/de-de/compliance/regulatory/offering-eu-model-clauses\\">Standardvertragsklauseln der Europ\xe4ischen Union - Microsoft Compliance</a>.<br /><br />\\n\\nWeitere Details entnehmen Sie der Datenschutzerkl\xe4rung des Anbieters unter <a target=\'_blank\'href=\\"https://www.microsoft.com/en-us/maps/bing-maps/product\\">Microsoft Bing Maps Platform APIs Terms Of Use - Microsoft Map Solutions</a>.<br /><br />\\n\\n<h3>Google reCAPTCHA</h3><br />Wir nutzen \u201EGoogle reCAPTCHA\u201C (im Folgenden \u201EreCAPTCHA\u201C) auf dieser Website. Anbieter ist die Google Ireland Limited (\u201EGoogle\u201C), Gordon House, Barrow Street, Dublin 4, Irland.<br /><br />\\n\\nMit reCAPTCHA soll \xfcberpr\xfcft werden, ob die Dateneingabe auf dieser Website (z. B. in einem Kontaktformular) durch einen Menschen oder durch ein automatisiertes Programm erfolgt. Hierzu analysiert reCAPTCHA das Verhalten des Websitebesuchers anhand verschiedener Merkmale. Diese Analyse beginnt automatisch, sobald der Websitebesucher die Website betritt. Zur Analyse wertet reCAPTCHA verschiedene Informationen aus (z. B. IP-Adresse, Verweildauer des Websitebesuchers auf der Website oder vom Nutzer get\xe4tigte Mausbewegungen). Die bei der Analyse erfassten Daten werden an Google weitergeleitet.<br /><br />\\n\\nDie reCAPTCHA-Analysen laufen vollst\xe4ndig im Hintergrund. Websitebesucher werden nicht darauf hingewiesen, dass eine Analyse stattfindet.<br /><br />\\n\\nDie Speicherung und Analyse der Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse daran, seine Webangebote vor missbr\xe4uchlicher automatisierter Aussp\xe4hung und vor SPAM zu sch\xfctzen. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nWeitere Informationen zu Google reCAPTCHA entnehmen Sie den Google-Datenschutzbestimmungen und den Google Nutzungsbedingungen unter folgenden Links: <a target=\'_blank\'href=\\"https://policies.google.com/privacy?hl=en\\">Privacy Policy \u2013 Privacy & Terms \u2013 Google</a> und <a target=\'_blank\'href=\\"https://policies.google.com/terms?hl=en\\">Google Terms of Service \u2013 Privacy & Terms \u2013 Google</a>.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br />\\n\\n<h3>hCaptcha</h3><br />Wir nutzen hCaptcha (im Folgenden \u201EhCaptcha\u201C) auf dieser Website. Anbieter ist die Intuition Machines, Inc., 2211 Selig Drive, Los Angeles, CA 90026, USA (im Folgenden \u201EIMI\u201C).<br /><br />\\n\\nMit hCaptcha soll \xfcberpr\xfcft werden, ob die Dateneingabe auf dieser Website (z. B. in einem Kontaktformular) durch einen Menschen oder durch ein automatisiertes Programm erfolgt. Hierzu analysiert hCaptcha das Verhalten des Websitebesuchers anhand verschiedener Merkmale.<br /><br />\\n\\nDiese Analyse beginnt automatisch, sobald der Websitebesucher eine Website mit aktiviertem hCaptcha betritt. Zur Analyse wertet hCaptcha verschiedene Informationen aus (z. B. IP-Adresse, Verweildauer des Websitebesuchers auf der Website oder vom Nutzer get\xe4tigte Mausbewegungen). Die bei der Analyse erfassten Daten werden an IMI weitergeleitet. Wird hCaptcha im \u201Eunsichtbaren Modus\u201C verwendet, laufen die Analysen vollst\xe4ndig im Hintergrund. Websitebesucher werden nicht darauf hingewiesen, dass eine Analyse stattfindet.<br /><br />\\n\\nDie Speicherung und Analyse der Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse daran, seine Webangebote vor missbr\xe4uchlicher automatisierter Aussp\xe4hung und vor SPAM zu sch\xfctzen. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nDie Datenverarbeitung wird auf Standardvertragsklauseln gest\xfctzt, die in den Datenverarbeitungszusatz zu den Allgemeinen Gesch\xe4ftsbedingungen von IMI bzw. den Datenverarbeitungsvertr\xe4gen enthalten sind.<br /><br />\\n\\nWeitere Informationen zu hCaptcha entnehmen Sie den Datenschutzbestimmungen und Nutzungsbedingungen unter folgenden Links: <a target=\'_blank\'href=\\"https://www.hcaptcha.com/privacy\\">hCaptcha - Privacy Policy</a> und <a target=\'_blank\'href=\\"https://hcaptcha.com/terms\\">hCaptcha - Terms of Service</a>.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/list\\">Data Privacy Framework</a>.<br /><br />"},"eCommerce":{"title":"9. eCommerce und Zahlungsanbieter","content":"<h3>Verarbeiten von Kunden- und Vertragsdaten</h3><br />\\nWir erheben, verarbeiten und nutzen personenbezogene Kunden- und Vertragsdaten zur Begr\xfcndung, inhaltlichen Ausgestaltung und \xc4nderung unserer Vertragsbeziehungen. Personenbezogene Daten \xfcber die Inanspruchnahme dieser Website (Nutzungsdaten) erheben, verarbeiten und nutzen wir nur, soweit dies erforderlich ist, um dem Nutzer die Inanspruchnahme des Dienstes zu erm\xf6glichen oder abzurechnen. Rechtsgrundlage hierf\xfcr ist Art. 6 Abs. 1 lit. b DSGVO.<br /><br />\\n\\nDie erhobenen Kundendaten werden nach Abschluss des Auftrags oder Beendigung der Gesch\xe4ftsbeziehung und Ablauf der ggf. bestehenden gesetzlichen Aufbewahrungsfristen gel\xf6scht. Gesetzliche Aufbewahrungsfristen bleiben unber\xfchrt.<br /><br />\\n\\n<h3>Daten\xad\xfcbermittlung bei Vertragsschluss f\xfcr Online-Shops, H\xe4ndler und Warenversand</h3><br />\\nWenn Sie Waren bei uns bestellen, geben wir Ihre personenbezogenen Daten an das zur Lieferung betraute Transportunternehmen sowie an den mit der Zahlungsabwicklung beauftragten Zahlungsdienstleister weiter. Es werden nur solche Daten herausgegeben, die der jeweilige Dienstleister zur Erf\xfcllung seiner Aufgabe ben\xf6tigt. Rechtsgrundlage hierf\xfcr ist Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten zur Erf\xfcllung eines Vertrags oder vorvertraglicher Ma\xdfnahmen gestattet. Sofern Sie eine entsprechende Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO erteilt haben, werden wir Ihre E-Mail-Adresse an das mit der Lieferung betraute Transportunternehmen \xfcbergeben, damit dieses Sie per E-Mail \xfcber den Versandstatus Ihrer Bestellung informieren kann; Sie k\xf6nnen die Einwilligung jederzeit widerrufen.<br /><br />\\n\\n<h3>Daten\xad\xfcbermittlung bei Vertragsschluss f\xfcr Dienstleistungen und digitale Inhalte</h3><br />\\nWir \xfcbermitteln personenbezogene Daten an Dritte nur dann, wenn dies im Rahmen der Vertragsabwicklung notwendig ist, etwa an das mit der Zahlungsabwicklung beauftragte Kreditinstitut.<br /><br />\\n\\nEine weitergehende \xdcbermittlung der Daten erfolgt nicht bzw. nur dann, wenn Sie der \xdcbermittlung ausdr\xfccklich zugestimmt haben. Eine Weitergabe Ihrer Daten an Dritte ohne ausdr\xfcckliche Einwilligung, etwa zu Zwecken der Werbung, erfolgt nicht.<br /><br />\\n\\nGrundlage f\xfcr die Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten zur Erf\xfcllung eines Vertrags oder vorvertraglicher Ma\xdfnahmen gestattet.<br /><br />\\n\\n<h3>Bonit\xe4tspr\xfcfungen</h3><br />\\nBei einem Kauf auf Rechnung oder einer sonstigen Zahlungsart, bei der wir in Vorleistung gehen, k\xf6nnen wir eine Bonit\xe4tspr\xfcfung Verfahren durchf\xfchren (Scoring). Hierzu \xfcbermitteln wir Ihre eingegebenen Daten (z. B. Name, Adresse, Alter oder Bankdaten) an eine Auskunftei. Auf Grundlage dieser Daten wird die Wahrscheinlichkeit eines Zahlungsausfalls ermittelt. Bei einem \xfcberh\xf6hten Zahlungsausfallrisiko k\xf6nnen wir die betreffende Zahlungsart verweigern.<br /><br />Die Bonit\xe4tspr\xfcfung erfolgt auf Grundlage zur Vertragserf\xfcllung (Art. 6 Abs. 1 lit. b DSGVO) sowie zur Vermeidung von Zahlungsausf\xe4llen (berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO). Sofern eine Einwilligung eingeholt wurde, erfolgt die Bonit\xe4tspr\xfcfung auf Grundlage dieser Einwilligung (Art. 6 Abs. 1 lit. DSGVO); die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\n<h3>Zahlungsdienste</h3><br />\\nWir binden Zahlungsdienste von Drittunternehmen auf unserer Website ein. Wenn Sie einen Kauf bei uns t\xe4tigen, werden Ihre Zahlungsdaten (z. B. Name, Zahlungssumme, Kontoverbindung, Kreditkartennummer) vom Zahlungsdienstleister zum Zwecke der Zahlungsabwicklung verarbeitet. F\xfcr diese Transaktionen gelten die jeweiligen Vertrags- und Datenschutzbestimmungen der jeweiligen Anbieter. Der Einsatz der Zahlungsdienstleister erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragsabwicklung) sowie im Interesse eines m\xf6glichst reibungslosen, komfortablen und sicheren Zahlungsvorgangs (Art. 6 Abs. 1 lit. f DSGVO). Soweit f\xfcr bestimmte Handlungen Ihre Einwilligung abgefragt wird, ist Art. 6 Abs. 1 lit. a DSGVO Rechtsgrundlage der Datenverarbeitung; Einwilligungen sind jederzeit f\xfcr die Zukunft widerrufbar.<br /><br />\\n\\nFolgende Zahlungsdienste / Zahlungsdienstleister setzen wir im Rahmen dieser Website ein::<br /><br />\\n\\n<b>PayPal</b><br />\\nAnbieter dieses Zahlungsdienstes ist PayPal (Europe) S.\xe0.r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg (im Folgenden \u201EPayPal\u201C).<br /><br />\\n\\nDie Daten\xfcbertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest\xfctzt. Details finden Sie hier: <a target=\'_blank\'href=\\"https://www.paypal.com/de/webapps/mpp/ua/pocpsa-full\\">PayPal</a>.<br /><br />\\n\\nDetails entnehmen Sie der Datenschutzerkl\xe4rung von PayPal: <a target=\'_blank\'href=\\"https://www.paypal.com/de/webapps/mpp/ua/privacy-full\\">PayPal-Datenschutzerkl\xe4rung</a>.<br /><br />"},"conferenceTools":{"title":"10. Audio- und Videokonferenzen","content":"<h3>Datenverarbeitung</h3><br />\\nF\xfcr die Kommunikation mit unseren Kunden setzen wir unter anderen Online-Konferenz-Tools ein. Die im Einzelnen von uns genutzten Tools sind unten aufgelistet. Wenn Sie mit uns per Video- oder Audiokonferenz via Internet kommunizieren, werden Ihre personenbezogenen Daten von uns und dem Anbieter des jeweiligen Konferenz-Tools erfasst und verarbeitet.<br /><br />\\n\\nDie Konferenz-Tools erfassen dabei alle Daten, die Sie zur Nutzung der Tools bereitstellen/einsetzen (E-Mail-Adresse und/oder Ihre Telefonnummer). Ferner verarbeiten die Konferenz-Tools die Dauer der Konferenz, Beginn und Ende (Zeit) der Teilnahme an der Konferenz, Anzahl der Teilnehmer und sonstige \u201EKontextinformationen\u201C im Zusammenhang mit dem Kommunikationsvorgang (Metadaten).<br /><br />\\n\\nDes Weiteren verarbeitet der Anbieter des Tools alle technischen Daten, die zur Abwicklung der Online-Kommunikation erforderlich sind. Dies umfasst insbesondere IP-Adressen, MAC-Adressen, Ger\xe4te-IDs, Ger\xe4tetyp, Betriebssystemtyp und -version, Client-Version, Kameratyp, Mikrofon oder Lautsprecher sowie die Art der Verbindung.<br /><br />\\n\\nSofern innerhalb des Tools Inhalte ausgetauscht, hochgeladen oder in sonstiger Weise bereitgestellt werden, werden diese ebenfalls auf den Servern der Tool-Anbieter gespeichert. Zu solchen Inhalten z\xe4hlen insbesondere Cloud-Aufzeichnungen, Chat-/ Sofortnachrichten, Voicemails hochgeladene Fotos und Videos, Dateien, Whiteboards und andere Informationen, die w\xe4hrend der Nutzung des Dienstes geteilt werden.<br /><br />\\n\\nBitte beachten Sie, dass wir nicht vollumf\xe4nglich Einfluss auf die Datenverarbeitungsvorg\xe4nge der verwendeten Tools haben. Unsere M\xf6glichkeiten richten sich ma\xdfgeblich nach der Unternehmenspolitik des jeweiligen Anbieters. Weitere Hinweise zur Datenverarbeitung durch die Konferenztools entnehmen Sie den Datenschutzerkl\xe4rungen der jeweils eingesetzten Tools, die wir unter diesem Text aufgef\xfchrt haben.<br /><br />\\n\\n<h3>Zweck und Rechtsgrundlagen</h3><br />\\nDie Konferenz-Tools werden genutzt, um mit angehenden oder bestehenden Vertragspartnern zu kommunizieren oder bestimmte Leistungen gegen\xfcber unseren Kunden anzubieten (Art. 6 Abs. 1 lit. b DSGVO). Des Weiteren dient der Einsatz der Tools der allgemeinen Vereinfachung und Beschleunigung der Kommunikation mit uns bzw. unserem Unternehmen (berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO). Soweit eine Einwilligung abgefragt wurde, erfolgt der Einsatz der betreffenden Tools auf Grundlage dieser Einwilligung; die Einwilligung ist jederzeit mit Wirkung f\xfcr die Zukunft widerrufbar.<br /><br />\\n\\n<h3>Speicherdauer</h3><br />\\nDie unmittelbar von uns \xfcber die Video- und Konferenz-Tools erfassten Daten werden von unseren Systemen gel\xf6scht, sobald Sie uns zur L\xf6schung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck f\xfcr die Datenspeicherung entf\xe4llt. Gespeicherte Cookies verbleiben auf Ihrem Endger\xe4t, bis Sie sie l\xf6schen. Zwingende gesetzliche Aufbewahrungsfristen bleiben unber\xfchrt.<br /><br />\\n\\nAuf die Speicherdauer Ihrer Daten, die von den Betreibern der Konferenz-Tools zu eigenen Zwecken gespeichert werden, haben wir keinen Einfluss. F\xfcr Einzelheiten dazu informieren Sie sich bitte direkt bei den Betreibern der Konferenz-Tools.<br /><br />\\n\\n<h3>Eingesetzte Konferenz-Tools</h3><br />\\nWir setzen folgende Konferenz-Tools ein:<br /><br />\\n\\n<h3>Google Meet</h3><br />\\nWir nutzen Google Meet. Anbieter ist die Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Details zur Datenverarbeitung entnehmen Sie der Datenschutzerkl\xe4rung von Google: <a target=\'_blank\'href=\\"https://policies.google.com/privacy?hl=en\\">Datenschutzerkl\xe4rung \u2013 Datenschutzerkl\xe4rung & Nutzungsbedingungen \u2013 Google</a>.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br />\\n\\n<h3>Auftragsverarbeitung</h3><br />\\nWir haben einen Vertrag \xfcber Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gew\xe4hrleistet, dass dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.<br /><br />"},"customServices":{"title":"11. Eigene Dienste","content":"<h3>Google Drive</h3><br />\\nWir haben Google Drive auf dieser Website eingebunden. Anbieter ist die Google Ireland Limited (\u201EGoogle\u201C), Gordon House, Barrow Street, Dublin 4, Irland.<br /><br />\\n\\nGoogle Drive erm\xf6glicht es uns, einen Uploadbereich auf unserer Website einzubinden, in dem Sie Inhalte hochladen k\xf6nnen. Wenn Sie Inhalte hochladen, werden diese auf den Servern von Google Drive gespeichert. Wenn Sie unsere Website betreten, wird au\xdferdem eine Verbindung zu Google Drive aufgebaut, sodass Google Drive feststellen kann, dass Sie unsere Website besucht haben.<br /><br />\\n\\nDie Verwendung von Google Drive erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an einem zuverl\xe4ssigen Uploadbereich auf seiner Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die Einwilligung ist jederzeit widerrufbar.<br /><br />\\n\\nDas Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u201EEU-US Data Privacy Framework\u201C (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: <a target=\'_blank\'href=\\"https://www.dataprivacyframework.gov/participant/5780\\">Data Privacy Framework</a>.<br /><br />\\n\\n<h3>Auftragsverarbeitung</h3><br />\\nWir haben einen Vertrag \xfcber Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gew\xe4hrleistet, dass dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.<br /><br />"}},"terms&condition":{"title":"AGB","generalCondition":{"title":"","content":"Allgemeine Gesch\xe4ftsbedingungen\\nf\xfcr den Online-Shop unter der URL\\n<a href=\\"https://www.cyberalarm.training\\">https://www.cyberalarm.training</a>\\nbetrieben von\\nGamebook Studio HQ GmbH Wilhelm-Kabus-Strasse 77 10829 BerlinGermany\\n\\nim Folgenden: Anbieter -\\n\\n"},"scope":{"title":"1. Geltungsbereich","content":"Diese Allgemeinen Gesch\xe4ftsbedingungen (AGB) gelten nach ihrer Einbeziehung f\xfcr alle Vertragsschl\xfcsse \xfcber den Erwerb von Waren, Dienstleistungen oder sonstigen G\xfctern (nachfolgend \u201EWaren\u201D) im Online-Shop unter der o.g. URL in ihrer zum Zeitpunkt des Vertragsschlusses g\xfcltigen Fassung. Diese AGB gelten ausschlie\xdflich. Abweichende AGB des Kunden werden nicht Vertragsbestandteil, es sei denn, der Anbieter stimmt diesen ausdr\xfccklich zu.<br /><br />"},"conclusion":{"title":"2. Vertragsschluss","content":"<b>2.1</b> Die Angebote im Online-Shop stellen eine unverbindliche Aufforderung des Anbieters an die Online-Shop-Besucher zur Abgabe eines Angebots zum Erwerb der im Shop angebotenen Waren dar.\\n<br /><br /><b>2.2</b> Die Bestellung der Ware(n) erfolgt \xfcber das Online-Bestellformular des Anbieters. Nach der Auswahl der gew\xfcnschten Ware(n), der Eingabe aller abgefragten Pflichtinformationen und dem Durchlaufen aller anderen verpflichtenden Schritte im Bestellprozess, k\xf6nnen die ausgew\xe4hlten Waren durch das Bet\xe4tigen des Bestell-Buttons am Ende der Checkout-Seite bestellt werden (Bestellung). Durch die Bestellung gibt der Kunde ein verbindliches Vertragsangebot zum Erwerb der ausgew\xe4hlten Ware(n) ab. Der Vertragsschluss erfolgt, indem der Anbieter das Angebot des Kunden annimmt. Die Annahme erfolgt, indem der Anbieter den Vertragsschluss in Schrift- oder Textform (z. B. per E-Mail) best\xe4tigt (Auftragsbest\xe4tigung) und diese Auftragsbest\xe4tigung dem Kunden zugeht oder indem er die bestellte Ware liefert und diese Ware dem Kunden zugeht oder indem er den Kunden zur Zahlung auffordert (z. B. Rechnung oder Kreditkartenzahlung im Bestellprozess) und die Zahlungsaufforderung dem Kunden zugeht; ma\xdfgeblich f\xfcr den Zeitpunkt des Vertragsschlusses ist dabei der Zeitpunkt, in dem eine der im ersten Halbsatz genannten Alternativen erstmalig eintritt.\\n<br /><b>2.3</b> Vor verbindlicher Abgabe der Bestellung \xfcber das Online-Bestellformular des Anbieters kann der Kunde seine Eingaben \xfcberpr\xfcfen und jederzeit \xfcber die \xfcblichen Tastatur-, Maus-, Touch- oder sonstigen zur Verf\xfcgung stehenden Eingabefunktionen korrigieren. Dar\xfcber hinaus werden alle Eingaben vor der verbindlichen Abgabe der Bestellung noch einmal in einem Best\xe4tigungsfenster angezeigt und k\xf6nnen auch dort mittels der \xfcblichen Tastatur-, Maus-, Touch- oder sonstigen zur Verf\xfcgung stehende Eingabefunktionen korrigiert werden.\\n<br /><b>2.4</b> Der Anbieter wird den Vertragstext nach dem Vertragsschluss speichern und dem Kunden in Textform (z. B. per E-Mail) \xfcbermitteln. Eine dar\xfcberhinausgehende Zug\xe4nglichmachung des Vertragstexts durch den Anbieter erfolgt nicht. Sofern der Einkauf \xfcber ein Kundenkonto im Online-Shop erfolgt ist, kann der Kunde seine Bestellungen und die damit verbundenen Bestelldaten dort einsehen.\\n<br /><b>2.5</b> F\xfcr den Vertragsschluss stehen folgende Sprachen zur Verf\xfcgung: Deutsch, Englisch"},"withdrawal":{"title":"3. Widerrufsrecht f\xfcr Verbraucher","content":"Verbrauchern steht bei au\xdferhalb von Gesch\xe4ftsr\xe4umen geschlossenen Vertr\xe4gen und bei Fernabsatzvertr\xe4gen grunds\xe4tzlich ein Widerrufsrecht zu. Verbraucher ist jede nat\xfcrliche Person, die ein Rechtsgesch\xe4ft zu Zwecken abschlie\xdft, die \xfcberwiegend weder ihrer gewerblichen noch ihrer selbstst\xe4ndigen beruflichen T\xe4tigkeit zugerechnet werden k\xf6nnen. Details sind der Widerrufsbelehrung zu entnehmen, die jedem Verbraucher sp\xe4testens unmittelbar vor Vertragsschluss zur Verf\xfcgung gestellt wird.\\n\\n"},"defaultPayment":{"title":"4. Zahlung, Verzug","content":"<b>4.1</b> Es gelten die zum Zeitpunkt der Bestellung im Online-Shop aufgef\xfchrten Preise. Alle Preise gelten inklusive der gesetzlichen Mehrwertsteuer sowie zuz\xfcglich der gegebenenfalls aufgef\xfchrten Versandkosten. \xdcber die zur Verf\xfcgung stehenden Zahlungsm\xf6glichkeiten wird der Kunde im Online-Shop des Anbieters informiert.\\n<br /><b>4.2</b> Ist \u201EVorkasse\u201D vereinbart wird der Kaufpreis sofort nach Vertragsabschluss f\xe4llig.\\n<br /><b>4.3</b> Ist \u201EKauf auf Rechnung/Rechnungskauf\u201D vereinbart, ist die Zahlung sofort nach Vertragsabschluss f\xe4llig, es sei denn, dass in der Rechnung oder im Kaufprozess ein anderes Zahlungsziel angegeben wurde.\\n<br /><b>4.4</b> Ist die Zahlung via \u201EPayPal\u201D vereinbart, wird der Kaufpreis sofort nach Vertragsabschluss f\xe4llig. Die Zahlungsabwicklung erfolgt \xfcber den Zahlungsdienstleister PayPal (Europe) S.\xe0 r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg."},"retention":{"title":"5. Eigentumsvorbehalt","content":"Die gekaufte Ware bleibt bis zur vollst\xe4ndigen Bezahlung des Kaufpreises Eigentum des Anbieters."},"delivery":{"title":"6. Lieferung und Selbstbelieferungsvorbehalt","content":"<b>6.1</b> Vorbehaltlich abweichender Vereinbarungen erfolgt die Lieferung innerhalb der im Online-Shop angegebenen Lieferzeit an die vom Kunden angegebene Lieferadresse. Die geltenden Lieferzeiten sind dem Online-Shop zu entnehmen.\\n<br /><b>6.2</b> Eine Selbstabholung der erworbenen Waren ist ausgeschlossen.\\n<br /><b>6.3</b> Wenn der Anbieter die bestellte Ware nicht liefern kann, weil er ohne eigenes Verschulden selbst nicht beliefert wurde, obwohl er rechtzeitig mit einem zuverl\xe4ssigen Lieferanten ein kongruentes Deckungsgesch\xe4ft abgeschlossen hat, wird der Anbieter von seiner Leistungspflicht frei und kann vom Vertrag zur\xfccktreten. Der Anbieter ist verpflichtet, den Kunden unverz\xfcglich \xfcber die Unm\xf6glichkeit der Leistungserf\xfcllung in Kenntnis zu setzen. Bereits erbrachte Gegenleistungen des Vertragspartners werden diesem unverz\xfcglich erstattet. Zwingendes Verbraucherrecht bleibt vom vorliegenden Absatz unber\xfchrt."},"warranty":{"title":"7. Gew\xe4hrleistung","content":"Es gelten die Vorschriften der gesetzlichen M\xe4ngelhaftung."},"liability":{"title":"8. Haftung","content":"<b>8.1</b> Der Anbieter haftet unbeschr\xe4nkt:<br /><style>ul {list-style-type: disc; padding-left: 20px;}</style><ul>\\n<li>f\xfcr Sch\xe4den aus der Verletzung des Lebens, des K\xf6rpers oder der Gesundheit, die auf einer vors\xe4tzlichen oder fahrl\xe4ssigen Pflichtverletzung des Anbieters oder einer vors\xe4tzlichen oder fahrl\xe4ssigen Pflichtverletzung eines gesetzlichen Vertreters oder Erf\xfcllungsgehilfen des Anbieters beruhen;</li>\\n<li>f\xfcr Sch\xe4den, die auf einer vors\xe4tzlichen oder grob fahrl\xe4ssigen Pflichtverletzung des Anbieters oder auf einer vors\xe4tzlichen oder grob fahrl\xe4ssigen Pflichtverletzung eines gesetzlichen Vertreters oder Erf\xfcllungsgehilfen des Anbieters beruhen;</li>\\n<li>aufgrund eines Garantieversprechens, soweit diesbez\xfcglich keine andere Regelung getroffen wurde;</li>\\n<li>aufgrund zwingender Haftung (z. B. nach dem Produkthaftungsgesetz)</li>\\n</ul><br />\\n<b>8.2</b> Wenn der Anbieter fahrl\xe4ssig eine wesentliche Vertragspflicht verletzt, ist dessen Haftung auf den vertragstypischen, vorhersehbaren Schaden beschr\xe4nkt, sofern nicht gem\xe4\xdf vorstehendem Absatz unbeschr\xe4nkt gehaftet wird. Wesentliche Vertragspflichten sind Pflichten, die der Vertrag dem Anbieter nach seinem Inhalt zur Erreichung des Vertragszwecks auferlegt, deren Erf\xfcllung die ordnungsgem\xe4\xdfe Durchf\xfchrung des Vertrags \xfcberhaupt erst erm\xf6glicht und auf deren Einhaltung der Kunde regelm\xe4\xdfig vertrauen darf.<br /><br />\\n<b>8.3</b> Im \xdcbrigen ist eine Haftung des Anbieters sowie die Haftung seiner Erf\xfcllungsgehilfen und gesetzlichen Vertreter ausgeschlossen.\\n"},"dataProtection":{"title":"9. Datenschutz","content":"Der Anbieter behandelt die personenbezogenen Daten seiner Kunden vertraulich und im Einklang mit den gesetzlichen Datenschutzvorschriften. N\xe4heres entnehmen Sie der Datenschutzerkl\xe4rung des Anbieters."},"final":{"title":"10. Schlussbestimmungen","content":"<b>10.1</b> Anwendbar ist das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts, soweit diese Rechtswahl nicht dazu f\xfchrt, dass ein Verbraucher mit gew\xf6hnlichem Aufenthalt in der EU hierdurch zwingenden gesetzlichen Bestimmungen des Rechts seines Aufenthaltsstaates entzogen wird.\\n<br /><b>10.2</b> Ist der Kunde Kaufmann, juristische Person des \xf6ffentlichen Rechts oder \xf6ffentlich-rechtliches Sonderverm\xf6gen, ist das Gericht am Sitz des Anbieters zust\xe4ndig, sofern nicht f\xfcr die Streitigkeit ein ausschlie\xdflicher Gerichtsstand begr\xfcndet ist. Dies gilt auch, wenn der Kunde keinen Wohnsitz innerhalb der Europ\xe4ischen Union hat. Der Sitz unseres Unternehmens ist der \xdcberschrift dieser AGB zu entnehmen.\\n<br /><b>10.3</b> Soweit eine Bestimmung dieses Vertrages ung\xfcltig oder undurchsetzbar ist oder wird, bleiben die \xfcbrigen Bestimmungen dieses Vertrages hiervon unber\xfchrt."},"disputeResolution":{"title":"11. Informationen zur Online-Streitbeilegung / Verbraucherschlichtung","content":"Die EU-Kommission stellt im Internet unter folgendem Link eine Plattform zur Online-Streitbeilegung bereit: <a href=\\"https://ec.europa.eu/consumers/odr\\">Online Dispute Resolution  European Commission</a>.\\n<br />Der Anbieter ist nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.\\n<br />Unsere E-Mail-Adresse entnehmen Sie der \xdcberschrift dieser AGB."}},"passwordValidator":{"minLength":"Das Passwort muss mindestens 8 Zeichen lang sein.","maxLength":"Das Passwort darf nicht l\xe4nger als 128 Zeichen sein.","lowercase":"Das Passwort muss mindestens einen Kleinbuchstaben enthalten.","uppercase":"Das Passwort muss mindestens einen Gro\xdfbuchstaben enthalten.","containNumber":"Das Passwort muss mindestens eine Zahl enthalten.","specialCharacter":"Das Passwort muss mindestens ein Sonderzeichen enthalten.","passwordRequired":"Das Passwort ist ein Pflichtfeld","emailRequired":"E-Mail ist ein Pflichtfeld","passwordMatch":"Das Passwort muss \xfcbereinstimmen","emailMatch":"E-Mail muss \xfcbereinstimmen","emailValid":"Die E-Mail-Adresse muss eine g\xfcltige E-Mail-Adresse sein"},"cookieConsent":{"consentModal":{"label":"Einwilligungsfenster","title":"Einwilligungsfenster","description":"Mit einem Klick auf \\"<b>Alle akzeptieren</b>\\" stimmen Sie der Verwendung aller Cookies zu.</br>Mit einem Klick auf \\"<b>Alle ablehnen</b>\\" werden nur essenzielle Cookies verwendet.","acceptAllBtn":"Alle akzeptieren","acceptNecessaryBtn":"Alle ablehnen","showPreferencesBtn":"Einstellungen verwalten","closeIconLabel":"Close","footer":"Weitere Informationen finden Sie in unserer </br><a target=\'_blank\'href=\\"https://www.cyberalarm.training/de/privacy-policy\\">Datenschutzerkl\xe4rung</a>"},"preferencesModal":{"title":"Cookie-Einstellungen","acceptAllBtn":"Alle akzeptieren","acceptNecessaryBtn":"Alle ablehnen","savePreferencesBtn":"Einstellungen speichern","closeIconLabel":"Schlie\xdfen","sections":[{"title":"Verwendung von Cookies","description":"Wir verwenden Cookies, um Ihre Nutzung unserer Website zu verbessern. Einige Cookies sind essenziell, damit die Website funktioniert (z. B. Sitzungs-Cookies und PayPal-Cookies). Andere, wie Google Analytics-Cookies, helfen uns, die Website zu analysieren und zu verbessern."},{"title":"Unbedingt notwendige Cookies","description":"Diese Cookies sind f\xfcr das ordnungsgem\xe4\xdfe Funktionieren meiner Website unerl\xe4sslich...","linkedCategory":"necessary"},{"title":"Performance und Analyse","description":"Diese Cookies sammeln Informationen \xfcber die Art und Weise der Nutzung dieser Webseite. Alle Daten sind anonymisiert und k\xf6nnen nicht mit jemandem in Verbindung gebracht werden.","linkedCategory":"analytics"},{"title":"Marketing und Werbung","description":"Diese Cookies erm\xf6glichen es uns und unseren Partnern (Google Ads, LinkedIn, Meta), zielgerichtete Werbung zu schalten und die Effektivit\xe4t der Kampagnen zu messen.","linkedCategory":"marketing"},{"title":"Weitere Informationen","description":"Bei Fragen zu unserer Cookie-Richtlinie und Ihren Auswahlm\xf6glichkeiten..."}]}},"contact":{"contactForm":{"header":"Kontaktieren Sie uns","labels":{"email":"Email","confirmEmail":"Best\xe4tigen Sie Ihre E-Mail Adresse","name":"Name","helpType":"Wobei k\xf6nnen wir Ihnen helfen?","subject":"Thema","message":"Mitteilung"},"options":{"sales":"Zahlung, Rechnung, ...","help":"Generelle Hilfe","info":"Informationen","account":"Mein Account","feedback":"Feedback","other":"Anderes"},"successMessage":"E-Mail erfolgreich gesendet, unser Support-Team wird sich in K\xfcrze bei Ihnen melden.","submit":"Senden"}}}');

});



parcelRegister("ynPL8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0675a9fdebce3e2f$export$2e2bcd8739ae039);
let $0675a9fdebce3e2f$var$script;



let $0675a9fdebce3e2f$var$initialize = ()=>{
    $0675a9fdebce3e2f$var$script = (parcelRequire("gpUOO"));
    if ($0675a9fdebce3e2f$var$script.__esModule) $0675a9fdebce3e2f$var$script = $0675a9fdebce3e2f$var$script.default;
    $0675a9fdebce3e2f$var$script.render = (parcelRequire("jQsHv")).render;
    (parcelRequire("hfeDy")).default($0675a9fdebce3e2f$var$script);
    $0675a9fdebce3e2f$var$script.__scopeId = "data-v-d18839";
    $0675a9fdebce3e2f$var$script.__file = "LoginView.vue";
};
$0675a9fdebce3e2f$var$initialize();
var $0675a9fdebce3e2f$export$2e2bcd8739ae039 = $0675a9fdebce3e2f$var$script;

});
parcelRegister("gpUOO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bf3b0e252c15063c$export$2e2bcd8739ae039);

var $jFUWD = parcelRequire("jFUWD");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $fRZwI = parcelRequire("fRZwI");

var $hEJWZ = parcelRequire("hEJWZ");

var $73mM4 = parcelRequire("73mM4");

var $ey2ik = parcelRequire("ey2ik");
var $kheUU = parcelRequire("kheUU");

var $1rS06 = parcelRequire("1rS06");

var $580JV = parcelRequire("580JV");

var $5lCi4 = parcelRequire("5lCi4");

var $1F5z6 = parcelRequire("1F5z6");

var $26BmW = parcelRequire("26BmW");

var $gQLqr = parcelRequire("gQLqr");

var $kW7Vr = parcelRequire("kW7Vr");

var $ifZB1 = parcelRequire("ifZB1");

var $gzF45 = parcelRequire("gzF45");
var $bf3b0e252c15063c$export$2e2bcd8739ae039 = {
    __name: "LoginView",
    setup (__props, { expose: __expose }) {
        __expose();
        const { t: t } = (0, $jFUWD.useI18n)();
        const homeNavigation = (0, $580JV.default).i18nRoute({
            name: "home"
        });
        const validationSchema = (0, $01W3b.markRaw)((0, $hEJWZ.object)({
            email: (0, $hEJWZ.string)().required(t("passwordValidator.emailRequired")).email(t("passwordValidator.emailValid")).label(t("loginView.email")),
            password: (0, $hEJWZ.string)().required(t("passwordValidator.passwordRequired")).label(t("loginView.password"))
        }));
        const { defineField: defineField, handleSubmit: handleSubmit } = (0, $fRZwI.useForm)({
            validationSchema: validationSchema
        });
        const [email, emailAttrs] = defineField("email");
        const [password, passwordAttrs] = defineField("password");
        // eslint-disable-next-line no-return-assign
        (0, $TusQn.watch)(email, (newVal)=>newVal !== newVal?.toLowerCase() && (email.value = newVal?.toLowerCase()));
        const userMessage = (0, $01W3b.ref)("");
        const pricingRoute = (0, $580JV.default).i18nRoute({
            name: "home",
            hash: "#pricing"
        });
        const resetPasswordRoute = (0, $580JV.default).i18nRoute({
            name: "reset-password"
        });
        const { getUserStateFromEndpoint: loginGetUserState, isLoading: isLoading, userFriendlyErrorSalt: userFriendlyErrorSalt, userFriendlyErrorLogin: userFriendlyErrorLogin } = (0, $gQLqr.useUserStateFromEndpoint)();
        const clearUserMessages = ()=>{
            userMessage.value = "";
            userFriendlyErrorSalt.value = "";
            userFriendlyErrorLogin.value = "";
        };
        // eslint-disable-next-line max-len
        const { currentEmployees: currentEmployees, userState: userState, currentCourses: currentCourses, isAuthenticated: isAuthenticated, resetUserState: resetUserState } = (0, $1rS06.useGlobalState)();
        const doLogin = handleSubmit(async (values)=>{
            clearUserMessages();
            (0, $ifZB1.trackEvent)("login_attempt", {
                event_category: "Login",
                event_label: "Attempt login"
            });
            try {
                const userStateFromEndpoint = await loginGetUserState(values.email, values.password);
                if ((0, $kheUU.default)(userStateFromEndpoint)) throw new Error("UserState is empty");
                userState.value = (0, $ey2ik.default)("isAuthenticated", true, userStateFromEndpoint);
                currentEmployees.value = userStateFromEndpoint.employees;
                currentCourses.set(userStateFromEndpoint.courses);
                (0, $ifZB1.trackEvent)("login_success", {
                    event_category: "Login",
                    event_label: "Successful login"
                });
                await (0, $26BmW.goToHomeScreenFor)((0, $01W3b.unref)(userState));
            } catch (e) {
                (0, $ifZB1.trackEvent)("login_failed", {
                    event_category: "Login",
                    event_label: "Incorrect credentials"
                });
                userMessage.value = t("loginView.wrongCredentials");
                if ((0, $gzF45.isLocalDevMode)()) console.error(e);
            }
        });
        (0, $TusQn.onBeforeMount)(async ()=>{
            if (!isAuthenticated()) return;
            resetUserState();
            await (0, $26BmW.goToHomeScreenFor)((0, $01W3b.unref)(userState));
        });
        const __returned__ = {
            t: t,
            homeNavigation: homeNavigation,
            validationSchema: validationSchema,
            defineField: defineField,
            handleSubmit: handleSubmit,
            email: email,
            emailAttrs: emailAttrs,
            password: password,
            passwordAttrs: passwordAttrs,
            userMessage: userMessage,
            pricingRoute: pricingRoute,
            resetPasswordRoute: resetPasswordRoute,
            loginGetUserState: loginGetUserState,
            isLoading: isLoading,
            userFriendlyErrorSalt: userFriendlyErrorSalt,
            userFriendlyErrorLogin: userFriendlyErrorLogin,
            clearUserMessages: clearUserMessages,
            currentEmployees: currentEmployees,
            userState: userState,
            currentCourses: currentCourses,
            isAuthenticated: isAuthenticated,
            resetUserState: resetUserState,
            doLogin: doLogin,
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            markRaw: $01W3b.markRaw,
            onBeforeMount: $TusQn.onBeforeMount,
            ref: $01W3b.ref,
            unref: $01W3b.unref,
            watch: $TusQn.watch,
            get ErrorMessage () {
                return 0, $fRZwI.ErrorMessage;
            },
            get useForm () {
                return 0, $fRZwI.useForm;
            },
            get object () {
                return 0, $hEJWZ.object;
            },
            get string () {
                return 0, $hEJWZ.string;
            },
            get RouterLink () {
                return 0, $73mM4.RouterLink;
            },
            get assoc () {
                return 0, $ey2ik.default;
            },
            get isEmpty () {
                return 0, $kheUU.default;
            },
            get useGlobalState () {
                return 0, $1rS06.useGlobalState;
            },
            get Trans () {
                return 0, $580JV.default;
            },
            GamebookLogo: $5lCi4.default,
            InPlaceAlert: $1F5z6.default,
            get goToHomeScreenFor () {
                return 0, $26BmW.goToHomeScreenFor;
            },
            get useUserStateFromEndpoint () {
                return 0, $gQLqr.useUserStateFromEndpoint;
            },
            WithLoader: $kW7Vr.default,
            get trackEvent () {
                return 0, $ifZB1.trackEvent;
            },
            get isLocalDevMode () {
                return 0, $gzF45.isLocalDevMode;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("fRZwI", function(module, exports) {

$parcel$export(module.exports, "useForm", () => $b8db88280711b5c9$export$87c0cf8eb5a167e0);
$parcel$export(module.exports, "ErrorMessage", () => $b8db88280711b5c9$export$915e9e7bd4f0f96d);
/**
  * vee-validate v4.12.8
  * (c) 2024 Abdelrahman Awad
  * @license MIT
  */ parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $j6G8F = parcelRequire("j6G8F");
function $b8db88280711b5c9$var$isCallable(fn) {
    return typeof fn === "function";
}
function $b8db88280711b5c9$var$isNullOrUndefined(value) {
    return value === null || value === undefined;
}
const $b8db88280711b5c9$var$isObject = (obj)=>obj !== null && !!obj && typeof obj === "object" && !Array.isArray(obj);
function $b8db88280711b5c9$var$isIndex(value) {
    return Number(value) >= 0;
}
function $b8db88280711b5c9$var$toNumber(value) {
    const n = parseFloat(value);
    return isNaN(n) ? value : n;
}
function $b8db88280711b5c9$var$isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
function $b8db88280711b5c9$var$getTag(value) {
    if (value == null) return value === undefined ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}
// Reference: https://github.com/lodash/lodash/blob/master/isPlainObject.js
function $b8db88280711b5c9$var$isPlainObject(value) {
    if (!$b8db88280711b5c9$var$isObjectLike(value) || $b8db88280711b5c9$var$getTag(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    let proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}
function $b8db88280711b5c9$var$merge(target, source) {
    Object.keys(source).forEach((key)=>{
        if ($b8db88280711b5c9$var$isPlainObject(source[key]) && $b8db88280711b5c9$var$isPlainObject(target[key])) {
            if (!target[key]) target[key] = {};
            $b8db88280711b5c9$var$merge(target[key], source[key]);
            return;
        }
        target[key] = source[key];
    });
    return target;
}
/**
 * Constructs a path with dot paths for arrays to use brackets to be compatible with vee-validate path syntax
 */ function $b8db88280711b5c9$var$normalizeFormPath(path) {
    const pathArr = path.split(".");
    if (!pathArr.length) return "";
    let fullPath = String(pathArr[0]);
    for(let i = 1; i < pathArr.length; i++){
        if ($b8db88280711b5c9$var$isIndex(pathArr[i])) {
            fullPath += `[${pathArr[i]}]`;
            continue;
        }
        fullPath += `.${pathArr[i]}`;
    }
    return fullPath;
}
const $b8db88280711b5c9$var$RULES = {};
/**
 * Adds a custom validator to the list of validation rules.
 */ function $b8db88280711b5c9$export$916987460846b635(id, validator) {
    // makes sure new rules are properly formatted.
    $b8db88280711b5c9$var$guardExtend(id, validator);
    $b8db88280711b5c9$var$RULES[id] = validator;
}
/**
 * Gets an already defined rule
 */ function $b8db88280711b5c9$var$resolveRule(id) {
    return $b8db88280711b5c9$var$RULES[id];
}
/**
 * Guards from extension violations.
 */ function $b8db88280711b5c9$var$guardExtend(id, validator) {
    if ($b8db88280711b5c9$var$isCallable(validator)) return;
    throw new Error(`Extension Error: The validator '${id}' must be a function.`);
}
function $b8db88280711b5c9$var$set(obj, key, val) {
    if (typeof val.value === "object") val.value = $b8db88280711b5c9$var$klona(val.value);
    if (!val.enumerable || val.get || val.set || !val.configurable || !val.writable || key === "__proto__") Object.defineProperty(obj, key, val);
    else obj[key] = val.value;
}
function $b8db88280711b5c9$var$klona(x) {
    if (typeof x !== "object") return x;
    var i = 0, k, list, tmp, str = Object.prototype.toString.call(x);
    if (str === "[object Object]") tmp = Object.create(x.__proto__ || null);
    else if (str === "[object Array]") tmp = Array(x.length);
    else if (str === "[object Set]") {
        tmp = new Set;
        x.forEach(function(val) {
            tmp.add($b8db88280711b5c9$var$klona(val));
        });
    } else if (str === "[object Map]") {
        tmp = new Map;
        x.forEach(function(val, key) {
            tmp.set($b8db88280711b5c9$var$klona(key), $b8db88280711b5c9$var$klona(val));
        });
    } else if (str === "[object Date]") tmp = new Date(+x);
    else if (str === "[object RegExp]") tmp = new RegExp(x.source, x.flags);
    else if (str === "[object DataView]") tmp = new x.constructor($b8db88280711b5c9$var$klona(x.buffer));
    else if (str === "[object ArrayBuffer]") tmp = x.slice(0);
    else if (str.slice(-6) === "Array]") // ArrayBuffer.isView(x)
    // ~> `new` bcuz `Buffer.slice` => ref
    tmp = new x.constructor(x);
    if (tmp) {
        for(list = Object.getOwnPropertySymbols(x); i < list.length; i++)$b8db88280711b5c9$var$set(tmp, list[i], Object.getOwnPropertyDescriptor(x, list[i]));
        for(i = 0, list = Object.getOwnPropertyNames(x); i < list.length; i++){
            if (Object.hasOwnProperty.call(tmp, k = list[i]) && tmp[k] === x[k]) continue;
            $b8db88280711b5c9$var$set(tmp, k, Object.getOwnPropertyDescriptor(x, k));
        }
    }
    return tmp || x;
}
const $b8db88280711b5c9$export$34448771f7911aa9 = Symbol("vee-validate-form");
const $b8db88280711b5c9$export$82b43ec3fe1404d8 = Symbol("vee-validate-field-instance");
const $b8db88280711b5c9$export$eb758c5980e9ddb2 = Symbol("Default empty value");
const $b8db88280711b5c9$var$isClient = typeof window !== "undefined";
function $b8db88280711b5c9$var$isLocator(value) {
    return $b8db88280711b5c9$var$isCallable(value) && !!value.__locatorRef;
}
function $b8db88280711b5c9$var$isTypedSchema(value) {
    return !!value && $b8db88280711b5c9$var$isCallable(value.parse) && value.__type === "VVTypedSchema";
}
function $b8db88280711b5c9$var$isYupValidator(value) {
    return !!value && $b8db88280711b5c9$var$isCallable(value.validate);
}
function $b8db88280711b5c9$var$hasCheckedAttr(type) {
    return type === "checkbox" || type === "radio";
}
function $b8db88280711b5c9$var$isContainerValue(value) {
    return $b8db88280711b5c9$var$isObject(value) || Array.isArray(value);
}
/**
 * True if the value is an empty object or array
 */ function $b8db88280711b5c9$var$isEmptyContainer(value) {
    if (Array.isArray(value)) return value.length === 0;
    return $b8db88280711b5c9$var$isObject(value) && Object.keys(value).length === 0;
}
/**
 * Checks if the path opted out of nested fields using `[fieldName]` syntax
 */ function $b8db88280711b5c9$export$69537c356a834701(path) {
    return /^\[.+\]$/i.test(path);
}
/**
 * Checks if an element is a native HTML5 multi-select input element
 */ function $b8db88280711b5c9$var$isNativeMultiSelect(el) {
    return $b8db88280711b5c9$var$isNativeSelect(el) && el.multiple;
}
/**
 * Checks if an element is a native HTML5 select input element
 */ function $b8db88280711b5c9$var$isNativeSelect(el) {
    return el.tagName === "SELECT";
}
/**
 * Checks if a tag name with attrs object will render a native multi-select element
 */ function $b8db88280711b5c9$var$isNativeMultiSelectNode(tag, attrs) {
    // The falsy value array is the values that Vue won't add the `multiple` prop if it has one of these values
    const hasTruthyBindingValue = ![
        false,
        null,
        undefined,
        0
    ].includes(attrs.multiple) && !Number.isNaN(attrs.multiple);
    return tag === "select" && "multiple" in attrs && hasTruthyBindingValue;
}
/**
 * Checks if a node should have a `:value` binding or not
 *
 * These nodes should not have a value binding
 * For files, because they are not reactive
 * For multi-selects because the value binding will reset the value
 */ function $b8db88280711b5c9$var$shouldHaveValueBinding(tag, attrs) {
    return !$b8db88280711b5c9$var$isNativeMultiSelectNode(tag, attrs) && attrs.type !== "file" && !$b8db88280711b5c9$var$hasCheckedAttr(attrs.type);
}
function $b8db88280711b5c9$var$isFormSubmitEvent(evt) {
    return $b8db88280711b5c9$var$isEvent(evt) && evt.target && "submit" in evt.target;
}
function $b8db88280711b5c9$var$isEvent(evt) {
    if (!evt) return false;
    if (typeof Event !== "undefined" && $b8db88280711b5c9$var$isCallable(Event) && evt instanceof Event) return true;
    // this is for IE and Cypress #3161
    /* istanbul ignore next */ if (evt && evt.srcElement) return true;
    return false;
}
function $b8db88280711b5c9$var$isPropPresent(obj, prop) {
    return prop in obj && obj[prop] !== $b8db88280711b5c9$export$eb758c5980e9ddb2;
}
/**
 * Compares if two values are the same borrowed from:
 * https://github.com/epoberezkin/fast-deep-equal
 * We added a case for file matching since `Object.keys` doesn't work with Files.
 * */ function $b8db88280711b5c9$var$isEqual(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (a.constructor !== b.constructor) return false;
        // eslint-disable-next-line no-var
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$b8db88280711b5c9$var$isEqual(a[i], b[i])) return false;
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            for (i of a.entries())if (!$b8db88280711b5c9$var$isEqual(i[1], b.get(i[0]))) return false;
            return true;
        }
        // We added this part for file comparison, arguably a little naive but should work for most cases.
        // #3911
        if ($b8db88280711b5c9$var$isFile(a) && $b8db88280711b5c9$var$isFile(b)) {
            if (a.size !== b.size) return false;
            if (a.name !== b.name) return false;
            if (a.lastModified !== b.lastModified) return false;
            if (a.type !== b.type) return false;
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        for(i = length; i-- !== 0;){
            // eslint-disable-next-line no-var
            var key = keys[i];
            if (!$b8db88280711b5c9$var$isEqual(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
}
function $b8db88280711b5c9$var$isFile(a) {
    if (!$b8db88280711b5c9$var$isClient) return false;
    return a instanceof File;
}
function $b8db88280711b5c9$export$d38b817f72584e57(path) {
    if ($b8db88280711b5c9$export$69537c356a834701(path)) return path.replace(/\[|\]/gi, "");
    return path;
}
function $b8db88280711b5c9$var$getFromPath(object, path, fallback) {
    if (!object) return fallback;
    if ($b8db88280711b5c9$export$69537c356a834701(path)) return object[$b8db88280711b5c9$export$d38b817f72584e57(path)];
    const resolvedValue = (path || "").split(/\.|\[(\d+)\]/).filter(Boolean).reduce((acc, propKey)=>{
        if ($b8db88280711b5c9$var$isContainerValue(acc) && propKey in acc) return acc[propKey];
        return fallback;
    }, object);
    return resolvedValue;
}
/**
 * Sets a nested property value in a path, creates the path properties if it doesn't exist
 */ function $b8db88280711b5c9$var$setInPath(object, path, value) {
    if ($b8db88280711b5c9$export$69537c356a834701(path)) {
        object[$b8db88280711b5c9$export$d38b817f72584e57(path)] = value;
        return;
    }
    const keys = path.split(/\.|\[(\d+)\]/).filter(Boolean);
    let acc = object;
    for(let i = 0; i < keys.length; i++){
        // Last key, set it
        if (i === keys.length - 1) {
            acc[keys[i]] = value;
            return;
        }
        // Key does not exist, create a container for it
        if (!(keys[i] in acc) || $b8db88280711b5c9$var$isNullOrUndefined(acc[keys[i]])) // container can be either an object or an array depending on the next key if it exists
        acc[keys[i]] = $b8db88280711b5c9$var$isIndex(keys[i + 1]) ? [] : {};
        acc = acc[keys[i]];
    }
}
function $b8db88280711b5c9$var$unset(object, key) {
    if (Array.isArray(object) && $b8db88280711b5c9$var$isIndex(key)) {
        object.splice(Number(key), 1);
        return;
    }
    if ($b8db88280711b5c9$var$isObject(object)) delete object[key];
}
/**
 * Removes a nested property from object
 */ function $b8db88280711b5c9$var$unsetPath(object, path) {
    if ($b8db88280711b5c9$export$69537c356a834701(path)) {
        delete object[$b8db88280711b5c9$export$d38b817f72584e57(path)];
        return;
    }
    const keys = path.split(/\.|\[(\d+)\]/).filter(Boolean);
    let acc = object;
    for(let i = 0; i < keys.length; i++){
        // Last key, unset it
        if (i === keys.length - 1) {
            $b8db88280711b5c9$var$unset(acc, keys[i]);
            break;
        }
        // Key does not exist, exit
        if (!(keys[i] in acc) || $b8db88280711b5c9$var$isNullOrUndefined(acc[keys[i]])) break;
        acc = acc[keys[i]];
    }
    const pathValues = keys.map((_, idx)=>{
        return $b8db88280711b5c9$var$getFromPath(object, keys.slice(0, idx).join("."));
    });
    for(let i = pathValues.length - 1; i >= 0; i--){
        if (!$b8db88280711b5c9$var$isEmptyContainer(pathValues[i])) continue;
        if (i === 0) {
            $b8db88280711b5c9$var$unset(object, keys[0]);
            continue;
        }
        $b8db88280711b5c9$var$unset(pathValues[i - 1], keys[i - 1]);
    }
}
/**
 * A typed version of Object.keys
 */ function $b8db88280711b5c9$var$keysOf(record) {
    return Object.keys(record);
}
// Uses same component provide as its own injections
// Due to changes in https://github.com/vuejs/vue-next/pull/2424
function $b8db88280711b5c9$var$injectWithSelf(symbol, def) {
    const vm = (0, $TusQn.getCurrentInstance)();
    return (vm === null || vm === void 0 ? void 0 : vm.provides[symbol]) || (0, $TusQn.inject)(symbol, def);
}
function $b8db88280711b5c9$var$warn(message) {
    (0, $TusQn.warn)(`[vee-validate]: ${message}`);
}
function $b8db88280711b5c9$var$resolveNextCheckboxValue(currentValue, checkedValue, uncheckedValue) {
    if (Array.isArray(currentValue)) {
        const newVal = [
            ...currentValue
        ];
        // Use isEqual since checked object values can possibly fail the equality check #3883
        const idx = newVal.findIndex((v)=>$b8db88280711b5c9$var$isEqual(v, checkedValue));
        idx >= 0 ? newVal.splice(idx, 1) : newVal.push(checkedValue);
        return newVal;
    }
    return $b8db88280711b5c9$var$isEqual(currentValue, checkedValue) ? uncheckedValue : checkedValue;
}
/**
 * Creates a throttled function that only invokes the provided function (`func`) at most once per within a given number of milliseconds
 * (`limit`)
 */ function $b8db88280711b5c9$var$throttle(func, limit) {
    let inThrottle;
    let lastResult;
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const context = this;
        if (!inThrottle) {
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
            lastResult = func.apply(context, args);
        }
        return lastResult;
    };
}
function $b8db88280711b5c9$var$debounceAsync(inner, ms = 0) {
    let timer = null;
    let resolves = [];
    return function(...args) {
        // Run the function after a certain amount of time
        if (timer) clearTimeout(timer);
        // @ts-expect-error timer is a number
        timer = setTimeout(()=>{
            // Get the result of the inner function, then apply it to the resolve function of
            // each promise that has been created since the last time the inner function was run
            const result = inner(...args);
            resolves.forEach((r)=>r(result));
            resolves = [];
        }, ms);
        return new Promise((resolve)=>resolves.push(resolve));
    };
}
function $b8db88280711b5c9$var$applyModelModifiers(value, modifiers) {
    if (!$b8db88280711b5c9$var$isObject(modifiers)) return value;
    if (modifiers.number) return $b8db88280711b5c9$var$toNumber(value);
    return value;
}
function $b8db88280711b5c9$var$withLatest(fn, onDone) {
    let latestRun;
    return async function runLatest(...args) {
        const pending = fn(...args);
        latestRun = pending;
        const result = await pending;
        if (pending !== latestRun) return result;
        latestRun = undefined;
        return onDone(result, args);
    };
}
function $b8db88280711b5c9$var$computedDeep({ get: get, set: set }) {
    const baseRef = (0, $01W3b.ref)($b8db88280711b5c9$var$klona(get()));
    (0, $TusQn.watch)(get, (newValue)=>{
        if ($b8db88280711b5c9$var$isEqual(newValue, baseRef.value)) return;
        baseRef.value = $b8db88280711b5c9$var$klona(newValue);
    }, {
        deep: true
    });
    (0, $TusQn.watch)(baseRef, (newValue)=>{
        if ($b8db88280711b5c9$var$isEqual(newValue, get())) return;
        set($b8db88280711b5c9$var$klona(newValue));
    }, {
        deep: true
    });
    return baseRef;
}
function $b8db88280711b5c9$var$normalizeErrorItem(message) {
    return Array.isArray(message) ? message : message ? [
        message
    ] : [];
}
function $b8db88280711b5c9$var$resolveFieldOrPathState(path) {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    const state = path ? (0, $01W3b.computed)(()=>form === null || form === void 0 ? void 0 : form.getPathState((0, $01W3b.toValue)(path))) : undefined;
    const field = path ? undefined : (0, $TusQn.inject)($b8db88280711b5c9$export$82b43ec3fe1404d8);
    if (!field && !(state === null || state === void 0 ? void 0 : state.value)) $b8db88280711b5c9$var$warn(`field with name ${(0, $01W3b.toValue)(path)} was not found`);
    return state || field;
}
function $b8db88280711b5c9$var$omit(obj, keys) {
    const target = {};
    for(const key in obj)if (!keys.includes(key)) target[key] = obj[key];
    return target;
}
function $b8db88280711b5c9$var$debounceNextTick(inner) {
    let lastTick = null;
    let resolves = [];
    return function(...args) {
        // Run the function after a certain amount of time
        const thisTick = (0, $TusQn.nextTick)(()=>{
            if (lastTick !== thisTick) return;
            // Get the result of the inner function, then apply it to the resolve function of
            // each promise that has been created since the last time the inner function was run
            const result = inner(...args);
            resolves.forEach((r)=>r(result));
            resolves = [];
            lastTick = null;
        });
        lastTick = thisTick;
        return new Promise((resolve)=>resolves.push(resolve));
    };
}
function $b8db88280711b5c9$var$normalizeChildren(tag, context, slotProps) {
    if (!context.slots.default) return context.slots.default;
    if (typeof tag === "string" || !tag) return context.slots.default(slotProps());
    return {
        default: ()=>{
            var _a, _b;
            return (_b = (_a = context.slots).default) === null || _b === void 0 ? void 0 : _b.call(_a, slotProps());
        }
    };
}
/**
 * Vue adds a `_value` prop at the moment on the input elements to store the REAL value on them, real values are different than the `value` attribute
 * as they do not get casted to strings unlike `el.value` which preserves user-code behavior
 */ function $b8db88280711b5c9$var$getBoundValue(el) {
    if ($b8db88280711b5c9$var$hasValueBinding(el)) return el._value;
    return undefined;
}
/**
 * Vue adds a `_value` prop at the moment on the input elements to store the REAL value on them, real values are different than the `value` attribute
 * as they do not get casted to strings unlike `el.value` which preserves user-code behavior
 */ function $b8db88280711b5c9$var$hasValueBinding(el) {
    return "_value" in el;
}
function $b8db88280711b5c9$var$parseInputValue(el) {
    if (el.type === "number") return Number.isNaN(el.valueAsNumber) ? el.value : el.valueAsNumber;
    if (el.type === "range") return Number.isNaN(el.valueAsNumber) ? el.value : el.valueAsNumber;
    return el.value;
}
function $b8db88280711b5c9$var$normalizeEventValue(value) {
    if (!$b8db88280711b5c9$var$isEvent(value)) return value;
    const input = value.target;
    // Vue sets the current bound value on `_value` prop
    // for checkboxes it it should fetch the value binding type as is (boolean instead of string)
    if ($b8db88280711b5c9$var$hasCheckedAttr(input.type) && $b8db88280711b5c9$var$hasValueBinding(input)) return $b8db88280711b5c9$var$getBoundValue(input);
    if (input.type === "file" && input.files) {
        const files = Array.from(input.files);
        return input.multiple ? files : files[0];
    }
    if ($b8db88280711b5c9$var$isNativeMultiSelect(input)) return Array.from(input.options).filter((opt)=>opt.selected && !opt.disabled).map($b8db88280711b5c9$var$getBoundValue);
    // makes sure we get the actual `option` bound value
    // #3440
    if ($b8db88280711b5c9$var$isNativeSelect(input)) {
        const selectedOption = Array.from(input.options).find((opt)=>opt.selected);
        return selectedOption ? $b8db88280711b5c9$var$getBoundValue(selectedOption) : input.value;
    }
    return $b8db88280711b5c9$var$parseInputValue(input);
}
/**
 * Normalizes the given rules expression.
 */ function $b8db88280711b5c9$export$10624d01c40e6e76(rules) {
    const acc = {};
    Object.defineProperty(acc, "_$$isNormalized", {
        value: true,
        writable: false,
        enumerable: false,
        configurable: false
    });
    if (!rules) return acc;
    // Object is already normalized, skip.
    if ($b8db88280711b5c9$var$isObject(rules) && rules._$$isNormalized) return rules;
    if ($b8db88280711b5c9$var$isObject(rules)) return Object.keys(rules).reduce((prev, curr)=>{
        const params = $b8db88280711b5c9$var$normalizeParams(rules[curr]);
        if (rules[curr] !== false) prev[curr] = $b8db88280711b5c9$var$buildParams(params);
        return prev;
    }, acc);
    /* istanbul ignore if */ if (typeof rules !== "string") return acc;
    return rules.split("|").reduce((prev, rule)=>{
        const parsedRule = $b8db88280711b5c9$var$parseRule(rule);
        if (!parsedRule.name) return prev;
        prev[parsedRule.name] = $b8db88280711b5c9$var$buildParams(parsedRule.params);
        return prev;
    }, acc);
}
/**
 * Normalizes a rule param.
 */ function $b8db88280711b5c9$var$normalizeParams(params) {
    if (params === true) return [];
    if (Array.isArray(params)) return params;
    if ($b8db88280711b5c9$var$isObject(params)) return params;
    return [
        params
    ];
}
function $b8db88280711b5c9$var$buildParams(provided) {
    const mapValueToLocator = (value)=>{
        // A target param using interpolation
        if (typeof value === "string" && value[0] === "@") return $b8db88280711b5c9$var$createLocator(value.slice(1));
        return value;
    };
    if (Array.isArray(provided)) return provided.map(mapValueToLocator);
    // #3073
    if (provided instanceof RegExp) return [
        provided
    ];
    return Object.keys(provided).reduce((prev, key)=>{
        prev[key] = mapValueToLocator(provided[key]);
        return prev;
    }, {});
}
/**
 * Parses a rule string expression.
 */ const $b8db88280711b5c9$var$parseRule = (rule)=>{
    let params = [];
    const name = rule.split(":")[0];
    if (rule.includes(":")) params = rule.split(":").slice(1).join(":").split(",");
    return {
        name: name,
        params: params
    };
};
function $b8db88280711b5c9$var$createLocator(value) {
    const locator = (crossTable)=>{
        const val = $b8db88280711b5c9$var$getFromPath(crossTable, value) || crossTable[value];
        return val;
    };
    locator.__locatorRef = value;
    return locator;
}
function $b8db88280711b5c9$var$extractLocators(params) {
    if (Array.isArray(params)) return params.filter($b8db88280711b5c9$var$isLocator);
    return $b8db88280711b5c9$var$keysOf(params).filter((key)=>$b8db88280711b5c9$var$isLocator(params[key])).map((key)=>params[key]);
}
const $b8db88280711b5c9$var$DEFAULT_CONFIG = {
    generateMessage: ({ field: field })=>`${field} is not valid.`,
    bails: true,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnInput: false,
    validateOnModelUpdate: true
};
let $b8db88280711b5c9$var$currentConfig = Object.assign({}, $b8db88280711b5c9$var$DEFAULT_CONFIG);
const $b8db88280711b5c9$var$getConfig = ()=>$b8db88280711b5c9$var$currentConfig;
const $b8db88280711b5c9$var$setConfig = (newConf)=>{
    $b8db88280711b5c9$var$currentConfig = Object.assign(Object.assign({}, $b8db88280711b5c9$var$currentConfig), newConf);
};
const $b8db88280711b5c9$export$8d21e34596265fa2 = $b8db88280711b5c9$var$setConfig;
/**
 * Validates a value against the rules.
 */ async function $b8db88280711b5c9$export$a22775fa5e2eebd9(value, rules, options = {}) {
    const shouldBail = options === null || options === void 0 ? void 0 : options.bails;
    const field = {
        name: (options === null || options === void 0 ? void 0 : options.name) || "{field}",
        rules: rules,
        label: options === null || options === void 0 ? void 0 : options.label,
        bails: shouldBail !== null && shouldBail !== void 0 ? shouldBail : true,
        formData: (options === null || options === void 0 ? void 0 : options.values) || {}
    };
    const result = await $b8db88280711b5c9$var$_validate(field, value);
    const errors = result.errors;
    return {
        errors: errors,
        valid: !errors.length
    };
}
/**
 * Starts the validation process.
 */ async function $b8db88280711b5c9$var$_validate(field, value) {
    if ($b8db88280711b5c9$var$isTypedSchema(field.rules) || $b8db88280711b5c9$var$isYupValidator(field.rules)) return $b8db88280711b5c9$var$validateFieldWithTypedSchema(value, field.rules);
    // if a generic function or chain of generic functions
    if ($b8db88280711b5c9$var$isCallable(field.rules) || Array.isArray(field.rules)) {
        const ctx = {
            field: field.label || field.name,
            name: field.name,
            label: field.label,
            form: field.formData,
            value: value
        };
        // Normalize the pipeline
        const pipeline = Array.isArray(field.rules) ? field.rules : [
            field.rules
        ];
        const length = pipeline.length;
        const errors = [];
        for(let i = 0; i < length; i++){
            const rule = pipeline[i];
            const result = await rule(value, ctx);
            const isValid = typeof result !== "string" && !Array.isArray(result) && result;
            if (isValid) continue;
            if (Array.isArray(result)) errors.push(...result);
            else {
                const message = typeof result === "string" ? result : $b8db88280711b5c9$var$_generateFieldError(ctx);
                errors.push(message);
            }
            if (field.bails) return {
                errors: errors
            };
        }
        return {
            errors: errors
        };
    }
    const normalizedContext = Object.assign(Object.assign({}, field), {
        rules: $b8db88280711b5c9$export$10624d01c40e6e76(field.rules)
    });
    const errors = [];
    const rulesKeys = Object.keys(normalizedContext.rules);
    const length = rulesKeys.length;
    for(let i = 0; i < length; i++){
        const rule = rulesKeys[i];
        const result = await $b8db88280711b5c9$var$_test(normalizedContext, value, {
            name: rule,
            params: normalizedContext.rules[rule]
        });
        if (result.error) {
            errors.push(result.error);
            if (field.bails) return {
                errors: errors
            };
        }
    }
    return {
        errors: errors
    };
}
function $b8db88280711b5c9$var$isYupError(err) {
    return !!err && err.name === "ValidationError";
}
function $b8db88280711b5c9$var$yupToTypedSchema(yupSchema) {
    const schema = {
        __type: "VVTypedSchema",
        async parse (values) {
            var _a;
            try {
                const output = await yupSchema.validate(values, {
                    abortEarly: false
                });
                return {
                    output: output,
                    errors: []
                };
            } catch (err) {
                // Yup errors have a name prop one them.
                // https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (!$b8db88280711b5c9$var$isYupError(err)) throw err;
                if (!((_a = err.inner) === null || _a === void 0 ? void 0 : _a.length) && err.errors.length) return {
                    errors: [
                        {
                            path: err.path,
                            errors: err.errors
                        }
                    ]
                };
                const errors = err.inner.reduce((acc, curr)=>{
                    const path = curr.path || "";
                    if (!acc[path]) acc[path] = {
                        errors: [],
                        path: path
                    };
                    acc[path].errors.push(...curr.errors);
                    return acc;
                }, {});
                return {
                    errors: Object.values(errors)
                };
            }
        }
    };
    return schema;
}
/**
 * Handles yup validation
 */ async function $b8db88280711b5c9$var$validateFieldWithTypedSchema(value, schema) {
    const typedSchema = $b8db88280711b5c9$var$isTypedSchema(schema) ? schema : $b8db88280711b5c9$var$yupToTypedSchema(schema);
    const result = await typedSchema.parse(value);
    const messages = [];
    for (const error of result.errors)if (error.errors.length) messages.push(...error.errors);
    return {
        errors: messages
    };
}
/**
 * Tests a single input value against a rule.
 */ async function $b8db88280711b5c9$var$_test(field, value, rule) {
    const validator = $b8db88280711b5c9$var$resolveRule(rule.name);
    if (!validator) throw new Error(`No such validator '${rule.name}' exists.`);
    const params = $b8db88280711b5c9$var$fillTargetValues(rule.params, field.formData);
    const ctx = {
        field: field.label || field.name,
        name: field.name,
        label: field.label,
        value: value,
        form: field.formData,
        rule: Object.assign(Object.assign({}, rule), {
            params: params
        })
    };
    const result = await validator(value, params, ctx);
    if (typeof result === "string") return {
        error: result
    };
    return {
        error: result ? undefined : $b8db88280711b5c9$var$_generateFieldError(ctx)
    };
}
/**
 * Generates error messages.
 */ function $b8db88280711b5c9$var$_generateFieldError(fieldCtx) {
    const message = $b8db88280711b5c9$var$getConfig().generateMessage;
    if (!message) return "Field is invalid";
    return message(fieldCtx);
}
function $b8db88280711b5c9$var$fillTargetValues(params, crossTable) {
    const normalize = (value)=>{
        if ($b8db88280711b5c9$var$isLocator(value)) return value(crossTable);
        return value;
    };
    if (Array.isArray(params)) return params.map(normalize);
    return Object.keys(params).reduce((acc, param)=>{
        acc[param] = normalize(params[param]);
        return acc;
    }, {});
}
async function $b8db88280711b5c9$var$validateTypedSchema(schema, values) {
    const typedSchema = $b8db88280711b5c9$var$isTypedSchema(schema) ? schema : $b8db88280711b5c9$var$yupToTypedSchema(schema);
    const validationResult = await typedSchema.parse($b8db88280711b5c9$var$klona(values));
    const results = {};
    const errors = {};
    for (const error of validationResult.errors){
        const messages = error.errors;
        // Fixes issue with path mapping with Yup 1.0 including quotes around array indices
        const path = (error.path || "").replace(/\["(\d+)"\]/g, (_, m)=>{
            return `[${m}]`;
        });
        results[path] = {
            valid: !messages.length,
            errors: messages
        };
        if (messages.length) errors[path] = messages[0];
    }
    return {
        valid: !validationResult.errors.length,
        results: results,
        errors: errors,
        values: validationResult.value
    };
}
async function $b8db88280711b5c9$export$381bae2d0f08004f(schema, values, opts) {
    const paths = $b8db88280711b5c9$var$keysOf(schema);
    const validations = paths.map(async (path)=>{
        var _a, _b, _c;
        const strings = (_a = opts === null || opts === void 0 ? void 0 : opts.names) === null || _a === void 0 ? void 0 : _a[path];
        const fieldResult = await $b8db88280711b5c9$export$a22775fa5e2eebd9($b8db88280711b5c9$var$getFromPath(values, path), schema[path], {
            name: (strings === null || strings === void 0 ? void 0 : strings.name) || path,
            label: strings === null || strings === void 0 ? void 0 : strings.label,
            values: values,
            bails: (_c = (_b = opts === null || opts === void 0 ? void 0 : opts.bailsMap) === null || _b === void 0 ? void 0 : _b[path]) !== null && _c !== void 0 ? _c : true
        });
        return Object.assign(Object.assign({}, fieldResult), {
            path: path
        });
    });
    let isAllValid = true;
    const validationResults = await Promise.all(validations);
    const results = {};
    const errors = {};
    for (const result of validationResults){
        results[result.path] = {
            valid: result.valid,
            errors: result.errors
        };
        if (!result.valid) {
            isAllValid = false;
            errors[result.path] = result.errors[0];
        }
    }
    return {
        valid: isAllValid,
        results: results,
        errors: errors
    };
}
let $b8db88280711b5c9$var$ID_COUNTER = 0;
function $b8db88280711b5c9$var$useFieldState(path, init) {
    const { value: value, initialValue: initialValue, setInitialValue: setInitialValue } = $b8db88280711b5c9$var$_useFieldValue(path, init.modelValue, init.form);
    if (!init.form) {
        const { errors: errors, setErrors: setErrors } = $b8db88280711b5c9$var$createFieldErrors();
        const id = $b8db88280711b5c9$var$ID_COUNTER >= Number.MAX_SAFE_INTEGER ? 0 : ++$b8db88280711b5c9$var$ID_COUNTER;
        const meta = $b8db88280711b5c9$var$createFieldMeta(value, initialValue, errors, init.schema);
        function setState(state) {
            var _a;
            if ("value" in state) value.value = state.value;
            if ("errors" in state) setErrors(state.errors);
            if ("touched" in state) meta.touched = (_a = state.touched) !== null && _a !== void 0 ? _a : meta.touched;
            if ("initialValue" in state) setInitialValue(state.initialValue);
        }
        return {
            id: id,
            path: path,
            value: value,
            initialValue: initialValue,
            meta: meta,
            flags: {
                pendingUnmount: {
                    [id]: false
                },
                pendingReset: false
            },
            errors: errors,
            setState: setState
        };
    }
    const state = init.form.createPathState(path, {
        bails: init.bails,
        label: init.label,
        type: init.type,
        validate: init.validate,
        schema: init.schema
    });
    const errors = (0, $01W3b.computed)(()=>state.errors);
    function setState(state) {
        var _a, _b, _c;
        if ("value" in state) value.value = state.value;
        if ("errors" in state) (_a = init.form) === null || _a === void 0 || _a.setFieldError((0, $01W3b.unref)(path), state.errors);
        if ("touched" in state) (_b = init.form) === null || _b === void 0 || _b.setFieldTouched((0, $01W3b.unref)(path), (_c = state.touched) !== null && _c !== void 0 ? _c : false);
        if ("initialValue" in state) setInitialValue(state.initialValue);
    }
    return {
        id: Array.isArray(state.id) ? state.id[state.id.length - 1] : state.id,
        path: path,
        value: value,
        errors: errors,
        meta: state,
        initialValue: initialValue,
        flags: state.__flags,
        setState: setState
    };
}
/**
 * Creates the field value and resolves the initial value
 */ function $b8db88280711b5c9$var$_useFieldValue(path, modelValue, form) {
    const modelRef = (0, $01W3b.ref)((0, $01W3b.unref)(modelValue));
    function resolveInitialValue() {
        if (!form) return (0, $01W3b.unref)(modelRef);
        return $b8db88280711b5c9$var$getFromPath(form.initialValues.value, (0, $01W3b.unref)(path), (0, $01W3b.unref)(modelRef));
    }
    function setInitialValue(value) {
        if (!form) {
            modelRef.value = value;
            return;
        }
        form.setFieldInitialValue((0, $01W3b.unref)(path), value, true);
    }
    const initialValue = (0, $01W3b.computed)(resolveInitialValue);
    // if no form is associated, use a regular ref.
    if (!form) {
        const value = (0, $01W3b.ref)(resolveInitialValue());
        return {
            value: value,
            initialValue: initialValue,
            setInitialValue: setInitialValue
        };
    }
    // to set the initial value, first check if there is a current value, if there is then use it.
    // otherwise use the configured initial value if it exists.
    // prioritize model value over form values
    // #3429
    const currentValue = $b8db88280711b5c9$var$resolveModelValue(modelValue, form, initialValue, path);
    form.stageInitialValue((0, $01W3b.unref)(path), currentValue, true);
    // otherwise use a computed setter that triggers the `setFieldValue`
    const value = (0, $01W3b.computed)({
        get () {
            return $b8db88280711b5c9$var$getFromPath(form.values, (0, $01W3b.unref)(path));
        },
        set (newVal) {
            form.setFieldValue((0, $01W3b.unref)(path), newVal, false);
        }
    });
    return {
        value: value,
        initialValue: initialValue,
        setInitialValue: setInitialValue
    };
}
/*
  to set the initial value, first check if there is a current value, if there is then use it.
  otherwise use the configured initial value if it exists.
  prioritize model value over form values
  #3429
*/ function $b8db88280711b5c9$var$resolveModelValue(modelValue, form, initialValue, path) {
    if ((0, $01W3b.isRef)(modelValue)) return (0, $01W3b.unref)(modelValue);
    if (modelValue !== undefined) return modelValue;
    return $b8db88280711b5c9$var$getFromPath(form.values, (0, $01W3b.unref)(path), (0, $01W3b.unref)(initialValue));
}
/**
 * Creates meta flags state and some associated effects with them
 */ function $b8db88280711b5c9$var$createFieldMeta(currentValue, initialValue, errors, schema) {
    const isRequired = (0, $01W3b.computed)(()=>{
        var _a, _b, _c;
        return (_c = (_b = (_a = (0, $01W3b.toValue)(schema)) === null || _a === void 0 ? void 0 : _a.describe) === null || _b === void 0 ? void 0 : _b.call(_a).required) !== null && _c !== void 0 ? _c : false;
    });
    const meta = (0, $01W3b.reactive)({
        touched: false,
        pending: false,
        valid: true,
        required: isRequired,
        validated: !!(0, $01W3b.unref)(errors).length,
        initialValue: (0, $01W3b.computed)(()=>(0, $01W3b.unref)(initialValue)),
        dirty: (0, $01W3b.computed)(()=>{
            return !$b8db88280711b5c9$var$isEqual((0, $01W3b.unref)(currentValue), (0, $01W3b.unref)(initialValue));
        })
    });
    (0, $TusQn.watch)(errors, (value)=>{
        meta.valid = !value.length;
    }, {
        immediate: true,
        flush: "sync"
    });
    return meta;
}
/**
 * Creates the error message state for the field state
 */ function $b8db88280711b5c9$var$createFieldErrors() {
    const errors = (0, $01W3b.ref)([]);
    return {
        errors: errors,
        setErrors: (messages)=>{
            errors.value = $b8db88280711b5c9$var$normalizeErrorItem(messages);
        }
    };
}
function $b8db88280711b5c9$var$installDevtoolsPlugin(app) {
    (0, $j6G8F.setupDevtoolsPlugin)({
        id: "vee-validate-devtools-plugin",
        label: "VeeValidate Plugin",
        packageName: "vee-validate",
        homepage: "https://vee-validate.logaretm.com/v4",
        app: app,
        logo: "https://vee-validate.logaretm.com/v4/logo.png"
    }, $b8db88280711b5c9$var$setupApiHooks);
}
const $b8db88280711b5c9$var$DEVTOOLS_FORMS = {};
const $b8db88280711b5c9$var$DEVTOOLS_FIELDS = {};
let $b8db88280711b5c9$var$API;
const $b8db88280711b5c9$var$refreshInspector = $b8db88280711b5c9$var$throttle(()=>{
    setTimeout(async ()=>{
        await (0, $TusQn.nextTick)();
        $b8db88280711b5c9$var$API === null || $b8db88280711b5c9$var$API === void 0 || $b8db88280711b5c9$var$API.sendInspectorState($b8db88280711b5c9$var$INSPECTOR_ID);
        $b8db88280711b5c9$var$API === null || $b8db88280711b5c9$var$API === void 0 || $b8db88280711b5c9$var$API.sendInspectorTree($b8db88280711b5c9$var$INSPECTOR_ID);
    }, 100);
}, 100);
function $b8db88280711b5c9$var$registerFormWithDevTools(form) {
    const vm = (0, $TusQn.getCurrentInstance)();
    if (!$b8db88280711b5c9$var$API) {
        const app = vm === null || vm === void 0 ? void 0 : vm.appContext.app;
        if (!app) return;
        $b8db88280711b5c9$var$installDevtoolsPlugin(app);
    }
    $b8db88280711b5c9$var$DEVTOOLS_FORMS[form.formId] = Object.assign({}, form);
    $b8db88280711b5c9$var$DEVTOOLS_FORMS[form.formId]._vm = vm;
    (0, $TusQn.onUnmounted)(()=>{
        delete $b8db88280711b5c9$var$DEVTOOLS_FORMS[form.formId];
        $b8db88280711b5c9$var$refreshInspector();
    });
    $b8db88280711b5c9$var$refreshInspector();
}
function $b8db88280711b5c9$var$registerSingleFieldWithDevtools(field) {
    const vm = (0, $TusQn.getCurrentInstance)();
    if (!$b8db88280711b5c9$var$API) {
        const app = vm === null || vm === void 0 ? void 0 : vm.appContext.app;
        if (!app) return;
        $b8db88280711b5c9$var$installDevtoolsPlugin(app);
    }
    $b8db88280711b5c9$var$DEVTOOLS_FIELDS[field.id] = Object.assign({}, field);
    $b8db88280711b5c9$var$DEVTOOLS_FIELDS[field.id]._vm = vm;
    (0, $TusQn.onUnmounted)(()=>{
        delete $b8db88280711b5c9$var$DEVTOOLS_FIELDS[field.id];
        $b8db88280711b5c9$var$refreshInspector();
    });
    $b8db88280711b5c9$var$refreshInspector();
}
const $b8db88280711b5c9$var$INSPECTOR_ID = "vee-validate-inspector";
const $b8db88280711b5c9$var$COLORS = {
    error: 0xbd4b4b,
    success: 0x06d77b,
    unknown: 0x54436b,
    white: 0xffffff,
    black: 0x000000,
    blue: 0x035397,
    purple: 0xb980f0,
    orange: 0xf5a962,
    gray: 0xbbbfca
};
let $b8db88280711b5c9$var$SELECTED_NODE = null;
function $b8db88280711b5c9$var$setupApiHooks(api) {
    $b8db88280711b5c9$var$API = api;
    api.addInspector({
        id: $b8db88280711b5c9$var$INSPECTOR_ID,
        icon: "rule",
        label: "vee-validate",
        noSelectionText: "Select a vee-validate node to inspect",
        actions: [
            {
                icon: "done_outline",
                tooltip: "Validate selected item",
                action: async ()=>{
                    if (!$b8db88280711b5c9$var$SELECTED_NODE) {
                        console.error("There is not a valid selected vee-validate node or component");
                        return;
                    }
                    if ($b8db88280711b5c9$var$SELECTED_NODE.type === "field") {
                        await $b8db88280711b5c9$var$SELECTED_NODE.field.validate();
                        return;
                    }
                    if ($b8db88280711b5c9$var$SELECTED_NODE.type === "form") {
                        await $b8db88280711b5c9$var$SELECTED_NODE.form.validate();
                        return;
                    }
                    if ($b8db88280711b5c9$var$SELECTED_NODE.type === "pathState") await $b8db88280711b5c9$var$SELECTED_NODE.form.validateField($b8db88280711b5c9$var$SELECTED_NODE.state.path);
                }
            },
            {
                icon: "delete_sweep",
                tooltip: "Clear validation state of the selected item",
                action: ()=>{
                    if (!$b8db88280711b5c9$var$SELECTED_NODE) {
                        console.error("There is not a valid selected vee-validate node or component");
                        return;
                    }
                    if ($b8db88280711b5c9$var$SELECTED_NODE.type === "field") {
                        $b8db88280711b5c9$var$SELECTED_NODE.field.resetField();
                        return;
                    }
                    if ($b8db88280711b5c9$var$SELECTED_NODE.type === "form") $b8db88280711b5c9$var$SELECTED_NODE.form.resetForm();
                    if ($b8db88280711b5c9$var$SELECTED_NODE.type === "pathState") $b8db88280711b5c9$var$SELECTED_NODE.form.resetField($b8db88280711b5c9$var$SELECTED_NODE.state.path);
                }
            }
        ]
    });
    api.on.getInspectorTree((payload)=>{
        if (payload.inspectorId !== $b8db88280711b5c9$var$INSPECTOR_ID) return;
        const forms = Object.values($b8db88280711b5c9$var$DEVTOOLS_FORMS);
        const fields = Object.values($b8db88280711b5c9$var$DEVTOOLS_FIELDS);
        payload.rootNodes = [
            ...forms.map($b8db88280711b5c9$var$mapFormForDevtoolsInspector),
            ...fields.map((field)=>$b8db88280711b5c9$var$mapFieldForDevtoolsInspector(field))
        ];
    });
    api.on.getInspectorState((payload, ctx)=>{
        if (payload.inspectorId !== $b8db88280711b5c9$var$INSPECTOR_ID || ctx.currentTab !== `custom-inspector:${$b8db88280711b5c9$var$INSPECTOR_ID}`) return;
        const { form: form, field: field, state: state, type: type } = $b8db88280711b5c9$var$decodeNodeId(payload.nodeId);
        if (form && type === "form") {
            payload.state = $b8db88280711b5c9$var$buildFormState(form);
            $b8db88280711b5c9$var$SELECTED_NODE = {
                type: "form",
                form: form
            };
            return;
        }
        if (state && type === "pathState" && form) {
            payload.state = $b8db88280711b5c9$var$buildFieldState(state);
            $b8db88280711b5c9$var$SELECTED_NODE = {
                type: "pathState",
                state: state,
                form: form
            };
            return;
        }
        if (field && type === "field") {
            payload.state = $b8db88280711b5c9$var$buildFieldState({
                errors: field.errors.value,
                dirty: field.meta.dirty,
                valid: field.meta.valid,
                touched: field.meta.touched,
                value: field.value.value,
                initialValue: field.meta.initialValue
            });
            $b8db88280711b5c9$var$SELECTED_NODE = {
                field: field,
                type: "field"
            };
            return;
        }
        $b8db88280711b5c9$var$SELECTED_NODE = null;
    });
}
function $b8db88280711b5c9$var$mapFormForDevtoolsInspector(form) {
    const { textColor: textColor, bgColor: bgColor } = $b8db88280711b5c9$var$getValidityColors(form.meta.value.valid);
    const formTreeNodes = {};
    Object.values(form.getAllPathStates()).forEach((state)=>{
        $b8db88280711b5c9$var$setInPath(formTreeNodes, (0, $01W3b.unref)(state.path), $b8db88280711b5c9$var$mapPathForDevtoolsInspector(state, form));
    });
    function buildFormTree(tree, path = []) {
        const key = [
            ...path
        ].pop();
        if ("id" in tree) return Object.assign(Object.assign({}, tree), {
            label: key || tree.label
        });
        if ($b8db88280711b5c9$var$isObject(tree)) return {
            id: `${path.join(".")}`,
            label: key || "",
            children: Object.keys(tree).map((key)=>buildFormTree(tree[key], [
                    ...path,
                    key
                ]))
        };
        if (Array.isArray(tree)) return {
            id: `${path.join(".")}`,
            label: `${key}[]`,
            children: tree.map((c, idx)=>buildFormTree(c, [
                    ...path,
                    String(idx)
                ]))
        };
        return {
            id: "",
            label: "",
            children: []
        };
    }
    const { children: children } = buildFormTree(formTreeNodes);
    return {
        id: $b8db88280711b5c9$var$encodeNodeId(form),
        label: "Form",
        children: children,
        tags: [
            {
                label: "Form",
                textColor: textColor,
                backgroundColor: bgColor
            },
            {
                label: `${form.getAllPathStates().length} fields`,
                textColor: $b8db88280711b5c9$var$COLORS.white,
                backgroundColor: $b8db88280711b5c9$var$COLORS.unknown
            }
        ]
    };
}
function $b8db88280711b5c9$var$mapPathForDevtoolsInspector(state, form) {
    return {
        id: $b8db88280711b5c9$var$encodeNodeId(form, state),
        label: (0, $01W3b.unref)(state.path),
        tags: $b8db88280711b5c9$var$getFieldNodeTags(state.multiple, state.fieldsCount, state.type, state.valid, form)
    };
}
function $b8db88280711b5c9$var$mapFieldForDevtoolsInspector(field, form) {
    return {
        id: $b8db88280711b5c9$var$encodeNodeId(form, field),
        label: (0, $01W3b.unref)(field.name),
        tags: $b8db88280711b5c9$var$getFieldNodeTags(false, 1, field.type, field.meta.valid, form)
    };
}
function $b8db88280711b5c9$var$getFieldNodeTags(multiple, fieldsCount, type, valid, form) {
    const { textColor: textColor, bgColor: bgColor } = $b8db88280711b5c9$var$getValidityColors(valid);
    return [
        multiple ? undefined : {
            label: "Field",
            textColor: textColor,
            backgroundColor: bgColor
        },
        !form ? {
            label: "Standalone",
            textColor: $b8db88280711b5c9$var$COLORS.black,
            backgroundColor: $b8db88280711b5c9$var$COLORS.gray
        } : undefined,
        type === "checkbox" ? {
            label: "Checkbox",
            textColor: $b8db88280711b5c9$var$COLORS.white,
            backgroundColor: $b8db88280711b5c9$var$COLORS.blue
        } : undefined,
        type === "radio" ? {
            label: "Radio",
            textColor: $b8db88280711b5c9$var$COLORS.white,
            backgroundColor: $b8db88280711b5c9$var$COLORS.purple
        } : undefined,
        multiple ? {
            label: "Multiple",
            textColor: $b8db88280711b5c9$var$COLORS.black,
            backgroundColor: $b8db88280711b5c9$var$COLORS.orange
        } : undefined
    ].filter(Boolean);
}
function $b8db88280711b5c9$var$encodeNodeId(form, stateOrField) {
    const type = stateOrField ? "path" in stateOrField ? "pathState" : "field" : "form";
    const fieldPath = stateOrField ? "path" in stateOrField ? stateOrField === null || stateOrField === void 0 ? void 0 : stateOrField.path : (0, $01W3b.unref)(stateOrField === null || stateOrField === void 0 ? void 0 : stateOrField.name) : "";
    const idObject = {
        f: form === null || form === void 0 ? void 0 : form.formId,
        ff: fieldPath,
        type: type
    };
    return btoa(encodeURIComponent(JSON.stringify(idObject)));
}
function $b8db88280711b5c9$var$decodeNodeId(nodeId) {
    try {
        const idObject = JSON.parse(decodeURIComponent(atob(nodeId)));
        const form = $b8db88280711b5c9$var$DEVTOOLS_FORMS[idObject.f];
        if (!form && idObject.ff) {
            const field = $b8db88280711b5c9$var$DEVTOOLS_FIELDS[idObject.ff];
            if (!field) return {};
            return {
                type: idObject.type,
                field: field
            };
        }
        if (!form) return {};
        const state = form.getPathState(idObject.ff);
        return {
            type: idObject.type,
            form: form,
            state: state
        };
    } catch (err) {
    // console.error(`Devtools: [vee-validate] Failed to parse node id ${nodeId}`);
    }
    return {};
}
function $b8db88280711b5c9$var$buildFieldState(state) {
    return {
        "Field state": [
            {
                key: "errors",
                value: state.errors
            },
            {
                key: "initialValue",
                value: state.initialValue
            },
            {
                key: "currentValue",
                value: state.value
            },
            {
                key: "touched",
                value: state.touched
            },
            {
                key: "dirty",
                value: state.dirty
            },
            {
                key: "valid",
                value: state.valid
            }
        ]
    };
}
function $b8db88280711b5c9$var$buildFormState(form) {
    const { errorBag: errorBag, meta: meta, values: values, isSubmitting: isSubmitting, isValidating: isValidating, submitCount: submitCount } = form;
    return {
        "Form state": [
            {
                key: "submitCount",
                value: submitCount.value
            },
            {
                key: "isSubmitting",
                value: isSubmitting.value
            },
            {
                key: "isValidating",
                value: isValidating.value
            },
            {
                key: "touched",
                value: meta.value.touched
            },
            {
                key: "dirty",
                value: meta.value.dirty
            },
            {
                key: "valid",
                value: meta.value.valid
            },
            {
                key: "initialValues",
                value: meta.value.initialValues
            },
            {
                key: "currentValues",
                value: values
            },
            {
                key: "errors",
                value: $b8db88280711b5c9$var$keysOf(errorBag.value).reduce((acc, key)=>{
                    var _a;
                    const message = (_a = errorBag.value[key]) === null || _a === void 0 ? void 0 : _a[0];
                    if (message) acc[key] = message;
                    return acc;
                }, {})
            }
        ]
    };
}
/**
 * Resolves the tag color based on the form state
 */ function $b8db88280711b5c9$var$getValidityColors(valid) {
    return {
        bgColor: valid ? $b8db88280711b5c9$var$COLORS.success : $b8db88280711b5c9$var$COLORS.error,
        textColor: valid ? $b8db88280711b5c9$var$COLORS.black : $b8db88280711b5c9$var$COLORS.white
    };
}
/**
 * Creates a field composite.
 */ function $b8db88280711b5c9$export$294aa081a6c6f55d(path, rules, opts) {
    if ($b8db88280711b5c9$var$hasCheckedAttr(opts === null || opts === void 0 ? void 0 : opts.type)) return $b8db88280711b5c9$var$useFieldWithChecked(path, rules, opts);
    return $b8db88280711b5c9$var$_useField(path, rules, opts);
}
function $b8db88280711b5c9$var$_useField(path, rules, opts) {
    const { initialValue: modelValue, validateOnMount: validateOnMount, bails: bails, type: type, checkedValue: checkedValue, label: label, validateOnValueUpdate: validateOnValueUpdate, uncheckedValue: uncheckedValue, controlled: controlled, keepValueOnUnmount: keepValueOnUnmount, syncVModel: syncVModel, form: controlForm } = $b8db88280711b5c9$var$normalizeOptions(opts);
    const injectedForm = controlled ? $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9) : undefined;
    const form = controlForm || injectedForm;
    const name = (0, $01W3b.computed)(()=>$b8db88280711b5c9$var$normalizeFormPath((0, $01W3b.toValue)(path)));
    const validator = (0, $01W3b.computed)(()=>{
        const schema = (0, $01W3b.toValue)(form === null || form === void 0 ? void 0 : form.schema);
        if (schema) return undefined;
        const rulesValue = (0, $01W3b.unref)(rules);
        if ($b8db88280711b5c9$var$isYupValidator(rulesValue) || $b8db88280711b5c9$var$isTypedSchema(rulesValue) || $b8db88280711b5c9$var$isCallable(rulesValue) || Array.isArray(rulesValue)) return rulesValue;
        return $b8db88280711b5c9$export$10624d01c40e6e76(rulesValue);
    });
    const isTyped = !$b8db88280711b5c9$var$isCallable(validator.value) && $b8db88280711b5c9$var$isTypedSchema((0, $01W3b.toValue)(rules));
    const { id: id, value: value, initialValue: initialValue, meta: meta, setState: setState, errors: errors, flags: flags } = $b8db88280711b5c9$var$useFieldState(name, {
        modelValue: modelValue,
        form: form,
        bails: bails,
        label: label,
        type: type,
        validate: validator.value ? validate$1 : undefined,
        schema: isTyped ? rules : undefined
    });
    const errorMessage = (0, $01W3b.computed)(()=>errors.value[0]);
    if (syncVModel) $b8db88280711b5c9$var$useVModel({
        value: value,
        prop: syncVModel,
        handleChange: handleChange,
        shouldValidate: ()=>validateOnValueUpdate && !flags.pendingReset
    });
    /**
     * Handles common onBlur meta update
     */ const handleBlur = (evt, shouldValidate = false)=>{
        meta.touched = true;
        if (shouldValidate) validateWithStateMutation();
    };
    async function validateCurrentValue(mode) {
        var _a, _b;
        if (form === null || form === void 0 ? void 0 : form.validateSchema) {
            const { results: results } = await form.validateSchema(mode);
            return (_a = results[(0, $01W3b.toValue)(name)]) !== null && _a !== void 0 ? _a : {
                valid: true,
                errors: []
            };
        }
        if (validator.value) return $b8db88280711b5c9$export$a22775fa5e2eebd9(value.value, validator.value, {
            name: (0, $01W3b.toValue)(name),
            label: (0, $01W3b.toValue)(label),
            values: (_b = form === null || form === void 0 ? void 0 : form.values) !== null && _b !== void 0 ? _b : {},
            bails: bails
        });
        return {
            valid: true,
            errors: []
        };
    }
    const validateWithStateMutation = $b8db88280711b5c9$var$withLatest(async ()=>{
        meta.pending = true;
        meta.validated = true;
        return validateCurrentValue("validated-only");
    }, (result)=>{
        if (flags.pendingUnmount[field.id]) return result;
        setState({
            errors: result.errors
        });
        meta.pending = false;
        meta.valid = result.valid;
        return result;
    });
    const validateValidStateOnly = $b8db88280711b5c9$var$withLatest(async ()=>{
        return validateCurrentValue("silent");
    }, (result)=>{
        meta.valid = result.valid;
        return result;
    });
    function validate$1(opts) {
        if ((opts === null || opts === void 0 ? void 0 : opts.mode) === "silent") return validateValidStateOnly();
        return validateWithStateMutation();
    }
    // Common input/change event handler
    function handleChange(e, shouldValidate = true) {
        const newValue = $b8db88280711b5c9$var$normalizeEventValue(e);
        setValue(newValue, shouldValidate);
    }
    // Runs the initial validation
    (0, $TusQn.onMounted)(()=>{
        if (validateOnMount) return validateWithStateMutation();
        // validate self initially if no form was handling this
        // forms should have their own initial silent validation run to make things more efficient
        if (!form || !form.validateSchema) validateValidStateOnly();
    });
    function setTouched(isTouched) {
        meta.touched = isTouched;
    }
    function resetField(state) {
        var _a;
        const newValue = state && "value" in state ? state.value : initialValue.value;
        setState({
            value: $b8db88280711b5c9$var$klona(newValue),
            initialValue: $b8db88280711b5c9$var$klona(newValue),
            touched: (_a = state === null || state === void 0 ? void 0 : state.touched) !== null && _a !== void 0 ? _a : false,
            errors: (state === null || state === void 0 ? void 0 : state.errors) || []
        });
        meta.pending = false;
        meta.validated = false;
        validateValidStateOnly();
    }
    const vm = (0, $TusQn.getCurrentInstance)();
    function setValue(newValue, shouldValidate = true) {
        value.value = vm && syncVModel ? $b8db88280711b5c9$var$applyModelModifiers(newValue, vm.props.modelModifiers) : newValue;
        const validateFn = shouldValidate ? validateWithStateMutation : validateValidStateOnly;
        validateFn();
    }
    function setErrors(errors) {
        setState({
            errors: Array.isArray(errors) ? errors : [
                errors
            ]
        });
    }
    const valueProxy = (0, $01W3b.computed)({
        get () {
            return value.value;
        },
        set (newValue) {
            setValue(newValue, validateOnValueUpdate);
        }
    });
    const field = {
        id: id,
        name: name,
        label: label,
        value: valueProxy,
        meta: meta,
        errors: errors,
        errorMessage: errorMessage,
        type: type,
        checkedValue: checkedValue,
        uncheckedValue: uncheckedValue,
        bails: bails,
        keepValueOnUnmount: keepValueOnUnmount,
        resetField: resetField,
        handleReset: ()=>resetField(),
        validate: validate$1,
        handleChange: handleChange,
        handleBlur: handleBlur,
        setState: setState,
        setTouched: setTouched,
        setErrors: setErrors,
        setValue: setValue
    };
    (0, $TusQn.provide)($b8db88280711b5c9$export$82b43ec3fe1404d8, field);
    if ((0, $01W3b.isRef)(rules) && typeof (0, $01W3b.unref)(rules) !== "function") (0, $TusQn.watch)(rules, (value, oldValue)=>{
        if ($b8db88280711b5c9$var$isEqual(value, oldValue)) return;
        meta.validated ? validateWithStateMutation() : validateValidStateOnly();
    }, {
        deep: true
    });
    field._vm = (0, $TusQn.getCurrentInstance)();
    (0, $TusQn.watch)(()=>Object.assign(Object.assign({
            errors: errors.value
        }, meta), {
            value: value.value
        }), $b8db88280711b5c9$var$refreshInspector, {
        deep: true
    });
    if (!form) $b8db88280711b5c9$var$registerSingleFieldWithDevtools(field);
    // if no associated form return the field API immediately
    if (!form) return field;
    // associate the field with the given form
    // extract cross-field dependencies in a computed prop
    const dependencies = (0, $01W3b.computed)(()=>{
        const rulesVal = validator.value;
        // is falsy, a function schema or a yup schema
        if (!rulesVal || $b8db88280711b5c9$var$isCallable(rulesVal) || $b8db88280711b5c9$var$isYupValidator(rulesVal) || $b8db88280711b5c9$var$isTypedSchema(rulesVal) || Array.isArray(rulesVal)) return {};
        return Object.keys(rulesVal).reduce((acc, rule)=>{
            const deps = $b8db88280711b5c9$var$extractLocators(rulesVal[rule]).map((dep)=>dep.__locatorRef).reduce((depAcc, depName)=>{
                const depValue = $b8db88280711b5c9$var$getFromPath(form.values, depName) || form.values[depName];
                if (depValue !== undefined) depAcc[depName] = depValue;
                return depAcc;
            }, {});
            Object.assign(acc, deps);
            return acc;
        }, {});
    });
    // Adds a watcher that runs the validation whenever field dependencies change
    (0, $TusQn.watch)(dependencies, (deps, oldDeps)=>{
        // Skip if no dependencies or if the field wasn't manipulated
        if (!Object.keys(deps).length) return;
        const shouldValidate = !$b8db88280711b5c9$var$isEqual(deps, oldDeps);
        if (shouldValidate) meta.validated ? validateWithStateMutation() : validateValidStateOnly();
    });
    (0, $TusQn.onBeforeUnmount)(()=>{
        var _a;
        const shouldKeepValue = (_a = (0, $01W3b.toValue)(field.keepValueOnUnmount)) !== null && _a !== void 0 ? _a : (0, $01W3b.toValue)(form.keepValuesOnUnmount);
        const path = (0, $01W3b.toValue)(name);
        if (shouldKeepValue || !form || flags.pendingUnmount[field.id]) {
            form === null || form === void 0 || form.removePathState(path, id);
            return;
        }
        flags.pendingUnmount[field.id] = true;
        const pathState = form.getPathState(path);
        const matchesId = Array.isArray(pathState === null || pathState === void 0 ? void 0 : pathState.id) && (pathState === null || pathState === void 0 ? void 0 : pathState.multiple) ? pathState === null || pathState === void 0 ? void 0 : pathState.id.includes(field.id) : (pathState === null || pathState === void 0 ? void 0 : pathState.id) === field.id;
        if (!matchesId) return;
        if ((pathState === null || pathState === void 0 ? void 0 : pathState.multiple) && Array.isArray(pathState.value)) {
            const valueIdx = pathState.value.findIndex((i)=>$b8db88280711b5c9$var$isEqual(i, (0, $01W3b.toValue)(field.checkedValue)));
            if (valueIdx > -1) {
                const newVal = [
                    ...pathState.value
                ];
                newVal.splice(valueIdx, 1);
                form.setFieldValue(path, newVal);
            }
            if (Array.isArray(pathState.id)) pathState.id.splice(pathState.id.indexOf(field.id), 1);
        } else form.unsetPathValue((0, $01W3b.toValue)(name));
        form.removePathState(path, id);
    });
    return field;
}
/**
 * Normalizes partial field options to include the full options
 */ function $b8db88280711b5c9$var$normalizeOptions(opts) {
    const defaults = ()=>({
            initialValue: undefined,
            validateOnMount: false,
            bails: true,
            label: undefined,
            validateOnValueUpdate: true,
            keepValueOnUnmount: undefined,
            syncVModel: false,
            controlled: true
        });
    const isVModelSynced = !!(opts === null || opts === void 0 ? void 0 : opts.syncVModel);
    const modelPropName = typeof (opts === null || opts === void 0 ? void 0 : opts.syncVModel) === "string" ? opts.syncVModel : (opts === null || opts === void 0 ? void 0 : opts.modelPropName) || "modelValue";
    const initialValue = isVModelSynced && !("initialValue" in (opts || {})) ? $b8db88280711b5c9$var$getCurrentModelValue((0, $TusQn.getCurrentInstance)(), modelPropName) : opts === null || opts === void 0 ? void 0 : opts.initialValue;
    if (!opts) return Object.assign(Object.assign({}, defaults()), {
        initialValue: initialValue
    });
    // TODO: Deprecate this in next major release
    const checkedValue = "valueProp" in opts ? opts.valueProp : opts.checkedValue;
    const controlled = "standalone" in opts ? !opts.standalone : opts.controlled;
    const syncVModel = (opts === null || opts === void 0 ? void 0 : opts.modelPropName) || (opts === null || opts === void 0 ? void 0 : opts.syncVModel) || false;
    return Object.assign(Object.assign(Object.assign({}, defaults()), opts || {}), {
        initialValue: initialValue,
        controlled: controlled !== null && controlled !== void 0 ? controlled : true,
        checkedValue: checkedValue,
        syncVModel: syncVModel
    });
}
function $b8db88280711b5c9$var$useFieldWithChecked(name, rules, opts) {
    const form = !(opts === null || opts === void 0 ? void 0 : opts.standalone) ? $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9) : undefined;
    const checkedValue = opts === null || opts === void 0 ? void 0 : opts.checkedValue;
    const uncheckedValue = opts === null || opts === void 0 ? void 0 : opts.uncheckedValue;
    function patchCheckedApi(field) {
        const handleChange = field.handleChange;
        const checked = (0, $01W3b.computed)(()=>{
            const currentValue = (0, $01W3b.toValue)(field.value);
            const checkedVal = (0, $01W3b.toValue)(checkedValue);
            return Array.isArray(currentValue) ? currentValue.findIndex((v)=>$b8db88280711b5c9$var$isEqual(v, checkedVal)) >= 0 : $b8db88280711b5c9$var$isEqual(checkedVal, currentValue);
        });
        function handleCheckboxChange(e, shouldValidate = true) {
            var _a, _b;
            if (checked.value === ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.checked)) {
                if (shouldValidate) field.validate();
                return;
            }
            const path = (0, $01W3b.toValue)(name);
            const pathState = form === null || form === void 0 ? void 0 : form.getPathState(path);
            const value = $b8db88280711b5c9$var$normalizeEventValue(e);
            let newValue = (_b = (0, $01W3b.toValue)(checkedValue)) !== null && _b !== void 0 ? _b : value;
            if (form && (pathState === null || pathState === void 0 ? void 0 : pathState.multiple) && pathState.type === "checkbox") newValue = $b8db88280711b5c9$var$resolveNextCheckboxValue($b8db88280711b5c9$var$getFromPath(form.values, path) || [], newValue, undefined);
            else if ((opts === null || opts === void 0 ? void 0 : opts.type) === "checkbox") newValue = $b8db88280711b5c9$var$resolveNextCheckboxValue((0, $01W3b.toValue)(field.value), newValue, (0, $01W3b.toValue)(uncheckedValue));
            handleChange(newValue, shouldValidate);
        }
        return Object.assign(Object.assign({}, field), {
            checked: checked,
            checkedValue: checkedValue,
            uncheckedValue: uncheckedValue,
            handleChange: handleCheckboxChange
        });
    }
    return patchCheckedApi($b8db88280711b5c9$var$_useField(name, rules, opts));
}
function $b8db88280711b5c9$var$useVModel({ prop: prop, value: value, handleChange: handleChange, shouldValidate: shouldValidate }) {
    const vm = (0, $TusQn.getCurrentInstance)();
    /* istanbul ignore next */ if (!vm || !prop) {
        console.warn("Failed to setup model events because `useField` was not called in setup.");
        return;
    }
    const propName = typeof prop === "string" ? prop : "modelValue";
    const emitName = `update:${propName}`;
    // Component doesn't have a model prop setup (must be defined on the props)
    if (!(propName in vm.props)) return;
    (0, $TusQn.watch)(value, (newValue)=>{
        if ($b8db88280711b5c9$var$isEqual(newValue, $b8db88280711b5c9$var$getCurrentModelValue(vm, propName))) return;
        vm.emit(emitName, newValue);
    });
    (0, $TusQn.watch)(()=>$b8db88280711b5c9$var$getCurrentModelValue(vm, propName), (propValue)=>{
        if (propValue === $b8db88280711b5c9$export$eb758c5980e9ddb2 && value.value === undefined) return;
        const newValue = propValue === $b8db88280711b5c9$export$eb758c5980e9ddb2 ? undefined : propValue;
        if ($b8db88280711b5c9$var$isEqual(newValue, value.value)) return;
        handleChange(newValue, shouldValidate());
    });
}
function $b8db88280711b5c9$var$getCurrentModelValue(vm, propName) {
    if (!vm) return undefined;
    return vm.props[propName];
}
const $b8db88280711b5c9$var$FieldImpl = /** #__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Field",
    inheritAttrs: false,
    props: {
        as: {
            type: [
                String,
                Object
            ],
            default: undefined
        },
        name: {
            type: String,
            required: true
        },
        rules: {
            type: [
                Object,
                String,
                Function
            ],
            default: undefined
        },
        validateOnMount: {
            type: Boolean,
            default: false
        },
        validateOnBlur: {
            type: Boolean,
            default: undefined
        },
        validateOnChange: {
            type: Boolean,
            default: undefined
        },
        validateOnInput: {
            type: Boolean,
            default: undefined
        },
        validateOnModelUpdate: {
            type: Boolean,
            default: undefined
        },
        bails: {
            type: Boolean,
            default: ()=>$b8db88280711b5c9$var$getConfig().bails
        },
        label: {
            type: String,
            default: undefined
        },
        uncheckedValue: {
            type: null,
            default: undefined
        },
        modelValue: {
            type: null,
            default: $b8db88280711b5c9$export$eb758c5980e9ddb2
        },
        modelModifiers: {
            type: null,
            default: ()=>({})
        },
        "onUpdate:modelValue": {
            type: null,
            default: undefined
        },
        standalone: {
            type: Boolean,
            default: false
        },
        keepValue: {
            type: Boolean,
            default: undefined
        }
    },
    setup (props, ctx) {
        const rules = (0, $01W3b.toRef)(props, "rules");
        const name = (0, $01W3b.toRef)(props, "name");
        const label = (0, $01W3b.toRef)(props, "label");
        const uncheckedValue = (0, $01W3b.toRef)(props, "uncheckedValue");
        const keepValue = (0, $01W3b.toRef)(props, "keepValue");
        const { errors: errors, value: value, errorMessage: errorMessage, validate: validateField, handleChange: handleChange, handleBlur: handleBlur, setTouched: setTouched, resetField: resetField, handleReset: handleReset, meta: meta, checked: checked, setErrors: setErrors } = $b8db88280711b5c9$export$294aa081a6c6f55d(name, rules, {
            validateOnMount: props.validateOnMount,
            bails: props.bails,
            standalone: props.standalone,
            type: ctx.attrs.type,
            initialValue: $b8db88280711b5c9$var$resolveInitialValue(props, ctx),
            // Only for checkboxes and radio buttons
            checkedValue: ctx.attrs.value,
            uncheckedValue: uncheckedValue,
            label: label,
            validateOnValueUpdate: props.validateOnModelUpdate,
            keepValueOnUnmount: keepValue,
            syncVModel: true
        });
        // If there is a v-model applied on the component we need to emit the `update:modelValue` whenever the value binding changes
        const onChangeHandler = function handleChangeWithModel(e, shouldValidate = true) {
            handleChange(e, shouldValidate);
        };
        const sharedProps = (0, $01W3b.computed)(()=>{
            const { validateOnInput: validateOnInput, validateOnChange: validateOnChange, validateOnBlur: validateOnBlur, validateOnModelUpdate: validateOnModelUpdate } = $b8db88280711b5c9$var$resolveValidationTriggers(props);
            function baseOnBlur(e) {
                handleBlur(e, validateOnBlur);
                if ($b8db88280711b5c9$var$isCallable(ctx.attrs.onBlur)) ctx.attrs.onBlur(e);
            }
            function baseOnInput(e) {
                onChangeHandler(e, validateOnInput);
                if ($b8db88280711b5c9$var$isCallable(ctx.attrs.onInput)) ctx.attrs.onInput(e);
            }
            function baseOnChange(e) {
                onChangeHandler(e, validateOnChange);
                if ($b8db88280711b5c9$var$isCallable(ctx.attrs.onChange)) ctx.attrs.onChange(e);
            }
            const attrs = {
                name: props.name,
                onBlur: baseOnBlur,
                onInput: baseOnInput,
                onChange: baseOnChange
            };
            attrs["onUpdate:modelValue"] = (e)=>onChangeHandler(e, validateOnModelUpdate);
            return attrs;
        });
        const fieldProps = (0, $01W3b.computed)(()=>{
            const attrs = Object.assign({}, sharedProps.value);
            if ($b8db88280711b5c9$var$hasCheckedAttr(ctx.attrs.type) && checked) attrs.checked = checked.value;
            const tag = $b8db88280711b5c9$var$resolveTag(props, ctx);
            if ($b8db88280711b5c9$var$shouldHaveValueBinding(tag, ctx.attrs)) attrs.value = value.value;
            return attrs;
        });
        const componentProps = (0, $01W3b.computed)(()=>{
            return Object.assign(Object.assign({}, sharedProps.value), {
                modelValue: value.value
            });
        });
        function slotProps() {
            return {
                field: fieldProps.value,
                componentField: componentProps.value,
                value: value.value,
                meta: meta,
                errors: errors.value,
                errorMessage: errorMessage.value,
                validate: validateField,
                resetField: resetField,
                handleChange: onChangeHandler,
                handleInput: (e)=>onChangeHandler(e, false),
                handleReset: handleReset,
                handleBlur: sharedProps.value.onBlur,
                setTouched: setTouched,
                setErrors: setErrors
            };
        }
        ctx.expose({
            value: value,
            meta: meta,
            errors: errors,
            errorMessage: errorMessage,
            setErrors: setErrors,
            setTouched: setTouched,
            reset: resetField,
            validate: validateField,
            handleChange: handleChange
        });
        return ()=>{
            const tag = (0, $TusQn.resolveDynamicComponent)($b8db88280711b5c9$var$resolveTag(props, ctx));
            const children = $b8db88280711b5c9$var$normalizeChildren(tag, ctx, slotProps);
            if (tag) return (0, $TusQn.h)(tag, Object.assign(Object.assign({}, ctx.attrs), fieldProps.value), children);
            return children;
        };
    }
});
function $b8db88280711b5c9$var$resolveTag(props, ctx) {
    let tag = props.as || "";
    if (!props.as && !ctx.slots.default) tag = "input";
    return tag;
}
function $b8db88280711b5c9$var$resolveValidationTriggers(props) {
    var _a, _b, _c, _d;
    const { validateOnInput: validateOnInput, validateOnChange: validateOnChange, validateOnBlur: validateOnBlur, validateOnModelUpdate: validateOnModelUpdate } = $b8db88280711b5c9$var$getConfig();
    return {
        validateOnInput: (_a = props.validateOnInput) !== null && _a !== void 0 ? _a : validateOnInput,
        validateOnChange: (_b = props.validateOnChange) !== null && _b !== void 0 ? _b : validateOnChange,
        validateOnBlur: (_c = props.validateOnBlur) !== null && _c !== void 0 ? _c : validateOnBlur,
        validateOnModelUpdate: (_d = props.validateOnModelUpdate) !== null && _d !== void 0 ? _d : validateOnModelUpdate
    };
}
function $b8db88280711b5c9$var$resolveInitialValue(props, ctx) {
    // Gets the initial value either from `value` prop/attr or `v-model` binding (modelValue)
    // For checkboxes and radio buttons it will always be the model value not the `value` attribute
    if (!$b8db88280711b5c9$var$hasCheckedAttr(ctx.attrs.type)) return $b8db88280711b5c9$var$isPropPresent(props, "modelValue") ? props.modelValue : ctx.attrs.value;
    return $b8db88280711b5c9$var$isPropPresent(props, "modelValue") ? props.modelValue : undefined;
}
const $b8db88280711b5c9$export$a455218a85c89869 = $b8db88280711b5c9$var$FieldImpl;
let $b8db88280711b5c9$var$FORM_COUNTER = 0;
const $b8db88280711b5c9$var$PRIVATE_PATH_STATE_KEYS = [
    "bails",
    "fieldsCount",
    "id",
    "multiple",
    "type",
    "validate"
];
function $b8db88280711b5c9$var$resolveInitialValues(opts) {
    const givenInitial = (opts === null || opts === void 0 ? void 0 : opts.initialValues) || {};
    const providedValues = Object.assign({}, (0, $01W3b.toValue)(givenInitial));
    const schema = (0, $01W3b.unref)(opts === null || opts === void 0 ? void 0 : opts.validationSchema);
    if (schema && $b8db88280711b5c9$var$isTypedSchema(schema) && $b8db88280711b5c9$var$isCallable(schema.cast)) return $b8db88280711b5c9$var$klona(schema.cast(providedValues) || {});
    return $b8db88280711b5c9$var$klona(providedValues);
}
function $b8db88280711b5c9$export$87c0cf8eb5a167e0(opts) {
    var _a;
    const formId = $b8db88280711b5c9$var$FORM_COUNTER++;
    // Prevents fields from double resetting their values, which causes checkboxes to toggle their initial value
    let FIELD_ID_COUNTER = 0;
    // If the form is currently submitting
    const isSubmitting = (0, $01W3b.ref)(false);
    // If the form is currently validating
    const isValidating = (0, $01W3b.ref)(false);
    // The number of times the user tried to submit the form
    const submitCount = (0, $01W3b.ref)(0);
    // field arrays managed by this form
    const fieldArrays = [];
    // a private ref for all form values
    const formValues = (0, $01W3b.reactive)($b8db88280711b5c9$var$resolveInitialValues(opts));
    const pathStates = (0, $01W3b.ref)([]);
    const extraErrorsBag = (0, $01W3b.ref)({});
    const pathStateLookup = (0, $01W3b.ref)({});
    const rebuildPathLookup = $b8db88280711b5c9$var$debounceNextTick(()=>{
        pathStateLookup.value = pathStates.value.reduce((names, state)=>{
            names[$b8db88280711b5c9$var$normalizeFormPath((0, $01W3b.toValue)(state.path))] = state;
            return names;
        }, {});
    });
    /**
     * Manually sets an error message on a specific field
     */ function setFieldError(field, message) {
        const state = findPathState(field);
        if (!state) {
            if (typeof field === "string") extraErrorsBag.value[$b8db88280711b5c9$var$normalizeFormPath(field)] = $b8db88280711b5c9$var$normalizeErrorItem(message);
            return;
        }
        // Move the error from the extras path if exists
        if (typeof field === "string") {
            const normalizedPath = $b8db88280711b5c9$var$normalizeFormPath(field);
            if (extraErrorsBag.value[normalizedPath]) delete extraErrorsBag.value[normalizedPath];
        }
        state.errors = $b8db88280711b5c9$var$normalizeErrorItem(message);
        state.valid = !state.errors.length;
    }
    /**
     * Sets errors for the fields specified in the object
     */ function setErrors(paths) {
        $b8db88280711b5c9$var$keysOf(paths).forEach((path)=>{
            setFieldError(path, paths[path]);
        });
    }
    if (opts === null || opts === void 0 ? void 0 : opts.initialErrors) setErrors(opts.initialErrors);
    const errorBag = (0, $01W3b.computed)(()=>{
        const pathErrors = pathStates.value.reduce((acc, state)=>{
            if (state.errors.length) acc[state.path] = state.errors;
            return acc;
        }, {});
        return Object.assign(Object.assign({}, extraErrorsBag.value), pathErrors);
    });
    // Gets the first error of each field
    const errors = (0, $01W3b.computed)(()=>{
        return $b8db88280711b5c9$var$keysOf(errorBag.value).reduce((acc, key)=>{
            const errors = errorBag.value[key];
            if (errors === null || errors === void 0 ? void 0 : errors.length) acc[key] = errors[0];
            return acc;
        }, {});
    });
    /**
     * Holds a computed reference to all fields names and labels
     */ const fieldNames = (0, $01W3b.computed)(()=>{
        return pathStates.value.reduce((names, state)=>{
            names[state.path] = {
                name: state.path || "",
                label: state.label || ""
            };
            return names;
        }, {});
    });
    const fieldBailsMap = (0, $01W3b.computed)(()=>{
        return pathStates.value.reduce((map, state)=>{
            var _a;
            map[state.path] = (_a = state.bails) !== null && _a !== void 0 ? _a : true;
            return map;
        }, {});
    });
    // mutable non-reactive reference to initial errors
    // we need this to process initial errors then unset them
    const initialErrors = Object.assign({}, (opts === null || opts === void 0 ? void 0 : opts.initialErrors) || {});
    const keepValuesOnUnmount = (_a = opts === null || opts === void 0 ? void 0 : opts.keepValuesOnUnmount) !== null && _a !== void 0 ? _a : false;
    // initial form values
    const { initialValues: initialValues, originalInitialValues: originalInitialValues, setInitialValues: setInitialValues } = $b8db88280711b5c9$var$useFormInitialValues(pathStates, formValues, opts);
    // form meta aggregations
    const meta = $b8db88280711b5c9$var$useFormMeta(pathStates, formValues, originalInitialValues, errors);
    const controlledValues = (0, $01W3b.computed)(()=>{
        return pathStates.value.reduce((acc, state)=>{
            const value = $b8db88280711b5c9$var$getFromPath(formValues, state.path);
            $b8db88280711b5c9$var$setInPath(acc, state.path, value);
            return acc;
        }, {});
    });
    const schema = opts === null || opts === void 0 ? void 0 : opts.validationSchema;
    function createPathState(path, config) {
        var _a, _b;
        const initialValue = (0, $01W3b.computed)(()=>$b8db88280711b5c9$var$getFromPath(initialValues.value, (0, $01W3b.toValue)(path)));
        const pathStateExists = pathStateLookup.value[(0, $01W3b.toValue)(path)];
        const isCheckboxOrRadio = (config === null || config === void 0 ? void 0 : config.type) === "checkbox" || (config === null || config === void 0 ? void 0 : config.type) === "radio";
        if (pathStateExists && isCheckboxOrRadio) {
            pathStateExists.multiple = true;
            const id = FIELD_ID_COUNTER++;
            if (Array.isArray(pathStateExists.id)) pathStateExists.id.push(id);
            else pathStateExists.id = [
                pathStateExists.id,
                id
            ];
            pathStateExists.fieldsCount++;
            pathStateExists.__flags.pendingUnmount[id] = false;
            return pathStateExists;
        }
        const currentValue = (0, $01W3b.computed)(()=>$b8db88280711b5c9$var$getFromPath(formValues, (0, $01W3b.toValue)(path)));
        const pathValue = (0, $01W3b.toValue)(path);
        const unsetBatchIndex = UNSET_BATCH.findIndex((_path)=>_path === pathValue);
        if (unsetBatchIndex !== -1) UNSET_BATCH.splice(unsetBatchIndex, 1);
        const isRequired = (0, $01W3b.computed)(()=>{
            var _a, _b, _c, _d;
            const schemaValue = (0, $01W3b.toValue)(schema);
            if ($b8db88280711b5c9$var$isTypedSchema(schemaValue)) return (_b = (_a = schemaValue.describe) === null || _a === void 0 ? void 0 : _a.call(schemaValue, (0, $01W3b.toValue)(path)).required) !== null && _b !== void 0 ? _b : false;
            // Path own schema
            const configSchemaValue = (0, $01W3b.toValue)(config === null || config === void 0 ? void 0 : config.schema);
            if ($b8db88280711b5c9$var$isTypedSchema(configSchemaValue)) return (_d = (_c = configSchemaValue.describe) === null || _c === void 0 ? void 0 : _c.call(configSchemaValue).required) !== null && _d !== void 0 ? _d : false;
            return false;
        });
        const id = FIELD_ID_COUNTER++;
        const state = (0, $01W3b.reactive)({
            id: id,
            path: path,
            touched: false,
            pending: false,
            valid: true,
            validated: !!((_a = initialErrors[pathValue]) === null || _a === void 0 ? void 0 : _a.length),
            required: isRequired,
            initialValue: initialValue,
            errors: (0, $01W3b.shallowRef)([]),
            bails: (_b = config === null || config === void 0 ? void 0 : config.bails) !== null && _b !== void 0 ? _b : false,
            label: config === null || config === void 0 ? void 0 : config.label,
            type: (config === null || config === void 0 ? void 0 : config.type) || "default",
            value: currentValue,
            multiple: false,
            __flags: {
                pendingUnmount: {
                    [id]: false
                },
                pendingReset: false
            },
            fieldsCount: 1,
            validate: config === null || config === void 0 ? void 0 : config.validate,
            dirty: (0, $01W3b.computed)(()=>{
                return !$b8db88280711b5c9$var$isEqual((0, $01W3b.unref)(currentValue), (0, $01W3b.unref)(initialValue));
            })
        });
        pathStates.value.push(state);
        pathStateLookup.value[pathValue] = state;
        rebuildPathLookup();
        if (errors.value[pathValue] && !initialErrors[pathValue]) (0, $TusQn.nextTick)(()=>{
            validateField(pathValue, {
                mode: "silent"
            });
        });
        // Handles when a path changes
        if ((0, $01W3b.isRef)(path)) (0, $TusQn.watch)(path, (newPath)=>{
            rebuildPathLookup();
            const nextValue = $b8db88280711b5c9$var$klona(currentValue.value);
            pathStateLookup.value[newPath] = state;
            (0, $TusQn.nextTick)(()=>{
                $b8db88280711b5c9$var$setInPath(formValues, newPath, nextValue);
            });
        });
        return state;
    }
    /**
     * Batches validation runs in 5ms batches
     * Must have two distinct batch queues to make sure they don't override each other settings #3783
     */ const debouncedSilentValidation = $b8db88280711b5c9$var$debounceAsync(_validateSchema, 5);
    const debouncedValidation = $b8db88280711b5c9$var$debounceAsync(_validateSchema, 5);
    const validateSchema = $b8db88280711b5c9$var$withLatest(async (mode)=>{
        return await (mode === "silent" ? debouncedSilentValidation() : debouncedValidation());
    }, (formResult, [mode])=>{
        // fields by id lookup
        // errors fields names, we need it to also check if custom errors are updated
        const currentErrorsPaths = $b8db88280711b5c9$var$keysOf(formCtx.errorBag.value);
        // collect all the keys from the schema and all fields
        // this ensures we have a complete key map of all the fields
        const paths = [
            ...new Set([
                ...$b8db88280711b5c9$var$keysOf(formResult.results),
                ...pathStates.value.map((p)=>p.path),
                ...currentErrorsPaths
            ])
        ].sort();
        // aggregates the paths into a single result object while applying the results on the fields
        const results = paths.reduce((validation, _path)=>{
            var _a;
            const expectedPath = _path;
            const pathState = findPathState(expectedPath) || findHoistedPath(expectedPath);
            const messages = ((_a = formResult.results[expectedPath]) === null || _a === void 0 ? void 0 : _a.errors) || [];
            // This is the real path of the field, because it might've been a hoisted field
            const path = (0, $01W3b.toValue)(pathState === null || pathState === void 0 ? void 0 : pathState.path) || expectedPath;
            // It is possible that multiple paths are collected across loops
            // We want to merge them to avoid overriding any iteration's results
            const fieldResult = $b8db88280711b5c9$var$mergeValidationResults({
                errors: messages,
                valid: !messages.length
            }, validation.results[path]);
            validation.results[path] = fieldResult;
            if (!fieldResult.valid) validation.errors[path] = fieldResult.errors[0];
            // clean up extra errors if path state exists
            if (pathState && extraErrorsBag.value[path]) delete extraErrorsBag.value[path];
            // field not rendered
            if (!pathState) {
                setFieldError(path, messages);
                return validation;
            }
            // always update the valid flag regardless of the mode
            pathState.valid = fieldResult.valid;
            if (mode === "silent") return validation;
            if (mode === "validated-only" && !pathState.validated) return validation;
            setFieldError(pathState, fieldResult.errors);
            return validation;
        }, {
            valid: formResult.valid,
            results: {},
            errors: {}
        });
        if (formResult.values) results.values = formResult.values;
        $b8db88280711b5c9$var$keysOf(results.results).forEach((path)=>{
            var _a;
            const pathState = findPathState(path);
            if (!pathState) return;
            if (mode === "silent") return;
            if (mode === "validated-only" && !pathState.validated) return;
            setFieldError(pathState, (_a = results.results[path]) === null || _a === void 0 ? void 0 : _a.errors);
        });
        return results;
    });
    function mutateAllPathState(mutation) {
        pathStates.value.forEach(mutation);
    }
    function findPathState(path) {
        const normalizedPath = typeof path === "string" ? $b8db88280711b5c9$var$normalizeFormPath(path) : path;
        const pathState = typeof normalizedPath === "string" ? pathStateLookup.value[normalizedPath] : normalizedPath;
        return pathState;
    }
    function findHoistedPath(path) {
        const candidates = pathStates.value.filter((state)=>path.startsWith(state.path));
        return candidates.reduce((bestCandidate, candidate)=>{
            if (!bestCandidate) return candidate;
            return candidate.path.length > bestCandidate.path.length ? candidate : bestCandidate;
        }, undefined);
    }
    let UNSET_BATCH = [];
    let PENDING_UNSET;
    function unsetPathValue(path) {
        UNSET_BATCH.push(path);
        if (!PENDING_UNSET) PENDING_UNSET = (0, $TusQn.nextTick)(()=>{
            const sortedPaths = [
                ...UNSET_BATCH
            ].sort().reverse();
            sortedPaths.forEach((p)=>{
                $b8db88280711b5c9$var$unsetPath(formValues, p);
            });
            UNSET_BATCH = [];
            PENDING_UNSET = null;
        });
        return PENDING_UNSET;
    }
    function makeSubmissionFactory(onlyControlled) {
        return function submitHandlerFactory(fn, onValidationError) {
            return function submissionHandler(e) {
                if (e instanceof Event) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                // Touch all fields
                mutateAllPathState((s)=>s.touched = true);
                isSubmitting.value = true;
                submitCount.value++;
                return validate().then((result)=>{
                    const values = $b8db88280711b5c9$var$klona(formValues);
                    if (result.valid && typeof fn === "function") {
                        const controlled = $b8db88280711b5c9$var$klona(controlledValues.value);
                        let submittedValues = onlyControlled ? controlled : values;
                        if (result.values) submittedValues = result.values;
                        return fn(submittedValues, {
                            evt: e,
                            controlledValues: controlled,
                            setErrors: setErrors,
                            setFieldError: setFieldError,
                            setTouched: setTouched,
                            setFieldTouched: setFieldTouched,
                            setValues: setValues,
                            setFieldValue: setFieldValue,
                            resetForm: resetForm,
                            resetField: resetField
                        });
                    }
                    if (!result.valid && typeof onValidationError === "function") onValidationError({
                        values: values,
                        evt: e,
                        errors: result.errors,
                        results: result.results
                    });
                }).then((returnVal)=>{
                    isSubmitting.value = false;
                    return returnVal;
                }, (err)=>{
                    isSubmitting.value = false;
                    // re-throw the err so it doesn't go silent
                    throw err;
                });
            };
        };
    }
    const handleSubmitImpl = makeSubmissionFactory(false);
    const handleSubmit = handleSubmitImpl;
    handleSubmit.withControlled = makeSubmissionFactory(true);
    function removePathState(path, id) {
        const idx = pathStates.value.findIndex((s)=>{
            return s.path === path && (Array.isArray(s.id) ? s.id.includes(id) : s.id === id);
        });
        const pathState = pathStates.value[idx];
        if (idx === -1 || !pathState) return;
        (0, $TusQn.nextTick)(()=>{
            validateField(path, {
                mode: "silent",
                warn: false
            });
        });
        if (pathState.multiple && pathState.fieldsCount) pathState.fieldsCount--;
        if (Array.isArray(pathState.id)) {
            const idIndex = pathState.id.indexOf(id);
            if (idIndex >= 0) pathState.id.splice(idIndex, 1);
            delete pathState.__flags.pendingUnmount[id];
        }
        if (!pathState.multiple || pathState.fieldsCount <= 0) {
            pathStates.value.splice(idx, 1);
            unsetInitialValue(path);
            rebuildPathLookup();
            delete pathStateLookup.value[path];
        }
    }
    function destroyPath(path) {
        $b8db88280711b5c9$var$keysOf(pathStateLookup.value).forEach((key)=>{
            if (key.startsWith(path)) delete pathStateLookup.value[key];
        });
        pathStates.value = pathStates.value.filter((s)=>!s.path.startsWith(path));
        (0, $TusQn.nextTick)(()=>{
            rebuildPathLookup();
        });
    }
    const formCtx = {
        formId: formId,
        values: formValues,
        controlledValues: controlledValues,
        errorBag: errorBag,
        errors: errors,
        schema: schema,
        submitCount: submitCount,
        meta: meta,
        isSubmitting: isSubmitting,
        isValidating: isValidating,
        fieldArrays: fieldArrays,
        keepValuesOnUnmount: keepValuesOnUnmount,
        validateSchema: (0, $01W3b.unref)(schema) ? validateSchema : undefined,
        validate: validate,
        setFieldError: setFieldError,
        validateField: validateField,
        setFieldValue: setFieldValue,
        setValues: setValues,
        setErrors: setErrors,
        setFieldTouched: setFieldTouched,
        setTouched: setTouched,
        resetForm: resetForm,
        resetField: resetField,
        handleSubmit: handleSubmit,
        useFieldModel: useFieldModel,
        defineInputBinds: defineInputBinds,
        defineComponentBinds: defineComponentBinds,
        defineField: defineField,
        stageInitialValue: stageInitialValue,
        unsetInitialValue: unsetInitialValue,
        setFieldInitialValue: setFieldInitialValue,
        createPathState: createPathState,
        getPathState: findPathState,
        unsetPathValue: unsetPathValue,
        removePathState: removePathState,
        initialValues: initialValues,
        getAllPathStates: ()=>pathStates.value,
        destroyPath: destroyPath,
        isFieldTouched: isFieldTouched,
        isFieldDirty: isFieldDirty,
        isFieldValid: isFieldValid
    };
    /**
     * Sets a single field value
     */ function setFieldValue(field, value, shouldValidate = true) {
        const clonedValue = $b8db88280711b5c9$var$klona(value);
        const path = typeof field === "string" ? field : field.path;
        const pathState = findPathState(path);
        if (!pathState) createPathState(path);
        $b8db88280711b5c9$var$setInPath(formValues, path, clonedValue);
        if (shouldValidate) validateField(path);
    }
    function forceSetValues(fields, shouldValidate = true) {
        // clean up old values
        $b8db88280711b5c9$var$keysOf(formValues).forEach((key)=>{
            delete formValues[key];
        });
        // set up new values
        $b8db88280711b5c9$var$keysOf(fields).forEach((path)=>{
            setFieldValue(path, fields[path], false);
        });
        if (shouldValidate) validate();
    }
    /**
     * Sets multiple fields values
     */ function setValues(fields, shouldValidate = true) {
        $b8db88280711b5c9$var$merge(formValues, fields);
        // regenerate the arrays when the form values change
        fieldArrays.forEach((f)=>f && f.reset());
        if (shouldValidate) validate();
    }
    function createModel(path, shouldValidate) {
        const pathState = findPathState((0, $01W3b.toValue)(path)) || createPathState(path);
        return (0, $01W3b.computed)({
            get () {
                return pathState.value;
            },
            set (value) {
                var _a;
                const pathValue = (0, $01W3b.toValue)(path);
                setFieldValue(pathValue, value, (_a = (0, $01W3b.toValue)(shouldValidate)) !== null && _a !== void 0 ? _a : false);
            }
        });
    }
    /**
     * Sets the touched meta state on a field
     */ function setFieldTouched(field, isTouched) {
        const pathState = findPathState(field);
        if (pathState) pathState.touched = isTouched;
    }
    function isFieldTouched(field) {
        const pathState = findPathState(field);
        if (pathState) return pathState.touched;
        // Find all nested paths and consider their touched state
        return pathStates.value.filter((s)=>s.path.startsWith(field)).some((s)=>s.touched);
    }
    function isFieldDirty(field) {
        const pathState = findPathState(field);
        if (pathState) return pathState.dirty;
        return pathStates.value.filter((s)=>s.path.startsWith(field)).some((s)=>s.dirty);
    }
    function isFieldValid(field) {
        const pathState = findPathState(field);
        if (pathState) return pathState.valid;
        return pathStates.value.filter((s)=>s.path.startsWith(field)).every((s)=>s.valid);
    }
    /**
     * Sets the touched meta state on multiple fields
     */ function setTouched(fields) {
        if (typeof fields === "boolean") {
            mutateAllPathState((state)=>{
                state.touched = fields;
            });
            return;
        }
        $b8db88280711b5c9$var$keysOf(fields).forEach((field)=>{
            setFieldTouched(field, !!fields[field]);
        });
    }
    function resetField(field, state) {
        var _a;
        const newValue = state && "value" in state ? state.value : $b8db88280711b5c9$var$getFromPath(initialValues.value, field);
        const pathState = findPathState(field);
        if (pathState) pathState.__flags.pendingReset = true;
        setFieldInitialValue(field, $b8db88280711b5c9$var$klona(newValue), true);
        setFieldValue(field, newValue, false);
        setFieldTouched(field, (_a = state === null || state === void 0 ? void 0 : state.touched) !== null && _a !== void 0 ? _a : false);
        setFieldError(field, (state === null || state === void 0 ? void 0 : state.errors) || []);
        (0, $TusQn.nextTick)(()=>{
            if (pathState) pathState.__flags.pendingReset = false;
        });
    }
    /**
     * Resets all fields
     */ function resetForm(resetState, opts) {
        let newValues = $b8db88280711b5c9$var$klona((resetState === null || resetState === void 0 ? void 0 : resetState.values) ? resetState.values : originalInitialValues.value);
        newValues = (opts === null || opts === void 0 ? void 0 : opts.force) ? newValues : $b8db88280711b5c9$var$merge(originalInitialValues.value, newValues);
        newValues = $b8db88280711b5c9$var$isTypedSchema(schema) && $b8db88280711b5c9$var$isCallable(schema.cast) ? schema.cast(newValues) : newValues;
        setInitialValues(newValues);
        mutateAllPathState((state)=>{
            var _a;
            state.__flags.pendingReset = true;
            state.validated = false;
            state.touched = ((_a = resetState === null || resetState === void 0 ? void 0 : resetState.touched) === null || _a === void 0 ? void 0 : _a[state.path]) || false;
            setFieldValue(state.path, $b8db88280711b5c9$var$getFromPath(newValues, state.path), false);
            setFieldError(state.path, undefined);
        });
        (opts === null || opts === void 0 ? void 0 : opts.force) ? forceSetValues(newValues, false) : setValues(newValues, false);
        setErrors((resetState === null || resetState === void 0 ? void 0 : resetState.errors) || {});
        submitCount.value = (resetState === null || resetState === void 0 ? void 0 : resetState.submitCount) || 0;
        (0, $TusQn.nextTick)(()=>{
            validate({
                mode: "silent"
            });
            mutateAllPathState((state)=>{
                state.__flags.pendingReset = false;
            });
        });
    }
    async function validate(opts) {
        const mode = (opts === null || opts === void 0 ? void 0 : opts.mode) || "force";
        if (mode === "force") mutateAllPathState((f)=>f.validated = true);
        if (formCtx.validateSchema) return formCtx.validateSchema(mode);
        isValidating.value = true;
        // No schema, each field is responsible to validate itself
        const validations = await Promise.all(pathStates.value.map((state)=>{
            if (!state.validate) return Promise.resolve({
                key: state.path,
                valid: true,
                errors: []
            });
            return state.validate(opts).then((result)=>{
                return {
                    key: state.path,
                    valid: result.valid,
                    errors: result.errors
                };
            });
        }));
        isValidating.value = false;
        const results = {};
        const errors = {};
        for (const validation of validations){
            results[validation.key] = {
                valid: validation.valid,
                errors: validation.errors
            };
            if (validation.errors.length) errors[validation.key] = validation.errors[0];
        }
        return {
            valid: validations.every((r)=>r.valid),
            results: results,
            errors: errors
        };
    }
    async function validateField(path, opts) {
        var _a;
        const state = findPathState(path);
        if (state && (opts === null || opts === void 0 ? void 0 : opts.mode) !== "silent") state.validated = true;
        if (schema) {
            const { results: results } = await validateSchema((opts === null || opts === void 0 ? void 0 : opts.mode) || "validated-only");
            return results[path] || {
                errors: [],
                valid: true
            };
        }
        if (state === null || state === void 0 ? void 0 : state.validate) return state.validate(opts);
        const shouldWarn = !state && ((_a = opts === null || opts === void 0 ? void 0 : opts.warn) !== null && _a !== void 0 ? _a : true);
        if (shouldWarn) (0, $TusQn.warn)(`field with path ${path} was not found`);
        return Promise.resolve({
            errors: [],
            valid: true
        });
    }
    function unsetInitialValue(path) {
        $b8db88280711b5c9$var$unsetPath(initialValues.value, path);
    }
    /**
     * Sneaky function to set initial field values
     */ function stageInitialValue(path, value, updateOriginal = false) {
        setFieldInitialValue(path, value);
        $b8db88280711b5c9$var$setInPath(formValues, path, value);
        if (updateOriginal && !(opts === null || opts === void 0 ? void 0 : opts.initialValues)) $b8db88280711b5c9$var$setInPath(originalInitialValues.value, path, $b8db88280711b5c9$var$klona(value));
    }
    function setFieldInitialValue(path, value, updateOriginal = false) {
        $b8db88280711b5c9$var$setInPath(initialValues.value, path, $b8db88280711b5c9$var$klona(value));
        if (updateOriginal) $b8db88280711b5c9$var$setInPath(originalInitialValues.value, path, $b8db88280711b5c9$var$klona(value));
    }
    async function _validateSchema() {
        const schemaValue = (0, $01W3b.unref)(schema);
        if (!schemaValue) return {
            valid: true,
            results: {},
            errors: {}
        };
        isValidating.value = true;
        const formResult = $b8db88280711b5c9$var$isYupValidator(schemaValue) || $b8db88280711b5c9$var$isTypedSchema(schemaValue) ? await $b8db88280711b5c9$var$validateTypedSchema(schemaValue, formValues) : await $b8db88280711b5c9$export$381bae2d0f08004f(schemaValue, formValues, {
            names: fieldNames.value,
            bailsMap: fieldBailsMap.value
        });
        isValidating.value = false;
        return formResult;
    }
    const submitForm = handleSubmit((_, { evt: evt })=>{
        if ($b8db88280711b5c9$var$isFormSubmitEvent(evt)) evt.target.submit();
    });
    // Trigger initial validation
    (0, $TusQn.onMounted)(()=>{
        if (opts === null || opts === void 0 ? void 0 : opts.initialErrors) setErrors(opts.initialErrors);
        if (opts === null || opts === void 0 ? void 0 : opts.initialTouched) setTouched(opts.initialTouched);
        // if validate on mount was enabled
        if (opts === null || opts === void 0 ? void 0 : opts.validateOnMount) {
            validate();
            return;
        }
        // otherwise run initial silent validation through schema if available
        // the useField should skip their own silent validation if a yup schema is present
        if (formCtx.validateSchema) formCtx.validateSchema("silent");
    });
    if ((0, $01W3b.isRef)(schema)) (0, $TusQn.watch)(schema, ()=>{
        var _a;
        (_a = formCtx.validateSchema) === null || _a === void 0 || _a.call(formCtx, "validated-only");
    });
    // Provide injections
    (0, $TusQn.provide)($b8db88280711b5c9$export$34448771f7911aa9, formCtx);
    $b8db88280711b5c9$var$registerFormWithDevTools(formCtx);
    (0, $TusQn.watch)(()=>Object.assign(Object.assign({
            errors: errorBag.value
        }, meta.value), {
            values: formValues,
            isSubmitting: isSubmitting.value,
            isValidating: isValidating.value,
            submitCount: submitCount.value
        }), $b8db88280711b5c9$var$refreshInspector, {
        deep: true
    });
    function defineField(path, config) {
        const label = $b8db88280711b5c9$var$isCallable(config) ? undefined : config === null || config === void 0 ? void 0 : config.label;
        const pathState = findPathState((0, $01W3b.toValue)(path)) || createPathState(path, {
            label: label
        });
        const evalConfig = ()=>$b8db88280711b5c9$var$isCallable(config) ? config($b8db88280711b5c9$var$omit(pathState, $b8db88280711b5c9$var$PRIVATE_PATH_STATE_KEYS)) : config || {};
        function onBlur() {
            var _a;
            pathState.touched = true;
            const validateOnBlur = (_a = evalConfig().validateOnBlur) !== null && _a !== void 0 ? _a : $b8db88280711b5c9$var$getConfig().validateOnBlur;
            if (validateOnBlur) validateField(pathState.path);
        }
        function onInput() {
            var _a;
            const validateOnInput = (_a = evalConfig().validateOnInput) !== null && _a !== void 0 ? _a : $b8db88280711b5c9$var$getConfig().validateOnInput;
            if (validateOnInput) (0, $TusQn.nextTick)(()=>{
                validateField(pathState.path);
            });
        }
        function onChange() {
            var _a;
            const validateOnChange = (_a = evalConfig().validateOnChange) !== null && _a !== void 0 ? _a : $b8db88280711b5c9$var$getConfig().validateOnChange;
            if (validateOnChange) (0, $TusQn.nextTick)(()=>{
                validateField(pathState.path);
            });
        }
        const props = (0, $01W3b.computed)(()=>{
            const base = {
                onChange: onChange,
                onInput: onInput,
                onBlur: onBlur
            };
            if ($b8db88280711b5c9$var$isCallable(config)) return Object.assign(Object.assign({}, base), config($b8db88280711b5c9$var$omit(pathState, $b8db88280711b5c9$var$PRIVATE_PATH_STATE_KEYS)).props || {});
            if (config === null || config === void 0 ? void 0 : config.props) return Object.assign(Object.assign({}, base), config.props($b8db88280711b5c9$var$omit(pathState, $b8db88280711b5c9$var$PRIVATE_PATH_STATE_KEYS)));
            return base;
        });
        const model = createModel(path, ()=>{
            var _a, _b, _c;
            return (_c = (_a = evalConfig().validateOnModelUpdate) !== null && _a !== void 0 ? _a : (_b = $b8db88280711b5c9$var$getConfig()) === null || _b === void 0 ? void 0 : _b.validateOnModelUpdate) !== null && _c !== void 0 ? _c : true;
        });
        return [
            model,
            props
        ];
    }
    function useFieldModel(pathOrPaths) {
        if (!Array.isArray(pathOrPaths)) return createModel(pathOrPaths);
        return pathOrPaths.map((p)=>createModel(p, true));
    }
    /**
     * @deprecated use defineField instead
     */ function defineInputBinds(path, config) {
        const [model, props] = defineField(path, config);
        function onBlur() {
            props.value.onBlur();
        }
        function onInput(e) {
            const value = $b8db88280711b5c9$var$normalizeEventValue(e);
            setFieldValue((0, $01W3b.toValue)(path), value, false);
            props.value.onInput();
        }
        function onChange(e) {
            const value = $b8db88280711b5c9$var$normalizeEventValue(e);
            setFieldValue((0, $01W3b.toValue)(path), value, false);
            props.value.onChange();
        }
        return (0, $01W3b.computed)(()=>{
            return Object.assign(Object.assign({}, props.value), {
                onBlur: onBlur,
                onInput: onInput,
                onChange: onChange,
                value: model.value
            });
        });
    }
    /**
     * @deprecated use defineField instead
     */ function defineComponentBinds(path, config) {
        const [model, props] = defineField(path, config);
        const pathState = findPathState((0, $01W3b.toValue)(path));
        function onUpdateModelValue(value) {
            model.value = value;
        }
        return (0, $01W3b.computed)(()=>{
            const conf = $b8db88280711b5c9$var$isCallable(config) ? config($b8db88280711b5c9$var$omit(pathState, $b8db88280711b5c9$var$PRIVATE_PATH_STATE_KEYS)) : config || {};
            return Object.assign({
                [conf.model || "modelValue"]: model.value,
                [`onUpdate:${conf.model || "modelValue"}`]: onUpdateModelValue
            }, props.value);
        });
    }
    return Object.assign(Object.assign({}, formCtx), {
        values: (0, $01W3b.readonly)(formValues),
        handleReset: ()=>resetForm(),
        submitForm: submitForm
    });
}
/**
 * Manages form meta aggregation
 */ function $b8db88280711b5c9$var$useFormMeta(pathsState, currentValues, initialValues, errors) {
    const MERGE_STRATEGIES = {
        touched: "some",
        pending: "some",
        valid: "every"
    };
    const isDirty = (0, $01W3b.computed)(()=>{
        return !$b8db88280711b5c9$var$isEqual(currentValues, (0, $01W3b.unref)(initialValues));
    });
    function calculateFlags() {
        const states = pathsState.value;
        return $b8db88280711b5c9$var$keysOf(MERGE_STRATEGIES).reduce((acc, flag)=>{
            const mergeMethod = MERGE_STRATEGIES[flag];
            acc[flag] = states[mergeMethod]((s)=>s[flag]);
            return acc;
        }, {});
    }
    const flags = (0, $01W3b.reactive)(calculateFlags());
    (0, $TusQn.watchEffect)(()=>{
        const value = calculateFlags();
        flags.touched = value.touched;
        flags.valid = value.valid;
        flags.pending = value.pending;
    });
    return (0, $01W3b.computed)(()=>{
        return Object.assign(Object.assign({
            initialValues: (0, $01W3b.unref)(initialValues)
        }, flags), {
            valid: flags.valid && !$b8db88280711b5c9$var$keysOf(errors.value).length,
            dirty: isDirty.value
        });
    });
}
/**
 * Manages the initial values prop
 */ function $b8db88280711b5c9$var$useFormInitialValues(pathsState, formValues, opts) {
    const values = $b8db88280711b5c9$var$resolveInitialValues(opts);
    // these are the mutable initial values as the fields are mounted/unmounted
    const initialValues = (0, $01W3b.ref)(values);
    // these are the original initial value as provided by the user initially, they don't keep track of conditional fields
    // this is important because some conditional fields will overwrite the initial values for other fields who had the same name
    // like array fields, any push/insert operation will overwrite the initial values because they "create new fields"
    // so these are the values that the reset function should use
    // these only change when the user explicitly changes the initial values or when the user resets them with new values.
    const originalInitialValues = (0, $01W3b.ref)($b8db88280711b5c9$var$klona(values));
    function setInitialValues(values, updateFields = false) {
        initialValues.value = $b8db88280711b5c9$var$merge($b8db88280711b5c9$var$klona(initialValues.value) || {}, $b8db88280711b5c9$var$klona(values));
        originalInitialValues.value = $b8db88280711b5c9$var$merge($b8db88280711b5c9$var$klona(originalInitialValues.value) || {}, $b8db88280711b5c9$var$klona(values));
        if (!updateFields) return;
        // update the pristine non-touched fields
        // those are excluded because it's unlikely you want to change the form values using initial values
        // we mostly watch them for API population or newly inserted fields
        // if the user API is taking too much time before user interaction they should consider disabling or hiding their inputs until the values are ready
        pathsState.value.forEach((state)=>{
            const wasTouched = state.touched;
            if (wasTouched) return;
            const newValue = $b8db88280711b5c9$var$getFromPath(initialValues.value, state.path);
            $b8db88280711b5c9$var$setInPath(formValues, state.path, $b8db88280711b5c9$var$klona(newValue));
        });
    }
    return {
        initialValues: initialValues,
        originalInitialValues: originalInitialValues,
        setInitialValues: setInitialValues
    };
}
function $b8db88280711b5c9$var$mergeValidationResults(a, b) {
    if (!b) return a;
    return {
        valid: a.valid && b.valid,
        errors: [
            ...a.errors,
            ...b.errors
        ]
    };
}
const $b8db88280711b5c9$var$FormImpl = /** #__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Form",
    inheritAttrs: false,
    props: {
        as: {
            type: null,
            default: "form"
        },
        validationSchema: {
            type: Object,
            default: undefined
        },
        initialValues: {
            type: Object,
            default: undefined
        },
        initialErrors: {
            type: Object,
            default: undefined
        },
        initialTouched: {
            type: Object,
            default: undefined
        },
        validateOnMount: {
            type: Boolean,
            default: false
        },
        onSubmit: {
            type: Function,
            default: undefined
        },
        onInvalidSubmit: {
            type: Function,
            default: undefined
        },
        keepValues: {
            type: Boolean,
            default: false
        }
    },
    setup (props, ctx) {
        const validationSchema = (0, $01W3b.toRef)(props, "validationSchema");
        const keepValues = (0, $01W3b.toRef)(props, "keepValues");
        const { errors: errors, errorBag: errorBag, values: values, meta: meta, isSubmitting: isSubmitting, isValidating: isValidating, submitCount: submitCount, controlledValues: controlledValues, validate: validate, validateField: validateField, handleReset: handleReset, resetForm: resetForm, handleSubmit: handleSubmit, setErrors: setErrors, setFieldError: setFieldError, setFieldValue: setFieldValue, setValues: setValues, setFieldTouched: setFieldTouched, setTouched: setTouched, resetField: resetField } = $b8db88280711b5c9$export$87c0cf8eb5a167e0({
            validationSchema: validationSchema.value ? validationSchema : undefined,
            initialValues: props.initialValues,
            initialErrors: props.initialErrors,
            initialTouched: props.initialTouched,
            validateOnMount: props.validateOnMount,
            keepValuesOnUnmount: keepValues
        });
        const submitForm = handleSubmit((_, { evt: evt })=>{
            if ($b8db88280711b5c9$var$isFormSubmitEvent(evt)) evt.target.submit();
        }, props.onInvalidSubmit);
        const onSubmit = props.onSubmit ? handleSubmit(props.onSubmit, props.onInvalidSubmit) : submitForm;
        function handleFormReset(e) {
            if ($b8db88280711b5c9$var$isEvent(e)) // Prevent default form reset behavior
            e.preventDefault();
            handleReset();
            if (typeof ctx.attrs.onReset === "function") ctx.attrs.onReset();
        }
        function handleScopedSlotSubmit(evt, onSubmit) {
            const onSuccess = typeof evt === "function" && !onSubmit ? evt : onSubmit;
            return handleSubmit(onSuccess, props.onInvalidSubmit)(evt);
        }
        function getValues() {
            return $b8db88280711b5c9$var$klona(values);
        }
        function getMeta() {
            return $b8db88280711b5c9$var$klona(meta.value);
        }
        function getErrors() {
            return $b8db88280711b5c9$var$klona(errors.value);
        }
        function slotProps() {
            return {
                meta: meta.value,
                errors: errors.value,
                errorBag: errorBag.value,
                values: values,
                isSubmitting: isSubmitting.value,
                isValidating: isValidating.value,
                submitCount: submitCount.value,
                controlledValues: controlledValues.value,
                validate: validate,
                validateField: validateField,
                handleSubmit: handleScopedSlotSubmit,
                handleReset: handleReset,
                submitForm: submitForm,
                setErrors: setErrors,
                setFieldError: setFieldError,
                setFieldValue: setFieldValue,
                setValues: setValues,
                setFieldTouched: setFieldTouched,
                setTouched: setTouched,
                resetForm: resetForm,
                resetField: resetField,
                getValues: getValues,
                getMeta: getMeta,
                getErrors: getErrors
            };
        }
        // expose these functions and methods as part of public API
        ctx.expose({
            setFieldError: setFieldError,
            setErrors: setErrors,
            setFieldValue: setFieldValue,
            setValues: setValues,
            setFieldTouched: setFieldTouched,
            setTouched: setTouched,
            resetForm: resetForm,
            validate: validate,
            validateField: validateField,
            resetField: resetField,
            getValues: getValues,
            getMeta: getMeta,
            getErrors: getErrors,
            values: values,
            meta: meta,
            errors: errors
        });
        return function renderForm() {
            // avoid resolving the form component as itself
            const tag = props.as === "form" ? props.as : !props.as ? null : (0, $TusQn.resolveDynamicComponent)(props.as);
            const children = $b8db88280711b5c9$var$normalizeChildren(tag, ctx, slotProps);
            if (!tag) return children;
            // Attributes to add on a native `form` tag
            const formAttrs = tag === "form" ? {
                // Disables native validation as vee-validate will handle it.
                novalidate: true
            } : {};
            return (0, $TusQn.h)(tag, Object.assign(Object.assign(Object.assign({}, formAttrs), ctx.attrs), {
                onSubmit: onSubmit,
                onReset: handleFormReset
            }), children);
        };
    }
});
const $b8db88280711b5c9$export$a7fed597f4b8afd8 = $b8db88280711b5c9$var$FormImpl;
function $b8db88280711b5c9$export$310131896651d559(arrayPath) {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9, undefined);
    const fields = (0, $01W3b.ref)([]);
    const noOp = ()=>{};
    const noOpApi = {
        fields: fields,
        remove: noOp,
        push: noOp,
        swap: noOp,
        insert: noOp,
        update: noOp,
        replace: noOp,
        prepend: noOp,
        move: noOp
    };
    if (!form) {
        $b8db88280711b5c9$var$warn("FieldArray requires being a child of `<Form/>` or `useForm` being called before it. Array fields may not work correctly");
        return noOpApi;
    }
    if (!(0, $01W3b.unref)(arrayPath)) {
        $b8db88280711b5c9$var$warn("FieldArray requires a field path to be provided, did you forget to pass the `name` prop?");
        return noOpApi;
    }
    const alreadyExists = form.fieldArrays.find((a)=>(0, $01W3b.unref)(a.path) === (0, $01W3b.unref)(arrayPath));
    if (alreadyExists) return alreadyExists;
    let entryCounter = 0;
    function getCurrentValues() {
        return $b8db88280711b5c9$var$getFromPath(form === null || form === void 0 ? void 0 : form.values, (0, $01W3b.toValue)(arrayPath), []) || [];
    }
    function initFields() {
        const currentValues = getCurrentValues();
        if (!Array.isArray(currentValues)) return;
        fields.value = currentValues.map((v, idx)=>createEntry(v, idx, fields.value));
        updateEntryFlags();
    }
    initFields();
    function updateEntryFlags() {
        const fieldsLength = fields.value.length;
        for(let i = 0; i < fieldsLength; i++){
            const entry = fields.value[i];
            entry.isFirst = i === 0;
            entry.isLast = i === fieldsLength - 1;
        }
    }
    function createEntry(value, idx, currentFields) {
        // Skips the work by returning the current entry if it already exists
        // This should make the `key` prop stable and doesn't cause more re-renders than needed
        // The value is computed and should update anyways
        if (currentFields && !$b8db88280711b5c9$var$isNullOrUndefined(idx) && currentFields[idx]) return currentFields[idx];
        const key = entryCounter++;
        const entry = {
            key: key,
            value: $b8db88280711b5c9$var$computedDeep({
                get () {
                    const currentValues = $b8db88280711b5c9$var$getFromPath(form === null || form === void 0 ? void 0 : form.values, (0, $01W3b.toValue)(arrayPath), []) || [];
                    const idx = fields.value.findIndex((e)=>e.key === key);
                    return idx === -1 ? value : currentValues[idx];
                },
                set (value) {
                    const idx = fields.value.findIndex((e)=>e.key === key);
                    if (idx === -1) {
                        $b8db88280711b5c9$var$warn(`Attempting to update a non-existent array item`);
                        return;
                    }
                    update(idx, value);
                }
            }),
            isFirst: false,
            isLast: false
        };
        return entry;
    }
    function afterMutation() {
        updateEntryFlags();
        // Should trigger a silent validation since a field may not do that #4096
        form === null || form === void 0 || form.validate({
            mode: "silent"
        });
    }
    function remove(idx) {
        const pathName = (0, $01W3b.toValue)(arrayPath);
        const pathValue = $b8db88280711b5c9$var$getFromPath(form === null || form === void 0 ? void 0 : form.values, pathName);
        if (!pathValue || !Array.isArray(pathValue)) return;
        const newValue = [
            ...pathValue
        ];
        newValue.splice(idx, 1);
        const fieldPath = pathName + `[${idx}]`;
        form.destroyPath(fieldPath);
        form.unsetInitialValue(fieldPath);
        $b8db88280711b5c9$var$setInPath(form.values, pathName, newValue);
        fields.value.splice(idx, 1);
        afterMutation();
    }
    function push(initialValue) {
        const value = $b8db88280711b5c9$var$klona(initialValue);
        const pathName = (0, $01W3b.toValue)(arrayPath);
        const pathValue = $b8db88280711b5c9$var$getFromPath(form === null || form === void 0 ? void 0 : form.values, pathName);
        const normalizedPathValue = $b8db88280711b5c9$var$isNullOrUndefined(pathValue) ? [] : pathValue;
        if (!Array.isArray(normalizedPathValue)) return;
        const newValue = [
            ...normalizedPathValue
        ];
        newValue.push(value);
        form.stageInitialValue(pathName + `[${newValue.length - 1}]`, value);
        $b8db88280711b5c9$var$setInPath(form.values, pathName, newValue);
        fields.value.push(createEntry(value));
        afterMutation();
    }
    function swap(indexA, indexB) {
        const pathName = (0, $01W3b.toValue)(arrayPath);
        const pathValue = $b8db88280711b5c9$var$getFromPath(form === null || form === void 0 ? void 0 : form.values, pathName);
        if (!Array.isArray(pathValue) || !(indexA in pathValue) || !(indexB in pathValue)) return;
        const newValue = [
            ...pathValue
        ];
        const newFields = [
            ...fields.value
        ];
        // the old switcheroo
        const temp = newValue[indexA];
        newValue[indexA] = newValue[indexB];
        newValue[indexB] = temp;
        const tempEntry = newFields[indexA];
        newFields[indexA] = newFields[indexB];
        newFields[indexB] = tempEntry;
        $b8db88280711b5c9$var$setInPath(form.values, pathName, newValue);
        fields.value = newFields;
        updateEntryFlags();
    }
    function insert(idx, initialValue) {
        const value = $b8db88280711b5c9$var$klona(initialValue);
        const pathName = (0, $01W3b.toValue)(arrayPath);
        const pathValue = $b8db88280711b5c9$var$getFromPath(form === null || form === void 0 ? void 0 : form.values, pathName);
        if (!Array.isArray(pathValue) || pathValue.length < idx) return;
        const newValue = [
            ...pathValue
        ];
        const newFields = [
            ...fields.value
        ];
        newValue.splice(idx, 0, value);
        newFields.splice(idx, 0, createEntry(value));
        $b8db88280711b5c9$var$setInPath(form.values, pathName, newValue);
        fields.value = newFields;
        afterMutation();
    }
    function replace(arr) {
        const pathName = (0, $01W3b.toValue)(arrayPath);
        form.stageInitialValue(pathName, arr);
        $b8db88280711b5c9$var$setInPath(form.values, pathName, arr);
        initFields();
        afterMutation();
    }
    function update(idx, value) {
        const pathName = (0, $01W3b.toValue)(arrayPath);
        const pathValue = $b8db88280711b5c9$var$getFromPath(form === null || form === void 0 ? void 0 : form.values, pathName);
        if (!Array.isArray(pathValue) || pathValue.length - 1 < idx) return;
        $b8db88280711b5c9$var$setInPath(form.values, `${pathName}[${idx}]`, value);
        form === null || form === void 0 || form.validate({
            mode: "validated-only"
        });
    }
    function prepend(initialValue) {
        const value = $b8db88280711b5c9$var$klona(initialValue);
        const pathName = (0, $01W3b.toValue)(arrayPath);
        const pathValue = $b8db88280711b5c9$var$getFromPath(form === null || form === void 0 ? void 0 : form.values, pathName);
        const normalizedPathValue = $b8db88280711b5c9$var$isNullOrUndefined(pathValue) ? [] : pathValue;
        if (!Array.isArray(normalizedPathValue)) return;
        const newValue = [
            value,
            ...normalizedPathValue
        ];
        $b8db88280711b5c9$var$setInPath(form.values, pathName, newValue);
        form.stageInitialValue(pathName + `[0]`, value);
        fields.value.unshift(createEntry(value));
        afterMutation();
    }
    function move(oldIdx, newIdx) {
        const pathName = (0, $01W3b.toValue)(arrayPath);
        const pathValue = $b8db88280711b5c9$var$getFromPath(form === null || form === void 0 ? void 0 : form.values, pathName);
        const newValue = $b8db88280711b5c9$var$isNullOrUndefined(pathValue) ? [] : [
            ...pathValue
        ];
        if (!Array.isArray(pathValue) || !(oldIdx in pathValue) || !(newIdx in pathValue)) return;
        const newFields = [
            ...fields.value
        ];
        const movedItem = newFields[oldIdx];
        newFields.splice(oldIdx, 1);
        newFields.splice(newIdx, 0, movedItem);
        const movedValue = newValue[oldIdx];
        newValue.splice(oldIdx, 1);
        newValue.splice(newIdx, 0, movedValue);
        $b8db88280711b5c9$var$setInPath(form.values, pathName, newValue);
        fields.value = newFields;
        afterMutation();
    }
    const fieldArrayCtx = {
        fields: fields,
        remove: remove,
        push: push,
        swap: swap,
        insert: insert,
        update: update,
        replace: replace,
        prepend: prepend,
        move: move
    };
    form.fieldArrays.push(Object.assign({
        path: arrayPath,
        reset: initFields
    }, fieldArrayCtx));
    (0, $TusQn.onBeforeUnmount)(()=>{
        const idx = form.fieldArrays.findIndex((i)=>(0, $01W3b.toValue)(i.path) === (0, $01W3b.toValue)(arrayPath));
        if (idx >= 0) form.fieldArrays.splice(idx, 1);
    });
    // Makes sure to sync the form values with the array value if they go out of sync
    // #4153
    (0, $TusQn.watch)(getCurrentValues, (formValues)=>{
        const fieldsValues = fields.value.map((f)=>f.value);
        // If form values are not the same as the current values then something overrode them.
        if (!$b8db88280711b5c9$var$isEqual(formValues, fieldsValues)) initFields();
    });
    return fieldArrayCtx;
}
const $b8db88280711b5c9$var$FieldArrayImpl = /** #__PURE__ */ (0, $TusQn.defineComponent)({
    name: "FieldArray",
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            required: true
        }
    },
    setup (props, ctx) {
        const { push: push, remove: remove, swap: swap, insert: insert, replace: replace, update: update, prepend: prepend, move: move, fields: fields } = $b8db88280711b5c9$export$310131896651d559(()=>props.name);
        function slotProps() {
            return {
                fields: fields.value,
                push: push,
                remove: remove,
                swap: swap,
                insert: insert,
                update: update,
                replace: replace,
                prepend: prepend,
                move: move
            };
        }
        ctx.expose({
            push: push,
            remove: remove,
            swap: swap,
            insert: insert,
            update: update,
            replace: replace,
            prepend: prepend,
            move: move
        });
        return ()=>{
            const children = $b8db88280711b5c9$var$normalizeChildren(undefined, ctx, slotProps);
            return children;
        };
    }
});
const $b8db88280711b5c9$export$2683597413c8b91 = $b8db88280711b5c9$var$FieldArrayImpl;
const $b8db88280711b5c9$var$ErrorMessageImpl = /** #__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ErrorMessage",
    props: {
        as: {
            type: String,
            default: undefined
        },
        name: {
            type: String,
            required: true
        }
    },
    setup (props, ctx) {
        const form = (0, $TusQn.inject)($b8db88280711b5c9$export$34448771f7911aa9, undefined);
        const message = (0, $01W3b.computed)(()=>{
            return form === null || form === void 0 ? void 0 : form.errors.value[props.name];
        });
        function slotProps() {
            return {
                message: message.value
            };
        }
        return ()=>{
            // Renders nothing if there are no messages
            if (!message.value) return undefined;
            const tag = props.as ? (0, $TusQn.resolveDynamicComponent)(props.as) : props.as;
            const children = $b8db88280711b5c9$var$normalizeChildren(tag, ctx, slotProps);
            const attrs = Object.assign({
                role: "alert"
            }, ctx.attrs);
            // If no tag was specified and there are children
            // render the slot as is without wrapping it
            if (!tag && (Array.isArray(children) || !children) && (children === null || children === void 0 ? void 0 : children.length)) return children;
            // If no children in slot
            // render whatever specified and fallback to a <span> with the message in it's contents
            if ((Array.isArray(children) || !children) && !(children === null || children === void 0 ? void 0 : children.length)) return (0, $TusQn.h)(tag || "span", attrs, message.value);
            return (0, $TusQn.h)(tag, attrs, children);
        };
    }
});
const $b8db88280711b5c9$export$915e9e7bd4f0f96d = $b8db88280711b5c9$var$ErrorMessageImpl;
function $b8db88280711b5c9$export$a83377ead26a9eb5() {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    if (!form) $b8db88280711b5c9$var$warn("No vee-validate <Form /> or `useForm` was detected in the component tree");
    return function resetForm(state) {
        if (!form) return;
        return form.resetForm(state);
    };
}
/**
 * If a field is dirty or not
 */ function $b8db88280711b5c9$export$2dde9c0e80793b90(path) {
    const fieldOrPath = $b8db88280711b5c9$var$resolveFieldOrPathState(path);
    return (0, $01W3b.computed)(()=>{
        var _a, _b;
        if (!fieldOrPath) return false;
        return (_b = "meta" in fieldOrPath ? fieldOrPath.meta.dirty : (_a = fieldOrPath === null || fieldOrPath === void 0 ? void 0 : fieldOrPath.value) === null || _a === void 0 ? void 0 : _a.dirty) !== null && _b !== void 0 ? _b : false;
    });
}
/**
 * If a field is touched or not
 */ function $b8db88280711b5c9$export$c04e3154d58cbd2f(path) {
    const fieldOrPath = $b8db88280711b5c9$var$resolveFieldOrPathState(path);
    return (0, $01W3b.computed)(()=>{
        var _a, _b;
        if (!fieldOrPath) return false;
        return (_b = "meta" in fieldOrPath ? fieldOrPath.meta.touched : (_a = fieldOrPath === null || fieldOrPath === void 0 ? void 0 : fieldOrPath.value) === null || _a === void 0 ? void 0 : _a.touched) !== null && _b !== void 0 ? _b : false;
    });
}
/**
 * If a field is validated and is valid
 */ function $b8db88280711b5c9$export$85ebfdb9bfcc15b(path) {
    const fieldOrPath = $b8db88280711b5c9$var$resolveFieldOrPathState(path);
    return (0, $01W3b.computed)(()=>{
        var _a, _b;
        if (!fieldOrPath) return false;
        return (_b = "meta" in fieldOrPath ? fieldOrPath.meta.valid : (_a = fieldOrPath === null || fieldOrPath === void 0 ? void 0 : fieldOrPath.value) === null || _a === void 0 ? void 0 : _a.valid) !== null && _b !== void 0 ? _b : false;
    });
}
/**
 * If the form is submitting or not
 */ function $b8db88280711b5c9$export$a168e743ee4163d4() {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    if (!form) $b8db88280711b5c9$var$warn("No vee-validate <Form /> or `useForm` was detected in the component tree");
    return (0, $01W3b.computed)(()=>{
        var _a;
        return (_a = form === null || form === void 0 ? void 0 : form.isSubmitting.value) !== null && _a !== void 0 ? _a : false;
    });
}
/**
 * If the form is validating or not
 */ function $b8db88280711b5c9$export$f77c408336de420b() {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    if (!form) $b8db88280711b5c9$var$warn("No vee-validate <Form /> or `useForm` was detected in the component tree");
    return (0, $01W3b.computed)(()=>{
        var _a;
        return (_a = form === null || form === void 0 ? void 0 : form.isValidating.value) !== null && _a !== void 0 ? _a : false;
    });
}
/**
 * Validates a single field
 */ function $b8db88280711b5c9$export$6a625dd7f29d34f7(path) {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    const field = path ? undefined : (0, $TusQn.inject)($b8db88280711b5c9$export$82b43ec3fe1404d8);
    return function validateField() {
        if (field) return field.validate();
        if (form && path) return form === null || form === void 0 ? void 0 : form.validateField((0, $01W3b.toValue)(path));
        $b8db88280711b5c9$var$warn(`field with name ${(0, $01W3b.unref)(path)} was not found`);
        return Promise.resolve({
            errors: [],
            valid: true
        });
    };
}
/**
 * If the form is dirty or not
 */ function $b8db88280711b5c9$export$99feafa9b9955d05() {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    if (!form) $b8db88280711b5c9$var$warn("No vee-validate <Form /> or `useForm` was detected in the component tree");
    return (0, $01W3b.computed)(()=>{
        var _a;
        return (_a = form === null || form === void 0 ? void 0 : form.meta.value.dirty) !== null && _a !== void 0 ? _a : false;
    });
}
/**
 * If the form is touched or not
 */ function $b8db88280711b5c9$export$9a9936047f3fe4ae() {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    if (!form) $b8db88280711b5c9$var$warn("No vee-validate <Form /> or `useForm` was detected in the component tree");
    return (0, $01W3b.computed)(()=>{
        var _a;
        return (_a = form === null || form === void 0 ? void 0 : form.meta.value.touched) !== null && _a !== void 0 ? _a : false;
    });
}
/**
 * If the form has been validated and is valid
 */ function $b8db88280711b5c9$export$149fdd6199aa6c8b() {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    if (!form) $b8db88280711b5c9$var$warn("No vee-validate <Form /> or `useForm` was detected in the component tree");
    return (0, $01W3b.computed)(()=>{
        var _a;
        return (_a = form === null || form === void 0 ? void 0 : form.meta.value.valid) !== null && _a !== void 0 ? _a : false;
    });
}
/**
 * Validate multiple fields
 */ function $b8db88280711b5c9$export$884fffe87ce8fd93() {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    if (!form) $b8db88280711b5c9$var$warn("No vee-validate <Form /> or `useForm` was detected in the component tree");
    return function validateField() {
        if (!form) return Promise.resolve({
            results: {},
            errors: {},
            valid: true
        });
        return form.validate();
    };
}
/**
 * The number of form's submission count
 */ function $b8db88280711b5c9$export$eba30474b0fb5d2c() {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    if (!form) $b8db88280711b5c9$var$warn("No vee-validate <Form /> or `useForm` was detected in the component tree");
    return (0, $01W3b.computed)(()=>{
        var _a;
        return (_a = form === null || form === void 0 ? void 0 : form.submitCount.value) !== null && _a !== void 0 ? _a : 0;
    });
}
/**
 * Gives access to a field's current value
 */ function $b8db88280711b5c9$export$b79fae7fbe3ac392(path) {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    // We don't want to use self injected context as it doesn't make sense
    const field = path ? undefined : (0, $TusQn.inject)($b8db88280711b5c9$export$82b43ec3fe1404d8);
    return (0, $01W3b.computed)(()=>{
        if (path) return $b8db88280711b5c9$var$getFromPath(form === null || form === void 0 ? void 0 : form.values, (0, $01W3b.toValue)(path));
        return (0, $01W3b.toValue)(field === null || field === void 0 ? void 0 : field.value);
    });
}
/**
 * Gives access to a form's values
 */ function $b8db88280711b5c9$export$41bdbaf4b954f0d6() {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    if (!form) $b8db88280711b5c9$var$warn("No vee-validate <Form /> or `useForm` was detected in the component tree");
    return (0, $01W3b.computed)(()=>{
        return (form === null || form === void 0 ? void 0 : form.values) || {};
    });
}
/**
 * Gives access to all form errors
 */ function $b8db88280711b5c9$export$14f46f59498b275f() {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    if (!form) $b8db88280711b5c9$var$warn("No vee-validate <Form /> or `useForm` was detected in the component tree");
    return (0, $01W3b.computed)(()=>{
        return (form === null || form === void 0 ? void 0 : form.errors.value) || {};
    });
}
/**
 * Gives access to a single field error
 */ function $b8db88280711b5c9$export$4e47fce8e3c29a14(path) {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    // We don't want to use self injected context as it doesn't make sense
    const field = path ? undefined : (0, $TusQn.inject)($b8db88280711b5c9$export$82b43ec3fe1404d8);
    return (0, $01W3b.computed)(()=>{
        if (path) return form === null || form === void 0 ? void 0 : form.errors.value[(0, $01W3b.toValue)(path)];
        return field === null || field === void 0 ? void 0 : field.errorMessage.value;
    });
}
function $b8db88280711b5c9$export$f892117c4d06c1ea(cb) {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    if (!form) $b8db88280711b5c9$var$warn("No vee-validate <Form /> or `useForm` was detected in the component tree");
    const onSubmit = form ? form.handleSubmit(cb) : undefined;
    return function submitForm(e) {
        if (!onSubmit) return;
        return onSubmit(e);
    };
}
/**
 * Sets a field's error message
 */ function $b8db88280711b5c9$export$35b01267aa2f9a6(path) {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    // We don't want to use self injected context as it doesn't make sense
    const field = path ? undefined : (0, $TusQn.inject)($b8db88280711b5c9$export$82b43ec3fe1404d8);
    return function setFieldError(message) {
        if (path && form) {
            form.setFieldError((0, $01W3b.toValue)(path), message);
            return;
        }
        if (field) {
            field.setErrors(message || []);
            return;
        }
        $b8db88280711b5c9$var$warn(`Could not set error message since there is no form context or a field named "${(0, $01W3b.toValue)(path)}", did you forget to call "useField" or "useForm"?`);
    };
}
/**
 * Sets a field's touched meta state
 */ function $b8db88280711b5c9$export$47e93021eb436fd4(path) {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    // We don't want to use self injected context as it doesn't make sense
    const field = path ? undefined : (0, $TusQn.inject)($b8db88280711b5c9$export$82b43ec3fe1404d8);
    return function setFieldTouched(touched) {
        if (path && form) {
            form.setFieldTouched((0, $01W3b.toValue)(path), touched);
            return;
        }
        if (field) {
            field.setTouched(touched);
            return;
        }
        $b8db88280711b5c9$var$warn(`Could not set touched state since there is no form context or a field named "${(0, $01W3b.toValue)(path)}", did you forget to call "useField" or "useForm"?`);
    };
}
/**
 * Sets a field's value
 */ function $b8db88280711b5c9$export$84b1dabd89c6372a(path) {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    // We don't want to use self injected context as it doesn't make sense
    const field = path ? undefined : (0, $TusQn.inject)($b8db88280711b5c9$export$82b43ec3fe1404d8);
    return function setFieldValue(value, shouldValidate = true) {
        if (path && form) {
            form.setFieldValue((0, $01W3b.toValue)(path), value, shouldValidate);
            return;
        }
        if (field) {
            field.setValue(value, shouldValidate);
            return;
        }
        $b8db88280711b5c9$var$warn(`Could not set value since there is no form context or a field named "${(0, $01W3b.toValue)(path)}", did you forget to call "useField" or "useForm"?`);
    };
}
/**
 * Sets multiple fields errors
 */ function $b8db88280711b5c9$export$f175373c2f9b29d() {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    function setFormErrors(fields) {
        if (form) {
            form.setErrors(fields);
            return;
        }
        $b8db88280711b5c9$var$warn(`Could not set errors because a form was not detected, did you forget to use "useForm" in a parent component?`);
    }
    return setFormErrors;
}
/**
 * Sets multiple fields touched or all fields in the form
 */ function $b8db88280711b5c9$export$17f4bb83fb45832c() {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    function setFormTouched(fields) {
        if (form) {
            form.setTouched(fields);
            return;
        }
        $b8db88280711b5c9$var$warn(`Could not set touched state because a form was not detected, did you forget to use "useForm" in a parent component?`);
    }
    return setFormTouched;
}
/**
 * Sets multiple fields values
 */ function $b8db88280711b5c9$export$54c43810c6db5a30() {
    const form = $b8db88280711b5c9$var$injectWithSelf($b8db88280711b5c9$export$34448771f7911aa9);
    function setFormValues(fields, shouldValidate = true) {
        if (form) {
            form.setValues(fields, shouldValidate);
            return;
        }
        $b8db88280711b5c9$var$warn(`Could not set form values because a form was not detected, did you forget to use "useForm" in a parent component?`);
    }
    return setFormValues;
}

});

parcelRegister("hEJWZ", function(module, exports) {

$parcel$export(module.exports, "printValue", () => $cda9d0e1103d595f$export$5790025c6e6c2ba6);
$parcel$export(module.exports, "ValidationError", () => $cda9d0e1103d595f$export$2191b9da168c6cf0);
$parcel$export(module.exports, "defaultLocale", () => $cda9d0e1103d595f$export$d7f512c98c859244);
$parcel$export(module.exports, "isSchema", () => $cda9d0e1103d595f$export$213e2a3e7c4f326e);
$parcel$export(module.exports, "ref", () => $cda9d0e1103d595f$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "getIn", () => $cda9d0e1103d595f$export$c52e5867d5879e24);
$parcel$export(module.exports, "reach", () => $cda9d0e1103d595f$export$cfedb76369cc7782);
$parcel$export(module.exports, "Schema", () => $cda9d0e1103d595f$export$19342e026b58ebb7);
$parcel$export(module.exports, "mixed", () => $cda9d0e1103d595f$export$9b30b6294c1449a8);
$parcel$export(module.exports, "MixedSchema", () => $cda9d0e1103d595f$export$1e88358c94ddec71);
$parcel$export(module.exports, "bool", () => $cda9d0e1103d595f$export$87b259aa03e3d267);
$parcel$export(module.exports, "BooleanSchema", () => $cda9d0e1103d595f$export$c7980688f11e1f49);
$parcel$export(module.exports, "string", () => $cda9d0e1103d595f$export$22b082955e083ec3);
$parcel$export(module.exports, "StringSchema", () => $cda9d0e1103d595f$export$49bf8b2ede5138eb);
$parcel$export(module.exports, "number", () => $cda9d0e1103d595f$export$98e628dec113755e);
$parcel$export(module.exports, "NumberSchema", () => $cda9d0e1103d595f$export$f192ec5e9228ab19);
$parcel$export(module.exports, "date", () => $cda9d0e1103d595f$export$324d90190a8b822a);
$parcel$export(module.exports, "DateSchema", () => $cda9d0e1103d595f$export$18ec3cc5a157503f);
$parcel$export(module.exports, "object", () => $cda9d0e1103d595f$export$be5493f9613cbbe);
$parcel$export(module.exports, "ObjectSchema", () => $cda9d0e1103d595f$export$18b4fc70ec7eccf8);
$parcel$export(module.exports, "array", () => $cda9d0e1103d595f$export$2f23118c22fb2630);
$parcel$export(module.exports, "ArraySchema", () => $cda9d0e1103d595f$export$4347112b8447a7d);
$parcel$export(module.exports, "tuple", () => $cda9d0e1103d595f$export$65e3907585753458);
$parcel$export(module.exports, "TupleSchema", () => $cda9d0e1103d595f$export$411c3b3687e8ecc8);
$parcel$export(module.exports, "lazy", () => $cda9d0e1103d595f$export$488013bae63b21da);
$parcel$export(module.exports, "setLocale", () => $cda9d0e1103d595f$export$c8aadf3621e41efb);
$parcel$export(module.exports, "addMethod", () => $cda9d0e1103d595f$export$20be359f745f973c);
$parcel$export(module.exports, "boolean", () => $cda9d0e1103d595f$export$87b259aa03e3d267);

var $Sk64T = parcelRequire("Sk64T");

var $i6Lf0 = parcelRequire("i6Lf0");

var $dYCFZ = parcelRequire("dYCFZ");
const $cda9d0e1103d595f$var$toString = Object.prototype.toString;
const $cda9d0e1103d595f$var$errorToString = Error.prototype.toString;
const $cda9d0e1103d595f$var$regExpToString = RegExp.prototype.toString;
const $cda9d0e1103d595f$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $cda9d0e1103d595f$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $cda9d0e1103d595f$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $cda9d0e1103d595f$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $cda9d0e1103d595f$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $cda9d0e1103d595f$var$symbolToString.call(val).replace($cda9d0e1103d595f$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $cda9d0e1103d595f$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $cda9d0e1103d595f$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $cda9d0e1103d595f$var$regExpToString.call(val);
    return null;
}
function $cda9d0e1103d595f$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $cda9d0e1103d595f$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $cda9d0e1103d595f$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $cda9d0e1103d595f$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $cda9d0e1103d595f$var$_Symbol$toStringTag, $cda9d0e1103d595f$var$_Symbol$hasInstance, $cda9d0e1103d595f$var$_Symbol$toStringTag2;
let $cda9d0e1103d595f$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$cda9d0e1103d595f$var$_Symbol$toStringTag = Symbol.toStringTag;
class $cda9d0e1103d595f$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$cda9d0e1103d595f$var$_Symbol$toStringTag] = "Error";
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $cda9d0e1103d595f$var$toArray(errorOrErrors).forEach((err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$cda9d0e1103d595f$var$_Symbol$hasInstance = Symbol.hasInstance;
$cda9d0e1103d595f$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $cda9d0e1103d595f$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = Object.assign({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($cda9d0e1103d595f$var$strReg, (_, key)=>$cda9d0e1103d595f$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $cda9d0e1103d595f$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$cda9d0e1103d595f$var$_Symbol$toStringTag2] = "Error";
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $cda9d0e1103d595f$export$2191b9da168c6cf0);
    }
    static [$cda9d0e1103d595f$var$_Symbol$hasInstance](inst) {
        return $cda9d0e1103d595f$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $cda9d0e1103d595f$var$mixed = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    defined: "${path} must be defined",
    notNull: "${path} cannot be null",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(originalValue, true)}\`).` : ".";
        return type !== "mixed" ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $cda9d0e1103d595f$var$string = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    datetime: "${path} must be a valid ISO date-time",
    datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $cda9d0e1103d595f$var$number = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $cda9d0e1103d595f$var$date = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $cda9d0e1103d595f$var$boolean = {
    isValue: "${path} field must be ${value}"
};
let $cda9d0e1103d595f$var$object = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $cda9d0e1103d595f$var$array = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
let $cda9d0e1103d595f$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $cda9d0e1103d595f$export$2191b9da168c6cf0.formatError($cda9d0e1103d595f$var$mixed.notType, params);
    }
};
var $cda9d0e1103d595f$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $cda9d0e1103d595f$var$mixed,
    string: $cda9d0e1103d595f$var$string,
    number: $cda9d0e1103d595f$var$number,
    date: $cda9d0e1103d595f$var$date,
    object: $cda9d0e1103d595f$var$object,
    array: $cda9d0e1103d595f$var$array,
    boolean: $cda9d0e1103d595f$var$boolean,
    tuple: $cda9d0e1103d595f$var$tuple
});
const $cda9d0e1103d595f$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $cda9d0e1103d595f$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        return new $cda9d0e1103d595f$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
const $cda9d0e1103d595f$var$prefixes = {
    context: "$",
    value: "."
};
function $cda9d0e1103d595f$export$eff4d24c3ff7876e(key, options) {
    return new $cda9d0e1103d595f$var$Reference(key, options);
}
class $cda9d0e1103d595f$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $cda9d0e1103d595f$var$prefixes.context;
        this.isValue = this.key[0] === $cda9d0e1103d595f$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $cda9d0e1103d595f$var$prefixes.context : this.isValue ? $cda9d0e1103d595f$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $Sk64T.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$cda9d0e1103d595f$var$Reference.prototype.__isYupRef = true;
const $cda9d0e1103d595f$var$isAbsent = (value)=>value == null;
function $cda9d0e1103d595f$var$createValidation(config) {
    function validate({ value: value, path: path = "", options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $cda9d0e1103d595f$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $cda9d0e1103d595f$export$2191b9da168c6cf0($cda9d0e1103d595f$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $cda9d0e1103d595f$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $cda9d0e1103d595f$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $Sk64T.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === "tuple";
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $cda9d0e1103d595f$export$cfedb76369cc7782(obj, path, value, context) {
    return $cda9d0e1103d595f$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $cda9d0e1103d595f$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($cda9d0e1103d595f$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $cda9d0e1103d595f$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $cda9d0e1103d595f$var$clone(src, seen = new Map()) {
    if ($cda9d0e1103d595f$export$213e2a3e7c4f326e(src) || !src || typeof src !== "object") return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $cda9d0e1103d595f$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $cda9d0e1103d595f$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($cda9d0e1103d595f$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $cda9d0e1103d595f$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $cda9d0e1103d595f$var$ReferenceSet();
        this._blacklist = new $cda9d0e1103d595f$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($cda9d0e1103d595f$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $cda9d0e1103d595f$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === "ignore-optionality";
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $cda9d0e1103d595f$var$isAbsent(result)) return result;
            let formattedValue = $cda9d0e1103d595f$export$5790025c6e6c2ba6(value);
            let formattedResult = $cda9d0e1103d595f$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError("Must include `key` or `index` for nested validations");
        const isIndex = typeof k === "number";
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? "index" : "key"]: k,
            path: isIndex || k.includes(".") ? `${parentPath || ""}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : "") + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $cda9d0e1103d595f$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $cda9d0e1103d595f$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this, options) : $cda9d0e1103d595f$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "nullable",
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "optionality",
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $cda9d0e1103d595f$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $cda9d0e1103d595f$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $cda9d0e1103d595f$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $cda9d0e1103d595f$var$mixed.default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = $cda9d0e1103d595f$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = $cda9d0e1103d595f$var$toArray(keys).map((key)=>new $cda9d0e1103d595f$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === "function" ? new $cda9d0e1103d595f$var$Condition(deps, options) : $cda9d0e1103d595f$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "typeError",
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $cda9d0e1103d595f$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "oneOf",
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $cda9d0e1103d595f$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$cda9d0e1103d595f$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $cda9d0e1103d595f$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[alias] = $cda9d0e1103d595f$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[alias] = $cda9d0e1103d595f$export$19342e026b58ebb7.prototype.notOneOf;
const $cda9d0e1103d595f$var$returnsTrue = ()=>true;
function $cda9d0e1103d595f$export$9b30b6294c1449a8(spec) {
    return new $cda9d0e1103d595f$export$1e88358c94ddec71(spec);
}
class $cda9d0e1103d595f$export$1e88358c94ddec71 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === "function" ? {
            type: "mixed",
            check: spec
        } : Object.assign({
            type: "mixed",
            check: $cda9d0e1103d595f$var$returnsTrue
        }, spec));
    }
}
$cda9d0e1103d595f$export$9b30b6294c1449a8.prototype = $cda9d0e1103d595f$export$1e88358c94ddec71.prototype;
function $cda9d0e1103d595f$export$87b259aa03e3d267() {
    return new $cda9d0e1103d595f$export$c7980688f11e1f49();
}
class $cda9d0e1103d595f$export$c7980688f11e1f49 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "boolean",
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === "boolean";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $cda9d0e1103d595f$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return $cda9d0e1103d595f$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $cda9d0e1103d595f$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return $cda9d0e1103d595f$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$cda9d0e1103d595f$export$87b259aa03e3d267.prototype = $cda9d0e1103d595f$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $cda9d0e1103d595f$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $cda9d0e1103d595f$var$parseIsoDate(date) {
    const struct = $cda9d0e1103d595f$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== "Z" && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === "+") totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $cda9d0e1103d595f$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $cda9d0e1103d595f$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $cda9d0e1103d595f$var$toNumber(regexResult[1]),
        month: $cda9d0e1103d595f$var$toNumber(regexResult[2], 1) - 1,
        day: $cda9d0e1103d595f$var$toNumber(regexResult[3], 1),
        hour: $cda9d0e1103d595f$var$toNumber(regexResult[4]),
        minute: $cda9d0e1103d595f$var$toNumber(regexResult[5]),
        second: $cda9d0e1103d595f$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $cda9d0e1103d595f$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $cda9d0e1103d595f$var$toNumber(regexResult[10]),
        minuteOffset: $cda9d0e1103d595f$var$toNumber(regexResult[11])
    };
}
function $cda9d0e1103d595f$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $cda9d0e1103d595f$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $cda9d0e1103d595f$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $cda9d0e1103d595f$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $cda9d0e1103d595f$var$yearMonthDay = "^\\d{4}-\\d{2}-\\d{2}";
let $cda9d0e1103d595f$var$hourMinuteSecond = "\\d{2}:\\d{2}:\\d{2}";
let $cda9d0e1103d595f$var$zOrOffset = "(([+-]\\d{2}(:?\\d{2})?)|Z)";
let $cda9d0e1103d595f$var$rIsoDateTime = new RegExp(`${$cda9d0e1103d595f$var$yearMonthDay}T${$cda9d0e1103d595f$var$hourMinuteSecond}(\\.\\d+)?${$cda9d0e1103d595f$var$zOrOffset}$`);
let $cda9d0e1103d595f$var$isTrimmed = (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.trim();
let $cda9d0e1103d595f$var$objStringTag = ({}).toString();
function $cda9d0e1103d595f$export$22b082955e083ec3() {
    return new $cda9d0e1103d595f$export$49bf8b2ede5138eb();
}
class $cda9d0e1103d595f$export$49bf8b2ede5138eb extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "string",
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === "string";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $cda9d0e1103d595f$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $cda9d0e1103d595f$var$mixed.required,
                name: "required",
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== "required");
            return schema;
        });
    }
    length(length, message = $cda9d0e1103d595f$var$string.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $cda9d0e1103d595f$var$string.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$string.max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || $cda9d0e1103d595f$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $cda9d0e1103d595f$var$string.email) {
        return this.matches($cda9d0e1103d595f$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $cda9d0e1103d595f$var$string.url) {
        return this.matches($cda9d0e1103d595f$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $cda9d0e1103d595f$var$string.uuid) {
        return this.matches($cda9d0e1103d595f$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = "";
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === "object") ({ message: message = "", allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($cda9d0e1103d595f$var$rIsoDateTime, {
            name: "datetime",
            message: message || $cda9d0e1103d595f$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: "datetime_offset",
            message: message || $cda9d0e1103d595f$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $cda9d0e1103d595f$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: "datetime_precision",
            message: message || $cda9d0e1103d595f$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $cda9d0e1103d595f$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = $cda9d0e1103d595f$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $cda9d0e1103d595f$var$isTrimmed
        });
    }
    lowercase(message = $cda9d0e1103d595f$var$string.lowercase) {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $cda9d0e1103d595f$var$string.uppercase) {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$cda9d0e1103d595f$export$22b082955e083ec3.prototype = $cda9d0e1103d595f$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $cda9d0e1103d595f$var$isNaN$1 = (value)=>value != +value;
function $cda9d0e1103d595f$export$98e628dec113755e() {
    return new $cda9d0e1103d595f$export$f192ec5e9228ab19();
}
class $cda9d0e1103d595f$export$f192ec5e9228ab19 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "number",
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === "number" && !$cda9d0e1103d595f$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $cda9d0e1103d595f$var$number.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$number.max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $cda9d0e1103d595f$var$number.lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $cda9d0e1103d595f$var$number.moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $cda9d0e1103d595f$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $cda9d0e1103d595f$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $cda9d0e1103d595f$var$number.integer) {
        return this.test({
            name: "integer",
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
        // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$cda9d0e1103d595f$export$98e628dec113755e.prototype = $cda9d0e1103d595f$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $cda9d0e1103d595f$var$invalidDate = new Date("");
let $cda9d0e1103d595f$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $cda9d0e1103d595f$export$324d90190a8b822a() {
    return new $cda9d0e1103d595f$export$18ec3cc5a157503f();
}
class $cda9d0e1103d595f$export$18ec3cc5a157503f extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "date",
            check (v) {
                return $cda9d0e1103d595f$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $cda9d0e1103d595f$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $cda9d0e1103d595f$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$cda9d0e1103d595f$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $cda9d0e1103d595f$var$date.min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$date.max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$cda9d0e1103d595f$export$18ec3cc5a157503f.INVALID_DATE = $cda9d0e1103d595f$var$invalidDate;
$cda9d0e1103d595f$export$324d90190a8b822a.prototype = $cda9d0e1103d595f$export$18ec3cc5a157503f.prototype;
$cda9d0e1103d595f$export$324d90190a8b822a.INVALID_DATE = $cda9d0e1103d595f$var$invalidDate;
// @ts-expect-error
function $cda9d0e1103d595f$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $Sk64T.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($cda9d0e1103d595f$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($cda9d0e1103d595f$export$213e2a3e7c4f326e(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($dYCFZ))).array(Array.from(nodes), edges).reverse();
}
function $cda9d0e1103d595f$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $cda9d0e1103d595f$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $cda9d0e1103d595f$var$findIndex(keys, a) - $cda9d0e1103d595f$var$findIndex(keys, b);
    };
}
const $cda9d0e1103d595f$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== "string") return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $cda9d0e1103d595f$var$deepPartial(schema) {
    if ("fields" in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $cda9d0e1103d595f$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === "array") {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $cda9d0e1103d595f$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === "tuple") return schema.optional().clone({
        types: schema.spec.types.map($cda9d0e1103d595f$var$deepPartial)
    });
    if ("optional" in schema) return schema.optional();
    return schema;
}
const $cda9d0e1103d595f$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $Sk64T.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $Sk64T.getter)((0, $Sk64T.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $cda9d0e1103d595f$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $cda9d0e1103d595f$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $cda9d0e1103d595f$var$defaultSort = $cda9d0e1103d595f$var$sortByKeyOrder([]);
function $cda9d0e1103d595f$export$be5493f9613cbbe(spec) {
    return new $cda9d0e1103d595f$export$18b4fc70ec7eccf8(spec);
}
class $cda9d0e1103d595f$export$18b4fc70ec7eccf8 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: "object",
            check (value) {
                return $cda9d0e1103d595f$var$isObject(value) || typeof value === "function";
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $cda9d0e1103d595f$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $cda9d0e1103d595f$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$cda9d0e1103d595f$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $cda9d0e1103d595f$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ("default" in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $cda9d0e1103d595f$var$sortFields(shape, excludedEdges);
        next._sortErrors = $cda9d0e1103d595f$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $cda9d0e1103d595f$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $Sk64T.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($cda9d0e1103d595f$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($cda9d0e1103d595f$var$parseJson);
    }
    noUnknown(noAllow = true, message = $cda9d0e1103d595f$var$object.noUnknown) {
        if (typeof noAllow !== "boolean") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $cda9d0e1103d595f$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $cda9d0e1103d595f$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $i6Lf0.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $i6Lf0.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $i6Lf0.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$cda9d0e1103d595f$export$be5493f9613cbbe.prototype = $cda9d0e1103d595f$export$18b4fc70ec7eccf8.prototype;
function $cda9d0e1103d595f$export$2f23118c22fb2630(type) {
    return new $cda9d0e1103d595f$export$4347112b8447a7d(type);
}
class $cda9d0e1103d595f$export$4347112b8447a7d extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: "array",
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($cda9d0e1103d595f$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + $cda9d0e1103d595f$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $cda9d0e1103d595f$var$array.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $cda9d0e1103d595f$var$array.min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $cda9d0e1103d595f$var$array.max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$cda9d0e1103d595f$export$2f23118c22fb2630.prototype = $cda9d0e1103d595f$export$4347112b8447a7d.prototype;
// @ts-ignore
function $cda9d0e1103d595f$export$65e3907585753458(schemas) {
    return new $cda9d0e1103d595f$export$411c3b3687e8ecc8(schemas);
}
class $cda9d0e1103d595f$export$411c3b3687e8ecc8 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: "tuple",
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($cda9d0e1103d595f$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ""}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$cda9d0e1103d595f$export$65e3907585753458.prototype = $cda9d0e1103d595f$export$411c3b3687e8ecc8.prototype;
function $cda9d0e1103d595f$export$488013bae63b21da(builder) {
    return new $cda9d0e1103d595f$var$Lazy(builder);
}
class $cda9d0e1103d595f$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError("lazy() functions must return a valid schema");
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $cda9d0e1103d595f$var$Lazy(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: "lazy",
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $cda9d0e1103d595f$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $cda9d0e1103d595f$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $cda9d0e1103d595f$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$cda9d0e1103d595f$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}

});
parcelRegister("Sk64T", function(module, exports) {
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $0a34a21cae127bf5$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$0a34a21cae127bf5$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$0a34a21cae127bf5$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$0a34a21cae127bf5$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $0a34a21cae127bf5$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $0a34a21cae127bf5$var$DIGIT_REGEX = /^\d+$/, $0a34a21cae127bf5$var$LEAD_DIGIT_REGEX = /^\d/, $0a34a21cae127bf5$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $0a34a21cae127bf5$var$MAX_CACHE_SIZE = 512;
var $0a34a21cae127bf5$var$pathCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$setCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$getCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE);
var $0a34a21cae127bf5$var$config;
module.exports = {
    Cache: $0a34a21cae127bf5$var$Cache,
    split: $0a34a21cae127bf5$var$split,
    normalizePath: $0a34a21cae127bf5$var$normalizePath,
    setter: function(path) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$setCache.get(path) || $0a34a21cae127bf5$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$getCache.get(path) || $0a34a21cae127bf5$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($0a34a21cae127bf5$var$isQuoted(part) || $0a34a21cae127bf5$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $0a34a21cae127bf5$var$forEach(Array.isArray(path) ? path : $0a34a21cae127bf5$var$split(path), cb, thisArg);
    }
};
function $0a34a21cae127bf5$var$normalizePath(path) {
    return $0a34a21cae127bf5$var$pathCache.get(path) || $0a34a21cae127bf5$var$pathCache.set(path, $0a34a21cae127bf5$var$split(path).map(function(part) {
        return part.replace($0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $0a34a21cae127bf5$var$split(path) {
    return path.match($0a34a21cae127bf5$var$SPLIT_REGEX) || [
        ""
    ];
}
function $0a34a21cae127bf5$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($0a34a21cae127bf5$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $0a34a21cae127bf5$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $0a34a21cae127bf5$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $0a34a21cae127bf5$var$hasLeadingNumber(part) {
    return part.match($0a34a21cae127bf5$var$LEAD_DIGIT_REGEX) && !part.match($0a34a21cae127bf5$var$DIGIT_REGEX);
}
function $0a34a21cae127bf5$var$hasSpecialChars(part) {
    return $0a34a21cae127bf5$var$SPEC_CHAR_REGEX.test(part);
}
function $0a34a21cae127bf5$var$shouldBeQuoted(part) {
    return !$0a34a21cae127bf5$var$isQuoted(part) && ($0a34a21cae127bf5$var$hasLeadingNumber(part) || $0a34a21cae127bf5$var$hasSpecialChars(part));
}

});

parcelRegister("i6Lf0", function(module, exports) {
const $d2ed6e977f19f182$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $d2ed6e977f19f182$var$words = (str)=>str.match($d2ed6e977f19f182$var$reWords) || [];
const $d2ed6e977f19f182$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $d2ed6e977f19f182$var$join = (str, d)=>$d2ed6e977f19f182$var$words(str).join(d).toLowerCase();
const $d2ed6e977f19f182$var$camelCase = (str)=>$d2ed6e977f19f182$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, "");
const $d2ed6e977f19f182$var$pascalCase = (str)=>$d2ed6e977f19f182$var$upperFirst($d2ed6e977f19f182$var$camelCase(str));
const $d2ed6e977f19f182$var$snakeCase = (str)=>$d2ed6e977f19f182$var$join(str, "_");
const $d2ed6e977f19f182$var$kebabCase = (str)=>$d2ed6e977f19f182$var$join(str, "-");
const $d2ed6e977f19f182$var$sentenceCase = (str)=>$d2ed6e977f19f182$var$upperFirst($d2ed6e977f19f182$var$join(str, " "));
const $d2ed6e977f19f182$var$titleCase = (str)=>$d2ed6e977f19f182$var$words(str).map($d2ed6e977f19f182$var$upperFirst).join(" ");
module.exports = {
    words: $d2ed6e977f19f182$var$words,
    upperFirst: $d2ed6e977f19f182$var$upperFirst,
    camelCase: $d2ed6e977f19f182$var$camelCase,
    pascalCase: $d2ed6e977f19f182$var$pascalCase,
    snakeCase: $d2ed6e977f19f182$var$snakeCase,
    kebabCase: $d2ed6e977f19f182$var$kebabCase,
    sentenceCase: $d2ed6e977f19f182$var$sentenceCase,
    titleCase: $d2ed6e977f19f182$var$titleCase
};

});

parcelRegister("dYCFZ", function(module, exports) {
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ module.exports = function(edges) {
    return $a2cee144eac47a21$var$toposort($a2cee144eac47a21$var$uniqueNodes(edges), edges);
};
module.exports.array = $a2cee144eac47a21$var$toposort;
function $a2cee144eac47a21$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $a2cee144eac47a21$var$makeOutgoingEdges(edges), nodesHash = $a2cee144eac47a21$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $a2cee144eac47a21$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $a2cee144eac47a21$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $a2cee144eac47a21$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}

});


parcelRegister("kheUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec30f762231a8e05$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $dybkl = parcelRequire("dybkl");

var $l7ahT = parcelRequire("l7ahT");
/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty, R.isNotEmpty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);           //=> false
 *      R.isEmpty([]);                  //=> true
 *      R.isEmpty('');                  //=> true
 *      R.isEmpty(null);                //=> false
 *      R.isEmpty({});                  //=> true
 *      R.isEmpty({length: 0});         //=> false
 *      R.isEmpty(Uint8Array.from('')); //=> true
 */ var $ec30f762231a8e05$var$isEmpty = /*#__PURE__*/ (0, $aSQee.default)(function isEmpty(x) {
    return x != null && (0, $l7ahT.default)(x, (0, $dybkl.default)(x));
});
var $ec30f762231a8e05$export$2e2bcd8739ae039 = $ec30f762231a8e05$var$isEmpty;

});
parcelRegister("dybkl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd73ca76fee62b7$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $hW4tV = parcelRequire("hW4tV");

var $aTzs4 = parcelRequire("aTzs4");

var $Ufvzo = parcelRequire("Ufvzo");

var $lBqhj = parcelRequire("lBqhj");

var $kHh3F = parcelRequire("kHh3F");
/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`),
 * TypedArray (`Uint8Array []`, `Float32Array []`, etc), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));               //=> Nothing()
 *      R.empty([1, 2, 3]);              //=> []
 *      R.empty('unicorns');             //=> ''
 *      R.empty({x: 1, y: 2});           //=> {}
 *      R.empty(Uint8Array.from('123')); //=> Uint8Array []
 */ var $9dd73ca76fee62b7$var$empty = /*#__PURE__*/ (0, $aSQee.default)(function empty(x) {
    return x != null && typeof x["fantasy-land/empty"] === "function" ? x["fantasy-land/empty"]() : x != null && x.constructor != null && typeof x.constructor["fantasy-land/empty"] === "function" ? x.constructor["fantasy-land/empty"]() : x != null && typeof x.empty === "function" ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === "function" ? x.constructor.empty() : (0, $aTzs4.default)(x) ? [] : (0, $lBqhj.default)(x) ? "" : (0, $Ufvzo.default)(x) ? {} : (0, $hW4tV.default)(x) ? function() {
        return arguments;
    }() : (0, $kHh3F.default)(x) ? x.constructor.from("") : void 0 // else
    ;
});
var $9dd73ca76fee62b7$export$2e2bcd8739ae039 = $9dd73ca76fee62b7$var$empty;

});
parcelRegister("kHh3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1150e2c44776968$export$2e2bcd8739ae039);
/**
 * Tests whether or not an object is a typed array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is a typed array, `false` otherwise.
 * @example
 *
 *      _isTypedArray(new Uint8Array([])); //=> true
 *      _isTypedArray(new Float32Array([])); //=> true
 *      _isTypedArray([]); //=> false
 *      _isTypedArray(null); //=> false
 *      _isTypedArray({}); //=> false
 */ function $f1150e2c44776968$export$2e2bcd8739ae039(val) {
    var type = Object.prototype.toString.call(val);
    return type === "[object Uint8ClampedArray]" || type === "[object Int8Array]" || type === "[object Uint8Array]" || type === "[object Int16Array]" || type === "[object Uint16Array]" || type === "[object Int32Array]" || type === "[object Uint32Array]" || type === "[object Float32Array]" || type === "[object Float64Array]" || type === "[object BigInt64Array]" || type === "[object BigUint64Array]";
}

});



parcelRegister("1rS06", function(module, exports) {

$parcel$export(module.exports, "dummyUserState", () => $10e2337c64e43b5d$export$b43a0bfd0aaff7f0);
$parcel$export(module.exports, "useGlobalState", () => $10e2337c64e43b5d$export$578754a141ccd236);
$parcel$export(module.exports, "isEmployee", () => $10e2337c64e43b5d$export$86f4511ee3749ba9);
$parcel$export(module.exports, "isOwner", () => $10e2337c64e43b5d$export$e71175321a2b5dc8);
$parcel$export(module.exports, "hasCompanyPlan", () => $10e2337c64e43b5d$export$8e6f75cc7b12bbe6);
$parcel$export(module.exports, "hasUserPlan", () => $10e2337c64e43b5d$export$9dad00cba3aebcb8);

var $a655N = parcelRequire("a655N");
var $l7ahT = parcelRequire("l7ahT");
var $16nvB = parcelRequire("16nvB");
var $3dVdd = parcelRequire("3dVdd");
var $dnABj = parcelRequire("dnABj");
var $iDR1F = parcelRequire("iDR1F");
var $fEFLm = parcelRequire("fEFLm");

var $AHHxt = parcelRequire("AHHxt");
var $hmpaa = parcelRequire("hmpaa");

var $4Kuwt = parcelRequire("4Kuwt");

var $bQytf = parcelRequire("bQytf");
function $10e2337c64e43b5d$var$useCachedStorage(key) {
    const storageWithExpiry = {
        expiry: null,
        data: null
    };
    const storage = (0, $hmpaa.useStorage)(key, storageWithExpiry, localStorage);
    const reset = ()=>{
        storage.value.data = null;
        storage.value.expiry = null;
    };
    const get = ()=>{
        // no expiration set or expired, reset data
        const isExpired = (0, $3dVdd.default)(Date.parse(storage.value.expiry), Date.now());
        const noExpirationSet = (0, $16nvB.default)(storage.value.expiry);
        if (noExpirationSet || isExpired) storage.value.data = null;
        return storage;
    };
    const data = ()=>{
        const store = get();
        return store.value.data;
    };
    const set = (d, expiry = null)=>{
        storage.value.data = d;
        storage.value.expiry = expiry;
    };
    const hasData = ()=>{
        const d = data();
        return !(0, $16nvB.default)(d);
    };
    return {
        reset: reset,
        get: get,
        hasData: hasData,
        data: data,
        set: set
    };
}
const $10e2337c64e43b5d$export$b43a0bfd0aaff7f0 = {
    employees: [],
    courses: [],
    role: "owner",
    isAuthenticated: false
};
const $10e2337c64e43b5d$var$getRole = (0, $iDR1F.default)("role");
const $10e2337c64e43b5d$var$getCompanyPlan = (0, $dnABj.default)([
    "plans",
    "company"
]);
const $10e2337c64e43b5d$var$getUserPlan = (0, $dnABj.default)([
    "plans",
    "user"
]);
const $10e2337c64e43b5d$export$578754a141ccd236 = (0, $AHHxt.createGlobalState)(()=>{
    // state
    const userState = (0, $hmpaa.useStorage)("userState", $10e2337c64e43b5d$export$b43a0bfd0aaff7f0, localStorage);
    const currentEmployees = (0, $hmpaa.useStorage)("currentEmployees", [], localStorage);
    const currentCourses = $10e2337c64e43b5d$var$useCachedStorage("currentCourses");
    const currentTrainingCourses = $10e2337c64e43b5d$var$useCachedStorage("currentTrainingCourses");
    const currentPlans = $10e2337c64e43b5d$var$useCachedStorage("plans");
    const sessionId = (0, $hmpaa.useStorage)("sessionId", (0, $4Kuwt.nanoid)(), localStorage);
    const resetUserState = ()=>{
        userState.value = $10e2337c64e43b5d$export$b43a0bfd0aaff7f0;
        currentEmployees.value.expiry = null;
        currentEmployees.value.data = [];
        currentCourses.reset();
        currentTrainingCourses.reset();
        currentPlans.reset();
        sessionId.value = (0, $4Kuwt.nanoid)();
    };
    const isAuthenticated = ()=>(0, $fEFLm.default)(false, "isAuthenticated", userState.value);
    return {
        userState: userState,
        currentEmployees: currentEmployees,
        currentCourses: currentCourses,
        currentTrainingCourses: currentTrainingCourses,
        currentPlans: currentPlans,
        sessionId: sessionId,
        resetUserState: resetUserState,
        isAuthenticated: isAuthenticated
    };
});
const $10e2337c64e43b5d$export$86f4511ee3749ba9 = (0, $a655N.default)((0, $l7ahT.default)("employee"), $10e2337c64e43b5d$var$getRole);
const $10e2337c64e43b5d$export$e71175321a2b5dc8 = (0, $a655N.default)((0, $l7ahT.default)("owner"), $10e2337c64e43b5d$var$getRole);
const $10e2337c64e43b5d$export$8e6f75cc7b12bbe6 = (0, $a655N.default)((0, $bQytf.isNotNullAndNotEmpty), $10e2337c64e43b5d$var$getCompanyPlan);
const $10e2337c64e43b5d$export$9dad00cba3aebcb8 = (0, $a655N.default)((0, $bQytf.isNotNullAndNotEmpty), $10e2337c64e43b5d$var$getUserPlan);

});
parcelRegister("a655N", function(module, exports) {

$parcel$export(module.exports, "default", () => $759e6a2bc2cac489$export$2e2bcd8739ae039);

var $4Gqbx = parcelRequire("4Gqbx");

var $2VCUM = parcelRequire("2VCUM");
function $759e6a2bc2cac489$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("compose requires at least one argument");
    return (0, $4Gqbx.default).apply(this, (0, $2VCUM.default)(arguments));
}

});
parcelRegister("2VCUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $221f174d4005544c$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $lBqhj = parcelRequire("lBqhj");
/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */ var $221f174d4005544c$var$reverse = /*#__PURE__*/ (0, $aSQee.default)(function reverse(list) {
    return (0, $lBqhj.default)(list) ? list.split("").reverse().join("") : Array.prototype.slice.call(list, 0).reverse();
});
var $221f174d4005544c$export$2e2bcd8739ae039 = $221f174d4005544c$var$reverse;

});


parcelRegister("3dVdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $258ef72187a06d41$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");
/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */ var $258ef72187a06d41$var$lte = /*#__PURE__*/ (0, $2jcOR.default)(function lte(a, b) {
    return a <= b;
});
var $258ef72187a06d41$export$2e2bcd8739ae039 = $258ef72187a06d41$var$lte;

});

parcelRegister("dnABj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bd9d0833c80fa65$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");

var $lczBz = parcelRequire("lczBz");
/**
 * Retrieves the value at a given path. The nodes of the path can be arbitrary strings or non-negative integers.
 * For anything else, the value is unspecified. Integer paths are meant to index arrays, strings are meant for objects.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {a} -> a | Undefined
 * @sig Idx = String | NonNegativeInt
 * @param {Array} path The path to use.
 * @param {Object} obj The object or array to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop, R.nth, R.assocPath, R.dissocPath
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 *      R.path(['a', 'b', 0], {a: {b: [1, 2, 3]}}); //=> 1
 *      R.path(['a', 'b', -2], {a: {b: [1, 2, 3]}}); //=> 2
 *      R.path([2], {'2': 2}); //=> 2
 *      R.path([-2], {'-2': 'a'}); //=> undefined
 */ var $9bd9d0833c80fa65$var$path = /*#__PURE__*/ (0, $2jcOR.default)((0, $lczBz.default));
var $9bd9d0833c80fa65$export$2e2bcd8739ae039 = $9bd9d0833c80fa65$var$path;

});
parcelRegister("lczBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f656604df543bd$export$2e2bcd8739ae039);

var $e1REz = parcelRequire("e1REz");

var $cJy4o = parcelRequire("cJy4o");
function $f6f656604df543bd$export$2e2bcd8739ae039(pathAr, obj) {
    var val = obj;
    for(var i = 0; i < pathAr.length; i += 1){
        if (val == null) return undefined;
        var p = pathAr[i];
        if ((0, $e1REz.default)(p)) val = (0, $cJy4o.default)(p, val);
        else val = val[p];
    }
    return val;
}

});


parcelRegister("fEFLm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65afcadd845f952$export$2e2bcd8739ae039);

var $io7kf = parcelRequire("io7kf");

var $TSLKn = parcelRequire("TSLKn");

var $iDR1F = parcelRequire("iDR1F");
/**
 * Return the specified property of the given non-null object if the property
 * is present and it's value is not `null`, `undefined` or `NaN`.
 *
 * Otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const favorite = R.prop('favoriteLibrary');
 *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */ var $b65afcadd845f952$var$propOr = /*#__PURE__*/ (0, $io7kf.default)(function propOr(val, p, obj) {
    return (0, $TSLKn.default)(val, (0, $iDR1F.default)(p, obj));
});
var $b65afcadd845f952$export$2e2bcd8739ae039 = $b65afcadd845f952$var$propOr;

});
parcelRegister("TSLKn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a7f9f2c99a59791$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");
/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      const defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42(false);  //=> false
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */ var $0a7f9f2c99a59791$var$defaultTo = /*#__PURE__*/ (0, $2jcOR.default)(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
});
var $0a7f9f2c99a59791$export$2e2bcd8739ae039 = $0a7f9f2c99a59791$var$defaultTo;

});


parcelRegister("AHHxt", function(module, exports) {

$parcel$export(module.exports, "computedWithControl", () => $bc6380c684a2e15a$export$220dfb31330e2956);
$parcel$export(module.exports, "tryOnScopeDispose", () => $bc6380c684a2e15a$export$c3d49ae4e58d3d9d);
$parcel$export(module.exports, "createEventHook", () => $bc6380c684a2e15a$export$c8b3b0996d763ee);
$parcel$export(module.exports, "createGlobalState", () => $bc6380c684a2e15a$export$aa9aac23b3959ee1);
$parcel$export(module.exports, "makeDestructurable", () => $bc6380c684a2e15a$export$d50fdd10db75504e);
$parcel$export(module.exports, "toValue", () => $bc6380c684a2e15a$export$30bdcc2218aa9458);
$parcel$export(module.exports, "isClient", () => $bc6380c684a2e15a$export$7383f122bf48ec30);
$parcel$export(module.exports, "isWorker", () => $bc6380c684a2e15a$export$3c901a5f01941a06);
$parcel$export(module.exports, "isDef", () => $bc6380c684a2e15a$export$7b816c9b8ecf71b4);
$parcel$export(module.exports, "notNullish", () => $bc6380c684a2e15a$export$aedb69ff3e31596c);
$parcel$export(module.exports, "isObject", () => $bc6380c684a2e15a$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "timestamp", () => $bc6380c684a2e15a$export$fc00ee57782020aa);
$parcel$export(module.exports, "clamp", () => $bc6380c684a2e15a$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "noop", () => $bc6380c684a2e15a$export$8793edee2d425525);
$parcel$export(module.exports, "hasOwn", () => $bc6380c684a2e15a$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isIOS", () => $bc6380c684a2e15a$export$fedb369cb70207f1);
$parcel$export(module.exports, "createFilterWrapper", () => $bc6380c684a2e15a$export$a1f1cf91007f23bf);
$parcel$export(module.exports, "bypassFilter", () => $bc6380c684a2e15a$export$8cc0e33a27868391);
$parcel$export(module.exports, "debounceFilter", () => $bc6380c684a2e15a$export$fca2c450ae03b38e);
$parcel$export(module.exports, "throttleFilter", () => $bc6380c684a2e15a$export$cd62e9dbf204fd92);
$parcel$export(module.exports, "pausableFilter", () => $bc6380c684a2e15a$export$8d46ce8e0ead9c2b);
$parcel$export(module.exports, "camelize", () => $bc6380c684a2e15a$export$161d051f5dd25de7);
$parcel$export(module.exports, "promiseTimeout", () => $bc6380c684a2e15a$export$69e8b3daf72c74b7);
$parcel$export(module.exports, "identity", () => $bc6380c684a2e15a$export$f0954fd7d5368655);
$parcel$export(module.exports, "createSingletonPromise", () => $bc6380c684a2e15a$export$7a0c7c93e8e22bce);
$parcel$export(module.exports, "containsProp", () => $bc6380c684a2e15a$export$d138bf93e1dfa23f);
$parcel$export(module.exports, "increaseWithUnit", () => $bc6380c684a2e15a$export$f5c97f6a04b90212);
$parcel$export(module.exports, "objectPick", () => $bc6380c684a2e15a$export$5f2d71bd504be1ec);
$parcel$export(module.exports, "objectOmit", () => $bc6380c684a2e15a$export$3320623908f24e40);
$parcel$export(module.exports, "objectEntries", () => $bc6380c684a2e15a$export$6a29ade99f81ec8a);
$parcel$export(module.exports, "toRef", () => $bc6380c684a2e15a$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "useDebounceFn", () => $bc6380c684a2e15a$export$ddf8f1aa96b8ea88);
$parcel$export(module.exports, "useThrottleFn", () => $bc6380c684a2e15a$export$8ed85856108010bc);
$parcel$export(module.exports, "watchWithFilter", () => $bc6380c684a2e15a$export$3955c00bb6715986);
$parcel$export(module.exports, "pausableWatch", () => $bc6380c684a2e15a$export$37fdf671f882195e);
$parcel$export(module.exports, "syncRef", () => $bc6380c684a2e15a$export$d43743c1df800be0);
$parcel$export(module.exports, "toRefs", () => $bc6380c684a2e15a$export$2e9533675e5e70e0);
$parcel$export(module.exports, "tryOnBeforeUnmount", () => $bc6380c684a2e15a$export$7b037ce8d7969c15);
$parcel$export(module.exports, "tryOnMounted", () => $bc6380c684a2e15a$export$cf1be5b643f0827);
$parcel$export(module.exports, "tryOnUnmounted", () => $bc6380c684a2e15a$export$9fa6e59ca833c930);
$parcel$export(module.exports, "until", () => $bc6380c684a2e15a$export$a40009bd2c363351);
$parcel$export(module.exports, "useIntervalFn", () => $bc6380c684a2e15a$export$35ee30a05e4f2223);
$parcel$export(module.exports, "useTimeoutFn", () => $bc6380c684a2e15a$export$14705c14c13d528a);
$parcel$export(module.exports, "watchIgnorable", () => $bc6380c684a2e15a$export$63ac06655f58d92a);
parcelRequire("2apCf");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $2apCf = parcelRequire("2apCf");
function $bc6380c684a2e15a$export$c92323792c35f5f1(fn, options) {
    var _a;
    const result = (0, $01W3b.shallowRef)();
    (0, $TusQn.watchEffect)(()=>{
        result.value = fn();
    }, {
        ...options,
        flush: (_a = options == null ? void 0 : options.flush) != null ? _a : "sync"
    });
    return (0, $01W3b.readonly)(result);
}
function $bc6380c684a2e15a$export$220dfb31330e2956(source, fn) {
    let v = void 0;
    let track;
    let trigger;
    const dirty = (0, $01W3b.ref)(true);
    const update = ()=>{
        dirty.value = true;
        trigger();
    };
    (0, $TusQn.watch)(source, update, {
        flush: "sync"
    });
    const get = typeof fn === "function" ? fn : fn.get;
    const set = typeof fn === "function" ? void 0 : fn.set;
    const result = (0, $01W3b.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                if (dirty.value) {
                    v = get();
                    dirty.value = false;
                }
                track();
                return v;
            },
            set (v2) {
                set == null || set(v2);
            }
        };
    });
    if (Object.isExtensible(result)) result.trigger = update;
    return result;
}
function $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(fn) {
    if ((0, $01W3b.getCurrentScope)()) {
        (0, $01W3b.onScopeDispose)(fn);
        return true;
    }
    return false;
}
function $bc6380c684a2e15a$export$c8b3b0996d763ee() {
    const fns = /* @__PURE__ */ new Set();
    const off = (fn)=>{
        fns.delete(fn);
    };
    const on = (fn)=>{
        fns.add(fn);
        const offFn = ()=>off(fn);
        $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(offFn);
        return {
            off: offFn
        };
    };
    const trigger = (...args)=>{
        return Promise.all(Array.from(fns).map((fn)=>fn(...args)));
    };
    return {
        on: on,
        off: off,
        trigger: trigger
    };
}
function $bc6380c684a2e15a$export$aa9aac23b3959ee1(stateFactory) {
    let initialized = false;
    let state;
    const scope = (0, $01W3b.effectScope)(true);
    return (...args)=>{
        if (!initialized) {
            state = scope.run(()=>stateFactory(...args));
            initialized = true;
        }
        return state;
    };
}
const $bc6380c684a2e15a$var$localProvidedStateMap = /* @__PURE__ */ new WeakMap();
const $bc6380c684a2e15a$export$a797c3886d31ed0 = (key, value)=>{
    var _a;
    const instance = (_a = (0, $TusQn.getCurrentInstance)()) == null ? void 0 : _a.proxy;
    if (instance == null) throw new Error("provideLocal must be called in setup");
    if (!$bc6380c684a2e15a$var$localProvidedStateMap.has(instance)) $bc6380c684a2e15a$var$localProvidedStateMap.set(instance, /* @__PURE__ */ Object.create(null));
    const localProvidedState = $bc6380c684a2e15a$var$localProvidedStateMap.get(instance);
    localProvidedState[key] = value;
    (0, $TusQn.provide)(key, value);
};
const $bc6380c684a2e15a$export$89897216f9bf9933 = (...args)=>{
    var _a;
    const key = args[0];
    const instance = (_a = (0, $TusQn.getCurrentInstance)()) == null ? void 0 : _a.proxy;
    if (instance == null) throw new Error("injectLocal must be called in setup");
    if ($bc6380c684a2e15a$var$localProvidedStateMap.has(instance) && key in $bc6380c684a2e15a$var$localProvidedStateMap.get(instance)) return $bc6380c684a2e15a$var$localProvidedStateMap.get(instance)[key];
    return (0, $TusQn.inject)(...args);
};
function $bc6380c684a2e15a$export$91b9c7550061230e(composable, options) {
    const key = (options == null ? void 0 : options.injectionKey) || Symbol(composable.name || "InjectionState");
    const useProvidingState = (...args)=>{
        const state = composable(...args);
        $bc6380c684a2e15a$export$a797c3886d31ed0(key, state);
        return state;
    };
    const useInjectedState = ()=>$bc6380c684a2e15a$export$89897216f9bf9933(key);
    return [
        useProvidingState,
        useInjectedState
    ];
}
function $bc6380c684a2e15a$export$9e8d4b001a1bb310(composable) {
    let subscribers = 0;
    let state;
    let scope;
    const dispose = ()=>{
        subscribers -= 1;
        if (scope && subscribers <= 0) {
            scope.stop();
            state = void 0;
            scope = void 0;
        }
    };
    return (...args)=>{
        subscribers += 1;
        if (!state) {
            scope = (0, $01W3b.effectScope)(true);
            state = scope.run(()=>composable(...args));
        }
        $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(dispose);
        return state;
    };
}
function $bc6380c684a2e15a$export$ecda8b07a1b5deab(ref, extend, { enumerable: enumerable = false, unwrap: unwrap = true } = {}) {
    if (!(0, $2apCf.isVue3) && !(0, $TusQn.version).startsWith("2.7.")) throw new Error("[VueUse] extendRef only works in Vue 2.7 or above.");
    for (const [key, value] of Object.entries(extend)){
        if (key === "value") continue;
        if ((0, $01W3b.isRef)(value) && unwrap) Object.defineProperty(ref, key, {
            get () {
                return value.value;
            },
            set (v) {
                value.value = v;
            },
            enumerable: enumerable
        });
        else Object.defineProperty(ref, key, {
            value: value,
            enumerable: enumerable
        });
    }
    return ref;
}
function $bc6380c684a2e15a$export$3988ae62b71be9a3(obj, key) {
    if (key == null) return (0, $01W3b.unref)(obj);
    return (0, $01W3b.unref)(obj)[key];
}
function $bc6380c684a2e15a$export$4e62c701997796c1(v) {
    return (0, $01W3b.unref)(v) != null;
}
function $bc6380c684a2e15a$export$d50fdd10db75504e(obj, arr) {
    if (typeof Symbol !== "undefined") {
        const clone = {
            ...obj
        };
        Object.defineProperty(clone, Symbol.iterator, {
            enumerable: false,
            value () {
                let index = 0;
                return {
                    next: ()=>({
                            value: arr[index++],
                            done: index > arr.length
                        })
                };
            }
        });
        return clone;
    } else return Object.assign([
        ...arr
    ], obj);
}
function $bc6380c684a2e15a$export$30bdcc2218aa9458(r) {
    return typeof r === "function" ? r() : (0, $01W3b.unref)(r);
}
const $bc6380c684a2e15a$export$13fbab860e8afb41 = $bc6380c684a2e15a$export$30bdcc2218aa9458;
function $bc6380c684a2e15a$export$4ba03523724ba2d7(fn, options) {
    const unrefFn = (options == null ? void 0 : options.computedGetter) === false ? (0, $01W3b.unref) : $bc6380c684a2e15a$export$30bdcc2218aa9458;
    return function(...args) {
        return (0, $01W3b.computed)(()=>fn.apply(this, args.map((i)=>unrefFn(i))));
    };
}
function $bc6380c684a2e15a$export$1ff2e29423610e60(obj, optionsOrKeys = {}) {
    let keys = [];
    let options;
    if (Array.isArray(optionsOrKeys)) keys = optionsOrKeys;
    else {
        options = optionsOrKeys;
        const { includeOwnProperties: includeOwnProperties = true } = optionsOrKeys;
        keys.push(...Object.keys(obj));
        if (includeOwnProperties) keys.push(...Object.getOwnPropertyNames(obj));
    }
    return Object.fromEntries(keys.map((key)=>{
        const value = obj[key];
        return [
            key,
            typeof value === "function" ? $bc6380c684a2e15a$export$4ba03523724ba2d7(value.bind(obj), options) : value
        ];
    }));
}
function $bc6380c684a2e15a$export$45c769cf449a508c(objectRef) {
    if (!(0, $01W3b.isRef)(objectRef)) return (0, $01W3b.reactive)(objectRef);
    const proxy = new Proxy({}, {
        get (_, p, receiver) {
            return (0, $01W3b.unref)(Reflect.get(objectRef.value, p, receiver));
        },
        set (_, p, value) {
            if ((0, $01W3b.isRef)(objectRef.value[p]) && !(0, $01W3b.isRef)(value)) objectRef.value[p].value = value;
            else objectRef.value[p] = value;
            return true;
        },
        deleteProperty (_, p) {
            return Reflect.deleteProperty(objectRef.value, p);
        },
        has (_, p) {
            return Reflect.has(objectRef.value, p);
        },
        ownKeys () {
            return Object.keys(objectRef.value);
        },
        getOwnPropertyDescriptor () {
            return {
                enumerable: true,
                configurable: true
            };
        }
    });
    return (0, $01W3b.reactive)(proxy);
}
function $bc6380c684a2e15a$export$35298289c11958e1(fn) {
    return $bc6380c684a2e15a$export$45c769cf449a508c((0, $01W3b.computed)(fn));
}
function $bc6380c684a2e15a$export$797deb43a681bdd1(obj, ...keys) {
    const flatKeys = keys.flat();
    const predicate = flatKeys[0];
    return $bc6380c684a2e15a$export$35298289c11958e1(()=>typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $01W3b.toRefs)(obj)).filter(([k, v])=>!predicate($bc6380c684a2e15a$export$30bdcc2218aa9458(v), k))) : Object.fromEntries(Object.entries((0, $01W3b.toRefs)(obj)).filter((e)=>!flatKeys.includes(e[0]))));
}
const $bc6380c684a2e15a$export$7383f122bf48ec30 = typeof window !== "undefined" && typeof document !== "undefined";
const $bc6380c684a2e15a$export$3c901a5f01941a06 = typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
const $bc6380c684a2e15a$export$7b816c9b8ecf71b4 = (val)=>typeof val !== "undefined";
const $bc6380c684a2e15a$export$aedb69ff3e31596c = (val)=>val != null;
const $bc6380c684a2e15a$export$a7a9523472993e97 = (condition, ...infos)=>{
    if (!condition) console.warn(...infos);
};
const $bc6380c684a2e15a$var$toString = Object.prototype.toString;
const $bc6380c684a2e15a$export$a6cdc56e425d0d0a = (val)=>$bc6380c684a2e15a$var$toString.call(val) === "[object Object]";
const $bc6380c684a2e15a$export$461939dd4422153 = ()=>Date.now();
const $bc6380c684a2e15a$export$fc00ee57782020aa = ()=>+Date.now();
const $bc6380c684a2e15a$export$7d15b64cf5a3a4c4 = (n, min, max)=>Math.min(max, Math.max(min, n));
const $bc6380c684a2e15a$export$8793edee2d425525 = ()=>{};
const $bc6380c684a2e15a$export$bb0a9c36cf454ea0 = (min, max)=>{
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
const $bc6380c684a2e15a$export$b5a638e9b3fff9f3 = (val, key)=>Object.prototype.hasOwnProperty.call(val, key);
const $bc6380c684a2e15a$export$fedb369cb70207f1 = /* @__PURE__ */ $bc6380c684a2e15a$var$getIsIOS();
function $bc6380c684a2e15a$var$getIsIOS() {
    var _a, _b;
    return $bc6380c684a2e15a$export$7383f122bf48ec30 && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((_b = window == null ? void 0 : window.navigator) == null ? void 0 : _b.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function $bc6380c684a2e15a$export$a1f1cf91007f23bf(filter, fn) {
    function wrapper(...args) {
        return new Promise((resolve, reject)=>{
            Promise.resolve(filter(()=>fn.apply(this, args), {
                fn: fn,
                thisArg: this,
                args: args
            })).then(resolve).catch(reject);
        });
    }
    return wrapper;
}
const $bc6380c684a2e15a$export$8cc0e33a27868391 = (invoke)=>{
    return invoke();
};
function $bc6380c684a2e15a$export$fca2c450ae03b38e(ms, options = {}) {
    let timer;
    let maxTimer;
    let lastRejector = $bc6380c684a2e15a$export$8793edee2d425525;
    const _clearTimeout = (timer2)=>{
        clearTimeout(timer2);
        lastRejector();
        lastRejector = $bc6380c684a2e15a$export$8793edee2d425525;
    };
    const filter = (invoke)=>{
        const duration = $bc6380c684a2e15a$export$30bdcc2218aa9458(ms);
        const maxDuration = $bc6380c684a2e15a$export$30bdcc2218aa9458(options.maxWait);
        if (timer) _clearTimeout(timer);
        if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
            if (maxTimer) {
                _clearTimeout(maxTimer);
                maxTimer = null;
            }
            return Promise.resolve(invoke());
        }
        return new Promise((resolve, reject)=>{
            lastRejector = options.rejectOnCancel ? reject : resolve;
            if (maxDuration && !maxTimer) maxTimer = setTimeout(()=>{
                if (timer) _clearTimeout(timer);
                maxTimer = null;
                resolve(invoke());
            }, maxDuration);
            timer = setTimeout(()=>{
                if (maxTimer) _clearTimeout(maxTimer);
                maxTimer = null;
                resolve(invoke());
            }, duration);
        });
    };
    return filter;
}
function $bc6380c684a2e15a$export$cd62e9dbf204fd92(...args) {
    let lastExec = 0;
    let timer;
    let isLeading = true;
    let lastRejector = $bc6380c684a2e15a$export$8793edee2d425525;
    let lastValue;
    let ms;
    let trailing;
    let leading;
    let rejectOnCancel;
    if (!(0, $01W3b.isRef)(args[0]) && typeof args[0] === "object") ({ delay: ms, trailing: trailing = true, leading: leading = true, rejectOnCancel: rejectOnCancel = false } = args[0]);
    else [ms, trailing = true, leading = true, rejectOnCancel = false] = args;
    const clear = ()=>{
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
            lastRejector();
            lastRejector = $bc6380c684a2e15a$export$8793edee2d425525;
        }
    };
    const filter = (_invoke)=>{
        const duration = $bc6380c684a2e15a$export$30bdcc2218aa9458(ms);
        const elapsed = Date.now() - lastExec;
        const invoke = ()=>{
            return lastValue = _invoke();
        };
        clear();
        if (duration <= 0) {
            lastExec = Date.now();
            return invoke();
        }
        if (elapsed > duration && (leading || !isLeading)) {
            lastExec = Date.now();
            invoke();
        } else if (trailing) lastValue = new Promise((resolve, reject)=>{
            lastRejector = rejectOnCancel ? reject : resolve;
            timer = setTimeout(()=>{
                lastExec = Date.now();
                isLeading = true;
                resolve(invoke());
                clear();
            }, Math.max(0, duration - elapsed));
        });
        if (!leading && !timer) timer = setTimeout(()=>isLeading = true, duration);
        isLeading = false;
        return lastValue;
    };
    return filter;
}
function $bc6380c684a2e15a$export$8d46ce8e0ead9c2b(extendFilter = $bc6380c684a2e15a$export$8cc0e33a27868391) {
    const isActive = (0, $01W3b.ref)(true);
    function pause() {
        isActive.value = false;
    }
    function resume() {
        isActive.value = true;
    }
    const eventFilter = (...args)=>{
        if (isActive.value) extendFilter(...args);
    };
    return {
        isActive: (0, $01W3b.readonly)(isActive),
        pause: pause,
        resume: resume,
        eventFilter: eventFilter
    };
}
const $bc6380c684a2e15a$export$2161f27fc78b6ab2 = {
    mounted: (0, $2apCf.isVue3) ? "mounted" : "inserted",
    updated: (0, $2apCf.isVue3) ? "updated" : "componentUpdated",
    unmounted: (0, $2apCf.isVue3) ? "unmounted" : "unbind"
};
function $bc6380c684a2e15a$var$cacheStringFunction(fn) {
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
const $bc6380c684a2e15a$var$hyphenateRE = /\B([A-Z])/g;
const $bc6380c684a2e15a$export$6e6a0a3676c4b8bb = $bc6380c684a2e15a$var$cacheStringFunction((str)=>str.replace($bc6380c684a2e15a$var$hyphenateRE, "-$1").toLowerCase());
const $bc6380c684a2e15a$var$camelizeRE = /-(\w)/g;
const $bc6380c684a2e15a$export$161d051f5dd25de7 = $bc6380c684a2e15a$var$cacheStringFunction((str)=>{
    return str.replace($bc6380c684a2e15a$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
function $bc6380c684a2e15a$export$69e8b3daf72c74b7(ms, throwOnTimeout = false, reason = "Timeout") {
    return new Promise((resolve, reject)=>{
        if (throwOnTimeout) setTimeout(()=>reject(reason), ms);
        else setTimeout(resolve, ms);
    });
}
function $bc6380c684a2e15a$export$f0954fd7d5368655(arg) {
    return arg;
}
function $bc6380c684a2e15a$export$7a0c7c93e8e22bce(fn) {
    let _promise;
    function wrapper() {
        if (!_promise) _promise = fn();
        return _promise;
    }
    wrapper.reset = async ()=>{
        const _prev = _promise;
        _promise = void 0;
        if (_prev) await _prev;
    };
    return wrapper;
}
function $bc6380c684a2e15a$export$468cda29b159ee5d(fn) {
    return fn();
}
function $bc6380c684a2e15a$export$d138bf93e1dfa23f(obj, ...props) {
    return props.some((k)=>k in obj);
}
function $bc6380c684a2e15a$export$f5c97f6a04b90212(target, delta) {
    var _a;
    if (typeof target === "number") return target + delta;
    const value = ((_a = target.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : _a[0]) || "";
    const unit = target.slice(value.length);
    const result = Number.parseFloat(value) + delta;
    if (Number.isNaN(result)) return target;
    return result + unit;
}
function $bc6380c684a2e15a$export$5f2d71bd504be1ec(obj, keys, omitUndefined = false) {
    return keys.reduce((n, k)=>{
        if (k in obj) {
            if (!omitUndefined || obj[k] !== void 0) n[k] = obj[k];
        }
        return n;
    }, {});
}
function $bc6380c684a2e15a$export$3320623908f24e40(obj, keys, omitUndefined = false) {
    return Object.fromEntries(Object.entries(obj).filter(([key, value])=>{
        return (!omitUndefined || value !== void 0) && !keys.includes(key);
    }));
}
function $bc6380c684a2e15a$export$6a29ade99f81ec8a(obj) {
    return Object.entries(obj);
}
function $bc6380c684a2e15a$export$5c967efe8efb656c(target) {
    return target || (0, $TusQn.getCurrentInstance)();
}
function $bc6380c684a2e15a$export$1f60508e4f47b4b7(...args) {
    if (args.length !== 1) return (0, $01W3b.toRef)(...args);
    const r = args[0];
    return typeof r === "function" ? (0, $01W3b.readonly)((0, $01W3b.customRef)(()=>({
            get: r,
            set: $bc6380c684a2e15a$export$8793edee2d425525
        }))) : (0, $01W3b.ref)(r);
}
const $bc6380c684a2e15a$export$fb2b8a41d9966b32 = $bc6380c684a2e15a$export$1f60508e4f47b4b7;
function $bc6380c684a2e15a$export$afd74972d99a820f(obj, ...keys) {
    const flatKeys = keys.flat();
    const predicate = flatKeys[0];
    return $bc6380c684a2e15a$export$35298289c11958e1(()=>typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $01W3b.toRefs)(obj)).filter(([k, v])=>predicate($bc6380c684a2e15a$export$30bdcc2218aa9458(v), k))) : Object.fromEntries(flatKeys.map((k)=>[
                k,
                $bc6380c684a2e15a$export$1f60508e4f47b4b7(obj, k)
            ])));
}
function $bc6380c684a2e15a$export$c1f1e286df6cc58f(defaultValue, afterMs = 1e4) {
    return (0, $01W3b.customRef)((track, trigger)=>{
        let value = $bc6380c684a2e15a$export$30bdcc2218aa9458(defaultValue);
        let timer;
        const resetAfter = ()=>setTimeout(()=>{
                value = $bc6380c684a2e15a$export$30bdcc2218aa9458(defaultValue);
                trigger();
            }, $bc6380c684a2e15a$export$30bdcc2218aa9458(afterMs));
        $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(()=>{
            clearTimeout(timer);
        });
        return {
            get () {
                track();
                return value;
            },
            set (newValue) {
                value = newValue;
                trigger();
                clearTimeout(timer);
                timer = resetAfter();
            }
        };
    });
}
function $bc6380c684a2e15a$export$ddf8f1aa96b8ea88(fn, ms = 200, options = {}) {
    return $bc6380c684a2e15a$export$a1f1cf91007f23bf($bc6380c684a2e15a$export$fca2c450ae03b38e(ms, options), fn);
}
function $bc6380c684a2e15a$export$179967fbe3ecb41a(value, ms = 200, options = {}) {
    const debounced = (0, $01W3b.ref)(value.value);
    const updater = $bc6380c684a2e15a$export$ddf8f1aa96b8ea88(()=>{
        debounced.value = value.value;
    }, ms, options);
    (0, $TusQn.watch)(value, ()=>updater());
    return debounced;
}
function $bc6380c684a2e15a$export$52a73c0b6dcfe111(source, defaultValue) {
    return (0, $01W3b.computed)({
        get () {
            var _a;
            return (_a = source.value) != null ? _a : defaultValue;
        },
        set (value) {
            source.value = value;
        }
    });
}
function $bc6380c684a2e15a$export$8ed85856108010bc(fn, ms = 200, trailing = false, leading = true, rejectOnCancel = false) {
    return $bc6380c684a2e15a$export$a1f1cf91007f23bf($bc6380c684a2e15a$export$cd62e9dbf204fd92(ms, trailing, leading, rejectOnCancel), fn);
}
function $bc6380c684a2e15a$export$4d1d638ad6b48495(value, delay = 200, trailing = true, leading = true) {
    if (delay <= 0) return value;
    const throttled = (0, $01W3b.ref)(value.value);
    const updater = $bc6380c684a2e15a$export$8ed85856108010bc(()=>{
        throttled.value = value.value;
    }, delay, trailing, leading);
    (0, $TusQn.watch)(value, ()=>updater());
    return throttled;
}
function $bc6380c684a2e15a$export$4b7f2010e13474b2(initial, options = {}) {
    let source = initial;
    let track;
    let trigger;
    const ref = (0, $01W3b.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                return get();
            },
            set (v) {
                set(v);
            }
        };
    });
    function get(tracking = true) {
        if (tracking) track();
        return source;
    }
    function set(value, triggering = true) {
        var _a, _b;
        if (value === source) return;
        const old = source;
        if (((_a = options.onBeforeChange) == null ? void 0 : _a.call(options, value, old)) === false) return;
        source = value;
        (_b = options.onChanged) == null || _b.call(options, value, old);
        if (triggering) trigger();
    }
    const untrackedGet = ()=>get(false);
    const silentSet = (v)=>set(v, false);
    const peek = ()=>get(false);
    const lay = (v)=>set(v, false);
    return $bc6380c684a2e15a$export$ecda8b07a1b5deab(ref, {
        get: get,
        set: set,
        untrackedGet: untrackedGet,
        silentSet: silentSet,
        peek: peek,
        lay: lay
    }, {
        enumerable: true
    });
}
const $bc6380c684a2e15a$export$6b6db3af7a80e2d2 = $bc6380c684a2e15a$export$4b7f2010e13474b2;
function $bc6380c684a2e15a$export$adaa4cf7ef1b65be(...args) {
    if (args.length === 2) {
        const [ref, value] = args;
        ref.value = value;
    }
    if (args.length === 3) {
        if (0, $2apCf.isVue2) (0, $2apCf.set)(...args);
        else {
            const [target, key, value] = args;
            target[key] = value;
        }
    }
}
function $bc6380c684a2e15a$export$3955c00bb6715986(source, cb, options = {}) {
    const { eventFilter: eventFilter = $bc6380c684a2e15a$export$8cc0e33a27868391, ...watchOptions } = options;
    return (0, $TusQn.watch)(source, $bc6380c684a2e15a$export$a1f1cf91007f23bf(eventFilter, cb), watchOptions);
}
function $bc6380c684a2e15a$export$37fdf671f882195e(source, cb, options = {}) {
    const { eventFilter: filter, ...watchOptions } = options;
    const { eventFilter: eventFilter, pause: pause, resume: resume, isActive: isActive } = $bc6380c684a2e15a$export$8d46ce8e0ead9c2b(filter);
    const stop = $bc6380c684a2e15a$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: eventFilter
    });
    return {
        stop: stop,
        pause: pause,
        resume: resume,
        isActive: isActive
    };
}
function $bc6380c684a2e15a$export$d43743c1df800be0(left, right, ...[options]) {
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true, direction: direction = "both", transform: transform = {} } = options || {};
    const watchers = [];
    const transformLTR = "ltr" in transform && transform.ltr || ((v)=>v);
    const transformRTL = "rtl" in transform && transform.rtl || ((v)=>v);
    if (direction === "both" || direction === "ltr") watchers.push($bc6380c684a2e15a$export$37fdf671f882195e(left, (newValue)=>{
        watchers.forEach((w)=>w.pause());
        right.value = transformLTR(newValue);
        watchers.forEach((w)=>w.resume());
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    if (direction === "both" || direction === "rtl") watchers.push($bc6380c684a2e15a$export$37fdf671f882195e(right, (newValue)=>{
        watchers.forEach((w)=>w.pause());
        left.value = transformRTL(newValue);
        watchers.forEach((w)=>w.resume());
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    const stop = ()=>{
        watchers.forEach((w)=>w.stop());
    };
    return stop;
}
function $bc6380c684a2e15a$export$16a582ae8a437df6(source, targets, options = {}) {
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true } = options;
    if (!Array.isArray(targets)) targets = [
        targets
    ];
    return (0, $TusQn.watch)(source, (newValue)=>targets.forEach((target)=>target.value = newValue), {
        flush: flush,
        deep: deep,
        immediate: immediate
    });
}
function $bc6380c684a2e15a$export$2e9533675e5e70e0(objectRef, options = {}) {
    if (!(0, $01W3b.isRef)(objectRef)) return (0, $01W3b.toRefs)(objectRef);
    const result = Array.isArray(objectRef.value) ? Array.from({
        length: objectRef.value.length
    }) : {};
    for(const key in objectRef.value)result[key] = (0, $01W3b.customRef)(()=>({
            get () {
                return objectRef.value[key];
            },
            set (v) {
                var _a;
                const replaceRef = (_a = $bc6380c684a2e15a$export$30bdcc2218aa9458(options.replaceRef)) != null ? _a : true;
                if (replaceRef) {
                    if (Array.isArray(objectRef.value)) {
                        const copy = [
                            ...objectRef.value
                        ];
                        copy[key] = v;
                        objectRef.value = copy;
                    } else {
                        const newObject = {
                            ...objectRef.value,
                            [key]: v
                        };
                        Object.setPrototypeOf(newObject, Object.getPrototypeOf(objectRef.value));
                        objectRef.value = newObject;
                    }
                } else objectRef.value[key] = v;
            }
        }));
    return result;
}
function $bc6380c684a2e15a$export$25180f6b7105226e(fn, sync = true, target) {
    const instance = $bc6380c684a2e15a$export$5c967efe8efb656c(target);
    if (instance) (0, $TusQn.onBeforeMount)(fn, target);
    else if (sync) fn();
    else (0, $TusQn.nextTick)(fn);
}
function $bc6380c684a2e15a$export$7b037ce8d7969c15(fn, target) {
    const instance = $bc6380c684a2e15a$export$5c967efe8efb656c(target);
    if (instance) (0, $TusQn.onBeforeUnmount)(fn, target);
}
function $bc6380c684a2e15a$export$cf1be5b643f0827(fn, sync = true, target) {
    const instance = $bc6380c684a2e15a$export$5c967efe8efb656c();
    if (instance) (0, $TusQn.onMounted)(fn, target);
    else if (sync) fn();
    else (0, $TusQn.nextTick)(fn);
}
function $bc6380c684a2e15a$export$9fa6e59ca833c930(fn, target) {
    const instance = $bc6380c684a2e15a$export$5c967efe8efb656c(target);
    if (instance) (0, $TusQn.onUnmounted)(fn, target);
}
function $bc6380c684a2e15a$var$createUntil(r, isNot = false) {
    function toMatch(condition, { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = {}) {
        let stop = null;
        const watcher = new Promise((resolve)=>{
            stop = (0, $TusQn.watch)(r, (v)=>{
                if (condition(v) !== isNot) {
                    stop == null || stop();
                    resolve(v);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        const promises = [
            watcher
        ];
        if (timeout != null) promises.push($bc6380c684a2e15a$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>$bc6380c684a2e15a$export$30bdcc2218aa9458(r)).finally(()=>stop == null ? void 0 : stop()));
        return Promise.race(promises);
    }
    function toBe(value, options) {
        if (!(0, $01W3b.isRef)(value)) return toMatch((v)=>v === value, options);
        const { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = options != null ? options : {};
        let stop = null;
        const watcher = new Promise((resolve)=>{
            stop = (0, $TusQn.watch)([
                r,
                value
            ], ([v1, v2])=>{
                if (isNot !== (v1 === v2)) {
                    stop == null || stop();
                    resolve(v1);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        const promises = [
            watcher
        ];
        if (timeout != null) promises.push($bc6380c684a2e15a$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>$bc6380c684a2e15a$export$30bdcc2218aa9458(r)).finally(()=>{
            stop == null || stop();
            return $bc6380c684a2e15a$export$30bdcc2218aa9458(r);
        }));
        return Promise.race(promises);
    }
    function toBeTruthy(options) {
        return toMatch((v)=>Boolean(v), options);
    }
    function toBeNull(options) {
        return toBe(null, options);
    }
    function toBeUndefined(options) {
        return toBe(void 0, options);
    }
    function toBeNaN(options) {
        return toMatch(Number.isNaN, options);
    }
    function toContains(value, options) {
        return toMatch((v)=>{
            const array = Array.from(v);
            return array.includes(value) || array.includes($bc6380c684a2e15a$export$30bdcc2218aa9458(value));
        }, options);
    }
    function changed(options) {
        return changedTimes(1, options);
    }
    function changedTimes(n = 1, options) {
        let count = -1;
        return toMatch(()=>{
            count += 1;
            return count >= n;
        }, options);
    }
    if (Array.isArray($bc6380c684a2e15a$export$30bdcc2218aa9458(r))) {
        const instance = {
            toMatch: toMatch,
            toContains: toContains,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $bc6380c684a2e15a$var$createUntil(r, !isNot);
            }
        };
        return instance;
    } else {
        const instance = {
            toMatch: toMatch,
            toBe: toBe,
            toBeTruthy: toBeTruthy,
            toBeNull: toBeNull,
            toBeNaN: toBeNaN,
            toBeUndefined: toBeUndefined,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $bc6380c684a2e15a$var$createUntil(r, !isNot);
            }
        };
        return instance;
    }
}
function $bc6380c684a2e15a$export$a40009bd2c363351(r) {
    return $bc6380c684a2e15a$var$createUntil(r);
}
function $bc6380c684a2e15a$var$defaultComparator(value, othVal) {
    return value === othVal;
}
function $bc6380c684a2e15a$export$34602ebc410e389c(...args) {
    var _a;
    const list = args[0];
    const values = args[1];
    let compareFn = (_a = args[2]) != null ? _a : $bc6380c684a2e15a$var$defaultComparator;
    if (typeof compareFn === "string") {
        const key = compareFn;
        compareFn = (value, othVal)=>value[key] === othVal[key];
    }
    return (0, $01W3b.computed)(()=>$bc6380c684a2e15a$export$30bdcc2218aa9458(list).filter((x)=>$bc6380c684a2e15a$export$30bdcc2218aa9458(values).findIndex((y)=>compareFn(x, y)) === -1));
}
function $bc6380c684a2e15a$export$1e5a400faddb345f(list, fn) {
    return (0, $01W3b.computed)(()=>$bc6380c684a2e15a$export$30bdcc2218aa9458(list).every((element, index, array)=>fn($bc6380c684a2e15a$export$30bdcc2218aa9458(element), index, array)));
}
function $bc6380c684a2e15a$export$d62e4083f0a2d244(list, fn) {
    return (0, $01W3b.computed)(()=>$bc6380c684a2e15a$export$30bdcc2218aa9458(list).map((i)=>$bc6380c684a2e15a$export$30bdcc2218aa9458(i)).filter(fn));
}
function $bc6380c684a2e15a$export$ace4ef07c63f605e(list, fn) {
    return (0, $01W3b.computed)(()=>$bc6380c684a2e15a$export$30bdcc2218aa9458($bc6380c684a2e15a$export$30bdcc2218aa9458(list).find((element, index, array)=>fn($bc6380c684a2e15a$export$30bdcc2218aa9458(element), index, array))));
}
function $bc6380c684a2e15a$export$3ec066cdb63e2970(list, fn) {
    return (0, $01W3b.computed)(()=>$bc6380c684a2e15a$export$30bdcc2218aa9458(list).findIndex((element, index, array)=>fn($bc6380c684a2e15a$export$30bdcc2218aa9458(element), index, array)));
}
function $bc6380c684a2e15a$var$findLast(arr, cb) {
    let index = arr.length;
    while(index-- > 0){
        if (cb(arr[index], index, arr)) return arr[index];
    }
    return void 0;
}
function $bc6380c684a2e15a$export$b59cd47693a134f7(list, fn) {
    return (0, $01W3b.computed)(()=>$bc6380c684a2e15a$export$30bdcc2218aa9458(!Array.prototype.findLast ? $bc6380c684a2e15a$var$findLast($bc6380c684a2e15a$export$30bdcc2218aa9458(list), (element, index, array)=>fn($bc6380c684a2e15a$export$30bdcc2218aa9458(element), index, array)) : $bc6380c684a2e15a$export$30bdcc2218aa9458(list).findLast((element, index, array)=>fn($bc6380c684a2e15a$export$30bdcc2218aa9458(element), index, array))));
}
function $bc6380c684a2e15a$var$isArrayIncludesOptions(obj) {
    return $bc6380c684a2e15a$export$a6cdc56e425d0d0a(obj) && $bc6380c684a2e15a$export$d138bf93e1dfa23f(obj, "formIndex", "comparator");
}
function $bc6380c684a2e15a$export$34f006a38543d952(...args) {
    var _a;
    const list = args[0];
    const value = args[1];
    let comparator = args[2];
    let formIndex = 0;
    if ($bc6380c684a2e15a$var$isArrayIncludesOptions(comparator)) {
        formIndex = (_a = comparator.fromIndex) != null ? _a : 0;
        comparator = comparator.comparator;
    }
    if (typeof comparator === "string") {
        const key = comparator;
        comparator = (element, value2)=>element[key] === $bc6380c684a2e15a$export$30bdcc2218aa9458(value2);
    }
    comparator = comparator != null ? comparator : (element, value2)=>element === $bc6380c684a2e15a$export$30bdcc2218aa9458(value2);
    return (0, $01W3b.computed)(()=>$bc6380c684a2e15a$export$30bdcc2218aa9458(list).slice(formIndex).some((element, index, array)=>comparator($bc6380c684a2e15a$export$30bdcc2218aa9458(element), $bc6380c684a2e15a$export$30bdcc2218aa9458(value), index, $bc6380c684a2e15a$export$30bdcc2218aa9458(array))));
}
function $bc6380c684a2e15a$export$4a02928bbff39848(list, separator) {
    return (0, $01W3b.computed)(()=>$bc6380c684a2e15a$export$30bdcc2218aa9458(list).map((i)=>$bc6380c684a2e15a$export$30bdcc2218aa9458(i)).join($bc6380c684a2e15a$export$30bdcc2218aa9458(separator)));
}
function $bc6380c684a2e15a$export$8cc4758f083c4ffe(list, fn) {
    return (0, $01W3b.computed)(()=>$bc6380c684a2e15a$export$30bdcc2218aa9458(list).map((i)=>$bc6380c684a2e15a$export$30bdcc2218aa9458(i)).map(fn));
}
function $bc6380c684a2e15a$export$2a4c0ee40e3400de(list, reducer, ...args) {
    const reduceCallback = (sum, value, index)=>reducer($bc6380c684a2e15a$export$30bdcc2218aa9458(sum), $bc6380c684a2e15a$export$30bdcc2218aa9458(value), index);
    return (0, $01W3b.computed)(()=>{
        const resolved = $bc6380c684a2e15a$export$30bdcc2218aa9458(list);
        return args.length ? resolved.reduce(reduceCallback, $bc6380c684a2e15a$export$30bdcc2218aa9458(args[0])) : resolved.reduce(reduceCallback);
    });
}
function $bc6380c684a2e15a$export$53834b0e1a20e7a3(list, fn) {
    return (0, $01W3b.computed)(()=>$bc6380c684a2e15a$export$30bdcc2218aa9458(list).some((element, index, array)=>fn($bc6380c684a2e15a$export$30bdcc2218aa9458(element), index, array)));
}
function $bc6380c684a2e15a$var$uniq(array) {
    return Array.from(new Set(array));
}
function $bc6380c684a2e15a$var$uniqueElementsBy(array, fn) {
    return array.reduce((acc, v)=>{
        if (!acc.some((x)=>fn(v, x, array))) acc.push(v);
        return acc;
    }, []);
}
function $bc6380c684a2e15a$export$1b97ec936c2f7d03(list, compareFn) {
    return (0, $01W3b.computed)(()=>{
        const resolvedList = $bc6380c684a2e15a$export$30bdcc2218aa9458(list).map((element)=>$bc6380c684a2e15a$export$30bdcc2218aa9458(element));
        return compareFn ? $bc6380c684a2e15a$var$uniqueElementsBy(resolvedList, compareFn) : $bc6380c684a2e15a$var$uniq(resolvedList);
    });
}
function $bc6380c684a2e15a$export$70c4067197c60e2d(initialValue = 0, options = {}) {
    let _initialValue = (0, $01W3b.unref)(initialValue);
    const count = (0, $01W3b.ref)(initialValue);
    const { max: max = Number.POSITIVE_INFINITY, min: min = Number.NEGATIVE_INFINITY } = options;
    const inc = (delta = 1)=>count.value = Math.max(Math.min(max, count.value + delta), min);
    const dec = (delta = 1)=>count.value = Math.min(Math.max(min, count.value - delta), max);
    const get = ()=>count.value;
    const set = (val)=>count.value = Math.max(min, Math.min(max, val));
    const reset = (val = _initialValue)=>{
        _initialValue = val;
        return set(val);
    };
    return {
        count: count,
        inc: inc,
        dec: dec,
        get: get,
        set: set,
        reset: reset
    };
}
const $bc6380c684a2e15a$var$REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/;
const $bc6380c684a2e15a$var$REGEX_FORMAT = /[YMDHhms]o|\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a{1,2}|A{1,2}|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
function $bc6380c684a2e15a$var$defaultMeridiem(hours, minutes, isLowercase, hasPeriod) {
    let m = hours < 12 ? "AM" : "PM";
    if (hasPeriod) m = m.split("").reduce((acc, curr)=>acc += `${curr}.`, "");
    return isLowercase ? m.toLowerCase() : m;
}
function $bc6380c684a2e15a$var$formatOrdinal(num) {
    const suffixes = [
        "th",
        "st",
        "nd",
        "rd"
    ];
    const v = num % 100;
    return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}
function $bc6380c684a2e15a$export$3ae94a2503e890a1(date, formatStr, options = {}) {
    var _a;
    const years = date.getFullYear();
    const month = date.getMonth();
    const days = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const milliseconds = date.getMilliseconds();
    const day = date.getDay();
    const meridiem = (_a = options.customMeridiem) != null ? _a : $bc6380c684a2e15a$var$defaultMeridiem;
    const matches = {
        Yo: ()=>$bc6380c684a2e15a$var$formatOrdinal(years),
        YY: ()=>String(years).slice(-2),
        YYYY: ()=>years,
        M: ()=>month + 1,
        Mo: ()=>$bc6380c684a2e15a$var$formatOrdinal(month + 1),
        MM: ()=>`${month + 1}`.padStart(2, "0"),
        MMM: ()=>date.toLocaleDateString(options.locales, {
                month: "short"
            }),
        MMMM: ()=>date.toLocaleDateString(options.locales, {
                month: "long"
            }),
        D: ()=>String(days),
        Do: ()=>$bc6380c684a2e15a$var$formatOrdinal(days),
        DD: ()=>`${days}`.padStart(2, "0"),
        H: ()=>String(hours),
        Ho: ()=>$bc6380c684a2e15a$var$formatOrdinal(hours),
        HH: ()=>`${hours}`.padStart(2, "0"),
        h: ()=>`${hours % 12 || 12}`.padStart(1, "0"),
        ho: ()=>$bc6380c684a2e15a$var$formatOrdinal(hours % 12 || 12),
        hh: ()=>`${hours % 12 || 12}`.padStart(2, "0"),
        m: ()=>String(minutes),
        mo: ()=>$bc6380c684a2e15a$var$formatOrdinal(minutes),
        mm: ()=>`${minutes}`.padStart(2, "0"),
        s: ()=>String(seconds),
        so: ()=>$bc6380c684a2e15a$var$formatOrdinal(seconds),
        ss: ()=>`${seconds}`.padStart(2, "0"),
        SSS: ()=>`${milliseconds}`.padStart(3, "0"),
        d: ()=>day,
        dd: ()=>date.toLocaleDateString(options.locales, {
                weekday: "narrow"
            }),
        ddd: ()=>date.toLocaleDateString(options.locales, {
                weekday: "short"
            }),
        dddd: ()=>date.toLocaleDateString(options.locales, {
                weekday: "long"
            }),
        A: ()=>meridiem(hours, minutes),
        AA: ()=>meridiem(hours, minutes, false, true),
        a: ()=>meridiem(hours, minutes, true),
        aa: ()=>meridiem(hours, minutes, true, true)
    };
    return formatStr.replace($bc6380c684a2e15a$var$REGEX_FORMAT, (match, $1)=>{
        var _a2, _b;
        return (_b = $1 != null ? $1 : (_a2 = matches[match]) == null ? void 0 : _a2.call(matches)) != null ? _b : match;
    });
}
function $bc6380c684a2e15a$export$fcc71269590ba0a8(date) {
    if (date === null) return new Date(Number.NaN);
    if (date === void 0) return /* @__PURE__ */ new Date();
    if (date instanceof Date) return new Date(date);
    if (typeof date === "string" && !/Z$/i.test(date)) {
        const d = date.match($bc6380c684a2e15a$var$REGEX_PARSE);
        if (d) {
            const m = d[2] - 1 || 0;
            const ms = (d[7] || "0").substring(0, 3);
            return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
        }
    }
    return new Date(date);
}
function $bc6380c684a2e15a$export$6d181172004bc6fc(date, formatStr = "HH:mm:ss", options = {}) {
    return (0, $01W3b.computed)(()=>$bc6380c684a2e15a$export$3ae94a2503e890a1($bc6380c684a2e15a$export$fcc71269590ba0a8($bc6380c684a2e15a$export$30bdcc2218aa9458(date)), $bc6380c684a2e15a$export$30bdcc2218aa9458(formatStr), options));
}
function $bc6380c684a2e15a$export$35ee30a05e4f2223(cb, interval = 1e3, options = {}) {
    const { immediate: immediate = true, immediateCallback: immediateCallback = false } = options;
    let timer = null;
    const isActive = (0, $01W3b.ref)(false);
    function clean() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }
    function pause() {
        isActive.value = false;
        clean();
    }
    function resume() {
        const intervalValue = $bc6380c684a2e15a$export$30bdcc2218aa9458(interval);
        if (intervalValue <= 0) return;
        isActive.value = true;
        if (immediateCallback) cb();
        clean();
        timer = setInterval(cb, intervalValue);
    }
    if (immediate && $bc6380c684a2e15a$export$7383f122bf48ec30) resume();
    if ((0, $01W3b.isRef)(interval) || typeof interval === "function") {
        const stopWatch = (0, $TusQn.watch)(interval, ()=>{
            if (isActive.value && $bc6380c684a2e15a$export$7383f122bf48ec30) resume();
        });
        $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(stopWatch);
    }
    $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(pause);
    return {
        isActive: isActive,
        pause: pause,
        resume: resume
    };
}
function $bc6380c684a2e15a$export$f4b266cd2aae9cb1(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, immediate: immediate = true, callback: callback } = options;
    const counter = (0, $01W3b.ref)(0);
    const update = ()=>counter.value += 1;
    const reset = ()=>{
        counter.value = 0;
    };
    const controls = $bc6380c684a2e15a$export$35ee30a05e4f2223(callback ? ()=>{
        update();
        callback(counter.value);
    } : update, interval, {
        immediate: immediate
    });
    if (exposeControls) return {
        counter: counter,
        reset: reset,
        ...controls
    };
    else return counter;
}
function $bc6380c684a2e15a$export$de385d6f89d6db3c(source, options = {}) {
    var _a;
    const ms = (0, $01W3b.ref)((_a = options.initialValue) != null ? _a : null);
    (0, $TusQn.watch)(source, ()=>ms.value = $bc6380c684a2e15a$export$fc00ee57782020aa(), options);
    return ms;
}
function $bc6380c684a2e15a$export$14705c14c13d528a(cb, interval, options = {}) {
    const { immediate: immediate = true } = options;
    const isPending = (0, $01W3b.ref)(false);
    let timer = null;
    function clear() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function stop() {
        isPending.value = false;
        clear();
    }
    function start(...args) {
        clear();
        isPending.value = true;
        timer = setTimeout(()=>{
            isPending.value = false;
            timer = null;
            cb(...args);
        }, $bc6380c684a2e15a$export$30bdcc2218aa9458(interval));
    }
    if (immediate) {
        isPending.value = true;
        if ($bc6380c684a2e15a$export$7383f122bf48ec30) start();
    }
    $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(stop);
    return {
        isPending: (0, $01W3b.readonly)(isPending),
        start: start,
        stop: stop
    };
}
function $bc6380c684a2e15a$export$d8e6abf214c9ec0f(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, callback: callback } = options;
    const controls = $bc6380c684a2e15a$export$14705c14c13d528a(callback != null ? callback : $bc6380c684a2e15a$export$8793edee2d425525, interval, options);
    const ready = (0, $01W3b.computed)(()=>!controls.isPending.value);
    if (exposeControls) return {
        ready: ready,
        ...controls
    };
    else return ready;
}
function $bc6380c684a2e15a$export$1ee6bb1f922f50b3(value, options = {}) {
    const { method: method = "parseFloat", radix: radix, nanToZero: nanToZero } = options;
    return (0, $01W3b.computed)(()=>{
        let resolved = $bc6380c684a2e15a$export$30bdcc2218aa9458(value);
        if (typeof resolved === "string") resolved = Number[method](resolved, radix);
        if (nanToZero && Number.isNaN(resolved)) resolved = 0;
        return resolved;
    });
}
function $bc6380c684a2e15a$export$8906942fea47e698(value) {
    return (0, $01W3b.computed)(()=>`${$bc6380c684a2e15a$export$30bdcc2218aa9458(value)}`);
}
function $bc6380c684a2e15a$export$cbe85ee05b554577(initialValue = false, options = {}) {
    const { truthyValue: truthyValue = true, falsyValue: falsyValue = false } = options;
    const valueIsRef = (0, $01W3b.isRef)(initialValue);
    const _value = (0, $01W3b.ref)(initialValue);
    function toggle(value) {
        if (arguments.length) {
            _value.value = value;
            return _value.value;
        } else {
            const truthy = $bc6380c684a2e15a$export$30bdcc2218aa9458(truthyValue);
            _value.value = _value.value === truthy ? $bc6380c684a2e15a$export$30bdcc2218aa9458(falsyValue) : truthy;
            return _value.value;
        }
    }
    if (valueIsRef) return toggle;
    else return [
        _value,
        toggle
    ];
}
function $bc6380c684a2e15a$export$8ebd2befe4deaa6b(source, cb, options) {
    let oldList = (options == null ? void 0 : options.immediate) ? [] : [
        ...source instanceof Function ? source() : Array.isArray(source) ? source : $bc6380c684a2e15a$export$30bdcc2218aa9458(source)
    ];
    return (0, $TusQn.watch)(source, (newList, _, onCleanup)=>{
        const oldListRemains = Array.from({
            length: oldList.length
        });
        const added = [];
        for (const obj of newList){
            let found = false;
            for(let i = 0; i < oldList.length; i++)if (!oldListRemains[i] && obj === oldList[i]) {
                oldListRemains[i] = true;
                found = true;
                break;
            }
            if (!found) added.push(obj);
        }
        const removed = oldList.filter((_2, i)=>!oldListRemains[i]);
        cb(newList, oldList, added, removed, onCleanup);
        oldList = [
            ...newList
        ];
    }, options);
}
function $bc6380c684a2e15a$export$a121c3bc1a97f0b4(source, cb, options) {
    const { count: count, ...watchOptions } = options;
    const current = (0, $01W3b.ref)(0);
    const stop = $bc6380c684a2e15a$export$3955c00bb6715986(source, (...args)=>{
        current.value += 1;
        if (current.value >= $bc6380c684a2e15a$export$30bdcc2218aa9458(count)) (0, $TusQn.nextTick)(()=>stop());
        cb(...args);
    }, watchOptions);
    return {
        count: current,
        stop: stop
    };
}
function $bc6380c684a2e15a$export$578b5d9cbe132cee(source, cb, options = {}) {
    const { debounce: debounce = 0, maxWait: maxWait, ...watchOptions } = options;
    return $bc6380c684a2e15a$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: $bc6380c684a2e15a$export$fca2c450ae03b38e(debounce, {
            maxWait: maxWait
        })
    });
}
function $bc6380c684a2e15a$export$79f242cf85fb93a(source, cb, options) {
    return (0, $TusQn.watch)(source, cb, {
        ...options,
        deep: true
    });
}
function $bc6380c684a2e15a$export$63ac06655f58d92a(source, cb, options = {}) {
    const { eventFilter: eventFilter = $bc6380c684a2e15a$export$8cc0e33a27868391, ...watchOptions } = options;
    const filteredCb = $bc6380c684a2e15a$export$a1f1cf91007f23bf(eventFilter, cb);
    let ignoreUpdates;
    let ignorePrevAsyncUpdates;
    let stop;
    if (watchOptions.flush === "sync") {
        const ignore = (0, $01W3b.ref)(false);
        ignorePrevAsyncUpdates = ()=>{};
        ignoreUpdates = (updater)=>{
            ignore.value = true;
            updater();
            ignore.value = false;
        };
        stop = (0, $TusQn.watch)(source, (...args)=>{
            if (!ignore.value) filteredCb(...args);
        }, watchOptions);
    } else {
        const disposables = [];
        const ignoreCounter = (0, $01W3b.ref)(0);
        const syncCounter = (0, $01W3b.ref)(0);
        ignorePrevAsyncUpdates = ()=>{
            ignoreCounter.value = syncCounter.value;
        };
        disposables.push((0, $TusQn.watch)(source, ()=>{
            syncCounter.value++;
        }, {
            ...watchOptions,
            flush: "sync"
        }));
        ignoreUpdates = (updater)=>{
            const syncCounterPrev = syncCounter.value;
            updater();
            ignoreCounter.value += syncCounter.value - syncCounterPrev;
        };
        disposables.push((0, $TusQn.watch)(source, (...args)=>{
            const ignore = ignoreCounter.value > 0 && ignoreCounter.value === syncCounter.value;
            ignoreCounter.value = 0;
            syncCounter.value = 0;
            if (ignore) return;
            filteredCb(...args);
        }, watchOptions));
        stop = ()=>{
            disposables.forEach((fn)=>fn());
        };
    }
    return {
        stop: stop,
        ignoreUpdates: ignoreUpdates,
        ignorePrevAsyncUpdates: ignorePrevAsyncUpdates
    };
}
function $bc6380c684a2e15a$export$d9aec7ec4e8a1634(source, cb, options) {
    return (0, $TusQn.watch)(source, cb, {
        ...options,
        immediate: true
    });
}
function $bc6380c684a2e15a$export$95d4a8ca30b80ae0(source, cb, options) {
    const stop = (0, $TusQn.watch)(source, (...args)=>{
        (0, $TusQn.nextTick)(()=>stop());
        return cb(...args);
    }, options);
    return stop;
}
function $bc6380c684a2e15a$export$2768dce732d5eb3(source, cb, options = {}) {
    const { throttle: throttle = 0, trailing: trailing = true, leading: leading = true, ...watchOptions } = options;
    return $bc6380c684a2e15a$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: $bc6380c684a2e15a$export$cd62e9dbf204fd92(throttle, trailing, leading)
    });
}
function $bc6380c684a2e15a$export$b75c094d1092c205(source, cb, options = {}) {
    let cleanupFn;
    function onEffect() {
        if (!cleanupFn) return;
        const fn = cleanupFn;
        cleanupFn = void 0;
        fn();
    }
    function onCleanup(callback) {
        cleanupFn = callback;
    }
    const _cb = (value, oldValue)=>{
        onEffect();
        return cb(value, oldValue, onCleanup);
    };
    const res = $bc6380c684a2e15a$export$63ac06655f58d92a(source, _cb, options);
    const { ignoreUpdates: ignoreUpdates } = res;
    const trigger = ()=>{
        let res2;
        ignoreUpdates(()=>{
            res2 = _cb($bc6380c684a2e15a$var$getWatchSources(source), $bc6380c684a2e15a$var$getOldValue(source));
        });
        return res2;
    };
    return {
        ...res,
        trigger: trigger
    };
}
function $bc6380c684a2e15a$var$getWatchSources(sources) {
    if ((0, $01W3b.isReactive)(sources)) return sources;
    if (Array.isArray(sources)) return sources.map((item)=>$bc6380c684a2e15a$export$30bdcc2218aa9458(item));
    return $bc6380c684a2e15a$export$30bdcc2218aa9458(sources);
}
function $bc6380c684a2e15a$var$getOldValue(source) {
    return Array.isArray(source) ? source.map(()=>void 0) : void 0;
}
function $bc6380c684a2e15a$export$909eba9696cc3445(source, cb, options) {
    const stop = (0, $TusQn.watch)(source, (v, ov, onInvalidate)=>{
        if (v) {
            if (options == null ? void 0 : options.once) (0, $TusQn.nextTick)(()=>stop());
            cb(v, ov, onInvalidate);
        }
    }, {
        ...options,
        once: false
    });
    return stop;
}

});
parcelRegister("2apCf", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("01W3b")).computed);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("TusQn")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "version", () => (parcelRequire("TusQn")).version);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);

$parcel$export(module.exports, "isVue2", () => $1ec6fc1442527e17$export$1da84e343e81ceb9);
$parcel$export(module.exports, "isVue3", () => $1ec6fc1442527e17$export$34b222e3d4733e48);
$parcel$export(module.exports, "set", () => $1ec6fc1442527e17$export$adaa4cf7ef1b65be);
parcelRequire("ecd4d");
var $1ec6fc1442527e17$export$1da84e343e81ceb9 = false;
var $1ec6fc1442527e17$export$34b222e3d4733e48 = true;
var $1ec6fc1442527e17$export$a8cb34872e7d8b79 = undefined;
function $1ec6fc1442527e17$export$4b3e715f166fdd78() {}
function $1ec6fc1442527e17$export$adaa4cf7ef1b65be(target, key, val) {
    if (Array.isArray(target)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    target[key] = val;
    return val;
}
function $1ec6fc1442527e17$export$1d2f21e549771e67(target, key) {
    if (Array.isArray(target)) {
        target.splice(key, 1);
        return;
    }
    delete target[key];
}

});


parcelRegister("hmpaa", function(module, exports) {
$parcel$export(module.exports, "bypassFilter", () => (parcelRequire("AHHxt")).bypassFilter);
$parcel$export(module.exports, "camelize", () => (parcelRequire("AHHxt")).camelize);
$parcel$export(module.exports, "clamp", () => (parcelRequire("AHHxt")).clamp);
$parcel$export(module.exports, "computedWithControl", () => (parcelRequire("AHHxt")).computedWithControl);
$parcel$export(module.exports, "containsProp", () => (parcelRequire("AHHxt")).containsProp);
$parcel$export(module.exports, "createEventHook", () => (parcelRequire("AHHxt")).createEventHook);
$parcel$export(module.exports, "createFilterWrapper", () => (parcelRequire("AHHxt")).createFilterWrapper);
$parcel$export(module.exports, "createGlobalState", () => (parcelRequire("AHHxt")).createGlobalState);
$parcel$export(module.exports, "createSingletonPromise", () => (parcelRequire("AHHxt")).createSingletonPromise);
$parcel$export(module.exports, "debounceFilter", () => (parcelRequire("AHHxt")).debounceFilter);
$parcel$export(module.exports, "hasOwn", () => (parcelRequire("AHHxt")).hasOwn);
$parcel$export(module.exports, "identity", () => (parcelRequire("AHHxt")).identity);
$parcel$export(module.exports, "increaseWithUnit", () => (parcelRequire("AHHxt")).increaseWithUnit);
$parcel$export(module.exports, "isClient", () => (parcelRequire("AHHxt")).isClient);
$parcel$export(module.exports, "isDef", () => (parcelRequire("AHHxt")).isDef);
$parcel$export(module.exports, "isIOS", () => (parcelRequire("AHHxt")).isIOS);
$parcel$export(module.exports, "isObject", () => (parcelRequire("AHHxt")).isObject);
$parcel$export(module.exports, "isWorker", () => (parcelRequire("AHHxt")).isWorker);
$parcel$export(module.exports, "makeDestructurable", () => (parcelRequire("AHHxt")).makeDestructurable);
$parcel$export(module.exports, "noop", () => (parcelRequire("AHHxt")).noop);
$parcel$export(module.exports, "notNullish", () => (parcelRequire("AHHxt")).notNullish);
$parcel$export(module.exports, "objectEntries", () => (parcelRequire("AHHxt")).objectEntries);
$parcel$export(module.exports, "objectOmit", () => (parcelRequire("AHHxt")).objectOmit);
$parcel$export(module.exports, "objectPick", () => (parcelRequire("AHHxt")).objectPick);
$parcel$export(module.exports, "pausableFilter", () => (parcelRequire("AHHxt")).pausableFilter);
$parcel$export(module.exports, "pausableWatch", () => (parcelRequire("AHHxt")).pausableWatch);
$parcel$export(module.exports, "promiseTimeout", () => (parcelRequire("AHHxt")).promiseTimeout);
$parcel$export(module.exports, "syncRef", () => (parcelRequire("AHHxt")).syncRef);
$parcel$export(module.exports, "throttleFilter", () => (parcelRequire("AHHxt")).throttleFilter);
$parcel$export(module.exports, "timestamp", () => (parcelRequire("AHHxt")).timestamp);
$parcel$export(module.exports, "toRef", () => (parcelRequire("AHHxt")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("AHHxt")).toRefs);
$parcel$export(module.exports, "toValue", () => (parcelRequire("AHHxt")).toValue);
$parcel$export(module.exports, "tryOnBeforeUnmount", () => (parcelRequire("AHHxt")).tryOnBeforeUnmount);
$parcel$export(module.exports, "tryOnMounted", () => (parcelRequire("AHHxt")).tryOnMounted);
$parcel$export(module.exports, "tryOnScopeDispose", () => (parcelRequire("AHHxt")).tryOnScopeDispose);
$parcel$export(module.exports, "tryOnUnmounted", () => (parcelRequire("AHHxt")).tryOnUnmounted);
$parcel$export(module.exports, "until", () => (parcelRequire("AHHxt")).until);
$parcel$export(module.exports, "useDebounceFn", () => (parcelRequire("AHHxt")).useDebounceFn);
$parcel$export(module.exports, "useIntervalFn", () => (parcelRequire("AHHxt")).useIntervalFn);
$parcel$export(module.exports, "useThrottleFn", () => (parcelRequire("AHHxt")).useThrottleFn);
$parcel$export(module.exports, "useTimeoutFn", () => (parcelRequire("AHHxt")).useTimeoutFn);
$parcel$export(module.exports, "watchIgnorable", () => (parcelRequire("AHHxt")).watchIgnorable);
$parcel$export(module.exports, "watchWithFilter", () => (parcelRequire("AHHxt")).watchWithFilter);

$parcel$export(module.exports, "useStorage", () => $6ffe9515611cb489$export$95809329f49ea9f9);

var $AHHxt = parcelRequire("AHHxt");
parcelRequire("keUOA");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $keUOA = parcelRequire("keUOA");
var $eeJ70 = parcelRequire("eeJ70");
function $6ffe9515611cb489$export$dcbb7025f4e5281b(evaluationCallback, initialState, optionsOrRef) {
    let options;
    if ((0, $01W3b.isRef)(optionsOrRef)) options = {
        evaluating: optionsOrRef
    };
    else options = optionsOrRef || {};
    const { lazy: lazy = false, evaluating: evaluating, shallow: shallow = true, onError: onError = (0, $AHHxt.noop) } = options;
    const started = (0, $01W3b.ref)(!lazy);
    const current = shallow ? (0, $01W3b.shallowRef)(initialState) : (0, $01W3b.ref)(initialState);
    let counter = 0;
    (0, $TusQn.watchEffect)(async (onInvalidate)=>{
        if (!started.value) return;
        counter++;
        const counterAtBeginning = counter;
        let hasFinished = false;
        if (evaluating) Promise.resolve().then(()=>{
            evaluating.value = true;
        });
        try {
            const result = await evaluationCallback((cancelCallback)=>{
                onInvalidate(()=>{
                    if (evaluating) evaluating.value = false;
                    if (!hasFinished) cancelCallback();
                });
            });
            if (counterAtBeginning === counter) current.value = result;
        } catch (e) {
            onError(e);
        } finally{
            if (evaluating && counterAtBeginning === counter) evaluating.value = false;
            hasFinished = true;
        }
    });
    if (lazy) return (0, $01W3b.computed)(()=>{
        started.value = true;
        return current.value;
    });
    else return current;
}
function $6ffe9515611cb489$export$dc0885167ecf1257(key, options, defaultSource, treatDefaultAsFactory) {
    let source = (0, $TusQn.inject)(key);
    if (defaultSource) source = (0, $TusQn.inject)(key, defaultSource);
    if (treatDefaultAsFactory) source = (0, $TusQn.inject)(key, defaultSource, treatDefaultAsFactory);
    if (typeof options === "function") return (0, $01W3b.computed)((ctx)=>options(source, ctx));
    else return (0, $01W3b.computed)({
        get: (ctx)=>options.get(source, ctx),
        set: options.set
    });
}
function $6ffe9515611cb489$export$7ef9f841998c60db(options = {}) {
    if (!(0, $keUOA.isVue3) && !(0, $TusQn.version).startsWith("2.7.")) throw new Error("[VueUse] createReusableTemplate only works in Vue 2.7 or above.");
    const { inheritAttrs: inheritAttrs = true } = options;
    const render = (0, $01W3b.shallowRef)();
    const define = /* #__PURE__ */ (0, $TusQn.defineComponent)({
        setup (_, { slots: slots }) {
            return ()=>{
                render.value = slots.default;
            };
        }
    });
    const reuse = /* #__PURE__ */ (0, $TusQn.defineComponent)({
        inheritAttrs: inheritAttrs,
        setup (_, { attrs: attrs, slots: slots }) {
            return ()=>{
                var _a;
                if (!render.value && true) throw new Error("[VueUse] Failed to find the definition of reusable template");
                const vnode = (_a = render.value) == null ? void 0 : _a.call(render, {
                    ...$6ffe9515611cb489$var$keysToCamelKebabCase(attrs),
                    $slots: slots
                });
                return inheritAttrs && (vnode == null ? void 0 : vnode.length) === 1 ? vnode[0] : vnode;
            };
        }
    });
    return (0, $AHHxt.makeDestructurable)({
        define: define,
        reuse: reuse
    }, [
        define,
        reuse
    ]);
}
function $6ffe9515611cb489$var$keysToCamelKebabCase(obj) {
    const newObj = {};
    for(const key in obj)newObj[(0, $AHHxt.camelize)(key)] = obj[key];
    return newObj;
}
function $6ffe9515611cb489$export$cf238338337c58d1(options = {}) {
    if (!(0, $keUOA.isVue3)) throw new Error("[VueUse] createTemplatePromise only works in Vue 3 or above.");
    let index = 0;
    const instances = (0, $01W3b.ref)([]);
    function create(...args) {
        const props = (0, $01W3b.shallowReactive)({
            key: index++,
            args: args,
            promise: void 0,
            resolve: ()=>{},
            reject: ()=>{},
            isResolving: false,
            options: options
        });
        instances.value.push(props);
        props.promise = new Promise((_resolve, _reject)=>{
            props.resolve = (v)=>{
                props.isResolving = true;
                return _resolve(v);
            };
            props.reject = _reject;
        }).finally(()=>{
            props.promise = void 0;
            const index2 = instances.value.indexOf(props);
            if (index2 !== -1) instances.value.splice(index2, 1);
        });
        return props.promise;
    }
    function start(...args) {
        if (options.singleton && instances.value.length > 0) return instances.value[0].promise;
        return create(...args);
    }
    const component = /* #__PURE__ */ (0, $TusQn.defineComponent)((_, { slots: slots })=>{
        const renderList = ()=>instances.value.map((props)=>{
                var _a;
                return (0, $TusQn.h)((0, $TusQn.Fragment), {
                    key: props.key
                }, (_a = slots.default) == null ? void 0 : _a.call(slots, props));
            });
        if (options.transition) return ()=>(0, $TusQn.h)((0, $eeJ70.TransitionGroup), options.transition, renderList);
        return renderList;
    });
    component.start = start;
    return component;
}
function $6ffe9515611cb489$export$4ebd6dd2d9c62e4b(fn) {
    return function(...args) {
        return fn.apply(this, args.map((i)=>(0, $AHHxt.toValue)(i)));
    };
}
function $6ffe9515611cb489$export$c61124d3cf5adbae(elRef) {
    var _a;
    const plain = (0, $AHHxt.toValue)(elRef);
    return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}
const $6ffe9515611cb489$export$16f8ba610718ae4a = (0, $AHHxt.isClient) ? window : void 0;
const $6ffe9515611cb489$export$37990bd438d16af3 = (0, $AHHxt.isClient) ? window.document : void 0;
const $6ffe9515611cb489$export$eade61489f57e3fc = (0, $AHHxt.isClient) ? window.navigator : void 0;
const $6ffe9515611cb489$export$66494ae16bad8985 = (0, $AHHxt.isClient) ? window.location : void 0;
function $6ffe9515611cb489$export$7080b3e976bc91ab(...args) {
    let target;
    let events;
    let listeners;
    let options;
    if (typeof args[0] === "string" || Array.isArray(args[0])) {
        [events, listeners, options] = args;
        target = $6ffe9515611cb489$export$16f8ba610718ae4a;
    } else [target, events, listeners, options] = args;
    if (!target) return 0, $AHHxt.noop;
    if (!Array.isArray(events)) events = [
        events
    ];
    if (!Array.isArray(listeners)) listeners = [
        listeners
    ];
    const cleanups = [];
    const cleanup = ()=>{
        cleanups.forEach((fn)=>fn());
        cleanups.length = 0;
    };
    const register = (el, event, listener, options2)=>{
        el.addEventListener(event, listener, options2);
        return ()=>el.removeEventListener(event, listener, options2);
    };
    const stopWatch = (0, $TusQn.watch)(()=>[
            $6ffe9515611cb489$export$c61124d3cf5adbae(target),
            (0, $AHHxt.toValue)(options)
        ], ([el, options2])=>{
        cleanup();
        if (!el) return;
        const optionsClone = (0, $AHHxt.isObject)(options2) ? {
            ...options2
        } : options2;
        cleanups.push(...events.flatMap((event)=>{
            return listeners.map((listener)=>register(el, event, listener, optionsClone));
        }));
    }, {
        immediate: true,
        flush: "post"
    });
    const stop = ()=>{
        stopWatch();
        cleanup();
    };
    (0, $AHHxt.tryOnScopeDispose)(stop);
    return stop;
}
let $6ffe9515611cb489$var$_iOSWorkaround = false;
function $6ffe9515611cb489$export$806d9a98fb0e6fd0(target, handler, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, ignore: ignore = [], capture: capture = true, detectIframe: detectIframe = false } = options;
    if (!window1) return 0, $AHHxt.noop;
    if ((0, $AHHxt.isIOS) && !$6ffe9515611cb489$var$_iOSWorkaround) {
        $6ffe9515611cb489$var$_iOSWorkaround = true;
        Array.from(window1.document.body.children).forEach((el)=>el.addEventListener("click", (0, $AHHxt.noop)));
        window1.document.documentElement.addEventListener("click", (0, $AHHxt.noop));
    }
    let shouldListen = true;
    const shouldIgnore = (event)=>{
        return ignore.some((target2)=>{
            if (typeof target2 === "string") return Array.from(window1.document.querySelectorAll(target2)).some((el)=>el === event.target || event.composedPath().includes(el));
            else {
                const el = $6ffe9515611cb489$export$c61124d3cf5adbae(target2);
                return el && (event.target === el || event.composedPath().includes(el));
            }
        });
    };
    const listener = (event)=>{
        const el = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
        if (!el || el === event.target || event.composedPath().includes(el)) return;
        if (event.detail === 0) shouldListen = !shouldIgnore(event);
        if (!shouldListen) {
            shouldListen = true;
            return;
        }
        handler(event);
    };
    const cleanup = [
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "click", listener, {
            passive: true,
            capture: capture
        }),
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "pointerdown", (e)=>{
            const el = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
            shouldListen = !shouldIgnore(e) && !!(el && !e.composedPath().includes(el));
        }, {
            passive: true
        }),
        detectIframe && $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "blur", (event)=>{
            setTimeout(()=>{
                var _a;
                const el = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
                if (((_a = window1.document.activeElement) == null ? void 0 : _a.tagName) === "IFRAME" && !(el == null ? void 0 : el.contains(window1.document.activeElement))) handler(event);
            }, 0);
        })
    ].filter(Boolean);
    const stop = ()=>cleanup.forEach((fn)=>fn());
    return stop;
}
function $6ffe9515611cb489$var$createKeyPredicate(keyFilter) {
    if (typeof keyFilter === "function") return keyFilter;
    else if (typeof keyFilter === "string") return (event)=>event.key === keyFilter;
    else if (Array.isArray(keyFilter)) return (event)=>keyFilter.includes(event.key);
    return ()=>true;
}
function $6ffe9515611cb489$export$70ca9878161d161b(...args) {
    let key;
    let handler;
    let options = {};
    if (args.length === 3) {
        key = args[0];
        handler = args[1];
        options = args[2];
    } else if (args.length === 2) {
        if (typeof args[1] === "object") {
            key = true;
            handler = args[0];
            options = args[1];
        } else {
            key = args[0];
            handler = args[1];
        }
    } else {
        key = true;
        handler = args[0];
    }
    const { target: target = $6ffe9515611cb489$export$16f8ba610718ae4a, eventName: eventName = "keydown", passive: passive = false, dedupe: dedupe = false } = options;
    const predicate = $6ffe9515611cb489$var$createKeyPredicate(key);
    const listener = (e)=>{
        if (e.repeat && (0, $AHHxt.toValue)(dedupe)) return;
        if (predicate(e)) handler(e);
    };
    return $6ffe9515611cb489$export$7080b3e976bc91ab(target, eventName, listener, passive);
}
function $6ffe9515611cb489$export$de8e1b1372cdb41b(key, handler, options = {}) {
    return $6ffe9515611cb489$export$70ca9878161d161b(key, handler, {
        ...options,
        eventName: "keydown"
    });
}
function $6ffe9515611cb489$export$33ead148203888dd(key, handler, options = {}) {
    return $6ffe9515611cb489$export$70ca9878161d161b(key, handler, {
        ...options,
        eventName: "keypress"
    });
}
function $6ffe9515611cb489$export$f144bbb6e186b14b(key, handler, options = {}) {
    return $6ffe9515611cb489$export$70ca9878161d161b(key, handler, {
        ...options,
        eventName: "keyup"
    });
}
const $6ffe9515611cb489$var$DEFAULT_DELAY = 500;
const $6ffe9515611cb489$var$DEFAULT_THRESHOLD = 10;
function $6ffe9515611cb489$export$d0dd9c8bca391fcb(target, handler, options) {
    var _a, _b;
    const elementRef = (0, $01W3b.computed)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(target));
    let timeout;
    let posStart;
    function clear() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = void 0;
        }
        posStart = void 0;
    }
    function onDown(ev) {
        var _a2, _b2, _c, _d;
        if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value) return;
        clear();
        if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent) ev.preventDefault();
        if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop) ev.stopPropagation();
        posStart = {
            x: ev.x,
            y: ev.y
        };
        timeout = setTimeout(()=>handler(ev), (_d = options == null ? void 0 : options.delay) != null ? _d : $6ffe9515611cb489$var$DEFAULT_DELAY);
    }
    function onMove(ev) {
        var _a2, _b2, _c, _d;
        if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value) return;
        if (!posStart || (options == null ? void 0 : options.distanceThreshold) === false) return;
        if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent) ev.preventDefault();
        if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop) ev.stopPropagation();
        const dx = ev.x - posStart.x;
        const dy = ev.y - posStart.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (distance >= ((_d = options == null ? void 0 : options.distanceThreshold) != null ? _d : $6ffe9515611cb489$var$DEFAULT_THRESHOLD)) clear();
    }
    const listenerOptions = {
        capture: (_a = options == null ? void 0 : options.modifiers) == null ? void 0 : _a.capture,
        once: (_b = options == null ? void 0 : options.modifiers) == null ? void 0 : _b.once
    };
    const cleanup = [
        $6ffe9515611cb489$export$7080b3e976bc91ab(elementRef, "pointerdown", onDown, listenerOptions),
        $6ffe9515611cb489$export$7080b3e976bc91ab(elementRef, "pointermove", onMove, listenerOptions),
        $6ffe9515611cb489$export$7080b3e976bc91ab(elementRef, [
            "pointerup",
            "pointerleave"
        ], clear, listenerOptions)
    ];
    const stop = ()=>cleanup.forEach((fn)=>fn());
    return stop;
}
function $6ffe9515611cb489$var$isFocusedElementEditable() {
    const { activeElement: activeElement, body: body } = document;
    if (!activeElement) return false;
    if (activeElement === body) return false;
    switch(activeElement.tagName){
        case "INPUT":
        case "TEXTAREA":
            return true;
    }
    return activeElement.hasAttribute("contenteditable");
}
function $6ffe9515611cb489$var$isTypedCharValid({ keyCode: keyCode, metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey }) {
    if (metaKey || ctrlKey || altKey) return false;
    if (keyCode >= 48 && keyCode <= 57) return true;
    if (keyCode >= 65 && keyCode <= 90) return true;
    if (keyCode >= 97 && keyCode <= 122) return true;
    return false;
}
function $6ffe9515611cb489$export$cd54fc233e2f4a5d(callback, options = {}) {
    const { document: document2 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    const keydown = (event)=>{
        !$6ffe9515611cb489$var$isFocusedElementEditable() && $6ffe9515611cb489$var$isTypedCharValid(event) && callback(event);
    };
    if (document2) $6ffe9515611cb489$export$7080b3e976bc91ab(document2, "keydown", keydown, {
        passive: true
    });
}
function $6ffe9515611cb489$export$fc38e812d383221(key, initialValue = null) {
    const instance = (0, $TusQn.getCurrentInstance)();
    let _trigger = ()=>{};
    const element = (0, $01W3b.customRef)((track, trigger)=>{
        _trigger = trigger;
        return {
            get () {
                var _a, _b;
                track();
                return (_b = (_a = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a.$refs[key]) != null ? _b : initialValue;
            },
            set () {}
        };
    });
    (0, $AHHxt.tryOnMounted)(_trigger);
    (0, $TusQn.onUpdated)(_trigger);
    return element;
}
function $6ffe9515611cb489$export$4e1875a4b2b1434f(options = {}) {
    var _a;
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, deep: deep = true } = options;
    const document1 = (_a = options.document) != null ? _a : window1 == null ? void 0 : window1.document;
    const getDeepActiveElement = ()=>{
        var _a2;
        let element = document1 == null ? void 0 : document1.activeElement;
        if (deep) while(element == null ? void 0 : element.shadowRoot)element = (_a2 = element == null ? void 0 : element.shadowRoot) == null ? void 0 : _a2.activeElement;
        return element;
    };
    const activeElement = (0, $01W3b.ref)();
    const trigger = ()=>{
        activeElement.value = getDeepActiveElement();
    };
    if (window1) {
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "blur", (event)=>{
            if (event.relatedTarget !== null) return;
            trigger();
        }, true);
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "focus", trigger, true);
    }
    trigger();
    return activeElement;
}
function $6ffe9515611cb489$export$bce3bfec9f56c837() {
    const isMounted = (0, $01W3b.ref)(false);
    const instance = (0, $TusQn.getCurrentInstance)();
    if (instance) (0, $TusQn.onMounted)(()=>{
        isMounted.value = true;
    }, (0, $keUOA.isVue2) ? null : instance);
    return isMounted;
}
function $6ffe9515611cb489$export$85904d4478b9c8a4(callback) {
    const isMounted = $6ffe9515611cb489$export$bce3bfec9f56c837();
    return (0, $01W3b.computed)(()=>{
        isMounted.value;
        return Boolean(callback());
    });
}
function $6ffe9515611cb489$export$13251e0fc79284e(fn, options = {}) {
    const { immediate: immediate = true, fpsLimit: fpsLimit, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isActive = (0, $01W3b.ref)(false);
    const intervalLimit = fpsLimit ? 1e3 / fpsLimit : null;
    let previousFrameTimestamp = 0;
    let rafId = null;
    function loop(timestamp) {
        if (!isActive.value || !window1) return;
        if (!previousFrameTimestamp) previousFrameTimestamp = timestamp;
        const delta = timestamp - previousFrameTimestamp;
        if (intervalLimit && delta < intervalLimit) {
            rafId = window1.requestAnimationFrame(loop);
            return;
        }
        previousFrameTimestamp = timestamp;
        fn({
            delta: delta,
            timestamp: timestamp
        });
        rafId = window1.requestAnimationFrame(loop);
    }
    function resume() {
        if (!isActive.value && window1) {
            isActive.value = true;
            previousFrameTimestamp = 0;
            rafId = window1.requestAnimationFrame(loop);
        }
    }
    function pause() {
        isActive.value = false;
        if (rafId != null && window1) {
            window1.cancelAnimationFrame(rafId);
            rafId = null;
        }
    }
    if (immediate) resume();
    (0, $AHHxt.tryOnScopeDispose)(pause);
    return {
        isActive: (0, $01W3b.readonly)(isActive),
        pause: pause,
        resume: resume
    };
}
function $6ffe9515611cb489$export$9f387b98a73b1511(target, keyframes, options) {
    let config;
    let animateOptions;
    if ((0, $AHHxt.isObject)(options)) {
        config = options;
        animateOptions = (0, $AHHxt.objectOmit)(options, [
            "window",
            "immediate",
            "commitStyles",
            "persist",
            "onReady",
            "onError"
        ]);
    } else {
        config = {
            duration: options
        };
        animateOptions = options;
    }
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, immediate: immediate = true, commitStyles: commitStyles, persist: persist, playbackRate: _playbackRate = 1, onReady: onReady, onError: onError = (e)=>{
        console.error(e);
    } } = config;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && HTMLElement && "animate" in HTMLElement.prototype);
    const animate = (0, $01W3b.shallowRef)(void 0);
    const store = (0, $01W3b.shallowReactive)({
        startTime: null,
        currentTime: null,
        timeline: null,
        playbackRate: _playbackRate,
        pending: false,
        playState: immediate ? "idle" : "paused",
        replaceState: "active"
    });
    const pending = (0, $01W3b.computed)(()=>store.pending);
    const playState = (0, $01W3b.computed)(()=>store.playState);
    const replaceState = (0, $01W3b.computed)(()=>store.replaceState);
    const startTime = (0, $01W3b.computed)({
        get () {
            return store.startTime;
        },
        set (value) {
            store.startTime = value;
            if (animate.value) animate.value.startTime = value;
        }
    });
    const currentTime = (0, $01W3b.computed)({
        get () {
            return store.currentTime;
        },
        set (value) {
            store.currentTime = value;
            if (animate.value) {
                animate.value.currentTime = value;
                syncResume();
            }
        }
    });
    const timeline = (0, $01W3b.computed)({
        get () {
            return store.timeline;
        },
        set (value) {
            store.timeline = value;
            if (animate.value) animate.value.timeline = value;
        }
    });
    const playbackRate = (0, $01W3b.computed)({
        get () {
            return store.playbackRate;
        },
        set (value) {
            store.playbackRate = value;
            if (animate.value) animate.value.playbackRate = value;
        }
    });
    const play = ()=>{
        if (animate.value) try {
            animate.value.play();
            syncResume();
        } catch (e) {
            syncPause();
            onError(e);
        }
        else update();
    };
    const pause = ()=>{
        var _a;
        try {
            (_a = animate.value) == null || _a.pause();
            syncPause();
        } catch (e) {
            onError(e);
        }
    };
    const reverse = ()=>{
        var _a;
        !animate.value && update();
        try {
            (_a = animate.value) == null || _a.reverse();
            syncResume();
        } catch (e) {
            syncPause();
            onError(e);
        }
    };
    const finish = ()=>{
        var _a;
        try {
            (_a = animate.value) == null || _a.finish();
            syncPause();
        } catch (e) {
            onError(e);
        }
    };
    const cancel = ()=>{
        var _a;
        try {
            (_a = animate.value) == null || _a.cancel();
            syncPause();
        } catch (e) {
            onError(e);
        }
    };
    (0, $TusQn.watch)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(target), (el)=>{
        el && update();
    });
    (0, $TusQn.watch)(()=>keyframes, (value)=>{
        !animate.value && update();
        if (!$6ffe9515611cb489$export$c61124d3cf5adbae(target) && animate.value) animate.value.effect = new KeyframeEffect($6ffe9515611cb489$export$c61124d3cf5adbae(target), (0, $AHHxt.toValue)(value), animateOptions);
    }, {
        deep: true
    });
    (0, $AHHxt.tryOnMounted)(()=>{
        (0, $TusQn.nextTick)(()=>update(true));
    });
    (0, $AHHxt.tryOnScopeDispose)(cancel);
    function update(init) {
        const el = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
        if (!isSupported.value || !el) return;
        if (!animate.value) animate.value = el.animate((0, $AHHxt.toValue)(keyframes), animateOptions);
        if (commitStyles) animate.value.commitStyles();
        if (persist) animate.value.persist();
        if (_playbackRate !== 1) animate.value.playbackRate = _playbackRate;
        if (init && !immediate) animate.value.pause();
        else syncResume();
        onReady == null || onReady(animate.value);
    }
    $6ffe9515611cb489$export$7080b3e976bc91ab(animate, [
        "cancel",
        "finish",
        "remove"
    ], syncPause);
    const { resume: resumeRef, pause: pauseRef } = $6ffe9515611cb489$export$13251e0fc79284e(()=>{
        if (!animate.value) return;
        store.pending = animate.value.pending;
        store.playState = animate.value.playState;
        store.replaceState = animate.value.replaceState;
        store.startTime = animate.value.startTime;
        store.currentTime = animate.value.currentTime;
        store.timeline = animate.value.timeline;
        store.playbackRate = animate.value.playbackRate;
    }, {
        immediate: false
    });
    function syncResume() {
        if (isSupported.value) resumeRef();
    }
    function syncPause() {
        if (isSupported.value && window1) window1.requestAnimationFrame(pauseRef);
    }
    return {
        isSupported: isSupported,
        animate: animate,
        play: // actions
        play,
        pause: pause,
        reverse: reverse,
        finish: finish,
        cancel: cancel,
        pending: // state
        pending,
        playState: playState,
        replaceState: replaceState,
        startTime: startTime,
        currentTime: currentTime,
        timeline: timeline,
        playbackRate: playbackRate
    };
}
function $6ffe9515611cb489$export$15048550d0df8459(tasks, options) {
    const { interrupt: interrupt = true, onError: onError = (0, $AHHxt.noop), onFinished: onFinished = (0, $AHHxt.noop), signal: signal } = options || {};
    const promiseState = {
        aborted: "aborted",
        fulfilled: "fulfilled",
        pending: "pending",
        rejected: "rejected"
    };
    const initialResult = Array.from(Array.from({
        length: tasks.length
    }), ()=>({
            state: promiseState.pending,
            data: null
        }));
    const result = (0, $01W3b.reactive)(initialResult);
    const activeIndex = (0, $01W3b.ref)(-1);
    if (!tasks || tasks.length === 0) {
        onFinished();
        return {
            activeIndex: activeIndex,
            result: result
        };
    }
    function updateResult(state, res) {
        activeIndex.value++;
        result[activeIndex.value].data = res;
        result[activeIndex.value].state = state;
    }
    tasks.reduce((prev, curr)=>{
        return prev.then((prevRes)=>{
            var _a;
            if (signal == null ? void 0 : signal.aborted) {
                updateResult(promiseState.aborted, new Error("aborted"));
                return;
            }
            if (((_a = result[activeIndex.value]) == null ? void 0 : _a.state) === promiseState.rejected && interrupt) {
                onFinished();
                return;
            }
            const done = curr(prevRes).then((currentRes)=>{
                updateResult(promiseState.fulfilled, currentRes);
                activeIndex.value === tasks.length - 1 && onFinished();
                return currentRes;
            });
            if (!signal) return done;
            return Promise.race([
                done,
                $6ffe9515611cb489$var$whenAborted(signal)
            ]);
        }).catch((e)=>{
            if (signal == null ? void 0 : signal.aborted) {
                updateResult(promiseState.aborted, e);
                return e;
            }
            updateResult(promiseState.rejected, e);
            onError();
            return e;
        });
    }, Promise.resolve());
    return {
        activeIndex: activeIndex,
        result: result
    };
}
function $6ffe9515611cb489$var$whenAborted(signal) {
    return new Promise((resolve, reject)=>{
        const error = new Error("aborted");
        if (signal.aborted) reject(error);
        else signal.addEventListener("abort", ()=>reject(error), {
            once: true
        });
    });
}
function $6ffe9515611cb489$export$d94717ae0e8aa8b(promise, initialState, options) {
    const { immediate: immediate = true, delay: delay = 0, onError: onError = (0, $AHHxt.noop), onSuccess: onSuccess = (0, $AHHxt.noop), resetOnExecute: resetOnExecute = true, shallow: shallow = true, throwError: throwError } = options != null ? options : {};
    const state = shallow ? (0, $01W3b.shallowRef)(initialState) : (0, $01W3b.ref)(initialState);
    const isReady = (0, $01W3b.ref)(false);
    const isLoading = (0, $01W3b.ref)(false);
    const error = (0, $01W3b.shallowRef)(void 0);
    async function execute(delay2 = 0, ...args) {
        if (resetOnExecute) state.value = initialState;
        error.value = void 0;
        isReady.value = false;
        isLoading.value = true;
        if (delay2 > 0) await (0, $AHHxt.promiseTimeout)(delay2);
        const _promise = typeof promise === "function" ? promise(...args) : promise;
        try {
            const data = await _promise;
            state.value = data;
            isReady.value = true;
            onSuccess(data);
        } catch (e) {
            error.value = e;
            onError(e);
            if (throwError) throw e;
        } finally{
            isLoading.value = false;
        }
        return state.value;
    }
    if (immediate) execute(delay);
    const shell = {
        state: state,
        isReady: isReady,
        isLoading: isLoading,
        error: error,
        execute: execute
    };
    function waitUntilIsLoaded() {
        return new Promise((resolve, reject)=>{
            (0, $AHHxt.until)(isLoading).toBe(false).then(()=>resolve(shell)).catch(reject);
        });
    }
    return {
        ...shell,
        then (onFulfilled, onRejected) {
            return waitUntilIsLoaded().then(onFulfilled, onRejected);
        }
    };
}
const $6ffe9515611cb489$var$defaults = {
    array: (v)=>JSON.stringify(v),
    object: (v)=>JSON.stringify(v),
    set: (v)=>JSON.stringify(Array.from(v)),
    map: (v)=>JSON.stringify(Object.fromEntries(v)),
    null: ()=>""
};
function $6ffe9515611cb489$var$getDefaultSerialization(target) {
    if (!target) return $6ffe9515611cb489$var$defaults.null;
    if (target instanceof Map) return $6ffe9515611cb489$var$defaults.map;
    else if (target instanceof Set) return $6ffe9515611cb489$var$defaults.set;
    else if (Array.isArray(target)) return $6ffe9515611cb489$var$defaults.array;
    else return $6ffe9515611cb489$var$defaults.object;
}
function $6ffe9515611cb489$export$a1fce3538bfe26db(target, options) {
    const base64 = (0, $01W3b.ref)("");
    const promise = (0, $01W3b.ref)();
    function execute() {
        if (!(0, $AHHxt.isClient)) return;
        promise.value = new Promise((resolve, reject)=>{
            try {
                const _target = (0, $AHHxt.toValue)(target);
                if (_target == null) resolve("");
                else if (typeof _target === "string") resolve($6ffe9515611cb489$var$blobToBase64(new Blob([
                    _target
                ], {
                    type: "text/plain"
                })));
                else if (_target instanceof Blob) resolve($6ffe9515611cb489$var$blobToBase64(_target));
                else if (_target instanceof ArrayBuffer) resolve(window.btoa(String.fromCharCode(...new Uint8Array(_target))));
                else if (_target instanceof HTMLCanvasElement) resolve(_target.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
                else if (_target instanceof HTMLImageElement) {
                    const img = _target.cloneNode(false);
                    img.crossOrigin = "Anonymous";
                    $6ffe9515611cb489$var$imgLoaded(img).then(()=>{
                        const canvas = document.createElement("canvas");
                        const ctx = canvas.getContext("2d");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                        resolve(canvas.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
                    }).catch(reject);
                } else if (typeof _target === "object") {
                    const _serializeFn = (options == null ? void 0 : options.serializer) || $6ffe9515611cb489$var$getDefaultSerialization(_target);
                    const serialized = _serializeFn(_target);
                    return resolve($6ffe9515611cb489$var$blobToBase64(new Blob([
                        serialized
                    ], {
                        type: "application/json"
                    })));
                } else reject(new Error("target is unsupported types"));
            } catch (error) {
                reject(error);
            }
        });
        promise.value.then((res)=>base64.value = res);
        return promise.value;
    }
    if ((0, $01W3b.isRef)(target) || typeof target === "function") (0, $TusQn.watch)(target, execute, {
        immediate: true
    });
    else execute();
    return {
        base64: base64,
        promise: promise,
        execute: execute
    };
}
function $6ffe9515611cb489$var$imgLoaded(img) {
    return new Promise((resolve, reject)=>{
        if (!img.complete) {
            img.onload = ()=>{
                resolve();
            };
            img.onerror = reject;
        } else resolve();
    });
}
function $6ffe9515611cb489$var$blobToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const fr = new FileReader();
        fr.onload = (e)=>{
            resolve(e.target.result);
        };
        fr.onerror = reject;
        fr.readAsDataURL(blob);
    });
}
function $6ffe9515611cb489$export$2a2cdda660e4b159(options = {}) {
    const { navigator: navigator = $6ffe9515611cb489$export$eade61489f57e3fc } = options;
    const events = [
        "chargingchange",
        "chargingtimechange",
        "dischargingtimechange",
        "levelchange"
    ];
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator && "getBattery" in navigator && typeof navigator.getBattery === "function");
    const charging = (0, $01W3b.ref)(false);
    const chargingTime = (0, $01W3b.ref)(0);
    const dischargingTime = (0, $01W3b.ref)(0);
    const level = (0, $01W3b.ref)(1);
    let battery;
    function updateBatteryInfo() {
        charging.value = this.charging;
        chargingTime.value = this.chargingTime || 0;
        dischargingTime.value = this.dischargingTime || 0;
        level.value = this.level;
    }
    if (isSupported.value) navigator.getBattery().then((_battery)=>{
        battery = _battery;
        updateBatteryInfo.call(battery);
        $6ffe9515611cb489$export$7080b3e976bc91ab(battery, events, updateBatteryInfo, {
            passive: true
        });
    });
    return {
        isSupported: isSupported,
        charging: charging,
        chargingTime: chargingTime,
        dischargingTime: dischargingTime,
        level: level
    };
}
function $6ffe9515611cb489$export$4fa034be92e08f89(options) {
    let { acceptAllDevices: acceptAllDevices = false } = options || {};
    const { filters: filters, optionalServices: optionalServices, navigator: navigator = $6ffe9515611cb489$export$eade61489f57e3fc } = options || {};
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator && "bluetooth" in navigator);
    const device = (0, $01W3b.shallowRef)(void 0);
    const error = (0, $01W3b.shallowRef)(null);
    (0, $TusQn.watch)(device, ()=>{
        connectToBluetoothGATTServer();
    });
    async function requestDevice() {
        if (!isSupported.value) return;
        error.value = null;
        if (filters && filters.length > 0) acceptAllDevices = false;
        try {
            device.value = await (navigator == null ? void 0 : navigator.bluetooth.requestDevice({
                acceptAllDevices: acceptAllDevices,
                filters: filters,
                optionalServices: optionalServices
            }));
        } catch (err) {
            error.value = err;
        }
    }
    const server = (0, $01W3b.ref)();
    const isConnected = (0, $01W3b.computed)(()=>{
        var _a;
        return ((_a = server.value) == null ? void 0 : _a.connected) || false;
    });
    async function connectToBluetoothGATTServer() {
        error.value = null;
        if (device.value && device.value.gatt) {
            device.value.addEventListener("gattserverdisconnected", ()=>{});
            try {
                server.value = await device.value.gatt.connect();
            } catch (err) {
                error.value = err;
            }
        }
    }
    (0, $AHHxt.tryOnMounted)(()=>{
        var _a;
        if (device.value) (_a = device.value.gatt) == null || _a.connect();
    });
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        var _a;
        if (device.value) (_a = device.value.gatt) == null || _a.disconnect();
    });
    return {
        isSupported: isSupported,
        isConnected: isConnected,
        device: // Device:
        device,
        requestDevice: requestDevice,
        server: // Server:
        server,
        error: // Errors:
        error
    };
}
function $6ffe9515611cb489$export$32d5543ab307c01(query, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "matchMedia" in window1 && typeof window1.matchMedia === "function");
    let mediaQuery;
    const matches = (0, $01W3b.ref)(false);
    const handler = (event)=>{
        matches.value = event.matches;
    };
    const cleanup = ()=>{
        if (!mediaQuery) return;
        if ("removeEventListener" in mediaQuery) mediaQuery.removeEventListener("change", handler);
        else mediaQuery.removeListener(handler);
    };
    const stopWatch = (0, $TusQn.watchEffect)(()=>{
        if (!isSupported.value) return;
        cleanup();
        mediaQuery = window1.matchMedia((0, $AHHxt.toValue)(query));
        if ("addEventListener" in mediaQuery) mediaQuery.addEventListener("change", handler);
        else mediaQuery.addListener(handler);
        matches.value = mediaQuery.matches;
    });
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        stopWatch();
        cleanup();
        mediaQuery = void 0;
    });
    return matches;
}
const $6ffe9515611cb489$export$1e7f3da0afb51c4 = {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
};
const $6ffe9515611cb489$export$ab05426c509559f5 = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
};
const $6ffe9515611cb489$export$59a8910ce37234c0 = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1264,
    xl: 1904
};
const $6ffe9515611cb489$export$f7fcbbae4606fa86 = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    xxl: 2560
};
const $6ffe9515611cb489$export$e826524d50707be3 = $6ffe9515611cb489$export$59a8910ce37234c0;
const $6ffe9515611cb489$export$913d30ac358ba918 = {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600
};
const $6ffe9515611cb489$export$6ed1cd5183566ff7 = {
    xs: 0,
    sm: 600,
    md: 1024,
    lg: 1440,
    xl: 1920
};
const $6ffe9515611cb489$export$b4376e330fd9cda3 = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 425,
    tablet: 768,
    laptop: 1024,
    laptopL: 1440,
    desktop4K: 2560
};
const $6ffe9515611cb489$export$dba9946743c0ab98 = {
    "3xs": 360,
    "2xs": 480,
    "xs": 600,
    "sm": 768,
    "md": 1024,
    "lg": 1280,
    "xl": 1440,
    "2xl": 1600,
    "3xl": 1920,
    "4xl": 2560
};
const $6ffe9515611cb489$export$71df204985f11b6 = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};
function $6ffe9515611cb489$export$e818ed21e924bde4(breakpoints, options = {}) {
    function getValue(k, delta) {
        let v = (0, $AHHxt.toValue)(breakpoints[(0, $AHHxt.toValue)(k)]);
        if (delta != null) v = (0, $AHHxt.increaseWithUnit)(v, delta);
        if (typeof v === "number") v = `${v}px`;
        return v;
    }
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, strategy: strategy = "min-width" } = options;
    function match(query) {
        if (!window1) return false;
        return window1.matchMedia(query).matches;
    }
    const greaterOrEqual = (k)=>{
        return $6ffe9515611cb489$export$32d5543ab307c01(()=>`(min-width: ${getValue(k)})`, options);
    };
    const smallerOrEqual = (k)=>{
        return $6ffe9515611cb489$export$32d5543ab307c01(()=>`(max-width: ${getValue(k)})`, options);
    };
    const shortcutMethods = Object.keys(breakpoints).reduce((shortcuts, k)=>{
        Object.defineProperty(shortcuts, k, {
            get: ()=>strategy === "min-width" ? greaterOrEqual(k) : smallerOrEqual(k),
            enumerable: true,
            configurable: true
        });
        return shortcuts;
    }, {});
    function current() {
        const points = Object.keys(breakpoints).map((i)=>[
                i,
                greaterOrEqual(i)
            ]);
        return (0, $01W3b.computed)(()=>points.filter(([, v])=>v.value).map(([k])=>k));
    }
    return Object.assign(shortcutMethods, {
        greaterOrEqual: greaterOrEqual,
        smallerOrEqual: smallerOrEqual,
        greater (k) {
            return $6ffe9515611cb489$export$32d5543ab307c01(()=>`(min-width: ${getValue(k, 0.1)})`, options);
        },
        smaller (k) {
            return $6ffe9515611cb489$export$32d5543ab307c01(()=>`(max-width: ${getValue(k, -0.1)})`, options);
        },
        between (a, b) {
            return $6ffe9515611cb489$export$32d5543ab307c01(()=>`(min-width: ${getValue(a)}) and (max-width: ${getValue(b, -0.1)})`, options);
        },
        isGreater (k) {
            return match(`(min-width: ${getValue(k, 0.1)})`);
        },
        isGreaterOrEqual (k) {
            return match(`(min-width: ${getValue(k)})`);
        },
        isSmaller (k) {
            return match(`(max-width: ${getValue(k, -0.1)})`);
        },
        isSmallerOrEqual (k) {
            return match(`(max-width: ${getValue(k)})`);
        },
        isInBetween (a, b) {
            return match(`(min-width: ${getValue(a)}) and (max-width: ${getValue(b, -0.1)})`);
        },
        current: current,
        active () {
            const bps = current();
            return (0, $01W3b.computed)(()=>bps.value.length === 0 ? "" : bps.value.at(-1));
        }
    });
}
function $6ffe9515611cb489$export$e38c76da774a8077(options) {
    const { name: name, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "BroadcastChannel" in window1);
    const isClosed = (0, $01W3b.ref)(false);
    const channel = (0, $01W3b.ref)();
    const data = (0, $01W3b.ref)();
    const error = (0, $01W3b.shallowRef)(null);
    const post = (data2)=>{
        if (channel.value) channel.value.postMessage(data2);
    };
    const close = ()=>{
        if (channel.value) channel.value.close();
        isClosed.value = true;
    };
    if (isSupported.value) (0, $AHHxt.tryOnMounted)(()=>{
        error.value = null;
        channel.value = new BroadcastChannel(name);
        channel.value.addEventListener("message", (e)=>{
            data.value = e.data;
        }, {
            passive: true
        });
        channel.value.addEventListener("messageerror", (e)=>{
            error.value = e;
        }, {
            passive: true
        });
        channel.value.addEventListener("close", ()=>{
            isClosed.value = true;
        });
    });
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        close();
    });
    return {
        isSupported: isSupported,
        channel: channel,
        data: data,
        post: post,
        close: close,
        error: error,
        isClosed: isClosed
    };
}
const $6ffe9515611cb489$var$WRITABLE_PROPERTIES = [
    "hash",
    "host",
    "hostname",
    "href",
    "pathname",
    "port",
    "protocol",
    "search"
];
function $6ffe9515611cb489$export$29c60f5332583(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const refs = Object.fromEntries($6ffe9515611cb489$var$WRITABLE_PROPERTIES.map((key)=>[
            key,
            (0, $01W3b.ref)()
        ]));
    for (const [key, ref2] of (0, $AHHxt.objectEntries)(refs))(0, $TusQn.watch)(ref2, (value)=>{
        if (!(window1 == null ? void 0 : window1.location) || window1.location[key] === value) return;
        window1.location[key] = value;
    });
    const buildState = (trigger)=>{
        var _a;
        const { state: state2, length: length } = (window1 == null ? void 0 : window1.history) || {};
        const { origin: origin } = (window1 == null ? void 0 : window1.location) || {};
        for (const key of $6ffe9515611cb489$var$WRITABLE_PROPERTIES)refs[key].value = (_a = window1 == null ? void 0 : window1.location) == null ? void 0 : _a[key];
        return (0, $01W3b.reactive)({
            trigger: trigger,
            state: state2,
            length: length,
            origin: origin,
            ...refs
        });
    };
    const state = (0, $01W3b.ref)(buildState("load"));
    if (window1) {
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "popstate", ()=>state.value = buildState("popstate"), {
            passive: true
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "hashchange", ()=>state.value = buildState("hashchange"), {
            passive: true
        });
    }
    return state;
}
function $6ffe9515611cb489$export$738959f2b29daa01(refValue, comparator = (a, b)=>a === b, watchOptions) {
    const cachedValue = (0, $01W3b.ref)(refValue.value);
    (0, $TusQn.watch)(()=>refValue.value, (value)=>{
        if (!comparator(value, cachedValue.value)) cachedValue.value = value;
    }, watchOptions);
    return cachedValue;
}
function $6ffe9515611cb489$export$d7376454a3cf5ab4(permissionDesc, options = {}) {
    const { controls: controls = false, navigator: navigator = $6ffe9515611cb489$export$eade61489f57e3fc } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator && "permissions" in navigator);
    let permissionStatus;
    const desc = typeof permissionDesc === "string" ? {
        name: permissionDesc
    } : permissionDesc;
    const state = (0, $01W3b.ref)();
    const onChange = ()=>{
        if (permissionStatus) state.value = permissionStatus.state;
    };
    const query = (0, $AHHxt.createSingletonPromise)(async ()=>{
        if (!isSupported.value) return;
        if (!permissionStatus) try {
            permissionStatus = await navigator.permissions.query(desc);
            $6ffe9515611cb489$export$7080b3e976bc91ab(permissionStatus, "change", onChange);
            onChange();
        } catch (e) {
            state.value = "prompt";
        }
        return permissionStatus;
    });
    query();
    if (controls) return {
        state: state,
        isSupported: isSupported,
        query: query
    };
    else return state;
}
function $6ffe9515611cb489$export$2314ca2a3e892862(options = {}) {
    const { navigator: navigator = $6ffe9515611cb489$export$eade61489f57e3fc, read: read = false, source: source, copiedDuring: copiedDuring = 1500, legacy: legacy = false } = options;
    const isClipboardApiSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator && "clipboard" in navigator);
    const permissionRead = $6ffe9515611cb489$export$d7376454a3cf5ab4("clipboard-read");
    const permissionWrite = $6ffe9515611cb489$export$d7376454a3cf5ab4("clipboard-write");
    const isSupported = (0, $01W3b.computed)(()=>isClipboardApiSupported.value || legacy);
    const text = (0, $01W3b.ref)("");
    const copied = (0, $01W3b.ref)(false);
    const timeout = (0, $AHHxt.useTimeoutFn)(()=>copied.value = false, copiedDuring);
    function updateText() {
        if (isClipboardApiSupported.value && isAllowed(permissionRead.value)) navigator.clipboard.readText().then((value)=>{
            text.value = value;
        });
        else text.value = legacyRead();
    }
    if (isSupported.value && read) $6ffe9515611cb489$export$7080b3e976bc91ab([
        "copy",
        "cut"
    ], updateText);
    async function copy(value = (0, $AHHxt.toValue)(source)) {
        if (isSupported.value && value != null) {
            if (isClipboardApiSupported.value && isAllowed(permissionWrite.value)) await navigator.clipboard.writeText(value);
            else legacyCopy(value);
            text.value = value;
            copied.value = true;
            timeout.start();
        }
    }
    function legacyCopy(value) {
        const ta = document.createElement("textarea");
        ta.value = value != null ? value : "";
        ta.style.position = "absolute";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
    }
    function legacyRead() {
        var _a, _b, _c;
        return (_c = (_b = (_a = document == null ? void 0 : document.getSelection) == null ? void 0 : _a.call(document)) == null ? void 0 : _b.toString()) != null ? _c : "";
    }
    function isAllowed(status) {
        return status === "granted" || status === "prompt";
    }
    return {
        isSupported: isSupported,
        text: text,
        copied: copied,
        copy: copy
    };
}
function $6ffe9515611cb489$export$ada6005637a1689d(options = {}) {
    const { navigator: navigator = $6ffe9515611cb489$export$eade61489f57e3fc, read: read = false, source: source, copiedDuring: copiedDuring = 1500 } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator && "clipboard" in navigator);
    const content = (0, $01W3b.ref)([]);
    const copied = (0, $01W3b.ref)(false);
    const timeout = (0, $AHHxt.useTimeoutFn)(()=>copied.value = false, copiedDuring);
    function updateContent() {
        if (isSupported.value) navigator.clipboard.read().then((items)=>{
            content.value = items;
        });
    }
    if (isSupported.value && read) $6ffe9515611cb489$export$7080b3e976bc91ab([
        "copy",
        "cut"
    ], updateContent);
    async function copy(value = (0, $AHHxt.toValue)(source)) {
        if (isSupported.value && value != null) {
            await navigator.clipboard.write(value);
            content.value = value;
            copied.value = true;
            timeout.start();
        }
    }
    return {
        isSupported: isSupported,
        content: content,
        copied: copied,
        copy: copy
    };
}
function $6ffe9515611cb489$export$9e72043f8ff3a3df(source) {
    return JSON.parse(JSON.stringify(source));
}
function $6ffe9515611cb489$export$1d793528ac2b824a(source, options = {}) {
    const cloned = (0, $01W3b.ref)({});
    const { manual: manual, clone: clone = $6ffe9515611cb489$export$9e72043f8ff3a3df, deep: // watch options
    deep = true, immediate: immediate = true } = options;
    function sync() {
        cloned.value = clone((0, $AHHxt.toValue)(source));
    }
    if (!manual && ((0, $01W3b.isRef)(source) || typeof source === "function")) (0, $TusQn.watch)(source, sync, {
        ...options,
        deep: deep,
        immediate: immediate
    });
    else sync();
    return {
        cloned: cloned,
        sync: sync
    };
}
const $6ffe9515611cb489$var$_global = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
const $6ffe9515611cb489$var$globalKey = "__vueuse_ssr_handlers__";
const $6ffe9515611cb489$var$handlers = /* @__PURE__ */ $6ffe9515611cb489$var$getHandlers();
function $6ffe9515611cb489$var$getHandlers() {
    if (!($6ffe9515611cb489$var$globalKey in $6ffe9515611cb489$var$_global)) $6ffe9515611cb489$var$_global[$6ffe9515611cb489$var$globalKey] = $6ffe9515611cb489$var$_global[$6ffe9515611cb489$var$globalKey] || {};
    return $6ffe9515611cb489$var$_global[$6ffe9515611cb489$var$globalKey];
}
function $6ffe9515611cb489$export$b0cf1ae5a98eb83b(key, fallback) {
    return $6ffe9515611cb489$var$handlers[key] || fallback;
}
function $6ffe9515611cb489$export$4094cfc0512bc950(key, fn) {
    $6ffe9515611cb489$var$handlers[key] = fn;
}
function $6ffe9515611cb489$var$guessSerializerType(rawInit) {
    return rawInit == null ? "any" : rawInit instanceof Set ? "set" : rawInit instanceof Map ? "map" : rawInit instanceof Date ? "date" : typeof rawInit === "boolean" ? "boolean" : typeof rawInit === "string" ? "string" : typeof rawInit === "object" ? "object" : !Number.isNaN(rawInit) ? "number" : "any";
}
const $6ffe9515611cb489$export$8111877b006f9b0b = {
    boolean: {
        read: (v)=>v === "true",
        write: (v)=>String(v)
    },
    object: {
        read: (v)=>JSON.parse(v),
        write: (v)=>JSON.stringify(v)
    },
    number: {
        read: (v)=>Number.parseFloat(v),
        write: (v)=>String(v)
    },
    any: {
        read: (v)=>v,
        write: (v)=>String(v)
    },
    string: {
        read: (v)=>v,
        write: (v)=>String(v)
    },
    map: {
        read: (v)=>new Map(JSON.parse(v)),
        write: (v)=>JSON.stringify(Array.from(v.entries()))
    },
    set: {
        read: (v)=>new Set(JSON.parse(v)),
        write: (v)=>JSON.stringify(Array.from(v))
    },
    date: {
        read: (v)=>new Date(v),
        write: (v)=>v.toISOString()
    }
};
const $6ffe9515611cb489$export$5962b94d93010632 = "vueuse-storage";
function $6ffe9515611cb489$export$95809329f49ea9f9(key, defaults, storage, options = {}) {
    var _a;
    const { flush: flush = "pre", deep: deep = true, listenToStorageChanges: listenToStorageChanges = true, writeDefaults: writeDefaults = true, mergeDefaults: mergeDefaults = false, shallow: shallow, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, eventFilter: eventFilter, onError: onError = (e)=>{
        console.error(e);
    }, initOnMounted: initOnMounted } = options;
    const data = (shallow ? (0, $01W3b.shallowRef) : (0, $01W3b.ref))(typeof defaults === "function" ? defaults() : defaults);
    if (!storage) try {
        storage = $6ffe9515611cb489$export$b0cf1ae5a98eb83b("getDefaultStorage", ()=>{
            var _a2;
            return (_a2 = $6ffe9515611cb489$export$16f8ba610718ae4a) == null ? void 0 : _a2.localStorage;
        })();
    } catch (e) {
        onError(e);
    }
    if (!storage) return data;
    const rawInit = (0, $AHHxt.toValue)(defaults);
    const type = $6ffe9515611cb489$var$guessSerializerType(rawInit);
    const serializer = (_a = options.serializer) != null ? _a : $6ffe9515611cb489$export$8111877b006f9b0b[type];
    const { pause: pauseWatch, resume: resumeWatch } = (0, $AHHxt.pausableWatch)(data, ()=>write(data.value), {
        flush: flush,
        deep: deep,
        eventFilter: eventFilter
    });
    if (window1 && listenToStorageChanges) (0, $AHHxt.tryOnMounted)(()=>{
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "storage", update);
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, $6ffe9515611cb489$export$5962b94d93010632, updateFromCustomEvent);
        if (initOnMounted) update();
    });
    if (!initOnMounted) update();
    function dispatchWriteEvent(oldValue, newValue) {
        if (window1) window1.dispatchEvent(new CustomEvent($6ffe9515611cb489$export$5962b94d93010632, {
            detail: {
                key: key,
                oldValue: oldValue,
                newValue: newValue,
                storageArea: storage
            }
        }));
    }
    function write(v) {
        try {
            const oldValue = storage.getItem(key);
            if (v == null) {
                dispatchWriteEvent(oldValue, null);
                storage.removeItem(key);
            } else {
                const serialized = serializer.write(v);
                if (oldValue !== serialized) {
                    storage.setItem(key, serialized);
                    dispatchWriteEvent(oldValue, serialized);
                }
            }
        } catch (e) {
            onError(e);
        }
    }
    function read(event) {
        const rawValue = event ? event.newValue : storage.getItem(key);
        if (rawValue == null) {
            if (writeDefaults && rawInit != null) storage.setItem(key, serializer.write(rawInit));
            return rawInit;
        } else if (!event && mergeDefaults) {
            const value = serializer.read(rawValue);
            if (typeof mergeDefaults === "function") return mergeDefaults(value, rawInit);
            else if (type === "object" && !Array.isArray(value)) return {
                ...rawInit,
                ...value
            };
            return value;
        } else if (typeof rawValue !== "string") return rawValue;
        else return serializer.read(rawValue);
    }
    function update(event) {
        if (event && event.storageArea !== storage) return;
        if (event && event.key == null) {
            data.value = rawInit;
            return;
        }
        if (event && event.key !== key) return;
        pauseWatch();
        try {
            if ((event == null ? void 0 : event.newValue) !== serializer.write(data.value)) data.value = read(event);
        } catch (e) {
            onError(e);
        } finally{
            if (event) (0, $TusQn.nextTick)(resumeWatch);
            else resumeWatch();
        }
    }
    function updateFromCustomEvent(event) {
        update(event.detail);
    }
    return data;
}
function $6ffe9515611cb489$export$a9fe667866660cd5(options) {
    return $6ffe9515611cb489$export$32d5543ab307c01("(prefers-color-scheme: dark)", options);
}
function $6ffe9515611cb489$export$20f3076712c8dfa(options = {}) {
    const { selector: selector = "html", attribute: attribute = "class", initialValue: initialValue = "auto", window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, storage: storage, storageKey: storageKey = "vueuse-color-scheme", listenToStorageChanges: listenToStorageChanges = true, storageRef: storageRef, emitAuto: emitAuto, disableTransition: disableTransition = true } = options;
    const modes = {
        auto: "",
        light: "light",
        dark: "dark",
        ...options.modes || {}
    };
    const preferredDark = $6ffe9515611cb489$export$a9fe667866660cd5({
        window: window1
    });
    const system = (0, $01W3b.computed)(()=>preferredDark.value ? "dark" : "light");
    const store = storageRef || (storageKey == null ? (0, $AHHxt.toRef)(initialValue) : $6ffe9515611cb489$export$95809329f49ea9f9(storageKey, initialValue, storage, {
        window: window1,
        listenToStorageChanges: listenToStorageChanges
    }));
    const state = (0, $01W3b.computed)(()=>store.value === "auto" ? system.value : store.value);
    const updateHTMLAttrs = $6ffe9515611cb489$export$b0cf1ae5a98eb83b("updateHTMLAttrs", (selector2, attribute2, value)=>{
        const el = typeof selector2 === "string" ? window1 == null ? void 0 : window1.document.querySelector(selector2) : $6ffe9515611cb489$export$c61124d3cf5adbae(selector2);
        if (!el) return;
        let style;
        if (disableTransition) {
            style = window1.document.createElement("style");
            const styleString = "*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
            style.appendChild(document.createTextNode(styleString));
            window1.document.head.appendChild(style);
        }
        if (attribute2 === "class") {
            const current = value.split(/\s/g);
            Object.values(modes).flatMap((i)=>(i || "").split(/\s/g)).filter(Boolean).forEach((v)=>{
                if (current.includes(v)) el.classList.add(v);
                else el.classList.remove(v);
            });
        } else el.setAttribute(attribute2, value);
        if (disableTransition) {
            window1.getComputedStyle(style).opacity;
            document.head.removeChild(style);
        }
    });
    function defaultOnChanged(mode) {
        var _a;
        updateHTMLAttrs(selector, attribute, (_a = modes[mode]) != null ? _a : mode);
    }
    function onChanged(mode) {
        if (options.onChanged) options.onChanged(mode, defaultOnChanged);
        else defaultOnChanged(mode);
    }
    (0, $TusQn.watch)(state, onChanged, {
        flush: "post",
        immediate: true
    });
    (0, $AHHxt.tryOnMounted)(()=>onChanged(state.value));
    const auto = (0, $01W3b.computed)({
        get () {
            return emitAuto ? store.value : state.value;
        },
        set (v) {
            store.value = v;
        }
    });
    try {
        return Object.assign(auto, {
            store: store,
            system: system,
            state: state
        });
    } catch (e) {
        return auto;
    }
}
function $6ffe9515611cb489$export$93c95fc6177ab5cd(revealed = (0, $01W3b.ref)(false)) {
    const confirmHook = (0, $AHHxt.createEventHook)();
    const cancelHook = (0, $AHHxt.createEventHook)();
    const revealHook = (0, $AHHxt.createEventHook)();
    let _resolve = (0, $AHHxt.noop);
    const reveal = (data)=>{
        revealHook.trigger(data);
        revealed.value = true;
        return new Promise((resolve)=>{
            _resolve = resolve;
        });
    };
    const confirm = (data)=>{
        revealed.value = false;
        confirmHook.trigger(data);
        _resolve({
            data: data,
            isCanceled: false
        });
    };
    const cancel = (data)=>{
        revealed.value = false;
        cancelHook.trigger(data);
        _resolve({
            data: data,
            isCanceled: true
        });
    };
    return {
        isRevealed: (0, $01W3b.computed)(()=>revealed.value),
        reveal: reveal,
        confirm: confirm,
        cancel: cancel,
        onReveal: revealHook.on,
        onConfirm: confirmHook.on,
        onCancel: cancelHook.on
    };
}
function $6ffe9515611cb489$export$8ecdcf3bb089e9cd(target, callback, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, ...mutationOptions } = options;
    let observer;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "MutationObserver" in window1);
    const cleanup = ()=>{
        if (observer) {
            observer.disconnect();
            observer = void 0;
        }
    };
    const targets = (0, $01W3b.computed)(()=>{
        const value = (0, $AHHxt.toValue)(target);
        const items = (Array.isArray(value) ? value : [
            value
        ]).map($6ffe9515611cb489$export$c61124d3cf5adbae).filter((0, $AHHxt.notNullish));
        return new Set(items);
    });
    const stopWatch = (0, $TusQn.watch)(()=>targets.value, (targets2)=>{
        cleanup();
        if (isSupported.value && window1 && targets2.size) {
            observer = new MutationObserver(callback);
            targets2.forEach((el)=>observer.observe(el, mutationOptions));
        }
    }, {
        immediate: true,
        flush: "post"
    });
    const takeRecords = ()=>{
        return observer == null ? void 0 : observer.takeRecords();
    };
    const stop = ()=>{
        cleanup();
        stopWatch();
    };
    (0, $AHHxt.tryOnScopeDispose)(stop);
    return {
        isSupported: isSupported,
        stop: stop,
        takeRecords: takeRecords
    };
}
function $6ffe9515611cb489$export$811e58a9be6ff112(prop, target, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, initialValue: initialValue = "", observe: observe = false } = options;
    const variable = (0, $01W3b.ref)(initialValue);
    const elRef = (0, $01W3b.computed)(()=>{
        var _a;
        return $6ffe9515611cb489$export$c61124d3cf5adbae(target) || ((_a = window1 == null ? void 0 : window1.document) == null ? void 0 : _a.documentElement);
    });
    function updateCssVar() {
        var _a;
        const key = (0, $AHHxt.toValue)(prop);
        const el = (0, $AHHxt.toValue)(elRef);
        if (el && window1) {
            const value = (_a = window1.getComputedStyle(el).getPropertyValue(key)) == null ? void 0 : _a.trim();
            variable.value = value || initialValue;
        }
    }
    if (observe) $6ffe9515611cb489$export$8ecdcf3bb089e9cd(elRef, updateCssVar, {
        attributeFilter: [
            "style",
            "class"
        ],
        window: window1
    });
    (0, $TusQn.watch)([
        elRef,
        ()=>(0, $AHHxt.toValue)(prop)
    ], updateCssVar, {
        immediate: true
    });
    (0, $TusQn.watch)(variable, (val)=>{
        var _a;
        if ((_a = elRef.value) == null ? void 0 : _a.style) elRef.value.style.setProperty((0, $AHHxt.toValue)(prop), val);
    });
    return variable;
}
function $6ffe9515611cb489$export$8d937a32bc2b31dd(rootComponent) {
    const vm = (0, $TusQn.getCurrentInstance)();
    const currentElement = (0, $AHHxt.computedWithControl)(()=>null, ()=>rootComponent ? $6ffe9515611cb489$export$c61124d3cf5adbae(rootComponent) : vm.proxy.$el);
    (0, $TusQn.onUpdated)(currentElement.trigger);
    (0, $TusQn.onMounted)(currentElement.trigger);
    return currentElement;
}
function $6ffe9515611cb489$export$a43ea948f6bdcecc(list, options) {
    const state = (0, $01W3b.shallowRef)(getInitialValue());
    const listRef = (0, $AHHxt.toRef)(list);
    const index = (0, $01W3b.computed)({
        get () {
            var _a;
            const targetList = listRef.value;
            let index2 = (options == null ? void 0 : options.getIndexOf) ? options.getIndexOf(state.value, targetList) : targetList.indexOf(state.value);
            if (index2 < 0) index2 = (_a = options == null ? void 0 : options.fallbackIndex) != null ? _a : 0;
            return index2;
        },
        set (v) {
            set(v);
        }
    });
    function set(i) {
        const targetList = listRef.value;
        const length = targetList.length;
        const index2 = (i % length + length) % length;
        const value = targetList[index2];
        state.value = value;
        return value;
    }
    function shift(delta = 1) {
        return set(index.value + delta);
    }
    function next(n = 1) {
        return shift(n);
    }
    function prev(n = 1) {
        return shift(-n);
    }
    function getInitialValue() {
        var _a, _b;
        return (_b = (0, $AHHxt.toValue)((_a = options == null ? void 0 : options.initialValue) != null ? _a : (0, $AHHxt.toValue)(list)[0])) != null ? _b : void 0;
    }
    (0, $TusQn.watch)(listRef, ()=>set(index.value));
    return {
        state: state,
        index: index,
        next: next,
        prev: prev,
        go: set
    };
}
function $6ffe9515611cb489$export$b067746439a7c60(options = {}) {
    const { valueDark: valueDark = "dark", valueLight: valueLight = "", window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const mode = $6ffe9515611cb489$export$20f3076712c8dfa({
        ...options,
        onChanged: (mode2, defaultHandler)=>{
            var _a;
            if (options.onChanged) (_a = options.onChanged) == null || _a.call(options, mode2 === "dark", defaultHandler, mode2);
            else defaultHandler(mode2);
        },
        modes: {
            dark: valueDark,
            light: valueLight
        }
    });
    const system = (0, $01W3b.computed)(()=>{
        if (mode.system) return mode.system.value;
        else {
            const preferredDark = $6ffe9515611cb489$export$a9fe667866660cd5({
                window: window1
            });
            return preferredDark.value ? "dark" : "light";
        }
    });
    const isDark = (0, $01W3b.computed)({
        get () {
            return mode.value === "dark";
        },
        set (v) {
            const modeVal = v ? "dark" : "light";
            if (system.value === modeVal) mode.value = "auto";
            else mode.value = modeVal;
        }
    });
    return isDark;
}
function $6ffe9515611cb489$var$fnBypass(v) {
    return v;
}
function $6ffe9515611cb489$var$fnSetSource(source, value) {
    return source.value = value;
}
function $6ffe9515611cb489$var$defaultDump(clone) {
    return clone ? typeof clone === "function" ? clone : $6ffe9515611cb489$export$9e72043f8ff3a3df : $6ffe9515611cb489$var$fnBypass;
}
function $6ffe9515611cb489$var$defaultParse(clone) {
    return clone ? typeof clone === "function" ? clone : $6ffe9515611cb489$export$9e72043f8ff3a3df : $6ffe9515611cb489$var$fnBypass;
}
function $6ffe9515611cb489$export$614531ad6f0c8fd(source, options = {}) {
    const { clone: clone = false, dump: dump = $6ffe9515611cb489$var$defaultDump(clone), parse: parse = $6ffe9515611cb489$var$defaultParse(clone), setSource: setSource = $6ffe9515611cb489$var$fnSetSource } = options;
    function _createHistoryRecord() {
        return (0, $01W3b.markRaw)({
            snapshot: dump(source.value),
            timestamp: (0, $AHHxt.timestamp)()
        });
    }
    const last = (0, $01W3b.ref)(_createHistoryRecord());
    const undoStack = (0, $01W3b.ref)([]);
    const redoStack = (0, $01W3b.ref)([]);
    const _setSource = (record)=>{
        setSource(source, parse(record.snapshot));
        last.value = record;
    };
    const commit = ()=>{
        undoStack.value.unshift(last.value);
        last.value = _createHistoryRecord();
        if (options.capacity && undoStack.value.length > options.capacity) undoStack.value.splice(options.capacity, Number.POSITIVE_INFINITY);
        if (redoStack.value.length) redoStack.value.splice(0, redoStack.value.length);
    };
    const clear = ()=>{
        undoStack.value.splice(0, undoStack.value.length);
        redoStack.value.splice(0, redoStack.value.length);
    };
    const undo = ()=>{
        const state = undoStack.value.shift();
        if (state) {
            redoStack.value.unshift(last.value);
            _setSource(state);
        }
    };
    const redo = ()=>{
        const state = redoStack.value.shift();
        if (state) {
            undoStack.value.unshift(last.value);
            _setSource(state);
        }
    };
    const reset = ()=>{
        _setSource(last.value);
    };
    const history = (0, $01W3b.computed)(()=>[
            last.value,
            ...undoStack.value
        ]);
    const canUndo = (0, $01W3b.computed)(()=>undoStack.value.length > 0);
    const canRedo = (0, $01W3b.computed)(()=>redoStack.value.length > 0);
    return {
        source: source,
        undoStack: undoStack,
        redoStack: redoStack,
        last: last,
        history: history,
        canUndo: canUndo,
        canRedo: canRedo,
        clear: clear,
        commit: commit,
        reset: reset,
        undo: undo,
        redo: redo
    };
}
function $6ffe9515611cb489$export$de889b39e422efc4(source, options = {}) {
    const { deep: deep = false, flush: flush = "pre", eventFilter: eventFilter } = options;
    const { eventFilter: composedFilter, pause: pause, resume: resumeTracking, isActive: isTracking } = (0, $AHHxt.pausableFilter)(eventFilter);
    const { ignoreUpdates: ignoreUpdates, ignorePrevAsyncUpdates: ignorePrevAsyncUpdates, stop: stop } = (0, $AHHxt.watchIgnorable)(source, commit, {
        deep: deep,
        flush: flush,
        eventFilter: composedFilter
    });
    function setSource(source2, value) {
        ignorePrevAsyncUpdates();
        ignoreUpdates(()=>{
            source2.value = value;
        });
    }
    const manualHistory = $6ffe9515611cb489$export$614531ad6f0c8fd(source, {
        ...options,
        clone: options.clone || deep,
        setSource: setSource
    });
    const { clear: clear, commit: manualCommit } = manualHistory;
    function commit() {
        ignorePrevAsyncUpdates();
        manualCommit();
    }
    function resume(commitNow) {
        resumeTracking();
        if (commitNow) commit();
    }
    function batch(fn) {
        let canceled = false;
        const cancel = ()=>canceled = true;
        ignoreUpdates(()=>{
            fn(cancel);
        });
        if (!canceled) commit();
    }
    function dispose() {
        stop();
        clear();
    }
    return {
        ...manualHistory,
        isTracking: isTracking,
        pause: pause,
        resume: resume,
        commit: commit,
        batch: batch,
        dispose: dispose
    };
}
function $6ffe9515611cb489$export$3b9372c83f595b14(source, options = {}) {
    const filter = options.debounce ? (0, $AHHxt.debounceFilter)(options.debounce) : void 0;
    const history = $6ffe9515611cb489$export$de889b39e422efc4(source, {
        ...options,
        eventFilter: filter
    });
    return {
        ...history
    };
}
function $6ffe9515611cb489$export$45ef0ca3d803202d(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, eventFilter: eventFilter = (0, $AHHxt.bypassFilter) } = options;
    const acceleration = (0, $01W3b.ref)({
        x: null,
        y: null,
        z: null
    });
    const rotationRate = (0, $01W3b.ref)({
        alpha: null,
        beta: null,
        gamma: null
    });
    const interval = (0, $01W3b.ref)(0);
    const accelerationIncludingGravity = (0, $01W3b.ref)({
        x: null,
        y: null,
        z: null
    });
    if (window1) {
        const onDeviceMotion = (0, $AHHxt.createFilterWrapper)(eventFilter, (event)=>{
            acceleration.value = event.acceleration;
            accelerationIncludingGravity.value = event.accelerationIncludingGravity;
            rotationRate.value = event.rotationRate;
            interval.value = event.interval;
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "devicemotion", onDeviceMotion);
    }
    return {
        acceleration: acceleration,
        accelerationIncludingGravity: accelerationIncludingGravity,
        rotationRate: rotationRate,
        interval: interval
    };
}
function $6ffe9515611cb489$export$9bafe4f626b63a33(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "DeviceOrientationEvent" in window1);
    const isAbsolute = (0, $01W3b.ref)(false);
    const alpha = (0, $01W3b.ref)(null);
    const beta = (0, $01W3b.ref)(null);
    const gamma = (0, $01W3b.ref)(null);
    if (window1 && isSupported.value) $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "deviceorientation", (event)=>{
        isAbsolute.value = event.absolute;
        alpha.value = event.alpha;
        beta.value = event.beta;
        gamma.value = event.gamma;
    });
    return {
        isSupported: isSupported,
        isAbsolute: isAbsolute,
        alpha: alpha,
        beta: beta,
        gamma: gamma
    };
}
function $6ffe9515611cb489$export$9619f0fa9e7879c6(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const pixelRatio = (0, $01W3b.ref)(1);
    if (window1) {
        let observe2 = function() {
            pixelRatio.value = window1.devicePixelRatio;
            cleanup2();
            media = window1.matchMedia(`(resolution: ${pixelRatio.value}dppx)`);
            media.addEventListener("change", observe2, {
                once: true
            });
        }, cleanup2 = function() {
            media == null || media.removeEventListener("change", observe2);
        };
        let media;
        observe2();
        (0, $AHHxt.tryOnScopeDispose)(cleanup2);
    }
    return {
        pixelRatio: pixelRatio
    };
}
function $6ffe9515611cb489$export$c860eb59c2f56cac(options = {}) {
    const { navigator: navigator = $6ffe9515611cb489$export$eade61489f57e3fc, requestPermissions: requestPermissions = false, constraints: constraints = {
        audio: true,
        video: true
    }, onUpdated: onUpdated } = options;
    const devices = (0, $01W3b.ref)([]);
    const videoInputs = (0, $01W3b.computed)(()=>devices.value.filter((i)=>i.kind === "videoinput"));
    const audioInputs = (0, $01W3b.computed)(()=>devices.value.filter((i)=>i.kind === "audioinput"));
    const audioOutputs = (0, $01W3b.computed)(()=>devices.value.filter((i)=>i.kind === "audiooutput"));
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices);
    const permissionGranted = (0, $01W3b.ref)(false);
    let stream;
    async function update() {
        if (!isSupported.value) return;
        devices.value = await navigator.mediaDevices.enumerateDevices();
        onUpdated == null || onUpdated(devices.value);
        if (stream) {
            stream.getTracks().forEach((t)=>t.stop());
            stream = null;
        }
    }
    async function ensurePermissions() {
        if (!isSupported.value) return false;
        if (permissionGranted.value) return true;
        const { state: state, query: query } = $6ffe9515611cb489$export$d7376454a3cf5ab4("camera", {
            controls: true
        });
        await query();
        if (state.value !== "granted") {
            stream = await navigator.mediaDevices.getUserMedia(constraints);
            update();
            permissionGranted.value = true;
        } else permissionGranted.value = true;
        return permissionGranted.value;
    }
    if (isSupported.value) {
        if (requestPermissions) ensurePermissions();
        $6ffe9515611cb489$export$7080b3e976bc91ab(navigator.mediaDevices, "devicechange", update);
        update();
    }
    return {
        devices: devices,
        ensurePermissions: ensurePermissions,
        permissionGranted: permissionGranted,
        videoInputs: videoInputs,
        audioInputs: audioInputs,
        audioOutputs: audioOutputs,
        isSupported: isSupported
    };
}
function $6ffe9515611cb489$export$f2d17e22a8e6ddfc(options = {}) {
    var _a;
    const enabled = (0, $01W3b.ref)((_a = options.enabled) != null ? _a : false);
    const video = options.video;
    const audio = options.audio;
    const { navigator: navigator = $6ffe9515611cb489$export$eade61489f57e3fc } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>{
        var _a2;
        return (_a2 = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a2.getDisplayMedia;
    });
    const constraint = {
        audio: audio,
        video: video
    };
    const stream = (0, $01W3b.shallowRef)();
    async function _start() {
        if (!isSupported.value || stream.value) return;
        stream.value = await navigator.mediaDevices.getDisplayMedia(constraint);
        return stream.value;
    }
    async function _stop() {
        var _a2;
        (_a2 = stream.value) == null || _a2.getTracks().forEach((t)=>t.stop());
        stream.value = void 0;
    }
    function stop() {
        _stop();
        enabled.value = false;
    }
    async function start() {
        await _start();
        if (stream.value) enabled.value = true;
        return stream.value;
    }
    (0, $TusQn.watch)(enabled, (v)=>{
        if (v) _start();
        else _stop();
    }, {
        immediate: true
    });
    return {
        isSupported: isSupported,
        stream: stream,
        start: start,
        stop: stop,
        enabled: enabled
    };
}
function $6ffe9515611cb489$export$87a87a3d299ece7c(options = {}) {
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    if (!document1) return (0, $01W3b.ref)("visible");
    const visibility = (0, $01W3b.ref)(document1.visibilityState);
    $6ffe9515611cb489$export$7080b3e976bc91ab(document1, "visibilitychange", ()=>{
        visibility.value = document1.visibilityState;
    });
    return visibility;
}
function $6ffe9515611cb489$export$df30c81f5aa01ff7(target, options = {}) {
    var _a, _b;
    const { pointerTypes: pointerTypes, preventDefault: preventDefault, stopPropagation: stopPropagation, exact: exact, onMove: onMove, onEnd: onEnd, onStart: onStart, initialValue: initialValue, axis: axis = "both", draggingElement: draggingElement = $6ffe9515611cb489$export$16f8ba610718ae4a, containerElement: containerElement, handle: draggingHandle = target } = options;
    const position = (0, $01W3b.ref)((_a = (0, $AHHxt.toValue)(initialValue)) != null ? _a : {
        x: 0,
        y: 0
    });
    const pressedDelta = (0, $01W3b.ref)();
    const filterEvent = (e)=>{
        if (pointerTypes) return pointerTypes.includes(e.pointerType);
        return true;
    };
    const handleEvent = (e)=>{
        if ((0, $AHHxt.toValue)(preventDefault)) e.preventDefault();
        if ((0, $AHHxt.toValue)(stopPropagation)) e.stopPropagation();
    };
    const start = (e)=>{
        var _a2;
        if ((0, $AHHxt.toValue)(options.disabled) || !filterEvent(e)) return;
        if ((0, $AHHxt.toValue)(exact) && e.target !== (0, $AHHxt.toValue)(target)) return;
        const container = (0, $AHHxt.toValue)(containerElement);
        const containerRect = (_a2 = container == null ? void 0 : container.getBoundingClientRect) == null ? void 0 : _a2.call(container);
        const targetRect = (0, $AHHxt.toValue)(target).getBoundingClientRect();
        const pos = {
            x: e.clientX - (container ? targetRect.left - containerRect.left + container.scrollLeft : targetRect.left),
            y: e.clientY - (container ? targetRect.top - containerRect.top + container.scrollTop : targetRect.top)
        };
        if ((onStart == null ? void 0 : onStart(pos, e)) === false) return;
        pressedDelta.value = pos;
        handleEvent(e);
    };
    const move = (e)=>{
        if ((0, $AHHxt.toValue)(options.disabled) || !filterEvent(e)) return;
        if (!pressedDelta.value) return;
        const container = (0, $AHHxt.toValue)(containerElement);
        const targetRect = (0, $AHHxt.toValue)(target).getBoundingClientRect();
        let { x: x, y: y } = position.value;
        if (axis === "x" || axis === "both") {
            x = e.clientX - pressedDelta.value.x;
            if (container) x = Math.min(Math.max(0, x), container.scrollWidth - targetRect.width);
        }
        if (axis === "y" || axis === "both") {
            y = e.clientY - pressedDelta.value.y;
            if (container) y = Math.min(Math.max(0, y), container.scrollHeight - targetRect.height);
        }
        position.value = {
            x: x,
            y: y
        };
        onMove == null || onMove(position.value, e);
        handleEvent(e);
    };
    const end = (e)=>{
        if ((0, $AHHxt.toValue)(options.disabled) || !filterEvent(e)) return;
        if (!pressedDelta.value) return;
        pressedDelta.value = void 0;
        onEnd == null || onEnd(position.value, e);
        handleEvent(e);
    };
    if (0, $AHHxt.isClient) {
        const config = {
            capture: (_b = options.capture) != null ? _b : true
        };
        $6ffe9515611cb489$export$7080b3e976bc91ab(draggingHandle, "pointerdown", start, config);
        $6ffe9515611cb489$export$7080b3e976bc91ab(draggingElement, "pointermove", move, config);
        $6ffe9515611cb489$export$7080b3e976bc91ab(draggingElement, "pointerup", end, config);
    }
    return {
        ...(0, $AHHxt.toRefs)(position),
        position: position,
        isDragging: (0, $01W3b.computed)(()=>!!pressedDelta.value),
        style: (0, $01W3b.computed)(()=>`left:${position.value.x}px;top:${position.value.y}px;`)
    };
}
function $6ffe9515611cb489$export$ff33ba24b8f2a683(target, options = {}) {
    const isOverDropZone = (0, $01W3b.ref)(false);
    const files = (0, $01W3b.shallowRef)(null);
    let counter = 0;
    let isDataTypeIncluded = true;
    if (0, $AHHxt.isClient) {
        const _options = typeof options === "function" ? {
            onDrop: options
        } : options;
        const getFiles = (event)=>{
            var _a, _b;
            const list = Array.from((_b = (_a = event.dataTransfer) == null ? void 0 : _a.files) != null ? _b : []);
            return files.value = list.length === 0 ? null : list;
        };
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "dragenter", (event)=>{
            var _a, _b;
            const types = Array.from(((_a = event == null ? void 0 : event.dataTransfer) == null ? void 0 : _a.items) || []).map((i)=>i.kind === "file" ? i.type : null).filter((0, $AHHxt.notNullish));
            if (_options.dataTypes && event.dataTransfer) {
                const dataTypes = (0, $01W3b.unref)(_options.dataTypes);
                isDataTypeIncluded = typeof dataTypes === "function" ? dataTypes(types) : dataTypes ? dataTypes.some((item)=>types.includes(item)) : true;
                if (!isDataTypeIncluded) return;
            }
            event.preventDefault();
            counter += 1;
            isOverDropZone.value = true;
            (_b = _options.onEnter) == null || _b.call(_options, getFiles(event), event);
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "dragover", (event)=>{
            var _a;
            if (!isDataTypeIncluded) return;
            event.preventDefault();
            (_a = _options.onOver) == null || _a.call(_options, getFiles(event), event);
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "dragleave", (event)=>{
            var _a;
            if (!isDataTypeIncluded) return;
            event.preventDefault();
            counter -= 1;
            if (counter === 0) isOverDropZone.value = false;
            (_a = _options.onLeave) == null || _a.call(_options, getFiles(event), event);
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "drop", (event)=>{
            var _a;
            event.preventDefault();
            counter = 0;
            isOverDropZone.value = false;
            (_a = _options.onDrop) == null || _a.call(_options, getFiles(event), event);
        });
    }
    return {
        files: files,
        isOverDropZone: isOverDropZone
    };
}
function $6ffe9515611cb489$export$683480f191c0e3ea(target, callback, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, ...observerOptions } = options;
    let observer;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "ResizeObserver" in window1);
    const cleanup = ()=>{
        if (observer) {
            observer.disconnect();
            observer = void 0;
        }
    };
    const targets = (0, $01W3b.computed)(()=>Array.isArray(target) ? target.map((el)=>$6ffe9515611cb489$export$c61124d3cf5adbae(el)) : [
            $6ffe9515611cb489$export$c61124d3cf5adbae(target)
        ]);
    const stopWatch = (0, $TusQn.watch)(targets, (els)=>{
        cleanup();
        if (isSupported.value && window1) {
            observer = new ResizeObserver(callback);
            for (const _el of els)_el && observer.observe(_el, observerOptions);
        }
    }, {
        immediate: true,
        flush: "post"
    });
    const stop = ()=>{
        cleanup();
        stopWatch();
    };
    (0, $AHHxt.tryOnScopeDispose)(stop);
    return {
        isSupported: isSupported,
        stop: stop
    };
}
function $6ffe9515611cb489$export$f623e6fca765c371(target, options = {}) {
    const { reset: reset = true, windowResize: windowResize = true, windowScroll: windowScroll = true, immediate: immediate = true } = options;
    const height = (0, $01W3b.ref)(0);
    const bottom = (0, $01W3b.ref)(0);
    const left = (0, $01W3b.ref)(0);
    const right = (0, $01W3b.ref)(0);
    const top = (0, $01W3b.ref)(0);
    const width = (0, $01W3b.ref)(0);
    const x = (0, $01W3b.ref)(0);
    const y = (0, $01W3b.ref)(0);
    function update() {
        const el = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
        if (!el) {
            if (reset) {
                height.value = 0;
                bottom.value = 0;
                left.value = 0;
                right.value = 0;
                top.value = 0;
                width.value = 0;
                x.value = 0;
                y.value = 0;
            }
            return;
        }
        const rect = el.getBoundingClientRect();
        height.value = rect.height;
        bottom.value = rect.bottom;
        left.value = rect.left;
        right.value = rect.right;
        top.value = rect.top;
        width.value = rect.width;
        x.value = rect.x;
        y.value = rect.y;
    }
    $6ffe9515611cb489$export$683480f191c0e3ea(target, update);
    (0, $TusQn.watch)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(target), (ele)=>!ele && update());
    $6ffe9515611cb489$export$8ecdcf3bb089e9cd(target, update, {
        attributeFilter: [
            "style",
            "class"
        ]
    });
    if (windowScroll) $6ffe9515611cb489$export$7080b3e976bc91ab("scroll", update, {
        capture: true,
        passive: true
    });
    if (windowResize) $6ffe9515611cb489$export$7080b3e976bc91ab("resize", update, {
        passive: true
    });
    (0, $AHHxt.tryOnMounted)(()=>{
        if (immediate) update();
    });
    return {
        height: height,
        bottom: bottom,
        left: left,
        right: right,
        top: top,
        width: width,
        x: x,
        y: y,
        update: update
    };
}
function $6ffe9515611cb489$export$f6b6f8dd6f68aad2(options) {
    const { x: x, y: y, document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, multiple: multiple, interval: interval = "requestAnimationFrame", immediate: immediate = true } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>{
        if ((0, $AHHxt.toValue)(multiple)) return document1 && "elementsFromPoint" in document1;
        return document1 && "elementFromPoint" in document1;
    });
    const element = (0, $01W3b.ref)(null);
    const cb = ()=>{
        var _a, _b;
        element.value = (0, $AHHxt.toValue)(multiple) ? (_a = document1 == null ? void 0 : document1.elementsFromPoint((0, $AHHxt.toValue)(x), (0, $AHHxt.toValue)(y))) != null ? _a : [] : (_b = document1 == null ? void 0 : document1.elementFromPoint((0, $AHHxt.toValue)(x), (0, $AHHxt.toValue)(y))) != null ? _b : null;
    };
    const controls = interval === "requestAnimationFrame" ? $6ffe9515611cb489$export$13251e0fc79284e(cb, {
        immediate: immediate
    }) : (0, $AHHxt.useIntervalFn)(cb, interval, {
        immediate: immediate
    });
    return {
        isSupported: isSupported,
        element: element,
        ...controls
    };
}
function $6ffe9515611cb489$export$6e95f3a294e6b04d(el, options = {}) {
    const { delayEnter: delayEnter = 0, delayLeave: delayLeave = 0, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isHovered = (0, $01W3b.ref)(false);
    let timer;
    const toggle = (entering)=>{
        const delay = entering ? delayEnter : delayLeave;
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
        }
        if (delay) timer = setTimeout(()=>isHovered.value = entering, delay);
        else isHovered.value = entering;
    };
    if (!window1) return isHovered;
    $6ffe9515611cb489$export$7080b3e976bc91ab(el, "mouseenter", ()=>toggle(true), {
        passive: true
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(el, "mouseleave", ()=>toggle(false), {
        passive: true
    });
    return isHovered;
}
function $6ffe9515611cb489$export$2b86bedf890eab8(target, initialSize = {
    width: 0,
    height: 0
}, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, box: box = "content-box" } = options;
    const isSVG = (0, $01W3b.computed)(()=>{
        var _a, _b;
        return (_b = (_a = $6ffe9515611cb489$export$c61124d3cf5adbae(target)) == null ? void 0 : _a.namespaceURI) == null ? void 0 : _b.includes("svg");
    });
    const width = (0, $01W3b.ref)(initialSize.width);
    const height = (0, $01W3b.ref)(initialSize.height);
    const { stop: stop1 } = $6ffe9515611cb489$export$683480f191c0e3ea(target, ([entry])=>{
        const boxSize = box === "border-box" ? entry.borderBoxSize : box === "content-box" ? entry.contentBoxSize : entry.devicePixelContentBoxSize;
        if (window1 && isSVG.value) {
            const $elem = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
            if ($elem) {
                const styles = window1.getComputedStyle($elem);
                width.value = Number.parseFloat(styles.width);
                height.value = Number.parseFloat(styles.height);
            }
        } else if (boxSize) {
            const formatBoxSize = Array.isArray(boxSize) ? boxSize : [
                boxSize
            ];
            width.value = formatBoxSize.reduce((acc, { inlineSize: inlineSize })=>acc + inlineSize, 0);
            height.value = formatBoxSize.reduce((acc, { blockSize: blockSize })=>acc + blockSize, 0);
        } else {
            width.value = entry.contentRect.width;
            height.value = entry.contentRect.height;
        }
    }, options);
    (0, $AHHxt.tryOnMounted)(()=>{
        const ele = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
        if (ele) {
            width.value = "offsetWidth" in ele ? ele.offsetWidth : initialSize.width;
            height.value = "offsetHeight" in ele ? ele.offsetHeight : initialSize.height;
        }
    });
    const stop2 = (0, $TusQn.watch)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(target), (ele)=>{
        width.value = ele ? initialSize.width : 0;
        height.value = ele ? initialSize.height : 0;
    });
    function stop() {
        stop1();
        stop2();
    }
    return {
        width: width,
        height: height,
        stop: stop
    };
}
function $6ffe9515611cb489$export$a7395f9832c00176(target, callback, options = {}) {
    const { root: root, rootMargin: rootMargin = "0px", threshold: threshold = 0.1, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, immediate: immediate = true } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "IntersectionObserver" in window1);
    const targets = (0, $01W3b.computed)(()=>{
        const _target = (0, $AHHxt.toValue)(target);
        return (Array.isArray(_target) ? _target : [
            _target
        ]).map($6ffe9515611cb489$export$c61124d3cf5adbae).filter((0, $AHHxt.notNullish));
    });
    let cleanup = (0, $AHHxt.noop);
    const isActive = (0, $01W3b.ref)(immediate);
    const stopWatch = isSupported.value ? (0, $TusQn.watch)(()=>[
            targets.value,
            $6ffe9515611cb489$export$c61124d3cf5adbae(root),
            isActive.value
        ], ([targets2, root2])=>{
        cleanup();
        if (!isActive.value) return;
        if (!targets2.length) return;
        const observer = new IntersectionObserver(callback, {
            root: $6ffe9515611cb489$export$c61124d3cf5adbae(root2),
            rootMargin: rootMargin,
            threshold: threshold
        });
        targets2.forEach((el)=>el && observer.observe(el));
        cleanup = ()=>{
            observer.disconnect();
            cleanup = (0, $AHHxt.noop);
        };
    }, {
        immediate: immediate,
        flush: "post"
    }) : (0, $AHHxt.noop);
    const stop = ()=>{
        cleanup();
        stopWatch();
        isActive.value = false;
    };
    (0, $AHHxt.tryOnScopeDispose)(stop);
    return {
        isSupported: isSupported,
        isActive: isActive,
        pause () {
            cleanup();
            isActive.value = false;
        },
        resume () {
            isActive.value = true;
        },
        stop: stop
    };
}
function $6ffe9515611cb489$export$6aadc312a449609d(element, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, scrollTarget: scrollTarget, threshold: threshold = 0 } = options;
    const elementIsVisible = (0, $01W3b.ref)(false);
    $6ffe9515611cb489$export$a7395f9832c00176(element, (intersectionObserverEntries)=>{
        let isIntersecting = elementIsVisible.value;
        let latestTime = 0;
        for (const entry of intersectionObserverEntries)if (entry.time >= latestTime) {
            latestTime = entry.time;
            isIntersecting = entry.isIntersecting;
        }
        elementIsVisible.value = isIntersecting;
    }, {
        root: scrollTarget,
        window: window1,
        threshold: threshold
    });
    return elementIsVisible;
}
const $6ffe9515611cb489$var$events = /* @__PURE__ */ new Map();
function $6ffe9515611cb489$export$965c4f095bc7d646(key) {
    const scope = (0, $01W3b.getCurrentScope)();
    function on(listener) {
        var _a;
        const listeners = $6ffe9515611cb489$var$events.get(key) || /* @__PURE__ */ new Set();
        listeners.add(listener);
        $6ffe9515611cb489$var$events.set(key, listeners);
        const _off = ()=>off(listener);
        (_a = scope == null ? void 0 : scope.cleanups) == null || _a.push(_off);
        return _off;
    }
    function once(listener) {
        function _listener(...args) {
            off(_listener);
            listener(...args);
        }
        return on(_listener);
    }
    function off(listener) {
        const listeners = $6ffe9515611cb489$var$events.get(key);
        if (!listeners) return;
        listeners.delete(listener);
        if (!listeners.size) reset();
    }
    function reset() {
        $6ffe9515611cb489$var$events.delete(key);
    }
    function emit(event, payload) {
        var _a;
        (_a = $6ffe9515611cb489$var$events.get(key)) == null || _a.forEach((v)=>v(event, payload));
    }
    return {
        on: on,
        once: once,
        off: off,
        emit: emit,
        reset: reset
    };
}
function $6ffe9515611cb489$var$resolveNestedOptions$1(options) {
    if (options === true) return {};
    return options;
}
function $6ffe9515611cb489$export$1492e5081ec8f8b5(url, events = [], options = {}) {
    const event = (0, $01W3b.ref)(null);
    const data = (0, $01W3b.ref)(null);
    const status = (0, $01W3b.ref)("CONNECTING");
    const eventSource = (0, $01W3b.ref)(null);
    const error = (0, $01W3b.shallowRef)(null);
    const urlRef = (0, $AHHxt.toRef)(url);
    let explicitlyClosed = false;
    let retried = 0;
    const { withCredentials: withCredentials = false, immediate: immediate = true } = options;
    const close = ()=>{
        if ((0, $AHHxt.isClient) && eventSource.value) {
            eventSource.value.close();
            eventSource.value = null;
            status.value = "CLOSED";
            explicitlyClosed = true;
        }
    };
    const _init = ()=>{
        if (explicitlyClosed || typeof urlRef.value === "undefined") return;
        const es = new EventSource(urlRef.value, {
            withCredentials: withCredentials
        });
        status.value = "CONNECTING";
        eventSource.value = es;
        es.onopen = ()=>{
            status.value = "OPEN";
            error.value = null;
        };
        es.onerror = (e)=>{
            status.value = "CLOSED";
            error.value = e;
            if (es.readyState === 2 && !explicitlyClosed && options.autoReconnect) {
                es.close();
                const { retries: retries = -1, delay: delay = 1e3, onFailed: onFailed } = $6ffe9515611cb489$var$resolveNestedOptions$1(options.autoReconnect);
                retried += 1;
                if (typeof retries === "number" && (retries < 0 || retried < retries)) setTimeout(_init, delay);
                else if (typeof retries === "function" && retries()) setTimeout(_init, delay);
                else onFailed == null || onFailed();
            }
        };
        es.onmessage = (e)=>{
            event.value = null;
            data.value = e.data;
        };
        for (const event_name of events)$6ffe9515611cb489$export$7080b3e976bc91ab(es, event_name, (e)=>{
            event.value = event_name;
            data.value = e.data || null;
        });
    };
    const open = ()=>{
        if (!(0, $AHHxt.isClient)) return;
        close();
        explicitlyClosed = false;
        retried = 0;
        _init();
    };
    if (immediate) (0, $TusQn.watch)(urlRef, open, {
        immediate: true
    });
    (0, $AHHxt.tryOnScopeDispose)(close);
    return {
        eventSource: eventSource,
        event: event,
        data: data,
        status: status,
        error: error,
        open: open,
        close: close
    };
}
function $6ffe9515611cb489$export$b649d244384df275(options = {}) {
    const { initialValue: initialValue = "" } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>typeof window !== "undefined" && "EyeDropper" in window);
    const sRGBHex = (0, $01W3b.ref)(initialValue);
    async function open(openOptions) {
        if (!isSupported.value) return;
        const eyeDropper = new window.EyeDropper();
        const result = await eyeDropper.open(openOptions);
        sRGBHex.value = result.sRGBHex;
        return result;
    }
    return {
        isSupported: isSupported,
        sRGBHex: sRGBHex,
        open: open
    };
}
function $6ffe9515611cb489$export$1252d0179ae6292b(newIcon = null, options = {}) {
    const { baseUrl: baseUrl = "", rel: rel = "icon", document: document1 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    const favicon = (0, $AHHxt.toRef)(newIcon);
    const applyIcon = (icon)=>{
        const elements = document1 == null ? void 0 : document1.head.querySelectorAll(`link[rel*="${rel}"]`);
        if (!elements || elements.length === 0) {
            const link = document1 == null ? void 0 : document1.createElement("link");
            if (link) {
                link.rel = rel;
                link.href = `${baseUrl}${icon}`;
                link.type = `image/${icon.split(".").pop()}`;
                document1 == null || document1.head.append(link);
            }
            return;
        }
        elements == null || elements.forEach((el)=>el.href = `${baseUrl}${icon}`);
    };
    (0, $TusQn.watch)(favicon, (i, o)=>{
        if (typeof i === "string" && i !== o) applyIcon(i);
    }, {
        immediate: true
    });
    return favicon;
}
const $6ffe9515611cb489$var$payloadMapping = {
    json: "application/json",
    text: "text/plain"
};
function $6ffe9515611cb489$var$isFetchOptions(obj) {
    return obj && (0, $AHHxt.containsProp)(obj, "immediate", "refetch", "initialData", "timeout", "beforeFetch", "afterFetch", "onFetchError", "fetch", "updateDataOnError");
}
function $6ffe9515611cb489$var$isAbsoluteURL(url) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
function $6ffe9515611cb489$var$headersToObject(headers) {
    if (typeof Headers !== "undefined" && headers instanceof Headers) return Object.fromEntries(headers.entries());
    return headers;
}
function $6ffe9515611cb489$var$combineCallbacks(combination, ...callbacks) {
    if (combination === "overwrite") return async (ctx)=>{
        const callback = callbacks[callbacks.length - 1];
        if (callback) return {
            ...ctx,
            ...await callback(ctx)
        };
        return ctx;
    };
    else return async (ctx)=>{
        for (const callback of callbacks)if (callback) ctx = {
            ...ctx,
            ...await callback(ctx)
        };
        return ctx;
    };
}
function $6ffe9515611cb489$export$3d173a42d8c9a48a(config = {}) {
    const _combination = config.combination || "chain";
    const _options = config.options || {};
    const _fetchOptions = config.fetchOptions || {};
    function useFactoryFetch(url, ...args) {
        const computedUrl = (0, $01W3b.computed)(()=>{
            const baseUrl = (0, $AHHxt.toValue)(config.baseUrl);
            const targetUrl = (0, $AHHxt.toValue)(url);
            return baseUrl && !$6ffe9515611cb489$var$isAbsoluteURL(targetUrl) ? $6ffe9515611cb489$var$joinPaths(baseUrl, targetUrl) : targetUrl;
        });
        let options = _options;
        let fetchOptions = _fetchOptions;
        if (args.length > 0) {
            if ($6ffe9515611cb489$var$isFetchOptions(args[0])) options = {
                ...options,
                ...args[0],
                beforeFetch: $6ffe9515611cb489$var$combineCallbacks(_combination, _options.beforeFetch, args[0].beforeFetch),
                afterFetch: $6ffe9515611cb489$var$combineCallbacks(_combination, _options.afterFetch, args[0].afterFetch),
                onFetchError: $6ffe9515611cb489$var$combineCallbacks(_combination, _options.onFetchError, args[0].onFetchError)
            };
            else fetchOptions = {
                ...fetchOptions,
                ...args[0],
                headers: {
                    ...$6ffe9515611cb489$var$headersToObject(fetchOptions.headers) || {},
                    ...$6ffe9515611cb489$var$headersToObject(args[0].headers) || {}
                }
            };
        }
        if (args.length > 1 && $6ffe9515611cb489$var$isFetchOptions(args[1])) options = {
            ...options,
            ...args[1],
            beforeFetch: $6ffe9515611cb489$var$combineCallbacks(_combination, _options.beforeFetch, args[1].beforeFetch),
            afterFetch: $6ffe9515611cb489$var$combineCallbacks(_combination, _options.afterFetch, args[1].afterFetch),
            onFetchError: $6ffe9515611cb489$var$combineCallbacks(_combination, _options.onFetchError, args[1].onFetchError)
        };
        return $6ffe9515611cb489$export$d852f5f778460fa4(computedUrl, fetchOptions, options);
    }
    return useFactoryFetch;
}
function $6ffe9515611cb489$export$d852f5f778460fa4(url, ...args) {
    var _a;
    const supportsAbort = typeof AbortController === "function";
    let fetchOptions = {};
    let options = {
        immediate: true,
        refetch: false,
        timeout: 0,
        updateDataOnError: false
    };
    const config = {
        method: "GET",
        type: "text",
        payload: void 0
    };
    if (args.length > 0) {
        if ($6ffe9515611cb489$var$isFetchOptions(args[0])) options = {
            ...options,
            ...args[0]
        };
        else fetchOptions = args[0];
    }
    if (args.length > 1) {
        if ($6ffe9515611cb489$var$isFetchOptions(args[1])) options = {
            ...options,
            ...args[1]
        };
    }
    const { fetch: fetch = (_a = $6ffe9515611cb489$export$16f8ba610718ae4a) == null ? void 0 : _a.fetch, initialData: initialData, timeout: timeout } = options;
    const responseEvent = (0, $AHHxt.createEventHook)();
    const errorEvent = (0, $AHHxt.createEventHook)();
    const finallyEvent = (0, $AHHxt.createEventHook)();
    const isFinished = (0, $01W3b.ref)(false);
    const isFetching = (0, $01W3b.ref)(false);
    const aborted = (0, $01W3b.ref)(false);
    const statusCode = (0, $01W3b.ref)(null);
    const response = (0, $01W3b.shallowRef)(null);
    const error = (0, $01W3b.shallowRef)(null);
    const data = (0, $01W3b.shallowRef)(initialData || null);
    const canAbort = (0, $01W3b.computed)(()=>supportsAbort && isFetching.value);
    let controller;
    let timer;
    const abort = ()=>{
        if (supportsAbort) {
            controller == null || controller.abort();
            controller = new AbortController();
            controller.signal.onabort = ()=>aborted.value = true;
            fetchOptions = {
                ...fetchOptions,
                signal: controller.signal
            };
        }
    };
    const loading = (isLoading)=>{
        isFetching.value = isLoading;
        isFinished.value = !isLoading;
    };
    if (timeout) timer = (0, $AHHxt.useTimeoutFn)(abort, timeout, {
        immediate: false
    });
    let executeCounter = 0;
    const execute = async (throwOnFailed = false)=>{
        var _a2, _b;
        abort();
        loading(true);
        error.value = null;
        statusCode.value = null;
        aborted.value = false;
        executeCounter += 1;
        const currentExecuteCounter = executeCounter;
        const defaultFetchOptions = {
            method: config.method,
            headers: {}
        };
        if (config.payload) {
            const headers = $6ffe9515611cb489$var$headersToObject(defaultFetchOptions.headers);
            const payload = (0, $AHHxt.toValue)(config.payload);
            if (!config.payloadType && payload && Object.getPrototypeOf(payload) === Object.prototype && !(payload instanceof FormData)) config.payloadType = "json";
            if (config.payloadType) headers["Content-Type"] = (_a2 = $6ffe9515611cb489$var$payloadMapping[config.payloadType]) != null ? _a2 : config.payloadType;
            defaultFetchOptions.body = config.payloadType === "json" ? JSON.stringify(payload) : payload;
        }
        let isCanceled = false;
        const context = {
            url: (0, $AHHxt.toValue)(url),
            options: {
                ...defaultFetchOptions,
                ...fetchOptions
            },
            cancel: ()=>{
                isCanceled = true;
            }
        };
        if (options.beforeFetch) Object.assign(context, await options.beforeFetch(context));
        if (isCanceled || !fetch) {
            loading(false);
            return Promise.resolve(null);
        }
        let responseData = null;
        if (timer) timer.start();
        return fetch(context.url, {
            ...defaultFetchOptions,
            ...context.options,
            headers: {
                ...$6ffe9515611cb489$var$headersToObject(defaultFetchOptions.headers),
                ...$6ffe9515611cb489$var$headersToObject((_b = context.options) == null ? void 0 : _b.headers)
            }
        }).then(async (fetchResponse)=>{
            response.value = fetchResponse;
            statusCode.value = fetchResponse.status;
            responseData = await fetchResponse.clone()[config.type]();
            if (!fetchResponse.ok) {
                data.value = initialData || null;
                throw new Error(fetchResponse.statusText);
            }
            if (options.afterFetch) ({ data: responseData } = await options.afterFetch({
                data: responseData,
                response: fetchResponse
            }));
            data.value = responseData;
            responseEvent.trigger(fetchResponse);
            return fetchResponse;
        }).catch(async (fetchError)=>{
            let errorData = fetchError.message || fetchError.name;
            if (options.onFetchError) ({ error: errorData, data: responseData } = await options.onFetchError({
                data: responseData,
                error: fetchError,
                response: response.value
            }));
            error.value = errorData;
            if (options.updateDataOnError) data.value = responseData;
            errorEvent.trigger(fetchError);
            if (throwOnFailed) throw fetchError;
            return null;
        }).finally(()=>{
            if (currentExecuteCounter === executeCounter) loading(false);
            if (timer) timer.stop();
            finallyEvent.trigger(null);
        });
    };
    const refetch = (0, $AHHxt.toRef)(options.refetch);
    (0, $TusQn.watch)([
        refetch,
        (0, $AHHxt.toRef)(url)
    ], ([refetch2])=>refetch2 && execute(), {
        deep: true
    });
    const shell = {
        isFinished: (0, $01W3b.readonly)(isFinished),
        isFetching: (0, $01W3b.readonly)(isFetching),
        statusCode: statusCode,
        response: response,
        error: error,
        data: data,
        canAbort: canAbort,
        aborted: aborted,
        abort: abort,
        execute: execute,
        onFetchResponse: responseEvent.on,
        onFetchError: errorEvent.on,
        onFetchFinally: finallyEvent.on,
        // method
        get: setMethod("GET"),
        put: setMethod("PUT"),
        post: setMethod("POST"),
        delete: setMethod("DELETE"),
        patch: setMethod("PATCH"),
        head: setMethod("HEAD"),
        options: setMethod("OPTIONS"),
        // type
        json: setType("json"),
        text: setType("text"),
        blob: setType("blob"),
        arrayBuffer: setType("arrayBuffer"),
        formData: setType("formData")
    };
    function setMethod(method) {
        return (payload, payloadType)=>{
            if (!isFetching.value) {
                config.method = method;
                config.payload = payload;
                config.payloadType = payloadType;
                if ((0, $01W3b.isRef)(config.payload)) (0, $TusQn.watch)([
                    refetch,
                    (0, $AHHxt.toRef)(config.payload)
                ], ([refetch2])=>refetch2 && execute(), {
                    deep: true
                });
                return {
                    ...shell,
                    then (onFulfilled, onRejected) {
                        return waitUntilFinished().then(onFulfilled, onRejected);
                    }
                };
            }
            return void 0;
        };
    }
    function waitUntilFinished() {
        return new Promise((resolve, reject)=>{
            (0, $AHHxt.until)(isFinished).toBe(true).then(()=>resolve(shell)).catch((error2)=>reject(error2));
        });
    }
    function setType(type) {
        return ()=>{
            if (!isFetching.value) {
                config.type = type;
                return {
                    ...shell,
                    then (onFulfilled, onRejected) {
                        return waitUntilFinished().then(onFulfilled, onRejected);
                    }
                };
            }
            return void 0;
        };
    }
    if (options.immediate) Promise.resolve().then(()=>execute());
    return {
        ...shell,
        then (onFulfilled, onRejected) {
            return waitUntilFinished().then(onFulfilled, onRejected);
        }
    };
}
function $6ffe9515611cb489$var$joinPaths(start, end) {
    if (!start.endsWith("/") && !end.startsWith("/")) return `${start}/${end}`;
    return `${start}${end}`;
}
const $6ffe9515611cb489$var$DEFAULT_OPTIONS = {
    multiple: true,
    accept: "*",
    reset: false,
    directory: false
};
function $6ffe9515611cb489$export$46ab9fa3f3719597(options = {}) {
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    const files = (0, $01W3b.ref)(null);
    const { on: onChange, trigger: trigger } = (0, $AHHxt.createEventHook)();
    let input;
    if (document1) {
        input = document1.createElement("input");
        input.type = "file";
        input.onchange = (event)=>{
            const result = event.target;
            files.value = result.files;
            trigger(files.value);
        };
    }
    const reset = ()=>{
        files.value = null;
        if (input) {
            input.value = "";
            trigger(null);
        }
    };
    const open = (localOptions)=>{
        if (!input) return;
        const _options = {
            ...$6ffe9515611cb489$var$DEFAULT_OPTIONS,
            ...options,
            ...localOptions
        };
        input.multiple = _options.multiple;
        input.accept = _options.accept;
        input.webkitdirectory = _options.directory;
        if ((0, $AHHxt.hasOwn)(_options, "capture")) input.capture = _options.capture;
        if (_options.reset) reset();
        input.click();
    };
    return {
        files: (0, $01W3b.readonly)(files),
        open: open,
        reset: reset,
        onChange: onChange
    };
}
function $6ffe9515611cb489$export$2af170812ec5e71(options = {}) {
    const { window: _window = $6ffe9515611cb489$export$16f8ba610718ae4a, dataType: dataType = "Text" } = options;
    const window1 = _window;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "showSaveFilePicker" in window1 && "showOpenFilePicker" in window1);
    const fileHandle = (0, $01W3b.ref)();
    const data = (0, $01W3b.ref)();
    const file = (0, $01W3b.ref)();
    const fileName = (0, $01W3b.computed)(()=>{
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.name) != null ? _b : "";
    });
    const fileMIME = (0, $01W3b.computed)(()=>{
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.type) != null ? _b : "";
    });
    const fileSize = (0, $01W3b.computed)(()=>{
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.size) != null ? _b : 0;
    });
    const fileLastModified = (0, $01W3b.computed)(()=>{
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.lastModified) != null ? _b : 0;
    });
    async function open(_options = {}) {
        if (!isSupported.value) return;
        const [handle] = await window1.showOpenFilePicker({
            ...(0, $AHHxt.toValue)(options),
            ..._options
        });
        fileHandle.value = handle;
        await updateData();
    }
    async function create(_options = {}) {
        if (!isSupported.value) return;
        fileHandle.value = await window1.showSaveFilePicker({
            ...options,
            ..._options
        });
        data.value = void 0;
        await updateData();
    }
    async function save(_options = {}) {
        if (!isSupported.value) return;
        if (!fileHandle.value) return saveAs(_options);
        if (data.value) {
            const writableStream = await fileHandle.value.createWritable();
            await writableStream.write(data.value);
            await writableStream.close();
        }
        await updateFile();
    }
    async function saveAs(_options = {}) {
        if (!isSupported.value) return;
        fileHandle.value = await window1.showSaveFilePicker({
            ...options,
            ..._options
        });
        if (data.value) {
            const writableStream = await fileHandle.value.createWritable();
            await writableStream.write(data.value);
            await writableStream.close();
        }
        await updateFile();
    }
    async function updateFile() {
        var _a;
        file.value = await ((_a = fileHandle.value) == null ? void 0 : _a.getFile());
    }
    async function updateData() {
        var _a, _b;
        await updateFile();
        const type = (0, $AHHxt.toValue)(dataType);
        if (type === "Text") data.value = await ((_a = file.value) == null ? void 0 : _a.text());
        else if (type === "ArrayBuffer") data.value = await ((_b = file.value) == null ? void 0 : _b.arrayBuffer());
        else if (type === "Blob") data.value = file.value;
    }
    (0, $TusQn.watch)(()=>(0, $AHHxt.toValue)(dataType), updateData);
    return {
        isSupported: isSupported,
        data: data,
        file: file,
        fileName: fileName,
        fileMIME: fileMIME,
        fileSize: fileSize,
        fileLastModified: fileLastModified,
        open: open,
        create: create,
        save: save,
        saveAs: saveAs,
        updateData: updateData
    };
}
function $6ffe9515611cb489$export$f8168d8dd8fd66e6(target, options = {}) {
    const { initialValue: initialValue = false, focusVisible: focusVisible = false } = options;
    const innerFocused = (0, $01W3b.ref)(false);
    const targetElement = (0, $01W3b.computed)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(target));
    $6ffe9515611cb489$export$7080b3e976bc91ab(targetElement, "focus", (event)=>{
        var _a, _b;
        if (!focusVisible || ((_b = (_a = event.target).matches) == null ? void 0 : _b.call(_a, ":focus-visible"))) innerFocused.value = true;
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(targetElement, "blur", ()=>innerFocused.value = false);
    const focused = (0, $01W3b.computed)({
        get: ()=>innerFocused.value,
        set (value) {
            var _a, _b;
            if (!value && innerFocused.value) (_a = targetElement.value) == null || _a.blur();
            else if (value && !innerFocused.value) (_b = targetElement.value) == null || _b.focus();
        }
    });
    (0, $TusQn.watch)(targetElement, ()=>{
        focused.value = initialValue;
    }, {
        immediate: true,
        flush: "post"
    });
    return {
        focused: focused
    };
}
function $6ffe9515611cb489$export$420e68273165f4ec(target, options = {}) {
    const activeElement = $6ffe9515611cb489$export$4e1875a4b2b1434f(options);
    const targetElement = (0, $01W3b.computed)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(target));
    const focused = (0, $01W3b.computed)(()=>targetElement.value && activeElement.value ? targetElement.value.contains(activeElement.value) : false);
    return {
        focused: focused
    };
}
function $6ffe9515611cb489$export$ab5229fe4b5ea5d0(options) {
    var _a;
    const fps = (0, $01W3b.ref)(0);
    if (typeof performance === "undefined") return fps;
    const every = (_a = options == null ? void 0 : options.every) != null ? _a : 10;
    let last = performance.now();
    let ticks = 0;
    $6ffe9515611cb489$export$13251e0fc79284e(()=>{
        ticks += 1;
        if (ticks >= every) {
            const now = performance.now();
            const diff = now - last;
            fps.value = Math.round(1e3 / (diff / ticks));
            last = now;
            ticks = 0;
        }
    });
    return fps;
}
const $6ffe9515611cb489$var$eventHandlers = [
    "fullscreenchange",
    "webkitfullscreenchange",
    "webkitendfullscreen",
    "mozfullscreenchange",
    "MSFullscreenChange"
];
function $6ffe9515611cb489$export$873ff9d3a24fe223(target, options = {}) {
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, autoExit: autoExit = false } = options;
    const targetRef = (0, $01W3b.computed)(()=>{
        var _a;
        return (_a = $6ffe9515611cb489$export$c61124d3cf5adbae(target)) != null ? _a : document1 == null ? void 0 : document1.querySelector("html");
    });
    const isFullscreen = (0, $01W3b.ref)(false);
    const requestMethod = (0, $01W3b.computed)(()=>{
        return [
            "requestFullscreen",
            "webkitRequestFullscreen",
            "webkitEnterFullscreen",
            "webkitEnterFullScreen",
            "webkitRequestFullScreen",
            "mozRequestFullScreen",
            "msRequestFullscreen"
        ].find((m)=>document1 && m in document1 || targetRef.value && m in targetRef.value);
    });
    const exitMethod = (0, $01W3b.computed)(()=>{
        return [
            "exitFullscreen",
            "webkitExitFullscreen",
            "webkitExitFullScreen",
            "webkitCancelFullScreen",
            "mozCancelFullScreen",
            "msExitFullscreen"
        ].find((m)=>document1 && m in document1 || targetRef.value && m in targetRef.value);
    });
    const fullscreenEnabled = (0, $01W3b.computed)(()=>{
        return [
            "fullScreen",
            "webkitIsFullScreen",
            "webkitDisplayingFullscreen",
            "mozFullScreen",
            "msFullscreenElement"
        ].find((m)=>document1 && m in document1 || targetRef.value && m in targetRef.value);
    });
    const fullscreenElementMethod = [
        "fullscreenElement",
        "webkitFullscreenElement",
        "mozFullScreenElement",
        "msFullscreenElement"
    ].find((m)=>document1 && m in document1);
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>targetRef.value && document1 && requestMethod.value !== void 0 && exitMethod.value !== void 0 && fullscreenEnabled.value !== void 0);
    const isCurrentElementFullScreen = ()=>{
        if (fullscreenElementMethod) return (document1 == null ? void 0 : document1[fullscreenElementMethod]) === targetRef.value;
        return false;
    };
    const isElementFullScreen = ()=>{
        if (fullscreenEnabled.value) {
            if (document1 && document1[fullscreenEnabled.value] != null) return document1[fullscreenEnabled.value];
            else {
                const target2 = targetRef.value;
                if ((target2 == null ? void 0 : target2[fullscreenEnabled.value]) != null) return Boolean(target2[fullscreenEnabled.value]);
            }
        }
        return false;
    };
    async function exit() {
        if (!isSupported.value || !isFullscreen.value) return;
        if (exitMethod.value) {
            if ((document1 == null ? void 0 : document1[exitMethod.value]) != null) await document1[exitMethod.value]();
            else {
                const target2 = targetRef.value;
                if ((target2 == null ? void 0 : target2[exitMethod.value]) != null) await target2[exitMethod.value]();
            }
        }
        isFullscreen.value = false;
    }
    async function enter() {
        if (!isSupported.value || isFullscreen.value) return;
        if (isElementFullScreen()) await exit();
        const target2 = targetRef.value;
        if (requestMethod.value && (target2 == null ? void 0 : target2[requestMethod.value]) != null) {
            await target2[requestMethod.value]();
            isFullscreen.value = true;
        }
    }
    async function toggle() {
        await (isFullscreen.value ? exit() : enter());
    }
    const handlerCallback = ()=>{
        const isElementFullScreenValue = isElementFullScreen();
        if (!isElementFullScreenValue || isElementFullScreenValue && isCurrentElementFullScreen()) isFullscreen.value = isElementFullScreenValue;
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab(document1, $6ffe9515611cb489$var$eventHandlers, handlerCallback, false);
    $6ffe9515611cb489$export$7080b3e976bc91ab(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(targetRef), $6ffe9515611cb489$var$eventHandlers, handlerCallback, false);
    if (autoExit) (0, $AHHxt.tryOnScopeDispose)(exit);
    return {
        isSupported: isSupported,
        isFullscreen: isFullscreen,
        enter: enter,
        exit: exit,
        toggle: toggle
    };
}
function $6ffe9515611cb489$export$9688e62b453d9aed(gamepad) {
    return (0, $01W3b.computed)(()=>{
        if (gamepad.value) return {
            buttons: {
                a: gamepad.value.buttons[0],
                b: gamepad.value.buttons[1],
                x: gamepad.value.buttons[2],
                y: gamepad.value.buttons[3]
            },
            bumper: {
                left: gamepad.value.buttons[4],
                right: gamepad.value.buttons[5]
            },
            triggers: {
                left: gamepad.value.buttons[6],
                right: gamepad.value.buttons[7]
            },
            stick: {
                left: {
                    horizontal: gamepad.value.axes[0],
                    vertical: gamepad.value.axes[1],
                    button: gamepad.value.buttons[10]
                },
                right: {
                    horizontal: gamepad.value.axes[2],
                    vertical: gamepad.value.axes[3],
                    button: gamepad.value.buttons[11]
                }
            },
            dpad: {
                up: gamepad.value.buttons[12],
                down: gamepad.value.buttons[13],
                left: gamepad.value.buttons[14],
                right: gamepad.value.buttons[15]
            },
            back: gamepad.value.buttons[8],
            start: gamepad.value.buttons[9]
        };
        return null;
    });
}
function $6ffe9515611cb489$export$467a9d70edd1fd69(options = {}) {
    const { navigator: navigator = $6ffe9515611cb489$export$eade61489f57e3fc } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator && "getGamepads" in navigator);
    const gamepads = (0, $01W3b.ref)([]);
    const onConnectedHook = (0, $AHHxt.createEventHook)();
    const onDisconnectedHook = (0, $AHHxt.createEventHook)();
    const stateFromGamepad = (gamepad)=>{
        const hapticActuators = [];
        const vibrationActuator = "vibrationActuator" in gamepad ? gamepad.vibrationActuator : null;
        if (vibrationActuator) hapticActuators.push(vibrationActuator);
        if (gamepad.hapticActuators) hapticActuators.push(...gamepad.hapticActuators);
        return {
            ...gamepad,
            id: gamepad.id,
            hapticActuators: hapticActuators,
            axes: gamepad.axes.map((axes)=>axes),
            buttons: gamepad.buttons.map((button)=>({
                    pressed: button.pressed,
                    touched: button.touched,
                    value: button.value
                })),
            index: gamepad.index
        };
    };
    const updateGamepadState = ()=>{
        const _gamepads = (navigator == null ? void 0 : navigator.getGamepads()) || [];
        for (const gamepad of _gamepads)if (gamepad && gamepads.value[gamepad.index]) gamepads.value[gamepad.index] = stateFromGamepad(gamepad);
    };
    const { isActive: isActive, pause: pause, resume: resume } = $6ffe9515611cb489$export$13251e0fc79284e(updateGamepadState);
    const onGamepadConnected = (gamepad)=>{
        if (!gamepads.value.some(({ index: index })=>index === gamepad.index)) {
            gamepads.value.push(stateFromGamepad(gamepad));
            onConnectedHook.trigger(gamepad.index);
        }
        resume();
    };
    const onGamepadDisconnected = (gamepad)=>{
        gamepads.value = gamepads.value.filter((x)=>x.index !== gamepad.index);
        onDisconnectedHook.trigger(gamepad.index);
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab("gamepadconnected", (e)=>onGamepadConnected(e.gamepad));
    $6ffe9515611cb489$export$7080b3e976bc91ab("gamepaddisconnected", (e)=>onGamepadDisconnected(e.gamepad));
    (0, $AHHxt.tryOnMounted)(()=>{
        const _gamepads = (navigator == null ? void 0 : navigator.getGamepads()) || [];
        for (const gamepad of _gamepads)if (gamepad && gamepads.value[gamepad.index]) onGamepadConnected(gamepad);
    });
    pause();
    return {
        isSupported: isSupported,
        onConnected: onConnectedHook.on,
        onDisconnected: onDisconnectedHook.on,
        gamepads: gamepads,
        pause: pause,
        resume: resume,
        isActive: isActive
    };
}
function $6ffe9515611cb489$export$8c959c84e890409a(options = {}) {
    const { enableHighAccuracy: enableHighAccuracy = true, maximumAge: maximumAge = 3e4, timeout: timeout = 27e3, navigator: navigator = $6ffe9515611cb489$export$eade61489f57e3fc, immediate: immediate = true } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator && "geolocation" in navigator);
    const locatedAt = (0, $01W3b.ref)(null);
    const error = (0, $01W3b.shallowRef)(null);
    const coords = (0, $01W3b.ref)({
        accuracy: 0,
        latitude: Number.POSITIVE_INFINITY,
        longitude: Number.POSITIVE_INFINITY,
        altitude: null,
        altitudeAccuracy: null,
        heading: null,
        speed: null
    });
    function updatePosition(position) {
        locatedAt.value = position.timestamp;
        coords.value = position.coords;
        error.value = null;
    }
    let watcher;
    function resume() {
        if (isSupported.value) watcher = navigator.geolocation.watchPosition(updatePosition, (err)=>error.value = err, {
            enableHighAccuracy: enableHighAccuracy,
            maximumAge: maximumAge,
            timeout: timeout
        });
    }
    if (immediate) resume();
    function pause() {
        if (watcher && navigator) navigator.geolocation.clearWatch(watcher);
    }
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        pause();
    });
    return {
        isSupported: isSupported,
        coords: coords,
        locatedAt: locatedAt,
        error: error,
        resume: resume,
        pause: pause
    };
}
const $6ffe9515611cb489$var$defaultEvents$1 = [
    "mousemove",
    "mousedown",
    "resize",
    "keydown",
    "touchstart",
    "wheel"
];
const $6ffe9515611cb489$var$oneMinute = 6e4;
function $6ffe9515611cb489$export$4fed27c116de10cb(timeout = $6ffe9515611cb489$var$oneMinute, options = {}) {
    const { initialState: initialState = false, listenForVisibilityChange: listenForVisibilityChange = true, events: events = $6ffe9515611cb489$var$defaultEvents$1, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, eventFilter: eventFilter = (0, $AHHxt.throttleFilter)(50) } = options;
    const idle = (0, $01W3b.ref)(initialState);
    const lastActive = (0, $01W3b.ref)((0, $AHHxt.timestamp)());
    let timer;
    const reset = ()=>{
        idle.value = false;
        clearTimeout(timer);
        timer = setTimeout(()=>idle.value = true, timeout);
    };
    const onEvent = (0, $AHHxt.createFilterWrapper)(eventFilter, ()=>{
        lastActive.value = (0, $AHHxt.timestamp)();
        reset();
    });
    if (window1) {
        const document1 = window1.document;
        for (const event of events)$6ffe9515611cb489$export$7080b3e976bc91ab(window1, event, onEvent, {
            passive: true
        });
        if (listenForVisibilityChange) $6ffe9515611cb489$export$7080b3e976bc91ab(document1, "visibilitychange", ()=>{
            if (!document1.hidden) onEvent();
        });
        reset();
    }
    return {
        idle: idle,
        lastActive: lastActive,
        reset: reset
    };
}
async function $6ffe9515611cb489$var$loadImage(options) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        const { src: src, srcset: srcset, sizes: sizes, class: clazz, loading: loading, crossorigin: crossorigin, referrerPolicy: referrerPolicy } = options;
        img.src = src;
        if (srcset) img.srcset = srcset;
        if (sizes) img.sizes = sizes;
        if (clazz) img.className = clazz;
        if (loading) img.loading = loading;
        if (crossorigin) img.crossOrigin = crossorigin;
        if (referrerPolicy) img.referrerPolicy = referrerPolicy;
        img.onload = ()=>resolve(img);
        img.onerror = reject;
    });
}
function $6ffe9515611cb489$export$e4da99f09da8b739(options, asyncStateOptions = {}) {
    const state = $6ffe9515611cb489$export$d94717ae0e8aa8b(()=>$6ffe9515611cb489$var$loadImage((0, $AHHxt.toValue)(options)), void 0, {
        resetOnExecute: true,
        ...asyncStateOptions
    });
    (0, $TusQn.watch)(()=>(0, $AHHxt.toValue)(options), ()=>state.execute(asyncStateOptions.delay), {
        deep: true
    });
    return state;
}
const $6ffe9515611cb489$var$ARRIVED_STATE_THRESHOLD_PIXELS = 1;
function $6ffe9515611cb489$export$d928051c8cd740b(element, options = {}) {
    const { throttle: throttle = 0, idle: idle = 200, onStop: onStop = (0, $AHHxt.noop), onScroll: onScroll = (0, $AHHxt.noop), offset: offset = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    }, eventListenerOptions: eventListenerOptions = {
        capture: false,
        passive: true
    }, behavior: behavior = "auto", window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, onError: onError = (e)=>{
        console.error(e);
    } } = options;
    const internalX = (0, $01W3b.ref)(0);
    const internalY = (0, $01W3b.ref)(0);
    const x = (0, $01W3b.computed)({
        get () {
            return internalX.value;
        },
        set (x2) {
            scrollTo1(x2, void 0);
        }
    });
    const y = (0, $01W3b.computed)({
        get () {
            return internalY.value;
        },
        set (y2) {
            scrollTo1(void 0, y2);
        }
    });
    function scrollTo1(_x, _y) {
        var _a, _b, _c;
        if (!window1) return;
        const _element = (0, $AHHxt.toValue)(element);
        if (!_element) return;
        (_c = _element instanceof Document ? window1.document.body : _element) == null || _c.scrollTo({
            top: (_a = (0, $AHHxt.toValue)(_y)) != null ? _a : y.value,
            left: (_b = (0, $AHHxt.toValue)(_x)) != null ? _b : x.value,
            behavior: (0, $AHHxt.toValue)(behavior)
        });
    }
    const isScrolling = (0, $01W3b.ref)(false);
    const arrivedState = (0, $01W3b.reactive)({
        left: true,
        right: false,
        top: true,
        bottom: false
    });
    const directions = (0, $01W3b.reactive)({
        left: false,
        right: false,
        top: false,
        bottom: false
    });
    const onScrollEnd = (e)=>{
        if (!isScrolling.value) return;
        isScrolling.value = false;
        directions.left = false;
        directions.right = false;
        directions.top = false;
        directions.bottom = false;
        onStop(e);
    };
    const onScrollEndDebounced = (0, $AHHxt.useDebounceFn)(onScrollEnd, throttle + idle);
    const setArrivedState = (target)=>{
        var _a;
        if (!window1) return;
        const el = ((_a = target == null ? void 0 : target.document) == null ? void 0 : _a.documentElement) || (target == null ? void 0 : target.documentElement) || $6ffe9515611cb489$export$c61124d3cf5adbae(target);
        const { display: display, flexDirection: flexDirection } = getComputedStyle(el);
        const scrollLeft = el.scrollLeft;
        directions.left = scrollLeft < internalX.value;
        directions.right = scrollLeft > internalX.value;
        const left = Math.abs(scrollLeft) <= (offset.left || 0);
        const right = Math.abs(scrollLeft) + el.clientWidth >= el.scrollWidth - (offset.right || 0) - $6ffe9515611cb489$var$ARRIVED_STATE_THRESHOLD_PIXELS;
        if (display === "flex" && flexDirection === "row-reverse") {
            arrivedState.left = right;
            arrivedState.right = left;
        } else {
            arrivedState.left = left;
            arrivedState.right = right;
        }
        internalX.value = scrollLeft;
        let scrollTop = el.scrollTop;
        if (target === window1.document && !scrollTop) scrollTop = window1.document.body.scrollTop;
        directions.top = scrollTop < internalY.value;
        directions.bottom = scrollTop > internalY.value;
        const top = Math.abs(scrollTop) <= (offset.top || 0);
        const bottom = Math.abs(scrollTop) + el.clientHeight >= el.scrollHeight - (offset.bottom || 0) - $6ffe9515611cb489$var$ARRIVED_STATE_THRESHOLD_PIXELS;
        if (display === "flex" && flexDirection === "column-reverse") {
            arrivedState.top = bottom;
            arrivedState.bottom = top;
        } else {
            arrivedState.top = top;
            arrivedState.bottom = bottom;
        }
        internalY.value = scrollTop;
    };
    const onScrollHandler = (e)=>{
        var _a;
        if (!window1) return;
        const eventTarget = (_a = e.target.documentElement) != null ? _a : e.target;
        setArrivedState(eventTarget);
        isScrolling.value = true;
        onScrollEndDebounced(e);
        onScroll(e);
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab(element, "scroll", throttle ? (0, $AHHxt.useThrottleFn)(onScrollHandler, throttle, true, false) : onScrollHandler, eventListenerOptions);
    (0, $AHHxt.tryOnMounted)(()=>{
        try {
            const _element = (0, $AHHxt.toValue)(element);
            if (!_element) return;
            setArrivedState(_element);
        } catch (e) {
            onError(e);
        }
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(element, "scrollend", onScrollEnd, eventListenerOptions);
    return {
        x: x,
        y: y,
        isScrolling: isScrolling,
        arrivedState: arrivedState,
        directions: directions,
        measure () {
            const _element = (0, $AHHxt.toValue)(element);
            if (window1 && _element) setArrivedState(_element);
        }
    };
}
function $6ffe9515611cb489$var$resolveElement(el) {
    if (typeof Window !== "undefined" && el instanceof Window) return el.document.documentElement;
    if (typeof Document !== "undefined" && el instanceof Document) return el.documentElement;
    return el;
}
function $6ffe9515611cb489$export$a973cef5093a8d22(element, onLoadMore, options = {}) {
    var _a;
    const { direction: direction = "bottom", interval: interval = 100, canLoadMore: canLoadMore = ()=>true } = options;
    const state = (0, $01W3b.reactive)($6ffe9515611cb489$export$d928051c8cd740b(element, {
        ...options,
        offset: {
            [direction]: (_a = options.distance) != null ? _a : 0,
            ...options.offset
        }
    }));
    const promise = (0, $01W3b.ref)();
    const isLoading = (0, $01W3b.computed)(()=>!!promise.value);
    const observedElement = (0, $01W3b.computed)(()=>{
        return $6ffe9515611cb489$var$resolveElement((0, $AHHxt.toValue)(element));
    });
    const isElementVisible = $6ffe9515611cb489$export$6aadc312a449609d(observedElement);
    function checkAndLoad() {
        state.measure();
        if (!observedElement.value || !isElementVisible.value || !canLoadMore(observedElement.value)) return;
        const { scrollHeight: scrollHeight, clientHeight: clientHeight, scrollWidth: scrollWidth, clientWidth: clientWidth } = observedElement.value;
        const isNarrower = direction === "bottom" || direction === "top" ? scrollHeight <= clientHeight : scrollWidth <= clientWidth;
        if (state.arrivedState[direction] || isNarrower) {
            if (!promise.value) promise.value = Promise.all([
                onLoadMore(state),
                new Promise((resolve)=>setTimeout(resolve, interval))
            ]).finally(()=>{
                promise.value = null;
                (0, $TusQn.nextTick)(()=>checkAndLoad());
            });
        }
    }
    (0, $TusQn.watch)(()=>[
            state.arrivedState[direction],
            isElementVisible.value
        ], checkAndLoad, {
        immediate: true
    });
    return {
        isLoading: isLoading
    };
}
const $6ffe9515611cb489$var$defaultEvents = [
    "mousedown",
    "mouseup",
    "keydown",
    "keyup"
];
function $6ffe9515611cb489$export$2056835662f651c4(modifier, options = {}) {
    const { events: events = $6ffe9515611cb489$var$defaultEvents, document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, initial: initial = null } = options;
    const state = (0, $01W3b.ref)(initial);
    if (document1) events.forEach((listenerEvent)=>{
        $6ffe9515611cb489$export$7080b3e976bc91ab(document1, listenerEvent, (evt)=>{
            if (typeof evt.getModifierState === "function") state.value = evt.getModifierState(modifier);
        });
    });
    return state;
}
function $6ffe9515611cb489$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    return $6ffe9515611cb489$export$95809329f49ea9f9(key, initialValue, window1 == null ? void 0 : window1.localStorage, options);
}
const $6ffe9515611cb489$export$73a678c1574e03a3 = {
    ctrl: "control",
    command: "meta",
    cmd: "meta",
    option: "alt",
    up: "arrowup",
    down: "arrowdown",
    left: "arrowleft",
    right: "arrowright"
};
function $6ffe9515611cb489$export$8805bf46e5b1d2e5(options = {}) {
    const { reactive: useReactive = false, target: target = $6ffe9515611cb489$export$16f8ba610718ae4a, aliasMap: aliasMap = $6ffe9515611cb489$export$73a678c1574e03a3, passive: passive = true, onEventFired: onEventFired = (0, $AHHxt.noop) } = options;
    const current = (0, $01W3b.reactive)(/* @__PURE__ */ new Set());
    const obj = {
        toJSON () {
            return {};
        },
        current: current
    };
    const refs = useReactive ? (0, $01W3b.reactive)(obj) : obj;
    const metaDeps = /* @__PURE__ */ new Set();
    const usedKeys = /* @__PURE__ */ new Set();
    function setRefs(key, value) {
        if (key in refs) {
            if (useReactive) refs[key] = value;
            else refs[key].value = value;
        }
    }
    function reset() {
        current.clear();
        for (const key of usedKeys)setRefs(key, false);
    }
    function updateRefs(e, value) {
        var _a, _b;
        const key = (_a = e.key) == null ? void 0 : _a.toLowerCase();
        const code = (_b = e.code) == null ? void 0 : _b.toLowerCase();
        const values = [
            code,
            key
        ].filter(Boolean);
        if (key) {
            if (value) current.add(key);
            else current.delete(key);
        }
        for (const key2 of values){
            usedKeys.add(key2);
            setRefs(key2, value);
        }
        if (key === "meta" && !value) {
            metaDeps.forEach((key2)=>{
                current.delete(key2);
                setRefs(key2, false);
            });
            metaDeps.clear();
        } else if (typeof e.getModifierState === "function" && e.getModifierState("Meta") && value) [
            ...current,
            ...values
        ].forEach((key2)=>metaDeps.add(key2));
    }
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "keydown", (e)=>{
        updateRefs(e, true);
        return onEventFired(e);
    }, {
        passive: passive
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "keyup", (e)=>{
        updateRefs(e, false);
        return onEventFired(e);
    }, {
        passive: passive
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab("blur", reset, {
        passive: true
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab("focus", reset, {
        passive: true
    });
    const proxy = new Proxy(refs, {
        get (target2, prop, rec) {
            if (typeof prop !== "string") return Reflect.get(target2, prop, rec);
            prop = prop.toLowerCase();
            if (prop in aliasMap) prop = aliasMap[prop];
            if (!(prop in refs)) {
                if (/[+_-]/.test(prop)) {
                    const keys = prop.split(/[+_-]/g).map((i)=>i.trim());
                    refs[prop] = (0, $01W3b.computed)(()=>keys.every((key)=>(0, $AHHxt.toValue)(proxy[key])));
                } else refs[prop] = (0, $01W3b.ref)(false);
            }
            const r = Reflect.get(target2, prop, rec);
            return useReactive ? (0, $AHHxt.toValue)(r) : r;
        }
    });
    return proxy;
}
function $6ffe9515611cb489$var$usingElRef(source, cb) {
    if ((0, $AHHxt.toValue)(source)) cb((0, $AHHxt.toValue)(source));
}
function $6ffe9515611cb489$var$timeRangeToArray(timeRanges) {
    let ranges = [];
    for(let i = 0; i < timeRanges.length; ++i)ranges = [
        ...ranges,
        [
            timeRanges.start(i),
            timeRanges.end(i)
        ]
    ];
    return ranges;
}
function $6ffe9515611cb489$var$tracksToArray(tracks) {
    return Array.from(tracks).map(({ label: label, kind: kind, language: language, mode: mode, activeCues: activeCues, cues: cues, inBandMetadataTrackDispatchType: inBandMetadataTrackDispatchType }, id)=>({
            id: id,
            label: label,
            kind: kind,
            language: language,
            mode: mode,
            activeCues: activeCues,
            cues: cues,
            inBandMetadataTrackDispatchType: inBandMetadataTrackDispatchType
        }));
}
const $6ffe9515611cb489$var$defaultOptions = {
    src: "",
    tracks: []
};
function $6ffe9515611cb489$export$4401816799be37c8(target, options = {}) {
    options = {
        ...$6ffe9515611cb489$var$defaultOptions,
        ...options
    };
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    const currentTime = (0, $01W3b.ref)(0);
    const duration = (0, $01W3b.ref)(0);
    const seeking = (0, $01W3b.ref)(false);
    const volume = (0, $01W3b.ref)(1);
    const waiting = (0, $01W3b.ref)(false);
    const ended = (0, $01W3b.ref)(false);
    const playing = (0, $01W3b.ref)(false);
    const rate = (0, $01W3b.ref)(1);
    const stalled = (0, $01W3b.ref)(false);
    const buffered = (0, $01W3b.ref)([]);
    const tracks = (0, $01W3b.ref)([]);
    const selectedTrack = (0, $01W3b.ref)(-1);
    const isPictureInPicture = (0, $01W3b.ref)(false);
    const muted = (0, $01W3b.ref)(false);
    const supportsPictureInPicture = document1 && "pictureInPictureEnabled" in document1;
    const sourceErrorEvent = (0, $AHHxt.createEventHook)();
    const disableTrack = (track)=>{
        $6ffe9515611cb489$var$usingElRef(target, (el)=>{
            if (track) {
                const id = typeof track === "number" ? track : track.id;
                el.textTracks[id].mode = "disabled";
            } else for(let i = 0; i < el.textTracks.length; ++i)el.textTracks[i].mode = "disabled";
            selectedTrack.value = -1;
        });
    };
    const enableTrack = (track, disableTracks = true)=>{
        $6ffe9515611cb489$var$usingElRef(target, (el)=>{
            const id = typeof track === "number" ? track : track.id;
            if (disableTracks) disableTrack();
            el.textTracks[id].mode = "showing";
            selectedTrack.value = id;
        });
    };
    const togglePictureInPicture = ()=>{
        return new Promise((resolve, reject)=>{
            $6ffe9515611cb489$var$usingElRef(target, async (el)=>{
                if (supportsPictureInPicture) {
                    if (!isPictureInPicture.value) el.requestPictureInPicture().then(resolve).catch(reject);
                    else document1.exitPictureInPicture().then(resolve).catch(reject);
                }
            });
        });
    };
    (0, $TusQn.watchEffect)(()=>{
        if (!document1) return;
        const el = (0, $AHHxt.toValue)(target);
        if (!el) return;
        const src = (0, $AHHxt.toValue)(options.src);
        let sources = [];
        if (!src) return;
        if (typeof src === "string") sources = [
            {
                src: src
            }
        ];
        else if (Array.isArray(src)) sources = src;
        else if ((0, $AHHxt.isObject)(src)) sources = [
            src
        ];
        el.querySelectorAll("source").forEach((e)=>{
            e.removeEventListener("error", sourceErrorEvent.trigger);
            e.remove();
        });
        sources.forEach(({ src: src2, type: type })=>{
            const source = document1.createElement("source");
            source.setAttribute("src", src2);
            source.setAttribute("type", type || "");
            source.addEventListener("error", sourceErrorEvent.trigger);
            el.appendChild(source);
        });
        el.load();
    });
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        const el = (0, $AHHxt.toValue)(target);
        if (!el) return;
        el.querySelectorAll("source").forEach((e)=>e.removeEventListener("error", sourceErrorEvent.trigger));
    });
    (0, $TusQn.watch)([
        target,
        volume
    ], ()=>{
        const el = (0, $AHHxt.toValue)(target);
        if (!el) return;
        el.volume = volume.value;
    });
    (0, $TusQn.watch)([
        target,
        muted
    ], ()=>{
        const el = (0, $AHHxt.toValue)(target);
        if (!el) return;
        el.muted = muted.value;
    });
    (0, $TusQn.watch)([
        target,
        rate
    ], ()=>{
        const el = (0, $AHHxt.toValue)(target);
        if (!el) return;
        el.playbackRate = rate.value;
    });
    (0, $TusQn.watchEffect)(()=>{
        if (!document1) return;
        const textTracks = (0, $AHHxt.toValue)(options.tracks);
        const el = (0, $AHHxt.toValue)(target);
        if (!textTracks || !textTracks.length || !el) return;
        el.querySelectorAll("track").forEach((e)=>e.remove());
        textTracks.forEach(({ default: isDefault, kind: kind, label: label, src: src, srcLang: srcLang }, i)=>{
            const track = document1.createElement("track");
            track.default = isDefault || false;
            track.kind = kind;
            track.label = label;
            track.src = src;
            track.srclang = srcLang;
            if (track.default) selectedTrack.value = i;
            el.appendChild(track);
        });
    });
    const { ignoreUpdates: ignoreCurrentTimeUpdates } = (0, $AHHxt.watchIgnorable)(currentTime, (time)=>{
        const el = (0, $AHHxt.toValue)(target);
        if (!el) return;
        el.currentTime = time;
    });
    const { ignoreUpdates: ignorePlayingUpdates } = (0, $AHHxt.watchIgnorable)(playing, (isPlaying)=>{
        const el = (0, $AHHxt.toValue)(target);
        if (!el) return;
        isPlaying ? el.play() : el.pause();
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "timeupdate", ()=>ignoreCurrentTimeUpdates(()=>currentTime.value = (0, $AHHxt.toValue)(target).currentTime));
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "durationchange", ()=>duration.value = (0, $AHHxt.toValue)(target).duration);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "progress", ()=>buffered.value = $6ffe9515611cb489$var$timeRangeToArray((0, $AHHxt.toValue)(target).buffered));
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "seeking", ()=>seeking.value = true);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "seeked", ()=>seeking.value = false);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, [
        "waiting",
        "loadstart"
    ], ()=>{
        waiting.value = true;
        ignorePlayingUpdates(()=>playing.value = false);
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "loadeddata", ()=>waiting.value = false);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "playing", ()=>{
        waiting.value = false;
        ended.value = false;
        ignorePlayingUpdates(()=>playing.value = true);
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "ratechange", ()=>rate.value = (0, $AHHxt.toValue)(target).playbackRate);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "stalled", ()=>stalled.value = true);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "ended", ()=>ended.value = true);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "pause", ()=>ignorePlayingUpdates(()=>playing.value = false));
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "play", ()=>ignorePlayingUpdates(()=>playing.value = true));
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "enterpictureinpicture", ()=>isPictureInPicture.value = true);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "leavepictureinpicture", ()=>isPictureInPicture.value = false);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "volumechange", ()=>{
        const el = (0, $AHHxt.toValue)(target);
        if (!el) return;
        volume.value = el.volume;
        muted.value = el.muted;
    });
    const listeners = [];
    const stop = (0, $TusQn.watch)([
        target
    ], ()=>{
        const el = (0, $AHHxt.toValue)(target);
        if (!el) return;
        stop();
        listeners[0] = $6ffe9515611cb489$export$7080b3e976bc91ab(el.textTracks, "addtrack", ()=>tracks.value = $6ffe9515611cb489$var$tracksToArray(el.textTracks));
        listeners[1] = $6ffe9515611cb489$export$7080b3e976bc91ab(el.textTracks, "removetrack", ()=>tracks.value = $6ffe9515611cb489$var$tracksToArray(el.textTracks));
        listeners[2] = $6ffe9515611cb489$export$7080b3e976bc91ab(el.textTracks, "change", ()=>tracks.value = $6ffe9515611cb489$var$tracksToArray(el.textTracks));
    });
    (0, $AHHxt.tryOnScopeDispose)(()=>listeners.forEach((listener)=>listener()));
    return {
        currentTime: currentTime,
        duration: duration,
        waiting: waiting,
        seeking: seeking,
        ended: ended,
        stalled: stalled,
        buffered: buffered,
        playing: playing,
        rate: rate,
        volume: // Volume
        volume,
        muted: muted,
        tracks: // Tracks
        tracks,
        selectedTrack: selectedTrack,
        enableTrack: enableTrack,
        disableTrack: disableTrack,
        supportsPictureInPicture: // Picture in Picture
        supportsPictureInPicture,
        togglePictureInPicture: togglePictureInPicture,
        isPictureInPicture: isPictureInPicture,
        // Events
        onSourceError: sourceErrorEvent.on
    };
}
function $6ffe9515611cb489$var$getMapVue2Compat() {
    const data = (0, $01W3b.shallowReactive)({});
    return {
        get: (key)=>data[key],
        set: (key, value)=>(0, $keUOA.set)(data, key, value),
        has: (key)=>(0, $AHHxt.hasOwn)(data, key),
        delete: (key)=>(0, $keUOA.del)(data, key),
        clear: ()=>{
            Object.keys(data).forEach((key)=>{
                (0, $keUOA.del)(data, key);
            });
        }
    };
}
function $6ffe9515611cb489$export$7403ef0fca9c6367(resolver, options) {
    const initCache = ()=>{
        if (options == null ? void 0 : options.cache) return (0, $01W3b.shallowReactive)(options.cache);
        if (0, $keUOA.isVue2) return $6ffe9515611cb489$var$getMapVue2Compat();
        return (0, $01W3b.shallowReactive)(/* @__PURE__ */ new Map());
    };
    const cache = initCache();
    const generateKey = (...args)=>(options == null ? void 0 : options.getKey) ? options.getKey(...args) : JSON.stringify(args);
    const _loadData = (key, ...args)=>{
        cache.set(key, resolver(...args));
        return cache.get(key);
    };
    const loadData = (...args)=>_loadData(generateKey(...args), ...args);
    const deleteData = (...args)=>{
        cache.delete(generateKey(...args));
    };
    const clearData = ()=>{
        cache.clear();
    };
    const memoized = (...args)=>{
        const key = generateKey(...args);
        if (cache.has(key)) return cache.get(key);
        return _loadData(key, ...args);
    };
    memoized.load = loadData;
    memoized.delete = deleteData;
    memoized.clear = clearData;
    memoized.generateKey = generateKey;
    memoized.cache = cache;
    return memoized;
}
function $6ffe9515611cb489$export$b1c8a28243292cb9(options = {}) {
    const memory = (0, $01W3b.ref)();
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>typeof performance !== "undefined" && "memory" in performance);
    if (isSupported.value) {
        const { interval: interval = 1e3 } = options;
        (0, $AHHxt.useIntervalFn)(()=>{
            memory.value = performance.memory;
        }, interval, {
            immediate: options.immediate,
            immediateCallback: options.immediateCallback
        });
    }
    return {
        isSupported: isSupported,
        memory: memory
    };
}
const $6ffe9515611cb489$var$UseMouseBuiltinExtractors = {
    page: (event)=>[
            event.pageX,
            event.pageY
        ],
    client: (event)=>[
            event.clientX,
            event.clientY
        ],
    screen: (event)=>[
            event.screenX,
            event.screenY
        ],
    movement: (event)=>event instanceof Touch ? null : [
            event.movementX,
            event.movementY
        ]
};
function $6ffe9515611cb489$export$70811b4970b0f258(options = {}) {
    const { type: type = "page", touch: touch = true, resetOnTouchEnds: resetOnTouchEnds = false, initialValue: initialValue = {
        x: 0,
        y: 0
    }, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, target: target = window1, scroll: scroll = true, eventFilter: eventFilter } = options;
    let _prevMouseEvent = null;
    const x = (0, $01W3b.ref)(initialValue.x);
    const y = (0, $01W3b.ref)(initialValue.y);
    const sourceType = (0, $01W3b.ref)(null);
    const extractor = typeof type === "function" ? type : $6ffe9515611cb489$var$UseMouseBuiltinExtractors[type];
    const mouseHandler = (event)=>{
        const result = extractor(event);
        _prevMouseEvent = event;
        if (result) {
            [x.value, y.value] = result;
            sourceType.value = "mouse";
        }
    };
    const touchHandler = (event)=>{
        if (event.touches.length > 0) {
            const result = extractor(event.touches[0]);
            if (result) {
                [x.value, y.value] = result;
                sourceType.value = "touch";
            }
        }
    };
    const scrollHandler = ()=>{
        if (!_prevMouseEvent || !window1) return;
        const pos = extractor(_prevMouseEvent);
        if (_prevMouseEvent instanceof MouseEvent && pos) {
            x.value = pos[0] + window1.scrollX;
            y.value = pos[1] + window1.scrollY;
        }
    };
    const reset = ()=>{
        x.value = initialValue.x;
        y.value = initialValue.y;
    };
    const mouseHandlerWrapper = eventFilter ? (event)=>eventFilter(()=>mouseHandler(event), {}) : (event)=>mouseHandler(event);
    const touchHandlerWrapper = eventFilter ? (event)=>eventFilter(()=>touchHandler(event), {}) : (event)=>touchHandler(event);
    const scrollHandlerWrapper = eventFilter ? ()=>eventFilter(()=>scrollHandler(), {}) : ()=>scrollHandler();
    if (target) {
        const listenerOptions = {
            passive: true
        };
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, [
            "mousemove",
            "dragover"
        ], mouseHandlerWrapper, listenerOptions);
        if (touch && type !== "movement") {
            $6ffe9515611cb489$export$7080b3e976bc91ab(target, [
                "touchstart",
                "touchmove"
            ], touchHandlerWrapper, listenerOptions);
            if (resetOnTouchEnds) $6ffe9515611cb489$export$7080b3e976bc91ab(target, "touchend", reset, listenerOptions);
        }
        if (scroll && type === "page") $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "scroll", scrollHandlerWrapper, {
            passive: true
        });
    }
    return {
        x: x,
        y: y,
        sourceType: sourceType
    };
}
function $6ffe9515611cb489$export$74acb291b8ceb4b8(target, options = {}) {
    const { handleOutside: handleOutside = true, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const type = options.type || "page";
    const { x: x, y: y, sourceType: sourceType } = $6ffe9515611cb489$export$70811b4970b0f258(options);
    const targetRef = (0, $01W3b.ref)(target != null ? target : window1 == null ? void 0 : window1.document.body);
    const elementX = (0, $01W3b.ref)(0);
    const elementY = (0, $01W3b.ref)(0);
    const elementPositionX = (0, $01W3b.ref)(0);
    const elementPositionY = (0, $01W3b.ref)(0);
    const elementHeight = (0, $01W3b.ref)(0);
    const elementWidth = (0, $01W3b.ref)(0);
    const isOutside = (0, $01W3b.ref)(true);
    let stop = ()=>{};
    if (window1) {
        stop = (0, $TusQn.watch)([
            targetRef,
            x,
            y
        ], ()=>{
            const el = $6ffe9515611cb489$export$c61124d3cf5adbae(targetRef);
            if (!el) return;
            const { left: left, top: top, width: width, height: height } = el.getBoundingClientRect();
            elementPositionX.value = left + (type === "page" ? window1.pageXOffset : 0);
            elementPositionY.value = top + (type === "page" ? window1.pageYOffset : 0);
            elementHeight.value = height;
            elementWidth.value = width;
            const elX = x.value - elementPositionX.value;
            const elY = y.value - elementPositionY.value;
            isOutside.value = width === 0 || height === 0 || elX < 0 || elY < 0 || elX > width || elY > height;
            if (handleOutside || !isOutside.value) {
                elementX.value = elX;
                elementY.value = elY;
            }
        }, {
            immediate: true
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(document, "mouseleave", ()=>{
            isOutside.value = true;
        });
    }
    return {
        x: x,
        y: y,
        sourceType: sourceType,
        elementX: elementX,
        elementY: elementY,
        elementPositionX: elementPositionX,
        elementPositionY: elementPositionY,
        elementHeight: elementHeight,
        elementWidth: elementWidth,
        isOutside: isOutside,
        stop: stop
    };
}
function $6ffe9515611cb489$export$5d7a2a40c559277c(options = {}) {
    const { touch: touch = true, drag: drag = true, capture: capture = false, initialValue: initialValue = false, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const pressed = (0, $01W3b.ref)(initialValue);
    const sourceType = (0, $01W3b.ref)(null);
    if (!window1) return {
        pressed: pressed,
        sourceType: sourceType
    };
    const onPressed = (srcType)=>()=>{
            pressed.value = true;
            sourceType.value = srcType;
        };
    const onReleased = ()=>{
        pressed.value = false;
        sourceType.value = null;
    };
    const target = (0, $01W3b.computed)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(options.target) || window1);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "mousedown", onPressed("mouse"), {
        passive: true,
        capture: capture
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "mouseleave", onReleased, {
        passive: true,
        capture: capture
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "mouseup", onReleased, {
        passive: true,
        capture: capture
    });
    if (drag) {
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "dragstart", onPressed("mouse"), {
            passive: true,
            capture: capture
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "drop", onReleased, {
            passive: true,
            capture: capture
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "dragend", onReleased, {
            passive: true,
            capture: capture
        });
    }
    if (touch) {
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "touchstart", onPressed("touch"), {
            passive: true,
            capture: capture
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "touchend", onReleased, {
            passive: true,
            capture: capture
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "touchcancel", onReleased, {
            passive: true,
            capture: capture
        });
    }
    return {
        pressed: pressed,
        sourceType: sourceType
    };
}
function $6ffe9515611cb489$export$64fd3a716d6bb70f(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const navigator = window1 == null ? void 0 : window1.navigator;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator && "language" in navigator);
    const language = (0, $01W3b.ref)(navigator == null ? void 0 : navigator.language);
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "languagechange", ()=>{
        if (navigator) language.value = navigator.language;
    });
    return {
        isSupported: isSupported,
        language: language
    };
}
function $6ffe9515611cb489$export$553aaf59afc1a2d8(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const navigator = window1 == null ? void 0 : window1.navigator;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator && "connection" in navigator);
    const isOnline = (0, $01W3b.ref)(true);
    const saveData = (0, $01W3b.ref)(false);
    const offlineAt = (0, $01W3b.ref)(void 0);
    const onlineAt = (0, $01W3b.ref)(void 0);
    const downlink = (0, $01W3b.ref)(void 0);
    const downlinkMax = (0, $01W3b.ref)(void 0);
    const rtt = (0, $01W3b.ref)(void 0);
    const effectiveType = (0, $01W3b.ref)(void 0);
    const type = (0, $01W3b.ref)("unknown");
    const connection = isSupported.value && navigator.connection;
    function updateNetworkInformation() {
        if (!navigator) return;
        isOnline.value = navigator.onLine;
        offlineAt.value = isOnline.value ? void 0 : Date.now();
        onlineAt.value = isOnline.value ? Date.now() : void 0;
        if (connection) {
            downlink.value = connection.downlink;
            downlinkMax.value = connection.downlinkMax;
            effectiveType.value = connection.effectiveType;
            rtt.value = connection.rtt;
            saveData.value = connection.saveData;
            type.value = connection.type;
        }
    }
    if (window1) {
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "offline", ()=>{
            isOnline.value = false;
            offlineAt.value = Date.now();
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "online", ()=>{
            isOnline.value = true;
            onlineAt.value = Date.now();
        });
    }
    if (connection) $6ffe9515611cb489$export$7080b3e976bc91ab(connection, "change", updateNetworkInformation, false);
    updateNetworkInformation();
    return {
        isSupported: isSupported,
        isOnline: isOnline,
        saveData: saveData,
        offlineAt: offlineAt,
        onlineAt: onlineAt,
        downlink: downlink,
        downlinkMax: downlinkMax,
        effectiveType: effectiveType,
        rtt: rtt,
        type: type
    };
}
function $6ffe9515611cb489$export$3a404aece3dff2fa(options = {}) {
    const { controls: exposeControls = false, interval: interval = "requestAnimationFrame" } = options;
    const now = (0, $01W3b.ref)(/* @__PURE__ */ new Date());
    const update = ()=>now.value = /* @__PURE__ */ new Date();
    const controls = interval === "requestAnimationFrame" ? $6ffe9515611cb489$export$13251e0fc79284e(update, {
        immediate: true
    }) : (0, $AHHxt.useIntervalFn)(update, interval, {
        immediate: true
    });
    if (exposeControls) return {
        now: now,
        ...controls
    };
    else return now;
}
function $6ffe9515611cb489$export$533619a63360a89b(object) {
    const url = (0, $01W3b.ref)();
    const release = ()=>{
        if (url.value) URL.revokeObjectURL(url.value);
        url.value = void 0;
    };
    (0, $TusQn.watch)(()=>(0, $AHHxt.toValue)(object), (newObject)=>{
        release();
        if (newObject) url.value = URL.createObjectURL(newObject);
    }, {
        immediate: true
    });
    (0, $AHHxt.tryOnScopeDispose)(release);
    return (0, $01W3b.readonly)(url);
}
function $6ffe9515611cb489$var$useClamp(value, min, max) {
    if (typeof value === "function" || (0, $01W3b.isReadonly)(value)) return (0, $01W3b.computed)(()=>(0, $AHHxt.clamp)((0, $AHHxt.toValue)(value), (0, $AHHxt.toValue)(min), (0, $AHHxt.toValue)(max)));
    const _value = (0, $01W3b.ref)(value);
    return (0, $01W3b.computed)({
        get () {
            return _value.value = (0, $AHHxt.clamp)(_value.value, (0, $AHHxt.toValue)(min), (0, $AHHxt.toValue)(max));
        },
        set (value2) {
            _value.value = (0, $AHHxt.clamp)(value2, (0, $AHHxt.toValue)(min), (0, $AHHxt.toValue)(max));
        }
    });
}
function $6ffe9515611cb489$export$dca1841098f618ea(options) {
    const { total: total = Number.POSITIVE_INFINITY, pageSize: pageSize = 10, page: page = 1, onPageChange: onPageChange = (0, $AHHxt.noop), onPageSizeChange: onPageSizeChange = (0, $AHHxt.noop), onPageCountChange: onPageCountChange = (0, $AHHxt.noop) } = options;
    const currentPageSize = $6ffe9515611cb489$var$useClamp(pageSize, 1, Number.POSITIVE_INFINITY);
    const pageCount = (0, $01W3b.computed)(()=>Math.max(1, Math.ceil((0, $AHHxt.toValue)(total) / (0, $AHHxt.toValue)(currentPageSize))));
    const currentPage = $6ffe9515611cb489$var$useClamp(page, 1, pageCount);
    const isFirstPage = (0, $01W3b.computed)(()=>currentPage.value === 1);
    const isLastPage = (0, $01W3b.computed)(()=>currentPage.value === pageCount.value);
    if ((0, $01W3b.isRef)(page)) (0, $AHHxt.syncRef)(page, currentPage, {
        direction: (0, $01W3b.isReadonly)(page) ? "ltr" : "both"
    });
    if ((0, $01W3b.isRef)(pageSize)) (0, $AHHxt.syncRef)(pageSize, currentPageSize, {
        direction: (0, $01W3b.isReadonly)(pageSize) ? "ltr" : "both"
    });
    function prev() {
        currentPage.value--;
    }
    function next() {
        currentPage.value++;
    }
    const returnValue = {
        currentPage: currentPage,
        currentPageSize: currentPageSize,
        pageCount: pageCount,
        isFirstPage: isFirstPage,
        isLastPage: isLastPage,
        prev: prev,
        next: next
    };
    (0, $TusQn.watch)(currentPage, ()=>{
        onPageChange((0, $01W3b.reactive)(returnValue));
    });
    (0, $TusQn.watch)(currentPageSize, ()=>{
        onPageSizeChange((0, $01W3b.reactive)(returnValue));
    });
    (0, $TusQn.watch)(pageCount, ()=>{
        onPageCountChange((0, $01W3b.reactive)(returnValue));
    });
    return returnValue;
}
function $6ffe9515611cb489$export$6feb6ada280bcdab(options = {}) {
    const { isOnline: isOnline } = $6ffe9515611cb489$export$553aaf59afc1a2d8(options);
    return isOnline;
}
function $6ffe9515611cb489$export$6bd1f37e929013e5(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isLeft = (0, $01W3b.ref)(false);
    const handler = (event)=>{
        if (!window1) return;
        event = event || window1.event;
        const from = event.relatedTarget || event.toElement;
        isLeft.value = !from;
    };
    if (window1) {
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "mouseout", handler, {
            passive: true
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1.document, "mouseleave", handler, {
            passive: true
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1.document, "mouseenter", handler, {
            passive: true
        });
    }
    return isLeft;
}
function $6ffe9515611cb489$export$588695585364abce(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "screen" in window1 && "orientation" in window1.screen);
    const screenOrientation = isSupported.value ? window1.screen.orientation : {};
    const orientation = (0, $01W3b.ref)(screenOrientation.type);
    const angle = (0, $01W3b.ref)(screenOrientation.angle || 0);
    if (isSupported.value) $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "orientationchange", ()=>{
        orientation.value = screenOrientation.type;
        angle.value = screenOrientation.angle;
    });
    const lockOrientation = (type)=>{
        if (isSupported.value && typeof screenOrientation.lock === "function") return screenOrientation.lock(type);
        return Promise.reject(new Error("Not supported"));
    };
    const unlockOrientation = ()=>{
        if (isSupported.value && typeof screenOrientation.unlock === "function") screenOrientation.unlock();
    };
    return {
        isSupported: isSupported,
        orientation: orientation,
        angle: angle,
        lockOrientation: lockOrientation,
        unlockOrientation: unlockOrientation
    };
}
function $6ffe9515611cb489$export$78dabaa73e04c89f(target, options = {}) {
    const { deviceOrientationTiltAdjust: deviceOrientationTiltAdjust = (i)=>i, deviceOrientationRollAdjust: deviceOrientationRollAdjust = (i)=>i, mouseTiltAdjust: mouseTiltAdjust = (i)=>i, mouseRollAdjust: mouseRollAdjust = (i)=>i, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const orientation = (0, $01W3b.reactive)($6ffe9515611cb489$export$9bafe4f626b63a33({
        window: window1
    }));
    const screenOrientation = (0, $01W3b.reactive)($6ffe9515611cb489$export$588695585364abce({
        window: window1
    }));
    const { elementX: x, elementY: y, elementWidth: width, elementHeight: height } = $6ffe9515611cb489$export$74acb291b8ceb4b8(target, {
        handleOutside: false,
        window: window1
    });
    const source = (0, $01W3b.computed)(()=>{
        if (orientation.isSupported && (orientation.alpha != null && orientation.alpha !== 0 || orientation.gamma != null && orientation.gamma !== 0)) return "deviceOrientation";
        return "mouse";
    });
    const roll = (0, $01W3b.computed)(()=>{
        if (source.value === "deviceOrientation") {
            let value;
            switch(screenOrientation.orientation){
                case "landscape-primary":
                    value = orientation.gamma / 90;
                    break;
                case "landscape-secondary":
                    value = -orientation.gamma / 90;
                    break;
                case "portrait-primary":
                    value = -orientation.beta / 90;
                    break;
                case "portrait-secondary":
                    value = orientation.beta / 90;
                    break;
                default:
                    value = -orientation.beta / 90;
            }
            return deviceOrientationRollAdjust(value);
        } else {
            const value = -(y.value - height.value / 2) / height.value;
            return mouseRollAdjust(value);
        }
    });
    const tilt = (0, $01W3b.computed)(()=>{
        if (source.value === "deviceOrientation") {
            let value;
            switch(screenOrientation.orientation){
                case "landscape-primary":
                    value = orientation.beta / 90;
                    break;
                case "landscape-secondary":
                    value = -orientation.beta / 90;
                    break;
                case "portrait-primary":
                    value = orientation.gamma / 90;
                    break;
                case "portrait-secondary":
                    value = -orientation.gamma / 90;
                    break;
                default:
                    value = orientation.gamma / 90;
            }
            return deviceOrientationTiltAdjust(value);
        } else {
            const value = (x.value - width.value / 2) / width.value;
            return mouseTiltAdjust(value);
        }
    });
    return {
        roll: roll,
        tilt: tilt,
        source: source
    };
}
function $6ffe9515611cb489$export$868ba98d0a4efc6f(element = $6ffe9515611cb489$export$8d937a32bc2b31dd()) {
    const parentElement = (0, $01W3b.shallowRef)();
    const update = ()=>{
        const el = $6ffe9515611cb489$export$c61124d3cf5adbae(element);
        if (el) parentElement.value = el.parentElement;
    };
    (0, $AHHxt.tryOnMounted)(update);
    (0, $TusQn.watch)(()=>(0, $AHHxt.toValue)(element), update);
    return parentElement;
}
function $6ffe9515611cb489$export$d3d061a08d0fe848(options, callback) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, immediate: immediate = true, ...performanceOptions } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "PerformanceObserver" in window1);
    let observer;
    const stop = ()=>{
        observer == null || observer.disconnect();
    };
    const start = ()=>{
        if (isSupported.value) {
            stop();
            observer = new PerformanceObserver(callback);
            observer.observe(performanceOptions);
        }
    };
    (0, $AHHxt.tryOnScopeDispose)(stop);
    if (immediate) start();
    return {
        isSupported: isSupported,
        start: start,
        stop: stop
    };
}
const $6ffe9515611cb489$var$defaultState = {
    x: 0,
    y: 0,
    pointerId: 0,
    pressure: 0,
    tiltX: 0,
    tiltY: 0,
    width: 0,
    height: 0,
    twist: 0,
    pointerType: null
};
const $6ffe9515611cb489$var$keys = /* @__PURE__ */ Object.keys($6ffe9515611cb489$var$defaultState);
function $6ffe9515611cb489$export$a6d851f32526772(options = {}) {
    const { target: target = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isInside = (0, $01W3b.ref)(false);
    const state = (0, $01W3b.ref)(options.initialValue || {});
    Object.assign(state.value, $6ffe9515611cb489$var$defaultState, state.value);
    const handler = (event)=>{
        isInside.value = true;
        if (options.pointerTypes && !options.pointerTypes.includes(event.pointerType)) return;
        state.value = (0, $AHHxt.objectPick)(event, $6ffe9515611cb489$var$keys, false);
    };
    if (target) {
        const listenerOptions = {
            passive: true
        };
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, [
            "pointerdown",
            "pointermove",
            "pointerup"
        ], handler, listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "pointerleave", ()=>isInside.value = false, listenerOptions);
    }
    return {
        ...(0, $AHHxt.toRefs)(state),
        isInside: isInside
    };
}
function $6ffe9515611cb489$export$fc4b89f039a97947(target, options = {}) {
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>document1 && "pointerLockElement" in document1);
    const element = (0, $01W3b.ref)();
    const triggerElement = (0, $01W3b.ref)();
    let targetElement;
    if (isSupported.value) {
        $6ffe9515611cb489$export$7080b3e976bc91ab(document1, "pointerlockchange", ()=>{
            var _a;
            const currentElement = (_a = document1.pointerLockElement) != null ? _a : element.value;
            if (targetElement && currentElement === targetElement) {
                element.value = document1.pointerLockElement;
                if (!element.value) targetElement = triggerElement.value = null;
            }
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(document1, "pointerlockerror", ()=>{
            var _a;
            const currentElement = (_a = document1.pointerLockElement) != null ? _a : element.value;
            if (targetElement && currentElement === targetElement) {
                const action = document1.pointerLockElement ? "release" : "acquire";
                throw new Error(`Failed to ${action} pointer lock.`);
            }
        });
    }
    async function lock(e) {
        var _a;
        if (!isSupported.value) throw new Error("Pointer Lock API is not supported by your browser.");
        triggerElement.value = e instanceof Event ? e.currentTarget : null;
        targetElement = e instanceof Event ? (_a = $6ffe9515611cb489$export$c61124d3cf5adbae(target)) != null ? _a : triggerElement.value : $6ffe9515611cb489$export$c61124d3cf5adbae(e);
        if (!targetElement) throw new Error("Target element undefined.");
        targetElement.requestPointerLock();
        return await (0, $AHHxt.until)(element).toBe(targetElement);
    }
    async function unlock() {
        if (!element.value) return false;
        document1.exitPointerLock();
        await (0, $AHHxt.until)(element).toBeNull();
        return true;
    }
    return {
        isSupported: isSupported,
        element: element,
        triggerElement: triggerElement,
        lock: lock,
        unlock: unlock
    };
}
function $6ffe9515611cb489$export$abaee32ee49963c1(target, options = {}) {
    const targetRef = (0, $AHHxt.toRef)(target);
    const { threshold: threshold = 50, onSwipe: onSwipe, onSwipeEnd: onSwipeEnd, onSwipeStart: onSwipeStart, disableTextSelect: disableTextSelect = false } = options;
    const posStart = (0, $01W3b.reactive)({
        x: 0,
        y: 0
    });
    const updatePosStart = (x, y)=>{
        posStart.x = x;
        posStart.y = y;
    };
    const posEnd = (0, $01W3b.reactive)({
        x: 0,
        y: 0
    });
    const updatePosEnd = (x, y)=>{
        posEnd.x = x;
        posEnd.y = y;
    };
    const distanceX = (0, $01W3b.computed)(()=>posStart.x - posEnd.x);
    const distanceY = (0, $01W3b.computed)(()=>posStart.y - posEnd.y);
    const { max: max, abs: abs } = Math;
    const isThresholdExceeded = (0, $01W3b.computed)(()=>max(abs(distanceX.value), abs(distanceY.value)) >= threshold);
    const isSwiping = (0, $01W3b.ref)(false);
    const isPointerDown = (0, $01W3b.ref)(false);
    const direction = (0, $01W3b.computed)(()=>{
        if (!isThresholdExceeded.value) return "none";
        if (abs(distanceX.value) > abs(distanceY.value)) return distanceX.value > 0 ? "left" : "right";
        else return distanceY.value > 0 ? "up" : "down";
    });
    const eventIsAllowed = (e)=>{
        var _a, _b, _c;
        const isReleasingButton = e.buttons === 0;
        const isPrimaryButton = e.buttons === 1;
        return (_c = (_b = (_a = options.pointerTypes) == null ? void 0 : _a.includes(e.pointerType)) != null ? _b : isReleasingButton || isPrimaryButton) != null ? _c : true;
    };
    const stops = [
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "pointerdown", (e)=>{
            if (!eventIsAllowed(e)) return;
            isPointerDown.value = true;
            const eventTarget = e.target;
            eventTarget == null || eventTarget.setPointerCapture(e.pointerId);
            const { clientX: x, clientY: y } = e;
            updatePosStart(x, y);
            updatePosEnd(x, y);
            onSwipeStart == null || onSwipeStart(e);
        }),
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "pointermove", (e)=>{
            if (!eventIsAllowed(e)) return;
            if (!isPointerDown.value) return;
            const { clientX: x, clientY: y } = e;
            updatePosEnd(x, y);
            if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
            if (isSwiping.value) onSwipe == null || onSwipe(e);
        }),
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "pointerup", (e)=>{
            if (!eventIsAllowed(e)) return;
            if (isSwiping.value) onSwipeEnd == null || onSwipeEnd(e, direction.value);
            isPointerDown.value = false;
            isSwiping.value = false;
        })
    ];
    (0, $AHHxt.tryOnMounted)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        (_b = (_a = targetRef.value) == null ? void 0 : _a.style) == null || _b.setProperty("touch-action", "none");
        if (disableTextSelect) {
            (_d = (_c = targetRef.value) == null ? void 0 : _c.style) == null || _d.setProperty("-webkit-user-select", "none");
            (_f = (_e = targetRef.value) == null ? void 0 : _e.style) == null || _f.setProperty("-ms-user-select", "none");
            (_h = (_g = targetRef.value) == null ? void 0 : _g.style) == null || _h.setProperty("user-select", "none");
        }
    });
    const stop = ()=>stops.forEach((s)=>s());
    return {
        isSwiping: (0, $01W3b.readonly)(isSwiping),
        direction: (0, $01W3b.readonly)(direction),
        posStart: (0, $01W3b.readonly)(posStart),
        posEnd: (0, $01W3b.readonly)(posEnd),
        distanceX: distanceX,
        distanceY: distanceY,
        stop: stop
    };
}
function $6ffe9515611cb489$export$7c3b8f854ca5e941(options) {
    const isLight = $6ffe9515611cb489$export$32d5543ab307c01("(prefers-color-scheme: light)", options);
    const isDark = $6ffe9515611cb489$export$32d5543ab307c01("(prefers-color-scheme: dark)", options);
    return (0, $01W3b.computed)(()=>{
        if (isDark.value) return "dark";
        if (isLight.value) return "light";
        return "no-preference";
    });
}
function $6ffe9515611cb489$export$14fe172294a7a184(options) {
    const isMore = $6ffe9515611cb489$export$32d5543ab307c01("(prefers-contrast: more)", options);
    const isLess = $6ffe9515611cb489$export$32d5543ab307c01("(prefers-contrast: less)", options);
    const isCustom = $6ffe9515611cb489$export$32d5543ab307c01("(prefers-contrast: custom)", options);
    return (0, $01W3b.computed)(()=>{
        if (isMore.value) return "more";
        if (isLess.value) return "less";
        if (isCustom.value) return "custom";
        return "no-preference";
    });
}
function $6ffe9515611cb489$export$408b11bf0000ced3(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    if (!window1) return (0, $01W3b.ref)([
        "en"
    ]);
    const navigator = window1.navigator;
    const value = (0, $01W3b.ref)(navigator.languages);
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "languagechange", ()=>{
        value.value = navigator.languages;
    });
    return value;
}
function $6ffe9515611cb489$export$66a8176c0ff6800c(options) {
    const isReduced = $6ffe9515611cb489$export$32d5543ab307c01("(prefers-reduced-motion: reduce)", options);
    return (0, $01W3b.computed)(()=>{
        if (isReduced.value) return "reduce";
        return "no-preference";
    });
}
function $6ffe9515611cb489$export$5cae361ad82dce8b(value, initialValue) {
    const previous = (0, $01W3b.shallowRef)(initialValue);
    (0, $TusQn.watch)((0, $AHHxt.toRef)(value), (_, oldValue)=>{
        previous.value = oldValue;
    }, {
        flush: "sync"
    });
    return (0, $01W3b.readonly)(previous);
}
const $6ffe9515611cb489$var$topVarName = "--vueuse-safe-area-top";
const $6ffe9515611cb489$var$rightVarName = "--vueuse-safe-area-right";
const $6ffe9515611cb489$var$bottomVarName = "--vueuse-safe-area-bottom";
const $6ffe9515611cb489$var$leftVarName = "--vueuse-safe-area-left";
function $6ffe9515611cb489$export$40dfca171e090791() {
    const top = (0, $01W3b.ref)("");
    const right = (0, $01W3b.ref)("");
    const bottom = (0, $01W3b.ref)("");
    const left = (0, $01W3b.ref)("");
    if (0, $AHHxt.isClient) {
        const topCssVar = $6ffe9515611cb489$export$811e58a9be6ff112($6ffe9515611cb489$var$topVarName);
        const rightCssVar = $6ffe9515611cb489$export$811e58a9be6ff112($6ffe9515611cb489$var$rightVarName);
        const bottomCssVar = $6ffe9515611cb489$export$811e58a9be6ff112($6ffe9515611cb489$var$bottomVarName);
        const leftCssVar = $6ffe9515611cb489$export$811e58a9be6ff112($6ffe9515611cb489$var$leftVarName);
        topCssVar.value = "env(safe-area-inset-top, 0px)";
        rightCssVar.value = "env(safe-area-inset-right, 0px)";
        bottomCssVar.value = "env(safe-area-inset-bottom, 0px)";
        leftCssVar.value = "env(safe-area-inset-left, 0px)";
        update();
        $6ffe9515611cb489$export$7080b3e976bc91ab("resize", (0, $AHHxt.useDebounceFn)(update));
    }
    function update() {
        top.value = $6ffe9515611cb489$var$getValue($6ffe9515611cb489$var$topVarName);
        right.value = $6ffe9515611cb489$var$getValue($6ffe9515611cb489$var$rightVarName);
        bottom.value = $6ffe9515611cb489$var$getValue($6ffe9515611cb489$var$bottomVarName);
        left.value = $6ffe9515611cb489$var$getValue($6ffe9515611cb489$var$leftVarName);
    }
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        update: update
    };
}
function $6ffe9515611cb489$var$getValue(position) {
    return getComputedStyle(document.documentElement).getPropertyValue(position);
}
function $6ffe9515611cb489$export$eac342b7cdc4d8de(src, onLoaded = (0, $AHHxt.noop), options = {}) {
    const { immediate: immediate = true, manual: manual = false, type: type = "text/javascript", async: async = true, crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, noModule: noModule, defer: defer, document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, attrs: attrs = {} } = options;
    const scriptTag = (0, $01W3b.ref)(null);
    let _promise = null;
    const loadScript = (waitForScriptLoad)=>new Promise((resolve, reject)=>{
            const resolveWithElement = (el2)=>{
                scriptTag.value = el2;
                resolve(el2);
                return el2;
            };
            if (!document1) {
                resolve(false);
                return;
            }
            let shouldAppend = false;
            let el = document1.querySelector(`script[src="${(0, $AHHxt.toValue)(src)}"]`);
            if (!el) {
                el = document1.createElement("script");
                el.type = type;
                el.async = async;
                el.src = (0, $AHHxt.toValue)(src);
                if (defer) el.defer = defer;
                if (crossOrigin) el.crossOrigin = crossOrigin;
                if (noModule) el.noModule = noModule;
                if (referrerPolicy) el.referrerPolicy = referrerPolicy;
                Object.entries(attrs).forEach(([name, value])=>el == null ? void 0 : el.setAttribute(name, value));
                shouldAppend = true;
            } else if (el.hasAttribute("data-loaded")) resolveWithElement(el);
            el.addEventListener("error", (event)=>reject(event));
            el.addEventListener("abort", (event)=>reject(event));
            el.addEventListener("load", ()=>{
                el.setAttribute("data-loaded", "true");
                onLoaded(el);
                resolveWithElement(el);
            });
            if (shouldAppend) el = document1.head.appendChild(el);
            if (!waitForScriptLoad) resolveWithElement(el);
        });
    const load = (waitForScriptLoad = true)=>{
        if (!_promise) _promise = loadScript(waitForScriptLoad);
        return _promise;
    };
    const unload = ()=>{
        if (!document1) return;
        _promise = null;
        if (scriptTag.value) scriptTag.value = null;
        const el = document1.querySelector(`script[src="${(0, $AHHxt.toValue)(src)}"]`);
        if (el) document1.head.removeChild(el);
    };
    if (immediate && !manual) (0, $AHHxt.tryOnMounted)(load);
    if (!manual) (0, $AHHxt.tryOnUnmounted)(unload);
    return {
        scriptTag: scriptTag,
        load: load,
        unload: unload
    };
}
function $6ffe9515611cb489$var$checkOverflowScroll(ele) {
    const style = window.getComputedStyle(ele);
    if (style.overflowX === "scroll" || style.overflowY === "scroll" || style.overflowX === "auto" && ele.clientWidth < ele.scrollWidth || style.overflowY === "auto" && ele.clientHeight < ele.scrollHeight) return true;
    else {
        const parent = ele.parentNode;
        if (!parent || parent.tagName === "BODY") return false;
        return $6ffe9515611cb489$var$checkOverflowScroll(parent);
    }
}
function $6ffe9515611cb489$var$preventDefault(rawEvent) {
    const e = rawEvent || window.event;
    const _target = e.target;
    if ($6ffe9515611cb489$var$checkOverflowScroll(_target)) return false;
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
}
const $6ffe9515611cb489$var$elInitialOverflow = /* @__PURE__ */ new WeakMap();
function $6ffe9515611cb489$export$e47ba1b900da5d3b(element, initialState = false) {
    const isLocked = (0, $01W3b.ref)(initialState);
    let stopTouchMoveListener = null;
    (0, $TusQn.watch)((0, $AHHxt.toRef)(element), (el)=>{
        const target = $6ffe9515611cb489$var$resolveElement((0, $AHHxt.toValue)(el));
        if (target) {
            const ele = target;
            if (!$6ffe9515611cb489$var$elInitialOverflow.get(ele)) $6ffe9515611cb489$var$elInitialOverflow.set(ele, ele.style.overflow);
            if (isLocked.value) ele.style.overflow = "hidden";
        }
    }, {
        immediate: true
    });
    const lock = ()=>{
        const el = $6ffe9515611cb489$var$resolveElement((0, $AHHxt.toValue)(element));
        if (!el || isLocked.value) return;
        if (0, $AHHxt.isIOS) stopTouchMoveListener = $6ffe9515611cb489$export$7080b3e976bc91ab(el, "touchmove", (e)=>{
            $6ffe9515611cb489$var$preventDefault(e);
        }, {
            passive: false
        });
        el.style.overflow = "hidden";
        isLocked.value = true;
    };
    const unlock = ()=>{
        var _a;
        const el = $6ffe9515611cb489$var$resolveElement((0, $AHHxt.toValue)(element));
        if (!el || !isLocked.value) return;
        (0, $AHHxt.isIOS) && (stopTouchMoveListener == null || stopTouchMoveListener());
        el.style.overflow = (_a = $6ffe9515611cb489$var$elInitialOverflow.get(el)) != null ? _a : "";
        $6ffe9515611cb489$var$elInitialOverflow.delete(el);
        isLocked.value = false;
    };
    (0, $AHHxt.tryOnScopeDispose)(unlock);
    return (0, $01W3b.computed)({
        get () {
            return isLocked.value;
        },
        set (v) {
            if (v) lock();
            else unlock();
        }
    });
}
function $6ffe9515611cb489$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    return $6ffe9515611cb489$export$95809329f49ea9f9(key, initialValue, window1 == null ? void 0 : window1.sessionStorage, options);
}
function $6ffe9515611cb489$export$96a35531d1008427(shareOptions = {}, options = {}) {
    const { navigator: navigator = $6ffe9515611cb489$export$eade61489f57e3fc } = options;
    const _navigator = navigator;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>_navigator && "canShare" in _navigator);
    const share = async (overrideOptions = {})=>{
        if (isSupported.value) {
            const data = {
                ...(0, $AHHxt.toValue)(shareOptions),
                ...(0, $AHHxt.toValue)(overrideOptions)
            };
            let granted = true;
            if (data.files && _navigator.canShare) granted = _navigator.canShare({
                files: data.files
            });
            if (granted) return _navigator.share(data);
        }
    };
    return {
        isSupported: isSupported,
        share: share
    };
}
const $6ffe9515611cb489$var$defaultSortFn = (source, compareFn)=>source.sort(compareFn);
const $6ffe9515611cb489$var$defaultCompare = (a, b)=>a - b;
function $6ffe9515611cb489$export$a4fc6b60896f06a0(...args) {
    var _a, _b, _c, _d;
    const [source] = args;
    let compareFn = $6ffe9515611cb489$var$defaultCompare;
    let options = {};
    if (args.length === 2) {
        if (typeof args[1] === "object") {
            options = args[1];
            compareFn = (_a = options.compareFn) != null ? _a : $6ffe9515611cb489$var$defaultCompare;
        } else compareFn = (_b = args[1]) != null ? _b : $6ffe9515611cb489$var$defaultCompare;
    } else if (args.length > 2) {
        compareFn = (_c = args[1]) != null ? _c : $6ffe9515611cb489$var$defaultCompare;
        options = (_d = args[2]) != null ? _d : {};
    }
    const { dirty: dirty = false, sortFn: sortFn = $6ffe9515611cb489$var$defaultSortFn } = options;
    if (!dirty) return (0, $01W3b.computed)(()=>sortFn([
            ...(0, $AHHxt.toValue)(source)
        ], compareFn));
    (0, $TusQn.watchEffect)(()=>{
        const result = sortFn((0, $AHHxt.toValue)(source), compareFn);
        if ((0, $01W3b.isRef)(source)) source.value = result;
        else source.splice(0, source.length, ...result);
    });
    return source;
}
function $6ffe9515611cb489$export$b2a8ce41ccd863a1(options = {}) {
    const { interimResults: interimResults = true, continuous: continuous = true, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const lang = (0, $AHHxt.toRef)(options.lang || "en-US");
    const isListening = (0, $01W3b.ref)(false);
    const isFinal = (0, $01W3b.ref)(false);
    const result = (0, $01W3b.ref)("");
    const error = (0, $01W3b.shallowRef)(void 0);
    const toggle = (value = !isListening.value)=>{
        isListening.value = value;
    };
    const start = ()=>{
        isListening.value = true;
    };
    const stop = ()=>{
        isListening.value = false;
    };
    const SpeechRecognition = window1 && (window1.SpeechRecognition || window1.webkitSpeechRecognition);
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>SpeechRecognition);
    let recognition;
    if (isSupported.value) {
        recognition = new SpeechRecognition();
        recognition.continuous = continuous;
        recognition.interimResults = interimResults;
        recognition.lang = (0, $AHHxt.toValue)(lang);
        recognition.onstart = ()=>{
            isFinal.value = false;
        };
        (0, $TusQn.watch)(lang, (lang2)=>{
            if (recognition && !isListening.value) recognition.lang = lang2;
        });
        recognition.onresult = (event)=>{
            const transcript = Array.from(event.results).map((result2)=>{
                isFinal.value = result2.isFinal;
                return result2[0];
            }).map((result2)=>result2.transcript).join("");
            result.value = transcript;
            error.value = void 0;
        };
        recognition.onerror = (event)=>{
            error.value = event;
        };
        recognition.onend = ()=>{
            isListening.value = false;
            recognition.lang = (0, $AHHxt.toValue)(lang);
        };
        (0, $TusQn.watch)(isListening, ()=>{
            if (isListening.value) recognition.start();
            else recognition.stop();
        });
    }
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        isListening.value = false;
    });
    return {
        isSupported: isSupported,
        isListening: isListening,
        isFinal: isFinal,
        recognition: recognition,
        result: result,
        error: error,
        toggle: toggle,
        start: start,
        stop: stop
    };
}
function $6ffe9515611cb489$export$44e311196d9d3623(text, options = {}) {
    const { pitch: pitch = 1, rate: rate = 1, volume: volume = 1, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const synth = window1 && window1.speechSynthesis;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>synth);
    const isPlaying = (0, $01W3b.ref)(false);
    const status = (0, $01W3b.ref)("init");
    const spokenText = (0, $AHHxt.toRef)(text || "");
    const lang = (0, $AHHxt.toRef)(options.lang || "en-US");
    const error = (0, $01W3b.shallowRef)(void 0);
    const toggle = (value = !isPlaying.value)=>{
        isPlaying.value = value;
    };
    const bindEventsForUtterance = (utterance2)=>{
        utterance2.lang = (0, $AHHxt.toValue)(lang);
        utterance2.voice = (0, $AHHxt.toValue)(options.voice) || null;
        utterance2.pitch = (0, $AHHxt.toValue)(pitch);
        utterance2.rate = (0, $AHHxt.toValue)(rate);
        utterance2.volume = volume;
        utterance2.onstart = ()=>{
            isPlaying.value = true;
            status.value = "play";
        };
        utterance2.onpause = ()=>{
            isPlaying.value = false;
            status.value = "pause";
        };
        utterance2.onresume = ()=>{
            isPlaying.value = true;
            status.value = "play";
        };
        utterance2.onend = ()=>{
            isPlaying.value = false;
            status.value = "end";
        };
        utterance2.onerror = (event)=>{
            error.value = event;
        };
    };
    const utterance = (0, $01W3b.computed)(()=>{
        isPlaying.value = false;
        status.value = "init";
        const newUtterance = new SpeechSynthesisUtterance(spokenText.value);
        bindEventsForUtterance(newUtterance);
        return newUtterance;
    });
    const speak = ()=>{
        synth.cancel();
        utterance && synth.speak(utterance.value);
    };
    const stop = ()=>{
        synth.cancel();
        isPlaying.value = false;
    };
    if (isSupported.value) {
        bindEventsForUtterance(utterance.value);
        (0, $TusQn.watch)(lang, (lang2)=>{
            if (utterance.value && !isPlaying.value) utterance.value.lang = lang2;
        });
        if (options.voice) (0, $TusQn.watch)(options.voice, ()=>{
            synth.cancel();
        });
        (0, $TusQn.watch)(isPlaying, ()=>{
            if (isPlaying.value) synth.resume();
            else synth.pause();
        });
    }
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        isPlaying.value = false;
    });
    return {
        isSupported: isSupported,
        isPlaying: isPlaying,
        status: status,
        utterance: utterance,
        error: error,
        stop: stop,
        toggle: toggle,
        speak: speak
    };
}
function $6ffe9515611cb489$export$9378619b14945e16(steps, initialStep) {
    const stepsRef = (0, $01W3b.ref)(steps);
    const stepNames = (0, $01W3b.computed)(()=>Array.isArray(stepsRef.value) ? stepsRef.value : Object.keys(stepsRef.value));
    const index = (0, $01W3b.ref)(stepNames.value.indexOf(initialStep != null ? initialStep : stepNames.value[0]));
    const current = (0, $01W3b.computed)(()=>at(index.value));
    const isFirst = (0, $01W3b.computed)(()=>index.value === 0);
    const isLast = (0, $01W3b.computed)(()=>index.value === stepNames.value.length - 1);
    const next = (0, $01W3b.computed)(()=>stepNames.value[index.value + 1]);
    const previous = (0, $01W3b.computed)(()=>stepNames.value[index.value - 1]);
    function at(index2) {
        if (Array.isArray(stepsRef.value)) return stepsRef.value[index2];
        return stepsRef.value[stepNames.value[index2]];
    }
    function get(step) {
        if (!stepNames.value.includes(step)) return;
        return at(stepNames.value.indexOf(step));
    }
    function goTo(step) {
        if (stepNames.value.includes(step)) index.value = stepNames.value.indexOf(step);
    }
    function goToNext() {
        if (isLast.value) return;
        index.value++;
    }
    function goToPrevious() {
        if (isFirst.value) return;
        index.value--;
    }
    function goBackTo(step) {
        if (isAfter(step)) goTo(step);
    }
    function isNext(step) {
        return stepNames.value.indexOf(step) === index.value + 1;
    }
    function isPrevious(step) {
        return stepNames.value.indexOf(step) === index.value - 1;
    }
    function isCurrent(step) {
        return stepNames.value.indexOf(step) === index.value;
    }
    function isBefore(step) {
        return index.value < stepNames.value.indexOf(step);
    }
    function isAfter(step) {
        return index.value > stepNames.value.indexOf(step);
    }
    return {
        steps: stepsRef,
        stepNames: stepNames,
        index: index,
        current: current,
        next: next,
        previous: previous,
        isFirst: isFirst,
        isLast: isLast,
        at: at,
        get: get,
        goTo: goTo,
        goToNext: goToNext,
        goToPrevious: goToPrevious,
        goBackTo: goBackTo,
        isNext: isNext,
        isPrevious: isPrevious,
        isCurrent: isCurrent,
        isBefore: isBefore,
        isAfter: isAfter
    };
}
function $6ffe9515611cb489$export$dd72d4318fe38e17(key, initialValue, storage, options = {}) {
    var _a;
    const { flush: flush = "pre", deep: deep = true, listenToStorageChanges: listenToStorageChanges = true, writeDefaults: writeDefaults = true, mergeDefaults: mergeDefaults = false, shallow: shallow, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, eventFilter: eventFilter, onError: onError = (e)=>{
        console.error(e);
    } } = options;
    const rawInit = (0, $AHHxt.toValue)(initialValue);
    const type = $6ffe9515611cb489$var$guessSerializerType(rawInit);
    const data = (shallow ? (0, $01W3b.shallowRef) : (0, $01W3b.ref))(initialValue);
    const serializer = (_a = options.serializer) != null ? _a : $6ffe9515611cb489$export$8111877b006f9b0b[type];
    if (!storage) try {
        storage = $6ffe9515611cb489$export$b0cf1ae5a98eb83b("getDefaultStorageAsync", ()=>{
            var _a2;
            return (_a2 = $6ffe9515611cb489$export$16f8ba610718ae4a) == null ? void 0 : _a2.localStorage;
        })();
    } catch (e) {
        onError(e);
    }
    async function read(event) {
        if (!storage || event && event.key !== key) return;
        try {
            const rawValue = event ? event.newValue : await storage.getItem(key);
            if (rawValue == null) {
                data.value = rawInit;
                if (writeDefaults && rawInit !== null) await storage.setItem(key, await serializer.write(rawInit));
            } else if (mergeDefaults) {
                const value = await serializer.read(rawValue);
                if (typeof mergeDefaults === "function") data.value = mergeDefaults(value, rawInit);
                else if (type === "object" && !Array.isArray(value)) data.value = {
                    ...rawInit,
                    ...value
                };
                else data.value = value;
            } else data.value = await serializer.read(rawValue);
        } catch (e) {
            onError(e);
        }
    }
    read();
    if (window1 && listenToStorageChanges) $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "storage", (e)=>Promise.resolve().then(()=>read(e)));
    if (storage) (0, $AHHxt.watchWithFilter)(data, async ()=>{
        try {
            if (data.value == null) await storage.removeItem(key);
            else await storage.setItem(key, await serializer.write(data.value));
        } catch (e) {
            onError(e);
        }
    }, {
        flush: flush,
        deep: deep,
        eventFilter: eventFilter
    });
    return data;
}
let $6ffe9515611cb489$var$_id = 0;
function $6ffe9515611cb489$export$c100116e6aa85030(css, options = {}) {
    const isLoaded = (0, $01W3b.ref)(false);
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, immediate: immediate = true, manual: manual = false, id: id = `vueuse_styletag_${++$6ffe9515611cb489$var$_id}` } = options;
    const cssRef = (0, $01W3b.ref)(css);
    let stop = ()=>{};
    const load = ()=>{
        if (!document1) return;
        const el = document1.getElementById(id) || document1.createElement("style");
        if (!el.isConnected) {
            el.id = id;
            if (options.media) el.media = options.media;
            document1.head.appendChild(el);
        }
        if (isLoaded.value) return;
        stop = (0, $TusQn.watch)(cssRef, (value)=>{
            el.textContent = value;
        }, {
            immediate: true
        });
        isLoaded.value = true;
    };
    const unload = ()=>{
        if (!document1 || !isLoaded.value) return;
        stop();
        document1.head.removeChild(document1.getElementById(id));
        isLoaded.value = false;
    };
    if (immediate && !manual) (0, $AHHxt.tryOnMounted)(load);
    if (!manual) (0, $AHHxt.tryOnScopeDispose)(unload);
    return {
        id: id,
        css: cssRef,
        unload: unload,
        load: load,
        isLoaded: (0, $01W3b.readonly)(isLoaded)
    };
}
function $6ffe9515611cb489$export$b57f07e22c950716(target, options = {}) {
    const { threshold: threshold = 50, onSwipe: onSwipe, onSwipeEnd: onSwipeEnd, onSwipeStart: onSwipeStart, passive: passive = true, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const coordsStart = (0, $01W3b.reactive)({
        x: 0,
        y: 0
    });
    const coordsEnd = (0, $01W3b.reactive)({
        x: 0,
        y: 0
    });
    const diffX = (0, $01W3b.computed)(()=>coordsStart.x - coordsEnd.x);
    const diffY = (0, $01W3b.computed)(()=>coordsStart.y - coordsEnd.y);
    const { max: max, abs: abs } = Math;
    const isThresholdExceeded = (0, $01W3b.computed)(()=>max(abs(diffX.value), abs(diffY.value)) >= threshold);
    const isSwiping = (0, $01W3b.ref)(false);
    const direction = (0, $01W3b.computed)(()=>{
        if (!isThresholdExceeded.value) return "none";
        if (abs(diffX.value) > abs(diffY.value)) return diffX.value > 0 ? "left" : "right";
        else return diffY.value > 0 ? "up" : "down";
    });
    const getTouchEventCoords = (e)=>[
            e.touches[0].clientX,
            e.touches[0].clientY
        ];
    const updateCoordsStart = (x, y)=>{
        coordsStart.x = x;
        coordsStart.y = y;
    };
    const updateCoordsEnd = (x, y)=>{
        coordsEnd.x = x;
        coordsEnd.y = y;
    };
    let listenerOptions;
    const isPassiveEventSupported = $6ffe9515611cb489$var$checkPassiveEventSupport(window1 == null ? void 0 : window1.document);
    if (!passive) listenerOptions = isPassiveEventSupported ? {
        passive: false,
        capture: true
    } : {
        capture: true
    };
    else listenerOptions = isPassiveEventSupported ? {
        passive: true
    } : {
        capture: false
    };
    const onTouchEnd = (e)=>{
        if (isSwiping.value) onSwipeEnd == null || onSwipeEnd(e, direction.value);
        isSwiping.value = false;
    };
    const stops = [
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "touchstart", (e)=>{
            if (e.touches.length !== 1) return;
            if (listenerOptions.capture && !listenerOptions.passive) e.preventDefault();
            const [x, y] = getTouchEventCoords(e);
            updateCoordsStart(x, y);
            updateCoordsEnd(x, y);
            onSwipeStart == null || onSwipeStart(e);
        }, listenerOptions),
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "touchmove", (e)=>{
            if (e.touches.length !== 1) return;
            const [x, y] = getTouchEventCoords(e);
            updateCoordsEnd(x, y);
            if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
            if (isSwiping.value) onSwipe == null || onSwipe(e);
        }, listenerOptions),
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, [
            "touchend",
            "touchcancel"
        ], onTouchEnd, listenerOptions)
    ];
    const stop = ()=>stops.forEach((s)=>s());
    return {
        isPassiveEventSupported: isPassiveEventSupported,
        isSwiping: isSwiping,
        direction: direction,
        coordsStart: coordsStart,
        coordsEnd: coordsEnd,
        lengthX: diffX,
        lengthY: diffY,
        stop: stop
    };
}
function $6ffe9515611cb489$var$checkPassiveEventSupport(document1) {
    if (!document1) return false;
    let supportsPassive = false;
    const optionsBlock = {
        get passive () {
            supportsPassive = true;
            return false;
        }
    };
    document1.addEventListener("x", (0, $AHHxt.noop), optionsBlock);
    document1.removeEventListener("x", (0, $AHHxt.noop));
    return supportsPassive;
}
function $6ffe9515611cb489$export$253c1ef7895b3fea() {
    const refs = (0, $01W3b.ref)([]);
    refs.value.set = (el)=>{
        if (el) refs.value.push(el);
    };
    (0, $TusQn.onBeforeUpdate)(()=>{
        refs.value.length = 0;
    });
    return refs;
}
function $6ffe9515611cb489$export$cf24a79f32f45545(options = {}) {
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, selector: selector = "html", observe: observe = false, initialValue: initialValue = "ltr" } = options;
    function getValue() {
        var _a, _b;
        return (_b = (_a = document1 == null ? void 0 : document1.querySelector(selector)) == null ? void 0 : _a.getAttribute("dir")) != null ? _b : initialValue;
    }
    const dir = (0, $01W3b.ref)(getValue());
    (0, $AHHxt.tryOnMounted)(()=>dir.value = getValue());
    if (observe && document1) $6ffe9515611cb489$export$8ecdcf3bb089e9cd(document1.querySelector(selector), ()=>dir.value = getValue(), {
        attributes: true
    });
    return (0, $01W3b.computed)({
        get () {
            return dir.value;
        },
        set (v) {
            var _a, _b;
            dir.value = v;
            if (!document1) return;
            if (dir.value) (_a = document1.querySelector(selector)) == null || _a.setAttribute("dir", dir.value);
            else (_b = document1.querySelector(selector)) == null || _b.removeAttribute("dir");
        }
    });
}
function $6ffe9515611cb489$var$getRangesFromSelection(selection) {
    var _a;
    const rangeCount = (_a = selection.rangeCount) != null ? _a : 0;
    return Array.from({
        length: rangeCount
    }, (_, i)=>selection.getRangeAt(i));
}
function $6ffe9515611cb489$export$9c9cf404b65a1c0a(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const selection = (0, $01W3b.ref)(null);
    const text = (0, $01W3b.computed)(()=>{
        var _a, _b;
        return (_b = (_a = selection.value) == null ? void 0 : _a.toString()) != null ? _b : "";
    });
    const ranges = (0, $01W3b.computed)(()=>selection.value ? $6ffe9515611cb489$var$getRangesFromSelection(selection.value) : []);
    const rects = (0, $01W3b.computed)(()=>ranges.value.map((range)=>range.getBoundingClientRect()));
    function onSelectionChange() {
        selection.value = null;
        if (window1) selection.value = window1.getSelection();
    }
    if (window1) $6ffe9515611cb489$export$7080b3e976bc91ab(window1.document, "selectionchange", onSelectionChange);
    return {
        text: text,
        rects: rects,
        ranges: ranges,
        selection: selection
    };
}
function $6ffe9515611cb489$export$2e9ef3b733cccd07(options) {
    var _a;
    const textarea = (0, $01W3b.ref)(options == null ? void 0 : options.element);
    const input = (0, $01W3b.ref)(options == null ? void 0 : options.input);
    const styleProp = (_a = options == null ? void 0 : options.styleProp) != null ? _a : "height";
    const textareaScrollHeight = (0, $01W3b.ref)(1);
    function triggerResize() {
        var _a2, _b;
        if (!textarea.value) return;
        let height = "";
        textarea.value.style[styleProp] = "1px";
        textareaScrollHeight.value = (_a2 = textarea.value) == null ? void 0 : _a2.scrollHeight;
        if (options == null ? void 0 : options.styleTarget) (0, $AHHxt.toValue)(options.styleTarget).style[styleProp] = `${textareaScrollHeight.value}px`;
        else height = `${textareaScrollHeight.value}px`;
        textarea.value.style[styleProp] = height;
        (_b = options == null ? void 0 : options.onResize) == null || _b.call(options);
    }
    (0, $TusQn.watch)([
        input,
        textarea
    ], ()=>(0, $TusQn.nextTick)(triggerResize), {
        immediate: true
    });
    $6ffe9515611cb489$export$683480f191c0e3ea(textarea, ()=>triggerResize());
    if (options == null ? void 0 : options.watch) (0, $TusQn.watch)(options.watch, triggerResize, {
        immediate: true,
        deep: true
    });
    return {
        textarea: textarea,
        input: input,
        triggerResize: triggerResize
    };
}
function $6ffe9515611cb489$export$55673c2843562e1(source, options = {}) {
    const { throttle: throttle = 200, trailing: trailing = true } = options;
    const filter = (0, $AHHxt.throttleFilter)(throttle, trailing);
    const history = $6ffe9515611cb489$export$de889b39e422efc4(source, {
        ...options,
        eventFilter: filter
    });
    return {
        ...history
    };
}
const $6ffe9515611cb489$var$DEFAULT_UNITS = [
    {
        max: 6e4,
        value: 1e3,
        name: "second"
    },
    {
        max: 276e4,
        value: 6e4,
        name: "minute"
    },
    {
        max: 72e6,
        value: 36e5,
        name: "hour"
    },
    {
        max: 5184e5,
        value: 864e5,
        name: "day"
    },
    {
        max: 24192e5,
        value: 6048e5,
        name: "week"
    },
    {
        max: 28512e6,
        value: 2592e6,
        name: "month"
    },
    {
        max: Number.POSITIVE_INFINITY,
        value: 31536e6,
        name: "year"
    }
];
const $6ffe9515611cb489$var$DEFAULT_MESSAGES = {
    justNow: "just now",
    past: (n)=>n.match(/\d/) ? `${n} ago` : n,
    future: (n)=>n.match(/\d/) ? `in ${n}` : n,
    month: (n, past)=>n === 1 ? past ? "last month" : "next month" : `${n} month${n > 1 ? "s" : ""}`,
    year: (n, past)=>n === 1 ? past ? "last year" : "next year" : `${n} year${n > 1 ? "s" : ""}`,
    day: (n, past)=>n === 1 ? past ? "yesterday" : "tomorrow" : `${n} day${n > 1 ? "s" : ""}`,
    week: (n, past)=>n === 1 ? past ? "last week" : "next week" : `${n} week${n > 1 ? "s" : ""}`,
    hour: (n)=>`${n} hour${n > 1 ? "s" : ""}`,
    minute: (n)=>`${n} minute${n > 1 ? "s" : ""}`,
    second: (n)=>`${n} second${n > 1 ? "s" : ""}`,
    invalid: ""
};
function $6ffe9515611cb489$var$DEFAULT_FORMATTER(date) {
    return date.toISOString().slice(0, 10);
}
function $6ffe9515611cb489$export$1deeb1050525eb40(time, options = {}) {
    const { controls: exposeControls = false, updateInterval: updateInterval = 3e4 } = options;
    const { now: now, ...controls } = $6ffe9515611cb489$export$3a404aece3dff2fa({
        interval: updateInterval,
        controls: true
    });
    const timeAgo = (0, $01W3b.computed)(()=>$6ffe9515611cb489$export$78ae3e68d8c394bc(new Date((0, $AHHxt.toValue)(time)), options, (0, $AHHxt.toValue)(now)));
    if (exposeControls) return {
        timeAgo: timeAgo,
        ...controls
    };
    else return timeAgo;
}
function $6ffe9515611cb489$export$78ae3e68d8c394bc(from, options = {}, now = Date.now()) {
    var _a;
    const { max: max, messages: messages = $6ffe9515611cb489$var$DEFAULT_MESSAGES, fullDateFormatter: fullDateFormatter = $6ffe9515611cb489$var$DEFAULT_FORMATTER, units: units = $6ffe9515611cb489$var$DEFAULT_UNITS, showSecond: showSecond = false, rounding: rounding = "round" } = options;
    const roundFn = typeof rounding === "number" ? (n)=>+n.toFixed(rounding) : Math[rounding];
    const diff = +now - +from;
    const absDiff = Math.abs(diff);
    function getValue(diff2, unit) {
        return roundFn(Math.abs(diff2) / unit.value);
    }
    function format(diff2, unit) {
        const val = getValue(diff2, unit);
        const past = diff2 > 0;
        const str = applyFormat(unit.name, val, past);
        return applyFormat(past ? "past" : "future", str, past);
    }
    function applyFormat(name, val, isPast) {
        const formatter = messages[name];
        if (typeof formatter === "function") return formatter(val, isPast);
        return formatter.replace("{0}", val.toString());
    }
    if (absDiff < 6e4 && !showSecond) return messages.justNow;
    if (typeof max === "number" && absDiff > max) return fullDateFormatter(new Date(from));
    if (typeof max === "string") {
        const unitMax = (_a = units.find((i)=>i.name === max)) == null ? void 0 : _a.max;
        if (unitMax && absDiff > unitMax) return fullDateFormatter(new Date(from));
    }
    for (const [idx, unit] of units.entries()){
        const val = getValue(diff, unit);
        if (val <= 0 && units[idx - 1]) return format(diff, units[idx - 1]);
        if (absDiff < unit.max) return format(diff, unit);
    }
    return messages.invalid;
}
function $6ffe9515611cb489$export$ce370d3d38ed4da0(fn, interval, timeoutPollOptions) {
    const { start: start } = (0, $AHHxt.useTimeoutFn)(loop, interval, {
        immediate: false
    });
    const isActive = (0, $01W3b.ref)(false);
    async function loop() {
        if (!isActive.value) return;
        await fn();
        start();
    }
    function resume() {
        if (!isActive.value) {
            isActive.value = true;
            loop();
        }
    }
    function pause() {
        isActive.value = false;
    }
    if (timeoutPollOptions == null ? void 0 : timeoutPollOptions.immediate) resume();
    (0, $AHHxt.tryOnScopeDispose)(pause);
    return {
        isActive: isActive,
        pause: pause,
        resume: resume
    };
}
function $6ffe9515611cb489$export$c4f6efe9f19a3a66(options = {}) {
    const { controls: exposeControls = false, offset: offset = 0, immediate: immediate = true, interval: interval = "requestAnimationFrame", callback: callback } = options;
    const ts = (0, $01W3b.ref)((0, $AHHxt.timestamp)() + offset);
    const update = ()=>ts.value = (0, $AHHxt.timestamp)() + offset;
    const cb = callback ? ()=>{
        update();
        callback(ts.value);
    } : update;
    const controls = interval === "requestAnimationFrame" ? $6ffe9515611cb489$export$13251e0fc79284e(cb, {
        immediate: immediate
    }) : (0, $AHHxt.useIntervalFn)(cb, interval, {
        immediate: immediate
    });
    if (exposeControls) return {
        timestamp: ts,
        ...controls
    };
    else return ts;
}
function $6ffe9515611cb489$export$bc98e171e8c82a3d(newTitle = null, options = {}) {
    var _a, _b, _c;
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, restoreOnUnmount: restoreOnUnmount = (t)=>t } = options;
    const originalTitle = (_a = document1 == null ? void 0 : document1.title) != null ? _a : "";
    const title = (0, $AHHxt.toRef)((_b = newTitle != null ? newTitle : document1 == null ? void 0 : document1.title) != null ? _b : null);
    const isReadonly = newTitle && typeof newTitle === "function";
    function format(t) {
        if (!("titleTemplate" in options)) return t;
        const template = options.titleTemplate || "%s";
        return typeof template === "function" ? template(t) : (0, $AHHxt.toValue)(template).replace(/%s/g, t);
    }
    (0, $TusQn.watch)(title, (t, o)=>{
        if (t !== o && document1) document1.title = format(typeof t === "string" ? t : "");
    }, {
        immediate: true
    });
    if (options.observe && !options.titleTemplate && document1 && !isReadonly) $6ffe9515611cb489$export$8ecdcf3bb089e9cd((_c = document1.head) == null ? void 0 : _c.querySelector("title"), ()=>{
        if (document1 && document1.title !== title.value) title.value = format(document1.title);
    }, {
        childList: true
    });
    (0, $AHHxt.tryOnBeforeUnmount)(()=>{
        if (restoreOnUnmount) {
            const restoredTitle = restoreOnUnmount(originalTitle, title.value || "");
            if (restoredTitle != null && document1) document1.title = restoredTitle;
        }
    });
    return title;
}
const $6ffe9515611cb489$var$_TransitionPresets = {
    easeInSine: [
        0.12,
        0,
        0.39,
        0
    ],
    easeOutSine: [
        0.61,
        1,
        0.88,
        1
    ],
    easeInOutSine: [
        0.37,
        0,
        0.63,
        1
    ],
    easeInQuad: [
        0.11,
        0,
        0.5,
        0
    ],
    easeOutQuad: [
        0.5,
        1,
        0.89,
        1
    ],
    easeInOutQuad: [
        0.45,
        0,
        0.55,
        1
    ],
    easeInCubic: [
        0.32,
        0,
        0.67,
        0
    ],
    easeOutCubic: [
        0.33,
        1,
        0.68,
        1
    ],
    easeInOutCubic: [
        0.65,
        0,
        0.35,
        1
    ],
    easeInQuart: [
        0.5,
        0,
        0.75,
        0
    ],
    easeOutQuart: [
        0.25,
        1,
        0.5,
        1
    ],
    easeInOutQuart: [
        0.76,
        0,
        0.24,
        1
    ],
    easeInQuint: [
        0.64,
        0,
        0.78,
        0
    ],
    easeOutQuint: [
        0.22,
        1,
        0.36,
        1
    ],
    easeInOutQuint: [
        0.83,
        0,
        0.17,
        1
    ],
    easeInExpo: [
        0.7,
        0,
        0.84,
        0
    ],
    easeOutExpo: [
        0.16,
        1,
        0.3,
        1
    ],
    easeInOutExpo: [
        0.87,
        0,
        0.13,
        1
    ],
    easeInCirc: [
        0.55,
        0,
        1,
        0.45
    ],
    easeOutCirc: [
        0,
        0.55,
        0.45,
        1
    ],
    easeInOutCirc: [
        0.85,
        0,
        0.15,
        1
    ],
    easeInBack: [
        0.36,
        0,
        0.66,
        -0.56
    ],
    easeOutBack: [
        0.34,
        1.56,
        0.64,
        1
    ],
    easeInOutBack: [
        0.68,
        -0.6,
        0.32,
        1.6
    ]
};
const $6ffe9515611cb489$export$a1745a8bb687f918 = /* @__PURE__ */ Object.assign({}, {
    linear: (0, $AHHxt.identity)
}, $6ffe9515611cb489$var$_TransitionPresets);
function $6ffe9515611cb489$var$createEasingFunction([p0, p1, p2, p3]) {
    const a = (a1, a2)=>1 - 3 * a2 + 3 * a1;
    const b = (a1, a2)=>3 * a2 - 6 * a1;
    const c = (a1)=>3 * a1;
    const calcBezier = (t, a1, a2)=>((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
    const getSlope = (t, a1, a2)=>3 * a(a1, a2) * t * t + 2 * b(a1, a2) * t + c(a1);
    const getTforX = (x)=>{
        let aGuessT = x;
        for(let i = 0; i < 4; ++i){
            const currentSlope = getSlope(aGuessT, p0, p2);
            if (currentSlope === 0) return aGuessT;
            const currentX = calcBezier(aGuessT, p0, p2) - x;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    };
    return (x)=>p0 === p1 && p2 === p3 ? x : calcBezier(getTforX(x), p1, p3);
}
function $6ffe9515611cb489$var$lerp(a, b, alpha) {
    return a + alpha * (b - a);
}
function $6ffe9515611cb489$var$toVec(t) {
    return (typeof t === "number" ? [
        t
    ] : t) || [];
}
function $6ffe9515611cb489$export$b82f7b6c1e4d2890(source, from, to, options = {}) {
    var _a, _b;
    const fromVal = (0, $AHHxt.toValue)(from);
    const toVal = (0, $AHHxt.toValue)(to);
    const v1 = $6ffe9515611cb489$var$toVec(fromVal);
    const v2 = $6ffe9515611cb489$var$toVec(toVal);
    const duration = (_a = (0, $AHHxt.toValue)(options.duration)) != null ? _a : 1e3;
    const startedAt = Date.now();
    const endAt = Date.now() + duration;
    const trans = typeof options.transition === "function" ? options.transition : (_b = (0, $AHHxt.toValue)(options.transition)) != null ? _b : (0, $AHHxt.identity);
    const ease = typeof trans === "function" ? trans : $6ffe9515611cb489$var$createEasingFunction(trans);
    return new Promise((resolve)=>{
        source.value = fromVal;
        const tick = ()=>{
            var _a2;
            if ((_a2 = options.abort) == null ? void 0 : _a2.call(options)) {
                resolve();
                return;
            }
            const now = Date.now();
            const alpha = ease((now - startedAt) / duration);
            const arr = $6ffe9515611cb489$var$toVec(source.value).map((n, i)=>$6ffe9515611cb489$var$lerp(v1[i], v2[i], alpha));
            if (Array.isArray(source.value)) source.value = arr.map((n, i)=>{
                var _a3, _b2;
                return $6ffe9515611cb489$var$lerp((_a3 = v1[i]) != null ? _a3 : 0, (_b2 = v2[i]) != null ? _b2 : 0, alpha);
            });
            else if (typeof source.value === "number") source.value = arr[0];
            if (now < endAt) requestAnimationFrame(tick);
            else {
                source.value = toVal;
                resolve();
            }
        };
        tick();
    });
}
function $6ffe9515611cb489$export$7b286972b8d8ccbf(source, options = {}) {
    let currentId = 0;
    const sourceVal = ()=>{
        const v = (0, $AHHxt.toValue)(source);
        return typeof v === "number" ? v : v.map((0, $AHHxt.toValue));
    };
    const outputRef = (0, $01W3b.ref)(sourceVal());
    (0, $TusQn.watch)(sourceVal, async (to)=>{
        var _a, _b;
        if ((0, $AHHxt.toValue)(options.disabled)) return;
        const id = ++currentId;
        if (options.delay) await (0, $AHHxt.promiseTimeout)((0, $AHHxt.toValue)(options.delay));
        if (id !== currentId) return;
        const toVal = Array.isArray(to) ? to.map((0, $AHHxt.toValue)) : (0, $AHHxt.toValue)(to);
        (_a = options.onStarted) == null || _a.call(options);
        await $6ffe9515611cb489$export$b82f7b6c1e4d2890(outputRef, outputRef.value, toVal, {
            ...options,
            abort: ()=>{
                var _a2;
                return id !== currentId || ((_a2 = options.abort) == null ? void 0 : _a2.call(options));
            }
        });
        (_b = options.onFinished) == null || _b.call(options);
    }, {
        deep: true
    });
    (0, $TusQn.watch)(()=>(0, $AHHxt.toValue)(options.disabled), (disabled)=>{
        if (disabled) {
            currentId++;
            outputRef.value = sourceVal();
        }
    });
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        currentId++;
    });
    return (0, $01W3b.computed)(()=>(0, $AHHxt.toValue)(options.disabled) ? sourceVal() : outputRef.value);
}
function $6ffe9515611cb489$export$a64580081d23e3b8(mode = "history", options = {}) {
    const { initialValue: initialValue = {}, removeNullishValues: removeNullishValues = true, removeFalsyValues: removeFalsyValues = false, write: enableWrite = true, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    if (!window1) return (0, $01W3b.reactive)(initialValue);
    const state = (0, $01W3b.reactive)({});
    function getRawParams() {
        if (mode === "history") return window1.location.search || "";
        else if (mode === "hash") {
            const hash = window1.location.hash || "";
            const index = hash.indexOf("?");
            return index > 0 ? hash.slice(index) : "";
        } else return (window1.location.hash || "").replace(/^#/, "");
    }
    function constructQuery(params) {
        const stringified = params.toString();
        if (mode === "history") return `${stringified ? `?${stringified}` : ""}${window1.location.hash || ""}`;
        if (mode === "hash-params") return `${window1.location.search || ""}${stringified ? `#${stringified}` : ""}`;
        const hash = window1.location.hash || "#";
        const index = hash.indexOf("?");
        if (index > 0) return `${hash.slice(0, index)}${stringified ? `?${stringified}` : ""}`;
        return `${hash}${stringified ? `?${stringified}` : ""}`;
    }
    function read() {
        return new URLSearchParams(getRawParams());
    }
    function updateState(params) {
        const unusedKeys = new Set(Object.keys(state));
        for (const key of params.keys()){
            const paramsForKey = params.getAll(key);
            state[key] = paramsForKey.length > 1 ? paramsForKey : params.get(key) || "";
            unusedKeys.delete(key);
        }
        Array.from(unusedKeys).forEach((key)=>delete state[key]);
    }
    const { pause: pause, resume: resume } = (0, $AHHxt.pausableWatch)(state, ()=>{
        const params = new URLSearchParams("");
        Object.keys(state).forEach((key)=>{
            const mapEntry = state[key];
            if (Array.isArray(mapEntry)) mapEntry.forEach((value)=>params.append(key, value));
            else if (removeNullishValues && mapEntry == null) params.delete(key);
            else if (removeFalsyValues && !mapEntry) params.delete(key);
            else params.set(key, mapEntry);
        });
        write(params);
    }, {
        deep: true
    });
    function write(params, shouldUpdate) {
        pause();
        if (shouldUpdate) updateState(params);
        window1.history.replaceState(window1.history.state, window1.document.title, window1.location.pathname + constructQuery(params));
        resume();
    }
    function onChanged() {
        if (!enableWrite) return;
        write(read(), true);
    }
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "popstate", onChanged, false);
    if (mode !== "history") $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "hashchange", onChanged, false);
    const initial = read();
    if (initial.keys().next().value) updateState(initial);
    else Object.assign(state, initialValue);
    return state;
}
function $6ffe9515611cb489$export$a16ee9849ed85b4e(options = {}) {
    var _a, _b;
    const enabled = (0, $01W3b.ref)((_a = options.enabled) != null ? _a : false);
    const autoSwitch = (0, $01W3b.ref)((_b = options.autoSwitch) != null ? _b : true);
    const constraints = (0, $01W3b.ref)(options.constraints);
    const { navigator: navigator = $6ffe9515611cb489$export$eade61489f57e3fc } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>{
        var _a2;
        return (_a2 = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a2.getUserMedia;
    });
    const stream = (0, $01W3b.shallowRef)();
    function getDeviceOptions(type) {
        switch(type){
            case "video":
                if (constraints.value) return constraints.value.video || false;
                break;
            case "audio":
                if (constraints.value) return constraints.value.audio || false;
                break;
        }
    }
    async function _start() {
        if (!isSupported.value || stream.value) return;
        stream.value = await navigator.mediaDevices.getUserMedia({
            video: getDeviceOptions("video"),
            audio: getDeviceOptions("audio")
        });
        return stream.value;
    }
    function _stop() {
        var _a2;
        (_a2 = stream.value) == null || _a2.getTracks().forEach((t)=>t.stop());
        stream.value = void 0;
    }
    function stop() {
        _stop();
        enabled.value = false;
    }
    async function start() {
        await _start();
        if (stream.value) enabled.value = true;
        return stream.value;
    }
    async function restart() {
        _stop();
        return await start();
    }
    (0, $TusQn.watch)(enabled, (v)=>{
        if (v) _start();
        else _stop();
    }, {
        immediate: true
    });
    (0, $TusQn.watch)(constraints, ()=>{
        if (autoSwitch.value && stream.value) restart();
    }, {
        immediate: true
    });
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        stop();
    });
    return {
        isSupported: isSupported,
        stream: stream,
        start: start,
        stop: stop,
        restart: restart,
        constraints: constraints,
        enabled: enabled,
        autoSwitch: autoSwitch
    };
}
function $6ffe9515611cb489$export$42662bab1b538e5(props, key, emit, options = {}) {
    var _a, _b, _c, _d, _e;
    const { clone: clone = false, passive: passive = false, eventName: eventName, deep: deep = false, defaultValue: defaultValue, shouldEmit: shouldEmit } = options;
    const vm = (0, $TusQn.getCurrentInstance)();
    const _emit = emit || (vm == null ? void 0 : vm.emit) || ((_a = vm == null ? void 0 : vm.$emit) == null ? void 0 : _a.bind(vm)) || ((_c = (_b = vm == null ? void 0 : vm.proxy) == null ? void 0 : _b.$emit) == null ? void 0 : _c.bind(vm == null ? void 0 : vm.proxy));
    let event = eventName;
    if (!key) {
        if (0, $keUOA.isVue2) {
            const modelOptions = (_e = (_d = vm == null ? void 0 : vm.proxy) == null ? void 0 : _d.$options) == null ? void 0 : _e.model;
            key = (modelOptions == null ? void 0 : modelOptions.value) || "value";
            if (!eventName) event = (modelOptions == null ? void 0 : modelOptions.event) || "input";
        } else key = "modelValue";
    }
    event = event || `update:${key.toString()}`;
    const cloneFn = (val)=>!clone ? val : typeof clone === "function" ? clone(val) : $6ffe9515611cb489$export$9e72043f8ff3a3df(val);
    const getValue = ()=>(0, $AHHxt.isDef)(props[key]) ? cloneFn(props[key]) : defaultValue;
    const triggerEmit = (value)=>{
        if (shouldEmit) {
            if (shouldEmit(value)) _emit(event, value);
        } else _emit(event, value);
    };
    if (passive) {
        const initialValue = getValue();
        const proxy = (0, $01W3b.ref)(initialValue);
        let isUpdating = false;
        (0, $TusQn.watch)(()=>props[key], (v)=>{
            if (!isUpdating) {
                isUpdating = true;
                proxy.value = cloneFn(v);
                (0, $TusQn.nextTick)(()=>isUpdating = false);
            }
        });
        (0, $TusQn.watch)(proxy, (v)=>{
            if (!isUpdating && (v !== props[key] || deep)) triggerEmit(v);
        }, {
            deep: deep
        });
        return proxy;
    } else return (0, $01W3b.computed)({
        get () {
            return getValue();
        },
        set (value) {
            triggerEmit(value);
        }
    });
}
function $6ffe9515611cb489$export$b020cc6dc10339b9(props, emit, options = {}) {
    const ret = {};
    for(const key in props)ret[key] = $6ffe9515611cb489$export$42662bab1b538e5(props, key, emit, options);
    return ret;
}
function $6ffe9515611cb489$export$165ce7a5158a386d(options) {
    const { pattern: pattern = [], interval: interval = 0, navigator: navigator = $6ffe9515611cb489$export$eade61489f57e3fc } = options || {};
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>typeof navigator !== "undefined" && "vibrate" in navigator);
    const patternRef = (0, $AHHxt.toRef)(pattern);
    let intervalControls;
    const vibrate = (pattern2 = patternRef.value)=>{
        if (isSupported.value) navigator.vibrate(pattern2);
    };
    const stop = ()=>{
        if (isSupported.value) navigator.vibrate(0);
        intervalControls == null || intervalControls.pause();
    };
    if (interval > 0) intervalControls = (0, $AHHxt.useIntervalFn)(vibrate, interval, {
        immediate: false,
        immediateCallback: false
    });
    return {
        isSupported: isSupported,
        pattern: pattern,
        intervalControls: intervalControls,
        vibrate: vibrate,
        stop: stop
    };
}
function $6ffe9515611cb489$export$e0cfc61c348fbd34(list, options) {
    const { containerStyle: containerStyle, wrapperProps: wrapperProps, scrollTo: scrollTo1, calculateRange: calculateRange, currentList: currentList, containerRef: containerRef } = "itemHeight" in options ? $6ffe9515611cb489$var$useVerticalVirtualList(options, list) : $6ffe9515611cb489$var$useHorizontalVirtualList(options, list);
    return {
        list: currentList,
        scrollTo: scrollTo1,
        containerProps: {
            ref: containerRef,
            onScroll: ()=>{
                calculateRange();
            },
            style: containerStyle
        },
        wrapperProps: wrapperProps
    };
}
function $6ffe9515611cb489$var$useVirtualListResources(list) {
    const containerRef = (0, $01W3b.ref)(null);
    const size = $6ffe9515611cb489$export$2b86bedf890eab8(containerRef);
    const currentList = (0, $01W3b.ref)([]);
    const source = (0, $01W3b.shallowRef)(list);
    const state = (0, $01W3b.ref)({
        start: 0,
        end: 10
    });
    return {
        state: state,
        source: source,
        currentList: currentList,
        size: size,
        containerRef: containerRef
    };
}
function $6ffe9515611cb489$var$createGetViewCapacity(state, source, itemSize) {
    return (containerSize)=>{
        if (typeof itemSize === "number") return Math.ceil(containerSize / itemSize);
        const { start: start = 0 } = state.value;
        let sum = 0;
        let capacity = 0;
        for(let i = start; i < source.value.length; i++){
            const size = itemSize(i);
            sum += size;
            capacity = i;
            if (sum > containerSize) break;
        }
        return capacity - start;
    };
}
function $6ffe9515611cb489$var$createGetOffset(source, itemSize) {
    return (scrollDirection)=>{
        if (typeof itemSize === "number") return Math.floor(scrollDirection / itemSize) + 1;
        let sum = 0;
        let offset = 0;
        for(let i = 0; i < source.value.length; i++){
            const size = itemSize(i);
            sum += size;
            if (sum >= scrollDirection) {
                offset = i;
                break;
            }
        }
        return offset + 1;
    };
}
function $6ffe9515611cb489$var$createCalculateRange(type, overscan, getOffset, getViewCapacity, { containerRef: containerRef, state: state, currentList: currentList, source: source }) {
    return ()=>{
        const element = containerRef.value;
        if (element) {
            const offset = getOffset(type === "vertical" ? element.scrollTop : element.scrollLeft);
            const viewCapacity = getViewCapacity(type === "vertical" ? element.clientHeight : element.clientWidth);
            const from = offset - overscan;
            const to = offset + viewCapacity + overscan;
            state.value = {
                start: from < 0 ? 0 : from,
                end: to > source.value.length ? source.value.length : to
            };
            currentList.value = source.value.slice(state.value.start, state.value.end).map((ele, index)=>({
                    data: ele,
                    index: index + state.value.start
                }));
        }
    };
}
function $6ffe9515611cb489$var$createGetDistance(itemSize, source) {
    return (index)=>{
        if (typeof itemSize === "number") {
            const size2 = index * itemSize;
            return size2;
        }
        const size = source.value.slice(0, index).reduce((sum, _, i)=>sum + itemSize(i), 0);
        return size;
    };
}
function $6ffe9515611cb489$var$useWatchForSizes(size, list, calculateRange) {
    (0, $TusQn.watch)([
        size.width,
        size.height,
        list
    ], ()=>{
        calculateRange();
    });
}
function $6ffe9515611cb489$var$createComputedTotalSize(itemSize, source) {
    return (0, $01W3b.computed)(()=>{
        if (typeof itemSize === "number") return source.value.length * itemSize;
        return source.value.reduce((sum, _, index)=>sum + itemSize(index), 0);
    });
}
const $6ffe9515611cb489$var$scrollToDictionaryForElementScrollKey = {
    horizontal: "scrollLeft",
    vertical: "scrollTop"
};
function $6ffe9515611cb489$var$createScrollTo(type, calculateRange, getDistance, containerRef) {
    return (index)=>{
        if (containerRef.value) {
            containerRef.value[$6ffe9515611cb489$var$scrollToDictionaryForElementScrollKey[type]] = getDistance(index);
            calculateRange();
        }
    };
}
function $6ffe9515611cb489$var$useHorizontalVirtualList(options, list) {
    const resources = $6ffe9515611cb489$var$useVirtualListResources(list);
    const { state: state, source: source, currentList: currentList, size: size, containerRef: containerRef } = resources;
    const containerStyle = {
        overflowX: "auto"
    };
    const { itemWidth: itemWidth, overscan: overscan = 5 } = options;
    const getViewCapacity = $6ffe9515611cb489$var$createGetViewCapacity(state, source, itemWidth);
    const getOffset = $6ffe9515611cb489$var$createGetOffset(source, itemWidth);
    const calculateRange = $6ffe9515611cb489$var$createCalculateRange("horizontal", overscan, getOffset, getViewCapacity, resources);
    const getDistanceLeft = $6ffe9515611cb489$var$createGetDistance(itemWidth, source);
    const offsetLeft = (0, $01W3b.computed)(()=>getDistanceLeft(state.value.start));
    const totalWidth = $6ffe9515611cb489$var$createComputedTotalSize(itemWidth, source);
    $6ffe9515611cb489$var$useWatchForSizes(size, list, calculateRange);
    const scrollTo1 = $6ffe9515611cb489$var$createScrollTo("horizontal", calculateRange, getDistanceLeft, containerRef);
    const wrapperProps = (0, $01W3b.computed)(()=>{
        return {
            style: {
                height: "100%",
                width: `${totalWidth.value - offsetLeft.value}px`,
                marginLeft: `${offsetLeft.value}px`,
                display: "flex"
            }
        };
    });
    return {
        scrollTo: scrollTo1,
        calculateRange: calculateRange,
        wrapperProps: wrapperProps,
        containerStyle: containerStyle,
        currentList: currentList,
        containerRef: containerRef
    };
}
function $6ffe9515611cb489$var$useVerticalVirtualList(options, list) {
    const resources = $6ffe9515611cb489$var$useVirtualListResources(list);
    const { state: state, source: source, currentList: currentList, size: size, containerRef: containerRef } = resources;
    const containerStyle = {
        overflowY: "auto"
    };
    const { itemHeight: itemHeight, overscan: overscan = 5 } = options;
    const getViewCapacity = $6ffe9515611cb489$var$createGetViewCapacity(state, source, itemHeight);
    const getOffset = $6ffe9515611cb489$var$createGetOffset(source, itemHeight);
    const calculateRange = $6ffe9515611cb489$var$createCalculateRange("vertical", overscan, getOffset, getViewCapacity, resources);
    const getDistanceTop = $6ffe9515611cb489$var$createGetDistance(itemHeight, source);
    const offsetTop = (0, $01W3b.computed)(()=>getDistanceTop(state.value.start));
    const totalHeight = $6ffe9515611cb489$var$createComputedTotalSize(itemHeight, source);
    $6ffe9515611cb489$var$useWatchForSizes(size, list, calculateRange);
    const scrollTo1 = $6ffe9515611cb489$var$createScrollTo("vertical", calculateRange, getDistanceTop, containerRef);
    const wrapperProps = (0, $01W3b.computed)(()=>{
        return {
            style: {
                width: "100%",
                height: `${totalHeight.value - offsetTop.value}px`,
                marginTop: `${offsetTop.value}px`
            }
        };
    });
    return {
        calculateRange: calculateRange,
        scrollTo: scrollTo1,
        containerStyle: containerStyle,
        wrapperProps: wrapperProps,
        currentList: currentList,
        containerRef: containerRef
    };
}
function $6ffe9515611cb489$export$73321d658b51e565(options = {}) {
    const { navigator: navigator = $6ffe9515611cb489$export$eade61489f57e3fc, document: document1 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    let wakeLock;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator && "wakeLock" in navigator);
    const isActive = (0, $01W3b.ref)(false);
    async function onVisibilityChange() {
        if (!isSupported.value || !wakeLock) return;
        if (document1 && document1.visibilityState === "visible") wakeLock = await navigator.wakeLock.request("screen");
        isActive.value = !wakeLock.released;
    }
    if (document1) $6ffe9515611cb489$export$7080b3e976bc91ab(document1, "visibilitychange", onVisibilityChange, {
        passive: true
    });
    async function request(type) {
        if (!isSupported.value) return;
        wakeLock = await navigator.wakeLock.request(type);
        isActive.value = !wakeLock.released;
    }
    async function release() {
        if (!isSupported.value || !wakeLock) return;
        await wakeLock.release();
        isActive.value = !wakeLock.released;
        wakeLock = null;
    }
    return {
        isSupported: isSupported,
        isActive: isActive,
        request: request,
        release: release
    };
}
function $6ffe9515611cb489$export$522fa265139e12a1(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, requestPermissions: _requestForPermissions = true } = options;
    const defaultWebNotificationOptions = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>!!window1 && "Notification" in window1);
    const permissionGranted = (0, $01W3b.ref)(isSupported.value && "permission" in Notification && Notification.permission === "granted");
    const notification = (0, $01W3b.ref)(null);
    const ensurePermissions = async ()=>{
        if (!isSupported.value) return;
        if (!permissionGranted.value && Notification.permission !== "denied") {
            const result = await Notification.requestPermission();
            if (result === "granted") permissionGranted.value = true;
        }
        return permissionGranted.value;
    };
    const { on: onClick, trigger: clickTrigger } = (0, $AHHxt.createEventHook)();
    const { on: onShow, trigger: showTrigger } = (0, $AHHxt.createEventHook)();
    const { on: onError, trigger: errorTrigger } = (0, $AHHxt.createEventHook)();
    const { on: onClose, trigger: closeTrigger } = (0, $AHHxt.createEventHook)();
    const show = async (overrides)=>{
        if (!isSupported.value || !permissionGranted.value) return;
        const options2 = Object.assign({}, defaultWebNotificationOptions, overrides);
        notification.value = new Notification(options2.title || "", options2);
        notification.value.onclick = clickTrigger;
        notification.value.onshow = showTrigger;
        notification.value.onerror = errorTrigger;
        notification.value.onclose = closeTrigger;
        return notification.value;
    };
    const close = ()=>{
        if (notification.value) notification.value.close();
        notification.value = null;
    };
    if (_requestForPermissions) (0, $AHHxt.tryOnMounted)(ensurePermissions);
    (0, $AHHxt.tryOnScopeDispose)(close);
    if (isSupported.value && window1) {
        const document1 = window1.document;
        $6ffe9515611cb489$export$7080b3e976bc91ab(document1, "visibilitychange", (e)=>{
            e.preventDefault();
            if (document1.visibilityState === "visible") close();
        });
    }
    return {
        isSupported: isSupported,
        notification: notification,
        ensurePermissions: ensurePermissions,
        permissionGranted: permissionGranted,
        show: show,
        close: close,
        onClick: onClick,
        onShow: onShow,
        onError: onError,
        onClose: onClose
    };
}
const $6ffe9515611cb489$var$DEFAULT_PING_MESSAGE = "ping";
function $6ffe9515611cb489$var$resolveNestedOptions(options) {
    if (options === true) return {};
    return options;
}
function $6ffe9515611cb489$export$ef4944d05bd3db0(url, options = {}) {
    const { onConnected: onConnected, onDisconnected: onDisconnected, onError: onError, onMessage: onMessage, immediate: immediate = true, autoClose: autoClose = true, protocols: protocols = [] } = options;
    const data = (0, $01W3b.ref)(null);
    const status = (0, $01W3b.ref)("CLOSED");
    const wsRef = (0, $01W3b.ref)();
    const urlRef = (0, $AHHxt.toRef)(url);
    let heartbeatPause;
    let heartbeatResume;
    let explicitlyClosed = false;
    let retried = 0;
    let bufferedData = [];
    let pongTimeoutWait;
    const _sendBuffer = ()=>{
        if (bufferedData.length && wsRef.value && status.value === "OPEN") {
            for (const buffer of bufferedData)wsRef.value.send(buffer);
            bufferedData = [];
        }
    };
    const resetHeartbeat = ()=>{
        clearTimeout(pongTimeoutWait);
        pongTimeoutWait = void 0;
    };
    const close = (code = 1e3, reason)=>{
        if (!(0, $AHHxt.isClient) || !wsRef.value) return;
        explicitlyClosed = true;
        resetHeartbeat();
        heartbeatPause == null || heartbeatPause();
        wsRef.value.close(code, reason);
        wsRef.value = void 0;
    };
    const send = (data2, useBuffer = true)=>{
        if (!wsRef.value || status.value !== "OPEN") {
            if (useBuffer) bufferedData.push(data2);
            return false;
        }
        _sendBuffer();
        wsRef.value.send(data2);
        return true;
    };
    const _init = ()=>{
        if (explicitlyClosed || typeof urlRef.value === "undefined") return;
        const ws = new WebSocket(urlRef.value, protocols);
        wsRef.value = ws;
        status.value = "CONNECTING";
        ws.onopen = ()=>{
            status.value = "OPEN";
            onConnected == null || onConnected(ws);
            heartbeatResume == null || heartbeatResume();
            _sendBuffer();
        };
        ws.onclose = (ev)=>{
            status.value = "CLOSED";
            onDisconnected == null || onDisconnected(ws, ev);
            if (!explicitlyClosed && options.autoReconnect) {
                const { retries: retries = -1, delay: delay = 1e3, onFailed: onFailed } = $6ffe9515611cb489$var$resolveNestedOptions(options.autoReconnect);
                retried += 1;
                if (typeof retries === "number" && (retries < 0 || retried < retries)) setTimeout(_init, delay);
                else if (typeof retries === "function" && retries()) setTimeout(_init, delay);
                else onFailed == null || onFailed();
            }
        };
        ws.onerror = (e)=>{
            onError == null || onError(ws, e);
        };
        ws.onmessage = (e)=>{
            if (options.heartbeat) {
                resetHeartbeat();
                const { message: message = $6ffe9515611cb489$var$DEFAULT_PING_MESSAGE } = $6ffe9515611cb489$var$resolveNestedOptions(options.heartbeat);
                if (e.data === message) return;
            }
            data.value = e.data;
            onMessage == null || onMessage(ws, e);
        };
    };
    if (options.heartbeat) {
        const { message: message = $6ffe9515611cb489$var$DEFAULT_PING_MESSAGE, interval: interval = 1e3, pongTimeout: pongTimeout = 1e3 } = $6ffe9515611cb489$var$resolveNestedOptions(options.heartbeat);
        const { pause: pause, resume: resume } = (0, $AHHxt.useIntervalFn)(()=>{
            send(message, false);
            if (pongTimeoutWait != null) return;
            pongTimeoutWait = setTimeout(()=>{
                close();
                explicitlyClosed = false;
            }, pongTimeout);
        }, interval, {
            immediate: false
        });
        heartbeatPause = pause;
        heartbeatResume = resume;
    }
    if (autoClose) {
        if (0, $AHHxt.isClient) $6ffe9515611cb489$export$7080b3e976bc91ab("beforeunload", ()=>close());
        (0, $AHHxt.tryOnScopeDispose)(close);
    }
    const open = ()=>{
        if (!(0, $AHHxt.isClient) && !(0, $AHHxt.isWorker)) return;
        close();
        explicitlyClosed = false;
        retried = 0;
        _init();
    };
    if (immediate) open();
    return {
        data: data,
        status: status,
        close: close,
        send: send,
        open: open,
        ws: wsRef
    };
}
function $6ffe9515611cb489$export$44bc62d25eb3a976(arg0, workerOptions, options) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options != null ? options : {};
    const data = (0, $01W3b.ref)(null);
    const worker = (0, $01W3b.shallowRef)();
    const post = (...args)=>{
        if (!worker.value) return;
        worker.value.postMessage(...args);
    };
    const terminate = function terminate2() {
        if (!worker.value) return;
        worker.value.terminate();
    };
    if (window1) {
        if (typeof arg0 === "string") worker.value = new Worker(arg0, workerOptions);
        else if (typeof arg0 === "function") worker.value = arg0();
        else worker.value = arg0;
        worker.value.onmessage = (e)=>{
            data.value = e.data;
        };
        (0, $AHHxt.tryOnScopeDispose)(()=>{
            if (worker.value) worker.value.terminate();
        });
    }
    return {
        data: data,
        post: post,
        terminate: terminate,
        worker: worker
    };
}
function $6ffe9515611cb489$var$jobRunner(userFunc) {
    return (e)=>{
        const userFuncArgs = e.data[0];
        return Promise.resolve(userFunc.apply(void 0, userFuncArgs)).then((result)=>{
            postMessage([
                "SUCCESS",
                result
            ]);
        }).catch((error)=>{
            postMessage([
                "ERROR",
                error
            ]);
        });
    };
}
function $6ffe9515611cb489$var$depsParser(deps) {
    if (deps.length === 0) return "";
    const depsString = deps.map((dep)=>`'${dep}'`).toString();
    return `importScripts(${depsString})`;
}
function $6ffe9515611cb489$var$createWorkerBlobUrl(fn, deps) {
    const blobCode = `${$6ffe9515611cb489$var$depsParser(deps)}; onmessage=(${$6ffe9515611cb489$var$jobRunner})(${fn})`;
    const blob = new Blob([
        blobCode
    ], {
        type: "text/javascript"
    });
    const url = URL.createObjectURL(blob);
    return url;
}
function $6ffe9515611cb489$export$33b1fcfcd57b961(fn, options = {}) {
    const { dependencies: dependencies = [], timeout: timeout, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const worker = (0, $01W3b.ref)();
    const workerStatus = (0, $01W3b.ref)("PENDING");
    const promise = (0, $01W3b.ref)({});
    const timeoutId = (0, $01W3b.ref)();
    const workerTerminate = (status = "PENDING")=>{
        if (worker.value && worker.value._url && window1) {
            worker.value.terminate();
            URL.revokeObjectURL(worker.value._url);
            promise.value = {};
            worker.value = void 0;
            window1.clearTimeout(timeoutId.value);
            workerStatus.value = status;
        }
    };
    workerTerminate();
    (0, $AHHxt.tryOnScopeDispose)(workerTerminate);
    const generateWorker = ()=>{
        const blobUrl = $6ffe9515611cb489$var$createWorkerBlobUrl(fn, dependencies);
        const newWorker = new Worker(blobUrl);
        newWorker._url = blobUrl;
        newWorker.onmessage = (e)=>{
            const { resolve: resolve = ()=>{}, reject: reject = ()=>{} } = promise.value;
            const [status, result] = e.data;
            switch(status){
                case "SUCCESS":
                    resolve(result);
                    workerTerminate(status);
                    break;
                default:
                    reject(result);
                    workerTerminate("ERROR");
                    break;
            }
        };
        newWorker.onerror = (e)=>{
            const { reject: reject = ()=>{} } = promise.value;
            e.preventDefault();
            reject(e);
            workerTerminate("ERROR");
        };
        if (timeout) timeoutId.value = setTimeout(()=>workerTerminate("TIMEOUT_EXPIRED"), timeout);
        return newWorker;
    };
    const callWorker = (...fnArgs)=>new Promise((resolve, reject)=>{
            promise.value = {
                resolve: resolve,
                reject: reject
            };
            worker.value && worker.value.postMessage([
                [
                    ...fnArgs
                ]
            ]);
            workerStatus.value = "RUNNING";
        });
    const workerFn = (...fnArgs)=>{
        if (workerStatus.value === "RUNNING") {
            console.error("[useWebWorkerFn] You can only run one instance of the worker at a time.");
            return Promise.reject();
        }
        worker.value = generateWorker();
        return callWorker(...fnArgs);
    };
    return {
        workerFn: workerFn,
        workerStatus: workerStatus,
        workerTerminate: workerTerminate
    };
}
function $6ffe9515611cb489$export$e838b63e89f8751e(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    if (!window1) return (0, $01W3b.ref)(false);
    const focused = (0, $01W3b.ref)(window1.document.hasFocus());
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "blur", ()=>{
        focused.value = false;
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "focus", ()=>{
        focused.value = true;
    });
    return focused;
}
function $6ffe9515611cb489$export$c510e5ca8a22f2a1(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, behavior: behavior = "auto" } = options;
    if (!window1) return {
        x: (0, $01W3b.ref)(0),
        y: (0, $01W3b.ref)(0)
    };
    const internalX = (0, $01W3b.ref)(window1.scrollX);
    const internalY = (0, $01W3b.ref)(window1.scrollY);
    const x = (0, $01W3b.computed)({
        get () {
            return internalX.value;
        },
        set (x2) {
            scrollTo({
                left: x2,
                behavior: behavior
            });
        }
    });
    const y = (0, $01W3b.computed)({
        get () {
            return internalY.value;
        },
        set (y2) {
            scrollTo({
                top: y2,
                behavior: behavior
            });
        }
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "scroll", ()=>{
        internalX.value = window1.scrollX;
        internalY.value = window1.scrollY;
    }, {
        capture: false,
        passive: true
    });
    return {
        x: x,
        y: y
    };
}
function $6ffe9515611cb489$export$42c02f33970a2afa(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, initialWidth: initialWidth = Number.POSITIVE_INFINITY, initialHeight: initialHeight = Number.POSITIVE_INFINITY, listenOrientation: listenOrientation = true, includeScrollbar: includeScrollbar = true } = options;
    const width = (0, $01W3b.ref)(initialWidth);
    const height = (0, $01W3b.ref)(initialHeight);
    const update = ()=>{
        if (window1) {
            if (includeScrollbar) {
                width.value = window1.innerWidth;
                height.value = window1.innerHeight;
            } else {
                width.value = window1.document.documentElement.clientWidth;
                height.value = window1.document.documentElement.clientHeight;
            }
        }
    };
    update();
    (0, $AHHxt.tryOnMounted)(update);
    $6ffe9515611cb489$export$7080b3e976bc91ab("resize", update, {
        passive: true
    });
    if (listenOrientation) {
        const matches = $6ffe9515611cb489$export$32d5543ab307c01("(orientation: portrait)");
        (0, $TusQn.watch)(matches, ()=>update());
    }
    return {
        width: width,
        height: height
    };
}

});
parcelRegister("keUOA", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("01W3b")).computed);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "TransitionGroup", () => (parcelRequire("eeJ70")).TransitionGroup);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "version", () => (parcelRequire("TusQn")).version);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);

$parcel$export(module.exports, "isVue2", () => $881156036404ab12$export$1da84e343e81ceb9);
$parcel$export(module.exports, "isVue3", () => $881156036404ab12$export$34b222e3d4733e48);
$parcel$export(module.exports, "set", () => $881156036404ab12$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "del", () => $881156036404ab12$export$1d2f21e549771e67);
parcelRequire("ecd4d");
var $881156036404ab12$export$1da84e343e81ceb9 = false;
var $881156036404ab12$export$34b222e3d4733e48 = true;
var $881156036404ab12$export$a8cb34872e7d8b79 = undefined;
function $881156036404ab12$export$4b3e715f166fdd78() {}
function $881156036404ab12$export$adaa4cf7ef1b65be(target, key, val) {
    if (Array.isArray(target)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    target[key] = val;
    return val;
}
function $881156036404ab12$export$1d2f21e549771e67(target, key) {
    if (Array.isArray(target)) {
        target.splice(key, 1);
        return;
    }
    delete target[key];
}

});


parcelRegister("4Kuwt", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $3753227fdc8a3f3b$export$ac4959f4f1338dfc);
let $3753227fdc8a3f3b$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $3753227fdc8a3f3b$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $3753227fdc8a3f3b$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $3753227fdc8a3f3b$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};

});

parcelRegister("bQytf", function(module, exports) {

$parcel$export(module.exports, "isNotNullAndNotEmpty", () => $89ff4a358e42cb71$export$a08b708e8eb98926);
$parcel$export(module.exports, "arrayRange", () => $89ff4a358e42cb71$export$dda5fc2d183b5cbd);
$parcel$export(module.exports, "isIndividualPlan", () => $89ff4a358e42cb71$export$72d6fabd90aecbe);

var $2nOds = parcelRequire("2nOds");
var $jKF2J = parcelRequire("jKF2J");
var $jXqeT = parcelRequire("jXqeT");
var $3o02A = parcelRequire("3o02A");
var $4Gqbx = parcelRequire("4Gqbx");
var $iDR1F = parcelRequire("iDR1F");

var $4Kuwt = parcelRequire("4Kuwt");
const $89ff4a358e42cb71$export$a08b708e8eb98926 = (0, $2nOds.default)([
    (0, $jXqeT.default),
    (0, $3o02A.default)
]);
const $89ff4a358e42cb71$var$isValuePropSet = (0, $4Gqbx.default)((0, $iDR1F.default)("value"), $89ff4a358e42cb71$export$a08b708e8eb98926);
const $89ff4a358e42cb71$var$getValue = (0, $iDR1F.default)("value");
const $89ff4a358e42cb71$export$6346312d48f93812 = (0, $jKF2J.default)($89ff4a358e42cb71$var$isValuePropSet, $89ff4a358e42cb71$var$getValue, ()=>(0, $4Kuwt.nanoid)());
const $89ff4a358e42cb71$export$dda5fc2d183b5cbd = (start, stop, step)=>Array.from({
        length: (stop - start) / step + 1
    }, (value, index)=>start + index * step);
const $89ff4a358e42cb71$export$72d6fabd90aecbe = (plan)=>plan !== undefined && plan.requireCompany === false;

});
parcelRegister("2nOds", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc4aea3bba47cb8$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $56Gyq = parcelRequire("56Gyq");

var $13hpE = parcelRequire("13hpE");

var $gXdUG = parcelRequire("gXdUG");

var $1mo4j = parcelRequire("1mo4j");
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass, R.both
 * @example
 *
 *      const isQueen = R.propEq('Q', 'rank');
 *      const isSpade = R.propEq('♠︎', 'suit');
 *      const isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */ var $1bc4aea3bba47cb8$var$allPass = /*#__PURE__*/ (0, $aSQee.default)(function allPass(preds) {
    return (0, $56Gyq.default)((0, $1mo4j.default)((0, $13hpE.default), 0, (0, $gXdUG.default)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (!preds[idx].apply(this, arguments)) return false;
            idx += 1;
        }
        return true;
    });
});
var $1bc4aea3bba47cb8$export$2e2bcd8739ae039 = $1bc4aea3bba47cb8$var$allPass;

});
parcelRegister("gXdUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c57cf2ecbe3ddf08$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");

var $f7umK = parcelRequire("f7umK");

var $iDR1F = parcelRequire("iDR1F");
/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.project, R.prop, R.props
 * @example
 *
 *      var getAges = R.pluck('age');
 *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
 *
 *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */ var $c57cf2ecbe3ddf08$var$pluck = /*#__PURE__*/ (0, $2jcOR.default)(function pluck(p, list) {
    return (0, $f7umK.default)((0, $iDR1F.default)(p), list);
});
var $c57cf2ecbe3ddf08$export$2e2bcd8739ae039 = $c57cf2ecbe3ddf08$var$pluck;

});


parcelRegister("jXqeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e877e18fe9a01e40$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $kheUU = parcelRequire("kheUU");
/**
 * Returns `false` if the given value is its type's empty value; `true`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.29.2
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty, R.isEmpty
 * @example
 *
 *      R.isNotEmpty([1, 2, 3]);           //=> true
 *      R.isNotEmpty([]);                  //=> false
 *      R.isNotEmpty('');                  //=> false
 *      R.isNotEmpty(null);                //=> true
 *      R.isNotEmpty({});                  //=> false
 *      R.isNotEmpty({length: 0});         //=> true
 *      R.isNotEmpty(Uint8Array.from('')); //=> false
 */ var $e877e18fe9a01e40$var$isNotEmpty = /*#__PURE__*/ (0, $aSQee.default)(function isNotEmpty(x) {
    return !(0, $kheUU.default)(x);
});
var $e877e18fe9a01e40$export$2e2bcd8739ae039 = $e877e18fe9a01e40$var$isNotEmpty;

});

parcelRegister("3o02A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2773a5141829022b$export$2e2bcd8739ae039);

var $16nvB = parcelRequire("16nvB");

var $aSQee = parcelRequire("aSQee");
/**
 * Checks if the input value is not `null` and not `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.29.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is not `undefined` or not `null`, otherwise `false`.
 * @example
 *
 *      R.isNotNil(null); //=> false
 *      R.isNotNil(undefined); //=> false
 *      R.isNotNil(0); //=> true
 *      R.isNotNil([]); //=> true
 */ var $2773a5141829022b$var$isNotNil = /*#__PURE__*/ (0, $aSQee.default)(function isNotNil(x) {
    return !(0, $16nvB.default)(x);
});
var $2773a5141829022b$export$2e2bcd8739ae039 = $2773a5141829022b$var$isNotNil;

});



parcelRegister("5lCi4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e4c9d98e9dd5ff4$export$2e2bcd8739ae039);
let $3e4c9d98e9dd5ff4$var$script;



let $3e4c9d98e9dd5ff4$var$initialize = ()=>{
    $3e4c9d98e9dd5ff4$var$script = (parcelRequire("l7kPU"));
    if ($3e4c9d98e9dd5ff4$var$script.__esModule) $3e4c9d98e9dd5ff4$var$script = $3e4c9d98e9dd5ff4$var$script.default;
    $3e4c9d98e9dd5ff4$var$script.render = (parcelRequire("kH8o0")).render;
    (parcelRequire("iA39f")).default($3e4c9d98e9dd5ff4$var$script);
    $3e4c9d98e9dd5ff4$var$script.__scopeId = "data-v-8c98e3";
    $3e4c9d98e9dd5ff4$var$script.__file = "GamebookLogo.vue";
};
$3e4c9d98e9dd5ff4$var$initialize();
var $3e4c9d98e9dd5ff4$export$2e2bcd8739ae039 = $3e4c9d98e9dd5ff4$var$script;

});
parcelRegister("l7kPU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f5fa6a0ae795c694$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $jgMby = parcelRequire("jgMby");

var $44qJ3 = parcelRequire("44qJ3");
var $f5fa6a0ae795c694$export$2e2bcd8739ae039 = {
    __name: "GamebookLogo",
    props: {
        dark: Boolean
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const SelectedLogo = (0, $01W3b.computed)(()=>props.dark ? (0, $44qJ3.default) : (0, $jgMby.default));
        const __returned__ = {
            props: props,
            SelectedLogo: SelectedLogo,
            computed: $01W3b.computed,
            logoSource: $jgMby.default,
            logoSourceDark: $44qJ3.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("jgMby", function(module, exports) {

$parcel$export(module.exports, "default", () => $e074e38f64d2c549$export$2e2bcd8739ae039);
let $e074e38f64d2c549$var$script;


let $e074e38f64d2c549$var$initialize = ()=>{
    $e074e38f64d2c549$var$script = {};
    $e074e38f64d2c549$var$script.render = (parcelRequire("bpnD4")).render;
    (parcelRequire("cL93a")).default($e074e38f64d2c549$var$script);
    $e074e38f64d2c549$var$script.__scopeId = "data-v-bce1d9";
    $e074e38f64d2c549$var$script.__file = "GamebookLogoBlue.vue";
};
$e074e38f64d2c549$var$initialize();
var $e074e38f64d2c549$export$2e2bcd8739ae039 = $e074e38f64d2c549$var$script;

});
parcelRegister("bpnD4", function(module, exports) {

$parcel$export(module.exports, "render", () => $84e45bc99e11d8af$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $84e45bc99e11d8af$var$_hoisted_1 = {
    width: "47",
    height: "68",
    viewBox: "0 0 47 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const $84e45bc99e11d8af$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("rect", {
    width: "46.6129",
    height: "68",
    fill: "url(#pattern0_904567_2275)"
}, null, -1 /* HOISTED */ );
const $84e45bc99e11d8af$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("defs", null, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("pattern", {
        id: "pattern0_904567_2275",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("use", {
            "xlink:href": "#image0_904567_2275",
            transform: "matrix(0.00155857 0 0 0.00106838 -0.050176 0)"
        })
    ]),
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("image", {
        id: "image0_904567_2275",
        width: "706",
        height: "936",
        "xlink:href": "data:image/png;base64,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"
    })
], -1 /* HOISTED */ );
const $84e45bc99e11d8af$var$_hoisted_4 = [
    $84e45bc99e11d8af$var$_hoisted_2,
    $84e45bc99e11d8af$var$_hoisted_3
];
function $84e45bc99e11d8af$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $84e45bc99e11d8af$var$_hoisted_1, $84e45bc99e11d8af$var$_hoisted_4);
}

});

parcelRegister("cL93a", function(module, exports) {

$parcel$export(module.exports, "default", () => $94a0e4f912e2e985$export$2e2bcd8739ae039);
let $94a0e4f912e2e985$var$NOOP = ()=>{};
var $94a0e4f912e2e985$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("44qJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f6c444a8ba51fc3$export$2e2bcd8739ae039);
let $2f6c444a8ba51fc3$var$script;


let $2f6c444a8ba51fc3$var$initialize = ()=>{
    $2f6c444a8ba51fc3$var$script = {};
    $2f6c444a8ba51fc3$var$script.render = (parcelRequire("aOodK")).render;
    (parcelRequire("cvl0Y")).default($2f6c444a8ba51fc3$var$script);
    $2f6c444a8ba51fc3$var$script.__scopeId = "data-v-02b075";
    $2f6c444a8ba51fc3$var$script.__file = "GamebookLogoDark.vue";
};
$2f6c444a8ba51fc3$var$initialize();
var $2f6c444a8ba51fc3$export$2e2bcd8739ae039 = $2f6c444a8ba51fc3$var$script;

});
parcelRegister("aOodK", function(module, exports) {

$parcel$export(module.exports, "render", () => $7df15ca32e6fe621$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $7df15ca32e6fe621$var$_hoisted_1 = {
    width: "309",
    height: "587",
    viewBox: "0 0 309 587",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const $7df15ca32e6fe621$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<g style="mix-blend-mode:multiply;"><mask id="mask0_904837_2058" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="0" y="0" width="309" height="587"><rect width="309" height="587" fill="url(#pattern0_904837_2058)"></rect></mask><g mask="url(#mask0_904837_2058)"><rect width="309" height="587" fill="#171661"></rect></g></g><defs><pattern id="pattern0_904837_2058" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image0_904837_2058" transform="matrix(0.00141643 0 0 0.000745617 0 0.151051)"></use></pattern><image id="image0_904837_2058" width="706" height="936" xlink:href="data:image/png;base64,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"></image></defs>', 2);
const $7df15ca32e6fe621$var$_hoisted_4 = [
    $7df15ca32e6fe621$var$_hoisted_2
];
function $7df15ca32e6fe621$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $7df15ca32e6fe621$var$_hoisted_1, $7df15ca32e6fe621$var$_hoisted_4);
}

});

parcelRegister("cvl0Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $91a8ae5a8f9a8f8d$export$2e2bcd8739ae039);
let $91a8ae5a8f9a8f8d$var$NOOP = ()=>{};
var $91a8ae5a8f9a8f8d$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("kH8o0", function(module, exports) {

$parcel$export(module.exports, "render", () => $f10e541ed0e153e9$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $f10e541ed0e153e9$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)($setup.SelectedLogo), {
        alt: "GameBook logo"
    });
}

});

parcelRegister("iA39f", function(module, exports) {

$parcel$export(module.exports, "default", () => $d86e07f00bc736ec$export$2e2bcd8739ae039);
let $d86e07f00bc736ec$var$NOOP = ()=>{};
var $d86e07f00bc736ec$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("1F5z6", function(module, exports) {

$parcel$export(module.exports, "default", () => $135defe75403ec19$export$2e2bcd8739ae039);
let $135defe75403ec19$var$script;



let $135defe75403ec19$var$initialize = ()=>{
    $135defe75403ec19$var$script = (parcelRequire("8Fr6U"));
    if ($135defe75403ec19$var$script.__esModule) $135defe75403ec19$var$script = $135defe75403ec19$var$script.default;
    $135defe75403ec19$var$script.render = (parcelRequire("5txZK")).render;
    (parcelRequire("itduM")).default($135defe75403ec19$var$script);
    $135defe75403ec19$var$script.__scopeId = "data-v-691919";
    $135defe75403ec19$var$script.__file = "InPlaceAlert.vue";
};
$135defe75403ec19$var$initialize();
var $135defe75403ec19$export$2e2bcd8739ae039 = $135defe75403ec19$var$script;

});
parcelRegister("8Fr6U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $64f72ea6106f83cf$export$2e2bcd8739ae039);

var $5zyMx = parcelRequire("5zyMx");
var $hKvje = parcelRequire("hKvje");
var $emKID = parcelRequire("emKID");

var $bQytf = parcelRequire("bQytf");
var $64f72ea6106f83cf$export$2e2bcd8739ae039 = {
    __name: "InPlaceAlert",
    props: {
        message: {
            type: String,
            default: "",
            required: true
        },
        type: {
            validator (value) {
                return [
                    "info",
                    "success",
                    "warning",
                    "error",
                    "simple"
                ].includes(value);
            },
            default: "warning"
        }
    },
    emits: [
        "close-alert"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const alertAttributes = (0, $5zyMx.default)([
            [
                (0, $hKvje.default)("info", "type"),
                ()=>({
                        id: "alert-border-1",
                        class: "flex items-center p-4 mb-4 text-blue-800 border-t-4 border-blue-300 bg-blue-50 dark:text-blue-400 dark:bg-gray-800 dark:border-blue-800",
                        buttonClass: "ms-auto -mx-1.5 -my-1.5 bg-blue-50 text-blue-500 rounded-lg focus:ring-2 focus:ring-blue-400 p-1.5 hover:bg-blue-200 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:text-blue-400 dark:hover:bg-gray-700"
                    })
            ],
            [
                (0, $hKvje.default)("error", "type"),
                ()=>({
                        id: "alert-border-2",
                        class: "flex items-center p-4 mb-4 text-red-800 border-t-4 border-red-300 bg-red-50 dark:text-red-400 dark:bg-gray-800 dark:border-red-800",
                        buttonClass: "ms-auto -mx-1.5 -my-1.5 bg-red-50 text-red-500 rounded-lg focus:ring-2 focus:ring-red-400 p-1.5 hover:bg-red-200 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:text-red-400 dark:hover:bg-gray-700"
                    })
            ],
            [
                (0, $hKvje.default)("success", "type"),
                ()=>({
                        id: "alert-border-3",
                        class: "flex items-center p-4 mb-4 text-green-800 border-t-4 border-green-300 bg-green-50 dark:text-green-400 dark:bg-gray-800 dark:border-green-800",
                        buttonClass: "ms-auto -mx-1.5 -my-1.5 bg-green-50 text-green-500 rounded-lg focus:ring-2 focus:ring-green-400 p-1.5 hover:bg-green-200 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:text-green-400 dark:hover:bg-gray-700"
                    })
            ],
            [
                (0, $hKvje.default)("warning", "type"),
                ()=>({
                        id: "alert-border-4",
                        class: "flex items-center p-4 mb-4 text-yellow-800 border-t-4 border-yellow-300 bg-yellow-50 dark:text-yellow-300 dark:bg-gray-800 dark:border-yellow-800",
                        buttonClass: "ms-auto -mx-1.5 -my-1.5 bg-yellow-50 text-yellow-500 rounded-lg focus:ring-2 focus:ring-yellow-400 p-1.5 hover:bg-yellow-200 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:text-yellow-300 dark:hover:bg-gray-700"
                    })
            ],
            [
                (0, $emKID.default),
                ()=>({
                        id: "alert-border-5",
                        class: "flex items-center p-4 border-t-4 border-gray-300 bg-gray-50 dark:bg-gray-800 dark:border-gray-600",
                        buttonClass: "ms-auto -mx-1.5 -my-1.5 bg-gray-50 text-gray-500 rounded-lg focus:ring-2 focus:ring-gray-400 p-1.5 hover:bg-gray-200 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white"
                    })
            ]
        ])(props);
        const emit = __emit;
        const __returned__ = {
            props: props,
            alertAttributes: alertAttributes,
            emit: emit,
            get cond () {
                return 0, $5zyMx.default;
            },
            get propEq () {
                return 0, $hKvje.default;
            },
            get T () {
                return 0, $emKID.default;
            },
            get isNotNullAndNotEmpty () {
                return 0, $bQytf.isNotNullAndNotEmpty;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("5txZK", function(module, exports) {

$parcel$export(module.exports, "render", () => $3fca07e0506329c2$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $3fca07e0506329c2$var$_hoisted_1 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("svg", {
    class: "flex-shrink-0 w-4 h-4",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("path", {
        d: "M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"
    })
], -1 /* HOISTED */ );
const $3fca07e0506329c2$var$_hoisted_2 = [
    "innerHTML"
];
const $3fca07e0506329c2$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
    class: "sr-only"
}, "Dismiss", -1 /* HOISTED */ );
const $3fca07e0506329c2$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("svg", {
    class: "w-3 h-3",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
    })
], -1 /* HOISTED */ );
const $3fca07e0506329c2$var$_hoisted_5 = [
    $3fca07e0506329c2$var$_hoisted_3,
    $3fca07e0506329c2$var$_hoisted_4
];
function $3fca07e0506329c2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $setup.isNotNullAndNotEmpty($setup.props.message) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", (0, $TusQn.mergeProps)({
        key: 0
    }, $setup.alertAttributes, {
        role: "alert"
    }), [
        $3fca07e0506329c2$var$_hoisted_1,
        (0, $TusQn.createElementVNode)("div", {
            class: "ms-3 text-sm font-medium",
            innerHTML: $setup.props.message
        }, null, 8 /* PROPS */ , $3fca07e0506329c2$var$_hoisted_2),
        (0, $TusQn.createElementVNode)("button", {
            onClick: _cache[0] || (_cache[0] = ($event)=>$setup.emit("close-alert")),
            type: "button",
            class: (0, $8POXm.normalizeClass)($setup.alertAttributes.buttonClass),
            "aria-label": "Close"
        }, $3fca07e0506329c2$var$_hoisted_5, 2 /* CLASS */ )
    ], 16 /* FULL_PROPS */ )) : (0, $TusQn.createCommentVNode)("v-if", true);
}

});

parcelRegister("itduM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d725675ba6f7ab68$export$2e2bcd8739ae039);
let $d725675ba6f7ab68$var$NOOP = ()=>{};
var $d725675ba6f7ab68$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("26BmW", function(module, exports) {

$parcel$export(module.exports, "goToHomeScreenFor", () => $1889210736281b69$export$8784cca41c2a2c3f);
$parcel$export(module.exports, "isUserLevelEmployee", () => $1889210736281b69$export$45b69376b0c1dd08);
$parcel$export(module.exports, "isUserLevelOwner", () => $1889210736281b69$export$4f42e0b56cdd44b7);
$parcel$export(module.exports, "isUserOwnerOfCompanyPlan", () => $1889210736281b69$export$bb6204b724e313f8);
$parcel$export(module.exports, "isUserOwnerOfIndividualPlan", () => $1889210736281b69$export$b6973cf994029a5b);

var $2nOds = parcelRequire("2nOds");
var $4CQUo = parcelRequire("4CQUo");
var $5zyMx = parcelRequire("5zyMx");
var $emKID = parcelRequire("emKID");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $1rS06 = parcelRequire("1rS06");

var $4OcZ0 = parcelRequire("4OcZ0");

var $580JV = parcelRequire("580JV");
const $1889210736281b69$export$8784cca41c2a2c3f = (0, $5zyMx.default)([
    [
        (0, $1rS06.isEmployee),
        ()=>(0, $4OcZ0.default).push((0, $580JV.default).i18nRoute({
                name: "dashboard"
            }))
    ],
    [
        (0, $1rS06.isOwner),
        ()=>(0, $4OcZ0.default).push((0, $580JV.default).i18nRoute({
                name: "dashboard"
            }))
    ],
    [
        (0, $emKID.default),
        ()=>(0, $4OcZ0.default).push((0, $580JV.default).i18nRoute({
                name: "home"
            }))
    ]
]);
const { userState: $1889210736281b69$var$userState } = (0, $1rS06.useGlobalState)();
const $1889210736281b69$export$45b69376b0c1dd08 = (0, $01W3b.computed)(()=>(0, $4CQUo.default)([
        (0, $1rS06.isEmployee)
    ])((0, $01W3b.toValue)($1889210736281b69$var$userState)));
const $1889210736281b69$export$4f42e0b56cdd44b7 = (0, $01W3b.computed)(()=>(0, $1rS06.isOwner)((0, $01W3b.toValue)($1889210736281b69$var$userState)));
const $1889210736281b69$export$bb6204b724e313f8 = (0, $01W3b.computed)(()=>(0, $2nOds.default)([
        (0, $1rS06.isOwner),
        (0, $1rS06.hasCompanyPlan)
    ])((0, $01W3b.toValue)($1889210736281b69$var$userState)));
const $1889210736281b69$export$b6973cf994029a5b = (0, $01W3b.computed)(()=>(0, $2nOds.default)([
        (0, $1rS06.isOwner),
        (0, $1rS06.hasUserPlan)
    ])((0, $01W3b.toValue)($1889210736281b69$var$userState)));

});
parcelRegister("4CQUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $35e3c08d2ef8d581$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $56Gyq = parcelRequire("56Gyq");

var $13hpE = parcelRequire("13hpE");

var $gXdUG = parcelRequire("gXdUG");

var $1mo4j = parcelRequire("1mo4j");
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass, R.either
 * @example
 *
 *      const isClub = R.propEq('♣', 'suit');
 *      const isSpade = R.propEq('♠', 'suit');
 *      const isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */ var $35e3c08d2ef8d581$var$anyPass = /*#__PURE__*/ (0, $aSQee.default)(function anyPass(preds) {
    return (0, $56Gyq.default)((0, $1mo4j.default)((0, $13hpE.default), 0, (0, $gXdUG.default)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (preds[idx].apply(this, arguments)) return true;
            idx += 1;
        }
        return false;
    });
});
var $35e3c08d2ef8d581$export$2e2bcd8739ae039 = $35e3c08d2ef8d581$var$anyPass;

});


parcelRegister("gQLqr", function(module, exports) {

$parcel$export(module.exports, "createEphemeral", () => $c4464a626d8758b2$export$bd603d5283289c42);
$parcel$export(module.exports, "getSalt", () => $c4464a626d8758b2$export$79bcd515db49ff31);
$parcel$export(module.exports, "getServerEphemeral", () => $c4464a626d8758b2$export$96762aac70b46352);
$parcel$export(module.exports, "useCreateSecureRemotePassword", () => $c4464a626d8758b2$export$1a237e2a62b5d5c);
$parcel$export(module.exports, "createClientSession", () => $c4464a626d8758b2$export$b671a3d2844d6e42);
$parcel$export(module.exports, "getServerProofRequestSpec", () => $c4464a626d8758b2$export$531bc37861c26981);
$parcel$export(module.exports, "fetchAndUpdateUserState", () => $c4464a626d8758b2$export$747ffc8e682cc1c);
$parcel$export(module.exports, "useUserStateFromEndpoint", () => $c4464a626d8758b2$export$e5016cae31bd83ec);

var $j21ta = parcelRequire("j21ta");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $lR3qp = parcelRequire("lR3qp");
var $ey2ik = parcelRequire("ey2ik");
var $dnABj = parcelRequire("dnABj");
var $iDR1F = parcelRequire("iDR1F");

var $bRn2L = parcelRequire("bRn2L");

var $1rS06 = parcelRequire("1rS06");

var $bQytf = parcelRequire("bQytf");

var $gzF45 = parcelRequire("gzF45");
const $c4464a626d8758b2$export$bd603d5283289c42 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($j21ta))).generateEphemeral();
const $c4464a626d8758b2$export$79bcd515db49ff31 = (0, $iDR1F.default)("salt");
const $c4464a626d8758b2$export$96762aac70b46352 = (0, $iDR1F.default)("serverEphemeral");
const $c4464a626d8758b2$export$4a314c097411dc17 = (0, $iDR1F.default)("proof");
const $c4464a626d8758b2$export$531a2013799771e3 = (0, $iDR1F.default)("userState");
const $c4464a626d8758b2$export$1a237e2a62b5d5c = (username, password)=>{
    const salt = (0, $01W3b.ref)("");
    const verifier = (0, $01W3b.ref)("");
    salt.value = (0, (/*@__PURE__*/$parcel$interopDefault($j21ta))).generateSalt();
    const privateKey = (0, (/*@__PURE__*/$parcel$interopDefault($j21ta))).derivePrivateKey(salt.value, username, password);
    verifier.value = (0, (/*@__PURE__*/$parcel$interopDefault($j21ta))).deriveVerifier(privateKey);
    return {
        salt: salt,
        verifier: verifier
    };
};
const $c4464a626d8758b2$export$b671a3d2844d6e42 = (options)=>{
    const username = (0, $iDR1F.default)("email", options);
    const serverSalt = (0, $iDR1F.default)("serverSalt", options);
    const serverEphemeral = (0, $iDR1F.default)("serverEphemeral", options);
    const password = (0, $iDR1F.default)("password", options);
    const clientSecret = (0, $iDR1F.default)("clientSecret", options);
    const privateKey = (0, (/*@__PURE__*/$parcel$interopDefault($j21ta))).derivePrivateKey(serverSalt, username, password);
    return (0, (/*@__PURE__*/$parcel$interopDefault($j21ta))).deriveSession(clientSecret, serverEphemeral, serverSalt, username, privateKey);
};
const $c4464a626d8758b2$export$531bc37861c26981 = (0, $lR3qp.default)({
    clientEphemeral: (0, $dnABj.default)([
        "clientEphemeral",
        "public"
    ]),
    email: (0, $iDR1F.default)("email")
});
function $c4464a626d8758b2$export$747ffc8e682cc1c() {
    const { callEndpoint: callEndpoint, endpointData: endpointData, isLoading: isLoading } = (0, $bRn2L.default)("userState");
    const { currentEmployees: currentEmployees, userState: userState, currentCourses: currentCourses, resetUserState: resetUserState } = (0, $1rS06.useGlobalState)();
    const fetch = async ()=>{
        await callEndpoint({
            method: "GET"
        }).then((response)=>{
            const userStateFromEndpoint = (0, $gzF45.isNoAuthMode)() ? (0, $1rS06.dummyUserState) : $c4464a626d8758b2$export$531a2013799771e3(response);
            if ((0, $bQytf.isNotNullAndNotEmpty)(userStateFromEndpoint)) {
                userState.value = (0, $ey2ik.default)("isAuthenticated", true, userStateFromEndpoint);
                currentEmployees.value = userStateFromEndpoint.employees;
                currentCourses.set(userStateFromEndpoint.courses);
            } else resetUserState();
        });
    };
    const response = (0, $01W3b.computed)(()=>endpointData.value);
    return {
        fetch: fetch,
        response: response,
        isLoading: isLoading
    };
}
function $c4464a626d8758b2$export$e5016cae31bd83ec() {
    const { callEndpoint: callEndpointSalt, endpointData: endpointDataSalt, userFriendlyError: userFriendlyErrorSalt, isLoading: isLoadingSalt } = (0, $bRn2L.default)("getSaltAndServerEphemeral");
    const { callEndpoint: loginFetchDataFromEndpoint, endpointData: endpointDataLogin, userFriendlyError: userFriendlyErrorLogin, isLoading: isLoadingLogin } = (0, $bRn2L.default)("login");
    const isLoading = (0, $01W3b.computed)(()=>isLoadingSalt.value || isLoadingLogin.value);
    const getUserStateFromEndpoint = async (email, password)=>{
        if ((0, $gzF45.isNoAuthMode)()) return 0, $1rS06.dummyUserState;
        const clientEphemeral = $c4464a626d8758b2$export$bd603d5283289c42();
        const requestForSalt = $c4464a626d8758b2$export$531bc37861c26981({
            clientEphemeral: clientEphemeral,
            email: email
        });
        await callEndpointSalt({
            request: requestForSalt,
            method: "POST"
        });
        if (userFriendlyErrorSalt.value) return {};
        const clientSession = $c4464a626d8758b2$export$b671a3d2844d6e42({
            email: email,
            password: password,
            serverSalt: $c4464a626d8758b2$export$79bcd515db49ff31(endpointDataSalt.value),
            serverEphemeral: $c4464a626d8758b2$export$96762aac70b46352(endpointDataSalt.value),
            clientSecret: clientEphemeral.secret
        });
        await loginFetchDataFromEndpoint({
            request: {
                proof: clientSession.proof
            },
            method: "POST"
        });
        if (userFriendlyErrorLogin.value) return {};
        const proofPayload = (0, $01W3b.toRaw)(endpointDataLogin.value);
        const serverSessionProof = $c4464a626d8758b2$export$4a314c097411dc17(proofPayload);
        (0, (/*@__PURE__*/$parcel$interopDefault($j21ta))).verifySession(clientEphemeral.public, clientSession, serverSessionProof);
        return $c4464a626d8758b2$export$531a2013799771e3(proofPayload);
    };
    return {
        getUserStateFromEndpoint: getUserStateFromEndpoint,
        isLoading: isLoading,
        userFriendlyErrorSalt: userFriendlyErrorSalt,
        userFriendlyErrorLogin: userFriendlyErrorLogin
    };
}

});
parcelRegister("j21ta", function(module, exports) {

$parcel$export(module.exports, "generateSalt", () => $ddaf5805662d07de$export$f85228abe13243ee, (v) => $ddaf5805662d07de$export$f85228abe13243ee = v);
$parcel$export(module.exports, "derivePrivateKey", () => $ddaf5805662d07de$export$c581d3211fd49b1, (v) => $ddaf5805662d07de$export$c581d3211fd49b1 = v);
$parcel$export(module.exports, "deriveVerifier", () => $ddaf5805662d07de$export$7144440dab1c1f43, (v) => $ddaf5805662d07de$export$7144440dab1c1f43 = v);
$parcel$export(module.exports, "generateEphemeral", () => $ddaf5805662d07de$export$ff1ce6bd290f64eb, (v) => $ddaf5805662d07de$export$ff1ce6bd290f64eb = v);
$parcel$export(module.exports, "deriveSession", () => $ddaf5805662d07de$export$2ef975069a72a064, (v) => $ddaf5805662d07de$export$2ef975069a72a064 = v);
$parcel$export(module.exports, "verifySession", () => $ddaf5805662d07de$export$76fde01f52932f13, (v) => $ddaf5805662d07de$export$76fde01f52932f13 = v);
var $ddaf5805662d07de$export$f85228abe13243ee;
var $ddaf5805662d07de$export$c581d3211fd49b1;
var $ddaf5805662d07de$export$7144440dab1c1f43;
var $ddaf5805662d07de$export$ff1ce6bd290f64eb;
var $ddaf5805662d07de$export$2ef975069a72a064;
var $ddaf5805662d07de$export$76fde01f52932f13;
"use strict";

var $iDilO = parcelRequire("iDilO");

var $5l41V = parcelRequire("5l41V");
$ddaf5805662d07de$export$f85228abe13243ee = function() {
    // s    User's salt
    const s = $5l41V.randomInteger($iDilO.hashOutputBytes);
    return s.toHex();
};
$ddaf5805662d07de$export$c581d3211fd49b1 = function(salt, username, password) {
    // H()  One-way hash function
    const { H: H } = $iDilO;
    // s    User's salt
    // I    Username
    // p    Cleartext Password
    const s = $5l41V.fromHex(salt);
    const I = String(username);
    const p = String(password);
    // x = H(s, H(I | ':' | p))  (s is chosen randomly)
    const x = H(s, H(`${I}:${p}`));
    return x.toHex();
};
$ddaf5805662d07de$export$7144440dab1c1f43 = function(privateKey) {
    // N    A large safe prime (N = 2q+1, where q is prime)
    // g    A generator modulo N
    const { N: N, g: g } = $iDilO;
    // x    Private key (derived from p and s)
    const x = $5l41V.fromHex(privateKey);
    // v = g^x                   (computes password verifier)
    const v = g.modPow(x, N);
    return v.toHex();
};
$ddaf5805662d07de$export$ff1ce6bd290f64eb = function() {
    // N    A large safe prime (N = 2q+1, where q is prime)
    // g    A generator modulo N
    const { N: N, g: g } = $iDilO;
    // A = g^a                  (a = random number)
    const a = $5l41V.randomInteger($iDilO.hashOutputBytes);
    const A = g.modPow(a, N);
    return {
        secret: a.toHex(),
        public: A.toHex()
    };
};
$ddaf5805662d07de$export$2ef975069a72a064 = function(clientSecretEphemeral, serverPublicEphemeral, salt, username, privateKey) {
    // N    A large safe prime (N = 2q+1, where q is prime)
    // g    A generator modulo N
    // k    Multiplier parameter (k = H(N, g) in SRP-6a, k = 3 for legacy SRP-6)
    // H()  One-way hash function
    const { N: N, g: g, k: k, H: H } = $iDilO;
    // a    Secret ephemeral values
    // B    Public ephemeral values
    // s    User's salt
    // I    Username
    // x    Private key (derived from p and s)
    const a = $5l41V.fromHex(clientSecretEphemeral);
    const B = $5l41V.fromHex(serverPublicEphemeral);
    const s = $5l41V.fromHex(salt);
    const I = String(username);
    const x = $5l41V.fromHex(privateKey);
    // A = g^a                  (a = random number)
    const A = g.modPow(a, N);
    // B % N > 0
    if (B.mod(N).equals($5l41V.ZERO)) // fixme: .code, .statusCode, etc.
    throw new Error("The server sent an invalid public ephemeral");
    // u = H(A, B)
    const u = H(A, B);
    // S = (B - kg^x) ^ (a + ux)
    const S = B.subtract(k.multiply(g.modPow(x, N))).modPow(a.add(u.multiply(x)), N);
    // K = H(S)
    const K = H(S);
    // M = H(H(N) xor H(g), H(I), s, A, B, K)
    const M = H(H(N).xor(H(g)), H(I), s, A, B, K);
    return {
        key: K.toHex(),
        proof: M.toHex()
    };
};
$ddaf5805662d07de$export$76fde01f52932f13 = function(clientPublicEphemeral, clientSession, serverSessionProof) {
    // H()  One-way hash function
    const { H: H } = $iDilO;
    // A    Public ephemeral values
    // M    Proof of K
    // K    Shared, strong session key
    const A = $5l41V.fromHex(clientPublicEphemeral);
    const M = $5l41V.fromHex(clientSession.proof);
    const K = $5l41V.fromHex(clientSession.key);
    // H(A, M, K)
    const expected = H(A, M, K);
    const actual = $5l41V.fromHex(serverSessionProof);
    if (!actual.equals(expected)) // fixme: .code, .statusCode, etc.
    throw new Error("Server provided session proof is invalid");
};

});
parcelRegister("iDilO", function(module, exports) {

$parcel$export(module.exports, "N", () => $d90a1a9da2435f6a$export$a07804094c3ecf2d, (v) => $d90a1a9da2435f6a$export$a07804094c3ecf2d = v);
$parcel$export(module.exports, "g", () => $d90a1a9da2435f6a$export$39b482c5e57630a8, (v) => $d90a1a9da2435f6a$export$39b482c5e57630a8 = v);
$parcel$export(module.exports, "k", () => $d90a1a9da2435f6a$export$342063e11d6c3cad, (v) => $d90a1a9da2435f6a$export$342063e11d6c3cad = v);
$parcel$export(module.exports, "H", () => $d90a1a9da2435f6a$export$7f8ddf7c7c20b3cd, (v) => $d90a1a9da2435f6a$export$7f8ddf7c7c20b3cd = v);
$parcel$export(module.exports, "hashOutputBytes", () => $d90a1a9da2435f6a$export$4b902235d2302757, (v) => $d90a1a9da2435f6a$export$4b902235d2302757 = v);
// N    A large safe prime (N = 2q+1, where q is prime)
// g    A generator modulo N
// k    Multiplier parameter (k = H(N, g) in SRP-6a, k = 3 for legacy SRP-6)
// H()  One-way hash function
var $d90a1a9da2435f6a$export$a07804094c3ecf2d;
var $d90a1a9da2435f6a$export$39b482c5e57630a8;
var $d90a1a9da2435f6a$export$342063e11d6c3cad;
var $d90a1a9da2435f6a$export$7f8ddf7c7c20b3cd;
var $d90a1a9da2435f6a$export$4b902235d2302757;
"use strict";

var $BE9cP = parcelRequire("BE9cP");

var $5l41V = parcelRequire("5l41V");
const $d90a1a9da2435f6a$var$input = {
    largeSafePrime: `
    AC6BDB41 324A9A9B F166DE5E 1389582F AF72B665 1987EE07 FC319294
    3DB56050 A37329CB B4A099ED 8193E075 7767A13D D52312AB 4B03310D
    CD7F48A9 DA04FD50 E8083969 EDB767B0 CF609517 9A163AB3 661A05FB
    D5FAAAE8 2918A996 2F0B93B8 55F97993 EC975EEA A80D740A DBF4FF74
    7359D041 D5C33EA7 1D281E44 6B14773B CA97B43A 23FB8016 76BD207A
    436C6481 F1D2B907 8717461A 5B9D32E6 88F87748 544523B5 24B0D57D
    5EA77A27 75D2ECFA 032CFBDB F52FB378 61602790 04E57AE6 AF874E73
    03CE5329 9CCC041C 7BC308D8 2A5698F3 A8D0C382 71AE35F8 E9DBFBB6
    94B5C803 D89F7AE4 35DE236D 525F5475 9B65E372 FCD68EF2 0FA7111F
    9E4AFF73
  `,
    generatorModulo: "02",
    hashFunction: "sha256",
    hashOutputBytes: 32
};
$d90a1a9da2435f6a$export$a07804094c3ecf2d = $5l41V.fromHex($d90a1a9da2435f6a$var$input.largeSafePrime.replace(/\s+/g, ""));
$d90a1a9da2435f6a$export$39b482c5e57630a8 = $5l41V.fromHex($d90a1a9da2435f6a$var$input.generatorModulo.replace(/\s+/g, ""));
$d90a1a9da2435f6a$export$342063e11d6c3cad = $BE9cP($d90a1a9da2435f6a$export$a07804094c3ecf2d, $d90a1a9da2435f6a$export$39b482c5e57630a8);
$d90a1a9da2435f6a$export$7f8ddf7c7c20b3cd = $BE9cP;
$d90a1a9da2435f6a$export$4b902235d2302757 = $d90a1a9da2435f6a$var$input.hashOutputBytes;

});
parcelRegister("BE9cP", function(module, exports) {
"use strict";

var $78IXs = parcelRequire("78IXs");

var $fB3iO = parcelRequire("fB3iO");

var $5c0Ab = parcelRequire("5c0Ab");

var $co2BW = parcelRequire("co2BW");

var $5l41V = parcelRequire("5l41V");
function $0712994514d52bc5$var$concat(buffers) {
    const length = buffers.reduce((mem, item)=>mem + item.byteLength, 0);
    const combined = new Uint8Array(length);
    buffers.reduce((offset, item)=>{
        combined.set(new Uint8Array(item), offset);
        return offset + item.byteLength;
    }, 0);
    return combined.buffer;
}
module.exports = function sha256(...args) {
    const buffer = $0712994514d52bc5$var$concat(args.map((arg)=>{
        if (arg instanceof $5l41V) return $5c0Ab(arg.toHex());
        else if (typeof arg === "string") return $fB3iO(arg);
        else throw new TypeError("Expected string or SRPInteger");
    }));
    return $5l41V.fromHex($78IXs($co2BW(buffer)));
};

});
parcelRegister("78IXs", function(module, exports) {
module.exports = function arrayBufferToHex(arrayBuffer) {
    if (typeof arrayBuffer !== "object" || arrayBuffer === null || typeof arrayBuffer.byteLength !== "number") throw new TypeError("Expected input to be an ArrayBuffer");
    var view = new Uint8Array(arrayBuffer);
    var result = "";
    var value;
    for(var i = 0; i < view.length; i++){
        value = view[i].toString(16);
        result += value.length === 1 ? "0" + value : value;
    }
    return result;
};

});

parcelRegister("fB3iO", function(module, exports) {
"use strict";
module.exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};

});

parcelRegister("5c0Ab", function(module, exports) {
module.exports = function hexToArrayBuffer(hex) {
    if (typeof hex !== "string") throw new TypeError("Expected input to be a string");
    if (hex.length % 2 !== 0) throw new RangeError("Expected string to be an even number of characters");
    var view = new Uint8Array(hex.length / 2);
    for(var i = 0; i < hex.length; i += 2)view[i / 2] = parseInt(hex.substring(i, i + 2), 16);
    return view.buffer;
};

});

parcelRegister("co2BW", function(module, exports) {
"use strict";
const $9049c067848dcb9b$var$K = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function $9049c067848dcb9b$var$hashBlocks(w, v, p) {
    let a, b, c, d, e, f, g, h, u, i, j, t1, t2;
    let position = 0;
    let length = p.length;
    while(length >= 64){
        a = v[0];
        b = v[1];
        c = v[2];
        d = v[3];
        e = v[4];
        f = v[5];
        g = v[6];
        h = v[7];
        for(i = 0; i < 16; i++){
            j = position + i * 4;
            w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
        }
        for(i = 16; i < 64; i++){
            u = w[i - 2];
            t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(i = 0; i < 64; i++){
            t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + ($9049c067848dcb9b$var$K[i] + w[i] | 0) | 0) | 0;
            t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        position += 64;
        length -= 64;
    }
}
function $9049c067848dcb9b$var$buildPadding(data) {
    const dataLength = data.length;
    const trailerLength = dataLength % 64;
    const paddingLength = dataLength % 64 < 56 ? 64 : 128;
    const padding = new Uint8Array(paddingLength);
    const bitLenHi = dataLength / 0x20000000 | 0;
    const bitLenLo = dataLength << 3;
    padding.set(data.subarray(dataLength - trailerLength));
    padding[trailerLength] = 0x80;
    padding[paddingLength - 8] = bitLenHi >>> 24 & 0xff;
    padding[paddingLength - 7] = bitLenHi >>> 16 & 0xff;
    padding[paddingLength - 6] = bitLenHi >>> 8 & 0xff;
    padding[paddingLength - 5] = bitLenHi >>> 0 & 0xff;
    padding[paddingLength - 4] = bitLenLo >>> 24 & 0xff;
    padding[paddingLength - 3] = bitLenLo >>> 16 & 0xff;
    padding[paddingLength - 2] = bitLenLo >>> 8 & 0xff;
    padding[paddingLength - 1] = bitLenLo >>> 0 & 0xff;
    return padding;
}
module.exports = function sha256(buffer) {
    const state = new Int32Array(8);
    const temp = new Int32Array(64);
    state[0] = 0x6a09e667;
    state[1] = 0xbb67ae85;
    state[2] = 0x3c6ef372;
    state[3] = 0xa54ff53a;
    state[4] = 0x510e527f;
    state[5] = 0x9b05688c;
    state[6] = 0x1f83d9ab;
    state[7] = 0x5be0cd19;
    const data = new Uint8Array(buffer);
    const padding = $9049c067848dcb9b$var$buildPadding(data);
    $9049c067848dcb9b$var$hashBlocks(temp, state, data);
    $9049c067848dcb9b$var$hashBlocks(temp, state, padding);
    const output = new Uint8Array(32);
    for(let i = 0; i < 8; i++){
        output[i * 4 + 0] = state[i] >>> 24 & 0xff;
        output[i * 4 + 1] = state[i] >>> 16 & 0xff;
        output[i * 4 + 2] = state[i] >>> 8 & 0xff;
        output[i * 4 + 3] = state[i] >>> 0 & 0xff;
    }
    return output.buffer;
};

});

parcelRegister("5l41V", function(module, exports) {
"use strict";

var $4GUYb = parcelRequire("4GUYb");

var $9Mr0P = parcelRequire("9Mr0P");

var $coNJ9 = parcelRequire("coNJ9");
var $3e320a2e20bd05f4$require$BigInteger = $coNJ9.BigInteger;
const $3e320a2e20bd05f4$var$kBigInteger = Symbol("big-integer");
const $3e320a2e20bd05f4$var$kHexLength = Symbol("hex-length");
class $3e320a2e20bd05f4$var$SRPInteger {
    constructor(bigInteger, hexLength){
        this[$3e320a2e20bd05f4$var$kBigInteger] = bigInteger;
        this[$3e320a2e20bd05f4$var$kHexLength] = hexLength;
    }
    add(val) {
        return new $3e320a2e20bd05f4$var$SRPInteger(this[$3e320a2e20bd05f4$var$kBigInteger].add(val[$3e320a2e20bd05f4$var$kBigInteger]), null);
    }
    equals(val) {
        return this[$3e320a2e20bd05f4$var$kBigInteger].equals(val[$3e320a2e20bd05f4$var$kBigInteger]);
    }
    multiply(val) {
        return new $3e320a2e20bd05f4$var$SRPInteger(this[$3e320a2e20bd05f4$var$kBigInteger].multiply(val[$3e320a2e20bd05f4$var$kBigInteger]), null);
    }
    modPow(exponent, m) {
        return new $3e320a2e20bd05f4$var$SRPInteger(this[$3e320a2e20bd05f4$var$kBigInteger].modPow(exponent[$3e320a2e20bd05f4$var$kBigInteger], m[$3e320a2e20bd05f4$var$kBigInteger]), m[$3e320a2e20bd05f4$var$kHexLength]);
    }
    mod(m) {
        return new $3e320a2e20bd05f4$var$SRPInteger(this[$3e320a2e20bd05f4$var$kBigInteger].mod(m[$3e320a2e20bd05f4$var$kBigInteger]), m[$3e320a2e20bd05f4$var$kHexLength]);
    }
    subtract(val) {
        return new $3e320a2e20bd05f4$var$SRPInteger(this[$3e320a2e20bd05f4$var$kBigInteger].subtract(val[$3e320a2e20bd05f4$var$kBigInteger]), this[$3e320a2e20bd05f4$var$kHexLength]);
    }
    xor(val) {
        return new $3e320a2e20bd05f4$var$SRPInteger(this[$3e320a2e20bd05f4$var$kBigInteger].xor(val[$3e320a2e20bd05f4$var$kBigInteger]), this[$3e320a2e20bd05f4$var$kHexLength]);
    }
    inspect() {
        const hex = this[$3e320a2e20bd05f4$var$kBigInteger].toString(16);
        return `<SRPInteger ${hex.slice(0, 16)}${hex.length > 16 ? "..." : ""}>`;
    }
    toHex() {
        if (this[$3e320a2e20bd05f4$var$kHexLength] === null) throw new Error("This SRPInteger has no specified length");
        return $4GUYb(this[$3e320a2e20bd05f4$var$kBigInteger].toString(16), this[$3e320a2e20bd05f4$var$kHexLength], "0");
    }
}
$3e320a2e20bd05f4$var$SRPInteger.fromHex = function(input) {
    return new $3e320a2e20bd05f4$var$SRPInteger(new $3e320a2e20bd05f4$require$BigInteger(input, 16), input.length);
};
$3e320a2e20bd05f4$var$SRPInteger.randomInteger = function(bytes) {
    return $3e320a2e20bd05f4$var$SRPInteger.fromHex($9Mr0P(bytes));
};
$3e320a2e20bd05f4$var$SRPInteger.ZERO = new $3e320a2e20bd05f4$var$SRPInteger(new $3e320a2e20bd05f4$require$BigInteger("0"), null);
module.exports = $3e320a2e20bd05f4$var$SRPInteger;

});
parcelRegister("4GUYb", function(module, exports) {
"use strict";
module.exports = function(string, maxLength, fillString) {
    if (string == null || maxLength == null) return string;
    var result = String(string);
    var targetLen = typeof maxLength === "number" ? maxLength : parseInt(maxLength, 10);
    if (isNaN(targetLen) || !isFinite(targetLen)) return result;
    var length = result.length;
    if (length >= targetLen) return result;
    var fill = fillString == null ? "" : String(fillString);
    if (fill === "") fill = " ";
    var fillLen = targetLen - length;
    while(fill.length < fillLen)fill += fill;
    var truncated = fill.length > fillLen ? fill.substr(0, fillLen) : fill;
    return truncated + result;
};

});

parcelRegister("9Mr0P", function(module, exports) {
/* globals crypto msCrypto */ "use strict";

var $78IXs = parcelRequire("78IXs");
module.exports = function randomHex(bytes) {
    const view = new Uint8Array(bytes);
    if (typeof crypto === "object" && typeof crypto.getRandomValues === "function") crypto.getRandomValues(view);
    else if (typeof msCrypto === "object" && typeof msCrypto.getRandomValues === "function") msCrypto.getRandomValues(view);
    else throw new Error("No secure random number generator available");
    return $78IXs(view.buffer);
};

});

parcelRegister("coNJ9", function(module, exports) {
(function() {
    // Copyright (c) 2005  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Basic JavaScript BN library - subset useful for RSA encryption.
    // Bits per digit
    var dbits;
    // JavaScript engine analysis
    var canary = 0xdeadbeefcafe;
    var j_lm = (canary & 0xffffff) == 0xefcafe;
    // (public) Constructor
    function BigInteger(a, b, c) {
        if (a != null) {
            if ("number" == typeof a) this.fromNumber(a, b, c);
            else if (b == null && "string" != typeof a) this.fromString(a, 256);
            else this.fromString(a, b);
        }
    }
    // return new, unset BigInteger
    function nbi() {
        return new BigInteger(null);
    }
    // am: Compute w_j += (x*this_i), propagate carries,
    // c is initial carry, returns final carry.
    // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
    // We need to select the fastest one that works in this environment.
    // am1: use a single mult and divide to get the high bits,
    // max digit bits should be 26 because
    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
    function am1(i, x, w, j, c, n) {
        while(--n >= 0){
            var v = x * this[i++] + w[j] + c;
            c = Math.floor(v / 0x4000000);
            w[j++] = v & 0x3ffffff;
        }
        return c;
    }
    // am2 avoids a big mult-and-extract completely.
    // Max digit bits should be <= 30 because we do bitwise ops
    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
    function am2(i, x, w, j, c, n) {
        var xl = x & 0x7fff, xh = x >> 15;
        while(--n >= 0){
            var l = this[i] & 0x7fff;
            var h = this[i++] >> 15;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
            c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
            w[j++] = l & 0x3fffffff;
        }
        return c;
    }
    // Alternately, set max digit bits to 28 since some
    // browsers slow down when dealing with 32-bit numbers.
    function am3(i, x, w, j, c, n) {
        var xl = x & 0x3fff, xh = x >> 14;
        while(--n >= 0){
            var l = this[i] & 0x3fff;
            var h = this[i++] >> 14;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
            c = (l >> 28) + (m >> 14) + xh * h;
            w[j++] = l & 0xfffffff;
        }
        return c;
    }
    var inBrowser = typeof navigator !== "undefined";
    if (inBrowser && j_lm && navigator.appName == "Microsoft Internet Explorer") {
        BigInteger.prototype.am = am2;
        dbits = 30;
    } else if (inBrowser && j_lm && navigator.appName != "Netscape") {
        BigInteger.prototype.am = am1;
        dbits = 26;
    } else {
        BigInteger.prototype.am = am3;
        dbits = 28;
    }
    BigInteger.prototype.DB = dbits;
    BigInteger.prototype.DM = (1 << dbits) - 1;
    BigInteger.prototype.DV = 1 << dbits;
    var BI_FP = 52;
    BigInteger.prototype.FV = Math.pow(2, BI_FP);
    BigInteger.prototype.F1 = BI_FP - dbits;
    BigInteger.prototype.F2 = 2 * dbits - BI_FP;
    // Digit conversions
    var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
    var BI_RC = new Array();
    var rr, vv;
    rr = "0".charCodeAt(0);
    for(vv = 0; vv <= 9; ++vv)BI_RC[rr++] = vv;
    rr = "a".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    rr = "A".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    function int2char(n) {
        return BI_RM.charAt(n);
    }
    function intAt(s, i) {
        var c = BI_RC[s.charCodeAt(i)];
        return c == null ? -1 : c;
    }
    // (protected) copy this to r
    function bnpCopyTo(r) {
        for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
        r.t = this.t;
        r.s = this.s;
    }
    // (protected) set from integer value x, -DV <= x < DV
    function bnpFromInt(x) {
        this.t = 1;
        this.s = x < 0 ? -1 : 0;
        if (x > 0) this[0] = x;
        else if (x < -1) this[0] = x + this.DV;
        else this.t = 0;
    }
    // return bigint initialized to value
    function nbv(i) {
        var r = nbi();
        r.fromInt(i);
        return r;
    }
    // (protected) set from string and radix
    function bnpFromString(s, b) {
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 256) k = 8; // byte array
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else {
            this.fromRadix(s, b);
            return;
        }
        this.t = 0;
        this.s = 0;
        var i = s.length, mi = false, sh = 0;
        while(--i >= 0){
            var x = k == 8 ? s[i] & 0xff : intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-") mi = true;
                continue;
            }
            mi = false;
            if (sh == 0) this[this.t++] = x;
            else if (sh + k > this.DB) {
                this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
                this[this.t++] = x >> this.DB - sh;
            } else this[this.t - 1] |= x << sh;
            sh += k;
            if (sh >= this.DB) sh -= this.DB;
        }
        if (k == 8 && (s[0] & 0x80) != 0) {
            this.s = -1;
            if (sh > 0) this[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
        }
        this.clamp();
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) clamp off excess high words
    function bnpClamp() {
        var c = this.s & this.DM;
        while(this.t > 0 && this[this.t - 1] == c)--this.t;
    }
    // (public) return string representation in given radix
    function bnToString(b) {
        if (this.s < 0) return "-" + this.negate().toString(b);
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else return this.toRadix(b);
        var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
        var p = this.DB - i * this.DB % k;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) > 0) {
                m = true;
                r = int2char(d);
            }
            while(i >= 0){
                if (p < k) {
                    d = (this[i] & (1 << p) - 1) << k - p;
                    d |= this[--i] >> (p += this.DB - k);
                } else {
                    d = this[i] >> (p -= k) & km;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if (d > 0) m = true;
                if (m) r += int2char(d);
            }
        }
        return m ? r : "0";
    }
    // (public) -this
    function bnNegate() {
        var r = nbi();
        BigInteger.ZERO.subTo(this, r);
        return r;
    }
    // (public) |this|
    function bnAbs() {
        return this.s < 0 ? this.negate() : this;
    }
    // (public) return + if this > a, - if this < a, 0 if equal
    function bnCompareTo(a) {
        var r = this.s - a.s;
        if (r != 0) return r;
        var i = this.t;
        r = i - a.t;
        if (r != 0) return this.s < 0 ? -r : r;
        while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
        return 0;
    }
    // returns bit length of the integer x
    function nbits(x) {
        var r = 1, t;
        if ((t = x >>> 16) != 0) {
            x = t;
            r += 16;
        }
        if ((t = x >> 8) != 0) {
            x = t;
            r += 8;
        }
        if ((t = x >> 4) != 0) {
            x = t;
            r += 4;
        }
        if ((t = x >> 2) != 0) {
            x = t;
            r += 2;
        }
        if ((t = x >> 1) != 0) {
            x = t;
            r += 1;
        }
        return r;
    }
    // (public) return the number of bits in "this"
    function bnBitLength() {
        if (this.t <= 0) return 0;
        return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
    }
    // (protected) r = this << n*DB
    function bnpDLShiftTo(n, r) {
        var i;
        for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
        for(i = n - 1; i >= 0; --i)r[i] = 0;
        r.t = this.t + n;
        r.s = this.s;
    }
    // (protected) r = this >> n*DB
    function bnpDRShiftTo(n, r) {
        for(var i = n; i < this.t; ++i)r[i - n] = this[i];
        r.t = Math.max(this.t - n, 0);
        r.s = this.s;
    }
    // (protected) r = this << n
    function bnpLShiftTo(n, r) {
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << cbs) - 1;
        var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
        for(i = this.t - 1; i >= 0; --i){
            r[i + ds + 1] = this[i] >> cbs | c;
            c = (this[i] & bm) << bs;
        }
        for(i = ds - 1; i >= 0; --i)r[i] = 0;
        r[ds] = c;
        r.t = this.t + ds + 1;
        r.s = this.s;
        r.clamp();
    }
    // (protected) r = this >> n
    function bnpRShiftTo(n, r) {
        r.s = this.s;
        var ds = Math.floor(n / this.DB);
        if (ds >= this.t) {
            r.t = 0;
            return;
        }
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << bs) - 1;
        r[0] = this[ds] >> bs;
        for(var i = ds + 1; i < this.t; ++i){
            r[i - ds - 1] |= (this[i] & bm) << cbs;
            r[i - ds] = this[i] >> bs;
        }
        if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
        r.t = this.t - ds;
        r.clamp();
    }
    // (protected) r = this - a
    function bnpSubTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] - a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c -= a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c -= a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c -= a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c < -1) r[i++] = this.DV + c;
        else if (c > 0) r[i++] = c;
        r.t = i;
        r.clamp();
    }
    // (protected) r = this * a, r != this,a (HAC 14.12)
    // "this" should be the larger one if appropriate.
    function bnpMultiplyTo(a, r) {
        var x = this.abs(), y = a.abs();
        var i = x.t;
        r.t = i + y.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
        r.s = 0;
        r.clamp();
        if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
    }
    // (protected) r = this^2, r != this (HAC 14.16)
    function bnpSquareTo(r) {
        var x = this.abs();
        var i = r.t = 2 * x.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < x.t - 1; ++i){
            var c = x.am(i, x[i], r, 2 * i, 0, 1);
            if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                r[i + x.t] -= x.DV;
                r[i + x.t + 1] = 1;
            }
        }
        if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
        r.s = 0;
        r.clamp();
    }
    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
    // r != q, this != m.  q or r may be null.
    function bnpDivRemTo(m, q, r) {
        var pm = m.abs();
        if (pm.t <= 0) return;
        var pt = this.abs();
        if (pt.t < pm.t) {
            if (q != null) q.fromInt(0);
            if (r != null) this.copyTo(r);
            return;
        }
        if (r == null) r = nbi();
        var y = nbi(), ts = this.s, ms = m.s;
        var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
        if (nsh > 0) {
            pm.lShiftTo(nsh, y);
            pt.lShiftTo(nsh, r);
        } else {
            pm.copyTo(y);
            pt.copyTo(r);
        }
        var ys = y.t;
        var y0 = y[ys - 1];
        if (y0 == 0) return;
        var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
        var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
        var i = r.t, j = i - ys, t = q == null ? nbi() : q;
        y.dlShiftTo(j, t);
        if (r.compareTo(t) >= 0) {
            r[r.t++] = 1;
            r.subTo(t, r);
        }
        BigInteger.ONE.dlShiftTo(ys, t);
        t.subTo(y, y); // "negative" y so we can replace sub with am later
        while(y.t < ys)y[y.t++] = 0;
        while(--j >= 0){
            // Estimate quotient digit
            var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
            if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
                y.dlShiftTo(j, t);
                r.subTo(t, r);
                while(r[i] < --qd)r.subTo(t, r);
            }
        }
        if (q != null) {
            r.drShiftTo(ys, q);
            if (ts != ms) BigInteger.ZERO.subTo(q, q);
        }
        r.t = ys;
        r.clamp();
        if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
        if (ts < 0) BigInteger.ZERO.subTo(r, r);
    }
    // (public) this mod a
    function bnMod(a) {
        var r = nbi();
        this.abs().divRemTo(a, null, r);
        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
        return r;
    }
    // Modular reduction using "classic" algorithm
    function Classic(m) {
        this.m = m;
    }
    function cConvert(x) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
        else return x;
    }
    function cRevert(x) {
        return x;
    }
    function cReduce(x) {
        x.divRemTo(this.m, null, x);
    }
    function cMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    function cSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    Classic.prototype.convert = cConvert;
    Classic.prototype.revert = cRevert;
    Classic.prototype.reduce = cReduce;
    Classic.prototype.mulTo = cMulTo;
    Classic.prototype.sqrTo = cSqrTo;
    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
    // justification:
    //         xy == 1 (mod m)
    //         xy =  1+km
    //   xy(2-xy) = (1+km)(1-km)
    // x[y(2-xy)] = 1-k^2m^2
    // x[y(2-xy)] == 1 (mod m^2)
    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
    // JS multiply "overflows" differently from C/C++, so care is needed here.
    function bnpInvDigit() {
        if (this.t < 1) return 0;
        var x = this[0];
        if ((x & 1) == 0) return 0;
        var y = x & 3; // y == 1/x mod 2^2
        y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
        y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
        y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
        // last step - calculate inverse mod DV directly;
        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
        y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
        // we really want the negative inverse, and -DV < y < DV
        return y > 0 ? this.DV - y : -y;
    }
    // Montgomery reduction
    function Montgomery(m) {
        this.m = m;
        this.mp = m.invDigit();
        this.mpl = this.mp & 0x7fff;
        this.mph = this.mp >> 15;
        this.um = (1 << m.DB - 15) - 1;
        this.mt2 = 2 * m.t;
    }
    // xR mod m
    function montConvert(x) {
        var r = nbi();
        x.abs().dlShiftTo(this.m.t, r);
        r.divRemTo(this.m, null, r);
        if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
        return r;
    }
    // x/R mod m
    function montRevert(x) {
        var r = nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
    // x = x/R mod m (HAC 14.32)
    function montReduce(x) {
        while(x.t <= this.mt2)x[x.t++] = 0;
        for(var i = 0; i < this.m.t; ++i){
            // faster way of calculating u0 = x[i]*mp mod DV
            var j = x[i] & 0x7fff;
            var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
            // use am to combine the multiply-shift-add into one call
            j = i + this.m.t;
            x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
            // propagate carry
            while(x[j] >= x.DV){
                x[j] -= x.DV;
                x[++j]++;
            }
        }
        x.clamp();
        x.drShiftTo(this.m.t, x);
        if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
    }
    // r = "x^2/R mod m"; x != r
    function montSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = "xy/R mod m"; x,y != r
    function montMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Montgomery.prototype.convert = montConvert;
    Montgomery.prototype.revert = montRevert;
    Montgomery.prototype.reduce = montReduce;
    Montgomery.prototype.mulTo = montMulTo;
    Montgomery.prototype.sqrTo = montSqrTo;
    // (protected) true iff this is even
    function bnpIsEven() {
        return (this.t > 0 ? this[0] & 1 : this.s) == 0;
    }
    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
    function bnpExp(e, z) {
        if (e > 0xffffffff || e < 1) return BigInteger.ONE;
        var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e) - 1;
        g.copyTo(r);
        while(--i >= 0){
            z.sqrTo(r, r2);
            if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
            else {
                var t = r;
                r = r2;
                r2 = t;
            }
        }
        return z.revert(r);
    }
    // (public) this^e % m, 0 <= e < 2^32
    function bnModPowInt(e, m) {
        var z;
        if (e < 256 || m.isEven()) z = new Classic(m);
        else z = new Montgomery(m);
        return this.exp(e, z);
    }
    // protected
    BigInteger.prototype.copyTo = bnpCopyTo;
    BigInteger.prototype.fromInt = bnpFromInt;
    BigInteger.prototype.fromString = bnpFromString;
    BigInteger.prototype.clamp = bnpClamp;
    BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
    BigInteger.prototype.drShiftTo = bnpDRShiftTo;
    BigInteger.prototype.lShiftTo = bnpLShiftTo;
    BigInteger.prototype.rShiftTo = bnpRShiftTo;
    BigInteger.prototype.subTo = bnpSubTo;
    BigInteger.prototype.multiplyTo = bnpMultiplyTo;
    BigInteger.prototype.squareTo = bnpSquareTo;
    BigInteger.prototype.divRemTo = bnpDivRemTo;
    BigInteger.prototype.invDigit = bnpInvDigit;
    BigInteger.prototype.isEven = bnpIsEven;
    BigInteger.prototype.exp = bnpExp;
    // public
    BigInteger.prototype.toString = bnToString;
    BigInteger.prototype.negate = bnNegate;
    BigInteger.prototype.abs = bnAbs;
    BigInteger.prototype.compareTo = bnCompareTo;
    BigInteger.prototype.bitLength = bnBitLength;
    BigInteger.prototype.mod = bnMod;
    BigInteger.prototype.modPowInt = bnModPowInt;
    // "constants"
    BigInteger.ZERO = nbv(0);
    BigInteger.ONE = nbv(1);
    // Copyright (c) 2005-2009  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Extended JavaScript BN functions, required for RSA private ops.
    // Version 1.1: new BigInteger("0", 10) returns "proper" zero
    // Version 1.2: square() API, isProbablePrime fix
    // (public)
    function bnClone() {
        var r = nbi();
        this.copyTo(r);
        return r;
    }
    // (public) return value as integer
    function bnIntValue() {
        if (this.s < 0) {
            if (this.t == 1) return this[0] - this.DV;
            else if (this.t == 0) return -1;
        } else if (this.t == 1) return this[0];
        else if (this.t == 0) return 0;
        // assumes 16 < DB < 32
        return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
    }
    // (public) return value as byte
    function bnByteValue() {
        return this.t == 0 ? this.s : this[0] << 24 >> 24;
    }
    // (public) return value as short (assumes DB>=16)
    function bnShortValue() {
        return this.t == 0 ? this.s : this[0] << 16 >> 16;
    }
    // (protected) return x s.t. r^x < DV
    function bnpChunkSize(r) {
        return Math.floor(Math.LN2 * this.DB / Math.log(r));
    }
    // (public) 0 if this == 0, 1 if this > 0
    function bnSigNum() {
        if (this.s < 0) return -1;
        else if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;
        else return 1;
    }
    // (protected) convert to radix string
    function bnpToRadix(b) {
        if (b == null) b = 10;
        if (this.signum() == 0 || b < 2 || b > 36) return "0";
        var cs = this.chunkSize(b);
        var a = Math.pow(b, cs);
        var d = nbv(a), y = nbi(), z = nbi(), r = "";
        this.divRemTo(d, y, z);
        while(y.signum() > 0){
            r = (a + z.intValue()).toString(b).substr(1) + r;
            y.divRemTo(d, y, z);
        }
        return z.intValue().toString(b) + r;
    }
    // (protected) convert from radix string
    function bnpFromRadix(s, b) {
        this.fromInt(0);
        if (b == null) b = 10;
        var cs = this.chunkSize(b);
        var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
        for(var i = 0; i < s.length; ++i){
            var x = intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
                continue;
            }
            w = b * w + x;
            if (++j >= cs) {
                this.dMultiply(d);
                this.dAddOffset(w, 0);
                j = 0;
                w = 0;
            }
        }
        if (j > 0) {
            this.dMultiply(Math.pow(b, j));
            this.dAddOffset(w, 0);
        }
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) alternate constructor
    function bnpFromNumber(a, b, c) {
        if ("number" == typeof b) {
            // new BigInteger(int,int,RNG)
            if (a < 2) this.fromInt(1);
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
                if (this.isEven()) this.dAddOffset(1, 0); // force odd
                while(!this.isProbablePrime(b)){
                    this.dAddOffset(2, 0);
                    if (this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
                }
            }
        } else {
            // new BigInteger(int,RNG)
            var x = new Array(), t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) x[0] &= (1 << t) - 1;
            else x[0] = 0;
            this.fromString(x, 256);
        }
    }
    // (public) convert to bigendian byte array
    function bnToByteArray() {
        var i = this.t, r = new Array();
        r[0] = this.s;
        var p = this.DB - i * this.DB % 8, d, k = 0;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
            while(i >= 0){
                if (p < 8) {
                    d = (this[i] & (1 << p) - 1) << 8 - p;
                    d |= this[--i] >> (p += this.DB - 8);
                } else {
                    d = this[i] >> (p -= 8) & 0xff;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if ((d & 0x80) != 0) d |= -256;
                if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
                if (k > 0 || d != this.s) r[k++] = d;
            }
        }
        return r;
    }
    function bnEquals(a) {
        return this.compareTo(a) == 0;
    }
    function bnMin(a) {
        return this.compareTo(a) < 0 ? this : a;
    }
    function bnMax(a) {
        return this.compareTo(a) > 0 ? this : a;
    }
    // (protected) r = this op a (bitwise)
    function bnpBitwiseTo(a, op, r) {
        var i, f, m = Math.min(a.t, this.t);
        for(i = 0; i < m; ++i)r[i] = op(this[i], a[i]);
        if (a.t < this.t) {
            f = a.s & this.DM;
            for(i = m; i < this.t; ++i)r[i] = op(this[i], f);
            r.t = this.t;
        } else {
            f = this.s & this.DM;
            for(i = m; i < a.t; ++i)r[i] = op(f, a[i]);
            r.t = a.t;
        }
        r.s = op(this.s, a.s);
        r.clamp();
    }
    // (public) this & a
    function op_and(x, y) {
        return x & y;
    }
    function bnAnd(a) {
        var r = nbi();
        this.bitwiseTo(a, op_and, r);
        return r;
    }
    // (public) this | a
    function op_or(x, y) {
        return x | y;
    }
    function bnOr(a) {
        var r = nbi();
        this.bitwiseTo(a, op_or, r);
        return r;
    }
    // (public) this ^ a
    function op_xor(x, y) {
        return x ^ y;
    }
    function bnXor(a) {
        var r = nbi();
        this.bitwiseTo(a, op_xor, r);
        return r;
    }
    // (public) this & ~a
    function op_andnot(x, y) {
        return x & ~y;
    }
    function bnAndNot(a) {
        var r = nbi();
        this.bitwiseTo(a, op_andnot, r);
        return r;
    }
    // (public) ~this
    function bnNot() {
        var r = nbi();
        for(var i = 0; i < this.t; ++i)r[i] = this.DM & ~this[i];
        r.t = this.t;
        r.s = ~this.s;
        return r;
    }
    // (public) this << n
    function bnShiftLeft(n) {
        var r = nbi();
        if (n < 0) this.rShiftTo(-n, r);
        else this.lShiftTo(n, r);
        return r;
    }
    // (public) this >> n
    function bnShiftRight(n) {
        var r = nbi();
        if (n < 0) this.lShiftTo(-n, r);
        else this.rShiftTo(n, r);
        return r;
    }
    // return index of lowest 1-bit in x, x < 2^31
    function lbit(x) {
        if (x == 0) return -1;
        var r = 0;
        if ((x & 0xffff) == 0) {
            x >>= 16;
            r += 16;
        }
        if ((x & 0xff) == 0) {
            x >>= 8;
            r += 8;
        }
        if ((x & 0xf) == 0) {
            x >>= 4;
            r += 4;
        }
        if ((x & 3) == 0) {
            x >>= 2;
            r += 2;
        }
        if ((x & 1) == 0) ++r;
        return r;
    }
    // (public) returns index of lowest 1-bit (or -1 if none)
    function bnGetLowestSetBit() {
        for(var i = 0; i < this.t; ++i)if (this[i] != 0) return i * this.DB + lbit(this[i]);
        if (this.s < 0) return this.t * this.DB;
        return -1;
    }
    // return number of 1 bits in x
    function cbit(x) {
        var r = 0;
        while(x != 0){
            x &= x - 1;
            ++r;
        }
        return r;
    }
    // (public) return number of set bits
    function bnBitCount() {
        var r = 0, x = this.s & this.DM;
        for(var i = 0; i < this.t; ++i)r += cbit(this[i] ^ x);
        return r;
    }
    // (public) true iff nth bit is set
    function bnTestBit(n) {
        var j = Math.floor(n / this.DB);
        if (j >= this.t) return this.s != 0;
        return (this[j] & 1 << n % this.DB) != 0;
    }
    // (protected) this op (1<<n)
    function bnpChangeBit(n, op) {
        var r = BigInteger.ONE.shiftLeft(n);
        this.bitwiseTo(r, op, r);
        return r;
    }
    // (public) this | (1<<n)
    function bnSetBit(n) {
        return this.changeBit(n, op_or);
    }
    // (public) this & ~(1<<n)
    function bnClearBit(n) {
        return this.changeBit(n, op_andnot);
    }
    // (public) this ^ (1<<n)
    function bnFlipBit(n) {
        return this.changeBit(n, op_xor);
    }
    // (protected) r = this + a
    function bnpAddTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] + a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c += a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c += a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c > 0) r[i++] = c;
        else if (c < -1) r[i++] = this.DV + c;
        r.t = i;
        r.clamp();
    }
    // (public) this + a
    function bnAdd(a) {
        var r = nbi();
        this.addTo(a, r);
        return r;
    }
    // (public) this - a
    function bnSubtract(a) {
        var r = nbi();
        this.subTo(a, r);
        return r;
    }
    // (public) this * a
    function bnMultiply(a) {
        var r = nbi();
        this.multiplyTo(a, r);
        return r;
    }
    // (public) this^2
    function bnSquare() {
        var r = nbi();
        this.squareTo(r);
        return r;
    }
    // (public) this / a
    function bnDivide(a) {
        var r = nbi();
        this.divRemTo(a, r, null);
        return r;
    }
    // (public) this % a
    function bnRemainder(a) {
        var r = nbi();
        this.divRemTo(a, null, r);
        return r;
    }
    // (public) [this/a,this%a]
    function bnDivideAndRemainder(a) {
        var q = nbi(), r = nbi();
        this.divRemTo(a, q, r);
        return new Array(q, r);
    }
    // (protected) this *= n, this >= 0, 1 < n < DV
    function bnpDMultiply(n) {
        this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
        ++this.t;
        this.clamp();
    }
    // (protected) this += n << w words, this >= 0
    function bnpDAddOffset(n, w) {
        if (n == 0) return;
        while(this.t <= w)this[this.t++] = 0;
        this[w] += n;
        while(this[w] >= this.DV){
            this[w] -= this.DV;
            if (++w >= this.t) this[this.t++] = 0;
            ++this[w];
        }
    }
    // A "null" reducer
    function NullExp() {}
    function nNop(x) {
        return x;
    }
    function nMulTo(x, y, r) {
        x.multiplyTo(y, r);
    }
    function nSqrTo(x, r) {
        x.squareTo(r);
    }
    NullExp.prototype.convert = nNop;
    NullExp.prototype.revert = nNop;
    NullExp.prototype.mulTo = nMulTo;
    NullExp.prototype.sqrTo = nSqrTo;
    // (public) this^e
    function bnPow(e) {
        return this.exp(e, new NullExp());
    }
    // (protected) r = lower n words of "this * a", a.t <= n
    // "this" should be the larger one if appropriate.
    function bnpMultiplyLowerTo(a, n, r) {
        var i = Math.min(this.t + a.t, n);
        r.s = 0; // assumes a,this >= 0
        r.t = i;
        while(i > 0)r[--i] = 0;
        var j;
        for(j = r.t - this.t; i < j; ++i)r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
        for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a[i], r, i, 0, n - i);
        r.clamp();
    }
    // (protected) r = "this * a" without lower n words, n > 0
    // "this" should be the larger one if appropriate.
    function bnpMultiplyUpperTo(a, n, r) {
        --n;
        var i = r.t = this.t + a.t - n;
        r.s = 0; // assumes a,this >= 0
        while(--i >= 0)r[i] = 0;
        for(i = Math.max(n - this.t, 0); i < a.t; ++i)r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
        r.clamp();
        r.drShiftTo(1, r);
    }
    // Barrett modular reduction
    function Barrett(m) {
        // setup Barrett
        this.r2 = nbi();
        this.q3 = nbi();
        BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
        this.mu = this.r2.divide(m);
        this.m = m;
    }
    function barrettConvert(x) {
        if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
        else if (x.compareTo(this.m) < 0) return x;
        else {
            var r = nbi();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }
    }
    function barrettRevert(x) {
        return x;
    }
    // x = x mod m (HAC 14.42)
    function barrettReduce(x) {
        x.drShiftTo(this.m.t - 1, this.r2);
        if (x.t > this.m.t + 1) {
            x.t = this.m.t + 1;
            x.clamp();
        }
        this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
        this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
        while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
        x.subTo(this.r2, x);
        while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
    }
    // r = x^2 mod m; x != r
    function barrettSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = x*y mod m; x,y != r
    function barrettMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Barrett.prototype.convert = barrettConvert;
    Barrett.prototype.revert = barrettRevert;
    Barrett.prototype.reduce = barrettReduce;
    Barrett.prototype.mulTo = barrettMulTo;
    Barrett.prototype.sqrTo = barrettSqrTo;
    // (public) this^e % m (HAC 14.85)
    function bnModPow(e, m) {
        var i = e.bitLength(), k, r = nbv(1), z;
        if (i <= 0) return r;
        else if (i < 18) k = 1;
        else if (i < 48) k = 3;
        else if (i < 144) k = 4;
        else if (i < 768) k = 5;
        else k = 6;
        if (i < 8) z = new Classic(m);
        else if (m.isEven()) z = new Barrett(m);
        else z = new Montgomery(m);
        // precomputation
        var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
        g[1] = z.convert(this);
        if (k > 1) {
            var g2 = nbi();
            z.sqrTo(g[1], g2);
            while(n <= km){
                g[n] = nbi();
                z.mulTo(g2, g[n - 2], g[n]);
                n += 2;
            }
        }
        var j = e.t - 1, w, is1 = true, r2 = nbi(), t;
        i = nbits(e[j]) - 1;
        while(j >= 0){
            if (i >= k1) w = e[j] >> i - k1 & km;
            else {
                w = (e[j] & (1 << i + 1) - 1) << k1 - i;
                if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
            }
            n = k;
            while((w & 1) == 0){
                w >>= 1;
                --n;
            }
            if ((i -= n) < 0) {
                i += this.DB;
                --j;
            }
            if (is1) {
                g[w].copyTo(r);
                is1 = false;
            } else {
                while(n > 1){
                    z.sqrTo(r, r2);
                    z.sqrTo(r2, r);
                    n -= 2;
                }
                if (n > 0) z.sqrTo(r, r2);
                else {
                    t = r;
                    r = r2;
                    r2 = t;
                }
                z.mulTo(r2, g[w], r);
            }
            while(j >= 0 && (e[j] & 1 << i) == 0){
                z.sqrTo(r, r2);
                t = r;
                r = r2;
                r2 = t;
                if (--i < 0) {
                    i = this.DB - 1;
                    --j;
                }
            }
        }
        return z.revert(r);
    }
    // (public) gcd(this,a) (HAC 14.54)
    function bnGCD(a) {
        var x = this.s < 0 ? this.negate() : this.clone();
        var y = a.s < 0 ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit(), g = y.getLowestSetBit();
        if (g < 0) return x;
        if (i < g) g = i;
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        while(x.signum() > 0){
            if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
            if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            } else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
        }
        if (g > 0) y.lShiftTo(g, y);
        return y;
    }
    // (protected) this % n, n < 2^26
    function bnpModInt(n) {
        if (n <= 0) return 0;
        var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
        if (this.t > 0) {
            if (d == 0) r = this[0] % n;
            else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this[i]) % n;
        }
        return r;
    }
    // (public) 1/this % m (HAC 14.61)
    function bnModInverse(m) {
        var ac = m.isEven();
        if (this.isEven() && ac || m.signum() == 0) return BigInteger.ZERO;
        var u = m.clone(), v = this.clone();
        var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);
        while(u.signum() != 0){
            while(u.isEven()){
                u.rShiftTo(1, u);
                if (ac) {
                    if (!a.isEven() || !b.isEven()) {
                        a.addTo(this, a);
                        b.subTo(m, b);
                    }
                    a.rShiftTo(1, a);
                } else if (!b.isEven()) b.subTo(m, b);
                b.rShiftTo(1, b);
            }
            while(v.isEven()){
                v.rShiftTo(1, v);
                if (ac) {
                    if (!c.isEven() || !d.isEven()) {
                        c.addTo(this, c);
                        d.subTo(m, d);
                    }
                    c.rShiftTo(1, c);
                } else if (!d.isEven()) d.subTo(m, d);
                d.rShiftTo(1, d);
            }
            if (u.compareTo(v) >= 0) {
                u.subTo(v, u);
                if (ac) a.subTo(c, a);
                b.subTo(d, b);
            } else {
                v.subTo(u, v);
                if (ac) c.subTo(a, c);
                d.subTo(b, d);
            }
        }
        if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
        if (d.compareTo(m) >= 0) return d.subtract(m);
        if (d.signum() < 0) d.addTo(m, d);
        else return d;
        if (d.signum() < 0) return d.add(m);
        else return d;
    }
    var lowprimes = [
        2,
        3,
        5,
        7,
        11,
        13,
        17,
        19,
        23,
        29,
        31,
        37,
        41,
        43,
        47,
        53,
        59,
        61,
        67,
        71,
        73,
        79,
        83,
        89,
        97,
        101,
        103,
        107,
        109,
        113,
        127,
        131,
        137,
        139,
        149,
        151,
        157,
        163,
        167,
        173,
        179,
        181,
        191,
        193,
        197,
        199,
        211,
        223,
        227,
        229,
        233,
        239,
        241,
        251,
        257,
        263,
        269,
        271,
        277,
        281,
        283,
        293,
        307,
        311,
        313,
        317,
        331,
        337,
        347,
        349,
        353,
        359,
        367,
        373,
        379,
        383,
        389,
        397,
        401,
        409,
        419,
        421,
        431,
        433,
        439,
        443,
        449,
        457,
        461,
        463,
        467,
        479,
        487,
        491,
        499,
        503,
        509,
        521,
        523,
        541,
        547,
        557,
        563,
        569,
        571,
        577,
        587,
        593,
        599,
        601,
        607,
        613,
        617,
        619,
        631,
        641,
        643,
        647,
        653,
        659,
        661,
        673,
        677,
        683,
        691,
        701,
        709,
        719,
        727,
        733,
        739,
        743,
        751,
        757,
        761,
        769,
        773,
        787,
        797,
        809,
        811,
        821,
        823,
        827,
        829,
        839,
        853,
        857,
        859,
        863,
        877,
        881,
        883,
        887,
        907,
        911,
        919,
        929,
        937,
        941,
        947,
        953,
        967,
        971,
        977,
        983,
        991,
        997
    ];
    var lplim = 67108864 / lowprimes[lowprimes.length - 1];
    // (public) test primality with certainty >= 1-.5^t
    function bnIsProbablePrime(t) {
        var i, x = this.abs();
        if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
            for(i = 0; i < lowprimes.length; ++i)if (x[0] == lowprimes[i]) return true;
            return false;
        }
        if (x.isEven()) return false;
        i = 1;
        while(i < lowprimes.length){
            var m = lowprimes[i], j = i + 1;
            while(j < lowprimes.length && m < lplim)m *= lowprimes[j++];
            m = x.modInt(m);
            while(i < j)if (m % lowprimes[i++] == 0) return false;
        }
        return x.millerRabin(t);
    }
    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
    function bnpMillerRabin(t) {
        var n1 = this.subtract(BigInteger.ONE);
        var k = n1.getLowestSetBit();
        if (k <= 0) return false;
        var r = n1.shiftRight(k);
        t = t + 1 >> 1;
        if (t > lowprimes.length) t = lowprimes.length;
        var a = nbi();
        for(var i = 0; i < t; ++i){
            //Pick bases at random, instead of starting at 2
            a.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)]);
            var y = a.modPow(r, this);
            if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
                var j = 1;
                while(j++ < k && y.compareTo(n1) != 0){
                    y = y.modPowInt(2, this);
                    if (y.compareTo(BigInteger.ONE) == 0) return false;
                }
                if (y.compareTo(n1) != 0) return false;
            }
        }
        return true;
    }
    // protected
    BigInteger.prototype.chunkSize = bnpChunkSize;
    BigInteger.prototype.toRadix = bnpToRadix;
    BigInteger.prototype.fromRadix = bnpFromRadix;
    BigInteger.prototype.fromNumber = bnpFromNumber;
    BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
    BigInteger.prototype.changeBit = bnpChangeBit;
    BigInteger.prototype.addTo = bnpAddTo;
    BigInteger.prototype.dMultiply = bnpDMultiply;
    BigInteger.prototype.dAddOffset = bnpDAddOffset;
    BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
    BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
    BigInteger.prototype.modInt = bnpModInt;
    BigInteger.prototype.millerRabin = bnpMillerRabin;
    // public
    BigInteger.prototype.clone = bnClone;
    BigInteger.prototype.intValue = bnIntValue;
    BigInteger.prototype.byteValue = bnByteValue;
    BigInteger.prototype.shortValue = bnShortValue;
    BigInteger.prototype.signum = bnSigNum;
    BigInteger.prototype.toByteArray = bnToByteArray;
    BigInteger.prototype.equals = bnEquals;
    BigInteger.prototype.min = bnMin;
    BigInteger.prototype.max = bnMax;
    BigInteger.prototype.and = bnAnd;
    BigInteger.prototype.or = bnOr;
    BigInteger.prototype.xor = bnXor;
    BigInteger.prototype.andNot = bnAndNot;
    BigInteger.prototype.not = bnNot;
    BigInteger.prototype.shiftLeft = bnShiftLeft;
    BigInteger.prototype.shiftRight = bnShiftRight;
    BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
    BigInteger.prototype.bitCount = bnBitCount;
    BigInteger.prototype.testBit = bnTestBit;
    BigInteger.prototype.setBit = bnSetBit;
    BigInteger.prototype.clearBit = bnClearBit;
    BigInteger.prototype.flipBit = bnFlipBit;
    BigInteger.prototype.add = bnAdd;
    BigInteger.prototype.subtract = bnSubtract;
    BigInteger.prototype.multiply = bnMultiply;
    BigInteger.prototype.divide = bnDivide;
    BigInteger.prototype.remainder = bnRemainder;
    BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
    BigInteger.prototype.modPow = bnModPow;
    BigInteger.prototype.modInverse = bnModInverse;
    BigInteger.prototype.pow = bnPow;
    BigInteger.prototype.gcd = bnGCD;
    BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
    // JSBN-specific extension
    BigInteger.prototype.square = bnSquare;
    // Expose the Barrett function
    BigInteger.prototype.Barrett = Barrett;
    // BigInteger interfaces not implemented in jsbn:
    // BigInteger(int signum, byte[] magnitude)
    // double doubleValue()
    // float floatValue()
    // int hashCode()
    // long longValue()
    // static BigInteger valueOf(long val)
    // Random number generator - requires a PRNG backend, e.g. prng4.js
    // For best results, put code like
    // <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
    // in your main HTML document.
    var rng_state;
    var rng_pool;
    var rng_pptr;
    // Mix in a 32-bit integer into the pool
    function rng_seed_int(x) {
        rng_pool[rng_pptr++] ^= x & 255;
        rng_pool[rng_pptr++] ^= x >> 8 & 255;
        rng_pool[rng_pptr++] ^= x >> 16 & 255;
        rng_pool[rng_pptr++] ^= x >> 24 & 255;
        if (rng_pptr >= rng_psize) rng_pptr -= rng_psize;
    }
    // Mix in the current time (w/milliseconds) into the pool
    function rng_seed_time() {
        rng_seed_int(new Date().getTime());
    }
    // Initialize the pool with junk if needed.
    if (rng_pool == null) {
        rng_pool = new Array();
        rng_pptr = 0;
        var t;
        if (typeof window !== "undefined" && window.crypto) {
            if (window.crypto.getRandomValues) {
                // Use webcrypto if available
                var ua = new Uint8Array(32);
                window.crypto.getRandomValues(ua);
                for(t = 0; t < 32; ++t)rng_pool[rng_pptr++] = ua[t];
            } else if (navigator.appName == "Netscape" && navigator.appVersion < "5") {
                // Extract entropy (256 bits) from NS4 RNG if available
                var z = window.crypto.random(32);
                for(t = 0; t < z.length; ++t)rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
            }
        }
        while(rng_pptr < rng_psize){
            t = Math.floor(65536 * Math.random());
            rng_pool[rng_pptr++] = t >>> 8;
            rng_pool[rng_pptr++] = t & 255;
        }
        rng_pptr = 0;
        rng_seed_time();
    //rng_seed_int(window.screenX);
    //rng_seed_int(window.screenY);
    }
    function rng_get_byte() {
        if (rng_state == null) {
            rng_seed_time();
            rng_state = prng_newstate();
            rng_state.init(rng_pool);
            for(rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)rng_pool[rng_pptr] = 0;
            rng_pptr = 0;
        //rng_pool = null;
        }
        // TODO: allow reseeding after first request
        return rng_state.next();
    }
    function rng_get_bytes(ba) {
        var i;
        for(i = 0; i < ba.length; ++i)ba[i] = rng_get_byte();
    }
    function SecureRandom() {}
    SecureRandom.prototype.nextBytes = rng_get_bytes;
    // prng4.js - uses Arcfour as a PRNG
    function Arcfour() {
        this.i = 0;
        this.j = 0;
        this.S = new Array();
    }
    // Initialize arcfour context from key, an array of ints, each from [0..255]
    function ARC4init(key) {
        var i, j, t;
        for(i = 0; i < 256; ++i)this.S[i] = i;
        j = 0;
        for(i = 0; i < 256; ++i){
            j = j + this.S[i] + key[i % key.length] & 255;
            t = this.S[i];
            this.S[i] = this.S[j];
            this.S[j] = t;
        }
        this.i = 0;
        this.j = 0;
    }
    function ARC4next() {
        var t;
        this.i = this.i + 1 & 255;
        this.j = this.j + this.S[this.i] & 255;
        t = this.S[this.i];
        this.S[this.i] = this.S[this.j];
        this.S[this.j] = t;
        return this.S[t + this.S[this.i] & 255];
    }
    Arcfour.prototype.init = ARC4init;
    Arcfour.prototype.next = ARC4next;
    // Plug in your RNG constructor here
    function prng_newstate() {
        return new Arcfour();
    }
    // Pool size must be a multiple of 4 and greater than 32.
    // An array of bytes the size of the pool will be passed to init()
    var rng_psize = 256;
    exports = module.exports = {
        default: BigInteger,
        BigInteger: BigInteger,
        SecureRandom: SecureRandom
    };
}).call(this);

});





parcelRegister("lR3qp", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe91345bd31babe2$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $aTzs4 = parcelRequire("aTzs4");

var $j4bb1 = parcelRequire("j4bb1");

var $56Gyq = parcelRequire("56Gyq");

var $13hpE = parcelRequire("13hpE");

var $gXdUG = parcelRequire("gXdUG");

var $1mo4j = parcelRequire("1mo4j");

var $bNBEE = parcelRequire("bNBEE");

var $aFa75 = parcelRequire("aFa75");
// Use custom mapValues function to avoid issues with specs that include a "map" key and R.map
// delegating calls to .map
function $fe91345bd31babe2$var$mapValues(fn, obj) {
    return (0, $aTzs4.default)(obj) ? obj.map(fn) : (0, $bNBEE.default)(obj).reduce(function(acc, key) {
        acc[key] = fn(obj[key]);
        return acc;
    }, {});
}
/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      const getMetrics = R.applySpec({
 *        sum: R.add,
 *        nested: { mul: R.multiply }
 *      });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */ var $fe91345bd31babe2$var$applySpec = /*#__PURE__*/ (0, $aSQee.default)(function applySpec(spec) {
    spec = $fe91345bd31babe2$var$mapValues(function(v) {
        return typeof v == "function" ? v : applySpec(v);
    }, spec);
    return (0, $56Gyq.default)((0, $1mo4j.default)((0, $13hpE.default), 0, (0, $gXdUG.default)("length", (0, $aFa75.default)(spec))), function() {
        var args = arguments;
        return $fe91345bd31babe2$var$mapValues(function(f) {
            return (0, $j4bb1.default)(f, args);
        }, spec);
    });
});
var $fe91345bd31babe2$export$2e2bcd8739ae039 = $fe91345bd31babe2$var$applySpec;

});
parcelRegister("j4bb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $de170f844fc81fb7$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");
/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      const nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */ var $de170f844fc81fb7$var$apply = /*#__PURE__*/ (0, $2jcOR.default)(function apply(fn, args) {
    return fn.apply(this, args);
});
var $de170f844fc81fb7$export$2e2bcd8739ae039 = $de170f844fc81fb7$var$apply;

});

parcelRegister("aFa75", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3594007c6fb40d$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $bNBEE = parcelRequire("bNBEE");
/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys, R.toPairs
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */ var $7c3594007c6fb40d$var$values = /*#__PURE__*/ (0, $aSQee.default)(function values(obj) {
    var props = (0, $bNBEE.default)(obj);
    var len = props.length;
    var vals = [];
    var idx = 0;
    while(idx < len){
        vals[idx] = obj[props[idx]];
        idx += 1;
    }
    return vals;
});
var $7c3594007c6fb40d$export$2e2bcd8739ae039 = $7c3594007c6fb40d$var$values;

});



parcelRegister("kW7Vr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3df5f3d31ab99b7$export$2e2bcd8739ae039);
let $f3df5f3d31ab99b7$var$script;



let $f3df5f3d31ab99b7$var$initialize = ()=>{
    $f3df5f3d31ab99b7$var$script = (parcelRequire("8Ycja"));
    if ($f3df5f3d31ab99b7$var$script.__esModule) $f3df5f3d31ab99b7$var$script = $f3df5f3d31ab99b7$var$script.default;
    $f3df5f3d31ab99b7$var$script.render = (parcelRequire("dPEws")).render;
    (parcelRequire("dpu3p")).default($f3df5f3d31ab99b7$var$script);
    $f3df5f3d31ab99b7$var$script.__scopeId = "data-v-0980a2";
    $f3df5f3d31ab99b7$var$script.__file = "WithLoader.vue";
};
$f3df5f3d31ab99b7$var$initialize();
var $f3df5f3d31ab99b7$export$2e2bcd8739ae039 = $f3df5f3d31ab99b7$var$script;

});
parcelRegister("8Ycja", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $687d797865f4e306$export$2e2bcd8739ae039);

var $f02BR = parcelRequire("f02BR");
var $687d797865f4e306$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.assign({
    inheritAttrs: false
}, {
    __name: "WithLoader",
    props: {
        isLoading: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            LoadingSpinner: $f02BR.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("f02BR", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeb8e157b3c35988$export$2e2bcd8739ae039);
let $aeb8e157b3c35988$var$script;


let $aeb8e157b3c35988$var$initialize = ()=>{
    $aeb8e157b3c35988$var$script = {};
    $aeb8e157b3c35988$var$script.render = (parcelRequire("8XJnG")).render;
    (parcelRequire("3dgdS")).default($aeb8e157b3c35988$var$script);
    $aeb8e157b3c35988$var$script.__scopeId = "data-v-7d6db0";
    $aeb8e157b3c35988$var$script.__file = "LoadingSpinner.vue";
};
$aeb8e157b3c35988$var$initialize();
var $aeb8e157b3c35988$export$2e2bcd8739ae039 = $aeb8e157b3c35988$var$script;

});
parcelRegister("8XJnG", function(module, exports) {

$parcel$export(module.exports, "render", () => $6867092783d3ba1a$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $6867092783d3ba1a$var$_hoisted_1 = {
    role: "status"
};
const $6867092783d3ba1a$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("svg", {
    "aria-hidden": "true",
    class: "w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("path", {
        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
        fill: "currentColor"
    }),
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("path", {
        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
        fill: "currentFill"
    })
], -1 /* HOISTED */ );
const $6867092783d3ba1a$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
    class: "sr-only"
}, "Loading...", -1 /* HOISTED */ );
const $6867092783d3ba1a$var$_hoisted_4 = [
    $6867092783d3ba1a$var$_hoisted_2,
    $6867092783d3ba1a$var$_hoisted_3
];
function $6867092783d3ba1a$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6867092783d3ba1a$var$_hoisted_1, $6867092783d3ba1a$var$_hoisted_4);
}

});

parcelRegister("3dgdS", function(module, exports) {

$parcel$export(module.exports, "default", () => $256f2b801bf2425f$export$2e2bcd8739ae039);
let $256f2b801bf2425f$var$NOOP = ()=>{};
var $256f2b801bf2425f$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("dPEws", function(module, exports) {

$parcel$export(module.exports, "render", () => $a11f78af6bbb5311$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $a11f78af6bbb5311$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $props.isLoading ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", (0, $TusQn.mergeProps)({
        key: 0
    }, _ctx.$attrs, {
        class: "w-full h-full flex items-center justify-center"
    }), [
        (0, $TusQn.createVNode)($setup["LoadingSpinner"])
    ], 16 /* FULL_PROPS */ )) : (0, $TusQn.renderSlot)(_ctx.$slots, "default", {
        key: 1
    });
}

});

parcelRegister("dpu3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c34ec41e26e01dd$export$2e2bcd8739ae039);
let $9c34ec41e26e01dd$var$NOOP = ()=>{};
var $9c34ec41e26e01dd$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("ifZB1", function(module, exports) {

$parcel$export(module.exports, "trackEvent", () => $d4a9686cb11d0c21$export$73d0a139caca1fee);
$parcel$export(module.exports, "initDefaultConsent", () => $d4a9686cb11d0c21$export$332cb5137dbd3ff6);
$parcel$export(module.exports, "updateGtagConsent", () => $d4a9686cb11d0c21$export$d6edc6884a987c57);
$parcel$export(module.exports, "applyConsentChange", () => $d4a9686cb11d0c21$export$1d7e00fb46179ed3);
let $d4a9686cb11d0c21$var$isInitialized = false;
let $d4a9686cb11d0c21$var$consentGranted = false;
const $d4a9686cb11d0c21$var$queuedEvents = [];
function $d4a9686cb11d0c21$export$f2a39aaa42ea357a(token) {
    if (!token) return;
    const gtmScript = document.createElement("script");
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtag/js?id=${token}`;
    document.head.appendChild(gtmScript);
    gtmScript.onload = ()=>{
        window.dataLayer = window.dataLayer || [];
        window.gtag = function() {
            window.dataLayer.push(arguments);
        };
        window.gtag("js", new Date());
        window.gtag("config", token);
        $d4a9686cb11d0c21$var$isInitialized = true;
        if ($d4a9686cb11d0c21$var$consentGranted) $d4a9686cb11d0c21$var$flushQueuedEvents();
    };
}
function $d4a9686cb11d0c21$export$73d0a139caca1fee(name, params = {}) {
    if ($d4a9686cb11d0c21$var$consentGranted) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: name,
            ...params
        });
        console.log("Event tracked: ", name);
    } else $d4a9686cb11d0c21$var$queuedEvents.push({
        name: name,
        params: params
    });
}
function $d4a9686cb11d0c21$export$332cb5137dbd3ff6() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function() {
        window.dataLayer.push(arguments);
    };
    window.gtag("consent", "default", {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied"
    });
}
function $d4a9686cb11d0c21$export$d6edc6884a987c57(consentConfig) {
    window.gtag("consent", "update", consentConfig);
}
function $d4a9686cb11d0c21$export$1d7e00fb46179ed3(decision) {
    if (decision === "granted") {
        $d4a9686cb11d0c21$var$consentGranted = true;
        $d4a9686cb11d0c21$var$flushQueuedEvents();
    } else $d4a9686cb11d0c21$var$consentGranted = false;
}
function $d4a9686cb11d0c21$var$flushQueuedEvents() {
    if ($d4a9686cb11d0c21$var$queuedEvents.length === 0) return;
    $d4a9686cb11d0c21$var$queuedEvents.forEach(({ name: name, params: params })=>{
        $d4a9686cb11d0c21$export$73d0a139caca1fee(name, params);
    });
    $d4a9686cb11d0c21$var$queuedEvents.length = 0;
}

});


parcelRegister("jQsHv", function(module, exports) {

$parcel$export(module.exports, "render", () => $e72922fdfaa9088f$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $e72922fdfaa9088f$var$_hoisted_1 = {
    class: "container mx-auto mt-8 min-w-80 w-1/4 base-gradient text-primary rounded-lg"
};
const $e72922fdfaa9088f$var$_hoisted_2 = {
    key: 0,
    class: "flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8"
};
const $e72922fdfaa9088f$var$_hoisted_3 = {
    class: "sm:mx-auto sm:w-full sm:max-w-sm"
};
const $e72922fdfaa9088f$var$_hoisted_4 = {
    class: "text-sm text-primary"
};
const $e72922fdfaa9088f$var$_hoisted_5 = {
    class: "mt-3 text-center text-lg font-bold leading-9 tracking-tight text-white"
};
const $e72922fdfaa9088f$var$_hoisted_6 = {
    class: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm"
};
const $e72922fdfaa9088f$var$_hoisted_7 = {
    for: "email",
    class: "block text-sm font-medium leading-6 text-white"
};
const $e72922fdfaa9088f$var$_hoisted_8 = {
    class: "mt-2"
};
const $e72922fdfaa9088f$var$_hoisted_9 = [
    "placeholder"
];
const $e72922fdfaa9088f$var$_hoisted_10 = {
    class: "flex items-center justify-between"
};
const $e72922fdfaa9088f$var$_hoisted_11 = {
    for: "password",
    class: "block text-sm font-medium leading-6 text-white"
};
const $e72922fdfaa9088f$var$_hoisted_12 = {
    class: "mt-2"
};
const $e72922fdfaa9088f$var$_hoisted_13 = {
    class: "flex items-center justify-end pt-1.5"
};
const $e72922fdfaa9088f$var$_hoisted_14 = {
    class: "text-sm"
};
const $e72922fdfaa9088f$var$_hoisted_15 = {
    type: "submit",
    class: "flex w-full justify-center btn-cta"
};
const $e72922fdfaa9088f$var$_hoisted_16 = {
    class: "mt-3 text-center text-sm"
};
function $e72922fdfaa9088f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("main", $e72922fdfaa9088f$var$_hoisted_1, [
        !$setup.isAuthenticated() ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e72922fdfaa9088f$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $e72922fdfaa9088f$var$_hoisted_3, [
                (0, $TusQn.createVNode)($setup["RouterLink"], {
                    to: $setup.homeNavigation,
                    class: "flex items-center justify-center mx-auto"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)($setup["GamebookLogo"], {
                                class: "h-14 w-auto m-1.5 rounded-md"
                            }),
                            (0, $TusQn.createElementVNode)("p", $e72922fdfaa9088f$var$_hoisted_4, (0, $8POXm.toDisplayString)(_ctx.$t("appTitle")), 1 /* TEXT */ )
                        ]),
                    _: 1 /* STABLE */ 
                }, 8 /* PROPS */ , [
                    "to"
                ]),
                (0, $TusQn.createElementVNode)("h2", $e72922fdfaa9088f$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("loginView.header")), 1 /* TEXT */ )
            ]),
            (0, $TusQn.createElementVNode)("div", $e72922fdfaa9088f$var$_hoisted_6, [
                (0, $TusQn.createVNode)($setup["InPlaceAlert"], {
                    message: $setup.userFriendlyErrorSalt,
                    onCloseAlert: $setup.clearUserMessages
                }, null, 8 /* PROPS */ , [
                    "message"
                ]),
                (0, $TusQn.createVNode)($setup["InPlaceAlert"], {
                    message: $setup.userMessage,
                    type: "error",
                    onCloseAlert: $setup.clearUserMessages
                }, null, 8 /* PROPS */ , [
                    "message"
                ]),
                (0, $TusQn.createElementVNode)("form", {
                    class: "space-y-6",
                    action: "#",
                    method: "POST",
                    onSubmit: _cache[2] || (_cache[2] = (0, $eeJ70.withModifiers)((...args)=>$setup.doLogin && $setup.doLogin(...args), [
                        "prevent"
                    ]))
                }, [
                    (0, $TusQn.createElementVNode)("div", null, [
                        (0, $TusQn.createElementVNode)("label", $e72922fdfaa9088f$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("loginView.email")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("div", $e72922fdfaa9088f$var$_hoisted_8, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
                                id: "email",
                                name: "email",
                                type: "email",
                                placeholder: _ctx.$t("loginView.emailPlaceholder"),
                                autocomplete: "email",
                                required: "required",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.email = $event)
                            }, $setup.emailAttrs, {
                                class: "block w-full input-transparent-text"
                            }), null, 16 /* FULL_PROPS */ , $e72922fdfaa9088f$var$_hoisted_9), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $setup.email
                                ]
                            ]),
                            (0, $TusQn.createVNode)($setup["ErrorMessage"], {
                                name: "email",
                                class: "px-2 mt-2 text-sm text-red-400 dark:text-red-400",
                                as: "p"
                            })
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", null, [
                        (0, $TusQn.createElementVNode)("div", $e72922fdfaa9088f$var$_hoisted_10, [
                            (0, $TusQn.createElementVNode)("label", $e72922fdfaa9088f$var$_hoisted_11, (0, $8POXm.toDisplayString)(_ctx.$t("loginView.password")), 1 /* TEXT */ )
                        ]),
                        (0, $TusQn.createElementVNode)("div", $e72922fdfaa9088f$var$_hoisted_12, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
                                id: "password",
                                name: "password",
                                type: "password",
                                autocomplete: "current-password",
                                required: "required",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.password = $event)
                            }, $setup.passwordAttrs, {
                                class: "block w-full input-transparent-text"
                            }), null, 16 /* FULL_PROPS */ ), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $setup.password
                                ]
                            ]),
                            (0, $TusQn.createVNode)($setup["ErrorMessage"], {
                                name: "password",
                                class: "px-2 mt-2 text-sm text-red-400 dark:text-red-400",
                                as: "p"
                            })
                        ]),
                        (0, $TusQn.createElementVNode)("div", $e72922fdfaa9088f$var$_hoisted_13, [
                            (0, $TusQn.createElementVNode)("div", $e72922fdfaa9088f$var$_hoisted_14, [
                                (0, $TusQn.createVNode)($setup["RouterLink"], {
                                    to: $setup.resetPasswordRoute,
                                    class: "font-semibold leading-6 text-secondary hover:text-highlight"
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("loginView.forgotPassword")), 1 /* TEXT */ )
                                        ]),
                                    _: 1 /* STABLE */ 
                                }, 8 /* PROPS */ , [
                                    "to"
                                ])
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", null, [
                        (0, $TusQn.createVNode)($setup["WithLoader"], {
                            "is-loading": $setup.isLoading
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createElementVNode)("button", $e72922fdfaa9088f$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("logIn")), 1 /* TEXT */ )
                                ]),
                            _: 1 /* STABLE */ 
                        }, 8 /* PROPS */ , [
                            "is-loading"
                        ])
                    ])
                ], 32 /* NEED_HYDRATION */ ),
                (0, $TusQn.createElementVNode)("p", $e72922fdfaa9088f$var$_hoisted_16, [
                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("loginView.noAccount")) + " " + (0, $8POXm.toDisplayString)(" ") + " ", 1 /* TEXT */ ),
                    (0, $TusQn.createVNode)($setup["RouterLink"], {
                        to: $setup.pricingRoute,
                        class: "font-semibold leading-6 text-secondary hover:text-highlight"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("loginView.signUp")), 1 /* TEXT */ )
                            ]),
                        _: 1 /* STABLE */ 
                    }, 8 /* PROPS */ , [
                        "to"
                    ])
                ])
            ])
        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
    ]);
}

});

parcelRegister("hfeDy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8df31003d2bc315$export$2e2bcd8739ae039);
let $c8df31003d2bc315$var$NOOP = ()=>{};
var $c8df31003d2bc315$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("7WABx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c8a580f07d9bbc8$export$2e2bcd8739ae039);
let $5c8a580f07d9bbc8$var$script;



let $5c8a580f07d9bbc8$var$initialize = ()=>{
    $5c8a580f07d9bbc8$var$script = (parcelRequire("539zj"));
    if ($5c8a580f07d9bbc8$var$script.__esModule) $5c8a580f07d9bbc8$var$script = $5c8a580f07d9bbc8$var$script.default;
    $5c8a580f07d9bbc8$var$script.render = (parcelRequire("7lCj5")).render;
    (parcelRequire("fdYkN")).default($5c8a580f07d9bbc8$var$script);
    $5c8a580f07d9bbc8$var$script.__scopeId = "data-v-b0d8cf";
    $5c8a580f07d9bbc8$var$script.__file = "LogoutView.vue";
};
$5c8a580f07d9bbc8$var$initialize();
var $5c8a580f07d9bbc8$export$2e2bcd8739ae039 = $5c8a580f07d9bbc8$var$script;

});
parcelRegister("539zj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3ad4a7a729be72a0$export$2e2bcd8739ae039);

var $73mM4 = parcelRequire("73mM4");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $580JV = parcelRequire("580JV");

var $bRn2L = parcelRequire("bRn2L");

var $1rS06 = parcelRequire("1rS06");

var $kW7Vr = parcelRequire("kW7Vr");
var $3ad4a7a729be72a0$export$2e2bcd8739ae039 = {
    __name: "LogoutView",
    setup (__props, { expose: __expose }) {
        __expose();
        const router = (0, $73mM4.useRouter)();
        const { callEndpoint: callEndpoint, isLoading: isLoading } = (0, $bRn2L.default)("logout");
        const { resetUserState: resetUserState } = (0, $1rS06.useGlobalState)();
        (0, $TusQn.onMounted)(async ()=>{
            await callEndpoint({
                method: "POST",
                request: {}
            });
            resetUserState();
            await router.push((0, $580JV.default).i18nRoute({
                name: "home"
            }));
        });
        const __returned__ = {
            router: router,
            callEndpoint: callEndpoint,
            isLoading: isLoading,
            resetUserState: resetUserState,
            get useRouter () {
                return 0, $73mM4.useRouter;
            },
            onMounted: $TusQn.onMounted,
            get Trans () {
                return 0, $580JV.default;
            },
            get useCallEndPointWith () {
                return 0, $bRn2L.default;
            },
            get useGlobalState () {
                return 0, $1rS06.useGlobalState;
            },
            WithLoader: $kW7Vr.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("7lCj5", function(module, exports) {

$parcel$export(module.exports, "render", () => $559835876c1a4f87$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $559835876c1a4f87$var$_hoisted_1 = {
    class: "grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8"
};
const $559835876c1a4f87$var$_hoisted_2 = {
    class: "text-center"
};
const $559835876c1a4f87$var$_hoisted_3 = {
    class: "mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl"
};
function $559835876c1a4f87$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("main", $559835876c1a4f87$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $559835876c1a4f87$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("h1", $559835876c1a4f87$var$_hoisted_3, (0, $8POXm.toDisplayString)(_ctx.$t("logoutView.header")), 1 /* TEXT */ ),
            (0, $TusQn.createVNode)($setup["WithLoader"], {
                "is-loading": $setup.isLoading
            }, null, 8 /* PROPS */ , [
                "is-loading"
            ])
        ])
    ]);
}

});

parcelRegister("fdYkN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b156df1499421b0c$export$2e2bcd8739ae039);
let $b156df1499421b0c$var$NOOP = ()=>{};
var $b156df1499421b0c$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("fAzx8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b595c800f86159c9$export$2e2bcd8739ae039);
let $b595c800f86159c9$var$script;



let $b595c800f86159c9$var$initialize = ()=>{
    $b595c800f86159c9$var$script = (parcelRequire("8akjM"));
    if ($b595c800f86159c9$var$script.__esModule) $b595c800f86159c9$var$script = $b595c800f86159c9$var$script.default;
    $b595c800f86159c9$var$script.render = (parcelRequire("eUFB1")).render;
    (parcelRequire("2eTK2")).default($b595c800f86159c9$var$script);
    $b595c800f86159c9$var$script.__scopeId = "data-v-065ee6";
    $b595c800f86159c9$var$script.__file = "ContactView.vue";
};
$b595c800f86159c9$var$initialize();
var $b595c800f86159c9$export$2e2bcd8739ae039 = $b595c800f86159c9$var$script;

});
parcelRegister("8akjM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5f1f049e4c8db248$export$2e2bcd8739ae039);

var $lP0re = parcelRequire("lP0re");

var $6GVXz = parcelRequire("6GVXz");
var $5f1f049e4c8db248$export$2e2bcd8739ae039 = {
    __name: "ContactView",
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            LandingPageNavBar: $lP0re.default,
            ContactForm: $6GVXz.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("lP0re", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe2eb36793fdd7de$export$2e2bcd8739ae039);
let $fe2eb36793fdd7de$var$script;



let $fe2eb36793fdd7de$var$initialize = ()=>{
    $fe2eb36793fdd7de$var$script = (parcelRequire("fIRQy"));
    if ($fe2eb36793fdd7de$var$script.__esModule) $fe2eb36793fdd7de$var$script = $fe2eb36793fdd7de$var$script.default;
    $fe2eb36793fdd7de$var$script.render = (parcelRequire("ld3le")).render;
    (parcelRequire("6ZDgw")).default($fe2eb36793fdd7de$var$script);
    $fe2eb36793fdd7de$var$script.__scopeId = "data-v-adb319";
    $fe2eb36793fdd7de$var$script.__file = "LandingPageNavigationBar.vue";
};
$fe2eb36793fdd7de$var$initialize();
var $fe2eb36793fdd7de$export$2e2bcd8739ae039 = $fe2eb36793fdd7de$var$script;

});
parcelRegister("fIRQy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b724bbe0ead83b2a$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $eeymv = parcelRequire("eeymv");

var $lXB30 = parcelRequire("lXB30");
var $5j8xD = parcelRequire("5j8xD");

var $jFUWD = parcelRequire("jFUWD");

var $73mM4 = parcelRequire("73mM4");

var $580JV = parcelRequire("580JV");

var $5lCi4 = parcelRequire("5lCi4");

var $1rS06 = parcelRequire("1rS06");

var $lRag7 = parcelRequire("lRag7");
var $b724bbe0ead83b2a$export$2e2bcd8739ae039 = {
    __name: "LandingPageNavigationBar",
    setup (__props, { expose: __expose }) {
        __expose();
        const i18n = (0, $jFUWD.useI18n)();
        const homeNavigation = (0, $580JV.default).i18nRoute({
            name: "home"
        });
        const loginNavigation = (0, $580JV.default).i18nRoute({
            name: "login"
        });
        const dashboardNavigation = (0, $580JV.default).i18nRoute({
            name: "dashboard"
        });
        const getStartedNavigation = (0, $580JV.default).i18nRoute({
            name: "register"
        });
        const activeSection = (0, $01W3b.ref)((0, $TusQn.inject)("activeSection"));
        const navigationData = [
            {
                name: i18n.t("nav.whyCyberalarm"),
                href: (0, $580JV.default).i18nRoute({
                    name: "home",
                    hash: "#why-cyberalarm"
                })
            },
            {
                name: i18n.t("nav.howItWorks"),
                href: (0, $580JV.default).i18nRoute({
                    name: "home",
                    hash: "#how-it-works"
                })
            },
            {
                name: i18n.t("nav.alarm"),
                href: (0, $580JV.default).i18nRoute({
                    name: "home",
                    hash: "#alarm"
                })
            },
            {
                name: i18n.t("nav.courses"),
                href: (0, $580JV.default).i18nRoute({
                    name: "home",
                    hash: "#courses"
                })
            },
            {
                name: i18n.t("nav.aboutUs"),
                href: (0, $580JV.default).i18nRoute({
                    name: "home",
                    hash: "#about-us"
                })
            },
            {
                name: i18n.t("nav.pricing"),
                href: (0, $580JV.default).i18nRoute({
                    name: "home",
                    hash: "#pricing"
                })
            }
        ];
        const extractHash = (href)=>{
            if (typeof href === "object" && href.hash) return href.hash.replace("#", "");
            const hrefString = typeof href === "string" ? href : href?.toString?.() || "";
            const index = hrefString.indexOf("#");
            return index !== -1 ? hrefString.slice(index + 1) : "";
        };
        const isActive = (href)=>{
            const targetHash = extractHash(href);
            return activeSection.value === targetHash;
        };
        const navLinkClasses = (0, $01W3b.computed)(()=>(href)=>{
                const baseClasses = "text-sm leading-6 transition-colors duration-300 ease-in-out";
                const isActiveLink = isActive(href);
                return `${baseClasses} ${isActiveLink ? "text-secondary" : "text-primary hover:opacity-50"}`;
            });
        const { isAuthenticated: isAuthenticated } = (0, $1rS06.useGlobalState)();
        const mobileMenuOpen = (0, $01W3b.ref)(false);
        const __returned__ = {
            i18n: i18n,
            homeNavigation: homeNavigation,
            loginNavigation: loginNavigation,
            dashboardNavigation: dashboardNavigation,
            getStartedNavigation: getStartedNavigation,
            activeSection: activeSection,
            navigationData: navigationData,
            extractHash: extractHash,
            isActive: isActive,
            navLinkClasses: navLinkClasses,
            isAuthenticated: isAuthenticated,
            mobileMenuOpen: mobileMenuOpen,
            computed: $01W3b.computed,
            inject: $TusQn.inject,
            ref: $01W3b.ref,
            get Dialog () {
                return 0, $eeymv.Dialog;
            },
            get DialogPanel () {
                return 0, $eeymv.DialogPanel;
            },
            get Bars3Icon () {
                return 0, $lXB30.default;
            },
            get XMarkIcon () {
                return 0, $5j8xD.default;
            },
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            get RouterLink () {
                return 0, $73mM4.RouterLink;
            },
            get Trans () {
                return 0, $580JV.default;
            },
            GamebookLogo: $5lCi4.default,
            get useGlobalState () {
                return 0, $1rS06.useGlobalState;
            },
            LogoutIcon: $lRag7.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("eeymv", function(module, exports) {

$parcel$export(module.exports, "Dialog", () => $a5cd071445f80471$export$3ddf2d174ce01153);
$parcel$export(module.exports, "DialogPanel", () => $a5cd071445f80471$export$46512663428d955a);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $7X383 = parcelRequire("7X383");

var $k03OY = parcelRequire("k03OY");

var $feyEv = parcelRequire("feyEv");

var $4P9tk = parcelRequire("4P9tk");

var $cU7Tb = parcelRequire("cU7Tb");

var $6cHqZ = parcelRequire("6cHqZ");

var $6T44y = parcelRequire("6T44y");

var $13Itm = parcelRequire("13Itm");

var $hmgEN = parcelRequire("hmgEN");

var $dScJl = parcelRequire("dScJl");

var $haTmA = parcelRequire("haTmA");

var $3U2PJ = parcelRequire("3U2PJ");

var $3bJmq = parcelRequire("3bJmq");

var $4JxcV = parcelRequire("4JxcV");

var $k8S1l = parcelRequire("k8S1l");

var $kSJAB = parcelRequire("kSJAB");

var $euWu2 = parcelRequire("euWu2");
var $a5cd071445f80471$var$Te = ((l)=>(l[l.Open = 0] = "Open", l[l.Closed = 1] = "Closed", l))($a5cd071445f80471$var$Te || {});
let $a5cd071445f80471$var$H = Symbol("DialogContext");
function $a5cd071445f80471$var$T(t) {
    let i = (0, $TusQn.inject)($a5cd071445f80471$var$H, null);
    if (i === null) {
        let l = new Error(`<${t} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(l, $a5cd071445f80471$var$T), l;
    }
    return i;
}
let $a5cd071445f80471$var$A = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", $a5cd071445f80471$export$3ddf2d174ce01153 = (0, $TusQn.defineComponent)({
    name: "Dialog",
    inheritAttrs: !1,
    props: {
        as: {
            type: [
                Object,
                String
            ],
            default: "div"
        },
        static: {
            type: Boolean,
            default: !1
        },
        unmount: {
            type: Boolean,
            default: !0
        },
        open: {
            type: [
                Boolean,
                String
            ],
            default: $a5cd071445f80471$var$A
        },
        initialFocus: {
            type: Object,
            default: null
        },
        id: {
            type: String,
            default: null
        },
        role: {
            type: String,
            default: "dialog"
        }
    },
    emits: {
        close: (t)=>!0
    },
    setup (t, { emit: i, attrs: l, slots: p, expose: s }) {
        var q, W;
        let n = (q = t.id) != null ? q : `headlessui-dialog-${(0, $4P9tk.useId)()}`, u = (0, $01W3b.ref)(!1);
        (0, $TusQn.onMounted)(()=>{
            u.value = !0;
        });
        let r = !1, g = (0, $01W3b.computed)(()=>t.role === "dialog" || t.role === "alertdialog" ? t.role : (r || (r = !0, console.warn(`Invalid role [${g}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), D = (0, $01W3b.ref)(0), S = (0, $13Itm.useOpenClosed)(), R = (0, $01W3b.computed)(()=>t.open === $a5cd071445f80471$var$A && S !== null ? (S.value & (0, $13Itm.State).Open) === (0, $13Itm.State).Open : t.open), m = (0, $01W3b.ref)(null), E = (0, $01W3b.computed)(()=>(0, $4JxcV.getOwnerDocument)(m));
        if (s({
            el: m,
            $el: m
        }), !(t.open !== $a5cd071445f80471$var$A || S !== null)) throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
        if (typeof R.value != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${R.value === $a5cd071445f80471$var$A ? void 0 : t.open}`);
        let c = (0, $01W3b.computed)(()=>u.value && R.value ? 0 : 1), k = (0, $01W3b.computed)(()=>c.value === 0), w = (0, $01W3b.computed)(()=>D.value > 1), N = (0, $TusQn.inject)($a5cd071445f80471$var$H, null) !== null, [Q, X] = (0, $euWu2.useNestedPortals)(), { resolveContainers: B, mainTreeNodeRef: K, MainTreeNode: Z } = (0, $6T44y.useRootContainers)({
            portals: Q,
            defaultContainers: [
                (0, $01W3b.computed)(()=>{
                    var e;
                    return (e = h.panelRef.value) != null ? e : m.value;
                })
            ]
        }), ee = (0, $01W3b.computed)(()=>w.value ? "parent" : "leaf"), U = (0, $01W3b.computed)(()=>S !== null ? (S.value & (0, $13Itm.State).Closing) === (0, $13Itm.State).Closing : !1), te = (0, $01W3b.computed)(()=>N || U.value ? !1 : k.value), le = (0, $01W3b.computed)(()=>{
            var e, a, d;
            return (d = Array.from((a = (e = E.value) == null ? void 0 : e.querySelectorAll("body > *")) != null ? a : []).find((f)=>f.id === "headlessui-portal-root" ? !1 : f.contains((0, $3U2PJ.dom)(K)) && f instanceof HTMLElement)) != null ? d : null;
        });
        (0, $cU7Tb.useInert)(le, te);
        let ae = (0, $01W3b.computed)(()=>w.value ? !0 : k.value), oe = (0, $01W3b.computed)(()=>{
            var e, a, d;
            return (d = Array.from((a = (e = E.value) == null ? void 0 : e.querySelectorAll("[data-headlessui-portal]")) != null ? a : []).find((f)=>f.contains((0, $3U2PJ.dom)(K)) && f instanceof HTMLElement)) != null ? d : null;
        });
        (0, $cU7Tb.useInert)(oe, ae), (0, $dScJl.useStackProvider)({
            type: "Dialog",
            enabled: (0, $01W3b.computed)(()=>c.value === 0),
            element: m,
            onUpdate: (e, a)=>{
                if (a === "Dialog") return (0, $3bJmq.match)(e, {
                    [(0, $dScJl.StackMessage).Add]: ()=>D.value += 1,
                    [(0, $dScJl.StackMessage).Remove]: ()=>D.value -= 1
                });
            }
        });
        let re = (0, $kSJAB.useDescriptions)({
            name: "DialogDescription",
            slot: (0, $01W3b.computed)(()=>({
                    open: R.value
                }))
        }), M = (0, $01W3b.ref)(null), h = {
            titleId: M,
            panelRef: (0, $01W3b.ref)(null),
            dialogState: c,
            setTitleId (e) {
                M.value !== e && (M.value = e);
            },
            close () {
                i("close", !1);
            }
        };
        (0, $TusQn.provide)($a5cd071445f80471$var$H, h);
        let ne = (0, $01W3b.computed)(()=>!(!k.value || w.value));
        (0, $6cHqZ.useOutsideClick)(B, (e, a)=>{
            e.preventDefault(), h.close(), (0, $TusQn.nextTick)(()=>a == null ? void 0 : a.focus());
        }, ne);
        let ie = (0, $01W3b.computed)(()=>!(w.value || c.value !== 0));
        (0, $feyEv.useEventListener)((W = E.value) == null ? void 0 : W.defaultView, "keydown", (e)=>{
            ie.value && (e.defaultPrevented || e.key === (0, $haTmA.Keys).Escape && (e.preventDefault(), e.stopPropagation(), h.close()));
        });
        let ue = (0, $01W3b.computed)(()=>!(U.value || c.value !== 0 || N));
        return (0, $k03OY.useDocumentOverflowLockedEffect)(E, ue, (e)=>{
            var a;
            return {
                containers: [
                    ...(a = e.containers) != null ? a : [],
                    B
                ]
            };
        }), (0, $TusQn.watchEffect)((e)=>{
            if (c.value !== 0) return;
            let a = (0, $3U2PJ.dom)(m);
            if (!a) return;
            let d = new ResizeObserver((f)=>{
                for (let L of f){
                    let x = L.target.getBoundingClientRect();
                    x.x === 0 && x.y === 0 && x.width === 0 && x.height === 0 && h.close();
                }
            });
            d.observe(a), e(()=>d.disconnect());
        }), ()=>{
            let { open: e, initialFocus: a, ...d } = t, f = {
                ...l,
                ref: m,
                id: n,
                role: g.value,
                "aria-modal": c.value === 0 ? !0 : void 0,
                "aria-labelledby": M.value,
                "aria-describedby": re.value
            }, L = {
                open: c.value === 0
            };
            return (0, $TusQn.h)((0, $hmgEN.ForcePortalRoot), {
                force: !0
            }, ()=>[
                    (0, $TusQn.h)((0, $euWu2.Portal), ()=>(0, $TusQn.h)((0, $euWu2.PortalGroup), {
                            target: m.value
                        }, ()=>(0, $TusQn.h)((0, $hmgEN.ForcePortalRoot), {
                                force: !1
                            }, ()=>(0, $TusQn.h)((0, $7X383.FocusTrap), {
                                    initialFocus: a,
                                    containers: B,
                                    features: k.value ? (0, $3bJmq.match)(ee.value, {
                                        parent: (0, $7X383.FocusTrap).features.RestoreFocus,
                                        leaf: (0, $7X383.FocusTrap).features.All & ~(0, $7X383.FocusTrap).features.FocusLock
                                    }) : (0, $7X383.FocusTrap).features.None
                                }, ()=>(0, $TusQn.h)(X, {}, ()=>(0, $k8S1l.render)({
                                            ourProps: f,
                                            theirProps: {
                                                ...d,
                                                ...l
                                            },
                                            slot: L,
                                            attrs: l,
                                            slots: p,
                                            visible: c.value === 0,
                                            features: (0, $k8S1l.Features).RenderStrategy | (0, $k8S1l.Features).Static,
                                            name: "Dialog"
                                        })))))),
                    (0, $TusQn.h)(Z)
                ]);
        };
    }
}), $a5cd071445f80471$export$bd1d06c79be19e17 = (0, $TusQn.defineComponent)({
    name: "DialogOverlay",
    props: {
        as: {
            type: [
                Object,
                String
            ],
            default: "div"
        },
        id: {
            type: String,
            default: null
        }
    },
    setup (t, { attrs: i, slots: l }) {
        var u;
        let p = (u = t.id) != null ? u : `headlessui-dialog-overlay-${(0, $4P9tk.useId)()}`, s = $a5cd071445f80471$var$T("DialogOverlay");
        function n(r) {
            r.target === r.currentTarget && (r.preventDefault(), r.stopPropagation(), s.close());
        }
        return ()=>{
            let { ...r } = t;
            return (0, $k8S1l.render)({
                ourProps: {
                    id: p,
                    "aria-hidden": !0,
                    onClick: n
                },
                theirProps: r,
                slot: {
                    open: s.dialogState.value === 0
                },
                attrs: i,
                slots: l,
                name: "DialogOverlay"
            });
        };
    }
}), $a5cd071445f80471$export$91fffd879a9415f4 = (0, $TusQn.defineComponent)({
    name: "DialogBackdrop",
    props: {
        as: {
            type: [
                Object,
                String
            ],
            default: "div"
        },
        id: {
            type: String,
            default: null
        }
    },
    inheritAttrs: !1,
    setup (t, { attrs: i, slots: l, expose: p }) {
        var r;
        let s = (r = t.id) != null ? r : `headlessui-dialog-backdrop-${(0, $4P9tk.useId)()}`, n = $a5cd071445f80471$var$T("DialogBackdrop"), u = (0, $01W3b.ref)(null);
        return p({
            el: u,
            $el: u
        }), (0, $TusQn.onMounted)(()=>{
            if (n.panelRef.value === null) throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
        }), ()=>{
            let { ...g } = t, D = {
                id: s,
                ref: u,
                "aria-hidden": !0
            };
            return (0, $TusQn.h)((0, $hmgEN.ForcePortalRoot), {
                force: !0
            }, ()=>(0, $TusQn.h)((0, $euWu2.Portal), ()=>(0, $k8S1l.render)({
                        ourProps: D,
                        theirProps: {
                            ...i,
                            ...g
                        },
                        slot: {
                            open: n.dialogState.value === 0
                        },
                        attrs: i,
                        slots: l,
                        name: "DialogBackdrop"
                    })));
        };
    }
}), $a5cd071445f80471$export$46512663428d955a = (0, $TusQn.defineComponent)({
    name: "DialogPanel",
    props: {
        as: {
            type: [
                Object,
                String
            ],
            default: "div"
        },
        id: {
            type: String,
            default: null
        }
    },
    setup (t, { attrs: i, slots: l, expose: p }) {
        var r;
        let s = (r = t.id) != null ? r : `headlessui-dialog-panel-${(0, $4P9tk.useId)()}`, n = $a5cd071445f80471$var$T("DialogPanel");
        p({
            el: n.panelRef,
            $el: n.panelRef
        });
        function u(g) {
            g.stopPropagation();
        }
        return ()=>{
            let { ...g } = t, D = {
                id: s,
                ref: n.panelRef,
                onClick: u
            };
            return (0, $k8S1l.render)({
                ourProps: D,
                theirProps: g,
                slot: {
                    open: n.dialogState.value === 0
                },
                attrs: i,
                slots: l,
                name: "DialogPanel"
            });
        };
    }
}), $a5cd071445f80471$export$16f7638e4a34b909 = (0, $TusQn.defineComponent)({
    name: "DialogTitle",
    props: {
        as: {
            type: [
                Object,
                String
            ],
            default: "h2"
        },
        id: {
            type: String,
            default: null
        }
    },
    setup (t, { attrs: i, slots: l }) {
        var n;
        let p = (n = t.id) != null ? n : `headlessui-dialog-title-${(0, $4P9tk.useId)()}`, s = $a5cd071445f80471$var$T("DialogTitle");
        return (0, $TusQn.onMounted)(()=>{
            s.setTitleId(p), (0, $TusQn.onUnmounted)(()=>s.setTitleId(null));
        }), ()=>{
            let { ...u } = t;
            return (0, $k8S1l.render)({
                ourProps: {
                    id: p
                },
                theirProps: u,
                slot: {
                    open: s.dialogState.value === 0
                },
                attrs: i,
                slots: l,
                name: "DialogTitle"
            });
        };
    }
}), $a5cd071445f80471$export$94e94c2ec2c954d5 = (0, $kSJAB.Description);

});
parcelRegister("7X383", function(module, exports) {

$parcel$export(module.exports, "FocusTrap", () => $5ca07866e7cbee04$export$34eba2437817a67b);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $feyEv = parcelRequire("feyEv");

var $l2oSo = parcelRequire("l2oSo");

var $c14U5 = parcelRequire("c14U5");

var $4QhZD = parcelRequire("4QhZD");

var $3U2PJ = parcelRequire("3U2PJ");

var $eFmmu = parcelRequire("eFmmu");

var $3bJmq = parcelRequire("3bJmq");

var $7t12d = parcelRequire("7t12d");

var $4JxcV = parcelRequire("4JxcV");

var $k8S1l = parcelRequire("k8S1l");
function $5ca07866e7cbee04$var$B(t) {
    if (!t) return new Set;
    if (typeof t == "function") return new Set(t());
    let n = new Set;
    for (let r of t.value){
        let l = (0, $3U2PJ.dom)(r);
        l instanceof HTMLElement && n.add(l);
    }
    return n;
}
var $5ca07866e7cbee04$var$A = ((e)=>(e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))($5ca07866e7cbee04$var$A || {});
let $5ca07866e7cbee04$export$34eba2437817a67b = Object.assign((0, $TusQn.defineComponent)({
    name: "FocusTrap",
    props: {
        as: {
            type: [
                Object,
                String
            ],
            default: "div"
        },
        initialFocus: {
            type: Object,
            default: null
        },
        features: {
            type: Number,
            default: 30
        },
        containers: {
            type: [
                Object,
                Function
            ],
            default: (0, $01W3b.ref)(new Set)
        }
    },
    inheritAttrs: !1,
    setup (t, { attrs: n, slots: r, expose: l }) {
        let o = (0, $01W3b.ref)(null);
        l({
            el: o,
            $el: o
        });
        let i = (0, $01W3b.computed)(()=>(0, $4JxcV.getOwnerDocument)(o)), e = (0, $01W3b.ref)(!1);
        (0, $TusQn.onMounted)(()=>e.value = !0), (0, $TusQn.onUnmounted)(()=>e.value = !1), $5ca07866e7cbee04$var$$({
            ownerDocument: i
        }, (0, $01W3b.computed)(()=>e.value && Boolean(t.features & 16)));
        let m = $5ca07866e7cbee04$var$z({
            ownerDocument: i,
            container: o,
            initialFocus: (0, $01W3b.computed)(()=>t.initialFocus)
        }, (0, $01W3b.computed)(()=>e.value && Boolean(t.features & 2)));
        $5ca07866e7cbee04$var$J({
            ownerDocument: i,
            container: o,
            containers: t.containers,
            previousActiveElement: m
        }, (0, $01W3b.computed)(()=>e.value && Boolean(t.features & 8)));
        let f = (0, $l2oSo.useTabDirection)();
        function a(u) {
            let T = (0, $3U2PJ.dom)(o);
            if (!T) return;
            ((w)=>w())(()=>{
                (0, $3bJmq.match)(f.value, {
                    [(0, $l2oSo.Direction).Forwards]: ()=>{
                        (0, $eFmmu.focusIn)(T, (0, $eFmmu.Focus).First, {
                            skipElements: [
                                u.relatedTarget
                            ]
                        });
                    },
                    [(0, $l2oSo.Direction).Backwards]: ()=>{
                        (0, $eFmmu.focusIn)(T, (0, $eFmmu.Focus).Last, {
                            skipElements: [
                                u.relatedTarget
                            ]
                        });
                    }
                });
            });
        }
        let s = (0, $01W3b.ref)(!1);
        function F(u) {
            u.key === "Tab" && (s.value = !0, requestAnimationFrame(()=>{
                s.value = !1;
            }));
        }
        function H(u) {
            if (!e.value) return;
            let T = $5ca07866e7cbee04$var$B(t.containers);
            (0, $3U2PJ.dom)(o) instanceof HTMLElement && T.add((0, $3U2PJ.dom)(o));
            let d = u.relatedTarget;
            d instanceof HTMLElement && d.dataset.headlessuiFocusGuard !== "true" && ($5ca07866e7cbee04$var$N(T, d) || (s.value ? (0, $eFmmu.focusIn)((0, $3U2PJ.dom)(o), (0, $3bJmq.match)(f.value, {
                [(0, $l2oSo.Direction).Forwards]: ()=>(0, $eFmmu.Focus).Next,
                [(0, $l2oSo.Direction).Backwards]: ()=>(0, $eFmmu.Focus).Previous
            }) | (0, $eFmmu.Focus).WrapAround, {
                relativeTo: u.target
            }) : u.target instanceof HTMLElement && (0, $eFmmu.focusElement)(u.target)));
        }
        return ()=>{
            let u = {}, T = {
                ref: o,
                onKeydown: F,
                onFocusout: H
            }, { features: d, initialFocus: w, containers: Q, ...O } = t;
            return (0, $TusQn.h)((0, $TusQn.Fragment), [
                Boolean(d & 4) && (0, $TusQn.h)((0, $c14U5.Hidden), {
                    as: "button",
                    type: "button",
                    "data-headlessui-focus-guard": !0,
                    onFocus: a,
                    features: (0, $c14U5.Features).Focusable
                }),
                (0, $k8S1l.render)({
                    ourProps: T,
                    theirProps: {
                        ...n,
                        ...O
                    },
                    slot: u,
                    attrs: n,
                    slots: r,
                    name: "FocusTrap"
                }),
                Boolean(d & 4) && (0, $TusQn.h)((0, $c14U5.Hidden), {
                    as: "button",
                    type: "button",
                    "data-headlessui-focus-guard": !0,
                    onFocus: a,
                    features: (0, $c14U5.Features).Focusable
                })
            ]);
        };
    }
}), {
    features: $5ca07866e7cbee04$var$A
});
function $5ca07866e7cbee04$var$W(t) {
    let n = (0, $01W3b.ref)((0, $4QhZD.history).slice());
    return (0, $TusQn.watch)([
        t
    ], ([r], [l])=>{
        l === !0 && r === !1 ? (0, $7t12d.microTask)(()=>{
            n.value.splice(0);
        }) : l === !1 && r === !0 && (n.value = (0, $4QhZD.history).slice());
    }, {
        flush: "post"
    }), ()=>{
        var r;
        return (r = n.value.find((l)=>l != null && l.isConnected)) != null ? r : null;
    };
}
function $5ca07866e7cbee04$var$$({ ownerDocument: t }, n) {
    let r = $5ca07866e7cbee04$var$W(n);
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watchEffect)(()=>{
            var l, o;
            n.value || ((l = t.value) == null ? void 0 : l.activeElement) === ((o = t.value) == null ? void 0 : o.body) && (0, $eFmmu.focusElement)(r());
        }, {
            flush: "post"
        });
    }), (0, $TusQn.onUnmounted)(()=>{
        n.value && (0, $eFmmu.focusElement)(r());
    });
}
function $5ca07866e7cbee04$var$z({ ownerDocument: t, container: n, initialFocus: r }, l) {
    let o = (0, $01W3b.ref)(null), i = (0, $01W3b.ref)(!1);
    return (0, $TusQn.onMounted)(()=>i.value = !0), (0, $TusQn.onUnmounted)(()=>i.value = !1), (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watch)([
            n,
            r,
            l
        ], (e, m)=>{
            if (e.every((a, s)=>(m == null ? void 0 : m[s]) === a) || !l.value) return;
            let f = (0, $3U2PJ.dom)(n);
            f && (0, $7t12d.microTask)(()=>{
                var F, H;
                if (!i.value) return;
                let a = (0, $3U2PJ.dom)(r), s = (F = t.value) == null ? void 0 : F.activeElement;
                if (a) {
                    if (a === s) {
                        o.value = s;
                        return;
                    }
                } else if (f.contains(s)) {
                    o.value = s;
                    return;
                }
                a ? (0, $eFmmu.focusElement)(a) : (0, $eFmmu.focusIn)(f, (0, $eFmmu.Focus).First | (0, $eFmmu.Focus).NoScroll) === (0, $eFmmu.FocusResult).Error && console.warn("There are no focusable elements inside the <FocusTrap />"), o.value = (H = t.value) == null ? void 0 : H.activeElement;
            });
        }, {
            immediate: !0,
            flush: "post"
        });
    }), o;
}
function $5ca07866e7cbee04$var$J({ ownerDocument: t, container: n, containers: r, previousActiveElement: l }, o) {
    var i;
    (0, $feyEv.useEventListener)((i = t.value) == null ? void 0 : i.defaultView, "focus", (e)=>{
        if (!o.value) return;
        let m = $5ca07866e7cbee04$var$B(r);
        (0, $3U2PJ.dom)(n) instanceof HTMLElement && m.add((0, $3U2PJ.dom)(n));
        let f = l.value;
        if (!f) return;
        let a = e.target;
        a && a instanceof HTMLElement ? $5ca07866e7cbee04$var$N(m, a) ? (l.value = a, (0, $eFmmu.focusElement)(a)) : (e.preventDefault(), e.stopPropagation(), (0, $eFmmu.focusElement)(f)) : (0, $eFmmu.focusElement)(l.value);
    }, !0);
}
function $5ca07866e7cbee04$var$N(t, n) {
    for (let r of t)if (r.contains(n)) return !0;
    return !1;
}

});
parcelRegister("feyEv", function(module, exports) {

$parcel$export(module.exports, "useEventListener", () => $b1730b0d5c1178ed$export$7080b3e976bc91ab);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $aWPTL = parcelRequire("aWPTL");
function $b1730b0d5c1178ed$export$7080b3e976bc91ab(n, e, o, r) {
    (0, $aWPTL.env).isServer || (0, $TusQn.watchEffect)((t)=>{
        n = n != null ? n : window, n.addEventListener(e, o, r), t(()=>n.removeEventListener(e, o, r));
    });
}

});
parcelRegister("aWPTL", function(module, exports) {

$parcel$export(module.exports, "env", () => $7f879420d4801933$export$a7b6bc01c63cdfc3);
var $7f879420d4801933$var$i = Object.defineProperty;
var $7f879420d4801933$var$d = (t, e, r)=>e in t ? $7f879420d4801933$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r;
var $7f879420d4801933$var$n = (t, e, r)=>($7f879420d4801933$var$d(t, typeof e != "symbol" ? e + "" : e, r), r);
class $7f879420d4801933$var$s {
    constructor(){
        $7f879420d4801933$var$n(this, "current", this.detect());
        $7f879420d4801933$var$n(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
}
let $7f879420d4801933$export$a7b6bc01c63cdfc3 = new $7f879420d4801933$var$s;

});


parcelRegister("l2oSo", function(module, exports) {

$parcel$export(module.exports, "Direction", () => $f50d14cf8098b5cd$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "useTabDirection", () => $f50d14cf8098b5cd$export$19b797546aece48f);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $1wXKz = parcelRequire("1wXKz");
var $f50d14cf8098b5cd$export$cacd6541cfeeb6c1 = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))($f50d14cf8098b5cd$export$cacd6541cfeeb6c1 || {});
function $f50d14cf8098b5cd$export$19b797546aece48f() {
    let o = (0, $01W3b.ref)(0);
    return (0, $1wXKz.useWindowEvent)("keydown", (e)=>{
        e.key === "Tab" && (o.value = e.shiftKey ? 1 : 0);
    }), o;
}

});
parcelRegister("1wXKz", function(module, exports) {

$parcel$export(module.exports, "useWindowEvent", () => $11d720b64f063847$export$ee579bb285b8d4aa);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $aWPTL = parcelRequire("aWPTL");
function $11d720b64f063847$export$ee579bb285b8d4aa(e, n, t) {
    (0, $aWPTL.env).isServer || (0, $TusQn.watchEffect)((o)=>{
        window.addEventListener(e, n, t), o(()=>window.removeEventListener(e, n, t));
    });
}

});


parcelRegister("c14U5", function(module, exports) {

$parcel$export(module.exports, "Features", () => $8bf961c457aef81b$export$617d79dae526d2cf);
$parcel$export(module.exports, "Hidden", () => $8bf961c457aef81b$export$8dc98ba7eadeaa56);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $k8S1l = parcelRequire("k8S1l");
var $8bf961c457aef81b$export$617d79dae526d2cf = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($8bf961c457aef81b$export$617d79dae526d2cf || {});
let $8bf961c457aef81b$export$8dc98ba7eadeaa56 = (0, $TusQn.defineComponent)({
    name: "Hidden",
    props: {
        as: {
            type: [
                Object,
                String
            ],
            default: "div"
        },
        features: {
            type: Number,
            default: 1
        }
    },
    setup (t, { slots: n, attrs: i }) {
        return ()=>{
            var r;
            let { features: e, ...d } = t, o = {
                "aria-hidden": (e & 2) === 2 ? !0 : (r = d["aria-hidden"]) != null ? r : void 0,
                hidden: (e & 4) === 4 ? !0 : void 0,
                style: {
                    position: "fixed",
                    top: 1,
                    left: 1,
                    width: 1,
                    height: 0,
                    padding: 0,
                    margin: -1,
                    overflow: "hidden",
                    clip: "rect(0, 0, 0, 0)",
                    whiteSpace: "nowrap",
                    borderWidth: "0",
                    ...(e & 4) === 4 && (e & 2) !== 2 && {
                        display: "none"
                    }
                }
            };
            return (0, $k8S1l.render)({
                ourProps: o,
                theirProps: d,
                slot: {},
                attrs: i,
                slots: n,
                name: "Hidden"
            });
        };
    }
});

});
parcelRegister("k8S1l", function(module, exports) {

$parcel$export(module.exports, "Features", () => $ea9e756877647e83$export$617d79dae526d2cf);
$parcel$export(module.exports, "render", () => $ea9e756877647e83$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $3bJmq = parcelRequire("3bJmq");
var $ea9e756877647e83$export$617d79dae526d2cf = ((o)=>(o[o.None = 0] = "None", o[o.RenderStrategy = 1] = "RenderStrategy", o[o.Static = 2] = "Static", o))($ea9e756877647e83$export$617d79dae526d2cf || {}), $ea9e756877647e83$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($ea9e756877647e83$export$80c0a745e59f7989 || {});
function $ea9e756877647e83$export$b3890eb0ae9dca99({ visible: r = !0, features: t = 0, ourProps: e, theirProps: o, ...i }) {
    var a;
    let n = $ea9e756877647e83$var$j(o, e), l = Object.assign(i, {
        props: n
    });
    if (r || t & 2 && n.static) return $ea9e756877647e83$var$y(l);
    if (t & 1) {
        let d = (a = n.unmount) == null || a ? 0 : 1;
        return (0, $3bJmq.match)(d, {
            [0] () {
                return null;
            },
            [1] () {
                return $ea9e756877647e83$var$y({
                    ...i,
                    props: {
                        ...n,
                        hidden: !0,
                        style: {
                            display: "none"
                        }
                    }
                });
            }
        });
    }
    return $ea9e756877647e83$var$y(l);
}
function $ea9e756877647e83$var$y({ props: r, attrs: t, slots: e, slot: o, name: i }) {
    var m, h;
    let { as: n, ...l } = $ea9e756877647e83$export$30a06c8d3562193f(r, [
        "unmount",
        "static"
    ]), a = (m = e.default) == null ? void 0 : m.call(e, o), d = {};
    if (o) {
        let u = !1, c = [];
        for (let [p, f] of Object.entries(o))typeof f == "boolean" && (u = !0), f === !0 && c.push(p);
        u && (d["data-headlessui-state"] = c.join(" "));
    }
    if (n === "template") {
        if (a = $ea9e756877647e83$var$b(a != null ? a : []), Object.keys(l).length > 0 || Object.keys(t).length > 0) {
            let [u, ...c] = a != null ? a : [];
            if (!$ea9e756877647e83$var$v(u) || c.length > 0) throw new Error([
                'Passing props on "template"!',
                "",
                `The current component <${i} /> is rendering a "template".`,
                "However we need to passthrough the following props:",
                Object.keys(l).concat(Object.keys(t)).map((s)=>s.trim()).filter((s, g, R)=>R.indexOf(s) === g).sort((s, g)=>s.localeCompare(g)).map((s)=>`  - ${s}`).join(`
`),
                "",
                "You can apply a few solutions:",
                [
                    'Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".',
                    "Render a single element as the child so that we can forward the props onto that element."
                ].map((s)=>`  - ${s}`).join(`
`)
            ].join(`
`));
            let p = $ea9e756877647e83$var$j((h = u.props) != null ? h : {}, l, d), f = (0, $TusQn.cloneVNode)(u, p, !0);
            for(let s in p)s.startsWith("on") && (f.props || (f.props = {}), f.props[s] = p[s]);
            return f;
        }
        return Array.isArray(a) && a.length === 1 ? a[0] : a;
    }
    return (0, $TusQn.h)(n, Object.assign({}, l, d), {
        default: ()=>a
    });
}
function $ea9e756877647e83$var$b(r) {
    return r.flatMap((t)=>t.type === (0, $TusQn.Fragment) ? $ea9e756877647e83$var$b(t.children) : [
            t
        ]);
}
function $ea9e756877647e83$var$j(...r) {
    var o;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let t = {}, e = {};
    for (let i of r)for(let n in i)n.startsWith("on") && typeof i[n] == "function" ? ((o = e[n]) != null || (e[n] = []), e[n].push(i[n])) : t[n] = i[n];
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((i)=>[
            i,
            void 0
        ])));
    for(let i in e)Object.assign(t, {
        [i] (n, ...l) {
            let a = e[i];
            for (let d of a){
                if (n instanceof Event && n.defaultPrevented) return;
                d(n, ...l);
            }
        }
    });
    return t;
}
function $ea9e756877647e83$export$8e16b83750b44988(r) {
    let t = Object.assign({}, r);
    for(let e in t)t[e] === void 0 && delete t[e];
    return t;
}
function $ea9e756877647e83$export$30a06c8d3562193f(r, t = []) {
    let e = Object.assign({}, r);
    for (let o of t)o in e && delete e[o];
    return e;
}
function $ea9e756877647e83$var$v(r) {
    return r == null ? !1 : typeof r.type == "string" || typeof r.type == "object" || typeof r.type == "function";
}

});
parcelRegister("3bJmq", function(module, exports) {

$parcel$export(module.exports, "match", () => $252595da25e54791$export$4659b591c19bdf3d);
function $252595da25e54791$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $252595da25e54791$export$4659b591c19bdf3d), t;
}

});



parcelRegister("4QhZD", function(module, exports) {

$parcel$export(module.exports, "history", () => $3869f9ccff2babee$export$55abd4691b317664);

var $eaNtf = parcelRequire("eaNtf");
let $3869f9ccff2babee$export$55abd4691b317664 = [];
(0, $eaNtf.onDocumentReady)(()=>{
    function e(n) {
        n.target instanceof HTMLElement && n.target !== document.body && $3869f9ccff2babee$export$55abd4691b317664[0] !== n.target && ($3869f9ccff2babee$export$55abd4691b317664.unshift(n.target), $3869f9ccff2babee$export$55abd4691b317664 = $3869f9ccff2babee$export$55abd4691b317664.filter((r)=>r != null && r.isConnected), $3869f9ccff2babee$export$55abd4691b317664.splice(10));
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});

});
parcelRegister("eaNtf", function(module, exports) {

$parcel$export(module.exports, "onDocumentReady", () => $a5185fb48774321e$export$a6a2315df743a26b);
function $a5185fb48774321e$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}

});


parcelRegister("3U2PJ", function(module, exports) {

$parcel$export(module.exports, "dom", () => $2d78ccb5814815c0$export$df3a06d6289f983e);
function $2d78ccb5814815c0$export$df3a06d6289f983e(e) {
    var l;
    if (e == null || e.value == null) return null;
    let n = (l = e.value.$el) != null ? l : e.value;
    return n instanceof Node ? n : null;
}

});

parcelRegister("eFmmu", function(module, exports) {

$parcel$export(module.exports, "Focus", () => $aad63d970f50bf70$export$807a7eae502106e7);
$parcel$export(module.exports, "FocusResult", () => $aad63d970f50bf70$export$abf286375dfa6dbd);
$parcel$export(module.exports, "FocusableMode", () => $aad63d970f50bf70$export$27112a34f2f8402d);
$parcel$export(module.exports, "isFocusableElement", () => $aad63d970f50bf70$export$ff1ec1c740b3c8d5);
$parcel$export(module.exports, "focusElement", () => $aad63d970f50bf70$export$5fed9cc43865dc7e);
$parcel$export(module.exports, "focusIn", () => $aad63d970f50bf70$export$82e1f4f412218a1d);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $3bJmq = parcelRequire("3bJmq");

var $4JxcV = parcelRequire("4JxcV");
let $aad63d970f50bf70$var$c = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $aad63d970f50bf70$export$807a7eae502106e7 = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n))($aad63d970f50bf70$export$807a7eae502106e7 || {}), $aad63d970f50bf70$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($aad63d970f50bf70$export$abf286375dfa6dbd || {}), $aad63d970f50bf70$var$F = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($aad63d970f50bf70$var$F || {});
function $aad63d970f50bf70$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($aad63d970f50bf70$var$c)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $aad63d970f50bf70$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($aad63d970f50bf70$export$27112a34f2f8402d || {});
function $aad63d970f50bf70$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $4JxcV.getOwnerDocument)(e)) == null ? void 0 : t.body) ? !1 : (0, $3bJmq.match)(r, {
        [0] () {
            return e.matches($aad63d970f50bf70$var$c);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches($aad63d970f50bf70$var$c)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function $aad63d970f50bf70$export$46388676ec35ab85(e) {
    let r = (0, $4JxcV.getOwnerDocument)(e);
    (0, $TusQn.nextTick)(()=>{
        r && !$aad63d970f50bf70$export$ff1ec1c740b3c8d5(r.activeElement, 0) && $aad63d970f50bf70$export$5fed9cc43865dc7e(e);
    });
}
var $aad63d970f50bf70$var$y = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))($aad63d970f50bf70$var$y || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $aad63d970f50bf70$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $aad63d970f50bf70$var$H = [
    "textarea",
    "input"
].join(",");
function $aad63d970f50bf70$var$I(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $aad63d970f50bf70$var$H)) != null ? t : !1;
}
function $aad63d970f50bf70$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, l)=>{
        let o = r(t), i = r(l);
        if (o === null || i === null) return 0;
        let n = o.compareDocumentPosition(i);
        return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $aad63d970f50bf70$export$7fb6c844b485e870(e, r) {
    return $aad63d970f50bf70$export$82e1f4f412218a1d($aad63d970f50bf70$export$433aaa1f216cf32d(), r, {
        relativeTo: e
    });
}
function $aad63d970f50bf70$export$82e1f4f412218a1d(e, r, { sorted: t = !0, relativeTo: l = null, skipElements: o = [] } = {}) {
    var m;
    let i = (m = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? m : document, n = Array.isArray(e) ? t ? $aad63d970f50bf70$export$20305e96f91bf103(e) : e : $aad63d970f50bf70$export$433aaa1f216cf32d(e);
    o.length > 0 && n.length > 1 && (n = n.filter((s)=>!o.includes(s))), l = l != null ? l : i.activeElement;
    let x = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), p = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, n.indexOf(l)) - 1;
        if (r & 4) return Math.max(0, n.indexOf(l)) + 1;
        if (r & 8) return n.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), L = r & 32 ? {
        preventScroll: !0
    } : {}, a = 0, d = n.length, u;
    do {
        if (a >= d || a + d <= 0) return 0;
        let s = p + a;
        if (r & 16) s = (s + d) % d;
        else {
            if (s < 0) return 3;
            if (s >= d) return 1;
        }
        u = n[s], u == null || u.focus(L), a += x;
    }while (u !== i.activeElement);
    return r & 6 && $aad63d970f50bf70$var$I(u) && u.select(), 2;
}

});
parcelRegister("4JxcV", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", () => $37251fb9f9fcbd77$export$b204af158042fbac);

var $3U2PJ = parcelRequire("3U2PJ");

var $aWPTL = parcelRequire("aWPTL");
function $37251fb9f9fcbd77$export$b204af158042fbac(r) {
    if ((0, $aWPTL.env).isServer) return null;
    if (r instanceof Node) return r.ownerDocument;
    if (r != null && r.hasOwnProperty("value")) {
        let n = (0, $3U2PJ.dom)(r);
        if (n) return n.ownerDocument;
    }
    return document;
}

});


parcelRegister("7t12d", function(module, exports) {

$parcel$export(module.exports, "microTask", () => $56fc0b4c0e31593f$export$a5ff0d6a738703ca);
function $56fc0b4c0e31593f$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}

});


parcelRegister("k03OY", function(module, exports) {

$parcel$export(module.exports, "useDocumentOverflowLockedEffect", () => $e8f6c58acd087e28$export$bb0ae4a42bcd9e0);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $6uLV9 = parcelRequire("6uLV9");

var $bGp41 = parcelRequire("bGp41");
function $e8f6c58acd087e28$export$bb0ae4a42bcd9e0(t, a, n) {
    let i = (0, $6uLV9.useStore)((0, $bGp41.overflows)), l = (0, $01W3b.computed)(()=>{
        let e = t.value ? i.value.get(t.value) : void 0;
        return e ? e.count > 0 : !1;
    });
    return (0, $TusQn.watch)([
        t,
        a
    ], ([e, m], [r], o)=>{
        if (!e || !m) return;
        (0, $bGp41.overflows).dispatch("PUSH", e, n);
        let f = !1;
        o(()=>{
            f || ((0, $bGp41.overflows).dispatch("POP", r != null ? r : e, n), f = !0);
        });
    }, {
        immediate: !0
    }), l;
}

});
parcelRegister("6uLV9", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $4baab783b7ca239b$export$6ccbb43953eebf8);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
function $4baab783b7ca239b$export$6ccbb43953eebf8(t) {
    let e = (0, $01W3b.shallowRef)(t.getSnapshot());
    return (0, $TusQn.onUnmounted)(t.subscribe(()=>{
        e.value = t.getSnapshot();
    })), e;
}

});

parcelRegister("bGp41", function(module, exports) {

$parcel$export(module.exports, "overflows", () => $88170f1a383b6d87$export$a4161f418919b5aa);

var $1SR95 = parcelRequire("1SR95");

var $8nfq8 = parcelRequire("8nfq8");

var $2N4su = parcelRequire("2N4su");

var $gtrGK = parcelRequire("gtrGK");

var $cJJLq = parcelRequire("cJJLq");
function $88170f1a383b6d87$var$m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let $88170f1a383b6d87$export$a4161f418919b5aa = (0, $8nfq8.createStore)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, $1SR95.disposables)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: $88170f1a383b6d87$var$m(t)
        }, c = [
            (0, $gtrGK.handleIOSLocking)(),
            (0, $2N4su.adjustScrollbarPadding)(),
            (0, $cJJLq.preventScroll)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$88170f1a383b6d87$export$a4161f418919b5aa.subscribe(()=>{
    let e = $88170f1a383b6d87$export$a4161f418919b5aa.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && $88170f1a383b6d87$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $88170f1a383b6d87$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});

});
parcelRegister("1SR95", function(module, exports) {

$parcel$export(module.exports, "disposables", () => $15f40f2d0c2686fb$export$12b26c28a05aa001);

var $7t12d = parcelRequire("7t12d");
function $15f40f2d0c2686fb$export$12b26c28a05aa001() {
    let a = [], s = {
        addEventListener (e, t, r, i) {
            return e.addEventListener(t, r, i), s.add(()=>e.removeEventListener(t, r, i));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            s.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            s.requestAnimationFrame(()=>{
                s.requestAnimationFrame(...e);
            });
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            s.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $7t12d.microTask)(()=>{
                t.current && e[0]();
            }), s.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, r) {
            let i = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: r
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: i
                });
            });
        },
        group (e) {
            let t = $15f40f2d0c2686fb$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return a.push(e), ()=>{
                let t = a.indexOf(e);
                if (t >= 0) for (let r of a.splice(t, 1))r();
            };
        },
        dispose () {
            for (let e of a.splice(0))e();
        }
    };
    return s;
}

});

parcelRegister("8nfq8", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $618c6eeab7085db2$export$f51a9068ac82ea43);
function $618c6eeab7085db2$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}

});

parcelRegister("2N4su", function(module, exports) {

$parcel$export(module.exports, "adjustScrollbarPadding", () => $20839dbcda173474$export$110627fb35ef9205);
function $20839dbcda173474$export$110627fb35ef9205() {
    let o;
    return {
        before ({ doc: e }) {
            var l;
            let n = e.documentElement;
            o = ((l = e.defaultView) != null ? l : window).innerWidth - n.clientWidth;
        },
        after ({ doc: e, d: n }) {
            let t = e.documentElement, l = t.clientWidth - t.offsetWidth, r = o - l;
            n.style(t, "paddingRight", `${r}px`);
        }
    };
}

});

parcelRegister("gtrGK", function(module, exports) {

$parcel$export(module.exports, "handleIOSLocking", () => $bfe4d5237999eaf3$export$e3a523dfabf27286);

var $1SR95 = parcelRequire("1SR95");

var $h3osi = parcelRequire("h3osi");
function $bfe4d5237999eaf3$export$e3a523dfabf27286() {
    return (0, $h3osi.isIOS)() ? {
        before ({ doc: r, d: n, meta: c }) {
            function a(o) {
                return c.containers.flatMap((l)=>l()).some((l)=>l.contains(o));
            }
            n.microTask(()=>{
                var s;
                if (window.getComputedStyle(r.documentElement).scrollBehavior !== "auto") {
                    let t = (0, $1SR95.disposables)();
                    t.style(r.documentElement, "scrollBehavior", "auto"), n.add(()=>n.microTask(()=>t.dispose()));
                }
                let o = (s = window.scrollY) != null ? s : window.pageYOffset, l = null;
                n.addEventListener(r, "click", (t)=>{
                    if (t.target instanceof HTMLElement) try {
                        let e = t.target.closest("a");
                        if (!e) return;
                        let { hash: f } = new URL(e.href), i = r.querySelector(f);
                        i && !a(i) && (l = i);
                    } catch  {}
                }, !0), n.addEventListener(r, "touchstart", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (a(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && a(e.parentElement);)e = e.parentElement;
                            n.style(e, "overscrollBehavior", "contain");
                        } else n.style(t.target, "touchAction", "none");
                    }
                }), n.addEventListener(r, "touchmove", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (t.target.tagName === "INPUT") return;
                        if (a(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);)e = e.parentElement;
                            e.dataset.headlessuiPortal === "" && t.preventDefault();
                        } else t.preventDefault();
                    }
                }, {
                    passive: !1
                }), n.add(()=>{
                    var e;
                    let t = (e = window.scrollY) != null ? e : window.pageYOffset;
                    o !== t && window.scrollTo(0, o), l && l.isConnected && (l.scrollIntoView({
                        block: "nearest"
                    }), l = null);
                });
            });
        }
    } : {};
}

});
parcelRegister("h3osi", function(module, exports) {

$parcel$export(module.exports, "isIOS", () => $c6a5afc9b016792b$export$fedb369cb70207f1);
$parcel$export(module.exports, "isMobile", () => $c6a5afc9b016792b$export$d0a8044dce8ff2fc);
function $c6a5afc9b016792b$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $c6a5afc9b016792b$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $c6a5afc9b016792b$export$d0a8044dce8ff2fc() {
    return $c6a5afc9b016792b$export$fedb369cb70207f1() || $c6a5afc9b016792b$export$a11b0059900ceec8();
}

});


parcelRegister("cJJLq", function(module, exports) {

$parcel$export(module.exports, "preventScroll", () => $945d2fc737c8471a$export$d8b6ff28805e84e9);
function $945d2fc737c8471a$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}

});



parcelRegister("4P9tk", function(module, exports) {

$parcel$export(module.exports, "useId", () => $383345c8fe2c1382$export$f680877a34711e37);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
let $383345c8fe2c1382$var$t = Symbol("headlessui.useid"), $383345c8fe2c1382$var$i = 0;
function $383345c8fe2c1382$export$f680877a34711e37() {
    return (0, $TusQn.inject)($383345c8fe2c1382$var$t, ()=>`${++$383345c8fe2c1382$var$i}`)();
}
function $383345c8fe2c1382$export$a83ff0ccca19daa7(e) {
    (0, $TusQn.provide)($383345c8fe2c1382$var$t, e);
}

});

parcelRegister("cU7Tb", function(module, exports) {

$parcel$export(module.exports, "useInert", () => $9650d594be82b5fb$export$bbe4e2927a3450da);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $3U2PJ = parcelRequire("3U2PJ");
let $9650d594be82b5fb$var$i = new Map, $9650d594be82b5fb$var$t = new Map;
function $9650d594be82b5fb$export$bbe4e2927a3450da(d, f = (0, $01W3b.ref)(!0)) {
    (0, $TusQn.watchEffect)((o)=>{
        var a;
        if (!f.value) return;
        let e = (0, $3U2PJ.dom)(d);
        if (!e) return;
        o(function() {
            var u;
            if (!e) return;
            let r = (u = $9650d594be82b5fb$var$t.get(e)) != null ? u : 1;
            if (r === 1 ? $9650d594be82b5fb$var$t.delete(e) : $9650d594be82b5fb$var$t.set(e, r - 1), r !== 1) return;
            let n = $9650d594be82b5fb$var$i.get(e);
            n && (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert, $9650d594be82b5fb$var$i.delete(e));
        });
        let l = (a = $9650d594be82b5fb$var$t.get(e)) != null ? a : 0;
        $9650d594be82b5fb$var$t.set(e, l + 1), l === 0 && ($9650d594be82b5fb$var$i.set(e, {
            "aria-hidden": e.getAttribute("aria-hidden"),
            inert: e.inert
        }), e.setAttribute("aria-hidden", "true"), e.inert = !0);
    });
}

});

parcelRegister("6cHqZ", function(module, exports) {

$parcel$export(module.exports, "useOutsideClick", () => $48458e353d78a4e6$export$71b2224f1ce5e08e);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $3U2PJ = parcelRequire("3U2PJ");

var $eFmmu = parcelRequire("eFmmu");

var $h3osi = parcelRequire("h3osi");

var $lRgXM = parcelRequire("lRgXM");

var $1wXKz = parcelRequire("1wXKz");
function $48458e353d78a4e6$export$71b2224f1ce5e08e(f, m, l = (0, $01W3b.computed)(()=>!0)) {
    function a(e, r) {
        if (!l.value || e.defaultPrevented) return;
        let t = r(e);
        if (t === null || !t.getRootNode().contains(t)) return;
        let c = function o(n) {
            return typeof n == "function" ? o(n()) : Array.isArray(n) || n instanceof Set ? n : [
                n
            ];
        }(f);
        for (let o of c){
            if (o === null) continue;
            let n = o instanceof HTMLElement ? o : (0, $3U2PJ.dom)(o);
            if (n != null && n.contains(t) || e.composed && e.composedPath().includes(n)) return;
        }
        return !(0, $eFmmu.isFocusableElement)(t, (0, $eFmmu.FocusableMode).Loose) && t.tabIndex !== -1 && e.preventDefault(), m(e, t);
    }
    let u = (0, $01W3b.ref)(null);
    (0, $lRgXM.useDocumentEvent)("pointerdown", (e)=>{
        var r, t;
        l.value && (u.value = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $lRgXM.useDocumentEvent)("mousedown", (e)=>{
        var r, t;
        l.value && (u.value = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $lRgXM.useDocumentEvent)("click", (e)=>{
        (0, $h3osi.isMobile)() || u.value && (a(e, ()=>u.value), u.value = null);
    }, !0), (0, $lRgXM.useDocumentEvent)("touchend", (e)=>a(e, ()=>e.target instanceof HTMLElement ? e.target : null), !0), (0, $1wXKz.useWindowEvent)("blur", (e)=>a(e, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}

});
parcelRegister("lRgXM", function(module, exports) {

$parcel$export(module.exports, "useDocumentEvent", () => $fe9bb4c581564936$export$55d2b5df396a097b);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $aWPTL = parcelRequire("aWPTL");
function $fe9bb4c581564936$export$55d2b5df396a097b(e, t, n) {
    (0, $aWPTL.env).isServer || (0, $TusQn.watchEffect)((o)=>{
        document.addEventListener(e, t, n), o(()=>document.removeEventListener(e, t, n));
    });
}

});


parcelRegister("6T44y", function(module, exports) {

$parcel$export(module.exports, "useRootContainers", () => $503b09dc06647cff$export$445f2d1a3d9b1b9f);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $c14U5 = parcelRequire("c14U5");

var $3U2PJ = parcelRequire("3U2PJ");

var $4JxcV = parcelRequire("4JxcV");
function $503b09dc06647cff$export$445f2d1a3d9b1b9f({ defaultContainers: o = [], portals: i, mainTreeNodeRef: H } = {}) {
    let t = (0, $01W3b.ref)(null), r = (0, $4JxcV.getOwnerDocument)(t);
    function u() {
        var l, f, a;
        let n = [];
        for (let e of o)e !== null && (e instanceof HTMLElement ? n.push(e) : "value" in e && e.value instanceof HTMLElement && n.push(e.value));
        if (i != null && i.value) for (let e of i.value)n.push(e);
        for (let e of (l = r == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? l : [])e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (e.contains((0, $3U2PJ.dom)(t)) || e.contains((a = (f = (0, $3U2PJ.dom)(t)) == null ? void 0 : f.getRootNode()) == null ? void 0 : a.host) || n.some((M)=>e.contains(M)) || n.push(e));
        return n;
    }
    return {
        resolveContainers: u,
        contains (n) {
            return u().some((l)=>l.contains(n));
        },
        mainTreeNodeRef: t,
        MainTreeNode () {
            return H != null ? null : (0, $TusQn.h)((0, $c14U5.Hidden), {
                features: (0, $c14U5.Features).Hidden,
                ref: t
            });
        }
    };
}
function $503b09dc06647cff$export$64db24433d7f4942() {
    let o = (0, $01W3b.ref)(null);
    return {
        mainTreeNodeRef: o,
        MainTreeNode () {
            return (0, $TusQn.h)((0, $c14U5.Hidden), {
                features: (0, $c14U5.Features).Hidden,
                ref: o
            });
        }
    };
}

});

parcelRegister("13Itm", function(module, exports) {

$parcel$export(module.exports, "State", () => $0c589196ce2e8b52$export$7254cc27399e90bd);
$parcel$export(module.exports, "useOpenClosed", () => $0c589196ce2e8b52$export$fc6fdf0ecf360e);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
let $0c589196ce2e8b52$var$n = Symbol("Context");
var $0c589196ce2e8b52$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($0c589196ce2e8b52$export$7254cc27399e90bd || {});
function $0c589196ce2e8b52$export$807a8cd446d08997() {
    return $0c589196ce2e8b52$export$fc6fdf0ecf360e() !== null;
}
function $0c589196ce2e8b52$export$fc6fdf0ecf360e() {
    return (0, $TusQn.inject)($0c589196ce2e8b52$var$n, null);
}
function $0c589196ce2e8b52$export$640900bce176f617(o) {
    (0, $TusQn.provide)($0c589196ce2e8b52$var$n, o);
}

});

parcelRegister("hmgEN", function(module, exports) {

$parcel$export(module.exports, "usePortalRoot", () => $ca31698004fc0111$export$6ecd3efa4eebe261);
$parcel$export(module.exports, "ForcePortalRoot", () => $ca31698004fc0111$export$8f2af6644e3a3c93);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $k8S1l = parcelRequire("k8S1l");
let $ca31698004fc0111$var$e = Symbol("ForcePortalRootContext");
function $ca31698004fc0111$export$6ecd3efa4eebe261() {
    return (0, $TusQn.inject)($ca31698004fc0111$var$e, !1);
}
let $ca31698004fc0111$export$8f2af6644e3a3c93 = (0, $TusQn.defineComponent)({
    name: "ForcePortalRoot",
    props: {
        as: {
            type: [
                Object,
                String
            ],
            default: "template"
        },
        force: {
            type: Boolean,
            default: !1
        }
    },
    setup (o, { slots: t, attrs: r }) {
        return (0, $TusQn.provide)($ca31698004fc0111$var$e, o.force), ()=>{
            let { force: f, ...n } = o;
            return (0, $k8S1l.render)({
                theirProps: n,
                ourProps: {},
                slot: {},
                slots: t,
                attrs: r,
                name: "ForcePortalRoot"
            });
        };
    }
});

});

parcelRegister("dScJl", function(module, exports) {

$parcel$export(module.exports, "StackMessage", () => $a19a317ac7fee76f$export$2dd25ef07fea092e);
$parcel$export(module.exports, "useStackProvider", () => $a19a317ac7fee76f$export$e8992e582e35a345);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
let $a19a317ac7fee76f$var$u = Symbol("StackContext");
var $a19a317ac7fee76f$export$2dd25ef07fea092e = ((e)=>(e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))($a19a317ac7fee76f$export$2dd25ef07fea092e || {});
function $a19a317ac7fee76f$export$59510f5936c4d8c4() {
    return (0, $TusQn.inject)($a19a317ac7fee76f$var$u, ()=>{});
}
function $a19a317ac7fee76f$export$e8992e582e35a345({ type: o, enabled: r, element: e, onUpdate: i }) {
    let a = $a19a317ac7fee76f$export$59510f5936c4d8c4();
    function t(...n) {
        i == null || i(...n), a(...n);
    }
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watch)(r, (n, d)=>{
            n ? t(0, o, e) : d === !0 && t(1, o, e);
        }, {
            immediate: !0,
            flush: "sync"
        });
    }), (0, $TusQn.onUnmounted)(()=>{
        r.value && t(1, o, e);
    }), (0, $TusQn.provide)($a19a317ac7fee76f$var$u, t);
}

});

parcelRegister("haTmA", function(module, exports) {

$parcel$export(module.exports, "Keys", () => $c80e50d3db2de0a2$export$4b0075e5ea5e1f26);
var $c80e50d3db2de0a2$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($c80e50d3db2de0a2$export$4b0075e5ea5e1f26 || {});

});

parcelRegister("kSJAB", function(module, exports) {

$parcel$export(module.exports, "useDescriptions", () => $f33c36e64cfe1fcf$export$babde88292020af7);
$parcel$export(module.exports, "Description", () => $f33c36e64cfe1fcf$export$393edc798c47379d);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $4P9tk = parcelRequire("4P9tk");

var $k8S1l = parcelRequire("k8S1l");
let $f33c36e64cfe1fcf$var$u = Symbol("DescriptionContext");
function $f33c36e64cfe1fcf$var$w() {
    let t = (0, $TusQn.inject)($f33c36e64cfe1fcf$var$u, null);
    if (t === null) throw new Error("Missing parent");
    return t;
}
function $f33c36e64cfe1fcf$export$babde88292020af7({ slot: t = (0, $01W3b.ref)({}), name: o = "Description", props: s = {} } = {}) {
    let e = (0, $01W3b.ref)([]);
    function r(n) {
        return e.value.push(n), ()=>{
            let i = e.value.indexOf(n);
            i !== -1 && e.value.splice(i, 1);
        };
    }
    return (0, $TusQn.provide)($f33c36e64cfe1fcf$var$u, {
        register: r,
        slot: t,
        name: o,
        props: s
    }), (0, $01W3b.computed)(()=>e.value.length > 0 ? e.value.join(" ") : void 0);
}
let $f33c36e64cfe1fcf$export$393edc798c47379d = (0, $TusQn.defineComponent)({
    name: "Description",
    props: {
        as: {
            type: [
                Object,
                String
            ],
            default: "p"
        },
        id: {
            type: String,
            default: null
        }
    },
    setup (t, { attrs: o, slots: s }) {
        var n;
        let e = (n = t.id) != null ? n : `headlessui-description-${(0, $4P9tk.useId)()}`, r = $f33c36e64cfe1fcf$var$w();
        return (0, $TusQn.onMounted)(()=>(0, $TusQn.onUnmounted)(r.register(e))), ()=>{
            let { name: i = "Description", slot: l = (0, $01W3b.ref)({}), props: d = {} } = r, { ...c } = t, f = {
                ...Object.entries(d).reduce((a, [g, m])=>Object.assign(a, {
                        [g]: (0, $01W3b.unref)(m)
                    }), {}),
                id: e
            };
            return (0, $k8S1l.render)({
                ourProps: f,
                theirProps: c,
                slot: l.value,
                attrs: o,
                slots: s,
                name: i
            });
        };
    }
});

});

parcelRegister("euWu2", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $a8e13ba564cd5dea$export$602eac185826482c);
$parcel$export(module.exports, "useNestedPortals", () => $a8e13ba564cd5dea$export$26b8c35244a70b37);
$parcel$export(module.exports, "PortalGroup", () => $a8e13ba564cd5dea$export$84c667e5e4409848);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $hmgEN = parcelRequire("hmgEN");

var $3U2PJ = parcelRequire("3U2PJ");

var $4JxcV = parcelRequire("4JxcV");

var $k8S1l = parcelRequire("k8S1l");
function $a8e13ba564cd5dea$var$x(e) {
    let t = (0, $4JxcV.getOwnerDocument)(e);
    if (!t) {
        if (e === null) return null;
        throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
    }
    let l = t.getElementById("headlessui-portal-root");
    if (l) return l;
    let r = t.createElement("div");
    return r.setAttribute("id", "headlessui-portal-root"), t.body.appendChild(r);
}
const $a8e13ba564cd5dea$var$f = new WeakMap;
function $a8e13ba564cd5dea$var$U(e) {
    var t;
    return (t = $a8e13ba564cd5dea$var$f.get(e)) != null ? t : 0;
}
function $a8e13ba564cd5dea$var$M(e, t) {
    let l = t($a8e13ba564cd5dea$var$U(e));
    return l <= 0 ? $a8e13ba564cd5dea$var$f.delete(e) : $a8e13ba564cd5dea$var$f.set(e, l), l;
}
let $a8e13ba564cd5dea$export$602eac185826482c = (0, $TusQn.defineComponent)({
    name: "Portal",
    props: {
        as: {
            type: [
                Object,
                String
            ],
            default: "div"
        }
    },
    setup (e, { slots: t, attrs: l }) {
        let r = (0, $01W3b.ref)(null), i = (0, $01W3b.computed)(()=>(0, $4JxcV.getOwnerDocument)(r)), o = (0, $hmgEN.usePortalRoot)(), u = (0, $TusQn.inject)($a8e13ba564cd5dea$var$H, null), n = (0, $01W3b.ref)(o === !0 || u == null ? $a8e13ba564cd5dea$var$x(r.value) : u.resolveTarget());
        n.value && $a8e13ba564cd5dea$var$M(n.value, (a)=>a + 1);
        let c = (0, $01W3b.ref)(!1);
        (0, $TusQn.onMounted)(()=>{
            c.value = !0;
        }), (0, $TusQn.watchEffect)(()=>{
            o || u != null && (n.value = u.resolveTarget());
        });
        let v = (0, $TusQn.inject)($a8e13ba564cd5dea$var$d, null), g = !1, b = (0, $TusQn.getCurrentInstance)();
        return (0, $TusQn.watch)(r, ()=>{
            if (g || !v) return;
            let a = (0, $3U2PJ.dom)(r);
            a && ((0, $TusQn.onUnmounted)(v.register(a), b), g = !0);
        }), (0, $TusQn.onUnmounted)(()=>{
            var P, T;
            let a = (P = i.value) == null ? void 0 : P.getElementById("headlessui-portal-root");
            !a || n.value !== a || $a8e13ba564cd5dea$var$M(n.value, (L)=>L - 1) || n.value.children.length > 0 || (T = n.value.parentElement) == null || T.removeChild(n.value);
        }), ()=>{
            if (!c.value || n.value === null) return null;
            let a = {
                ref: r,
                "data-headlessui-portal": ""
            };
            return (0, $TusQn.h)((0, $TusQn.Teleport), {
                to: n.value
            }, (0, $k8S1l.render)({
                ourProps: a,
                theirProps: e,
                slot: {},
                attrs: l,
                slots: t,
                name: "Portal"
            }));
        };
    }
}), $a8e13ba564cd5dea$var$d = Symbol("PortalParentContext");
function $a8e13ba564cd5dea$export$26b8c35244a70b37() {
    let e = (0, $TusQn.inject)($a8e13ba564cd5dea$var$d, null), t = (0, $01W3b.ref)([]);
    function l(o) {
        return t.value.push(o), e && e.register(o), ()=>r(o);
    }
    function r(o) {
        let u = t.value.indexOf(o);
        u !== -1 && t.value.splice(u, 1), e && e.unregister(o);
    }
    let i = {
        register: l,
        unregister: r,
        portals: t
    };
    return [
        t,
        (0, $TusQn.defineComponent)({
            name: "PortalWrapper",
            setup (o, { slots: u }) {
                return (0, $TusQn.provide)($a8e13ba564cd5dea$var$d, i), ()=>{
                    var n;
                    return (n = u.default) == null ? void 0 : n.call(u);
                };
            }
        })
    ];
}
let $a8e13ba564cd5dea$var$H = Symbol("PortalGroupContext"), $a8e13ba564cd5dea$export$84c667e5e4409848 = (0, $TusQn.defineComponent)({
    name: "PortalGroup",
    props: {
        as: {
            type: [
                Object,
                String
            ],
            default: "template"
        },
        target: {
            type: Object,
            default: null
        }
    },
    setup (e, { attrs: t, slots: l }) {
        let r = (0, $01W3b.reactive)({
            resolveTarget () {
                return e.target;
            }
        });
        return (0, $TusQn.provide)($a8e13ba564cd5dea$var$H, r), ()=>{
            let { target: i, ...o } = e;
            return (0, $k8S1l.render)({
                theirProps: o,
                ourProps: {},
                slot: {},
                attrs: t,
                slots: l,
                name: "PortalGroup"
            });
        };
    }
});

});


parcelRegister("lXB30", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffcbd888a5dc904a$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $ffcbd888a5dc904a$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
        })
    ]);
}

});

parcelRegister("5j8xD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dd55a3de727e2d1$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $3dd55a3de727e2d1$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6 18 18 6M6 6l12 12"
        })
    ]);
}

});

parcelRegister("lRag7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe9681732b3e2900$export$2e2bcd8739ae039);
let $fe9681732b3e2900$var$script;


let $fe9681732b3e2900$var$initialize = ()=>{
    $fe9681732b3e2900$var$script = {};
    $fe9681732b3e2900$var$script.render = (parcelRequire("10ZTi")).render;
    (parcelRequire("6X9AZ")).default($fe9681732b3e2900$var$script);
    $fe9681732b3e2900$var$script.__scopeId = "data-v-672205";
    $fe9681732b3e2900$var$script.__file = "LogoutIcon.vue";
};
$fe9681732b3e2900$var$initialize();
var $fe9681732b3e2900$export$2e2bcd8739ae039 = $fe9681732b3e2900$var$script;

});
parcelRegister("10ZTi", function(module, exports) {

$parcel$export(module.exports, "render", () => $0bd5ccbf8976d188$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $0bd5ccbf8976d188$var$_hoisted_1 = {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "w-6 h-6"
};
const $0bd5ccbf8976d188$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
}, null, -1 /* HOISTED */ );
const $0bd5ccbf8976d188$var$_hoisted_3 = [
    $0bd5ccbf8976d188$var$_hoisted_2
];
function $0bd5ccbf8976d188$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $0bd5ccbf8976d188$var$_hoisted_1, $0bd5ccbf8976d188$var$_hoisted_3);
}

});

parcelRegister("6X9AZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $50ffb243e89e8e4d$export$2e2bcd8739ae039);
let $50ffb243e89e8e4d$var$NOOP = ()=>{};
var $50ffb243e89e8e4d$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("ld3le", function(module, exports) {

$parcel$export(module.exports, "render", () => $f70d676795828f9e$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $f70d676795828f9e$var$_hoisted_1 = {
    class: "fixed z-50 top-0 start-0 w-full bg-basecolor text-primary after:absolute after:bottom-0 after:w-full after:h-[3px] after:bg-highlightLight"
};
const $f70d676795828f9e$var$_hoisted_2 = {
    class: "relative mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-1"
};
const $f70d676795828f9e$var$_hoisted_3 = {
    class: "flex items-center gap-x-12"
};
const $f70d676795828f9e$var$_hoisted_4 = {
    class: "sr-only"
};
const $f70d676795828f9e$var$_hoisted_5 = {
    class: "font-bold p-3 flex-col"
};
const $f70d676795828f9e$var$_hoisted_6 = {
    class: "relative hidden lg:flex lg:gap-x-12"
};
const $f70d676795828f9e$var$_hoisted_7 = {
    class: "hidden lg:flex lg:gap-x-12"
};
const $f70d676795828f9e$var$_hoisted_8 = {
    class: "flex lg:hidden"
};
const $f70d676795828f9e$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
    class: "sr-only"
}, "Open main menu", -1 /* HOISTED */ );
const $f70d676795828f9e$var$_hoisted_10 = {
    class: "hidden lg:flex items-center gap-x-4"
};
const $f70d676795828f9e$var$_hoisted_11 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "fixed inset-0 z-50"
}, null, -1 /* HOISTED */ );
const $f70d676795828f9e$var$_hoisted_12 = {
    class: "flex items-center justify-between"
};
const $f70d676795828f9e$var$_hoisted_13 = {
    class: "sr-only"
};
const $f70d676795828f9e$var$_hoisted_14 = {
    class: "sr-only"
};
const $f70d676795828f9e$var$_hoisted_15 = {
    class: "mt-6 flow-root"
};
const $f70d676795828f9e$var$_hoisted_16 = {
    class: "-my-6 divide-y divide-gray-500/10"
};
const $f70d676795828f9e$var$_hoisted_17 = {
    class: "space-y-2 py-6"
};
const $f70d676795828f9e$var$_hoisted_18 = {
    class: "py-6"
};
function $f70d676795828f9e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("header", $f70d676795828f9e$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("nav", $f70d676795828f9e$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $f70d676795828f9e$var$_hoisted_3, [
                (0, $TusQn.createVNode)($setup["RouterLink"], {
                    to: $setup.homeNavigation,
                    class: "-m-1.5 p-1.5 inline-flex"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createElementVNode)("span", $f70d676795828f9e$var$_hoisted_4, (0, $8POXm.toDisplayString)(_ctx.$t("appTitle")), 1 /* TEXT */ ),
                            (0, $TusQn.createVNode)($setup["GamebookLogo"], {
                                class: "flex-col h-12 w-auto"
                            }),
                            (0, $TusQn.createElementVNode)("span", $f70d676795828f9e$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("appTitle")), 1 /* TEXT */ )
                        ]),
                    _: 1 /* STABLE */ 
                }, 8 /* PROPS */ , [
                    "to"
                ]),
                (0, $TusQn.createElementVNode)("div", $f70d676795828f9e$var$_hoisted_6, [
                    (0, $TusQn.createElementVNode)("div", $f70d676795828f9e$var$_hoisted_7, [
                        ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.navigationData, (item)=>{
                            return (0, $TusQn.createVNode)($setup["RouterLink"], {
                                key: item.name,
                                to: item.href,
                                class: "relative pb-2"
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createElementVNode)("span", {
                                            class: (0, $8POXm.normalizeClass)($setup.navLinkClasses(item.href))
                                        }, (0, $8POXm.toDisplayString)(item.name), 3 /* TEXT, CLASS */ ),
                                        (0, $TusQn.createElementVNode)("span", {
                                            class: (0, $8POXm.normalizeClass)([
                                                "absolute left-0 top-[3.5rem] z-50 origin-left h-[7px] rounded-t bg-secondary transition-all duration-300 ease-in-out",
                                                {
                                                    "w-full opacity-100": $setup.isActive(item.href),
                                                    "w-0 group-hover:w-full group-hover:opacity-50": !$setup.isActive(item.href)
                                                }
                                            ])
                                        }, null, 2 /* CLASS */ )
                                    ]),
                                _: 2 /* DYNAMIC */ 
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */ , [
                                "to"
                            ]);
                        }), 64 /* STABLE_FRAGMENT */ ))
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $f70d676795828f9e$var$_hoisted_8, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "-m-2.5 inline-flex items-center justify-center rounded-md p-2.5",
                    onClick: _cache[0] || (_cache[0] = ($event)=>$setup.mobileMenuOpen = true)
                }, [
                    $f70d676795828f9e$var$_hoisted_9,
                    (0, $TusQn.createVNode)($setup["Bars3Icon"], {
                        class: "h-6 w-6",
                        "aria-hidden": "true"
                    })
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $f70d676795828f9e$var$_hoisted_10, [
                $setup.isAuthenticated() ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 0
                }, [
                    (0, $TusQn.createVNode)($setup["RouterLink"], {
                        to: $setup.dashboardNavigation,
                        class: "btn-transparent text-sm px-3 xl:px-4 py-1.5"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("dashboardBtn")), 1 /* TEXT */ )
                            ]),
                        _: 1 /* STABLE */ 
                    }, 8 /* PROPS */ , [
                        "to"
                    ]),
                    (0, $TusQn.createVNode)($setup["RouterLink"], {
                        to: "/logout",
                        class: "btn-transparent text-sm px-3 xl:px-4 py-1.5"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)($setup["LogoutIcon"], {
                                    class: "float-left mr-5"
                                }),
                                (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("logOut")), 1 /* TEXT */ )
                            ]),
                        _: 1 /* STABLE */ 
                    })
                ], 64 /* STABLE_FRAGMENT */ )) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 1
                }, [
                    (0, $TusQn.createVNode)($setup["RouterLink"], {
                        to: $setup.loginNavigation,
                        class: "btn-transparent text-sm px-6 xl:px-12 py-1.5"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("logIn")), 1 /* TEXT */ )
                            ]),
                        _: 1 /* STABLE */ 
                    }, 8 /* PROPS */ , [
                        "to"
                    ]),
                    (0, $TusQn.createVNode)($setup["RouterLink"], {
                        to: $setup.getStartedNavigation,
                        class: "btn-cta text-sm px-4 xl:px-8 py-1.5"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("getStartedCTA")), 1 /* TEXT */ )
                            ]),
                        _: 1 /* STABLE */ 
                    }, 8 /* PROPS */ , [
                        "to"
                    ])
                ], 64 /* STABLE_FRAGMENT */ ))
            ])
        ]),
        (0, $TusQn.createVNode)($setup["Dialog"], {
            class: "lg:hidden",
            onClose: _cache[8] || (_cache[8] = ($event)=>$setup.mobileMenuOpen = false),
            open: $setup.mobileMenuOpen
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    $f70d676795828f9e$var$_hoisted_11,
                    (0, $TusQn.createVNode)($setup["DialogPanel"], {
                        class: "text-primary fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-basecolor px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createElementVNode)("div", $f70d676795828f9e$var$_hoisted_12, [
                                    (0, $TusQn.createVNode)($setup["RouterLink"], {
                                        onClick: _cache[1] || (_cache[1] = ($event)=>$setup.mobileMenuOpen = false),
                                        to: $setup.homeNavigation,
                                        class: "-m-1.5 p-1.5"
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createElementVNode)("span", $f70d676795828f9e$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("appTitle")), 1 /* TEXT */ ),
                                                (0, $TusQn.createVNode)($setup["GamebookLogo"], {
                                                    class: "h-8 w-auto rounded-md"
                                                })
                                            ]),
                                        _: 1 /* STABLE */ 
                                    }, 8 /* PROPS */ , [
                                        "to"
                                    ]),
                                    (0, $TusQn.createElementVNode)("button", {
                                        type: "button",
                                        class: "-m-2.5 rounded-md p-2.5",
                                        onClick: _cache[2] || (_cache[2] = ($event)=>$setup.mobileMenuOpen = false)
                                    }, [
                                        (0, $TusQn.createElementVNode)("span", $f70d676795828f9e$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("nav.closeMenu")), 1 /* TEXT */ ),
                                        (0, $TusQn.createVNode)($setup["XMarkIcon"], {
                                            class: "h-6 w-6",
                                            "aria-hidden": "true"
                                        })
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("div", $f70d676795828f9e$var$_hoisted_15, [
                                    (0, $TusQn.createElementVNode)("div", $f70d676795828f9e$var$_hoisted_16, [
                                        (0, $TusQn.createElementVNode)("div", $f70d676795828f9e$var$_hoisted_17, [
                                            ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.navigationData, (item)=>{
                                                return (0, $TusQn.createVNode)($setup["RouterLink"], {
                                                    onClick: _cache[3] || (_cache[3] = ($event)=>$setup.mobileMenuOpen = false),
                                                    key: item.name,
                                                    to: item.href,
                                                    class: (0, $8POXm.normalizeClass)([
                                                        "text-sm -mx-3 block rounded-lg px-3 py-2 leading-7 hover:bg-gray-50 hover:text-basecolor",
                                                        {
                                                            "bg-secondary": $setup.isActive(item.href)
                                                        }
                                                    ])
                                                }, {
                                                    default: (0, $TusQn.withCtx)(()=>[
                                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1 /* TEXT */ )
                                                        ]),
                                                    _: 2 /* DYNAMIC */ 
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */ , [
                                                    "to",
                                                    "class"
                                                ]);
                                            }), 64 /* STABLE_FRAGMENT */ ))
                                        ]),
                                        (0, $TusQn.createElementVNode)("div", $f70d676795828f9e$var$_hoisted_18, [
                                            $setup.isAuthenticated() ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                                key: 0
                                            }, [
                                                (0, $TusQn.createVNode)($setup["RouterLink"], {
                                                    onClick: _cache[4] || (_cache[4] = ($event)=>$setup.mobileMenuOpen = false),
                                                    to: $setup.dashboardNavigation,
                                                    class: "-mx-3 block rounded-lg px-3 py-2.5 font-semibold leading-7 hover:bg-gray-50 hover:text-basecolor"
                                                }, {
                                                    default: (0, $TusQn.withCtx)(()=>[
                                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("dashboardBtn")), 1 /* TEXT */ )
                                                        ]),
                                                    _: 1 /* STABLE */ 
                                                }, 8 /* PROPS */ , [
                                                    "to"
                                                ]),
                                                (0, $TusQn.createVNode)($setup["RouterLink"], {
                                                    onClick: _cache[5] || (_cache[5] = ($event)=>$setup.mobileMenuOpen = false),
                                                    to: "/logout",
                                                    class: "-mx-3 block rounded-lg px-3 py-2.5 font-semibold leading-7 hover:bg-gray-50 hover:text-basecolor flex items-center"
                                                }, {
                                                    default: (0, $TusQn.withCtx)(()=>[
                                                            (0, $TusQn.createVNode)($setup["LogoutIcon"], {
                                                                class: "mr-2 h-5 w-5"
                                                            }),
                                                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("logOut")), 1 /* TEXT */ )
                                                        ]),
                                                    _: 1 /* STABLE */ 
                                                })
                                            ], 64 /* STABLE_FRAGMENT */ )) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                                key: 1
                                            }, [
                                                (0, $TusQn.createVNode)($setup["RouterLink"], {
                                                    onClick: _cache[6] || (_cache[6] = ($event)=>$setup.mobileMenuOpen = false),
                                                    to: $setup.loginNavigation,
                                                    class: "-mx-3 block rounded-lg px-3 py-2.5 font-semibold leading-7 hover:bg-gray-50 hover:text-basecolor"
                                                }, {
                                                    default: (0, $TusQn.withCtx)(()=>[
                                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("logIn")), 1 /* TEXT */ )
                                                        ]),
                                                    _: 1 /* STABLE */ 
                                                }, 8 /* PROPS */ , [
                                                    "to"
                                                ]),
                                                (0, $TusQn.createVNode)($setup["RouterLink"], {
                                                    onClick: _cache[7] || (_cache[7] = ($event)=>$setup.mobileMenuOpen = false),
                                                    to: $setup.getStartedNavigation,
                                                    class: "-mx-3 block rounded-lg px-3 py-2.5 font-semibold leading-7 hover:bg-gray-50 hover:text-basecolor"
                                                }, {
                                                    default: (0, $TusQn.withCtx)(()=>[
                                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("getStartedCTA")), 1 /* TEXT */ )
                                                        ]),
                                                    _: 1 /* STABLE */ 
                                                }, 8 /* PROPS */ , [
                                                    "to"
                                                ])
                                            ], 64 /* STABLE_FRAGMENT */ ))
                                        ])
                                    ])
                                ])
                            ]),
                        _: 1 /* STABLE */ 
                    })
                ]),
            _: 1 /* STABLE */ 
        }, 8 /* PROPS */ , [
            "open"
        ])
    ]);
}

});

parcelRegister("6ZDgw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5176e5e357c9cac2$export$2e2bcd8739ae039);
let $5176e5e357c9cac2$var$NOOP = ()=>{};
var $5176e5e357c9cac2$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("6GVXz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4df39feaa8e02e48$export$2e2bcd8739ae039);
let $4df39feaa8e02e48$var$script;



let $4df39feaa8e02e48$var$initialize = ()=>{
    $4df39feaa8e02e48$var$script = (parcelRequire("4SEGo"));
    if ($4df39feaa8e02e48$var$script.__esModule) $4df39feaa8e02e48$var$script = $4df39feaa8e02e48$var$script.default;
    $4df39feaa8e02e48$var$script.render = (parcelRequire("fVxB7")).render;
    (parcelRequire("bG5Kz")).default($4df39feaa8e02e48$var$script);
    $4df39feaa8e02e48$var$script.__scopeId = "data-v-1e0398";
    $4df39feaa8e02e48$var$script.__file = "ContactForm.vue";
};
$4df39feaa8e02e48$var$initialize();
var $4df39feaa8e02e48$export$2e2bcd8739ae039 = $4df39feaa8e02e48$var$script;

});
parcelRegister("4SEGo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $38dbc34b0ba7e3e5$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $fRZwI = parcelRequire("fRZwI");

var $hEJWZ = parcelRequire("hEJWZ");

var $ey2ik = parcelRequire("ey2ik");
var $kheUU = parcelRequire("kheUU");
var $lFFdy = parcelRequire("lFFdy");
var $4lpPx = parcelRequire("4lpPx");
var $4Gqbx = parcelRequire("4Gqbx");
var $iDR1F = parcelRequire("iDR1F");

var $jFUWD = parcelRequire("jFUWD");

var $3Wj1M = parcelRequire("3Wj1M");

var $jYHy6 = parcelRequire("jYHy6");

var $1LxTI = parcelRequire("1LxTI");

var $1F5z6 = parcelRequire("1F5z6");

var $bRn2L = parcelRequire("bRn2L");

var $40DKr = parcelRequire("40DKr");

var $1rS06 = parcelRequire("1rS06");

var $3qEQo = parcelRequire("3qEQo");

var $kW7Vr = parcelRequire("kW7Vr");
var $38dbc34b0ba7e3e5$export$2e2bcd8739ae039 = {
    __name: "ContactForm",
    setup (__props, { expose: __expose }) {
        __expose();
        const { t: t } = (0, $jFUWD.useI18n)();
        const { isAuthenticated: isAuthenticated } = (0, $1rS06.useGlobalState)();
        const validationSchema = (0, $01W3b.markRaw)($hEJWZ.object({
            email: $hEJWZ.string().email().lowercase().required().label(t("registerView.accountForm.labels.email")),
            confirmEmail: $hEJWZ.string().email().required().oneOf([
                $hEJWZ.ref("email")
            ], "Emails must match").label(t("registerView.accountForm.labels.confirmEmail")),
            name: $hEJWZ.string().required().label(t("registerView.accountForm.labels.name")),
            helpType: $hEJWZ.string().required().label(t("contact.contactForm.labels.helpType")),
            subject: $hEJWZ.string().required().max(128).label(t("contact.contactForm.labels.subject")),
            message: $hEJWZ.string().required().max(500).label(t("contact.contactForm.labels.message"))
        }));
        const { defineField: defineField, handleSubmit: handleSubmit } = (0, $fRZwI.useForm)({
            validationSchema: validationSchema
        });
        const [email, emailAttrs] = defineField("email");
        const [confirmEmail, confirmEmailAttrs] = defineField("confirmEmail");
        const [name, nameAttrs] = defineField("name");
        const [helpType, helpTypeAttrs] = defineField("helpType");
        const [subject, subjectAttrs] = defineField("subject");
        const [message, messageAttrs] = defineField("message");
        const { callEndpoint: callEndpoint, userFriendlyError: userFriendlyError, isLoading: isLoading } = (0, $bRn2L.default)("contact");
        const createContactFormData = (0, $4Gqbx.default)((0, $4lpPx.default)([
            "email",
            "name",
            "helpType",
            "subject",
            "message"
        ]));
        const { userInfo: userInfo, fetchUserInfo: fetchUserInfo, isLoadingGet: isLoadingGet, errorGet: errorGet } = (0, $3qEQo.default)();
        (0, $TusQn.onMounted)(async ()=>{
            if (isAuthenticated()) {
                await fetchUserInfo();
                if ((0, $lFFdy.default)((0, $kheUU.default)(errorGet.value))) console.error("Error retrieving account data:", errorGet.value);
                email.value = (0, $iDR1F.default)("email", (0, $01W3b.toValue)(userInfo));
                confirmEmail.value = (0, $iDR1F.default)("email", (0, $01W3b.toValue)(userInfo));
                name.value = `${(0, $iDR1F.default)("firstName", (0, $01W3b.toValue)(userInfo))} ${(0, $iDR1F.default)("lastName", (0, $01W3b.toValue)(userInfo))}`;
            }
        });
        const successMessage = (0, $01W3b.ref)("");
        const submit = handleSubmit(async (values)=>{
            const formData = createContactFormData(values);
            await callEndpoint((0, $ey2ik.default)("method", "POST", {
                request: formData
            }));
            successMessage.value = t("contact.contactForm.successMessage");
        });
        const __returned__ = {
            t: t,
            isAuthenticated: isAuthenticated,
            validationSchema: validationSchema,
            defineField: defineField,
            handleSubmit: handleSubmit,
            email: email,
            emailAttrs: emailAttrs,
            confirmEmail: confirmEmail,
            confirmEmailAttrs: confirmEmailAttrs,
            name: name,
            nameAttrs: nameAttrs,
            helpType: helpType,
            helpTypeAttrs: helpTypeAttrs,
            subject: subject,
            subjectAttrs: subjectAttrs,
            message: message,
            messageAttrs: messageAttrs,
            callEndpoint: callEndpoint,
            userFriendlyError: userFriendlyError,
            isLoading: isLoading,
            createContactFormData: createContactFormData,
            userInfo: userInfo,
            fetchUserInfo: fetchUserInfo,
            isLoadingGet: isLoadingGet,
            errorGet: errorGet,
            successMessage: successMessage,
            submit: submit,
            markRaw: $01W3b.markRaw,
            onMounted: $TusQn.onMounted,
            ref: $01W3b.ref,
            toValue: $01W3b.toValue,
            get useForm () {
                return 0, $fRZwI.useForm;
            },
            get yup () {
                return $hEJWZ;
            },
            get pick () {
                return 0, $4lpPx.default;
            },
            get pipe () {
                return 0, $4Gqbx.default;
            },
            get assoc () {
                return 0, $ey2ik.default;
            },
            get not () {
                return 0, $lFFdy.default;
            },
            get isEmpty () {
                return 0, $kheUU.default;
            },
            get prop () {
                return 0, $iDR1F.default;
            },
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            AccountFormField: $3Wj1M.default,
            AccountFormFieldSelect: $jYHy6.default,
            AccountFormTextArea: $1LxTI.default,
            InPlaceAlert: $1F5z6.default,
            get useCallEndPointWith () {
                return 0, $bRn2L.default;
            },
            get helpOptions () {
                return 0, $40DKr.helpOptions;
            },
            get useGlobalState () {
                return 0, $1rS06.useGlobalState;
            },
            get user () {
                return 0, $3qEQo.default;
            },
            WithLoader: $kW7Vr.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("lFFdy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc6d663e9099e5f2$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");
/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */ var $fc6d663e9099e5f2$var$not = /*#__PURE__*/ (0, $aSQee.default)(function not(a) {
    return !a;
});
var $fc6d663e9099e5f2$export$2e2bcd8739ae039 = $fc6d663e9099e5f2$var$not;

});

parcelRegister("4lpPx", function(module, exports) {

$parcel$export(module.exports, "default", () => $329d28ecd48758d6$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");
/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */ var $329d28ecd48758d6$var$pick = /*#__PURE__*/ (0, $2jcOR.default)(function pick(names, obj) {
    var result = {};
    var idx = 0;
    while(idx < names.length){
        if (names[idx] in obj) result[names[idx]] = obj[names[idx]];
        idx += 1;
    }
    return result;
});
var $329d28ecd48758d6$export$2e2bcd8739ae039 = $329d28ecd48758d6$var$pick;

});

parcelRegister("3Wj1M", function(module, exports) {

$parcel$export(module.exports, "default", () => $2de58c68e8ecb4a2$export$2e2bcd8739ae039);
let $2de58c68e8ecb4a2$var$script;



let $2de58c68e8ecb4a2$var$initialize = ()=>{
    $2de58c68e8ecb4a2$var$script = (parcelRequire("hXzpO"));
    if ($2de58c68e8ecb4a2$var$script.__esModule) $2de58c68e8ecb4a2$var$script = $2de58c68e8ecb4a2$var$script.default;
    $2de58c68e8ecb4a2$var$script.render = (parcelRequire("04MM6")).render;
    (parcelRequire("g1YT6")).default($2de58c68e8ecb4a2$var$script);
    $2de58c68e8ecb4a2$var$script.__scopeId = "data-v-85d0c9";
    $2de58c68e8ecb4a2$var$script.__file = "AccountFormField.vue";
};
$2de58c68e8ecb4a2$var$initialize();
var $2de58c68e8ecb4a2$export$2e2bcd8739ae039 = $2de58c68e8ecb4a2$var$script;

});
parcelRegister("hXzpO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d1336b1ce28c5586$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $fRZwI = parcelRequire("fRZwI");
var $d1336b1ce28c5586$export$2e2bcd8739ae039 = {
    __name: "AccountFormField",
    props: /*#__PURE__*/ (0, $TusQn.mergeModels)({
        label: {
            required: true
        },
        inputType: {
            default: "text"
        },
        autoCompleteType: {
            default: null
        },
        id: {
            required: true
        },
        isRequired: {
            default: false
        }
    }, {
        "modelValue": {},
        "modelModifiers": {}
    }),
    emits: [
        "update:modelValue"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const model = (0, $TusQn.useModel)(__props, "modelValue");
        const __returned__ = {
            props: props,
            model: model,
            get ErrorMessage () {
                return 0, $fRZwI.ErrorMessage;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("04MM6", function(module, exports) {

$parcel$export(module.exports, "render", () => $00e6358621bbd096$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $00e6358621bbd096$var$_hoisted_1 = {
    class: "mt-6"
};
const $00e6358621bbd096$var$_hoisted_2 = [
    "for"
];
const $00e6358621bbd096$var$_hoisted_3 = [
    "for"
];
const $00e6358621bbd096$var$_hoisted_4 = {
    class: "mt-3"
};
const $00e6358621bbd096$var$_hoisted_5 = [
    "id",
    "type",
    "required",
    "autocomplete"
];
const $00e6358621bbd096$var$_hoisted_6 = [
    "innerHTML"
];
function $00e6358621bbd096$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $00e6358621bbd096$var$_hoisted_1, [
        $setup.props.isRequired ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("label", {
            key: 0,
            for: $setup.props.id,
            class: "block text-sm font-medium text-primary"
        }, (0, $8POXm.toDisplayString)($props.label) + " *", 9 /* TEXT, PROPS */ , $00e6358621bbd096$var$_hoisted_2)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("label", {
            key: 1,
            for: $setup.props.id,
            class: "block text-sm font-medium text-primary"
        }, (0, $8POXm.toDisplayString)($props.label), 9 /* TEXT, PROPS */ , $00e6358621bbd096$var$_hoisted_3)),
        (0, $TusQn.createElementVNode)("div", $00e6358621bbd096$var$_hoisted_4, [
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)(_ctx.$attrs, {
                id: $setup.props.id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.model = $event),
                type: $setup.props.inputType,
                class: "block w-full input-transparent-text",
                required: $setup.props.isRequired,
                autocomplete: $setup.props.autoCompleteType
            }), null, 16 /* FULL_PROPS */ , $00e6358621bbd096$var$_hoisted_5), [
                [
                    (0, $eeJ70.vModelDynamic),
                    $setup.model
                ]
            ]),
            (0, $TusQn.renderSlot)(_ctx.$slots, "default"),
            (0, $TusQn.createVNode)($setup["ErrorMessage"], {
                name: $setup.props.id,
                class: "px-2 mt-2 text-sm text-red-400 dark:text-red-400",
                as: "p"
            }, {
                default: (0, $TusQn.withCtx)(({ message: message })=>[
                        (0, $TusQn.createElementVNode)("div", {
                            innerHTML: message
                        }, null, 8 /* PROPS */ , $00e6358621bbd096$var$_hoisted_6)
                    ]),
                _: 1 /* STABLE */ 
            }, 8 /* PROPS */ , [
                "name"
            ])
        ])
    ]);
}

});

parcelRegister("g1YT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $babbf85bdb34e1b4$export$2e2bcd8739ae039);
let $babbf85bdb34e1b4$var$NOOP = ()=>{};
var $babbf85bdb34e1b4$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("jYHy6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8b566d677ca4e9e$export$2e2bcd8739ae039);
let $e8b566d677ca4e9e$var$script;



let $e8b566d677ca4e9e$var$initialize = ()=>{
    $e8b566d677ca4e9e$var$script = (parcelRequire("lT0Wh"));
    if ($e8b566d677ca4e9e$var$script.__esModule) $e8b566d677ca4e9e$var$script = $e8b566d677ca4e9e$var$script.default;
    $e8b566d677ca4e9e$var$script.render = (parcelRequire("lzbXg")).render;
    (parcelRequire("1Lp8N")).default($e8b566d677ca4e9e$var$script);
    $e8b566d677ca4e9e$var$script.__scopeId = "data-v-a76047";
    $e8b566d677ca4e9e$var$script.__file = "AccountFormFieldSelect.vue";
};
$e8b566d677ca4e9e$var$initialize();
var $e8b566d677ca4e9e$export$2e2bcd8739ae039 = $e8b566d677ca4e9e$var$script;

});
parcelRegister("lT0Wh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $feef767809a7a136$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $fRZwI = parcelRequire("fRZwI");
var $feef767809a7a136$export$2e2bcd8739ae039 = {
    __name: "AccountFormFieldSelect",
    props: /*#__PURE__*/ (0, $TusQn.mergeModels)({
        label: {
            required: true
        },
        autoCompleteType: {
            default: null
        },
        id: {
            required: true
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        options: {
            default: [
                {
                    id: "none",
                    label: "None",
                    value: "none"
                }
            ],
            required: true
        }
    }, {
        "modelValue": {},
        "modelModifiers": {}
    }),
    emits: [
        "update:modelValue"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const model = (0, $TusQn.useModel)(__props, "modelValue");
        const __returned__ = {
            props: props,
            model: model,
            get ErrorMessage () {
                return 0, $fRZwI.ErrorMessage;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("lzbXg", function(module, exports) {

$parcel$export(module.exports, "render", () => $fb3623d7f47a0dc1$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $fb3623d7f47a0dc1$var$_hoisted_1 = {
    class: "mt-6"
};
const $fb3623d7f47a0dc1$var$_hoisted_2 = [
    "for"
];
const $fb3623d7f47a0dc1$var$_hoisted_3 = [
    "for"
];
const $fb3623d7f47a0dc1$var$_hoisted_4 = {
    class: "mt-3"
};
const $fb3623d7f47a0dc1$var$_hoisted_5 = [
    "required"
];
const $fb3623d7f47a0dc1$var$_hoisted_6 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    class: "bg-basecolor text-primary",
    disabled: "",
    value: ""
}, null, -1 /* HOISTED */ );
const $fb3623d7f47a0dc1$var$_hoisted_7 = [
    "value"
];
function $fb3623d7f47a0dc1$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $fb3623d7f47a0dc1$var$_hoisted_1, [
        $setup.props.isRequired ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("label", {
            key: 0,
            for: $setup.props.id,
            class: "block text-sm font-medium text-primary"
        }, (0, $8POXm.toDisplayString)($props.label) + " *", 9 /* TEXT, PROPS */ , $fb3623d7f47a0dc1$var$_hoisted_2)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("label", {
            key: 1,
            for: $setup.props.id,
            class: "block text-sm font-medium text-primary"
        }, (0, $8POXm.toDisplayString)($props.label), 9 /* TEXT, PROPS */ , $fb3623d7f47a0dc1$var$_hoisted_3)),
        (0, $TusQn.createElementVNode)("div", $fb3623d7f47a0dc1$var$_hoisted_4, [
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.model = $event),
                required: $setup.props.isRequired,
                class: "block w-full bg-transparent text-primary border border-primary text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            }, [
                $fb3623d7f47a0dc1$var$_hoisted_6,
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.props.options, (option)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                        class: "bg-basecolor text-primary",
                        value: option.value,
                        key: option.id
                    }, (0, $8POXm.toDisplayString)(option.label ? option.label : option.labelI18n ? _ctx.$t(option.labelI18n) : "ERR: NO LABEL"), 9 /* TEXT, PROPS */ , $fb3623d7f47a0dc1$var$_hoisted_7);
                }), 128 /* KEYED_FRAGMENT */ ))
            ], 8 /* PROPS */ , $fb3623d7f47a0dc1$var$_hoisted_5), [
                [
                    (0, $eeJ70.vModelSelect),
                    $setup.model
                ]
            ]),
            (0, $TusQn.renderSlot)(_ctx.$slots, "default"),
            (0, $TusQn.createVNode)($setup["ErrorMessage"], {
                name: $setup.props.id,
                class: "px-2 mt-2 text-sm text-red-400 dark:text-red-400",
                as: "p"
            }, null, 8 /* PROPS */ , [
                "name"
            ])
        ])
    ]);
}

});

parcelRegister("1Lp8N", function(module, exports) {

$parcel$export(module.exports, "default", () => $148daeb3de7a6d1a$export$2e2bcd8739ae039);
let $148daeb3de7a6d1a$var$NOOP = ()=>{};
var $148daeb3de7a6d1a$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("1LxTI", function(module, exports) {

$parcel$export(module.exports, "default", () => $149479938178a804$export$2e2bcd8739ae039);
let $149479938178a804$var$script;



let $149479938178a804$var$initialize = ()=>{
    $149479938178a804$var$script = (parcelRequire("8jOdg"));
    if ($149479938178a804$var$script.__esModule) $149479938178a804$var$script = $149479938178a804$var$script.default;
    $149479938178a804$var$script.render = (parcelRequire("8xqE4")).render;
    (parcelRequire("2z5rt")).default($149479938178a804$var$script);
    $149479938178a804$var$script.__scopeId = "data-v-4fa634";
    $149479938178a804$var$script.__file = "AccountFormTextArea.vue";
};
$149479938178a804$var$initialize();
var $149479938178a804$export$2e2bcd8739ae039 = $149479938178a804$var$script;

});
parcelRegister("8jOdg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $60e70c5054aaac35$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $fRZwI = parcelRequire("fRZwI");
var $60e70c5054aaac35$export$2e2bcd8739ae039 = {
    __name: "AccountFormTextArea",
    props: /*#__PURE__*/ (0, $TusQn.mergeModels)({
        label: {
            required: true
        },
        inputType: {
            default: "text"
        },
        autoCompleteType: {
            default: null
        },
        id: {
            required: true
        },
        isRequired: {
            default: false
        }
    }, {
        "modelValue": {},
        "modelModifiers": {}
    }),
    emits: [
        "update:modelValue"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const model = (0, $TusQn.useModel)(__props, "modelValue");
        const __returned__ = {
            props: props,
            model: model,
            get ErrorMessage () {
                return 0, $fRZwI.ErrorMessage;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("8xqE4", function(module, exports) {

$parcel$export(module.exports, "render", () => $63761302434ebe1a$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $63761302434ebe1a$var$_hoisted_1 = {
    class: "mt-6"
};
const $63761302434ebe1a$var$_hoisted_2 = [
    "for"
];
const $63761302434ebe1a$var$_hoisted_3 = [
    "for"
];
const $63761302434ebe1a$var$_hoisted_4 = {
    class: "mt-3"
};
const $63761302434ebe1a$var$_hoisted_5 = [
    "id",
    "type",
    "required",
    "autocomplete"
];
function $63761302434ebe1a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $63761302434ebe1a$var$_hoisted_1, [
        $setup.props.isRequired ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("label", {
            key: 0,
            for: $setup.props.id,
            class: "block text-sm font-medium text-primary"
        }, (0, $8POXm.toDisplayString)($props.label) + " *", 9 /* TEXT, PROPS */ , $63761302434ebe1a$var$_hoisted_2)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("label", {
            key: 1,
            for: $setup.props.id,
            class: "block text-sm font-medium text-primary"
        }, (0, $8POXm.toDisplayString)($props.label), 9 /* TEXT, PROPS */ , $63761302434ebe1a$var$_hoisted_3)),
        (0, $TusQn.createElementVNode)("div", $63761302434ebe1a$var$_hoisted_4, [
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("textarea", (0, $TusQn.mergeProps)(_ctx.$attrs, {
                id: $setup.props.id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.model = $event),
                type: $setup.props.inputType,
                class: "block w-full input-transparent-text",
                required: $setup.props.isRequired,
                autocomplete: $setup.props.autoCompleteType
            }), null, 16 /* FULL_PROPS */ , $63761302434ebe1a$var$_hoisted_5), [
                [
                    (0, $eeJ70.vModelText),
                    $setup.model
                ]
            ]),
            (0, $TusQn.renderSlot)(_ctx.$slots, "default"),
            (0, $TusQn.createVNode)($setup["ErrorMessage"], {
                name: $setup.props.id,
                class: "px-2 mt-2 text-sm text-red-400 dark:text-red-400",
                as: "p"
            }, null, 8 /* PROPS */ , [
                "name"
            ])
        ])
    ]);
}

});

parcelRegister("2z5rt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1de31259a23bd29e$export$2e2bcd8739ae039);
let $1de31259a23bd29e$var$NOOP = ()=>{};
var $1de31259a23bd29e$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("40DKr", function(module, exports) {

$parcel$export(module.exports, "genderOptions", () => $2eb5fea4d668edd2$export$9657669ee60b4be0);
$parcel$export(module.exports, "communicationPreferencesOptions", () => $2eb5fea4d668edd2$export$eb6c53f554ac749c);
$parcel$export(module.exports, "communicationLanguageOptions", () => $2eb5fea4d668edd2$export$d6429c0e22e0d1f2);
$parcel$export(module.exports, "situationOptions", () => $2eb5fea4d668edd2$export$3ed7fd7c3ac7573b);
$parcel$export(module.exports, "countryOptions", () => $2eb5fea4d668edd2$export$d9f9bfd5c6fdc088);
$parcel$export(module.exports, "helpOptions", () => $2eb5fea4d668edd2$export$90ed613bf9243fe9);
const $2eb5fea4d668edd2$export$9657669ee60b4be0 = [
    {
        id: "other",
        labelI18n: "registerView.accountForm.labels.genderOptionOther",
        value: "other"
    },
    {
        id: "male",
        labelI18n: "registerView.accountForm.labels.genderOptionMale",
        value: "male"
    },
    {
        id: "female",
        labelI18n: "registerView.accountForm.labels.genderOptionFemale",
        value: "female"
    }
];
const $2eb5fea4d668edd2$export$eb6c53f554ac749c = [
    {
        id: "preference-email",
        labelI18n: "registerView.accountForm.labels.communicationPreferenceOptionEmail",
        value: "email"
    },
    {
        id: "preference-phone",
        labelI18n: "registerView.accountForm.labels.communicationPreferenceOptionPhone",
        value: "phone"
    }
];
const $2eb5fea4d668edd2$export$d6429c0e22e0d1f2 = [
    {
        id: "en",
        labelI18n: "registerView.accountForm.labels.communicationLanguageOptionEN",
        value: "en"
    },
    {
        id: "de",
        labelI18n: "registerView.accountForm.labels.communicationLanguageOptionDE",
        value: "de"
    }
];
const $2eb5fea4d668edd2$export$3ed7fd7c3ac7573b = [
    {
        id: "A",
        labelI18n: "registerView.accountForm.labels.situationOptions.employed",
        value: "employed"
    },
    {
        id: "B",
        labelI18n: "registerView.accountForm.labels.situationOptions.unemployed",
        value: "unemployed"
    },
    {
        id: "C",
        labelI18n: "registerView.accountForm.labels.situationOptions.training",
        value: "training"
    },
    {
        id: "D",
        labelI18n: "registerView.accountForm.labels.situationOptions.selfEmployed",
        value: "selfEmployed"
    },
    {
        id: "E",
        labelI18n: "registerView.accountForm.labels.situationOptions.student",
        value: "student"
    },
    {
        id: "F",
        labelI18n: "registerView.accountForm.labels.situationOptions.civilServant",
        value: "civilServant"
    },
    {
        id: "G",
        labelI18n: "registerView.accountForm.labels.situationOptions.pensioner",
        value: "pensioner"
    },
    {
        id: "H",
        labelI18n: "registerView.accountForm.labels.situationOptions.other",
        value: "other"
    }
];
const $2eb5fea4d668edd2$export$d9f9bfd5c6fdc088 = [
    {
        id: "A",
        labelI18n: "registerView.accountForm.labels.countries.germany",
        value: "de"
    },
    {
        id: "B",
        labelI18n: "registerView.accountForm.labels.countries.other",
        value: "employed"
    }
];
const $2eb5fea4d668edd2$export$90ed613bf9243fe9 = [
    {
        id: "A",
        value: "Sales",
        labelI18n: "contact.contactForm.options.sales"
    },
    {
        id: "B",
        value: "General help",
        labelI18n: "contact.contactForm.options.help"
    },
    {
        id: "C",
        value: "Information",
        labelI18n: "contact.contactForm.options.info"
    },
    {
        id: "D",
        value: "Account",
        labelI18n: "contact.contactForm.options.account"
    },
    {
        id: "E",
        value: "Feedback",
        labelI18n: "contact.contactForm.options.feedback"
    },
    {
        id: "F",
        value: "Other",
        labelI18n: "contact.contactForm.options.other"
    }
];

});

parcelRegister("3qEQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $27f37b8fb49e430b$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $bRn2L = parcelRequire("bRn2L");
const $27f37b8fb49e430b$var$user = ()=>{
    const { callEndpoint: getCall, endpointData: endpointData, isLoading: isLoadingGet, userFriendlyError: errorGet } = (0, $bRn2L.default)("account");
    const { callEndpoint: updateCall, isLoading: isLoadingUpdate, userFriendlyError: errorUpdate } = (0, $bRn2L.default)("account");
    const fetchUserInfo = async ()=>{
        await getCall({
            method: "GET"
        });
    };
    const userInfo = (0, $01W3b.computed)(()=>endpointData.value || {});
    const updateUserInfo = async (values)=>{
        await updateCall({
            method: "POST",
            request: values
        });
    };
    return {
        fetchUserInfo: fetchUserInfo,
        userInfo: userInfo,
        isLoadingGet: isLoadingGet,
        isLoadingUpdate: isLoadingUpdate,
        updateUserInfo: updateUserInfo,
        errorGet: errorGet,
        errorUpdate: errorUpdate
    };
};
var $27f37b8fb49e430b$export$2e2bcd8739ae039 = $27f37b8fb49e430b$var$user;

});


parcelRegister("fVxB7", function(module, exports) {

$parcel$export(module.exports, "render", () => $b9863daeffa8be35$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $b9863daeffa8be35$var$_hoisted_1 = {
    class: "mt-24 pb-24 pt-12"
};
const $b9863daeffa8be35$var$_hoisted_2 = {
    class: "max-w-4xl mx-auto px-16 py-8 mt-8 base-gradient text-primary rounded-lg"
};
const $b9863daeffa8be35$var$_hoisted_3 = {
    class: "text-2xl"
};
const $b9863daeffa8be35$var$_hoisted_4 = {
    class: "px-4 pb-36 pt-8 sm:px-6"
};
const $b9863daeffa8be35$var$_hoisted_5 = {
    class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-3"
};
const $b9863daeffa8be35$var$_hoisted_6 = {
    class: "flex flex-row justify-end max-w-4xl mx-auto mt-8"
};
const $b9863daeffa8be35$var$_hoisted_7 = {
    type: "submit",
    class: "w-full mt-4 px-14 py-2 btn-cta sm:order-last sm:w-auto"
};
function $b9863daeffa8be35$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b9863daeffa8be35$var$_hoisted_1, [
        (0, $TusQn.createVNode)($setup["WithLoader"], {
            "is-loading": $setup.isLoadingGet
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createVNode)($setup["WithLoader"], {
                        "is-loading": $setup.isLoading
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createElementVNode)("form", {
                                    onSubmit: _cache[8] || (_cache[8] = (0, $eeJ70.withModifiers)((...args)=>$setup.submit && $setup.submit(...args), [
                                        "prevent"
                                    ]))
                                }, [
                                    (0, $TusQn.createElementVNode)("div", $b9863daeffa8be35$var$_hoisted_2, [
                                        (0, $TusQn.createElementVNode)("h2", $b9863daeffa8be35$var$_hoisted_3, (0, $8POXm.toDisplayString)(_ctx.$t("contact.contactForm.header")), 1 /* TEXT */ ),
                                        (0, $TusQn.createElementVNode)("div", $b9863daeffa8be35$var$_hoisted_4, [
                                            (0, $TusQn.createElementVNode)("div", $b9863daeffa8be35$var$_hoisted_5, [
                                                (0, $TusQn.createVNode)($setup["InPlaceAlert"], {
                                                    message: $setup.userFriendlyError,
                                                    type: "error",
                                                    class: "col-span-2",
                                                    onCloseAlert: _cache[0] || (_cache[0] = ($event)=>$setup.userFriendlyError = "")
                                                }, null, 8 /* PROPS */ , [
                                                    "message"
                                                ]),
                                                $setup.successMessage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["InPlaceAlert"], {
                                                    key: 0,
                                                    message: $setup.successMessage,
                                                    type: "success",
                                                    class: "col-span-2",
                                                    onCloseAlert: _cache[1] || (_cache[1] = ($event)=>$setup.successMessage = "")
                                                }, null, 8 /* PROPS */ , [
                                                    "message"
                                                ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                                (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                                                    id: "email",
                                                    label: _ctx.$t("contact.contactForm.labels.email"),
                                                    "is-required": true,
                                                    modelValue: $setup.email,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.email = $event)
                                                }, $setup.emailAttrs, {
                                                    "input-type": "email",
                                                    "auto-complete-type": "email"
                                                }), null, 16 /* FULL_PROPS */ , [
                                                    "label",
                                                    "modelValue"
                                                ]),
                                                (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                                                    id: "confirmEmail",
                                                    label: _ctx.$t("contact.contactForm.labels.confirmEmail"),
                                                    "is-required": true,
                                                    modelValue: $setup.confirmEmail,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.confirmEmail = $event)
                                                }, $setup.confirmEmailAttrs, {
                                                    "input-type": "email",
                                                    "auto-complete-type": "email"
                                                }), null, 16 /* FULL_PROPS */ , [
                                                    "label",
                                                    "modelValue"
                                                ]),
                                                (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                                                    id: "name",
                                                    label: _ctx.$t("contact.contactForm.labels.name"),
                                                    "is-required": true,
                                                    modelValue: $setup.name,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.name = $event)
                                                }, $setup.nameAttrs, {
                                                    "input-type": "text",
                                                    "auto-complete-type": "name"
                                                }), null, 16 /* FULL_PROPS */ , [
                                                    "label",
                                                    "modelValue"
                                                ]),
                                                (0, $TusQn.createVNode)($setup["AccountFormFieldSelect"], (0, $TusQn.mergeProps)({
                                                    id: "helpType",
                                                    label: _ctx.$t("contact.contactForm.labels.helpType"),
                                                    "is-required": true,
                                                    modelValue: $setup.helpType,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.helpType = $event)
                                                }, $setup.helpTypeAttrs, {
                                                    options: $setup.helpOptions
                                                }), null, 16 /* FULL_PROPS */ , [
                                                    "label",
                                                    "modelValue",
                                                    "options"
                                                ]),
                                                (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                                                    id: "subject",
                                                    label: _ctx.$t("contact.contactForm.labels.subject"),
                                                    "is-required": true,
                                                    modelValue: $setup.subject,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.subject = $event)
                                                }, $setup.subjectAttrs, {
                                                    "input-type": "text",
                                                    "auto-complete-type": "subject"
                                                }), null, 16 /* FULL_PROPS */ , [
                                                    "label",
                                                    "modelValue"
                                                ]),
                                                (0, $TusQn.createVNode)($setup["AccountFormTextArea"], (0, $TusQn.mergeProps)({
                                                    id: "message",
                                                    label: _ctx.$t("contact.contactForm.labels.message"),
                                                    "is-required": true,
                                                    modelValue: $setup.message,
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.message = $event)
                                                }, $setup.messageAttrs, {
                                                    class: "min-h-60"
                                                }), null, 16 /* FULL_PROPS */ , [
                                                    "label",
                                                    "modelValue"
                                                ])
                                            ])
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $b9863daeffa8be35$var$_hoisted_6, [
                                        (0, $TusQn.createElementVNode)("button", $b9863daeffa8be35$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("contact.contactForm.submit")), 1 /* TEXT */ )
                                    ])
                                ], 32 /* NEED_HYDRATION */ )
                            ]),
                        _: 1 /* STABLE */ 
                    }, 8 /* PROPS */ , [
                        "is-loading"
                    ])
                ]),
            _: 1 /* STABLE */ 
        }, 8 /* PROPS */ , [
            "is-loading"
        ])
    ]);
}

});

parcelRegister("bG5Kz", function(module, exports) {

$parcel$export(module.exports, "default", () => $880813cdd9850488$export$2e2bcd8739ae039);
let $880813cdd9850488$var$NOOP = ()=>{};
var $880813cdd9850488$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("eUFB1", function(module, exports) {

$parcel$export(module.exports, "render", () => $adb68fc45f8607d7$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $adb68fc45f8607d7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["LandingPageNavBar"]),
        (0, $TusQn.createVNode)($setup["ContactForm"])
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("2eTK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a1820ab8a16a0a7$export$2e2bcd8739ae039);
let $1a1820ab8a16a0a7$var$NOOP = ()=>{};
var $1a1820ab8a16a0a7$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("fpXBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3976c15fa748750$export$2e2bcd8739ae039);
let $b3976c15fa748750$var$script;



let $b3976c15fa748750$var$initialize = ()=>{
    $b3976c15fa748750$var$script = (parcelRequire("hVoWp"));
    if ($b3976c15fa748750$var$script.__esModule) $b3976c15fa748750$var$script = $b3976c15fa748750$var$script.default;
    $b3976c15fa748750$var$script.render = (parcelRequire("4HLaC")).render;
    (parcelRequire("jPdvm")).default($b3976c15fa748750$var$script);
    $b3976c15fa748750$var$script.__scopeId = "data-v-e4d44d";
    $b3976c15fa748750$var$script.__file = "HomeView.vue";
};
$b3976c15fa748750$var$initialize();
var $b3976c15fa748750$export$2e2bcd8739ae039 = $b3976c15fa748750$var$script;

});
parcelRegister("hVoWp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d0cb1b4fd8d21269$export$2e2bcd8739ae039);

var $lP0re = parcelRequire("lP0re");

var $jXydL = parcelRequire("jXydL");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
var $d0cb1b4fd8d21269$export$2e2bcd8739ae039 = {
    __name: "HomeView",
    setup (__props, { expose: __expose }) {
        __expose();
        const activeSection = (0, $01W3b.ref)("");
        (0, $TusQn.provide)("activeSection", activeSection);
        let observer;
        (0, $TusQn.onMounted)(()=>{
            const sections = document.querySelectorAll("section[id]");
            observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    if (entry.isIntersecting) activeSection.value = entry.target.id;
                });
            }, {
                threshold: 0.3,
                rootMargin: "0px 0px -30% 0px"
            });
            sections.forEach((section)=>observer.observe(section));
        });
        (0, $TusQn.onUnmounted)(()=>{
            if (observer) observer.disconnect();
        });
        const __returned__ = {
            activeSection: activeSection,
            get observer () {
                return observer;
            },
            set observer (v){
                observer = v;
            },
            LandingPageNavBar: $lP0re.default,
            Footer: $jXydL.default,
            ref: $01W3b.ref,
            provide: $TusQn.provide,
            onMounted: $TusQn.onMounted,
            onUnmounted: $TusQn.onUnmounted
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("jXydL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e87e129c9f019f14$export$2e2bcd8739ae039);
let $e87e129c9f019f14$var$script;



let $e87e129c9f019f14$var$initialize = ()=>{
    $e87e129c9f019f14$var$script = (parcelRequire("bn1Cj"));
    if ($e87e129c9f019f14$var$script.__esModule) $e87e129c9f019f14$var$script = $e87e129c9f019f14$var$script.default;
    $e87e129c9f019f14$var$script.render = (parcelRequire("5igkU")).render;
    (parcelRequire("bn0Ck")).default($e87e129c9f019f14$var$script);
    $e87e129c9f019f14$var$script.__scopeId = "data-v-8e4b5f";
    $e87e129c9f019f14$var$script.__file = "Footer.vue";
};
$e87e129c9f019f14$var$initialize();
var $e87e129c9f019f14$export$2e2bcd8739ae039 = $e87e129c9f019f14$var$script;

});
parcelRegister("bn1Cj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $847318cda845d652$export$2e2bcd8739ae039);

var $jFUWD = parcelRequire("jFUWD");

var $580JV = parcelRequire("580JV");

var $5lCi4 = parcelRequire("5lCi4");

var $kaorL = parcelRequire("kaorL");

var $3vEhG = parcelRequire("3vEhG");
var $847318cda845d652$export$2e2bcd8739ae039 = {
    __name: "Footer",
    setup (__props, { expose: __expose }) {
        __expose();
        const i18n = (0, $jFUWD.useI18n)();
        const navigation = {
            product: [
                {
                    name: i18n.t("nav.howItWorks"),
                    href: (0, $580JV.default).i18nRoute({
                        name: "home",
                        hash: "#how-it-works"
                    })
                },
                {
                    name: i18n.t("nav.pricing"),
                    href: (0, $580JV.default).i18nRoute({
                        name: "home",
                        hash: "#pricing"
                    })
                }
            ],
            company: [
                {
                    name: i18n.t("nav.whyCyberalarm"),
                    href: (0, $580JV.default).i18nRoute({
                        name: "home",
                        hash: "#why-cyberalarm"
                    })
                },
                {
                    name: i18n.t("nav.aboutUs"),
                    href: (0, $580JV.default).i18nRoute({
                        name: "home",
                        hash: "#about-us"
                    })
                },
                {
                    name: i18n.t("nav.contact"),
                    href: (0, $580JV.default).i18nRoute({
                        name: "contact"
                    })
                }
            ],
            legal: [
                {
                    name: i18n.t("nav.imprint"),
                    href: (0, $580JV.default).i18nRoute({
                        name: "imprint"
                    })
                },
                {
                    name: i18n.t("nav.privacy"),
                    href: "privacy-policy"
                },
                {
                    name: i18n.t("nav.terms"),
                    href: "terms-and-conditions"
                }
            ]
        };
        const __returned__ = {
            i18n: i18n,
            navigation: navigation,
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            get Trans () {
                return 0, $580JV.default;
            },
            GamebookLogo: $5lCi4.default,
            MailIcon: $kaorL.default,
            LinkedInIcon: $3vEhG.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("kaorL", function(module, exports) {

$parcel$export(module.exports, "default", () => $eae7b4728cc74e6b$export$2e2bcd8739ae039);
let $eae7b4728cc74e6b$var$script;


let $eae7b4728cc74e6b$var$initialize = ()=>{
    $eae7b4728cc74e6b$var$script = {};
    $eae7b4728cc74e6b$var$script.render = (parcelRequire("4xYC1")).render;
    (parcelRequire("5GjIq")).default($eae7b4728cc74e6b$var$script);
    $eae7b4728cc74e6b$var$script.__scopeId = "data-v-f00bbd";
    $eae7b4728cc74e6b$var$script.__file = "MailIcon.vue";
};
$eae7b4728cc74e6b$var$initialize();
var $eae7b4728cc74e6b$export$2e2bcd8739ae039 = $eae7b4728cc74e6b$var$script;

});
parcelRegister("4xYC1", function(module, exports) {

$parcel$export(module.exports, "render", () => $34f942d645b10d40$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $34f942d645b10d40$var$_hoisted_1 = {
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $34f942d645b10d40$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("path", {
    d: "M20.8359 4.16797H4.16927C3.02344 4.16797 2.09635 5.10547 2.09635 6.2513L2.08594 18.7513C2.08594 19.8971 3.02344 20.8346 4.16927 20.8346H20.8359C21.9818 20.8346 22.9193 19.8971 22.9193 18.7513V6.2513C22.9193 5.10547 21.9818 4.16797 20.8359 4.16797ZM20.4193 8.59505L13.0547 13.1992C12.7214 13.4076 12.2839 13.4076 11.9505 13.1992L4.58594 8.59505C4.48149 8.53642 4.39002 8.4572 4.31707 8.36219C4.24412 8.26718 4.19121 8.15836 4.16154 8.04231C4.13186 7.92626 4.12604 7.8054 4.14443 7.68704C4.16282 7.56868 4.20504 7.45527 4.26852 7.3537C4.33201 7.25212 4.41544 7.16448 4.51378 7.09609C4.61211 7.02769 4.7233 6.97996 4.84062 6.95578C4.95794 6.9316 5.07894 6.93148 5.19631 6.95541C5.31367 6.97935 5.42496 7.02686 5.52344 7.09505L12.5026 11.4596L19.4818 7.09505C19.5802 7.02686 19.6915 6.97935 19.8089 6.95541C19.9263 6.93148 20.0473 6.9316 20.1646 6.95578C20.2819 6.97996 20.3931 7.02769 20.4914 7.09609C20.5898 7.16448 20.6732 7.25212 20.7367 7.3537C20.8002 7.45527 20.8424 7.56868 20.8608 7.68704C20.8792 7.8054 20.8733 7.92626 20.8437 8.04231C20.814 8.15836 20.7611 8.26718 20.6881 8.36219C20.6152 8.4572 20.5237 8.53642 20.4193 8.59505Z",
    fill: "white"
}, null, -1 /* HOISTED */ );
const $34f942d645b10d40$var$_hoisted_3 = [
    $34f942d645b10d40$var$_hoisted_2
];
function $34f942d645b10d40$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $34f942d645b10d40$var$_hoisted_1, $34f942d645b10d40$var$_hoisted_3);
}

});

parcelRegister("5GjIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $42302b143bfe1275$export$2e2bcd8739ae039);
let $42302b143bfe1275$var$NOOP = ()=>{};
var $42302b143bfe1275$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("3vEhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e383ee66b2d980$export$2e2bcd8739ae039);
let $28e383ee66b2d980$var$script;


let $28e383ee66b2d980$var$initialize = ()=>{
    $28e383ee66b2d980$var$script = {};
    $28e383ee66b2d980$var$script.render = (parcelRequire("2pz47")).render;
    (parcelRequire("gcKU5")).default($28e383ee66b2d980$var$script);
    $28e383ee66b2d980$var$script.__scopeId = "data-v-522eb3";
    $28e383ee66b2d980$var$script.__file = "LinkedInIcon.vue";
};
$28e383ee66b2d980$var$initialize();
var $28e383ee66b2d980$export$2e2bcd8739ae039 = $28e383ee66b2d980$var$script;

});
parcelRegister("2pz47", function(module, exports) {

$parcel$export(module.exports, "render", () => $1c191dd11835b716$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $1c191dd11835b716$var$_hoisted_1 = {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $1c191dd11835b716$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("path", {
    d: "M17.7778 0C18.3671 0 18.9324 0.234126 19.3491 0.650874C19.7659 1.06762 20 1.63285 20 2.22222V17.7778C20 18.3671 19.7659 18.9324 19.3491 19.3491C18.9324 19.7659 18.3671 20 17.7778 20H2.22222C1.63285 20 1.06762 19.7659 0.650874 19.3491C0.234126 18.9324 0 18.3671 0 17.7778V2.22222C0 1.63285 0.234126 1.06762 0.650874 0.650874C1.06762 0.234126 1.63285 0 2.22222 0H17.7778ZM17.2222 17.2222V11.3333C17.2222 10.3727 16.8406 9.45133 16.1613 8.77204C15.482 8.09274 14.5607 7.71111 13.6 7.71111C12.6556 7.71111 11.5556 8.28889 11.0222 9.15556V7.92222H7.92222V17.2222H11.0222V11.7444C11.0222 10.8889 11.7111 10.1889 12.5667 10.1889C12.9792 10.1889 13.3749 10.3528 13.6666 10.6445C13.9583 10.9362 14.1222 11.3319 14.1222 11.7444V17.2222H17.2222ZM4.31111 6.17778C4.80618 6.17778 5.28098 5.98111 5.63104 5.63104C5.98111 5.28098 6.17778 4.80618 6.17778 4.31111C6.17778 3.27778 5.34444 2.43333 4.31111 2.43333C3.81309 2.43333 3.33547 2.63117 2.98332 2.98332C2.63117 3.33547 2.43333 3.81309 2.43333 4.31111C2.43333 5.34444 3.27778 6.17778 4.31111 6.17778ZM5.85556 17.2222V7.92222H2.77778V17.2222H5.85556Z",
    fill: "white"
}, null, -1 /* HOISTED */ );
const $1c191dd11835b716$var$_hoisted_3 = [
    $1c191dd11835b716$var$_hoisted_2
];
function $1c191dd11835b716$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $1c191dd11835b716$var$_hoisted_1, $1c191dd11835b716$var$_hoisted_3);
}

});

parcelRegister("gcKU5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc2266cb7cced71$export$2e2bcd8739ae039);
let $bcc2266cb7cced71$var$NOOP = ()=>{};
var $bcc2266cb7cced71$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("5igkU", function(module, exports) {

$parcel$export(module.exports, "render", () => $3dab4e36ceae7315$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $3dab4e36ceae7315$var$_hoisted_1 = {
    class: "bg-basecolor text-white text-sm",
    "aria-labelledby": "footer-heading"
};
const $3dab4e36ceae7315$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("h2", {
    id: "footer-heading",
    class: "sr-only"
}, " Footer ", -1 /* HOISTED */ );
const $3dab4e36ceae7315$var$_hoisted_3 = {
    class: "mx-auto max-w-7xl px-6 pb-8 pt-10 sm:pt-24 lg:px-8"
};
const $3dab4e36ceae7315$var$_hoisted_4 = {
    class: "xl:grid xl:grid-cols-2 xl:gap-8"
};
const $3dab4e36ceae7315$var$_hoisted_5 = {
    class: "space-y-8"
};
const $3dab4e36ceae7315$var$_hoisted_6 = {
    class: "flex sm:justify-start justify-center items-center gap-2"
};
const $3dab4e36ceae7315$var$_hoisted_7 = {
    class: "text-lg font-bold"
};
const $3dab4e36ceae7315$var$_hoisted_8 = {
    class: "flex sm:justify-start justify-center gap-2"
};
const $3dab4e36ceae7315$var$_hoisted_9 = {
    class: "text-lg"
};
const $3dab4e36ceae7315$var$_hoisted_10 = {
    class: "flex gap-2"
};
const $3dab4e36ceae7315$var$_hoisted_11 = {
    class: "text-xs"
};
const $3dab4e36ceae7315$var$_hoisted_12 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("br", null, null, -1 /* HOISTED */ );
const $3dab4e36ceae7315$var$_hoisted_13 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("br", null, null, -1 /* HOISTED */ );
const $3dab4e36ceae7315$var$_hoisted_14 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("br", null, null, -1 /* HOISTED */ );
const $3dab4e36ceae7315$var$_hoisted_15 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("br", null, null, -1 /* HOISTED */ );
const $3dab4e36ceae7315$var$_hoisted_16 = {
    class: "text-left"
};
const $3dab4e36ceae7315$var$_hoisted_17 = {
    class: "flex gap-2"
};
const $3dab4e36ceae7315$var$_hoisted_18 = {
    class: "text-xs"
};
const $3dab4e36ceae7315$var$_hoisted_19 = {
    class: "flex gap-2"
};
const $3dab4e36ceae7315$var$_hoisted_20 = {
    href: "https://www.linkedin.com/company/cyberalarmtraining",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "flex items-center px-1 gap-2 text-xs text-white hover:underline"
};
const $3dab4e36ceae7315$var$_hoisted_21 = {
    class: "mt-16 sm:grid sm:grid-cols-3 flex flex-col gap-8 xl:mt-0"
};
const $3dab4e36ceae7315$var$_hoisted_22 = {
    class: "text-sm font-semibold leading-6 text-white"
};
const $3dab4e36ceae7315$var$_hoisted_23 = {
    role: "list",
    class: "mt-6 space-y-4"
};
const $3dab4e36ceae7315$var$_hoisted_24 = {
    class: "text-sm font-semibold leading-6 text-white"
};
const $3dab4e36ceae7315$var$_hoisted_25 = {
    role: "list",
    class: "mt-6 space-y-4"
};
const $3dab4e36ceae7315$var$_hoisted_26 = {
    class: "text-sm font-semibold leading-6 text-white"
};
const $3dab4e36ceae7315$var$_hoisted_27 = {
    role: "list",
    class: "mt-6 space-y-4"
};
const $3dab4e36ceae7315$var$_hoisted_28 = {
    class: "mt-4 sm:mt-20 lg:mt-24"
};
const $3dab4e36ceae7315$var$_hoisted_29 = {
    class: "text-xs leading-5 text-gray-400 text-right"
};
function $3dab4e36ceae7315$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("footer", $3dab4e36ceae7315$var$_hoisted_1, [
        $3dab4e36ceae7315$var$_hoisted_2,
        (0, $TusQn.createElementVNode)("div", $3dab4e36ceae7315$var$_hoisted_3, [
            (0, $TusQn.createElementVNode)("div", $3dab4e36ceae7315$var$_hoisted_4, [
                (0, $TusQn.createElementVNode)("div", $3dab4e36ceae7315$var$_hoisted_5, [
                    (0, $TusQn.createElementVNode)("span", $3dab4e36ceae7315$var$_hoisted_6, [
                        (0, $TusQn.createVNode)($setup["GamebookLogo"]),
                        (0, $TusQn.createElementVNode)("p", $3dab4e36ceae7315$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("footer.title")), 1 /* TEXT */ )
                    ]),
                    (0, $TusQn.createElementVNode)("span", $3dab4e36ceae7315$var$_hoisted_8, [
                        (0, $TusQn.createElementVNode)("p", $3dab4e36ceae7315$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("footer.slogan")), 1 /* TEXT */ )
                    ]),
                    (0, $TusQn.createElementVNode)("span", $3dab4e36ceae7315$var$_hoisted_10, [
                        (0, $TusQn.createElementVNode)("p", $3dab4e36ceae7315$var$_hoisted_11, [
                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("company.address1")), 1 /* TEXT */ ),
                            $3dab4e36ceae7315$var$_hoisted_12,
                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("company.address2")), 1 /* TEXT */ ),
                            $3dab4e36ceae7315$var$_hoisted_13,
                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("company.address3")), 1 /* TEXT */ ),
                            $3dab4e36ceae7315$var$_hoisted_14,
                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("company.address4")), 1 /* TEXT */ ),
                            $3dab4e36ceae7315$var$_hoisted_15
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $3dab4e36ceae7315$var$_hoisted_16, [
                        (0, $TusQn.createElementVNode)("span", $3dab4e36ceae7315$var$_hoisted_17, [
                            (0, $TusQn.createVNode)($setup["MailIcon"]),
                            (0, $TusQn.createElementVNode)("p", $3dab4e36ceae7315$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("company.email")), 1 /* TEXT */ )
                        ]),
                        (0, $TusQn.createElementVNode)("span", $3dab4e36ceae7315$var$_hoisted_19, [
                            (0, $TusQn.createElementVNode)("a", $3dab4e36ceae7315$var$_hoisted_20, [
                                (0, $TusQn.createVNode)($setup["LinkedInIcon"]),
                                (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)(_ctx.$t("company.linkedin")), 1 /* TEXT */ )
                            ])
                        ])
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $3dab4e36ceae7315$var$_hoisted_21, [
                    (0, $TusQn.createElementVNode)("div", null, [
                        (0, $TusQn.createElementVNode)("h3", $3dab4e36ceae7315$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("footer.product")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("ul", $3dab4e36ceae7315$var$_hoisted_23, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.navigation.product, (item)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    key: item.name
                                }, [
                                    (0, $TusQn.createVNode)(_component_RouterLink, {
                                        to: item.href,
                                        class: "text-sm leading-6 text-gray-300 hover:text-white"
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1 /* TEXT */ )
                                            ]),
                                        _: 2 /* DYNAMIC */ 
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */ , [
                                        "to"
                                    ])
                                ]);
                            }), 128 /* KEYED_FRAGMENT */ ))
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", null, [
                        (0, $TusQn.createElementVNode)("h3", $3dab4e36ceae7315$var$_hoisted_24, (0, $8POXm.toDisplayString)(_ctx.$t("footer.company")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("ul", $3dab4e36ceae7315$var$_hoisted_25, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.navigation.company, (item)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    key: item.name
                                }, [
                                    (0, $TusQn.createVNode)(_component_RouterLink, {
                                        to: item.href,
                                        class: "text-sm leading-6 text-gray-300 hover:text-white"
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1 /* TEXT */ )
                                            ]),
                                        _: 2 /* DYNAMIC */ 
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */ , [
                                        "to"
                                    ])
                                ]);
                            }), 128 /* KEYED_FRAGMENT */ ))
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", null, [
                        (0, $TusQn.createElementVNode)("h3", $3dab4e36ceae7315$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("footer.legal")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("ul", $3dab4e36ceae7315$var$_hoisted_27, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.navigation.legal, (item)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    key: item.name
                                }, [
                                    (0, $TusQn.createVNode)(_component_RouterLink, {
                                        to: item.href,
                                        class: "text-sm leading-6 text-gray-300 hover:text-white"
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1 /* TEXT */ )
                                            ]),
                                        _: 2 /* DYNAMIC */ 
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */ , [
                                        "to"
                                    ])
                                ]);
                            }), 128 /* KEYED_FRAGMENT */ ))
                        ])
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $3dab4e36ceae7315$var$_hoisted_28, [
                (0, $TusQn.createElementVNode)("p", $3dab4e36ceae7315$var$_hoisted_29, " \xa9 " + (0, $8POXm.toDisplayString)(_ctx.$t("company.copyright")), 1 /* TEXT */ )
            ])
        ])
    ]);
}

});

parcelRegister("bn0Ck", function(module, exports) {

$parcel$export(module.exports, "default", () => $8472524018912fa5$export$2e2bcd8739ae039);
let $8472524018912fa5$var$NOOP = ()=>{};
var $8472524018912fa5$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("4HLaC", function(module, exports) {

$parcel$export(module.exports, "render", () => $36cfc49bdd441b76$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $36cfc49bdd441b76$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterView = (0, $TusQn.resolveComponent)("RouterView");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["LandingPageNavBar"]),
        (0, $TusQn.createVNode)(_component_RouterView),
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("jPdvm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6ed418ab9d4d43f$export$2e2bcd8739ae039);
let $e6ed418ab9d4d43f$var$NOOP = ()=>{};
var $e6ed418ab9d4d43f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("bgAOC", function(module, exports) {

$parcel$export(module.exports, "default", () => $833dbf1d7c3bf473$export$2e2bcd8739ae039);
let $833dbf1d7c3bf473$var$script;



let $833dbf1d7c3bf473$var$initialize = ()=>{
    $833dbf1d7c3bf473$var$script = (parcelRequire("5WqBK"));
    if ($833dbf1d7c3bf473$var$script.__esModule) $833dbf1d7c3bf473$var$script = $833dbf1d7c3bf473$var$script.default;
    $833dbf1d7c3bf473$var$script.render = (parcelRequire("cM5az")).render;
    (parcelRequire("39CES")).default($833dbf1d7c3bf473$var$script);
    $833dbf1d7c3bf473$var$script.__scopeId = "data-v-500d14";
    $833dbf1d7c3bf473$var$script.__file = "ImprintView.vue";
};
$833dbf1d7c3bf473$var$initialize();
var $833dbf1d7c3bf473$export$2e2bcd8739ae039 = $833dbf1d7c3bf473$var$script;

});
parcelRegister("5WqBK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $453702467de548a6$export$2e2bcd8739ae039);

var $jFUWD = parcelRequire("jFUWD");

var $jXydL = parcelRequire("jXydL");

var $lP0re = parcelRequire("lP0re");

var $6TiGr = parcelRequire("6TiGr");
var $453702467de548a6$export$2e2bcd8739ae039 = {
    __name: "ImprintView",
    setup (__props, { expose: __expose }) {
        __expose();
        const { t: t } = (0, $jFUWD.useI18n)();
        const imprints = [
            {
                id: 1,
                title: t("imprintView.siteNotice.title"),
                content: t("imprintView.siteNotice.content")
            },
            {
                id: 2,
                title: t("imprintView.contact.title"),
                content: t("imprintView.contact.content")
            },
            {
                id: 3,
                title: t("imprintView.vat.title"),
                content: t("imprintView.vat.content")
            },
            {
                id: 4,
                title: t("imprintView.editorialResponsible.title"),
                content: t("imprintView.editorialResponsible.content")
            },
            {
                id: 5,
                title: t("imprintView.euDisputeResolution.title"),
                content: t("imprintView.euDisputeResolution.content")
            },
            {
                id: 6,
                title: t("imprintView.disputeProceedings.title"),
                content: t("imprintView.disputeProceedings.content")
            }
        ];
        const __returned__ = {
            t: t,
            imprints: imprints,
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            Footer: $jXydL.default,
            LandingPageNavBar: $lP0re.default,
            ImprintList: $6TiGr.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("6TiGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $50465f485e22e5d0$export$2e2bcd8739ae039);
let $50465f485e22e5d0$var$script;



let $50465f485e22e5d0$var$initialize = ()=>{
    $50465f485e22e5d0$var$script = (parcelRequire("2Z8a7"));
    if ($50465f485e22e5d0$var$script.__esModule) $50465f485e22e5d0$var$script = $50465f485e22e5d0$var$script.default;
    $50465f485e22e5d0$var$script.render = (parcelRequire("g9B73")).render;
    (parcelRequire("6o2ik")).default($50465f485e22e5d0$var$script);
    $50465f485e22e5d0$var$script.__scopeId = "data-v-f020a6";
    $50465f485e22e5d0$var$script.__file = "ImprintList.vue";
};
$50465f485e22e5d0$var$initialize();
var $50465f485e22e5d0$export$2e2bcd8739ae039 = $50465f485e22e5d0$var$script;

});
parcelRegister("2Z8a7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $22c79c188e24c39f$export$2e2bcd8739ae039);
var $22c79c188e24c39f$export$2e2bcd8739ae039 = {
    __name: "ImprintList",
    props: {
        title: {
            type: String,
            required: true
        },
        imprints: {
            type: Array,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = {
            props: props
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("g9B73", function(module, exports) {

$parcel$export(module.exports, "render", () => $bc2a46705b52c714$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $bc2a46705b52c714$var$_hoisted_1 = {
    class: "bg-white"
};
const $bc2a46705b52c714$var$_hoisted_2 = {
    class: "mx-auto max-w-7xl divide-y divide-highlight px-6 py-24 sm:py-32 lg:px-8 lg:py-40"
};
const $bc2a46705b52c714$var$_hoisted_3 = {
    class: "text-2xl font-bold leading-10 tracking-tight text-basecolor"
};
const $bc2a46705b52c714$var$_hoisted_4 = {
    class: "mt-10 space-y-8 divide-y divide-highlight"
};
const $bc2a46705b52c714$var$_hoisted_5 = {
    class: "text-xl font-semibold leading-7 text-basecolor lg:col-span-5"
};
const $bc2a46705b52c714$var$_hoisted_6 = {
    class: "mt-4 lg:col-span-7 lg:mt-0"
};
const $bc2a46705b52c714$var$_hoisted_7 = [
    "innerHTML"
];
function $bc2a46705b52c714$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $bc2a46705b52c714$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $bc2a46705b52c714$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("h2", $bc2a46705b52c714$var$_hoisted_3, (0, $8POXm.toDisplayString)($props.title), 1 /* TEXT */ ),
            (0, $TusQn.createElementVNode)("dl", $bc2a46705b52c714$var$_hoisted_4, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.imprints, (imprint)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: imprint.id,
                        class: "pt-8 lg:grid lg:grid-cols-12 lg:gap-8"
                    }, [
                        (0, $TusQn.createElementVNode)("dt", $bc2a46705b52c714$var$_hoisted_5, (0, $8POXm.toDisplayString)(imprint.title), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("dd", $bc2a46705b52c714$var$_hoisted_6, [
                            (0, $TusQn.createElementVNode)("div", {
                                class: "leading-7 text-basecolor external-text",
                                innerHTML: imprint.content
                            }, null, 8 /* PROPS */ , $bc2a46705b52c714$var$_hoisted_7)
                        ])
                    ]);
                }), 128 /* KEYED_FRAGMENT */ ))
            ])
        ])
    ]);
}

});

parcelRegister("6o2ik", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a66c3a5f20754aa$export$2e2bcd8739ae039);
let $4a66c3a5f20754aa$var$NOOP = ()=>{};
var $4a66c3a5f20754aa$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("cM5az", function(module, exports) {

$parcel$export(module.exports, "render", () => $94cdfa49f12f368f$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $94cdfa49f12f368f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["LandingPageNavBar"]),
        (0, $TusQn.createVNode)($setup["ImprintList"], {
            title: $setup.t("imprintView.title"),
            imprints: $setup.imprints
        }, null, 8 /* PROPS */ , [
            "title"
        ]),
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("39CES", function(module, exports) {

$parcel$export(module.exports, "default", () => $24c03312c3742c98$export$2e2bcd8739ae039);
let $24c03312c3742c98$var$NOOP = ()=>{};
var $24c03312c3742c98$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("99Mjh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aaa6dae1153a07b$export$2e2bcd8739ae039);
let $6aaa6dae1153a07b$var$script;



let $6aaa6dae1153a07b$var$initialize = ()=>{
    $6aaa6dae1153a07b$var$script = (parcelRequire("5sHbJ"));
    if ($6aaa6dae1153a07b$var$script.__esModule) $6aaa6dae1153a07b$var$script = $6aaa6dae1153a07b$var$script.default;
    $6aaa6dae1153a07b$var$script.render = (parcelRequire("a50TV")).render;
    (parcelRequire("34ME9")).default($6aaa6dae1153a07b$var$script);
    $6aaa6dae1153a07b$var$script.__scopeId = "data-v-bafd03";
    $6aaa6dae1153a07b$var$script.__file = "PrivacyPolicyView.vue";
};
$6aaa6dae1153a07b$var$initialize();
var $6aaa6dae1153a07b$export$2e2bcd8739ae039 = $6aaa6dae1153a07b$var$script;

});
parcelRegister("5sHbJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3fa1118e21e697e0$export$2e2bcd8739ae039);

var $jFUWD = parcelRequire("jFUWD");

var $jXydL = parcelRequire("jXydL");

var $lP0re = parcelRequire("lP0re");

var $i2qFL = parcelRequire("i2qFL");
var $3fa1118e21e697e0$export$2e2bcd8739ae039 = {
    __name: "PrivacyPolicyView",
    setup (__props, { expose: __expose }) {
        __expose();
        const { t: t } = (0, $jFUWD.useI18n)();
        const imprints = [
            {
                id: 1,
                title: t("privacyPolicyView.dataProtection.title"),
                content: t("privacyPolicyView.dataProtection.content")
            },
            {
                id: 2,
                title: t("privacyPolicyView.hostingCDN.title"),
                content: t("privacyPolicyView.hostingCDN.content")
            },
            {
                id: 3,
                title: t("privacyPolicyView.generalInformation.title"),
                content: t("privacyPolicyView.generalInformation.content")
            },
            {
                id: 4,
                title: t("privacyPolicyView.recordingData.title"),
                content: t("privacyPolicyView.recordingData.content")
            },
            {
                id: 5,
                title: t("privacyPolicyView.socialMedia.title"),
                content: t("privacyPolicyView.socialMedia.content")
            },
            {
                id: 6,
                title: t("privacyPolicyView.analysisTools.title"),
                content: t("privacyPolicyView.analysisTools.content")
            },
            {
                id: 7,
                title: t("privacyPolicyView.newsletterPrivacyPolicy.title"),
                content: t("privacyPolicyView.newsletterPrivacyPolicy.content")
            },
            {
                id: 8,
                title: t("privacyPolicyView.pluginsTools.title"),
                content: t("privacyPolicyView.pluginsTools.content")
            },
            {
                id: 9,
                title: t("privacyPolicyView.eCommerce.title"),
                content: t("privacyPolicyView.eCommerce.content")
            },
            {
                id: 10,
                title: t("privacyPolicyView.conferenceTools.title"),
                content: t("privacyPolicyView.conferenceTools.content")
            },
            {
                id: 11,
                title: t("privacyPolicyView.customServices.title"),
                content: t("privacyPolicyView.customServices.content")
            }
        ];
        const __returned__ = {
            t: t,
            imprints: imprints,
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            Footer: $jXydL.default,
            LandingPageNavBar: $lP0re.default,
            PrivacyPolicyList: $i2qFL.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("i2qFL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21d1a85bece2e1e$export$2e2bcd8739ae039);
let $d21d1a85bece2e1e$var$script;



let $d21d1a85bece2e1e$var$initialize = ()=>{
    $d21d1a85bece2e1e$var$script = (parcelRequire("1TnKm"));
    if ($d21d1a85bece2e1e$var$script.__esModule) $d21d1a85bece2e1e$var$script = $d21d1a85bece2e1e$var$script.default;
    $d21d1a85bece2e1e$var$script.render = (parcelRequire("eU4TV")).render;
    (parcelRequire("fSw0B")).default($d21d1a85bece2e1e$var$script);
    $d21d1a85bece2e1e$var$script.__scopeId = "data-v-a299ba";
    $d21d1a85bece2e1e$var$script.__file = "PrivacyPolicyList.vue";
};
$d21d1a85bece2e1e$var$initialize();
var $d21d1a85bece2e1e$export$2e2bcd8739ae039 = $d21d1a85bece2e1e$var$script;

});
parcelRegister("1TnKm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $160d5918d54038d2$export$2e2bcd8739ae039);
var $160d5918d54038d2$export$2e2bcd8739ae039 = {
    __name: "PrivacyPolicyList",
    props: {
        title: {
            type: String,
            required: true
        },
        imprints: {
            type: Array,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = {
            props: props
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("eU4TV", function(module, exports) {

$parcel$export(module.exports, "render", () => $ad9a18e1eee43b6d$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $ad9a18e1eee43b6d$var$_hoisted_1 = {
    class: "bg-white"
};
const $ad9a18e1eee43b6d$var$_hoisted_2 = {
    class: "mx-auto max-w-7xl divide-y divide-highlight px-6 py-24 sm:py-32 lg:px-8 lg:py-40"
};
const $ad9a18e1eee43b6d$var$_hoisted_3 = {
    class: "text-2xl font-bold leading-10 tracking-tight text-basecolor"
};
const $ad9a18e1eee43b6d$var$_hoisted_4 = {
    class: "mt-10 space-y-8 divide-y divide-highlight"
};
const $ad9a18e1eee43b6d$var$_hoisted_5 = {
    class: "text-xl font-semibold leading-7 text-basecolor"
};
const $ad9a18e1eee43b6d$var$_hoisted_6 = {
    class: "mt-4"
};
const $ad9a18e1eee43b6d$var$_hoisted_7 = [
    "innerHTML"
];
function $ad9a18e1eee43b6d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $ad9a18e1eee43b6d$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $ad9a18e1eee43b6d$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("h2", $ad9a18e1eee43b6d$var$_hoisted_3, (0, $8POXm.toDisplayString)($props.title), 1 /* TEXT */ ),
            (0, $TusQn.createElementVNode)("dl", $ad9a18e1eee43b6d$var$_hoisted_4, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.imprints, (imprint)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: imprint.id,
                        class: "pt-8"
                    }, [
                        (0, $TusQn.createElementVNode)("dt", $ad9a18e1eee43b6d$var$_hoisted_5, (0, $8POXm.toDisplayString)(imprint.title), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("dd", $ad9a18e1eee43b6d$var$_hoisted_6, [
                            (0, $TusQn.createElementVNode)("div", {
                                class: "leading-7 text-basecolor text-justify external-text",
                                innerHTML: imprint.content
                            }, null, 8 /* PROPS */ , $ad9a18e1eee43b6d$var$_hoisted_7)
                        ])
                    ]);
                }), 128 /* KEYED_FRAGMENT */ ))
            ])
        ])
    ]);
}

});

parcelRegister("fSw0B", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f4ba710e0655c3$export$2e2bcd8739ae039);
let $b8f4ba710e0655c3$var$NOOP = ()=>{};
var $b8f4ba710e0655c3$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("a50TV", function(module, exports) {

$parcel$export(module.exports, "render", () => $756b11f004a076bb$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $756b11f004a076bb$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["LandingPageNavBar"]),
        (0, $TusQn.createVNode)($setup["PrivacyPolicyList"], {
            title: $setup.t("privacyPolicyView.title"),
            imprints: $setup.imprints
        }, null, 8 /* PROPS */ , [
            "title"
        ]),
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("34ME9", function(module, exports) {

$parcel$export(module.exports, "default", () => $23d77b05626292ff$export$2e2bcd8739ae039);
let $23d77b05626292ff$var$NOOP = ()=>{};
var $23d77b05626292ff$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("82LGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5db37f1b64695880$export$2e2bcd8739ae039);
let $5db37f1b64695880$var$script;



let $5db37f1b64695880$var$initialize = ()=>{
    $5db37f1b64695880$var$script = (parcelRequire("ahKcS"));
    if ($5db37f1b64695880$var$script.__esModule) $5db37f1b64695880$var$script = $5db37f1b64695880$var$script.default;
    $5db37f1b64695880$var$script.render = (parcelRequire("jjtxo")).render;
    (parcelRequire("gbh1o")).default($5db37f1b64695880$var$script);
    $5db37f1b64695880$var$script.__scopeId = "data-v-244748";
    $5db37f1b64695880$var$script.__file = "TermsConditionsView.vue";
};
$5db37f1b64695880$var$initialize();
var $5db37f1b64695880$export$2e2bcd8739ae039 = $5db37f1b64695880$var$script;

});
parcelRegister("ahKcS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $77cf559b700b3a70$export$2e2bcd8739ae039);

var $jFUWD = parcelRequire("jFUWD");

var $jXydL = parcelRequire("jXydL");

var $i2qFL = parcelRequire("i2qFL");

var $lP0re = parcelRequire("lP0re");
var $77cf559b700b3a70$export$2e2bcd8739ae039 = {
    __name: "TermsConditionsView",
    setup (__props, { expose: __expose }) {
        __expose();
        const { t: t } = (0, $jFUWD.useI18n)();
        const imprints = [
            {
                id: 1,
                title: t("terms&condition.generalCondition.title"),
                content: t("terms&condition.generalCondition.content")
            },
            {
                id: 2,
                title: t("terms&condition.scope.title"),
                content: t("terms&condition.scope.content")
            },
            {
                id: 3,
                title: t("terms&condition.conclusion.title"),
                content: t("terms&condition.conclusion.content")
            },
            {
                id: 4,
                title: t("terms&condition.withdrawal.title"),
                content: t("terms&condition.withdrawal.content")
            },
            {
                id: 5,
                title: t("terms&condition.defaultPayment.title"),
                content: t("terms&condition.defaultPayment.content")
            },
            {
                id: 6,
                title: t("terms&condition.retention.title"),
                content: t("terms&condition.retention.content")
            },
            {
                id: 7,
                title: t("terms&condition.delivery.title"),
                content: t("terms&condition.delivery.content")
            },
            {
                id: 8,
                title: t("terms&condition.warranty.title"),
                content: t("terms&condition.warranty.content")
            },
            {
                id: 9,
                title: t("terms&condition.liability.title"),
                content: t("terms&condition.liability.content")
            },
            {
                id: 10,
                title: t("terms&condition.dataProtection.title"),
                content: t("terms&condition.dataProtection.content")
            },
            {
                id: 11,
                title: t("terms&condition.final.title"),
                content: t("terms&condition.final.content")
            },
            {
                id: 12,
                title: t("terms&condition.disputeResolution.title"),
                content: t("terms&condition.disputeResolution.content")
            }
        ];
        const __returned__ = {
            t: t,
            imprints: imprints,
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            Footer: $jXydL.default,
            PrivacyPolicyList: $i2qFL.default,
            LandingPageNavBar: $lP0re.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("jjtxo", function(module, exports) {

$parcel$export(module.exports, "render", () => $e0f6b434472b0606$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $e0f6b434472b0606$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["LandingPageNavBar"]),
        (0, $TusQn.createVNode)($setup["PrivacyPolicyList"], {
            title: $setup.t("terms&condition.title"),
            imprints: $setup.imprints
        }, null, 8 /* PROPS */ , [
            "title"
        ]),
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("gbh1o", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc7ae088a857fadd$export$2e2bcd8739ae039);
let $bc7ae088a857fadd$var$NOOP = ()=>{};
var $bc7ae088a857fadd$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("bY4xD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b68d22206e565db$export$2e2bcd8739ae039);
let $8b68d22206e565db$var$script;



let $8b68d22206e565db$var$initialize = ()=>{
    $8b68d22206e565db$var$script = (parcelRequire("ijDHX"));
    if ($8b68d22206e565db$var$script.__esModule) $8b68d22206e565db$var$script = $8b68d22206e565db$var$script.default;
    $8b68d22206e565db$var$script.render = (parcelRequire("chFPN")).render;
    (parcelRequire("b26Fc")).default($8b68d22206e565db$var$script);
    $8b68d22206e565db$var$script.__scopeId = "data-v-978b4e";
    $8b68d22206e565db$var$script.__file = "RegisterView.vue";
};
$8b68d22206e565db$var$initialize();
var $8b68d22206e565db$export$2e2bcd8739ae039 = $8b68d22206e565db$var$script;

});
parcelRegister("ijDHX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d558cd862048bf8a$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $73mM4 = parcelRequire("73mM4");

var $l7ahT = parcelRequire("l7ahT");
var $dnABj = parcelRequire("dnABj");

var $jFUWD = parcelRequire("jFUWD");

var $1ZSdF = parcelRequire("1ZSdF");

var $b916O = parcelRequire("b916O");

var $briW4 = parcelRequire("briW4");

var $fTwov = parcelRequire("fTwov");

var $bgub5 = parcelRequire("bgub5");

var $deRlR = parcelRequire("deRlR");

var $aquiH = parcelRequire("aquiH");

var $bQytf = parcelRequire("bQytf");

var $ifZB1 = parcelRequire("ifZB1");

var $gzF45 = parcelRequire("gzF45");
var $d558cd862048bf8a$export$2e2bcd8739ae039 = {
    __name: "RegisterView",
    setup (__props, { expose: __expose }) {
        __expose();
        const { t: t } = (0, $jFUWD.useI18n)();
        const router = (0, $73mM4.useRouter)();
        const route = (0, $73mM4.useRoute)();
        const isPaymentReturn = (0, $01W3b.computed)(()=>(0, $bQytf.isNotNullAndNotEmpty)(route.params.success));
        const wasPaymentSuccess = (0, $01W3b.computed)(()=>(0, $l7ahT.default)(route.params.success, "true"));
        const freePaymentSuccess = (0, $01W3b.ref)(false);
        const wasFreePaymentSuccess = (0, $01W3b.computed)(()=>freePaymentSuccess.value);
        const RegisterSteps = {
            ChoosePlan: 0,
            AccountDetails: 1,
            Billing: 2,
            Confirmation: 3
        };
        const currentRegisterStep = (0, $01W3b.ref)(RegisterSteps.ChoosePlan);
        (0, $TusQn.onMounted)(()=>{
            if ((0, $01W3b.toValue)(isPaymentReturn)) currentRegisterStep.value = RegisterSteps.Confirmation;
        });
        (0, $TusQn.watch)(currentRegisterStep, (newStep, oldStep)=>{
            const stepNames = {
                0: "ChoosePlan",
                1: "AccountDetails",
                2: "Billing",
                3: "Confirmation"
            };
            (0, $ifZB1.trackEvent)("register_step_changed", {
                event_category: "Register",
                event_label: oldStep !== undefined ? `Changed from ${stepNames[oldStep]} to ${stepNames[newStep]}` : `Initial step ${stepNames[newStep]}`,
                step: newStep
            });
        });
        const emailForPayment = (0, $01W3b.ref)("");
        const chosenCountry = (0, $01W3b.ref)("");
        const chosenVat = (0, $01W3b.ref)(0);
        const chosenPlan = (0, $01W3b.ref)();
        function onPlanChosen(plan) {
            chosenPlan.value = plan;
            currentRegisterStep.value = RegisterSteps.AccountDetails;
            (0, $ifZB1.trackEvent)("plan_chosen", {
                event_category: "Register",
                event_label: plan.name
            });
        }
        function calculateVatByCountry(country) {
            if (country === "de") return 0.19;
            return 0;
        }
        function onDetailsConfirmed(values) {
            emailForPayment.value = (0, $dnABj.default)([
                "user",
                "email"
            ], values);
            chosenCountry.value = (0, $bQytf.isIndividualPlan)(chosenPlan.value) ? (0, $dnABj.default)([
                "user",
                "country"
            ], values) : (0, $dnABj.default)([
                "company",
                "country"
            ], values);
            const country = chosenCountry.value;
            chosenVat.value = calculateVatByCountry(country);
            (0, $deRlR.default)("Country ", country, "VAT", chosenVat.value);
            (0, $deRlR.default)(`Using email ${emailForPayment.value} for Billing step.)`);
            currentRegisterStep.value = RegisterSteps.Billing;
        }
        function onPaymentSuccess() {
            currentRegisterStep.value = RegisterSteps.Confirmation;
            (0, $ifZB1.trackEvent)("payment_success", {
                event_category: "Payments",
                event_label: wasPaymentSuccess
            });
        }
        function onFreePayment() {
            freePaymentSuccess.value = true;
            currentRegisterStep.value = RegisterSteps.Confirmation;
            (0, $ifZB1.trackEvent)("free_payment_success", {
                event_category: "Payments",
                event_label: freePaymentSuccess.value
            });
        }
        function onGoBack() {
            switch(currentRegisterStep.value){
                case RegisterSteps.ChoosePlan:
                    router.push("/");
                    break;
                case RegisterSteps.AccountDetails:
                    currentRegisterStep.value = RegisterSteps.ChoosePlan;
                    break;
                case RegisterSteps.Billing:
                    currentRegisterStep.value = RegisterSteps.AccountDetails;
                    break;
                case RegisterSteps.Confirmation:
                    break;
                default:
                    router.push("/");
                    break;
            }
        }
        const stepsText = {
            plans: t("registerView.processCircle.plan"),
            accountDetails: t("registerView.processCircle.accountDetails"),
            billingInformation: t("registerView.processCircle.billing"),
            confirmation: t("registerView.processCircle.confirmation")
        };
        const steps = [
            {
                name: stepsText.plans,
                isDone: ()=>currentRegisterStep.value > RegisterSteps.ChoosePlan,
                isCurrent: ()=>currentRegisterStep.value === RegisterSteps.ChoosePlan
            },
            {
                name: stepsText.accountDetails,
                isDone: ()=>currentRegisterStep.value > RegisterSteps.AccountDetails,
                isCurrent: ()=>currentRegisterStep.value === RegisterSteps.AccountDetails
            },
            {
                name: stepsText.billingInformation,
                isDone: ()=>currentRegisterStep.value > RegisterSteps.Billing,
                isCurrent: ()=>currentRegisterStep.value === RegisterSteps.Billing
            },
            {
                name: stepsText.confirmation,
                // confirmation is basically always done automatically
                isDone: ()=>currentRegisterStep.value === RegisterSteps.Confirmation,
                isCurrent: ()=>false
            }
        ];
        function devSkipStep() {
            currentRegisterStep.value++;
            if (currentRegisterStep.value === RegisterSteps.Billing) {
                emailForPayment.value = "skippedEmailSo@usethistotest.com";
                (0, $deRlR.default)(`Skipped account. Will use test email ${emailForPayment.value}`);
            }
        }
        function stepShortcutClicked(idx) {
            if (currentRegisterStep.value >= RegisterSteps.Billing) return;
            if (idx < 0 || idx >= currentRegisterStep.value) return;
            currentRegisterStep.value = idx;
        }
        const __returned__ = {
            t: t,
            router: router,
            route: route,
            isPaymentReturn: isPaymentReturn,
            wasPaymentSuccess: wasPaymentSuccess,
            freePaymentSuccess: freePaymentSuccess,
            wasFreePaymentSuccess: wasFreePaymentSuccess,
            RegisterSteps: RegisterSteps,
            currentRegisterStep: currentRegisterStep,
            emailForPayment: emailForPayment,
            chosenCountry: chosenCountry,
            chosenVat: chosenVat,
            chosenPlan: chosenPlan,
            onPlanChosen: onPlanChosen,
            calculateVatByCountry: calculateVatByCountry,
            onDetailsConfirmed: onDetailsConfirmed,
            onPaymentSuccess: onPaymentSuccess,
            onFreePayment: onFreePayment,
            onGoBack: onGoBack,
            stepsText: stepsText,
            steps: steps,
            devSkipStep: devSkipStep,
            stepShortcutClicked: stepShortcutClicked,
            computed: $01W3b.computed,
            onMounted: $TusQn.onMounted,
            ref: $01W3b.ref,
            toValue: $01W3b.toValue,
            watch: $TusQn.watch,
            get useRoute () {
                return 0, $73mM4.useRoute;
            },
            get useRouter () {
                return 0, $73mM4.useRouter;
            },
            get equals () {
                return 0, $l7ahT.default;
            },
            get path () {
                return 0, $dnABj.default;
            },
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            ChoosePlansComponent: $1ZSdF.default,
            BillingComponent: $b916O.default,
            ProcessCircles: $briW4.default,
            ConfirmationComponent: $fTwov.default,
            RegisterNavigationBar: $bgub5.default,
            get logInDevMode () {
                return 0, $deRlR.default;
            },
            CreateAccountStepComponent: $aquiH.default,
            get isIndividualPlan () {
                return 0, $bQytf.isIndividualPlan;
            },
            get isNotNullAndNotEmpty () {
                return 0, $bQytf.isNotNullAndNotEmpty;
            },
            get trackEvent () {
                return 0, $ifZB1.trackEvent;
            },
            get isLocalDevMode () {
                return 0, $gzF45.isLocalDevMode;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("1ZSdF", function(module, exports) {

$parcel$export(module.exports, "default", () => $17458bcb7831d428$export$2e2bcd8739ae039);
let $17458bcb7831d428$var$script;



let $17458bcb7831d428$var$initialize = ()=>{
    $17458bcb7831d428$var$script = (parcelRequire("8YRiy"));
    if ($17458bcb7831d428$var$script.__esModule) $17458bcb7831d428$var$script = $17458bcb7831d428$var$script.default;
    $17458bcb7831d428$var$script.render = (parcelRequire("ehh2b")).render;
    (parcelRequire("161rJ")).default($17458bcb7831d428$var$script);
    $17458bcb7831d428$var$script.__scopeId = "data-v-1124b5";
    $17458bcb7831d428$var$script.__file = "ChoosePlanComponent.vue";
};
$17458bcb7831d428$var$initialize();
var $17458bcb7831d428$export$2e2bcd8739ae039 = $17458bcb7831d428$var$script;

});
parcelRegister("8YRiy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $689d453a8a8ad7ae$export$2e2bcd8739ae039);

var $73mM4 = parcelRequire("73mM4");

var $kheUU = parcelRequire("kheUU");
var $16nvB = parcelRequire("16nvB");

var $580JV = parcelRequire("580JV");

var $j13lk = parcelRequire("j13lk");
var $689d453a8a8ad7ae$export$2e2bcd8739ae039 = {
    __name: "ChoosePlanComponent",
    emits: [
        "planChosen",
        "back"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const emit = __emit;
        const route = (0, $73mM4.useRoute)();
        const router = (0, $73mM4.useRouter)();
        const plansFetched = (plans)=>{
            const givenPlanByQuery = route.query.plan;
            if (givenPlanByQuery !== undefined) {
                const foundPlan = plans.value.find((p)=>!p.needsContact && p.name === givenPlanByQuery);
                if (!(0, $kheUU.default)(foundPlan) && !(0, $16nvB.default)(foundPlan)) {
                    emit("planChosen", foundPlan);
                    // remove query param because we 'consumed' it already
                    router.replace({
                        query: null
                    });
                }
            }
        };
        const __returned__ = {
            emit: emit,
            route: route,
            router: router,
            plansFetched: plansFetched,
            get useRoute () {
                return 0, $73mM4.useRoute;
            },
            get useRouter () {
                return 0, $73mM4.useRouter;
            },
            get isEmpty () {
                return 0, $kheUU.default;
            },
            get isNil () {
                return 0, $16nvB.default;
            },
            get Trans () {
                return 0, $580JV.default;
            },
            FetchPlanCardsComponent: $j13lk.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("j13lk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd80b42535f15f67$export$2e2bcd8739ae039);
let $dd80b42535f15f67$var$script;



let $dd80b42535f15f67$var$initialize = ()=>{
    $dd80b42535f15f67$var$script = (parcelRequire("4aHtr"));
    if ($dd80b42535f15f67$var$script.__esModule) $dd80b42535f15f67$var$script = $dd80b42535f15f67$var$script.default;
    $dd80b42535f15f67$var$script.render = (parcelRequire("10Ohx")).render;
    (parcelRequire("da7hL")).default($dd80b42535f15f67$var$script);
    $dd80b42535f15f67$var$script.__scopeId = "data-v-945688";
    $dd80b42535f15f67$var$script.__file = "FetchPlanCardsComponent.vue";
};
$dd80b42535f15f67$var$initialize();
var $dd80b42535f15f67$export$2e2bcd8739ae039 = $dd80b42535f15f67$var$script;

});
parcelRegister("4aHtr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3099d194653e8c05$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $5e7Uo = parcelRequire("5e7Uo");

var $4Om5W = parcelRequire("4Om5W");

var $f02BR = parcelRequire("f02BR");

var $1rS06 = parcelRequire("1rS06");
var $3099d194653e8c05$export$2e2bcd8739ae039 = {
    __name: "FetchPlanCardsComponent",
    props: [
        "useCallback"
    ],
    emits: [
        "planChosen",
        "fetchingDone"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const emit = __emit;
        const props = __props;
        const { fetch: fetch, response: plans, isLoading: isFetchingPlans } = (0, $4Om5W.fetchPlans)();
        const { userState: userState } = (0, $1rS06.useGlobalState)();
        const filteredPlans = (0, $01W3b.computed)(()=>{
            if (!userState.value.isAuthenticated) return plans.value;
            if ((0, $1rS06.hasCompanyPlan)(userState.value)) return plans.value.filter((plan)=>plan.planId === 2);
            if ((0, $1rS06.hasUserPlan)(userState.value)) return plans.value.filter((plan)=>plan.planId === 1);
            return plans.value;
        });
        (0, $TusQn.onBeforeMount)(async ()=>{
            fetch().then(()=>{
                emit("fetchingDone", plans);
            });
        });
        const __returned__ = {
            emit: emit,
            props: props,
            fetch: fetch,
            plans: plans,
            isFetchingPlans: isFetchingPlans,
            userState: userState,
            filteredPlans: filteredPlans,
            computed: $01W3b.computed,
            onBeforeMount: $TusQn.onBeforeMount,
            onMounted: $TusQn.onMounted,
            PlanCard: $5e7Uo.default,
            get fetchPlans () {
                return 0, $4Om5W.fetchPlans;
            },
            LoadingSpinner: $f02BR.default,
            get hasCompanyPlan () {
                return 0, $1rS06.hasCompanyPlan;
            },
            get hasUserPlan () {
                return 0, $1rS06.hasUserPlan;
            },
            get useGlobalState () {
                return 0, $1rS06.useGlobalState;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("5e7Uo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ce4650bc4565d09$export$2e2bcd8739ae039);
let $3ce4650bc4565d09$var$script;



let $3ce4650bc4565d09$var$initialize = ()=>{
    $3ce4650bc4565d09$var$script = (parcelRequire("4mgUr"));
    if ($3ce4650bc4565d09$var$script.__esModule) $3ce4650bc4565d09$var$script = $3ce4650bc4565d09$var$script.default;
    $3ce4650bc4565d09$var$script.render = (parcelRequire("kuZuJ")).render;
    (parcelRequire("e2bna")).default($3ce4650bc4565d09$var$script);
    $3ce4650bc4565d09$var$script.__scopeId = "data-v-956fa8";
    $3ce4650bc4565d09$var$script.__file = "PlanCard.vue";
};
$3ce4650bc4565d09$var$initialize();
var $3ce4650bc4565d09$export$2e2bcd8739ae039 = $3ce4650bc4565d09$var$script;

});
parcelRegister("4mgUr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $32c6555be4124ede$export$2e2bcd8739ae039);

var $ggmOH = parcelRequire("ggmOH");

var $73mM4 = parcelRequire("73mM4");

var $jFUWD = parcelRequire("jFUWD");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $580JV = parcelRequire("580JV");

var $hbEdS = parcelRequire("hbEdS");

var $4Js1T = parcelRequire("4Js1T");
var $4Gqbx = parcelRequire("4Gqbx");
var $32c6555be4124ede$export$2e2bcd8739ae039 = {
    __name: "PlanCard",
    props: {
        plan: {
            type: Object,
            required: true
        },
        useCallback: {
            required: false,
            default: false
        }
    },
    emits: [
        "planChosen"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const redirectToMail = ()=>{
            window.location.href = "mailto:sales@gamebook.services";
        };
        const roundToTwoDecimals = (value)=>Math.round(value * 100) / 100;
        const applyVat = (0, $4Js1T.default)(1.19);
        const finalPrice = (0, $4Gqbx.default)(applyVat, roundToTwoDecimals);
        // eslint-disable-next-line max-len
        const getSubscriptionPrice = (0, $01W3b.computed)(()=>props.plan.requireCompany ? finalPrice(props.plan.seatPrice) : finalPrice(props.plan.subscriptionPrice));
        const { t: t, tm: tm } = (0, $jFUWD.useI18n)({
            messages: props.plan.description
        });
        const __returned__ = {
            props: props,
            redirectToMail: redirectToMail,
            roundToTwoDecimals: roundToTwoDecimals,
            applyVat: applyVat,
            finalPrice: finalPrice,
            getSubscriptionPrice: getSubscriptionPrice,
            t: t,
            tm: tm,
            get CheckCircleIcon () {
                return 0, $ggmOH.default;
            },
            get RouterLink () {
                return 0, $73mM4.RouterLink;
            },
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            computed: $01W3b.computed,
            get Trans () {
                return 0, $580JV.default;
            },
            Price: $hbEdS.default,
            get multiply () {
                return 0, $4Js1T.default;
            },
            get pipe () {
                return 0, $4Gqbx.default;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("ggmOH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd6fd6e886ded78d$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $bd6fd6e886ded78d$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "fill-rule": "evenodd",
            d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z",
            "clip-rule": "evenodd"
        })
    ]);
}

});

parcelRegister("hbEdS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c832aa29578e2de1$export$2e2bcd8739ae039);
let $c832aa29578e2de1$var$script;



let $c832aa29578e2de1$var$initialize = ()=>{
    $c832aa29578e2de1$var$script = (parcelRequire("4FEUf"));
    if ($c832aa29578e2de1$var$script.__esModule) $c832aa29578e2de1$var$script = $c832aa29578e2de1$var$script.default;
    $c832aa29578e2de1$var$script.render = (parcelRequire("iO3NA")).render;
    (parcelRequire("7CaOe")).default($c832aa29578e2de1$var$script);
    $c832aa29578e2de1$var$script.__scopeId = "data-v-4e5e1b";
    $c832aa29578e2de1$var$script.__file = "Price.vue";
};
$c832aa29578e2de1$var$initialize();
var $c832aa29578e2de1$export$2e2bcd8739ae039 = $c832aa29578e2de1$var$script;

});
parcelRegister("4FEUf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $366ab8e5ccd58842$export$2e2bcd8739ae039);

var $47c0h = parcelRequire("47c0h");
var $5zyMx = parcelRequire("5zyMx");
var $l7ahT = parcelRequire("l7ahT");
var $kheUU = parcelRequire("kheUU");
var $4Js1T = parcelRequire("4Js1T");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $366ab8e5ccd58842$export$2e2bcd8739ae039 = {
    __name: "Price",
    props: {
        price: {
            required: true
        },
        sign: {
            required: false,
            default: ""
        },
        type: {
            required: false,
            default: "money"
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const currencyByType = (0, $01W3b.computed)(()=>(0, $5zyMx.default)([
                [
                    (0, $l7ahT.default)("money"),
                    (0, $47c0h.default)("\u20AC")
                ],
                [
                    (0, $l7ahT.default)("percent"),
                    (0, $47c0h.default)("%")
                ]
            ])(props.type));
        const finalPrice = (0, $01W3b.computed)(()=>Math.round(props.price * 100) / 100);
        const __returned__ = {
            props: props,
            currencyByType: currencyByType,
            finalPrice: finalPrice,
            get always () {
                return 0, $47c0h.default;
            },
            get cond () {
                return 0, $5zyMx.default;
            },
            get equals () {
                return 0, $l7ahT.default;
            },
            get isEmpty () {
                return 0, $kheUU.default;
            },
            get multiply () {
                return 0, $4Js1T.default;
            },
            computed: $01W3b.computed
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("4Js1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $37211b73a19f3a8b$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");
/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      const double = R.multiply(2);
 *      const triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */ var $37211b73a19f3a8b$var$multiply = /*#__PURE__*/ (0, $2jcOR.default)(function multiply(a, b) {
    return a * b;
});
var $37211b73a19f3a8b$export$2e2bcd8739ae039 = $37211b73a19f3a8b$var$multiply;

});


parcelRegister("iO3NA", function(module, exports) {

$parcel$export(module.exports, "render", () => $db0fd7e27917829d$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $db0fd7e27917829d$var$_hoisted_1 = {
    key: 0
};
function $db0fd7e27917829d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", null, [
        !$setup.isEmpty($props.sign) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db0fd7e27917829d$var$_hoisted_1, (0, $8POXm.toDisplayString)($props.sign), 1 /* TEXT */ )) : (0, $TusQn.createCommentVNode)("v-if", true),
        (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($setup.finalPrice) + " " + (0, $8POXm.toDisplayString)($setup.currencyByType), 1 /* TEXT */ )
    ]);
}

});

parcelRegister("7CaOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $58b47780c35ea429$export$2e2bcd8739ae039);
let $58b47780c35ea429$var$NOOP = ()=>{};
var $58b47780c35ea429$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("kuZuJ", function(module, exports) {

$parcel$export(module.exports, "render", () => $eec64f8b245ba7b4$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $eec64f8b245ba7b4$var$_hoisted_1 = {
    class: "base-gradient ring-1 ring-basecolor p-8 text-center text-xs rounded-lg text-primary"
};
const $eec64f8b245ba7b4$var$_hoisted_2 = [
    "id"
];
const $eec64f8b245ba7b4$var$_hoisted_3 = {
    key: 0
};
const $eec64f8b245ba7b4$var$_hoisted_4 = {
    class: "rounded-2xl bg-primary text-basecolor w-10 m-auto text-2xs"
};
const $eec64f8b245ba7b4$var$_hoisted_5 = {
    class: "mt-6 mb-2 items-baseline gap-x-1"
};
const $eec64f8b245ba7b4$var$_hoisted_6 = {
    key: 0,
    class: "text-2xl font-bold tracking-tight"
};
const $eec64f8b245ba7b4$var$_hoisted_7 = {
    key: 1,
    class: "text-sm font-bold tracking-tight"
};
const $eec64f8b245ba7b4$var$_hoisted_8 = [
    "disabled"
];
const $eec64f8b245ba7b4$var$_hoisted_9 = [
    "onClick"
];
const $eec64f8b245ba7b4$var$_hoisted_10 = {
    key: 4,
    class: "mb-3 mt-4 text-2xs"
};
const $eec64f8b245ba7b4$var$_hoisted_11 = {
    key: 5,
    class: "mb-3 mt-4 text-2xs"
};
const $eec64f8b245ba7b4$var$_hoisted_12 = {
    class: "mt-4 text-left leading-6"
};
const $eec64f8b245ba7b4$var$_hoisted_13 = {
    role: "list",
    class: "mt-8 space-y-3 leading-6"
};
function $eec64f8b245ba7b4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $eec64f8b245ba7b4$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h3", {
            id: $setup.props.plan.id,
            class: "text-md font-medium leading-8"
        }, [
            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($setup.t("planName")) + " ", 1 /* TEXT */ ),
            $setup.props.plan.isDemo ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $eec64f8b245ba7b4$var$_hoisted_3, "*")) : (0, $TusQn.createCommentVNode)("v-if", true)
        ], 8 /* PROPS */ , $eec64f8b245ba7b4$var$_hoisted_2),
        (0, $TusQn.createElementVNode)("div", $eec64f8b245ba7b4$var$_hoisted_4, (0, $8POXm.toDisplayString)($setup.props.plan.seats), 1 /* TEXT */ ),
        (0, $TusQn.createElementVNode)("p", $eec64f8b245ba7b4$var$_hoisted_5, [
            !$setup.props.plan.needsContact || $setup.props.plan.isDemo ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $eec64f8b245ba7b4$var$_hoisted_6, [
                (0, $TusQn.createVNode)($setup["Price"], {
                    price: $setup.getSubscriptionPrice
                }, null, 8 /* PROPS */ , [
                    "price"
                ])
            ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $eec64f8b245ba7b4$var$_hoisted_7, (0, $8POXm.toDisplayString)($setup.t("landingPage.prices.contactForPricing")), 1 /* TEXT */ ))
        ]),
        !$setup.props.plan.needsContact && $setup.props.useCallback === true ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
            key: 0,
            disabled: $setup.props.plan.isDemo,
            onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("planChosen", $setup.props.plan)),
            class: "w-full btn-cta m-auto block text-xs py-2"
        }, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.choosePlan")), 9 /* TEXT, PROPS */ , $eec64f8b245ba7b4$var$_hoisted_8)) : !$setup.props.plan.needsContact ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["RouterLink"], {
            key: 1,
            to: $setup.Trans.i18nRoute({
                name: "register",
                query: {
                    plan: $setup.props.plan.name
                }
            })
        }, {
            default: (0, $TusQn.withCtx)(({ navigate: navigate })=>[
                    (0, $TusQn.createElementVNode)("button", {
                        class: "w-full btn-cta m-auto block text-xs py-2",
                        onClick: navigate
                    }, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.startNow")), 9 /* TEXT, PROPS */ , $eec64f8b245ba7b4$var$_hoisted_9)
                ]),
            _: 1 /* STABLE */ 
        }, 8 /* PROPS */ , [
            "to"
        ])) : $setup.props.plan.isDemo ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
            key: 2,
            onClick: $setup.redirectToMail,
            class: "w-full btn-cta m-auto block text-xs py-2"
        }, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.contactUs")), 1 /* TEXT */ )) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["RouterLink"], {
            key: 3,
            to: $setup.Trans.i18nRoute({
                name: "contact"
            }),
            class: "w-full btn-cta m-auto block text-xs py-2"
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("landingPage.contactUs")), 1 /* TEXT */ )
                ]),
            _: 1 /* STABLE */ 
        }, 8 /* PROPS */ , [
            "to"
        ])),
        !$setup.props.plan.isDemo ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $eec64f8b245ba7b4$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.prices.freeTrial")), 1 /* TEXT */ )) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $eec64f8b245ba7b4$var$_hoisted_11, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.prices.limitedTime")), 1 /* TEXT */ )),
        (0, $TusQn.createElementVNode)("p", $eec64f8b245ba7b4$var$_hoisted_12, (0, $8POXm.toDisplayString)($setup.t("planDescription")), 1 /* TEXT */ ),
        (0, $TusQn.createElementVNode)("ul", $eec64f8b245ba7b4$var$_hoisted_13, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.tm("planFeatures"), (feature)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                    key: feature,
                    class: "flex gap-x-3 text-left"
                }, [
                    (0, $TusQn.createVNode)($setup["CheckCircleIcon"], {
                        class: "h-6 w-5 flex-none fill-secondary",
                        "aria-hidden": "true"
                    }),
                    (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(feature), 1 /* TEXT */ )
                ]);
            }), 128 /* KEYED_FRAGMENT */ ))
        ])
    ]);
}

});

parcelRegister("e2bna", function(module, exports) {

$parcel$export(module.exports, "default", () => $a37a12f95a627e37$export$2e2bcd8739ae039);
let $a37a12f95a627e37$var$NOOP = ()=>{};
var $a37a12f95a627e37$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("4Om5W", function(module, exports) {

$parcel$export(module.exports, "fetchPlans", () => $380cf87d1fcb53c3$export$fb1d0aa72da89ce8);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $kheUU = parcelRequire("kheUU");
var $iDR1F = parcelRequire("iDR1F");
var $fEFLm = parcelRequire("fEFLm");
var $e6Gw0 = parcelRequire("e6Gw0");

var $bRn2L = parcelRequire("bRn2L");

var $1rS06 = parcelRequire("1rS06");
function $380cf87d1fcb53c3$export$fb1d0aa72da89ce8(useCache = false) {
    const { currentPlans: currentPlans } = (0, $1rS06.useGlobalState)();
    if (useCache && currentPlans.hasData()) return {
        fetch: async ()=>{},
        response: (0, $01W3b.ref)(currentPlans.data()),
        isLoading: false
    };
    const { callEndpoint: callEndpoint, endpointData: endpointData, isLoading: isLoading } = (0, $bRn2L.default)("plans");
    const fetch = async ()=>{
        await callEndpoint({
            method: "GET"
        }).then((response)=>{
            if (!(0, $kheUU.default)(response)) {
                const expire = (0, $fEFLm.default)(Date.now() + 1, "expireCacheTimestamp", response);
                currentPlans.set((0, $iDR1F.default)("plans", response), expire);
            }
            return response;
        });
    };
    const response = (0, $01W3b.computed)(()=>{
        const ret = (0, $fEFLm.default)([], "plans", endpointData.value);
        if (!(0, $kheUU.default)(ret)) return (0, $e6Gw0.default)((0, $iDR1F.default)("planId"))(ret);
        return ret;
    });
    return {
        fetch: fetch,
        response: response,
        isLoading: isLoading
    };
}
function $380cf87d1fcb53c3$export$d05e812b3ef77928(id) {
    const { fetch: fetch, response: response } = $380cf87d1fcb53c3$export$fb1d0aa72da89ce8();
    return fetch().then(()=>response.value.find((p)=>p.planId === id));
}

});
parcelRegister("e6Gw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4529adb39872fec$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");
/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      const sortByFirstItem = R.sortBy(R.prop(0));
 *      const pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *
 *      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      const people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */ var $a4529adb39872fec$var$sortBy = /*#__PURE__*/ (0, $2jcOR.default)(function sortBy(fn, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var aa = fn(a);
        var bb = fn(b);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
    });
});
var $a4529adb39872fec$export$2e2bcd8739ae039 = $a4529adb39872fec$var$sortBy;

});



parcelRegister("10Ohx", function(module, exports) {

$parcel$export(module.exports, "render", () => $0bcccb7accc7105c$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $0bcccb7accc7105c$var$_hoisted_1 = {
    key: 1,
    class: "isolate mx-auto mt-12 grid max-w-md grid-cols-1 gap-8 md:max-w-2xl md:grid-cols-2 lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-4"
};
function $0bcccb7accc7105c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        $setup.isFetchingPlans ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["LoadingSpinner"], {
            key: 0,
            class: "text-center"
        })) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0bcccb7accc7105c$var$_hoisted_1, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.filteredPlans, (tier)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["PlanCard"], {
                    "use-callback": $setup.props.useCallback,
                    onPlanChosen: _cache[0] || (_cache[0] = ($event)=>$setup.emit("planChosen", $event)),
                    key: tier.id,
                    plan: tier
                }, null, 8 /* PROPS */ , [
                    "use-callback",
                    "plan"
                ]);
            }), 128 /* KEYED_FRAGMENT */ ))
        ]))
    ]);
}

});

parcelRegister("da7hL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9951dc4bec74592b$export$2e2bcd8739ae039);
let $9951dc4bec74592b$var$NOOP = ()=>{};
var $9951dc4bec74592b$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("ehh2b", function(module, exports) {

$parcel$export(module.exports, "render", () => $02aeb5207604494b$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $02aeb5207604494b$var$_hoisted_1 = {
    class: "text-3xl text-center text-basecolor"
};
const $02aeb5207604494b$var$_hoisted_2 = {
    class: "isolate mx-auto mt-12 grid max-w-md grid-cols-1 gap-8 md:max-w-2xl md:grid-cols-2 lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-4"
};
const $02aeb5207604494b$var$_hoisted_3 = {
    class: "text-sm mt-6 mb-3 text-basecolor col-span-1 md:col-span-2 xl:col-span-5"
};
function $02aeb5207604494b$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createElementVNode)("h2", $02aeb5207604494b$var$_hoisted_1, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.selectSubscription")), 1 /* TEXT */ ),
        (0, $TusQn.createElementVNode)("div", $02aeb5207604494b$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("p", $02aeb5207604494b$var$_hoisted_3, [
                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("registerView.loginHint")) + " ", 1 /* TEXT */ ),
                (0, $TusQn.createVNode)(_component_RouterLink, {
                    class: "font-bold",
                    to: $setup.Trans.i18nRoute({
                        name: "login"
                    })
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("logIn")), 1 /* TEXT */ )
                        ]),
                    _: 1 /* STABLE */ 
                }, 8 /* PROPS */ , [
                    "to"
                ])
            ])
        ]),
        (0, $TusQn.createVNode)($setup["FetchPlanCardsComponent"], {
            "use-callback": true,
            onPlanChosen: _cache[0] || (_cache[0] = ($event)=>$setup.emit("planChosen", $event)),
            onFetchingDone: $setup.plansFetched
        }),
        (0, $TusQn.createElementVNode)("button", {
            class: "mt-8 text-xs text-basecolor",
            onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("back"))
        }, [
            (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.goBack")), 1 /* TEXT */ )
        ])
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("161rJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cc779294020d6b1$export$2e2bcd8739ae039);
let $0cc779294020d6b1$var$NOOP = ()=>{};
var $0cc779294020d6b1$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("b916O", function(module, exports) {

$parcel$export(module.exports, "default", () => $81d165273c5c6da3$export$2e2bcd8739ae039);
let $81d165273c5c6da3$var$script;



let $81d165273c5c6da3$var$initialize = ()=>{
    $81d165273c5c6da3$var$script = (parcelRequire("gI98L"));
    if ($81d165273c5c6da3$var$script.__esModule) $81d165273c5c6da3$var$script = $81d165273c5c6da3$var$script.default;
    $81d165273c5c6da3$var$script.render = (parcelRequire("10duT")).render;
    (parcelRequire("9kBmf")).default($81d165273c5c6da3$var$script);
    $81d165273c5c6da3$var$script.__scopeId = "data-v-54523d";
    $81d165273c5c6da3$var$script.__file = "BillingComponent.vue";
};
$81d165273c5c6da3$var$initialize();
var $81d165273c5c6da3$export$2e2bcd8739ae039 = $81d165273c5c6da3$var$script;

});
parcelRegister("gI98L", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c2a7d87b81f987ed$export$2e2bcd8739ae039);

var $a3L1E = parcelRequire("a3L1E");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $csTml = parcelRequire("csTml");
var $4Gqbx = parcelRequire("4Gqbx");
var $iDR1F = parcelRequire("iDR1F");
var $hKvje = parcelRequire("hKvje");

var $73mM4 = parcelRequire("73mM4");

var $jFUWD = parcelRequire("jFUWD");

var $bQytf = parcelRequire("bQytf");

var $bRn2L = parcelRequire("bRn2L");

var $1F5z6 = parcelRequire("1F5z6");

var $3dsFz = parcelRequire("3dsFz");

var $kiljT = parcelRequire("kiljT");

var $hbEdS = parcelRequire("hbEdS");

var $580JV = parcelRequire("580JV");

var $kW7Vr = parcelRequire("kW7Vr");

var $ifZB1 = parcelRequire("ifZB1");
const $c2a7d87b81f987ed$var$minNumSeats = 1;
const $c2a7d87b81f987ed$var$maxNumSeats = 9999;
var $c2a7d87b81f987ed$export$2e2bcd8739ae039 = {
    __name: "BillingComponent",
    props: {
        chosenPlan: {
            required: true
        },
        vat: {
            required: true
        },
        emailForPayment: {
            required: true
        },
        paypalShape: {
            default: "pill",
            type: String
        },
        paypalLayout: {
            default: "horizontal",
            type: String
        }
    },
    emits: [
        "paymentSuccess",
        "back",
        "freePaymentSuccess"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const route = (0, $73mM4.useRoute)();
        const router = (0, $73mM4.useRouter)();
        const emit = __emit;
        (0, $TusQn.onMounted)(()=>{
            (0, $ifZB1.trackEvent)("step_billing", {
                event_category: [
                    "Payments",
                    "Register"
                ],
                event_label: "Billing Component Loaded"
            });
        });
        const payPalResponseMessage = (0, $01W3b.ref)({
            message: "",
            isError: false
        });
        const props = __props;
        const { t: t } = (0, $jFUWD.useI18n)({
            messages: props.chosenPlan.description
        });
        const hasError = payPalResponseMessage.value.isError;
        const appliedDiscount = (0, $01W3b.ref)({});
        const numSeatsToBuy = (0, $01W3b.ref)(1);
        const updatedTotalPrice = (0, $01W3b.ref)(props.chosenPlan.subscriptionPrice);
        const login = (0, $580JV.default).i18nRoute({
            name: "login"
        });
        const isFreePlan = (0, $01W3b.computed)(()=>updatedTotalPrice.value === 0);
        const handlePriceUpdate = (event)=>{
            updatedTotalPrice.value = event.totalPrice;
        };
        sessionStorage.setItem("chosenPlan", JSON.stringify(t("planName")));
        (0, $TusQn.watch)(numSeatsToBuy, async (newNum)=>{
            if (newNum > $c2a7d87b81f987ed$var$maxNumSeats) numSeatsToBuy.value = $c2a7d87b81f987ed$var$maxNumSeats;
            if (newNum < $c2a7d87b81f987ed$var$minNumSeats) numSeatsToBuy.value = $c2a7d87b81f987ed$var$minNumSeats;
        });
        const { callEndpoint: callEndpoint, endpointData: endpointData, userFriendlyError: userFriendlyError, isLoading: isLoading } = (0, $bRn2L.default)("createSubscription");
        async function callCreateSubscription() {
            await callEndpoint({
                method: "POST",
                request: {
                    planId: props.chosenPlan.planId,
                    email: props.emailForPayment,
                    seats: numSeatsToBuy.value,
                    vat: props.vat,
                    redeemKey: (0, $iDR1F.default)("key", (0, $01W3b.toValue)(appliedDiscount)),
                    returnPath: router.resolve((0, $580JV.default).i18nRoute({
                        name: "register-payment-return",
                        params: {
                            success: true
                        }
                    })).path,
                    cancelPath: router.resolve((0, $580JV.default).i18nRoute({
                        name: "register-payment-return",
                        params: {
                            success: false
                        }
                    })).path
                }
            });
            const response = endpointData.value;
            if ((0, $bQytf.isNotNullAndNotEmpty)(userFriendlyError.value)) {
                payPalResponseMessage.value = {
                    message: "Error creating your subscription",
                    isError: true
                };
                return;
            }
            const approveUrl = (0, $4Gqbx.default)((0, $iDR1F.default)("links"), (0, $csTml.default)((0, $hKvje.default)("approve", "rel")), (0, $iDR1F.default)("href"))(response);
            window.open(approveUrl, "_self");
        }
        const onFreePlanClick = ()=>{
            emit("freePaymentSuccess", true);
            callCreateSubscription();
        };
        console.log("vat in billing", props.vat);
        const showMessage = (0, $01W3b.computed)(()=>(0, $bQytf.isNotNullAndNotEmpty)(payPalResponseMessage.value.message));
        const __returned__ = {
            route: route,
            router: router,
            emit: emit,
            payPalResponseMessage: payPalResponseMessage,
            props: props,
            t: t,
            hasError: hasError,
            appliedDiscount: appliedDiscount,
            numSeatsToBuy: numSeatsToBuy,
            minNumSeats: $c2a7d87b81f987ed$var$minNumSeats,
            maxNumSeats: $c2a7d87b81f987ed$var$maxNumSeats,
            updatedTotalPrice: updatedTotalPrice,
            login: login,
            isFreePlan: isFreePlan,
            handlePriceUpdate: handlePriceUpdate,
            callEndpoint: callEndpoint,
            endpointData: endpointData,
            userFriendlyError: userFriendlyError,
            isLoading: isLoading,
            callCreateSubscription: callCreateSubscription,
            onFreePlanClick: onFreePlanClick,
            showMessage: showMessage,
            get CheckCircleIcon () {
                return 0, $a3L1E.CheckCircleIcon;
            },
            computed: $01W3b.computed,
            onMounted: $TusQn.onMounted,
            ref: $01W3b.ref,
            toValue: $01W3b.toValue,
            watch: $TusQn.watch,
            get find () {
                return 0, $csTml.default;
            },
            get pipe () {
                return 0, $4Gqbx.default;
            },
            get prop () {
                return 0, $iDR1F.default;
            },
            get propEq () {
                return 0, $hKvje.default;
            },
            get RouterLink () {
                return 0, $73mM4.RouterLink;
            },
            get useRoute () {
                return 0, $73mM4.useRoute;
            },
            get useRouter () {
                return 0, $73mM4.useRouter;
            },
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            get isIndividualPlan () {
                return 0, $bQytf.isIndividualPlan;
            },
            get isNotNullAndNotEmpty () {
                return 0, $bQytf.isNotNullAndNotEmpty;
            },
            get useCallEndPointWith () {
                return 0, $bRn2L.default;
            },
            InPlaceAlert: $1F5z6.default,
            RedeemKeyComponent: $3dsFz.default,
            PricingComponent: $kiljT.default,
            Price: $hbEdS.default,
            get Trans () {
                return 0, $580JV.default;
            },
            WithLoader: $kW7Vr.default,
            get trackEvent () {
                return 0, $ifZB1.trackEvent;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("a3L1E", function(module, exports) {

$parcel$export(module.exports, "ArrowDownTrayIcon", () => $752ea97b2c47801e$export$dc865c26b741dc02, (v) => $752ea97b2c47801e$export$dc865c26b741dc02 = v);
$parcel$export(module.exports, "CheckCircleIcon", () => $752ea97b2c47801e$export$f6dd727656c97851, (v) => $752ea97b2c47801e$export$f6dd727656c97851 = v);
$parcel$export(module.exports, "PencilSquareIcon", () => $752ea97b2c47801e$export$9793ed02a42534a8, (v) => $752ea97b2c47801e$export$9793ed02a42534a8 = v);
$parcel$export(module.exports, "XCircleIcon", () => $752ea97b2c47801e$export$a5090bbd7fc88fde, (v) => $752ea97b2c47801e$export$a5090bbd7fc88fde = v);
var $752ea97b2c47801e$export$141edd2393d796a9;
var $752ea97b2c47801e$export$430b361266d98a9c;
var $752ea97b2c47801e$export$5235e3b1e8fcaba3;
var $752ea97b2c47801e$export$ee58fb344f566f9b;
var $752ea97b2c47801e$export$10812a8617e2c6b9;
var $752ea97b2c47801e$export$cbcd847490094766;
var $752ea97b2c47801e$export$84344cb244906eac;
var $752ea97b2c47801e$export$8b57ee4b0e98fb27;
var $752ea97b2c47801e$export$f7f013ee72c08482;
var $752ea97b2c47801e$export$4a222ece1c6759b;
var $752ea97b2c47801e$export$814e7401971f4e15;
var $752ea97b2c47801e$export$dc865c26b741dc02;
var $752ea97b2c47801e$export$1c939d3c9b6931b;
var $752ea97b2c47801e$export$82537baac17e0dbb;
var $752ea97b2c47801e$export$4399dc42376eac9c;
var $752ea97b2c47801e$export$c7f22c41eb07c148;
var $752ea97b2c47801e$export$a259bacf73bb3d6e;
var $752ea97b2c47801e$export$8afed21ef5c2afa5;
var $752ea97b2c47801e$export$f575da5b66d36a53;
var $752ea97b2c47801e$export$b1d71fe5e1cc7d99;
var $752ea97b2c47801e$export$428cb7af25b2b543;
var $752ea97b2c47801e$export$baee59bcd973443c;
var $752ea97b2c47801e$export$5e0b0de6a47bd7ac;
var $752ea97b2c47801e$export$dd39e62a36cfa28c;
var $752ea97b2c47801e$export$6c78843fde89ffaa;
var $752ea97b2c47801e$export$bcd1aab73058ee97;
var $752ea97b2c47801e$export$38da5aa074715985;
var $752ea97b2c47801e$export$d9aa47fce6d79fac;
var $752ea97b2c47801e$export$9ca09caa9c849d9c;
var $752ea97b2c47801e$export$cc7e4e49e499fffa;
var $752ea97b2c47801e$export$77d685e7fdfe6076;
var $752ea97b2c47801e$export$315dbb83bd58c954;
var $752ea97b2c47801e$export$492da48b030471a2;
var $752ea97b2c47801e$export$7e348dc8f4784e33;
var $752ea97b2c47801e$export$c6b81b55640ed0d8;
var $752ea97b2c47801e$export$e49b7f370f54775c;
var $752ea97b2c47801e$export$d7af126b1dafd5a7;
var $752ea97b2c47801e$export$8c53b52ced56b6d0;
var $752ea97b2c47801e$export$5ad6f41219f06b50;
var $752ea97b2c47801e$export$dedb108411b29d17;
var $752ea97b2c47801e$export$ca4d2b63d3464320;
var $752ea97b2c47801e$export$7f5caa0d0d14d340;
var $752ea97b2c47801e$export$f1a507b991affc46;
var $752ea97b2c47801e$export$587b092349543b96;
var $752ea97b2c47801e$export$ec723471d1323019;
var $752ea97b2c47801e$export$e262667569189d19;
var $752ea97b2c47801e$export$1470669c32964f43;
var $752ea97b2c47801e$export$f2a37f97edeec0d3;
var $752ea97b2c47801e$export$8efb4619cdfb6513;
var $752ea97b2c47801e$export$be5b5dd9c91f07d0;
var $752ea97b2c47801e$export$58e576027fe18fad;
var $752ea97b2c47801e$export$9ef4476dd8c1d9ae;
var $752ea97b2c47801e$export$12a4185d7caff8bd;
var $752ea97b2c47801e$export$5c3b3115ee314f0a;
var $752ea97b2c47801e$export$78dbdedc5f0bdf4d;
var $752ea97b2c47801e$export$f36c2bd656248ff3;
var $752ea97b2c47801e$export$32faa8d48191df18;
var $752ea97b2c47801e$export$7333c78cbc2171e9;
var $752ea97b2c47801e$export$3ac1a72fa804a0dc;
var $752ea97b2c47801e$export$9ce3a4f91474d93a;
var $752ea97b2c47801e$export$281c113741720df9;
var $752ea97b2c47801e$export$ed1aa341ef80d7f0;
var $752ea97b2c47801e$export$48505c9c0c14af4f;
var $752ea97b2c47801e$export$e66e7cf20adff1b7;
var $752ea97b2c47801e$export$6ddc53809a83b7ec;
var $752ea97b2c47801e$export$fb3662ce8aa83c9a;
var $752ea97b2c47801e$export$4a0107eb20c58f1c;
var $752ea97b2c47801e$export$a503c6b6dd253ccb;
var $752ea97b2c47801e$export$f7b8d0021b678e0e;
var $752ea97b2c47801e$export$c6ba93a39dc74f2d;
var $752ea97b2c47801e$export$2235404cc2cfe93c;
var $752ea97b2c47801e$export$f9374a13fa82a4e3;
var $752ea97b2c47801e$export$19686091d79be9ab;
var $752ea97b2c47801e$export$32d9dd3fbd9d1c94;
var $752ea97b2c47801e$export$27fe15307e1afa36;
var $752ea97b2c47801e$export$d828110bd481d895;
var $752ea97b2c47801e$export$93cb139c864b0aec;
var $752ea97b2c47801e$export$6211d598766c7b98;
var $752ea97b2c47801e$export$402e41abfe259f0d;
var $752ea97b2c47801e$export$fa7d920298ea85ae;
var $752ea97b2c47801e$export$939e27523e02e012;
var $752ea97b2c47801e$export$499dcb4f8b3f3afa;
var $752ea97b2c47801e$export$e9883edc3c068586;
var $752ea97b2c47801e$export$8b18ad6526b7b786;
var $752ea97b2c47801e$export$2dfd996de35ccf9c;
var $752ea97b2c47801e$export$def73d593967d3;
var $752ea97b2c47801e$export$5fda1783bb83f57b;
var $752ea97b2c47801e$export$1bd12807c2fea239;
var $752ea97b2c47801e$export$6ae0ed811dbed747;
var $752ea97b2c47801e$export$9da4f9d7ed027300;
var $752ea97b2c47801e$export$809b547827087d7c;
var $752ea97b2c47801e$export$2a16a811049852e6;
var $752ea97b2c47801e$export$82d7f8273fbe7701;
var $752ea97b2c47801e$export$99ce0282ab5f30a4;
var $752ea97b2c47801e$export$ef46f9706f79911b;
var $752ea97b2c47801e$export$c00084af95a47876;
var $752ea97b2c47801e$export$1b1f8a302cdd496d;
var $752ea97b2c47801e$export$c0f43db9f6f9f1e8;
var $752ea97b2c47801e$export$2ec2b5678b8ae4e5;
var $752ea97b2c47801e$export$f6dd727656c97851;
var $752ea97b2c47801e$export$7dd004358974b05d;
var $752ea97b2c47801e$export$f749a305e52bbafa;
var $752ea97b2c47801e$export$4897d8e4f5658d8b;
var $752ea97b2c47801e$export$e9e5a080959514b8;
var $752ea97b2c47801e$export$dd77447915947d2;
var $752ea97b2c47801e$export$4857d3f3f5f8319b;
var $752ea97b2c47801e$export$20bc5960c3c9eebb;
var $752ea97b2c47801e$export$b837bd7eac09a33e;
var $752ea97b2c47801e$export$557f078d6e0efaa3;
var $752ea97b2c47801e$export$7f01a6cbee61a0f2;
var $752ea97b2c47801e$export$ca10eccc37f8d4ca;
var $752ea97b2c47801e$export$af603ba6deebbd24;
var $752ea97b2c47801e$export$f9f313acf21f3ef8;
var $752ea97b2c47801e$export$8e8f23a709b7b99f;
var $752ea97b2c47801e$export$60f3f00eeba09710;
var $752ea97b2c47801e$export$8099ab97743c966c;
var $752ea97b2c47801e$export$5192c9267bc0234b;
var $752ea97b2c47801e$export$d2f3ef7e26f48005;
var $752ea97b2c47801e$export$575cd077dbb2b254;
var $752ea97b2c47801e$export$b352416871dafe8a;
var $752ea97b2c47801e$export$c573863debaecc45;
var $752ea97b2c47801e$export$2d6e044d29d6a90;
var $752ea97b2c47801e$export$52bf71e3f8d70b8b;
var $752ea97b2c47801e$export$f9d7900821a42259;
var $752ea97b2c47801e$export$ba6bc60bb18aac30;
var $752ea97b2c47801e$export$7b763131f0d29a82;
var $752ea97b2c47801e$export$5937b93b6e611163;
var $752ea97b2c47801e$export$9aecafbc92062ce3;
var $752ea97b2c47801e$export$a6c9637093beefda;
var $752ea97b2c47801e$export$315ae6298b7de94;
var $752ea97b2c47801e$export$8584f743f0e3e63f;
var $752ea97b2c47801e$export$5ffcd7dbba94edfb;
var $752ea97b2c47801e$export$ac51f3e1cb7a3a3;
var $752ea97b2c47801e$export$e1a3d38b37dc5875;
var $752ea97b2c47801e$export$798882a79f27ef2e;
var $752ea97b2c47801e$export$58d5ff49d70e7fbc;
var $752ea97b2c47801e$export$de2dd8b59a7757bf;
var $752ea97b2c47801e$export$edc908ab288cb7b3;
var $752ea97b2c47801e$export$bd22f6f59a17c595;
var $752ea97b2c47801e$export$e6efd249420c76f8;
var $752ea97b2c47801e$export$c027bee0ab43e63a;
var $752ea97b2c47801e$export$b36c8fdb8ea6f204;
var $752ea97b2c47801e$export$e386166ae0e40f61;
var $752ea97b2c47801e$export$115fcaac9bb72f6a;
var $752ea97b2c47801e$export$18c9c674e481bfe7;
var $752ea97b2c47801e$export$6ae15c04fc6c6f90;
var $752ea97b2c47801e$export$b900b7f1caabfc38;
var $752ea97b2c47801e$export$684b4dada05c233f;
var $752ea97b2c47801e$export$b5cd56d9a3a154c4;
var $752ea97b2c47801e$export$5068802198d106bd;
var $752ea97b2c47801e$export$bbf452a86f360bac;
var $752ea97b2c47801e$export$3b62c53c8b355e9b;
var $752ea97b2c47801e$export$c8f34779732d0331;
var $752ea97b2c47801e$export$808857d2db6c57a2;
var $752ea97b2c47801e$export$ea4109706c07d076;
var $752ea97b2c47801e$export$d98c3112f0dca07f;
var $752ea97b2c47801e$export$b409b230b61d4724;
var $752ea97b2c47801e$export$f00d02ec11710973;
var $752ea97b2c47801e$export$a3d42ccaf02d165b;
var $752ea97b2c47801e$export$4b2c798a70974642;
var $752ea97b2c47801e$export$64a2e1c332d36f9f;
var $752ea97b2c47801e$export$65b5a23acb0faca9;
var $752ea97b2c47801e$export$b35c1b407b6df1c7;
var $752ea97b2c47801e$export$6388e39d7182bf32;
var $752ea97b2c47801e$export$98afb0d17ceac256;
var $752ea97b2c47801e$export$4fd8d63cb0915eb0;
var $752ea97b2c47801e$export$db62ea719f644804;
var $752ea97b2c47801e$export$dd7e6024654b311e;
var $752ea97b2c47801e$export$f6a56b2243a6d25;
var $752ea97b2c47801e$export$ed422bf40c39c48;
var $752ea97b2c47801e$export$b7c13c52029a403;
var $752ea97b2c47801e$export$ff6abe1e0cf4a7a5;
var $752ea97b2c47801e$export$42fc21bec4c92031;
var $752ea97b2c47801e$export$3572f625f7e8fe79;
var $752ea97b2c47801e$export$ff2bc02d3eb290f9;
var $752ea97b2c47801e$export$89472f18b6de8cda;
var $752ea97b2c47801e$export$8d39e6ed8d8f29bd;
var $752ea97b2c47801e$export$83cee9a8bb37f576;
var $752ea97b2c47801e$export$7a3ce5c7bbd0bbe5;
var $752ea97b2c47801e$export$20fd3de39b00766c;
var $752ea97b2c47801e$export$a72518433a425208;
var $752ea97b2c47801e$export$fdc6eeecb485b0eb;
var $752ea97b2c47801e$export$e5011219a0c9d712;
var $752ea97b2c47801e$export$98b97f42a47a4ca4;
var $752ea97b2c47801e$export$16f03ed71cfb60c9;
var $752ea97b2c47801e$export$d387511b47e19a5e;
var $752ea97b2c47801e$export$92c8767b874048d;
var $752ea97b2c47801e$export$bda64e1ebac5d6f2;
var $752ea97b2c47801e$export$a5eb475fd5f67c0b;
var $752ea97b2c47801e$export$bd5de8eff5608510;
var $752ea97b2c47801e$export$f146fd7f5447dd59;
var $752ea97b2c47801e$export$60cd31239d03d159;
var $752ea97b2c47801e$export$3dc0fe769dc7dcac;
var $752ea97b2c47801e$export$7bbb2363e70a6ecf;
var $752ea97b2c47801e$export$cf9331a766906c8c;
var $752ea97b2c47801e$export$870380bdcb26b5e8;
var $752ea97b2c47801e$export$69387b41dfc808f7;
var $752ea97b2c47801e$export$9b1a2d77017d0edb;
var $752ea97b2c47801e$export$f53936b98653a113;
var $752ea97b2c47801e$export$8e05a58e6971f13d;
var $752ea97b2c47801e$export$ce4a25f329a732c1;
var $752ea97b2c47801e$export$3b1a7f542fddd58c;
var $752ea97b2c47801e$export$f0342f75deb7660d;
var $752ea97b2c47801e$export$f7658c347b037c3f;
var $752ea97b2c47801e$export$b87dec932856ad7d;
var $752ea97b2c47801e$export$a6b9c7133f02bfd8;
var $752ea97b2c47801e$export$ea0da4856fb919cc;
var $752ea97b2c47801e$export$d2834cd4e399cf8b;
var $752ea97b2c47801e$export$270e2e3af79d1405;
var $752ea97b2c47801e$export$58158fc355654f52;
var $752ea97b2c47801e$export$cb808a3c41736d8e;
var $752ea97b2c47801e$export$41051b6be05d5fb0;
var $752ea97b2c47801e$export$10b717363a87548b;
var $752ea97b2c47801e$export$1bf0d3e2b126bf94;
var $752ea97b2c47801e$export$514c1168d5b4e969;
var $752ea97b2c47801e$export$4799ca36cb97dc90;
var $752ea97b2c47801e$export$bd597ed9308dedb4;
var $752ea97b2c47801e$export$3837f2d2dad99206;
var $752ea97b2c47801e$export$75886cde6273c22e;
var $752ea97b2c47801e$export$9b47433640e5db3a;
var $752ea97b2c47801e$export$9793ed02a42534a8;
var $752ea97b2c47801e$export$d2c72b688139a728;
var $752ea97b2c47801e$export$3cb0ccd478360eb0;
var $752ea97b2c47801e$export$64fe9c2579901a7e;
var $752ea97b2c47801e$export$c5a7000185b78898;
var $752ea97b2c47801e$export$54336acd81078d46;
var $752ea97b2c47801e$export$4c11f98bc0a981d3;
var $752ea97b2c47801e$export$28b9e44e3136e9b2;
var $752ea97b2c47801e$export$7d0369adef4aaf0f;
var $752ea97b2c47801e$export$a6630b90defda83f;
var $752ea97b2c47801e$export$99bb4c5ac5bf5ec5;
var $752ea97b2c47801e$export$16f6c9e82e8075d5;
var $752ea97b2c47801e$export$f21ab0717a89c77f;
var $752ea97b2c47801e$export$a885e2ed1683455d;
var $752ea97b2c47801e$export$22ca00a8e64bda41;
var $752ea97b2c47801e$export$b364543b04db6ce9;
var $752ea97b2c47801e$export$f21330c31e4a5cd1;
var $752ea97b2c47801e$export$459bc0cba6c836fd;
var $752ea97b2c47801e$export$33dd147542b2195b;
var $752ea97b2c47801e$export$2ecbafc0ed9d1775;
var $752ea97b2c47801e$export$256060083837e2e2;
var $752ea97b2c47801e$export$dc5561ae0d840124;
var $752ea97b2c47801e$export$10e4962aacdcd546;
var $752ea97b2c47801e$export$4fc618f2329eb355;
var $752ea97b2c47801e$export$e17ffeebc2b885bb;
var $752ea97b2c47801e$export$679ee9b1cc8603ac;
var $752ea97b2c47801e$export$ccc8b9cc502aea29;
var $752ea97b2c47801e$export$459b2edd884123b9;
var $752ea97b2c47801e$export$a4c67d229bd7a9fe;
var $752ea97b2c47801e$export$ca010e7ed4ef0790;
var $752ea97b2c47801e$export$7b70c2f3b38d6bc;
var $752ea97b2c47801e$export$94639b65b951e28;
var $752ea97b2c47801e$export$40148c7db598e4e0;
var $752ea97b2c47801e$export$da01a61080044588;
var $752ea97b2c47801e$export$e8a37441be818d6d;
var $752ea97b2c47801e$export$eb28a2dd0e114531;
var $752ea97b2c47801e$export$6b817c26c15a0b1e;
var $752ea97b2c47801e$export$e231d5caed50d147;
var $752ea97b2c47801e$export$6684b2d3da651354;
var $752ea97b2c47801e$export$a05b22346a85e647;
var $752ea97b2c47801e$export$324aa7995c07cdff;
var $752ea97b2c47801e$export$b33e7cdce48201eb;
var $752ea97b2c47801e$export$5f9bee459ead05d1;
var $752ea97b2c47801e$export$2256d9264dbec922;
var $752ea97b2c47801e$export$a057aa6abd82d303;
var $752ea97b2c47801e$export$6a497e769d0f8b52;
var $752ea97b2c47801e$export$2ee28caa7f1e962e;
var $752ea97b2c47801e$export$ce4e46a8e76856c;
var $752ea97b2c47801e$export$dc6949a98411e916;
var $752ea97b2c47801e$export$cd27c497b93dbe8d;
var $752ea97b2c47801e$export$934a51f4f675879a;
var $752ea97b2c47801e$export$ad99d0f8cc35b614;
var $752ea97b2c47801e$export$80beb1cb95701424;
var $752ea97b2c47801e$export$94891d1b6e067768;
var $752ea97b2c47801e$export$d23329de703dffc4;
var $752ea97b2c47801e$export$38852ed648a706e8;
var $752ea97b2c47801e$export$e3534c3b39a723c6;
var $752ea97b2c47801e$export$9b12771a3e45d163;
var $752ea97b2c47801e$export$9daf73c3c6a408a2;
var $752ea97b2c47801e$export$b29ee6925331c0f2;
var $752ea97b2c47801e$export$c29b260e6cdfd013;
var $752ea97b2c47801e$export$d3cb1fce65c7d22c;
var $752ea97b2c47801e$export$4202723ba73439f5;
var $752ea97b2c47801e$export$4e04c809deb7a605;
var $752ea97b2c47801e$export$5b196e941358b505;
var $752ea97b2c47801e$export$e227a0e5d7fa29a5;
var $752ea97b2c47801e$export$bed1a57ff13393e9;
var $752ea97b2c47801e$export$7bfe724f0db8184c;
var $752ea97b2c47801e$export$a9bec65d47219da0;
var $752ea97b2c47801e$export$deff84e7338ee5a5;
var $752ea97b2c47801e$export$ed96e71539d42a7e;
var $752ea97b2c47801e$export$ba5de1f54f2b11af;
var $752ea97b2c47801e$export$aee12a6e2a07833f;
var $752ea97b2c47801e$export$bc176c2a10341979;
var $752ea97b2c47801e$export$a5090bbd7fc88fde;
var $752ea97b2c47801e$export$313827c411e782cb;

$752ea97b2c47801e$export$141edd2393d796a9 = (parcelRequire("aV10I"));

$752ea97b2c47801e$export$430b361266d98a9c = (parcelRequire("eMRSV"));

$752ea97b2c47801e$export$5235e3b1e8fcaba3 = (parcelRequire("5DURq"));

$752ea97b2c47801e$export$ee58fb344f566f9b = (parcelRequire("0g0IT"));

$752ea97b2c47801e$export$10812a8617e2c6b9 = (parcelRequire("cnZXy"));

$752ea97b2c47801e$export$cbcd847490094766 = (parcelRequire("9NP4c"));

$752ea97b2c47801e$export$84344cb244906eac = (parcelRequire("7RfcN"));

$752ea97b2c47801e$export$8b57ee4b0e98fb27 = (parcelRequire("cLkTA"));

$752ea97b2c47801e$export$f7f013ee72c08482 = (parcelRequire("962wj"));

$752ea97b2c47801e$export$4a222ece1c6759b = (parcelRequire("b90DV"));

$752ea97b2c47801e$export$814e7401971f4e15 = (parcelRequire("cnON7"));

$752ea97b2c47801e$export$dc865c26b741dc02 = (parcelRequire("aPATX"));

$752ea97b2c47801e$export$1c939d3c9b6931b = (parcelRequire("fGDBz"));

$752ea97b2c47801e$export$82537baac17e0dbb = (parcelRequire("2idXY"));

$752ea97b2c47801e$export$4399dc42376eac9c = (parcelRequire("lJR2z"));

$752ea97b2c47801e$export$c7f22c41eb07c148 = (parcelRequire("igCI5"));

$752ea97b2c47801e$export$a259bacf73bb3d6e = (parcelRequire("fENLg"));

$752ea97b2c47801e$export$8afed21ef5c2afa5 = (parcelRequire("9K1eb"));

$752ea97b2c47801e$export$f575da5b66d36a53 = (parcelRequire("3dt18"));

$752ea97b2c47801e$export$b1d71fe5e1cc7d99 = (parcelRequire("bemwF"));

$752ea97b2c47801e$export$428cb7af25b2b543 = (parcelRequire("htxiZ"));

$752ea97b2c47801e$export$baee59bcd973443c = (parcelRequire("hZW5p"));

$752ea97b2c47801e$export$5e0b0de6a47bd7ac = (parcelRequire("kM8V9"));

$752ea97b2c47801e$export$dd39e62a36cfa28c = (parcelRequire("5lHCp"));

$752ea97b2c47801e$export$6c78843fde89ffaa = (parcelRequire("7s903"));

$752ea97b2c47801e$export$bcd1aab73058ee97 = (parcelRequire("fIAHU"));

$752ea97b2c47801e$export$38da5aa074715985 = (parcelRequire("aRCR3"));

$752ea97b2c47801e$export$d9aa47fce6d79fac = (parcelRequire("8zEuh"));

$752ea97b2c47801e$export$9ca09caa9c849d9c = (parcelRequire("ajw5T"));

$752ea97b2c47801e$export$cc7e4e49e499fffa = (parcelRequire("cJR8e"));

$752ea97b2c47801e$export$77d685e7fdfe6076 = (parcelRequire("9FYWl"));

$752ea97b2c47801e$export$315dbb83bd58c954 = (parcelRequire("5KQfH"));

$752ea97b2c47801e$export$492da48b030471a2 = (parcelRequire("4KZ0i"));

$752ea97b2c47801e$export$7e348dc8f4784e33 = (parcelRequire("9BOWV"));

$752ea97b2c47801e$export$c6b81b55640ed0d8 = (parcelRequire("10IpV"));

$752ea97b2c47801e$export$e49b7f370f54775c = (parcelRequire("kV17j"));

$752ea97b2c47801e$export$d7af126b1dafd5a7 = (parcelRequire("dIFNq"));

$752ea97b2c47801e$export$8c53b52ced56b6d0 = (parcelRequire("d7gES"));

$752ea97b2c47801e$export$5ad6f41219f06b50 = (parcelRequire("02dah"));

$752ea97b2c47801e$export$dedb108411b29d17 = (parcelRequire("keChs"));

$752ea97b2c47801e$export$ca4d2b63d3464320 = (parcelRequire("dGiMC"));

$752ea97b2c47801e$export$7f5caa0d0d14d340 = (parcelRequire("eaIrY"));

$752ea97b2c47801e$export$f1a507b991affc46 = (parcelRequire("hx9Vp"));

$752ea97b2c47801e$export$587b092349543b96 = (parcelRequire("i93Ck"));

$752ea97b2c47801e$export$ec723471d1323019 = (parcelRequire("9CLhA"));

$752ea97b2c47801e$export$e262667569189d19 = (parcelRequire("c1LY9"));

$752ea97b2c47801e$export$1470669c32964f43 = (parcelRequire("bSvFj"));

$752ea97b2c47801e$export$f2a37f97edeec0d3 = (parcelRequire("7ttvk"));

$752ea97b2c47801e$export$8efb4619cdfb6513 = (parcelRequire("d4Brq"));

$752ea97b2c47801e$export$be5b5dd9c91f07d0 = (parcelRequire("1n92e"));

$752ea97b2c47801e$export$58e576027fe18fad = (parcelRequire("9ACLr"));

$752ea97b2c47801e$export$9ef4476dd8c1d9ae = (parcelRequire("Xz1jk"));

$752ea97b2c47801e$export$12a4185d7caff8bd = (parcelRequire("iOf8A"));

$752ea97b2c47801e$export$5c3b3115ee314f0a = (parcelRequire("5LQ1P"));

$752ea97b2c47801e$export$78dbdedc5f0bdf4d = (parcelRequire("dMuT4"));

$752ea97b2c47801e$export$f36c2bd656248ff3 = (parcelRequire("bCKsb"));

$752ea97b2c47801e$export$32faa8d48191df18 = (parcelRequire("eJ1gk"));

$752ea97b2c47801e$export$7333c78cbc2171e9 = (parcelRequire("cOCMf"));

$752ea97b2c47801e$export$3ac1a72fa804a0dc = (parcelRequire("kGk37"));

$752ea97b2c47801e$export$9ce3a4f91474d93a = (parcelRequire("fgUNd"));

$752ea97b2c47801e$export$281c113741720df9 = (parcelRequire("gOEjC"));

$752ea97b2c47801e$export$ed1aa341ef80d7f0 = (parcelRequire("1jmoC"));

$752ea97b2c47801e$export$48505c9c0c14af4f = (parcelRequire("brU96"));

$752ea97b2c47801e$export$e66e7cf20adff1b7 = (parcelRequire("guuZD"));

$752ea97b2c47801e$export$6ddc53809a83b7ec = (parcelRequire("l36UW"));

$752ea97b2c47801e$export$fb3662ce8aa83c9a = (parcelRequire("jCMSG"));

$752ea97b2c47801e$export$4a0107eb20c58f1c = (parcelRequire("eL1JI"));

$752ea97b2c47801e$export$a503c6b6dd253ccb = (parcelRequire("d6rJN"));

$752ea97b2c47801e$export$f7b8d0021b678e0e = (parcelRequire("huL11"));

$752ea97b2c47801e$export$c6ba93a39dc74f2d = (parcelRequire("qOY90"));

$752ea97b2c47801e$export$2235404cc2cfe93c = (parcelRequire("NtNgR"));

$752ea97b2c47801e$export$f9374a13fa82a4e3 = (parcelRequire("9A0cH"));

$752ea97b2c47801e$export$19686091d79be9ab = (parcelRequire("jJyKA"));

$752ea97b2c47801e$export$32d9dd3fbd9d1c94 = (parcelRequire("4HjPb"));

$752ea97b2c47801e$export$27fe15307e1afa36 = (parcelRequire("iAaV3"));

$752ea97b2c47801e$export$d828110bd481d895 = (parcelRequire("1NbDR"));

$752ea97b2c47801e$export$93cb139c864b0aec = (parcelRequire("cQqO7"));

$752ea97b2c47801e$export$6211d598766c7b98 = (parcelRequire("dA9hL"));

$752ea97b2c47801e$export$402e41abfe259f0d = (parcelRequire("82jnV"));

$752ea97b2c47801e$export$fa7d920298ea85ae = (parcelRequire("iThBv"));

$752ea97b2c47801e$export$939e27523e02e012 = (parcelRequire("52THN"));

$752ea97b2c47801e$export$499dcb4f8b3f3afa = (parcelRequire("47gsa"));

$752ea97b2c47801e$export$e9883edc3c068586 = (parcelRequire("2QB73"));

$752ea97b2c47801e$export$8b18ad6526b7b786 = (parcelRequire("1smyB"));

$752ea97b2c47801e$export$2dfd996de35ccf9c = (parcelRequire("06myN"));

$752ea97b2c47801e$export$def73d593967d3 = (parcelRequire("1Hl6l"));

$752ea97b2c47801e$export$5fda1783bb83f57b = (parcelRequire("2tbmd"));

$752ea97b2c47801e$export$1bd12807c2fea239 = (parcelRequire("k5Scy"));

$752ea97b2c47801e$export$6ae0ed811dbed747 = (parcelRequire("hN8Zc"));

$752ea97b2c47801e$export$9da4f9d7ed027300 = (parcelRequire("4ZyWA"));

$752ea97b2c47801e$export$809b547827087d7c = (parcelRequire("3alIu"));

$752ea97b2c47801e$export$2a16a811049852e6 = (parcelRequire("4i7pa"));

$752ea97b2c47801e$export$82d7f8273fbe7701 = (parcelRequire("dNEuP"));

$752ea97b2c47801e$export$99ce0282ab5f30a4 = (parcelRequire("9LFy0"));

$752ea97b2c47801e$export$ef46f9706f79911b = (parcelRequire("2kyu1"));

$752ea97b2c47801e$export$c00084af95a47876 = (parcelRequire("ifZEV"));

$752ea97b2c47801e$export$1b1f8a302cdd496d = (parcelRequire("9FsF1"));

$752ea97b2c47801e$export$c0f43db9f6f9f1e8 = (parcelRequire("lBB74"));

$752ea97b2c47801e$export$2ec2b5678b8ae4e5 = (parcelRequire("dkCbe"));

$752ea97b2c47801e$export$f6dd727656c97851 = (parcelRequire("gOQxg"));

$752ea97b2c47801e$export$7dd004358974b05d = (parcelRequire("1CxWM"));

$752ea97b2c47801e$export$f749a305e52bbafa = (parcelRequire("7kzLH"));

$752ea97b2c47801e$export$4897d8e4f5658d8b = (parcelRequire("1ZGHE"));

$752ea97b2c47801e$export$e9e5a080959514b8 = (parcelRequire("lNOXQ"));

$752ea97b2c47801e$export$dd77447915947d2 = (parcelRequire("dyepk"));

$752ea97b2c47801e$export$4857d3f3f5f8319b = (parcelRequire("1ZwLD"));

$752ea97b2c47801e$export$20bc5960c3c9eebb = (parcelRequire("1RAw3"));

$752ea97b2c47801e$export$b837bd7eac09a33e = (parcelRequire("jNu5x"));

$752ea97b2c47801e$export$557f078d6e0efaa3 = (parcelRequire("3gOlL"));

$752ea97b2c47801e$export$7f01a6cbee61a0f2 = (parcelRequire("lviE0"));

$752ea97b2c47801e$export$ca10eccc37f8d4ca = (parcelRequire("C9YEn"));

$752ea97b2c47801e$export$af603ba6deebbd24 = (parcelRequire("9kxOp"));

$752ea97b2c47801e$export$f9f313acf21f3ef8 = (parcelRequire("dSu9t"));

$752ea97b2c47801e$export$8e8f23a709b7b99f = (parcelRequire("70BbW"));

$752ea97b2c47801e$export$60f3f00eeba09710 = (parcelRequire("aBLBR"));

$752ea97b2c47801e$export$8099ab97743c966c = (parcelRequire("cJVCb"));

$752ea97b2c47801e$export$5192c9267bc0234b = (parcelRequire("5cqqv"));

$752ea97b2c47801e$export$d2f3ef7e26f48005 = (parcelRequire("3FuAc"));

$752ea97b2c47801e$export$575cd077dbb2b254 = (parcelRequire("ame0a"));

$752ea97b2c47801e$export$b352416871dafe8a = (parcelRequire("jTSBW"));

$752ea97b2c47801e$export$c573863debaecc45 = (parcelRequire("jiuNr"));

$752ea97b2c47801e$export$2d6e044d29d6a90 = (parcelRequire("bXhxp"));

$752ea97b2c47801e$export$52bf71e3f8d70b8b = (parcelRequire("4P00n"));

$752ea97b2c47801e$export$f9d7900821a42259 = (parcelRequire("3n51f"));

$752ea97b2c47801e$export$ba6bc60bb18aac30 = (parcelRequire("6fxYb"));

$752ea97b2c47801e$export$7b763131f0d29a82 = (parcelRequire("fYQMI"));

$752ea97b2c47801e$export$5937b93b6e611163 = (parcelRequire("dZM6W"));

$752ea97b2c47801e$export$9aecafbc92062ce3 = (parcelRequire("lO4Rt"));

$752ea97b2c47801e$export$a6c9637093beefda = (parcelRequire("8Kur6"));

$752ea97b2c47801e$export$315ae6298b7de94 = (parcelRequire("4Hwc4"));

$752ea97b2c47801e$export$8584f743f0e3e63f = (parcelRequire("jkh4b"));

$752ea97b2c47801e$export$5ffcd7dbba94edfb = (parcelRequire("6j9tB"));

$752ea97b2c47801e$export$ac51f3e1cb7a3a3 = (parcelRequire("jzozt"));

$752ea97b2c47801e$export$e1a3d38b37dc5875 = (parcelRequire("iBQfA"));

$752ea97b2c47801e$export$798882a79f27ef2e = (parcelRequire("fMxjI"));

$752ea97b2c47801e$export$58d5ff49d70e7fbc = (parcelRequire("a7skV"));

$752ea97b2c47801e$export$de2dd8b59a7757bf = (parcelRequire("sGoXN"));

$752ea97b2c47801e$export$edc908ab288cb7b3 = (parcelRequire("29hz7"));

$752ea97b2c47801e$export$bd22f6f59a17c595 = (parcelRequire("1UCXU"));

$752ea97b2c47801e$export$e6efd249420c76f8 = (parcelRequire("bLqtu"));

$752ea97b2c47801e$export$c027bee0ab43e63a = (parcelRequire("9otN2"));

$752ea97b2c47801e$export$b36c8fdb8ea6f204 = (parcelRequire("hGCgb"));

$752ea97b2c47801e$export$e386166ae0e40f61 = (parcelRequire("cYujE"));

$752ea97b2c47801e$export$115fcaac9bb72f6a = (parcelRequire("7Uefv"));

$752ea97b2c47801e$export$18c9c674e481bfe7 = (parcelRequire("dkw6y"));

$752ea97b2c47801e$export$6ae15c04fc6c6f90 = (parcelRequire("6vYrx"));

$752ea97b2c47801e$export$b900b7f1caabfc38 = (parcelRequire("hE3Dc"));

$752ea97b2c47801e$export$684b4dada05c233f = (parcelRequire("cWRcR"));

$752ea97b2c47801e$export$b5cd56d9a3a154c4 = (parcelRequire("bJBov"));

$752ea97b2c47801e$export$5068802198d106bd = (parcelRequire("hRLNT"));

$752ea97b2c47801e$export$bbf452a86f360bac = (parcelRequire("cpYgE"));

$752ea97b2c47801e$export$3b62c53c8b355e9b = (parcelRequire("4tXhi"));

$752ea97b2c47801e$export$c8f34779732d0331 = (parcelRequire("j1dcT"));

$752ea97b2c47801e$export$808857d2db6c57a2 = (parcelRequire("2uB8V"));

$752ea97b2c47801e$export$ea4109706c07d076 = (parcelRequire("2W8T3"));

$752ea97b2c47801e$export$d98c3112f0dca07f = (parcelRequire("iYjpD"));

$752ea97b2c47801e$export$b409b230b61d4724 = (parcelRequire("630FK"));

$752ea97b2c47801e$export$f00d02ec11710973 = (parcelRequire("dEqIC"));

$752ea97b2c47801e$export$a3d42ccaf02d165b = (parcelRequire("giJWO"));

$752ea97b2c47801e$export$4b2c798a70974642 = (parcelRequire("3ZnuL"));

$752ea97b2c47801e$export$64a2e1c332d36f9f = (parcelRequire("bDAnH"));

$752ea97b2c47801e$export$65b5a23acb0faca9 = (parcelRequire("kqx4S"));

$752ea97b2c47801e$export$b35c1b407b6df1c7 = (parcelRequire("92Lb6"));

$752ea97b2c47801e$export$6388e39d7182bf32 = (parcelRequire("hyXRx"));

$752ea97b2c47801e$export$98afb0d17ceac256 = (parcelRequire("b61ys"));

$752ea97b2c47801e$export$4fd8d63cb0915eb0 = (parcelRequire("flKyw"));

$752ea97b2c47801e$export$db62ea719f644804 = (parcelRequire("w1sDO"));

$752ea97b2c47801e$export$dd7e6024654b311e = (parcelRequire("XhOuD"));

$752ea97b2c47801e$export$f6a56b2243a6d25 = (parcelRequire("20AiV"));

$752ea97b2c47801e$export$ed422bf40c39c48 = (parcelRequire("4LNFs"));

$752ea97b2c47801e$export$b7c13c52029a403 = (parcelRequire("6F6Eg"));

$752ea97b2c47801e$export$ff6abe1e0cf4a7a5 = (parcelRequire("1cCcP"));

$752ea97b2c47801e$export$42fc21bec4c92031 = (parcelRequire("jtLIU"));

$752ea97b2c47801e$export$3572f625f7e8fe79 = (parcelRequire("jq7K4"));

$752ea97b2c47801e$export$ff2bc02d3eb290f9 = (parcelRequire("4qeU0"));

$752ea97b2c47801e$export$89472f18b6de8cda = (parcelRequire("71Csk"));

$752ea97b2c47801e$export$8d39e6ed8d8f29bd = (parcelRequire("bnvtD"));

$752ea97b2c47801e$export$83cee9a8bb37f576 = (parcelRequire("bsUUO"));

$752ea97b2c47801e$export$7a3ce5c7bbd0bbe5 = (parcelRequire("alSjI"));

$752ea97b2c47801e$export$20fd3de39b00766c = (parcelRequire("kkB37"));

$752ea97b2c47801e$export$a72518433a425208 = (parcelRequire("cFNHO"));

$752ea97b2c47801e$export$fdc6eeecb485b0eb = (parcelRequire("aSg8q"));

$752ea97b2c47801e$export$e5011219a0c9d712 = (parcelRequire("1G3sA"));

$752ea97b2c47801e$export$98b97f42a47a4ca4 = (parcelRequire("lavVg"));

$752ea97b2c47801e$export$16f03ed71cfb60c9 = (parcelRequire("e5AoA"));

$752ea97b2c47801e$export$d387511b47e19a5e = (parcelRequire("hHi79"));

$752ea97b2c47801e$export$92c8767b874048d = (parcelRequire("3apb5"));

$752ea97b2c47801e$export$bda64e1ebac5d6f2 = (parcelRequire("iMVOY"));

$752ea97b2c47801e$export$a5eb475fd5f67c0b = (parcelRequire("k3inm"));

$752ea97b2c47801e$export$bd5de8eff5608510 = (parcelRequire("uiZaB"));

$752ea97b2c47801e$export$f146fd7f5447dd59 = (parcelRequire("i5hyO"));

$752ea97b2c47801e$export$60cd31239d03d159 = (parcelRequire("8epRX"));

$752ea97b2c47801e$export$3dc0fe769dc7dcac = (parcelRequire("0O1eM"));

$752ea97b2c47801e$export$7bbb2363e70a6ecf = (parcelRequire("cV25S"));

$752ea97b2c47801e$export$cf9331a766906c8c = (parcelRequire("4eOmz"));

$752ea97b2c47801e$export$870380bdcb26b5e8 = (parcelRequire("cXNKH"));

$752ea97b2c47801e$export$69387b41dfc808f7 = (parcelRequire("6kxvn"));

$752ea97b2c47801e$export$9b1a2d77017d0edb = (parcelRequire("b3YRg"));

$752ea97b2c47801e$export$f53936b98653a113 = (parcelRequire("dKo2r"));

$752ea97b2c47801e$export$8e05a58e6971f13d = (parcelRequire("a4d0U"));

$752ea97b2c47801e$export$ce4a25f329a732c1 = (parcelRequire("v8kjQ"));

$752ea97b2c47801e$export$3b1a7f542fddd58c = (parcelRequire("ePaLw"));

$752ea97b2c47801e$export$f0342f75deb7660d = (parcelRequire("fkrcE"));

$752ea97b2c47801e$export$f7658c347b037c3f = (parcelRequire("cwAo8"));

$752ea97b2c47801e$export$b87dec932856ad7d = (parcelRequire("7lnZ6"));

$752ea97b2c47801e$export$a6b9c7133f02bfd8 = (parcelRequire("i53WX"));

$752ea97b2c47801e$export$ea0da4856fb919cc = (parcelRequire("42Zg1"));

$752ea97b2c47801e$export$d2834cd4e399cf8b = (parcelRequire("4QGKE"));

$752ea97b2c47801e$export$270e2e3af79d1405 = (parcelRequire("hjiaP"));

$752ea97b2c47801e$export$58158fc355654f52 = (parcelRequire("dX80P"));

$752ea97b2c47801e$export$cb808a3c41736d8e = (parcelRequire("hVPjd"));

$752ea97b2c47801e$export$41051b6be05d5fb0 = (parcelRequire("hB97W"));

$752ea97b2c47801e$export$10b717363a87548b = (parcelRequire("4PlKI"));

$752ea97b2c47801e$export$1bf0d3e2b126bf94 = (parcelRequire("2Ooeh"));

$752ea97b2c47801e$export$514c1168d5b4e969 = (parcelRequire("93cEq"));

$752ea97b2c47801e$export$4799ca36cb97dc90 = (parcelRequire("60DEn"));

$752ea97b2c47801e$export$bd597ed9308dedb4 = (parcelRequire("i2Djj"));

$752ea97b2c47801e$export$3837f2d2dad99206 = (parcelRequire("39fEW"));

$752ea97b2c47801e$export$75886cde6273c22e = (parcelRequire("bdwjs"));

$752ea97b2c47801e$export$9b47433640e5db3a = (parcelRequire("kE3KW"));

$752ea97b2c47801e$export$9793ed02a42534a8 = (parcelRequire("eUNHZ"));

$752ea97b2c47801e$export$d2c72b688139a728 = (parcelRequire("12IX5"));

$752ea97b2c47801e$export$3cb0ccd478360eb0 = (parcelRequire("1T3Xc"));

$752ea97b2c47801e$export$64fe9c2579901a7e = (parcelRequire("87Iek"));

$752ea97b2c47801e$export$c5a7000185b78898 = (parcelRequire("fFzem"));

$752ea97b2c47801e$export$54336acd81078d46 = (parcelRequire("fMheQ"));

$752ea97b2c47801e$export$4c11f98bc0a981d3 = (parcelRequire("g1rsd"));

$752ea97b2c47801e$export$28b9e44e3136e9b2 = (parcelRequire("9fU86"));

$752ea97b2c47801e$export$7d0369adef4aaf0f = (parcelRequire("kz2U2"));

$752ea97b2c47801e$export$a6630b90defda83f = (parcelRequire("1xGrE"));

$752ea97b2c47801e$export$99bb4c5ac5bf5ec5 = (parcelRequire("l36yp"));

$752ea97b2c47801e$export$16f6c9e82e8075d5 = (parcelRequire("9ZpTm"));

$752ea97b2c47801e$export$f21ab0717a89c77f = (parcelRequire("5JctM"));

$752ea97b2c47801e$export$a885e2ed1683455d = (parcelRequire("bnExM"));

$752ea97b2c47801e$export$22ca00a8e64bda41 = (parcelRequire("ayYWi"));

$752ea97b2c47801e$export$b364543b04db6ce9 = (parcelRequire("aVHzo"));

$752ea97b2c47801e$export$f21330c31e4a5cd1 = (parcelRequire("hOrGh"));

$752ea97b2c47801e$export$459bc0cba6c836fd = (parcelRequire("a3UdX"));

$752ea97b2c47801e$export$33dd147542b2195b = (parcelRequire("hILM1"));

$752ea97b2c47801e$export$2ecbafc0ed9d1775 = (parcelRequire("bcyUb"));

$752ea97b2c47801e$export$256060083837e2e2 = (parcelRequire("f0mwz"));

$752ea97b2c47801e$export$dc5561ae0d840124 = (parcelRequire("fJfiU"));

$752ea97b2c47801e$export$10e4962aacdcd546 = (parcelRequire("5Ttos"));

$752ea97b2c47801e$export$4fc618f2329eb355 = (parcelRequire("gvbky"));

$752ea97b2c47801e$export$e17ffeebc2b885bb = (parcelRequire("fCBe7"));

$752ea97b2c47801e$export$679ee9b1cc8603ac = (parcelRequire("bszUX"));

$752ea97b2c47801e$export$ccc8b9cc502aea29 = (parcelRequire("8wZQw"));

$752ea97b2c47801e$export$459b2edd884123b9 = (parcelRequire("gwJ93"));

$752ea97b2c47801e$export$a4c67d229bd7a9fe = (parcelRequire("3eTkp"));

$752ea97b2c47801e$export$ca010e7ed4ef0790 = (parcelRequire("SOs1d"));

$752ea97b2c47801e$export$7b70c2f3b38d6bc = (parcelRequire("eQdbf"));

$752ea97b2c47801e$export$94639b65b951e28 = (parcelRequire("3EUXX"));

$752ea97b2c47801e$export$40148c7db598e4e0 = (parcelRequire("3mqOs"));

$752ea97b2c47801e$export$da01a61080044588 = (parcelRequire("22PXU"));

$752ea97b2c47801e$export$e8a37441be818d6d = (parcelRequire("il33X"));

$752ea97b2c47801e$export$eb28a2dd0e114531 = (parcelRequire("hjQzL"));

$752ea97b2c47801e$export$6b817c26c15a0b1e = (parcelRequire("afDxu"));

$752ea97b2c47801e$export$e231d5caed50d147 = (parcelRequire("5NNuk"));

$752ea97b2c47801e$export$6684b2d3da651354 = (parcelRequire("cqnNP"));

$752ea97b2c47801e$export$a05b22346a85e647 = (parcelRequire("l9mv5"));

$752ea97b2c47801e$export$324aa7995c07cdff = (parcelRequire("ipko4"));

$752ea97b2c47801e$export$b33e7cdce48201eb = (parcelRequire("kwbAg"));

$752ea97b2c47801e$export$5f9bee459ead05d1 = (parcelRequire("24ewq"));

$752ea97b2c47801e$export$2256d9264dbec922 = (parcelRequire("8wVdw"));

$752ea97b2c47801e$export$a057aa6abd82d303 = (parcelRequire("frWNv"));

$752ea97b2c47801e$export$6a497e769d0f8b52 = (parcelRequire("csZWQ"));

$752ea97b2c47801e$export$2ee28caa7f1e962e = (parcelRequire("lnHlL"));

$752ea97b2c47801e$export$ce4e46a8e76856c = (parcelRequire("1gvhm"));

$752ea97b2c47801e$export$dc6949a98411e916 = (parcelRequire("eSsn4"));

$752ea97b2c47801e$export$cd27c497b93dbe8d = (parcelRequire("KeK7p"));

$752ea97b2c47801e$export$934a51f4f675879a = (parcelRequire("g6nUc"));

$752ea97b2c47801e$export$ad99d0f8cc35b614 = (parcelRequire("flR2k"));

$752ea97b2c47801e$export$80beb1cb95701424 = (parcelRequire("8OVTs"));

$752ea97b2c47801e$export$94891d1b6e067768 = (parcelRequire("fq1lw"));

$752ea97b2c47801e$export$d23329de703dffc4 = (parcelRequire("3ZA8P"));

$752ea97b2c47801e$export$38852ed648a706e8 = (parcelRequire("iLsBB"));

$752ea97b2c47801e$export$e3534c3b39a723c6 = (parcelRequire("hW4DL"));

$752ea97b2c47801e$export$9b12771a3e45d163 = (parcelRequire("fFJpf"));

$752ea97b2c47801e$export$9daf73c3c6a408a2 = (parcelRequire("3Eubm"));

$752ea97b2c47801e$export$b29ee6925331c0f2 = (parcelRequire("12KTX"));

$752ea97b2c47801e$export$c29b260e6cdfd013 = (parcelRequire("bbBGF"));

$752ea97b2c47801e$export$d3cb1fce65c7d22c = (parcelRequire("j0fWi"));

$752ea97b2c47801e$export$4202723ba73439f5 = (parcelRequire("ijwSa"));

$752ea97b2c47801e$export$4e04c809deb7a605 = (parcelRequire("chyHJ"));

$752ea97b2c47801e$export$5b196e941358b505 = (parcelRequire("hQOBe"));

$752ea97b2c47801e$export$e227a0e5d7fa29a5 = (parcelRequire("8LqEm"));

$752ea97b2c47801e$export$bed1a57ff13393e9 = (parcelRequire("hc4p6"));

$752ea97b2c47801e$export$7bfe724f0db8184c = (parcelRequire("leM3x"));

$752ea97b2c47801e$export$a9bec65d47219da0 = (parcelRequire("2mKDS"));

$752ea97b2c47801e$export$deff84e7338ee5a5 = (parcelRequire("jU0Jh"));

$752ea97b2c47801e$export$ed96e71539d42a7e = (parcelRequire("dwnyJ"));

$752ea97b2c47801e$export$ba5de1f54f2b11af = (parcelRequire("4vysw"));

$752ea97b2c47801e$export$aee12a6e2a07833f = (parcelRequire("eCMfX"));

$752ea97b2c47801e$export$bc176c2a10341979 = (parcelRequire("wUDHn"));

$752ea97b2c47801e$export$a5090bbd7fc88fde = (parcelRequire("1rh9S"));

$752ea97b2c47801e$export$313827c411e782cb = (parcelRequire("gAIQB"));

});
parcelRegister("aV10I", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $7f3002f185c60974$require$_createElementVNode = $TusQn.createElementVNode;
var $7f3002f185c60974$require$_openBlock = $TusQn.openBlock;
var $7f3002f185c60974$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $7f3002f185c60974$require$_openBlock(), $7f3002f185c60974$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $7f3002f185c60974$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5"
        })
    ]);
};

});

parcelRegister("eMRSV", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $ac3f58cb0d2fbfa8$require$_createElementVNode = $TusQn.createElementVNode;
var $ac3f58cb0d2fbfa8$require$_openBlock = $TusQn.openBlock;
var $ac3f58cb0d2fbfa8$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $ac3f58cb0d2fbfa8$require$_openBlock(), $ac3f58cb0d2fbfa8$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $ac3f58cb0d2fbfa8$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"
        })
    ]);
};

});

parcelRegister("5DURq", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $41bcb3a446d67b65$require$_createElementVNode = $TusQn.createElementVNode;
var $41bcb3a446d67b65$require$_openBlock = $TusQn.openBlock;
var $41bcb3a446d67b65$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $41bcb3a446d67b65$require$_openBlock(), $41bcb3a446d67b65$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $41bcb3a446d67b65$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5"
        })
    ]);
};

});

parcelRegister("0g0IT", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $000c6b95f2b3c36c$require$_createElementVNode = $TusQn.createElementVNode;
var $000c6b95f2b3c36c$require$_openBlock = $TusQn.openBlock;
var $000c6b95f2b3c36c$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $000c6b95f2b3c36c$require$_openBlock(), $000c6b95f2b3c36c$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $000c6b95f2b3c36c$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0-3-3m3 3 3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
        })
    ]);
};

});

parcelRegister("cnZXy", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $9047b1e78ff32e31$require$_createElementVNode = $TusQn.createElementVNode;
var $9047b1e78ff32e31$require$_openBlock = $TusQn.openBlock;
var $9047b1e78ff32e31$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $9047b1e78ff32e31$require$_openBlock(), $9047b1e78ff32e31$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $9047b1e78ff32e31$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m6 4.125 2.25 2.25m0 0 2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
        })
    ]);
};

});

parcelRegister("9NP4c", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01d77d1eb1402eec$require$_createElementVNode = $TusQn.createElementVNode;
var $01d77d1eb1402eec$require$_openBlock = $TusQn.openBlock;
var $01d77d1eb1402eec$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $01d77d1eb1402eec$require$_openBlock(), $01d77d1eb1402eec$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $01d77d1eb1402eec$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
        })
    ]);
};

});

parcelRegister("7RfcN", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $5b8947219b0e2633$require$_createElementVNode = $TusQn.createElementVNode;
var $5b8947219b0e2633$require$_openBlock = $TusQn.openBlock;
var $5b8947219b0e2633$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $5b8947219b0e2633$require$_openBlock(), $5b8947219b0e2633$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $5b8947219b0e2633$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m9 12.75 3 3m0 0 3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("cLkTA", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $94aa153dd9e5044d$require$_createElementVNode = $TusQn.createElementVNode;
var $94aa153dd9e5044d$require$_openBlock = $TusQn.openBlock;
var $94aa153dd9e5044d$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $94aa153dd9e5044d$require$_openBlock(), $94aa153dd9e5044d$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $94aa153dd9e5044d$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m19.5 4.5-15 15m0 0h11.25m-11.25 0V8.25"
        })
    ]);
};

});

parcelRegister("962wj", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $69f6a108fb0c0c62$require$_createElementVNode = $TusQn.createElementVNode;
var $69f6a108fb0c0c62$require$_openBlock = $TusQn.openBlock;
var $69f6a108fb0c0c62$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $69f6a108fb0c0c62$require$_openBlock(), $69f6a108fb0c0c62$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $69f6a108fb0c0c62$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m-6 3.75 3 3m0 0 3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75"
        })
    ]);
};

});

parcelRegister("b90DV", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $81d108a66b9ec18f$require$_createElementVNode = $TusQn.createElementVNode;
var $81d108a66b9ec18f$require$_openBlock = $TusQn.openBlock;
var $81d108a66b9ec18f$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $81d108a66b9ec18f$require$_openBlock(), $81d108a66b9ec18f$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $81d108a66b9ec18f$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M9 12l3 3m0 0 3-3m-3 3V2.25"
        })
    ]);
};

});

parcelRegister("cnON7", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $903f081763d80201$require$_createElementVNode = $TusQn.createElementVNode;
var $903f081763d80201$require$_openBlock = $TusQn.openBlock;
var $903f081763d80201$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $903f081763d80201$require$_openBlock(), $903f081763d80201$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $903f081763d80201$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m4.5 4.5 15 15m0 0V8.25m0 11.25H8.25"
        })
    ]);
};

});

parcelRegister("aPATX", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $7e2b4aad487cf461$require$_createElementVNode = $TusQn.createElementVNode;
var $7e2b4aad487cf461$require$_openBlock = $TusQn.openBlock;
var $7e2b4aad487cf461$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $7e2b4aad487cf461$require$_openBlock(), $7e2b4aad487cf461$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $7e2b4aad487cf461$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
        })
    ]);
};

});

parcelRegister("fGDBz", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b6b97ff6b943ea2f$require$_createElementVNode = $TusQn.createElementVNode;
var $b6b97ff6b943ea2f$require$_openBlock = $TusQn.openBlock;
var $b6b97ff6b943ea2f$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b6b97ff6b943ea2f$require$_openBlock(), $b6b97ff6b943ea2f$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b6b97ff6b943ea2f$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
        })
    ]);
};

});

parcelRegister("2idXY", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $1ab8189e3ee38440$require$_createElementVNode = $TusQn.createElementVNode;
var $1ab8189e3ee38440$require$_openBlock = $TusQn.openBlock;
var $1ab8189e3ee38440$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $1ab8189e3ee38440$require$_openBlock(), $1ab8189e3ee38440$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $1ab8189e3ee38440$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("lJR2z", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $fd36f1a7eb433fe6$require$_createElementVNode = $TusQn.createElementVNode;
var $fd36f1a7eb433fe6$require$_openBlock = $TusQn.openBlock;
var $fd36f1a7eb433fe6$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $fd36f1a7eb433fe6$require$_openBlock(), $fd36f1a7eb433fe6$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $fd36f1a7eb433fe6$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"
        })
    ]);
};

});

parcelRegister("igCI5", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d4c7bfa25717b4ae$require$_createElementVNode = $TusQn.createElementVNode;
var $d4c7bfa25717b4ae$require$_openBlock = $TusQn.openBlock;
var $d4c7bfa25717b4ae$require$_createElementBlock = $TusQn.createElementBlock;
/** @deprecated */ module.exports = function render(_ctx, _cache) {
    return $d4c7bfa25717b4ae$require$_openBlock(), $d4c7bfa25717b4ae$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d4c7bfa25717b4ae$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"
        })
    ]);
};

});

parcelRegister("fENLg", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b66130fd1f7bd0d0$require$_createElementVNode = $TusQn.createElementVNode;
var $b66130fd1f7bd0d0$require$_openBlock = $TusQn.openBlock;
var $b66130fd1f7bd0d0$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b66130fd1f7bd0d0$require$_openBlock(), $b66130fd1f7bd0d0$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b66130fd1f7bd0d0$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"
        })
    ]);
};

});

parcelRegister("9K1eb", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01d489c10888303b$require$_createElementVNode = $TusQn.createElementVNode;
var $01d489c10888303b$require$_openBlock = $TusQn.openBlock;
var $01d489c10888303b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $01d489c10888303b$require$_openBlock(), $01d489c10888303b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $01d489c10888303b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
        })
    ]);
};

});

parcelRegister("3dt18", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $2579183479e3f169$require$_createElementVNode = $TusQn.createElementVNode;
var $2579183479e3f169$require$_openBlock = $TusQn.openBlock;
var $2579183479e3f169$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $2579183479e3f169$require$_openBlock(), $2579183479e3f169$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $2579183479e3f169$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 17.25 12 21m0 0-3.75-3.75M12 21V3"
        })
    ]);
};

});

parcelRegister("bemwF", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $82d279af0f3e0ea9$require$_createElementVNode = $TusQn.createElementVNode;
var $82d279af0f3e0ea9$require$_openBlock = $TusQn.openBlock;
var $82d279af0f3e0ea9$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $82d279af0f3e0ea9$require$_openBlock(), $82d279af0f3e0ea9$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $82d279af0f3e0ea9$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
        })
    ]);
};

});

parcelRegister("htxiZ", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $cb8efad5823a46b4$require$_createElementVNode = $TusQn.createElementVNode;
var $cb8efad5823a46b4$require$_openBlock = $TusQn.openBlock;
var $cb8efad5823a46b4$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $cb8efad5823a46b4$require$_openBlock(), $cb8efad5823a46b4$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $cb8efad5823a46b4$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
        })
    ]);
};

});

parcelRegister("hZW5p", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d1a530df9210c1f6$require$_createElementVNode = $TusQn.createElementVNode;
var $d1a530df9210c1f6$require$_openBlock = $TusQn.openBlock;
var $d1a530df9210c1f6$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $d1a530df9210c1f6$require$_openBlock(), $d1a530df9210c1f6$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d1a530df9210c1f6$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.25 6.75 12 3m0 0 3.75 3.75M12 3v18"
        })
    ]);
};

});

parcelRegister("kM8V9", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $f1ff35cdfc16fb17$require$_createElementVNode = $TusQn.createElementVNode;
var $f1ff35cdfc16fb17$require$_openBlock = $TusQn.openBlock;
var $f1ff35cdfc16fb17$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $f1ff35cdfc16fb17$require$_openBlock(), $f1ff35cdfc16fb17$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $f1ff35cdfc16fb17$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 0 0-3.7-3.7 48.678 48.678 0 0 0-7.324 0 4.006 4.006 0 0 0-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 0 0 3.7 3.7 48.656 48.656 0 0 0 7.324 0 4.006 4.006 0 0 0 3.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3-3 3"
        })
    ]);
};

});

parcelRegister("5lHCp", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $3e50bf9defac196d$require$_createElementVNode = $TusQn.createElementVNode;
var $3e50bf9defac196d$require$_openBlock = $TusQn.openBlock;
var $3e50bf9defac196d$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $3e50bf9defac196d$require$_openBlock(), $3e50bf9defac196d$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $3e50bf9defac196d$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
        })
    ]);
};

});

parcelRegister("7s903", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $56d221208f312ae2$require$_createElementVNode = $TusQn.createElementVNode;
var $56d221208f312ae2$require$_openBlock = $TusQn.openBlock;
var $56d221208f312ae2$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $56d221208f312ae2$require$_openBlock(), $56d221208f312ae2$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $56d221208f312ae2$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("fIAHU", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b717705cad0fd339$require$_createElementVNode = $TusQn.createElementVNode;
var $b717705cad0fd339$require$_openBlock = $TusQn.openBlock;
var $b717705cad0fd339$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b717705cad0fd339$require$_openBlock(), $b717705cad0fd339$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b717705cad0fd339$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25"
        })
    ]);
};

});

parcelRegister("aRCR3", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $7e8cfe583b4e21b0$require$_createElementVNode = $TusQn.createElementVNode;
var $7e8cfe583b4e21b0$require$_openBlock = $TusQn.openBlock;
var $7e8cfe583b4e21b0$require$_createElementBlock = $TusQn.createElementBlock;
/** @deprecated */ module.exports = function render(_ctx, _cache) {
    return $7e8cfe583b4e21b0$require$_openBlock(), $7e8cfe583b4e21b0$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $7e8cfe583b4e21b0$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
        })
    ]);
};

});

parcelRegister("8zEuh", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $63e0ff96cc43fde1$require$_createElementVNode = $TusQn.createElementVNode;
var $63e0ff96cc43fde1$require$_openBlock = $TusQn.openBlock;
var $63e0ff96cc43fde1$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $63e0ff96cc43fde1$require$_openBlock(), $63e0ff96cc43fde1$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $63e0ff96cc43fde1$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
        })
    ]);
};

});

parcelRegister("ajw5T", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $782492f5d1d90da9$require$_createElementVNode = $TusQn.createElementVNode;
var $782492f5d1d90da9$require$_openBlock = $TusQn.openBlock;
var $782492f5d1d90da9$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $782492f5d1d90da9$require$_openBlock(), $782492f5d1d90da9$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $782492f5d1d90da9$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
        })
    ]);
};

});

parcelRegister("cJR8e", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $9462e6dd6c493544$require$_createElementVNode = $TusQn.createElementVNode;
var $9462e6dd6c493544$require$_openBlock = $TusQn.openBlock;
var $9462e6dd6c493544$require$_createElementBlock = $TusQn.createElementBlock;
/** @deprecated */ module.exports = function render(_ctx, _cache) {
    return $9462e6dd6c493544$require$_openBlock(), $9462e6dd6c493544$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $9462e6dd6c493544$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 4.5v15m0 0 6.75-6.75M12 19.5l-6.75-6.75"
        })
    ]);
};

});

parcelRegister("9FYWl", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $70b736d1b1895005$require$_createElementVNode = $TusQn.createElementVNode;
var $70b736d1b1895005$require$_openBlock = $TusQn.openBlock;
var $70b736d1b1895005$require$_createElementBlock = $TusQn.createElementBlock;
/** @deprecated */ module.exports = function render(_ctx, _cache) {
    return $70b736d1b1895005$require$_openBlock(), $70b736d1b1895005$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $70b736d1b1895005$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M19.5 12h-15m0 0 6.75 6.75M4.5 12l6.75-6.75"
        })
    ]);
};

});

parcelRegister("5KQfH", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $4309c7cf2d82dd99$require$_createElementVNode = $TusQn.createElementVNode;
var $4309c7cf2d82dd99$require$_openBlock = $TusQn.openBlock;
var $4309c7cf2d82dd99$require$_createElementBlock = $TusQn.createElementBlock;
/** @deprecated */ module.exports = function render(_ctx, _cache) {
    return $4309c7cf2d82dd99$require$_openBlock(), $4309c7cf2d82dd99$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $4309c7cf2d82dd99$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M4.5 12h15m0 0-6.75-6.75M19.5 12l-6.75 6.75"
        })
    ]);
};

});

parcelRegister("4KZ0i", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $376ac765d4697399$require$_createElementVNode = $TusQn.createElementVNode;
var $376ac765d4697399$require$_openBlock = $TusQn.openBlock;
var $376ac765d4697399$require$_createElementBlock = $TusQn.createElementBlock;
/** @deprecated */ module.exports = function render(_ctx, _cache) {
    return $376ac765d4697399$require$_openBlock(), $376ac765d4697399$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $376ac765d4697399$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 19.5v-15m0 0-6.75 6.75M12 4.5l6.75 6.75"
        })
    ]);
};

});

parcelRegister("9BOWV", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $6fef173a74c48019$require$_createElementVNode = $TusQn.createElementVNode;
var $6fef173a74c48019$require$_openBlock = $TusQn.openBlock;
var $6fef173a74c48019$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $6fef173a74c48019$require$_openBlock(), $6fef173a74c48019$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $6fef173a74c48019$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
        })
    ]);
};

});

parcelRegister("10IpV", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0bc83eddcb13d1b3$require$_createElementVNode = $TusQn.createElementVNode;
var $0bc83eddcb13d1b3$require$_openBlock = $TusQn.openBlock;
var $0bc83eddcb13d1b3$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0bc83eddcb13d1b3$require$_openBlock(), $0bc83eddcb13d1b3$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0bc83eddcb13d1b3$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.25 6 9 12.75l4.286-4.286a11.948 11.948 0 0 1 4.306 6.43l.776 2.898m0 0 3.182-5.511m-3.182 5.51-5.511-3.181"
        })
    ]);
};

});

parcelRegister("kV17j", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $f3a9ff4cd04135e3$require$_createElementVNode = $TusQn.createElementVNode;
var $f3a9ff4cd04135e3$require$_openBlock = $TusQn.openBlock;
var $f3a9ff4cd04135e3$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $f3a9ff4cd04135e3$require$_openBlock(), $f3a9ff4cd04135e3$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $f3a9ff4cd04135e3$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941"
        })
    ]);
};

});

parcelRegister("dIFNq", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $9fcfce3ff06b8ca8$require$_createElementVNode = $TusQn.createElementVNode;
var $9fcfce3ff06b8ca8$require$_openBlock = $TusQn.openBlock;
var $9fcfce3ff06b8ca8$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $9fcfce3ff06b8ca8$require$_openBlock(), $9fcfce3ff06b8ca8$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $9fcfce3ff06b8ca8$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("d7gES", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $98c8d9c76f72f4ae$require$_createElementVNode = $TusQn.createElementVNode;
var $98c8d9c76f72f4ae$require$_openBlock = $TusQn.openBlock;
var $98c8d9c76f72f4ae$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $98c8d9c76f72f4ae$require$_openBlock(), $98c8d9c76f72f4ae$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $98c8d9c76f72f4ae$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m19.5 19.5-15-15m0 0v11.25m0-11.25h11.25"
        })
    ]);
};

});

parcelRegister("02dah", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $006a664592cddc30$require$_createElementVNode = $TusQn.createElementVNode;
var $006a664592cddc30$require$_openBlock = $TusQn.openBlock;
var $006a664592cddc30$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $006a664592cddc30$require$_openBlock(), $006a664592cddc30$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $006a664592cddc30$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m0-3-3-3m0 0-3 3m3-3v11.25m6-2.25h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75"
        })
    ]);
};

});

parcelRegister("keChs", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $ebb2cf3151efb034$require$_createElementVNode = $TusQn.createElementVNode;
var $ebb2cf3151efb034$require$_openBlock = $TusQn.openBlock;
var $ebb2cf3151efb034$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $ebb2cf3151efb034$require$_openBlock(), $ebb2cf3151efb034$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $ebb2cf3151efb034$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15"
        })
    ]);
};

});

parcelRegister("dGiMC", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $9f5dc48a8023eaf6$require$_createElementVNode = $TusQn.createElementVNode;
var $9f5dc48a8023eaf6$require$_openBlock = $TusQn.openBlock;
var $9f5dc48a8023eaf6$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $9f5dc48a8023eaf6$require$_openBlock(), $9f5dc48a8023eaf6$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $9f5dc48a8023eaf6$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
        })
    ]);
};

});

parcelRegister("eaIrY", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $a5147ac3686fbbc8$require$_createElementVNode = $TusQn.createElementVNode;
var $a5147ac3686fbbc8$require$_openBlock = $TusQn.openBlock;
var $a5147ac3686fbbc8$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $a5147ac3686fbbc8$require$_openBlock(), $a5147ac3686fbbc8$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $a5147ac3686fbbc8$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"
        })
    ]);
};

});

parcelRegister("hx9Vp", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $cc3d379c08a10aee$require$_createElementVNode = $TusQn.createElementVNode;
var $cc3d379c08a10aee$require$_openBlock = $TusQn.openBlock;
var $cc3d379c08a10aee$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $cc3d379c08a10aee$require$_openBlock(), $cc3d379c08a10aee$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $cc3d379c08a10aee$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
        })
    ]);
};

});

parcelRegister("i93Ck", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d35bdf8dd10b0bfb$require$_createElementVNode = $TusQn.createElementVNode;
var $d35bdf8dd10b0bfb$require$_openBlock = $TusQn.openBlock;
var $d35bdf8dd10b0bfb$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $d35bdf8dd10b0bfb$require$_openBlock(), $d35bdf8dd10b0bfb$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d35bdf8dd10b0bfb$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m15 15-6 6m0 0-6-6m6 6V9a6 6 0 0 1 12 0v3"
        })
    ]);
};

});

parcelRegister("9CLhA", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $701c5704eb107e1c$require$_createElementVNode = $TusQn.createElementVNode;
var $701c5704eb107e1c$require$_openBlock = $TusQn.openBlock;
var $701c5704eb107e1c$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $701c5704eb107e1c$require$_openBlock(), $701c5704eb107e1c$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $701c5704eb107e1c$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
        })
    ]);
};

});

parcelRegister("c1LY9", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8c1ac9b427a90073$require$_createElementVNode = $TusQn.createElementVNode;
var $8c1ac9b427a90073$require$_openBlock = $TusQn.openBlock;
var $8c1ac9b427a90073$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $8c1ac9b427a90073$require$_openBlock(), $8c1ac9b427a90073$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $8c1ac9b427a90073$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m15 15 6-6m0 0-6-6m6 6H9a6 6 0 0 0 0 12h3"
        })
    ]);
};

});

parcelRegister("bSvFj", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8a5d4cf28bde1b8f$require$_createElementVNode = $TusQn.createElementVNode;
var $8a5d4cf28bde1b8f$require$_openBlock = $TusQn.openBlock;
var $8a5d4cf28bde1b8f$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $8a5d4cf28bde1b8f$require$_openBlock(), $8a5d4cf28bde1b8f$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $8a5d4cf28bde1b8f$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m9 9 6-6m0 0 6 6m-6-6v12a6 6 0 0 1-12 0v-3"
        })
    ]);
};

});

parcelRegister("7ttvk", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $571220c2e79e11f4$require$_createElementVNode = $TusQn.createElementVNode;
var $571220c2e79e11f4$require$_openBlock = $TusQn.openBlock;
var $571220c2e79e11f4$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $571220c2e79e11f4$require$_openBlock(), $571220c2e79e11f4$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $571220c2e79e11f4$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25"
        })
    ]);
};

});

parcelRegister("d4Brq", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $9848b12d0078dcf0$require$_createElementVNode = $TusQn.createElementVNode;
var $9848b12d0078dcf0$require$_openBlock = $TusQn.openBlock;
var $9848b12d0078dcf0$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $9848b12d0078dcf0$require$_openBlock(), $9848b12d0078dcf0$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $9848b12d0078dcf0$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
        })
    ]);
};

});

parcelRegister("1n92e", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0ffef293817e08e5$require$_createElementVNode = $TusQn.createElementVNode;
var $0ffef293817e08e5$require$_openBlock = $TusQn.openBlock;
var $0ffef293817e08e5$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0ffef293817e08e5$require$_openBlock(), $0ffef293817e08e5$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0ffef293817e08e5$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
        })
    ]);
};

});

parcelRegister("9ACLr", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $6fb58b983ab213da$require$_createElementVNode = $TusQn.createElementVNode;
var $6fb58b983ab213da$require$_openBlock = $TusQn.openBlock;
var $6fb58b983ab213da$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $6fb58b983ab213da$require$_openBlock(), $6fb58b983ab213da$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $6fb58b983ab213da$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
        })
    ]);
};

});

parcelRegister("Xz1jk", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0b30ad12d15432a5$require$_createElementVNode = $TusQn.createElementVNode;
var $0b30ad12d15432a5$require$_openBlock = $TusQn.openBlock;
var $0b30ad12d15432a5$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0b30ad12d15432a5$require$_openBlock(), $0b30ad12d15432a5$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0b30ad12d15432a5$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25"
        })
    ]);
};

});

parcelRegister("iOf8A", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $db18a382fdd3f47e$require$_createElementVNode = $TusQn.createElementVNode;
var $db18a382fdd3f47e$require$_openBlock = $TusQn.openBlock;
var $db18a382fdd3f47e$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $db18a382fdd3f47e$require$_openBlock(), $db18a382fdd3f47e$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $db18a382fdd3f47e$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25m-2.58 4.92-6.374-6.375a1.125 1.125 0 0 1 0-1.59L9.42 4.83c.21-.211.497-.33.795-.33H19.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1-2.25 2.25h-9.284c-.298 0-.585-.119-.795-.33Z"
        })
    ]);
};

});

parcelRegister("5LQ1P", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $4339b355d608f49f$require$_createElementVNode = $TusQn.createElementVNode;
var $4339b355d608f49f$require$_openBlock = $TusQn.openBlock;
var $4339b355d608f49f$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $4339b355d608f49f$require$_openBlock(), $4339b355d608f49f$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $4339b355d608f49f$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21 16.811c0 .864-.933 1.406-1.683.977l-7.108-4.061a1.125 1.125 0 0 1 0-1.954l7.108-4.061A1.125 1.125 0 0 1 21 8.689v8.122ZM11.25 16.811c0 .864-.933 1.406-1.683.977l-7.108-4.061a1.125 1.125 0 0 1 0-1.954l7.108-4.061a1.125 1.125 0 0 1 1.683.977v8.122Z"
        })
    ]);
};

});

parcelRegister("dMuT4", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $a087b7a0366a6008$require$_createElementVNode = $TusQn.createElementVNode;
var $a087b7a0366a6008$require$_openBlock = $TusQn.openBlock;
var $a087b7a0366a6008$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $a087b7a0366a6008$require$_openBlock(), $a087b7a0366a6008$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $a087b7a0366a6008$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
        })
    ]);
};

});

parcelRegister("bCKsb", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $87674706925b3320$require$_createElementVNode = $TusQn.createElementVNode;
var $87674706925b3320$require$_openBlock = $TusQn.openBlock;
var $87674706925b3320$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $87674706925b3320$require$_openBlock(), $87674706925b3320$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $87674706925b3320$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 9h16.5m-16.5 6.75h16.5"
        })
    ]);
};

});

parcelRegister("eJ1gk", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $ab863f5cdc053c80$require$_createElementVNode = $TusQn.createElementVNode;
var $ab863f5cdc053c80$require$_openBlock = $TusQn.openBlock;
var $ab863f5cdc053c80$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $ab863f5cdc053c80$require$_openBlock(), $ab863f5cdc053c80$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $ab863f5cdc053c80$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
        })
    ]);
};

});

parcelRegister("cOCMf", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $95483be8f7a54419$require$_createElementVNode = $TusQn.createElementVNode;
var $95483be8f7a54419$require$_openBlock = $TusQn.openBlock;
var $95483be8f7a54419$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $95483be8f7a54419$require$_openBlock(), $95483be8f7a54419$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $95483be8f7a54419$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 6.75h16.5M3.75 12h16.5M12 17.25h8.25"
        })
    ]);
};

});

parcelRegister("kGk37", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $f0e748448254ccc8$require$_createElementVNode = $TusQn.createElementVNode;
var $f0e748448254ccc8$require$_openBlock = $TusQn.openBlock;
var $f0e748448254ccc8$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $f0e748448254ccc8$require$_openBlock(), $f0e748448254ccc8$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $f0e748448254ccc8$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5"
        })
    ]);
};

});

parcelRegister("fgUNd", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b1e4677d32de8046$require$_createElementVNode = $TusQn.createElementVNode;
var $b1e4677d32de8046$require$_openBlock = $TusQn.openBlock;
var $b1e4677d32de8046$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b1e4677d32de8046$require$_openBlock(), $b1e4677d32de8046$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b1e4677d32de8046$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
        })
    ]);
};

});

parcelRegister("gOEjC", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $c3e096a5301d30e2$require$_createElementVNode = $TusQn.createElementVNode;
var $c3e096a5301d30e2$require$_openBlock = $TusQn.openBlock;
var $c3e096a5301d30e2$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $c3e096a5301d30e2$require$_openBlock(), $c3e096a5301d30e2$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $c3e096a5301d30e2$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"
        })
    ]);
};

});

parcelRegister("1jmoC", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0f48f02c36e1e16f$require$_createElementVNode = $TusQn.createElementVNode;
var $0f48f02c36e1e16f$require$_openBlock = $TusQn.openBlock;
var $0f48f02c36e1e16f$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0f48f02c36e1e16f$require$_openBlock(), $0f48f02c36e1e16f$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0f48f02c36e1e16f$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0-3.75-3.75M17.25 21 21 17.25"
        })
    ]);
};

});

parcelRegister("brU96", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $855dc4bda5e9b15a$require$_createElementVNode = $TusQn.createElementVNode;
var $855dc4bda5e9b15a$require$_openBlock = $TusQn.openBlock;
var $855dc4bda5e9b15a$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $855dc4bda5e9b15a$require$_openBlock(), $855dc4bda5e9b15a$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $855dc4bda5e9b15a$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12"
        })
    ]);
};

});

parcelRegister("guuZD", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $c0177d4b97a47a34$require$_createElementVNode = $TusQn.createElementVNode;
var $c0177d4b97a47a34$require$_openBlock = $TusQn.openBlock;
var $c0177d4b97a47a34$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $c0177d4b97a47a34$require$_openBlock(), $c0177d4b97a47a34$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $c0177d4b97a47a34$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z"
        })
    ]);
};

});

parcelRegister("l36UW", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $f52f3e720513b184$require$_createElementVNode = $TusQn.createElementVNode;
var $f52f3e720513b184$require$_openBlock = $TusQn.openBlock;
var $f52f3e720513b184$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $f52f3e720513b184$require$_openBlock(), $f52f3e720513b184$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $f52f3e720513b184$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5H18V15H4.5v-4.5ZM3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z"
        })
    ]);
};

});

parcelRegister("jCMSG", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $e4977ba790c4f0f6$require$_createElementVNode = $TusQn.createElementVNode;
var $e4977ba790c4f0f6$require$_openBlock = $TusQn.openBlock;
var $e4977ba790c4f0f6$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $e4977ba790c4f0f6$require$_openBlock(), $e4977ba790c4f0f6$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $e4977ba790c4f0f6$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5h6.75V15H4.5v-4.5ZM3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z"
        })
    ]);
};

});

parcelRegister("eL1JI", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $abe6cd481c13476d$require$_createElementVNode = $TusQn.createElementVNode;
var $abe6cd481c13476d$require$_openBlock = $TusQn.openBlock;
var $abe6cd481c13476d$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $abe6cd481c13476d$require$_openBlock(), $abe6cd481c13476d$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $abe6cd481c13476d$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5"
        })
    ]);
};

});

parcelRegister("d6rJN", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $98a15a02623fa6fa$require$_createElementVNode = $TusQn.createElementVNode;
var $98a15a02623fa6fa$require$_openBlock = $TusQn.openBlock;
var $98a15a02623fa6fa$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $98a15a02623fa6fa$require$_openBlock(), $98a15a02623fa6fa$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $98a15a02623fa6fa$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5"
        })
    ]);
};

});

parcelRegister("huL11", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $cbc9b554daef80d3$require$_createElementVNode = $TusQn.createElementVNode;
var $cbc9b554daef80d3$require$_openBlock = $TusQn.openBlock;
var $cbc9b554daef80d3$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $cbc9b554daef80d3$require$_openBlock(), $cbc9b554daef80d3$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $cbc9b554daef80d3$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9.143 17.082a24.248 24.248 0 0 0 3.844.148m-3.844-.148a23.856 23.856 0 0 1-5.455-1.31 8.964 8.964 0 0 0 2.3-5.542m3.155 6.852a3 3 0 0 0 5.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 0 0 3.536-1.003A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53"
        })
    ]);
};

});

parcelRegister("qOY90", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0509f737e0c659be$require$_createElementVNode = $TusQn.createElementVNode;
var $0509f737e0c659be$require$_openBlock = $TusQn.openBlock;
var $0509f737e0c659be$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0509f737e0c659be$require$_openBlock(), $0509f737e0c659be$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0509f737e0c659be$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M10.5 8.25h3l-3 4.5h3"
        })
    ]);
};

});

parcelRegister("NtNgR", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $094bb01ffaf3ee76$require$_createElementVNode = $TusQn.createElementVNode;
var $094bb01ffaf3ee76$require$_openBlock = $TusQn.openBlock;
var $094bb01ffaf3ee76$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $094bb01ffaf3ee76$require$_openBlock(), $094bb01ffaf3ee76$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $094bb01ffaf3ee76$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
        })
    ]);
};

});

parcelRegister("9A0cH", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $6f97a24cf75ed281$require$_createElementVNode = $TusQn.createElementVNode;
var $6f97a24cf75ed281$require$_openBlock = $TusQn.openBlock;
var $6f97a24cf75ed281$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $6f97a24cf75ed281$require$_openBlock(), $6f97a24cf75ed281$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $6f97a24cf75ed281$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M11.412 15.655 9.75 21.75l3.745-4.012M9.257 13.5H3.75l2.659-2.849m2.048-2.194L14.25 2.25 12 10.5h8.25l-4.707 5.043M8.457 8.457 3 3m5.457 5.457 7.086 7.086m0 0L21 21"
        })
    ]);
};

});

parcelRegister("jJyKA", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $e5dd2d02a57f207e$require$_createElementVNode = $TusQn.createElementVNode;
var $e5dd2d02a57f207e$require$_openBlock = $TusQn.openBlock;
var $e5dd2d02a57f207e$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $e5dd2d02a57f207e$require$_openBlock(), $e5dd2d02a57f207e$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $e5dd2d02a57f207e$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z"
        })
    ]);
};

});

parcelRegister("4HjPb", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $36ba8e4c4fb1eb50$require$_createElementVNode = $TusQn.createElementVNode;
var $36ba8e4c4fb1eb50$require$_openBlock = $TusQn.openBlock;
var $36ba8e4c4fb1eb50$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $36ba8e4c4fb1eb50$require$_openBlock(), $36ba8e4c4fb1eb50$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $36ba8e4c4fb1eb50$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"
        })
    ]);
};

});

parcelRegister("iAaV3", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d8740f17ea07eae2$require$_createElementVNode = $TusQn.createElementVNode;
var $d8740f17ea07eae2$require$_openBlock = $TusQn.openBlock;
var $d8740f17ea07eae2$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $d8740f17ea07eae2$require$_openBlock(), $d8740f17ea07eae2$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d8740f17ea07eae2$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m3 3 1.664 1.664M21 21l-1.5-1.5m-5.485-1.242L12 17.25 4.5 21V8.742m.164-4.078a2.15 2.15 0 0 1 1.743-1.342 48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185V19.5M4.664 4.664 19.5 19.5"
        })
    ]);
};

});

parcelRegister("1NbDR", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $14e365e5688a63f4$require$_createElementVNode = $TusQn.createElementVNode;
var $14e365e5688a63f4$require$_openBlock = $TusQn.openBlock;
var $14e365e5688a63f4$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $14e365e5688a63f4$require$_openBlock(), $14e365e5688a63f4$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $14e365e5688a63f4$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M16.5 3.75V16.5L12 14.25 7.5 16.5V3.75m9 0H18A2.25 2.25 0 0 1 20.25 6v12A2.25 2.25 0 0 1 18 20.25H6A2.25 2.25 0 0 1 3.75 18V6A2.25 2.25 0 0 1 6 3.75h1.5m9 0h-9"
        })
    ]);
};

});

parcelRegister("cQqO7", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $959f22be8a527615$require$_createElementVNode = $TusQn.createElementVNode;
var $959f22be8a527615$require$_openBlock = $TusQn.openBlock;
var $959f22be8a527615$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $959f22be8a527615$require$_openBlock(), $959f22be8a527615$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $959f22be8a527615$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
        })
    ]);
};

});

parcelRegister("dA9hL", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $9e35d70a24d32864$require$_createElementVNode = $TusQn.createElementVNode;
var $9e35d70a24d32864$require$_openBlock = $TusQn.openBlock;
var $9e35d70a24d32864$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $9e35d70a24d32864$require$_openBlock(), $9e35d70a24d32864$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $9e35d70a24d32864$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
        })
    ]);
};

});

parcelRegister("82jnV", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $5d9d8c0f497add94$require$_createElementVNode = $TusQn.createElementVNode;
var $5d9d8c0f497add94$require$_openBlock = $TusQn.openBlock;
var $5d9d8c0f497add94$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $5d9d8c0f497add94$require$_openBlock(), $5d9d8c0f497add94$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $5d9d8c0f497add94$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
        })
    ]);
};

});

parcelRegister("iThBv", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $dc0b04d563dcedbb$require$_createElementVNode = $TusQn.createElementVNode;
var $dc0b04d563dcedbb$require$_openBlock = $TusQn.openBlock;
var $dc0b04d563dcedbb$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $dc0b04d563dcedbb$require$_openBlock(), $dc0b04d563dcedbb$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $dc0b04d563dcedbb$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z"
        })
    ]);
};

});

parcelRegister("52THN", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $3ac8599a795acd96$require$_createElementVNode = $TusQn.createElementVNode;
var $3ac8599a795acd96$require$_openBlock = $TusQn.openBlock;
var $3ac8599a795acd96$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $3ac8599a795acd96$require$_openBlock(), $3ac8599a795acd96$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $3ac8599a795acd96$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z"
        })
    ]);
};

});

parcelRegister("47gsa", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $2ff49427897642ec$require$_createElementVNode = $TusQn.createElementVNode;
var $2ff49427897642ec$require$_openBlock = $TusQn.openBlock;
var $2ff49427897642ec$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $2ff49427897642ec$require$_openBlock(), $2ff49427897642ec$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $2ff49427897642ec$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
        })
    ]);
};

});

parcelRegister("2QB73", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $212d39ed399474b7$require$_createElementVNode = $TusQn.createElementVNode;
var $212d39ed399474b7$require$_openBlock = $TusQn.openBlock;
var $212d39ed399474b7$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $212d39ed399474b7$require$_openBlock(), $212d39ed399474b7$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $212d39ed399474b7$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z"
        })
    ]);
};

});

parcelRegister("1smyB", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $10f9e75643c6baeb$require$_createElementVNode = $TusQn.createElementVNode;
var $10f9e75643c6baeb$require$_openBlock = $TusQn.openBlock;
var $10f9e75643c6baeb$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $10f9e75643c6baeb$require$_openBlock(), $10f9e75643c6baeb$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $10f9e75643c6baeb$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 8.25v-1.5m0 1.5c-1.355 0-2.697.056-4.024.166C6.845 8.51 6 9.473 6 10.608v2.513m6-4.871c1.355 0 2.697.056 4.024.166C17.155 8.51 18 9.473 18 10.608v2.513M15 8.25v-1.5m-6 1.5v-1.5m12 9.75-1.5.75a3.354 3.354 0 0 1-3 0 3.354 3.354 0 0 0-3 0 3.354 3.354 0 0 1-3 0 3.354 3.354 0 0 0-3 0 3.354 3.354 0 0 1-3 0L3 16.5m15-3.379a48.474 48.474 0 0 0-6-.371c-2.032 0-4.034.126-6 .371m12 0c.39.049.777.102 1.163.16 1.07.16 1.837 1.094 1.837 2.175v5.169c0 .621-.504 1.125-1.125 1.125H4.125A1.125 1.125 0 0 1 3 20.625v-5.17c0-1.08.768-2.014 1.837-2.174A47.78 47.78 0 0 1 6 13.12M12.265 3.11a.375.375 0 1 1-.53 0L12 2.845l.265.265Zm-3 0a.375.375 0 1 1-.53 0L9 2.845l.265.265Zm6 0a.375.375 0 1 1-.53 0L15 2.845l.265.265Z"
        })
    ]);
};

});

parcelRegister("06myN", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0004efbc8528f555$require$_createElementVNode = $TusQn.createElementVNode;
var $0004efbc8528f555$require$_openBlock = $TusQn.openBlock;
var $0004efbc8528f555$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0004efbc8528f555$require$_openBlock(), $0004efbc8528f555$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0004efbc8528f555$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V13.5Zm0 2.25h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V18Zm2.498-6.75h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V13.5Zm0 2.25h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V18Zm2.504-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5Zm0 2.25h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V18Zm2.498-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5ZM8.25 6h7.5v2.25h-7.5V6ZM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z"
        })
    ]);
};

});

parcelRegister("1Hl6l", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $13ca2cddc2110426$require$_createElementVNode = $TusQn.createElementVNode;
var $13ca2cddc2110426$require$_openBlock = $TusQn.openBlock;
var $13ca2cddc2110426$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $13ca2cddc2110426$require$_openBlock(), $13ca2cddc2110426$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $13ca2cddc2110426$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
        })
    ]);
};

});

parcelRegister("2tbmd", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $1cc71981c2c564bd$require$_createElementVNode = $TusQn.createElementVNode;
var $1cc71981c2c564bd$require$_openBlock = $TusQn.openBlock;
var $1cc71981c2c564bd$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $1cc71981c2c564bd$require$_openBlock(), $1cc71981c2c564bd$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $1cc71981c2c564bd$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
        })
    ]);
};

});

parcelRegister("k5Scy", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $ea0e518b8eb2ae7d$require$_createElementVNode = $TusQn.createElementVNode;
var $ea0e518b8eb2ae7d$require$_openBlock = $TusQn.openBlock;
var $ea0e518b8eb2ae7d$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $ea0e518b8eb2ae7d$require$_openBlock(), $ea0e518b8eb2ae7d$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $ea0e518b8eb2ae7d$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z"
        }),
        $ea0e518b8eb2ae7d$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z"
        })
    ]);
};

});

parcelRegister("hN8Zc", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $cf3dfbb71b3910f6$require$_createElementVNode = $TusQn.createElementVNode;
var $cf3dfbb71b3910f6$require$_openBlock = $TusQn.openBlock;
var $cf3dfbb71b3910f6$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $cf3dfbb71b3910f6$require$_openBlock(), $cf3dfbb71b3910f6$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $cf3dfbb71b3910f6$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
        })
    ]);
};

});

parcelRegister("4ZyWA", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $3a27f7138215b86c$require$_createElementVNode = $TusQn.createElementVNode;
var $3a27f7138215b86c$require$_openBlock = $TusQn.openBlock;
var $3a27f7138215b86c$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $3a27f7138215b86c$require$_openBlock(), $3a27f7138215b86c$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $3a27f7138215b86c$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
        })
    ]);
};

});

parcelRegister("3alIu", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $24e326b7e533c1fa$require$_createElementVNode = $TusQn.createElementVNode;
var $24e326b7e533c1fa$require$_openBlock = $TusQn.openBlock;
var $24e326b7e533c1fa$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $24e326b7e533c1fa$require$_openBlock(), $24e326b7e533c1fa$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $24e326b7e533c1fa$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z"
        }),
        $24e326b7e533c1fa$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z"
        })
    ]);
};

});

parcelRegister("4i7pa", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $31fe9658c19cbd4f$require$_createElementVNode = $TusQn.createElementVNode;
var $31fe9658c19cbd4f$require$_openBlock = $TusQn.openBlock;
var $31fe9658c19cbd4f$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $31fe9658c19cbd4f$require$_openBlock(), $31fe9658c19cbd4f$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $31fe9658c19cbd4f$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
        })
    ]);
};

});

parcelRegister("dNEuP", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $a0bf43afd9a30c6e$require$_createElementVNode = $TusQn.createElementVNode;
var $a0bf43afd9a30c6e$require$_openBlock = $TusQn.openBlock;
var $a0bf43afd9a30c6e$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $a0bf43afd9a30c6e$require$_openBlock(), $a0bf43afd9a30c6e$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $a0bf43afd9a30c6e$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.068.157 2.148.279 3.238.364.466.037.893.281 1.153.671L12 21l2.652-3.978c.26-.39.687-.634 1.153-.67 1.09-.086 2.17-.208 3.238-.365 1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
        })
    ]);
};

});

parcelRegister("9LFy0", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $71c8bb4876805543$require$_createElementVNode = $TusQn.createElementVNode;
var $71c8bb4876805543$require$_openBlock = $TusQn.openBlock;
var $71c8bb4876805543$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $71c8bb4876805543$require$_openBlock(), $71c8bb4876805543$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $71c8bb4876805543$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
        })
    ]);
};

});

parcelRegister("2kyu1", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $1b2832ae7307d9f0$require$_createElementVNode = $TusQn.createElementVNode;
var $1b2832ae7307d9f0$require$_openBlock = $TusQn.openBlock;
var $1b2832ae7307d9f0$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $1b2832ae7307d9f0$require$_openBlock(), $1b2832ae7307d9f0$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $1b2832ae7307d9f0$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
        })
    ]);
};

});

parcelRegister("ifZEV", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d4a974eaf78e047c$require$_createElementVNode = $TusQn.createElementVNode;
var $d4a974eaf78e047c$require$_openBlock = $TusQn.openBlock;
var $d4a974eaf78e047c$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $d4a974eaf78e047c$require$_openBlock(), $d4a974eaf78e047c$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d4a974eaf78e047c$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 0 1 1.037-.443 48.282 48.282 0 0 0 5.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
        })
    ]);
};

});

parcelRegister("9FsF1", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $709e2ccb1d047f56$require$_createElementVNode = $TusQn.createElementVNode;
var $709e2ccb1d047f56$require$_openBlock = $TusQn.openBlock;
var $709e2ccb1d047f56$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $709e2ccb1d047f56$require$_openBlock(), $709e2ccb1d047f56$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $709e2ccb1d047f56$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
        })
    ]);
};

});

parcelRegister("lBB74", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $fba9d788987998f3$require$_createElementVNode = $TusQn.createElementVNode;
var $fba9d788987998f3$require$_openBlock = $TusQn.openBlock;
var $fba9d788987998f3$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $fba9d788987998f3$require$_openBlock(), $fba9d788987998f3$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $fba9d788987998f3$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z"
        })
    ]);
};

});

parcelRegister("dkCbe", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $9b4ac26b38cff76d$require$_createElementVNode = $TusQn.createElementVNode;
var $9b4ac26b38cff76d$require$_openBlock = $TusQn.openBlock;
var $9b4ac26b38cff76d$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $9b4ac26b38cff76d$require$_openBlock(), $9b4ac26b38cff76d$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $9b4ac26b38cff76d$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
        })
    ]);
};

});

parcelRegister("gOQxg", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $c3ea1151484bba7a$require$_createElementVNode = $TusQn.createElementVNode;
var $c3ea1151484bba7a$require$_openBlock = $TusQn.openBlock;
var $c3ea1151484bba7a$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $c3ea1151484bba7a$require$_openBlock(), $c3ea1151484bba7a$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $c3ea1151484bba7a$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("1CxWM", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $12e3ac3720c56e51$require$_createElementVNode = $TusQn.createElementVNode;
var $12e3ac3720c56e51$require$_openBlock = $TusQn.openBlock;
var $12e3ac3720c56e51$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $12e3ac3720c56e51$require$_openBlock(), $12e3ac3720c56e51$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $12e3ac3720c56e51$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m4.5 12.75 6 6 9-13.5"
        })
    ]);
};

});

parcelRegister("7kzLH", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $55662583a16f58f6$require$_createElementVNode = $TusQn.createElementVNode;
var $55662583a16f58f6$require$_openBlock = $TusQn.openBlock;
var $55662583a16f58f6$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $55662583a16f58f6$require$_openBlock(), $55662583a16f58f6$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $55662583a16f58f6$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5"
        })
    ]);
};

});

parcelRegister("1ZGHE", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $173c9ce2d6caf73d$require$_createElementVNode = $TusQn.createElementVNode;
var $173c9ce2d6caf73d$require$_openBlock = $TusQn.openBlock;
var $173c9ce2d6caf73d$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $173c9ce2d6caf73d$require$_openBlock(), $173c9ce2d6caf73d$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $173c9ce2d6caf73d$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
        })
    ]);
};

});

parcelRegister("lNOXQ", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $fdf5b508ceb96653$require$_createElementVNode = $TusQn.createElementVNode;
var $fdf5b508ceb96653$require$_openBlock = $TusQn.openBlock;
var $fdf5b508ceb96653$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $fdf5b508ceb96653$require$_openBlock(), $fdf5b508ceb96653$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $fdf5b508ceb96653$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
        })
    ]);
};

});

parcelRegister("dyepk", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $9dd9a0617ed58c9b$require$_createElementVNode = $TusQn.createElementVNode;
var $9dd9a0617ed58c9b$require$_openBlock = $TusQn.openBlock;
var $9dd9a0617ed58c9b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $9dd9a0617ed58c9b$require$_openBlock(), $9dd9a0617ed58c9b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $9dd9a0617ed58c9b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m4.5 18.75 7.5-7.5 7.5 7.5"
        }),
        $9dd9a0617ed58c9b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m4.5 12.75 7.5-7.5 7.5 7.5"
        })
    ]);
};

});

parcelRegister("1ZwLD", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $1734e7db86dde040$require$_createElementVNode = $TusQn.createElementVNode;
var $1734e7db86dde040$require$_openBlock = $TusQn.openBlock;
var $1734e7db86dde040$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $1734e7db86dde040$require$_openBlock(), $1734e7db86dde040$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $1734e7db86dde040$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m19.5 8.25-7.5 7.5-7.5-7.5"
        })
    ]);
};

});

parcelRegister("1RAw3", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $15b711053f4c9229$require$_createElementVNode = $TusQn.createElementVNode;
var $15b711053f4c9229$require$_openBlock = $TusQn.openBlock;
var $15b711053f4c9229$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $15b711053f4c9229$require$_openBlock(), $15b711053f4c9229$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $15b711053f4c9229$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 19.5 8.25 12l7.5-7.5"
        })
    ]);
};

});

parcelRegister("jNu5x", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $e699eedbf7d8a825$require$_createElementVNode = $TusQn.createElementVNode;
var $e699eedbf7d8a825$require$_openBlock = $TusQn.openBlock;
var $e699eedbf7d8a825$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $e699eedbf7d8a825$require$_openBlock(), $e699eedbf7d8a825$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $e699eedbf7d8a825$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m8.25 4.5 7.5 7.5-7.5 7.5"
        })
    ]);
};

});

parcelRegister("3gOlL", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $2619ec362b595d83$require$_createElementVNode = $TusQn.createElementVNode;
var $2619ec362b595d83$require$_openBlock = $TusQn.openBlock;
var $2619ec362b595d83$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $2619ec362b595d83$require$_openBlock(), $2619ec362b595d83$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $2619ec362b595d83$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
        })
    ]);
};

});

parcelRegister("lviE0", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $fa7af49555d57817$require$_createElementVNode = $TusQn.createElementVNode;
var $fa7af49555d57817$require$_openBlock = $TusQn.openBlock;
var $fa7af49555d57817$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $fa7af49555d57817$require$_openBlock(), $fa7af49555d57817$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $fa7af49555d57817$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m4.5 15.75 7.5-7.5 7.5 7.5"
        })
    ]);
};

});

parcelRegister("C9YEn", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $072b49feb241c127$require$_createElementVNode = $TusQn.createElementVNode;
var $072b49feb241c127$require$_openBlock = $TusQn.openBlock;
var $072b49feb241c127$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $072b49feb241c127$require$_openBlock(), $072b49feb241c127$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $072b49feb241c127$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
        })
    ]);
};

});

parcelRegister("9kxOp", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $6cb035aaea02ef9a$require$_createElementVNode = $TusQn.createElementVNode;
var $6cb035aaea02ef9a$require$_openBlock = $TusQn.openBlock;
var $6cb035aaea02ef9a$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $6cb035aaea02ef9a$require$_openBlock(), $6cb035aaea02ef9a$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $6cb035aaea02ef9a$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75"
        })
    ]);
};

});

parcelRegister("dSu9t", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $a1a7b508d7cb66e5$require$_createElementVNode = $TusQn.createElementVNode;
var $a1a7b508d7cb66e5$require$_openBlock = $TusQn.openBlock;
var $a1a7b508d7cb66e5$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $a1a7b508d7cb66e5$require$_openBlock(), $a1a7b508d7cb66e5$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $a1a7b508d7cb66e5$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
        })
    ]);
};

});

parcelRegister("70BbW", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $51a561f6044a090d$require$_createElementVNode = $TusQn.createElementVNode;
var $51a561f6044a090d$require$_openBlock = $TusQn.openBlock;
var $51a561f6044a090d$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $51a561f6044a090d$require$_openBlock(), $51a561f6044a090d$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $51a561f6044a090d$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z"
        })
    ]);
};

});

parcelRegister("aBLBR", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $7b924a5d0df72ef2$require$_createElementVNode = $TusQn.createElementVNode;
var $7b924a5d0df72ef2$require$_openBlock = $TusQn.openBlock;
var $7b924a5d0df72ef2$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $7b924a5d0df72ef2$require$_openBlock(), $7b924a5d0df72ef2$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $7b924a5d0df72ef2$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
        })
    ]);
};

});

parcelRegister("cJVCb", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $94666122e9db93b0$require$_createElementVNode = $TusQn.createElementVNode;
var $94666122e9db93b0$require$_openBlock = $TusQn.openBlock;
var $94666122e9db93b0$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $94666122e9db93b0$require$_openBlock(), $94666122e9db93b0$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $94666122e9db93b0$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("5cqqv", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $3c92928280fe0011$require$_createElementVNode = $TusQn.createElementVNode;
var $3c92928280fe0011$require$_openBlock = $TusQn.openBlock;
var $3c92928280fe0011$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $3c92928280fe0011$require$_openBlock(), $3c92928280fe0011$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $3c92928280fe0011$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 9.75v6.75m0 0-3-3m3 3 3-3m-8.25 6a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
        })
    ]);
};

});

parcelRegister("3FuAc", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $2abcec8d585e57d9$require$_createElementVNode = $TusQn.createElementVNode;
var $2abcec8d585e57d9$require$_openBlock = $TusQn.openBlock;
var $2abcec8d585e57d9$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $2abcec8d585e57d9$require$_openBlock(), $2abcec8d585e57d9$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $2abcec8d585e57d9$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
        })
    ]);
};

});

parcelRegister("ame0a", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $78a6d1e4e84e50b9$require$_createElementVNode = $TusQn.createElementVNode;
var $78a6d1e4e84e50b9$require$_openBlock = $TusQn.openBlock;
var $78a6d1e4e84e50b9$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $78a6d1e4e84e50b9$require$_openBlock(), $78a6d1e4e84e50b9$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $78a6d1e4e84e50b9$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.25 15a4.5 4.5 0 0 0 4.5 4.5H18a3.75 3.75 0 0 0 1.332-7.257 3 3 0 0 0-3.758-3.848 5.25 5.25 0 0 0-10.233 2.33A4.502 4.502 0 0 0 2.25 15Z"
        })
    ]);
};

});

parcelRegister("jTSBW", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $e7cd83f906091882$require$_createElementVNode = $TusQn.createElementVNode;
var $e7cd83f906091882$require$_openBlock = $TusQn.openBlock;
var $e7cd83f906091882$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $e7cd83f906091882$require$_openBlock(), $e7cd83f906091882$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $e7cd83f906091882$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M14.25 9.75 16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
        })
    ]);
};

});

parcelRegister("jiuNr", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $e0c796472ff181d4$require$_createElementVNode = $TusQn.createElementVNode;
var $e0c796472ff181d4$require$_openBlock = $TusQn.openBlock;
var $e0c796472ff181d4$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $e0c796472ff181d4$require$_openBlock(), $e0c796472ff181d4$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $e0c796472ff181d4$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5"
        })
    ]);
};

});

parcelRegister("bXhxp", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8b42cf0ea966dce6$require$_createElementVNode = $TusQn.createElementVNode;
var $8b42cf0ea966dce6$require$_openBlock = $TusQn.openBlock;
var $8b42cf0ea966dce6$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $8b42cf0ea966dce6$require$_openBlock(), $8b42cf0ea966dce6$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $8b42cf0ea966dce6$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
        }),
        $8b42cf0ea966dce6$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        })
    ]);
};

});

parcelRegister("4P00n", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $382bedd5164408a4$require$_createElementVNode = $TusQn.createElementVNode;
var $382bedd5164408a4$require$_openBlock = $TusQn.openBlock;
var $382bedd5164408a4$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $382bedd5164408a4$require$_openBlock(), $382bedd5164408a4$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $382bedd5164408a4$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z"
        }),
        $382bedd5164408a4$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        })
    ]);
};

});

parcelRegister("3n51f", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $274769cbab557468$require$_createElementVNode = $TusQn.createElementVNode;
var $274769cbab557468$require$_openBlock = $TusQn.openBlock;
var $274769cbab557468$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $274769cbab557468$require$_openBlock(), $274769cbab557468$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $274769cbab557468$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M4.5 12a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077 1.41-.513m14.095-5.13 1.41-.513M5.106 17.785l1.15-.964m11.49-9.642 1.149-.964M7.501 19.795l.75-1.3m7.5-12.99.75-1.3m-6.063 16.658.26-1.477m2.605-14.772.26-1.477m0 17.726-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205 12 12m6.894 5.785-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"
        })
    ]);
};

});

parcelRegister("6fxYb", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $48ce7e7b71727c53$require$_createElementVNode = $TusQn.createElementVNode;
var $48ce7e7b71727c53$require$_openBlock = $TusQn.openBlock;
var $48ce7e7b71727c53$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $48ce7e7b71727c53$require$_openBlock(), $48ce7e7b71727c53$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $48ce7e7b71727c53$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m6.75 7.5 3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0 0 21 18V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v12a2.25 2.25 0 0 0 2.25 2.25Z"
        })
    ]);
};

});

parcelRegister("fYQMI", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $ba25678b4f37d5ff$require$_createElementVNode = $TusQn.createElementVNode;
var $ba25678b4f37d5ff$require$_openBlock = $TusQn.openBlock;
var $ba25678b4f37d5ff$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $ba25678b4f37d5ff$require$_openBlock(), $ba25678b4f37d5ff$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $ba25678b4f37d5ff$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
        })
    ]);
};

});

parcelRegister("dZM6W", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $a3064ab26ea4e369$require$_createElementVNode = $TusQn.createElementVNode;
var $a3064ab26ea4e369$require$_openBlock = $TusQn.openBlock;
var $a3064ab26ea4e369$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $a3064ab26ea4e369$require$_openBlock(), $a3064ab26ea4e369$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $a3064ab26ea4e369$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 6.75v10.5a2.25 2.25 0 0 0 2.25 2.25Zm.75-12h9v9h-9v-9Z"
        })
    ]);
};

});

parcelRegister("lO4Rt", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $fe0209df062bba5f$require$_createElementVNode = $TusQn.createElementVNode;
var $fe0209df062bba5f$require$_openBlock = $TusQn.openBlock;
var $fe0209df062bba5f$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $fe0209df062bba5f$require$_openBlock(), $fe0209df062bba5f$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $fe0209df062bba5f$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
        })
    ]);
};

});

parcelRegister("8Kur6", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $65ea3a918a017893$require$_createElementVNode = $TusQn.createElementVNode;
var $65ea3a918a017893$require$_openBlock = $TusQn.openBlock;
var $65ea3a918a017893$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $65ea3a918a017893$require$_openBlock(), $65ea3a918a017893$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $65ea3a918a017893$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m21 7.5-2.25-1.313M21 7.5v2.25m0-2.25-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3 2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75 2.25-1.313M12 21.75V19.5m0 2.25-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"
        })
    ]);
};

});

parcelRegister("4Hwc4", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $36c426973ffcb8df$require$_createElementVNode = $TusQn.createElementVNode;
var $36c426973ffcb8df$require$_openBlock = $TusQn.openBlock;
var $36c426973ffcb8df$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $36c426973ffcb8df$require$_openBlock(), $36c426973ffcb8df$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $36c426973ffcb8df$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
        })
    ]);
};

});

parcelRegister("jkh4b", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $e11d1f9ec25248f2$require$_createElementVNode = $TusQn.createElementVNode;
var $e11d1f9ec25248f2$require$_openBlock = $TusQn.openBlock;
var $e11d1f9ec25248f2$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $e11d1f9ec25248f2$require$_openBlock(), $e11d1f9ec25248f2$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $e11d1f9ec25248f2$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m8.25 7.5.415-.207a.75.75 0 0 1 1.085.67V10.5m0 0h6m-6 0h-1.5m1.5 0v5.438c0 .354.161.697.473.865a3.751 3.751 0 0 0 5.452-2.553c.083-.409-.263-.75-.68-.75h-.745M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("6j9tB", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $497bde46d3ae2c51$require$_createElementVNode = $TusQn.createElementVNode;
var $497bde46d3ae2c51$require$_openBlock = $TusQn.openBlock;
var $497bde46d3ae2c51$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $497bde46d3ae2c51$require$_openBlock(), $497bde46d3ae2c51$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $497bde46d3ae2c51$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("jzozt", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $e3f4588cf0ee774b$require$_createElementVNode = $TusQn.createElementVNode;
var $e3f4588cf0ee774b$require$_openBlock = $TusQn.openBlock;
var $e3f4588cf0ee774b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $e3f4588cf0ee774b$require$_openBlock(), $e3f4588cf0ee774b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $e3f4588cf0ee774b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M14.25 7.756a4.5 4.5 0 1 0 0 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("iBQfA", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d8c43682b15b61bf$require$_createElementVNode = $TusQn.createElementVNode;
var $d8c43682b15b61bf$require$_openBlock = $TusQn.openBlock;
var $d8c43682b15b61bf$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $d8c43682b15b61bf$require$_openBlock(), $d8c43682b15b61bf$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d8c43682b15b61bf$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M14.121 7.629A3 3 0 0 0 9.017 9.43c-.023.212-.002.425.028.636l.506 3.541a4.5 4.5 0 0 1-.43 2.65L9 16.5l1.539-.513a2.25 2.25 0 0 1 1.422 0l.655.218a2.25 2.25 0 0 0 1.718-.122L15 15.75M8.25 12H12m9 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("fMxjI", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b7d52ec79f1d763b$require$_createElementVNode = $TusQn.createElementVNode;
var $b7d52ec79f1d763b$require$_openBlock = $TusQn.openBlock;
var $b7d52ec79f1d763b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b7d52ec79f1d763b$require$_openBlock(), $b7d52ec79f1d763b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b7d52ec79f1d763b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15 8.25H9m6 3H9m3 6-3-3h1.5a3 3 0 1 0 0-6M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("a7skV", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $75e089e34f66f9d1$require$_createElementVNode = $TusQn.createElementVNode;
var $75e089e34f66f9d1$require$_openBlock = $TusQn.openBlock;
var $75e089e34f66f9d1$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $75e089e34f66f9d1$require$_openBlock(), $75e089e34f66f9d1$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $75e089e34f66f9d1$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m9 7.5 3 4.5m0 0 3-4.5M12 12v5.25M15 12H9m6 3H9m12-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("sGoXN", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $056381b8baf3abfd$require$_createElementVNode = $TusQn.createElementVNode;
var $056381b8baf3abfd$require$_openBlock = $TusQn.openBlock;
var $056381b8baf3abfd$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $056381b8baf3abfd$require$_openBlock(), $056381b8baf3abfd$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $056381b8baf3abfd$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59"
        })
    ]);
};

});

parcelRegister("29hz7", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $190a0c2ab56943af$require$_createElementVNode = $TusQn.createElementVNode;
var $190a0c2ab56943af$require$_openBlock = $TusQn.openBlock;
var $190a0c2ab56943af$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $190a0c2ab56943af$require$_openBlock(), $190a0c2ab56943af$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $190a0c2ab56943af$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672Zm-7.518-.267A8.25 8.25 0 1 1 20.25 10.5M8.288 14.212A5.25 5.25 0 1 1 17.25 10.5"
        })
    ]);
};

});

parcelRegister("1UCXU", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $16493f15cd4be83b$require$_createElementVNode = $TusQn.createElementVNode;
var $16493f15cd4be83b$require$_openBlock = $TusQn.openBlock;
var $16493f15cd4be83b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $16493f15cd4be83b$require$_openBlock(), $16493f15cd4be83b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $16493f15cd4be83b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"
        })
    ]);
};

});

parcelRegister("bLqtu", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $89089ed39e1d79f8$require$_createElementVNode = $TusQn.createElementVNode;
var $89089ed39e1d79f8$require$_openBlock = $TusQn.openBlock;
var $89089ed39e1d79f8$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $89089ed39e1d79f8$require$_openBlock(), $89089ed39e1d79f8$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $89089ed39e1d79f8$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-15a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 4.5v15a2.25 2.25 0 0 0 2.25 2.25Z"
        })
    ]);
};

});

parcelRegister("9otN2", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $6d6d769729221e28$require$_createElementVNode = $TusQn.createElementVNode;
var $6d6d769729221e28$require$_openBlock = $TusQn.openBlock;
var $6d6d769729221e28$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $6d6d769729221e28$require$_openBlock(), $6d6d769729221e28$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $6d6d769729221e28$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
        })
    ]);
};

});

parcelRegister("hGCgb", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $ce040989039001dd$require$_createElementVNode = $TusQn.createElementVNode;
var $ce040989039001dd$require$_openBlock = $TusQn.openBlock;
var $ce040989039001dd$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $ce040989039001dd$require$_openBlock(), $ce040989039001dd$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $ce040989039001dd$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12-3-3m0 0-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
        })
    ]);
};

});

parcelRegister("cYujE", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $97229abf660b5dc0$require$_createElementVNode = $TusQn.createElementVNode;
var $97229abf660b5dc0$require$_openBlock = $TusQn.openBlock;
var $97229abf660b5dc0$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $97229abf660b5dc0$require$_openBlock(), $97229abf660b5dc0$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $97229abf660b5dc0$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
        })
    ]);
};

});

parcelRegister("7Uefv", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $5c18d0eca991c832$require$_createElementVNode = $TusQn.createElementVNode;
var $5c18d0eca991c832$require$_openBlock = $TusQn.openBlock;
var $5c18d0eca991c832$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $5c18d0eca991c832$require$_openBlock(), $5c18d0eca991c832$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $5c18d0eca991c832$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12"
        })
    ]);
};

});

parcelRegister("dkw6y", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $9b460bee99598a63$require$_createElementVNode = $TusQn.createElementVNode;
var $9b460bee99598a63$require$_openBlock = $TusQn.openBlock;
var $9b460bee99598a63$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $9b460bee99598a63$require$_openBlock(), $9b460bee99598a63$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $9b460bee99598a63$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
        })
    ]);
};

});

parcelRegister("6vYrx", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $4be4860f84b35221$require$_createElementVNode = $TusQn.createElementVNode;
var $4be4860f84b35221$require$_openBlock = $TusQn.openBlock;
var $4be4860f84b35221$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $4be4860f84b35221$require$_openBlock(), $4be4860f84b35221$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $4be4860f84b35221$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm3.75 11.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
        })
    ]);
};

});

parcelRegister("hE3Dc", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $cd88fd33e2ccb570$require$_createElementVNode = $TusQn.createElementVNode;
var $cd88fd33e2ccb570$require$_openBlock = $TusQn.openBlock;
var $cd88fd33e2ccb570$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $cd88fd33e2ccb570$require$_openBlock(), $cd88fd33e2ccb570$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $cd88fd33e2ccb570$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
        })
    ]);
};

});

parcelRegister("cWRcR", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $96d42c827eb68fdb$require$_createElementVNode = $TusQn.createElementVNode;
var $96d42c827eb68fdb$require$_openBlock = $TusQn.openBlock;
var $96d42c827eb68fdb$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $96d42c827eb68fdb$require$_openBlock(), $96d42c827eb68fdb$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $96d42c827eb68fdb$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
        })
    ]);
};

});

parcelRegister("bJBov", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $88b0e761c049c538$require$_createElementVNode = $TusQn.createElementVNode;
var $88b0e761c049c538$require$_openBlock = $TusQn.openBlock;
var $88b0e761c049c538$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $88b0e761c049c538$require$_openBlock(), $88b0e761c049c538$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $88b0e761c049c538$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
        })
    ]);
};

});

parcelRegister("hRLNT", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d01c77bd00670f3b$require$_createElementVNode = $TusQn.createElementVNode;
var $d01c77bd00670f3b$require$_openBlock = $TusQn.openBlock;
var $d01c77bd00670f3b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $d01c77bd00670f3b$require$_openBlock(), $d01c77bd00670f3b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d01c77bd00670f3b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
        })
    ]);
};

});

parcelRegister("cpYgE", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $90a691ba13681268$require$_createElementVNode = $TusQn.createElementVNode;
var $90a691ba13681268$require$_openBlock = $TusQn.openBlock;
var $90a691ba13681268$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $90a691ba13681268$require$_openBlock(), $90a691ba13681268$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $90a691ba13681268$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("4tXhi", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $3437da38142aaa36$require$_createElementVNode = $TusQn.createElementVNode;
var $3437da38142aaa36$require$_openBlock = $TusQn.openBlock;
var $3437da38142aaa36$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $3437da38142aaa36$require$_openBlock(), $3437da38142aaa36$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $3437da38142aaa36$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
        })
    ]);
};

});

parcelRegister("j1dcT", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $dd885aecfc30799b$require$_createElementVNode = $TusQn.createElementVNode;
var $dd885aecfc30799b$require$_openBlock = $TusQn.openBlock;
var $dd885aecfc30799b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $dd885aecfc30799b$require$_openBlock(), $dd885aecfc30799b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $dd885aecfc30799b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
        })
    ]);
};

});

parcelRegister("2uB8V", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $1d0b31f331fe13a6$require$_createElementVNode = $TusQn.createElementVNode;
var $1d0b31f331fe13a6$require$_openBlock = $TusQn.openBlock;
var $1d0b31f331fe13a6$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $1d0b31f331fe13a6$require$_openBlock(), $1d0b31f331fe13a6$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $1d0b31f331fe13a6$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.981l7.5-4.039a2.25 2.25 0 0 1 2.134 0l7.5 4.039a2.25 2.25 0 0 1 1.183 1.98V19.5Z"
        })
    ]);
};

});

parcelRegister("2W8T3", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $2237e454da05cca3$require$_createElementVNode = $TusQn.createElementVNode;
var $2237e454da05cca3$require$_openBlock = $TusQn.openBlock;
var $2237e454da05cca3$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $2237e454da05cca3$require$_openBlock(), $2237e454da05cca3$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $2237e454da05cca3$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
        })
    ]);
};

});

parcelRegister("iYjpD", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $dcfce37ecdce71a1$require$_createElementVNode = $TusQn.createElementVNode;
var $dcfce37ecdce71a1$require$_openBlock = $TusQn.openBlock;
var $dcfce37ecdce71a1$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $dcfce37ecdce71a1$require$_openBlock(), $dcfce37ecdce71a1$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $dcfce37ecdce71a1$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
        })
    ]);
};

});

parcelRegister("630FK", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $46738b69ea3e67ee$require$_createElementVNode = $TusQn.createElementVNode;
var $46738b69ea3e67ee$require$_openBlock = $TusQn.openBlock;
var $46738b69ea3e67ee$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $46738b69ea3e67ee$require$_openBlock(), $46738b69ea3e67ee$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $46738b69ea3e67ee$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
        })
    ]);
};

});

parcelRegister("dEqIC", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $9f03bc8ac8aa8159$require$_createElementVNode = $TusQn.createElementVNode;
var $9f03bc8ac8aa8159$require$_openBlock = $TusQn.openBlock;
var $9f03bc8ac8aa8159$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $9f03bc8ac8aa8159$require$_openBlock(), $9f03bc8ac8aa8159$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $9f03bc8ac8aa8159$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m15 11.25 1.5 1.5.75-.75V8.758l2.276-.61a3 3 0 1 0-3.675-3.675l-.61 2.277H12l-.75.75 1.5 1.5M15 11.25l-8.47 8.47c-.34.34-.8.53-1.28.53s-.94.19-1.28.53l-.97.97-.75-.75.97-.97c.34-.34.53-.8.53-1.28s.19-.94.53-1.28L12.75 9M15 11.25 12.75 9"
        })
    ]);
};

});

parcelRegister("giJWO", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $bde1f7fea08287e5$require$_createElementVNode = $TusQn.createElementVNode;
var $bde1f7fea08287e5$require$_openBlock = $TusQn.openBlock;
var $bde1f7fea08287e5$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $bde1f7fea08287e5$require$_openBlock(), $bde1f7fea08287e5$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $bde1f7fea08287e5$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
        })
    ]);
};

});

parcelRegister("3ZnuL", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $2e794b4540b5a258$require$_createElementVNode = $TusQn.createElementVNode;
var $2e794b4540b5a258$require$_openBlock = $TusQn.openBlock;
var $2e794b4540b5a258$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $2e794b4540b5a258$require$_openBlock(), $2e794b4540b5a258$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $2e794b4540b5a258$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
        }),
        $2e794b4540b5a258$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        })
    ]);
};

});

parcelRegister("bDAnH", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $878f8ecc40741499$require$_createElementVNode = $TusQn.createElementVNode;
var $878f8ecc40741499$require$_openBlock = $TusQn.openBlock;
var $878f8ecc40741499$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $878f8ecc40741499$require$_openBlock(), $878f8ecc40741499$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $878f8ecc40741499$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.182 16.318A4.486 4.486 0 0 0 12.016 15a4.486 4.486 0 0 0-3.198 1.318M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"
        })
    ]);
};

});

parcelRegister("kqx4S", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $edefe4e21b9e44a0$require$_createElementVNode = $TusQn.createElementVNode;
var $edefe4e21b9e44a0$require$_openBlock = $TusQn.openBlock;
var $edefe4e21b9e44a0$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $edefe4e21b9e44a0$require$_openBlock(), $edefe4e21b9e44a0$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $edefe4e21b9e44a0$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"
        })
    ]);
};

});

parcelRegister("92Lb6", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $6958e58e8bf9795f$require$_createElementVNode = $TusQn.createElementVNode;
var $6958e58e8bf9795f$require$_openBlock = $TusQn.openBlock;
var $6958e58e8bf9795f$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $6958e58e8bf9795f$require$_openBlock(), $6958e58e8bf9795f$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $6958e58e8bf9795f$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0 1 18 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0 1 18 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 0 1 6 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5"
        })
    ]);
};

});

parcelRegister("hyXRx", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $cc940c1c6af46ce5$require$_createElementVNode = $TusQn.createElementVNode;
var $cc940c1c6af46ce5$require$_openBlock = $TusQn.openBlock;
var $cc940c1c6af46ce5$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $cc940c1c6af46ce5$require$_openBlock(), $cc940c1c6af46ce5$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $cc940c1c6af46ce5$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M7.864 4.243A7.5 7.5 0 0 1 19.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 0 0 4.5 10.5a7.464 7.464 0 0 1-1.15 3.993m1.989 3.559A11.209 11.209 0 0 0 8.25 10.5a3.75 3.75 0 1 1 7.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 0 1-3.6 9.75m6.633-4.596a18.666 18.666 0 0 1-2.485 5.33"
        })
    ]);
};

});

parcelRegister("b61ys", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $814175f8324321e2$require$_createElementVNode = $TusQn.createElementVNode;
var $814175f8324321e2$require$_openBlock = $TusQn.openBlock;
var $814175f8324321e2$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $814175f8324321e2$require$_openBlock(), $814175f8324321e2$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $814175f8324321e2$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.362 5.214A8.252 8.252 0 0 1 12 21 8.25 8.25 0 0 1 6.038 7.047 8.287 8.287 0 0 0 9 9.601a8.983 8.983 0 0 1 3.361-6.867 8.21 8.21 0 0 0 3 2.48Z"
        }),
        $814175f8324321e2$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 18a3.75 3.75 0 0 0 .495-7.468 5.99 5.99 0 0 0-1.925 3.547 5.975 5.975 0 0 1-2.133-1.001A3.75 3.75 0 0 0 12 18Z"
        })
    ]);
};

});

parcelRegister("flKyw", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b2ccee2cd49af68a$require$_createElementVNode = $TusQn.createElementVNode;
var $b2ccee2cd49af68a$require$_openBlock = $TusQn.openBlock;
var $b2ccee2cd49af68a$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b2ccee2cd49af68a$require$_openBlock(), $b2ccee2cd49af68a$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b2ccee2cd49af68a$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5"
        })
    ]);
};

});

parcelRegister("w1sDO", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $06041f636842aee5$require$_createElementVNode = $TusQn.createElementVNode;
var $06041f636842aee5$require$_openBlock = $TusQn.openBlock;
var $06041f636842aee5$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $06041f636842aee5$require$_openBlock(), $06041f636842aee5$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $06041f636842aee5$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m9 13.5 3 3m0 0 3-3m-3 3v-6m1.06-4.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
        })
    ]);
};

});

parcelRegister("XhOuD", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0b23542ca87d2f93$require$_createElementVNode = $TusQn.createElementVNode;
var $0b23542ca87d2f93$require$_openBlock = $TusQn.openBlock;
var $0b23542ca87d2f93$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0b23542ca87d2f93$require$_openBlock(), $0b23542ca87d2f93$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0b23542ca87d2f93$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15 13.5H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
        })
    ]);
};

});

parcelRegister("20AiV", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $1767be2580f48396$require$_createElementVNode = $TusQn.createElementVNode;
var $1767be2580f48396$require$_openBlock = $TusQn.openBlock;
var $1767be2580f48396$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $1767be2580f48396$require$_openBlock(), $1767be2580f48396$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $1767be2580f48396$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 0 0-1.883 2.542l.857 6a2.25 2.25 0 0 0 2.227 1.932H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-1.883-2.542m-16.5 0V6A2.25 2.25 0 0 1 6 3.75h3.879a1.5 1.5 0 0 1 1.06.44l2.122 2.12a1.5 1.5 0 0 0 1.06.44H18A2.25 2.25 0 0 1 20.25 9v.776"
        })
    ]);
};

});

parcelRegister("4LNFs", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $3792142dd55bbecd$require$_createElementVNode = $TusQn.createElementVNode;
var $3792142dd55bbecd$require$_openBlock = $TusQn.openBlock;
var $3792142dd55bbecd$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $3792142dd55bbecd$require$_openBlock(), $3792142dd55bbecd$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $3792142dd55bbecd$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 10.5v6m3-3H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
        })
    ]);
};

});

parcelRegister("6F6Eg", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $4d9bbaa708c6c0d6$require$_createElementVNode = $TusQn.createElementVNode;
var $4d9bbaa708c6c0d6$require$_openBlock = $TusQn.openBlock;
var $4d9bbaa708c6c0d6$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $4d9bbaa708c6c0d6$require$_openBlock(), $4d9bbaa708c6c0d6$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $4d9bbaa708c6c0d6$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
        })
    ]);
};

});

parcelRegister("1cCcP", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0e048c548a8d8afb$require$_createElementVNode = $TusQn.createElementVNode;
var $0e048c548a8d8afb$require$_openBlock = $TusQn.openBlock;
var $0e048c548a8d8afb$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0e048c548a8d8afb$require$_openBlock(), $0e048c548a8d8afb$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0e048c548a8d8afb$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061A1.125 1.125 0 0 1 3 16.811V8.69ZM12.75 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061a1.125 1.125 0 0 1-1.683-.977V8.69Z"
        })
    ]);
};

});

parcelRegister("jtLIU", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $e2e5bea22fadfe0d$require$_createElementVNode = $TusQn.createElementVNode;
var $e2e5bea22fadfe0d$require$_openBlock = $TusQn.openBlock;
var $e2e5bea22fadfe0d$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $e2e5bea22fadfe0d$require$_openBlock(), $e2e5bea22fadfe0d$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $e2e5bea22fadfe0d$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
        })
    ]);
};

});

parcelRegister("jq7K4", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $e2367370c92750aa$require$_createElementVNode = $TusQn.createElementVNode;
var $e2367370c92750aa$require$_openBlock = $TusQn.openBlock;
var $e2367370c92750aa$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $e2367370c92750aa$require$_openBlock(), $e2367370c92750aa$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $e2367370c92750aa$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12.75 8.25v7.5m6-7.5h-3V12m0 0v3.75m0-3.75H18M9.75 9.348c-1.03-1.464-2.698-1.464-3.728 0-1.03 1.465-1.03 3.84 0 5.304 1.03 1.464 2.699 1.464 3.728 0V12h-1.5M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
        })
    ]);
};

});

parcelRegister("4qeU0", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $3385266f0a267ccb$require$_createElementVNode = $TusQn.createElementVNode;
var $3385266f0a267ccb$require$_openBlock = $TusQn.openBlock;
var $3385266f0a267ccb$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $3385266f0a267ccb$require$_openBlock(), $3385266f0a267ccb$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $3385266f0a267ccb$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 3.75v16.5M2.25 12h19.5M6.375 17.25a4.875 4.875 0 0 0 4.875-4.875V12m6.375 5.25a4.875 4.875 0 0 1-4.875-4.875V12m-9 8.25h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5Zm12.621-9.44c-1.409 1.41-4.242 1.061-4.242 1.061s-.349-2.833 1.06-4.242a2.25 2.25 0 0 1 3.182 3.182ZM10.773 7.63c1.409 1.409 1.06 4.242 1.06 4.242S9 12.22 7.592 10.811a2.25 2.25 0 1 1 3.182-3.182Z"
        })
    ]);
};

});

parcelRegister("71Csk", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $51d674f28a789624$require$_createElementVNode = $TusQn.createElementVNode;
var $51d674f28a789624$require$_openBlock = $TusQn.openBlock;
var $51d674f28a789624$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $51d674f28a789624$require$_openBlock(), $51d674f28a789624$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $51d674f28a789624$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
        })
    ]);
};

});

parcelRegister("bnvtD", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $848a4260ac308a54$require$_createElementVNode = $TusQn.createElementVNode;
var $848a4260ac308a54$require$_openBlock = $TusQn.openBlock;
var $848a4260ac308a54$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $848a4260ac308a54$require$_openBlock(), $848a4260ac308a54$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $848a4260ac308a54$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
        })
    ]);
};

});

parcelRegister("bsUUO", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $858e757403c7ee42$require$_createElementVNode = $TusQn.createElementVNode;
var $858e757403c7ee42$require$_openBlock = $TusQn.openBlock;
var $858e757403c7ee42$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $858e757403c7ee42$require$_openBlock(), $858e757403c7ee42$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $858e757403c7ee42$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m6.115 5.19.319 1.913A6 6 0 0 0 8.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 0 0 2.288-4.042 1.087 1.087 0 0 0-.358-1.099l-1.33-1.108c-.251-.21-.582-.299-.905-.245l-1.17.195a1.125 1.125 0 0 1-.98-.314l-.295-.295a1.125 1.125 0 0 1 0-1.591l.13-.132a1.125 1.125 0 0 1 1.3-.21l.603.302a.809.809 0 0 0 1.086-1.086L14.25 7.5l1.256-.837a4.5 4.5 0 0 0 1.528-1.732l.146-.292M6.115 5.19A9 9 0 1 0 17.18 4.64M6.115 5.19A8.965 8.965 0 0 1 12 3c1.929 0 3.716.607 5.18 1.64"
        })
    ]);
};

});

parcelRegister("alSjI", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $7895ffc8a18e3051$require$_createElementVNode = $TusQn.createElementVNode;
var $7895ffc8a18e3051$require$_openBlock = $TusQn.openBlock;
var $7895ffc8a18e3051$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $7895ffc8a18e3051$require$_openBlock(), $7895ffc8a18e3051$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $7895ffc8a18e3051$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12.75 3.03v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 0 1-1.161.886l-.143.048a1.107 1.107 0 0 0-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 0 1-1.652.928l-.679-.906a1.125 1.125 0 0 0-1.906.172L4.5 15.75l-.612.153M12.75 3.031a9 9 0 0 0-8.862 12.872M12.75 3.031a9 9 0 0 1 6.69 14.036m0 0-.177-.529A2.25 2.25 0 0 0 17.128 15H16.5l-.324-.324a1.453 1.453 0 0 0-2.328.377l-.036.073a1.586 1.586 0 0 1-.982.816l-.99.282c-.55.157-.894.702-.8 1.267l.073.438c.08.474.49.821.97.821.846 0 1.598.542 1.865 1.345l.215.643m5.276-3.67a9.012 9.012 0 0 1-5.276 3.67m0 0a9 9 0 0 1-10.275-4.835M15.75 9c0 .896-.393 1.7-1.016 2.25"
        })
    ]);
};

});

parcelRegister("kkB37", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $ecd26a216e20624b$require$_createElementVNode = $TusQn.createElementVNode;
var $ecd26a216e20624b$require$_openBlock = $TusQn.openBlock;
var $ecd26a216e20624b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $ecd26a216e20624b$require$_openBlock(), $ecd26a216e20624b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $ecd26a216e20624b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m20.893 13.393-1.135-1.135a2.252 2.252 0 0 1-.421-.585l-1.08-2.16a.414.414 0 0 0-.663-.107.827.827 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025 1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 0 1-1.383-2.46l.007-.042a2.25 2.25 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 0 1-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 0 1-1.458-1.137l1.411-2.353a2.25 2.25 0 0 0 .286-.76m11.928 9.869A9 9 0 0 0 8.965 3.525m11.928 9.868A9 9 0 1 1 8.965 3.525"
        })
    ]);
};

});

parcelRegister("cFNHO", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $939fdee4c69ddc2e$require$_createElementVNode = $TusQn.createElementVNode;
var $939fdee4c69ddc2e$require$_openBlock = $TusQn.openBlock;
var $939fdee4c69ddc2e$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $939fdee4c69ddc2e$require$_openBlock(), $939fdee4c69ddc2e$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $939fdee4c69ddc2e$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M10.05 4.575a1.575 1.575 0 1 0-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 0 1 3.15 0v1.5m-3.15 0 .075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 0 1 3.15 0V15M6.9 7.575a1.575 1.575 0 1 0-3.15 0v8.175a6.75 6.75 0 0 0 6.75 6.75h2.018a5.25 5.25 0 0 0 3.712-1.538l1.732-1.732a5.25 5.25 0 0 0 1.538-3.712l.003-2.024a.668.668 0 0 1 .198-.471 1.575 1.575 0 1 0-2.228-2.228 3.818 3.818 0 0 0-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0 1 16.35 15m.002 0h-.002"
        })
    ]);
};

});

parcelRegister("aSg8q", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $7eab768f5ee87825$require$_createElementVNode = $TusQn.createElementVNode;
var $7eab768f5ee87825$require$_openBlock = $TusQn.openBlock;
var $7eab768f5ee87825$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $7eab768f5ee87825$require$_openBlock(), $7eab768f5ee87825$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $7eab768f5ee87825$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M7.498 15.25H4.372c-1.026 0-1.945-.694-2.054-1.715a12.137 12.137 0 0 1-.068-1.285c0-2.848.992-5.464 2.649-7.521C5.287 4.247 5.886 4 6.504 4h4.016a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23h1.294M7.498 15.25c.618 0 .991.724.725 1.282A7.471 7.471 0 0 0 7.5 19.75 2.25 2.25 0 0 0 9.75 22a.75.75 0 0 0 .75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 0 0 2.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384m-10.253 1.5H9.7m8.075-9.75c.01.05.027.1.05.148.593 1.2.925 2.55.925 3.977 0 1.487-.36 2.89-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398-.306.774-1.086 1.227-1.918 1.227h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 0 0 .303-.54"
        })
    ]);
};

});

parcelRegister("1G3sA", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $138c65c712267465$require$_createElementVNode = $TusQn.createElementVNode;
var $138c65c712267465$require$_openBlock = $TusQn.openBlock;
var $138c65c712267465$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $138c65c712267465$require$_openBlock(), $138c65c712267465$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $138c65c712267465$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6.633 10.25c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282m0 0h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23H5.904m10.598-9.75H14.25M5.904 18.5c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 0 1-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 9.953 4.167 9.5 5 9.5h1.053c.472 0 .745.556.5.96a8.958 8.958 0 0 0-1.302 4.665c0 1.194.232 2.333.654 3.375Z"
        })
    ]);
};

});

parcelRegister("lavVg", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $f6934b4aa8dc4ab0$require$_createElementVNode = $TusQn.createElementVNode;
var $f6934b4aa8dc4ab0$require$_openBlock = $TusQn.openBlock;
var $f6934b4aa8dc4ab0$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $f6934b4aa8dc4ab0$require$_openBlock(), $f6934b4aa8dc4ab0$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $f6934b4aa8dc4ab0$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5-3.9 19.5m-2.1-19.5-3.9 19.5"
        })
    ]);
};

});

parcelRegister("e5AoA", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $a41dc3bcee272700$require$_createElementVNode = $TusQn.createElementVNode;
var $a41dc3bcee272700$require$_openBlock = $TusQn.openBlock;
var $a41dc3bcee272700$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $a41dc3bcee272700$require$_openBlock(), $a41dc3bcee272700$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $a41dc3bcee272700$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
        })
    ]);
};

});

parcelRegister("hHi79", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $ce2480f6e621b07c$require$_createElementVNode = $TusQn.createElementVNode;
var $ce2480f6e621b07c$require$_openBlock = $TusQn.openBlock;
var $ce2480f6e621b07c$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $ce2480f6e621b07c$require$_openBlock(), $ce2480f6e621b07c$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $ce2480f6e621b07c$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205 3 1m1.5.5-1.5-.5M6.75 7.364V3h-3v18m3-13.636 10.5-3.819"
        })
    ]);
};

});

parcelRegister("3apb5", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $24e5d610899d8f70$require$_createElementVNode = $TusQn.createElementVNode;
var $24e5d610899d8f70$require$_openBlock = $TusQn.openBlock;
var $24e5d610899d8f70$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $24e5d610899d8f70$require$_openBlock(), $24e5d610899d8f70$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $24e5d610899d8f70$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
        })
    ]);
};

});

parcelRegister("iMVOY", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0387a359d5cad059$require$_createElementVNode = $TusQn.createElementVNode;
var $0387a359d5cad059$require$_openBlock = $TusQn.openBlock;
var $0387a359d5cad059$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0387a359d5cad059$require$_openBlock(), $0387a359d5cad059$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0387a359d5cad059$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z"
        })
    ]);
};

});

parcelRegister("k3inm", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $e992577fe7b9ee58$require$_createElementVNode = $TusQn.createElementVNode;
var $e992577fe7b9ee58$require$_openBlock = $TusQn.openBlock;
var $e992577fe7b9ee58$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $e992577fe7b9ee58$require$_openBlock(), $e992577fe7b9ee58$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $e992577fe7b9ee58$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 3.75H6.912a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859M12 3v8.25m0 0-3-3m3 3 3-3"
        })
    ]);
};

});

parcelRegister("uiZaB", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $05b1879aa2472213$require$_createElementVNode = $TusQn.createElementVNode;
var $05b1879aa2472213$require$_openBlock = $TusQn.openBlock;
var $05b1879aa2472213$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $05b1879aa2472213$require$_openBlock(), $05b1879aa2472213$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $05b1879aa2472213$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m7.875 14.25 1.214 1.942a2.25 2.25 0 0 0 1.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 0 1 1.872 1.002l.164.246a2.25 2.25 0 0 0 1.872 1.002h2.092a2.25 2.25 0 0 0 1.872-1.002l.164-.246A2.25 2.25 0 0 1 16.954 9h4.636M2.41 9a2.25 2.25 0 0 0-.16.832V12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 0 1 .382-.632l3.285-3.832a2.25 2.25 0 0 1 1.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M4.5 20.25h15A2.25 2.25 0 0 0 21.75 18v-2.625c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125V18a2.25 2.25 0 0 0 2.25 2.25Z"
        })
    ]);
};

});

parcelRegister("i5hyO", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d2a650c2f0ec8412$require$_createElementVNode = $TusQn.createElementVNode;
var $d2a650c2f0ec8412$require$_openBlock = $TusQn.openBlock;
var $d2a650c2f0ec8412$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $d2a650c2f0ec8412$require$_openBlock(), $d2a650c2f0ec8412$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d2a650c2f0ec8412$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H6.911a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661Z"
        })
    ]);
};

});

parcelRegister("8epRX", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $5fe3b29ffd8eb916$require$_createElementVNode = $TusQn.createElementVNode;
var $5fe3b29ffd8eb916$require$_openBlock = $TusQn.openBlock;
var $5fe3b29ffd8eb916$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $5fe3b29ffd8eb916$require$_openBlock(), $5fe3b29ffd8eb916$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $5fe3b29ffd8eb916$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        })
    ]);
};

});

parcelRegister("0O1eM", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0026ccecb1ea472b$require$_createElementVNode = $TusQn.createElementVNode;
var $0026ccecb1ea472b$require$_openBlock = $TusQn.openBlock;
var $0026ccecb1ea472b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0026ccecb1ea472b$require$_openBlock(), $0026ccecb1ea472b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0026ccecb1ea472b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z"
        })
    ]);
};

});

parcelRegister("cV25S", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $967c6eab155615d0$require$_createElementVNode = $TusQn.createElementVNode;
var $967c6eab155615d0$require$_openBlock = $TusQn.openBlock;
var $967c6eab155615d0$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $967c6eab155615d0$require$_openBlock(), $967c6eab155615d0$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $967c6eab155615d0$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802"
        })
    ]);
};

});

parcelRegister("4eOmz", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $315f8945212dcfc7$require$_createElementVNode = $TusQn.createElementVNode;
var $315f8945212dcfc7$require$_openBlock = $TusQn.openBlock;
var $315f8945212dcfc7$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $315f8945212dcfc7$require$_openBlock(), $315f8945212dcfc7$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $315f8945212dcfc7$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M16.712 4.33a9.027 9.027 0 0 1 1.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 0 0-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 0 1 0 9.424m-4.138-5.976a3.736 3.736 0 0 0-.88-1.388 3.737 3.737 0 0 0-1.388-.88m2.268 2.268a3.765 3.765 0 0 1 0 2.528m-2.268-4.796a3.765 3.765 0 0 0-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 0 1-1.388.88m2.268-2.268 4.138 3.448m0 0a9.027 9.027 0 0 1-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0-3.448-4.138m3.448 4.138a9.014 9.014 0 0 1-9.424 0m5.976-4.138a3.765 3.765 0 0 1-2.528 0m0 0a3.736 3.736 0 0 1-1.388-.88 3.737 3.737 0 0 1-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 0 1-1.652-1.306 9.027 9.027 0 0 1-1.306-1.652m0 0 4.138-3.448M4.33 16.712a9.014 9.014 0 0 1 0-9.424m4.138 5.976a3.765 3.765 0 0 1 0-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 0 1 1.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 0 0-1.652 1.306A9.025 9.025 0 0 0 4.33 7.288"
        })
    ]);
};

});

parcelRegister("cXNKH", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $9701967463944d1b$require$_createElementVNode = $TusQn.createElementVNode;
var $9701967463944d1b$require$_openBlock = $TusQn.openBlock;
var $9701967463944d1b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $9701967463944d1b$require$_openBlock(), $9701967463944d1b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $9701967463944d1b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"
        })
    ]);
};

});

parcelRegister("6kxvn", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $49be99b851283509$require$_createElementVNode = $TusQn.createElementVNode;
var $49be99b851283509$require$_openBlock = $TusQn.openBlock;
var $49be99b851283509$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $49be99b851283509$require$_openBlock(), $49be99b851283509$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $49be99b851283509$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"
        })
    ]);
};

});

parcelRegister("b3YRg", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $80df2ea89dcf9a8d$require$_createElementVNode = $TusQn.createElementVNode;
var $80df2ea89dcf9a8d$require$_openBlock = $TusQn.openBlock;
var $80df2ea89dcf9a8d$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $80df2ea89dcf9a8d$require$_openBlock(), $80df2ea89dcf9a8d$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $80df2ea89dcf9a8d$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
        })
    ]);
};

});

parcelRegister("dKo2r", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $a02237c8fd657359$require$_createElementVNode = $TusQn.createElementVNode;
var $a02237c8fd657359$require$_openBlock = $TusQn.openBlock;
var $a02237c8fd657359$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $a02237c8fd657359$require$_openBlock(), $a02237c8fd657359$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $a02237c8fd657359$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
        })
    ]);
};

});

parcelRegister("a4d0U", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $75445f56fb008e1a$require$_createElementVNode = $TusQn.createElementVNode;
var $75445f56fb008e1a$require$_openBlock = $TusQn.openBlock;
var $75445f56fb008e1a$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $75445f56fb008e1a$require$_openBlock(), $75445f56fb008e1a$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $75445f56fb008e1a$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M13.5 10.5V6.75a4.5 4.5 0 1 1 9 0v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
        })
    ]);
};

});

parcelRegister("v8kjQ", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $05d95ae13b4ce1ae$require$_createElementVNode = $TusQn.createElementVNode;
var $05d95ae13b4ce1ae$require$_openBlock = $TusQn.openBlock;
var $05d95ae13b4ce1ae$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $05d95ae13b4ce1ae$require$_openBlock(), $05d95ae13b4ce1ae$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $05d95ae13b4ce1ae$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m15.75 15.75-2.489-2.489m0 0a3.375 3.375 0 1 0-4.773-4.773 3.375 3.375 0 0 0 4.774 4.774ZM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("ePaLw", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $acae2de4a2efce4e$require$_createElementVNode = $TusQn.createElementVNode;
var $acae2de4a2efce4e$require$_openBlock = $TusQn.openBlock;
var $acae2de4a2efce4e$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $acae2de4a2efce4e$require$_openBlock(), $acae2de4a2efce4e$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $acae2de4a2efce4e$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM13.5 10.5h-6"
        })
    ]);
};

});

parcelRegister("fkrcE", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b28dd33a66245450$require$_createElementVNode = $TusQn.createElementVNode;
var $b28dd33a66245450$require$_openBlock = $TusQn.openBlock;
var $b28dd33a66245450$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b28dd33a66245450$require$_openBlock(), $b28dd33a66245450$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b28dd33a66245450$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM10.5 7.5v6m3-3h-6"
        })
    ]);
};

});

parcelRegister("cwAo8", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $91e4b322f48f2bfc$require$_createElementVNode = $TusQn.createElementVNode;
var $91e4b322f48f2bfc$require$_openBlock = $TusQn.openBlock;
var $91e4b322f48f2bfc$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $91e4b322f48f2bfc$require$_openBlock(), $91e4b322f48f2bfc$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $91e4b322f48f2bfc$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
        })
    ]);
};

});

parcelRegister("7lnZ6", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $558d196693ac1e41$require$_createElementVNode = $TusQn.createElementVNode;
var $558d196693ac1e41$require$_openBlock = $TusQn.openBlock;
var $558d196693ac1e41$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $558d196693ac1e41$require$_openBlock(), $558d196693ac1e41$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $558d196693ac1e41$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        }),
        $558d196693ac1e41$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
        })
    ]);
};

});

parcelRegister("i53WX", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d29bc1fc3901e1fe$require$_createElementVNode = $TusQn.createElementVNode;
var $d29bc1fc3901e1fe$require$_openBlock = $TusQn.openBlock;
var $d29bc1fc3901e1fe$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $d29bc1fc3901e1fe$require$_openBlock(), $d29bc1fc3901e1fe$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d29bc1fc3901e1fe$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z"
        })
    ]);
};

});

parcelRegister("42Zg1", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $2f26ddcb1eb10c60$require$_createElementVNode = $TusQn.createElementVNode;
var $2f26ddcb1eb10c60$require$_openBlock = $TusQn.openBlock;
var $2f26ddcb1eb10c60$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $2f26ddcb1eb10c60$require$_openBlock(), $2f26ddcb1eb10c60$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $2f26ddcb1eb10c60$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46"
        })
    ]);
};

});

parcelRegister("4QGKE", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $387d2e4e3c41dd55$require$_createElementVNode = $TusQn.createElementVNode;
var $387d2e4e3c41dd55$require$_openBlock = $TusQn.openBlock;
var $387d2e4e3c41dd55$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $387d2e4e3c41dd55$require$_openBlock(), $387d2e4e3c41dd55$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $387d2e4e3c41dd55$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z"
        })
    ]);
};

});

parcelRegister("hjiaP", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $c9a24eea13781d48$require$_createElementVNode = $TusQn.createElementVNode;
var $c9a24eea13781d48$require$_openBlock = $TusQn.openBlock;
var $c9a24eea13781d48$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $c9a24eea13781d48$require$_openBlock(), $c9a24eea13781d48$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $c9a24eea13781d48$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("dX80P", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $a287002537f85695$require$_createElementVNode = $TusQn.createElementVNode;
var $a287002537f85695$require$_openBlock = $TusQn.openBlock;
var $a287002537f85695$require$_createElementBlock = $TusQn.createElementBlock;
/** @deprecated */ module.exports = function render(_ctx, _cache) {
    return $a287002537f85695$require$_openBlock(), $a287002537f85695$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $a287002537f85695$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M18 12H6"
        })
    ]);
};

});

parcelRegister("hVPjd", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d0df8f70a6613073$require$_createElementVNode = $TusQn.createElementVNode;
var $d0df8f70a6613073$require$_openBlock = $TusQn.openBlock;
var $d0df8f70a6613073$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $d0df8f70a6613073$require$_openBlock(), $d0df8f70a6613073$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d0df8f70a6613073$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M5 12h14"
        })
    ]);
};

});

parcelRegister("hB97W", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $ccfcf8cdecc39d20$require$_createElementVNode = $TusQn.createElementVNode;
var $ccfcf8cdecc39d20$require$_openBlock = $TusQn.openBlock;
var $ccfcf8cdecc39d20$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $ccfcf8cdecc39d20$require$_openBlock(), $ccfcf8cdecc39d20$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $ccfcf8cdecc39d20$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"
        })
    ]);
};

});

parcelRegister("4PlKI", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $383ccc6dccfffa5d$require$_createElementVNode = $TusQn.createElementVNode;
var $383ccc6dccfffa5d$require$_openBlock = $TusQn.openBlock;
var $383ccc6dccfffa5d$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $383ccc6dccfffa5d$require$_openBlock(), $383ccc6dccfffa5d$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $383ccc6dccfffa5d$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m9 9 10.5-3m0 6.553v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 1 1-.99-3.467l2.31-.66a2.25 2.25 0 0 0 1.632-2.163Zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 0 1-.99-3.467l2.31-.66A2.25 2.25 0 0 0 9 15.553Z"
        })
    ]);
};

});

parcelRegister("2Ooeh", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $20c30bb8543380df$require$_createElementVNode = $TusQn.createElementVNode;
var $20c30bb8543380df$require$_openBlock = $TusQn.openBlock;
var $20c30bb8543380df$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $20c30bb8543380df$require$_openBlock(), $20c30bb8543380df$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $20c30bb8543380df$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z"
        })
    ]);
};

});

parcelRegister("93cEq", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $696e351c98770234$require$_createElementVNode = $TusQn.createElementVNode;
var $696e351c98770234$require$_openBlock = $TusQn.openBlock;
var $696e351c98770234$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $696e351c98770234$require$_openBlock(), $696e351c98770234$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $696e351c98770234$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636"
        })
    ]);
};

});

parcelRegister("60DEn", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $46017fe1a4cbca53$require$_createElementVNode = $TusQn.createElementVNode;
var $46017fe1a4cbca53$require$_openBlock = $TusQn.openBlock;
var $46017fe1a4cbca53$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $46017fe1a4cbca53$require$_openBlock(), $46017fe1a4cbca53$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $46017fe1a4cbca53$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9.53 16.122a3 3 0 0 0-5.78 1.128 2.25 2.25 0 0 1-2.4 2.245 4.5 4.5 0 0 0 8.4-2.245c0-.399-.078-.78-.22-1.128Zm0 0a15.998 15.998 0 0 0 3.388-1.62m-5.043-.025a15.994 15.994 0 0 1 1.622-3.395m3.42 3.42a15.995 15.995 0 0 0 4.764-4.648l3.876-5.814a1.151 1.151 0 0 0-1.597-1.597L14.146 6.32a15.996 15.996 0 0 0-4.649 4.763m3.42 3.42a6.776 6.776 0 0 0-3.42-3.42"
        })
    ]);
};

});

parcelRegister("i2Djj", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d226e82ad5dbad5c$require$_createElementVNode = $TusQn.createElementVNode;
var $d226e82ad5dbad5c$require$_openBlock = $TusQn.openBlock;
var $d226e82ad5dbad5c$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $d226e82ad5dbad5c$require$_openBlock(), $d226e82ad5dbad5c$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d226e82ad5dbad5c$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
        })
    ]);
};

});

parcelRegister("39fEW", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $24ae5bfa47ff6870$require$_createElementVNode = $TusQn.createElementVNode;
var $24ae5bfa47ff6870$require$_openBlock = $TusQn.openBlock;
var $24ae5bfa47ff6870$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $24ae5bfa47ff6870$require$_openBlock(), $24ae5bfa47ff6870$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $24ae5bfa47ff6870$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13"
        })
    ]);
};

});

parcelRegister("bdwjs", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $82a9f944e06297f7$require$_createElementVNode = $TusQn.createElementVNode;
var $82a9f944e06297f7$require$_openBlock = $TusQn.openBlock;
var $82a9f944e06297f7$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $82a9f944e06297f7$require$_openBlock(), $82a9f944e06297f7$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $82a9f944e06297f7$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M14.25 9v6m-4.5 0V9M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("kE3KW", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $f07a74f9c27b733e$require$_createElementVNode = $TusQn.createElementVNode;
var $f07a74f9c27b733e$require$_openBlock = $TusQn.openBlock;
var $f07a74f9c27b733e$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $f07a74f9c27b733e$require$_openBlock(), $f07a74f9c27b733e$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $f07a74f9c27b733e$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 5.25v13.5m-7.5-13.5v13.5"
        })
    ]);
};

});

parcelRegister("eUNHZ", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $adbcdab5f61a1350$require$_createElementVNode = $TusQn.createElementVNode;
var $adbcdab5f61a1350$require$_openBlock = $TusQn.openBlock;
var $adbcdab5f61a1350$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $adbcdab5f61a1350$require$_openBlock(), $adbcdab5f61a1350$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $adbcdab5f61a1350$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
        })
    ]);
};

});

parcelRegister("12IX5", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0c28d8dcaedb880b$require$_createElementVNode = $TusQn.createElementVNode;
var $0c28d8dcaedb880b$require$_openBlock = $TusQn.openBlock;
var $0c28d8dcaedb880b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0c28d8dcaedb880b$require$_openBlock(), $0c28d8dcaedb880b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0c28d8dcaedb880b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
        })
    ]);
};

});

parcelRegister("1T3Xc", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $15fdfea518c409eb$require$_createElementVNode = $TusQn.createElementVNode;
var $15fdfea518c409eb$require$_openBlock = $TusQn.openBlock;
var $15fdfea518c409eb$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $15fdfea518c409eb$require$_openBlock(), $15fdfea518c409eb$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $15fdfea518c409eb$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M14.25 9.75v-4.5m0 4.5h4.5m-4.5 0 6-6m-3 18c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z"
        })
    ]);
};

});

parcelRegister("87Iek", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $5ea149611471e893$require$_createElementVNode = $TusQn.createElementVNode;
var $5ea149611471e893$require$_openBlock = $TusQn.openBlock;
var $5ea149611471e893$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $5ea149611471e893$require$_openBlock(), $5ea149611471e893$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $5ea149611471e893$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M20.25 3.75v4.5m0-4.5h-4.5m4.5 0-6 6m3 12c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z"
        })
    ]);
};

});

parcelRegister("fFzem", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b686036a0c511d8f$require$_createElementVNode = $TusQn.createElementVNode;
var $b686036a0c511d8f$require$_openBlock = $TusQn.openBlock;
var $b686036a0c511d8f$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b686036a0c511d8f$require$_openBlock(), $b686036a0c511d8f$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b686036a0c511d8f$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 3.75 18 6m0 0 2.25 2.25M18 6l2.25-2.25M18 6l-2.25 2.25m1.5 13.5c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z"
        })
    ]);
};

});

parcelRegister("fMheQ", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b7c8b5ecff23de80$require$_createElementVNode = $TusQn.createElementVNode;
var $b7c8b5ecff23de80$require$_openBlock = $TusQn.openBlock;
var $b7c8b5ecff23de80$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b7c8b5ecff23de80$require$_openBlock(), $b7c8b5ecff23de80$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b7c8b5ecff23de80$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
        })
    ]);
};

});

parcelRegister("g1rsd", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $baa209255e33cd5f$require$_createElementVNode = $TusQn.createElementVNode;
var $baa209255e33cd5f$require$_openBlock = $TusQn.openBlock;
var $baa209255e33cd5f$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $baa209255e33cd5f$require$_openBlock(), $baa209255e33cd5f$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $baa209255e33cd5f$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
        })
    ]);
};

});

parcelRegister("9fU86", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $6bd10df9e4e73b3c$require$_createElementVNode = $TusQn.createElementVNode;
var $6bd10df9e4e73b3c$require$_openBlock = $TusQn.openBlock;
var $6bd10df9e4e73b3c$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $6bd10df9e4e73b3c$require$_openBlock(), $6bd10df9e4e73b3c$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $6bd10df9e4e73b3c$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        }),
        $6bd10df9e4e73b3c$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z"
        })
    ]);
};

});

parcelRegister("kz2U2", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $ef8953f8754f76e8$require$_createElementVNode = $TusQn.createElementVNode;
var $ef8953f8754f76e8$require$_openBlock = $TusQn.openBlock;
var $ef8953f8754f76e8$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $ef8953f8754f76e8$require$_openBlock(), $ef8953f8754f76e8$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $ef8953f8754f76e8$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21 7.5V18M15 7.5V18M3 16.811V8.69c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061A1.125 1.125 0 0 1 3 16.811Z"
        })
    ]);
};

});

parcelRegister("1xGrE", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $11f9cc2f74f0a1da$require$_createElementVNode = $TusQn.createElementVNode;
var $11f9cc2f74f0a1da$require$_openBlock = $TusQn.openBlock;
var $11f9cc2f74f0a1da$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $11f9cc2f74f0a1da$require$_openBlock(), $11f9cc2f74f0a1da$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $11f9cc2f74f0a1da$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z"
        })
    ]);
};

});

parcelRegister("l36yp", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $f52ef647bff375e0$require$_createElementVNode = $TusQn.createElementVNode;
var $f52ef647bff375e0$require$_openBlock = $TusQn.openBlock;
var $f52ef647bff375e0$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $f52ef647bff375e0$require$_openBlock(), $f52ef647bff375e0$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $f52ef647bff375e0$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("9ZpTm", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $745de521a2eb99b8$require$_createElementVNode = $TusQn.createElementVNode;
var $745de521a2eb99b8$require$_openBlock = $TusQn.openBlock;
var $745de521a2eb99b8$require$_createElementBlock = $TusQn.createElementBlock;
/** @deprecated */ module.exports = function render(_ctx, _cache) {
    return $745de521a2eb99b8$require$_openBlock(), $745de521a2eb99b8$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $745de521a2eb99b8$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 6v12m6-6H6"
        })
    ]);
};

});

parcelRegister("5JctM", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $42bad5db83764b5b$require$_createElementVNode = $TusQn.createElementVNode;
var $42bad5db83764b5b$require$_openBlock = $TusQn.openBlock;
var $42bad5db83764b5b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $42bad5db83764b5b$require$_openBlock(), $42bad5db83764b5b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $42bad5db83764b5b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 4.5v15m7.5-7.5h-15"
        })
    ]);
};

});

parcelRegister("bnExM", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $84914adc5450d2d0$require$_createElementVNode = $TusQn.createElementVNode;
var $84914adc5450d2d0$require$_openBlock = $TusQn.openBlock;
var $84914adc5450d2d0$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $84914adc5450d2d0$require$_openBlock(), $84914adc5450d2d0$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $84914adc5450d2d0$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M5.636 5.636a9 9 0 1 0 12.728 0M12 3v9"
        })
    ]);
};

});

parcelRegister("ayYWi", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $7b0c59a0d3d301c6$require$_createElementVNode = $TusQn.createElementVNode;
var $7b0c59a0d3d301c6$require$_openBlock = $TusQn.openBlock;
var $7b0c59a0d3d301c6$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $7b0c59a0d3d301c6$require$_openBlock(), $7b0c59a0d3d301c6$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $7b0c59a0d3d301c6$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6"
        })
    ]);
};

});

parcelRegister("aVHzo", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $7f5106537d008d26$require$_createElementVNode = $TusQn.createElementVNode;
var $7f5106537d008d26$require$_openBlock = $TusQn.openBlock;
var $7f5106537d008d26$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $7f5106537d008d26$require$_openBlock(), $7f5106537d008d26$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $7f5106537d008d26$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605"
        })
    ]);
};

});

parcelRegister("hOrGh", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $cf7c9409f3ae63a0$require$_createElementVNode = $TusQn.createElementVNode;
var $cf7c9409f3ae63a0$require$_openBlock = $TusQn.openBlock;
var $cf7c9409f3ae63a0$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $cf7c9409f3ae63a0$require$_openBlock(), $cf7c9409f3ae63a0$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $cf7c9409f3ae63a0$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z"
        })
    ]);
};

});

parcelRegister("a3UdX", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $7535cc22074969b9$require$_createElementVNode = $TusQn.createElementVNode;
var $7535cc22074969b9$require$_openBlock = $TusQn.openBlock;
var $7535cc22074969b9$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $7535cc22074969b9$require$_openBlock(), $7535cc22074969b9$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $7535cc22074969b9$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 0 1-.657.643 48.39 48.39 0 0 1-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 0 1-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 0 0-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 0 1-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 0 0 .657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 0 0 5.427-.63 48.05 48.05 0 0 0 .582-4.717.532.532 0 0 0-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 0 0 .658-.663 48.422 48.422 0 0 0-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 0 1-.61-.58v0Z"
        })
    ]);
};

});

parcelRegister("hILM1", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $ce6b9a8c19ef54ce$require$_createElementVNode = $TusQn.createElementVNode;
var $ce6b9a8c19ef54ce$require$_openBlock = $TusQn.openBlock;
var $ce6b9a8c19ef54ce$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $ce6b9a8c19ef54ce$require$_openBlock(), $ce6b9a8c19ef54ce$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $ce6b9a8c19ef54ce$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z"
        }),
        $ce6b9a8c19ef54ce$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z"
        })
    ]);
};

});

parcelRegister("bcyUb", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $827be41daf984b16$require$_createElementVNode = $TusQn.createElementVNode;
var $827be41daf984b16$require$_openBlock = $TusQn.openBlock;
var $827be41daf984b16$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $827be41daf984b16$require$_openBlock(), $827be41daf984b16$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $827be41daf984b16$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
        })
    ]);
};

});

parcelRegister("f0mwz", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $aec853fac88ad5e7$require$_createElementVNode = $TusQn.createElementVNode;
var $aec853fac88ad5e7$require$_openBlock = $TusQn.openBlock;
var $aec853fac88ad5e7$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $aec853fac88ad5e7$require$_openBlock(), $aec853fac88ad5e7$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $aec853fac88ad5e7$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 0 1 0 3.75H5.625a1.875 1.875 0 0 1 0-3.75Z"
        })
    ]);
};

});

parcelRegister("fJfiU", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b736ee0934d200ae$require$_createElementVNode = $TusQn.createElementVNode;
var $b736ee0934d200ae$require$_openBlock = $TusQn.openBlock;
var $b736ee0934d200ae$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b736ee0934d200ae$require$_openBlock(), $b736ee0934d200ae$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b736ee0934d200ae$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m3.75 7.5 16.5-4.125M12 6.75c-2.708 0-5.363.224-7.948.655C2.999 7.58 2.25 8.507 2.25 9.574v9.176A2.25 2.25 0 0 0 4.5 21h15a2.25 2.25 0 0 0 2.25-2.25V9.574c0-1.067-.75-1.994-1.802-2.169A48.329 48.329 0 0 0 12 6.75Zm-1.683 6.443-.005.005-.006-.005.006-.005.005.005Zm-.005 2.127-.005-.006.005-.005.005.005-.005.005Zm-2.116-.006-.005.006-.006-.006.005-.005.006.005Zm-.005-2.116-.006-.005.006-.005.005.005-.005.005ZM9.255 10.5v.008h-.008V10.5h.008Zm3.249 1.88-.007.004-.003-.007.006-.003.004.006Zm-1.38 5.126-.003-.006.006-.004.004.007-.006.003Zm.007-6.501-.003.006-.007-.003.004-.007.006.004Zm1.37 5.129-.007-.004.004-.006.006.003-.004.007Zm.504-1.877h-.008v-.007h.008v.007ZM9.255 18v.008h-.008V18h.008Zm-3.246-1.87-.007.004L6 16.127l.006-.003.004.006Zm1.366-5.119-.004-.006.006-.004.004.007-.006.003ZM7.38 17.5l-.003.006-.007-.003.004-.007.006.004Zm-1.376-5.116L6 12.38l.003-.007.007.004-.004.007Zm-.5 1.873h-.008v-.007h.008v.007ZM17.25 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm0 4.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
        })
    ]);
};

});

parcelRegister("5Ttos", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $44a8e3bf80d01b06$require$_createElementVNode = $TusQn.createElementVNode;
var $44a8e3bf80d01b06$require$_openBlock = $TusQn.openBlock;
var $44a8e3bf80d01b06$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $44a8e3bf80d01b06$require$_openBlock(), $44a8e3bf80d01b06$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $44a8e3bf80d01b06$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m9 14.25 6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185ZM9.75 9h.008v.008H9.75V9Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008V13.5Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
        })
    ]);
};

});

parcelRegister("gvbky", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $c0385493820ac2f0$require$_createElementVNode = $TusQn.createElementVNode;
var $c0385493820ac2f0$require$_openBlock = $TusQn.openBlock;
var $c0385493820ac2f0$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $c0385493820ac2f0$require$_openBlock(), $c0385493820ac2f0$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $c0385493820ac2f0$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.25 9.75h4.875a2.625 2.625 0 0 1 0 5.25H12M8.25 9.75 10.5 7.5M8.25 9.75 10.5 12m9-7.243V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185Z"
        })
    ]);
};

});

parcelRegister("fCBe7", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b5f74811c11c113b$require$_createElementVNode = $TusQn.createElementVNode;
var $b5f74811c11c113b$require$_openBlock = $TusQn.openBlock;
var $b5f74811c11c113b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b5f74811c11c113b$require$_openBlock(), $b5f74811c11c113b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b5f74811c11c113b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z"
        })
    ]);
};

});

parcelRegister("bszUX", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $857e2bc2369ed81e$require$_createElementVNode = $TusQn.createElementVNode;
var $857e2bc2369ed81e$require$_openBlock = $TusQn.openBlock;
var $857e2bc2369ed81e$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $857e2bc2369ed81e$require$_openBlock(), $857e2bc2369ed81e$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $857e2bc2369ed81e$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6 6.878V6a2.25 2.25 0 0 1 2.25-2.25h7.5A2.25 2.25 0 0 1 18 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 0 0 4.5 9v.878m13.5-3A2.25 2.25 0 0 1 19.5 9v.878m0 0a2.246 2.246 0 0 0-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0 1 21 12v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6c0-.98.626-1.813 1.5-2.122"
        })
    ]);
};

});

parcelRegister("8wZQw", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $63614938736688d2$require$_createElementVNode = $TusQn.createElementVNode;
var $63614938736688d2$require$_openBlock = $TusQn.openBlock;
var $63614938736688d2$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $63614938736688d2$require$_openBlock(), $63614938736688d2$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $63614938736688d2$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
        })
    ]);
};

});

parcelRegister("gwJ93", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $c082a760d7c8aa74$require$_createElementVNode = $TusQn.createElementVNode;
var $c082a760d7c8aa74$require$_openBlock = $TusQn.openBlock;
var $c082a760d7c8aa74$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $c082a760d7c8aa74$require$_openBlock(), $c082a760d7c8aa74$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $c082a760d7c8aa74$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12.75 19.5v-.75a7.5 7.5 0 0 0-7.5-7.5H4.5m0-6.75h.75c7.87 0 14.25 6.38 14.25 14.25v.75M6 18.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
        })
    ]);
};

});

parcelRegister("3eTkp", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $25bd98f19d345534$require$_createElementVNode = $TusQn.createElementVNode;
var $25bd98f19d345534$require$_openBlock = $TusQn.openBlock;
var $25bd98f19d345534$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $25bd98f19d345534$require$_openBlock(), $25bd98f19d345534$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $25bd98f19d345534$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 0 1-2.031.352 5.989 5.989 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z"
        })
    ]);
};

});

parcelRegister("SOs1d", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0a4c2dc2cd32ddb1$require$_createElementVNode = $TusQn.createElementVNode;
var $0a4c2dc2cd32ddb1$require$_openBlock = $TusQn.openBlock;
var $0a4c2dc2cd32ddb1$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0a4c2dc2cd32ddb1$require$_openBlock(), $0a4c2dc2cd32ddb1$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0a4c2dc2cd32ddb1$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m7.848 8.25 1.536.887M7.848 8.25a3 3 0 1 1-5.196-3 3 3 0 0 1 5.196 3Zm1.536.887a2.165 2.165 0 0 1 1.083 1.839c.005.351.054.695.14 1.024M9.384 9.137l2.077 1.199M7.848 15.75l1.536-.887m-1.536.887a3 3 0 1 1-5.196 3 3 3 0 0 1 5.196-3Zm1.536-.887a2.165 2.165 0 0 0 1.083-1.838c.005-.352.054-.695.14-1.025m-1.223 2.863 2.077-1.199m0-3.328a4.323 4.323 0 0 1 2.068-1.379l5.325-1.628a4.5 4.5 0 0 1 2.48-.044l.803.215-7.794 4.5m-2.882-1.664A4.33 4.33 0 0 0 10.607 12m3.736 0 7.794 4.5-.802.215a4.5 4.5 0 0 1-2.48-.043l-5.326-1.629a4.324 4.324 0 0 1-2.068-1.379M14.343 12l-2.882 1.664"
        })
    ]);
};

});

parcelRegister("eQdbf", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $ace0255db7a521ac$require$_createElementVNode = $TusQn.createElementVNode;
var $ace0255db7a521ac$require$_openBlock = $TusQn.openBlock;
var $ace0255db7a521ac$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $ace0255db7a521ac$require$_openBlock(), $ace0255db7a521ac$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $ace0255db7a521ac$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M5.25 14.25h13.5m-13.5 0a3 3 0 0 1-3-3m3 3a3 3 0 1 0 0 6h13.5a3 3 0 1 0 0-6m-16.5-3a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3m-19.5 0a4.5 4.5 0 0 1 .9-2.7L5.737 5.1a3.375 3.375 0 0 1 2.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 0 1 .9 2.7m0 0a3 3 0 0 1-3 3m0 3h.008v.008h-.008v-.008Zm0-6h.008v.008h-.008v-.008Zm-3 6h.008v.008h-.008v-.008Zm0-6h.008v.008h-.008v-.008Z"
        })
    ]);
};

});

parcelRegister("3EUXX", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $2aa14bc601f83d4e$require$_createElementVNode = $TusQn.createElementVNode;
var $2aa14bc601f83d4e$require$_openBlock = $TusQn.openBlock;
var $2aa14bc601f83d4e$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $2aa14bc601f83d4e$require$_openBlock(), $2aa14bc601f83d4e$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $2aa14bc601f83d4e$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21.75 17.25v-.228a4.5 4.5 0 0 0-.12-1.03l-2.268-9.64a3.375 3.375 0 0 0-3.285-2.602H7.923a3.375 3.375 0 0 0-3.285 2.602l-2.268 9.64a4.5 4.5 0 0 0-.12 1.03v.228m19.5 0a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3m19.5 0a3 3 0 0 0-3-3H5.25a3 3 0 0 0-3 3m16.5 0h.008v.008h-.008v-.008Zm-3 0h.008v.008h-.008v-.008Z"
        })
    ]);
};

});

parcelRegister("3mqOs", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $272839a81cf368c3$require$_createElementVNode = $TusQn.createElementVNode;
var $272839a81cf368c3$require$_openBlock = $TusQn.openBlock;
var $272839a81cf368c3$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $272839a81cf368c3$require$_openBlock(), $272839a81cf368c3$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $272839a81cf368c3$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
        })
    ]);
};

});

parcelRegister("22PXU", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $17d413e707360769$require$_createElementVNode = $TusQn.createElementVNode;
var $17d413e707360769$require$_openBlock = $TusQn.openBlock;
var $17d413e707360769$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $17d413e707360769$require$_openBlock(), $17d413e707360769$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $17d413e707360769$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
        })
    ]);
};

});

parcelRegister("il33X", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d59c905d7c2d216c$require$_createElementVNode = $TusQn.createElementVNode;
var $d59c905d7c2d216c$require$_openBlock = $TusQn.openBlock;
var $d59c905d7c2d216c$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $d59c905d7c2d216c$require$_openBlock(), $d59c905d7c2d216c$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d59c905d7c2d216c$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 9v3.75m0-10.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.25-8.25-3.286Zm0 13.036h.008v.008H12v-.008Z"
        })
    ]);
};

});

parcelRegister("hjQzL", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $c9bcfe772de03622$require$_createElementVNode = $TusQn.createElementVNode;
var $c9bcfe772de03622$require$_openBlock = $TusQn.openBlock;
var $c9bcfe772de03622$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $c9bcfe772de03622$require$_openBlock(), $c9bcfe772de03622$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $c9bcfe772de03622$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
        })
    ]);
};

});

parcelRegister("afDxu", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $7769f9bdbe8ce0fe$require$_createElementVNode = $TusQn.createElementVNode;
var $7769f9bdbe8ce0fe$require$_openBlock = $TusQn.openBlock;
var $7769f9bdbe8ce0fe$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $7769f9bdbe8ce0fe$require$_openBlock(), $7769f9bdbe8ce0fe$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $7769f9bdbe8ce0fe$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
        })
    ]);
};

});

parcelRegister("5NNuk", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $4397eaae17944d35$require$_createElementVNode = $TusQn.createElementVNode;
var $4397eaae17944d35$require$_openBlock = $TusQn.openBlock;
var $4397eaae17944d35$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $4397eaae17944d35$require$_openBlock(), $4397eaae17944d35$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $4397eaae17944d35$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m3 3 8.735 8.735m0 0a.374.374 0 1 1 .53.53m-.53-.53.53.53m0 0L21 21M14.652 9.348a3.75 3.75 0 0 1 0 5.304m2.121-7.425a6.75 6.75 0 0 1 0 9.546m2.121-11.667c3.808 3.807 3.808 9.98 0 13.788m-9.546-4.242a3.733 3.733 0 0 1-1.06-2.122m-1.061 4.243a6.75 6.75 0 0 1-1.625-6.929m-.496 9.05c-3.068-3.067-3.664-7.67-1.79-11.334M12 12h.008v.008H12V12Z"
        })
    ]);
};

});

parcelRegister("cqnNP", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $90ba6078e12b09a3$require$_createElementVNode = $TusQn.createElementVNode;
var $90ba6078e12b09a3$require$_openBlock = $TusQn.openBlock;
var $90ba6078e12b09a3$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $90ba6078e12b09a3$require$_openBlock(), $90ba6078e12b09a3$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $90ba6078e12b09a3$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9.348 14.652a3.75 3.75 0 0 1 0-5.304m5.304 0a3.75 3.75 0 0 1 0 5.304m-7.425 2.121a6.75 6.75 0 0 1 0-9.546m9.546 0a6.75 6.75 0 0 1 0 9.546M5.106 18.894c-3.808-3.807-3.808-9.98 0-13.788m13.788 0c3.808 3.807 3.808 9.98 0 13.788M12 12h.008v.008H12V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
        })
    ]);
};

});

parcelRegister("l9mv5", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $f65be4554fd401ec$require$_createElementVNode = $TusQn.createElementVNode;
var $f65be4554fd401ec$require$_openBlock = $TusQn.openBlock;
var $f65be4554fd401ec$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $f65be4554fd401ec$require$_openBlock(), $f65be4554fd401ec$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $f65be4554fd401ec$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
        })
    ]);
};

});

parcelRegister("ipko4", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d66a604c5655d9b3$require$_createElementVNode = $TusQn.createElementVNode;
var $d66a604c5655d9b3$require$_openBlock = $TusQn.openBlock;
var $d66a604c5655d9b3$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $d66a604c5655d9b3$require$_openBlock(), $d66a604c5655d9b3$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d66a604c5655d9b3$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
        })
    ]);
};

});

parcelRegister("kwbAg", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeffc820bc5a59b3$require$_createElementVNode = $TusQn.createElementVNode;
var $eeffc820bc5a59b3$require$_openBlock = $TusQn.openBlock;
var $eeffc820bc5a59b3$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $eeffc820bc5a59b3$require$_openBlock(), $eeffc820bc5a59b3$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $eeffc820bc5a59b3$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M17.25 9.75 19.5 12m0 0 2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6 4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
        })
    ]);
};

});

parcelRegister("24ewq", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $1817383bcf0ebb5b$require$_createElementVNode = $TusQn.createElementVNode;
var $1817383bcf0ebb5b$require$_openBlock = $TusQn.openBlock;
var $1817383bcf0ebb5b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $1817383bcf0ebb5b$require$_openBlock(), $1817383bcf0ebb5b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $1817383bcf0ebb5b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M16.5 8.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v8.25A2.25 2.25 0 0 0 6 16.5h2.25m8.25-8.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-7.5A2.25 2.25 0 0 1 8.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 0 0-2.25 2.25v6"
        })
    ]);
};

});

parcelRegister("8wVdw", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $635db1fe0ea1b7fa$require$_createElementVNode = $TusQn.createElementVNode;
var $635db1fe0ea1b7fa$require$_openBlock = $TusQn.openBlock;
var $635db1fe0ea1b7fa$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $635db1fe0ea1b7fa$require$_openBlock(), $635db1fe0ea1b7fa$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $635db1fe0ea1b7fa$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6.429 9.75 2.25 12l4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0 4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0-5.571 3-5.571-3"
        })
    ]);
};

});

parcelRegister("frWNv", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b3f6fc9353714d8f$require$_createElementVNode = $TusQn.createElementVNode;
var $b3f6fc9353714d8f$require$_openBlock = $TusQn.openBlock;
var $b3f6fc9353714d8f$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b3f6fc9353714d8f$require$_openBlock(), $b3f6fc9353714d8f$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b3f6fc9353714d8f$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
        })
    ]);
};

});

parcelRegister("csZWQ", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $91382729b13ba659$require$_createElementVNode = $TusQn.createElementVNode;
var $91382729b13ba659$require$_openBlock = $TusQn.openBlock;
var $91382729b13ba659$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $91382729b13ba659$require$_openBlock(), $91382729b13ba659$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $91382729b13ba659$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v2.25A2.25 2.25 0 0 0 6 10.5Zm0 9.75h2.25A2.25 2.25 0 0 0 10.5 18v-2.25a2.25 2.25 0 0 0-2.25-2.25H6a2.25 2.25 0 0 0-2.25 2.25V18A2.25 2.25 0 0 0 6 20.25Zm9.75-9.75H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.75h-2.25A2.25 2.25 0 0 0 13.5 6v2.25a2.25 2.25 0 0 0 2.25 2.25Z"
        })
    ]);
};

});

parcelRegister("lnHlL", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $f90d5f61c0334823$require$_createElementVNode = $TusQn.createElementVNode;
var $f90d5f61c0334823$require$_openBlock = $TusQn.openBlock;
var $f90d5f61c0334823$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $f90d5f61c0334823$require$_openBlock(), $f90d5f61c0334823$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $f90d5f61c0334823$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
        })
    ]);
};

});

parcelRegister("1gvhm", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0ebf8c72d2d1f7cb$require$_createElementVNode = $TusQn.createElementVNode;
var $0ebf8c72d2d1f7cb$require$_openBlock = $TusQn.openBlock;
var $0ebf8c72d2d1f7cb$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0ebf8c72d2d1f7cb$require$_openBlock(), $0ebf8c72d2d1f7cb$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0ebf8c72d2d1f7cb$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        }),
        $0ebf8c72d2d1f7cb$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 9.563C9 9.252 9.252 9 9.563 9h4.874c.311 0 .563.252.563.563v4.874c0 .311-.252.563-.563.563H9.564A.562.562 0 0 1 9 14.437V9.564Z"
        })
    ]);
};

});

parcelRegister("eSsn4", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $ad4c1dc2187f8797$require$_createElementVNode = $TusQn.createElementVNode;
var $ad4c1dc2187f8797$require$_openBlock = $TusQn.openBlock;
var $ad4c1dc2187f8797$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $ad4c1dc2187f8797$require$_openBlock(), $ad4c1dc2187f8797$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $ad4c1dc2187f8797$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M5.25 7.5A2.25 2.25 0 0 1 7.5 5.25h9a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9Z"
        })
    ]);
};

});

parcelRegister("KeK7p", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $08afbb9d5850c054$require$_createElementVNode = $TusQn.createElementVNode;
var $08afbb9d5850c054$require$_openBlock = $TusQn.openBlock;
var $08afbb9d5850c054$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $08afbb9d5850c054$require$_openBlock(), $08afbb9d5850c054$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $08afbb9d5850c054$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
        })
    ]);
};

});

parcelRegister("g6nUc", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $bb8fc001e06a3673$require$_createElementVNode = $TusQn.createElementVNode;
var $bb8fc001e06a3673$require$_openBlock = $TusQn.openBlock;
var $bb8fc001e06a3673$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $bb8fc001e06a3673$require$_openBlock(), $bb8fc001e06a3673$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $bb8fc001e06a3673$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M4.098 19.902a3.75 3.75 0 0 0 5.304 0l6.401-6.402M6.75 21A3.75 3.75 0 0 1 3 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 0 0 3.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008Z"
        })
    ]);
};

});

parcelRegister("flR2k", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b2d1f52649dd564d$require$_createElementVNode = $TusQn.createElementVNode;
var $b2d1f52649dd564d$require$_openBlock = $TusQn.openBlock;
var $b2d1f52649dd564d$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b2d1f52649dd564d$require$_openBlock(), $b2d1f52649dd564d$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b2d1f52649dd564d$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"
        })
    ]);
};

});

parcelRegister("8OVTs", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01a841a8086444da$require$_createElementVNode = $TusQn.createElementVNode;
var $01a841a8086444da$require$_openBlock = $TusQn.openBlock;
var $01a841a8086444da$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $01a841a8086444da$require$_openBlock(), $01a841a8086444da$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $01a841a8086444da$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"
        }),
        $01a841a8086444da$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6 6h.008v.008H6V6Z"
        })
    ]);
};

});

parcelRegister("fq1lw", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b39a540560ab274a$require$_createElementVNode = $TusQn.createElementVNode;
var $b39a540560ab274a$require$_openBlock = $TusQn.openBlock;
var $b39a540560ab274a$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b39a540560ab274a$require$_openBlock(), $b39a540560ab274a$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b39a540560ab274a$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"
        })
    ]);
};

});

parcelRegister("3ZA8P", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $2e831a833fa72a0e$require$_createElementVNode = $TusQn.createElementVNode;
var $2e831a833fa72a0e$require$_openBlock = $TusQn.openBlock;
var $2e831a833fa72a0e$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $2e831a833fa72a0e$require$_openBlock(), $2e831a833fa72a0e$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $2e831a833fa72a0e$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
        })
    ]);
};

});

parcelRegister("iLsBB", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $da92ce4014aefd7b$require$_createElementVNode = $TusQn.createElementVNode;
var $da92ce4014aefd7b$require$_openBlock = $TusQn.openBlock;
var $da92ce4014aefd7b$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $da92ce4014aefd7b$require$_openBlock(), $da92ce4014aefd7b$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $da92ce4014aefd7b$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M16.5 18.75h-9m9 0a3 3 0 0 1 3 3h-15a3 3 0 0 1 3-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 0 1-.982-3.172M9.497 14.25a7.454 7.454 0 0 0 .981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 0 0 7.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 0 0 2.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 0 1 2.916.52 6.003 6.003 0 0 1-5.395 4.972m0 0a6.726 6.726 0 0 1-2.749 1.35m0 0a6.772 6.772 0 0 1-3.044 0"
        })
    ]);
};

});

parcelRegister("hW4DL", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $035ea2e6e651ab43$require$_createElementVNode = $TusQn.createElementVNode;
var $035ea2e6e651ab43$require$_openBlock = $TusQn.openBlock;
var $035ea2e6e651ab43$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $035ea2e6e651ab43$require$_openBlock(), $035ea2e6e651ab43$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $035ea2e6e651ab43$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
        })
    ]);
};

});

parcelRegister("fFJpf", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $b68de81a9e6a886c$require$_createElementVNode = $TusQn.createElementVNode;
var $b68de81a9e6a886c$require$_openBlock = $TusQn.openBlock;
var $b68de81a9e6a886c$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $b68de81a9e6a886c$require$_openBlock(), $b68de81a9e6a886c$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $b68de81a9e6a886c$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125Z"
        })
    ]);
};

});

parcelRegister("3Eubm", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $2a8c8511f35b86c1$require$_createElementVNode = $TusQn.createElementVNode;
var $2a8c8511f35b86c1$require$_openBlock = $TusQn.openBlock;
var $2a8c8511f35b86c1$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $2a8c8511f35b86c1$require$_openBlock(), $2a8c8511f35b86c1$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $2a8c8511f35b86c1$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        })
    ]);
};

});

parcelRegister("12KTX", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $0c2a5c0624fa0857$require$_createElementVNode = $TusQn.createElementVNode;
var $0c2a5c0624fa0857$require$_openBlock = $TusQn.openBlock;
var $0c2a5c0624fa0857$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $0c2a5c0624fa0857$require$_openBlock(), $0c2a5c0624fa0857$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $0c2a5c0624fa0857$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
        })
    ]);
};

});

parcelRegister("bbBGF", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $824df4a81ec25338$require$_createElementVNode = $TusQn.createElementVNode;
var $824df4a81ec25338$require$_openBlock = $TusQn.openBlock;
var $824df4a81ec25338$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $824df4a81ec25338$require$_openBlock(), $824df4a81ec25338$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $824df4a81ec25338$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M22 10.5h-6m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM4 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 10.374 21c-2.331 0-4.512-.645-6.374-1.766Z"
        })
    ]);
};

});

parcelRegister("j0fWi", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $dd5a61971ff6545a$require$_createElementVNode = $TusQn.createElementVNode;
var $dd5a61971ff6545a$require$_openBlock = $TusQn.openBlock;
var $dd5a61971ff6545a$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $dd5a61971ff6545a$require$_openBlock(), $dd5a61971ff6545a$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $dd5a61971ff6545a$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z"
        })
    ]);
};

});

parcelRegister("ijwSa", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $d553802d2a259967$require$_createElementVNode = $TusQn.createElementVNode;
var $d553802d2a259967$require$_openBlock = $TusQn.openBlock;
var $d553802d2a259967$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $d553802d2a259967$require$_openBlock(), $d553802d2a259967$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $d553802d2a259967$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
        })
    ]);
};

});

parcelRegister("chyHJ", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8f11fe2745e3436f$require$_createElementVNode = $TusQn.createElementVNode;
var $8f11fe2745e3436f$require$_openBlock = $TusQn.openBlock;
var $8f11fe2745e3436f$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $8f11fe2745e3436f$require$_openBlock(), $8f11fe2745e3436f$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $8f11fe2745e3436f$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
        })
    ]);
};

});

parcelRegister("hQOBe", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $cfee8b06d42030ae$require$_createElementVNode = $TusQn.createElementVNode;
var $cfee8b06d42030ae$require$_openBlock = $TusQn.openBlock;
var $cfee8b06d42030ae$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $cfee8b06d42030ae$require$_openBlock(), $cfee8b06d42030ae$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $cfee8b06d42030ae$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M4.745 3A23.933 23.933 0 0 0 3 12c0 3.183.62 6.22 1.745 9M19.5 3c.967 2.78 1.5 5.817 1.5 9s-.533 6.22-1.5 9M8.25 8.885l1.444-.89a.75.75 0 0 1 1.105.402l2.402 7.206a.75.75 0 0 0 1.104.401l1.445-.889m-8.25.75.213.09a1.687 1.687 0 0 0 2.062-.617l4.45-6.676a1.688 1.688 0 0 1 2.062-.618l.213.09"
        })
    ]);
};

});

parcelRegister("8LqEm", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $6617629f2b3ec761$require$_createElementVNode = $TusQn.createElementVNode;
var $6617629f2b3ec761$require$_openBlock = $TusQn.openBlock;
var $6617629f2b3ec761$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $6617629f2b3ec761$require$_openBlock(), $6617629f2b3ec761$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $6617629f2b3ec761$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 0 1-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 0 0-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409"
        })
    ]);
};

});

parcelRegister("hc4p6", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $c846f93129212469$require$_createElementVNode = $TusQn.createElementVNode;
var $c846f93129212469$require$_openBlock = $TusQn.openBlock;
var $c846f93129212469$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $c846f93129212469$require$_openBlock(), $c846f93129212469$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $c846f93129212469$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z"
        })
    ]);
};

});

parcelRegister("leM3x", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $f7602eb47c20ecf2$require$_createElementVNode = $TusQn.createElementVNode;
var $f7602eb47c20ecf2$require$_openBlock = $TusQn.openBlock;
var $f7602eb47c20ecf2$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $f7602eb47c20ecf2$require$_openBlock(), $f7602eb47c20ecf2$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $f7602eb47c20ecf2$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125Z"
        })
    ]);
};

});

parcelRegister("2mKDS", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $1b91d0fc11beacbf$require$_createElementVNode = $TusQn.createElementVNode;
var $1b91d0fc11beacbf$require$_openBlock = $TusQn.openBlock;
var $1b91d0fc11beacbf$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $1b91d0fc11beacbf$require$_openBlock(), $1b91d0fc11beacbf$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $1b91d0fc11beacbf$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M7.5 3.75H6A2.25 2.25 0 0 0 3.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0 1 20.25 6v1.5m0 9V18A2.25 2.25 0 0 1 18 20.25h-1.5m-9 0H6A2.25 2.25 0 0 1 3.75 18v-1.5M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        })
    ]);
};

});

parcelRegister("jU0Jh", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $e7d3d0227d770373$require$_createElementVNode = $TusQn.createElementVNode;
var $e7d3d0227d770373$require$_openBlock = $TusQn.openBlock;
var $e7d3d0227d770373$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $e7d3d0227d770373$require$_openBlock(), $e7d3d0227d770373$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $e7d3d0227d770373$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3"
        })
    ]);
};

});

parcelRegister("dwnyJ", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $9d8089e2a824cc27$require$_createElementVNode = $TusQn.createElementVNode;
var $9d8089e2a824cc27$require$_openBlock = $TusQn.openBlock;
var $9d8089e2a824cc27$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $9d8089e2a824cc27$require$_openBlock(), $9d8089e2a824cc27$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $9d8089e2a824cc27$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M8.288 15.038a5.25 5.25 0 0 1 7.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 0 1 1.06 0Z"
        })
    ]);
};

});

parcelRegister("4vysw", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $3484c989406574f8$require$_createElementVNode = $TusQn.createElementVNode;
var $3484c989406574f8$require$_openBlock = $TusQn.openBlock;
var $3484c989406574f8$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $3484c989406574f8$require$_openBlock(), $3484c989406574f8$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $3484c989406574f8$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M3 8.25V18a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 21 18V8.25m-18 0V6a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6ZM7.5 6h.008v.008H7.5V6Zm2.25 0h.008v.008H9.75V6Z"
        })
    ]);
};

});

parcelRegister("eCMfX", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $aa5a0c05d0a62282$require$_createElementVNode = $TusQn.createElementVNode;
var $aa5a0c05d0a62282$require$_openBlock = $TusQn.openBlock;
var $aa5a0c05d0a62282$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $aa5a0c05d0a62282$require$_openBlock(), $aa5a0c05d0a62282$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $aa5a0c05d0a62282$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z"
        })
    ]);
};

});

parcelRegister("wUDHn", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $062eeca8b798f035$require$_createElementVNode = $TusQn.createElementVNode;
var $062eeca8b798f035$require$_openBlock = $TusQn.openBlock;
var $062eeca8b798f035$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $062eeca8b798f035$require$_openBlock(), $062eeca8b798f035$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $062eeca8b798f035$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21.75 6.75a4.5 4.5 0 0 1-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 1 1-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 0 1 6.336-4.486l-3.276 3.276a3.004 3.004 0 0 0 2.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852Z"
        }),
        $062eeca8b798f035$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M4.867 19.125h.008v.008h-.008v-.008Z"
        })
    ]);
};

});

parcelRegister("1rh9S", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $10c59f5bfb0f73b3$require$_createElementVNode = $TusQn.createElementVNode;
var $10c59f5bfb0f73b3$require$_openBlock = $TusQn.openBlock;
var $10c59f5bfb0f73b3$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $10c59f5bfb0f73b3$require$_openBlock(), $10c59f5bfb0f73b3$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $10c59f5bfb0f73b3$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
};

});

parcelRegister("gAIQB", function(module, exports) {
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $c142cbe92e1a2059$require$_createElementVNode = $TusQn.createElementVNode;
var $c142cbe92e1a2059$require$_openBlock = $TusQn.openBlock;
var $c142cbe92e1a2059$require$_createElementBlock = $TusQn.createElementBlock;
module.exports = function render(_ctx, _cache) {
    return $c142cbe92e1a2059$require$_openBlock(), $c142cbe92e1a2059$require$_createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        $c142cbe92e1a2059$require$_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M6 18 18 6M6 6l12 12"
        })
    ]);
};

});


parcelRegister("csTml", function(module, exports) {

$parcel$export(module.exports, "default", () => $91330ac21ab7206c$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");

var $6ZOtW = parcelRequire("6ZOtW");

var $6CeEP = parcelRequire("6CeEP");
/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq(2, 'a'))(xs); //=> {a: 2}
 *      R.find(R.propEq(4, 'a'))(xs); //=> undefined
 */ var $91330ac21ab7206c$var$find = /*#__PURE__*/ (0, $2jcOR.default)(/*#__PURE__*/ (0, $6ZOtW.default)([
    "find"
], (0, $6CeEP.default), function find(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return list[idx];
        idx += 1;
    }
}));
var $91330ac21ab7206c$export$2e2bcd8739ae039 = $91330ac21ab7206c$var$find;

});
parcelRegister("6CeEP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d11a95ca32445c4$export$2e2bcd8739ae039);

var $j2oQ7 = parcelRequire("j2oQ7");

var $eR2XP = parcelRequire("eR2XP");
var $4d11a95ca32445c4$var$XFind = /*#__PURE__*/ function() {
    function XFind(f, xf) {
        this.xf = xf;
        this.f = f;
        this.found = false;
    }
    XFind.prototype["@@transducer/init"] = (0, $eR2XP.default).init;
    XFind.prototype["@@transducer/result"] = function(result) {
        if (!this.found) result = this.xf["@@transducer/step"](result, void 0);
        return this.xf["@@transducer/result"](result);
    };
    XFind.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) {
            this.found = true;
            result = (0, $j2oQ7.default)(this.xf["@@transducer/step"](result, input));
        }
        return result;
    };
    return XFind;
}();
function $4d11a95ca32445c4$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $4d11a95ca32445c4$var$XFind(f, xf);
    };
}

});
parcelRegister("j2oQ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc178dcc7c7ccc5$export$2e2bcd8739ae039);
function $ddc178dcc7c7ccc5$export$2e2bcd8739ae039(x) {
    return x && x["@@transducer/reduced"] ? x : {
        "@@transducer/value": x,
        "@@transducer/reduced": true
    };
}

});



parcelRegister("3dsFz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2578d32c8062a72f$export$2e2bcd8739ae039);
let $2578d32c8062a72f$var$script;



let $2578d32c8062a72f$var$initialize = ()=>{
    $2578d32c8062a72f$var$script = (parcelRequire("aTbMU"));
    if ($2578d32c8062a72f$var$script.__esModule) $2578d32c8062a72f$var$script = $2578d32c8062a72f$var$script.default;
    $2578d32c8062a72f$var$script.render = (parcelRequire("diL5w")).render;
    (parcelRequire("bhwVi")).default($2578d32c8062a72f$var$script);
    $2578d32c8062a72f$var$script.__scopeId = "data-v-6e778d";
    $2578d32c8062a72f$var$script.__file = "RedeemKeyComponent.vue";
};
$2578d32c8062a72f$var$initialize();
var $2578d32c8062a72f$export$2e2bcd8739ae039 = $2578d32c8062a72f$var$script;

});
parcelRegister("aTbMU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7ed82f4132804bc8$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $hEJWZ = parcelRequire("hEJWZ");

var $fRZwI = parcelRequire("fRZwI");

var $jFUWD = parcelRequire("jFUWD");

var $kheUU = parcelRequire("kheUU");

var $ilDn7 = parcelRequire("ilDn7");

var $1F5z6 = parcelRequire("1F5z6");

var $dHodW = parcelRequire("dHodW");

var $kW7Vr = parcelRequire("kW7Vr");
var $7ed82f4132804bc8$export$2e2bcd8739ae039 = {
    __name: "RedeemKeyComponent",
    props: {
        "modelValue": {},
        "modelModifiers": {}
    },
    emits: [
        "update:modelValue"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const discountModel = (0, $TusQn.useModel)(__props, "modelValue");
        const { t: t } = (0, $jFUWD.useI18n)();
        const validationSchema = (0, $01W3b.markRaw)((0, $hEJWZ.object)({
            discountCode: (0, $hEJWZ.string)().required().label("")
        }));
        const { defineField: defineField, handleSubmit: handleSubmit } = (0, $fRZwI.useForm)({
            validationSchema: validationSchema
        });
        const [discountCode, discountCodeAttrs] = defineField("discountCode");
        const userMessage = (0, $01W3b.ref)("");
        const { fetch: fetch, response: response, isLoading: isVerifyingKey, userFriendlyError: userFriendlyError } = (0, $dHodW.default)();
        const doSubmitCode = handleSubmit(async (values)=>{
            await fetch(values.discountCode);
            discountModel.value = {
                key: response.value.key,
                type: response.value.type,
                discount: response.value.discount,
                extraSeats: response.value.extraSeats
            };
            if ((0, $kheUU.default)(userFriendlyError.value)) userMessage.value = "";
            else {
                discountModel.value = {};
                userMessage.value = t("registerView.billing.invalidKey");
            }
        });
        const clearDiscount = ()=>{
            discountModel.value = {};
            discountCode.value = "";
        };
        const hasDiscountApplied = ()=>!(0, $kheUU.default)(discountModel.value);
        const clearUserMessages = ()=>{
            userMessage.value = "";
            userFriendlyError.value = "";
        };
        const __returned__ = {
            discountModel: discountModel,
            t: t,
            validationSchema: validationSchema,
            defineField: defineField,
            handleSubmit: handleSubmit,
            discountCode: discountCode,
            discountCodeAttrs: discountCodeAttrs,
            userMessage: userMessage,
            fetch: fetch,
            response: response,
            isVerifyingKey: isVerifyingKey,
            userFriendlyError: userFriendlyError,
            doSubmitCode: doSubmitCode,
            clearDiscount: clearDiscount,
            hasDiscountApplied: hasDiscountApplied,
            clearUserMessages: clearUserMessages,
            markRaw: $01W3b.markRaw,
            ref: $01W3b.ref,
            get object () {
                return 0, $hEJWZ.object;
            },
            get string () {
                return 0, $hEJWZ.string;
            },
            get useForm () {
                return 0, $fRZwI.useForm;
            },
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            get isEmpty () {
                return 0, $kheUU.default;
            },
            get CheckCircleIcon () {
                return 0, $ilDn7.default;
            },
            InPlaceAlert: $1F5z6.default,
            get useVerifyKey () {
                return 0, $dHodW.default;
            },
            WithLoader: $kW7Vr.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("ilDn7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5b8ba9ed5d94e7a$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $d5b8ba9ed5d94e7a$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "fill-rule": "evenodd",
            d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
            "clip-rule": "evenodd"
        })
    ]);
}

});

parcelRegister("dHodW", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f9214d838ee1988$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $fEFLm = parcelRequire("fEFLm");

var $bRn2L = parcelRequire("bRn2L");
const $9f9214d838ee1988$var$useVerifyKey = ()=>{
    const { endpointData: endpointData, callEndpoint: callEndpoint, userFriendlyError: userFriendlyError, isLoading: isLoading } = (0, $bRn2L.default)("verifyKey");
    const fetch = async (key)=>{
        isLoading.value = true;
        await callEndpoint({
            method: "POST",
            request: {
                key: key
            }
        });
    };
    const response = (0, $01W3b.computed)(()=>({
            key: (0, $fEFLm.default)("", "key", endpointData.value),
            type: (0, $fEFLm.default)("", "type", endpointData.value),
            discount: (0, $fEFLm.default)("", "discount", endpointData.value),
            extraSeats: (0, $fEFLm.default)("", "extraSeats", endpointData.value)
        }));
    return {
        fetch: fetch,
        response: response,
        isLoading: isLoading,
        userFriendlyError: userFriendlyError
    };
};
var $9f9214d838ee1988$export$2e2bcd8739ae039 = $9f9214d838ee1988$var$useVerifyKey;

});


parcelRegister("diL5w", function(module, exports) {

$parcel$export(module.exports, "render", () => $9af17b7fba6e38a2$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $9af17b7fba6e38a2$var$_hoisted_1 = {
    key: 0,
    class: "mt-6 grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-3"
};
const $9af17b7fba6e38a2$var$_hoisted_2 = {
    class: "col-span-2"
};
const $9af17b7fba6e38a2$var$_hoisted_3 = {
    class: "mt-1"
};
const $9af17b7fba6e38a2$var$_hoisted_4 = [
    "placeholder",
    "disabled"
];
const $9af17b7fba6e38a2$var$_hoisted_5 = {
    class: "mt-1"
};
const $9af17b7fba6e38a2$var$_hoisted_6 = {
    type: "submit",
    class: "w-full btn-cta"
};
const $9af17b7fba6e38a2$var$_hoisted_7 = {
    key: 1,
    class: "mt-6 grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-3"
};
const $9af17b7fba6e38a2$var$_hoisted_8 = {
    class: "col-span-2"
};
const $9af17b7fba6e38a2$var$_hoisted_9 = {
    class: "mt-1 relative"
};
const $9af17b7fba6e38a2$var$_hoisted_10 = {
    class: "absolute h-full ml-3 w-8 flex text-green-400"
};
const $9af17b7fba6e38a2$var$_hoisted_11 = [
    "placeholder"
];
const $9af17b7fba6e38a2$var$_hoisted_12 = {
    class: "mt-1"
};
function $9af17b7fba6e38a2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        (0, $TusQn.createElementVNode)("form", {
            onSubmit: _cache[2] || (_cache[2] = (...args)=>$setup.doSubmitCode && $setup.doSubmitCode(...args))
        }, [
            !$setup.hasDiscountApplied() ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $9af17b7fba6e38a2$var$_hoisted_1, [
                (0, $TusQn.createElementVNode)("div", $9af17b7fba6e38a2$var$_hoisted_2, [
                    (0, $TusQn.createElementVNode)("div", $9af17b7fba6e38a2$var$_hoisted_3, [
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
                            type: "text",
                            placeholder: _ctx.$t("registerView.billing.discountPlaceholder"),
                            id: "discountCode",
                            name: "discountCode",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.discountCode = $event)
                        }, $setup.discountCodeAttrs, {
                            required: "",
                            disabled: $setup.isVerifyingKey,
                            class: "w-full input-transparent-text placeholder-gray-100"
                        }), null, 16 /* FULL_PROPS */ , $9af17b7fba6e38a2$var$_hoisted_4), [
                            [
                                (0, $eeJ70.vModelText),
                                $setup.discountCode
                            ]
                        ])
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", null, [
                    (0, $TusQn.createElementVNode)("div", $9af17b7fba6e38a2$var$_hoisted_5, [
                        (0, $TusQn.createVNode)($setup["WithLoader"], {
                            "is-loading": $setup.isVerifyingKey
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createElementVNode)("button", $9af17b7fba6e38a2$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.discountApply")), 1 /* TEXT */ )
                                ]),
                            _: 1 /* STABLE */ 
                        }, 8 /* PROPS */ , [
                            "is-loading"
                        ])
                    ])
                ])
            ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $9af17b7fba6e38a2$var$_hoisted_7, [
                (0, $TusQn.createElementVNode)("div", $9af17b7fba6e38a2$var$_hoisted_8, [
                    (0, $TusQn.createElementVNode)("div", $9af17b7fba6e38a2$var$_hoisted_9, [
                        (0, $TusQn.createElementVNode)("span", $9af17b7fba6e38a2$var$_hoisted_10, [
                            (0, $TusQn.createVNode)($setup["CheckCircleIcon"], {
                                class: "items-center justify-center align-middle"
                            })
                        ]),
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            type: "text",
                            placeholder: _ctx.$t("registerView.billing.discountPlaceholder"),
                            disabled: "",
                            id: "discountCode",
                            name: "discountCode",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.discountCode = $event),
                            required: "",
                            class: "pl-14 w-full input-transparent-text border-1 border-green-400"
                        }, null, 8 /* PROPS */ , $9af17b7fba6e38a2$var$_hoisted_11), [
                            [
                                (0, $eeJ70.vModelText),
                                $setup.discountCode
                            ]
                        ])
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", null, [
                    (0, $TusQn.createElementVNode)("div", $9af17b7fba6e38a2$var$_hoisted_12, [
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            onClick: $setup.clearDiscount,
                            class: "w-full btn-cta"
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.discountClear")), 1 /* TEXT */ )
                    ])
                ])
            ]))
        ], 32 /* NEED_HYDRATION */ ),
        (0, $TusQn.createVNode)($setup["InPlaceAlert"], {
            class: "mt-3",
            message: $setup.userMessage,
            onCloseAlert: $setup.clearUserMessages
        }, null, 8 /* PROPS */ , [
            "message"
        ])
    ]);
}

});

parcelRegister("bhwVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $836ad21cde87a8e8$export$2e2bcd8739ae039);
let $836ad21cde87a8e8$var$NOOP = ()=>{};
var $836ad21cde87a8e8$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("kiljT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec6606c32ed65fb6$export$2e2bcd8739ae039);
let $ec6606c32ed65fb6$var$script;



let $ec6606c32ed65fb6$var$initialize = ()=>{
    $ec6606c32ed65fb6$var$script = (parcelRequire("i0DfK"));
    if ($ec6606c32ed65fb6$var$script.__esModule) $ec6606c32ed65fb6$var$script = $ec6606c32ed65fb6$var$script.default;
    $ec6606c32ed65fb6$var$script.render = (parcelRequire("6znL6")).render;
    (parcelRequire("gSmPJ")).default($ec6606c32ed65fb6$var$script);
    $ec6606c32ed65fb6$var$script.__scopeId = "data-v-5aebaa";
    $ec6606c32ed65fb6$var$script.__file = "PricingComponent.vue";
};
$ec6606c32ed65fb6$var$initialize();
var $ec6606c32ed65fb6$export$2e2bcd8739ae039 = $ec6606c32ed65fb6$var$script;

});
parcelRegister("i0DfK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d1c6acee706f7429$export$2e2bcd8739ae039);

var $a5cve = parcelRequire("a5cve");
var $47c0h = parcelRequire("47c0h");
var $5zyMx = parcelRequire("5zyMx");
var $hHl8k = parcelRequire("hHl8k");
var $l7ahT = parcelRequire("l7ahT");
var $16nvB = parcelRequire("16nvB");
var $3o02A = parcelRequire("3o02A");
var $4Js1T = parcelRequire("4Js1T");
var $dnABj = parcelRequire("dnABj");
var $4Gqbx = parcelRequire("4Gqbx");
var $iDR1F = parcelRequire("iDR1F");
var $7Q6S5 = parcelRequire("7Q6S5");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $hbEdS = parcelRequire("hbEdS");

var $bQytf = parcelRequire("bQytf");

var $iTrGU = parcelRequire("iTrGU");

var $kW7Vr = parcelRequire("kW7Vr");
var $d1c6acee706f7429$export$2e2bcd8739ae039 = {
    __name: "PricingComponent",
    props: {
        chosenPlan: {
            required: true
        },
        numberSeats: {
            required: true
        },
        vat: {
            required: true
        },
        appliedDiscount: {
            required: true
        }
    },
    emits: [
        "price-updated"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const { fetch: fetch, response: response, isLoading: isCalculatingPrice } = (0, $iTrGU.default)();
        const isIndividual = (0, $01W3b.computed)(()=>(0, $bQytf.isIndividualPlan)((0, $01W3b.toValue)(props.chosenPlan)));
        const standardPrice = (0, $01W3b.computed)(()=>(0, $4Js1T.default)(props.numberSeats, (0, $01W3b.toValue)(isIndividual) ? props.chosenPlan.subscriptionPrice : props.chosenPlan.seatPrice));
        const appliedVat = props.vat;
        const ceilToTwoDecimals = (value)=>Math.round(value * 100) / 100;
        const vatAmount = (0, $01W3b.computed)(()=>ceilToTwoDecimals((0, $4Js1T.default)(standardPrice.value, appliedVat)));
        const totalPrice = (0, $01W3b.ref)(ceilToTwoDecimals((0, $4Js1T.default)(standardPrice.value, 1 + appliedVat)));
        const isLoadingPrice = (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(isCalculatingPrice) || (0, $01W3b.toValue)(seatChangeTimeout) > 0);
        const seatChangeTimeout = (0, $01W3b.ref)(0);
        const hasDiscountApplied = (0, $01W3b.computed)(()=>(0, $bQytf.isNotNullAndNotEmpty)((0, $01W3b.toValue)(props.appliedDiscount)));
        const discountTypeForPricing = (0, $01W3b.computed)(()=>(0, $5zyMx.default)([
                [
                    (0, $l7ahT.default)("discountAmount"),
                    (0, $47c0h.default)("money")
                ],
                [
                    (0, $l7ahT.default)("discountPercentage"),
                    (0, $47c0h.default)("percent")
                ]
            ])((0, $01W3b.toValue)(props.appliedDiscount).type));
        const recalculatePrice = async ()=>{
            const calculateVatReduction = (discount)=>(0, $hHl8k.default)(discount, (0, $a5cve.default)(1, appliedVat));
            if (!hasDiscountApplied.value) {
                totalPrice.value = ceilToTwoDecimals((0, $4Js1T.default)(standardPrice.value, (0, $a5cve.default)(1, appliedVat)));
                vatAmount.value = ceilToTwoDecimals((0, $4Js1T.default)(standardPrice.value, appliedVat));
                return;
            }
            await fetch(props.chosenPlan.planId, props.numberSeats, props.appliedDiscount.key);
            const totalWithDiscount = (0, $iDR1F.default)("total", (0, $01W3b.toValue)(response));
            const discountAmount = (0, $01W3b.toValue)(props.appliedDiscount.discount);
            totalPrice.value = (0, $4Gqbx.default)((0, $5zyMx.default)([
                [
                    (0, $l7ahT.default)("percent"),
                    (0, $47c0h.default)(totalWithDiscount)
                ],
                [
                    (0, $l7ahT.default)("money"),
                    ()=>(0, $a5cve.default)(totalWithDiscount, (0, $7Q6S5.default)(discountAmount, calculateVatReduction(discountAmount)))
                ]
            ]), ceilToTwoDecimals)(discountTypeForPricing.value);
            vatAmount.value = ceilToTwoDecimals((0, $7Q6S5.default)(totalPrice.value, totalWithDiscount));
            emit("price-updated", {
                totalPrice: totalPrice.value,
                vatAmount: vatAmount.value,
                hasDiscount: hasDiscountApplied.value
            });
        };
        (0, $TusQn.watch)(()=>props.appliedDiscount, recalculatePrice);
        (0, $TusQn.watch)(()=>props.appliedDiscount, ()=>{
            recalculatePrice();
        });
        (0, $TusQn.watch)(()=>props.numberSeats, ()=>{
            if (!(0, $01W3b.toValue)(hasDiscountApplied)) {
                recalculatePrice();
                return;
            }
            // buffer changes before making the final request
            const bufferTime = 1000;
            if ((0, $3o02A.default)(seatChangeTimeout)) {
                clearTimeout(seatChangeTimeout.value);
                seatChangeTimeout.value = 0;
            }
            seatChangeTimeout.value = setTimeout(()=>{
                recalculatePrice();
                seatChangeTimeout.value = 0;
            }, bufferTime);
        });
        (0, $TusQn.watch)(()=>props.chosenPlan, ()=>{
            recalculatePrice();
        });
        console.log("VAT in pricing component", props.vat);
        const __returned__ = {
            props: props,
            emit: emit,
            fetch: fetch,
            response: response,
            isCalculatingPrice: isCalculatingPrice,
            isIndividual: isIndividual,
            standardPrice: standardPrice,
            appliedVat: appliedVat,
            ceilToTwoDecimals: ceilToTwoDecimals,
            vatAmount: vatAmount,
            totalPrice: totalPrice,
            isLoadingPrice: isLoadingPrice,
            seatChangeTimeout: seatChangeTimeout,
            hasDiscountApplied: hasDiscountApplied,
            discountTypeForPricing: discountTypeForPricing,
            recalculatePrice: recalculatePrice,
            get add () {
                return 0, $a5cve.default;
            },
            get always () {
                return 0, $47c0h.default;
            },
            get cond () {
                return 0, $5zyMx.default;
            },
            get divide () {
                return 0, $hHl8k.default;
            },
            get equals () {
                return 0, $l7ahT.default;
            },
            get isNil () {
                return 0, $16nvB.default;
            },
            get isNotNil () {
                return 0, $3o02A.default;
            },
            get multiply () {
                return 0, $4Js1T.default;
            },
            get path () {
                return 0, $dnABj.default;
            },
            get pipe () {
                return 0, $4Gqbx.default;
            },
            get prop () {
                return 0, $iDR1F.default;
            },
            get subtract () {
                return 0, $7Q6S5.default;
            },
            computed: $01W3b.computed,
            ref: $01W3b.ref,
            toValue: $01W3b.toValue,
            watch: $TusQn.watch,
            Price: $hbEdS.default,
            get isIndividualPlan () {
                return 0, $bQytf.isIndividualPlan;
            },
            get isNotNullAndNotEmpty () {
                return 0, $bQytf.isNotNullAndNotEmpty;
            },
            get useCalculatePrice () {
                return 0, $iTrGU.default;
            },
            WithLoader: $kW7Vr.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("a5cve", function(module, exports) {

$parcel$export(module.exports, "default", () => $757411ca5124d4c2$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");
/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */ var $757411ca5124d4c2$var$add = /*#__PURE__*/ (0, $2jcOR.default)(function add(a, b) {
    return Number(a) + Number(b);
});
var $757411ca5124d4c2$export$2e2bcd8739ae039 = $757411ca5124d4c2$var$add;

});

parcelRegister("hHl8k", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce26d877daaac912$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");
/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      const half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      const reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */ var $ce26d877daaac912$var$divide = /*#__PURE__*/ (0, $2jcOR.default)(function divide(a, b) {
    return a / b;
});
var $ce26d877daaac912$export$2e2bcd8739ae039 = $ce26d877daaac912$var$divide;

});

parcelRegister("7Q6S5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b52b842b81a55ac$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");
/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      const minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      const complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */ var $5b52b842b81a55ac$var$subtract = /*#__PURE__*/ (0, $2jcOR.default)(function subtract(a, b) {
    return Number(a) - Number(b);
});
var $5b52b842b81a55ac$export$2e2bcd8739ae039 = $5b52b842b81a55ac$var$subtract;

});

parcelRegister("iTrGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc12d7edae2f824b$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $40VMZ = parcelRequire("40VMZ");

var $bRn2L = parcelRequire("bRn2L");
const $dc12d7edae2f824b$var$useCalculatePrice = ()=>{
    const { endpointData: endpointData, callEndpoint: callEndpoint, userFriendlyError: userFriendlyError, isLoading: isLoading } = (0, $bRn2L.default)("calculatePrice");
    const fetch = async (planId, numberOfSeats, redeemKey)=>{
        isLoading.value = true;
        await callEndpoint({
            method: "POST",
            request: {
                planId: planId,
                numberOfSeats: numberOfSeats,
                redeemKey: redeemKey
            }
        });
    };
    const response = (0, $01W3b.computed)(()=>({
            total: (0, $40VMZ.default)("", [
                "pricing",
                "total"
            ], endpointData.value),
            vat: (0, $40VMZ.default)("", [
                "pricing",
                "vat"
            ], endpointData.value)
        }));
    return {
        fetch: fetch,
        response: response,
        isLoading: isLoading,
        userFriendlyError: userFriendlyError
    };
};
var $dc12d7edae2f824b$export$2e2bcd8739ae039 = $dc12d7edae2f824b$var$useCalculatePrice;

});
parcelRegister("40VMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ec3fd40f6e47b46$export$2e2bcd8739ae039);

var $io7kf = parcelRequire("io7kf");

var $lczBz = parcelRequire("lczBz");

var $TSLKn = parcelRequire("TSLKn");
/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */ var $2ec3fd40f6e47b46$var$pathOr = /*#__PURE__*/ (0, $io7kf.default)(function pathOr(d, p, obj) {
    return (0, $TSLKn.default)(d, (0, $lczBz.default)(p, obj));
});
var $2ec3fd40f6e47b46$export$2e2bcd8739ae039 = $2ec3fd40f6e47b46$var$pathOr;

});



parcelRegister("6znL6", function(module, exports) {

$parcel$export(module.exports, "render", () => $4c8870ec3594b9ed$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $4c8870ec3594b9ed$var$_hoisted_1 = {
    class: "flex items-center font-bold justify-between border-t border-white border-opacity-10 pt-6 mt-3"
};
const $4c8870ec3594b9ed$var$_hoisted_2 = {
    class: "text-2xl line-through"
};
const $4c8870ec3594b9ed$var$_hoisted_3 = {
    class: "flex items-center font-bold justify-between pt-6 mt-3"
};
const $4c8870ec3594b9ed$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("dt", null, null, -1 /* HOISTED */ );
const $4c8870ec3594b9ed$var$_hoisted_5 = {
    class: "text-xl"
};
const $4c8870ec3594b9ed$var$_hoisted_6 = {
    class: "flex items-center font-bold justify-between pt-6 mt-3"
};
const $4c8870ec3594b9ed$var$_hoisted_7 = {
    class: "flex items-center font-bold justify-between border-t border-white border-opacity-10 pt-6 mt-3"
};
const $4c8870ec3594b9ed$var$_hoisted_8 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("dt", null, "Total", -1 /* HOISTED */ );
const $4c8870ec3594b9ed$var$_hoisted_9 = {
    class: "text-2xl"
};
const $4c8870ec3594b9ed$var$_hoisted_10 = {
    class: "flex items-center font-bold justify-between pt-6 mt-3"
};
const $4c8870ec3594b9ed$var$_hoisted_11 = {
    class: "flex items-center font-bold justify-between border-t border-white border-opacity-10 pt-6 mt-3"
};
const $4c8870ec3594b9ed$var$_hoisted_12 = {
    class: "text-2xl"
};
function $4c8870ec3594b9ed$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_i18n_t = (0, $TusQn.resolveComponent)("i18n-t");
    return $setup.hasDiscountApplied ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
        key: 0
    }, [
        (0, $TusQn.createElementVNode)("div", $4c8870ec3594b9ed$var$_hoisted_1, [
            (0, $TusQn.createVNode)(_component_i18n_t, {
                tag: "dt",
                class: "",
                keypath: "registerView.billing.yearlyTotalPrice"
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)($props.numberSeats), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)($setup.isIndividual ? $props.chosenPlan.subscriptionPrice : $props.chosenPlan.seatPrice), 1 /* TEXT */ )
                    ]),
                _: 1 /* STABLE */ 
            }),
            (0, $TusQn.createElementVNode)("dd", $4c8870ec3594b9ed$var$_hoisted_2, [
                (0, $TusQn.createVNode)($setup["Price"], {
                    price: $setup.standardPrice
                }, null, 8 /* PROPS */ , [
                    "price"
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $4c8870ec3594b9ed$var$_hoisted_3, [
            (0, $TusQn.createElementVNode)("dt", null, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.discount")), 1 /* TEXT */ ),
            (0, $TusQn.createElementVNode)("dd", null, [
                (0, $TusQn.createVNode)($setup["Price"], {
                    price: $props.appliedDiscount.discount,
                    sign: "-",
                    type: $setup.discountTypeForPricing
                }, null, 8 /* PROPS */ , [
                    "price",
                    "type"
                ])
            ]),
            $4c8870ec3594b9ed$var$_hoisted_4,
            (0, $TusQn.createElementVNode)("dd", $4c8870ec3594b9ed$var$_hoisted_5, [
                (0, $TusQn.createVNode)($setup["Price"], {
                    price: $setup.totalPrice
                }, null, 8 /* PROPS */ , [
                    "price"
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $4c8870ec3594b9ed$var$_hoisted_6, [
            (0, $TusQn.createElementVNode)("dt", null, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.vatLabel")) + " (" + (0, $8POXm.toDisplayString)($setup.appliedVat * 100) + "%)", 1 /* TEXT */ ),
            (0, $TusQn.createElementVNode)("dd", null, [
                (0, $TusQn.createVNode)($setup["Price"], {
                    price: $setup.totalPrice * (1 + $setup.appliedVat) - $setup.totalPrice
                }, null, 8 /* PROPS */ , [
                    "price"
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $4c8870ec3594b9ed$var$_hoisted_7, [
            $4c8870ec3594b9ed$var$_hoisted_8,
            (0, $TusQn.createElementVNode)("dd", $4c8870ec3594b9ed$var$_hoisted_9, [
                (0, $TusQn.createVNode)($setup["WithLoader"], {
                    "is-loading": $setup.isLoadingPrice
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)($setup["Price"], {
                                price: $setup.totalPrice * (1 + $setup.appliedVat)
                            }, null, 8 /* PROPS */ , [
                                "price"
                            ])
                        ]),
                    _: 1 /* STABLE */ 
                }, 8 /* PROPS */ , [
                    "is-loading"
                ])
            ])
        ])
    ], 64 /* STABLE_FRAGMENT */ )) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
        key: 1
    }, [
        (0, $TusQn.createElementVNode)("div", $4c8870ec3594b9ed$var$_hoisted_10, [
            (0, $TusQn.createElementVNode)("dt", null, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.vatLabel")) + " (" + (0, $8POXm.toDisplayString)($setup.appliedVat * 100) + "%)", 1 /* TEXT */ ),
            (0, $TusQn.createElementVNode)("dd", null, [
                (0, $TusQn.createVNode)($setup["Price"], {
                    price: $setup.vatAmount
                }, null, 8 /* PROPS */ , [
                    "price"
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $4c8870ec3594b9ed$var$_hoisted_11, [
            (0, $TusQn.createVNode)(_component_i18n_t, {
                tag: "dt",
                class: "",
                keypath: "registerView.billing.yearlyTotalPrice"
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)($props.numberSeats), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)($setup.isIndividual ? $props.chosenPlan.subscriptionPrice : $props.chosenPlan.seatPrice), 1 /* TEXT */ )
                    ]),
                _: 1 /* STABLE */ 
            }),
            (0, $TusQn.createElementVNode)("dd", $4c8870ec3594b9ed$var$_hoisted_12, [
                (0, $TusQn.createVNode)($setup["WithLoader"], {
                    "is-loading": $setup.isLoadingPrice
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)($setup["Price"], {
                                price: $setup.totalPrice
                            }, null, 8 /* PROPS */ , [
                                "price"
                            ])
                        ]),
                    _: 1 /* STABLE */ 
                }, 8 /* PROPS */ , [
                    "is-loading"
                ])
            ])
        ])
    ], 64 /* STABLE_FRAGMENT */ ));
}

});

parcelRegister("gSmPJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c49366bb2a73f138$export$2e2bcd8739ae039);
let $c49366bb2a73f138$var$NOOP = ()=>{};
var $c49366bb2a73f138$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("10duT", function(module, exports) {

$parcel$export(module.exports, "render", () => $0bb042d39170a104$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $0bb042d39170a104$var$_hoisted_1 = {
    class: "p-12 pt-8 bg-basecolor rounded-md text-primary lg:col-start-2 lg:row-start-1 lg:mx-auto lg:w-full lg:max-w-lg"
};
const $0bb042d39170a104$var$_hoisted_2 = {
    class: "mx-auto max-w-2xl px-4 lg:max-w-none lg:px-0"
};
const $0bb042d39170a104$var$_hoisted_3 = {
    class: "mx-auto max-w-2xl px-4 lg:max-w-none lg:px-0"
};
const $0bb042d39170a104$var$_hoisted_4 = {
    class: "text-xl"
};
const $0bb042d39170a104$var$_hoisted_5 = {
    key: 0,
    id: "individual-plan-pricing"
};
const $0bb042d39170a104$var$_hoisted_6 = {
    class: "space-y-6 border-opacity-10 pt-6 font-medium"
};
const $0bb042d39170a104$var$_hoisted_7 = {
    class: "flex items-center justify-between"
};
const $0bb042d39170a104$var$_hoisted_8 = {
    key: 1,
    id: "company-plan-pricing"
};
const $0bb042d39170a104$var$_hoisted_9 = {
    class: "space-y-6 border-opacity-10 pt-6 font-medium"
};
const $0bb042d39170a104$var$_hoisted_10 = {
    class: "flex items-center justify-between"
};
const $0bb042d39170a104$var$_hoisted_11 = {
    class: "text-lg"
};
const $0bb042d39170a104$var$_hoisted_12 = {
    class: "flex items-center justify-between"
};
const $0bb042d39170a104$var$_hoisted_13 = {
    class: "text-lg w-[30%]"
};
const $0bb042d39170a104$var$_hoisted_14 = {
    class: "mt-12 mb-12"
};
const $0bb042d39170a104$var$_hoisted_15 = {
    class: ""
};
const $0bb042d39170a104$var$_hoisted_16 = {
    role: "list",
    class: "mt-8 space-y-3 leading-6 text-primary"
};
const $0bb042d39170a104$var$_hoisted_17 = {
    class: "flex gap-x-3"
};
const $0bb042d39170a104$var$_hoisted_18 = {
    class: "flex gap-x-3"
};
const $0bb042d39170a104$var$_hoisted_19 = {
    class: "flex gap-x-3"
};
const $0bb042d39170a104$var$_hoisted_20 = {
    class: "mt-10 flex justify-center pt-6",
    id: "paypal-button-container"
};
function $0bb042d39170a104$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0bb042d39170a104$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $0bb042d39170a104$var$_hoisted_2, [
            (0, $TusQn.createVNode)($setup["InPlaceAlert"], {
                message: $setup.userFriendlyError,
                type: "error",
                onCloseAlert: _cache[0] || (_cache[0] = ($event)=>$setup.userFriendlyError = "")
            }, null, 8 /* PROPS */ , [
                "message"
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $0bb042d39170a104$var$_hoisted_3, [
            (0, $TusQn.createElementVNode)("h2", $0bb042d39170a104$var$_hoisted_4, (0, $8POXm.toDisplayString)($setup.t("planName")), 1 /* TEXT */ ),
            $setup.isIndividualPlan($props.chosenPlan) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0bb042d39170a104$var$_hoisted_5, [
                (0, $TusQn.createElementVNode)("dl", $0bb042d39170a104$var$_hoisted_6, [
                    (0, $TusQn.createElementVNode)("div", $0bb042d39170a104$var$_hoisted_7, [
                        (0, $TusQn.createElementVNode)("dt", null, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.yearlyPriceLabel")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("dd", null, [
                            (0, $TusQn.createVNode)($setup["Price"], {
                                price: $props.chosenPlan.subscriptionPrice
                            }, null, 8 /* PROPS */ , [
                                "price"
                            ])
                        ])
                    ])
                ])
            ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0bb042d39170a104$var$_hoisted_8, [
                (0, $TusQn.createElementVNode)("dl", $0bb042d39170a104$var$_hoisted_9, [
                    (0, $TusQn.createElementVNode)("div", $0bb042d39170a104$var$_hoisted_10, [
                        (0, $TusQn.createElementVNode)("dt", null, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.yearlyPriceLabel")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("dd", $0bb042d39170a104$var$_hoisted_11, [
                            (0, $TusQn.createVNode)($setup["Price"], {
                                price: $props.chosenPlan.seatPrice
                            }, null, 8 /* PROPS */ , [
                                "price"
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $0bb042d39170a104$var$_hoisted_12, [
                        (0, $TusQn.createElementVNode)("dt", null, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.numLicensesLabel")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("dd", $0bb042d39170a104$var$_hoisted_13, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "number",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.numSeatsToBuy = $event),
                                class: "block input-transparent-text w-full text-right",
                                required: true,
                                min: $setup.minNumSeats,
                                max: $setup.maxNumSeats
                            }, null, 512 /* NEED_PATCH */ ), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $setup.numSeatsToBuy
                                ]
                            ])
                        ])
                    ])
                ])
            ])),
            (0, $TusQn.createVNode)($setup["PricingComponent"], {
                "applied-discount": $setup.appliedDiscount,
                vat: $props.vat,
                "number-seats": $setup.numSeatsToBuy,
                "chosen-plan": $props.chosenPlan,
                onPriceUpdated: $setup.handlePriceUpdate
            }, null, 8 /* PROPS */ , [
                "applied-discount",
                "vat",
                "number-seats",
                "chosen-plan"
            ]),
            (0, $TusQn.createVNode)($setup["RedeemKeyComponent"], {
                modelValue: $setup.appliedDiscount,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.appliedDiscount = $event)
            }, null, 8 /* PROPS */ , [
                "modelValue"
            ]),
            (0, $TusQn.createElementVNode)("div", $0bb042d39170a104$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("p", $0bb042d39170a104$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.terms.desc")), 1 /* TEXT */ ),
                (0, $TusQn.createElementVNode)("ul", $0bb042d39170a104$var$_hoisted_16, [
                    (0, $TusQn.createElementVNode)("li", $0bb042d39170a104$var$_hoisted_17, [
                        (0, $TusQn.createVNode)($setup["CheckCircleIcon"], {
                            class: "h-6 w-5 flex-none",
                            "aria-hidden": "true"
                        }),
                        (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.terms.bullet1")), 1 /* TEXT */ )
                    ]),
                    (0, $TusQn.createElementVNode)("li", $0bb042d39170a104$var$_hoisted_18, [
                        (0, $TusQn.createVNode)($setup["CheckCircleIcon"], {
                            class: "h-6 w-5 flex-none",
                            "aria-hidden": "true"
                        }),
                        (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.terms.bullet2")), 1 /* TEXT */ )
                    ]),
                    (0, $TusQn.createElementVNode)("li", $0bb042d39170a104$var$_hoisted_19, [
                        (0, $TusQn.createVNode)($setup["CheckCircleIcon"], {
                            class: "h-6 w-5 flex-none",
                            "aria-hidden": "true"
                        }),
                        (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.terms.bullet3")), 1 /* TEXT */ )
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $0bb042d39170a104$var$_hoisted_20, [
                (0, $TusQn.createVNode)($setup["WithLoader"], {
                    "is-loading": $setup.isLoading
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            $setup.isFreePlan ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                key: 0,
                                onClick: $setup.onFreePlanClick,
                                class: "rounded-md border border-transparent bg-secondary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50"
                            }, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.free")), 1 /* TEXT */ )) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                key: 1,
                                onClick: $setup.callCreateSubscription,
                                class: "rounded-md border border-transparent bg-secondary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50"
                            }, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.billing.payWithPaypal")), 1 /* TEXT */ ))
                        ]),
                    _: 1 /* STABLE */ 
                }, 8 /* PROPS */ , [
                    "is-loading"
                ])
            ]),
            $setup.showMessage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: 2,
                class: (0, $8POXm.normalizeClass)([
                    "p-5",
                    {
                        "bg-red-200": $setup.hasError,
                        "bg-green-200": !$setup.hasError
                    }
                ])
            }, [
                (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)($setup.payPalResponseMessage.message), 1 /* TEXT */ )
            ], 2 /* CLASS */ )) : (0, $TusQn.createCommentVNode)("v-if", true)
        ])
    ]);
}

});

parcelRegister("9kBmf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cb2f5cfeec8d2fd$export$2e2bcd8739ae039);
let $6cb2f5cfeec8d2fd$var$NOOP = ()=>{};
var $6cb2f5cfeec8d2fd$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("briW4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8540e78e87f69e03$export$2e2bcd8739ae039);
let $8540e78e87f69e03$var$script;



let $8540e78e87f69e03$var$initialize = ()=>{
    $8540e78e87f69e03$var$script = (parcelRequire("g3eFh"));
    if ($8540e78e87f69e03$var$script.__esModule) $8540e78e87f69e03$var$script = $8540e78e87f69e03$var$script.default;
    $8540e78e87f69e03$var$script.render = (parcelRequire("hykot")).render;
    (parcelRequire("fdTp8")).default($8540e78e87f69e03$var$script);
    $8540e78e87f69e03$var$script.__scopeId = "data-v-4a1d46";
    $8540e78e87f69e03$var$script.__file = "ProcessCircles.vue";
};
$8540e78e87f69e03$var$initialize();
var $8540e78e87f69e03$export$2e2bcd8739ae039 = $8540e78e87f69e03$var$script;

});
parcelRegister("g3eFh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $baf84d43244c619e$export$2e2bcd8739ae039);

var $hPtJY = parcelRequire("hPtJY");

var $gzofV = parcelRequire("gzofV");
var $baf84d43244c619e$export$2e2bcd8739ae039 = {
    __name: "ProcessCircles",
    props: {
        steps: {
            required: true
        },
        size: {
            required: true
        }
    },
    emits: [
        "requestStepShortcut"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const sizeClass = [
            "h-24",
            "w-24"
        ];
        const __returned__ = {
            props: props,
            sizeClass: sizeClass,
            get emit () {
                return 0, $hPtJY.emit;
            },
            get CheckIcon () {
                return 0, $gzofV.default;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("gzofV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c102baea0343c078$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $c102baea0343c078$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "fill-rule": "evenodd",
            d: "M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z",
            "clip-rule": "evenodd"
        })
    ]);
}

});


parcelRegister("hykot", function(module, exports) {

$parcel$export(module.exports, "render", () => $cc756e6ff27b6aee$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $cc756e6ff27b6aee$var$_hoisted_1 = {
    role: "list",
    class: "flex items-center justify-center"
};
const $cc756e6ff27b6aee$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "absolute inset-0 flex items-center",
    "aria-hidden": "true"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "h-0.5 w-full bg-basecolor"
    })
], -1 /* HOISTED */ );
const $cc756e6ff27b6aee$var$_hoisted_3 = [
    "onClick"
];
const $cc756e6ff27b6aee$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
    class: "rounded-full bg-basecolor",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */ );
const $cc756e6ff27b6aee$var$_hoisted_5 = {
    class: "sr-only"
};
const $cc756e6ff27b6aee$var$_hoisted_6 = {
    class: "text-secondary text-xl"
};
const $cc756e6ff27b6aee$var$_hoisted_7 = {
    class: "absolute w-24 uppercase flex items-center justify-center text-sm text-center text-basecolor"
};
const $cc756e6ff27b6aee$var$_hoisted_8 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "absolute inset-0 flex items-center",
    "aria-hidden": "true"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "h-0.5 w-full bg-registerLight"
    })
], -1 /* HOISTED */ );
const $cc756e6ff27b6aee$var$_hoisted_9 = {
    class: "sr-only"
};
const $cc756e6ff27b6aee$var$_hoisted_10 = {
    class: "text-secondary text-2xl"
};
const $cc756e6ff27b6aee$var$_hoisted_11 = {
    class: "absolute w-24 uppercase font-bold flex items-center justify-center text-sm text-center text-basecolor"
};
const $cc756e6ff27b6aee$var$_hoisted_12 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "absolute inset-0 flex items-center",
    "aria-hidden": "true"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "h-0.5 w-full bg-registerLight"
    })
], -1 /* HOISTED */ );
const $cc756e6ff27b6aee$var$_hoisted_13 = {
    class: "sr-only"
};
const $cc756e6ff27b6aee$var$_hoisted_14 = {
    class: "text-secondary text-2xl"
};
const $cc756e6ff27b6aee$var$_hoisted_15 = {
    class: "absolute w-24 uppercase flex items-center justify-center text-sm text-center text-basecolor"
};
function $cc756e6ff27b6aee$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ol", $cc756e6ff27b6aee$var$_hoisted_1, [
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.steps, (step, stepIdx)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                key: step.name,
                class: (0, $8POXm.normalizeClass)([
                    stepIdx !== $props.steps.length - 1 ? "pr-8 md:pr-32 xl:pr-64" : "",
                    "relative"
                ])
            }, [
                step.isDone() ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 0
                }, [
                    $cc756e6ff27b6aee$var$_hoisted_2,
                    (0, $TusQn.createElementVNode)("a", {
                        onClick: (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit("requestStepShortcut", stepIdx), [
                            "prevent"
                        ]),
                        class: (0, $8POXm.normalizeClass)([
                            [
                                $setup.sizeClass,
                                "cursor-pointer"
                            ],
                            "relative flex items-center justify-center rounded-full border-1 bg-basecolor border-basecolor"
                        ])
                    }, [
                        $cc756e6ff27b6aee$var$_hoisted_4,
                        (0, $TusQn.createElementVNode)("span", $cc756e6ff27b6aee$var$_hoisted_5, (0, $8POXm.toDisplayString)(step.name), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("span", $cc756e6ff27b6aee$var$_hoisted_6, [
                            (0, $TusQn.createVNode)($setup["CheckIcon"], {
                                class: "w-12 h-12"
                            })
                        ])
                    ], 10 /* CLASS, PROPS */ , $cc756e6ff27b6aee$var$_hoisted_3),
                    (0, $TusQn.createElementVNode)("div", $cc756e6ff27b6aee$var$_hoisted_7, (0, $8POXm.toDisplayString)(step.name), 1 /* TEXT */ )
                ], 64 /* STABLE_FRAGMENT */ )) : step.isCurrent() ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 1
                }, [
                    $cc756e6ff27b6aee$var$_hoisted_8,
                    (0, $TusQn.createElementVNode)("a", {
                        class: (0, $8POXm.normalizeClass)([
                            [
                                $setup.sizeClass,
                                "cursor-pointer"
                            ],
                            "relative flex items-center justify-center rounded-full border-1 border-registerLight bg-basecolor"
                        ]),
                        "aria-current": "step"
                    }, [
                        (0, $TusQn.createElementVNode)("span", $cc756e6ff27b6aee$var$_hoisted_9, (0, $8POXm.toDisplayString)(step.name), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("span", $cc756e6ff27b6aee$var$_hoisted_10, (0, $8POXm.toDisplayString)(stepIdx + 1), 1 /* TEXT */ )
                    ], 2 /* CLASS */ ),
                    (0, $TusQn.createElementVNode)("div", $cc756e6ff27b6aee$var$_hoisted_11, (0, $8POXm.toDisplayString)(step.name), 1 /* TEXT */ )
                ], 64 /* STABLE_FRAGMENT */ )) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 2
                }, [
                    $cc756e6ff27b6aee$var$_hoisted_12,
                    (0, $TusQn.createElementVNode)("a", {
                        class: (0, $8POXm.normalizeClass)([
                            $setup.sizeClass,
                            "group relative flex items-center justify-center rounded-full border-1 border-registerLight bg-registerLight"
                        ])
                    }, [
                        (0, $TusQn.createElementVNode)("span", $cc756e6ff27b6aee$var$_hoisted_13, (0, $8POXm.toDisplayString)(step.name), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("span", $cc756e6ff27b6aee$var$_hoisted_14, (0, $8POXm.toDisplayString)(stepIdx + 1), 1 /* TEXT */ )
                    ]),
                    (0, $TusQn.createElementVNode)("div", $cc756e6ff27b6aee$var$_hoisted_15, (0, $8POXm.toDisplayString)(step.name), 1 /* TEXT */ )
                ], 64 /* STABLE_FRAGMENT */ ))
            ], 2 /* CLASS */ );
        }), 128 /* KEYED_FRAGMENT */ ))
    ]);
}

});

parcelRegister("fdTp8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1530c16e7cbe296$export$2e2bcd8739ae039);
let $b1530c16e7cbe296$var$NOOP = ()=>{};
var $b1530c16e7cbe296$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("fTwov", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9251ee9abb9b48b$export$2e2bcd8739ae039);
let $b9251ee9abb9b48b$var$script;



let $b9251ee9abb9b48b$var$initialize = ()=>{
    $b9251ee9abb9b48b$var$script = (parcelRequire("2GsbE"));
    if ($b9251ee9abb9b48b$var$script.__esModule) $b9251ee9abb9b48b$var$script = $b9251ee9abb9b48b$var$script.default;
    $b9251ee9abb9b48b$var$script.render = (parcelRequire("k0LXk")).render;
    (parcelRequire("c3GfJ")).default($b9251ee9abb9b48b$var$script);
    $b9251ee9abb9b48b$var$script.__scopeId = "data-v-8b4b41";
    $b9251ee9abb9b48b$var$script.__file = "ConfirmationComponent.vue";
};
$b9251ee9abb9b48b$var$initialize();
var $b9251ee9abb9b48b$export$2e2bcd8739ae039 = $b9251ee9abb9b48b$var$script;

});
parcelRegister("2GsbE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1f455e5f9a568c05$export$2e2bcd8739ae039);

var $e6aNv = parcelRequire("e6aNv");
var $jkSLk = parcelRequire("jkSLk");

var $jFUWD = parcelRequire("jFUWD");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $580JV = parcelRequire("580JV");

var $1rS06 = parcelRequire("1rS06");

var $5u1XQ = parcelRequire("5u1XQ");

var $f02BR = parcelRequire("f02BR");

var $4Om5W = parcelRequire("4Om5W");

var $gQLqr = parcelRequire("gQLqr");

var $ifZB1 = parcelRequire("ifZB1");
var $1f455e5f9a568c05$export$2e2bcd8739ae039 = {
    __name: "ConfirmationComponent",
    props: {
        paymentSuccess: {
            required: true,
            default: false
        },
        freePaymentSuccess: {
            required: false,
            default: false
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const chosenPlan = (0, $01W3b.ref)(null);
        const { fetch: updateUserState } = (0, $gQLqr.fetchAndUpdateUserState)();
        const { isAuthenticated: isAuthenticated, userState: userState } = (0, $1rS06.useGlobalState)();
        const subscriptionPolling = (0, $01W3b.ref)(null);
        (0, $TusQn.onMounted)(async ()=>{
            await (0, $4Om5W.fetchPlans)();
            await updateUserState();
            const storedPlan = sessionStorage.getItem("chosenPlan");
            if (storedPlan) chosenPlan.value = JSON.parse(storedPlan);
            else console.error("No chosen plan found after PayPal redirection");
            const endpointUsed = (0, $01W3b.computed)(()=>(0, $1rS06.hasCompanyPlan)((0, $01W3b.toValue)(userState)) ? "subscription" : "mySubscription");
            subscriptionPolling.value = (0, $5u1XQ.useSubscriptionPolling)(props.paymentSuccess, endpointUsed);
            (0, $ifZB1.trackEvent)("register_confirmation_step", {
                paymentSuccess: props.paymentSuccess,
                event_category: [
                    "Payments",
                    "Register"
                ],
                event_label: "Confirmation Step"
            });
            if (props.freePaymentSuccess) (0, $ifZB1.trackEvent)("confirmation_free_payment_success", {
                event_category: [
                    "Payments",
                    "Register"
                ],
                event_label: chosenPlan.value?.name || "unknown"
            });
            else if (props.paymentSuccess) (0, $ifZB1.trackEvent)("confirmation_payment_success", {
                event_category: [
                    "Payments",
                    "Register"
                ],
                event_label: chosenPlan.value?.name || "unknown"
            });
            else (0, $ifZB1.trackEvent)("confirmation_payment_failed", {
                event_category: [
                    "Payments",
                    "Register"
                ],
                event_label: chosenPlan.value?.name || "unknown"
            });
        });
        const { t: t } = (0, $jFUWD.useI18n)();
        // eslint-disable-next-line max-len
        const isSubscriptionActive = (0, $01W3b.computed)(()=>subscriptionPolling.value ? subscriptionPolling.value.isSubscriptionActive : false);
        const titleMessage = (0, $01W3b.computed)(()=>{
            if (props.freePaymentSuccess) return t("registerView.confirmation.successTitle");
            if (props.paymentSuccess) return isSubscriptionActive.value ? t("registerView.confirmation.successTitle") : t("registerView.confirmation.waitingTitle");
            return t("registerView.confirmation.failureTitle");
        });
        const infoMessage = (0, $01W3b.computed)(()=>{
            if (props.freePaymentSuccess) return t("registerView.confirmation.freeInfo", {
                planName: chosenPlan.value
            });
            if (props.paymentSuccess) return isSubscriptionActive.value ? t("registerView.confirmation.successInfo", {
                planName: chosenPlan.value
            }) : t("registerView.confirmation.waitingInfo", {
                planName: chosenPlan.value
            });
            return t("registerView.confirmation.failureInfo");
        });
        const homeNavigation = (0, $580JV.default).i18nRoute({
            name: "home"
        });
        const loginNavigation = (0, $580JV.default).i18nRoute({
            name: "login"
        });
        const dashboardNavigation = (0, $580JV.default).i18nRoute({
            name: "dashboard"
        });
        const __returned__ = {
            props: props,
            chosenPlan: chosenPlan,
            updateUserState: updateUserState,
            isAuthenticated: isAuthenticated,
            userState: userState,
            subscriptionPolling: subscriptionPolling,
            t: t,
            isSubscriptionActive: isSubscriptionActive,
            titleMessage: titleMessage,
            infoMessage: infoMessage,
            homeNavigation: homeNavigation,
            loginNavigation: loginNavigation,
            dashboardNavigation: dashboardNavigation,
            get CheckCircleIcon () {
                return 0, $e6aNv.default;
            },
            get XCircleIcon () {
                return 0, $jkSLk.default;
            },
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            computed: $01W3b.computed,
            onBeforeMount: $TusQn.onBeforeMount,
            onMounted: $TusQn.onMounted,
            ref: $01W3b.ref,
            toValue: $01W3b.toValue,
            get Trans () {
                return 0, $580JV.default;
            },
            get useGlobalState () {
                return 0, $1rS06.useGlobalState;
            },
            get hasCompanyPlan () {
                return 0, $1rS06.hasCompanyPlan;
            },
            get useSubscriptionPolling () {
                return 0, $5u1XQ.useSubscriptionPolling;
            },
            LoadingSpinner: $f02BR.default,
            get fetchPlans () {
                return 0, $4Om5W.fetchPlans;
            },
            get fetchAndUpdateUserState () {
                return 0, $gQLqr.fetchAndUpdateUserState;
            },
            get trackEvent () {
                return 0, $ifZB1.trackEvent;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("e6aNv", function(module, exports) {

$parcel$export(module.exports, "default", () => $a43a00622ad02f06$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $a43a00622ad02f06$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
}

});

parcelRegister("jkSLk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e13a5d3b684fc14e$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $e13a5d3b684fc14e$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    ]);
}

});

parcelRegister("5u1XQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe1472a1c37d6f2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isSubscriptionActive", () => $3fe1472a1c37d6f2$export$3f81f1ade0652ac);
$parcel$export(module.exports, "useSubscriptionPolling", () => $3fe1472a1c37d6f2$export$f38c89520cf5d042);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $bRn2L = parcelRequire("bRn2L");

var $l7ahT = parcelRequire("l7ahT");
var $dnABj = parcelRequire("dnABj");
const $3fe1472a1c37d6f2$var$fetchSubscription = (endpoint)=>{
    const { callEndpoint: callEndpoint, endpointData: endpointData, isLoading: isLoading } = (0, $bRn2L.default)(endpoint);
    const fetch = async ()=>{
        await callEndpoint({
            method: "GET"
        });
    };
    const response = (0, $01W3b.computed)(()=>endpointData.value);
    return {
        fetch: fetch,
        response: response,
        isLoading: isLoading
    };
};
var $3fe1472a1c37d6f2$export$2e2bcd8739ae039 = $3fe1472a1c37d6f2$var$fetchSubscription;
const $3fe1472a1c37d6f2$export$3f81f1ade0652ac = (subscription)=>(0, $l7ahT.default)("ACTIVE", (0, $dnABj.default)([
        "status"
    ], subscription));
function $3fe1472a1c37d6f2$export$f38c89520cf5d042(paymentSuccess, endpoint, pollInterval = 5000) {
    const subscriptionAPI = $3fe1472a1c37d6f2$var$fetchSubscription(endpoint);
    const subscriptionStatus = (0, $01W3b.ref)(null);
    const isSubscriptionActiveComputed = (0, $01W3b.computed)(()=>subscriptionStatus.value === "ACTIVE");
    let intervalId = null;
    let timeoutId = null;
    const maxPollingTime = 300000;
    const pollSubscription = ()=>{
        subscriptionAPI.fetch().then(()=>{
            const data = subscriptionAPI.response.value;
            if (data && data.status) {
                subscriptionStatus.value = data.status;
                if (data.status === "ACTIVE" && intervalId) clearInterval(intervalId);
            }
        });
    };
    if (paymentSuccess) {
        pollSubscription();
        intervalId = setInterval(pollSubscription, pollInterval);
        timeoutId = setTimeout(()=>{
            if (intervalId) clearInterval(intervalId);
        }, maxPollingTime);
    }
    (0, $TusQn.onUnmounted)(()=>{
        if (intervalId) clearInterval(intervalId);
        if (timeoutId) clearTimeout(timeoutId);
    });
    return {
        subscriptionStatus: subscriptionStatus,
        isSubscriptionActive: isSubscriptionActiveComputed
    };
}

});


parcelRegister("k0LXk", function(module, exports) {

$parcel$export(module.exports, "render", () => $e91901c6541f2ae0$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $e91901c6541f2ae0$var$_hoisted_1 = {
    class: "p-12 pt-8 rounded-md bg-basecolor text-primary lg:col-start-2 lg:row-start-1 lg:mx-auto lg:w-full lg:max-w-lg"
};
const $e91901c6541f2ae0$var$_hoisted_2 = {
    class: "mx-auto max-w-2xl px-4 lg:max-w-none lg:px-0 text-center"
};
const $e91901c6541f2ae0$var$_hoisted_3 = {
    class: "text-2xl"
};
const $e91901c6541f2ae0$var$_hoisted_4 = {
    class: "text-xl mt-3"
};
const $e91901c6541f2ae0$var$_hoisted_5 = [
    "innerHTML"
];
const $e91901c6541f2ae0$var$_hoisted_6 = {
    class: "mt-10 flex justify-between pt-6"
};
function $e91901c6541f2ae0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e91901c6541f2ae0$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $e91901c6541f2ae0$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $e91901c6541f2ae0$var$_hoisted_3, [
                $props.paymentSuccess && $setup.isSubscriptionActive || $props.freePaymentSuccess ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["CheckCircleIcon"], {
                    key: 0,
                    class: "font-semibold w-16 h-16 m-auto"
                })) : $props.paymentSuccess && !$setup.isSubscriptionActive ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 1
                }, [], 64 /* STABLE_FRAGMENT */ )) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["XCircleIcon"], {
                    key: 2,
                    class: "font-semibold w-16 h-16 m-auto text-red-500"
                }))
            ]),
            (0, $TusQn.createElementVNode)("h2", $e91901c6541f2ae0$var$_hoisted_4, (0, $8POXm.toDisplayString)($setup.titleMessage), 1 /* TEXT */ ),
            (0, $TusQn.createElementVNode)("p", {
                class: "mt-5 text-sm",
                innerHTML: $setup.infoMessage
            }, null, 8 /* PROPS */ , $e91901c6541f2ae0$var$_hoisted_5),
            (0, $TusQn.createElementVNode)("div", $e91901c6541f2ae0$var$_hoisted_6, [
                $setup.isAuthenticated() && $setup.isSubscriptionActive || !$props.paymentSuccess ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_RouterLink, {
                    key: 0,
                    to: $setup.homeNavigation,
                    class: "rounded-md border border-primary bg-transparent px-14 py-3 text-sm font-medium text-primary shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("registerView.confirmation.homeButton")), 1 /* TEXT */ )
                        ]),
                    _: 1 /* STABLE */ 
                }, 8 /* PROPS */ , [
                    "to"
                ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                $setup.isAuthenticated() && ($setup.isSubscriptionActive || $props.freePaymentSuccess) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_RouterLink, {
                    key: 1,
                    to: $setup.dashboardNavigation,
                    class: "rounded-md border border-transparent bg-secondary px-14 py-3 text-sm font-medium text-primary shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("dashboardBtn")), 1 /* TEXT */ )
                        ]),
                    _: 1 /* STABLE */ 
                }, 8 /* PROPS */ , [
                    "to"
                ])) : $props.paymentSuccess && !$setup.isSubscriptionActive ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["LoadingSpinner"], {
                    key: 2,
                    class: "w-16 h-16 m-auto"
                })) : !$setup.isAuthenticated() ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_RouterLink, {
                    key: 3,
                    to: $setup.loginNavigation,
                    class: "rounded-md border border-transparent bg-secondary px-14 py-3 text-sm font-medium text-primary shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("registerView.confirmation.logInButton")), 1 /* TEXT */ )
                        ]),
                    _: 1 /* STABLE */ 
                }, 8 /* PROPS */ , [
                    "to"
                ])) : (0, $TusQn.createCommentVNode)("v-if", true)
            ])
        ])
    ]);
}

});

parcelRegister("c3GfJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c768a5636a27e9a$export$2e2bcd8739ae039);
let $8c768a5636a27e9a$var$NOOP = ()=>{};
var $8c768a5636a27e9a$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("bgub5", function(module, exports) {

$parcel$export(module.exports, "default", () => $833899045b863f6b$export$2e2bcd8739ae039);
let $833899045b863f6b$var$script;



let $833899045b863f6b$var$initialize = ()=>{
    $833899045b863f6b$var$script = (parcelRequire("jQZDK"));
    if ($833899045b863f6b$var$script.__esModule) $833899045b863f6b$var$script = $833899045b863f6b$var$script.default;
    $833899045b863f6b$var$script.render = (parcelRequire("9bPrR")).render;
    (parcelRequire("5WFLh")).default($833899045b863f6b$var$script);
    $833899045b863f6b$var$script.__scopeId = "data-v-1da84c";
    $833899045b863f6b$var$script.__file = "RegisterNavigationBar.vue";
};
$833899045b863f6b$var$initialize();
var $833899045b863f6b$export$2e2bcd8739ae039 = $833899045b863f6b$var$script;

});
parcelRegister("jQZDK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e742b01a234c7324$export$2e2bcd8739ae039);

var $73mM4 = parcelRequire("73mM4");

var $580JV = parcelRequire("580JV");

var $5lCi4 = parcelRequire("5lCi4");
var $e742b01a234c7324$export$2e2bcd8739ae039 = {
    __name: "RegisterNavigationBar",
    setup (__props, { expose: __expose }) {
        __expose();
        const homeNavigation = (0, $580JV.default).i18nRoute({
            name: "home"
        });
        const __returned__ = {
            homeNavigation: homeNavigation,
            get RouterLink () {
                return 0, $73mM4.RouterLink;
            },
            get Trans () {
                return 0, $580JV.default;
            },
            GamebookLogo: $5lCi4.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("9bPrR", function(module, exports) {

$parcel$export(module.exports, "render", () => $6b0d0cb480d0f7f1$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $6b0d0cb480d0f7f1$var$_hoisted_1 = {
    class: "bg-primary text-basecolor"
};
const $6b0d0cb480d0f7f1$var$_hoisted_2 = {
    class: "mx-auto flex items-center justify-between p-6 lg:px-8"
};
const $6b0d0cb480d0f7f1$var$_hoisted_3 = {
    class: "flex items-center gap-x-12"
};
const $6b0d0cb480d0f7f1$var$_hoisted_4 = {
    class: "sr-only"
};
const $6b0d0cb480d0f7f1$var$_hoisted_5 = {
    class: "font-black p-3 flex-col text-basecolor"
};
function $6b0d0cb480d0f7f1$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("header", $6b0d0cb480d0f7f1$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("nav", $6b0d0cb480d0f7f1$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $6b0d0cb480d0f7f1$var$_hoisted_3, [
                (0, $TusQn.createVNode)($setup["RouterLink"], {
                    to: $setup.homeNavigation,
                    class: "-m-1.5 p-1.5 inline-flex"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createElementVNode)("span", $6b0d0cb480d0f7f1$var$_hoisted_4, (0, $8POXm.toDisplayString)(_ctx.$t("appTitle")), 1 /* TEXT */ ),
                            (0, $TusQn.createVNode)($setup["GamebookLogo"], {
                                dark: true,
                                class: "flex-col h-12 w-auto rounded-lg"
                            }),
                            (0, $TusQn.createElementVNode)("span", $6b0d0cb480d0f7f1$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("appTitle")), 1 /* TEXT */ )
                        ]),
                    _: 1 /* STABLE */ 
                }, 8 /* PROPS */ , [
                    "to"
                ])
            ])
        ])
    ]);
}

});

parcelRegister("5WFLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4542c37dd0a6602d$export$2e2bcd8739ae039);
let $4542c37dd0a6602d$var$NOOP = ()=>{};
var $4542c37dd0a6602d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("aquiH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7973d627c9f0c1ba$export$2e2bcd8739ae039);
let $7973d627c9f0c1ba$var$script;



let $7973d627c9f0c1ba$var$initialize = ()=>{
    $7973d627c9f0c1ba$var$script = (parcelRequire("2Idbb"));
    if ($7973d627c9f0c1ba$var$script.__esModule) $7973d627c9f0c1ba$var$script = $7973d627c9f0c1ba$var$script.default;
    $7973d627c9f0c1ba$var$script.render = (parcelRequire("lcF0M")).render;
    (parcelRequire("efIaD")).default($7973d627c9f0c1ba$var$script);
    $7973d627c9f0c1ba$var$script.__scopeId = "data-v-4a8dac";
    $7973d627c9f0c1ba$var$script.__file = "CreateAccountStepComponent.vue";
};
$7973d627c9f0c1ba$var$initialize();
var $7973d627c9f0c1ba$export$2e2bcd8739ae039 = $7973d627c9f0c1ba$var$script;

});
parcelRegister("2Idbb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1f99ea011f635404$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $ey2ik = parcelRequire("ey2ik");
var $l8CfQ = parcelRequire("l8CfQ");

var $bQytf = parcelRequire("bQytf");

var $lCXov = parcelRequire("lCXov");

var $2x7Ab = parcelRequire("2x7Ab");

var $1rS06 = parcelRequire("1rS06");

var $ifZB1 = parcelRequire("ifZB1");
var $1f99ea011f635404$export$2e2bcd8739ae039 = {
    __name: "CreateAccountStepComponent",
    props: [
        "chosenPlan"
    ],
    emits: [
        "detailsConfirmed",
        "back"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const { userState: userState, isAuthenticated: isAuthenticated } = (0, $1rS06.useGlobalState)();
        const props = __props;
        const emit = __emit;
        (0, $TusQn.onMounted)(()=>{
            (0, $ifZB1.trackEvent)("create_account_step", {
                event_category: "Register",
                event_label: "Create Account Step"
            });
            if (isAuthenticated()) {
                const skipDetails = (0, $l8CfQ.default)([
                    "user",
                    "email"
                ], userState.value.email)({});
                console.log("User already logged in. we can skip account creation", skipDetails);
                emit("detailsConfirmed", skipDetails);
            }
        });
        const __returned__ = {
            userState: userState,
            isAuthenticated: isAuthenticated,
            props: props,
            emit: emit,
            onMounted: $TusQn.onMounted,
            get assoc () {
                return 0, $ey2ik.default;
            },
            get assocPath () {
                return 0, $l8CfQ.default;
            },
            get isIndividualPlan () {
                return 0, $bQytf.isIndividualPlan;
            },
            AccountDetailsCompanyComponent: $lCXov.default,
            AccountDetailsIndividualComponent: $2x7Ab.default,
            get useGlobalState () {
                return 0, $1rS06.useGlobalState;
            },
            get trackEvent () {
                return 0, $ifZB1.trackEvent;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("lCXov", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbeb380c7b9c3d48$export$2e2bcd8739ae039);
let $fbeb380c7b9c3d48$var$script;



let $fbeb380c7b9c3d48$var$initialize = ()=>{
    $fbeb380c7b9c3d48$var$script = (parcelRequire("fQdVv"));
    if ($fbeb380c7b9c3d48$var$script.__esModule) $fbeb380c7b9c3d48$var$script = $fbeb380c7b9c3d48$var$script.default;
    $fbeb380c7b9c3d48$var$script.render = (parcelRequire("fKAbR")).render;
    (parcelRequire("kvJtC")).default($fbeb380c7b9c3d48$var$script);
    $fbeb380c7b9c3d48$var$script.__scopeId = "data-v-bf6cc8";
    $fbeb380c7b9c3d48$var$script.__file = "AccountDetailsCompanyComponent.vue";
};
$fbeb380c7b9c3d48$var$initialize();
var $fbeb380c7b9c3d48$export$2e2bcd8739ae039 = $fbeb380c7b9c3d48$var$script;

});
parcelRegister("fQdVv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b88683ddd0916a61$export$2e2bcd8739ae039);

var $jFUWD = parcelRequire("jFUWD");

var $ey2ik = parcelRequire("ey2ik");
var $l8CfQ = parcelRequire("l8CfQ");
var $kheUU = parcelRequire("kheUU");
var $4Gqbx = parcelRequire("4Gqbx");

var $fRZwI = parcelRequire("fRZwI");

var $hEJWZ = parcelRequire("hEJWZ");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $3Wj1M = parcelRequire("3Wj1M");

var $bRn2L = parcelRequire("bRn2L");

var $1F5z6 = parcelRequire("1F5z6");

var $gQLqr = parcelRequire("gQLqr");

var $4mqh0 = parcelRequire("4mqh0");

var $jYHy6 = parcelRequire("jYHy6");

var $40DKr = parcelRequire("40DKr");

var $3FNUq = parcelRequire("3FNUq");

var $kW7Vr = parcelRequire("kW7Vr");

var $dW1mF = parcelRequire("dW1mF");

var $gA4YI = parcelRequire("gA4YI");

var $1rS06 = parcelRequire("1rS06");

var $ifZB1 = parcelRequire("ifZB1");

var $3hjmJ = parcelRequire("3hjmJ");
var $b88683ddd0916a61$export$2e2bcd8739ae039 = {
    __name: "AccountDetailsCompanyComponent",
    emits: [
        "detailsConfirmed",
        "back"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const { t: t } = (0, $jFUWD.useI18n)();
        const validationMessages = (0, $gA4YI.default)();
        const emit = __emit;
        const { defineField: defineField, handleSubmit: handleSubmit } = (0, $fRZwI.useForm)({
            validationSchema: $hEJWZ.object({
                user: $hEJWZ.object({
                    email: $hEJWZ.string().email(t("passwordValidator.emailValid")).lowercase().required(t("passwordValidator.emailRequired")).label(t("registerView.accountForm.labels.email")),
                    confirmEmail: $hEJWZ.string().email(t("passwordValidator.emailValid")).lowercase().required(t("passwordValidator.emailRequired")).oneOf([
                        $hEJWZ.ref("email")
                    ], t("passwordValidator.emailMatch")).label(t("registerView.accountForm.labels.confirmEmail")),
                    password: (0, $dW1mF.default)(validationMessages).label(t("registerView.accountForm.labels.password")),
                    confirmPassword: $hEJWZ.string().required(t("passwordValidator.passwordRequired")).oneOf([
                        $hEJWZ.ref("password")
                    ], t("passwordValidator.passwordMatch")).label(t("registerView.accountForm.labels.confirmPassword")),
                    phoneNumber: $hEJWZ.string().label(t("registerView.accountForm.labels.phoneNumber")),
                    gender: $hEJWZ.string().required().label(t("registerView.accountForm.labels.gender")),
                    firstName: $hEJWZ.string().required().label(t("registerView.accountForm.labels.firstName")),
                    lastName: $hEJWZ.string().required().label(t("registerView.accountForm.labels.lastName")),
                    communicationLanguage: $hEJWZ.string().label(t("registerView.accountForm.labels.communicationLanguage")),
                    department: $hEJWZ.string().label(t("registerView.accountForm.labels.department")),
                    roleInCompany: $hEJWZ.string().label(t("registerView.accountForm.labels.roleInCompany"))
                }),
                company: $hEJWZ.object({
                    companyName: $hEJWZ.string().min(3).required().label(t("registerView.accountForm.labels.companyName")),
                    numberOfEmployees: $hEJWZ.number().label(t("registerView.accountForm.labels.numberOfEmployees")),
                    industry: $hEJWZ.string().label(t("registerView.accountForm.labels.industry")),
                    website: $hEJWZ.string().label(t("registerView.accountForm.labels.website")),
                    legalForm: $hEJWZ.string().label(t("registerView.accountForm.labels.legalForm")),
                    taxNumber: $hEJWZ.string().label(t("registerView.accountForm.labels.taxNumber")),
                    commercialRegisterNumber: $hEJWZ.string().label(t("registerView.accountForm.labels.commercialRegisterNumber")),
                    streetAddress: $hEJWZ.string().label(t("registerView.accountForm.labels.streetAddress")),
                    zipCode: $hEJWZ.string().label(t("registerView.accountForm.labels.zipCode")),
                    country: $hEJWZ.string().required().label(t("registerView.accountForm.labels.country")),
                    city: $hEJWZ.string().label(t("registerView.accountForm.labels.city"))
                }).nullable().default(null),
                termsAccepted: $hEJWZ.boolean().oneOf([
                    true
                ], t("registerView.accountForm.labels.termsRequired")).label(t("registerView.accountForm.labels.terms")),
                privacyAccepted: $hEJWZ.boolean().oneOf([
                    true
                ], t("registerView.accountForm.labels.privacyRequired")).label(t("registerView.accountForm.labels.privacy"))
            })
        });
        const [email, emailAttrs] = defineField("user.email");
        const [confirmEmail, confirmEmailAttrs] = defineField("user.confirmEmail");
        const [password, passwordAttrs] = defineField("user.password");
        const [confirmPassword, confirmPasswordAttrs] = defineField("user.confirmPassword");
        const [gender, genderAttrs] = defineField("user.gender");
        const [firstName, firstNameAttrs] = defineField("user.firstName");
        const [lastName, lastNameAttrs] = defineField("user.lastName");
        const [companyName, companyNameAttrs] = defineField("company.companyName");
        const [country, countryAttrs] = defineField("company.country");
        const [termsAccepted, termsAcceptedAttrs] = defineField("user.termsAccepted");
        const [privacyAccepted, privacyAcceptedAttrs] = defineField("user.privacyAccepted");
        /*
const [roleInCompany, roleInCompanyAttrs] = defineField('user.roleInCompany');
const [department, departmentAttrs] = defineField('user.department');
const [communicationPreference, communicationPreferenceAttrs] = defineField(
  'user.communicationPreference',
);
const [communicationLanguage, communicationLanguageAttrs] = defineField(
  'user.communicationLanguage',
);
const [phoneNumber, phoneNumberAttrs] = defineField('user.phoneNumber');
const [streetAddress, streetAddressAttrs] = defineField('company.streetAddress');
const [zipCode, zipCodeAttrs] = defineField('company.zipCode');
const [city, cityAttrs] = defineField('company.city');
const [numberOfEmployees, numberOfEmployeesAttrs] = defineField('company.numberOfEmployees');
const [industry, industryAttrs] = defineField('company.industry');
const [website, websiteAttrs] = defineField('company.website');
const [legalForm, legalFormAttrs] = defineField('company.legalForm');
const [taxNumber, taxNumberAttrs] = defineField('company.taxNumber');
const [commercialRegisterNumber, commercialRegisterNumberAttrs] = defineField(
  'company.commercialRegisterNumber',
);
*/ country.value = "de";
        const { callEndpoint: callEndpoint, userFriendlyError: userFriendlyError, isLoading: isSendingRegisterForm } = (0, $bRn2L.default)("register");
        const { userState: userState, currentEmployees: currentEmployees, currentCourses: currentCourses } = (0, $1rS06.useGlobalState)();
        const { getUserStateFromEndpoint: getUserStateFromEndpoint, isLoading: isLoading } = (0, $gQLqr.useUserStateFromEndpoint)();
        const submit = handleSubmit(async (values)=>{
            try {
                const username = values.user.email;
                const { password: password } = values.user;
                const usernameLowercased = username.toLowerCase();
                const { salt: salt, verifier: verifier } = (0, $gQLqr.useCreateSecureRemotePassword)(usernameLowercased, password);
                const request = (0, $4Gqbx.default)((0, $l8CfQ.default)([
                    "user",
                    "salt"
                ], (0, $01W3b.toValue)(salt)), (0, $l8CfQ.default)([
                    "user",
                    "verifier"
                ], (0, $01W3b.toValue)(verifier)), (0, $3FNUq.registerSpec))(values);
                await callEndpoint((0, $ey2ik.default)("method", "POST", {
                    request: request
                }));
                (0, $ifZB1.updateGtagConsent)({
                    "analytics_storage": "granted"
                });
                localStorage.setItem("gaRegisteredUserConsent", "true");
                if ((0, $kheUU.default)(userFriendlyError.value)) {
                    const userStateFromEndpoint = await getUserStateFromEndpoint(values.user.email, values.user.password); // eslint-disable-line max-len
                    if (!(0, $kheUU.default)(userStateFromEndpoint)) {
                        userState.value = (0, $ey2ik.default)("isAuthenticated", true, userStateFromEndpoint);
                        currentEmployees.value = userStateFromEndpoint.employees;
                        currentCourses.set(userStateFromEndpoint.courses);
                    }
                    (0, $ifZB1.trackEvent)("company_registration_success", {
                        event_category: "Register",
                        event_label: "New company user"
                    });
                    emit("detailsConfirmed", values);
                }
            } catch (error) {
                (0, $ifZB1.trackEvent)("company_registration_exception", {
                    event_category: "Register",
                    event_label: "Error registering company User",
                    error: error.message || "unknown"
                });
                if (error.response && error.response.data && error.response.data.error) userFriendlyError.value = error.response.data.error;
                else userFriendlyError.value = t("registerView.accountForm.errors.userExists");
            }
        });
        const __returned__ = {
            t: t,
            validationMessages: validationMessages,
            emit: emit,
            defineField: defineField,
            handleSubmit: handleSubmit,
            email: email,
            emailAttrs: emailAttrs,
            confirmEmail: confirmEmail,
            confirmEmailAttrs: confirmEmailAttrs,
            password: password,
            passwordAttrs: passwordAttrs,
            confirmPassword: confirmPassword,
            confirmPasswordAttrs: confirmPasswordAttrs,
            gender: gender,
            genderAttrs: genderAttrs,
            firstName: firstName,
            firstNameAttrs: firstNameAttrs,
            lastName: lastName,
            lastNameAttrs: lastNameAttrs,
            companyName: companyName,
            companyNameAttrs: companyNameAttrs,
            country: country,
            countryAttrs: countryAttrs,
            termsAccepted: termsAccepted,
            termsAcceptedAttrs: termsAcceptedAttrs,
            privacyAccepted: privacyAccepted,
            privacyAcceptedAttrs: privacyAcceptedAttrs,
            callEndpoint: callEndpoint,
            userFriendlyError: userFriendlyError,
            isSendingRegisterForm: isSendingRegisterForm,
            userState: userState,
            currentEmployees: currentEmployees,
            currentCourses: currentCourses,
            getUserStateFromEndpoint: getUserStateFromEndpoint,
            isLoading: isLoading,
            submit: submit,
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            get assoc () {
                return 0, $ey2ik.default;
            },
            get assocPath () {
                return 0, $l8CfQ.default;
            },
            get isEmpty () {
                return 0, $kheUU.default;
            },
            get pipe () {
                return 0, $4Gqbx.default;
            },
            get useForm () {
                return 0, $fRZwI.useForm;
            },
            get yup () {
                return $hEJWZ;
            },
            toValue: $01W3b.toValue,
            AccountFormField: $3Wj1M.default,
            get useCallEndPointWith () {
                return 0, $bRn2L.default;
            },
            InPlaceAlert: $1F5z6.default,
            get useCreateSecureRemotePassword () {
                return 0, $gQLqr.useCreateSecureRemotePassword;
            },
            get useUserStateFromEndpoint () {
                return 0, $gQLqr.useUserStateFromEndpoint;
            },
            AccountFormFieldRadio: $4mqh0.default,
            AccountFormFieldSelect: $jYHy6.default,
            get communicationLanguageOptions () {
                return 0, $40DKr.communicationLanguageOptions;
            },
            get communicationPreferencesOptions () {
                return 0, $40DKr.communicationPreferencesOptions;
            },
            get countryOptions () {
                return 0, $40DKr.countryOptions;
            },
            get genderOptions () {
                return 0, $40DKr.genderOptions;
            },
            get situationOptions () {
                return 0, $40DKr.situationOptions;
            },
            get registerSpec () {
                return 0, $3FNUq.registerSpec;
            },
            WithLoader: $kW7Vr.default,
            get passwordValidator () {
                return 0, $dW1mF.default;
            },
            get getValidationMessages () {
                return 0, $gA4YI.default;
            },
            get useGlobalState () {
                return 0, $1rS06.useGlobalState;
            },
            get trackEvent () {
                return 0, $ifZB1.trackEvent;
            },
            get updateGtagConsent () {
                return 0, $ifZB1.updateGtagConsent;
            },
            AccountFormFieldCheckbox: $3hjmJ.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("4mqh0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32cd98d5eaf9508d$export$2e2bcd8739ae039);
let $32cd98d5eaf9508d$var$script;



let $32cd98d5eaf9508d$var$initialize = ()=>{
    $32cd98d5eaf9508d$var$script = (parcelRequire("kqm1Z"));
    if ($32cd98d5eaf9508d$var$script.__esModule) $32cd98d5eaf9508d$var$script = $32cd98d5eaf9508d$var$script.default;
    $32cd98d5eaf9508d$var$script.render = (parcelRequire("36kcz")).render;
    (parcelRequire("765I3")).default($32cd98d5eaf9508d$var$script);
    $32cd98d5eaf9508d$var$script.__scopeId = "data-v-793525";
    $32cd98d5eaf9508d$var$script.__file = "AccountFormFieldRadio.vue";
};
$32cd98d5eaf9508d$var$initialize();
var $32cd98d5eaf9508d$export$2e2bcd8739ae039 = $32cd98d5eaf9508d$var$script;

});
parcelRegister("kqm1Z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ede753453979c2a0$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $fRZwI = parcelRequire("fRZwI");
var $ede753453979c2a0$export$2e2bcd8739ae039 = {
    __name: "AccountFormFieldRadio",
    props: /*#__PURE__*/ (0, $TusQn.mergeModels)({
        label: {
            required: true
        },
        autoCompleteType: {
            default: null
        },
        id: {
            required: true
        },
        isRequired: {
            default: false
        },
        options: {
            default: [
                {
                    id: "none",
                    label: "None",
                    value: "none"
                }
            ],
            required: true
        }
    }, {
        "modelValue": {},
        "modelModifiers": {}
    }),
    emits: [
        "update:modelValue"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const model = (0, $TusQn.useModel)(__props, "modelValue");
        const __returned__ = {
            props: props,
            model: model,
            get ErrorMessage () {
                return 0, $fRZwI.ErrorMessage;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("36kcz", function(module, exports) {

$parcel$export(module.exports, "render", () => $24219a4729862b1e$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $24219a4729862b1e$var$_hoisted_1 = {
    class: "mt-6"
};
const $24219a4729862b1e$var$_hoisted_2 = [
    "for"
];
const $24219a4729862b1e$var$_hoisted_3 = {
    class: "mt-3"
};
const $24219a4729862b1e$var$_hoisted_4 = [
    "id"
];
const $24219a4729862b1e$var$_hoisted_5 = [
    "id",
    "value",
    "required",
    "autocomplete"
];
const $24219a4729862b1e$var$_hoisted_6 = [
    "for"
];
function $24219a4729862b1e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $24219a4729862b1e$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("label", {
            for: $setup.props.id,
            class: "block text-sm font-medium text-primary"
        }, (0, $8POXm.toDisplayString)($props.label), 9 /* TEXT, PROPS */ , $24219a4729862b1e$var$_hoisted_2),
        (0, $TusQn.createElementVNode)("div", $24219a4729862b1e$var$_hoisted_3, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.props.options, (option)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    id: $setup.props.id,
                    key: option.id
                }, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
                        ref_for: true
                    }, _ctx.$attrs, {
                        id: option.id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.model = $event),
                        type: "radio",
                        value: option.value,
                        required: $setup.props.isRequired,
                        autocomplete: $setup.props.autoCompleteType,
                        class: "w-5 h-5 bg-transparent text-primary border-gray-300 focus:ring-1 focus:ring-highlight"
                    }), null, 16 /* FULL_PROPS */ , $24219a4729862b1e$var$_hoisted_5), [
                        [
                            (0, $eeJ70.vModelRadio),
                            $setup.model
                        ]
                    ]),
                    (0, $TusQn.createElementVNode)("label", {
                        for: $setup.props.id,
                        class: "ml-3 text-sm font-medium text-primary"
                    }, (0, $8POXm.toDisplayString)(option.label ? option.label : option.labelI18n ? _ctx.$t(option.labelI18n) : "ERR: NO LABEL"), 9 /* TEXT, PROPS */ , $24219a4729862b1e$var$_hoisted_6)
                ], 8 /* PROPS */ , $24219a4729862b1e$var$_hoisted_4);
            }), 128 /* KEYED_FRAGMENT */ )),
            (0, $TusQn.renderSlot)(_ctx.$slots, "default"),
            (0, $TusQn.createVNode)($setup["ErrorMessage"], {
                name: $setup.props.id,
                class: "px-2 mt-2 text-sm text-red-400 dark:text-red-400",
                as: "p"
            }, null, 8 /* PROPS */ , [
                "name"
            ])
        ])
    ]);
}

});

parcelRegister("765I3", function(module, exports) {

$parcel$export(module.exports, "default", () => $52ad85bb4edf7c18$export$2e2bcd8739ae039);
let $52ad85bb4edf7c18$var$NOOP = ()=>{};
var $52ad85bb4edf7c18$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("3FNUq", function(module, exports) {

$parcel$export(module.exports, "registerSpec", () => $2acbea51f145620c$export$907ff843733bc3de);
$parcel$export(module.exports, "companyDetailsSpec", () => $2acbea51f145620c$export$3e5d8299d9c6e483);
$parcel$export(module.exports, "accountDetailsSpec", () => $2acbea51f145620c$export$a224d9c4b2776dc7);

var $lR3qp = parcelRequire("lR3qp");
var $4lpPx = parcelRequire("4lpPx");
var $4Gqbx = parcelRequire("4Gqbx");
var $fEFLm = parcelRequire("fEFLm");
const $2acbea51f145620c$export$907ff843733bc3de = (0, $lR3qp.default)({
    user: (0, $4Gqbx.default)((0, $fEFLm.default)({}, "user"), (0, $4lpPx.default)([
        "gender",
        "firstName",
        "lastName",
        "situation",
        "job",
        "streetAddress",
        "zipCode",
        "city",
        "phoneNumber",
        "country",
        "email",
        "communicationPreference",
        "communicationLanguage",
        "roleInCompany",
        "department",
        "salt",
        "verifier"
    ])),
    company: (0, $4Gqbx.default)((0, $fEFLm.default)({}, "company"), (0, $4lpPx.default)([
        "companyName",
        "numberOfEmployees",
        "industry",
        "website",
        "legalForm",
        "taxNumber",
        "commercialRegisterNumber",
        "streetAddress",
        "zipCode",
        "city",
        "country"
    ]))
});
const $2acbea51f145620c$export$3e5d8299d9c6e483 = (0, $lR3qp.default)({
    company: (0, $4Gqbx.default)((0, $fEFLm.default)({}, "company"), (0, $4lpPx.default)([
        "companyName",
        "numberOfEmployees",
        "industry",
        "website",
        "legalForm",
        "taxNumber",
        "commercialRegisterNumber",
        "streetAddress",
        "zipCode",
        "city",
        "country"
    ]))
});
const $2acbea51f145620c$export$a224d9c4b2776dc7 = (0, $lR3qp.default)({
    user: (0, $4Gqbx.default)((0, $fEFLm.default)({}, "user"), (0, $4lpPx.default)([
        "gender",
        "firstName",
        "lastName",
        "streetAddress",
        "zipCode",
        "city",
        "phoneNumber",
        "country",
        "communicationPreference",
        "communicationLanguage",
        "roleInCompany",
        "department",
        "email"
    ]))
});

});

parcelRegister("dW1mF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a251c01e803fc17c$export$2e2bcd8739ae039);

var $hEJWZ = parcelRequire("hEJWZ");

var $3o02A = parcelRequire("3o02A");
const $a251c01e803fc17c$var$createPasswordValidator = ({ minLength: minLength = "Password must be at least 8 characters long", maxLength: maxLength = "Password cannot be more than 128 characters long", lowercase: lowercase = "Password must contain at least one lowercase letter", uppercase: uppercase = "Password must contain at least one uppercase letter", containNumber: containNumber = "Password must contain at least one number", specialCharacter: specialCharacter = "Password must contain at least one special character", required: required = "Password is required" } = {})=>{
    const owaspRules = [
        // require 8 characters at least
        (password)=>{
            if (password.length < 8) return minLength;
            return null;
        },
        // require 128 characters max
        (password)=>{
            if (password.length > 128) return maxLength;
            return null;
        },
        // require at least one lowercase letter
        (password)=>{
            if (!/[a-z]/.test(password)) return lowercase;
            return null;
        },
        // require at least one uppercase letter
        (password)=>{
            if (!/[A-Z]/.test(password)) return uppercase;
            return null;
        },
        // require at least one number
        (password)=>{
            if (!/[0-9]/.test(password)) return containNumber;
            return null;
        },
        // require at least one special character
        (password)=>{
            if (!/[^A-Za-z0-9]/.test(password)) return specialCharacter;
            return null;
        }
    ];
    return $hEJWZ.string().required(required).test("validation-rules", function validateRules(value) {
        const errors = owaspRules.map((rule)=>rule(value)).filter((0, $3o02A.default));
        if (errors.length) return this.createError({
            message: errors.join("<br />")
        });
        return true;
    });
};
var $a251c01e803fc17c$export$2e2bcd8739ae039 = $a251c01e803fc17c$var$createPasswordValidator;

});

parcelRegister("gA4YI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c123debc722711cf$export$2e2bcd8739ae039);

var $jFUWD = parcelRequire("jFUWD");
const $c123debc722711cf$var$getValidationMessages = ()=>{
    const { t: t } = (0, $jFUWD.useI18n)();
    return {
        required: t("passwordValidator.passwordRequired"),
        minLength: t("passwordValidator.minLength"),
        maxLength: t("passwordValidator.maxLength"),
        lowercase: t("passwordValidator.lowercase"),
        uppercase: t("passwordValidator.uppercase"),
        containNumber: t("passwordValidator.containNumber"),
        specialCharacter: t("passwordValidator.specialCharacter")
    };
};
var $c123debc722711cf$export$2e2bcd8739ae039 = $c123debc722711cf$var$getValidationMessages;

});

parcelRegister("3hjmJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2631fb3cb6a5717d$export$2e2bcd8739ae039);
let $2631fb3cb6a5717d$var$script;



let $2631fb3cb6a5717d$var$initialize = ()=>{
    $2631fb3cb6a5717d$var$script = (parcelRequire("jRvaQ"));
    if ($2631fb3cb6a5717d$var$script.__esModule) $2631fb3cb6a5717d$var$script = $2631fb3cb6a5717d$var$script.default;
    $2631fb3cb6a5717d$var$script.render = (parcelRequire("lQtYE")).render;
    (parcelRequire("iHpTY")).default($2631fb3cb6a5717d$var$script);
    $2631fb3cb6a5717d$var$script.__scopeId = "data-v-44cc89";
    $2631fb3cb6a5717d$var$script.__file = "AccountFormFieldCheckbox.vue";
};
$2631fb3cb6a5717d$var$initialize();
var $2631fb3cb6a5717d$export$2e2bcd8739ae039 = $2631fb3cb6a5717d$var$script;

});
parcelRegister("jRvaQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e75b2609c022ece7$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $fRZwI = parcelRequire("fRZwI");
var $e75b2609c022ece7$export$2e2bcd8739ae039 = {
    __name: "AccountFormFieldCheckbox",
    props: /*#__PURE__*/ (0, $TusQn.mergeModels)({
        label: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        isRequired: {
            type: Boolean,
            default: false
        }
    }, {
        "modelValue": {},
        "modelModifiers": {}
    }),
    emits: [
        "update:modelValue"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const model = (0, $TusQn.useModel)(__props, "modelValue");
        const __returned__ = {
            props: props,
            model: model,
            get ErrorMessage () {
                return 0, $fRZwI.ErrorMessage;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("lQtYE", function(module, exports) {

$parcel$export(module.exports, "render", () => $fe75b52edd1d13c3$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $fe75b52edd1d13c3$var$_hoisted_1 = {
    class: "mt-6"
};
const $fe75b52edd1d13c3$var$_hoisted_2 = [
    "for"
];
const $fe75b52edd1d13c3$var$_hoisted_3 = [
    "id",
    "required"
];
const $fe75b52edd1d13c3$var$_hoisted_4 = {
    key: 0,
    class: "w-4 h-4 text-white",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
};
const $fe75b52edd1d13c3$var$_hoisted_5 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "3",
    d: "M5 13l4 4L19 7"
}, null, -1 /* HOISTED */ );
const $fe75b52edd1d13c3$var$_hoisted_6 = [
    $fe75b52edd1d13c3$var$_hoisted_5
];
const $fe75b52edd1d13c3$var$_hoisted_7 = [
    "innerHTML"
];
function $fe75b52edd1d13c3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $fe75b52edd1d13c3$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("label", {
            for: $setup.props.id,
            class: "flex items-center space-x-2 cursor-pointer"
        }, [
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)(_ctx.$attrs, {
                id: $setup.props.id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.model = $event),
                type: "checkbox",
                required: $setup.props.isRequired,
                class: "absolute opacity-0 w-5 h-5 z-10"
            }), null, 16 /* FULL_PROPS */ , $fe75b52edd1d13c3$var$_hoisted_3), [
                [
                    (0, $eeJ70.vModelCheckbox),
                    $setup.model
                ]
            ]),
            (0, $TusQn.createElementVNode)("div", {
                class: (0, $8POXm.normalizeClass)([
                    "w-5 h-5 flex items-center justify-center border border-gray-300 rounded peer-focus:ring-1 peer-focus:ring-highlight",
                    {
                        "bg-secondary": $setup.model
                    }
                ])
            }, [
                $setup.model ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $fe75b52edd1d13c3$var$_hoisted_4, $fe75b52edd1d13c3$var$_hoisted_6)) : (0, $TusQn.createCommentVNode)("v-if", true)
            ], 2 /* CLASS */ ),
            (0, $TusQn.createElementVNode)("span", {
                innerHTML: $setup.props.label,
                class: "text-sm font-medium text-primary"
            }, null, 8 /* PROPS */ , $fe75b52edd1d13c3$var$_hoisted_7)
        ], 8 /* PROPS */ , $fe75b52edd1d13c3$var$_hoisted_2),
        (0, $TusQn.createVNode)($setup["ErrorMessage"], {
            name: $setup.props.id,
            class: "mt-2 text-sm text-red-400",
            as: "p"
        }, null, 8 /* PROPS */ , [
            "name"
        ])
    ]);
}

});

parcelRegister("iHpTY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9d055ae6d4d222f$export$2e2bcd8739ae039);
let $d9d055ae6d4d222f$var$NOOP = ()=>{};
var $d9d055ae6d4d222f$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("fKAbR", function(module, exports) {

$parcel$export(module.exports, "render", () => $b7773982ac45e92b$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $b7773982ac45e92b$var$_hoisted_1 = {
    class: "text-3xl text-center text-basecolor mb-8"
};
const $b7773982ac45e92b$var$_hoisted_2 = {
    class: "max-w-4xl mx-auto px-16 py-8 base-gradient text-primary rounded-lg gap-x-3"
};
const $b7773982ac45e92b$var$_hoisted_3 = {
    class: "text-2xl"
};
const $b7773982ac45e92b$var$_hoisted_4 = {
    class: "px-4 pb-36 pt-8 sm:px-6 lg:col-start-1 lg:row-start-1 lg:px-0 lg:pb-16"
};
const $b7773982ac45e92b$var$_hoisted_5 = {
    class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-3 items-center"
};
const $b7773982ac45e92b$var$_hoisted_6 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-3"
}, null, -1 /* HOISTED */ );
const $b7773982ac45e92b$var$_hoisted_7 = {
    class: "max-w-4xl mx-auto px-16 py-8 mt-8 base-gradient text-primary rounded-lg"
};
const $b7773982ac45e92b$var$_hoisted_8 = {
    class: "text-2xl"
};
const $b7773982ac45e92b$var$_hoisted_9 = {
    class: "px-4 pb-36 pt-8 sm:px-6 lg:col-start-1 lg:row-start-1 lg:px-0 lg:pb-16"
};
const $b7773982ac45e92b$var$_hoisted_10 = {
    class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-3"
};
const $b7773982ac45e92b$var$_hoisted_11 = {
    class: "grid grid-cols-2 md:grid-cols-3 gap-x-3"
};
const $b7773982ac45e92b$var$_hoisted_12 = {
    class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-3"
};
const $b7773982ac45e92b$var$_hoisted_13 = {
    class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-3"
};
const $b7773982ac45e92b$var$_hoisted_14 = {
    class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-3"
};
const $b7773982ac45e92b$var$_hoisted_15 = {
    class: "flex flex-row justify-end max-w-4xl mx-auto mt-8"
};
const $b7773982ac45e92b$var$_hoisted_16 = {
    type: "submit",
    class: "w-full mt-4 px-14 py-2 btn-cta sm:order-last sm:w-auto"
};
function $b7773982ac45e92b$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        (0, $TusQn.createElementVNode)("h2", $b7773982ac45e92b$var$_hoisted_1, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.accountForm.title")), 1 /* TEXT */ ),
        (0, $TusQn.createElementVNode)("form", {
            onSubmit: _cache[12] || (_cache[12] = (...args)=>$setup.submit && $setup.submit(...args)),
            class: "m-10"
        }, [
            (0, $TusQn.createElementVNode)("div", $b7773982ac45e92b$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("h2", $b7773982ac45e92b$var$_hoisted_3, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.accountForm.companyDetailsTitle")), 1 /* TEXT */ ),
                (0, $TusQn.createElementVNode)("div", $b7773982ac45e92b$var$_hoisted_4, [
                    (0, $TusQn.createElementVNode)("div", $b7773982ac45e92b$var$_hoisted_5, [
                        (0, $TusQn.createVNode)($setup["InPlaceAlert"], {
                            message: $setup.userFriendlyError,
                            type: "error",
                            class: "col-span-2",
                            onCloseAlert: _cache[0] || (_cache[0] = ($event)=>$setup.userFriendlyError = "")
                        }, null, 8 /* PROPS */ , [
                            "message"
                        ]),
                        (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                            id: "company.companyName",
                            label: _ctx.$t("registerView.accountForm.labels.companyName"),
                            "is-required": true,
                            modelValue: $setup.companyName,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.companyName = $event),
                            "input-type": "text"
                        }, $setup.companyNameAttrs, {
                            "auto-complete-type": "organization"
                        }), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ]),
                        (0, $TusQn.createVNode)($setup["AccountFormFieldSelect"], (0, $TusQn.mergeProps)({
                            id: "company.country",
                            label: _ctx.$t("registerView.accountForm.labels.country"),
                            "is-required": true,
                            modelValue: $setup.country,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.country = $event)
                        }, $setup.countryAttrs, {
                            options: $setup.countryOptions
                        }), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue",
                            "options"
                        ])
                    ]),
                    $b7773982ac45e92b$var$_hoisted_6
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $b7773982ac45e92b$var$_hoisted_7, [
                (0, $TusQn.createElementVNode)("h2", $b7773982ac45e92b$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.accountForm.ownerDetailsTitle")), 1 /* TEXT */ ),
                (0, $TusQn.createElementVNode)("div", $b7773982ac45e92b$var$_hoisted_9, [
                    (0, $TusQn.createElementVNode)("div", $b7773982ac45e92b$var$_hoisted_10, [
                        (0, $TusQn.createElementVNode)("div", $b7773982ac45e92b$var$_hoisted_11, [
                            (0, $TusQn.createVNode)($setup["AccountFormFieldSelect"], (0, $TusQn.mergeProps)({
                                class: "md:col-span-1",
                                id: "user.gender",
                                label: _ctx.$t("registerView.accountForm.labels.gender"),
                                "is-required": true,
                                modelValue: $setup.gender,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.gender = $event)
                            }, $setup.genderAttrs, {
                                "auto-complete-type": "gender",
                                options: $setup.genderOptions
                            }), null, 16 /* FULL_PROPS */ , [
                                "label",
                                "modelValue",
                                "options"
                            ]),
                            (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                                class: "md:col-span-2",
                                id: "user.firstName",
                                label: _ctx.$t("registerView.accountForm.labels.firstName"),
                                "is-required": true,
                                modelValue: $setup.firstName,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.firstName = $event),
                                "input-type": "text"
                            }, $setup.firstNameAttrs, {
                                "auto-complete-type": "firstname"
                            }), null, 16 /* FULL_PROPS */ , [
                                "label",
                                "modelValue"
                            ])
                        ]),
                        (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                            id: "user.lastName",
                            label: _ctx.$t("registerView.accountForm.labels.lastName"),
                            "is-required": true,
                            modelValue: $setup.lastName,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.lastName = $event),
                            "input-type": "text"
                        }, $setup.lastNameAttrs, {
                            "auto-complete-type": "lastname"
                        }), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $b7773982ac45e92b$var$_hoisted_12, [
                        (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                            id: "user.email",
                            label: _ctx.$t("registerView.accountForm.labels.email"),
                            "is-required": true,
                            modelValue: $setup.email,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.email = $event)
                        }, $setup.emailAttrs, {
                            "input-type": "email",
                            "auto-complete-type": "email"
                        }), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ]),
                        (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                            id: "user.confirmEmail",
                            label: _ctx.$t("registerView.accountForm.labels.confirmEmail"),
                            "is-required": true,
                            modelValue: $setup.confirmEmail,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.confirmEmail = $event)
                        }, $setup.confirmEmailAttrs, {
                            "input-type": "email",
                            "auto-complete-type": "confirm-email"
                        }), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $b7773982ac45e92b$var$_hoisted_13, [
                        (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                            id: "user.password",
                            label: _ctx.$t("registerView.accountForm.labels.password"),
                            "is-required": true,
                            modelValue: $setup.password,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.password = $event)
                        }, $setup.passwordAttrs, {
                            "input-type": "password",
                            "auto-complete-type": "password"
                        }), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ]),
                        (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                            id: "user.confirmPassword",
                            label: _ctx.$t("registerView.accountForm.labels.confirmPassword"),
                            "is-required": true,
                            modelValue: $setup.confirmPassword,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.confirmPassword = $event)
                        }, $setup.confirmPasswordAttrs, {
                            "input-type": "password",
                            "auto-complete-type": "confirm-password"
                        }), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $b7773982ac45e92b$var$_hoisted_14, [
                        (0, $TusQn.createVNode)($setup["AccountFormFieldCheckbox"], (0, $TusQn.mergeProps)({
                            id: "termsAccepted",
                            label: _ctx.$t("registerView.accountForm.labels.terms"),
                            "is-required": true,
                            modelValue: $setup.termsAccepted,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.termsAccepted = $event)
                        }, $setup.termsAcceptedAttrs), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ]),
                        (0, $TusQn.createVNode)($setup["AccountFormFieldCheckbox"], (0, $TusQn.mergeProps)({
                            id: "privacyAccepted",
                            label: _ctx.$t("registerView.accountForm.labels.privacy"),
                            "is-required": true,
                            modelValue: $setup.privacyAccepted,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event)=>$setup.privacyAccepted = $event)
                        }, $setup.privacyAcceptedAttrs), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ])
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $b7773982ac45e92b$var$_hoisted_15, [
                (0, $TusQn.createVNode)($setup["WithLoader"], {
                    "is-loading": $setup.isSendingRegisterForm || $setup.isLoading
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createElementVNode)("button", $b7773982ac45e92b$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.accountForm.confirm")), 1 /* TEXT */ )
                        ]),
                    _: 1 /* STABLE */ 
                }, 8 /* PROPS */ , [
                    "is-loading"
                ])
            ])
        ], 32 /* NEED_HYDRATION */ )
    ]);
}

});

parcelRegister("kvJtC", function(module, exports) {

$parcel$export(module.exports, "default", () => $eee9fa9e215ef847$export$2e2bcd8739ae039);
let $eee9fa9e215ef847$var$NOOP = ()=>{};
var $eee9fa9e215ef847$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("2x7Ab", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d848b97782a8cb3$export$2e2bcd8739ae039);
let $1d848b97782a8cb3$var$script;



let $1d848b97782a8cb3$var$initialize = ()=>{
    $1d848b97782a8cb3$var$script = (parcelRequire("dyvlK"));
    if ($1d848b97782a8cb3$var$script.__esModule) $1d848b97782a8cb3$var$script = $1d848b97782a8cb3$var$script.default;
    $1d848b97782a8cb3$var$script.render = (parcelRequire("es579")).render;
    (parcelRequire("2lnGJ")).default($1d848b97782a8cb3$var$script);
    $1d848b97782a8cb3$var$script.__scopeId = "data-v-8288d1";
    $1d848b97782a8cb3$var$script.__file = "AccountDetailsIndividualComponent.vue";
};
$1d848b97782a8cb3$var$initialize();
var $1d848b97782a8cb3$export$2e2bcd8739ae039 = $1d848b97782a8cb3$var$script;

});
parcelRegister("dyvlK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9de6c4c3e0c1f075$export$2e2bcd8739ae039);

var $jFUWD = parcelRequire("jFUWD");

var $fRZwI = parcelRequire("fRZwI");

var $hEJWZ = parcelRequire("hEJWZ");

var $ey2ik = parcelRequire("ey2ik");
var $l8CfQ = parcelRequire("l8CfQ");
var $kheUU = parcelRequire("kheUU");
var $hyLUA = parcelRequire("hyLUA");
var $4Gqbx = parcelRequire("4Gqbx");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $3Wj1M = parcelRequire("3Wj1M");

var $bRn2L = parcelRequire("bRn2L");

var $1F5z6 = parcelRequire("1F5z6");

var $jYHy6 = parcelRequire("jYHy6");

var $40DKr = parcelRequire("40DKr");

var $gQLqr = parcelRequire("gQLqr");

var $3FNUq = parcelRequire("3FNUq");

var $kW7Vr = parcelRequire("kW7Vr");

var $dW1mF = parcelRequire("dW1mF");

var $gA4YI = parcelRequire("gA4YI");

var $1rS06 = parcelRequire("1rS06");

var $ifZB1 = parcelRequire("ifZB1");

var $3hjmJ = parcelRequire("3hjmJ");
var $9de6c4c3e0c1f075$export$2e2bcd8739ae039 = {
    __name: "AccountDetailsIndividualComponent",
    emits: [
        "detailsConfirmed",
        "back"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const { t: t } = (0, $jFUWD.useI18n)();
        const validationMessages = (0, $gA4YI.default)();
        const emit = __emit;
        const { defineField: defineField, handleSubmit: handleSubmit } = (0, $fRZwI.useForm)({
            validationSchema: $hEJWZ.object({
                user: $hEJWZ.object({
                    email: $hEJWZ.string().email(t("passwordValidator.emailValid")).lowercase().required(t("passwordValidator.emailRequired")).label(t("registerView.accountForm.labels.email")),
                    confirmEmail: $hEJWZ.string().email(t("passwordValidator.emailValid")).lowercase().required(t("passwordValidator.emailRequired")).oneOf([
                        $hEJWZ.ref("email")
                    ], t("passwordValidator.emailMatch")).label(t("registerView.accountForm.labels.confirmEmail")),
                    password: (0, $dW1mF.default)(validationMessages).label(t("registerView.accountForm.labels.password")),
                    confirmPassword: $hEJWZ.string().required(t("passwordValidator.passwordRequired")).oneOf([
                        $hEJWZ.ref("password")
                    ], t("passwordValidator.passwordMatch")).label(t("registerView.accountForm.labels.confirmPassword")),
                    phoneNumber: $hEJWZ.string().label(t("registerView.accountForm.labels.phoneNumber")),
                    gender: $hEJWZ.string().required().label(t("registerView.accountForm.labels.gender")),
                    firstName: $hEJWZ.string().required().label(t("registerView.accountForm.labels.firstName")),
                    lastName: $hEJWZ.string().required().label(t("registerView.accountForm.labels.lastName")),
                    situation: $hEJWZ.string().label(t("registerView.accountForm.labels.situation")),
                    job: $hEJWZ.string().when("situation", {
                        is: "employed",
                        then: (schema)=>schema
                    }).label(t("registerView.accountForm.labels.job")),
                    streetAddress: $hEJWZ.string().label(t("registerView.accountForm.labels.streetAddress")),
                    zipCode: $hEJWZ.string().label(t("registerView.accountForm.labels.zipCode")),
                    country: $hEJWZ.string().required().label(t("registerView.accountForm.labels.country")),
                    city: $hEJWZ.string().label(t("registerView.accountForm.labels.city")),
                    termsAccepted: $hEJWZ.boolean().oneOf([
                        true
                    ], t("registerView.accountForm.labels.termsRequired")).label(t("registerView.accountForm.labels.terms")),
                    privacyAccepted: $hEJWZ.boolean().oneOf([
                        true
                    ], t("registerView.accountForm.labels.privacyRequired")).label(t("registerView.accountForm.labels.privacy"))
                })
            })
        });
        const [email, emailAttrs] = defineField("user.email");
        const [confirmEmail, confirmEmailAttrs] = defineField("user.confirmEmail");
        const [password, passwordAttrs] = defineField("user.password");
        const [confirmPassword, confirmPasswordAttrs] = defineField("user.confirmPassword");
        const [country, countryAttrs] = defineField("user.country");
        const [gender, genderAttrs] = defineField("user.gender");
        const [firstName, firstNameAttrs] = defineField("user.firstName");
        const [lastName, lastNameAttrs] = defineField("user.lastName");
        const [termsAccepted, termsAcceptedAttrs] = defineField("user.termsAccepted");
        const [privacyAccepted, privacyAcceptedAttrs] = defineField("user.privacyAccepted");
        // const [situation, situationAttrs] = defineField('user.situation');
        // const [job, jobAttrs] = defineField('user.job');
        // const [city, cityAttrs] = defineField('user.city');
        // const [phoneNumber, phoneNumberAttrs] = defineField('user.phoneNumber');
        // const [streetAddress, streetAddressAttrs] = defineField('user.streetAddress');
        // const [zipCode, zipCodeAttrs] = defineField('user.zipCode');
        country.value = "de";
        const { callEndpoint: callEndpoint, userFriendlyError: userFriendlyError, isLoading: isSendingRegisterForm } = (0, $bRn2L.default)("register");
        const { userState: userState, currentEmployees: currentEmployees, currentCourses: currentCourses } = (0, $1rS06.useGlobalState)();
        const { getUserStateFromEndpoint: getUserStateFromEndpoint, isLoading: isLoading } = (0, $gQLqr.useUserStateFromEndpoint)();
        const submit = handleSubmit(async (values)=>{
            try {
                const username = values.user.email;
                const { password: password } = values.user;
                const usernameLowercased = username.toLowerCase();
                const { salt: salt, verifier: verifier } = (0, $gQLqr.useCreateSecureRemotePassword)(usernameLowercased, password);
                const request = (0, $4Gqbx.default)((0, $l8CfQ.default)([
                    "user",
                    "salt"
                ], (0, $01W3b.toValue)(salt)), (0, $l8CfQ.default)([
                    "user",
                    "verifier"
                ], (0, $01W3b.toValue)(verifier)), (0, $3FNUq.registerSpec), (0, $hyLUA.default)([
                    "company"
                ]))(values);
                await callEndpoint((0, $ey2ik.default)("method", "POST", {
                    request: request
                }));
                (0, $ifZB1.updateGtagConsent)({
                    "analytics_storage": "granted"
                });
                (0, $ifZB1.updateGtagConsent)({
                    "ad_storage": "granted"
                });
                localStorage.setItem("gaRegisteredUserConsent", "true");
                if ((0, $kheUU.default)(userFriendlyError.value)) {
                    const userStateFromEndpoint = await getUserStateFromEndpoint(values.user.email, values.user.password); // eslint-disable-line max-len
                    if (!(0, $kheUU.default)(userStateFromEndpoint)) {
                        userState.value = (0, $ey2ik.default)("isAuthenticated", true, userStateFromEndpoint);
                        currentEmployees.value = userStateFromEndpoint.employees;
                        currentCourses.set(userStateFromEndpoint.courses);
                    }
                    (0, $ifZB1.trackEvent)("individual_registration_success", {
                        event_category: "Register",
                        event_label: "New User"
                    });
                    emit("detailsConfirmed", values);
                }
            } catch (error) {
                (0, $ifZB1.trackEvent)("individual_registration_exception", {
                    event_category: "Register",
                    event_label: "Error registering user",
                    error: error.message || "unknown"
                });
                if (error.response && error.response.data && error.response.data.error) userFriendlyError.value = error.response.data.error;
                else userFriendlyError.value = t("registerView.accountForm.errors.userExists");
            }
        });
        const __returned__ = {
            t: t,
            validationMessages: validationMessages,
            emit: emit,
            defineField: defineField,
            handleSubmit: handleSubmit,
            email: email,
            emailAttrs: emailAttrs,
            confirmEmail: confirmEmail,
            confirmEmailAttrs: confirmEmailAttrs,
            password: password,
            passwordAttrs: passwordAttrs,
            confirmPassword: confirmPassword,
            confirmPasswordAttrs: confirmPasswordAttrs,
            country: country,
            countryAttrs: countryAttrs,
            gender: gender,
            genderAttrs: genderAttrs,
            firstName: firstName,
            firstNameAttrs: firstNameAttrs,
            lastName: lastName,
            lastNameAttrs: lastNameAttrs,
            termsAccepted: termsAccepted,
            termsAcceptedAttrs: termsAcceptedAttrs,
            privacyAccepted: privacyAccepted,
            privacyAcceptedAttrs: privacyAcceptedAttrs,
            callEndpoint: callEndpoint,
            userFriendlyError: userFriendlyError,
            isSendingRegisterForm: isSendingRegisterForm,
            userState: userState,
            currentEmployees: currentEmployees,
            currentCourses: currentCourses,
            getUserStateFromEndpoint: getUserStateFromEndpoint,
            isLoading: isLoading,
            submit: submit,
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            get useForm () {
                return 0, $fRZwI.useForm;
            },
            get yup () {
                return $hEJWZ;
            },
            get assoc () {
                return 0, $ey2ik.default;
            },
            get assocPath () {
                return 0, $l8CfQ.default;
            },
            get isEmpty () {
                return 0, $kheUU.default;
            },
            get omit () {
                return 0, $hyLUA.default;
            },
            get pipe () {
                return 0, $4Gqbx.default;
            },
            toValue: $01W3b.toValue,
            AccountFormField: $3Wj1M.default,
            get useCallEndPointWith () {
                return 0, $bRn2L.default;
            },
            InPlaceAlert: $1F5z6.default,
            AccountFormFieldSelect: $jYHy6.default,
            get genderOptions () {
                return 0, $40DKr.genderOptions;
            },
            get countryOptions () {
                return 0, $40DKr.countryOptions;
            },
            get useCreateSecureRemotePassword () {
                return 0, $gQLqr.useCreateSecureRemotePassword;
            },
            get useUserStateFromEndpoint () {
                return 0, $gQLqr.useUserStateFromEndpoint;
            },
            get registerSpec () {
                return 0, $3FNUq.registerSpec;
            },
            WithLoader: $kW7Vr.default,
            get passwordValidator () {
                return 0, $dW1mF.default;
            },
            get getValidationMessages () {
                return 0, $gA4YI.default;
            },
            get useGlobalState () {
                return 0, $1rS06.useGlobalState;
            },
            get trackEvent () {
                return 0, $ifZB1.trackEvent;
            },
            get updateGtagConsent () {
                return 0, $ifZB1.updateGtagConsent;
            },
            AccountFormFieldCheckbox: $3hjmJ.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("hyLUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc8ac6ed0ffb93b6$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");
/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */ var $cc8ac6ed0ffb93b6$var$omit = /*#__PURE__*/ (0, $2jcOR.default)(function omit(names, obj) {
    var result = {};
    var index = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        index[names[idx]] = 1;
        idx += 1;
    }
    for(var prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
});
var $cc8ac6ed0ffb93b6$export$2e2bcd8739ae039 = $cc8ac6ed0ffb93b6$var$omit;

});


parcelRegister("es579", function(module, exports) {

$parcel$export(module.exports, "render", () => $a857a5d637465cf3$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $a857a5d637465cf3$var$_hoisted_1 = {
    class: "text-3xl text-center text-basecolor mb-8"
};
const $a857a5d637465cf3$var$_hoisted_2 = {
    class: "max-w-4xl mx-auto px-16 py-8 mt-8 base-gradient text-primary rounded-lg"
};
const $a857a5d637465cf3$var$_hoisted_3 = {
    class: "text-2xl"
};
const $a857a5d637465cf3$var$_hoisted_4 = {
    class: "px-4 pb-36 pt-8 sm:px-6 lg:col-start-1 lg:row-start-1 lg:px-0 lg:pb-16"
};
const $a857a5d637465cf3$var$_hoisted_5 = {
    class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-3"
};
const $a857a5d637465cf3$var$_hoisted_6 = {
    class: "grid grid-cols-2 md:grid-cols-3 gap-x-3"
};
const $a857a5d637465cf3$var$_hoisted_7 = {
    class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-3"
};
const $a857a5d637465cf3$var$_hoisted_8 = {
    class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-3"
};
const $a857a5d637465cf3$var$_hoisted_9 = {
    class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-3"
};
const $a857a5d637465cf3$var$_hoisted_10 = {
    class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-3"
};
const $a857a5d637465cf3$var$_hoisted_11 = {
    class: "flex flex-row justify-end max-w-4xl mx-auto mt-8"
};
const $a857a5d637465cf3$var$_hoisted_12 = {
    type: "submit",
    class: "w-full mt-4 px-14 py-2 btn-cta sm:order-last sm:w-auto"
};
function $a857a5d637465cf3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        (0, $TusQn.createElementVNode)("h2", $a857a5d637465cf3$var$_hoisted_1, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.accountForm.title")), 1 /* TEXT */ ),
        (0, $TusQn.createElementVNode)("form", {
            onSubmit: _cache[11] || (_cache[11] = (...args)=>$setup.submit && $setup.submit(...args)),
            class: "m-10"
        }, [
            (0, $TusQn.createElementVNode)("div", $a857a5d637465cf3$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("h2", $a857a5d637465cf3$var$_hoisted_3, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.accountForm.individualDetailsTitle")), 1 /* TEXT */ ),
                (0, $TusQn.createVNode)($setup["InPlaceAlert"], {
                    message: $setup.userFriendlyError,
                    type: "error",
                    class: "mt-3 col-span-2",
                    onCloseAlert: _cache[0] || (_cache[0] = ($event)=>$setup.userFriendlyError = "")
                }, null, 8 /* PROPS */ , [
                    "message"
                ]),
                (0, $TusQn.createElementVNode)("div", $a857a5d637465cf3$var$_hoisted_4, [
                    (0, $TusQn.createElementVNode)("div", $a857a5d637465cf3$var$_hoisted_5, [
                        (0, $TusQn.createElementVNode)("div", $a857a5d637465cf3$var$_hoisted_6, [
                            (0, $TusQn.createVNode)($setup["AccountFormFieldSelect"], (0, $TusQn.mergeProps)({
                                class: "md:col-span-1",
                                id: "user.gender",
                                label: _ctx.$t("registerView.accountForm.labels.gender"),
                                "is-required": true,
                                modelValue: $setup.gender,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.gender = $event)
                            }, $setup.genderAttrs, {
                                "auto-complete-type": "gender",
                                options: $setup.genderOptions
                            }), null, 16 /* FULL_PROPS */ , [
                                "label",
                                "modelValue",
                                "options"
                            ]),
                            (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                                class: "md:col-span-2",
                                id: "user.firstName",
                                label: _ctx.$t("registerView.accountForm.labels.firstName"),
                                "is-required": true,
                                modelValue: $setup.firstName,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.firstName = $event),
                                "input-type": "text"
                            }, $setup.firstNameAttrs, {
                                "auto-complete-type": "firstname"
                            }), null, 16 /* FULL_PROPS */ , [
                                "label",
                                "modelValue"
                            ])
                        ]),
                        (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                            id: "user.lastName",
                            label: _ctx.$t("registerView.accountForm.labels.lastName"),
                            "is-required": true,
                            modelValue: $setup.lastName,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.lastName = $event),
                            "input-type": "text"
                        }, $setup.lastNameAttrs, {
                            "auto-complete-type": "lastname"
                        }), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $a857a5d637465cf3$var$_hoisted_7, [
                        (0, $TusQn.createVNode)($setup["AccountFormFieldSelect"], (0, $TusQn.mergeProps)({
                            id: "user.country",
                            label: _ctx.$t("registerView.accountForm.labels.country"),
                            "is-required": true,
                            modelValue: $setup.country,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.country = $event)
                        }, $setup.countryAttrs, {
                            options: $setup.countryOptions
                        }), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue",
                            "options"
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $a857a5d637465cf3$var$_hoisted_8, [
                        (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                            id: "user.email",
                            label: _ctx.$t("registerView.accountForm.labels.email"),
                            "is-required": true,
                            modelValue: $setup.email,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.email = $event)
                        }, $setup.emailAttrs, {
                            "input-type": "email",
                            "auto-complete-type": "email"
                        }), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ]),
                        (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                            id: "user.confirmEmail",
                            label: _ctx.$t("registerView.accountForm.labels.confirmEmail"),
                            "is-required": true,
                            modelValue: $setup.confirmEmail,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.confirmEmail = $event)
                        }, $setup.confirmEmailAttrs, {
                            "input-type": "email",
                            "auto-complete-type": "confirm-email"
                        }), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $a857a5d637465cf3$var$_hoisted_9, [
                        (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                            id: "user.password",
                            label: _ctx.$t("registerView.accountForm.labels.password"),
                            "is-required": true,
                            modelValue: $setup.password,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.password = $event)
                        }, $setup.passwordAttrs, {
                            "input-type": "password",
                            "auto-complete-type": "password"
                        }), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ]),
                        (0, $TusQn.createVNode)($setup["AccountFormField"], (0, $TusQn.mergeProps)({
                            id: "user.confirmPassword",
                            label: _ctx.$t("registerView.accountForm.labels.confirmPassword"),
                            "is-required": true,
                            modelValue: $setup.confirmPassword,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.confirmPassword = $event)
                        }, $setup.confirmPasswordAttrs, {
                            "input-type": "password",
                            "auto-complete-type": "confirm-password"
                        }), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $a857a5d637465cf3$var$_hoisted_10, [
                        (0, $TusQn.createVNode)($setup["AccountFormFieldCheckbox"], (0, $TusQn.mergeProps)({
                            id: "user.termsAccepted",
                            label: _ctx.$t("registerView.accountForm.labels.terms"),
                            "is-required": true,
                            modelValue: $setup.termsAccepted,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.termsAccepted = $event)
                        }, $setup.termsAcceptedAttrs), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ]),
                        (0, $TusQn.createVNode)($setup["AccountFormFieldCheckbox"], (0, $TusQn.mergeProps)({
                            id: "user.privacyAccepted",
                            label: _ctx.$t("registerView.accountForm.labels.privacy"),
                            "is-required": true,
                            modelValue: $setup.privacyAccepted,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.privacyAccepted = $event)
                        }, $setup.privacyAcceptedAttrs), null, 16 /* FULL_PROPS */ , [
                            "label",
                            "modelValue"
                        ])
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $a857a5d637465cf3$var$_hoisted_11, [
                (0, $TusQn.createVNode)($setup["WithLoader"], {
                    "is-loading": $setup.isSendingRegisterForm || $setup.isLoading
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createElementVNode)("button", $a857a5d637465cf3$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("registerView.accountForm.confirm")), 1 /* TEXT */ )
                        ]),
                    _: 1 /* STABLE */ 
                }, 8 /* PROPS */ , [
                    "is-loading"
                ])
            ])
        ], 32 /* NEED_HYDRATION */ )
    ]);
}

});

parcelRegister("2lnGJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b4feaefe45bcfec$export$2e2bcd8739ae039);
let $1b4feaefe45bcfec$var$NOOP = ()=>{};
var $1b4feaefe45bcfec$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("lcF0M", function(module, exports) {

$parcel$export(module.exports, "render", () => $f6fa87fe2e424e99$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $f6fa87fe2e424e99$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return !$setup.isIndividualPlan($props.chosenPlan) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["AccountDetailsCompanyComponent"], {
        key: 0,
        onDetailsConfirmed: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("detailsConfirmed", $event)),
        onBack: _cache[1] || (_cache[1] = ($event)=>$setup.emit("back"))
    })) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["AccountDetailsIndividualComponent"], {
        key: 1,
        onDetailsConfirmed: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("detailsConfirmed", $event)),
        onBack: _cache[3] || (_cache[3] = ($event)=>$setup.emit("back"))
    }));
}

});

parcelRegister("efIaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a604bac18997d39a$export$2e2bcd8739ae039);
let $a604bac18997d39a$var$NOOP = ()=>{};
var $a604bac18997d39a$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("chFPN", function(module, exports) {

$parcel$export(module.exports, "render", () => $8f178607802e0331$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $8f178607802e0331$var$_hoisted_1 = {
    class: "w-full h-full"
};
const $8f178607802e0331$var$_hoisted_2 = {
    class: "mx-auto max-w-7xl pt-24"
};
const $8f178607802e0331$var$_hoisted_3 = {
    class: "pt-24"
};
function $8f178607802e0331$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["RegisterNavigationBar"]),
        $setup.isLocalDevMode === true ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
            key: 0,
            onClick: $setup.devSkipStep
        }, " DEV SKIP STEP ")) : (0, $TusQn.createCommentVNode)("v-if", true),
        (0, $TusQn.createElementVNode)("div", $8f178607802e0331$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $8f178607802e0331$var$_hoisted_2, [
                (0, $TusQn.createVNode)($setup["ProcessCircles"], {
                    steps: $setup.steps,
                    size: "24",
                    onRequestStepShortcut: $setup.stepShortcutClicked
                }),
                (0, $TusQn.createElementVNode)("div", $8f178607802e0331$var$_hoisted_3, [
                    $setup.currentRegisterStep === $setup.RegisterSteps.ChoosePlan ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["ChoosePlansComponent"], {
                        key: 0,
                        onPlanChosen: $setup.onPlanChosen,
                        onBack: $setup.onGoBack
                    })) : (0, $TusQn.createCommentVNode)("v-if", true),
                    $setup.currentRegisterStep === $setup.RegisterSteps.AccountDetails ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["CreateAccountStepComponent"], {
                        key: 1,
                        "chosen-plan": $setup.chosenPlan,
                        onDetailsConfirmed: $setup.onDetailsConfirmed,
                        onBack: $setup.onGoBack
                    }, null, 8 /* PROPS */ , [
                        "chosen-plan"
                    ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                    $setup.currentRegisterStep === $setup.RegisterSteps.Billing ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["BillingComponent"], {
                        key: 2,
                        "email-for-payment": $setup.emailForPayment,
                        "chosen-plan": $setup.chosenPlan,
                        vat: $setup.chosenVat,
                        onPaymentSuccess: $setup.onPaymentSuccess,
                        onFreePaymentSuccess: $setup.onFreePayment,
                        onBack: $setup.onGoBack
                    }, null, 8 /* PROPS */ , [
                        "email-for-payment",
                        "chosen-plan",
                        "vat"
                    ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                    $setup.currentRegisterStep === $setup.RegisterSteps.Confirmation ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["ConfirmationComponent"], {
                        key: 3,
                        onBack: $setup.onGoBack,
                        "payment-success": $setup.wasPaymentSuccess,
                        "free-payment-success": $setup.wasFreePaymentSuccess
                    }, null, 8 /* PROPS */ , [
                        "payment-success",
                        "free-payment-success"
                    ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                ])
            ])
        ])
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("b26Fc", function(module, exports) {

$parcel$export(module.exports, "default", () => $80850cd96eb43f87$export$2e2bcd8739ae039);
let $80850cd96eb43f87$var$NOOP = ()=>{};
var $80850cd96eb43f87$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("jHZ5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5916c9cda945365$export$2e2bcd8739ae039);
let $e5916c9cda945365$var$script;



let $e5916c9cda945365$var$initialize = ()=>{
    $e5916c9cda945365$var$script = (parcelRequire("4lTyR"));
    if ($e5916c9cda945365$var$script.__esModule) $e5916c9cda945365$var$script = $e5916c9cda945365$var$script.default;
    $e5916c9cda945365$var$script.render = (parcelRequire("5Sddj")).render;
    (parcelRequire("668dj")).default($e5916c9cda945365$var$script);
    $e5916c9cda945365$var$script.__scopeId = "data-v-64d6a0";
    $e5916c9cda945365$var$script.__file = "LandingPageView.vue";
};
$e5916c9cda945365$var$initialize();
var $e5916c9cda945365$export$2e2bcd8739ae039 = $e5916c9cda945365$var$script;

});
parcelRegister("4lTyR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $32b438e580358ccc$export$2e2bcd8739ae039);

var $5smZ6 = parcelRequire("5smZ6");

var $32KFM = parcelRequire("32KFM");

var $kSkA0 = parcelRequire("kSkA0");

var $5C9Dc = parcelRequire("5C9Dc");

var $39atu = parcelRequire("39atu");

var $9rs6C = parcelRequire("9rs6C");

var $dYKt3 = parcelRequire("dYKt3");
var $32b438e580358ccc$export$2e2bcd8739ae039 = {
    __name: "LandingPageView",
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            LandingHero: $5smZ6.default,
            LandingWhyCyberalarm: $32KFM.default,
            LandingHowItWorks: $kSkA0.default,
            LandingCourses: $5C9Dc.default,
            LandingAboutUs: $39atu.default,
            LandingPrices: $9rs6C.default,
            LandingAlarm: $dYKt3.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("5smZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f91658657a0be3a$export$2e2bcd8739ae039);
let $3f91658657a0be3a$var$script;



let $3f91658657a0be3a$var$initialize = ()=>{
    $3f91658657a0be3a$var$script = (parcelRequire("ilawm"));
    if ($3f91658657a0be3a$var$script.__esModule) $3f91658657a0be3a$var$script = $3f91658657a0be3a$var$script.default;
    $3f91658657a0be3a$var$script.render = (parcelRequire("aUCsA")).render;
    (parcelRequire("6SU8c")).default($3f91658657a0be3a$var$script);
    $3f91658657a0be3a$var$script.__scopeId = "data-v-fa8f50";
    $3f91658657a0be3a$var$script.__file = "LandingHero.vue";
};
$3f91658657a0be3a$var$initialize();
var $3f91658657a0be3a$export$2e2bcd8739ae039 = $3f91658657a0be3a$var$script;

});
parcelRegister("ilawm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d5a25960b0d021aa$export$2e2bcd8739ae039);

var $jFUWD = parcelRequire("jFUWD");

var $73mM4 = parcelRequire("73mM4");

var $580JV = parcelRequire("580JV");

var $lNKtN = parcelRequire("lNKtN");

var $hzqmY = parcelRequire("hzqmY");

var $6Az8w = parcelRequire("6Az8w");
var $d5a25960b0d021aa$export$2e2bcd8739ae039 = {
    __name: "LandingHero",
    setup (__props, { expose: __expose }) {
        __expose();
        const i18n = (0, $jFUWD.useI18n)();
        const { locale: locale } = (0, $jFUWD.useI18n)();
        const heroImg1 = (0, $hzqmY.default)("landing_Cyber_Main_card.png", locale.value);
        const heroImg2 = (0, $hzqmY.default)("landing_hero_img_2.png", locale.value);
        const heroImg3 = (0, $hzqmY.default)("landing_hero_img_3.png", locale.value);
        const getStartedNavigation = (0, $580JV.default).i18nRoute({
            name: "register"
        });
        const stats = [
            {
                id: 1,
                name: i18n.t("landingPage.heroSection.stats[0]"),
                value: (0, $lNKtN.default)
            },
            {
                id: 2,
                name: i18n.t("landingPage.heroSection.stats[1]"),
                value: (0, $lNKtN.default)
            },
            {
                id: 3,
                name: i18n.t("landingPage.heroSection.stats[2]"),
                value: (0, $lNKtN.default)
            }
        ];
        const __returned__ = {
            i18n: i18n,
            locale: locale,
            heroImg1: heroImg1,
            heroImg2: heroImg2,
            heroImg3: heroImg3,
            getStartedNavigation: getStartedNavigation,
            stats: stats,
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            get RouterLink () {
                return 0, $73mM4.RouterLink;
            },
            get Trans () {
                return 0, $580JV.default;
            },
            RoundedCheckIcon: $lNKtN.default,
            get resolveImgUrl () {
                return 0, $hzqmY.default;
            },
            get Vue3Marquee () {
                return 0, $6Az8w.Vue3Marquee;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("lNKtN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdf23a731eed9cf0$export$2e2bcd8739ae039);
let $fdf23a731eed9cf0$var$script;


let $fdf23a731eed9cf0$var$initialize = ()=>{
    $fdf23a731eed9cf0$var$script = {};
    $fdf23a731eed9cf0$var$script.render = (parcelRequire("5vPAT")).render;
    (parcelRequire("2KkDc")).default($fdf23a731eed9cf0$var$script);
    $fdf23a731eed9cf0$var$script.__scopeId = "data-v-8db472";
    $fdf23a731eed9cf0$var$script.__file = "RoundedCheckIcon.vue";
};
$fdf23a731eed9cf0$var$initialize();
var $fdf23a731eed9cf0$export$2e2bcd8739ae039 = $fdf23a731eed9cf0$var$script;

});
parcelRegister("5vPAT", function(module, exports) {

$parcel$export(module.exports, "render", () => $4037de84d4d332be$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $4037de84d4d332be$var$_hoisted_1 = {
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $4037de84d4d332be$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("rect", {
    x: "2.5",
    y: "2.5",
    width: "45",
    height: "45",
    rx: "22.5",
    fill: "white"
}, null, -1 /* HOISTED */ );
const $4037de84d4d332be$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("rect", {
    x: "2.5",
    y: "2.5",
    width: "45",
    height: "45",
    rx: "22.5",
    stroke: "#FC4C71",
    "stroke-width": "5"
}, null, -1 /* HOISTED */ );
const $4037de84d4d332be$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("path", {
    d: "M24.9974 4.16797C13.4974 4.16797 4.16406 13.5013 4.16406 25.0013C4.16406 36.5013 13.4974 45.8346 24.9974 45.8346C36.4974 45.8346 45.8307 36.5013 45.8307 25.0013C45.8307 13.5013 36.4974 4.16797 24.9974 4.16797ZM19.3516 33.9388L11.8724 26.4596C11.6795 26.2668 11.5265 26.0378 11.4221 25.7858C11.3177 25.5338 11.264 25.2637 11.264 24.9909C11.264 24.7181 11.3177 24.448 11.4221 24.196C11.5265 23.944 11.6795 23.715 11.8724 23.5221C12.0653 23.3293 12.2943 23.1763 12.5463 23.0719C12.7983 22.9675 13.0684 22.9138 13.3411 22.9138C13.6139 22.9138 13.884 22.9675 14.136 23.0719C14.388 23.1763 14.617 23.3293 14.8099 23.5221L20.8307 29.5221L35.1641 15.1888C35.5536 14.7993 36.0819 14.5804 36.6328 14.5804C37.1837 14.5804 37.712 14.7993 38.1016 15.1888C38.4911 15.5783 38.7099 16.1067 38.7099 16.6576C38.7099 17.2084 38.4911 17.7368 38.1016 18.1263L22.2891 33.9388C22.0963 34.1319 21.8674 34.2852 21.6154 34.3897C21.3633 34.4943 21.0932 34.5481 20.8203 34.5481C20.5475 34.5481 20.2773 34.4943 20.0253 34.3897C19.7732 34.2852 19.5443 34.1319 19.3516 33.9388Z",
    fill: "#FC4C71"
}, null, -1 /* HOISTED */ );
const $4037de84d4d332be$var$_hoisted_5 = [
    $4037de84d4d332be$var$_hoisted_2,
    $4037de84d4d332be$var$_hoisted_3,
    $4037de84d4d332be$var$_hoisted_4
];
function $4037de84d4d332be$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $4037de84d4d332be$var$_hoisted_1, $4037de84d4d332be$var$_hoisted_5);
}

});

parcelRegister("2KkDc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fffe19a234774ce$export$2e2bcd8739ae039);
let $1fffe19a234774ce$var$NOOP = ()=>{};
var $1fffe19a234774ce$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("hzqmY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccaa2903174a7c96$export$2e2bcd8739ae039);
const $ccaa2903174a7c96$var$resolveImgUrl = (imgPath, language)=>{
    const imgUrl = `/images/${language}/${imgPath}`;
    return imgPath ? imgUrl : imgPath;
};
var $ccaa2903174a7c96$export$2e2bcd8739ae039 = $ccaa2903174a7c96$var$resolveImgUrl;

});

parcelRegister("6Az8w", function(module, exports) {

$parcel$export(module.exports, "Vue3Marquee", () => $4cc15c40e86bfdfa$export$d86fa7dbcf6bc097);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
(function() {
    "use strict";
    try {
        if (typeof document != "undefined") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode('.vue3-marquee{display:flex!important;position:relative}.vue3-marquee.horizontal{overflow-x:hidden!important;flex-direction:row!important;width:100%;height:max-content}.vue3-marquee.vertical{overflow-y:hidden!important;flex-direction:column!important;height:100%;width:max-content}.vue3-marquee:hover>.marquee{animation-play-state:var(--pauseOnHover)}.vue3-marquee:active>.marquee{animation-play-state:var(--pauseOnClick)}.vue3-marquee>.marquee{flex:0 0 auto;min-width:var(--min-width);min-height:var(--min-height);z-index:1;animation:var(--orientation) var(--duration) linear var(--delay) var(--loops);animation-play-state:var(--pauseAnimation);animation-direction:var(--direction)}.vue3-marquee.horizontal>.marquee{display:flex;flex-direction:row;align-items:center}.vue3-marquee.vertical>.marquee{display:flex;flex-direction:column;align-items:center}@keyframes scrollX{0%{transform:translate(0)}to{transform:translate(-100%)}}@keyframes scrollY{0%{transform:translateY(0)}to{transform:translateY(-100%)}}.vue3-marquee>.overlay{position:absolute;width:100%;height:100%}.vue3-marquee>.transparent-overlay{position:absolute;width:100%;height:100%}.vue3-marquee>.overlay:before,.vue3-marquee>.overlay:after{content:"";position:absolute;z-index:2}.vue3-marquee.horizontal>.overlay:before,.vue3-marquee.horizontal>.overlay:after{background:linear-gradient(to right,var(--gradient-color));height:100%;width:var(--gradient-length)}.vue3-marquee.vertical>.overlay:before,.vue3-marquee.vertical>.overlay:after{background:linear-gradient(to bottom,var(--gradient-color));height:var(--gradient-length);width:100%}.vue3-marquee.horizontal>.overlay:after{transform:rotate(180deg)}.vue3-marquee.vertical>.overlay:after{transform:rotate(-180deg)}.vue3-marquee>.overlay:before{left:0;top:0}.vue3-marquee.horizontal>.overlay:after{right:0;top:0}.vue3-marquee.vertical>.overlay:after{left:0;bottom:0}')), document.head.appendChild(e);
        }
    } catch (a) {
        console.error("vite-plugin-css-injected-by-js", a);
    }
})();
var $4cc15c40e86bfdfa$var$__defProp = Object.defineProperty;
var $4cc15c40e86bfdfa$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4cc15c40e86bfdfa$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4cc15c40e86bfdfa$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4cc15c40e86bfdfa$var$__defNormalProp = (obj, key, value)=>key in obj ? $4cc15c40e86bfdfa$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4cc15c40e86bfdfa$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4cc15c40e86bfdfa$var$__hasOwnProp.call(b, prop)) $4cc15c40e86bfdfa$var$__defNormalProp(a, prop, b[prop]);
    if ($4cc15c40e86bfdfa$var$__getOwnPropSymbols) {
        for (var prop of $4cc15c40e86bfdfa$var$__getOwnPropSymbols(b))if ($4cc15c40e86bfdfa$var$__propIsEnum.call(b, prop)) $4cc15c40e86bfdfa$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4cc15c40e86bfdfa$var$vue3Marquee_vue_vue_type_style_index_0_lang = "";
var $4cc15c40e86bfdfa$var$_export_sfc = (sfc, props)=>{
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props)target[key] = val;
    return target;
};
const $4cc15c40e86bfdfa$var$_sfc_main = (0, $TusQn.defineComponent)({
    props: {
        vertical: {
            type: Boolean,
            default: false
        },
        direction: {
            type: String,
            default: "normal"
        },
        duration: {
            type: Number,
            default: 20
        },
        delay: {
            type: Number,
            default: 0
        },
        loop: {
            type: Number,
            default: 0
        },
        clone: {
            type: Boolean,
            default: false
        },
        gradient: {
            type: Boolean,
            default: false
        },
        gradientColor: {
            type: Array,
            default: [
                255,
                255,
                255
            ]
        },
        gradientWidth: {
            type: String
        },
        gradientLength: {
            type: String
        },
        pauseOnHover: {
            type: Boolean,
            default: false
        },
        pauseOnClick: {
            type: Boolean,
            default: false
        },
        pause: {
            type: Boolean,
            default: false
        },
        animateOnOverflowOnly: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "onComplete",
        "onLoopComplete",
        "onPause",
        "onResume",
        "onOverflowDetected",
        "onOverflowCleared"
    ],
    setup (props, { emit: emit }) {
        const cloneAmount = (0, $01W3b.ref)(0);
        const minWidth = (0, $01W3b.ref)("100%");
        const minHeight = (0, $01W3b.ref)("100%");
        const componentKey = (0, $01W3b.ref)(0);
        const verticalAnimationPause = (0, $01W3b.ref)(false);
        const animateOnOverflowPause = (0, $01W3b.ref)(true);
        const containerWidth = (0, $01W3b.ref)(0);
        const contentWidth = (0, $01W3b.ref)(0);
        const containerHeight = (0, $01W3b.ref)(0);
        const contentHeight = (0, $01W3b.ref)(0);
        const mouseOverMarquee = (0, $01W3b.ref)(false);
        const mouseDownMarquee = (0, $01W3b.ref)(false);
        const loopCounter = (0, $01W3b.ref)(0);
        const loopInterval = (0, $01W3b.ref)(null);
        const gradientLength = (0, $01W3b.ref)("200px");
        const ready = (0, $01W3b.ref)(false);
        const marqueeContent = (0, $01W3b.ref)(null);
        const marqueeOverlayContainer = (0, $01W3b.ref)(null);
        const ForcesUpdate = async ()=>{
            await checkForClone();
            componentKey.value++;
        };
        const checkForClone = async ()=>{
            if (props.vertical) verticalAnimationPause.value = true;
            setInterval(()=>{
                minWidth.value = "0%";
                minHeight.value = "0%";
                if (marqueeContent.value !== null && marqueeOverlayContainer.value !== null && marqueeContent.value && marqueeOverlayContainer.value) {
                    if (props.vertical && "clientHeight" in marqueeContent.value && "clientHeight" in marqueeOverlayContainer.value) {
                        contentHeight.value = marqueeContent.value.clientHeight;
                        containerHeight.value = marqueeOverlayContainer.value.clientHeight;
                        const localCloneAmount = Math.ceil(containerHeight.value / contentHeight.value);
                        cloneAmount.value = props.animateOnOverflowOnly ? 0 : isFinite(localCloneAmount) ? localCloneAmount : 0;
                        verticalAnimationPause.value = false;
                        return cloneAmount.value;
                    } else if (!props.vertical && "clientWidth" in marqueeContent.value && "clientWidth" in marqueeOverlayContainer.value) {
                        contentWidth.value = marqueeContent.value.clientWidth;
                        containerWidth.value = marqueeOverlayContainer.value.clientWidth;
                        if (props.animateOnOverflowOnly && ready.value) {
                            if (contentWidth.value <= containerWidth.value) {
                                animateOnOverflowPause.value = true;
                                emit("onOverflowCleared");
                            } else {
                                animateOnOverflowPause.value = false;
                                emit("onOverflowDetected");
                            }
                            return 0;
                        }
                        const localCloneAmount = Math.ceil(containerWidth.value / contentWidth.value);
                        cloneAmount.value = isFinite(localCloneAmount) ? localCloneAmount : 0;
                        return cloneAmount.value;
                    } else {
                        minWidth.value = "100%";
                        minHeight.value = "100%";
                        return 0;
                    }
                } else {
                    minWidth.value = "100%";
                    minHeight.value = "100%";
                    return 0;
                }
            }, 100);
        };
        (0, $TusQn.watch)(contentWidth, async ()=>{
            if (props.clone) ForcesUpdate();
        });
        (0, $TusQn.watch)(containerWidth, async ()=>{
            if (props.clone || props.animateOnOverflowOnly) ForcesUpdate();
        });
        (0, $TusQn.watch)(()=>props.pause, (newVal, oldVal)=>{
            if (newVal !== oldVal) {
                if (newVal) emit("onResume");
                else emit("onPause");
            }
        });
        const hoverStarted = ()=>{
            if (props.pauseOnHover) {
                emit("onPause");
                mouseOverMarquee.value = true;
            }
        };
        const hoverEnded = ()=>{
            if (props.pauseOnHover) {
                emit("onResume");
                mouseOverMarquee.value = false;
            }
        };
        const mouseDown = ()=>{
            if (props.pauseOnClick) {
                emit("onPause");
                mouseDownMarquee.value = true;
            }
        };
        const mouseUp = ()=>{
            if (props.pauseOnClick) {
                emit("onResume");
                mouseDownMarquee.value = false;
            }
        };
        const animationState = (0, $01W3b.computed)(()=>{
            if (props.pause) return "paused";
            if (props.vertical && verticalAnimationPause.value) return "paused";
            if (props.animateOnOverflowOnly && animateOnOverflowPause.value) return "paused";
            return "running";
        });
        const hoverAnimationState = (0, $01W3b.computed)(()=>{
            if (props.pauseOnHover && (mouseOverMarquee.value || mouseDownMarquee.value)) return "paused";
            if (!props.pauseOnHover && animationState.value === "paused") return "paused";
            return "running";
        });
        const clickAnimationState = (0, $01W3b.computed)(()=>{
            if (props.pauseOnHover && mouseOverMarquee.value) return "paused";
            if (props.pauseOnClick && mouseDownMarquee.value) return "paused";
            if (!props.pauseOnHover && animationState.value === "paused") return "paused";
            return "running";
        });
        const getCurrentStyle = (0, $01W3b.computed)(()=>{
            const cssVariables = {
                "--duration": `${props.duration}s`,
                "--delay": `${props.delay}s`,
                "--direction": `${props.direction}`,
                "--pauseOnHover": `${hoverAnimationState.value}`,
                "--pauseOnClick": `${clickAnimationState.value}`,
                "--pauseAnimation": `${animationState.value}`,
                "--loops": `${props.loop === 0 ? "infinite" : props.loop}`,
                "--gradient-color": `rgba(${props.gradientColor[0]}, ${props.gradientColor[1]}, ${props.gradientColor[2]}, 1), rgba(${props.gradientColor[0]}, ${props.gradientColor[1]}, ${props.gradientColor[2]}, 0)`,
                "--gradient-length": `${gradientLength.value}`,
                "--min-width": `${minWidth.value}`,
                "--min-height": `${minHeight.value}`
            };
            const animationStyles = {
                "--orientation": "scrollX",
                orientation: "horizontal"
            };
            if (props.vertical) animationStyles["--orientation"] = "scrollY";
            const styles = $4cc15c40e86bfdfa$var$__spreadValues($4cc15c40e86bfdfa$var$__spreadValues({}, cssVariables), animationStyles);
            return styles;
        });
        const showGradient = (0, $01W3b.computed)(()=>{
            if (props.gradient) return true;
            return false;
        });
        const setupMarquee = async ()=>{
            if (props.vertical) {
                minHeight.value = "100%";
                minWidth.value = "auto";
                if (props.animateOnOverflowOnly) console.warn("The `animateOnOverflowOnly` prop is not supported for vertical marquees.");
            } else {
                minHeight.value = "auto";
                if (props.animateOnOverflowOnly) minWidth.value = "auto";
                else minWidth.value = "100%";
            }
            if (props.gradient) {
                if (props.gradientWidth) {
                    console.warn("The `gradientWidth` prop has been deprecated and will be removed in a future release. Please use `gradientLength` instead.");
                    gradientLength.value = props.gradientWidth;
                } else if (props.gradientLength) gradientLength.value = props.gradientLength;
            }
            if (props.clone || props.animateOnOverflowOnly) {
                await checkForClone();
                ForcesUpdate();
                ready.value = true;
            } else ready.value = true;
        };
        (0, $TusQn.onMounted)(async ()=>{
            setupMarquee();
            loopInterval.value = setInterval(()=>{
                loopCounter.value++;
                if (props.loop !== 0 && loopCounter.value === props.loop) {
                    emit("onComplete");
                    clearInterval(loopInterval.value);
                }
                emit("onLoopComplete");
            }, props.duration * 1e3);
        });
        (0, $TusQn.onBeforeUnmount)(()=>{
            clearInterval(loopInterval.value);
        });
        return {
            ready: ready,
            contentWidth: contentWidth,
            containerWidth: containerWidth,
            contentHeight: contentHeight,
            containerHeight: containerHeight,
            loopCounter: loopCounter,
            loopInterval: loopInterval,
            mouseOverMarquee: mouseOverMarquee,
            mouseDownMarquee: mouseDownMarquee,
            minWidth: minWidth,
            minHeight: minHeight,
            animateOnOverflowPause: animateOnOverflowPause,
            marqueeContent: marqueeContent,
            marqueeOverlayContainer: marqueeOverlayContainer,
            componentKey: componentKey,
            showGradient: showGradient,
            cloneAmount: cloneAmount,
            ForcesUpdate: ForcesUpdate,
            checkForClone: checkForClone,
            setupMarquee: setupMarquee,
            getCurrentStyle: getCurrentStyle,
            hoverStarted: hoverStarted,
            hoverEnded: hoverEnded,
            mouseDown: mouseDown,
            mouseUp: mouseUp
        };
    }
});
const $4cc15c40e86bfdfa$var$_hoisted_1 = {
    class: "transparent-overlay",
    ref: "marqueeOverlayContainer",
    "aria-hidden": true
};
const $4cc15c40e86bfdfa$var$_hoisted_2 = {
    class: "marquee",
    ref: "marqueeContent"
};
const $4cc15c40e86bfdfa$var$_hoisted_3 = {
    key: 1,
    "aria-hidden": true,
    class: "marquee"
};
function $4cc15c40e86bfdfa$var$_sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
    return _ctx.ready ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8POXm.normalizeClass)([
            "vue3-marquee",
            {
                vertical: _ctx.vertical,
                horizontal: !_ctx.vertical
            }
        ]),
        style: (0, $8POXm.normalizeStyle)(_ctx.getCurrentStyle),
        key: _ctx.componentKey,
        onMouseenter: _cache[0] || (_cache[0] = (...args)=>_ctx.hoverStarted && _ctx.hoverStarted(...args)),
        onMouseleave: _cache[1] || (_cache[1] = (...args)=>_ctx.hoverEnded && _ctx.hoverEnded(...args)),
        onMousedown: _cache[2] || (_cache[2] = (...args)=>_ctx.mouseDown && _ctx.mouseDown(...args)),
        onMouseup: _cache[3] || (_cache[3] = (...args)=>_ctx.mouseUp && _ctx.mouseUp(...args))
    }, [
        (0, $TusQn.createElementVNode)("div", $4cc15c40e86bfdfa$var$_hoisted_1, null, 512),
        _ctx.showGradient ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
            key: 0,
            "aria-hidden": true,
            class: (0, $8POXm.normalizeClass)([
                "overlay",
                {
                    vertical: _ctx.vertical,
                    horizontal: !_ctx.vertical
                }
            ])
        }, null, 2)) : (0, $TusQn.createCommentVNode)("", true),
        (0, $TusQn.createElementVNode)("div", $4cc15c40e86bfdfa$var$_hoisted_2, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ], 512),
        !_ctx.animateOnOverflowOnly || _ctx.animateOnOverflowOnly && !_ctx.animateOnOverflowPause ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $4cc15c40e86bfdfa$var$_hoisted_3, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ])) : (0, $TusQn.createCommentVNode)("", true),
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.cloneAmount, (num)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                "aria-hidden": true,
                class: "marquee cloned",
                key: num
            }, [
                (0, $TusQn.renderSlot)(_ctx.$slots, "default")
            ]);
        }), 128))
    ], 38)) : (0, $TusQn.createCommentVNode)("", true);
}
var $4cc15c40e86bfdfa$export$d86fa7dbcf6bc097 = /* @__PURE__ */ $4cc15c40e86bfdfa$var$_export_sfc($4cc15c40e86bfdfa$var$_sfc_main, [
    [
        "render",
        $4cc15c40e86bfdfa$var$_sfc_render
    ]
]);
var $4cc15c40e86bfdfa$export$2e2bcd8739ae039 = {
    install (app, options) {
        var _a;
        const name = (_a = options == null ? void 0 : options.name) != null ? _a : "Vue3Marquee";
        app.component(name, $4cc15c40e86bfdfa$export$d86fa7dbcf6bc097);
    }
};

});


parcelRegister("aUCsA", function(module, exports) {

$parcel$export(module.exports, "render", () => $7f1cf7bd089175da$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $7f1cf7bd089175da$var$_hoisted_1 = {
    class: "gradient-with-mesh text-primary pb-24 after:absolute after:bottom-0 after:w-full after:h-[3px] after:bg-highlightLight"
};
const $7f1cf7bd089175da$var$_hoisted_2 = {
    class: "relative isolate overflow-hidden"
};
const $7f1cf7bd089175da$var$_hoisted_3 = {
    class: "mx-auto max-w-7xl px-6 pb-10 pt-10 sm:pb-32 lg:flex lg:px-8 lg:py-40"
};
const $7f1cf7bd089175da$var$_hoisted_4 = {
    class: "mx-auto max-w-2xl lg:mx-0 lg:max-w-lg lg:flex-shrink-0"
};
const $7f1cf7bd089175da$var$_hoisted_5 = {
    class: "text-secondary"
};
const $7f1cf7bd089175da$var$_hoisted_6 = {
    class: "mt-8 text-md leading-8 text-center lg:text-left"
};
const $7f1cf7bd089175da$var$_hoisted_7 = {
    class: "mt-14 items-center gap-x-6"
};
const $7f1cf7bd089175da$var$_hoisted_8 = {
    class: "mx-auto mt-16 flex flex-grow max-w-2xl sm:mt-24 lg:ml-10 lg:mr-0 lg:mt-0 lg:max-w-none lg:flex-none xl:ml-32"
};
const $7f1cf7bd089175da$var$_hoisted_9 = {
    class: ""
};
const $7f1cf7bd089175da$var$_hoisted_10 = {
    class: "flex flex-row gap-x-3 justify-center sm:justify-start"
};
const $7f1cf7bd089175da$var$_hoisted_11 = {
    class: "rounded-xl p-2 lg:-m-4 lg:rounded-2xl lg:p-4"
};
const $7f1cf7bd089175da$var$_hoisted_12 = [
    "src"
];
const $7f1cf7bd089175da$var$_hoisted_13 = {
    class: "rounded-xl p-2 lg:-m-4 lg:rounded-2xl lg:p-4 hidden sm:block"
};
const $7f1cf7bd089175da$var$_hoisted_14 = [
    "src"
];
const $7f1cf7bd089175da$var$_hoisted_15 = {
    class: "rounded-xl p-2 lg:-m-4 lg:rounded-2xl lg:p-4"
};
const $7f1cf7bd089175da$var$_hoisted_16 = [
    "src"
];
const $7f1cf7bd089175da$var$_hoisted_17 = {
    class: "mx-auto w-full py-6 text-primary lg:px-8 base-gradient"
};
const $7f1cf7bd089175da$var$_hoisted_18 = {
    class: "mx-auto max-w-7xl"
};
const $7f1cf7bd089175da$var$_hoisted_19 = {
    class: "text-center overflow-hidden rounded-2xl"
};
const $7f1cf7bd089175da$var$_hoisted_20 = {
    class: "sm:block lg:hidden w-full overflow-hidden"
};
const $7f1cf7bd089175da$var$_hoisted_21 = {
    class: "flex flex-col px-2 py-8 col-span-1 items-center justify-center"
};
const $7f1cf7bd089175da$var$_hoisted_22 = {
    class: "text-2xl font-semibold mb-3 text-center"
};
const $7f1cf7bd089175da$var$_hoisted_23 = [
    "href"
];
const $7f1cf7bd089175da$var$_hoisted_24 = {
    class: "flex flex-col col-span-1 items-center justify-center"
};
const $7f1cf7bd089175da$var$_hoisted_25 = {
    class: "text-3xl mb-2 flex justify-center items-center"
};
const $7f1cf7bd089175da$var$_hoisted_26 = {
    class: "text-md leading-6 text-center"
};
const $7f1cf7bd089175da$var$_hoisted_27 = {
    class: "hidden lg:grid grid-cols-4 gap-1"
};
const $7f1cf7bd089175da$var$_hoisted_28 = {
    class: "flex flex-col p-8 col-span-1"
};
const $7f1cf7bd089175da$var$_hoisted_29 = {
    class: "text-2xl font-semibold mb-3 text-left"
};
const $7f1cf7bd089175da$var$_hoisted_30 = [
    "href"
];
const $7f1cf7bd089175da$var$_hoisted_31 = {
    class: "text-3xl mb-2 flex justify-center items-center"
};
const $7f1cf7bd089175da$var$_hoisted_32 = {
    class: "text-md leading-6 text-center"
};
function $7f1cf7bd089175da$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_i18n_t = (0, $TusQn.resolveComponent)("i18n-t");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_4, [
                        (0, $TusQn.createVNode)(_component_i18n_t, {
                            tag: "h1",
                            class: "leading-10 font-bold text-6xl text-highlight text-center lg:text-left",
                            keypath: "landingPage.heroSection.slogan",
                            for: "highlighted"
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createElementVNode)("span", $7f1cf7bd089175da$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.heroSection.sloganHighlighted")), 1 /* TEXT */ )
                                ]),
                            _: 1 /* STABLE */ 
                        }),
                        (0, $TusQn.createElementVNode)("p", $7f1cf7bd089175da$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.heroSection.subtext")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_7, [
                            (0, $TusQn.createVNode)($setup["RouterLink"], {
                                to: $setup.getStartedNavigation,
                                class: "btn-cta w-full block text-center text-lg py-4"
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("getStartedCTA")), 1 /* TEXT */ )
                                    ]),
                                _: 1 /* STABLE */ 
                            }, 8 /* PROPS */ , [
                                "to"
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_8, [
                        (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_9, [
                            (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_10, [
                                (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_11, [
                                    (0, $TusQn.createElementVNode)("img", {
                                        src: $setup.heroImg2,
                                        width: "185",
                                        height: "336",
                                        class: "rounded-md shadow-2xl",
                                        alt: "Cyberalarm safety first"
                                    }, null, 8 /* PROPS */ , $7f1cf7bd089175da$var$_hoisted_12)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_13, [
                                    (0, $TusQn.createElementVNode)("img", {
                                        src: $setup.heroImg1,
                                        width: "185",
                                        height: "336",
                                        class: "rounded-md shadow-2xl",
                                        alt: "Cyberalarm hero image"
                                    }, null, 8 /* PROPS */ , $7f1cf7bd089175da$var$_hoisted_14)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_15, [
                                    (0, $TusQn.createElementVNode)("img", {
                                        src: $setup.heroImg3,
                                        width: "185",
                                        height: "336",
                                        class: "rounded-md shadow-2xl",
                                        alt: "Cyberalarm timed choice"
                                    }, null, 8 /* PROPS */ , $7f1cf7bd089175da$var$_hoisted_16)
                                ])
                            ])
                        ])
                    ])
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_17, [
            (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_18, [
                (0, $TusQn.createElementVNode)("dl", $7f1cf7bd089175da$var$_hoisted_19, [
                    (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_20, [
                        (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_21, [
                            (0, $TusQn.createElementVNode)("h2", $7f1cf7bd089175da$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.heroSection.statsTitle")), 1 /* TEXT */ ),
                            (0, $TusQn.createElementVNode)("a", {
                                href: _ctx.$t("landingPage.seeMoreLink"),
                                target: "_blank",
                                class: "btn-transparent max-w-3xl"
                            }, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.seeMore")), 9 /* TEXT, PROPS */ , $7f1cf7bd089175da$var$_hoisted_23)
                        ]),
                        (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_24, [
                            (0, $TusQn.createVNode)($setup["Vue3Marquee"], {
                                clone: true,
                                duration: 10
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.stats, (stat)=>{
                                            return (0, $TusQn.createElementVNode)("div", {
                                                key: stat.id,
                                                class: "flex flex-col items-center justify-center min-w-[200px] px-6 py-4"
                                            }, [
                                                (0, $TusQn.createElementVNode)("dd", $7f1cf7bd089175da$var$_hoisted_25, [
                                                    ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(stat.value)))
                                                ]),
                                                (0, $TusQn.createElementVNode)("dt", $7f1cf7bd089175da$var$_hoisted_26, (0, $8POXm.toDisplayString)(stat.name), 1 /* TEXT */ )
                                            ]);
                                        }), 64 /* STABLE_FRAGMENT */ ))
                                    ]),
                                _: 1 /* STABLE */ 
                            })
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_27, [
                        (0, $TusQn.createElementVNode)("div", $7f1cf7bd089175da$var$_hoisted_28, [
                            (0, $TusQn.createElementVNode)("h2", $7f1cf7bd089175da$var$_hoisted_29, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.heroSection.statsTitle")), 1 /* TEXT */ ),
                            (0, $TusQn.createElementVNode)("a", {
                                href: _ctx.$t("landingPage.seeMoreLink"),
                                target: "_blank",
                                class: "btn-transparent"
                            }, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.seeMore")), 9 /* TEXT, PROPS */ , $7f1cf7bd089175da$var$_hoisted_30)
                        ]),
                        ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.stats, (stat)=>{
                            return (0, $TusQn.createElementVNode)("div", {
                                key: stat.id,
                                class: "flex flex-col p-6 gap-2 justify-center items-center"
                            }, [
                                (0, $TusQn.createElementVNode)("dd", $7f1cf7bd089175da$var$_hoisted_31, [
                                    ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(stat.value)))
                                ]),
                                (0, $TusQn.createElementVNode)("dt", $7f1cf7bd089175da$var$_hoisted_32, (0, $8POXm.toDisplayString)(stat.name), 1 /* TEXT */ )
                            ]);
                        }), 64 /* STABLE_FRAGMENT */ ))
                    ])
                ])
            ])
        ])
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("6SU8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $503353ba3a3d911c$export$2e2bcd8739ae039);
let $503353ba3a3d911c$var$NOOP = ()=>{};
var $503353ba3a3d911c$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("32KFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2375c34994f26a5d$export$2e2bcd8739ae039);
let $2375c34994f26a5d$var$script;



let $2375c34994f26a5d$var$initialize = ()=>{
    $2375c34994f26a5d$var$script = (parcelRequire("6oAwt"));
    if ($2375c34994f26a5d$var$script.__esModule) $2375c34994f26a5d$var$script = $2375c34994f26a5d$var$script.default;
    $2375c34994f26a5d$var$script.render = (parcelRequire("8xhib")).render;
    (parcelRequire("7djUf")).default($2375c34994f26a5d$var$script);
    $2375c34994f26a5d$var$script.__scopeId = "data-v-17d1d4";
    $2375c34994f26a5d$var$script.__file = "LandingWhyCyberalarm.vue";
};
$2375c34994f26a5d$var$initialize();
var $2375c34994f26a5d$export$2e2bcd8739ae039 = $2375c34994f26a5d$var$script;

});
parcelRegister("6oAwt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4a8150a3d9bc50d6$export$2e2bcd8739ae039);

var $8a92Q = parcelRequire("8a92Q");
var $9RArT = parcelRequire("9RArT");
var $04Gss = parcelRequire("04Gss");
var $iL5IF = parcelRequire("iL5IF");
var $3ONsP = parcelRequire("3ONsP");

var $fMq06 = parcelRequire("fMq06");

var $ktKw6 = parcelRequire("ktKw6");
var $4a8150a3d9bc50d6$export$2e2bcd8739ae039 = {
    __name: "LandingWhyCyberalarm",
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            get LanguageIcon () {
                return 0, $8a92Q.default;
            },
            get LockClosedIcon () {
                return 0, $9RArT.default;
            },
            get ShieldCheckIcon () {
                return 0, $04Gss.default;
            },
            get StarIcon () {
                return 0, $iL5IF.default;
            },
            get UserIcon () {
                return 0, $3ONsP.default;
            },
            IncentiveCard: $fMq06.default,
            InboxCustomizeIcon: $ktKw6.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("8a92Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f1646079b238bf1$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $5f1646079b238bf1$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802"
        })
    ]);
}

});

parcelRegister("9RArT", function(module, exports) {

$parcel$export(module.exports, "default", () => $72e5564d959e99a8$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $72e5564d959e99a8$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
        })
    ]);
}

});

parcelRegister("04Gss", function(module, exports) {

$parcel$export(module.exports, "default", () => $00e14f1a067446fd$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $00e14f1a067446fd$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
        })
    ]);
}

});

parcelRegister("iL5IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $da810d8af35cf369$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $da810d8af35cf369$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
        })
    ]);
}

});

parcelRegister("3ONsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7c69254d0c1ba0$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $2c7c69254d0c1ba0$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
        })
    ]);
}

});

parcelRegister("fMq06", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7cf81ec4dcda21f$export$2e2bcd8739ae039);
let $b7cf81ec4dcda21f$var$script;



let $b7cf81ec4dcda21f$var$initialize = ()=>{
    $b7cf81ec4dcda21f$var$script = (parcelRequire("9xz4R"));
    if ($b7cf81ec4dcda21f$var$script.__esModule) $b7cf81ec4dcda21f$var$script = $b7cf81ec4dcda21f$var$script.default;
    $b7cf81ec4dcda21f$var$script.render = (parcelRequire("9oCp2")).render;
    (parcelRequire("5vQOY")).default($b7cf81ec4dcda21f$var$script);
    $b7cf81ec4dcda21f$var$script.__scopeId = "data-v-13d1a1";
    $b7cf81ec4dcda21f$var$script.__file = "IncentiveCard.vue";
};
$b7cf81ec4dcda21f$var$initialize();
var $b7cf81ec4dcda21f$export$2e2bcd8739ae039 = $b7cf81ec4dcda21f$var$script;

});
parcelRegister("9xz4R", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6f2267c76283fe3a$export$2e2bcd8739ae039);
var $6f2267c76283fe3a$export$2e2bcd8739ae039 = {
    __name: "IncentiveCard",
    props: [
        "icon",
        "iconClasses",
        "title",
        "desc"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {};
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("9oCp2", function(module, exports) {

$parcel$export(module.exports, "render", () => $6d7424f641df3753$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $6d7424f641df3753$var$_hoisted_1 = {
    class: "sm:flex lg:block"
};
const $6d7424f641df3753$var$_hoisted_2 = {
    class: "sm:flex-shrink-0"
};
const $6d7424f641df3753$var$_hoisted_3 = {
    class: "mt-4 sm:ml-6 sm:mt-0 lg:ml-0 lg:mt-6"
};
const $6d7424f641df3753$var$_hoisted_4 = {
    class: "text-md font-bold"
};
const $6d7424f641df3753$var$_hoisted_5 = {
    class: "mt-2 text-sm"
};
function $6d7424f641df3753$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6d7424f641df3753$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $6d7424f641df3753$var$_hoisted_2, [
            ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)($props.icon), {
                class: (0, $8POXm.normalizeClass)([
                    "w-14 text-secondary",
                    $props.iconClasses
                ])
            }, null, 8 /* PROPS */ , [
                "class"
            ]))
        ]),
        (0, $TusQn.createElementVNode)("div", $6d7424f641df3753$var$_hoisted_3, [
            (0, $TusQn.createElementVNode)("h4", $6d7424f641df3753$var$_hoisted_4, (0, $8POXm.toDisplayString)($props.title), 1 /* TEXT */ ),
            (0, $TusQn.createElementVNode)("p", $6d7424f641df3753$var$_hoisted_5, (0, $8POXm.toDisplayString)($props.desc), 1 /* TEXT */ )
        ])
    ]);
}

});

parcelRegister("5vQOY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4038d228597c34dc$export$2e2bcd8739ae039);
let $4038d228597c34dc$var$NOOP = ()=>{};
var $4038d228597c34dc$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("ktKw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee8a99544544dd07$export$2e2bcd8739ae039);
let $ee8a99544544dd07$var$script;


let $ee8a99544544dd07$var$initialize = ()=>{
    $ee8a99544544dd07$var$script = {};
    $ee8a99544544dd07$var$script.render = (parcelRequire("hashU")).render;
    (parcelRequire("2Yysc")).default($ee8a99544544dd07$var$script);
    $ee8a99544544dd07$var$script.__scopeId = "data-v-aff94e";
    $ee8a99544544dd07$var$script.__file = "InboxCustomizeIcon.vue";
};
$ee8a99544544dd07$var$initialize();
var $ee8a99544544dd07$export$2e2bcd8739ae039 = $ee8a99544544dd07$var$script;

});
parcelRegister("hashU", function(module, exports) {

$parcel$export(module.exports, "render", () => $c7f95036859d09fd$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $c7f95036859d09fd$var$_hoisted_1 = {
    xmlns: "http://www.w3.org/2000/svg",
    class: "fill-secondary",
    viewBox: "0 -960 960 960"
};
const $c7f95036859d09fd$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("path", {
    d: "M212.31-180Q182-180 161-201q-21-21-21-51.31v-535.38Q140-818 161-839q21-21 51.31-21h535.38Q778-860 799-839q21 21 21 51.31v217.54q-14.39-7.46-29.19-12.2-14.81-4.73-30.81-7.73v-197.61q0-5.39-3.46-8.85t-8.85-3.46H212.31q-5.39 0-8.85 3.46t-3.46 8.85v360h168q9 27.38 30.19 47.38 21.19 20 48.35 28-1.08 15.39-.92 30.69.15 15.31 2.77 30.7-35.62-6.23-65.58-26.12-29.96-19.88-51.27-50.65H200v115.38q0 5.39 3.46 8.85t8.85 3.46h254.92q6.62 16.61 14.27 31.42 7.65 14.81 18.35 28.58H212.31Zm0-60H200 467.23 212.31Zm464.07 84.61-8.15-47.3q-17-5-29.81-11.85-12.81-6.85-25.34-18.69l-45.31 15.69L537-267.85l37.15-31.54q-4.69-16.23-4.69-33.3 0-17.08 4.69-33.7L537-398.31l30.77-50.3 45.31 15.69q12.15-11.46 25.53-18.5 13.39-7.04 29.62-12.04l8.15-47.31h60l8.16 47.31q16.23 4.61 29.42 11.84 13.19 7.24 25.73 18.7L845-448.61l30.77 50.3-37.16 31.92q5.08 17 4.89 33.89-.19 16.88-5.27 33.11l37.54 31.54L845-217.54l-45.31-15.69q-12.54 11.46-25.35 18.5-12.8 7.04-29.8 12.04l-8.16 47.3h-60Zm30-94.61q34.16 0 58.62-24.46t24.46-58.62q0-34.15-24.46-58.61-24.46-24.47-58.62-24.47-34.15 0-58.61 24.47-24.46 24.46-24.46 58.61 0 34.16 24.46 58.62T706.38-250Z"
}, null, -1 /* HOISTED */ );
const $c7f95036859d09fd$var$_hoisted_3 = [
    $c7f95036859d09fd$var$_hoisted_2
];
function $c7f95036859d09fd$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $c7f95036859d09fd$var$_hoisted_1, $c7f95036859d09fd$var$_hoisted_3);
}

});

parcelRegister("2Yysc", function(module, exports) {

$parcel$export(module.exports, "default", () => $22abe934186dbb20$export$2e2bcd8739ae039);
let $22abe934186dbb20$var$NOOP = ()=>{};
var $22abe934186dbb20$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("8xhib", function(module, exports) {

$parcel$export(module.exports, "render", () => $636ed1aa16c8aa7c$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $636ed1aa16c8aa7c$var$_hoisted_1 = {
    class: "bg-primary text-basecolor py-8 md:py-24 px-6"
};
const $636ed1aa16c8aa7c$var$_hoisted_2 = {
    class: "mx-auto max-w-7xl"
};
const $636ed1aa16c8aa7c$var$_hoisted_3 = {
    class: "mx-auto max-w-2xl px-4 lg:max-w-none"
};
const $636ed1aa16c8aa7c$var$_hoisted_4 = {
    class: "max-w-3xl"
};
const $636ed1aa16c8aa7c$var$_hoisted_5 = {
    class: "text-3xl font-semibold tracking-tight"
};
const $636ed1aa16c8aa7c$var$_hoisted_6 = {
    class: "mt-16 grid xl:grid-cols-2 grid-cols-1 gap-x-20 gap-y-10"
};
const $636ed1aa16c8aa7c$var$_hoisted_7 = {
    class: "text-lg font-semibold tracking-tight"
};
const $636ed1aa16c8aa7c$var$_hoisted_8 = {
    class: "text-sm mt-4"
};
const $636ed1aa16c8aa7c$var$_hoisted_9 = {
    class: "text-lg font-semibold tracking-tight"
};
const $636ed1aa16c8aa7c$var$_hoisted_10 = {
    class: "mt-4 text-sm"
};
const $636ed1aa16c8aa7c$var$_hoisted_11 = {
    class: "list-disc list-inside"
};
const $636ed1aa16c8aa7c$var$_hoisted_12 = {
    class: "mx-auto max-w-7xl sm:pt-24 pt-10"
};
const $636ed1aa16c8aa7c$var$_hoisted_13 = {
    class: "mx-auto max-w-2xl px-4 lg:max-w-none"
};
const $636ed1aa16c8aa7c$var$_hoisted_14 = {
    class: "max-w-3xl"
};
const $636ed1aa16c8aa7c$var$_hoisted_15 = {
    class: "text-2xl font-bold tracking-tight"
};
const $636ed1aa16c8aa7c$var$_hoisted_16 = {
    class: "mt-16 grid grid-cols-1 gap-x-16 gap-y-10 lg:grid-cols-3"
};
function $636ed1aa16c8aa7c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $636ed1aa16c8aa7c$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $636ed1aa16c8aa7c$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $636ed1aa16c8aa7c$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", $636ed1aa16c8aa7c$var$_hoisted_4, [
                    (0, $TusQn.createElementVNode)("h2", $636ed1aa16c8aa7c$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.whySection.title")), 1 /* TEXT */ )
                ]),
                (0, $TusQn.createElementVNode)("div", $636ed1aa16c8aa7c$var$_hoisted_6, [
                    (0, $TusQn.createElementVNode)("div", null, [
                        (0, $TusQn.createElementVNode)("h3", $636ed1aa16c8aa7c$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.whySection.block1.title")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("p", $636ed1aa16c8aa7c$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.whySection.block1.text")), 1 /* TEXT */ )
                    ]),
                    (0, $TusQn.createElementVNode)("div", null, [
                        (0, $TusQn.createElementVNode)("h3", $636ed1aa16c8aa7c$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.whySection.block2.title")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("div", $636ed1aa16c8aa7c$var$_hoisted_10, [
                            (0, $TusQn.createElementVNode)("ul", $636ed1aa16c8aa7c$var$_hoisted_11, [
                                (0, $TusQn.createElementVNode)("li", null, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.whySection.block2.bullet1")), 1 /* TEXT */ ),
                                (0, $TusQn.createElementVNode)("li", null, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.whySection.block2.bullet2")), 1 /* TEXT */ ),
                                (0, $TusQn.createElementVNode)("li", null, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.whySection.block2.bullet3")), 1 /* TEXT */ )
                            ])
                        ])
                    ])
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $636ed1aa16c8aa7c$var$_hoisted_12, [
            (0, $TusQn.createElementVNode)("div", $636ed1aa16c8aa7c$var$_hoisted_13, [
                (0, $TusQn.createElementVNode)("div", $636ed1aa16c8aa7c$var$_hoisted_14, [
                    (0, $TusQn.createElementVNode)("h2", $636ed1aa16c8aa7c$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.whySection.incentivesTitle")), 1 /* TEXT */ )
                ]),
                (0, $TusQn.createElementVNode)("div", $636ed1aa16c8aa7c$var$_hoisted_16, [
                    (0, $TusQn.createVNode)($setup["IncentiveCard"], {
                        icon: $setup.StarIcon,
                        title: _ctx.$t("landingPage.whySection.incentives[0].title"),
                        desc: _ctx.$t("landingPage.whySection.incentives[0].text")
                    }, null, 8 /* PROPS */ , [
                        "icon",
                        "title",
                        "desc"
                    ]),
                    (0, $TusQn.createVNode)($setup["IncentiveCard"], {
                        icon: $setup.UserIcon,
                        title: _ctx.$t("landingPage.whySection.incentives[1].title"),
                        desc: _ctx.$t("landingPage.whySection.incentives[1].text")
                    }, null, 8 /* PROPS */ , [
                        "icon",
                        "title",
                        "desc"
                    ]),
                    (0, $TusQn.createVNode)($setup["IncentiveCard"], {
                        icon: $setup.ShieldCheckIcon,
                        title: _ctx.$t("landingPage.whySection.incentives[2].title"),
                        desc: _ctx.$t("landingPage.whySection.incentives[2].text")
                    }, null, 8 /* PROPS */ , [
                        "icon",
                        "title",
                        "desc"
                    ]),
                    (0, $TusQn.createVNode)($setup["IncentiveCard"], {
                        icon: $setup.LanguageIcon,
                        title: _ctx.$t("landingPage.whySection.incentives[3].title"),
                        desc: _ctx.$t("landingPage.whySection.incentives[3].text")
                    }, null, 8 /* PROPS */ , [
                        "icon",
                        "title",
                        "desc"
                    ]),
                    (0, $TusQn.createVNode)($setup["IncentiveCard"], {
                        icon: $setup.InboxCustomizeIcon,
                        title: _ctx.$t("landingPage.whySection.incentives[4].title"),
                        desc: _ctx.$t("landingPage.whySection.incentives[4].text")
                    }, null, 8 /* PROPS */ , [
                        "title",
                        "desc"
                    ]),
                    (0, $TusQn.createVNode)($setup["IncentiveCard"], {
                        icon: $setup.LockClosedIcon,
                        title: _ctx.$t("landingPage.whySection.incentives[5].title"),
                        desc: _ctx.$t("landingPage.whySection.incentives[5].text")
                    }, null, 8 /* PROPS */ , [
                        "icon",
                        "title",
                        "desc"
                    ])
                ])
            ])
        ])
    ]);
}

});

parcelRegister("7djUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5409303e85d9b8e0$export$2e2bcd8739ae039);
let $5409303e85d9b8e0$var$NOOP = ()=>{};
var $5409303e85d9b8e0$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("kSkA0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f328d07f2e667ac8$export$2e2bcd8739ae039);
let $f328d07f2e667ac8$var$script;


let $f328d07f2e667ac8$var$initialize = ()=>{
    $f328d07f2e667ac8$var$script = {};
    $f328d07f2e667ac8$var$script.render = (parcelRequire("2RseN")).render;
    (parcelRequire("as6Bc")).default($f328d07f2e667ac8$var$script);
    $f328d07f2e667ac8$var$script.__scopeId = "data-v-5a23bc";
    $f328d07f2e667ac8$var$script.__file = "LandingHowItWorks.vue";
};
$f328d07f2e667ac8$var$initialize();
var $f328d07f2e667ac8$export$2e2bcd8739ae039 = $f328d07f2e667ac8$var$script;

});
parcelRegister("2RseN", function(module, exports) {

$parcel$export(module.exports, "render", () => $21566f6484ccfcee$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

var $6tSLU = parcelRequire("6tSLU");

var $3KqKn = parcelRequire("3KqKn");
const $21566f6484ccfcee$var$_hoisted_1 = {
    class: "base-gradient py-8 md:py-24 px-6 text-md text-primary"
};
const $21566f6484ccfcee$var$_hoisted_2 = {
    class: "mx-auto max-w-7xl"
};
const $21566f6484ccfcee$var$_hoisted_3 = {
    class: "mx-auto max-w-2xl px-4 lg:max-w-none"
};
const $21566f6484ccfcee$var$_hoisted_4 = {
    class: "max-w-full text-balance"
};
const $21566f6484ccfcee$var$_hoisted_5 = {
    class: "text-3xl font-bold tracking-tight"
};
const $21566f6484ccfcee$var$_hoisted_6 = {
    class: "mt-16 text-sm"
};
const $21566f6484ccfcee$var$_hoisted_7 = {
    class: "mt-4 grid xl:grid-cols-2 grid-cols-1 gap-x-24 gap-y-10"
};
const $21566f6484ccfcee$var$_hoisted_8 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "mt-16 sm:mt-16 xl:mx-auto"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6tSLU))),
        alt: "Training platform",
        class: "aspect-[5/2]] w-full object-cover"
    })
], -1 /* HOISTED */ );
const $21566f6484ccfcee$var$_hoisted_9 = {
    class: "text-2xl mt-4 font-bold tracking-tight"
};
const $21566f6484ccfcee$var$_hoisted_10 = {
    class: "mt-4 text-secondary"
};
const $21566f6484ccfcee$var$_hoisted_11 = {
    class: "mt-4 list-disc list-inside text-primary"
};
const $21566f6484ccfcee$var$_hoisted_12 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "mt-16 sm:mt-16 xl:max-w-7xl"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3KqKn))),
        alt: "Management platform",
        class: "aspect-[5/2]] w-full object-cover"
    })
], -1 /* HOISTED */ );
const $21566f6484ccfcee$var$_hoisted_13 = {
    class: "text-2xl mt-4 font-bold tracking-tight"
};
const $21566f6484ccfcee$var$_hoisted_14 = {
    class: "mt-4 text-secondary"
};
const $21566f6484ccfcee$var$_hoisted_15 = {
    class: "mt-4 list-disc list-inside text-primary"
};
function $21566f6484ccfcee$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $21566f6484ccfcee$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $21566f6484ccfcee$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $21566f6484ccfcee$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", $21566f6484ccfcee$var$_hoisted_4, [
                    (0, $TusQn.createElementVNode)("h2", $21566f6484ccfcee$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.title")), 1 /* TEXT */ ),
                    (0, $TusQn.createElementVNode)("p", $21566f6484ccfcee$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.text")), 1 /* TEXT */ )
                ]),
                (0, $TusQn.createElementVNode)("div", $21566f6484ccfcee$var$_hoisted_7, [
                    (0, $TusQn.createElementVNode)("div", null, [
                        (0, $TusQn.createCommentVNode)(" Image section "),
                        $21566f6484ccfcee$var$_hoisted_8,
                        (0, $TusQn.createElementVNode)("h3", $21566f6484ccfcee$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.block1.title")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("p", $21566f6484ccfcee$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.block1.subtitle")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("ul", $21566f6484ccfcee$var$_hoisted_11, [
                            (0, $TusQn.createElementVNode)("li", null, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.block1.bullet1")), 1 /* TEXT */ ),
                            (0, $TusQn.createElementVNode)("li", null, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.block1.bullet2")), 1 /* TEXT */ ),
                            (0, $TusQn.createElementVNode)("li", null, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.block1.bullet3")), 1 /* TEXT */ ),
                            (0, $TusQn.createElementVNode)("li", null, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.block1.bullet4")), 1 /* TEXT */ )
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", null, [
                        (0, $TusQn.createCommentVNode)(" Image section "),
                        $21566f6484ccfcee$var$_hoisted_12,
                        (0, $TusQn.createElementVNode)("h3", $21566f6484ccfcee$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.block2.title")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("p", $21566f6484ccfcee$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.block2.subtitle")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("ul", $21566f6484ccfcee$var$_hoisted_15, [
                            (0, $TusQn.createElementVNode)("li", null, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.block2.bullet1")), 1 /* TEXT */ ),
                            (0, $TusQn.createElementVNode)("li", null, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.block2.bullet2")), 1 /* TEXT */ ),
                            (0, $TusQn.createElementVNode)("li", null, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.block2.bullet3")), 1 /* TEXT */ ),
                            (0, $TusQn.createElementVNode)("li", null, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.howSection.block2.bullet4")), 1 /* TEXT */ )
                        ])
                    ])
                ])
            ])
        ])
    ]);
}

});
parcelRegister("6tSLU", function(module, exports) {
module.exports = new URL("training-platform-screenshot.a3b0cf9b.png", import.meta.url).toString();

});

parcelRegister("3KqKn", function(module, exports) {
module.exports = new URL("management-platform-screenshot.a77c235c.png", import.meta.url).toString();

});


parcelRegister("as6Bc", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c1a355fabe7148$export$2e2bcd8739ae039);
let $79c1a355fabe7148$var$NOOP = ()=>{};
var $79c1a355fabe7148$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("5C9Dc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4167f8e974e6c6ef$export$2e2bcd8739ae039);
let $4167f8e974e6c6ef$var$script;



let $4167f8e974e6c6ef$var$initialize = ()=>{
    $4167f8e974e6c6ef$var$script = (parcelRequire("134OU"));
    if ($4167f8e974e6c6ef$var$script.__esModule) $4167f8e974e6c6ef$var$script = $4167f8e974e6c6ef$var$script.default;
    $4167f8e974e6c6ef$var$script.render = (parcelRequire("lUMix")).render;
    (parcelRequire("iu7ZR")).default($4167f8e974e6c6ef$var$script);
    $4167f8e974e6c6ef$var$script.__scopeId = "data-v-6c0f14";
    $4167f8e974e6c6ef$var$script.__file = "LandingCourses.vue";
};
$4167f8e974e6c6ef$var$initialize();
var $4167f8e974e6c6ef$export$2e2bcd8739ae039 = $4167f8e974e6c6ef$var$script;

});
parcelRegister("134OU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0c39cf6aad6c9656$export$2e2bcd8739ae039);

var $9LPuZ = parcelRequire("9LPuZ");

var $jlV5w = parcelRequire("jlV5w");
var $0c39cf6aad6c9656$export$2e2bcd8739ae039 = {
    __name: "LandingCourses",
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            LoaderIcon: $9LPuZ.default,
            CoursesCarousel: $jlV5w.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("9LPuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $71d0736e6c2b02a1$export$2e2bcd8739ae039);
let $71d0736e6c2b02a1$var$script;


let $71d0736e6c2b02a1$var$initialize = ()=>{
    $71d0736e6c2b02a1$var$script = {};
    $71d0736e6c2b02a1$var$script.render = (parcelRequire("6u1lt")).render;
    (parcelRequire("jza2j")).default($71d0736e6c2b02a1$var$script);
    $71d0736e6c2b02a1$var$script.__scopeId = "data-v-ff968f";
    $71d0736e6c2b02a1$var$script.__file = "LoaderIcon.vue";
};
$71d0736e6c2b02a1$var$initialize();
var $71d0736e6c2b02a1$export$2e2bcd8739ae039 = $71d0736e6c2b02a1$var$script;

});
parcelRegister("6u1lt", function(module, exports) {

$parcel$export(module.exports, "render", () => $4b86969a13db5612$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $4b86969a13db5612$var$_hoisted_1 = {
    xmlns: "http://www.w3.org/2000/svg",
    class: "icon icon-tabler icon-tabler-loader",
    width: "60",
    height: "60",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "#2c3e50",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
};
const $4b86969a13db5612$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 6l0 -3"></path><path d="M16.25 7.75l2.15 -2.15"></path><path d="M18 12l3 0"></path><path d="M16.25 16.25l2.15 2.15"></path><path d="M12 18l0 3"></path><path d="M7.75 16.25l-2.15 2.15"></path><path d="M6 12l-3 0"></path><path d="M7.75 7.75l-2.15 -2.15"></path>', 9);
const $4b86969a13db5612$var$_hoisted_11 = [
    $4b86969a13db5612$var$_hoisted_2
];
function $4b86969a13db5612$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $4b86969a13db5612$var$_hoisted_1, $4b86969a13db5612$var$_hoisted_11);
}

});

parcelRegister("jza2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3e9123586a6cb95$export$2e2bcd8739ae039);
let $e3e9123586a6cb95$var$NOOP = ()=>{};
var $e3e9123586a6cb95$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("jlV5w", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16c42fd6127f258$export$2e2bcd8739ae039);
let $e16c42fd6127f258$var$script;



let $e16c42fd6127f258$var$initialize = ()=>{
    $e16c42fd6127f258$var$script = (parcelRequire("6SZgc"));
    if ($e16c42fd6127f258$var$script.__esModule) $e16c42fd6127f258$var$script = $e16c42fd6127f258$var$script.default;
    $e16c42fd6127f258$var$script.render = (parcelRequire("c9Daa")).render;
    (parcelRequire("fJjEy")).default($e16c42fd6127f258$var$script);
    $e16c42fd6127f258$var$script.__scopeId = "data-v-4476f7";
    $e16c42fd6127f258$var$script.__file = "CoursesCarousel.vue";
};
$e16c42fd6127f258$var$initialize();
var $e16c42fd6127f258$export$2e2bcd8739ae039 = $e16c42fd6127f258$var$script;

});
parcelRegister("6SZgc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $50374e3e4603f65a$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
parcelRequire("66mw7");
var $knUNi = parcelRequire("knUNi");

var $jFUWD = parcelRequire("jFUWD");

var $7jPnz = parcelRequire("7jPnz");

var $hzqmY = parcelRequire("hzqmY");
var $50374e3e4603f65a$export$2e2bcd8739ae039 = {
    __name: "CoursesCarousel",
    setup (__props, { expose: __expose }) {
        __expose();
        const { locale: locale } = (0, $jFUWD.useI18n)();
        const lesson1 = (0, $hzqmY.default)("lesson_1.png", locale.value);
        const lesson2 = (0, $hzqmY.default)("lesson_2.png", locale.value);
        const lesson3 = (0, $hzqmY.default)("lesson_3.png", locale.value);
        const lesson4 = (0, $hzqmY.default)("lesson_4.png", locale.value);
        const lesson5 = (0, $hzqmY.default)("lesson_5.png", locale.value);
        const lesson6 = (0, $hzqmY.default)("lesson_6.png", locale.value);
        const lesson7 = (0, $hzqmY.default)("lesson_7.png", locale.value);
        (0, $TusQn.onMounted)(()=>{
            (0, $knUNi.initCarousels)();
        });
        const __returned__ = {
            locale: locale,
            lesson1: lesson1,
            lesson2: lesson2,
            lesson3: lesson3,
            lesson4: lesson4,
            lesson5: lesson5,
            lesson6: lesson6,
            lesson7: lesson7,
            onMounted: $TusQn.onMounted,
            get initCarousels () {
                return 0, $knUNi.initCarousels;
            },
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            CoursesCarouselCard: $7jPnz.default,
            get resolveImgUrl () {
                return 0, $hzqmY.default;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("66mw7", function(module, exports) {

$parcel$export(module.exports, "Modal", () => (parcelRequire("jF2f2")).default);
$parcel$export(module.exports, "initCarousels", () => (parcelRequire("knUNi")).initCarousels);
$parcel$export(module.exports, "initModals", () => (parcelRequire("jF2f2")).initModals);

var $3brKf = parcelRequire("3brKf");

var $gSilK = parcelRequire("gSilK");

var $g6C8J = parcelRequire("g6C8J");

var $knUNi = parcelRequire("knUNi");

var $9MHg3 = parcelRequire("9MHg3");

var $7sBGF = parcelRequire("7sBGF");

var $jF2f2 = parcelRequire("jF2f2");

var $6E0Df = parcelRequire("6E0Df");

var $5M6bU = parcelRequire("5M6bU");

var $1aBcu = parcelRequire("1aBcu");

var $lmTfj = parcelRequire("lmTfj");

var $3a83f = parcelRequire("3a83f");

var $2r2in = parcelRequire("2r2in");

var $cvVci = parcelRequire("cvVci");

var $8M1Z2 = parcelRequire("8M1Z2");
parcelRequire("lSJ3U");
parcelRequire("gwg2V");
parcelRequire("icSXv");
parcelRequire("iYs5h");
parcelRequire("h2r3Q");
parcelRequire("hqkIY");
parcelRequire("8RSc7");
parcelRequire("3koZx");
parcelRequire("5LmHG");
parcelRequire("4QM70");
parcelRequire("1ZSPI");
parcelRequire("gveSB");
parcelRequire("atP5T");
parcelRequire("7wk7g");
parcelRequire("eaNC5");
parcelRequire("2rnw3");
parcelRequire("kX6FP");
parcelRequire("fVade");
parcelRequire("bC3tH");
parcelRequire("3Vz0T");
parcelRequire("aJMRa");
parcelRequire("bkAHS");
parcelRequire("e7wEz");
parcelRequire("atzcx");
parcelRequire("9N2Z7");
parcelRequire("aYmWQ");
parcelRequire("bfad5");
// setup events for data attributes
var $4714c50421590160$var$events = new (0, $3brKf.default)("load", [
    (0, $gSilK.initAccordions),
    (0, $g6C8J.initCollapses),
    (0, $knUNi.initCarousels),
    (0, $9MHg3.initDismisses),
    (0, $7sBGF.initDropdowns),
    (0, $jF2f2.initModals),
    (0, $6E0Df.initDrawers),
    (0, $5M6bU.initTabs),
    (0, $1aBcu.initTooltips),
    (0, $lmTfj.initPopovers),
    (0, $3a83f.initDials),
    (0, $2r2in.initInputCounters),
    (0, $cvVci.initCopyClipboards)
]);
$4714c50421590160$var$events.init();

});
parcelRegister("3brKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2517ebbe139f796a$export$2e2bcd8739ae039);
var $2517ebbe139f796a$var$Events = /** @class */ function() {
    function Events(eventType, eventFunctions) {
        if (eventFunctions === void 0) eventFunctions = [];
        this._eventType = eventType;
        this._eventFunctions = eventFunctions;
    }
    Events.prototype.init = function() {
        var _this = this;
        this._eventFunctions.forEach(function(eventFunction) {
            if (typeof window !== "undefined") window.addEventListener(_this._eventType, eventFunction);
        });
    };
    return Events;
}();
var $2517ebbe139f796a$export$2e2bcd8739ae039 = $2517ebbe139f796a$var$Events;

});

parcelRegister("gSilK", function(module, exports) {

$parcel$export(module.exports, "initAccordions", () => $c48fec59664056e4$export$226c1dc98323ee4d);

var $dATps = parcelRequire("dATps");
var $c48fec59664056e4$var$__assign = undefined && undefined.__assign || function() {
    $c48fec59664056e4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c48fec59664056e4$var$__assign.apply(this, arguments);
};
var $c48fec59664056e4$var$Default = {
    alwaysOpen: false,
    activeClasses: "bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white",
    inactiveClasses: "text-gray-500 dark:text-gray-400",
    onOpen: function() {},
    onClose: function() {},
    onToggle: function() {}
};
var $c48fec59664056e4$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $c48fec59664056e4$var$Accordion = /** @class */ function() {
    function Accordion(accordionEl, items, options, instanceOptions) {
        if (accordionEl === void 0) accordionEl = null;
        if (items === void 0) items = [];
        if (options === void 0) options = $c48fec59664056e4$var$Default;
        if (instanceOptions === void 0) instanceOptions = $c48fec59664056e4$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : accordionEl.id;
        this._accordionEl = accordionEl;
        this._items = items;
        this._options = $c48fec59664056e4$var$__assign($c48fec59664056e4$var$__assign({}, $c48fec59664056e4$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $dATps.default).addInstance("Accordion", this, this._instanceId, instanceOptions.override);
    }
    Accordion.prototype.init = function() {
        var _this = this;
        if (this._items.length && !this._initialized) {
            // show accordion item based on click
            this._items.forEach(function(item) {
                if (item.active) _this.open(item.id);
                var clickHandler = function() {
                    _this.toggle(item.id);
                };
                item.triggerEl.addEventListener("click", clickHandler);
                // Store the clickHandler in a property of the item for removal later
                item.clickHandler = clickHandler;
            });
            this._initialized = true;
        }
    };
    Accordion.prototype.destroy = function() {
        if (this._items.length && this._initialized) {
            this._items.forEach(function(item) {
                item.triggerEl.removeEventListener("click", item.clickHandler);
                // Clean up by deleting the clickHandler property from the item
                delete item.clickHandler;
            });
            this._initialized = false;
        }
    };
    Accordion.prototype.removeInstance = function() {
        (0, $dATps.default).removeInstance("Accordion", this._instanceId);
    };
    Accordion.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Accordion.prototype.getItem = function(id) {
        return this._items.filter(function(item) {
            return item.id === id;
        })[0];
    };
    Accordion.prototype.open = function(id) {
        var _a, _b;
        var _this = this;
        var item = this.getItem(id);
        // don't hide other accordions if always open
        if (!this._options.alwaysOpen) this._items.map(function(i) {
            var _a, _b;
            if (i !== item) {
                (_a = i.triggerEl.classList).remove.apply(_a, _this._options.activeClasses.split(" "));
                (_b = i.triggerEl.classList).add.apply(_b, _this._options.inactiveClasses.split(" "));
                i.targetEl.classList.add("hidden");
                i.triggerEl.setAttribute("aria-expanded", "false");
                i.active = false;
                // rotate icon if set
                if (i.iconEl) i.iconEl.classList.add("rotate-180");
            }
        });
        // show active item
        (_a = item.triggerEl.classList).add.apply(_a, this._options.activeClasses.split(" "));
        (_b = item.triggerEl.classList).remove.apply(_b, this._options.inactiveClasses.split(" "));
        item.triggerEl.setAttribute("aria-expanded", "true");
        item.targetEl.classList.remove("hidden");
        item.active = true;
        // rotate icon if set
        if (item.iconEl) item.iconEl.classList.remove("rotate-180");
        // callback function
        this._options.onOpen(this, item);
    };
    Accordion.prototype.toggle = function(id) {
        var item = this.getItem(id);
        if (item.active) this.close(id);
        else this.open(id);
        // callback function
        this._options.onToggle(this, item);
    };
    Accordion.prototype.close = function(id) {
        var _a, _b;
        var item = this.getItem(id);
        (_a = item.triggerEl.classList).remove.apply(_a, this._options.activeClasses.split(" "));
        (_b = item.triggerEl.classList).add.apply(_b, this._options.inactiveClasses.split(" "));
        item.targetEl.classList.add("hidden");
        item.triggerEl.setAttribute("aria-expanded", "false");
        item.active = false;
        // rotate icon if set
        if (item.iconEl) item.iconEl.classList.add("rotate-180");
        // callback function
        this._options.onClose(this, item);
    };
    Accordion.prototype.updateOnOpen = function(callback) {
        this._options.onOpen = callback;
    };
    Accordion.prototype.updateOnClose = function(callback) {
        this._options.onClose = callback;
    };
    Accordion.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Accordion;
}();
function $c48fec59664056e4$export$226c1dc98323ee4d() {
    document.querySelectorAll("[data-accordion]").forEach(function($accordionEl) {
        var alwaysOpen = $accordionEl.getAttribute("data-accordion");
        var activeClasses = $accordionEl.getAttribute("data-active-classes");
        var inactiveClasses = $accordionEl.getAttribute("data-inactive-classes");
        var items = [];
        $accordionEl.querySelectorAll("[data-accordion-target]").forEach(function($triggerEl) {
            // Consider only items that directly belong to $accordionEl
            // (to make nested accordions work).
            if ($triggerEl.closest("[data-accordion]") === $accordionEl) {
                var item = {
                    id: $triggerEl.getAttribute("data-accordion-target"),
                    triggerEl: $triggerEl,
                    targetEl: document.querySelector($triggerEl.getAttribute("data-accordion-target")),
                    iconEl: $triggerEl.querySelector("[data-accordion-icon]"),
                    active: $triggerEl.getAttribute("aria-expanded") === "true" ? true : false
                };
                items.push(item);
            }
        });
        new $c48fec59664056e4$var$Accordion($accordionEl, items, {
            alwaysOpen: alwaysOpen === "open" ? true : false,
            activeClasses: activeClasses ? activeClasses : $c48fec59664056e4$var$Default.activeClasses,
            inactiveClasses: inactiveClasses ? inactiveClasses : $c48fec59664056e4$var$Default.inactiveClasses
        });
    });
}
if (typeof window !== "undefined") {
    window.Accordion = $c48fec59664056e4$var$Accordion;
    window.initAccordions = $c48fec59664056e4$export$226c1dc98323ee4d;
}
var $c48fec59664056e4$export$2e2bcd8739ae039 = $c48fec59664056e4$var$Accordion;

});
parcelRegister("dATps", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e599e545d4197d0$export$2e2bcd8739ae039);
var $9e599e545d4197d0$var$Instances = /** @class */ function() {
    function Instances() {
        this._instances = {
            Accordion: {},
            Carousel: {},
            Collapse: {},
            Dial: {},
            Dismiss: {},
            Drawer: {},
            Dropdown: {},
            Modal: {},
            Popover: {},
            Tabs: {},
            Tooltip: {},
            InputCounter: {},
            CopyClipboard: {}
        };
    }
    Instances.prototype.addInstance = function(component, instance, id, override) {
        if (override === void 0) override = false;
        if (!this._instances[component]) {
            console.warn("Flowbite: Component ".concat(component, " does not exist."));
            return false;
        }
        if (this._instances[component][id] && !override) {
            console.warn("Flowbite: Instance with ID ".concat(id, " already exists."));
            return;
        }
        if (override && this._instances[component][id]) this._instances[component][id].destroyAndRemoveInstance();
        this._instances[component][id ? id : this._generateRandomId()] = instance;
    };
    Instances.prototype.getAllInstances = function() {
        return this._instances;
    };
    Instances.prototype.getInstances = function(component) {
        if (!this._instances[component]) {
            console.warn("Flowbite: Component ".concat(component, " does not exist."));
            return false;
        }
        return this._instances[component];
    };
    Instances.prototype.getInstance = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        if (!this._instances[component][id]) {
            console.warn("Flowbite: Instance with ID ".concat(id, " does not exist."));
            return;
        }
        return this._instances[component][id];
    };
    Instances.prototype.destroyAndRemoveInstance = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        this.destroyInstanceObject(component, id);
        this.removeInstance(component, id);
    };
    Instances.prototype.removeInstance = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        delete this._instances[component][id];
    };
    Instances.prototype.destroyInstanceObject = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        this._instances[component][id].destroy();
    };
    Instances.prototype.instanceExists = function(component, id) {
        if (!this._instances[component]) return false;
        if (!this._instances[component][id]) return false;
        return true;
    };
    Instances.prototype._generateRandomId = function() {
        return Math.random().toString(36).substr(2, 9);
    };
    Instances.prototype._componentAndInstanceCheck = function(component, id) {
        if (!this._instances[component]) {
            console.warn("Flowbite: Component ".concat(component, " does not exist."));
            return false;
        }
        if (!this._instances[component][id]) {
            console.warn("Flowbite: Instance with ID ".concat(id, " does not exist."));
            return false;
        }
        return true;
    };
    return Instances;
}();
var $9e599e545d4197d0$var$instances = new $9e599e545d4197d0$var$Instances();
var $9e599e545d4197d0$export$2e2bcd8739ae039 = $9e599e545d4197d0$var$instances;
if (typeof window !== "undefined") window.FlowbiteInstances = $9e599e545d4197d0$var$instances;

});


parcelRegister("g6C8J", function(module, exports) {

$parcel$export(module.exports, "initCollapses", () => $bb9acaac13d1970e$export$355ba5a528b4009a);

var $dATps = parcelRequire("dATps");
var $bb9acaac13d1970e$var$__assign = undefined && undefined.__assign || function() {
    $bb9acaac13d1970e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bb9acaac13d1970e$var$__assign.apply(this, arguments);
};
var $bb9acaac13d1970e$var$Default = {
    onCollapse: function() {},
    onExpand: function() {},
    onToggle: function() {}
};
var $bb9acaac13d1970e$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $bb9acaac13d1970e$var$Collapse = /** @class */ function() {
    function Collapse(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $bb9acaac13d1970e$var$Default;
        if (instanceOptions === void 0) instanceOptions = $bb9acaac13d1970e$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $bb9acaac13d1970e$var$__assign($bb9acaac13d1970e$var$__assign({}, $bb9acaac13d1970e$var$Default), options);
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $dATps.default).addInstance("Collapse", this, this._instanceId, instanceOptions.override);
    }
    Collapse.prototype.init = function() {
        var _this = this;
        if (this._triggerEl && this._targetEl && !this._initialized) {
            if (this._triggerEl.hasAttribute("aria-expanded")) this._visible = this._triggerEl.getAttribute("aria-expanded") === "true";
            else // fix until v2 not to break previous single collapses which became dismiss
            this._visible = !this._targetEl.classList.contains("hidden");
            this._clickHandler = function() {
                _this.toggle();
            };
            this._triggerEl.addEventListener("click", this._clickHandler);
            this._initialized = true;
        }
    };
    Collapse.prototype.destroy = function() {
        if (this._triggerEl && this._initialized) {
            this._triggerEl.removeEventListener("click", this._clickHandler);
            this._initialized = false;
        }
    };
    Collapse.prototype.removeInstance = function() {
        (0, $dATps.default).removeInstance("Collapse", this._instanceId);
    };
    Collapse.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Collapse.prototype.collapse = function() {
        this._targetEl.classList.add("hidden");
        if (this._triggerEl) this._triggerEl.setAttribute("aria-expanded", "false");
        this._visible = false;
        // callback function
        this._options.onCollapse(this);
    };
    Collapse.prototype.expand = function() {
        this._targetEl.classList.remove("hidden");
        if (this._triggerEl) this._triggerEl.setAttribute("aria-expanded", "true");
        this._visible = true;
        // callback function
        this._options.onExpand(this);
    };
    Collapse.prototype.toggle = function() {
        if (this._visible) this.collapse();
        else this.expand();
        // callback function
        this._options.onToggle(this);
    };
    Collapse.prototype.updateOnCollapse = function(callback) {
        this._options.onCollapse = callback;
    };
    Collapse.prototype.updateOnExpand = function(callback) {
        this._options.onExpand = callback;
    };
    Collapse.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Collapse;
}();
function $bb9acaac13d1970e$export$355ba5a528b4009a() {
    document.querySelectorAll("[data-collapse-toggle]").forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute("data-collapse-toggle");
        var $targetEl = document.getElementById(targetId);
        // check if the target element exists
        if ($targetEl) {
            if (!(0, $dATps.default).instanceExists("Collapse", $targetEl.getAttribute("id"))) new $bb9acaac13d1970e$var$Collapse($targetEl, $triggerEl);
            else // if instance exists already for the same target element then create a new one with a different trigger element
            new $bb9acaac13d1970e$var$Collapse($targetEl, $triggerEl, {}, {
                id: $targetEl.getAttribute("id") + "_" + (0, $dATps.default)._generateRandomId()
            });
        } else console.error('The target element with id "'.concat(targetId, '" does not exist. Please check the data-collapse-toggle attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Collapse = $bb9acaac13d1970e$var$Collapse;
    window.initCollapses = $bb9acaac13d1970e$export$355ba5a528b4009a;
}
var $bb9acaac13d1970e$export$2e2bcd8739ae039 = $bb9acaac13d1970e$var$Collapse;

});

parcelRegister("knUNi", function(module, exports) {

$parcel$export(module.exports, "initCarousels", () => $ed7202bee3ce6cfe$export$3ab77386b16b9e58);

var $dATps = parcelRequire("dATps");
var $ed7202bee3ce6cfe$var$__assign = undefined && undefined.__assign || function() {
    $ed7202bee3ce6cfe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ed7202bee3ce6cfe$var$__assign.apply(this, arguments);
};
var $ed7202bee3ce6cfe$var$Default = {
    defaultPosition: 0,
    indicators: {
        items: [],
        activeClasses: "bg-white dark:bg-gray-800",
        inactiveClasses: "bg-white/50 dark:bg-gray-800/50 hover:bg-white dark:hover:bg-gray-800"
    },
    interval: 3000,
    onNext: function() {},
    onPrev: function() {},
    onChange: function() {}
};
var $ed7202bee3ce6cfe$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $ed7202bee3ce6cfe$var$Carousel = /** @class */ function() {
    function Carousel(carouselEl, items, options, instanceOptions) {
        if (carouselEl === void 0) carouselEl = null;
        if (items === void 0) items = [];
        if (options === void 0) options = $ed7202bee3ce6cfe$var$Default;
        if (instanceOptions === void 0) instanceOptions = $ed7202bee3ce6cfe$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : carouselEl.id;
        this._carouselEl = carouselEl;
        this._items = items;
        this._options = $ed7202bee3ce6cfe$var$__assign($ed7202bee3ce6cfe$var$__assign($ed7202bee3ce6cfe$var$__assign({}, $ed7202bee3ce6cfe$var$Default), options), {
            indicators: $ed7202bee3ce6cfe$var$__assign($ed7202bee3ce6cfe$var$__assign({}, $ed7202bee3ce6cfe$var$Default.indicators), options.indicators)
        });
        this._activeItem = this.getItem(this._options.defaultPosition);
        this._indicators = this._options.indicators.items;
        this._intervalDuration = this._options.interval;
        this._intervalInstance = null;
        this._initialized = false;
        this.init();
        (0, $dATps.default).addInstance("Carousel", this, this._instanceId, instanceOptions.override);
    }
    /**
     * initialize carousel and items based on active one
     */ Carousel.prototype.init = function() {
        var _this = this;
        if (this._items.length && !this._initialized) {
            this._items.map(function(item) {
                item.el.classList.add("absolute", "inset-0", "transition-transform", "transform");
            });
            // if no active item is set then first position is default
            if (this.getActiveItem()) this.slideTo(this.getActiveItem().position);
            else this.slideTo(0);
            this._indicators.map(function(indicator, position) {
                indicator.el.addEventListener("click", function() {
                    _this.slideTo(position);
                });
            });
            this._initialized = true;
        }
    };
    Carousel.prototype.destroy = function() {
        if (this._initialized) this._initialized = false;
    };
    Carousel.prototype.removeInstance = function() {
        (0, $dATps.default).removeInstance("Carousel", this._instanceId);
    };
    Carousel.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Carousel.prototype.getItem = function(position) {
        return this._items[position];
    };
    /**
     * Slide to the element based on id
     * @param {*} position
     */ Carousel.prototype.slideTo = function(position) {
        var nextItem = this._items[position];
        var rotationItems = {
            left: nextItem.position === 0 ? this._items[this._items.length - 1] : this._items[nextItem.position - 1],
            middle: nextItem,
            right: nextItem.position === this._items.length - 1 ? this._items[0] : this._items[nextItem.position + 1]
        };
        this._rotate(rotationItems);
        this._setActiveItem(nextItem);
        if (this._intervalInstance) {
            this.pause();
            this.cycle();
        }
        this._options.onChange(this);
    };
    /**
     * Based on the currently active item it will go to the next position
     */ Carousel.prototype.next = function() {
        var activeItem = this.getActiveItem();
        var nextItem = null;
        // check if last item
        if (activeItem.position === this._items.length - 1) nextItem = this._items[0];
        else nextItem = this._items[activeItem.position + 1];
        this.slideTo(nextItem.position);
        // callback function
        this._options.onNext(this);
    };
    /**
     * Based on the currently active item it will go to the previous position
     */ Carousel.prototype.prev = function() {
        var activeItem = this.getActiveItem();
        var prevItem = null;
        // check if first item
        if (activeItem.position === 0) prevItem = this._items[this._items.length - 1];
        else prevItem = this._items[activeItem.position - 1];
        this.slideTo(prevItem.position);
        // callback function
        this._options.onPrev(this);
    };
    /**
     * This method applies the transform classes based on the left, middle, and right rotation carousel items
     * @param {*} rotationItems
     */ Carousel.prototype._rotate = function(rotationItems) {
        // reset
        this._items.map(function(item) {
            item.el.classList.add("hidden");
        });
        // Handling the case when there is only one item
        if (this._items.length === 1) {
            rotationItems.middle.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-10");
            rotationItems.middle.el.classList.add("translate-x-0", "z-20");
            return;
        }
        // left item (previously active)
        rotationItems.left.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-20");
        rotationItems.left.el.classList.add("-translate-x-full", "z-10");
        // currently active item
        rotationItems.middle.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-10");
        rotationItems.middle.el.classList.add("translate-x-0", "z-30");
        // right item (upcoming active)
        rotationItems.right.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-30");
        rotationItems.right.el.classList.add("translate-x-full", "z-20");
    };
    /**
     * Set an interval to cycle through the carousel items
     */ Carousel.prototype.cycle = function() {
        var _this = this;
        if (typeof window !== "undefined") this._intervalInstance = window.setInterval(function() {
            _this.next();
        }, this._intervalDuration);
    };
    /**
     * Clears the cycling interval
     */ Carousel.prototype.pause = function() {
        clearInterval(this._intervalInstance);
    };
    /**
     * Get the currently active item
     */ Carousel.prototype.getActiveItem = function() {
        return this._activeItem;
    };
    /**
     * Set the currently active item and data attribute
     * @param {*} position
     */ Carousel.prototype._setActiveItem = function(item) {
        var _a, _b;
        var _this = this;
        this._activeItem = item;
        var position = item.position;
        // update the indicators if available
        if (this._indicators.length) {
            this._indicators.map(function(indicator) {
                var _a, _b;
                indicator.el.setAttribute("aria-current", "false");
                (_a = indicator.el.classList).remove.apply(_a, _this._options.indicators.activeClasses.split(" "));
                (_b = indicator.el.classList).add.apply(_b, _this._options.indicators.inactiveClasses.split(" "));
            });
            (_a = this._indicators[position].el.classList).add.apply(_a, this._options.indicators.activeClasses.split(" "));
            (_b = this._indicators[position].el.classList).remove.apply(_b, this._options.indicators.inactiveClasses.split(" "));
            this._indicators[position].el.setAttribute("aria-current", "true");
        }
    };
    Carousel.prototype.updateOnNext = function(callback) {
        this._options.onNext = callback;
    };
    Carousel.prototype.updateOnPrev = function(callback) {
        this._options.onPrev = callback;
    };
    Carousel.prototype.updateOnChange = function(callback) {
        this._options.onChange = callback;
    };
    return Carousel;
}();
function $ed7202bee3ce6cfe$export$3ab77386b16b9e58() {
    document.querySelectorAll("[data-carousel]").forEach(function($carouselEl) {
        var interval = $carouselEl.getAttribute("data-carousel-interval");
        var slide = $carouselEl.getAttribute("data-carousel") === "slide" ? true : false;
        var items = [];
        var defaultPosition = 0;
        if ($carouselEl.querySelectorAll("[data-carousel-item]").length) Array.from($carouselEl.querySelectorAll("[data-carousel-item]")).map(function($carouselItemEl, position) {
            items.push({
                position: position,
                el: $carouselItemEl
            });
            if ($carouselItemEl.getAttribute("data-carousel-item") === "active") defaultPosition = position;
        });
        var indicators = [];
        if ($carouselEl.querySelectorAll("[data-carousel-slide-to]").length) Array.from($carouselEl.querySelectorAll("[data-carousel-slide-to]")).map(function($indicatorEl) {
            indicators.push({
                position: parseInt($indicatorEl.getAttribute("data-carousel-slide-to")),
                el: $indicatorEl
            });
        });
        var carousel = new $ed7202bee3ce6cfe$var$Carousel($carouselEl, items, {
            defaultPosition: defaultPosition,
            indicators: {
                items: indicators
            },
            interval: interval ? interval : $ed7202bee3ce6cfe$var$Default.interval
        });
        if (slide) carousel.cycle();
        // check for controls
        var carouselNextEl = $carouselEl.querySelector("[data-carousel-next]");
        var carouselPrevEl = $carouselEl.querySelector("[data-carousel-prev]");
        if (carouselNextEl) carouselNextEl.addEventListener("click", function() {
            carousel.next();
        });
        if (carouselPrevEl) carouselPrevEl.addEventListener("click", function() {
            carousel.prev();
        });
    });
}
if (typeof window !== "undefined") {
    window.Carousel = $ed7202bee3ce6cfe$var$Carousel;
    window.initCarousels = $ed7202bee3ce6cfe$export$3ab77386b16b9e58;
}
var $ed7202bee3ce6cfe$export$2e2bcd8739ae039 = $ed7202bee3ce6cfe$var$Carousel;

});

parcelRegister("9MHg3", function(module, exports) {

$parcel$export(module.exports, "initDismisses", () => $71fa26dd9880ee1d$export$69c84787a503daef);

var $dATps = parcelRequire("dATps");
var $71fa26dd9880ee1d$var$__assign = undefined && undefined.__assign || function() {
    $71fa26dd9880ee1d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $71fa26dd9880ee1d$var$__assign.apply(this, arguments);
};
var $71fa26dd9880ee1d$var$Default = {
    transition: "transition-opacity",
    duration: 300,
    timing: "ease-out",
    onHide: function() {}
};
var $71fa26dd9880ee1d$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $71fa26dd9880ee1d$var$Dismiss = /** @class */ function() {
    function Dismiss(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $71fa26dd9880ee1d$var$Default;
        if (instanceOptions === void 0) instanceOptions = $71fa26dd9880ee1d$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $71fa26dd9880ee1d$var$__assign($71fa26dd9880ee1d$var$__assign({}, $71fa26dd9880ee1d$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $dATps.default).addInstance("Dismiss", this, this._instanceId, instanceOptions.override);
    }
    Dismiss.prototype.init = function() {
        var _this = this;
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._clickHandler = function() {
                _this.hide();
            };
            this._triggerEl.addEventListener("click", this._clickHandler);
            this._initialized = true;
        }
    };
    Dismiss.prototype.destroy = function() {
        if (this._triggerEl && this._initialized) {
            this._triggerEl.removeEventListener("click", this._clickHandler);
            this._initialized = false;
        }
    };
    Dismiss.prototype.removeInstance = function() {
        (0, $dATps.default).removeInstance("Dismiss", this._instanceId);
    };
    Dismiss.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Dismiss.prototype.hide = function() {
        var _this = this;
        this._targetEl.classList.add(this._options.transition, "duration-".concat(this._options.duration), this._options.timing, "opacity-0");
        setTimeout(function() {
            _this._targetEl.classList.add("hidden");
        }, this._options.duration);
        // callback function
        this._options.onHide(this, this._targetEl);
    };
    Dismiss.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    return Dismiss;
}();
function $71fa26dd9880ee1d$export$69c84787a503daef() {
    document.querySelectorAll("[data-dismiss-target]").forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute("data-dismiss-target");
        var $dismissEl = document.querySelector(targetId);
        if ($dismissEl) new $71fa26dd9880ee1d$var$Dismiss($dismissEl, $triggerEl);
        else console.error('The dismiss element with id "'.concat(targetId, '" does not exist. Please check the data-dismiss-target attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Dismiss = $71fa26dd9880ee1d$var$Dismiss;
    window.initDismisses = $71fa26dd9880ee1d$export$69c84787a503daef;
}
var $71fa26dd9880ee1d$export$2e2bcd8739ae039 = $71fa26dd9880ee1d$var$Dismiss;

});

parcelRegister("7sBGF", function(module, exports) {

$parcel$export(module.exports, "initDropdowns", () => $56e861d2255aee7e$export$8cb65a02593bf108);

var $3tUi5 = parcelRequire("3tUi5");

var $dATps = parcelRequire("dATps");
var $56e861d2255aee7e$var$__assign = undefined && undefined.__assign || function() {
    $56e861d2255aee7e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $56e861d2255aee7e$var$__assign.apply(this, arguments);
};
var $56e861d2255aee7e$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $56e861d2255aee7e$var$Default = {
    placement: "bottom",
    triggerType: "click",
    offsetSkidding: 0,
    offsetDistance: 10,
    delay: 300,
    ignoreClickOutsideClass: false,
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $56e861d2255aee7e$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $56e861d2255aee7e$var$Dropdown = /** @class */ function() {
    function Dropdown(targetElement, triggerElement, options, instanceOptions) {
        if (targetElement === void 0) targetElement = null;
        if (triggerElement === void 0) triggerElement = null;
        if (options === void 0) options = $56e861d2255aee7e$var$Default;
        if (instanceOptions === void 0) instanceOptions = $56e861d2255aee7e$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetElement.id;
        this._targetEl = targetElement;
        this._triggerEl = triggerElement;
        this._options = $56e861d2255aee7e$var$__assign($56e861d2255aee7e$var$__assign({}, $56e861d2255aee7e$var$Default), options);
        this._popperInstance = null;
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $dATps.default).addInstance("Dropdown", this, this._instanceId, instanceOptions.override);
    }
    Dropdown.prototype.init = function() {
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._popperInstance = this._createPopperInstance();
            this._setupEventListeners();
            this._initialized = true;
        }
    };
    Dropdown.prototype.destroy = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        // Remove click event listeners for trigger element
        if (this._options.triggerType === "click") triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.removeEventListener(ev, _this._clickHandler);
        });
        // Remove hover event listeners for trigger and target elements
        if (this._options.triggerType === "hover") {
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hoverShowTriggerElHandler);
                _this._targetEl.removeEventListener(ev, _this._hoverShowTargetElHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hoverHideHandler);
                _this._targetEl.removeEventListener(ev, _this._hoverHideHandler);
            });
        }
        this._popperInstance.destroy();
        this._initialized = false;
    };
    Dropdown.prototype.removeInstance = function() {
        (0, $dATps.default).removeInstance("Dropdown", this._instanceId);
    };
    Dropdown.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Dropdown.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        this._clickHandler = function() {
            _this.toggle();
        };
        // click event handling for trigger element
        if (this._options.triggerType === "click") triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._clickHandler);
        });
        this._hoverShowTriggerElHandler = function(ev) {
            if (ev.type === "click") _this.toggle();
            else setTimeout(function() {
                _this.show();
            }, _this._options.delay);
        };
        this._hoverShowTargetElHandler = function() {
            _this.show();
        };
        this._hoverHideHandler = function() {
            setTimeout(function() {
                if (!_this._targetEl.matches(":hover")) _this.hide();
            }, _this._options.delay);
        };
        // hover event handling for trigger element
        if (this._options.triggerType === "hover") {
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, _this._hoverShowTriggerElHandler);
                _this._targetEl.addEventListener(ev, _this._hoverShowTargetElHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, _this._hoverHideHandler);
                _this._targetEl.addEventListener(ev, _this._hoverHideHandler);
            });
        }
    };
    Dropdown.prototype._createPopperInstance = function() {
        return (0, $3tUi5.createPopper)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            this._options.offsetSkidding,
                            this._options.offsetDistance
                        ]
                    }
                }
            ]
        });
    };
    Dropdown.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener("click", this._clickOutsideEventListener, true);
    };
    Dropdown.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener("click", this._clickOutsideEventListener, true);
    };
    Dropdown.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        // Ignore clicks on the trigger element (ie. a datepicker input)
        var ignoreClickOutsideClass = this._options.ignoreClickOutsideClass;
        var isIgnored = false;
        if (ignoreClickOutsideClass) {
            var ignoredClickOutsideEls = document.querySelectorAll(".".concat(ignoreClickOutsideClass));
            ignoredClickOutsideEls.forEach(function(el) {
                if (el.contains(clickedEl)) {
                    isIgnored = true;
                    return;
                }
            });
        }
        // Ignore clicks on the target element (ie. dropdown itself)
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && !isIgnored && this.isVisible()) this.hide();
    };
    Dropdown.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case "hover":
                return {
                    showEvents: [
                        "mouseenter",
                        "click"
                    ],
                    hideEvents: [
                        "mouseleave"
                    ]
                };
            case "click":
                return {
                    showEvents: [
                        "click"
                    ],
                    hideEvents: []
                };
            case "none":
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        "click"
                    ],
                    hideEvents: []
                };
        }
    };
    Dropdown.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
        this._options.onToggle(this);
    };
    Dropdown.prototype.isVisible = function() {
        return this._visible;
    };
    Dropdown.prototype.show = function() {
        this._targetEl.classList.remove("hidden");
        this._targetEl.classList.add("block");
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $56e861d2255aee7e$var$__assign($56e861d2255aee7e$var$__assign({}, options), {
                modifiers: $56e861d2255aee7e$var$__spreadArray($56e861d2255aee7e$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: true
                    }
                ], false)
            });
        });
        this._setupClickOutsideListener();
        // Update its position
        this._popperInstance.update();
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Dropdown.prototype.hide = function() {
        this._targetEl.classList.remove("block");
        this._targetEl.classList.add("hidden");
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $56e861d2255aee7e$var$__assign($56e861d2255aee7e$var$__assign({}, options), {
                modifiers: $56e861d2255aee7e$var$__spreadArray($56e861d2255aee7e$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: false
                    }
                ], false)
            });
        });
        this._visible = false;
        this._removeClickOutsideListener();
        // callback function
        this._options.onHide(this);
    };
    Dropdown.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Dropdown.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Dropdown.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Dropdown;
}();
function $56e861d2255aee7e$export$8cb65a02593bf108() {
    document.querySelectorAll("[data-dropdown-toggle]").forEach(function($triggerEl) {
        var dropdownId = $triggerEl.getAttribute("data-dropdown-toggle");
        var $dropdownEl = document.getElementById(dropdownId);
        if ($dropdownEl) {
            var placement = $triggerEl.getAttribute("data-dropdown-placement");
            var offsetSkidding = $triggerEl.getAttribute("data-dropdown-offset-skidding");
            var offsetDistance = $triggerEl.getAttribute("data-dropdown-offset-distance");
            var triggerType = $triggerEl.getAttribute("data-dropdown-trigger");
            var delay = $triggerEl.getAttribute("data-dropdown-delay");
            var ignoreClickOutsideClass = $triggerEl.getAttribute("data-dropdown-ignore-click-outside-class");
            new $56e861d2255aee7e$var$Dropdown($dropdownEl, $triggerEl, {
                placement: placement ? placement : $56e861d2255aee7e$var$Default.placement,
                triggerType: triggerType ? triggerType : $56e861d2255aee7e$var$Default.triggerType,
                offsetSkidding: offsetSkidding ? parseInt(offsetSkidding) : $56e861d2255aee7e$var$Default.offsetSkidding,
                offsetDistance: offsetDistance ? parseInt(offsetDistance) : $56e861d2255aee7e$var$Default.offsetDistance,
                delay: delay ? parseInt(delay) : $56e861d2255aee7e$var$Default.delay,
                ignoreClickOutsideClass: ignoreClickOutsideClass ? ignoreClickOutsideClass : $56e861d2255aee7e$var$Default.ignoreClickOutsideClass
            });
        } else console.error('The dropdown element with id "'.concat(dropdownId, '" does not exist. Please check the data-dropdown-toggle attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Dropdown = $56e861d2255aee7e$var$Dropdown;
    window.initDropdowns = $56e861d2255aee7e$export$8cb65a02593bf108;
}
var $56e861d2255aee7e$export$2e2bcd8739ae039 = $56e861d2255aee7e$var$Dropdown;

});
parcelRegister("3tUi5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);

var $8iXfp = parcelRequire("8iXfp");

var $jU5vk = parcelRequire("jU5vk");

var $cePA2 = parcelRequire("cePA2");

var $5ZHwq = parcelRequire("5ZHwq");

var $aOl9t = parcelRequire("aOl9t");

var $lWzyf = parcelRequire("lWzyf");

var $hMqHB = parcelRequire("hMqHB");

var $bxdrS = parcelRequire("bxdrS");

var $kU5lB = parcelRequire("kU5lB");

var $95q7y = parcelRequire("95q7y");


var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $jU5vk.default),
    (0, $cePA2.default),
    (0, $5ZHwq.default),
    (0, $aOl9t.default),
    (0, $lWzyf.default),
    (0, $hMqHB.default),
    (0, $bxdrS.default),
    (0, $kU5lB.default),
    (0, $95q7y.default)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8iXfp.popperGenerator)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8iXfp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);

var $gcqB4 = parcelRequire("gcqB4");

var $dElKO = parcelRequire("dElKO");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $ahlk8 = parcelRequire("ahlk8");

var $dlelj = parcelRequire("dlelj");

var $l57aq = parcelRequire("l57aq");


var $93iQ7 = parcelRequire("93iQ7");
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $93iQ7.isElement)(reference) ? (0, $cqjGx.default)(reference) : reference.contextElement ? (0, $cqjGx.default)(reference.contextElement) : [],
                    popper: (0, $cqjGx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ahlk8.default)((0, $l57aq.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gcqB4.default)(reference, (0, $5KzeH.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $dElKO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlelj.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gcqB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb265ed9201975a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $eOasn = parcelRequire("eOasn");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");

var $8fnXo = parcelRequire("8fnXo");

var $17OuU = parcelRequire("17OuU");

var $1ADUj = parcelRequire("1ADUj");

var $4J8n1 = parcelRequire("4J8n1");
function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4J8n1.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4J8n1.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $93iQ7.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $93iQ7.isHTMLElement)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $17OuU.default)(offsetParent);
    var rect = (0, $41Z5W.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $oKPBf.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1ADUj.default)(documentElement)) scroll = (0, $eOasn.default)(offsetParent);
        if ((0, $93iQ7.isHTMLElement)(offsetParent)) {
            offsets = (0, $41Z5W.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8fnXo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("41Z5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef6a598263dba8e$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");

var $4J8n1 = parcelRequire("4J8n1");

var $93G53 = parcelRequire("93G53");

var $gotNd = parcelRequire("gotNd");
function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $93iQ7.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4J8n1.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4J8n1.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $93iQ7.isElement)(element) ? (0, $93G53.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gotNd.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("93iQ7", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $69730206aa270d41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $69730206aa270d41$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $69730206aa270d41$export$af51f0f06c0f328a);

var $93G53 = parcelRequire("93G53");
function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $93G53.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $93G53.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $93G53.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("93G53", function(module, exports) {

$parcel$export(module.exports, "default", () => $6985093033570817$export$2e2bcd8739ae039);
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("4J8n1", function(module, exports) {

$parcel$export(module.exports, "max", () => $3711db8b00de96df$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $3711db8b00de96df$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $3711db8b00de96df$export$2077e0241d6afd3c);
var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gotNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef5ff765617d084$export$2e2bcd8739ae039);

var $9r1ut = parcelRequire("9r1ut");
function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9r1ut.default)());
}

});
parcelRegister("9r1ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de7caa8ee90d63c$export$2e2bcd8739ae039);
function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("eOasn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7dd8aeabb81fe8$export$2e2bcd8739ae039);

var $4WW7r = parcelRequire("4WW7r");

var $93G53 = parcelRequire("93G53");

var $93iQ7 = parcelRequire("93iQ7");

var $ieX38 = parcelRequire("ieX38");
function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $93G53.default)(node) || !(0, $93iQ7.isHTMLElement)(node)) return (0, $4WW7r.default)(node);
    else return (0, $ieX38.default)(node);
}

});
parcelRegister("4WW7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a9a96b6f99add9$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $93G53.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ieX38", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47756cb7a847081$export$2e2bcd8739ae039);
function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("oKPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a691b7a330df44$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("8fnXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60124eceeef28a28$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $17OuU = parcelRequire("17OuU");

var $4WW7r = parcelRequire("4WW7r");
function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $41Z5W.default)((0, $17OuU.default)(element)).left + (0, $4WW7r.default)(element).scrollLeft;
}

});
parcelRegister("17OuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1d9daad62fa952$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $93iQ7.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("1ADUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12881c0013479a14$export$2e2bcd8739ae039);

var $huVQQ = parcelRequire("huVQQ");
function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $huVQQ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("huVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd21d1454570861$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $93G53.default)(element).getComputedStyle(element);
}

});



parcelRegister("dElKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9effe2b32f662e4a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");
function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $41Z5W.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("cqjGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b72ed15edfd54a$export$2e2bcd8739ae039);

var $3QP5e = parcelRequire("3QP5e");

var $aerap = parcelRequire("aerap");

var $93G53 = parcelRequire("93G53");

var $1ADUj = parcelRequire("1ADUj");
function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3QP5e.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $93G53.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1ADUj.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $aerap.default)(target)));
}

});
parcelRegister("3QP5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cddda83e3357241$export$2e2bcd8739ae039);

var $aerap = parcelRequire("aerap");

var $1ADUj = parcelRequire("1ADUj");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $oKPBf.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $93iQ7.isHTMLElement)(node) && (0, $1ADUj.default)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $aerap.default)(node));
}

});
parcelRegister("aerap", function(module, exports) {

$parcel$export(module.exports, "default", () => $773048fc1d2aa7ee$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $17OuU = parcelRequire("17OuU");

var $93iQ7 = parcelRequire("93iQ7");
function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $oKPBf.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $93iQ7.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $17OuU.default)(element) // fallback
    );
}

});



parcelRegister("5KzeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc94c94931c781$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $oKPBf = parcelRequire("oKPBf");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $lKbxe = parcelRequire("lKbxe");

var $aerap = parcelRequire("aerap");

var $9r1ut = parcelRequire("9r1ut");
function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $93iQ7.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $huVQQ.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9r1ut.default)());
    var isIE = /Trident/i.test((0, $9r1ut.default)());
    if (isIE && (0, $93iQ7.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $huVQQ.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $aerap.default)(element);
    if ((0, $93iQ7.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $93iQ7.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $oKPBf.default)(currentNode)) < 0){
        var css = (0, $huVQQ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $93G53.default)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lKbxe.default)(offsetParent) && (0, $huVQQ.default)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $oKPBf.default)(offsetParent) === "html" || (0, $oKPBf.default)(offsetParent) === "body" && (0, $huVQQ.default)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}

});
parcelRegister("lKbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd46d779ec622be4$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");
function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $oKPBf.default)(element)) >= 0;
}

});


parcelRegister("ahlk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bc085de34276f2$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");
function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1KQnQ.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1KQnQ", function(module, exports) {

$parcel$export(module.exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];

});


parcelRegister("dlelj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b685cb08303911c$export$2e2bcd8739ae039);
function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l57aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58f9fd4551b4b0f$export$2e2bcd8739ae039);
function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("jU5vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7845625089588$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $93G53.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};

});

parcelRegister("cePA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);

var $dgDBP = parcelRequire("dgDBP");
function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dgDBP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};

});
parcelRegister("dgDBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8b7e877fbba4f3$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $g1hRA = parcelRequire("g1hRA");

var $1KQnQ = parcelRequire("1KQnQ");
function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h06jI.default)(placement) : null;
    var variation = placement ? (0, $7kchx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1KQnQ.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1KQnQ.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1KQnQ.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1KQnQ.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $g1hRA.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1KQnQ.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1KQnQ.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("h06jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6075629d0814627$export$2e2bcd8739ae039);

function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("7kchx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553ed9c2ee225e3$export$2e2bcd8739ae039);
function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("g1hRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a98a4204389e3$export$2e2bcd8739ae039);
function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("5ZHwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $5KzeH = parcelRequire("5KzeH");

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $4J8n1 = parcelRequire("4J8n1");
var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4J8n1.round)(x * dpr) / dpr || 0,
        y: (0, $4J8n1.round)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1KQnQ.left);
    var sideY = (0, $1KQnQ.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5KzeH.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $93G53.default)(popper)) {
            offsetParent = (0, $17OuU.default)(popper);
            if ((0, $huVQQ.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1KQnQ.top) || (placement === (0, $1KQnQ.left) || placement === (0, $1KQnQ.right)) && variation === (0, $1KQnQ.end)) {
            sideY = (0, $1KQnQ.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1KQnQ.left) || (placement === (0, $1KQnQ.top) || placement === (0, $1KQnQ.bottom)) && variation === (0, $1KQnQ.end)) {
            sideX = (0, $1KQnQ.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $93G53.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $h06jI.default)(state.placement),
        variation: (0, $7kchx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};

});

parcelRegister("aOl9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deefb3680d4558f$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("lWzyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $1KQnQ = parcelRequire("1KQnQ");
function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h06jI.default)(placement);
    var invertDistance = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1KQnQ.placements).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};

});

parcelRegister("hMqHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);

var $eFT7Y = parcelRequire("eFT7Y");

var $h06jI = parcelRequire("h06jI");

var $4NVvZ = parcelRequire("4NVvZ");

var $gGcga = parcelRequire("gGcga");

var $iN4T7 = parcelRequire("iN4T7");

var $1KQnQ = parcelRequire("1KQnQ");

var $7kchx = parcelRequire("7kchx");
function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h06jI.default)(placement) === (0, $1KQnQ.auto)) return [];
    var oppositePlacement = (0, $eFT7Y.default)(placement);
    return [
        (0, $4NVvZ.default)(placement),
        oppositePlacement,
        (0, $4NVvZ.default)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h06jI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $eFT7Y.default)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h06jI.default)(placement) === (0, $1KQnQ.auto) ? (0, $iN4T7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h06jI.default)(placement);
        var isStartVariation = (0, $7kchx.default)(placement) === (0, $1KQnQ.start);
        var isVertical = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1KQnQ.right) : (0, $1KQnQ.left) : isStartVariation ? (0, $1KQnQ.bottom) : (0, $1KQnQ.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var altVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("eFT7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaefa8315f14c8e2$export$2e2bcd8739ae039);
var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}

});

parcelRegister("4NVvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f85a49ff946cb6$export$2e2bcd8739ae039);
var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}

});

parcelRegister("gGcga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);

var $5T76m = parcelRequire("5T76m");

var $17OuU = parcelRequire("17OuU");

var $41Z5W = parcelRequire("41Z5W");

var $dgDBP = parcelRequire("dgDBP");

var $ik7Fq = parcelRequire("ik7Fq");

var $1KQnQ = parcelRequire("1KQnQ");

var $93iQ7 = parcelRequire("93iQ7");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");
function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1KQnQ.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1KQnQ.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1KQnQ.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Os63.default)(typeof padding !== "number" ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
    var altContext = elementContext === (0, $1KQnQ.popper) ? (0, $1KQnQ.reference) : (0, $1KQnQ.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5T76m.default)((0, $93iQ7.isElement)(element) ? element : element.contextElement || (0, $17OuU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $41Z5W.default)(state.elements.reference);
    var popperOffsets = (0, $dgDBP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $ik7Fq.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1KQnQ.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1KQnQ.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1KQnQ.right),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1KQnQ.top),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5T76m", function(module, exports) {

$parcel$export(module.exports, "default", () => $449799046a13d100$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $e1yxe = parcelRequire("e1yxe");

var $ef4Kl = parcelRequire("ef4Kl");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $41Z5W = parcelRequire("41Z5W");

var $aerap = parcelRequire("aerap");

var $ciq1x = parcelRequire("ciq1x");

var $oKPBf = parcelRequire("oKPBf");

var $ik7Fq = parcelRequire("ik7Fq");

var $4J8n1 = parcelRequire("4J8n1");
function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $41Z5W.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1KQnQ.viewport) ? (0, $ik7Fq.default)((0, $e1yxe.default)(element, strategy)) : (0, $93iQ7.isElement)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ik7Fq.default)((0, $ef4Kl.default)((0, $17OuU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $cqjGx.default)((0, $aerap.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $huVQQ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $93iQ7.isHTMLElement)(element) ? (0, $5KzeH.default)(element) : element;
    if (!(0, $93iQ7.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $93iQ7.isElement)(clippingParent) && (0, $ciq1x.default)(clippingParent, clipperElement) && (0, $oKPBf.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4J8n1.max)(rect.top, accRect.top);
        accRect.right = (0, $4J8n1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4J8n1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4J8n1.max)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("e1yxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35bf29d5fc5ab40$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $8fnXo = parcelRequire("8fnXo");

var $gotNd = parcelRequire("gotNd");
function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $93G53.default)(element);
    var html = (0, $17OuU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gotNd.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8fnXo.default)(element),
        y: y
    };
}

});

parcelRegister("ef4Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e625ef2dd801ec$export$2e2bcd8739ae039);

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $8fnXo = parcelRequire("8fnXo");

var $4WW7r = parcelRequire("4WW7r");

var $4J8n1 = parcelRequire("4J8n1");
function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $17OuU.default)(element);
    var winScroll = (0, $4WW7r.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4J8n1.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4J8n1.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8fnXo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $huVQQ.default)(body || html).direction === "rtl") x += (0, $4J8n1.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ciq1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3b5a3db2e59cbc$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $93iQ7.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ik7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5700acdd3ba9a3c$export$2e2bcd8739ae039);
function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3Os63", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6bd604be4c867e$export$2e2bcd8739ae039);

var $gcu3h = parcelRequire("gcu3h");
function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gcu3h.default)(), paddingObject);
}

});
parcelRegister("gcu3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb51404109b5184$export$2e2bcd8739ae039);
function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hdgde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88039fe47959ef5$export$2e2bcd8739ae039);
function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iN4T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae0983d65fbfc0b$export$2e2bcd8739ae039);

var $7kchx = parcelRequire("7kchx");

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");

var $h06jI = parcelRequire("h06jI");
function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1KQnQ.placements) : _options$allowedAutoP;
    var variation = (0, $7kchx.default)(placement);
    var placements = variation ? flipVariations ? (0, $1KQnQ.variationPlacements) : (0, $1KQnQ.variationPlacements).filter(function(placement) {
        return (0, $7kchx.default)(placement) === variation;
    }) : (0, $1KQnQ.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h06jI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("bxdrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d356b2ca960a5$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $h06jI = parcelRequire("h06jI");

var $g1hRA = parcelRequire("g1hRA");

var $8ptl2 = parcelRequire("8ptl2");

var $cOvrb = parcelRequire("cOvrb");

var $dElKO = parcelRequire("dElKO");

var $5KzeH = parcelRequire("5KzeH");

var $gGcga = parcelRequire("gGcga");

var $7kchx = parcelRequire("7kchx");

var $gcu3h = parcelRequire("gcu3h");

var $4J8n1 = parcelRequire("4J8n1");
function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gGcga.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h06jI.default)(state.placement);
    var variation = (0, $7kchx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $g1hRA.default)(basePlacement);
    var altAxis = (0, $8ptl2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var altSide = mainAxis === "y" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1KQnQ.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1KQnQ.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dElKO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $gcu3h.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cOvrb.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5KzeH.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cOvrb.within)(tether ? (0, $4J8n1.min)(min, tetherMin) : min, offset, tether ? (0, $4J8n1.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var _altSide = mainAxis === "x" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cOvrb.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cOvrb.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("8ptl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f76a8076c296c7$export$2e2bcd8739ae039);
function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("cOvrb", function(module, exports) {

$parcel$export(module.exports, "within", () => $95428a5e75015184$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $95428a5e75015184$export$86c8af6d3ef0b4a);

var $4J8n1 = parcelRequire("4J8n1");
function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $4J8n1.max)(min, (0, $4J8n1.min)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("kU5lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $dElKO = parcelRequire("dElKO");

var $ciq1x = parcelRequire("ciq1x");

var $5KzeH = parcelRequire("5KzeH");

var $g1hRA = parcelRequire("g1hRA");

var $cOvrb = parcelRequire("cOvrb");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");

var $1KQnQ = parcelRequire("1KQnQ");
var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Os63.default)(typeof padding !== "number" ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h06jI.default)(state.placement);
    var axis = (0, $g1hRA.default)(basePlacement);
    var isVertical = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dElKO.default)(arrowElement);
    var minProp = axis === "y" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
    var maxProp = axis === "y" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5KzeH.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cOvrb.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ciq1x.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("95q7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");
function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1KQnQ.top),
        (0, $1KQnQ.right),
        (0, $1KQnQ.bottom),
        (0, $1KQnQ.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gGcga.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $gGcga.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};

});



parcelRegister("jF2f2", function(module, exports) {

$parcel$export(module.exports, "initModals", () => $e50395cbfc69fa09$export$e14d3bc873a8b9b1);
$parcel$export(module.exports, "default", () => $e50395cbfc69fa09$export$2e2bcd8739ae039);

var $dATps = parcelRequire("dATps");
var $e50395cbfc69fa09$var$__assign = undefined && undefined.__assign || function() {
    $e50395cbfc69fa09$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e50395cbfc69fa09$var$__assign.apply(this, arguments);
};
var $e50395cbfc69fa09$var$Default = {
    placement: "center",
    backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
    backdrop: "dynamic",
    closable: true,
    onHide: function() {},
    onShow: function() {},
    onToggle: function() {}
};
var $e50395cbfc69fa09$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $e50395cbfc69fa09$var$Modal = /** @class */ function() {
    function Modal(targetEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $e50395cbfc69fa09$var$Default;
        if (instanceOptions === void 0) instanceOptions = $e50395cbfc69fa09$var$DefaultInstanceOptions;
        this._eventListenerInstances = [];
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._options = $e50395cbfc69fa09$var$__assign($e50395cbfc69fa09$var$__assign({}, $e50395cbfc69fa09$var$Default), options);
        this._isHidden = true;
        this._backdropEl = null;
        this._initialized = false;
        this.init();
        (0, $dATps.default).addInstance("Modal", this, this._instanceId, instanceOptions.override);
    }
    Modal.prototype.init = function() {
        var _this = this;
        if (this._targetEl && !this._initialized) {
            this._getPlacementClasses().map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._initialized = true;
        }
    };
    Modal.prototype.destroy = function() {
        if (this._initialized) {
            this.removeAllEventListenerInstances();
            this._destroyBackdropEl();
            this._initialized = false;
        }
    };
    Modal.prototype.removeInstance = function() {
        (0, $dATps.default).removeInstance("Modal", this._instanceId);
    };
    Modal.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Modal.prototype._createBackdrop = function() {
        var _a;
        if (this._isHidden) {
            var backdropEl = document.createElement("div");
            backdropEl.setAttribute("modal-backdrop", "");
            (_a = backdropEl.classList).add.apply(_a, this._options.backdropClasses.split(" "));
            document.querySelector("body").append(backdropEl);
            this._backdropEl = backdropEl;
        }
    };
    Modal.prototype._destroyBackdropEl = function() {
        if (!this._isHidden) document.querySelector("[modal-backdrop]").remove();
    };
    Modal.prototype._setupModalCloseEventListeners = function() {
        var _this = this;
        if (this._options.backdrop === "dynamic") {
            this._clickOutsideEventListener = function(ev) {
                _this._handleOutsideClick(ev.target);
            };
            this._targetEl.addEventListener("click", this._clickOutsideEventListener, true);
        }
        this._keydownEventListener = function(ev) {
            if (ev.key === "Escape") _this.hide();
        };
        document.body.addEventListener("keydown", this._keydownEventListener, true);
    };
    Modal.prototype._removeModalCloseEventListeners = function() {
        if (this._options.backdrop === "dynamic") this._targetEl.removeEventListener("click", this._clickOutsideEventListener, true);
        document.body.removeEventListener("keydown", this._keydownEventListener, true);
    };
    Modal.prototype._handleOutsideClick = function(target) {
        if (target === this._targetEl || target === this._backdropEl && this.isVisible()) this.hide();
    };
    Modal.prototype._getPlacementClasses = function() {
        switch(this._options.placement){
            // top
            case "top-left":
                return [
                    "justify-start",
                    "items-start"
                ];
            case "top-center":
                return [
                    "justify-center",
                    "items-start"
                ];
            case "top-right":
                return [
                    "justify-end",
                    "items-start"
                ];
            // center
            case "center-left":
                return [
                    "justify-start",
                    "items-center"
                ];
            case "center":
                return [
                    "justify-center",
                    "items-center"
                ];
            case "center-right":
                return [
                    "justify-end",
                    "items-center"
                ];
            // bottom
            case "bottom-left":
                return [
                    "justify-start",
                    "items-end"
                ];
            case "bottom-center":
                return [
                    "justify-center",
                    "items-end"
                ];
            case "bottom-right":
                return [
                    "justify-end",
                    "items-end"
                ];
            default:
                return [
                    "justify-center",
                    "items-center"
                ];
        }
    };
    Modal.prototype.toggle = function() {
        if (this._isHidden) this.show();
        else this.hide();
        // callback function
        this._options.onToggle(this);
    };
    Modal.prototype.show = function() {
        if (this.isHidden) {
            this._targetEl.classList.add("flex");
            this._targetEl.classList.remove("hidden");
            this._targetEl.setAttribute("aria-modal", "true");
            this._targetEl.setAttribute("role", "dialog");
            this._targetEl.removeAttribute("aria-hidden");
            this._createBackdrop();
            this._isHidden = false;
            // Add keyboard event listener to the document
            if (this._options.closable) this._setupModalCloseEventListeners();
            // prevent body scroll
            document.body.classList.add("overflow-hidden");
            // callback function
            this._options.onShow(this);
        }
    };
    Modal.prototype.hide = function() {
        if (this.isVisible) {
            this._targetEl.classList.add("hidden");
            this._targetEl.classList.remove("flex");
            this._targetEl.setAttribute("aria-hidden", "true");
            this._targetEl.removeAttribute("aria-modal");
            this._targetEl.removeAttribute("role");
            this._destroyBackdropEl();
            this._isHidden = true;
            // re-apply body scroll
            document.body.classList.remove("overflow-hidden");
            if (this._options.closable) this._removeModalCloseEventListeners();
            // callback function
            this._options.onHide(this);
        }
    };
    Modal.prototype.isVisible = function() {
        return !this._isHidden;
    };
    Modal.prototype.isHidden = function() {
        return this._isHidden;
    };
    Modal.prototype.addEventListenerInstance = function(element, type, handler) {
        this._eventListenerInstances.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    Modal.prototype.removeAllEventListenerInstances = function() {
        this._eventListenerInstances.map(function(eventListenerInstance) {
            eventListenerInstance.element.removeEventListener(eventListenerInstance.type, eventListenerInstance.handler);
        });
        this._eventListenerInstances = [];
    };
    Modal.prototype.getAllEventListenerInstances = function() {
        return this._eventListenerInstances;
    };
    Modal.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Modal.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Modal.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Modal;
}();
function $e50395cbfc69fa09$export$e14d3bc873a8b9b1() {
    // initiate modal based on data-modal-target
    document.querySelectorAll("[data-modal-target]").forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute("data-modal-target");
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var placement = $modalEl.getAttribute("data-modal-placement");
            var backdrop = $modalEl.getAttribute("data-modal-backdrop");
            new $e50395cbfc69fa09$var$Modal($modalEl, {
                placement: placement ? placement : $e50395cbfc69fa09$var$Default.placement,
                backdrop: backdrop ? backdrop : $e50395cbfc69fa09$var$Default.backdrop
            });
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-target attribute points to the correct modal id?."));
    });
    // toggle modal visibility
    document.querySelectorAll("[data-modal-toggle]").forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute("data-modal-toggle");
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_1 = (0, $dATps.default).getInstance("Modal", modalId);
            if (modal_1) {
                var toggleModal = function() {
                    modal_1.toggle();
                };
                $triggerEl.addEventListener("click", toggleModal);
                modal_1.addEventListenerInstance($triggerEl, "click", toggleModal);
            } else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-toggle attribute points to the correct modal id?"));
    });
    // show modal on click if exists based on id
    document.querySelectorAll("[data-modal-show]").forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute("data-modal-show");
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_2 = (0, $dATps.default).getInstance("Modal", modalId);
            if (modal_2) {
                var showModal = function() {
                    modal_2.show();
                };
                $triggerEl.addEventListener("click", showModal);
                modal_2.addEventListenerInstance($triggerEl, "click", showModal);
            } else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-show attribute points to the correct modal id?"));
    });
    // hide modal on click if exists based on id
    document.querySelectorAll("[data-modal-hide]").forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute("data-modal-hide");
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_3 = (0, $dATps.default).getInstance("Modal", modalId);
            if (modal_3) {
                var hideModal = function() {
                    modal_3.hide();
                };
                $triggerEl.addEventListener("click", hideModal);
                modal_3.addEventListenerInstance($triggerEl, "click", hideModal);
            } else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-hide attribute points to the correct modal id?"));
    });
}
if (typeof window !== "undefined") {
    window.Modal = $e50395cbfc69fa09$var$Modal;
    window.initModals = $e50395cbfc69fa09$export$e14d3bc873a8b9b1;
}
var $e50395cbfc69fa09$export$2e2bcd8739ae039 = $e50395cbfc69fa09$var$Modal;

});

parcelRegister("6E0Df", function(module, exports) {

$parcel$export(module.exports, "initDrawers", () => $4d66f8052cdbfb83$export$319df2b10e87c8ec);

var $dATps = parcelRequire("dATps");
var $4d66f8052cdbfb83$var$__assign = undefined && undefined.__assign || function() {
    $4d66f8052cdbfb83$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4d66f8052cdbfb83$var$__assign.apply(this, arguments);
};
var $4d66f8052cdbfb83$var$Default = {
    placement: "left",
    bodyScrolling: false,
    backdrop: true,
    edge: false,
    edgeOffset: "bottom-[60px]",
    backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30",
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $4d66f8052cdbfb83$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $4d66f8052cdbfb83$var$Drawer = /** @class */ function() {
    function Drawer(targetEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $4d66f8052cdbfb83$var$Default;
        if (instanceOptions === void 0) instanceOptions = $4d66f8052cdbfb83$var$DefaultInstanceOptions;
        this._eventListenerInstances = [];
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._options = $4d66f8052cdbfb83$var$__assign($4d66f8052cdbfb83$var$__assign({}, $4d66f8052cdbfb83$var$Default), options);
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $dATps.default).addInstance("Drawer", this, this._instanceId, instanceOptions.override);
    }
    Drawer.prototype.init = function() {
        var _this = this;
        // set initial accessibility attributes
        if (this._targetEl && !this._initialized) {
            this._targetEl.setAttribute("aria-hidden", "true");
            this._targetEl.classList.add("transition-transform");
            // set base placement classes
            this._getPlacementClasses(this._options.placement).base.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._handleEscapeKey = function(event) {
                if (event.key === "Escape") // if 'Escape' key is pressed
                {
                    if (_this.isVisible()) // if the Drawer is visible
                    _this.hide(); // hide the Drawer
                }
            };
            // add keyboard event listener to document
            document.addEventListener("keydown", this._handleEscapeKey);
            this._initialized = true;
        }
    };
    Drawer.prototype.destroy = function() {
        if (this._initialized) {
            this.removeAllEventListenerInstances();
            this._destroyBackdropEl();
            // Remove the keyboard event listener
            document.removeEventListener("keydown", this._handleEscapeKey);
            this._initialized = false;
        }
    };
    Drawer.prototype.removeInstance = function() {
        (0, $dATps.default).removeInstance("Drawer", this._instanceId);
    };
    Drawer.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Drawer.prototype.hide = function() {
        var _this = this;
        // based on the edge option show placement classes
        if (this._options.edge) {
            this._getPlacementClasses(this._options.placement + "-edge").active.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
            this._getPlacementClasses(this._options.placement + "-edge").inactive.map(function(c) {
                _this._targetEl.classList.add(c);
            });
        } else {
            this._getPlacementClasses(this._options.placement).active.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
            this._getPlacementClasses(this._options.placement).inactive.map(function(c) {
                _this._targetEl.classList.add(c);
            });
        }
        // set accessibility attributes
        this._targetEl.setAttribute("aria-hidden", "true");
        this._targetEl.removeAttribute("aria-modal");
        this._targetEl.removeAttribute("role");
        // enable body scroll
        if (!this._options.bodyScrolling) document.body.classList.remove("overflow-hidden");
        // destroy backdrop
        if (this._options.backdrop) this._destroyBackdropEl();
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Drawer.prototype.show = function() {
        var _this = this;
        if (this._options.edge) {
            this._getPlacementClasses(this._options.placement + "-edge").active.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._getPlacementClasses(this._options.placement + "-edge").inactive.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
        } else {
            this._getPlacementClasses(this._options.placement).active.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._getPlacementClasses(this._options.placement).inactive.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
        }
        // set accessibility attributes
        this._targetEl.setAttribute("aria-modal", "true");
        this._targetEl.setAttribute("role", "dialog");
        this._targetEl.removeAttribute("aria-hidden");
        // disable body scroll
        if (!this._options.bodyScrolling) document.body.classList.add("overflow-hidden");
        // show backdrop
        if (this._options.backdrop) this._createBackdrop();
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Drawer.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
    };
    Drawer.prototype._createBackdrop = function() {
        var _a;
        var _this = this;
        if (!this._visible) {
            var backdropEl = document.createElement("div");
            backdropEl.setAttribute("drawer-backdrop", "");
            (_a = backdropEl.classList).add.apply(_a, this._options.backdropClasses.split(" "));
            document.querySelector("body").append(backdropEl);
            backdropEl.addEventListener("click", function() {
                _this.hide();
            });
        }
    };
    Drawer.prototype._destroyBackdropEl = function() {
        if (this._visible && document.querySelector("[drawer-backdrop]") !== null) document.querySelector("[drawer-backdrop]").remove();
    };
    Drawer.prototype._getPlacementClasses = function(placement) {
        switch(placement){
            case "top":
                return {
                    base: [
                        "top-0",
                        "left-0",
                        "right-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "-translate-y-full"
                    ]
                };
            case "right":
                return {
                    base: [
                        "right-0",
                        "top-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "translate-x-full"
                    ]
                };
            case "bottom":
                return {
                    base: [
                        "bottom-0",
                        "left-0",
                        "right-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "translate-y-full"
                    ]
                };
            case "left":
                return {
                    base: [
                        "left-0",
                        "top-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "-translate-x-full"
                    ]
                };
            case "bottom-edge":
                return {
                    base: [
                        "left-0",
                        "top-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "translate-y-full",
                        this._options.edgeOffset
                    ]
                };
            default:
                return {
                    base: [
                        "left-0",
                        "top-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "-translate-x-full"
                    ]
                };
        }
    };
    Drawer.prototype.isHidden = function() {
        return !this._visible;
    };
    Drawer.prototype.isVisible = function() {
        return this._visible;
    };
    Drawer.prototype.addEventListenerInstance = function(element, type, handler) {
        this._eventListenerInstances.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    Drawer.prototype.removeAllEventListenerInstances = function() {
        this._eventListenerInstances.map(function(eventListenerInstance) {
            eventListenerInstance.element.removeEventListener(eventListenerInstance.type, eventListenerInstance.handler);
        });
        this._eventListenerInstances = [];
    };
    Drawer.prototype.getAllEventListenerInstances = function() {
        return this._eventListenerInstances;
    };
    Drawer.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Drawer.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Drawer.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Drawer;
}();
function $4d66f8052cdbfb83$export$319df2b10e87c8ec() {
    document.querySelectorAll("[data-drawer-target]").forEach(function($triggerEl) {
        // mandatory
        var drawerId = $triggerEl.getAttribute("data-drawer-target");
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var placement = $triggerEl.getAttribute("data-drawer-placement");
            var bodyScrolling = $triggerEl.getAttribute("data-drawer-body-scrolling");
            var backdrop = $triggerEl.getAttribute("data-drawer-backdrop");
            var edge = $triggerEl.getAttribute("data-drawer-edge");
            var edgeOffset = $triggerEl.getAttribute("data-drawer-edge-offset");
            new $4d66f8052cdbfb83$var$Drawer($drawerEl, {
                placement: placement ? placement : $4d66f8052cdbfb83$var$Default.placement,
                bodyScrolling: bodyScrolling ? bodyScrolling === "true" ? true : false : $4d66f8052cdbfb83$var$Default.bodyScrolling,
                backdrop: backdrop ? backdrop === "true" ? true : false : $4d66f8052cdbfb83$var$Default.backdrop,
                edge: edge ? edge === "true" ? true : false : $4d66f8052cdbfb83$var$Default.edge,
                edgeOffset: edgeOffset ? edgeOffset : $4d66f8052cdbfb83$var$Default.edgeOffset
            });
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
    document.querySelectorAll("[data-drawer-toggle]").forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute("data-drawer-toggle");
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_1 = (0, $dATps.default).getInstance("Drawer", drawerId);
            if (drawer_1) {
                var toggleDrawer = function() {
                    drawer_1.toggle();
                };
                $triggerEl.addEventListener("click", toggleDrawer);
                drawer_1.addEventListenerInstance($triggerEl, "click", toggleDrawer);
            } else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
    document.querySelectorAll("[data-drawer-dismiss], [data-drawer-hide]").forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute("data-drawer-dismiss") ? $triggerEl.getAttribute("data-drawer-dismiss") : $triggerEl.getAttribute("data-drawer-hide");
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_2 = (0, $dATps.default).getInstance("Drawer", drawerId);
            if (drawer_2) {
                var hideDrawer = function() {
                    drawer_2.hide();
                };
                $triggerEl.addEventListener("click", hideDrawer);
                drawer_2.addEventListenerInstance($triggerEl, "click", hideDrawer);
            } else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id"));
    });
    document.querySelectorAll("[data-drawer-show]").forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute("data-drawer-show");
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_3 = (0, $dATps.default).getInstance("Drawer", drawerId);
            if (drawer_3) {
                var showDrawer = function() {
                    drawer_3.show();
                };
                $triggerEl.addEventListener("click", showDrawer);
                drawer_3.addEventListenerInstance($triggerEl, "click", showDrawer);
            } else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
}
if (typeof window !== "undefined") {
    window.Drawer = $4d66f8052cdbfb83$var$Drawer;
    window.initDrawers = $4d66f8052cdbfb83$export$319df2b10e87c8ec;
}
var $4d66f8052cdbfb83$export$2e2bcd8739ae039 = $4d66f8052cdbfb83$var$Drawer;

});

parcelRegister("5M6bU", function(module, exports) {

$parcel$export(module.exports, "initTabs", () => $43463cdeacf1e0fa$export$c92e8f569ad2976f);

var $dATps = parcelRequire("dATps");
var $43463cdeacf1e0fa$var$__assign = undefined && undefined.__assign || function() {
    $43463cdeacf1e0fa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $43463cdeacf1e0fa$var$__assign.apply(this, arguments);
};
var $43463cdeacf1e0fa$var$Default = {
    defaultTabId: null,
    activeClasses: "text-blue-600 hover:text-blue-600 dark:text-blue-500 dark:hover:text-blue-500 border-blue-600 dark:border-blue-500",
    inactiveClasses: "dark:border-transparent text-gray-500 hover:text-gray-600 dark:text-gray-400 border-gray-100 hover:border-gray-300 dark:border-gray-700 dark:hover:text-gray-300",
    onShow: function() {}
};
var $43463cdeacf1e0fa$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $43463cdeacf1e0fa$var$Tabs = /** @class */ function() {
    function Tabs(tabsEl, items, options, instanceOptions) {
        if (tabsEl === void 0) tabsEl = null;
        if (items === void 0) items = [];
        if (options === void 0) options = $43463cdeacf1e0fa$var$Default;
        if (instanceOptions === void 0) instanceOptions = $43463cdeacf1e0fa$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : tabsEl.id;
        this._tabsEl = tabsEl;
        this._items = items;
        this._activeTab = options ? this.getTab(options.defaultTabId) : null;
        this._options = $43463cdeacf1e0fa$var$__assign($43463cdeacf1e0fa$var$__assign({}, $43463cdeacf1e0fa$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $dATps.default).addInstance("Tabs", this, this._tabsEl.id, true);
        (0, $dATps.default).addInstance("Tabs", this, this._instanceId, instanceOptions.override);
    }
    Tabs.prototype.init = function() {
        var _this = this;
        if (this._items.length && !this._initialized) {
            // set the first tab as active if not set by explicitly
            if (!this._activeTab) this.setActiveTab(this._items[0]);
            // force show the first default tab
            this.show(this._activeTab.id, true);
            // show tab content based on click
            this._items.map(function(tab) {
                tab.triggerEl.addEventListener("click", function(event) {
                    event.preventDefault();
                    _this.show(tab.id);
                });
            });
        }
    };
    Tabs.prototype.destroy = function() {
        if (this._initialized) this._initialized = false;
    };
    Tabs.prototype.removeInstance = function() {
        this.destroy();
        (0, $dATps.default).removeInstance("Tabs", this._instanceId);
    };
    Tabs.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Tabs.prototype.getActiveTab = function() {
        return this._activeTab;
    };
    Tabs.prototype.setActiveTab = function(tab) {
        this._activeTab = tab;
    };
    Tabs.prototype.getTab = function(id) {
        return this._items.filter(function(t) {
            return t.id === id;
        })[0];
    };
    Tabs.prototype.show = function(id, forceShow) {
        var _a, _b;
        var _this = this;
        if (forceShow === void 0) forceShow = false;
        var tab = this.getTab(id);
        // don't do anything if already active
        if (tab === this._activeTab && !forceShow) return;
        // hide other tabs
        this._items.map(function(t) {
            var _a, _b;
            if (t !== tab) {
                (_a = t.triggerEl.classList).remove.apply(_a, _this._options.activeClasses.split(" "));
                (_b = t.triggerEl.classList).add.apply(_b, _this._options.inactiveClasses.split(" "));
                t.targetEl.classList.add("hidden");
                t.triggerEl.setAttribute("aria-selected", "false");
            }
        });
        // show active tab
        (_a = tab.triggerEl.classList).add.apply(_a, this._options.activeClasses.split(" "));
        (_b = tab.triggerEl.classList).remove.apply(_b, this._options.inactiveClasses.split(" "));
        tab.triggerEl.setAttribute("aria-selected", "true");
        tab.targetEl.classList.remove("hidden");
        this.setActiveTab(tab);
        // callback function
        this._options.onShow(this, tab);
    };
    Tabs.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    return Tabs;
}();
function $43463cdeacf1e0fa$export$c92e8f569ad2976f() {
    document.querySelectorAll("[data-tabs-toggle]").forEach(function($parentEl) {
        var tabItems = [];
        var activeClasses = $parentEl.getAttribute("data-tabs-active-classes");
        var inactiveClasses = $parentEl.getAttribute("data-tabs-inactive-classes");
        var defaultTabId = null;
        $parentEl.querySelectorAll('[role="tab"]').forEach(function($triggerEl) {
            var isActive = $triggerEl.getAttribute("aria-selected") === "true";
            var tab = {
                id: $triggerEl.getAttribute("data-tabs-target"),
                triggerEl: $triggerEl,
                targetEl: document.querySelector($triggerEl.getAttribute("data-tabs-target"))
            };
            tabItems.push(tab);
            if (isActive) defaultTabId = tab.id;
        });
        new $43463cdeacf1e0fa$var$Tabs($parentEl, tabItems, {
            defaultTabId: defaultTabId,
            activeClasses: activeClasses ? activeClasses : $43463cdeacf1e0fa$var$Default.activeClasses,
            inactiveClasses: inactiveClasses ? inactiveClasses : $43463cdeacf1e0fa$var$Default.inactiveClasses
        });
    });
}
if (typeof window !== "undefined") {
    window.Tabs = $43463cdeacf1e0fa$var$Tabs;
    window.initTabs = $43463cdeacf1e0fa$export$c92e8f569ad2976f;
}
var $43463cdeacf1e0fa$export$2e2bcd8739ae039 = $43463cdeacf1e0fa$var$Tabs;

});

parcelRegister("1aBcu", function(module, exports) {

$parcel$export(module.exports, "initTooltips", () => $0da394db4be38aaa$export$8f2a38c1f9d9dc3e);

var $3tUi5 = parcelRequire("3tUi5");

var $dATps = parcelRequire("dATps");
var $0da394db4be38aaa$var$__assign = undefined && undefined.__assign || function() {
    $0da394db4be38aaa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0da394db4be38aaa$var$__assign.apply(this, arguments);
};
var $0da394db4be38aaa$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $0da394db4be38aaa$var$Default = {
    placement: "top",
    triggerType: "hover",
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $0da394db4be38aaa$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $0da394db4be38aaa$var$Tooltip = /** @class */ function() {
    function Tooltip(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $0da394db4be38aaa$var$Default;
        if (instanceOptions === void 0) instanceOptions = $0da394db4be38aaa$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $0da394db4be38aaa$var$__assign($0da394db4be38aaa$var$__assign({}, $0da394db4be38aaa$var$Default), options);
        this._popperInstance = null;
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $dATps.default).addInstance("Tooltip", this, this._instanceId, instanceOptions.override);
    }
    Tooltip.prototype.init = function() {
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._setupEventListeners();
            this._popperInstance = this._createPopperInstance();
            this._initialized = true;
        }
    };
    Tooltip.prototype.destroy = function() {
        var _this = this;
        if (this._initialized) {
            // remove event listeners associated with the trigger element
            var triggerEvents = this._getTriggerEvents();
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._showHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hideHandler);
            });
            // remove event listeners for keydown
            this._removeKeydownListener();
            // remove event listeners for click outside
            this._removeClickOutsideListener();
            // destroy the Popper instance if you have one (assuming this._popperInstance is the Popper instance)
            if (this._popperInstance) this._popperInstance.destroy();
            this._initialized = false;
        }
    };
    Tooltip.prototype.removeInstance = function() {
        (0, $dATps.default).removeInstance("Tooltip", this._instanceId);
    };
    Tooltip.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Tooltip.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        this._showHandler = function() {
            _this.show();
        };
        this._hideHandler = function() {
            _this.hide();
        };
        triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._showHandler);
        });
        triggerEvents.hideEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._hideHandler);
        });
    };
    Tooltip.prototype._createPopperInstance = function() {
        return (0, $3tUi5.createPopper)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                }
            ]
        });
    };
    Tooltip.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case "hover":
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
            case "click":
                return {
                    showEvents: [
                        "click",
                        "focus"
                    ],
                    hideEvents: [
                        "focusout",
                        "blur"
                    ]
                };
            case "none":
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
        }
    };
    Tooltip.prototype._setupKeydownListener = function() {
        var _this = this;
        this._keydownEventListener = function(ev) {
            if (ev.key === "Escape") _this.hide();
        };
        document.body.addEventListener("keydown", this._keydownEventListener, true);
    };
    Tooltip.prototype._removeKeydownListener = function() {
        document.body.removeEventListener("keydown", this._keydownEventListener, true);
    };
    Tooltip.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener("click", this._clickOutsideEventListener, true);
    };
    Tooltip.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener("click", this._clickOutsideEventListener, true);
    };
    Tooltip.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && this.isVisible()) this.hide();
    };
    Tooltip.prototype.isVisible = function() {
        return this._visible;
    };
    Tooltip.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
    };
    Tooltip.prototype.show = function() {
        this._targetEl.classList.remove("opacity-0", "invisible");
        this._targetEl.classList.add("opacity-100", "visible");
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $0da394db4be38aaa$var$__assign($0da394db4be38aaa$var$__assign({}, options), {
                modifiers: $0da394db4be38aaa$var$__spreadArray($0da394db4be38aaa$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: true
                    }
                ], false)
            });
        });
        // handle click outside
        this._setupClickOutsideListener();
        // handle esc keydown
        this._setupKeydownListener();
        // Update its position
        this._popperInstance.update();
        // set visibility
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Tooltip.prototype.hide = function() {
        this._targetEl.classList.remove("opacity-100", "visible");
        this._targetEl.classList.add("opacity-0", "invisible");
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $0da394db4be38aaa$var$__assign($0da394db4be38aaa$var$__assign({}, options), {
                modifiers: $0da394db4be38aaa$var$__spreadArray($0da394db4be38aaa$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: false
                    }
                ], false)
            });
        });
        // handle click outside
        this._removeClickOutsideListener();
        // handle esc keydown
        this._removeKeydownListener();
        // set visibility
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Tooltip.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Tooltip.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Tooltip.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Tooltip;
}();
function $0da394db4be38aaa$export$8f2a38c1f9d9dc3e() {
    document.querySelectorAll("[data-tooltip-target]").forEach(function($triggerEl) {
        var tooltipId = $triggerEl.getAttribute("data-tooltip-target");
        var $tooltipEl = document.getElementById(tooltipId);
        if ($tooltipEl) {
            var triggerType = $triggerEl.getAttribute("data-tooltip-trigger");
            var placement = $triggerEl.getAttribute("data-tooltip-placement");
            new $0da394db4be38aaa$var$Tooltip($tooltipEl, $triggerEl, {
                placement: placement ? placement : $0da394db4be38aaa$var$Default.placement,
                triggerType: triggerType ? triggerType : $0da394db4be38aaa$var$Default.triggerType
            });
        } else console.error('The tooltip element with id "'.concat(tooltipId, '" does not exist. Please check the data-tooltip-target attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Tooltip = $0da394db4be38aaa$var$Tooltip;
    window.initTooltips = $0da394db4be38aaa$export$8f2a38c1f9d9dc3e;
}
var $0da394db4be38aaa$export$2e2bcd8739ae039 = $0da394db4be38aaa$var$Tooltip;

});

parcelRegister("lmTfj", function(module, exports) {

$parcel$export(module.exports, "initPopovers", () => $f8e681bd2d19b9c0$export$200409e83b2a0dd4);

var $3tUi5 = parcelRequire("3tUi5");

var $dATps = parcelRequire("dATps");
var $f8e681bd2d19b9c0$var$__assign = undefined && undefined.__assign || function() {
    $f8e681bd2d19b9c0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f8e681bd2d19b9c0$var$__assign.apply(this, arguments);
};
var $f8e681bd2d19b9c0$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $f8e681bd2d19b9c0$var$Default = {
    placement: "top",
    offset: 10,
    triggerType: "hover",
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $f8e681bd2d19b9c0$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $f8e681bd2d19b9c0$var$Popover = /** @class */ function() {
    function Popover(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $f8e681bd2d19b9c0$var$Default;
        if (instanceOptions === void 0) instanceOptions = $f8e681bd2d19b9c0$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $f8e681bd2d19b9c0$var$__assign($f8e681bd2d19b9c0$var$__assign({}, $f8e681bd2d19b9c0$var$Default), options);
        this._popperInstance = null;
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $dATps.default).addInstance("Popover", this, instanceOptions.id ? instanceOptions.id : this._targetEl.id, instanceOptions.override);
    }
    Popover.prototype.init = function() {
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._setupEventListeners();
            this._popperInstance = this._createPopperInstance();
            this._initialized = true;
        }
    };
    Popover.prototype.destroy = function() {
        var _this = this;
        if (this._initialized) {
            // remove event listeners associated with the trigger element and target element
            var triggerEvents = this._getTriggerEvents();
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._showHandler);
                _this._targetEl.removeEventListener(ev, _this._showHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hideHandler);
                _this._targetEl.removeEventListener(ev, _this._hideHandler);
            });
            // remove event listeners for keydown
            this._removeKeydownListener();
            // remove event listeners for click outside
            this._removeClickOutsideListener();
            // destroy the Popper instance if you have one (assuming this._popperInstance is the Popper instance)
            if (this._popperInstance) this._popperInstance.destroy();
            this._initialized = false;
        }
    };
    Popover.prototype.removeInstance = function() {
        (0, $dATps.default).removeInstance("Popover", this._instanceId);
    };
    Popover.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Popover.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        this._showHandler = function() {
            _this.show();
        };
        this._hideHandler = function() {
            setTimeout(function() {
                if (!_this._targetEl.matches(":hover")) _this.hide();
            }, 100);
        };
        triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._showHandler);
            _this._targetEl.addEventListener(ev, _this._showHandler);
        });
        triggerEvents.hideEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._hideHandler);
            _this._targetEl.addEventListener(ev, _this._hideHandler);
        });
    };
    Popover.prototype._createPopperInstance = function() {
        return (0, $3tUi5.createPopper)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            this._options.offset
                        ]
                    }
                }
            ]
        });
    };
    Popover.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case "hover":
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
            case "click":
                return {
                    showEvents: [
                        "click",
                        "focus"
                    ],
                    hideEvents: [
                        "focusout",
                        "blur"
                    ]
                };
            case "none":
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
        }
    };
    Popover.prototype._setupKeydownListener = function() {
        var _this = this;
        this._keydownEventListener = function(ev) {
            if (ev.key === "Escape") _this.hide();
        };
        document.body.addEventListener("keydown", this._keydownEventListener, true);
    };
    Popover.prototype._removeKeydownListener = function() {
        document.body.removeEventListener("keydown", this._keydownEventListener, true);
    };
    Popover.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener("click", this._clickOutsideEventListener, true);
    };
    Popover.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener("click", this._clickOutsideEventListener, true);
    };
    Popover.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && this.isVisible()) this.hide();
    };
    Popover.prototype.isVisible = function() {
        return this._visible;
    };
    Popover.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
        this._options.onToggle(this);
    };
    Popover.prototype.show = function() {
        this._targetEl.classList.remove("opacity-0", "invisible");
        this._targetEl.classList.add("opacity-100", "visible");
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $f8e681bd2d19b9c0$var$__assign($f8e681bd2d19b9c0$var$__assign({}, options), {
                modifiers: $f8e681bd2d19b9c0$var$__spreadArray($f8e681bd2d19b9c0$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: true
                    }
                ], false)
            });
        });
        // handle click outside
        this._setupClickOutsideListener();
        // handle esc keydown
        this._setupKeydownListener();
        // Update its position
        this._popperInstance.update();
        // set visibility to true
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Popover.prototype.hide = function() {
        this._targetEl.classList.remove("opacity-100", "visible");
        this._targetEl.classList.add("opacity-0", "invisible");
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $f8e681bd2d19b9c0$var$__assign($f8e681bd2d19b9c0$var$__assign({}, options), {
                modifiers: $f8e681bd2d19b9c0$var$__spreadArray($f8e681bd2d19b9c0$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: false
                    }
                ], false)
            });
        });
        // handle click outside
        this._removeClickOutsideListener();
        // handle esc keydown
        this._removeKeydownListener();
        // set visibility to false
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Popover.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Popover.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Popover.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Popover;
}();
function $f8e681bd2d19b9c0$export$200409e83b2a0dd4() {
    document.querySelectorAll("[data-popover-target]").forEach(function($triggerEl) {
        var popoverID = $triggerEl.getAttribute("data-popover-target");
        var $popoverEl = document.getElementById(popoverID);
        if ($popoverEl) {
            var triggerType = $triggerEl.getAttribute("data-popover-trigger");
            var placement = $triggerEl.getAttribute("data-popover-placement");
            var offset = $triggerEl.getAttribute("data-popover-offset");
            new $f8e681bd2d19b9c0$var$Popover($popoverEl, $triggerEl, {
                placement: placement ? placement : $f8e681bd2d19b9c0$var$Default.placement,
                offset: offset ? parseInt(offset) : $f8e681bd2d19b9c0$var$Default.offset,
                triggerType: triggerType ? triggerType : $f8e681bd2d19b9c0$var$Default.triggerType
            });
        } else console.error('The popover element with id "'.concat(popoverID, '" does not exist. Please check the data-popover-target attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Popover = $f8e681bd2d19b9c0$var$Popover;
    window.initPopovers = $f8e681bd2d19b9c0$export$200409e83b2a0dd4;
}
var $f8e681bd2d19b9c0$export$2e2bcd8739ae039 = $f8e681bd2d19b9c0$var$Popover;

});

parcelRegister("3a83f", function(module, exports) {

$parcel$export(module.exports, "initDials", () => $24d88d1ae14e4d54$export$33aa68e0bfaa065d);

var $dATps = parcelRequire("dATps");
var $24d88d1ae14e4d54$var$__assign = undefined && undefined.__assign || function() {
    $24d88d1ae14e4d54$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $24d88d1ae14e4d54$var$__assign.apply(this, arguments);
};
var $24d88d1ae14e4d54$var$Default = {
    triggerType: "hover",
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $24d88d1ae14e4d54$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $24d88d1ae14e4d54$var$Dial = /** @class */ function() {
    function Dial(parentEl, triggerEl, targetEl, options, instanceOptions) {
        if (parentEl === void 0) parentEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $24d88d1ae14e4d54$var$Default;
        if (instanceOptions === void 0) instanceOptions = $24d88d1ae14e4d54$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._parentEl = parentEl;
        this._triggerEl = triggerEl;
        this._targetEl = targetEl;
        this._options = $24d88d1ae14e4d54$var$__assign($24d88d1ae14e4d54$var$__assign({}, $24d88d1ae14e4d54$var$Default), options);
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $dATps.default).addInstance("Dial", this, this._instanceId, instanceOptions.override);
    }
    Dial.prototype.init = function() {
        var _this = this;
        if (this._triggerEl && this._targetEl && !this._initialized) {
            var triggerEventTypes = this._getTriggerEventTypes(this._options.triggerType);
            this._showEventHandler = function() {
                _this.show();
            };
            triggerEventTypes.showEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, _this._showEventHandler);
                _this._targetEl.addEventListener(ev, _this._showEventHandler);
            });
            this._hideEventHandler = function() {
                if (!_this._parentEl.matches(":hover")) _this.hide();
            };
            triggerEventTypes.hideEvents.forEach(function(ev) {
                _this._parentEl.addEventListener(ev, _this._hideEventHandler);
            });
            this._initialized = true;
        }
    };
    Dial.prototype.destroy = function() {
        var _this = this;
        if (this._initialized) {
            var triggerEventTypes = this._getTriggerEventTypes(this._options.triggerType);
            triggerEventTypes.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._showEventHandler);
                _this._targetEl.removeEventListener(ev, _this._showEventHandler);
            });
            triggerEventTypes.hideEvents.forEach(function(ev) {
                _this._parentEl.removeEventListener(ev, _this._hideEventHandler);
            });
            this._initialized = false;
        }
    };
    Dial.prototype.removeInstance = function() {
        (0, $dATps.default).removeInstance("Dial", this._instanceId);
    };
    Dial.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Dial.prototype.hide = function() {
        this._targetEl.classList.add("hidden");
        if (this._triggerEl) this._triggerEl.setAttribute("aria-expanded", "false");
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Dial.prototype.show = function() {
        this._targetEl.classList.remove("hidden");
        if (this._triggerEl) this._triggerEl.setAttribute("aria-expanded", "true");
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Dial.prototype.toggle = function() {
        if (this._visible) this.hide();
        else this.show();
    };
    Dial.prototype.isHidden = function() {
        return !this._visible;
    };
    Dial.prototype.isVisible = function() {
        return this._visible;
    };
    Dial.prototype._getTriggerEventTypes = function(triggerType) {
        switch(triggerType){
            case "hover":
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
            case "click":
                return {
                    showEvents: [
                        "click",
                        "focus"
                    ],
                    hideEvents: [
                        "focusout",
                        "blur"
                    ]
                };
            case "none":
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
        }
    };
    Dial.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Dial.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Dial.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Dial;
}();
function $24d88d1ae14e4d54$export$33aa68e0bfaa065d() {
    document.querySelectorAll("[data-dial-init]").forEach(function($parentEl) {
        var $triggerEl = $parentEl.querySelector("[data-dial-toggle]");
        if ($triggerEl) {
            var dialId = $triggerEl.getAttribute("data-dial-toggle");
            var $dialEl = document.getElementById(dialId);
            if ($dialEl) {
                var triggerType = $triggerEl.getAttribute("data-dial-trigger");
                new $24d88d1ae14e4d54$var$Dial($parentEl, $triggerEl, $dialEl, {
                    triggerType: triggerType ? triggerType : $24d88d1ae14e4d54$var$Default.triggerType
                });
            } else console.error("Dial with id ".concat(dialId, " does not exist. Are you sure that the data-dial-toggle attribute points to the correct modal id?"));
        } else console.error("Dial with id ".concat($parentEl.id, " does not have a trigger element. Are you sure that the data-dial-toggle attribute exists?"));
    });
}
if (typeof window !== "undefined") {
    window.Dial = $24d88d1ae14e4d54$var$Dial;
    window.initDials = $24d88d1ae14e4d54$export$33aa68e0bfaa065d;
}
var $24d88d1ae14e4d54$export$2e2bcd8739ae039 = $24d88d1ae14e4d54$var$Dial;

});

parcelRegister("2r2in", function(module, exports) {

$parcel$export(module.exports, "initInputCounters", () => $1c5fe2354b7370dd$export$4352dd3b7a1676ab);

var $dATps = parcelRequire("dATps");
var $1c5fe2354b7370dd$var$__assign = undefined && undefined.__assign || function() {
    $1c5fe2354b7370dd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1c5fe2354b7370dd$var$__assign.apply(this, arguments);
};
var $1c5fe2354b7370dd$var$Default = {
    minValue: null,
    maxValue: null,
    onIncrement: function() {},
    onDecrement: function() {}
};
var $1c5fe2354b7370dd$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $1c5fe2354b7370dd$var$InputCounter = /** @class */ function() {
    function InputCounter(targetEl, incrementEl, decrementEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (incrementEl === void 0) incrementEl = null;
        if (decrementEl === void 0) decrementEl = null;
        if (options === void 0) options = $1c5fe2354b7370dd$var$Default;
        if (instanceOptions === void 0) instanceOptions = $1c5fe2354b7370dd$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._incrementEl = incrementEl;
        this._decrementEl = decrementEl;
        this._options = $1c5fe2354b7370dd$var$__assign($1c5fe2354b7370dd$var$__assign({}, $1c5fe2354b7370dd$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $dATps.default).addInstance("InputCounter", this, this._instanceId, instanceOptions.override);
    }
    InputCounter.prototype.init = function() {
        var _this = this;
        if (this._targetEl && !this._initialized) {
            this._inputHandler = function(event) {
                var target = event.target;
                // check if the value is numeric
                if (!/^\d*$/.test(target.value)) // Regex to check if the value is numeric
                target.value = target.value.replace(/[^\d]/g, ""); // Remove non-numeric characters
                // check for max value
                if (_this._options.maxValue !== null && parseInt(target.value) > _this._options.maxValue) target.value = _this._options.maxValue.toString();
                // check for min value
                if (_this._options.minValue !== null && parseInt(target.value) < _this._options.minValue) target.value = _this._options.minValue.toString();
            };
            this._incrementClickHandler = function() {
                _this.increment();
            };
            this._decrementClickHandler = function() {
                _this.decrement();
            };
            // Add event listener to restrict input to numeric values only
            this._targetEl.addEventListener("input", this._inputHandler);
            if (this._incrementEl) this._incrementEl.addEventListener("click", this._incrementClickHandler);
            if (this._decrementEl) this._decrementEl.addEventListener("click", this._decrementClickHandler);
            this._initialized = true;
        }
    };
    InputCounter.prototype.destroy = function() {
        if (this._targetEl && this._initialized) {
            this._targetEl.removeEventListener("input", this._inputHandler);
            if (this._incrementEl) this._incrementEl.removeEventListener("click", this._incrementClickHandler);
            if (this._decrementEl) this._decrementEl.removeEventListener("click", this._decrementClickHandler);
            this._initialized = false;
        }
    };
    InputCounter.prototype.removeInstance = function() {
        (0, $dATps.default).removeInstance("InputCounter", this._instanceId);
    };
    InputCounter.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    InputCounter.prototype.getCurrentValue = function() {
        return parseInt(this._targetEl.value) || 0;
    };
    InputCounter.prototype.increment = function() {
        // don't increment if the value is already at the maximum value
        if (this._options.maxValue !== null && this.getCurrentValue() >= this._options.maxValue) return;
        this._targetEl.value = (this.getCurrentValue() + 1).toString();
        this._options.onIncrement(this);
    };
    InputCounter.prototype.decrement = function() {
        // don't decrement if the value is already at the minimum value
        if (this._options.minValue !== null && this.getCurrentValue() <= this._options.minValue) return;
        this._targetEl.value = (this.getCurrentValue() - 1).toString();
        this._options.onDecrement(this);
    };
    InputCounter.prototype.updateOnIncrement = function(callback) {
        this._options.onIncrement = callback;
    };
    InputCounter.prototype.updateOnDecrement = function(callback) {
        this._options.onDecrement = callback;
    };
    return InputCounter;
}();
function $1c5fe2354b7370dd$export$4352dd3b7a1676ab() {
    document.querySelectorAll("[data-input-counter]").forEach(function($targetEl) {
        var targetId = $targetEl.id;
        var $incrementEl = document.querySelector('[data-input-counter-increment="' + targetId + '"]');
        var $decrementEl = document.querySelector('[data-input-counter-decrement="' + targetId + '"]');
        var minValue = $targetEl.getAttribute("data-input-counter-min");
        var maxValue = $targetEl.getAttribute("data-input-counter-max");
        // check if the target element exists
        if ($targetEl) {
            if (!(0, $dATps.default).instanceExists("InputCounter", $targetEl.getAttribute("id"))) new $1c5fe2354b7370dd$var$InputCounter($targetEl, $incrementEl ? $incrementEl : null, $decrementEl ? $decrementEl : null, {
                minValue: minValue ? parseInt(minValue) : null,
                maxValue: maxValue ? parseInt(maxValue) : null
            });
        } else console.error('The target element with id "'.concat(targetId, '" does not exist. Please check the data-input-counter attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.InputCounter = $1c5fe2354b7370dd$var$InputCounter;
    window.initInputCounters = $1c5fe2354b7370dd$export$4352dd3b7a1676ab;
}
var $1c5fe2354b7370dd$export$2e2bcd8739ae039 = $1c5fe2354b7370dd$var$InputCounter;

});

parcelRegister("cvVci", function(module, exports) {

$parcel$export(module.exports, "initCopyClipboards", () => $0259e20e6a846074$export$ad4117886fd6cf74);

var $dATps = parcelRequire("dATps");
var $0259e20e6a846074$var$__assign = undefined && undefined.__assign || function() {
    $0259e20e6a846074$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0259e20e6a846074$var$__assign.apply(this, arguments);
};
var $0259e20e6a846074$var$Default = {
    htmlEntities: false,
    contentType: "input",
    onCopy: function() {}
};
var $0259e20e6a846074$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $0259e20e6a846074$var$CopyClipboard = /** @class */ function() {
    function CopyClipboard(triggerEl, targetEl, options, instanceOptions) {
        if (triggerEl === void 0) triggerEl = null;
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $0259e20e6a846074$var$Default;
        if (instanceOptions === void 0) instanceOptions = $0259e20e6a846074$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._triggerEl = triggerEl;
        this._targetEl = targetEl;
        this._options = $0259e20e6a846074$var$__assign($0259e20e6a846074$var$__assign({}, $0259e20e6a846074$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $dATps.default).addInstance("CopyClipboard", this, this._instanceId, instanceOptions.override);
    }
    CopyClipboard.prototype.init = function() {
        var _this = this;
        if (this._targetEl && this._triggerEl && !this._initialized) {
            this._triggerElClickHandler = function() {
                _this.copy();
            };
            // clicking on the trigger element should copy the value of the target element
            if (this._triggerEl) this._triggerEl.addEventListener("click", this._triggerElClickHandler);
            this._initialized = true;
        }
    };
    CopyClipboard.prototype.destroy = function() {
        if (this._triggerEl && this._targetEl && this._initialized) {
            if (this._triggerEl) this._triggerEl.removeEventListener("click", this._triggerElClickHandler);
            this._initialized = false;
        }
    };
    CopyClipboard.prototype.removeInstance = function() {
        (0, $dATps.default).removeInstance("CopyClipboard", this._instanceId);
    };
    CopyClipboard.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    CopyClipboard.prototype.getTargetValue = function() {
        if (this._options.contentType === "input") return this._targetEl.value;
        if (this._options.contentType === "innerHTML") return this._targetEl.innerHTML;
        if (this._options.contentType === "textContent") return this._targetEl.textContent.replace(/\s+/g, " ").trim();
    };
    CopyClipboard.prototype.copy = function() {
        var textToCopy = this.getTargetValue();
        // Check if HTMLEntities option is enabled
        if (this._options.htmlEntities) // Encode the text using HTML entities
        textToCopy = this.decodeHTML(textToCopy);
        // Create a temporary textarea element
        var tempTextArea = document.createElement("textarea");
        tempTextArea.value = textToCopy;
        document.body.appendChild(tempTextArea);
        // Select the text inside the textarea and copy it to the clipboard
        tempTextArea.select();
        document.execCommand("copy");
        // Remove the temporary textarea
        document.body.removeChild(tempTextArea);
        // Callback function
        this._options.onCopy(this);
        return textToCopy;
    };
    // Function to encode text into HTML entities
    CopyClipboard.prototype.decodeHTML = function(html) {
        var textarea = document.createElement("textarea");
        textarea.innerHTML = html;
        return textarea.textContent;
    };
    CopyClipboard.prototype.updateOnCopyCallback = function(callback) {
        this._options.onCopy = callback;
    };
    return CopyClipboard;
}();
function $0259e20e6a846074$export$ad4117886fd6cf74() {
    document.querySelectorAll("[data-copy-to-clipboard-target]").forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute("data-copy-to-clipboard-target");
        var $targetEl = document.getElementById(targetId);
        var contentType = $triggerEl.getAttribute("data-copy-to-clipboard-content-type");
        var htmlEntities = $triggerEl.getAttribute("data-copy-to-clipboard-html-entities");
        // check if the target element exists
        if ($targetEl) {
            if (!(0, $dATps.default).instanceExists("CopyClipboard", $targetEl.getAttribute("id"))) new $0259e20e6a846074$var$CopyClipboard($triggerEl, $targetEl, {
                htmlEntities: htmlEntities && htmlEntities === "true" ? true : $0259e20e6a846074$var$Default.htmlEntities,
                contentType: contentType ? contentType : $0259e20e6a846074$var$Default.contentType
            });
        } else console.error('The target element with id "'.concat(targetId, '" does not exist. Please check the data-copy-to-clipboard-target attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.CopyClipboard = $0259e20e6a846074$var$CopyClipboard;
    window.initClipboards = $0259e20e6a846074$export$ad4117886fd6cf74;
}
var $0259e20e6a846074$export$2e2bcd8739ae039 = $0259e20e6a846074$var$CopyClipboard;

});

parcelRegister("8M1Z2", function(module, exports) {

var $gSilK = parcelRequire("gSilK");

var $knUNi = parcelRequire("knUNi");

var $cvVci = parcelRequire("cvVci");

var $g6C8J = parcelRequire("g6C8J");

var $3a83f = parcelRequire("3a83f");

var $9MHg3 = parcelRequire("9MHg3");

var $6E0Df = parcelRequire("6E0Df");

var $7sBGF = parcelRequire("7sBGF");

var $2r2in = parcelRequire("2r2in");

var $jF2f2 = parcelRequire("jF2f2");

var $lmTfj = parcelRequire("lmTfj");

var $5M6bU = parcelRequire("5M6bU");

var $1aBcu = parcelRequire("1aBcu");
function $6634584ec8613a9f$export$4cd50b9c69a85fd5() {
    (0, $gSilK.initAccordions)();
    (0, $g6C8J.initCollapses)();
    (0, $knUNi.initCarousels)();
    (0, $9MHg3.initDismisses)();
    (0, $7sBGF.initDropdowns)();
    (0, $jF2f2.initModals)();
    (0, $6E0Df.initDrawers)();
    (0, $5M6bU.initTabs)();
    (0, $1aBcu.initTooltips)();
    (0, $lmTfj.initPopovers)();
    (0, $3a83f.initDials)();
    (0, $2r2in.initInputCounters)();
    (0, $cvVci.initCopyClipboards)();
}
if (typeof window !== "undefined") window.initFlowbite = $6634584ec8613a9f$export$4cd50b9c69a85fd5;

});

parcelRegister("lSJ3U", function(module, exports) {

});

parcelRegister("gwg2V", function(module, exports) {

});

parcelRegister("icSXv", function(module, exports) {

});

parcelRegister("iYs5h", function(module, exports) {

});

parcelRegister("h2r3Q", function(module, exports) {

});

parcelRegister("hqkIY", function(module, exports) {

});

parcelRegister("8RSc7", function(module, exports) {

});

parcelRegister("3koZx", function(module, exports) {

});

parcelRegister("5LmHG", function(module, exports) {

});

parcelRegister("4QM70", function(module, exports) {

});

parcelRegister("1ZSPI", function(module, exports) {

});

parcelRegister("gveSB", function(module, exports) {

});

parcelRegister("atP5T", function(module, exports) {

});

parcelRegister("7wk7g", function(module, exports) {

});

parcelRegister("eaNC5", function(module, exports) {

});

parcelRegister("2rnw3", function(module, exports) {

});

parcelRegister("kX6FP", function(module, exports) {

});

parcelRegister("fVade", function(module, exports) {

});

parcelRegister("bC3tH", function(module, exports) {

});

parcelRegister("3Vz0T", function(module, exports) {

});

parcelRegister("aJMRa", function(module, exports) {

});

parcelRegister("bkAHS", function(module, exports) {

});

parcelRegister("e7wEz", function(module, exports) {

});

parcelRegister("atzcx", function(module, exports) {

});

parcelRegister("9N2Z7", function(module, exports) {

});

parcelRegister("aYmWQ", function(module, exports) {

});

parcelRegister("bfad5", function(module, exports) {

});


parcelRegister("7jPnz", function(module, exports) {

$parcel$export(module.exports, "default", () => $55422993a32bff07$export$2e2bcd8739ae039);
let $55422993a32bff07$var$script;



let $55422993a32bff07$var$initialize = ()=>{
    $55422993a32bff07$var$script = (parcelRequire("6ijSr"));
    if ($55422993a32bff07$var$script.__esModule) $55422993a32bff07$var$script = $55422993a32bff07$var$script.default;
    $55422993a32bff07$var$script.render = (parcelRequire("j16XE")).render;
    (parcelRequire("9yObP")).default($55422993a32bff07$var$script);
    $55422993a32bff07$var$script.__scopeId = "data-v-5dcc85";
    $55422993a32bff07$var$script.__file = "CoursesCarouselCard.vue";
};
$55422993a32bff07$var$initialize();
var $55422993a32bff07$export$2e2bcd8739ae039 = $55422993a32bff07$var$script;

});
parcelRegister("6ijSr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4953d7acad292a41$export$2e2bcd8739ae039);
var $4953d7acad292a41$export$2e2bcd8739ae039 = {
    __name: "CoursesCarouselCard",
    props: [
        "imgSrc",
        "title",
        "desc"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {};
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("j16XE", function(module, exports) {

$parcel$export(module.exports, "render", () => $dd8382a77ccbc8e6$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $dd8382a77ccbc8e6$var$_hoisted_1 = {
    class: "grid grid-cols-2 text-basecolor overflow-hidden md:px-14"
};
const $dd8382a77ccbc8e6$var$_hoisted_2 = {
    class: "rounded-2xl border-2 border-black"
};
const $dd8382a77ccbc8e6$var$_hoisted_3 = [
    "src"
];
const $dd8382a77ccbc8e6$var$_hoisted_4 = {
    class: "rounded-2xl pl-4 pr-4 pb-4 py-6 overflow-hidden"
};
const $dd8382a77ccbc8e6$var$_hoisted_5 = {
    class: "text-sm font-bold leading-6"
};
const $dd8382a77ccbc8e6$var$_hoisted_6 = {
    class: "text-2xs mt-3"
};
function $dd8382a77ccbc8e6$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $dd8382a77ccbc8e6$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $dd8382a77ccbc8e6$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("img", {
                class: "rounded-2xl w-full h-full object-cover",
                src: $props.imgSrc,
                alt: "Course Preview image"
            }, null, 8 /* PROPS */ , $dd8382a77ccbc8e6$var$_hoisted_3)
        ]),
        (0, $TusQn.createElementVNode)("div", $dd8382a77ccbc8e6$var$_hoisted_4, [
            (0, $TusQn.createElementVNode)("h3", $dd8382a77ccbc8e6$var$_hoisted_5, (0, $8POXm.toDisplayString)($props.title), 1 /* TEXT */ ),
            (0, $TusQn.createElementVNode)("p", $dd8382a77ccbc8e6$var$_hoisted_6, (0, $8POXm.toDisplayString)($props.desc), 1 /* TEXT */ )
        ])
    ]);
}

});

parcelRegister("9yObP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f5e38b165f47a82$export$2e2bcd8739ae039);
let $6f5e38b165f47a82$var$NOOP = ()=>{};
var $6f5e38b165f47a82$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("c9Daa", function(module, exports) {

$parcel$export(module.exports, "render", () => $8d94b445fd692c7f$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $8d94b445fd692c7f$var$_hoisted_1 = {
    id: "default-carousel",
    class: "relative max-h-fit max-w-sm md:max-w-lg mx-auto",
    "data-carousel": "static"
};
const $8d94b445fd692c7f$var$_hoisted_2 = {
    class: "relative overflow-hidden rounded-lg h-96"
};
const $8d94b445fd692c7f$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<button type="button" class="absolute top-0 start-0 -left-4 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none" data-carousel-prev><span class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-transparent dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60"><svg class="w-10 h-10 text-secondary dark:text-gray-800 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M5 1 1 5l4 4"></path></svg></span></button><button type="button" class="absolute top-0 end-0 z-30 -right-4 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none" data-carousel-next><span class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-transparent dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60"><svg class="w-10 h-10 text-secondary dark:text-gray-800 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="m1 9 4-4-4-4"></path></svg><span class="sr-only">Next</span></span></button>', 2);
function $8d94b445fd692c7f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $8d94b445fd692c7f$var$_hoisted_1, [
        (0, $TusQn.createCommentVNode)(" Carousel wrapper "),
        (0, $TusQn.createElementVNode)("div", $8d94b445fd692c7f$var$_hoisted_2, [
            (0, $TusQn.createVNode)($setup["CoursesCarouselCard"], {
                class: "hidden duration-700 ease-in-out",
                "data-carousel-item": "",
                "img-src": $setup.lesson1,
                title: _ctx.$t("landingPage.coursesSection.courses[0].title"),
                desc: _ctx.$t("landingPage.coursesSection.courses[0].desc")
            }, null, 8 /* PROPS */ , [
                "img-src",
                "title",
                "desc"
            ]),
            (0, $TusQn.createVNode)($setup["CoursesCarouselCard"], {
                class: "hidden duration-700 ease-in-out",
                "data-carousel-item": "",
                "img-src": $setup.lesson2,
                title: _ctx.$t("landingPage.coursesSection.courses[1].title"),
                desc: _ctx.$t("landingPage.coursesSection.courses[1].desc")
            }, null, 8 /* PROPS */ , [
                "img-src",
                "title",
                "desc"
            ]),
            (0, $TusQn.createVNode)($setup["CoursesCarouselCard"], {
                class: "hidden duration-700 ease-in-out",
                "data-carousel-item": "",
                "img-src": $setup.lesson3,
                title: _ctx.$t("landingPage.coursesSection.courses[2].title"),
                desc: _ctx.$t("landingPage.coursesSection.courses[2].desc")
            }, null, 8 /* PROPS */ , [
                "img-src",
                "title",
                "desc"
            ]),
            (0, $TusQn.createVNode)($setup["CoursesCarouselCard"], {
                class: "hidden duration-700 ease-in-out",
                "data-carousel-item": "",
                "img-src": $setup.lesson4,
                title: _ctx.$t("landingPage.coursesSection.courses[3].title"),
                desc: _ctx.$t("landingPage.coursesSection.courses[3].desc")
            }, null, 8 /* PROPS */ , [
                "img-src",
                "title",
                "desc"
            ]),
            (0, $TusQn.createVNode)($setup["CoursesCarouselCard"], {
                class: "hidden duration-700 ease-in-out",
                "data-carousel-item": "",
                "img-src": $setup.lesson5,
                title: _ctx.$t("landingPage.coursesSection.courses[4].title"),
                desc: _ctx.$t("landingPage.coursesSection.courses[4].desc")
            }, null, 8 /* PROPS */ , [
                "img-src",
                "title",
                "desc"
            ]),
            (0, $TusQn.createVNode)($setup["CoursesCarouselCard"], {
                class: "hidden duration-700 ease-in-out",
                "data-carousel-item": "",
                "img-src": $setup.lesson6,
                title: _ctx.$t("landingPage.coursesSection.courses[5].title"),
                desc: _ctx.$t("landingPage.coursesSection.courses[5].desc")
            }, null, 8 /* PROPS */ , [
                "img-src",
                "title",
                "desc"
            ]),
            (0, $TusQn.createVNode)($setup["CoursesCarouselCard"], {
                class: "hidden duration-700 ease-in-out",
                "data-carousel-item": "",
                "img-src": $setup.lesson7,
                title: _ctx.$t("landingPage.coursesSection.courses[6].title"),
                desc: _ctx.$t("landingPage.coursesSection.courses[6].desc")
            }, null, 8 /* PROPS */ , [
                "img-src",
                "title",
                "desc"
            ])
        ]),
        (0, $TusQn.createCommentVNode)(" Slider controls "),
        $8d94b445fd692c7f$var$_hoisted_3
    ]);
}

});

parcelRegister("fJjEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b73a4dad3aa041f3$export$2e2bcd8739ae039);
let $b73a4dad3aa041f3$var$NOOP = ()=>{};
var $b73a4dad3aa041f3$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("lUMix", function(module, exports) {

$parcel$export(module.exports, "render", () => $ff444aee5919a107$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $ff444aee5919a107$var$_hoisted_1 = {
    class: "bg-primary py-8 md:py-24 sm:px-2 lg:px-4 text-md text-basecolor"
};
const $ff444aee5919a107$var$_hoisted_2 = {
    class: "mx-auto max-w-7xl px-6"
};
const $ff444aee5919a107$var$_hoisted_3 = {
    class: "mx-auto max-w-2xl px-4 lg:max-w-none"
};
const $ff444aee5919a107$var$_hoisted_4 = {
    class: "max-w-3xl"
};
const $ff444aee5919a107$var$_hoisted_5 = {
    class: "text-3xl font-bold tracking-tight"
};
const $ff444aee5919a107$var$_hoisted_6 = {
    class: "mt-14 grid xl:grid-cols-2 grid-cols-1 gap-x-24 gap-y-10 mb-12"
};
const $ff444aee5919a107$var$_hoisted_7 = {
    class: "text-2xl font-bold tracking-tight"
};
const $ff444aee5919a107$var$_hoisted_8 = {
    class: "mt-12"
};
const $ff444aee5919a107$var$_hoisted_9 = {
    class: "xl:mx-auto xl:max-w-7xl xl:px-8"
};
const $ff444aee5919a107$var$_hoisted_10 = {
    class: "text-xl font-semibold rounded-3xl bg-white px-8 py-3 inline"
};
function $ff444aee5919a107$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $ff444aee5919a107$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $ff444aee5919a107$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $ff444aee5919a107$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", $ff444aee5919a107$var$_hoisted_4, [
                    (0, $TusQn.createElementVNode)("h2", $ff444aee5919a107$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.coursesSection.title")), 1 /* TEXT */ )
                ]),
                (0, $TusQn.createElementVNode)("div", $ff444aee5919a107$var$_hoisted_6, [
                    (0, $TusQn.createElementVNode)("div", null, [
                        (0, $TusQn.createElementVNode)("h3", $ff444aee5919a107$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.coursesSection.subtitle")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("p", $ff444aee5919a107$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.coursesSection.text")), 1 /* TEXT */ )
                    ]),
                    (0, $TusQn.createElementVNode)("div", null, [
                        (0, $TusQn.createCommentVNode)(" Carousel section "),
                        (0, $TusQn.createElementVNode)("div", $ff444aee5919a107$var$_hoisted_9, [
                            (0, $TusQn.createVNode)($setup["CoursesCarousel"])
                        ])
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $ff444aee5919a107$var$_hoisted_10, [
                    (0, $TusQn.createVNode)($setup["LoaderIcon"], {
                        class: "inline w-6 text-secondary stroke-secondary pb-1"
                    }),
                    (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.coursesSection.moreComing")), 1 /* TEXT */ )
                ])
            ])
        ])
    ]);
}

});

parcelRegister("iu7ZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7513b56fe2e7550$export$2e2bcd8739ae039);
let $d7513b56fe2e7550$var$NOOP = ()=>{};
var $d7513b56fe2e7550$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("39atu", function(module, exports) {

$parcel$export(module.exports, "default", () => $24aa5668e7db07c6$export$2e2bcd8739ae039);
let $24aa5668e7db07c6$var$script;


let $24aa5668e7db07c6$var$initialize = ()=>{
    $24aa5668e7db07c6$var$script = {};
    $24aa5668e7db07c6$var$script.render = (parcelRequire("lQ2oP")).render;
    (parcelRequire("loNhz")).default($24aa5668e7db07c6$var$script);
    $24aa5668e7db07c6$var$script.__scopeId = "data-v-7a967d";
    $24aa5668e7db07c6$var$script.__file = "LandingAboutUs.vue";
};
$24aa5668e7db07c6$var$initialize();
var $24aa5668e7db07c6$export$2e2bcd8739ae039 = $24aa5668e7db07c6$var$script;

});
parcelRegister("lQ2oP", function(module, exports) {

$parcel$export(module.exports, "render", () => $fe6050c47d0c66aa$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

var $lwQ6h = parcelRequire("lwQ6h");
const $fe6050c47d0c66aa$var$_hoisted_1 = {
    class: "base-gradient text-primary py-8 md:py-24 sm:px-2 lg:px-4 text-md"
};
const $fe6050c47d0c66aa$var$_hoisted_2 = {
    class: "mx-auto max-w-7xl px-6"
};
const $fe6050c47d0c66aa$var$_hoisted_3 = {
    class: "mx-auto max-w-2xl px-4 lg:max-w-none"
};
const $fe6050c47d0c66aa$var$_hoisted_4 = {
    class: "max-w-3xl"
};
const $fe6050c47d0c66aa$var$_hoisted_5 = {
    class: "text-3xl font-bold tracking-tight"
};
const $fe6050c47d0c66aa$var$_hoisted_6 = {
    class: "mt-16 grid lg:grid-cols-3 grid-cols-1 gap-x-24 gap-y-10"
};
const $fe6050c47d0c66aa$var$_hoisted_7 = {
    class: "lg:col-span-2"
};
const $fe6050c47d0c66aa$var$_hoisted_8 = {
    class: "text-2xl font-bold tracking-tight"
};
const $fe6050c47d0c66aa$var$_hoisted_9 = {
    class: "mt-8"
};
const $fe6050c47d0c66aa$var$_hoisted_10 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", null, [
    /*#__PURE__*/ (0, $TusQn.createCommentVNode)(" Image section ")
], -1 /* HOISTED */ );
const $fe6050c47d0c66aa$var$_hoisted_11 = {
    class: "mt-16 grid lg:grid-cols-3 grid-cols-1 gap-x-24 gap-y-10"
};
const $fe6050c47d0c66aa$var$_hoisted_12 = {
    class: "lg:col-span-2"
};
const $fe6050c47d0c66aa$var$_hoisted_13 = {
    class: "text-2xl font-bold tracking-tight"
};
const $fe6050c47d0c66aa$var$_hoisted_14 = {
    class: "mt-8"
};
const $fe6050c47d0c66aa$var$_hoisted_15 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "flex justify-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createCommentVNode)(" Image section "),
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lwQ6h))),
        alt: "GameBook Services Logo Transparent",
        class: "aspect-[2/2] w-60 h-60"
    })
], -1 /* HOISTED */ );
function $fe6050c47d0c66aa$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $fe6050c47d0c66aa$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $fe6050c47d0c66aa$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $fe6050c47d0c66aa$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", $fe6050c47d0c66aa$var$_hoisted_4, [
                    (0, $TusQn.createElementVNode)("h2", $fe6050c47d0c66aa$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.aboutUsSection.title")), 1 /* TEXT */ )
                ]),
                (0, $TusQn.createElementVNode)("div", $fe6050c47d0c66aa$var$_hoisted_6, [
                    (0, $TusQn.createElementVNode)("div", $fe6050c47d0c66aa$var$_hoisted_7, [
                        (0, $TusQn.createElementVNode)("h3", $fe6050c47d0c66aa$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.aboutUsSection.block1.title")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("p", $fe6050c47d0c66aa$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.aboutUsSection.block1.text")), 1 /* TEXT */ )
                    ]),
                    $fe6050c47d0c66aa$var$_hoisted_10
                ]),
                (0, $TusQn.createElementVNode)("div", $fe6050c47d0c66aa$var$_hoisted_11, [
                    (0, $TusQn.createElementVNode)("div", $fe6050c47d0c66aa$var$_hoisted_12, [
                        (0, $TusQn.createElementVNode)("h3", $fe6050c47d0c66aa$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.aboutUsSection.block2.title")), 1 /* TEXT */ ),
                        (0, $TusQn.createElementVNode)("p", $fe6050c47d0c66aa$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.aboutUsSection.block2.text")), 1 /* TEXT */ )
                    ]),
                    $fe6050c47d0c66aa$var$_hoisted_15
                ])
            ])
        ])
    ]);
}

});
parcelRegister("lwQ6h", function(module, exports) {
module.exports = new URL("gamebook-services_logo_transp.209fd0b0.png", import.meta.url).toString();

});


parcelRegister("loNhz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f94211528051d78a$export$2e2bcd8739ae039);
let $f94211528051d78a$var$NOOP = ()=>{};
var $f94211528051d78a$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("9rs6C", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dfc6fe9a1237f24$export$2e2bcd8739ae039);
let $6dfc6fe9a1237f24$var$script;



let $6dfc6fe9a1237f24$var$initialize = ()=>{
    $6dfc6fe9a1237f24$var$script = (parcelRequire("HI1s0"));
    if ($6dfc6fe9a1237f24$var$script.__esModule) $6dfc6fe9a1237f24$var$script = $6dfc6fe9a1237f24$var$script.default;
    $6dfc6fe9a1237f24$var$script.render = (parcelRequire("fnXo4")).render;
    (parcelRequire("6vaFS")).default($6dfc6fe9a1237f24$var$script);
    $6dfc6fe9a1237f24$var$script.__scopeId = "data-v-918dab";
    $6dfc6fe9a1237f24$var$script.__file = "LandingPrices.vue";
};
$6dfc6fe9a1237f24$var$initialize();
var $6dfc6fe9a1237f24$export$2e2bcd8739ae039 = $6dfc6fe9a1237f24$var$script;

});
parcelRegister("HI1s0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $08362a32aeaba39b$export$2e2bcd8739ae039);

var $j13lk = parcelRequire("j13lk");
var $08362a32aeaba39b$export$2e2bcd8739ae039 = {
    __name: "LandingPrices",
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            FetchPlanCardsComponent: $j13lk.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("fnXo4", function(module, exports) {

$parcel$export(module.exports, "render", () => $b337121734b7f1da$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $b337121734b7f1da$var$_hoisted_1 = {
    class: "bg-primary text-basecolor py-8 md:py-24 sm:px-2 lg:px-4"
};
const $b337121734b7f1da$var$_hoisted_2 = {
    class: "mx-auto max-w-7xl px-6 lg:px-8"
};
const $b337121734b7f1da$var$_hoisted_3 = {
    class: "max-w-4xl px-4"
};
const $b337121734b7f1da$var$_hoisted_4 = {
    class: "text-3xl font-bold tracking-tight"
};
const $b337121734b7f1da$var$_hoisted_5 = {
    class: "mt-12 text-2xl font-bold"
};
const $b337121734b7f1da$var$_hoisted_6 = {
    class: "mt-12"
};
const $b337121734b7f1da$var$_hoisted_7 = {
    class: "mt-12 text-2xl font-bold"
};
const $b337121734b7f1da$var$_hoisted_8 = {
    class: "mt-12 text-md"
};
function $b337121734b7f1da$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b337121734b7f1da$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $b337121734b7f1da$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $b337121734b7f1da$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("h2", $b337121734b7f1da$var$_hoisted_4, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.prices.title")), 1 /* TEXT */ ),
                (0, $TusQn.createElementVNode)("p", $b337121734b7f1da$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.prices.subtitle")), 1 /* TEXT */ )
            ]),
            (0, $TusQn.createVNode)($setup["FetchPlanCardsComponent"], {
                class: "px-4"
            }),
            (0, $TusQn.createElementVNode)("div", $b337121734b7f1da$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("h2", $b337121734b7f1da$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.prices.unsubscribe.title")), 1 /* TEXT */ ),
                (0, $TusQn.createElementVNode)("p", $b337121734b7f1da$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.prices.unsubscribe.text")), 1 /* TEXT */ )
            ])
        ])
    ]);
}

});

parcelRegister("6vaFS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bbdeb074b63922c$export$2e2bcd8739ae039);
let $4bbdeb074b63922c$var$NOOP = ()=>{};
var $4bbdeb074b63922c$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("dYKt3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2d4ec729bf585d6$export$2e2bcd8739ae039);
let $a2d4ec729bf585d6$var$script;



let $a2d4ec729bf585d6$var$initialize = ()=>{
    $a2d4ec729bf585d6$var$script = (parcelRequire("fIm9U"));
    if ($a2d4ec729bf585d6$var$script.__esModule) $a2d4ec729bf585d6$var$script = $a2d4ec729bf585d6$var$script.default;
    $a2d4ec729bf585d6$var$script.render = (parcelRequire("fah7G")).render;
    (parcelRequire("dMHwL")).default($a2d4ec729bf585d6$var$script);
    $a2d4ec729bf585d6$var$script.__scopeId = "data-v-3de75d";
    $a2d4ec729bf585d6$var$script.__file = "LandingAlarm.vue";
};
$a2d4ec729bf585d6$var$initialize();
var $a2d4ec729bf585d6$export$2e2bcd8739ae039 = $a2d4ec729bf585d6$var$script;

});
parcelRegister("fIm9U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b70c275dd1f7a297$export$2e2bcd8739ae039);

var $3Ypae = parcelRequire("3Ypae");

var $l7Nmn = parcelRequire("l7Nmn");

var $hcgKX = parcelRequire("hcgKX");

var $dlQWs = parcelRequire("dlQWs");

var $hzqmY = parcelRequire("hzqmY");

var $jFUWD = parcelRequire("jFUWD");
var $b70c275dd1f7a297$export$2e2bcd8739ae039 = {
    __name: "LandingAlarm",
    setup (__props, { expose: __expose }) {
        __expose();
        const { locale: locale } = (0, $jFUWD.useI18n)();
        const LS2 = (0, $hzqmY.default)("LS2.png", locale.value);
        const __returned__ = {
            locale: locale,
            LS2: LS2,
            ImageLinkCard: $3Ypae.default,
            get alarmPartner () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($l7Nmn));
            },
            get awareness () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($hcgKX));
            },
            get germanMap () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($dlQWs));
            },
            get resolveImgUrl () {
                return 0, $hzqmY.default;
            },
            get useI18n () {
                return 0, $jFUWD.useI18n;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("3Ypae", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4a7ebcb339ba72$export$2e2bcd8739ae039);
let $2e4a7ebcb339ba72$var$script;



let $2e4a7ebcb339ba72$var$initialize = ()=>{
    $2e4a7ebcb339ba72$var$script = (parcelRequire("jBsRY"));
    if ($2e4a7ebcb339ba72$var$script.__esModule) $2e4a7ebcb339ba72$var$script = $2e4a7ebcb339ba72$var$script.default;
    $2e4a7ebcb339ba72$var$script.render = (parcelRequire("6Rqdp")).render;
    (parcelRequire("9412O")).default($2e4a7ebcb339ba72$var$script);
    $2e4a7ebcb339ba72$var$script.__scopeId = "data-v-246c9f";
    $2e4a7ebcb339ba72$var$script.__file = "ImageLinkCard.vue";
};
$2e4a7ebcb339ba72$var$initialize();
var $2e4a7ebcb339ba72$export$2e2bcd8739ae039 = $2e4a7ebcb339ba72$var$script;

});
parcelRegister("jBsRY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e457dde38852d6e8$export$2e2bcd8739ae039);
var $e457dde38852d6e8$export$2e2bcd8739ae039 = {
    __name: "ImageLinkCard",
    props: {
        imgSrc: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        buttonText: {
            type: String,
            required: true
        },
        buttonLink: {
            type: String,
            required: false,
            default: "#"
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = {
            props: props
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("6Rqdp", function(module, exports) {

$parcel$export(module.exports, "render", () => $4fec072463683bf6$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $4fec072463683bf6$var$_hoisted_1 = {
    class: "max-w-sm flex flex-col rounded max-h-full overflow-hidden shadow-lg bg-basecolor text-primary rounded-2xl"
};
const $4fec072463683bf6$var$_hoisted_2 = [
    "src"
];
const $4fec072463683bf6$var$_hoisted_3 = {
    class: "px-6 py-4 flex-grow"
};
const $4fec072463683bf6$var$_hoisted_4 = {
    class: "text-lg font-semibold mb-2"
};
const $4fec072463683bf6$var$_hoisted_5 = {
    class: "px-8 pt-4 pb-2 text-center"
};
const $4fec072463683bf6$var$_hoisted_6 = [
    "href"
];
const $4fec072463683bf6$var$_hoisted_7 = {
    class: "inline-block bg-secondary w-full rounded-full px-3 py-1 text-sm font-semibold mr-2 mb-2"
};
function $4fec072463683bf6$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $4fec072463683bf6$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("img", {
            class: "w-full h-72 object-cover",
            src: $props.imgSrc,
            alt: "Imagen del componente"
        }, null, 8 /* PROPS */ , $4fec072463683bf6$var$_hoisted_2),
        (0, $TusQn.createElementVNode)("div", $4fec072463683bf6$var$_hoisted_3, [
            (0, $TusQn.createElementVNode)("div", $4fec072463683bf6$var$_hoisted_4, (0, $8POXm.toDisplayString)($props.title), 1 /* TEXT */ ),
            (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($props.text), 1 /* TEXT */ )
        ]),
        (0, $TusQn.createElementVNode)("div", $4fec072463683bf6$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("a", {
                href: $props.buttonLink
            }, [
                (0, $TusQn.createElementVNode)("button", $4fec072463683bf6$var$_hoisted_7, (0, $8POXm.toDisplayString)($props.buttonText), 1 /* TEXT */ )
            ], 8 /* PROPS */ , $4fec072463683bf6$var$_hoisted_6)
        ])
    ]);
}

});

parcelRegister("9412O", function(module, exports) {

$parcel$export(module.exports, "default", () => $69954c2bc7a448b6$export$2e2bcd8739ae039);
let $69954c2bc7a448b6$var$NOOP = ()=>{};
var $69954c2bc7a448b6$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("l7Nmn", function(module, exports) {
module.exports = new URL("ALARM-Partner.569bcb9b.png", import.meta.url).toString();

});

parcelRegister("hcgKX", function(module, exports) {
module.exports = new URL("Foto-Awarenes-Forum.410c8747.png", import.meta.url).toString();

});

parcelRegister("dlQWs", function(module, exports) {
module.exports = new URL("German_Map_DE.7baed562.png", import.meta.url).toString();

});


parcelRegister("fah7G", function(module, exports) {

$parcel$export(module.exports, "render", () => $b0a51276b80fe32a$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $b0a51276b80fe32a$var$_hoisted_1 = {
    class: "bg-softBlue text-basecolor py-8 md:py-24 sm:px-2 lg:px-4"
};
const $b0a51276b80fe32a$var$_hoisted_2 = {
    class: "mx-auto max-w-7xl px-6"
};
const $b0a51276b80fe32a$var$_hoisted_3 = {
    class: "mx-auto max-w-2xl px-4 lg:max-w-none"
};
const $b0a51276b80fe32a$var$_hoisted_4 = {
    class: "text-3xl font-bold tracking-tight"
};
const $b0a51276b80fe32a$var$_hoisted_5 = {
    class: "mt-12 text-md"
};
const $b0a51276b80fe32a$var$_hoisted_6 = {
    class: "isolate mx-auto mt-12 grid max-w-md grid-cols-1 justify-items-center gap-8 md:max-w-2xl md:grid-cols-2 lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-4"
};
function $b0a51276b80fe32a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b0a51276b80fe32a$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $b0a51276b80fe32a$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $b0a51276b80fe32a$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("h2", $b0a51276b80fe32a$var$_hoisted_4, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.alarmSection.title")), 1 /* TEXT */ ),
                (0, $TusQn.createElementVNode)("p", $b0a51276b80fe32a$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("landingPage.alarmSection.text")), 1 /* TEXT */ )
            ]),
            (0, $TusQn.createElementVNode)("div", $b0a51276b80fe32a$var$_hoisted_6, [
                (0, $TusQn.createVNode)($setup["ImageLinkCard"], {
                    "img-src": $setup.alarmPartner,
                    title: _ctx.$t("landingPage.alarmSection.alarmProject.title"),
                    text: _ctx.$t("landingPage.alarmSection.alarmProject.text"),
                    "button-text": _ctx.$t("landingPage.alarmSection.seeMore"),
                    "button-link": "https://alarm.wildau.biz/en/"
                }, null, 8 /* PROPS */ , [
                    "img-src",
                    "title",
                    "text",
                    "button-text"
                ]),
                (0, $TusQn.createVNode)($setup["ImageLinkCard"], {
                    "img-src": $setup.LS2,
                    title: _ctx.$t("landingPage.alarmSection.digital.title"),
                    text: _ctx.$t("landingPage.alarmSection.digital.text"),
                    "button-text": _ctx.$t("landingPage.alarmSection.seeMore"),
                    "button-link": "https://alarm.wildau.biz/#learningScenarios"
                }, null, 8 /* PROPS */ , [
                    "img-src",
                    "title",
                    "text",
                    "button-text"
                ]),
                (0, $TusQn.createVNode)($setup["ImageLinkCard"], {
                    "img-src": $setup.germanMap,
                    title: _ctx.$t("landingPage.alarmSection.partners.title"),
                    text: _ctx.$t("landingPage.alarmSection.partners.text"),
                    "button-text": _ctx.$t("landingPage.alarmSection.seeMore"),
                    "button-link": "https://alarm.wildau.biz/#partner"
                }, null, 8 /* PROPS */ , [
                    "img-src",
                    "title",
                    "text",
                    "button-text"
                ]),
                (0, $TusQn.createVNode)($setup["ImageLinkCard"], {
                    "img-src": $setup.awareness,
                    title: _ctx.$t("landingPage.alarmSection.publication.title"),
                    text: _ctx.$t("landingPage.alarmSection.publication.text"),
                    "button-text": _ctx.$t("landingPage.alarmSection.seeMore"),
                    "button-link": "https://alarm.wildau.biz/en/#publications"
                }, null, 8 /* PROPS */ , [
                    "img-src",
                    "title",
                    "text",
                    "button-text"
                ])
            ])
        ])
    ]);
}

});

parcelRegister("dMHwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09185b721bc0d03$export$2e2bcd8739ae039);
let $a09185b721bc0d03$var$NOOP = ()=>{};
var $a09185b721bc0d03$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("5Sddj", function(module, exports) {

$parcel$export(module.exports, "render", () => $446c3ed9077d722a$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $446c3ed9077d722a$var$_hoisted_1 = {
    id: "top",
    class: "mt-24"
};
const $446c3ed9077d722a$var$_hoisted_2 = {
    class: "pt-section",
    id: "why-cyberalarm"
};
const $446c3ed9077d722a$var$_hoisted_3 = {
    id: "how-it-works"
};
const $446c3ed9077d722a$var$_hoisted_4 = {
    id: "alarm"
};
const $446c3ed9077d722a$var$_hoisted_5 = {
    id: "courses"
};
const $446c3ed9077d722a$var$_hoisted_6 = {
    id: "about-us"
};
const $446c3ed9077d722a$var$_hoisted_7 = {
    id: "pricing"
};
function $446c3ed9077d722a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createElementVNode)("section", $446c3ed9077d722a$var$_hoisted_1, [
            (0, $TusQn.createVNode)($setup["LandingHero"])
        ]),
        (0, $TusQn.createElementVNode)("section", $446c3ed9077d722a$var$_hoisted_2, [
            (0, $TusQn.createVNode)($setup["LandingWhyCyberalarm"])
        ]),
        (0, $TusQn.createElementVNode)("section", $446c3ed9077d722a$var$_hoisted_3, [
            (0, $TusQn.createVNode)($setup["LandingHowItWorks"])
        ]),
        (0, $TusQn.createElementVNode)("section", $446c3ed9077d722a$var$_hoisted_4, [
            (0, $TusQn.createVNode)($setup["LandingAlarm"])
        ]),
        (0, $TusQn.createElementVNode)("section", $446c3ed9077d722a$var$_hoisted_5, [
            (0, $TusQn.createVNode)($setup["LandingCourses"])
        ]),
        (0, $TusQn.createElementVNode)("section", $446c3ed9077d722a$var$_hoisted_6, [
            (0, $TusQn.createVNode)($setup["LandingAboutUs"])
        ]),
        (0, $TusQn.createElementVNode)("section", $446c3ed9077d722a$var$_hoisted_7, [
            (0, $TusQn.createVNode)($setup["LandingPrices"])
        ])
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("668dj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4709acaca2b3ce5e$export$2e2bcd8739ae039);
let $4709acaca2b3ce5e$var$NOOP = ()=>{};
var $4709acaca2b3ce5e$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("bvEvf", function(module, exports) {

$parcel$export(module.exports, "default", () => $86120205c4f4bed1$export$2e2bcd8739ae039);
let $86120205c4f4bed1$var$script;


let $86120205c4f4bed1$var$initialize = ()=>{
    $86120205c4f4bed1$var$script = {};
    $86120205c4f4bed1$var$script.render = (parcelRequire("j4HPT")).render;
    (parcelRequire("c0Ufj")).default($86120205c4f4bed1$var$script);
    $86120205c4f4bed1$var$script.__scopeId = "data-v-1e8b08";
    $86120205c4f4bed1$var$script.__file = "ResearchProjectView.vue";
};
$86120205c4f4bed1$var$initialize();
var $86120205c4f4bed1$export$2e2bcd8739ae039 = $86120205c4f4bed1$var$script;

});
parcelRegister("j4HPT", function(module, exports) {

$parcel$export(module.exports, "render", () => $de3064ef9c9e0da2$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $de3064ef9c9e0da2$var$_hoisted_1 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("h1", null, "Research Project Alarm", -1 /* HOISTED */ );
const $de3064ef9c9e0da2$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("p", null, [
    /*#__PURE__*/ (0, $TusQn.createTextVNode)(" Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do "),
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("b", null, "eiusmod tempor incididunt ut labore et dolore.")
], -1 /* HOISTED */ );
const $de3064ef9c9e0da2$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("p", null, " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. ", -1 /* HOISTED */ );
function $de3064ef9c9e0da2$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        $de3064ef9c9e0da2$var$_hoisted_1,
        $de3064ef9c9e0da2$var$_hoisted_2,
        $de3064ef9c9e0da2$var$_hoisted_3
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("c0Ufj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bf11d62d4b83e69$export$2e2bcd8739ae039);
let $8bf11d62d4b83e69$var$NOOP = ()=>{};
var $8bf11d62d4b83e69$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("epiTL", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("82kA8").then(()=>parcelRequire("3wkkc"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("iQTAW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2qBbj").then(()=>parcelRequire("703Gi"));

});

parcelRegister("9OKOf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("5j5Gk"),
    $Gr8vk("ia96m")
]).then(()=>parcelRequire("jKZSm"));

});

parcelRegister("6UF9E", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hH7d5").then(()=>parcelRequire("6whfv"));

});

parcelRegister("bHrXk", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cwzsY").then(()=>parcelRequire("jwHVt"));

});

parcelRegister("c6hxS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("eiB8M"),
    $Gr8vk("aD9MA")
]).then(()=>parcelRequire("dKz3J"));

});

parcelRegister("1uE3O", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("jHoFG"),
    $Gr8vk("kUa44")
]).then(()=>parcelRequire("i3PO7"));

});

parcelRegister("1bXD0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("5j5Gk"),
    $Gr8vk("f7AoK")
]).then(()=>parcelRequire("9XhDi"));

});

parcelRegister("e8BMT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6GKMl").then(()=>parcelRequire("kyCw7"));

});

parcelRegister("aJeJ1", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("eZ6Dk"),
    $Gr8vk("eiB8M"),
    $Gr8vk("gdTQa")
]).then(()=>parcelRequire("go3Le"));

});

parcelRegister("aIy1Q", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("eZ6Dk"),
    $Gr8vk("eiB8M"),
    $Gr8vk("8kb9x")
]).then(()=>parcelRequire("bgk3m"));

});

parcelRegister("ZxrTi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("jHoFG"),
    $Gr8vk("kPrXt")
]).then(()=>parcelRequire("hewMM"));

});

parcelRegister("7Pdvf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("5j5Gk"),
    $Gr8vk("ecW3v")
]).then(()=>parcelRequire("29jtt"));

});

parcelRegister("4xSV3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1pGvm").then(()=>parcelRequire("7lcEE"));

});



parcelRegister("6RKL9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffbf6cb2e2e6a39$export$2e2bcd8739ae039);

var $47c0h = parcelRequire("47c0h");
var $4CQUo = parcelRequire("4CQUo");
var $ey2ik = parcelRequire("ey2ik");
var $1ZUq6 = parcelRequire("1ZUq6");
var $l7ahT = parcelRequire("l7ahT");
var $lFFdy = parcelRequire("lFFdy");
var $4Gqbx = parcelRequire("4Gqbx");
var $hKvje = parcelRequire("hKvje");
var $iqNgl = parcelRequire("iqNgl");

var $7c6z4 = parcelRequire("7c6z4");

var $bQytf = parcelRequire("bQytf");

var $deRlR = parcelRequire("deRlR");
const $4ffbf6cb2e2e6a39$var$isValidHttpMethod = (0, $4CQUo.default)([
    (0, $l7ahT.default)("POST"),
    (0, $l7ahT.default)("GET"),
    (0, $l7ahT.default)("DELETE")
]);
const $4ffbf6cb2e2e6a39$var$isPostHttpMethod = (0, $hKvje.default)("POST", "method");
const $4ffbf6cb2e2e6a39$var$isDeleteHttpMethod = (0, $hKvje.default)("DELETE", "method");
const $4ffbf6cb2e2e6a39$var$createRequestWith = (options)=>{
    const { method: method = "GET", request: request, sessionId: sessionId } = options;
    if ((0, $lFFdy.default)($4ffbf6cb2e2e6a39$var$isValidHttpMethod(method))) return {};
    const currentLocale = (0, $7c6z4.default).global.locale.value;
    const headers = (0, $4Gqbx.default)((0, $ey2ik.default)("Content-type", "application/json; charset=UTF-8"), (0, $ey2ik.default)("accept-language", currentLocale), (0, $iqNgl.default)((0, $47c0h.default)((0, $bQytf.isNotNullAndNotEmpty)(sessionId)), (0, $ey2ik.default)("X-SESSION-ID", sessionId)))({});
    return (0, $4Gqbx.default)((0, $iqNgl.default)((0, $1ZUq6.default)($4ffbf6cb2e2e6a39$var$isPostHttpMethod, $4ffbf6cb2e2e6a39$var$isDeleteHttpMethod), (0, $ey2ik.default)("body", JSON.stringify(request))), (0, $deRlR.default))({
        method: method,
        headers: headers
    });
};
var $4ffbf6cb2e2e6a39$export$2e2bcd8739ae039 = $4ffbf6cb2e2e6a39$var$createRequestWith;

});
parcelRegister("1ZUq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $174740c9e060027b$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");

var $1huO0 = parcelRequire("1huO0");

var $ifTfg = parcelRequire("ifTfg");

var $e2JJf = parcelRequire("e2JJf");
/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.both, R.anyPass, R.or
 * @example
 *
 *      const gt10 = x => x > 10;
 *      const even = x => x % 2 === 0;
 *      const f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 *
 *      R.either(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(55)
 *      R.either([false, false, 'a'], [11]) // => [11, 11, "a"]
 */ var $174740c9e060027b$var$either = /*#__PURE__*/ (0, $2jcOR.default)(function either(f, g) {
    return (0, $1huO0.default)(f) ? function _either() {
        return f.apply(this, arguments) || g.apply(this, arguments);
    } : (0, $ifTfg.default)((0, $e2JJf.default))(f, g);
});
var $174740c9e060027b$export$2e2bcd8739ae039 = $174740c9e060027b$var$either;

});
parcelRegister("1huO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eef464cca01ff27$export$2e2bcd8739ae039);
function $0eef464cca01ff27$export$2e2bcd8739ae039(x) {
    var type = Object.prototype.toString.call(x);
    return type === "[object Function]" || type === "[object AsyncFunction]" || type === "[object GeneratorFunction]" || type === "[object AsyncGeneratorFunction]";
}

});

parcelRegister("ifTfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4a47b4162ca03e7$export$2e2bcd8739ae039);

var $aSQee = parcelRequire("aSQee");

var $bGmML = parcelRequire("bGmML");
/**
 * "lifts" a function of arity >= 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      const madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([100, 200], [30, 40], [5, 6, 7]); //=> [135, 136, 137, 145, 146, 147, 235, 236, 237, 245, 246, 247]
 *
 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([10, 20], [1], [2, 3], [4], [100, 200]); //=> [117, 217, 118, 218, 127, 227, 128, 228]
 */ var $d4a47b4162ca03e7$var$lift = /*#__PURE__*/ (0, $aSQee.default)(function lift(fn) {
    return (0, $bGmML.default)(fn.length, fn);
});
var $d4a47b4162ca03e7$export$2e2bcd8739ae039 = $d4a47b4162ca03e7$var$lift;

});
parcelRegister("bGmML", function(module, exports) {

$parcel$export(module.exports, "default", () => $88154aac63bd773b$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");

var $i5mkn = parcelRequire("i5mkn");

var $aqZkK = parcelRequire("aqZkK");

var $56Gyq = parcelRequire("56Gyq");

var $f7umK = parcelRequire("f7umK");
/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */ var $88154aac63bd773b$var$liftN = /*#__PURE__*/ (0, $2jcOR.default)(function liftN(arity, fn) {
    var lifted = (0, $56Gyq.default)(arity, fn);
    return (0, $56Gyq.default)(arity, function() {
        return (0, $i5mkn.default)((0, $aqZkK.default), (0, $f7umK.default)(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
    });
});
var $88154aac63bd773b$export$2e2bcd8739ae039 = $88154aac63bd773b$var$liftN;

});
parcelRegister("aqZkK", function(module, exports) {

$parcel$export(module.exports, "default", () => $798be8b27a50c416$export$2e2bcd8739ae039);

var $6eGa6 = parcelRequire("6eGa6");

var $2jcOR = parcelRequire("2jcOR");

var $lkVty = parcelRequire("lkVty");

var $f7umK = parcelRequire("f7umK");
/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the first argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */ var $798be8b27a50c416$var$ap = /*#__PURE__*/ (0, $2jcOR.default)(function ap(applyF, applyX) {
    return typeof applyX["fantasy-land/ap"] === "function" ? applyX["fantasy-land/ap"](applyF) : typeof applyF.ap === "function" ? applyF.ap(applyX) : typeof applyF === "function" ? function(x) {
        return applyF(x)(applyX(x));
    } : (0, $lkVty.default)(function(acc, f) {
        return (0, $6eGa6.default)(acc, (0, $f7umK.default)(f, applyX));
    }, [], applyF);
});
var $798be8b27a50c416$export$2e2bcd8739ae039 = $798be8b27a50c416$var$ap;

});
parcelRegister("6eGa6", function(module, exports) {

$parcel$export(module.exports, "default", () => $48a4c161d30e4183$export$2e2bcd8739ae039);
/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */ function $48a4c161d30e4183$export$2e2bcd8739ae039(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;
    while(idx < len1){
        result[result.length] = set1[idx];
        idx += 1;
    }
    idx = 0;
    while(idx < len2){
        result[result.length] = set2[idx];
        idx += 1;
    }
    return result;
}

});

parcelRegister("lkVty", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8880cbac514a5a0$export$2e2bcd8739ae039);

var $i5mkn = parcelRequire("i5mkn");

var $gjl6R = parcelRequire("gjl6R");
function $f8880cbac514a5a0$var$_iterableReduce(reducer, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = reducer(acc, step.value);
        step = iter.next();
    }
    return acc;
}
function $f8880cbac514a5a0$var$_methodReduce(reducer, acc, obj, methodName) {
    return obj[methodName](reducer, acc);
}
var $f8880cbac514a5a0$var$_reduce = /*#__PURE__*/ (0, $gjl6R.default)((0, $i5mkn.default), $f8880cbac514a5a0$var$_methodReduce, $f8880cbac514a5a0$var$_iterableReduce);
var $f8880cbac514a5a0$export$2e2bcd8739ae039 = $f8880cbac514a5a0$var$_reduce;

});




parcelRegister("e2JJf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a394b964a29c41ab$export$2e2bcd8739ae039);

var $2jcOR = parcelRequire("2jcOR");
/**
 * Returns the first argument if it is truthy, otherwise the second argument.
 * Acts as the boolean `or` statement if both inputs are `Boolean`s.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any}
 * @see R.either, R.and
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */ var $a394b964a29c41ab$var$or = /*#__PURE__*/ (0, $2jcOR.default)(function or(a, b) {
    return a || b;
});
var $a394b964a29c41ab$export$2e2bcd8739ae039 = $a394b964a29c41ab$var$or;

});





parcelRegister("3NNX1", function(module, exports) {

$parcel$export(module.exports, "render", () => $2c4cb1eb429dee56$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $2c4cb1eb429dee56$var$_hoisted_1 = {
    class: "flex flex-col"
};
function $2c4cb1eb429dee56$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2c4cb1eb429dee56$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("section", null, [
            (0, $TusQn.createVNode)($setup["RouterView"])
        ])
    ]);
}

});

parcelRegister("1rrBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cdb945e864b702$export$2e2bcd8739ae039);
let $10cdb945e864b702$var$NOOP = ()=>{};
var $10cdb945e864b702$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");

var $7c6z4 = parcelRequire("7c6z4");

var $7a93b84855bb04e2$exports = {};

$parcel$export($7a93b84855bb04e2$exports, "acceptCategory", () => $7a93b84855bb04e2$export$f733614a75aede52);
$parcel$export($7a93b84855bb04e2$exports, "acceptedCategory", () => $7a93b84855bb04e2$export$d57953daf19d40f0);
$parcel$export($7a93b84855bb04e2$exports, "acceptService", () => $7a93b84855bb04e2$export$954bc960519baaed);
$parcel$export($7a93b84855bb04e2$exports, "acceptedService", () => $7a93b84855bb04e2$export$c6d040ca60661d88);
$parcel$export($7a93b84855bb04e2$exports, "validCookie", () => $7a93b84855bb04e2$export$26b2c20fc8da53a0);
$parcel$export($7a93b84855bb04e2$exports, "eraseCookies", () => $7a93b84855bb04e2$export$6dde6a4e31d2b3a6);
$parcel$export($7a93b84855bb04e2$exports, "show", () => $7a93b84855bb04e2$export$57bf213be019eeb0);
$parcel$export($7a93b84855bb04e2$exports, "hide", () => $7a93b84855bb04e2$export$fe8985bb6374093c);
$parcel$export($7a93b84855bb04e2$exports, "showPreferences", () => $7a93b84855bb04e2$export$535e69674d40eb20);
$parcel$export($7a93b84855bb04e2$exports, "hidePreferences", () => $7a93b84855bb04e2$export$5b3a895f6cbac580);
$parcel$export($7a93b84855bb04e2$exports, "validConsent", () => $7a93b84855bb04e2$export$3bdcc4c9b3764a39);
$parcel$export($7a93b84855bb04e2$exports, "setLanguage", () => $7a93b84855bb04e2$export$4b6bf64406ec64af);
$parcel$export($7a93b84855bb04e2$exports, "getUserPreferences", () => $7a93b84855bb04e2$export$ae3f5fa351e2f57a);
$parcel$export($7a93b84855bb04e2$exports, "loadScript", () => $7a93b84855bb04e2$export$2cb99e4be0dc4646);
$parcel$export($7a93b84855bb04e2$exports, "setCookieData", () => $7a93b84855bb04e2$export$3cbc67a40c3171bd);
$parcel$export($7a93b84855bb04e2$exports, "getCookie", () => $7a93b84855bb04e2$export$4be65e66cfa2648a);
$parcel$export($7a93b84855bb04e2$exports, "getConfig", () => $7a93b84855bb04e2$export$44487a86467333c3);
$parcel$export($7a93b84855bb04e2$exports, "run", () => $7a93b84855bb04e2$export$889ea624f2cb2c57);
$parcel$export($7a93b84855bb04e2$exports, "reset", () => $7a93b84855bb04e2$export$aad8462122ac592b);
/*!
* CookieConsent 3.0.1
* https://github.com/orestbida/cookieconsent
* Author Orest Bida
* Released under the MIT License
*/ const $7a93b84855bb04e2$var$e = "opt-in", $7a93b84855bb04e2$var$t = "opt-out", $7a93b84855bb04e2$var$o = "show--consent", $7a93b84855bb04e2$var$n = "show--preferences", $7a93b84855bb04e2$var$a = "disable--interaction", $7a93b84855bb04e2$var$s = "data-category", $7a93b84855bb04e2$var$c = "div", $7a93b84855bb04e2$var$r = "button", $7a93b84855bb04e2$var$i = "aria-hidden", $7a93b84855bb04e2$var$l = "btn-group", $7a93b84855bb04e2$var$d = "click", $7a93b84855bb04e2$var$f = "data-role", $7a93b84855bb04e2$var$_ = "consentModal", $7a93b84855bb04e2$var$u = "preferencesModal";
class $7a93b84855bb04e2$var$p {
    constructor(){
        this.t = {
            mode: $7a93b84855bb04e2$var$e,
            revision: 0,
            autoShow: !0,
            lazyHtmlGeneration: !0,
            autoClearCookies: !0,
            manageScriptTags: !0,
            hideFromBots: !0,
            cookie: {
                name: "cc_cookie",
                expiresAfterDays: 182,
                domain: "",
                path: "/",
                sameSite: "Lax"
            }
        }, this.o = {
            i: {},
            l: "",
            _: {},
            u: {},
            p: {},
            m: [],
            v: !1,
            h: null,
            C: null,
            S: null,
            M: "",
            D: !0,
            T: !1,
            k: !1,
            A: !1,
            N: !1,
            H: [],
            V: !1,
            I: !0,
            L: [],
            j: !1,
            F: "",
            P: !1,
            O: [],
            R: [],
            B: [],
            G: [],
            J: !1,
            U: !1,
            $: !1,
            q: [],
            K: [],
            W: [],
            X: {},
            Y: {},
            Z: {},
            ee: {},
            te: {},
            oe: []
        }, this.ne = {
            ae: {},
            se: {}
        }, this.ce = {}, this.re = {
            ie: "cc:onFirstConsent",
            le: "cc:onConsent",
            de: "cc:onChange",
            fe: "cc:onModalShow",
            _e: "cc:onModalHide",
            ue: "cc:onModalReady"
        };
    }
}
const $7a93b84855bb04e2$var$m = new $7a93b84855bb04e2$var$p, $7a93b84855bb04e2$var$g = (e, t)=>e.indexOf(t), $7a93b84855bb04e2$var$b = (e, t)=>-1 !== $7a93b84855bb04e2$var$g(e, t), $7a93b84855bb04e2$var$v = (e)=>Array.isArray(e), $7a93b84855bb04e2$var$y = (e)=>"string" == typeof e, $7a93b84855bb04e2$var$h = (e)=>!!e && "object" == typeof e && !$7a93b84855bb04e2$var$v(e), $7a93b84855bb04e2$var$C = (e)=>"function" == typeof e, $7a93b84855bb04e2$var$w = (e)=>Object.keys(e), $7a93b84855bb04e2$var$S = (e)=>Array.from(new Set(e)), $7a93b84855bb04e2$var$x = ()=>document.activeElement, $7a93b84855bb04e2$var$M = (e)=>e.preventDefault(), $7a93b84855bb04e2$var$D = (e, t)=>e.querySelectorAll(t), $7a93b84855bb04e2$var$T = (e)=>e.dispatchEvent(new Event("change")), $7a93b84855bb04e2$var$k = (e)=>{
    const t = document.createElement(e);
    return e === $7a93b84855bb04e2$var$r && (t.type = e), t;
}, $7a93b84855bb04e2$var$E = (e, t, o)=>e.setAttribute(t, o), $7a93b84855bb04e2$var$A = (e, t, o)=>{
    e.removeAttribute(o ? "data-" + t : t);
}, $7a93b84855bb04e2$var$N = (e, t, o)=>e.getAttribute(o ? "data-" + t : t), $7a93b84855bb04e2$var$H = (e, t)=>e.appendChild(t), $7a93b84855bb04e2$var$V = (e, t)=>e.classList.add(t), $7a93b84855bb04e2$var$I = (e, t)=>$7a93b84855bb04e2$var$V(e, "cm__" + t), $7a93b84855bb04e2$var$L = (e, t)=>$7a93b84855bb04e2$var$V(e, "pm__" + t), $7a93b84855bb04e2$var$j = (e, t)=>e.classList.remove(t), $7a93b84855bb04e2$var$F = (e)=>{
    if ("object" != typeof e) return e;
    if (e instanceof Date) return new Date(e.getTime());
    let t = Array.isArray(e) ? [] : {};
    for(let o in e){
        let n = e[o];
        t[o] = $7a93b84855bb04e2$var$F(n);
    }
    return t;
}, $7a93b84855bb04e2$var$P = ()=>{
    const e = {}, { O: t, X: o, Y: n } = $7a93b84855bb04e2$var$m.o;
    for (const a of t)e[a] = $7a93b84855bb04e2$var$G(n[a], $7a93b84855bb04e2$var$w(o[a]));
    return e;
}, $7a93b84855bb04e2$var$O = (e, t)=>dispatchEvent(new CustomEvent(e, {
        detail: t
    })), $7a93b84855bb04e2$var$R = (e, t, o, n)=>{
    e.addEventListener(t, o), n && $7a93b84855bb04e2$var$m.o.m.push({
        pe: e,
        me: t,
        ge: o
    });
}, $7a93b84855bb04e2$var$B = ()=>{
    const e = $7a93b84855bb04e2$var$m.t.cookie.expiresAfterDays;
    return $7a93b84855bb04e2$var$C(e) ? e($7a93b84855bb04e2$var$m.o.F) : e;
}, $7a93b84855bb04e2$var$G = (e, t)=>{
    const o = e || [], n = t || [];
    return o.filter((e)=>!$7a93b84855bb04e2$var$b(n, e)).concat(n.filter((e)=>!$7a93b84855bb04e2$var$b(o, e)));
}, $7a93b84855bb04e2$var$J = (e)=>{
    $7a93b84855bb04e2$var$m.o.R = $7a93b84855bb04e2$var$S(e), $7a93b84855bb04e2$var$m.o.F = (()=>{
        let e = "custom";
        const { R: t, O: o, B: n } = $7a93b84855bb04e2$var$m.o, a = t.length;
        return a === o.length ? e = "all" : a === n.length && (e = "necessary"), e;
    })();
}, $7a93b84855bb04e2$var$U = (e, t, o, n)=>{
    const a = "accept-", { show: s, showPreferences: c, hide: r, hidePreferences: i, acceptCategory: l } = t, f = e || document, _ = (e)=>$7a93b84855bb04e2$var$D(f, `[data-cc="${e}"]`), u = (e, t)=>{
        $7a93b84855bb04e2$var$M(e), l(t), i(), r();
    }, p = _("show-preferencesModal"), g = _("show-consentModal"), b = _(a + "all"), v = _(a + "necessary"), y = _(a + "custom"), h = $7a93b84855bb04e2$var$m.t.lazyHtmlGeneration;
    for (const e of p)$7a93b84855bb04e2$var$E(e, "aria-haspopup", "dialog"), $7a93b84855bb04e2$var$R(e, $7a93b84855bb04e2$var$d, (e)=>{
        $7a93b84855bb04e2$var$M(e), c();
    }), h && ($7a93b84855bb04e2$var$R(e, "mouseenter", (e)=>{
        $7a93b84855bb04e2$var$M(e), $7a93b84855bb04e2$var$m.o.N || o(t, n);
    }, !0), $7a93b84855bb04e2$var$R(e, "focus", ()=>{
        $7a93b84855bb04e2$var$m.o.N || o(t, n);
    }));
    for (let e of g)$7a93b84855bb04e2$var$E(e, "aria-haspopup", "dialog"), $7a93b84855bb04e2$var$R(e, $7a93b84855bb04e2$var$d, (e)=>{
        $7a93b84855bb04e2$var$M(e), s(!0);
    }, !0);
    for (let e of b)$7a93b84855bb04e2$var$R(e, $7a93b84855bb04e2$var$d, (e)=>{
        u(e, "all");
    }, !0);
    for (let e of y)$7a93b84855bb04e2$var$R(e, $7a93b84855bb04e2$var$d, (e)=>{
        u(e);
    }, !0);
    for (let e of v)$7a93b84855bb04e2$var$R(e, $7a93b84855bb04e2$var$d, (e)=>{
        u(e, []);
    }, !0);
}, $7a93b84855bb04e2$var$$ = (e, t)=>{
    e && (t && (e.tabIndex = -1), e.focus(), t && e.removeAttribute("tabindex"));
}, $7a93b84855bb04e2$var$z = (e, t)=>{
    const o = (n)=>{
        n.target.removeEventListener("transitionend", o), "opacity" === n.propertyName && "1" === getComputedStyle(e).opacity && $7a93b84855bb04e2$var$$(((e)=>1 === e ? $7a93b84855bb04e2$var$m.ne.be : $7a93b84855bb04e2$var$m.ne.ve)(t));
    };
    $7a93b84855bb04e2$var$R(e, "transitionend", o);
};
let $7a93b84855bb04e2$var$q;
const $7a93b84855bb04e2$var$K = (e)=>{
    clearTimeout($7a93b84855bb04e2$var$q), e ? $7a93b84855bb04e2$var$V($7a93b84855bb04e2$var$m.ne.ye, $7a93b84855bb04e2$var$a) : $7a93b84855bb04e2$var$q = setTimeout(()=>{
        $7a93b84855bb04e2$var$j($7a93b84855bb04e2$var$m.ne.ye, $7a93b84855bb04e2$var$a);
    }, 500);
}, $7a93b84855bb04e2$var$Q = [
    "M 19.5 4.5 L 4.5 19.5 M 4.5 4.501 L 19.5 19.5",
    "M 3.572 13.406 L 8.281 18.115 L 20.428 5.885",
    "M 21.999 6.94 L 11.639 17.18 L 2.001 6.82 "
], $7a93b84855bb04e2$var$W = (e = 0, t = 1.5)=>`<svg viewBox="0 0 24 24" stroke-width="${t}"><path d="${$7a93b84855bb04e2$var$Q[e]}"/></svg>`, $7a93b84855bb04e2$var$X = (e)=>{
    const t = $7a93b84855bb04e2$var$m.ne, o = $7a93b84855bb04e2$var$m.o;
    ((e)=>{
        const n = e === t.he, a = o.i.disablePageInteraction ? t.ye : n ? t.Ce : t.ye;
        $7a93b84855bb04e2$var$R(a, "keydown", (t)=>{
            if ("Tab" !== t.key || !(n ? o.k && !o.A : o.A)) return;
            const a = $7a93b84855bb04e2$var$x(), s = n ? o.q : o.K;
            0 !== s.length && (t.shiftKey ? a !== s[0] && e.contains(a) || ($7a93b84855bb04e2$var$M(t), $7a93b84855bb04e2$var$$(s[1])) : a !== s[1] && e.contains(a) || ($7a93b84855bb04e2$var$M(t), $7a93b84855bb04e2$var$$(s[0])));
        }, !0);
    })(e);
}, $7a93b84855bb04e2$var$Y = [
    "[href]",
    $7a93b84855bb04e2$var$r,
    "input",
    "details",
    "[tabindex]"
].map((e)=>e + ':not([tabindex="-1"])').join(","), $7a93b84855bb04e2$var$Z = (e)=>{
    const { o: t, ne: o } = $7a93b84855bb04e2$var$m, n = (e, t)=>{
        const o = $7a93b84855bb04e2$var$D(e, $7a93b84855bb04e2$var$Y);
        t[0] = o[0], t[1] = o[o.length - 1];
    };
    1 === e && t.T && n(o.he, t.q), 2 === e && t.N && n(o.we, t.K);
}, $7a93b84855bb04e2$var$ee = (e, t, o)=>{
    const { de: n, le: a, ie: s, _e: c, ue: r, fe: i } = $7a93b84855bb04e2$var$m.ce, l = $7a93b84855bb04e2$var$m.re;
    if (t) {
        const n = {
            modalName: t
        };
        return e === l.fe ? $7a93b84855bb04e2$var$C(i) && i(n) : e === l._e ? $7a93b84855bb04e2$var$C(c) && c(n) : (n.modal = o, $7a93b84855bb04e2$var$C(r) && r(n)), $7a93b84855bb04e2$var$O(e, n);
    }
    const d = {
        cookie: $7a93b84855bb04e2$var$m.o.p
    };
    e === l.ie ? $7a93b84855bb04e2$var$C(s) && s($7a93b84855bb04e2$var$F(d)) : e === l.le ? $7a93b84855bb04e2$var$C(a) && a($7a93b84855bb04e2$var$F(d)) : (d.changedCategories = $7a93b84855bb04e2$var$m.o.L, d.changedServices = $7a93b84855bb04e2$var$m.o.ee, $7a93b84855bb04e2$var$C(n) && n($7a93b84855bb04e2$var$F(d))), $7a93b84855bb04e2$var$O(e, $7a93b84855bb04e2$var$F(d));
}, $7a93b84855bb04e2$var$te = (e, t)=>{
    try {
        return e();
    } catch (e) {
        return !t && console.warn("CookieConsent:", e), !1;
    }
}, $7a93b84855bb04e2$var$oe = (e)=>{
    const { Y: t, ee: o, O: n, X: a, oe: c, p: r, L: i } = $7a93b84855bb04e2$var$m.o;
    for (const e of n){
        const n = o[e] || t[e] || [];
        for (const o of n){
            const n = a[e][o];
            if (!n) continue;
            const { onAccept: s, onReject: c } = n;
            !n.Se && $7a93b84855bb04e2$var$b(t[e], o) ? (n.Se = !0, $7a93b84855bb04e2$var$C(s) && s()) : n.Se && !$7a93b84855bb04e2$var$b(t[e], o) && (n.Se = !1, $7a93b84855bb04e2$var$C(c) && c());
        }
    }
    if (!$7a93b84855bb04e2$var$m.t.manageScriptTags) return;
    const l = c, d = e || r.categories || [], f = (e, n)=>{
        if (n >= e.length) return;
        const a = c[n];
        if (a.xe) return f(e, n + 1);
        const r = a.Me, l = a.De, _ = a.Te, u = $7a93b84855bb04e2$var$b(d, l), p = !!_ && $7a93b84855bb04e2$var$b(t[l], _);
        if (!_ && !a.ke && u || !_ && a.ke && !u && $7a93b84855bb04e2$var$b(i, l) || _ && !a.ke && p || _ && a.ke && !p && $7a93b84855bb04e2$var$b(o[l] || [], _)) {
            a.xe = !0;
            const t = $7a93b84855bb04e2$var$N(r, "type", !0);
            $7a93b84855bb04e2$var$A(r, "type", !!t), $7a93b84855bb04e2$var$A(r, $7a93b84855bb04e2$var$s);
            let o = $7a93b84855bb04e2$var$N(r, "src", !0);
            o && $7a93b84855bb04e2$var$A(r, "src", !0);
            const c = $7a93b84855bb04e2$var$k("script");
            c.textContent = r.innerHTML;
            for (const { nodeName: e } of r.attributes)$7a93b84855bb04e2$var$E(c, e, r[e] || $7a93b84855bb04e2$var$N(r, e));
            t && (c.type = t), o ? c.src = o : o = r.src;
            const i = !!o && (!t || [
                "text/javascript",
                "module"
            ].includes(t));
            if (i && (c.onload = c.onerror = ()=>{
                f(e, ++n);
            }), r.replaceWith(c), i) return;
        }
        f(e, ++n);
    };
    f(l, 0);
}, $7a93b84855bb04e2$var$ne = "bottom", $7a93b84855bb04e2$var$ae = "left", $7a93b84855bb04e2$var$se = "center", $7a93b84855bb04e2$var$ce = "right", $7a93b84855bb04e2$var$re = "inline", $7a93b84855bb04e2$var$ie = "wide", $7a93b84855bb04e2$var$le = "pm--", $7a93b84855bb04e2$var$de = [
    "middle",
    "top",
    $7a93b84855bb04e2$var$ne
], $7a93b84855bb04e2$var$fe = [
    $7a93b84855bb04e2$var$ae,
    $7a93b84855bb04e2$var$se,
    $7a93b84855bb04e2$var$ce
], $7a93b84855bb04e2$var$_e = {
    box: {
        Ee: [
            $7a93b84855bb04e2$var$ie,
            $7a93b84855bb04e2$var$re
        ],
        Ae: $7a93b84855bb04e2$var$de,
        Ne: $7a93b84855bb04e2$var$fe,
        He: $7a93b84855bb04e2$var$ne,
        Ve: $7a93b84855bb04e2$var$ce
    },
    cloud: {
        Ee: [
            $7a93b84855bb04e2$var$re
        ],
        Ae: $7a93b84855bb04e2$var$de,
        Ne: $7a93b84855bb04e2$var$fe,
        He: $7a93b84855bb04e2$var$ne,
        Ve: $7a93b84855bb04e2$var$se
    },
    bar: {
        Ee: [
            $7a93b84855bb04e2$var$re
        ],
        Ae: $7a93b84855bb04e2$var$de.slice(1),
        Ne: [],
        He: $7a93b84855bb04e2$var$ne,
        Ve: ""
    }
}, $7a93b84855bb04e2$var$ue = {
    box: {
        Ee: [],
        Ae: [],
        Ne: [],
        He: "",
        Ve: ""
    },
    bar: {
        Ee: [
            $7a93b84855bb04e2$var$ie
        ],
        Ae: [],
        Ne: [
            $7a93b84855bb04e2$var$ae,
            $7a93b84855bb04e2$var$ce
        ],
        He: "",
        Ve: $7a93b84855bb04e2$var$ae
    }
}, $7a93b84855bb04e2$var$pe = (e)=>{
    const t = $7a93b84855bb04e2$var$m.o.i.guiOptions, o = t && t.consentModal, n = t && t.preferencesModal;
    0 === e && $7a93b84855bb04e2$var$me($7a93b84855bb04e2$var$m.ne.he, $7a93b84855bb04e2$var$_e, o, "cm--", "box", "cm"), 1 === e && $7a93b84855bb04e2$var$me($7a93b84855bb04e2$var$m.ne.we, $7a93b84855bb04e2$var$ue, n, $7a93b84855bb04e2$var$le, "box", "pm");
}, $7a93b84855bb04e2$var$me = (e, t, o, n, a, s)=>{
    e.className = s;
    const c = o && o.layout, r = o && o.position, i = o && o.flipButtons, l = !o || !1 !== o.equalWeightButtons, d = c && c.split(" ") || [], f = d[0], _ = d[1], u = f in t ? f : a, p = t[u], g = $7a93b84855bb04e2$var$b(p.Ee, _) && _, v = r && r.split(" ") || [], y = v[0], h = n === $7a93b84855bb04e2$var$le ? v[0] : v[1], C = $7a93b84855bb04e2$var$b(p.Ae, y) ? y : p.He, w = $7a93b84855bb04e2$var$b(p.Ne, h) ? h : p.Ve, S = (t)=>{
        t && $7a93b84855bb04e2$var$V(e, n + t);
    };
    S(u), S(g), S(C), S(w), i && S("flip");
    const x = s + "__btn--secondary";
    if ("cm" === s) {
        const { Ie: e, Le: t } = $7a93b84855bb04e2$var$m.ne;
        e && (l ? $7a93b84855bb04e2$var$j(e, x) : $7a93b84855bb04e2$var$V(e, x)), t && (l ? $7a93b84855bb04e2$var$j(t, x) : $7a93b84855bb04e2$var$V(t, x));
    } else {
        const { je: e } = $7a93b84855bb04e2$var$m.ne;
        e && (l ? $7a93b84855bb04e2$var$j(e, x) : $7a93b84855bb04e2$var$V(e, x));
    }
}, $7a93b84855bb04e2$var$ge = (e, t)=>{
    const o = $7a93b84855bb04e2$var$m.o, n = $7a93b84855bb04e2$var$m.ne, { hide: a, hidePreferences: s, acceptCategory: _ } = e, p = (e)=>{
        _(e), s(), a();
    }, g = o.u && o.u.preferencesModal;
    if (!g) return;
    const b = g.title, v = g.closeIconLabel, C = g.acceptAllBtn, S = g.acceptNecessaryBtn, x = g.savePreferencesBtn, M = g.sections || [], D = C || S || x;
    if (n.Fe) n.Pe = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), $7a93b84855bb04e2$var$L(n.Pe, "body");
    else {
        n.Fe = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), $7a93b84855bb04e2$var$V(n.Fe, "pm-wrapper");
        const e = $7a93b84855bb04e2$var$k("div");
        $7a93b84855bb04e2$var$V(e, "pm-overlay"), $7a93b84855bb04e2$var$H(n.Fe, e), $7a93b84855bb04e2$var$R(e, $7a93b84855bb04e2$var$d, s), n.we = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), $7a93b84855bb04e2$var$V(n.we, "pm"), $7a93b84855bb04e2$var$E(n.we, "role", "dialog"), $7a93b84855bb04e2$var$E(n.we, $7a93b84855bb04e2$var$i, !0), $7a93b84855bb04e2$var$E(n.we, "aria-modal", !0), $7a93b84855bb04e2$var$E(n.we, "aria-labelledby", "pm__title"), $7a93b84855bb04e2$var$R(n.ye, "keydown", (e)=>{
            27 === e.keyCode && s();
        }, !0), n.Oe = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), $7a93b84855bb04e2$var$L(n.Oe, "header"), n.Re = $7a93b84855bb04e2$var$k("h2"), $7a93b84855bb04e2$var$L(n.Re, "title"), n.Re.id = "pm__title", n.Be = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$r), $7a93b84855bb04e2$var$L(n.Be, "close-btn"), $7a93b84855bb04e2$var$E(n.Be, "aria-label", g.closeIconLabel || ""), $7a93b84855bb04e2$var$R(n.Be, $7a93b84855bb04e2$var$d, s), n.Ge = $7a93b84855bb04e2$var$k("span"), n.Ge.innerHTML = $7a93b84855bb04e2$var$W(), $7a93b84855bb04e2$var$H(n.Be, n.Ge), n.Je = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), $7a93b84855bb04e2$var$L(n.Je, "body"), n.Ue = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), $7a93b84855bb04e2$var$L(n.Ue, "footer");
        var T = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c);
        $7a93b84855bb04e2$var$V(T, "btns");
        var A = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), N = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c);
        $7a93b84855bb04e2$var$L(A, $7a93b84855bb04e2$var$l), $7a93b84855bb04e2$var$L(N, $7a93b84855bb04e2$var$l), $7a93b84855bb04e2$var$H(n.Ue, A), $7a93b84855bb04e2$var$H(n.Ue, N), $7a93b84855bb04e2$var$H(n.Oe, n.Re), $7a93b84855bb04e2$var$H(n.Oe, n.Be), n.ve = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), $7a93b84855bb04e2$var$E(n.ve, "tabIndex", -1), $7a93b84855bb04e2$var$H(n.we, n.ve), $7a93b84855bb04e2$var$H(n.we, n.Oe), $7a93b84855bb04e2$var$H(n.we, n.Je), D && $7a93b84855bb04e2$var$H(n.we, n.Ue), $7a93b84855bb04e2$var$H(n.Fe, n.we);
    }
    let I;
    b && (n.Re.innerHTML = b, v && $7a93b84855bb04e2$var$E(n.Be, "aria-label", v)), M.forEach((e, t)=>{
        const a = e.title, s = e.description, l = e.linkedCategory, f = l && o.P[l], _ = e.cookieTable, u = _ && _.body, p = _ && _.caption, m = u && u.length > 0, b = !!f, v = b && o.X[l], C = $7a93b84855bb04e2$var$h(v) && $7a93b84855bb04e2$var$w(v) || [], S = b && (!!s || !!m || $7a93b84855bb04e2$var$w(v).length > 0);
        var x = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c);
        if ($7a93b84855bb04e2$var$L(x, "section"), S || s) {
            var M = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c);
            $7a93b84855bb04e2$var$L(M, "section-desc-wrapper");
        }
        let D = C.length;
        if (S && D > 0) {
            const e = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c);
            $7a93b84855bb04e2$var$L(e, "section-services");
            for (const t of C){
                const o = v[t], n = o && o.label || t, a = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), s = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), r = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), i = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c);
                $7a93b84855bb04e2$var$L(a, "service"), $7a93b84855bb04e2$var$L(i, "service-title"), $7a93b84855bb04e2$var$L(s, "service-header"), $7a93b84855bb04e2$var$L(r, "service-icon");
                const d = $7a93b84855bb04e2$var$be(n, t, f, !0, l);
                i.innerHTML = n, $7a93b84855bb04e2$var$H(s, r), $7a93b84855bb04e2$var$H(s, i), $7a93b84855bb04e2$var$H(a, s), $7a93b84855bb04e2$var$H(a, d), $7a93b84855bb04e2$var$H(e, a);
            }
            $7a93b84855bb04e2$var$H(M, e);
        }
        if (a) {
            var T = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), A = $7a93b84855bb04e2$var$k(b ? $7a93b84855bb04e2$var$r : $7a93b84855bb04e2$var$c);
            if ($7a93b84855bb04e2$var$L(T, "section-title-wrapper"), $7a93b84855bb04e2$var$L(A, "section-title"), A.innerHTML = a, $7a93b84855bb04e2$var$H(T, A), b) {
                const e = $7a93b84855bb04e2$var$k("span");
                e.innerHTML = $7a93b84855bb04e2$var$W(2, 3.5), $7a93b84855bb04e2$var$L(e, "section-arrow"), $7a93b84855bb04e2$var$H(T, e), x.className += "--toggle";
                const t = $7a93b84855bb04e2$var$be(a, l, f);
                let o = g.serviceCounterLabel;
                if (D > 0 && $7a93b84855bb04e2$var$y(o)) {
                    let e = $7a93b84855bb04e2$var$k("span");
                    $7a93b84855bb04e2$var$L(e, "badge"), $7a93b84855bb04e2$var$L(e, "service-counter"), $7a93b84855bb04e2$var$E(e, $7a93b84855bb04e2$var$i, !0), $7a93b84855bb04e2$var$E(e, "data-servicecounter", D), o && (o = o.split("|"), o = o.length > 1 && D > 1 ? o[1] : o[0], $7a93b84855bb04e2$var$E(e, "data-counterlabel", o)), e.innerHTML = D + (o ? " " + o : ""), $7a93b84855bb04e2$var$H(A, e);
                }
                if (S) {
                    $7a93b84855bb04e2$var$L(x, "section--expandable");
                    var N = l + "-desc";
                    $7a93b84855bb04e2$var$E(A, "aria-expanded", !1), $7a93b84855bb04e2$var$E(A, "aria-controls", N);
                }
                $7a93b84855bb04e2$var$H(T, t);
            } else $7a93b84855bb04e2$var$E(A, "role", "heading"), $7a93b84855bb04e2$var$E(A, "aria-level", "3");
            $7a93b84855bb04e2$var$H(x, T);
        }
        if (s) {
            var F = $7a93b84855bb04e2$var$k("p");
            $7a93b84855bb04e2$var$L(F, "section-desc"), F.innerHTML = s, $7a93b84855bb04e2$var$H(M, F);
        }
        if (S && ($7a93b84855bb04e2$var$E(M, $7a93b84855bb04e2$var$i, "true"), M.id = N, ((e, t, o)=>{
            $7a93b84855bb04e2$var$R(A, $7a93b84855bb04e2$var$d, ()=>{
                t.classList.contains("is-expanded") ? ($7a93b84855bb04e2$var$j(t, "is-expanded"), $7a93b84855bb04e2$var$E(o, "aria-expanded", "false"), $7a93b84855bb04e2$var$E(e, $7a93b84855bb04e2$var$i, "true")) : ($7a93b84855bb04e2$var$V(t, "is-expanded"), $7a93b84855bb04e2$var$E(o, "aria-expanded", "true"), $7a93b84855bb04e2$var$E(e, $7a93b84855bb04e2$var$i, "false"));
            });
        })(M, x, A), m)) {
            const e = $7a93b84855bb04e2$var$k("table"), o = $7a93b84855bb04e2$var$k("thead"), a = $7a93b84855bb04e2$var$k("tbody");
            if (p) {
                const t = $7a93b84855bb04e2$var$k("caption");
                $7a93b84855bb04e2$var$L(t, "table-caption"), t.innerHTML = p, e.appendChild(t);
            }
            $7a93b84855bb04e2$var$L(e, "section-table"), $7a93b84855bb04e2$var$L(o, "table-head"), $7a93b84855bb04e2$var$L(a, "table-body");
            const s = _.headers, r = $7a93b84855bb04e2$var$w(s), i = n.$e.createDocumentFragment(), l = $7a93b84855bb04e2$var$k("tr");
            for (const e of r){
                const o = s[e], n = $7a93b84855bb04e2$var$k("th");
                n.id = "cc__row-" + o + t, $7a93b84855bb04e2$var$E(n, "scope", "col"), $7a93b84855bb04e2$var$L(n, "table-th"), n.innerHTML = o, $7a93b84855bb04e2$var$H(i, n);
            }
            $7a93b84855bb04e2$var$H(l, i), $7a93b84855bb04e2$var$H(o, l);
            const d = n.$e.createDocumentFragment();
            for (const e of u){
                const o = $7a93b84855bb04e2$var$k("tr");
                $7a93b84855bb04e2$var$L(o, "table-tr");
                for (const n of r){
                    const a = s[n], r = e[n], i = $7a93b84855bb04e2$var$k("td"), l = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c);
                    $7a93b84855bb04e2$var$L(i, "table-td"), $7a93b84855bb04e2$var$E(i, "data-column", a), $7a93b84855bb04e2$var$E(i, "headers", "cc__row-" + a + t), l.insertAdjacentHTML("beforeend", r), $7a93b84855bb04e2$var$H(i, l), $7a93b84855bb04e2$var$H(o, i);
                }
                $7a93b84855bb04e2$var$H(d, o);
            }
            $7a93b84855bb04e2$var$H(a, d), $7a93b84855bb04e2$var$H(e, o), $7a93b84855bb04e2$var$H(e, a), $7a93b84855bb04e2$var$H(M, e);
        }
        (S || s) && $7a93b84855bb04e2$var$H(x, M);
        const P = n.Pe || n.Je;
        b ? (I || (I = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), $7a93b84855bb04e2$var$L(I, "section-toggles")), I.appendChild(x)) : I = null, $7a93b84855bb04e2$var$H(P, I || x);
    }), C && (n.ze || (n.ze = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$r), $7a93b84855bb04e2$var$L(n.ze, "btn"), $7a93b84855bb04e2$var$E(n.ze, $7a93b84855bb04e2$var$f, "all"), $7a93b84855bb04e2$var$H(A, n.ze), $7a93b84855bb04e2$var$R(n.ze, $7a93b84855bb04e2$var$d, ()=>p("all"))), n.ze.innerHTML = C), S && (n.je || (n.je = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$r), $7a93b84855bb04e2$var$L(n.je, "btn"), $7a93b84855bb04e2$var$E(n.je, $7a93b84855bb04e2$var$f, "necessary"), $7a93b84855bb04e2$var$H(A, n.je), $7a93b84855bb04e2$var$R(n.je, $7a93b84855bb04e2$var$d, ()=>p([]))), n.je.innerHTML = S), x && (n.qe || (n.qe = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$r), $7a93b84855bb04e2$var$L(n.qe, "btn"), $7a93b84855bb04e2$var$L(n.qe, "btn--secondary"), $7a93b84855bb04e2$var$E(n.qe, $7a93b84855bb04e2$var$f, "save"), $7a93b84855bb04e2$var$H(N, n.qe), $7a93b84855bb04e2$var$R(n.qe, $7a93b84855bb04e2$var$d, ()=>p())), n.qe.innerHTML = x), n.Pe && (n.we.replaceChild(n.Pe, n.Je), n.Je = n.Pe), $7a93b84855bb04e2$var$pe(1), o.N || (o.N = !0, $7a93b84855bb04e2$var$ee($7a93b84855bb04e2$var$m.re.ue, $7a93b84855bb04e2$var$u, n.we), t(e), $7a93b84855bb04e2$var$H(n.Ce, n.Fe), $7a93b84855bb04e2$var$X(n.we), setTimeout(()=>$7a93b84855bb04e2$var$V(n.Fe, "cc--anim"), 100)), $7a93b84855bb04e2$var$Z(2);
};
function $7a93b84855bb04e2$var$be(e, t, o, n, a) {
    const c = $7a93b84855bb04e2$var$m.o, r = $7a93b84855bb04e2$var$m.ne, l = $7a93b84855bb04e2$var$k("label"), f = $7a93b84855bb04e2$var$k("input"), _ = $7a93b84855bb04e2$var$k("span"), u = $7a93b84855bb04e2$var$k("span"), p = $7a93b84855bb04e2$var$k("span"), g = $7a93b84855bb04e2$var$k("span"), v = $7a93b84855bb04e2$var$k("span");
    if (g.innerHTML = $7a93b84855bb04e2$var$W(1, 3), v.innerHTML = $7a93b84855bb04e2$var$W(0, 3), f.type = "checkbox", $7a93b84855bb04e2$var$V(l, "section__toggle-wrapper"), $7a93b84855bb04e2$var$V(f, "section__toggle"), $7a93b84855bb04e2$var$V(g, "toggle__icon-on"), $7a93b84855bb04e2$var$V(v, "toggle__icon-off"), $7a93b84855bb04e2$var$V(_, "toggle__icon"), $7a93b84855bb04e2$var$V(u, "toggle__icon-circle"), $7a93b84855bb04e2$var$V(p, "toggle__label"), $7a93b84855bb04e2$var$E(_, $7a93b84855bb04e2$var$i, "true"), n ? ($7a93b84855bb04e2$var$V(l, "toggle-service"), $7a93b84855bb04e2$var$E(f, $7a93b84855bb04e2$var$s, a), r.se[a][t] = f) : r.ae[t] = f, n ? ((e)=>{
        $7a93b84855bb04e2$var$R(f, "change", ()=>{
            const t = r.se[e], o = r.ae[e];
            c.Z[e] = [];
            for(let o in t){
                const n = t[o];
                n.checked && c.Z[e].push(n.value);
            }
            o.checked = c.Z[e].length > 0;
        });
    })(a) : ((e)=>{
        $7a93b84855bb04e2$var$R(f, $7a93b84855bb04e2$var$d, ()=>{
            const t = r.se[e], o = f.checked;
            c.Z[e] = [];
            for(let n in t)t[n].checked = o, o && c.Z[e].push(n);
        });
    })(t), f.value = t, p.textContent = e.replace(/<.*>.*<\/.*>/gm, ""), $7a93b84855bb04e2$var$H(u, v), $7a93b84855bb04e2$var$H(u, g), $7a93b84855bb04e2$var$H(_, u), c.D) (o.readOnly || o.enabled) && (f.checked = !0);
    else if (n) {
        const e = c.Y[a];
        f.checked = o.readOnly || $7a93b84855bb04e2$var$b(e, t);
    } else $7a93b84855bb04e2$var$b(c.R, t) && (f.checked = !0);
    return o.readOnly && (f.disabled = !0), $7a93b84855bb04e2$var$H(l, f), $7a93b84855bb04e2$var$H(l, _), $7a93b84855bb04e2$var$H(l, p), l;
}
const $7a93b84855bb04e2$var$ve = ()=>{
    const e = $7a93b84855bb04e2$var$k("span");
    return $7a93b84855bb04e2$var$m.ne.Ke || ($7a93b84855bb04e2$var$m.ne.Ke = e), e;
}, $7a93b84855bb04e2$var$ye = (e, t)=>{
    const o = $7a93b84855bb04e2$var$m.o, n = $7a93b84855bb04e2$var$m.ne, { hide: a, showPreferences: s, acceptCategory: u } = e, p = o.u && o.u.consentModal;
    if (!p) return;
    const g = p.acceptAllBtn, b = p.acceptNecessaryBtn, v = p.showPreferencesBtn, y = p.closeIconLabel, h = p.footer, C = p.label, w = p.title, S = (e)=>{
        a(), u(e);
    };
    if (!n.Qe) {
        n.Qe = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), n.he = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), n.We = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), n.Xe = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), n.Ye = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), $7a93b84855bb04e2$var$V(n.Qe, "cm-wrapper"), $7a93b84855bb04e2$var$V(n.he, "cm"), $7a93b84855bb04e2$var$I(n.We, "body"), $7a93b84855bb04e2$var$I(n.Xe, "texts"), $7a93b84855bb04e2$var$I(n.Ye, "btns"), $7a93b84855bb04e2$var$E(n.he, "role", "dialog"), $7a93b84855bb04e2$var$E(n.he, "aria-modal", "true"), $7a93b84855bb04e2$var$E(n.he, $7a93b84855bb04e2$var$i, "false"), $7a93b84855bb04e2$var$E(n.he, "aria-describedby", "cm__desc"), C ? $7a93b84855bb04e2$var$E(n.he, "aria-label", C) : w && $7a93b84855bb04e2$var$E(n.he, "aria-labelledby", "cm__title");
        const e = "box", t = o.i.guiOptions, a = t && t.consentModal, s = (a && a.layout || e).split(" ")[0] === e;
        w && y && s && (n.Le || (n.Le = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$r), n.Le.innerHTML = $7a93b84855bb04e2$var$W(), $7a93b84855bb04e2$var$I(n.Le, "btn"), $7a93b84855bb04e2$var$I(n.Le, "btn--close"), $7a93b84855bb04e2$var$R(n.Le, $7a93b84855bb04e2$var$d, ()=>{
            S([]);
        }), $7a93b84855bb04e2$var$H(n.We, n.Le)), $7a93b84855bb04e2$var$E(n.Le, "aria-label", y)), $7a93b84855bb04e2$var$H(n.We, n.Xe), (g || b || v) && $7a93b84855bb04e2$var$H(n.We, n.Ye), n.be = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), $7a93b84855bb04e2$var$E(n.be, "tabIndex", -1), $7a93b84855bb04e2$var$H(n.he, n.be), $7a93b84855bb04e2$var$H(n.he, n.We), $7a93b84855bb04e2$var$H(n.Qe, n.he);
    }
    w && (n.Ze || (n.Ze = $7a93b84855bb04e2$var$k("h2"), n.Ze.className = n.Ze.id = "cm__title", $7a93b84855bb04e2$var$H(n.Xe, n.Ze)), n.Ze.innerHTML = w);
    let x = p.description;
    if (x && (o.V && (x = x.replace("{{revisionMessage}}", o.I ? "" : p.revisionMessage || "")), n.et || (n.et = $7a93b84855bb04e2$var$k("p"), n.et.className = n.et.id = "cm__desc", $7a93b84855bb04e2$var$H(n.Xe, n.et)), n.et.innerHTML = x), g && (n.tt || (n.tt = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$r), $7a93b84855bb04e2$var$H(n.tt, $7a93b84855bb04e2$var$ve()), $7a93b84855bb04e2$var$I(n.tt, "btn"), $7a93b84855bb04e2$var$E(n.tt, $7a93b84855bb04e2$var$f, "all"), $7a93b84855bb04e2$var$R(n.tt, $7a93b84855bb04e2$var$d, ()=>{
        S("all");
    })), n.tt.firstElementChild.innerHTML = g), b && (n.Ie || (n.Ie = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$r), $7a93b84855bb04e2$var$H(n.Ie, $7a93b84855bb04e2$var$ve()), $7a93b84855bb04e2$var$I(n.Ie, "btn"), $7a93b84855bb04e2$var$E(n.Ie, $7a93b84855bb04e2$var$f, "necessary"), $7a93b84855bb04e2$var$R(n.Ie, $7a93b84855bb04e2$var$d, ()=>{
        S([]);
    })), n.Ie.firstElementChild.innerHTML = b), v && (n.ot || (n.ot = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$r), $7a93b84855bb04e2$var$H(n.ot, $7a93b84855bb04e2$var$ve()), $7a93b84855bb04e2$var$I(n.ot, "btn"), $7a93b84855bb04e2$var$I(n.ot, "btn--secondary"), $7a93b84855bb04e2$var$E(n.ot, $7a93b84855bb04e2$var$f, "show"), $7a93b84855bb04e2$var$R(n.ot, "mouseenter", ()=>{
        o.N || $7a93b84855bb04e2$var$ge(e, t);
    }), $7a93b84855bb04e2$var$R(n.ot, $7a93b84855bb04e2$var$d, s)), n.ot.firstElementChild.innerHTML = v), n.nt || (n.nt = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), $7a93b84855bb04e2$var$I(n.nt, $7a93b84855bb04e2$var$l), g && $7a93b84855bb04e2$var$H(n.nt, n.tt), b && $7a93b84855bb04e2$var$H(n.nt, n.Ie), (g || b) && $7a93b84855bb04e2$var$H(n.We, n.nt), $7a93b84855bb04e2$var$H(n.Ye, n.nt)), n.ot && !n.st && (n.st = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), n.Ie && n.tt ? ($7a93b84855bb04e2$var$I(n.st, $7a93b84855bb04e2$var$l), $7a93b84855bb04e2$var$H(n.st, n.ot), $7a93b84855bb04e2$var$H(n.Ye, n.st)) : ($7a93b84855bb04e2$var$H(n.nt, n.ot), $7a93b84855bb04e2$var$I(n.nt, $7a93b84855bb04e2$var$l + "--uneven"))), h) {
        if (!n.ct) {
            let e = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), t = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c);
            n.ct = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), $7a93b84855bb04e2$var$I(e, "footer"), $7a93b84855bb04e2$var$I(t, "links"), $7a93b84855bb04e2$var$I(n.ct, "link-group"), $7a93b84855bb04e2$var$H(t, n.ct), $7a93b84855bb04e2$var$H(e, t), $7a93b84855bb04e2$var$H(n.he, e);
        }
        n.ct.innerHTML = h;
    }
    $7a93b84855bb04e2$var$pe(0), o.T || (o.T = !0, $7a93b84855bb04e2$var$ee($7a93b84855bb04e2$var$m.re.ue, $7a93b84855bb04e2$var$_, n.he), t(e), $7a93b84855bb04e2$var$H(n.Ce, n.Qe), $7a93b84855bb04e2$var$X(n.he), setTimeout(()=>$7a93b84855bb04e2$var$V(n.Qe, "cc--anim"), 100)), $7a93b84855bb04e2$var$Z(1), $7a93b84855bb04e2$var$U(n.We, e, $7a93b84855bb04e2$var$ge, t);
}, $7a93b84855bb04e2$var$he = (e)=>{
    if (!$7a93b84855bb04e2$var$y(e)) return null;
    if (e in $7a93b84855bb04e2$var$m.o._) return e;
    let t = e.slice(0, 2);
    return t in $7a93b84855bb04e2$var$m.o._ ? t : null;
}, $7a93b84855bb04e2$var$Ce = ()=>$7a93b84855bb04e2$var$m.o.l || $7a93b84855bb04e2$var$m.o.i.language.default, $7a93b84855bb04e2$var$we = (e)=>{
    e && ($7a93b84855bb04e2$var$m.o.l = e);
}, $7a93b84855bb04e2$var$Se = async (e)=>{
    const t = $7a93b84855bb04e2$var$m.o;
    let o = $7a93b84855bb04e2$var$he(e) ? e : $7a93b84855bb04e2$var$Ce(), n = t._[o];
    return $7a93b84855bb04e2$var$y(n) ? n = await (async (e)=>{
        try {
            const t = await fetch(e);
            return await t.json();
        } catch (e) {
            return console.error(e), !1;
        }
    })(n) : $7a93b84855bb04e2$var$C(n) && (n = await n()), !!n && (t.u = n, $7a93b84855bb04e2$var$we(o), !0);
}, $7a93b84855bb04e2$var$xe = ()=>{
    let e = $7a93b84855bb04e2$var$m.o.i.language.rtl, t = $7a93b84855bb04e2$var$m.ne.Ce;
    e && t && ($7a93b84855bb04e2$var$v(e) || (e = [
        e
    ]), $7a93b84855bb04e2$var$b(e, $7a93b84855bb04e2$var$m.o.l) ? $7a93b84855bb04e2$var$V(t, "cc--rtl") : $7a93b84855bb04e2$var$j(t, "cc--rtl"));
}, $7a93b84855bb04e2$var$Me = ()=>{
    const e = $7a93b84855bb04e2$var$m.ne;
    if (e.Ce) return;
    e.Ce = $7a93b84855bb04e2$var$k($7a93b84855bb04e2$var$c), e.Ce.id = "cc-main", e.Ce.setAttribute("data-nosnippet", ""), $7a93b84855bb04e2$var$xe();
    let t = $7a93b84855bb04e2$var$m.o.i.root;
    t && $7a93b84855bb04e2$var$y(t) && (t = document.querySelector(t)), (t || e.$e.body).appendChild(e.Ce);
}, $7a93b84855bb04e2$var$De = (e)=>$7a93b84855bb04e2$var$te(()=>localStorage.removeItem(e)), $7a93b84855bb04e2$var$Te = (e, t)=>{
    if (t instanceof RegExp) return e.filter((e)=>t.test(e));
    {
        const o = $7a93b84855bb04e2$var$g(e, t);
        return o > -1 ? [
            e[o]
        ] : [];
    }
}, $7a93b84855bb04e2$var$ke = (e)=>{
    const { hostname: t, protocol: o } = location, { name: n, path: a, domain: s, sameSite: c, useLocalStorage: r } = $7a93b84855bb04e2$var$m.t.cookie, i = e ? (()=>{
        const e = $7a93b84855bb04e2$var$m.o.S, t = e ? new Date - e : 0;
        return 864e5 * $7a93b84855bb04e2$var$B() - t;
    })() : 864e5 * $7a93b84855bb04e2$var$B(), l = new Date;
    l.setTime(l.getTime() + i), $7a93b84855bb04e2$var$m.o.p.expirationTime = l.getTime();
    const d = JSON.stringify($7a93b84855bb04e2$var$m.o.p);
    let f = n + "=" + encodeURIComponent(d) + (0 !== i ? "; expires=" + l.toUTCString() : "") + "; Path=" + a + "; SameSite=" + c;
    $7a93b84855bb04e2$var$b(t, ".") && (f += "; Domain=" + s), "https:" === o && (f += "; Secure"), r ? ((e, t)=>{
        $7a93b84855bb04e2$var$te(()=>localStorage.setItem(e, t));
    })(n, d) : document.cookie = f, $7a93b84855bb04e2$var$m.o.p;
}, $7a93b84855bb04e2$var$Ee = (e, t, o)=>{
    if (0 === e.length) return;
    const n = o || $7a93b84855bb04e2$var$m.t.cookie.domain, a = t || $7a93b84855bb04e2$var$m.t.cookie.path, s = "www." === n.slice(0, 4), c = s && n.substring(4), r = (e, t)=>{
        document.cookie = e + "=; path=" + a + (t ? "; domain=." + t : "") + "; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    };
    for (const t of e)r(t), r(t, n), s && r(t, c);
}, $7a93b84855bb04e2$var$Ae = (e)=>{
    const t = e || $7a93b84855bb04e2$var$m.t.cookie.name, o = $7a93b84855bb04e2$var$m.t.cookie.useLocalStorage;
    var n;
    return ((e, t)=>{
        let o;
        return o = $7a93b84855bb04e2$var$te(()=>JSON.parse(t ? e : decodeURIComponent(e)), !0) || {}, o;
    })(o ? (n = t, $7a93b84855bb04e2$var$te(()=>localStorage.getItem(n)) || "") : $7a93b84855bb04e2$var$Ne(t, !0), o);
}, $7a93b84855bb04e2$var$Ne = (e, t)=>{
    const o = document.cookie.match("(^|;)\\s*" + e + "\\s*=\\s*([^;]+)");
    return o ? t ? o.pop() : e : "";
}, $7a93b84855bb04e2$var$He = (e)=>{
    const t = document.cookie.split(/;\s*/), o = [];
    for (const n of t){
        let t = n.split("=")[0];
        e ? $7a93b84855bb04e2$var$te(()=>{
            e.test(t) && o.push(t);
        }) : o.push(t);
    }
    return o;
}, $7a93b84855bb04e2$export$f733614a75aede52 = (o, n = [])=>{
    ((e, t)=>{
        const { O: o, R: n, B: a, N: s, Z: c, G: r, X: i } = $7a93b84855bb04e2$var$m.o;
        let l = [];
        if (e) {
            $7a93b84855bb04e2$var$v(e) ? l.push(...e) : $7a93b84855bb04e2$var$y(e) && (l = "all" === e ? o : [
                e
            ]);
            for (const e of o)c[e] = $7a93b84855bb04e2$var$b(l, e) ? $7a93b84855bb04e2$var$w(i[e]) : [];
        } else l = [
            ...n,
            ...r
        ], s && (l = (()=>{
            const e = $7a93b84855bb04e2$var$m.ne.ae;
            if (!e) return [];
            let t = [];
            for(let o in e)e[o].checked && t.push(o);
            return t;
        })());
        l = l.filter((e)=>!$7a93b84855bb04e2$var$b(o, e) || !$7a93b84855bb04e2$var$b(t, e)), l.push(...a), $7a93b84855bb04e2$var$J(l);
    })(o, n), ((e)=>{
        const t = $7a93b84855bb04e2$var$m.o, { Z: o, B: n, Y: a, X: s, O: c } = t, r = c;
        t.te = $7a93b84855bb04e2$var$F(a);
        for (const e of r){
            const c = s[e], r = $7a93b84855bb04e2$var$w(c), i = o[e] && o[e].length > 0, l = $7a93b84855bb04e2$var$b(n, e);
            if (0 !== r.length) {
                if (a[e] = [], l) a[e].push(...r);
                else if (i) {
                    const t = o[e];
                    a[e].push(...t);
                } else a[e] = t.Z[e];
                a[e] = $7a93b84855bb04e2$var$S(a[e]);
            }
        }
    })(), (()=>{
        const o = $7a93b84855bb04e2$var$m.o;
        o.L = $7a93b84855bb04e2$var$m.t.mode === $7a93b84855bb04e2$var$t && o.D ? $7a93b84855bb04e2$var$G(o.G, o.R) : $7a93b84855bb04e2$var$G(o.R, o.p.categories);
        let n = o.L.length > 0, a = !1;
        for (const e of o.O)o.ee[e] = $7a93b84855bb04e2$var$G(o.Y[e], o.te[e]), o.ee[e].length > 0 && (a = !0);
        const s = $7a93b84855bb04e2$var$m.ne.ae;
        for(const e in s)s[e].checked = $7a93b84855bb04e2$var$b(o.R, e);
        for (const e of o.O){
            const t = $7a93b84855bb04e2$var$m.ne.se[e], n = o.Y[e];
            for(const e in t)t[e].checked = $7a93b84855bb04e2$var$b(n, e);
        }
        o.C || (o.C = new Date), o.M || (o.M = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (e)=>(e ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e / 4).toString(16))), o.p = {
            categories: $7a93b84855bb04e2$var$F(o.R),
            revision: $7a93b84855bb04e2$var$m.t.revision,
            data: o.h,
            consentTimestamp: o.C.toISOString(),
            consentId: o.M,
            services: $7a93b84855bb04e2$var$F(o.Y)
        };
        let c = !1;
        const r = n || a;
        (o.D || r) && (o.D && (o.D = !1, c = !0), o.S = o.S ? new Date : o.C, o.p.lastConsentTimestamp = o.S.toISOString(), $7a93b84855bb04e2$var$ke(), $7a93b84855bb04e2$var$m.t.autoClearCookies && (c || r) && ((e)=>{
            const t = $7a93b84855bb04e2$var$m.o, o = $7a93b84855bb04e2$var$He(), n = ((e)=>{
                const t = $7a93b84855bb04e2$var$m.o;
                return (e ? t.O : t.L).filter((e)=>{
                    const o = t.P[e];
                    return !!o && !o.readOnly && !!o.autoClear;
                });
            })(e);
            for(const e in t.ee)for (const n of t.ee[e]){
                const a = t.X[e][n].cookies;
                if (!$7a93b84855bb04e2$var$b(t.Y[e], n) && a) for (const e of a){
                    const t = $7a93b84855bb04e2$var$Te(o, e.name);
                    $7a93b84855bb04e2$var$Ee(t, e.path, e.domain);
                }
            }
            for (const a of n){
                const n = t.P[a].autoClear, s = n && n.cookies || [], c = $7a93b84855bb04e2$var$b(t.L, a), r = !$7a93b84855bb04e2$var$b(t.R, a), i = c && r;
                if (e ? r : i) {
                    n.reloadPage && i && (t.j = !0);
                    for (const e of s){
                        const t = $7a93b84855bb04e2$var$Te(o, e.name);
                        $7a93b84855bb04e2$var$Ee(t, e.path, e.domain);
                    }
                }
            }
        })(c), $7a93b84855bb04e2$var$oe()), c && ($7a93b84855bb04e2$var$ee($7a93b84855bb04e2$var$m.re.ie), $7a93b84855bb04e2$var$ee($7a93b84855bb04e2$var$m.re.le), $7a93b84855bb04e2$var$m.t.mode === $7a93b84855bb04e2$var$e) || (r && $7a93b84855bb04e2$var$ee($7a93b84855bb04e2$var$m.re.de), o.j && (o.j = !1, location.reload()));
    })();
}, $7a93b84855bb04e2$export$d57953daf19d40f0 = (e)=>{
    const t = $7a93b84855bb04e2$var$m.o.D ? [] : $7a93b84855bb04e2$var$m.o.R;
    return $7a93b84855bb04e2$var$b(t, e);
}, $7a93b84855bb04e2$export$954bc960519baaed = (e, t)=>{
    const { O: o, X: n } = $7a93b84855bb04e2$var$m.o;
    if (!(e && t && $7a93b84855bb04e2$var$y(t) && $7a93b84855bb04e2$var$b(o, t) && 0 !== $7a93b84855bb04e2$var$w(n[t]).length)) return !1;
    ((e, t)=>{
        const o = $7a93b84855bb04e2$var$m.o, { X: n, Z: a, N: s } = o, c = $7a93b84855bb04e2$var$m.ne.se[t] || {}, r = $7a93b84855bb04e2$var$m.ne.ae[t] || {}, i = $7a93b84855bb04e2$var$w(n[t]);
        if (a[t] = [], $7a93b84855bb04e2$var$y(e)) {
            if ("all" === e) {
                if (a[t].push(...i), s) for(let e in c)c[e].checked = !0, $7a93b84855bb04e2$var$T(c[e]);
            } else if ($7a93b84855bb04e2$var$b(i, e) && a[t].push(e), s) for(let t in c)c[t].checked = e === t, $7a93b84855bb04e2$var$T(c[t]);
        } else if ($7a93b84855bb04e2$var$v(e)) for (let o of i){
            const n = $7a93b84855bb04e2$var$b(e, o);
            n && a[t].push(o), s && (c[o].checked = n, $7a93b84855bb04e2$var$T(c[o]));
        }
        const l = 0 === a[t].length;
        o.R = l ? o.R.filter((e)=>e !== t) : $7a93b84855bb04e2$var$S([
            ...o.R,
            t
        ]), s && (r.checked = !l, $7a93b84855bb04e2$var$T(r));
    })(e, t), $7a93b84855bb04e2$export$f733614a75aede52();
}, $7a93b84855bb04e2$export$c6d040ca60661d88 = (e, t)=>{
    const o = $7a93b84855bb04e2$var$m.o.D ? [] : $7a93b84855bb04e2$var$m.o.Y[t] || [];
    return $7a93b84855bb04e2$var$b(o, e);
}, $7a93b84855bb04e2$export$26b2c20fc8da53a0 = (e)=>"" !== $7a93b84855bb04e2$var$Ne(e, !0), $7a93b84855bb04e2$export$6dde6a4e31d2b3a6 = (e, t, o)=>{
    let n = [];
    const a = (e)=>{
        if ($7a93b84855bb04e2$var$y(e)) {
            let t = $7a93b84855bb04e2$var$Ne(e);
            "" !== t && n.push(t);
        } else n.push(...$7a93b84855bb04e2$var$He(e));
    };
    if ($7a93b84855bb04e2$var$v(e)) for (let t of e)a(t);
    else a(e);
    $7a93b84855bb04e2$var$Ee(n, t, o);
}, $7a93b84855bb04e2$export$57bf213be019eeb0 = (e)=>{
    const { ne: t, o: n } = $7a93b84855bb04e2$var$m;
    if (!n.k) {
        if (!n.T) {
            if (!e) return;
            $7a93b84855bb04e2$var$ye($7a93b84855bb04e2$var$Je, $7a93b84855bb04e2$var$Me);
        }
        n.k = !0, n.U = $7a93b84855bb04e2$var$x(), n.v && $7a93b84855bb04e2$var$K(!0), $7a93b84855bb04e2$var$z(t.he, 1), $7a93b84855bb04e2$var$V(t.ye, $7a93b84855bb04e2$var$o), $7a93b84855bb04e2$var$E(t.he, $7a93b84855bb04e2$var$i, "false"), setTimeout(()=>{
            $7a93b84855bb04e2$var$$($7a93b84855bb04e2$var$m.ne.be);
        }, 100), $7a93b84855bb04e2$var$ee($7a93b84855bb04e2$var$m.re.fe, $7a93b84855bb04e2$var$_);
    }
}, $7a93b84855bb04e2$export$fe8985bb6374093c = ()=>{
    const { ne: e, o: t, re: n } = $7a93b84855bb04e2$var$m;
    t.k && (t.k = !1, t.v && $7a93b84855bb04e2$var$K(), $7a93b84855bb04e2$var$$(e.Ke, !0), $7a93b84855bb04e2$var$j(e.ye, $7a93b84855bb04e2$var$o), $7a93b84855bb04e2$var$E(e.he, $7a93b84855bb04e2$var$i, "true"), $7a93b84855bb04e2$var$$(t.U), t.U = null, $7a93b84855bb04e2$var$ee(n._e, $7a93b84855bb04e2$var$_));
}, $7a93b84855bb04e2$export$535e69674d40eb20 = ()=>{
    const e = $7a93b84855bb04e2$var$m.o;
    e.A || (e.N || $7a93b84855bb04e2$var$ge($7a93b84855bb04e2$var$Je, $7a93b84855bb04e2$var$Me), e.A = !0, e.k ? e.$ = $7a93b84855bb04e2$var$x() : e.U = $7a93b84855bb04e2$var$x(), $7a93b84855bb04e2$var$z($7a93b84855bb04e2$var$m.ne.we, 2), $7a93b84855bb04e2$var$V($7a93b84855bb04e2$var$m.ne.ye, $7a93b84855bb04e2$var$n), $7a93b84855bb04e2$var$E($7a93b84855bb04e2$var$m.ne.we, $7a93b84855bb04e2$var$i, "false"), setTimeout(()=>{
        $7a93b84855bb04e2$var$$($7a93b84855bb04e2$var$m.ne.ve);
    }, 100), $7a93b84855bb04e2$var$ee($7a93b84855bb04e2$var$m.re.fe, $7a93b84855bb04e2$var$u));
}, $7a93b84855bb04e2$export$5b3a895f6cbac580 = ()=>{
    const e = $7a93b84855bb04e2$var$m.o;
    e.A && (e.A = !1, (()=>{
        const e = $7a93b84855bb04e2$export$3bdcc4c9b3764a39(), t = $7a93b84855bb04e2$var$m.o.P, o = $7a93b84855bb04e2$var$m.ne.ae, n = $7a93b84855bb04e2$var$m.ne.se, a = (e)=>$7a93b84855bb04e2$var$b($7a93b84855bb04e2$var$m.o.G, e);
        for(const s in o){
            const c = !!t[s].readOnly;
            o[s].checked = c || (e ? $7a93b84855bb04e2$export$d57953daf19d40f0(s) : a(s));
            for(const t in n[s])n[s][t].checked = c || (e ? $7a93b84855bb04e2$export$c6d040ca60661d88(t, s) : a(s));
        }
    })(), $7a93b84855bb04e2$var$$($7a93b84855bb04e2$var$m.ne.Ge, !0), $7a93b84855bb04e2$var$j($7a93b84855bb04e2$var$m.ne.ye, $7a93b84855bb04e2$var$n), $7a93b84855bb04e2$var$E($7a93b84855bb04e2$var$m.ne.we, $7a93b84855bb04e2$var$i, "true"), e.k ? ($7a93b84855bb04e2$var$$(e.$), e.$ = null) : ($7a93b84855bb04e2$var$$(e.U), e.U = null), $7a93b84855bb04e2$var$ee($7a93b84855bb04e2$var$m.re._e, $7a93b84855bb04e2$var$u));
};
var $7a93b84855bb04e2$var$Je = {
    show: $7a93b84855bb04e2$export$57bf213be019eeb0,
    hide: $7a93b84855bb04e2$export$fe8985bb6374093c,
    showPreferences: $7a93b84855bb04e2$export$535e69674d40eb20,
    hidePreferences: $7a93b84855bb04e2$export$5b3a895f6cbac580,
    acceptCategory: $7a93b84855bb04e2$export$f733614a75aede52
};
const $7a93b84855bb04e2$export$4b6bf64406ec64af = async (e, t)=>{
    if (!$7a93b84855bb04e2$var$he(e)) return !1;
    const o = $7a93b84855bb04e2$var$m.o;
    return !(e === $7a93b84855bb04e2$var$Ce() && !0 !== t || !await $7a93b84855bb04e2$var$Se(e) || ($7a93b84855bb04e2$var$we(e), o.T && $7a93b84855bb04e2$var$ye($7a93b84855bb04e2$var$Je, $7a93b84855bb04e2$var$Me), o.N && $7a93b84855bb04e2$var$ge($7a93b84855bb04e2$var$Je, $7a93b84855bb04e2$var$Me), $7a93b84855bb04e2$var$xe(), 0));
}, $7a93b84855bb04e2$export$ae3f5fa351e2f57a = ()=>{
    const { F: e, Y: t } = $7a93b84855bb04e2$var$m.o, { accepted: o, rejected: n } = (()=>{
        const { D: e, R: t, O: o } = $7a93b84855bb04e2$var$m.o;
        return {
            accepted: t,
            rejected: e ? [] : o.filter((e)=>!$7a93b84855bb04e2$var$b(t, e))
        };
    })();
    return $7a93b84855bb04e2$var$F({
        acceptType: e,
        acceptedCategories: o,
        rejectedCategories: n,
        acceptedServices: t,
        rejectedServices: $7a93b84855bb04e2$var$P()
    });
}, $7a93b84855bb04e2$export$2cb99e4be0dc4646 = (e, t)=>{
    let o = document.querySelector('script[src="' + e + '"]');
    return new Promise((n)=>{
        if (o) return n(!0);
        if (o = $7a93b84855bb04e2$var$k("script"), $7a93b84855bb04e2$var$h(t)) for(const e in t)$7a93b84855bb04e2$var$E(o, e, t[e]);
        o.onload = ()=>n(!0), o.onerror = ()=>{
            o.remove(), n(!1);
        }, o.src = e, $7a93b84855bb04e2$var$H(document.head, o);
    });
}, $7a93b84855bb04e2$export$3cbc67a40c3171bd = (e)=>{
    let t, o = e.value, n = e.mode, a = !1;
    const s = $7a93b84855bb04e2$var$m.o;
    if ("update" === n) {
        s.h = t = $7a93b84855bb04e2$export$4be65e66cfa2648a("data");
        const e = typeof t == typeof o;
        if (e && "object" == typeof t) {
            !t && (t = {});
            for(let e in o)t[e] !== o[e] && (t[e] = o[e], a = !0);
        } else !e && t || t === o || (t = o, a = !0);
    } else t = o, a = !0;
    return a && (s.h = t, s.p.data = t, $7a93b84855bb04e2$var$ke(!0)), a;
}, $7a93b84855bb04e2$export$4be65e66cfa2648a = (e, t)=>{
    const o = $7a93b84855bb04e2$var$Ae(t);
    return e ? o[e] : o;
}, $7a93b84855bb04e2$export$44487a86467333c3 = (e)=>{
    const t = $7a93b84855bb04e2$var$m.t, o = $7a93b84855bb04e2$var$m.o.i;
    return e ? t[e] || o[e] : {
        ...t,
        ...o,
        cookie: {
            ...t.cookie
        }
    };
}, $7a93b84855bb04e2$export$3bdcc4c9b3764a39 = ()=>!$7a93b84855bb04e2$var$m.o.D, $7a93b84855bb04e2$export$889ea624f2cb2c57 = async (e)=>{
    const { o: o, t: n, re: a } = $7a93b84855bb04e2$var$m, c = window;
    if (!c._ccRun) {
        if (c._ccRun = !0, ((e)=>{
            const { ne: o, t: n, o: a } = $7a93b84855bb04e2$var$m, c = n, r = a, { cookie: i } = c, l = $7a93b84855bb04e2$var$m.ce, d = e.cookie, f = e.categories, _ = $7a93b84855bb04e2$var$w(f) || [], u = navigator, p = document;
            o.$e = p, o.ye = p.documentElement, i.domain = location.hostname, r.i = e, r.P = f, r.O = _, r._ = e.language.translations, r.v = !!e.disablePageInteraction, l.ie = e.onFirstConsent, l.le = e.onConsent, l.de = e.onChange, l._e = e.onModalHide, l.fe = e.onModalShow, l.ue = e.onModalReady;
            const { mode: g, autoShow: v, lazyHtmlGeneration: y, autoClearCookies: C, revision: S, manageScriptTags: x, hideFromBots: M } = e;
            g === $7a93b84855bb04e2$var$t && (c.mode = g), "boolean" == typeof C && (c.autoClearCookies = C), "boolean" == typeof x && (c.manageScriptTags = x), "number" == typeof S && S >= 0 && (c.revision = S, r.V = !0), "boolean" == typeof v && (c.autoShow = v), "boolean" == typeof y && (c.lazyHtmlGeneration = y), !1 === M && (c.hideFromBots = !1), !0 === c.hideFromBots && u && (r.J = u.userAgent && /bot|crawl|spider|slurp|teoma/i.test(u.userAgent) || u.webdriver), $7a93b84855bb04e2$var$h(d) && (c.cookie = {
                ...i,
                ...d
            }), c.autoClearCookies, r.V, c.manageScriptTags, ((e)=>{
                const { P: t, X: o, Y: n, Z: a, B: s } = $7a93b84855bb04e2$var$m.o;
                for (let c of e){
                    const e = t[c], r = e.services || {}, i = $7a93b84855bb04e2$var$h(r) && $7a93b84855bb04e2$var$w(r) || [];
                    o[c] = {}, n[c] = [], a[c] = [], e.readOnly && (s.push(c), n[c] = i), $7a93b84855bb04e2$var$m.ne.se[c] = {};
                    for (let e of i){
                        const t = r[e];
                        t.Se = !1, o[c][e] = t;
                    }
                }
            })(_), (()=>{
                if (!$7a93b84855bb04e2$var$m.t.manageScriptTags) return;
                const e = $7a93b84855bb04e2$var$m.o, t = $7a93b84855bb04e2$var$D(document, "script[" + $7a93b84855bb04e2$var$s + "]");
                for (const o of t){
                    let t = $7a93b84855bb04e2$var$N(o, $7a93b84855bb04e2$var$s), n = o.dataset.service || "", a = !1;
                    if (t && "!" === t.charAt(0) && (t = t.slice(1), a = !0), "!" === n.charAt(0) && (n = n.slice(1), a = !0), $7a93b84855bb04e2$var$b(e.O, t) && (e.oe.push({
                        Me: o,
                        xe: !1,
                        ke: a,
                        De: t,
                        Te: n
                    }), n)) {
                        const o = e.X[t];
                        o[n] || (o[n] = {
                            Se: !1
                        });
                    }
                }
            })(), $7a93b84855bb04e2$var$we((()=>{
                const e = $7a93b84855bb04e2$var$m.o.i.language.autoDetect;
                if (e) {
                    const t = {
                        browser: navigator.language,
                        document: document.documentElement.lang
                    }, o = $7a93b84855bb04e2$var$he(t[e]);
                    if (o) return o;
                }
                return $7a93b84855bb04e2$var$Ce();
            })());
        })(e), o.J) return;
        (()=>{
            const e = $7a93b84855bb04e2$var$m.o, o = $7a93b84855bb04e2$var$m.t, n = $7a93b84855bb04e2$var$Ae(), { categories: a, services: s, consentId: c, consentTimestamp: r, lastConsentTimestamp: i, data: l, revision: d } = n, f = $7a93b84855bb04e2$var$v(a);
            e.p = n, e.M = c;
            const _ = !!c && $7a93b84855bb04e2$var$y(c);
            e.C = r, e.C && (e.C = new Date(r)), e.S = i, e.S && (e.S = new Date(i)), e.h = void 0 !== l ? l : null, e.V && _ && d !== o.revision && (e.I = !1), e.D = !(_ && e.I && e.C && e.S && f), o.cookie.useLocalStorage && !e.D && (e.D = (new Date).getTime() > (n.expirationTime || 0), e.D && $7a93b84855bb04e2$var$De(o.cookie.name)), e.D, (()=>{
                const e = $7a93b84855bb04e2$var$m.o;
                for (const o of e.O){
                    const n = e.P[o];
                    if (n.readOnly || n.enabled) {
                        e.G.push(o);
                        const n = e.X[o] || {};
                        for(let a in n)e.Z[o].push(a), e.i.mode === $7a93b84855bb04e2$var$t && e.Y[o].push(a);
                    }
                }
            })(), e.D ? o.mode === $7a93b84855bb04e2$var$t && (e.R = [
                ...e.G
            ]) : (e.Z = {
                ...e.Y
            }, e.Y = {
                ...e.Y,
                ...s
            }, $7a93b84855bb04e2$var$J([
                ...e.B,
                ...a
            ]));
        })();
        const i = $7a93b84855bb04e2$export$3bdcc4c9b3764a39();
        if (!await $7a93b84855bb04e2$var$Se()) return !1;
        if ($7a93b84855bb04e2$var$U(null, r = $7a93b84855bb04e2$var$Je, $7a93b84855bb04e2$var$ge, $7a93b84855bb04e2$var$Me), $7a93b84855bb04e2$var$m.o.D && $7a93b84855bb04e2$var$ye(r, $7a93b84855bb04e2$var$Me), $7a93b84855bb04e2$var$m.t.lazyHtmlGeneration || $7a93b84855bb04e2$var$ge(r, $7a93b84855bb04e2$var$Me), n.autoShow && !i && $7a93b84855bb04e2$export$57bf213be019eeb0(!0), i) return $7a93b84855bb04e2$var$oe(), $7a93b84855bb04e2$var$ee(a.le);
        n.mode === $7a93b84855bb04e2$var$t && $7a93b84855bb04e2$var$oe(o.G);
    }
    var r;
}, $7a93b84855bb04e2$export$aad8462122ac592b = (e)=>{
    const { Ce: t, ye: s } = $7a93b84855bb04e2$var$m.ne, { name: c, path: r, domain: i, useLocalStorage: l } = $7a93b84855bb04e2$var$m.t.cookie;
    e && (l ? $7a93b84855bb04e2$var$De(c) : $7a93b84855bb04e2$export$6dde6a4e31d2b3a6(c, r, i));
    for (const { pe: e, me: t, ge: o } of $7a93b84855bb04e2$var$m.o.m)e.removeEventListener(t, o);
    t && t.remove(), s && s.classList.remove($7a93b84855bb04e2$var$a, $7a93b84855bb04e2$var$n, $7a93b84855bb04e2$var$o);
    const d = new $7a93b84855bb04e2$var$p;
    for(const e in $7a93b84855bb04e2$var$m)$7a93b84855bb04e2$var$m[e] = d[e];
    window._ccRun = !1;
};



var $7c6z4 = parcelRequire("7c6z4");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $ifZB1 = parcelRequire("ifZB1");

var $j328z = parcelRequire("j328z");

var $5XUMN = parcelRequire("5XUMN");
var $de0881259c00534d$export$2e2bcd8739ae039 = {
    install: (app)=>{
        const initializeCookieConsent = (locale)=>{
            const options = {
                cookie: {
                    name: "cc_cookie",
                    expiresAfterDays: (acceptType)=>{
                        const days = acceptType === "all" ? 365.25 : 7;
                        return days;
                    },
                    path: "/",
                    secure: true,
                    sameSite: "Lax"
                },
                callbacks: {
                    onAcceptAll: ()=>{
                        (0, $ifZB1.updateGtagConsent)({
                            analytics_storage: "granted"
                        });
                        (0, $ifZB1.applyConsentChange)("granted");
                        (0, $ifZB1.updateGtagConsent)({
                            ad_storage: "granted"
                        });
                    },
                    onRejectAll: ()=>{
                        (0, $ifZB1.updateGtagConsent)({
                            analytics_storage: "granted"
                        });
                        (0, $ifZB1.updateGtagConsent)({
                            ad_storage: "denied"
                        });
                        (0, $ifZB1.applyConsentChange)("denied");
                    }
                },
                categories: {
                    necessary: {
                        enabled: true,
                        readOnly: true
                    },
                    analytics: {
                        services: {
                            ga: {
                                label: "Google Analytics",
                                onInitialise: ()=>{
                                    (0, $ifZB1.updateGtagConsent)({
                                        "analytics_storage": "granted"
                                    });
                                    (0, $ifZB1.applyConsentChange)("granted");
                                },
                                onAccept: ()=>{
                                    (0, $ifZB1.updateGtagConsent)({
                                        "analytics_storage": "granted"
                                    });
                                    (0, $ifZB1.applyConsentChange)("granted");
                                },
                                onConsent: ()=>{
                                    (0, $ifZB1.updateGtagConsent)({
                                        "analytics_storage": "granted"
                                    });
                                    (0, $ifZB1.applyConsentChange)("granted");
                                },
                                onReject: ()=>{
                                    if (localStorage.getItem("gaRegisteredUserConsent") !== "true") {
                                        (0, $ifZB1.updateGtagConsent)({
                                            "analytics_storage": "denied"
                                        });
                                        (0, $ifZB1.applyConsentChange)("denied");
                                    }
                                },
                                cookies: [
                                    {
                                        name: /^(_ga|_gid)/
                                    }
                                ]
                            }
                        }
                    },
                    marketing: {
                        label: "Marketing and Ads",
                        services: {
                            googleAds: {
                                label: "Google Ads",
                                onInitialise: ()=>{},
                                onAccept: ()=>{
                                    (0, $ifZB1.updateGtagConsent)({
                                        "ad_storage": "granted"
                                    });
                                    (0, $ifZB1.updateGtagConsent)({
                                        "ad_user_data": "granted"
                                    });
                                    (0, $ifZB1.updateGtagConsent)({
                                        "ad_personalization": "granted"
                                    });
                                    (0, $ifZB1.applyConsentChange)("granted");
                                },
                                onReject: ()=>{
                                    (0, $ifZB1.updateGtagConsent)({
                                        "ad_storage": "denied"
                                    });
                                    (0, $ifZB1.updateGtagConsent)({
                                        "ad_user_data": "denied"
                                    });
                                    (0, $ifZB1.updateGtagConsent)({
                                        "ad_personalization": "denied"
                                    });
                                }
                            },
                            linkedin: {
                                label: "LinkedIn Insight",
                                onInitialise: ()=>{},
                                onAccept: ()=>{
                                    (0, $ifZB1.updateGtagConsent)({
                                        "ad_storage": "granted"
                                    });
                                },
                                onReject: ()=>{}
                            },
                            metaPixel: {
                                label: "Meta Pixel",
                                onInitialise: ()=>{},
                                onAccept: ()=>{
                                    (0, $ifZB1.updateGtagConsent)({
                                        "ad_storage": "granted"
                                    });
                                },
                                onReject: ()=>{}
                            }
                        }
                    }
                },
                language: {
                    default: locale,
                    autoDetect: false,
                    translations: {
                        en: (0, (/*@__PURE__*/$parcel$interopDefault($5XUMN))).cookieConsent,
                        de: (0, (/*@__PURE__*/$parcel$interopDefault($j328z))).cookieConsent
                    }
                }
            };
            if (app.config.globalProperties.$CookieConsent) delete app.config.globalProperties.$CookieConsent;
            app.config.globalProperties.$CookieConsent = $7a93b84855bb04e2$exports;
            app.config.globalProperties.$CookieConsent.run(options);
        };
        setTimeout(()=>{
            initializeCookieConsent((0, $7c6z4.default).global.locale.value);
        }, 100);
        (0, $TusQn.watch)(()=>(0, $7c6z4.default).global.locale.value, (newLocale)=>{
            initializeCookieConsent(newLocale);
        });
    }
};



var $ifZB1 = parcelRequire("ifZB1");
function $7554ff3a6c40b756$export$2e2bcd8739ae039(containerId) {
    if (!containerId) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js"
    });
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
    document.head.appendChild(script);
}


let $ae3de8900c09c2f9$var$script;



let $ae3de8900c09c2f9$var$initialize = ()=>{
    $ae3de8900c09c2f9$var$script = (parcelRequire("boZNq"));
    if ($ae3de8900c09c2f9$var$script.__esModule) $ae3de8900c09c2f9$var$script = $ae3de8900c09c2f9$var$script.default;
    $ae3de8900c09c2f9$var$script.render = (parcelRequire("3NNX1")).render;
    (parcelRequire("1rrBo")).default($ae3de8900c09c2f9$var$script);
    $ae3de8900c09c2f9$var$script.__scopeId = "data-v-ae37f9";
    $ae3de8900c09c2f9$var$script.__file = "App.vue";
};
$ae3de8900c09c2f9$var$initialize();
var $ae3de8900c09c2f9$export$2e2bcd8739ae039 = $ae3de8900c09c2f9$var$script;



var $4OcZ0 = parcelRequire("4OcZ0");
const $2b6e161c9edcf319$var$app = (0, $eeJ70.createApp)((0, $ae3de8900c09c2f9$export$2e2bcd8739ae039));
$2b6e161c9edcf319$var$app.use((0, $4OcZ0.default));
$2b6e161c9edcf319$var$app.use((0, $7c6z4.default));
$2b6e161c9edcf319$var$app.config.errorHandler = (err, instance, info)=>{
    console.error(err, instance, info); // eslint-disable-line no-console
};
$2b6e161c9edcf319$var$app.use((0, $de0881259c00534d$export$2e2bcd8739ae039));
$2b6e161c9edcf319$var$app.mount("#app");
const $2b6e161c9edcf319$var$GTM_TOKEN = "GTM-PRG5BVHZ";
(0, $ifZB1.initDefaultConsent)();
const $2b6e161c9edcf319$var$tokens = [
    {
        name: "GTM",
        token: $2b6e161c9edcf319$var$GTM_TOKEN,
        init: (0, $7554ff3a6c40b756$export$2e2bcd8739ae039)
    }
];
$2b6e161c9edcf319$var$tokens.forEach(({ name: name, token: token, init: init })=>{
    if (!token) console.warn(`No ${name} token found.`);
    else init(token);
});


//# sourceMappingURL=index.5ccd6321.js.map
